/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(282);
	module.exports = __webpack_require__(495);


/***/ }),
/* 1 */
[783, 760],
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var accordionContent = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "accordion-item-content" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueAccordionContent = accordionContent;
	var accordionItem = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "accordion-item", class: { 'accordion-item-expanded': _vm.expanded }, on: { "accordion:open": _vm.onOpen, "accordion:opened": _vm.onOpened, "accordion:close": _vm.onClose, "accordion:closed": _vm.onClosed } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        expanded: Boolean
	    },
	    methods: {
	        onOpen: function (event) {
	            this.$emit('accordion:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('accordion:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('accordion:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('accordion:closed', event);
	        }
	    }
	};
	exports.VueAccordionItem = accordionItem;
	var accordionToggle = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "accordion-item-toggle" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueAccordionToggle = accordionToggle;
	var accordion = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "accordion-list" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueAccordion = accordion;
	var actionsButton = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "actions-modal-button", class: _vm.classesObject, on: { "click": _vm.onClick } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'color': String,
	        'bold': Boolean,
	        'close': {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        classesObject: function () {
	            var self = this;
	            var co = {
	                'actions-modal-button-bold': self.bold
	            };
	            if (self.color) {
	                co['color-' + self.color] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            if (this.close && this.$f7) {
	                this.$f7.closeModal(this.$parent.$parent.$el);
	            }
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueActionsButton = actionsButton;
	var actionsGroup = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "actions-modal-group" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueActionsGroup = actionsGroup;
	var actionsLabel = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "actions-modal-label", class: _vm.classesObject, on: { "click": _vm.onClick } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        color: String,
	        bold: Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var self = this;
	            var co = {
	                'actions-modal-button-bold': self.bold
	            };
	            if (self.color) {
	                co['color-' + self.color] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueActionsLabel = actionsLabel;
	var actions = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "actions-modal keep-on-close", class: { 'modal-in': _vm.opened }, on: { "actions:open": _vm.onOpen, "actions:opened": _vm.onOpened, "actions:close": _vm.onClose, "actions:closed": _vm.onClosed } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    mounted: function () {
	        var self = this;
	        if (self.opened) {
	            self.$el.style.display = 'block';
	        }
	        else {
	            self.$el.style.display = 'none';
	        }
	    },
	    watch: {
	        opened: function (opened) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            if (opened) {
	                self.$el.style.display = 'block';
	                self.$f7.openModal(self.$el);
	            }
	            else {
	                self.$el.style.display = 'none';
	                self.$f7.closeModal(self.$el);
	            }
	        }
	    },
	    props: {
	        opened: Boolean
	    },
	    methods: {
	        onOpen: function (event) {
	            this.$emit('actions:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('actions:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('actions:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('actions:closed', event);
	        },
	        onF7Init: function () {
	            var $$ = this.$$;
	            if (!$$) {
	                return;
	            }
	            if ($$('.modal-overlay').length === 0) {
	                $$(this.$root.$el).append('<div class="modal-overlay' + (this.opened ? ' modal-overlay-visible' : '') + '"></div>');
	            }
	        },
	        open: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.openModal(self.$el, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.closeModal(self.$el, animated);
	        }
	    }
	};
	exports.VueActions = actions;
	var badge = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { staticClass: "badge", class: _vm.color ? 'color-' + _vm.color : '' }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'color': String
	    }
	};
	exports.VueBadge = badge;
	var LinkMixin = {
	    data: function () {
	        return {
	            routeInfo: {
	                activeTab: this.$route && this.$route.route.tab
	            }
	        };
	    },
	    props: {
	        noLinkClass: Boolean,
	        noFastclick: Boolean,
	        external: Boolean,
	        color: String,
	        bg: String,
	        theme: String,
	        text: String,
	        iconOnly: Boolean,
	        icon: String,
	        iconMaterial: String,
	        iconIon: String,
	        iconFa: String,
	        iconF7: String,
	        iconIfMaterial: String,
	        iconIfIos: String,
	        iconSize: [String, Number],
	        rippleColor: String,
	        href: {
	            type: String,
	            default: '#'
	        },
	        // Button
	        round: Boolean,
	        fill: Boolean,
	        big: Boolean,
	        raised: Boolean,
	        // Router
	        force: Boolean,
	        reload: Boolean,
	        animatePages: Boolean,
	        ignoreCache: Boolean,
	        pageName: String,
	        template: String,
	        // View
	        view: String,
	        // Panel
	        openPanel: [Boolean, String],
	        closePanel: [Boolean, String],
	        // Popup
	        openPopup: [Boolean, String],
	        closePopup: [Boolean, String],
	        // Popover
	        openPopover: [Boolean, String],
	        closePopover: [Boolean, String],
	        // Login Screen
	        openLoginScreen: [Boolean, String],
	        closeLoginScreen: [Boolean, String],
	        // Picker
	        openPicker: [Boolean, String],
	        closePicker: [Boolean, String],
	        // Tab
	        tabLink: [Boolean, String],
	        routeTabLink: [Boolean, String],
	        // Sortable
	        openSortable: [Boolean, String],
	        closeSortable: [Boolean, String],
	        toggleSortable: [Boolean, String],
	        // Active
	        active: Boolean,
	        // Badge
	        badge: [String, Number],
	        iconBadge: [String, Number],
	        badgeColor: [String],
	        // Back Link
	        back: Boolean
	    },
	    computed: {
	        attrsObject: function () {
	            var self = this;
	            var ao = {
	                href: self.href
	            };
	            var pd = self.$options.propsData;
	            if ('force' in pd) {
	                ao['data-force'] = self.force;
	            }
	            if ('reload' in pd) {
	                ao['data-reload'] = 'true';
	            }
	            if ('animatePages' in pd && typeof pd.animatePages === 'boolean') {
	                ao['data-animate-pages'] = pd.animatePages.toString();
	            }
	            if ('ignoreCache' in pd) {
	                ao['data-ignore-cache'] = 'true';
	            }
	            if (self.pageName) {
	                ao['data-page-name'] = self.pageName;
	            }
	            if (self.template) {
	                ao['data-template'] = self.template;
	            }
	            if (self.view) {
	                ao['data-view'] = self.view;
	            }
	            function trustyString(s) {
	                if (typeof s === 'string' && s !== '') {
	                    return true;
	                }
	                return false;
	            }
	            if (trustyString(self.openPanel)) {
	                ao['data-panel'] = self.openPanel;
	            }
	            if (trustyString(self.openPopup)) {
	                ao['data-popup'] = self.openPopup;
	            }
	            if (trustyString(self.openPopover)) {
	                ao['data-popover'] = self.openPopover;
	            }
	            if (trustyString(self.openPicker)) {
	                ao['data-picker'] = self.openPicker;
	            }
	            if (trustyString(self.openLoginScreen)) {
	                ao['data-login-screen'] = self.openLoginScreen;
	            }
	            if (trustyString(self.openSortable)) {
	                ao['data-sortable'] = self.openSortable;
	            }
	            if (trustyString(self.toggleSortable)) {
	                ao['data-sortable'] = self.toggleSortable;
	            }
	            if (trustyString(self.closePopup)) {
	                ao['data-popup'] = self.closePopup;
	            }
	            if (trustyString(self.closePopover)) {
	                ao['data-popover'] = self.closePopover;
	            }
	            if (trustyString(self.closePicker)) {
	                ao['data-picker'] = self.closePicker;
	            }
	            if (trustyString(self.closeLoginScreen)) {
	                ao['data-login-screen'] = self.closeLoginScreen;
	            }
	            if (trustyString(self.closeSortable)) {
	                ao['data-sortable'] = self.closeSortable;
	            }
	            if (trustyString(self.tabLink)) {
	                ao['data-tab'] = self.tabLink;
	            }
	            return ao;
	        },
	        classesObject: function () {
	            var self = this;
	            var co = {
	                back: self.back,
	                external: self.external,
	                'no-fastclick': self.noFastclick
	            };
	            var pd = self.$options.propsData;
	            if (self.rippleColor) {
	                co['ripple-color-' + self.rippleColor] = true;
	            }
	            if (self.color) {
	                co['color-' + self.color] = true;
	            }
	            if (self.theme) {
	                co['theme-' + self.theme] = true;
	            }
	            if (self.bg) {
	                co['bg-' + self.bg] = true;
	            }
	            // Button
	            ['round', 'fill', 'big', 'raised'].forEach(function (prop, index) {
	                if (self[prop]) {
	                    co['button-' + prop] = true;
	                }
	            });
	            // Active
	            if (self.routeInfo.activeTab) {
	                var isActiveTab = self.routeTabLink && self.routeTabLink.replace('#', '') === self.routeInfo.activeTab.tabId;
	                co.active = isActiveTab;
	            }
	            else {
	                co.active = self.active;
	            }
	            function trustyBoolean(b) {
	                if (b || b === '') {
	                    return true;
	                }
	                return false;
	            }
	            // Panel
	            if (trustyBoolean(self.closePanel)) {
	                co['close-panel'] = true;
	            }
	            if (self.openPanel || self.openPanel === '') {
	                co['open-panel'] = true;
	            }
	            // Popup
	            if (trustyBoolean(self.closePopup)) {
	                co['close-popup'] = true;
	            }
	            if (self.openPopup || self.openPopup === '') {
	                co['open-popup'] = true;
	            }
	            // Popover
	            if (trustyBoolean(self.closePopover)) {
	                co['close-popover'] = true;
	            }
	            if (self.openPopover || self.openPopover === '') {
	                co['open-popover'] = true;
	            }
	            // Picker
	            if (trustyBoolean(self.closePicker)) {
	                co['close-picker'] = true;
	            }
	            if (self.openPicker || self.openPicker === '') {
	                co['open-picker'] = true;
	            }
	            // Login Screen
	            if (trustyBoolean(self.closeLoginScreen)) {
	                co['close-login-screen'] = true;
	            }
	            if (self.openLoginScreen || self.openLoginScreen === '') {
	                co['open-login-screen'] = true;
	            }
	            // Sortable
	            if (trustyBoolean(self.closeSortable)) {
	                co['close-sortable'] = true;
	            }
	            if (self.openSortable || self.openSortable === '') {
	                co['open-sortable'] = true;
	            }
	            if (self.toggleSortable || self.toggleSortable === '') {
	                co['toggle-sortable'] = true;
	            }
	            // Tab
	            if (self.tabLink || self.tabLink === '') {
	                co['tab-link'] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        },
	        onRouteChange: function (e) {
	            if (e.route.tab) {
	                this.$set(this.routeInfo, 'activeTab', e.route.tab);
	            }
	        }
	    }
	};
	exports.VueLinkMixin = LinkMixin;
	var button = {
	    render: function (c) {
	        var iconEl, textEl, self = this;
	        if (self.text) {
	            textEl = c('span', {}, self.text);
	        }
	        if (self.icon || self.iconMaterial || self.iconIon || self.iconFa || self.iconF7 || self.iconIfMaterial || self.iconIfIos) {
	            iconEl = c('f7-icon', { props: {
	                    material: self.iconMaterial,
	                    ion: self.iconIon,
	                    fa: self.iconFa,
	                    f7: self.iconF7,
	                    icon: self.icon,
	                    ifMaterial: self.iconIfMaterial,
	                    ifIos: self.iconIfIos,
	                    size: self.iconSize
	                } });
	        }
	        self.classesObject.button = true;
	        var linkEl = c('a', {
	            class: self.classesObject,
	            attrs: self.attrsObject,
	            on: {
	                click: self.onClick
	            }
	        }, [iconEl, textEl, self.$slots.default]);
	        return linkEl;
	    },
	    mixins: [LinkMixin],
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueButton = button;
	var buttonsSegmented = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "buttons-row", class: (_vm.colorComputed ? 'theme-' + _vm.colorComputed : '') }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'color': String,
	        'theme': String,
	        'bg': String
	    },
	    computed: {
	        colorComputed: function () {
	            return this.color || this.theme || this.bg;
	        }
	    }
	};
	exports.VueButtonsSegmented = buttonsSegmented;
	var CalendarDatePickerMixin = {
	    props: {
	        value: [String, Array, Number],
	        monthNames: Array,
	        monthNamesShort: Array,
	        dayNames: Array,
	        dayNamesShort: Array,
	        firstDay: Number,
	        weekendDays: Array,
	        multiple: Boolean,
	        rangePicker: Boolean,
	        dateFormat: String,
	        direction: String,
	        minDate: [Date, String, Number],
	        maxDate: [Date, String, Number],
	        disabled: [Array, Function, Object],
	        events: [Array, Function, Object],
	        rangesClasses: [Array, Function, Object],
	        touchMove: Boolean,
	        animate: Boolean,
	        closeOnSelect: Boolean,
	        monthPicker: Boolean,
	        yearPicker: Boolean,
	        weekHeader: Boolean,
	        // Common settings
	        closeByOutsideClick: Boolean,
	        scrollToInput: Boolean,
	        inputReadOnly: Boolean,
	        convertToPopover: Boolean,
	        onlyInPopover: Boolean,
	        toolbar: Boolean,
	        toolbarTemplate: String,
	        toolbarCloseText: String,
	        headerPlaceholder: String,
	        header: Boolean,
	        footer: Boolean,
	    },
	    computed: {
	        calendarValue: function calendarValue() {
	            var self = this;
	            if (self.value && !Array.isArray(self.value)) {
	                return [self.value];
	            }
	            return self.value;
	        }
	    },
	    watch: {
	        value: function value() {
	            var self = this;
	            if (self.f7Calendar) {
	                var newValue = self.value;
	                if (!Array.isArray(self.value)) {
	                    newValue = [self.value];
	                }
	                self.$nextTick(function () {
	                    self.f7Calendar.setValue(newValue);
	                });
	            }
	        }
	    },
	    beforeDestroy: function beforeDestroy() {
	        var self = this;
	        if (self.f7Calendar && self.f7Calendar.destroy) {
	            self.f7Calendar.destroy();
	        }
	    },
	    methods: {
	        getValue: function getValue() {
	            if (!this.f7Calendar) {
	                return;
	            }
	            return this.f7Calendar.value;
	        },
	        setValue: function setValue(values) {
	            if (!this.f7Calendar) {
	                return;
	            }
	            return this.f7Calendar.setValue(values);
	        },
	        nextMonth: function nextMonth(duration) {
	            if (!this.f7Calendar) {
	                return;
	            }
	            return this.f7Calendar.nextMonth(duration);
	        },
	        prevMonth: function prevMonth(duration) {
	            if (!this.f7Calendar) {
	                return;
	            }
	            return this.f7Calendar.prevMonth(duration);
	        },
	        nextYear: function nextYear() {
	            if (!this.f7Calendar) {
	                return;
	            }
	            return this.f7Calendar.nextYear();
	        },
	        prevYear: function prevYear() {
	            if (!this.f7Calendar) {
	                return;
	            }
	            return this.f7Calendar.prevYear();
	        },
	        setYearMonth: function setYearMonth(year, month, duration) {
	            if (!this.f7Calendar) {
	                return;
	            }
	            return this.f7Calendar.setYearMonth(year, month, duration);
	        },
	        open: function open() {
	            if (!this.f7Calendar) {
	                return;
	            }
	            return this.f7Calendar.open();
	        },
	        close: function close() {
	            if (!this.f7Calendar) {
	                return;
	            }
	            return this.f7Calendar.close();
	        },
	    }
	};
	exports.VueCalendarDatePickerMixin = CalendarDatePickerMixin;
	var calendar = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "calendar-inline" }); },
	    staticRenderFns: [],
	    mixins: [CalendarDatePickerMixin],
	    methods: {
	        onF7Init: function onF7Init(f7) {
	            var self = this;
	            if (typeof self.$options.propsData.footer === 'undefined') {
	                self.$options.propsData.footer = false;
	            }
	            if (typeof self.$options.propsData.header === 'undefined') {
	                self.$options.propsData.header = false;
	            }
	            var params = Object.assign(self.$options.propsData, {
	                container: self.$el,
	                value: self.calendarValue,
	                onChange: function onChange(c, values, displayValues) {
	                    self.$emit('change', c, values, displayValues);
	                },
	                onMonthAdd: function onMonthAdd(c, monthContainer) {
	                    self.$emit('monthAdd', c, monthContainer);
	                },
	                onDayClick: function onDayClick(c, dayContainer, year, month, day) {
	                    self.$emit('dayClick', c, dayContainer, year, month, day);
	                },
	                onMonthYearChangeStart: function onMonthYearChangeStart(c, year, month) {
	                    self.$emit('monthYearChangeStart', c, year, month);
	                },
	                onMonthYearChangeEnd: function onMonthYearChangeEnd(c, year, month) {
	                    self.$emit('monthYearChangeEnd', c, year, month);
	                },
	                onOpen: function onOpen(c) {
	                    self.$emit('open', c);
	                },
	                onClose: function onClose(c) {
	                    self.$emit('close', c);
	                },
	            });
	            self.f7Calendar = f7.calendar(params);
	        }
	    }
	};
	exports.VueCalendar = calendar;
	var cardContent = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "card-content" }, [(_vm.inner) ? _c('div', { staticClass: "card-content-inner" }, [_vm._t("default")], 2) : _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        inner: {
	            type: Boolean,
	            default: true
	        }
	    }
	};
	exports.VueCardContent = cardContent;
	var cardFooter = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "card-footer" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueCardFooter = cardFooter;
	var cardHeader = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "card-header" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueCardHeader = cardHeader;
	var card = {
	    render: function (c) {
	        var self = this;
	        var headerEl, contentEl, contentChildEl, footerEl;
	        if (self.title) {
	            headerEl = c('f7-card-header', { domProps: { innerHTML: self.title } });
	        }
	        if (self.content) {
	            contentChildEl = c('div', { domProps: { innerHTML: self.content } });
	            contentEl = c('f7-card-content', { props: { inner: self.inner } }, [contentChildEl]);
	        }
	        if (self.footer) {
	            footerEl = c('f7-card-footer', { domProps: { innerHTML: self.footer } });
	        }
	        return c('div', { staticClass: 'card' }, [headerEl, contentEl, footerEl, self.$slots.default]);
	    },
	    props: {
	        'title': [String, Number],
	        'content': [String, Number],
	        'footer': [String, Number],
	        'inner': {
	            type: Boolean,
	            default: true
	        }
	    }
	};
	exports.VueCard = card;
	var chip = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { staticClass: "chip", class: _vm.chipClassObject, on: { "click": _vm.onClick } }, [(_vm.media) ? _c('span', { staticClass: "chip-media", class: _vm.mediaClassObject, domProps: { "innerHTML": _vm._s(_vm.media) } }) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('span', { staticClass: "chip-label", domProps: { "innerHTML": _vm._s(_vm.text) } }) : _vm._e(), _vm._v(" "), (_vm.deleteable) ? _c('a', { staticClass: "chip-delete", attrs: { "href": "#" }, on: { "click": _vm.onDeleteClick } }) : _vm._e()]); },
	    staticRenderFns: [],
	    props: {
	        media: String,
	        text: [String, Number],
	        deleteable: Boolean,
	        color: String,
	        bg: String,
	        mediaBg: String,
	        mediaColor: String
	    },
	    computed: {
	        mediaClassObject: function () {
	            var c = {};
	            if (this.mediaColor) {
	                c['color-' + this.mediaColor] = true;
	            }
	            if (this.mediaBg) {
	                c['bg-' + this.mediaBg] = true;
	            }
	            return c;
	        },
	        chipClassObject: function () {
	            var c = {};
	            if (this.color) {
	                c['color-' + this.color] = true;
	            }
	            if (this.bg) {
	                c['bg-' + this.bg] = true;
	            }
	            return c;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        },
	        onDeleteClick: function (event) {
	            this.$emit('delete', event);
	        }
	    }
	};
	exports.VueChip = chip;
	var contentBlockTitle = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "content-block-title" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueContentBlockTitle = contentBlockTitle;
	var contentBlock = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "content-block", class: _vm.classesObject, on: { "tab:show": _vm.onTabShow, "tab:hide": _vm.onTabHide } }, [(_vm.inner) ? _c('div', { staticClass: "content-block-inner" }, [_vm._t("default")], 2) : _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'inset': Boolean,
	        'tablet-inset': Boolean,
	        'inner': Boolean,
	        'tabs': Boolean,
	        'tab': Boolean,
	        'active': Boolean,
	        'no-hairlines': Boolean,
	        'no-hairlines-between': Boolean,
	    },
	    computed: {
	        classesObject: function () {
	            var self = this;
	            return {
	                'inset': self.inset,
	                'tablet-inset': self.tabletInset,
	                'tabs': self.tabs,
	                'tab': self.tab,
	                'active': self.active,
	                'no-hairlines': self.noHairlines,
	                'no-hairlines-between': self.noHairlinesBetween,
	            };
	        }
	    },
	    methods: {
	        onTabShow: function (e) {
	            this.$emit('tab:show', e);
	        },
	        onTabHide: function (e) {
	            this.$emit('tab:hide', e);
	        }
	    }
	};
	exports.VueContentBlock = contentBlock;
	var dataTableActions = {
	    render: function (c) {
	        var self = this;
	        return c('div', { staticClass: 'data-table-actions' }, self.$slots.default);
	    }
	};
	exports.VueDataTableActions = dataTableActions;
	var dataTableCell = {
	    render: function (c) {
	        var self = this;
	        var heading = self.$parent && self.$parent.heading;
	        return c(heading ? 'th' : 'td', {
	            attrs: {
	                'data-collapsible-title': self.collapsibleTitle
	            },
	            class: self.classesObject,
	            on: {
	                click: self.onClick
	            }
	        }, [self.$slots.default]);
	    },
	    props: {
	        label: Boolean,
	        numeric: Boolean,
	        actions: Boolean,
	        sortable: Boolean,
	        checkbox: Boolean,
	        order: {
	            type: String,
	            default: 'asc'
	        },
	        'sortable-active': Boolean,
	        'collapsible-title': String,
	        'active-sorting': Boolean,
	        'tablet-only': Boolean,
	        'tablet-landscape-only': Boolean,
	    },
	    computed: {
	        classesObject: function classesObject() {
	            var self = this;
	            return {
	                'checkbox-cell': self.checkbox,
	                'label-cell': self.label,
	                'numeric-cell': self.numeric,
	                'actions-cell': self.actions,
	                'sortable-cell': self.sortable,
	                'sortable-asc': self.order === 'asc',
	                'sortable-desc': self.order === 'desc',
	                'sortable-active': self.sortableActive,
	                'tablet-only': self.tabletOnly,
	                'tablet-landscape-only': self.tabletLandscapeOnly,
	            };
	        }
	    },
	    methods: {
	        onClick: function onClick(event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueDataTableCell = dataTableCell;
	var dataTableHeader = {
	    render: function (c) {
	        var self = this;
	        var headerEl, titleEl;
	        if (self.title) {
	            titleEl = c('div', {
	                class: {
	                    'data-table-title': !self.selected,
	                    'data-table-title-selected': self.selected,
	                }
	            }, [self.title]);
	        }
	        if (self.$slots.default) {
	            self.$slots.default.map(function (el) {
	                var tag = el.componentOptions && el.componentOptions.tag;
	                if (tag === 'f7-table-title' && el.componentOptions.propsData) {
	                    el.componentOptions.propsData.selected = self.selected;
	                }
	            });
	        }
	        headerEl = c('div', {
	            class: {
	                'data-table-header': !self.selected,
	                'data-table-header-selected': self.selected,
	            }
	        }, [titleEl, self.$slots.default]);
	        return c('div', { staticClass: 'card-header' }, [headerEl]);
	    },
	    props: {
	        title: String,
	        selected: Boolean
	    }
	};
	exports.VueDataTableHeader = dataTableHeader;
	var dataTableLinks = {
	    render: function (c) {
	        var self = this;
	        return c('div', { staticClass: 'data-table-links' }, self.$slots.default);
	    }
	};
	exports.VueDataTableLinks = dataTableLinks;
	var dataTableRow = {
	    render: function (c) {
	        var self = this;
	        var checkboxEl;
	        if (self.selectable) {
	            checkboxEl = c('f7-table-cell', { props: { checkbox: true } }, [
	                c('label', { staticClass: 'form-checkbox' }, [
	                    c('input', {
	                        attrs: {
	                            type: 'checkbox'
	                        },
	                        domProps: {
	                            checked: self.selected
	                        },
	                        on: {
	                            change: self.onChange
	                        }
	                    }),
	                    c('i')
	                ])
	            ]);
	        }
	        return c('tr', {
	            class: {
	                'data-table-row-selected': self.selected
	            }
	        }, [checkboxEl, self.$slots.default]);
	    },
	    props: {
	        heading: Boolean,
	        selectable: Boolean,
	        selected: Boolean
	    },
	    methods: {
	        onChange: function (event) {
	            var self = this;
	            self.$emit('change', event);
	        }
	    }
	};
	exports.VueDataTableRow = dataTableRow;
	var dataTableTitle = {
	    render: function (c) {
	        var self = this;
	        return c('div', {
	            class: {
	                'data-table-title': !self.selected,
	                'data-table-title-selected': self.selected,
	            }
	        }, self.$slots.default);
	    },
	    props: {
	        selected: Boolean
	    }
	};
	exports.VueDataTableTitle = dataTableTitle;
	var dataTable = {
	    render: function (c) {
	        var self = this;
	        // Split Rows into thead and tbody
	        var theadEl = [];
	        var theadEls = [];
	        var tbodyEl = [];
	        var tbodyEls = [];
	        var beforeTableEls = [];
	        var afterTableEls = [];
	        var cells;
	        if (self.headings) {
	            cells = [];
	            self.headings.forEach(function (heading, index) {
	                var isNumeric = self.columns[index] && self.items[0][self.columns[index]] * 1 === parseFloat(self.items[0][self.columns[index]]);
	                cells.push(c('f7-table-cell', {
	                    props: {
	                        label: index === 0 && !isNumeric,
	                        numeric: isNumeric
	                    }
	                }, [heading]));
	            });
	            theadEls.push(c('f7-table-row', {
	                props: {
	                    heading: true,
	                    selectable: self.selectable
	                }
	            }, cells));
	        }
	        if (self.items) {
	            cells = [];
	            self.items.forEach(function (item) {
	                var cells = [];
	                self.columns.forEach(function (column, index) {
	                    var isNumeric = item[column] * 1 === parseFloat(item[column]);
	                    cells.push(c('f7-table-cell', {
	                        props: {
	                            label: index === 0 && !isNumeric,
	                            numeric: isNumeric
	                        }
	                    }, [item[column]]));
	                });
	                tbodyEls.push(c('f7-table-row', {
	                    props: {
	                        selectable: self.selectable
	                    }
	                }, cells));
	            });
	        }
	        if (self.title) {
	            beforeTableEls.push(c('f7-table-header', { props: { title: self.title } }));
	        }
	        var children = self.$slots.default || [];
	        for (var i = 0; i < children.length; i++) {
	            var child = children[i];
	            var tag = child.componentOptions && child.componentOptions.tag;
	            var childProps = child.componentOptions && child.componentOptions.propsData;
	            if (tag === 'f7-table-row') {
	                if (childProps.heading === '' || childProps.heading === true) {
	                    theadEls.push(child);
	                }
	                else {
	                    tbodyEls.push(child);
	                }
	                if (self.selectable && !('selectable' in childProps)) {
	                    childProps.selectable = true;
	                }
	            }
	            else {
	                beforeTableEls.push(child);
	            }
	            if (tag === 'f7-table-header') {
	                self.hasSelected = childProps.selected;
	            }
	        }
	        if (theadEls.length > 0) {
	            theadEl = c('thead', {}, theadEls);
	        }
	        tbodyEl = c('tbody', {}, tbodyEls);
	        // Before Table
	        beforeTableEls.push(self.$slots['before-table']);
	        // After Table
	        afterTableEls.push(self.$slots['after-table']);
	        // Table
	        var tableEl = c('table', {}, [theadEl, tbodyEl]);
	        return c('div', {
	            staticClass: 'data-table',
	            class: {
	                'data-table-collapsible': self.collapsible,
	                'data-table-has-checked': self.hasSelected,
	                'data-table-has-selected': self.hasSelected,
	                'card': self.card
	            }
	        }, [beforeTableEls, tableEl, afterTableEls]);
	    },
	    props: {
	        card: Boolean,
	        collapsible: Boolean,
	        selectable: Boolean,
	        items: Array,
	        title: String,
	        headings: Array,
	        columns: Array
	    }
	};
	exports.VueDataTable = dataTable;
	var datepicker = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "item-input" }, [_c('input', { attrs: { "type": "text", "name": _vm.name }, domProps: { "value": _vm.value } })]); },
	    staticRenderFns: [],
	    mixins: [CalendarDatePickerMixin],
	    props: {
	        name: String,
	    },
	    methods: {
	        onF7Init: function onF7Init(f7) {
	            var self = this;
	            var $$ = self.$$;
	            var input = $$(self.$el).find('input');
	            var params = Object.assign(self.$options.propsData, {
	                input: input,
	                value: self.calendarValue,
	                onChange: function onChange(c, values, displayValues) {
	                    self.$emit('change', c, values, displayValues);
	                },
	                onMonthAdd: function onMonthAdd(c, monthContainer) {
	                    self.$emit('monthAdd', c, monthContainer);
	                },
	                onDayClick: function onDayClick(c, dayContainer, year, month, day) {
	                    self.$emit('dayClick', c, dayContainer, year, month, day);
	                },
	                onMonthYearChangeStart: function onMonthYearChangeStart(c, year, month) {
	                    self.$emit('monthYearChangeStart', c, year, month);
	                },
	                onMonthYearChangeEnd: function onMonthYearChangeEnd(c, year, month) {
	                    self.$emit('monthYearChangeEnd', c, year, month);
	                },
	                onOpen: function onOpen(c) {
	                    self.$emit('open', c);
	                },
	                onClose: function onClose(c) {
	                    self.$emit('close', c);
	                },
	            });
	            self.f7Calendar = f7.calendar(params);
	        }
	    }
	};
	exports.VueDatepicker = datepicker;
	var fabSpeedDialAction = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('a', { class: _vm.classesObject, attrs: { "href": "#" }, on: { "click": _vm.onClick } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'color': String,
	        'closeSpeedDial': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {};
	            if (this.color) {
	                co['color-' + this.color] = true;
	            }
	            if (this.closeSpeedDial) {
	                co['close-speed-dial'] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueFabSpeedDialAction = fabSpeedDialAction;
	var fabSpeedDialActions = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "speed-dial-buttons", class: _vm.theme ? 'theme-' + _vm.theme : false }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        theme: String
	    }
	};
	exports.VueFabSpeedDialActions = fabSpeedDialActions;
	var fabSpeedDial = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "speed-dial", class: _vm.theme ? 'theme-' + _vm.theme : false }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        theme: String
	    }
	};
	exports.VueFabSpeedDial = fabSpeedDial;
	var fab = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('a', { staticClass: "floating-button", class: _vm.color ? 'color-' + _vm.color : false, attrs: { "href": "#" }, on: { "click": _vm.onClick } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        color: String
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueFab = fab;
	var formInput = {
	    render: function (c) {
	        var inputEl;
	        var self = this;
	        var attrs = {
	            name: self.name,
	            type: self.type,
	            placeholder: self.placeholder,
	            id: self.id,
	            value: self.valueComputed,
	            size: self.size,
	            accept: self.accept,
	            autocomplete: self.autocomplete,
	            autocorrect: self.autocorrect,
	            autocapitalize: self.autocapitalize,
	            spellcheck: self.spellcheck,
	            autofocus: self.autofocus,
	            autosave: self.autosave,
	            checked: self.checkedComputed,
	            disabled: self.disabled,
	            max: self.max,
	            maxlength: self.maxlength,
	            min: self.min,
	            minlength: self.minlength,
	            step: self.step,
	            multiple: self.multiple,
	            readonly: self.readonly,
	            required: self.required,
	            color: self.color,
	            pattern: self.pattern,
	            tabindex: self.tabindex,
	        };
	        var on = {
	            focus: self.onFocus,
	            blur: self.onBlur,
	            input: self.onInput,
	            change: self.onChange,
	            click: self.onClick,
	            keypress: self.onKeyPress,
	            keyup: self.onKeyUp,
	            keydown: self.onKeyDown,
	            beforeinput: self.onBeforeInput,
	            compositionstart: self.onCompositionStart,
	            compositionupdate: self.onCompositionUpdate,
	            compositionend: self.onCompositionEnd,
	            focusin: self.onFocusIn,
	            focusout: self.onFocusOut,
	            dblclick: self.onDblClick,
	            mousedown: self.onMouseDown,
	            mouseenter: self.onMouseEnter,
	            mouseleave: self.onMouseLeave,
	            mousemove: self.onMouseMove,
	            mouseout: self.onMouseOut,
	            mouseover: self.onMouseOver,
	            mouseup: self.onMouseUp,
	            wheel: self.onWheel,
	            select: self.onSelect
	        };
	        if (self.type === 'select' || self.type === 'textarea' || self.type === 'file') {
	            delete attrs.value;
	            if (self.type === 'select') {
	                if (self.hasSelectModel) {
	                    inputEl = c('select', { attrs: attrs, on: on, style: self.inputStyle }, self.$slots.default);
	                }
	                else {
	                    inputEl = c('select', { attrs: attrs, on: on, style: self.inputStyle, domProps: { value: self.valueComputed } }, self.$slots.default);
	                }
	            }
	            else if (self.type === 'file') {
	                inputEl = c('input', { attrs: attrs, style: self.inputStyle, on: on }, self.$slots.default);
	            }
	            else {
	                inputEl = c('textarea', { attrs: attrs, style: self.inputStyle, on: on, class: { resizable: self.resizable }, domProps: { value: self.valueComputed } }, self.$slots.default);
	            }
	        }
	        else {
	            if (self.$slots.default && self.$slots.default.length > 0 || !self.type) {
	                inputEl = self.$slots.default;
	            }
	            else {
	                if (self.type === 'switch') {
	                    inputEl = c('f7-switch', { props: attrs, on: on });
	                }
	                else if (self.type === 'range') {
	                    inputEl = c('f7-range', { props: attrs, on: on });
	                }
	                else {
	                    inputEl = c('input', { attrs: attrs, style: self.inputStyle, on: on, domProps: { value: self.valueComputed, checked: self.checkedComputed } });
	                }
	            }
	        }
	        var itemInput = self.wrap ? c('div', { staticClass: 'item-input' }, [inputEl]) : inputEl;
	        return itemInput;
	    },
	    watch: {
	        value: function () {
	            var self = this;
	            if (!self.hasSelectModel) {
	                return;
	            }
	            var $$ = self.$$;
	            $$(self.$el).find('option').each(function (index, option) {
	                if (self.value.indexOf(option.value) >= 0) {
	                    option.selected = true;
	                }
	                else {
	                    option.selected = false;
	                }
	            });
	        }
	    },
	    mounted: function () {
	        var self = this;
	        if (!self.hasSelectModel) {
	            return;
	        }
	        var $$ = self.$$;
	        $$(self.$el).find('option').each(function (index, option) {
	            if (self.value.indexOf(option.value) >= 0) {
	                option.selected = true;
	            }
	            else {
	                option.selected = false;
	            }
	        });
	    },
	    props: {
	        // Inputs
	        type: String,
	        name: String,
	        placeholder: String,
	        id: String,
	        value: [String, Number, Boolean, Array, Object],
	        inputValue: [String, Number],
	        size: [String, Number],
	        accept: [String, Number],
	        autocomplete: [String],
	        autocorrect: [String],
	        autocapitalize: [String],
	        spellcheck: [String],
	        autofocus: Boolean,
	        autosave: String,
	        checked: Boolean,
	        disabled: Boolean,
	        max: [String, Number],
	        min: [String, Number],
	        step: [String, Number],
	        maxlength: [String, Number],
	        minlength: [String, Number],
	        multiple: Boolean,
	        readonly: Boolean,
	        required: Boolean,
	        inputStyle: String,
	        pattern: String,
	        tabindex: [String, Number],
	        resizable: Boolean,
	        // Components
	        color: String,
	        wrap: {
	            "type": Boolean,
	            "default": true
	        }
	    },
	    computed: {
	        hasCheckboxModel: function () {
	            var self = this;
	            return (self.type === 'checkbox' || self.type === 'switch') && (typeof self.$options.propsData.value !== 'undefined' && typeof self.value === 'boolean' || Array.isArray(self.value));
	        },
	        hasRadioModel: function () {
	            var self = this;
	            return self.type === 'radio' && typeof self.inputValue !== 'undefined';
	        },
	        hasSelectModel: function () {
	            var self = this;
	            return self.type === 'select' && Array.isArray(self.value);
	        },
	        valueComputed: function () {
	            var self = this;
	            if (self.inputValue) {
	                return self.inputValue;
	            }
	            else if (self.hasCheckboxModel) {
	                return undefined;
	            }
	            else if (self.$options.propsData && self.$options.propsData.value !== undefined) {
	                return self.value;
	            }
	            else if (!self.hasCheckboxModel && !self.hasRadioModel && !self.hasSelectModel && 'value' in self.$options.propsData) {
	                return self.value;
	            }
	            return undefined;
	        },
	        checkedComputed: function () {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (self.inputValue && Array.isArray(self.value)) {
	                    return self.value.indexOf(self.inputValue) >= 0;
	                }
	                return self.value;
	            }
	            else if (self.hasRadioModel) {
	                if (typeof self.value !== typeof self.inputValue) {
	                    return self.value.toString() === self.inputValue.toString();
	                }
	                return self.value === self.inputValue;
	            }
	            else {
	                return self.checked;
	            }
	        }
	    },
	    methods: {
	        onInput: function (event) {
	            if (this.hasSelectModel) {
	                return;
	            }
	            if (event && event.type && event.type === 'input') {
	                this.$emit('input', event.target.value);
	            }
	            else {
	                this.$emit('input', event);
	            }
	        },
	        onFocus: function (event) {
	            this.$emit('focus', event);
	        },
	        onBlur: function (event) {
	            this.$emit('blur', event);
	        },
	        onChange: function (event) {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (Array.isArray(self.value)) {
	                    if (event.target.checked) {
	                        self.value.push(event.target.value);
	                    }
	                    else {
	                        self.value.splice(self.value.indexOf(event.target.value), 1);
	                    }
	                }
	                else {
	                    self.$emit('input', event.target.checked);
	                }
	                self.$emit('change', event);
	            }
	            else if (self.hasRadioModel) {
	                self.$emit('input', event.target.value);
	            }
	            else if (self.hasSelectModel) {
	                var values = Array.prototype.filter.call(event.target.options, function (option) {
	                    return option.selected;
	                }).map(function (option) {
	                    var val = "_value" in option ? option._value : option.value;
	                    return val;
	                });
	                self.$emit('input', values);
	            }
	            else {
	                self.$emit('change', event);
	            }
	        },
	        onClick: function (event) {
	            this.$emit('click', event);
	        },
	        onKeyPress: function (event) {
	            this.$emit('keypress', event);
	        },
	        onKeyUp: function (event) {
	            this.$emit('keyup', event);
	        },
	        onKeyDown: function (event) {
	            this.$emit('keydown', event);
	        },
	        onBeforeInput: function (event) {
	            this.$emit('beforeinput', event);
	        },
	        onCompositionStart: function (event) {
	            this.$emit('compositionstart', event);
	        },
	        onCompositionUpdate: function (event) {
	            this.$emit('compositionupdate', event);
	        },
	        onCompositionEnd: function (event) {
	            this.$emit('compositionend', event);
	        },
	        onFocusIn: function (event) {
	            this.$emit('focusin', event);
	        },
	        onFocusOut: function (event) {
	            this.$emit('focusout', event);
	        },
	        onDblClick: function (event) {
	            this.$emit('dblclick', event);
	        },
	        onMouseDown: function (event) {
	            this.$emit('mousedown', event);
	        },
	        onMouseEnter: function (event) {
	            this.$emit('mouseenter', event);
	        },
	        onMouseLeave: function (event) {
	            this.$emit('mouseleave', event);
	        },
	        onMouseMove: function (event) {
	            this.$emit('mousemove', event);
	        },
	        onMouseOut: function (event) {
	            this.$emit('mouseout', event);
	        },
	        onMouseOver: function (event) {
	            this.$emit('mouseover', event);
	        },
	        onMouseUp: function (event) {
	            this.$emit('mouseup', event);
	        },
	        onWheel: function (event) {
	            this.$emit('wheel', event);
	        },
	        onSelect: function (event) {
	            this.$emit('select', event);
	        }
	    }
	};
	exports.VueFormInput = formInput;
	var formLabel = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "item-title", class: { 'label': !_vm.floating, 'floating-label': _vm.floating } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        floating: Boolean
	    }
	};
	exports.VueFormLabel = formLabel;
	var formRange = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "range-slider", class: _vm.color ? 'color-' + _vm.color : '' }, [_c('input', { style: (_vm.inputStyle), attrs: { "type": "range", "name": _vm.name, "id": _vm.id, "disabled": _vm.disabled, "readonly": _vm.readonly, "required": _vm.required, "max": _vm.max, "min": _vm.min, "step": _vm.step }, domProps: { "value": _vm.value }, on: { "input": _vm.onInput, "change": _vm.onChange, "click": _vm.onClick } })]); },
	    staticRenderFns: [],
	    props: {
	        name: String,
	        id: String,
	        value: [String, Number],
	        disabled: Boolean,
	        readonly: Boolean,
	        required: Boolean,
	        inputStyle: String,
	        max: [String, Number],
	        min: [String, Number],
	        step: [String, Number],
	        color: String
	    },
	    methods: {
	        onInput: function (event) {
	            this.$emit('input', event.target.value);
	        },
	        onChange: function (event) {
	            this.$emit('change', event);
	        },
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueFormRange = formRange;
	var formSwitch = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('label', { staticClass: "label-switch", class: _vm.color ? 'color-' + _vm.color : '', on: { "click": _vm.onClick } }, [_c('input', { style: (_vm.inputStyle), attrs: { "type": "checkbox", "name": _vm.name, "id": _vm.id, "disabled": _vm.disabled, "readonly": _vm.readonly, "required": _vm.required }, domProps: { "value": _vm.valueComputed, "checked": _vm.checkedComputed }, on: { "input": _vm.onInput, "change": _vm.onChange } }), _vm._v(" "), _c('div', { staticClass: "checkbox" })]); },
	    staticRenderFns: [],
	    props: {
	        name: String,
	        id: String,
	        value: [String, Number, Boolean, Array],
	        inputValue: [String, Number],
	        checked: Boolean,
	        disabled: Boolean,
	        readonly: Boolean,
	        required: Boolean,
	        inputStyle: String,
	        color: String
	    },
	    computed: {
	        hasCheckboxModel: function () {
	            return typeof this.value === 'boolean' || Array.isArray(this.value);
	        },
	        valueComputed: function () {
	            var self = this;
	            if (self.inputValue) {
	                return self.inputValue;
	            }
	            else if (self.hasCheckboxModel) {
	                return undefined;
	            }
	            else if (self.$options.propsData && self.$options.propsData.value) {
	                return self.value;
	            }
	            return undefined;
	        },
	        checkedComputed: function () {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (self.inputValue && Array.isArray(self.value)) {
	                    return self.value.indexOf(self.inputValue) >= 0;
	                }
	                return self.value;
	            }
	            else {
	                return self.checked;
	            }
	        }
	    },
	    methods: {
	        onInput: function (event) {
	            this.$emit('input', event);
	        },
	        onChange: function (event) {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (Array.isArray(self.value)) {
	                    if (event.target.checked) {
	                        self.value.push(event.target.value);
	                    }
	                    else {
	                        self.value.splice(self.value.indexOf(event.target.value), 1);
	                    }
	                    self.$emit('change', event);
	                }
	                else {
	                    self.$emit('input', event.target.checked);
	                }
	            }
	            else {
	                self.$emit('change', event);
	            }
	        },
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueFormSwitch = formSwitch;
	var gridCol = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { class: ('col-' + _vm.width) + (_vm.tabletWidth ? ' tablet-' + _vm.tabletWidth : '') }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'width': {
	            type: [Number, String],
	            default: 'auto'
	        },
	        'tablet-width': {
	            type: [Number, String]
	        }
	    },
	    data: function () {
	        return {};
	    }
	};
	exports.VueGridCol = gridCol;
	var gridRow = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "row", class: { 'no-gutter': _vm.noGutter } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'no-gutter': Boolean
	    },
	    data: function () {
	        return {};
	    }
	};
	exports.VueGridRow = gridRow;
	var icon = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('i', { staticClass: "icon", class: _vm.classesObject, style: ({ 'font-size': _vm.sizeComputed }) }, [_vm._v(_vm._s(_vm.iconTextComputed)), _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'color': String,
	        'material': String,
	        'f7': String,
	        'ion': String,
	        'fa': String,
	        'icon': String,
	        'if-material': String,
	        'if-ios': String,
	        'size': [String, Number]
	    },
	    computed: {
	        sizeComputed: function () {
	            var self = this;
	            var size = self.size;
	            if (typeof size === 'number' || parseFloat(size) === size * 1) {
	                size = size + 'px';
	            }
	            return size;
	        },
	        iconTextComputed: function () {
	            var self = this;
	            var text = self.material || self.f7;
	            if (self.ifMaterial && self.$theme.material && (self.ifMaterial.indexOf('material:') >= 0 || self.ifMaterial.indexOf('f7:') >= 0)) {
	                text = self.ifMaterial.split(':')[1];
	            }
	            else if (self.ifIos && self.$theme.ios && (self.ifIos.indexOf('material:') >= 0 || self.ifIos.indexOf('f7:') >= 0)) {
	                text = self.ifIos.split(':')[1];
	            }
	            return text;
	        },
	        classesObject: function () {
	            var co = {};
	            var self = this;
	            if (self.ifMaterial || self.ifIos) {
	                var parts = self[self.$theme.material ? 'ifMaterial' : 'ifIos'].split(':');
	                var prop = parts[0];
	                var value = parts[1];
	                if (prop === 'material' || prop === 'fa' || prop === 'f7') {
	                    co['fa'] = prop === 'fa';
	                    co['material-icons'] = prop === 'material';
	                    co['f7-icons'] = prop === 'f7';
	                }
	                if (prop === 'fa' || prop === 'ion') {
	                    co[prop + '-' + value] = true;
	                }
	                if (prop === 'icon') {
	                    co[value] = true;
	                }
	            }
	            else {
	                co = {
	                    'material-icons': this.material,
	                    'f7-icons': this.f7,
	                    'fa': this.fa
	                };
	                if (this.ion) {
	                    co['ion-' + this.ion] = true;
	                }
	                if (this.fa) {
	                    co['fa-' + this.fa] = true;
	                }
	                if (this.icon) {
	                    co[this.icon] = true;
	                }
	            }
	            if (this.color) {
	                co['color-' + this.color] = true;
	            }
	            return co;
	        }
	    }
	};
	exports.VueIcon = icon;
	var link = {
	    mixins: [LinkMixin],
	    render: function (c) {
	        var iconEl, textEl, isTabbarLabel, badgeEl, iconBadgeEl, self = this;
	        isTabbarLabel = (self.tabLink || self.tabLink === '') && self.$parent && self.$parent.tabbar && self.$parent.labels;
	        if (self.text) {
	            if (self.badge) {
	                badgeEl = c('f7-badge', { props: { color: self.badgeColor } }, self.badge);
	            }
	            textEl = c('span', { class: { 'tabbar-label': isTabbarLabel } }, [self.text, badgeEl]);
	        }
	        if (self.icon || self.iconMaterial || self.iconIon || self.iconFa || self.iconF7 || (self.iconIfMaterial && self.$theme.material) || (self.iconIfIos && self.$theme.ios)) {
	            if (self.iconBadge) {
	                iconBadgeEl = c('f7-badge', { props: { color: self.badgeColor } }, self.iconBadge);
	            }
	            iconEl = c('f7-icon', { props: {
	                    material: self.iconMaterial,
	                    ion: self.iconIon,
	                    fa: self.iconFa,
	                    f7: self.iconF7,
	                    icon: self.icon,
	                    ifMaterial: self.iconIfMaterial,
	                    ifIos: self.iconIfIos,
	                    size: self.iconSize
	                } }, [iconBadgeEl]);
	        }
	        if (!self.text && self.$slots.default && self.$slots.default.length === 0 || self.iconOnly || !self.text && !self.$slots.default) {
	            self.classesObject['icon-only'] = true;
	        }
	        self.classesObject.link = self.noLinkClass || isTabbarLabel ? false : true;
	        var linkEl = c('a', {
	            class: self.classesObject,
	            attrs: self.attrsObject,
	            on: {
	                click: self.onClick
	            }
	        }, [iconEl, textEl, self.$slots.default]);
	        return linkEl;
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueLink = link;
	var listButton = {
	    render: function (c) {
	        var self = this;
	        var linkEl;
	        if (self.title) {
	            linkEl = c('a', {
	                staticClass: 'item-link list-button',
	                attrs: self.attrsObject,
	                class: self.classesObject,
	                domProps: {
	                    innerHTML: self.title
	                },
	                on: {
	                    click: self.onClick
	                }
	            });
	        }
	        else {
	            linkEl = c('a', {
	                staticClass: 'item-link list-button',
	                attrs: self.attrsObject,
	                class: self.classesObject,
	                on: {
	                    click: self.onClick
	                }
	            }, [self.$slots.default]);
	        }
	        return c('li', {}, [linkEl]);
	    },
	    props: {
	        'title': [String, Number],
	        'link': [Boolean, String],
	        'href': [Boolean, String],
	        'tabindex': [Number, String],
	        'external': Boolean,
	        'link-external': Boolean,
	        'back': Boolean,
	        'link-back': Boolean,
	        'no-fastclick': Boolean,
	        'link-no-fastlick': Boolean,
	        color: String,
	        // Router
	        force: Boolean,
	        reload: Boolean,
	        animatePages: Boolean,
	        ignoreCache: Boolean,
	        pageName: String,
	        template: String,
	        // View
	        view: String,
	        // Panel
	        openPanel: [Boolean, String],
	        closePanel: [Boolean, String],
	        // Popup
	        openPopup: [Boolean, String],
	        closePopup: [Boolean, String],
	        // Popover
	        openPopover: [Boolean, String],
	        closePopover: [Boolean, String],
	        // Login Screen
	        openLoginScreen: [Boolean, String],
	        closeLoginScreen: [Boolean, String],
	        // Picker
	        openPicker: [Boolean, String],
	        closePicker: [Boolean, String],
	        // Tab
	        tabLink: [Boolean, String],
	        // Sortable
	        openSortable: [Boolean, String],
	        closeSortable: [Boolean, String],
	        toggleSortable: [Boolean, String],
	    },
	    computed: {
	        attrsObject: function () {
	            var self = this;
	            var ao = {
	                href: ((typeof self.link === 'boolean' && typeof self.href === 'boolean') ? '#' : (self.link || self.href))
	            };
	            var pd = self.$options.propsData;
	            if ('force' in pd) {
	                ao['data-force'] = self.force;
	            }
	            if ('reload' in pd) {
	                ao['data-reload'] = 'true';
	            }
	            if ('animatePages' in pd && typeof pd.animatePages === 'boolean') {
	                ao['data-animate-pages'] = pd.animatePages.toString();
	            }
	            if ('ignoreCache' in pd) {
	                ao['data-ignore-cache'] = 'true';
	            }
	            if (self.pageName) {
	                ao['data-page-name'] = self.pageName;
	            }
	            if (self.template) {
	                ao['data-template'] = self.template;
	            }
	            if (self.view) {
	                ao['data-view'] = self.view;
	            }
	            if (self.tabindex) {
	                ao['tabindex'] = self.tabindex;
	            }
	            function trustyString(s) {
	                if (typeof s === 'string' && s !== '') {
	                    return true;
	                }
	                return false;
	            }
	            if (trustyString(self.openPanel)) {
	                ao['data-panel'] = self.openPanel;
	            }
	            if (trustyString(self.openPopup)) {
	                ao['data-popup'] = self.openPopup;
	            }
	            if (trustyString(self.openPopover)) {
	                ao['data-popover'] = self.openPopover;
	            }
	            if (trustyString(self.openPicker)) {
	                ao['data-picker'] = self.openPicker;
	            }
	            if (trustyString(self.openLoginScreen)) {
	                ao['data-login-screen'] = self.openLoginScreen;
	            }
	            if (trustyString(self.openSortable)) {
	                ao['data-sortable'] = self.openSortable;
	            }
	            if (trustyString(self.toggleSortable)) {
	                ao['data-sortable'] = self.toggleSortable;
	            }
	            if (trustyString(self.closePopup)) {
	                ao['data-popup'] = self.closePopup;
	            }
	            if (trustyString(self.closePopover)) {
	                ao['data-popover'] = self.closePopover;
	            }
	            if (trustyString(self.closePicker)) {
	                ao['data-picker'] = self.closePicker;
	            }
	            if (trustyString(self.closeLoginScreen)) {
	                ao['data-login-screen'] = self.closeLoginScreen;
	            }
	            if (trustyString(self.closeSortable)) {
	                ao['data-sortable'] = self.closeSortable;
	            }
	            if (trustyString(self.tabLink)) {
	                ao['data-tab'] = self.tabLink;
	            }
	            return ao;
	        },
	        classesObject: function () {
	            var self = this;
	            var co = {
	                'external': self.external || self.linkExternal,
	                'back': self.back || self.linkBack,
	                'no-fastclick': self.noFastclick || self.linkNoFastclick
	            };
	            function trustyBoolean(b) {
	                if (b || b === '') {
	                    return true;
	                }
	                return false;
	            }
	            // Panel
	            if (trustyBoolean(self.closePanel)) {
	                co['close-panel'] = true;
	            }
	            if (self.openPanel || self.openPanel === '') {
	                co['open-panel'] = true;
	            }
	            // Popup
	            if (trustyBoolean(self.closePopup)) {
	                co['close-popup'] = true;
	            }
	            if (self.openPopup || self.openPopup === '') {
	                co['open-popup'] = true;
	            }
	            // Popover
	            if (trustyBoolean(self.closePopover)) {
	                co['close-popover'] = true;
	            }
	            if (self.openPopover || self.openPopover === '') {
	                co['open-popover'] = true;
	            }
	            // Picker
	            if (trustyBoolean(self.closePicker)) {
	                co['close-picker'] = true;
	            }
	            if (self.openPicker || self.openPicker === '') {
	                co['open-picker'] = true;
	            }
	            // Login Screen
	            if (trustyBoolean(self.closeLoginScreen)) {
	                co['close-login-screen'] = true;
	            }
	            if (self.openLoginScreen || self.openLoginScreen === '') {
	                co['open-login-screen'] = true;
	            }
	            // Sortable
	            if (trustyBoolean(self.closeSortable)) {
	                co['close-sortable'] = true;
	            }
	            if (self.openSortable || self.openSortable === '') {
	                co['open-sortable'] = true;
	            }
	            if (self.toggleSortable || self.toggleSortable === '') {
	                co['toggle-sortable'] = true;
	            }
	            // Tab
	            if (trustyBoolean(self.tabLink)) {
	                co['tab-link'] = true;
	            }
	            // Color
	            if (self.color) {
	                co['color-' + self.color] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueListButton = listButton;
	var listGroup = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "list-block-group" }, [_c('ul', [_vm._t("default")], 2)]); },
	    staticRenderFns: [],
	    props: {
	        'media-list': Boolean,
	        'sortable': Boolean,
	    },
	    computed: {
	        sortableComputed: function () {
	            return this.sortable || this.$parent.sortable;
	        },
	        mediaListComputed: function () {
	            return this.mediaList || this.$parent.mediaList;
	        }
	    },
	    data: function () {
	        return {};
	    }
	};
	exports.VueListGroup = listGroup;
	var listItemContent = {
	    render: function (c) {
	        var titleEl, afterWrapEl, afterEl, badgeEl, innerEl, titleRowEl, subtitleEl, textEl, mediaEl, inputEl, inputIconEl;
	        var self = this;
	        var slotsContentStart = [], slotsContent = [], slotsInnerStart = [], slotsInner = [], slotsAfterStart = [], slotsAfter = [], slotsMediaStart = [], slotsMedia = [];
	        if (self.$slots.default && self.$slots.default.length > 0) {
	            for (var i = 0; i < self.$slots.default.length; i++) {
	                var slotName = self.$slots.default[i].data ? self.$slots.default[i].data.slot : undefined;
	                if (slotName && slotName === 'content-start') {
	                    slotsContentStart.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'content') {
	                    slotsContent.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'after-start') {
	                    slotsAfterStart.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'after') {
	                    slotsAfter.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'media-start') {
	                    slotsMediaStart.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'media') {
	                    slotsMedia.push(self.$slots.default[i]);
	                }
	                if (slotName && slotName === 'inner-start') {
	                    slotsInnerStart.push(self.$slots.default[i]);
	                }
	                if (!slotName || slotName && slotName === 'inner') {
	                    slotsInner.push(self.$slots.default[i]);
	                }
	            }
	        }
	        // Input
	        if (self.radio || self.checkbox) {
	            inputEl = c('input', {
	                attrs: {
	                    value: self.value,
	                    name: self.name,
	                    checked: self.checked,
	                    readonly: self.readonly,
	                    disabled: self.disabled,
	                    required: self.required,
	                    type: self.radio ? 'radio' : 'checkbox'
	                },
	                on: {
	                    change: self.onChange
	                },
	                domProps: {
	                    checked: self.checked
	                }
	            });
	        }
	        // Media
	        if (self.media || self.checkbox || self.radio && self.$theme.material || slotsMediaStart.length || slotsMedia.length) {
	            if (self.checkbox || self.radio && self.$theme.material) {
	                if (self.media) {
	                    inputIconEl = '<i class="icon icon-form-' + (self.radio ? 'radio' : 'checkbox') + '"></i>';
	                    mediaEl = c('div', { 'class': { 'item-media': true }, domProps: { innerHTML: inputIconEl + (self.media ? self.media : '') } });
	                }
	                else {
	                    var iconClasses = { 'icon': true };
	                    iconClasses['icon-form-' + (self.radio ? 'radio' : 'checkbox')] = true;
	                    inputIconEl = c('i', { 'class': iconClasses });
	                    mediaEl = c('div', { 'class': { 'item-media': true } }, [slotsMediaStart, inputIconEl, slotsMedia]);
	                }
	            }
	            else {
	                if (self.media) {
	                    mediaEl = c('div', { staticClass: 'item-media', domProps: { innerHTML: self.media } });
	                }
	                else {
	                    mediaEl = c('div', { staticClass: 'item-media' }, [slotsMediaStart, slotsMedia]);
	                }
	            }
	        }
	        // Inner Elements
	        if (self.title) {
	            titleEl = c('div', { staticClass: 'item-title', domProps: { innerHTML: self.title } }, [self.title]);
	        }
	        if (self.subtitle) {
	            subtitleEl = c('div', { staticClass: 'item-subtitle', domProps: { innerHTML: self.subtitle } }, [self.subtitle]);
	        }
	        if (self.text) {
	            textEl = c('div', { staticClass: 'item-text', domProps: { innerHTML: self.text } });
	        }
	        if (self.after || self.badge || slotsAfter.length) {
	            if (self.after) {
	                afterEl = c('span', { domProps: { innerHTML: self.after } });
	            }
	            if (self.badge) {
	                badgeEl = c('f7-badge', { props: { color: self.badgeColor } }, [self.badge]);
	            }
	            afterWrapEl = c('div', { staticClass: 'item-after' }, [slotsAfterStart, afterEl, badgeEl, slotsAfter]);
	        }
	        if (self.mediaList) {
	            titleRowEl = c('div', { staticClass: 'item-title-row' }, [titleEl, afterWrapEl]);
	        }
	        innerEl = c('div', { staticClass: 'item-inner' }, self.mediaList ? [slotsInnerStart, titleRowEl, subtitleEl, textEl, slotsInner] : [slotsInnerStart, titleEl, afterWrapEl, slotsInner]);
	        // Finalize
	        return c((self.checkbox || self.radio) ? 'label' : 'div', { staticClass: 'item-content', 'class': { 'label-checkbox': self.checkbox, 'label-radio': self.radio }, on: { click: self.onClick } }, [slotsContentStart, inputEl, mediaEl, innerEl, slotsContent]);
	    },
	    props: {
	        'title': [String, Number],
	        'text': [String, Number],
	        'media': String,
	        'subtitle': [String, Number],
	        'after': [String, Number],
	        'badge': [String, Number],
	        'badge-color': String,
	        'media-list': Boolean,
	        'checkbox': Boolean,
	        'checked': Boolean,
	        'radio': Boolean,
	        'name': String,
	        'value': [String, Number, Boolean, Array],
	        'input-value': [String, Number],
	        'readonly': Boolean,
	        'required': Boolean,
	        'disabled': Boolean
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        },
	        onChange: function (event) {
	            this.$emit('change', event);
	        }
	    }
	};
	exports.VueListItemContent = listItemContent;
	var listItemSwipeoutActions = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { class: 'swipeout-actions-' + _vm.sideComputed }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'left': Boolean,
	        'right': Boolean,
	        'side': String
	    },
	    computed: {
	        sideComputed: function () {
	            if (!this.side) {
	                if (this.left) {
	                    return 'left';
	                }
	                if (this.right) {
	                    return 'right';
	                }
	                return 'right';
	            }
	            return this.side;
	        }
	    },
	    data: function () {
	        return {};
	    }
	};
	exports.VueListItemSwipeoutActions = listItemSwipeoutActions;
	var listItemSwipeoutButton = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('a', { class: _vm.classObject, attrs: { "href": "#" }, on: { "click": _vm.onClick } }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))])], 2); },
	    staticRenderFns: [],
	    props: {
	        'text': String,
	        'overswipe': Boolean,
	        'close': Boolean,
	        'delete': Boolean,
	        'color': String,
	        'bg': String
	    },
	    computed: {
	        classObject: function () {
	            var co = {
	                'swipeout-overswipe': this.overswipe,
	                'swipeout-delete': this.delete,
	                'swipeout-close': this.close
	            };
	            if (this.color) {
	                co['bg-' + this.color] = true;
	            }
	            if (this.bg) {
	                co['bg-' + this.bg] = true;
	            }
	            return co;
	        }
	    },
	    data: function () {
	        return {};
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        }
	    }
	};
	exports.VueListItemSwipeoutButton = listItemSwipeoutButton;
	var listItem = {
	    render: function (c) {
	        var liChildren, linkEl, itemContentEl;
	        var self = this;
	        function trustyBoolean(b) {
	            if (b || b === '') {
	                return true;
	            }
	            return false;
	        }
	        function trustyString(s) {
	            if (typeof s === 'string' && s !== '') {
	                return true;
	            }
	            return false;
	        }
	        // Item Content
	        itemContentEl = c('f7-list-item-content', {
	            props: {
	                'title': self.title,
	                'text': self.text,
	                'media': self.media,
	                'subtitle': self.subtitle,
	                'after': self.after,
	                'badge': self.badge,
	                'badge-color': self.badgeColor,
	                'media-list': self.mediaListComputed,
	                'accordion-item': self.accordionItem,
	                'checkbox': self.checkbox,
	                'checked': self.checkedComputed,
	                'radio': self.radio,
	                'name': self.name,
	                'value': self.valueComputed,
	                'readonly': self.readonly,
	                'required': self.required,
	                'disabled': self.disabled
	            },
	            on: (self.link || self.accordionItem || self.smartSelect) ? {} : { click: self.onClick, change: self.onChange }
	        }, [self.$slots['content-start'], self.$slots.content, self.$slots['media-start'], self.$slots.media, self.$slots['inner-start'], self.$slots.inner, self.$slots['after-start'], self.$slots.after, (self.swipeout || self.accordionItem ? [] : self.$slots.default)]);
	        // Link
	        if (self.link || self.accordionItem || self.smartSelect) {
	            linkEl = c('a', {
	                attrs: {
	                    href: self.link === true || self.accordionItem || self.smartSelect ? '#' : self.link,
	                    'target': self.linkTarget,
	                    'data-searchbar': self.smartSelectSearchbar,
	                    'data-searchbar-placeholder': self.smartSelectSearchbarPlaceholder,
	                    'data-searchbar-cancel': self.smartSelectSearchbarCancel,
	                    'data-page-title': self.smartSelectPageTitle,
	                    'data-back-text': self.smartSelectBackText,
	                    'data-back-on-select': self.smartSelectBackOnSelect,
	                    'data-virtual-list': self.smartSelectVirtualList,
	                    'data-virtual-list-height': self.smartSelectVirtualListHeight,
	                    'data-open-in': self.smartSelectOpenIn,
	                    'data-navbar-theme': self.smartSelectNavbarTheme,
	                    'data-form-theme': self.smartSelectFormTheme,
	                    'data-view': trustyString(self.linkView) ? self.linkView : false,
	                    'data-panel': trustyString(self.linkOpenPanel) ? self.linkOpenPanel : false,
	                    'data-popup': trustyString(self.linkOpenPopup) ? self.linkOpenPopup : false,
	                    'data-popover': trustyString(self.linkOpenPopover) ? self.linkOpenPopover : false,
	                    'data-picker': trustyString(self.linkOpenPicker) ? self.linkOpenPicker : false,
	                    'data-login-screen': trustyString(self.linkOpenLoginScreen) ? self.linkOpenLoginScreen : false,
	                    'data-sortable': trustyString(self.linkOpenSortable) ? self.linkOpenSortable : (trustyString(self.linkToggleSortable) ? self.linkToggleSortable : false),
	                    'data-force': self.linkForce,
	                    'data-reload': self.linkReload,
	                    'data-animate-pages': ('linkAnimatePages' in self.$options.propsData) ? self.linkAnimatePages.toString() : undefined,
	                    'data-ignore-cache': self.linkIgnoreCache,
	                    'data-page-name': typeof self.linkPageName === 'string' ? self.linkPageName : false,
	                    'data-template': typeof self.linkTemplate === 'string' ? self.linkTemplate : false,
	                },
	                'class': {
	                    'item-link': true,
	                    'external': self.linkExternal,
	                    'back': self.linkBack,
	                    'no-fastclick': self.linkNoFastclick,
	                    'smart-select': self.smartSelect,
	                    'close-panel': trustyBoolean(self.linkClosePanel),
	                    'open-panel': self.linkOpenPanel || self.linkOpenPanel === '',
	                    'close-popup': trustyBoolean(self.linkClosePopup),
	                    'open-popup': self.linkOpenPopup || self.linkOpenPopup === '',
	                    'close-popover': trustyBoolean(self.linkClosePopover),
	                    'open-popover': self.linkOpenPopover || self.linkOpenPopover === '',
	                    'close-picker': trustyBoolean(self.linkClosePicker),
	                    'open-picker': self.linkOpenPicker || self.linkOpenPicker === '',
	                    'close-login-screen': trustyBoolean(self.linkCloseLoginScreen),
	                    'open-login-screen': self.linkOpenLoginScreen || self.linkOpenLoginScreen === '',
	                    'close-sortable': trustyBoolean(self.linkCloseSortable),
	                    'open-sortable': self.linkOpenSortable || self.linkOpenSortable === '',
	                    'toggle-sortable': self.linkToggleSortable || self.linkToggleSortable === '',
	                },
	                on: {
	                    click: self.onClick
	                }
	            }, [itemContentEl]);
	        }
	        if (self.dividerOrGroupTitle) {
	            liChildren = [c('span', self.$slots.default || self.title)];
	        }
	        else {
	            var linkItemEl = (self.link || self.smartSelect || self.accordionItem) ? linkEl : itemContentEl;
	            if (self.swipeout) {
	                liChildren = [c('div', { 'class': { 'swipeout-content': true } }, [linkItemEl])];
	            }
	            else {
	                liChildren = [linkItemEl];
	            }
	            if (self.sortableComputed) {
	                liChildren.push(c('div', { 'class': { 'sortable-handler': true } }));
	            }
	            if (self.swipeout || self.accordionItem) {
	                liChildren.push(self.$slots.default);
	            }
	            liChildren.unshift(self.$slots['root-start']);
	            liChildren.push(self.$slots.root);
	        }
	        return c('li', {
	            'class': {
	                'item-divider': self.divider,
	                'list-group-title': self.groupTitle,
	                'swipeout': self.swipeout,
	                'accordion-item': self.accordionItem,
	                'accordion-item-expanded': self.accordionExpanded
	            },
	            on: {
	                'swipeout:open': self.onSwipeoutOpen,
	                'swipeout:opened': self.onSwipeoutOpened,
	                'swipeout:close': self.onSwipeoutClose,
	                'swipeout:closed': self.onSwipeoutClosed,
	                'swipeout:delete': self.onSwipeoutDelete,
	                'swipeout:deleted': self.onSwipeoutDeleted,
	                'swipeout': self.onSwipeout,
	                'accordion:open': self.onAccOpen,
	                'accordion:opened': self.onAccOpened,
	                'accordion:close': self.onAccClose,
	                'accordion:closed': self.onAccClosed,
	            }
	        }, liChildren);
	    },
	    props: {
	        'title': [String, Number],
	        'text': [String, Number],
	        'media': String,
	        'subtitle': [String, Number],
	        // Link Props
	        'link': [Boolean, String],
	        'link-external': Boolean,
	        'link-back': Boolean,
	        'link-no-fastclick': Boolean,
	        'link-force': Boolean,
	        'link-reload': Boolean,
	        'link-animate-pages': Boolean,
	        'link-ignore-cache': Boolean,
	        'link-page-name': String,
	        'link-template': String,
	        'link-target': String,
	        'link-view': String,
	        'link-open-panel': [Boolean, String],
	        'link-close-panel': [Boolean, String],
	        'link-open-popup': [Boolean, String],
	        'link-close-popup': [Boolean, String],
	        'link-open-popover': [Boolean, String],
	        'link-close-popover': [Boolean, String],
	        'link-open-login-screen': [Boolean, String],
	        'link-close-login-screen': [Boolean, String],
	        'link-open-picker': [Boolean, String],
	        'link-close-picker': [Boolean, String],
	        'after': [String, Number],
	        'badge': [String, Number],
	        'badge-color': String,
	        'media-item': Boolean,
	        'media-list-item': Boolean,
	        'media-list': Boolean,
	        'divider': Boolean,
	        'group-title': Boolean,
	        'swipeout': Boolean,
	        'sortable': Boolean,
	        'accordion-item': Boolean,
	        'accordion-expanded': Boolean,
	        // Smart Select
	        'smart-select': Boolean,
	        'smart-select-searchbar': Boolean,
	        'smart-select-searchbar-placeholder': String,
	        'smart-select-searchbar-cancel': String,
	        'smart-select-page-title': String,
	        'smart-select-back-text': String,
	        'smart-select-back-on-select': Boolean,
	        'smart-select-virtual-list': Boolean,
	        'smart-select-virtual-list-height': Number,
	        'smart-select-open-in': String,
	        'smart-select-navbar-theme': String,
	        'smart-select-form-theme': String,
	        // Inputs
	        'checkbox': Boolean,
	        'checked': Boolean,
	        'radio': Boolean,
	        'name': String,
	        'value': [String, Number, Boolean, Array],
	        'input-value': [String, Number],
	        'readonly': Boolean,
	        'required': Boolean,
	        'disabled': Boolean
	    },
	    computed: {
	        dividerOrGroupTitle: function () {
	            return this.divider || this.groupTitle;
	        },
	        sortableComputed: function () {
	            return this.sortable || this.$parent.sortable || this.$parent.sortableComputed;
	        },
	        mediaListComputed: function () {
	            return this.mediaList || this.mediaItem || this.$parent.mediaList || this.$parent.mediaListComputed;
	        },
	        hasCheckboxModel: function () {
	            var self = this;
	            return self.checkbox && (typeof self.$options.propsData.value !== 'undefined' && typeof self.value === 'boolean' || Array.isArray(self.value));
	        },
	        hasRadioModel: function () {
	            var self = this;
	            return self.radio && typeof self.inputValue !== 'undefined';
	        },
	        valueComputed: function () {
	            var self = this;
	            if (self.inputValue) {
	                return self.inputValue;
	            }
	            else if (self.hasCheckboxModel) {
	                return undefined;
	            }
	            else {
	                return self.value;
	            }
	        },
	        checkedComputed: function () {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (self.inputValue && Array.isArray(self.value)) {
	                    return self.value.indexOf(self.inputValue) >= 0;
	                }
	                return self.value;
	            }
	            else if (self.hasRadioModel) {
	                if (typeof self.value !== typeof self.inputValue) {
	                    return self.value.toString() === self.inputValue.toString();
	                }
	                return self.value === self.inputValue;
	            }
	            else {
	                return self.checked;
	            }
	        }
	    },
	    methods: {
	        onClick: function (event) {
	            if (event.target.tagName.toLowerCase() !== 'input') {
	                this.$emit('click', event);
	            }
	        },
	        onSwipeoutDeleted: function (event) {
	            this.$emit('swipeout:deleted', event);
	        },
	        onSwipeoutDelete: function (event) {
	            this.$emit('swipeout:delete', event);
	        },
	        onSwipeoutClose: function (event) {
	            this.$emit('swipeout:close', event);
	        },
	        onSwipeoutClosed: function (event) {
	            this.$emit('swipeout:closed', event);
	        },
	        onSwipeoutOpen: function (event) {
	            this.$emit('swipeout:open', event);
	        },
	        onSwipeoutOpened: function (event) {
	            this.$emit('swipeout:opened', event);
	        },
	        onSwipeout: function (event) {
	            this.$emit('swipeout', event);
	        },
	        onAccClose: function (event) {
	            this.$emit('accordion:close', event);
	        },
	        onAccClosed: function (event) {
	            this.$emit('accordion:closed', event);
	        },
	        onAccOpen: function (event) {
	            this.$emit('accordion:open', event);
	        },
	        onAccOpened: function (event) {
	            this.$emit('accordion:opened', event);
	        },
	        onChange: function (event) {
	            var self = this;
	            if (self.hasCheckboxModel) {
	                if (Array.isArray(self.value)) {
	                    if (event.target.checked) {
	                        self.value.push(event.target.value);
	                    }
	                    else {
	                        self.value.splice(self.value.indexOf(event.target.value), 1);
	                    }
	                }
	                else {
	                    self.$emit('input', event.target.checked);
	                }
	                self.$emit('change', event);
	            }
	            else if (self.hasRadioModel) {
	                self.$emit('input', event.target.value);
	            }
	            else {
	                self.$emit('change', event);
	            }
	        }
	    }
	};
	exports.VueListItem = listItem;
	var listLabel = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "list-block-label" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueListLabel = listLabel;
	var list = {
	    beforeDestroy: function () {
	        var self = this;
	        if (!(self.virtual && self.virtualInit && self.f7VirtualList)) {
	            return;
	        }
	        if (self.f7VirtualList.destroy) {
	            self.f7VirtualList.destroy();
	        }
	    },
	    watch: {
	        virtualItems: function () {
	            // Items Updated
	            var self = this;
	            if (!(self.virtual && self.virtualInit && self.f7VirtualList)) {
	                return;
	            }
	            self.f7VirtualList.replaceAllItems(self.virtualItems);
	        },
	    },
	    render: function (c) {
	        var blockEl, blockChildren;
	        var self = this;
	        blockChildren = self.grouped ? self.$slots.default : c('ul', {}, self.$slots.default);
	        var outOfList = [], ulSlots = [];
	        if (self.$slots.default) {
	            for (var i = 0; i < self.$slots.default.length; i++) {
	                var tag = self.$slots.default[i].tag;
	                if (tag && !(tag == 'li' || tag.indexOf('list-item') >= 0 || tag.indexOf('list-button') >= 0)) {
	                    outOfList.push(self.$slots.default[i]);
	                }
	                else {
	                    ulSlots.push(self.$slots.default[i]);
	                }
	            }
	        }
	        blockEl = c(self.form ? 'form' : 'div', {
	            staticClass: 'list-block',
	            'class': {
	                'inset': self.inset,
	                'tablet-inset': self.tabletInset,
	                'media-list': self.mediaList,
	                'sortable': self.sortable,
	                'accordion-list': self.accordion,
	                'contacts-block': self.contacts,
	                'virtual-list': self.virtual,
	                'tab': self.tab,
	                'active': self.active,
	                'no-hairlines': self.noHairlines,
	                'no-hairlines-between': self.noHairlinesBetween,
	                'store-data': self.storeData
	            },
	            on: {
	                'sortable:open': self.onSortableOpen,
	                'sortable:close': self.onSortableClose,
	                'sortable:sort': self.onSortableSort,
	                'tab:show': self.onTabShow,
	                'tab:hide': self.onTabHide
	            }
	        }, [
	            ulSlots.length > 0 ? [c('ul', {}, ulSlots), outOfList] : outOfList
	        ]);
	        return blockEl;
	    },
	    props: {
	        'inset': Boolean,
	        'tablet-inset': Boolean,
	        'media-list': Boolean,
	        'grouped': Boolean,
	        'sortable': Boolean,
	        'label': String,
	        'accordion': Boolean,
	        'contacts': Boolean,
	        'no-hairlines': Boolean,
	        'no-hairlines-between': Boolean,
	        // Tab
	        'tab': Boolean,
	        'active': Boolean,
	        // Form
	        'form': Boolean,
	        'store-data': Boolean,
	        // Virtual List
	        'virtual': Boolean,
	        'virtual-init': {
	            type: Boolean,
	            default: true
	        },
	        'virtual-items': [Array, Object],
	        'virtual-height': [Number, Function],
	        'virtual-rows-before': Number,
	        'virtual-rows-after': Number,
	        'virtual-cols': {
	            type: Number,
	            default: 1
	        },
	        'virtual-cache': {
	            type: Boolean,
	            default: true
	        },
	        'virtual-filtered-only': {
	            type: Boolean,
	            default: false
	        },
	        'virtual-search-by-item': Function,
	        'virtual-search-all': Function,
	        'virtual-render-item': Function,
	        'virtual-empty-template': String,
	        'virtual-render-external': Function,
	    },
	    methods: {
	        onSortableOpen: function (event) {
	            this.$emit('sortable:open', event);
	        },
	        onSortableClose: function (event) {
	            this.$emit('sortable:close', event);
	        },
	        onSortableSort: function (event) {
	            this.$emit('sortable:sort', event, event.detail);
	        },
	        onTabShow: function (e) {
	            this.$emit('tab:show', e);
	        },
	        onTabHide: function (e) {
	            this.$emit('tab:hide', e);
	        },
	        onF7Init: function (f7) {
	            var self = this;
	            // Init Virtual List
	            if (!(self.virtual && self.virtualInit)) {
	                return;
	            }
	            var $$ = self.$$;
	            var $el = $$(self.$el);
	            var templateScript = $el.find('script');
	            var template = templateScript.html();
	            if (!template && templateScript.length > 0) {
	                template = templateScript[0].outerHTML;
	                template = /\<script type="text\/template7"\>(.*)<\/script>/.exec(template)[1];
	            }
	            if (!template && !self.virtualRenderItem && !self.virtualRenderExternal) {
	                return;
	            }
	            if (template) {
	                template = self.$t7.compile(template);
	            }
	            self.f7VirtualList = f7.virtualList(self.$el, {
	                items: self.virtualItems || [],
	                template: template,
	                height: self.virtualHeight || undefined,
	                cols: self.virtualCols,
	                rowsBefore: self.virtualRowsBefore || undefined,
	                rowsAfter: self.virtualRowsAfter || undefined,
	                showFilteredItemsOnly: self.virtualFilteredOnly,
	                searchByItem: self.virtualSearchByItem,
	                searchAll: self.virtualSearchAll,
	                renderItem: self.virtualRenderItem,
	                renderExternal: self.virtualRenderExternal,
	                emptyTemplate: self.virtualEmptyTemplate,
	                onItemBeforeInsert: function (list, item) {
	                    self.$emit('virtual:itembeforeinsert', list, item);
	                },
	                onBeforeClear: function (list, fragment) {
	                    self.$emit('virtual:beforeclear', list, fragment);
	                },
	                onItemsBeforeInsert: function (list, fragment) {
	                    self.$emit('virtual:itemsbeforeinsert', list, fragment);
	                },
	                onItemsAfterInsert: function (list, fragment) {
	                    self.$emit('virtual:itemsafterinsert', list, fragment);
	                },
	            });
	        }
	    }
	};
	exports.VueList = list;
	var loginScreenTitle = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "login-screen-title" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	};
	exports.VueLoginScreenTitle = loginScreenTitle;
	var loginScreen = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "login-screen", class: _vm.classesObject, on: { "loginscreen:open": _vm.onOpen, "loginscreen:opened": _vm.onOpened, "loginscreen:close": _vm.onClose, "loginscreen:closed": _vm.onClosed } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    mounted: function () {
	        var self = this;
	        if (self.opened) {
	            self.$el.style.display = 'block';
	        }
	    },
	    watch: {
	        opened: function (opened) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            var $$ = self.$$;
	            if (opened) {
	                self.$f7.loginScreen(self.$el);
	            }
	            else {
	                if (!$$(self.$el).hasClass('modal-in')) {
	                    return;
	                }
	                self.$f7.closeModal(self.$el);
	            }
	        }
	    },
	    props: {
	        theme: String,
	        layout: String,
	        opened: Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'modal-in': this.opened,
	                'modal-out': !this.opened
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onOpen: function (event) {
	            this.$emit('loginscreen:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('loginscreen:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('loginscreen:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('loginscreen:closed', event);
	        },
	        open: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.loginScreen(self.$el, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.closeModal(self.$el, animated);
	        }
	    }
	};
	exports.VueLoginScreen = loginScreen;
	var message = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { class: _vm.classesObject, on: { "click": _vm.onClick } }, [_vm._v("\n  " + _vm._s(_vm.day) + " "), (_vm.time) ? _c('span', [_vm._v(_vm._s(_vm.time))]) : _vm._e(), _vm._v(" "), _vm._t("start"), _vm._v(" "), (_vm.name) ? _c('div', { staticClass: "message-name", on: { "click": _vm.onNameClick } }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _vm._v(" "), _c('div', { staticClass: "message-text", on: { "click": _vm.onTextClick } }, [_vm._t("default", [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.date) ? _c('div', { staticClass: "message-date" }, [_vm._v(_vm._s(_vm.date))]) : _vm._e()], 2), _vm._v(" "), (_vm.avatar) ? _c('div', { staticClass: "message-avatar", style: ({ 'background-image': 'url(' + _vm.avatar + ')' }), on: { "click": _vm.onAvatarClick } }) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('div', { staticClass: "message-label" }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _vm._t("end")], 2); },
	    staticRenderFns: [],
	    props: {
	        text: String,
	        name: String,
	        avatar: String,
	        type: {
	            type: String,
	            default: 'sent'
	        },
	        label: String,
	        day: String,
	        date: String,
	        time: String,
	        last: {
	            type: Boolean,
	            default: true
	        },
	        first: {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        classesObject: function () {
	            var co = {};
	            var self = this;
	            if (self.day || self.time) {
	                co['messages-date'] = self.day || self.time;
	            }
	            else {
	                var newPosition = 'bottom';
	                if (self.$parent.newFirst) {
	                    newPosition = 'top';
	                }
	                // co['message-appear-from-' + newPosition] = true;
	                co['message-date'] = self.day || self.time;
	                co['message'] = !(self.day || self.time);
	                co['message-' + self.type] = true;
	                co['message-with-avatar'] = self.avatar;
	                co['message-first'] = self.first;
	                co['message-last'] = self.last;
	                co['message-with-tail'] = self.last;
	            }
	            return co;
	        },
	    },
	    methods: {
	        onClick: function (event) {
	            this.$emit('click', event);
	        },
	        onNameClick: function (event) {
	            this.$emit('click:name', event);
	        },
	        onTextClick: function (event) {
	            this.$emit('click:text', event);
	        },
	        onAvatarClick: function (event) {
	            this.$emit('click:avatar', event);
	        },
	    }
	};
	exports.VueMessage = message;
	var messagebar = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "toolbar messagebar" }, [_vm._t("before-inner"), _vm._v(" "), _c('div', { staticClass: "toolbar-inner" }, [_vm._t("before-textarea"), _vm._v(" "), _c('textarea', { ref: "area", attrs: { "placeholder": _vm.placeholder, "disabled": _vm.disabled, "name": _vm.name, "readonly": _vm.readonly }, on: { "input": _vm.onInput, "change": _vm.onChange, "focus": _vm.onFocus, "blur": _vm.onBlur } }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _vm._t("after-textarea"), _vm._v(" "), (_vm.sendLink && _vm.sendLink.indexOf('<') >= 0) ? _c('f7-link', { domProps: { "innerHTML": _vm._s(_vm.sendLink) }, on: { "click": _vm.onClick } }) : _c('f7-link', { on: { "click": _vm.onClick } }, [_vm._t("send-link", [_vm._v(_vm._s(_vm.sendLink))])], 2), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm._t("after-inner")], 2); },
	    staticRenderFns: [],
	    beforeDestroy: function () {
	        if (this.f7Messagebar && this.f7Messagebar.destroy) {
	            this.f7Messagebar.destroy();
	        }
	    },
	    props: {
	        placeholder: {
	            type: String,
	            default: 'Message'
	        },
	        init: {
	            type: Boolean,
	            default: true
	        },
	        maxHeight: Number,
	        sendLink: String,
	        value: [String, Number],
	        disabled: Boolean,
	        readonly: Boolean,
	        name: String
	    },
	    methods: {
	        getValue: function () {
	            if (!this.f7Messagebar) {
	                return;
	            }
	            return this.f7Messagebar.value();
	        },
	        setValue: function (newValue) {
	            if (!this.f7Messagebar) {
	                return;
	            }
	            return this.f7Messagebar.value(newValue);
	        },
	        clear: function () {
	            if (!this.f7Messagebar) {
	                return;
	            }
	            return this.f7Messagebar.clear();
	        },
	        onChange: function (event) {
	            this.$emit('change', event);
	        },
	        onInput: function (event) {
	            this.$emit('input', event.target.value);
	        },
	        onFocus: function (event) {
	            this.$emit('focus', event);
	        },
	        onBlur: function (event) {
	            this.$emit('blur', event);
	        },
	        onClick: function (event) {
	            var value = this.$refs.area.value;
	            var clear = this.f7Messagebar ? this.f7Messagebar.clear : function () { };
	            this.$emit('submit', value, clear);
	            this.$emit('click', event);
	        },
	        onF7Init: function () {
	            var self = this;
	            if (!self.init) {
	                return;
	            }
	            self.f7Messagebar = self.$f7.messagebar(self.$el, {
	                maxHeight: self.maxHeight
	            });
	        }
	    }
	};
	exports.VueMessagebar = messagebar;
	var messages = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "messages" }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    beforeDestroy: function () {
	        if (this.f7Messages && this.f7Messages.destroy) {
	            this.f7Messages.destroy();
	        }
	    },
	    beforeUpdate: function (a, b) {
	        var self = this;
	        if (!self.init) {
	            return;
	        }
	        self.$children.forEach(function (el) {
	            self.$$(el.$el).addClass('message-appeared');
	        });
	    },
	    updated: function (a, b) {
	        var self = this;
	        if (!self.init) {
	            return;
	        }
	        self.$children.forEach(function (el) {
	            var $el = self.$$(el.$el);
	            if (!$el.hasClass('message-appeared')) {
	                $el.addClass('message-appear-from-bottom');
	            }
	        });
	        if (this.f7Messages && this.f7Messages.layout && this.autoLayout) {
	            this.f7Messages.layout();
	        }
	        if (this.f7Messages && this.f7Messages.scrollMessages && this.scrollMessages) {
	            this.f7Messages.scrollMessages();
	        }
	    },
	    props: {
	        autoLayout: {
	            type: Boolean,
	            default: true
	        },
	        newMessagesFirst: Boolean,
	        messages: Array,
	        scrollMessages: {
	            type: Boolean,
	            default: true
	        },
	        scrollMessagesOnlyOnEdge: Boolean,
	        init: {
	            type: Boolean,
	            default: true
	        }
	    },
	    methods: {
	        addMessage: function (messageParameters, method, animate) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.addMessage(messageParameters, method, animate);
	        },
	        appendMessage: function (messageParameters, animate) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.appendMessage(messageParameters, animate);
	        },
	        prependMessage: function (messageParameters, animate) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.prependMessage(messageParameters, animate);
	        },
	        addMessages: function (messages, method, animate) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.addMessages(messages, method, animate);
	        },
	        removeMessage: function (message) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.removeMessage(message);
	        },
	        removeMessages: function (messages) {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.removeMessages(messages);
	        },
	        scroll: function () {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.scrollMessages();
	        },
	        layout: function () {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.layout();
	        },
	        clean: function () {
	            if (!this.f7Messages) {
	                return;
	            }
	            return this.f7Messages.clean();
	        },
	        onF7Init: function (f7) {
	            var self = this;
	            if (!self.init) {
	                return;
	            }
	            self.f7Messages = f7.messages(self.$el, {
	                autoLayout: self.autoLayout,
	                newMessagesFirst: self.newMessagesFirst,
	                messages: self.messages,
	                scrollMessages: self.scrollMessages,
	                scrollMessagesOnlyOnEdge: self.scrollMessagesOnlyOnEdge,
	            });
	        }
	    }
	};
	exports.VueMessages = messages;
	var navCenter = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "center", class: { sliding: _vm.sliding } }, [_vm._t("default", [_vm._v(_vm._s(_vm.title))])], 2); },
	    staticRenderFns: [],
	    props: {
	        sliding: Boolean,
	        title: String
	    }
	};
	exports.VueNavCenter = navCenter;
	var navLeft = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "left", class: { sliding: _vm.sliding } }, [(_vm.backLink) ? _c('f7-link', { class: { 'icon-only': (_vm.backLink === true || _vm.backLink && _vm.$theme.material) }, attrs: { "href": _vm.backLinkUrl || _vm.backLinkHref || '#', "back": "", "icon": "icon-back", "text": _vm.backLink !== true && !_vm.$theme.material ? _vm.backLink : undefined }, on: { "click": _vm.onBackClick } }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        backLink: [Boolean, String],
	        backLinkUrl: String,
	        backLinkHref: String,
	        sliding: Boolean
	    },
	    methods: {
	        onBackClick: function (e) {
	            this.$emit('back-click', e);
	            this.$emit('click:back', e);
	        }
	    }
	};
	exports.VueNavLeft = navLeft;
	var navRight = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "right", class: { sliding: _vm.sliding } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        sliding: Boolean
	    }
	};
	exports.VueNavRight = navRight;
	var navbar = {
	    render: function (c) {
	        var self = this, innerEl, leftEl, centerEl;
	        if (self.inner) {
	            if (self.backLink) {
	                leftEl = c('f7-nav-left', {
	                    props: {
	                        backLink: self.backLink,
	                        sliding: self.sliding,
	                        backLinkHref: self.backLinkUrl || self.backLinkHref
	                    },
	                    on: {
	                        'back-click': self.onBackClick
	                    }
	                });
	            }
	            if (self.title) {
	                centerEl = c('f7-nav-center', {
	                    props: {
	                        title: self.title,
	                        sliding: self.sliding
	                    }
	                });
	            }
	            innerEl = c('div', { staticClass: 'navbar-inner' }, [leftEl, centerEl, self.$slots.default]);
	        }
	        return c('div', {
	            staticClass: 'navbar',
	            class: self.classesObject,
	            on: {
	                'navbar:beforeinit': self.onBeforeInit,
	                'navbar:init': self.onInit,
	                'navbar:reinit': self.onReinit,
	                'navbar:beforeremove': self.onBeforeRemove,
	            },
	        }, [self.$slots['before-inner'], innerEl, self.$slots['after-inner']]);
	    },
	    updated: function () {
	        var self = this;
	        self.$nextTick(function () {
	            self.$f7.sizeNavbars();
	        });
	    },
	    props: {
	        backLink: [Boolean, String],
	        backLinkUrl: String,
	        backLinkHref: String,
	        sliding: Boolean,
	        title: String,
	        theme: String,
	        layout: String,
	        hidden: Boolean,
	        noShadow: Boolean,
	        inner: {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'navbar-hidden': this.hidden
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            if (this.noShadow) {
	                co['no-shadow'] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        hide: function (animated) {
	            if (!this.$f7) {
	                return;
	            }
	            return this.$f7.hideNavbar(this.$el, animated);
	        },
	        show: function (animated) {
	            if (!this.$f7) {
	                return;
	            }
	            return this.$f7.showNavbar(this.$el, animated);
	        },
	        size: function () {
	            if (!this.$f7 || this.$theme.material) {
	                return;
	            }
	            return this.$f7.sizeNavbars();
	        },
	        onBeforeInit: function (e) {
	            this.$emit('navbar:beforeinit', e);
	        },
	        onInit: function (e) {
	            this.$emit('navbar:init', e);
	        },
	        onReinit: function (e) {
	            this.$emit('navbar:reinit', e);
	        },
	        onBeforeRemove: function (e) {
	            this.$emit('navbar:beforeremove', e);
	        },
	        onBackClick: function (e) {
	            this.$emit('back-click', e);
	            this.$emit('click:back', e);
	        }
	    }
	};
	exports.VueNavbar = navbar;
	var pageContent = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "page-content", class: _vm.classesObject, on: { "tab:show": _vm.onTabShow, "tab:hide": _vm.onTabHide } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'tab': Boolean,
	        'active': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var self = this;
	            return {
	                'tab': self.tab,
	                'active': self.active
	            };
	        }
	    },
	    methods: {
	        onTabShow: function (e) {
	            this.$emit('tab:show', e);
	        },
	        onTabHide: function (e) {
	            this.$emit('tab:hide', e);
	        }
	    }
	};
	exports.VuePageContent = pageContent;
	var page = {
	    render: function (c) {
	        var pageEl, pageContentEl, ptrEl, infiniteEl, fixedList = [], staticList = [];
	        var self = this;
	        if (self.pullToRefresh && (self.ptrLayer && self.pullToRefreshLayer)) {
	            ptrEl = c('div', { class: { 'pull-to-refresh-layer': true } }, [
	                c('div', { class: { 'preloader': true } }),
	                c('div', { class: { 'pull-to-refresh-arrow': true } })
	            ]);
	        }
	        if ((self.infiniteScroll || self.infiniteScroll === '') && self.infiniteScrollPreloader) {
	            infiniteEl = c('div', { class: { 'infinite-scroll-preloader': true } }, [
	                c('div', { class: { 'preloader': true } })
	            ]);
	        }
	        var fixedTags = ('navbar toolbar tabbar subnavbar searchbar messagebar fab speed-dial floating-button').split(' ');
	        var tag, child, withSubnavbar, withMessages, withSearchbar;
	        var i, j;
	        if (self.$slots.default) {
	            for (i = 0; i < self.$slots.default.length; i++) {
	                child = self.$slots.default[i];
	                tag = child.tag;
	                if (!tag) {
	                    staticList.push(child);
	                    continue;
	                }
	                var isFixed = false;
	                if (tag.indexOf('messages') >= 0) {
	                    withMessages = true;
	                }
	                if (tag.indexOf('subnavbar') >= 0) {
	                    withSubnavbar = true;
	                }
	                if (tag.indexOf('searchbar') >= 0) {
	                    withSearchbar = true;
	                }
	                for (j = 0; j < fixedTags.length; j++) {
	                    if (tag.indexOf(fixedTags[j]) >= 0) {
	                        isFixed = true;
	                    }
	                }
	                if (isFixed) {
	                    fixedList.push(child);
	                }
	                else {
	                    staticList.push(child);
	                }
	            }
	        }
	        if (fixedList.length > 0 && withSearchbar) {
	            fixedList.push(c('div', { class: { 'searchbar-overlay': true } }));
	        }
	        if (withMessages) {
	            self.classesObjectPageContent['messages-content'] = true;
	        }
	        if (!self.noPageContent) {
	            pageContentEl = c('div', {
	                staticClass: 'page-content',
	                class: self.classesObjectPageContent,
	                attrs: {
	                    'data-ptr-distance': self.pullToRefreshDistance || self.ptrDistance,
	                    'data-distance': self.infiniteScrollDistance
	                },
	                on: {
	                    'ptr:pullstart': self.onPtrPullstart,
	                    'ptr:pullmove': self.onPtrPullmove,
	                    'ptr:pullend': self.onPtrPullend,
	                    'ptr:refresh': self.onPtrRefresh,
	                    'ptr:done': self.onPtrRefreshdone,
	                    'infinite': self.onInfinite
	                },
	            }, (self.infiniteScroll === 'top' ? [ptrEl, infiniteEl, self.$slots.static, staticList] : [ptrEl, self.$slots.static, staticList, infiniteEl]));
	        }
	        else {
	            pageContentEl = [];
	            if (self.$slots.default && fixedList.length > 0) {
	                for (i = 0; i < self.$slots.default.length; i++) {
	                    if (fixedList.indexOf(self.$slots.default[i]) < 0) {
	                        pageContentEl.push(self.$slots.default[i]);
	                    }
	                }
	            }
	            else {
	                pageContentEl = [self.$slots.default];
	            }
	        }
	        fixedList.push(self.$slots.fixed);
	        if (withSubnavbar) {
	            self.classesObjectPage['with-subnavbar'] = true;
	        }
	        pageEl = c('div', {
	            staticClass: 'page',
	            class: self.classesObjectPage,
	            attrs: {
	                'data-page': self.name
	            },
	            on: {
	                'page:beforeinit': self.onPageBeforeInit,
	                'page:init': self.onPageInit,
	                'page:reinit': self.onPageReinit,
	                'page:beforeanimation': self.onPageBeforeAnimation,
	                'page:afteranimation': self.onPageAfterAnimation,
	                'page:beforeremove': self.onPageBeforeRemove,
	                'page:back': self.onPageBack,
	                'page:afterback': self.onPageAfterBack
	            }
	        }, [fixedList, pageContentEl]);
	        return pageEl;
	    },
	    props: {
	        'name': String,
	        'cached': Boolean,
	        'navbar-fixed': Boolean,
	        'navbar-through': Boolean,
	        'toolbar-fixed': Boolean,
	        'toolbar-through': Boolean,
	        'tabbar-fixed': Boolean,
	        'tabbar-through': Boolean,
	        'tabbar-labels-fixed': Boolean,
	        'tabbar-labels-through': Boolean,
	        'with-subnavbar': Boolean,
	        'subnavbar': Boolean,
	        'no-navbar': Boolean,
	        'no-toolbar': Boolean,
	        'no-tabbar': Boolean,
	        'pull-to-refresh': Boolean,
	        'pull-to-refresh-distance': Number,
	        'ptr-distance': Number,
	        'pull-to-refresh-layer': {
	            type: Boolean,
	            default: true
	        },
	        'ptr-layer': {
	            type: Boolean,
	            default: true
	        },
	        'infinite-scroll': [Boolean, String],
	        'infinite-scroll-distance': Number,
	        'infinite-scroll-preloader': {
	            type: Boolean,
	            default: true
	        },
	        'hide-bars-on-scroll': Boolean,
	        'hide-navbar-on-scroll': Boolean,
	        'hide-toolbar-on-scroll': Boolean,
	        'hide-tabbar-on-scroll': Boolean,
	        'messages': Boolean,
	        'tabs': Boolean,
	        'no-page-content': Boolean,
	        'login-screen': Boolean,
	        'theme': String,
	        'layout': String,
	        'no-swipeback': Boolean
	    },
	    computed: {
	        classesObjectPage: function () {
	            var co = {
	                'cached': this.cached,
	                'navbar-fixed': this.navbarFixed || this.navbarThrough && this.$theme.material,
	                'navbar-through': this.navbarThrough,
	                'toolbar-fixed': this.toolbarFixed,
	                'toolbar-through': this.toolbarThrough,
	                'tabbar-fixed': this.tabbarFixed,
	                'tabbar-through': this.tabbarThrough,
	                'tabbar-labels-fixed': this.tabbarLabelsFixed,
	                'tabbar-labels-through': this.tabbarLabelsThrough,
	                'with-subnavbar': this.subnavbar || this.withSubnavbar,
	                'no-navbar': this.noNavbar,
	                'no-toolbar': this.noToolbar,
	                'no-tabbar': this.noTabbar,
	                'tabs': this.tabs,
	                'no-swipeback': this.noSwipeback
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        },
	        classesObjectPageContent: function () {
	            return {
	                'pull-to-refresh-content': this.pullToRefresh,
	                'infinite-scroll': this.infiniteScroll || this.infiniteScroll === '',
	                'infinite-scroll-top': this.infiniteScroll === 'top',
	                'hide-bars-on-scroll': this.hideBarsOnScroll,
	                'hide-navbar-on-scroll': this.hideNavbarOnScroll,
	                'hide-toolbar-on-scroll': this.hideToolbarOnScroll,
	                'hide-tabbar-on-scroll': this.hideTabbarOnScroll,
	                'messages-content': this.messages,
	                'login-screen-content': this.loginScreen
	            };
	        }
	    },
	    methods: {
	        onPtrPullstart: function (event) {
	            this.$emit('ptr:pullstart', event);
	        },
	        onPtrPullmove: function (event) {
	            this.$emit('ptr:pullmove', event);
	        },
	        onPtrPullend: function (event) {
	            this.$emit('ptr:pullend', event);
	        },
	        onPtrRefresh: function (event) {
	            this.$emit('ptr:refresh', event, event.detail.done);
	        },
	        onPtrRefreshdone: function (event) {
	            this.$emit('ptr:done', event);
	        },
	        onInfinite: function (event) {
	            this.$emit('infinite', event);
	        },
	        onPageBeforeInit: function (event) {
	            this.f7PageData = event.detail.page;
	            this.$emit('page:beforeinit', event, event.detail.page);
	        },
	        onPageInit: function (event) {
	            this.$emit('page:init', event, event.detail.page);
	        },
	        onPageReinit: function (event) {
	            this.$emit('page:reinit', event, event.detail.page);
	        },
	        onPageBeforeAnimation: function (event) {
	            this.$emit('page:beforeanimation', event, event.detail.page);
	        },
	        onPageAfterAnimation: function (event) {
	            this.$emit('page:afteranimation', event, event.detail.page);
	        },
	        onPageBeforeRemove: function (event) {
	            this.$emit('page:beforeremove', event, event.detail.page);
	        },
	        onPageBack: function (event) {
	            this.$emit('page:back', event, event.detail.page);
	        },
	        onPageAfterBack: function (event) {
	            this.$emit('page:afterback', event, event.detail.page);
	        }
	    }
	};
	exports.VuePage = page;
	var pages = {
	    render: function (c) {
	        var self = this;
	        var pages = [];
	        for (var pageId in self.pages) {
	            var page = self.pages[pageId];
	            pages.push(c(page.component, { tag: 'component', props: self.$route && self.$route.params, key: pageId }));
	        }
	        return c('div', {
	            staticClass: 'pages',
	            ref: 'pages',
	            class: self.classesObject,
	            on: {
	                'page:beforeremove': self.onPageBeforeRemove
	            }
	        }, [
	            self.$slots.default,
	            pages
	        ]);
	    },
	    props: {
	        'navbar-fixed': Boolean,
	        'navbar-through': Boolean,
	        'toolbar-fixed': Boolean,
	        'toolbar-through': Boolean,
	        'tabbar-fixed': Boolean,
	        'tabbar-through': Boolean,
	        'tabbar-labels-fixed': Boolean,
	        'tabbar-labels-through': Boolean,
	        'theme': String,
	        'layout': String
	    },
	    data: function () {
	        return {
	            pages: {}
	        };
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'navbar-fixed': this.navbarFixed || this.navbarThrough && this.$theme.material,
	                'navbar-through': this.navbarThrough,
	                'toolbar-fixed': this.toolbarFixed,
	                'toolbar-through': this.toolbarThrough,
	                'tabbar-fixed': this.tabbarFixed,
	                'tabbar-through': this.tabbarThrough,
	                'tabbar-labels-fixed': this.tabbarLabelsFixed,
	                'tabbar-labels-through': this.tabbarLabesThrough
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onPageBeforeRemove: function (e) {
	            var this$1 = this;
	            var idToRemove;
	            for (var id in this$1.pages) {
	                if (e.target === this$1.pages[id].pageElement) {
	                    idToRemove = id;
	                    break;
	                }
	            }
	            if (idToRemove) {
	                this.$delete(this.pages, idToRemove);
	            }
	        },
	        onRouteChange: function (event) {
	            var self = this;
	            var pageComponent = event.route.component;
	            var view = event.view;
	            var currentView = self.$parent.f7View || self.$parent.$el.f7View;
	            if (view !== currentView) {
	                return;
	            }
	            var previousRoute = self.$f7Router.findMatchingRoute(view.url) || { route: { path: '/', pagePath: '/' } };
	            var pageRouteChanged = previousRoute.route.pagePath !== event.route.pagePath;
	            var childRouteChanged = !pageRouteChanged && previousRoute.route.path !== event.route.path;
	            var shouldUpdatePages = pageRouteChanged || (!childRouteChanged && (event.options.reload || view.params.allowDuplicateUrls));
	            if (!shouldUpdatePages) {
	                return;
	            }
	            var id = new Date().getTime();
	            self.$set(self.pages, id, { component: pageComponent });
	            view.allowPageChange = false;
	            self.$nextTick(function () {
	                var newPage = view.pagesContainer.querySelector('.page:last-child');
	                self.pages[id].pageElement = newPage;
	                view.allowPageChange = true;
	                var options = Object.assign(event.options, {
	                    pageElement: newPage
	                });
	                if (options.isBack) {
	                    view.router.back(options);
	                }
	                else {
	                    view.router.load(options);
	                }
	            });
	        }
	    }
	};
	exports.VuePages = pages;
	var panel = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "panel", class: _vm.classesObject, on: { "panel:open": _vm.onOpen, "panel:opened": _vm.onOpened, "panel:close": _vm.onClose, "panel:closed": _vm.onClosed, "panel:overlay-click": _vm.onOverlayClick, "panel:swipe": _vm.onPanelSwipe } }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'side': String,
	        'effect': String,
	        'cover': Boolean,
	        'reveal': Boolean,
	        'left': Boolean,
	        'right': Boolean,
	        'theme': String,
	        'layout': String,
	        'opened': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var self = this;
	            var side = self.side || (self.left ? 'left' : 'right');
	            var effect = self.effect || (self.reveal ? 'reveal' : 'cover');
	            var co = {};
	            co['panel-' + side] = true;
	            co['panel-' + effect] = true;
	            if (self.layout) {
	                co['layout-' + self.layout] = true;
	            }
	            if (self.theme) {
	                co['theme-' + self.theme] = true;
	            }
	            co.active = self.opened;
	            return co;
	        }
	    },
	    watch: {
	        opened: function (opened) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            var side = self.side || (self.left ? 'left' : 'right');
	            if (opened) {
	                self.$f7.openPanel(side);
	            }
	            else {
	                self.$f7.closePanel(side);
	            }
	        }
	    },
	    mounted: function () {
	        var self = this;
	        if (self.opened) {
	            self.$el.style.display = 'block';
	        }
	        var $$ = self.$$;
	        if (!$$) {
	            return;
	        }
	        var side = self.side || (self.left ? 'left' : 'right');
	        var effect = self.effect || (self.reveal ? 'reveal' : 'cover');
	        if (self.opened) {
	            $$('body').addClass('with-panel-' + side + '-' + effect);
	        }
	    },
	    methods: {
	        onOpen: function (event) {
	            this.$emit('panel:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('panel:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('panel:open', event);
	        },
	        onClosed: function (event) {
	            this.$emit('panel:closed', event);
	        },
	        onOverlayClick: function onOverlayClick(event) {
	            this.$emit('panel:overlay-click', event);
	        },
	        onPanelSwipe: function onPanelSwipe(event) {
	            this.$emit('panel:swipe', event);
	        },
	        onF7Init: function () {
	            var $$ = this.$$;
	            if (!$$) {
	                return;
	            }
	            if ($$('.panel-overlay').length === 0) {
	                $$('<div class="panel-overlay"></div>').insertBefore(this.$el);
	            }
	        },
	        open: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            var side = self.side || (self.left ? 'left' : 'right');
	            self.$f7.openPanel(side, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            self.$f7.closePanel(animated);
	        }
	    }
	};
	exports.VuePanel = panel;
	var photoBrowser = {
	    render: function () { },
	    beforeDestroy: function () {
	        var self = this;
	        if (self.f7PhotoBrowser && self.f7PhotoBrowser.destroy) {
	            self.f7PhotoBrowser.destroy();
	        }
	    },
	    props: {
	        init: {
	            type: Boolean,
	            default: true
	        },
	        params: Object,
	        photos: Array,
	        initialSlide: Number,
	        spaceBetween: Number,
	        speed: Number,
	        zoom: Boolean,
	        zoomMax: Number,
	        zoomMin: Number,
	        exposition: Boolean,
	        expositionHideCaptions: Boolean,
	        type: String,
	        navbar: Boolean,
	        toolbar: Boolean,
	        theme: String,
	        captionsTheme: String,
	        swipeToClose: Boolean,
	        backLinkText: String,
	        ofText: String,
	        loop: Boolean,
	        lazyLoading: Boolean,
	        lazyLoadingInPrevNext: Boolean,
	        lazyLoadingOnTransitionStart: Boolean,
	    },
	    methods: {
	        open: function (index) {
	            return this.f7PhotoBrowser.open(index);
	        },
	        close: function () {
	            return this.f7PhotoBrowser.close();
	        },
	        toggleZoom: function () {
	            return this.f7PhotoBrowser.toggleZoom();
	        },
	        toggleExposition: function () {
	            return this.f7PhotoBrowser.toggleExposition();
	        },
	        enableExposition: function () {
	            return this.f7PhotoBrowser.enableExposition();
	        },
	        disableExposition: function () {
	            return this.f7PhotoBrowser.disableExposition();
	        },
	        onF7Init: function (f7) {
	            var self = this;
	            // Init Virtual List
	            if (!self.init) {
	                return;
	            }
	            var params = self.$options.propsData;
	            self.f7PhotoBrowser = f7.photoBrowser(self.params || {
	                photos: params.photos,
	                initialSlide: params.initialSlide,
	                spaceBetween: params.spaceBetween,
	                speed: params.speed,
	                zoom: params.zoom,
	                zoomMax: params.zoomMax,
	                zoomMin: params.zoomMin,
	                exposition: params.exposition,
	                expositionHideCaptions: params.expositionHideCaptions,
	                type: params.type,
	                navbar: params.navbar,
	                toolbar: params.toolbar,
	                theme: params.theme,
	                captionsTheme: params.captionsTheme,
	                swipeToClose: params.swipeToClose,
	                backLinkText: params.backLinkText,
	                ofText: params.ofText,
	                loop: params.loop,
	                lazyLoading: params.lazyLoading,
	                lazyLoadingInPrevNext: params.lazyLoadingInPrevNext,
	                lazyLoadingOnTransitionStart: params.lazyLoadingOnTransitionStart,
	                onOpen: function (pb) {
	                    self.$emit('open', pb);
	                },
	                onClose: function (pb) {
	                    self.$emit('close', pb);
	                },
	                onSwipeToClose: function (pb) {
	                    self.$emit('swipeToClose', pb);
	                },
	                onSlideChangeStart: function (swiper) {
	                    self.$emit('slideChangeStart', swiper);
	                },
	                onSlideChangeEnd: function (swiper) {
	                    self.$emit('slideChangeEnd', swiper);
	                },
	                onTransitionStart: function (swiper) {
	                    self.$emit('transitionStart', swiper);
	                },
	                onTransitionEnd: function (swiper) {
	                    self.$emit('transitionEnd', swiper);
	                },
	                onClick: function (swiper, event) {
	                    self.$emit('click', swiper, event);
	                },
	                onTap: function (swiper, event) {
	                    self.$emit('tap', swiper, event);
	                },
	                onDoubleTap: function (swiper, event) {
	                    self.$emit('doubleTap', swiper, event);
	                },
	                onLazyImageLoad: function (swiper, event) {
	                    self.$emit('lazyImageLoad', swiper, event);
	                },
	                onLazyImageReady: function (swiper, event) {
	                    self.$emit('lazyImageReady', swiper, event);
	                }
	            });
	        }
	    }
	};
	exports.VuePhotoBrowser = photoBrowser;
	var pickerModal = {
	    render: function (c) {
	        var pickerEl, innerEl, fixedList = [], staticList = [];
	        var self = this;
	        var fixedTags = ('navbar toolbar tabbar subnavbar searchbar messagebar fab speed-dial floating-button').split(' ');
	        var tag, child;
	        if (self.$slots.default) {
	            for (var i = 0; i < self.$slots.default.length; i++) {
	                child = self.$slots.default[i];
	                tag = child.tag;
	                if (!tag) {
	                    staticList.push(child);
	                    continue;
	                }
	                var isFixed = false;
	                for (var j = 0; j < fixedTags.length; j++) {
	                    if (tag.indexOf(fixedTags[j]) >= 0) {
	                        isFixed = true;
	                    }
	                }
	                if (isFixed) {
	                    fixedList.push(child);
	                }
	                else {
	                    staticList.push(child);
	                }
	            }
	        }
	        innerEl = c('div', {
	            staticClass: 'picker-modal-inner'
	        }, staticList);
	        return c('div', {
	            class: self.classesObject,
	            staticClass: 'picker-modal',
	            on: {
	                'picker:open': self.onOpen,
	                'picker:opened': self.onOpened,
	                'picker:close': self.onClose,
	                'picker:closed': self.onClosed
	            }
	        }, [fixedList, innerEl]);
	    },
	    mounted: function () {
	        var self = this;
	        if (self.opened) {
	            self.$el.style.display = 'block';
	        }
	    },
	    watch: {
	        opened: function (opened) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            if (opened) {
	                self.$f7.pickerModal(self.$el);
	            }
	            else {
	                self.$f7.closeModal(self.$el);
	            }
	        }
	    },
	    props: {
	        'opened': Boolean,
	        'theme': String,
	        'layout': String,
	        'overlay': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'modal-in': this.opened,
	                'modal-out': !this.opened
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onOpen: function (event) {
	            if (this.overlay) {
	                this.$$('.picker-modal-overlay').addClass('modal-overlay-visible');
	            }
	            this.$emit('picker:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('picker:opened', event);
	        },
	        onClose: function (event) {
	            if (this.overlay) {
	                this.$$('.picker-modal-overlay').removeClass('modal-overlay-visible');
	            }
	            this.$emit('picker:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('picker:closed', event);
	        },
	        onF7Init: function () {
	            var $$ = this.$$;
	            if (!$$) {
	                return;
	            }
	            if ($$('.picker-modal-overlay').length === 0 && (this.$theme && this.$theme.material || this.overlay)) {
	                $$(this.$root.$el).append('<div class="picker-modal-overlay ' + (this.opened ? ' modal-overlay-visible' : '') + '"></div>');
	            }
	        },
	        open: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.pickerModal(self.$el, undefined, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.closeModal(self.$el, animated);
	        }
	    }
	};
	exports.VuePickerModal = pickerModal;
	var popover = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "popover", on: { "popover:open": _vm.onOpen, "popover:opened": _vm.onOpened, "popover:close": _vm.onClose, "popover:closed": _vm.onClosed } }, [_c('div', { staticClass: "popover-angle" }), _vm._v(" "), _c('div', { staticClass: "popover-content" }, [_vm._t("default")], 2)]); },
	    staticRenderFns: [],
	    methods: {
	        onOpen: function (event) {
	            this.$emit('popover:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('popover:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('popover:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('popover:closed', event);
	        },
	        open: function (target, animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.popover(self.$el, target, undefined, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.closeModal(self.$el, animated);
	        }
	    }
	};
	exports.VuePopover = popover;
	var popup = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "popup", class: _vm.classesObject, on: { "popup:open": _vm.onOpen, "popup:opened": _vm.onOpened, "popup:close": _vm.onClose, "popup:closed": _vm.onClosed } }, [(_vm.opened) ? _vm._t("default") : _vm._e()], 2); },
	    staticRenderFns: [],
	    mounted: function () {
	        var self = this;
	        if (self.opened) {
	            self.$el.style.display = 'block';
	        }
	    },
	    watch: {
	        opened: function (opened) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            var $$ = self.$$;
	            if (opened) {
	                self.$f7.popup(self.$el);
	            }
	            else {
	                if (!$$(self.$el).hasClass('modal-in')) {
	                    return;
	                }
	                self.$f7.closeModal(self.$el);
	            }
	        }
	    },
	    props: {
	        'tablet-fullscreen': Boolean,
	        'theme': String,
	        'layout': String,
	        'opened': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'tablet-fullscreen': this.tabletFullscreen,
	                'modal-in': this.opened,
	                'modal-out': !this.opened
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        onOpen: function (event) {
	            this.$emit('popup:open', event);
	        },
	        onOpened: function (event) {
	            this.$emit('popup:opened', event);
	        },
	        onClose: function (event) {
	            this.$emit('popup:close', event);
	        },
	        onClosed: function (event) {
	            this.$emit('popup:closed', event);
	        },
	        onF7Init: function () {
	            var $$ = this.$$;
	            if (!$$) {
	                return;
	            }
	            if ($$('.popup-overlay').length === 0) {
	                $$(this.$root.$el).append('<div class="popup-overlay ' + (this.opened ? ' modal-overlay-visible' : '') + '"></div>');
	            }
	        },
	        open: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.popup(self.$el, undefined, animated);
	        },
	        close: function (animated) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.closeModal(self.$el, animated);
	        }
	    }
	};
	exports.VuePopup = popup;
	var preloader = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { staticClass: "preloader", class: (_vm.color ? ('color-' + _vm.color + ' preloader-' + _vm.color) : ''), style: ({ 'width': (_vm.sizeComputed ? _vm.sizeComputed + 'px' : ''), 'height': (_vm.sizeComputed ? _vm.sizeComputed + 'px' : '') }) }, [(_vm.$theme.material) ? _c('span', { staticClass: "preloader-inner" }, [_c('span', { staticClass: "preloader-inner-gap" }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()]); },
	    staticRenderFns: [function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { staticClass: "preloader-inner-left" }, [_c('span', { staticClass: "preloader-inner-half-circle" })]); }, function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('span', { staticClass: "preloader-inner-right" }, [_c('span', { staticClass: "preloader-inner-half-circle" })]); }],
	    props: {
	        'color': String,
	        'size': [Number, String]
	    },
	    computed: {
	        sizeComputed: function () {
	            var s = this.size;
	            if (s && typeof s === 'string' && s.indexOf('px') >= 0) {
	                s = s.replace('px', '');
	            }
	            return s;
	        }
	    }
	};
	exports.VuePreloader = preloader;
	var progressbar = {
	    render: function (c) {
	        var self = this;
	        var color = self.color;
	        var progress = self.progress;
	        var infinite = self.infinite;
	        return c('span', {
	            staticClass: 'progressbar',
	            class: [(color ? ('color-' + color + ' progressbar-' + color) : ''), (infinite ? 'progressbar-infinite' : '')].join(' ')
	        }, [
	            c('span', {
	                style: {
	                    'transform': progress ? 'translate3d(' + (-100 + progress) + '%,0,0)' : ''
	                }
	            })
	        ]);
	    },
	    props: {
	        'color': String,
	        'progress': Number,
	        'infinite': Boolean
	    },
	    methods: {
	        set: function (progress, speed) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.setProgressbar(self.$el, progress, speed);
	        },
	        show: function (container, progress, color) {
	            var self = this;
	            if (!self.$f7) {
	                return;
	            }
	            return self.$f7.showProgressbar(container, progress, color);
	        }
	    }
	};
	exports.VueProgressbar = progressbar;
	var searchbar = {
	    render: function (c) {
	        var self = this;
	        var clearEl, cancelEl, inputEl, inputWrapEl;
	        inputEl = c('input', {
	            attrs: {
	                'placeholder': self.placeholder,
	                'type': 'search'
	            },
	            on: {
	                input: self.onInput,
	                change: self.onChange,
	                focus: self.onFocus,
	                blur: self.onBlur
	            }
	        });
	        if (self.clearButtonComputed) {
	            clearEl = c('a', {
	                staticClass: 'searchbar-clear',
	                attrs: {
	                    'href': '#'
	                },
	                on: {
	                    click: self.onClearClick
	                }
	            });
	        }
	        if (self.cancelLink) {
	            cancelEl = c('a', {
	                staticClass: 'searchbar-cancel',
	                attrs: {
	                    'href': '#'
	                },
	                domProps: {
	                    innerHTML: self.cancelLink
	                },
	                on: {
	                    click: self.onCancelClick
	                }
	            });
	        }
	        inputWrapEl = c('div', { staticClass: 'searchbar-input' }, [inputEl, clearEl]);
	        return c(self.form ? 'form' : 'div', {
	            staticClass: 'searchbar',
	            class: {
	                'no-shadow': self.noShadow
	            },
	            on: {
	                'submit': self.onSubmit,
	                'searchbar:search': self.onSearch,
	                'searchbar:enable': self.onEnable,
	                'searchbar:disable': self.onDisable,
	                'searchbar:clear': self.onClear
	            }
	        }, [self.$slots['before-input'], inputWrapEl, self.$slots['after-input'], cancelEl, self.$slots.default]);
	    },
	    beforeDestroy: function () {
	        if (this.f7Searchbar && this.f7Searchbar.destroy) {
	            this.f7Searchbar.destroy();
	        }
	    },
	    props: {
	        noShadow: Boolean,
	        form: {
	            type: Boolean,
	            default: true
	        },
	        placeholder: {
	            type: String,
	            default: 'Search'
	        },
	        cancelLink: String,
	        clear: Boolean,
	        clearButton: {
	            type: Boolean,
	            default: true
	        },
	        // SB Params
	        params: Object,
	        searchList: [String, Object],
	        searchIn: {
	            type: String,
	            default: '.item-title'
	        },
	        searchBy: String,
	        found: [String, Object],
	        notFound: [String, Object],
	        overlay: [String, Object],
	        ignore: {
	            type: String,
	            default: '.searchbar-ignore'
	        },
	        customSearch: {
	            type: Boolean,
	            default: false
	        },
	        removeDiacritics: {
	            type: Boolean,
	            default: false
	        },
	        hideDividers: {
	            type: Boolean,
	            default: true
	        },
	        hideGroups: {
	            type: Boolean,
	            default: true
	        },
	        init: {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        clearButtonComputed: function () {
	            var self = this;
	            var cb = self.clearButton;
	            if (self.$options.propsData.clear === false) {
	                cb = false;
	            }
	            return cb;
	        }
	    },
	    methods: {
	        search: function (query) {
	            if (!this.f7Searchbar) {
	                return;
	            }
	            return this.f7Searchbar.search(query);
	        },
	        enable: function () {
	            if (!this.f7Searchbar) {
	                return;
	            }
	            return this.f7Searchbar.enable();
	        },
	        disable: function () {
	            if (!this.f7Searchbar) {
	                return;
	            }
	            return this.f7Searchbar.disable();
	        },
	        empty: function () {
	            if (!this.f7Searchbar) {
	                return;
	            }
	            return this.f7Searchbar.clear();
	        },
	        onChange: function (event) {
	            this.$emit('change', event);
	        },
	        onInput: function (event) {
	            this.$emit('input', event.target.value);
	        },
	        onFocus: function (event) {
	            this.$emit('focus', event);
	        },
	        onBlur: function (event) {
	            this.$emit('blur', event);
	        },
	        onSubmit: function (event) {
	            this.$emit('submit', event);
	        },
	        onSearch: function (event) {
	            if (!event.detail) {
	                return;
	            }
	            this.$emit('searchbar:search', event.detail.query, event.detail.foundItems);
	        },
	        onClear: function (event) {
	            this.$emit('searchbar:clear', event);
	        },
	        onEnable: function (event) {
	            this.$emit('searchbar:enable', event);
	        },
	        onDisable: function (event) {
	            this.$emit('searchbar:disable', event);
	        },
	        onClearClick: function (event) {
	            this.$emit('click:clear', event);
	        },
	        onCancelClick: function (event) {
	            this.$emit('click:cancel', event);
	        },
	        onF7Init: function () {
	            var self = this;
	            if (!self.init) {
	                return;
	            }
	            self.f7Searchbar = self.$f7.searchbar(self.$el, self.params || {
	                searchList: self.searchList,
	                searchIn: self.searchIn,
	                searchBy: self.searchBy,
	                found: self.found,
	                notFound: self.notFound,
	                overlay: self.overlay,
	                ignore: self.ignore,
	                customSearch: self.customSearch,
	                removeDiacritics: self.removeDiacritics,
	                hideDividers: self.hideDividers,
	                hideGroups: self.hideGroups
	            });
	        }
	    }
	};
	exports.VueSearchbar = searchbar;
	var statusbar = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "statusbar-overlay", class: (_vm.theme ? 'theme-' + _vm.theme : undefined) }); },
	    staticRenderFns: [],
	    props: {
	        theme: String
	    }
	};
	exports.VueStatusbar = statusbar;
	var subnavbar = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "subnavbar", class: _vm.sliding ? 'sliding' : false }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        sliding: Boolean
	    }
	};
	exports.VueSubnavbar = subnavbar;
	var swiperSlide = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "swiper-slide" }, [(_vm.zoom) ? _c('div', { staticClass: "swiper-zoom-container" }, [_vm._t("default")], 2) : _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'zoom': Boolean
	    }
	};
	exports.VueSwiperSlide = swiperSlide;
	var swiper = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "swiper-container" }, [_c('div', { staticClass: "swiper-wrapper" }, [_vm._t("default")], 2), _vm._v(" "), (_vm.paginationComputed === true) ? _c('div', { staticClass: "swiper-pagination" }) : _vm._e(), _vm._v(" "), (_vm.scrollbarComputed === true) ? _c('div', { staticClass: "swiper-scrollbar" }) : _vm._e(), _vm._v(" "), (_vm.nextButtonComputed === true) ? _c('div', { staticClass: "swiper-button-next" }) : _vm._e(), _vm._v(" "), (_vm.prevButtonComputed === true) ? _c('div', { staticClass: "swiper-button-prev" }) : _vm._e()]); },
	    staticRenderFns: [],
	    beforeDestroy: function () {
	        var self = this;
	        if (!self.init) {
	            return;
	        }
	        if (self.swiper && self.swiper.destroy) {
	            self.swiper.destroy();
	        }
	    },
	    props: {
	        'params': Object,
	        'pagination': [Boolean, String, Object],
	        'scrollbar': [Boolean, String, Object],
	        'next-button': [Boolean, String, Object],
	        'prev-button': [Boolean, String, Object],
	        init: {
	            type: Boolean,
	            default: true
	        }
	    },
	    computed: {
	        paramsComputed: function () {
	            return this.params || {};
	        },
	        paginationComputed: function () {
	            var self = this;
	            if (self.pagination === true || self.pagination === '') {
	                self.paramsComputed.pagination = '.swiper-pagination';
	                return true;
	            }
	            else if (typeof self.pagination === 'object' || typeof self.pagination === 'string') {
	                self.paramsComputed.pagination = self.pagination;
	                return true;
	            }
	            return false;
	        },
	        scrollbarComputed: function () {
	            var self = this;
	            if (self.scrollbar || self.scrollbar === '') {
	                self.paramsComputed.scrollbar = '.swiper-scrollbar';
	                return true;
	            }
	            else if (typeof self.scrollbar === 'object' || typeof self.scrollbar === 'string') {
	                self.paramsComputed.scrollbar = self.scrollbar;
	                return true;
	            }
	            return false;
	        },
	        nextButtonComputed: function () {
	            var self = this;
	            if (self.nextButton || self.nextButton === '') {
	                self.paramsComputed.nextButton = '.swiper-button-next';
	                return true;
	            }
	            else if (typeof self.nextButton === 'object' || typeof self.nextButton === 'string') {
	                self.paramsComputed.nextButton = self.nextButton;
	                return true;
	            }
	            return false;
	        },
	        prevButtonComputed: function () {
	            var self = this;
	            if (self.prevButton || self.prevButton === '') {
	                self.paramsComputed.prevButton = '.swiper-button-prev';
	                return true;
	            }
	            else if (typeof self.prevButton === 'object' || typeof self.prevButton === 'string') {
	                self.paramsComputed.prevButton = self.prevButton;
	                return true;
	            }
	            return false;
	        }
	    },
	    methods: {
	        onF7Init: function () {
	            if (!this.init) {
	                return;
	            }
	            this.swiper = new window.Swiper(this.$el, this.paramsComputed);
	        }
	    }
	};
	exports.VueSwiper = swiper;
	var tab = {
	    props: {
	        'active': Boolean,
	        'id': String
	    },
	    data: function () {
	        return {
	            routeInfo: {
	                activeTab: this.$route && this.$route.route.tab
	            }
	        };
	    },
	    render: function (c) {
	        var self = this;
	        var activeTab = self.routeInfo.activeTab;
	        return c('div', {
	            staticClass: 'tab',
	            attrs: {
	                id: self.id
	            },
	            class: {
	                'active': (activeTab) ? activeTab.tabId === self.id : self.active
	            },
	            on: {
	                'tab:show': self.onTabShow,
	                'tab:hide': self.onTabHide
	            }
	        }, [activeTab && activeTab.tabId === self.id ? c(activeTab.component, { tag: 'component', props: self.$route.params }) : self.$slots.default]);
	    },
	    methods: {
	        show: function (animated) {
	            if (!this.$f7) {
	                return;
	            }
	            this.$f7.showTab(this.$el, animated);
	        },
	        onTabShow: function (e) {
	            this.$emit('tab:show', e);
	        },
	        onTabHide: function (e) {
	            this.$emit('tab:hide', e);
	        },
	        onRouteChange: function (e) {
	            if (e.route.tab) {
	                var currentlyActiveTabId = this.routeInfo.activeTab && this.routeInfo.activeTab.tabId;
	                var nextActiveTabId = e.route.tab.tabId;
	                var thisTabId = this.id;
	                if (thisTabId === currentlyActiveTabId && nextActiveTabId !== thisTabId) {
	                    this.$$(this.$el).trigger('tab:hide');
	                }
	                else if (thisTabId !== currentlyActiveTabId && nextActiveTabId === thisTabId) {
	                    this.$$(this.$el).trigger('tab:show');
	                }
	                this.$set(this.routeInfo, 'activeTab', e.route.tab);
	            }
	        }
	    }
	};
	exports.VueTab = tab;
	var tabs = {
	    render: function (c) {
	        var self = this;
	        var tabs = c('div', { staticClass: 'tabs' }, [self.$slots.default]);
	        if (self.animated || self.swipeable) {
	            return c('div', { class: self.classesObject }, [tabs]);
	        }
	        else {
	            return tabs;
	        }
	    },
	    props: {
	        'animated': Boolean,
	        'swipeable': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            return {
	                'tabs-animated-wrap': this.animated,
	                'tabs-swipeable-wrap': this.swipeable,
	            };
	        },
	    }
	};
	exports.VueTabs = tabs;
	var template7Template = {
	    render: function (c) {
	        return c('script', { attrs: { type: 'text/template7' } }, this.$slots.default);
	    }
	};
	exports.VueTemplate7Template = template7Template;
	var timelineItemChild = {
	    render: function (c) {
	        var self = this;
	        var timeEl, titleEl, subtitleEl, textEl;
	        if (self.time) {
	            timeEl = c('div', { staticClass: 'timeline-item-time', domProps: { innerHTML: self.time } });
	        }
	        if (self.title) {
	            titleEl = c('div', { staticClass: 'timeline-item-title', domProps: { innerHTML: self.title } });
	        }
	        if (self.subtitle) {
	            subtitleEl = c('div', { staticClass: 'timeline-item-subtitle', domProps: { innerHTML: self.subtitle } });
	        }
	        if (self.text) {
	            textEl = c('div', { staticClass: 'timeline-item-text', domProps: { innerHTML: self.text } });
	        }
	        if (self.content) {
	            return c('div', {
	                class: {
	                    'timeline-item-inner': self.inner,
	                    'timeline-item-child': !self.inner
	                },
	                domProps: {
	                    innerHTML: self.content
	                }
	            });
	        }
	        else {
	            return c('div', {
	                class: {
	                    'timeline-item-inner': self.inner,
	                    'timeline-item-child': !self.inner
	                }
	            }, [timeEl, titleEl, subtitleEl, textEl, self.$slots.default]);
	        }
	    },
	    props: {
	        inner: Boolean,
	        content: String,
	        time: String,
	        title: String,
	        subtitle: String,
	        text: String
	    }
	};
	exports.VueTimelineItemChild = timelineItemChild;
	var timelineItem = {
	    render: function (c) {
	        var self = this;
	        var timeEl, titleEl, subtitleEl, textEl, dateEl, dividerEl, contentEl, innerEl;
	        if (self.day || self.month) {
	            dateEl = c('div', { staticClass: 'timeline-item-date', domProps: { innerHTML: [self.day, '<small>' + self.month + '</small>'].join(' ') } });
	        }
	        else {
	            dateEl = c('div', { staticClass: 'timeline-item-date', domProps: { innerHTML: self.date } });
	        }
	        dividerEl = c('div', { staticClass: 'timeline-item-divider' });
	        if (self.time) {
	            timeEl = c('div', { staticClass: 'timeline-item-time', domProps: { innerHTML: self.time } });
	        }
	        if (self.title) {
	            titleEl = c('div', { staticClass: 'timeline-item-title', domProps: { innerHTML: self.title } });
	        }
	        if (self.subtitle) {
	            subtitleEl = c('div', { staticClass: 'timeline-item-subtitle', domProps: { innerHTML: self.subtitle } });
	        }
	        if (self.text) {
	            textEl = c('div', { staticClass: 'timeline-item-text', domProps: { innerHTML: self.text } });
	        }
	        if (self.inner) {
	            if (self.content) {
	                innerEl = c('div', { staticClass: 'timeline-item-inner', domProps: { innerHTML: self.content } });
	            }
	            else {
	                innerEl = c('div', { staticClass: 'timeline-item-inner' }, [timeEl, titleEl, subtitleEl, textEl, self.$slots.default]);
	            }
	        }
	        else {
	            innerEl = [timeEl, titleEl, subtitleEl, textEl, self.$slots.default];
	        }
	        if (self.content && !self.inner) {
	            contentEl = c('div', { staticClass: 'timeline-item-content', domProps: { innerHTML: self.content } });
	        }
	        else {
	            contentEl = c('div', { staticClass: 'timeline-item-content' }, [innerEl]);
	        }
	        return c('div', {
	            staticClass: 'timeline-item',
	            class: {
	                'timeline-item-left': self.side === 'left',
	                'timeline-item-right': self.side === 'right'
	            }
	        }, [dateEl, dividerEl, contentEl]);
	    },
	    props: {
	        date: [String, Number, Date],
	        day: [String, Number],
	        month: [String, Number],
	        inner: Boolean,
	        content: String,
	        side: String,
	        time: String,
	        title: String,
	        subtitle: String,
	        text: String
	    }
	};
	exports.VueTimelineItem = timelineItem;
	var timelineMonth = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "timeline-month" }, [(_vm.month || _vm.title) ? _c('div', { staticClass: "timeline-month-title" }, [_c('span', { domProps: { "innerHTML": _vm._s(_vm.month || _vm.title) } })]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        month: [Number, String],
	        title: [Number, String]
	    }
	};
	exports.VueTimelineMonth = timelineMonth;
	var timelineYear = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "timeline-year" }, [(_vm.year || _vm.title) ? _c('div', { staticClass: "timeline-year-title" }, [_c('span', { domProps: { "innerHTML": _vm._s(_vm.year || _vm.title) } })]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        year: [Number, String],
	        title: [Number, String]
	    }
	};
	exports.VueTimelineYear = timelineYear;
	var timeline = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "timeline", class: _vm.classesObject }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'sides': Boolean,
	        'tablet-sides': Boolean,
	        'col': [Number, String],
	        'tablet-col': [Number, String],
	        'horizontal': Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {};
	            var self = this;
	            if (self.sides) {
	                co['timeline-sides'] = true;
	            }
	            if (self.tabletSides) {
	                co['tablet-sides'] = true;
	            }
	            if (self.horizontal) {
	                co['timeline-horizontal'] = true;
	            }
	            if (self.col) {
	                co['col-' + self.col] = true;
	            }
	            if (self.tabletCol) {
	                co['tablet-' + self.tabletCol] = true;
	            }
	            return co;
	        }
	    }
	};
	exports.VueTimeline = timeline;
	var toolbar = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "toolbar", class: _vm.classesObject }, [_vm._t("before-inner"), _vm._v(" "), _c('div', { staticClass: "toolbar-inner" }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("after-inner")], 2); },
	    staticRenderFns: [],
	    props: {
	        bottom: Boolean,
	        tabbar: Boolean,
	        labels: Boolean,
	        scrollable: Boolean,
	        theme: String,
	        layout: String,
	        hidden: Boolean,
	        noShadow: Boolean
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'toolbar-bottom': this.bottom,
	                'tabbar': this.tabbar,
	                'tabbar-labels': this.labels,
	                'tabbar-scrollable': this.scrollable,
	                'toolbar-hidden': this.hidden
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            if (this.noShadow) {
	                co['no-shadow'] = true;
	            }
	            return co;
	        }
	    },
	    methods: {
	        hide: function (animated) {
	            if (!this.$f7) {
	                return;
	            }
	            return this.$f7.hideToolbar(this.$el, animated);
	        },
	        show: function (animated) {
	            if (!this.$f7) {
	                return;
	            }
	            return this.$f7.showToolbar(this.$el, animated);
	        }
	    }
	};
	exports.VueToolbar = toolbar;
	var view = {
	    render: function (c) {
	        var hasNavbar, hasPages, pagesEl, navbarEl, self = this;
	        if (self.$slots.default) {
	            for (var i = 0; i < self.$slots.default.length; i++) {
	                var child = self.$slots.default[i];
	                if (child.tag && child.tag.indexOf('navbar') >= 0) {
	                    hasNavbar = true;
	                }
	                if (child.tag && child.tag.indexOf('pages') >= 0) {
	                    hasPages = true;
	                }
	            }
	        }
	        if (!hasPages) {
	            pagesEl = c('f7-pages');
	        }
	        if (!hasNavbar && self.$theme.ios && (self.dynamicNavbar || self.navbarThrough || (self.params && self.params.dynamicNavbar))) {
	            navbarEl = c('f7-navbar', { props: { inner: false } });
	        }
	        return c('div', {
	            class: self.classesObject,
	            on: {
	                'swipeback:move': self.onSwipeBackMove,
	                'swipeback:beforechange': self.onSwipeBackBeforeChange,
	                'swipeback:afterchange': self.onSwipeBackAfterChange,
	                'swipeback:beforereset': self.onSwipeBackBeforeReset,
	                'swipeback:afterreset': self.onSwipeBackAfterReset,
	                'tab:show': self.onTabShow,
	                'tab:hide': self.onTabHide
	            }
	        }, [navbarEl, pagesEl, self.$slots.default]);
	    },
	    beforeDestroy: function () {
	        var self = this;
	        if (self.f7View && self.f7View.destroy) {
	            self.f7View.destroy();
	        }
	    },
	    props: {
	        'main': Boolean,
	        'navbar-fixed': Boolean,
	        'navbar-through': Boolean,
	        'toolbar-fixed': Boolean,
	        'toolbar-through': Boolean,
	        'tabbar-fixed': Boolean,
	        'tabbar-through': Boolean,
	        'tabbar-labels-fixed': Boolean,
	        'tabbar-labels-through': Boolean,
	        'tab': Boolean,
	        'active': Boolean,
	        'dynamic-navbar': Boolean,
	        'dom-cache': Boolean,
	        'links-view': [String, Object],
	        'reload-pages': Boolean,
	        'unique-history': Boolean,
	        'unique-history-ignore-get-parameters': Boolean,
	        'allow-duplicate-urls': Boolean,
	        'swipe-back-page': Boolean,
	        'swipe-back-page-animate-shadow': Boolean,
	        'swipe-back-page-animate-opacity': Boolean,
	        'swipe-back-page-active-area': Boolean,
	        'swipe-back-page-threshold': Boolean,
	        'animate-pages': Boolean,
	        'preload-previous-page': Boolean,
	        'name': String,
	        'params': Object,
	        'url': String,
	        'init': {
	            type: Boolean,
	            default: true
	        },
	        'theme': String,
	        'layout': String
	    },
	    computed: {
	        classesObject: function () {
	            var co = {
	                'view': true,
	                'view-main': this.main,
	                'active': this.active,
	                'tab': this.tab,
	                'navbar-fixed': this.navbarFixed || this.navbarThrough && this.$theme.material,
	                'navbar-through': this.navbarThrough,
	                'toolbar-fixed': this.toolbarFixed,
	                'toolbar-through': this.toolbarThrough,
	                'tabbar-fixed': this.tabbarFixed,
	                'tabbar-through': this.tabbarThrough,
	                'tabbar-labels-fixed': this.tabbarLabelsFixed,
	                'tabbar-labels-through': this.tabbarLabesThrough,
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        },
	    },
	    methods: {
	        onF7Init: function (f7) {
	            var self = this;
	            if (!self.init) {
	                return;
	            }
	            var propsData = self.$options.propsData;
	            var params = self.params || {
	                name: self.name,
	                url: self.url,
	                dynamicNavbar: propsData.dynamicNavbar,
	                domCache: typeof propsData.domCache === 'undefined' ? true : propsData.domCache,
	                linksView: propsData.linksView,
	                reloadPages: propsData.reloadPages,
	                uniqueHistory: propsData.uniqueHistory,
	                uniqueHistoryIgnoreGetParameters: propsData.uniqueHistoryIgnoreGetParameters,
	                allowDuplicateUrls: propsData.allowDuplicateUrls,
	                swipeBackPage: propsData.swipeBackPage,
	                swipeBackPageAnimateShadow: propsData.swipeBackPageAnimateShadow,
	                swipeBackPageAnimateOpacity: propsData.swipeBackPageAnimateOpacity,
	                swipeBackPageActiveArea: propsData.swipeBackPageActiveArea,
	                swipeBackPageThreshold: propsData.swipeBackPageThreshold,
	                animatePages: propsData.animatePages,
	                preloadPreviousPage: propsData.preloadPreviousPage,
	            };
	            var $$ = self.$$;
	            var pagesContainer = $$(self.$el).find('.pages')[0];
	            // Include page by route
	            if (pagesContainer.querySelectorAll('.page').length === 0 && params.url) {
	                // Find Matching Route
	                var matchingRoute = self.$f7Router.findMatchingRoute(params.url);
	                if (!matchingRoute) {
	                    return;
	                }
	                // Find Pages Vue Component
	                var pagesVue = pagesContainer.__vue__;
	                // Generate Page Id
	                var id = new Date().getTime();
	                // Push New Page component
	                self.$set(pagesVue.pages, id, { component: matchingRoute.route.component });
	                self.$nextTick(function () {
	                    // Page element
	                    var newPage = pagesContainer.querySelector('.page:first-child');
	                    pagesVue.pages[id].pageElement = newPage;
	                    // Move Navbar
	                    var newNavbar;
	                    var dynamicNavbar = self.$theme.ios && params.dynamicNavbar;
	                    if (dynamicNavbar) {
	                        newNavbar = $$(newPage).find('.navbar-inner:first-child');
	                        $$(self.$el).children('.navbar').append(newNavbar);
	                        $$(newPage).find('.navbar').remove();
	                    }
	                    // Init Page and Navbar Callbacks
	                    f7.initPageWithCallback(newPage);
	                    if (dynamicNavbar && newNavbar) {
	                        f7.initNavbarWithCallback(newNavbar);
	                    }
	                });
	            }
	            // Init View
	            self.f7View = f7.addView(self.$el, params);
	        },
	        onSwipeBackMove: function (event) {
	            this.$emit('swipeback:move', event, event.detail);
	        },
	        onSwipeBackBeforeChange: function (event) {
	            this.$emit('swipeback:beforechange', event, event.detail);
	        },
	        onSwipeBackAfterChange: function (event) {
	            this.$emit('swipeback:afterchange', event, event.detail);
	        },
	        onSwipeBackBeforeReset: function (event) {
	            this.$emit('swipeback:beforereset', event, event.detail);
	        },
	        onSwipeBackAfterReset: function (event) {
	            this.$emit('swipeback:afterreset', event, event.detail);
	        },
	        onTabShow: function (e) {
	            this.$emit('tab:show', e);
	        },
	        onTabHide: function (e) {
	            this.$emit('tab:hide', e);
	        }
	    }
	};
	exports.VueView = view;
	var views = {
	    render: function () { var _vm = this; var _h = _vm.$createElement; var _c = _vm._self._c || _h; return _c('div', { staticClass: "views", class: _vm.classObject }, [_vm._t("default")], 2); },
	    staticRenderFns: [],
	    props: {
	        'navbar-fixed': Boolean,
	        'navbar-through': Boolean,
	        'toolbar-fixed': Boolean,
	        'toolbar-through': Boolean,
	        'tabbar-fixed': Boolean,
	        'tabbar-through': Boolean,
	        'tabbar-labels-fixed': Boolean,
	        'tabbar-labels-through': Boolean,
	        'tabs': Boolean,
	        'theme': String,
	        'layout': String
	    },
	    computed: {
	        classObject: function () {
	            var co = {
	                'tabs': this.tabs,
	                'navbar-fixed': this.navbarFixed || this.navbarThrough && this.$theme.material,
	                'navbar-through': this.navbarThrough,
	                'toolbar-fixed': this.toolbarFixed,
	                'toolbar-through': this.toolbarThrough,
	                'tabbar-fixed': this.tabbarFixed,
	                'tabbar-through': this.tabbarThrough,
	                'tabbar-labels-fixed': this.tabbarLabelsFixed,
	                'tabbar-labels-through': this.tabbarLabelsThrough
	            };
	            if (this.theme) {
	                co['theme-' + this.theme] = true;
	            }
	            if (this.layout) {
	                co['layout-' + this.layout] = true;
	            }
	            return co;
	        }
	    }
	};
	exports.VueViews = views;
	//# sourceMappingURL=framework7-vue.js.map
	
	//# sourceMappingURL=framework7-vue.js.map


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(716)();
	}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(32);
	var prop_types_1 = __webpack_require__(3);
	var change_case_1 = __webpack_require__(109);
	var ReactifyVue_1 = __webpack_require__(366);
	var Framework7_1 = __webpack_require__(81);
	var Framework7_2 = __webpack_require__(81);
	var nextComponentId = 0;
	exports.reactifyF7Vue = function (args) {
	    var innerComponent = ReactifyVue_1.reactifyVue({
	        component: args.component,
	        name: "F7" + args.name,
	        tag: args.tag,
	        slots: !args.slots ? null : args.slots.reduce(function (slotMap, currentSlotName) {
	            return __assign({}, slotMap, (_a = {}, _a[currentSlotName] = change_case_1.camelCase(currentSlotName) + 'Slot', _a));
	            var _a;
	        }, {}),
	        events: !args.events ? null : args.events.reduce(function (eventMap, currentEventName) {
	            return __assign({}, eventMap, (_a = {}, _a[currentEventName] = change_case_1.camelCase('on-' + currentEventName.split(':').join('-')), _a));
	            var _a;
	        }, {}),
	        instantiatedComponents: args.instantiatedComponents,
	        args: __assign({}, args.args, { $$: Framework7_1.Dom7, $t7: Framework7_2.Template7 }),
	        mixin: args.mixin
	    });
	    var reactClass = (function (_super) {
	        __extends(reactClass, _super);
	        function reactClass(props, context) {
	            var _this = _super.call(this, props, context) || this;
	            var framework7AppContext = _this.context.framework7AppContext;
	            framework7AppContext.getFramework7(function (f7) {
	                _this.framework7 = f7;
	            });
	            Object.defineProperty(args.component, '$f7Router', {
	                get: framework7AppContext.getRouter,
	                enumerable: true,
	                configurable: true
	            });
	            Object.defineProperty(args.component, '$route', {
	                get: framework7AppContext.getCurrentRoute,
	                enumerable: true,
	                configurable: true
	            });
	            Object.defineProperty(args.component, '$f7', {
	                get: function () { return _this.framework7; },
	                enumerable: true,
	                configurable: true
	            });
	            _this.componentId = nextComponentId++;
	            return _this;
	        }
	        reactClass.prototype.componentWillUnmount = function () {
	            var framework7AppContext = this.context.framework7AppContext;
	            framework7AppContext.unregisterRouteChange(this.componentId);
	        };
	        reactClass.prototype.render = function () {
	            var _this = this;
	            var props = this.props;
	            var framework7AppContext = this.context.framework7AppContext;
	            var innerEl = React.createElement(innerComponent, __assign({}, props, { $theme: framework7AppContext.theme, __onMount: function (self) {
	                    var tag = args.tag;
	                    framework7AppContext.getFramework7(function (f7) {
	                        if (self.vueComponent.onF7Init) {
	                            self.vueComponent.onF7Init(f7);
	                        }
	                    });
	                    framework7AppContext.onRouteChange(_this.componentId, function (route) {
	                        if (self.vueComponent.onRouteChange) {
	                            self.vueComponent.onRouteChange(route);
	                        }
	                    });
	                } }));
	            return innerEl;
	        };
	        return reactClass;
	    }(React.Component));
	    reactClass.tag = args.tag;
	    reactClass.vueComponent = args.component;
	    reactClass.contextTypes = {
	        framework7AppContext: prop_types_1.object
	    };
	    return reactClass;
	};
	
	//# sourceMappingURL=ReactifyF7Vue.js.map


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.11';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	
	        return result;
	      }
	
	      if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	
	        return result;
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(41)(module)))

/***/ }),
/* 6 */
[783, 406],
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	var es5 = __webpack_require__(44);
	var canEvaluate = typeof navigator == "undefined";
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	var globalObject = typeof self !== "undefined" ? self :
	    typeof window !== "undefined" ? window :
	    typeof global !== "undefined" ? global :
	    this !== undefined ? this : null;
	
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return typeof value === "function" ||
	           typeof value === "object" && value !== null;
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function FakeConstructor() {}
	    FakeConstructor.prototype = obj;
	    var receiver = new FakeConstructor();
	    function ic() {
	        return typeof receiver.foo;
	    }
	    ic();
	    ic();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function isError(obj) {
	    return obj instanceof Error ||
	        (obj !== null &&
	           typeof obj === "object" &&
	           typeof obj.message === "string" &&
	           typeof obj.name === "string");
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return isError(obj) && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var asArray = function(v) {
	    if (es5.isArray(v)) {
	        return v;
	    }
	    return null;
	};
	
	if (typeof Symbol !== "undefined" && Symbol.iterator) {
	    var ArrayFrom = typeof Array.from === "function" ? function(v) {
	        return Array.from(v);
	    } : function(v) {
	        var ret = [];
	        var it = v[Symbol.iterator]();
	        var itResult;
	        while (!((itResult = it.next()).done)) {
	            ret.push(itResult.value);
	        }
	        return ret;
	    };
	
	    asArray = function(v) {
	        if (es5.isArray(v)) {
	            return v;
	        } else if (v != null && typeof v[Symbol.iterator] === "function") {
	            return ArrayFrom(v);
	        }
	        return null;
	    };
	}
	
	var isNode = typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]";
	
	var hasEnvVariables = typeof process !== "undefined" &&
	    typeof process.env !== "undefined";
	
	function env(key) {
	    return hasEnvVariables ? process.env[key] : undefined;
	}
	
	function getNativePromise() {
	    if (typeof Promise === "function") {
	        try {
	            var promise = new Promise(function(){});
	            if ({}.toString.call(promise) === "[object Promise]") {
	                return Promise;
	            }
	        } catch (e) {}
	    }
	}
	
	function domainBind(self, cb) {
	    return self.bind(cb);
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    asArray: asArray,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    isError: isError,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: isNode,
	    hasEnvVariables: hasEnvVariables,
	    env: env,
	    global: globalObject,
	    getNativePromise: getNativePromise,
	    domainBind: domainBind
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version;
	    if (process.versions && process.versions.node) {    
	        version = process.versions.node.split(".").map(Number);
	    } else if (process.version) {
	        version = process.version.split(".").map(Number);
	    }
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(38)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SWITCH_BUNDLE_ID = exports.SWITCH_BUNDLE_ID = 'SWITCH_BUNDLE_ID';
	var SWITCH_API_ENDPOINT = exports.SWITCH_API_ENDPOINT = 'SWITCH_API_ENDPOINT';
	var LOAD_APP_CONFIGURATION_START = exports.LOAD_APP_CONFIGURATION_START = 'LOAD_APP_CONFIGURATION_START';
	var LOAD_APP_CONFIGURATION_SUCCESS = exports.LOAD_APP_CONFIGURATION_SUCCESS = 'LOAD_APP_CONFIGURATION_SUCCESS';
	var LOAD_APP_CONFIGURATION_FAILURE = exports.LOAD_APP_CONFIGURATION_FAILURE = 'LOAD_APP_CONFIGURATION_FAILURE';
	
	var STAGING_LOAD_APPS_START = exports.STAGING_LOAD_APPS_START = 'STAGING_LOAD_APPS_START';
	var STAGING_LOAD_APPS_SUCCESS = exports.STAGING_LOAD_APPS_SUCCESS = 'STAGING_LOAD_APPS_SUCCESS';
	var STAGING_LOAD_APPS_FAILURE = exports.STAGING_LOAD_APPS_FAILURE = 'STAGING_LOAD_APPS_FAILURE';
	
	var LOAD_MERCHANT_INFO_START = exports.LOAD_MERCHANT_INFO_START = 'LOAD_MERCHANT_INFO_START';
	var LOAD_MERCHANT_INFO_SUCCESS = exports.LOAD_MERCHANT_INFO_SUCCESS = 'LOAD_MERCHANT_INFO_SUCCESS';
	var LOAD_MERCHANT_INFO_FAILURE = exports.LOAD_MERCHANT_INFO_FAILURE = 'LOAD_MERCHANT_INFO_FAILURE';
	
	var LOAD_BOOKING_RUSHES_START = exports.LOAD_BOOKING_RUSHES_START = 'LOAD_BOOKING_RUSHES_START';
	var LOAD_BOOKING_RUSHES_SUCCESS = exports.LOAD_BOOKING_RUSHES_SUCCESS = 'LOAD_BOOKING_RUSHES_SUCCESS';
	var LOAD_BOOKING_RUSHES_FAILURE = exports.LOAD_BOOKING_RUSHES_FAILURE = 'LOAD_BOOKING_RUSHES_FAILURE';
	
	var UPDATE_CONNECTION_INFO = exports.UPDATE_CONNECTION_INFO = 'UPDATE_CONNECTION_INFO';
	
	var SET_ENVIRONMENT = exports.SET_ENVIRONMENT = 'SET_ENVIRONMENT';
	
	var LOAD_MENU_START = exports.LOAD_MENU_START = 'LOAD_MENU_START';
	var LOAD_MENU_SUCCESS = exports.LOAD_MENU_SUCCESS = 'LOAD_MENU_SUCCESS';
	var LOAD_MENU_FAILURE = exports.LOAD_MENU_FAILURE = 'LOAD_MENU_FAILURE';
	
	var CREATE_CARD_TOKEN_START = exports.CREATE_CARD_TOKEN_START = 'CREATE_CARD_TOKEN_START';
	var CREATE_CARD_TOKEN_SUCCESS = exports.CREATE_CARD_TOKEN_SUCCESS = 'CREATE_CARD_TOKEN_SUCCESS';
	var CREATE_CARD_TOKEN_FAILURE = exports.CREATE_CARD_TOKEN_FAILURE = 'CREATE_CARD_TOKEN_FAILURE';
	
	var MENU_CONFIGURE_ITEM = exports.MENU_CONFIGURE_ITEM = 'MENU_CONFIGURE_ITEM';
	var MENU_CART_ADDITEM = exports.MENU_CART_ADDITEM = 'MENU_CART_ADDITEM';
	var MENU_CART_RESTORE_FROM_ORDER = exports.MENU_CART_RESTORE_FROM_ORDER = 'MENU_CART_RESTORE_FROM_ORDER';
	var MENU_CART_REMOVEITEM = exports.MENU_CART_REMOVEITEM = 'MENU_CART_REMOVEITEM';
	var MENU_CART_RESET = exports.MENU_CART_RESET = 'MENU_CART_RESET';
	var MENU_SHOW_ERRORS = exports.MENU_SHOW_ERRORS = 'MENU_SHOW_ERRORS';
	
	var DELIVERY_ADDRESS_CHECK_START = exports.DELIVERY_ADDRESS_CHECK_START = 'DELIVERY_ADDRESS_CHECK_START';
	var DELIVERY_ADDRESS_CHECK_SUCCESS = exports.DELIVERY_ADDRESS_CHECK_SUCCESS = 'DELIVERY_ADDRESS_CHECK_SUCCESS';
	var DELIVERY_ADDRESS_CHECK_FAILURE = exports.DELIVERY_ADDRESS_CHECK_FAILURE = 'DELIVERY_ADDRESS_CHECK_FAILURE';
	
	var DELIVERY_ADDRESS_UPDATE_START = exports.DELIVERY_ADDRESS_UPDATE_START = 'DELIVERY_ADDRESS_UPDATE_START';
	var DELIVERY_ADDRESS_UPDATE_SUCCESS = exports.DELIVERY_ADDRESS_UPDATE_SUCCESS = 'DELIVERY_ADDRESS_UPDATE_SUCCESS';
	var DELIVERY_ADDRESS_UPDATE_FAILURE = exports.DELIVERY_ADDRESS_UPDATE_FAILURE = 'DELIVERY_ADDRESS_UPDATE_FAILURE';
	
	var DELIVERY_SET_DATE_TIME = exports.DELIVERY_SET_DATE_TIME = 'DELIVERY_SET_DATE_TIME';
	var DELIVERY_DATE_DEFAULT = exports.DELIVERY_DATE_DEFAULT = 'TODAY';
	var DELIVERY_TIME_DEFAULT = exports.DELIVERY_TIME_DEFAULT = 'ASAP';
	var DELIVERY_TIME_ASAP = exports.DELIVERY_TIME_ASAP = 'ASAP';
	var DELIVERY_SET_ADDRESS = exports.DELIVERY_SET_ADDRESS = 'DELIVERY_SET_ADDRESS';
	var DELIVERY_CONFIRM_ADDRESS = exports.DELIVERY_CONFIRM_ADDRESS = 'DELIVERY_CONFIRM_ADDRESS';
	var DELIVERY_RESET_ADDRESS = exports.DELIVERY_RESET_ADDRESS = 'DELIVERY_RESET_ADDRESS';
	var DELIVERY_SET_ORDER_TYPE = exports.DELIVERY_SET_ORDER_TYPE = 'DELIVERY_SET_ORDER_TYPE';
	var DELIVERY_SET_ORDER_DATA = exports.DELIVERY_SET_ORDER_DATA = 'DELIVERY_SET_ORDER_DATA';
	var DELIVERY_UPDATE_ADDRESS_SNUMBER = exports.DELIVERY_UPDATE_ADDRESS_SNUMBER = 'DELIVERY_UPDATE_ADDRESS_SNUMBER';
	var DELIVERY_UPDATE_EXTRA_INFO = exports.DELIVERY_UPDATE_EXTRA_INFO = 'DELIVERY_UPDATE_EXTRA_INFO';
	var USER_LOCATION = exports.USER_LOCATION = 'USER_LOCATION';
	
	var PAYMENT_SET_METHOD = exports.PAYMENT_SET_METHOD = 'PAYMENT';
	var PAYMENT_METHOD_CC = exports.PAYMENT_METHOD_CC = 'credit-card';
	var PAYMENT_UNHANDLED = exports.PAYMENT_UNHANDLED = 'unhandled';
	
	var TAKEAWAY_SET_RESTAURANT = exports.TAKEAWAY_SET_RESTAURANT = 'TAKEAWAY_SET_RESTAURANT';
	var ORDER_TYPE_DELIVERY = exports.ORDER_TYPE_DELIVERY = 'delivery';
	var ORDER_TYPE_TAKEAWAY = exports.ORDER_TYPE_TAKEAWAY = 'takeAway';
	var ORDER_RESET = exports.ORDER_RESET = 'ORDER_RESET';
	var ORDER_RELOAD = exports.ORDER_RELOAD = 'ORDER_RELOAD';
	var STORE_ORDER_START = exports.STORE_ORDER_START = 'STORE_ORDER_START';
	var STORE_ORDER_SUCCESS = exports.STORE_ORDER_SUCCESS = 'STORE_ORDER_SUCCESS';
	var STORE_ORDER_FAILURE = exports.STORE_ORDER_FAILURE = 'STORE_ORDER_FAILURE';
	var UPDATE_CURRENTORDER = exports.UPDATE_CURRENTORDER = 'UPDATE_CURRENTORDER';
	var ORDER_SET_CHECKOUT_FORM = exports.ORDER_SET_CHECKOUT_FORM = 'ORDER_SET_CHECKOUT_FORM';
	var ORDER_ADD_VOUCHER = exports.ORDER_ADD_VOUCHER = 'ORDER_ADD_VOUCHER';
	var ORDER_NO_VOUCHER = exports.ORDER_NO_VOUCHER = -1;
	var ORDER_TOGGLE_UNHANDLED = exports.ORDER_TOGGLE_UNHANDLED = 'ORDER_TOGGLE_UNHANDLED';
	var ORDER_NEW_CC_SETFORM = exports.ORDER_NEW_CC_SETFORM = 'ORDER_NEW_CC_SETFORM';
	var ORDER_SET_CONFIRMED = exports.ORDER_SET_CONFIRMED = 'ORDER_SET_CONFIRMED';
	var ORDER_FETCH_EXTRA_COSTS_START = exports.ORDER_FETCH_EXTRA_COSTS_START = 'ORDER_FETCH_EXTRA_COSTS_START';
	var ORDER_FETCH_EXTRA_COSTS_SUCCESS = exports.ORDER_FETCH_EXTRA_COSTS_SUCCESS = 'ORDER_FETCH_EXTRA_COSTS_SUCCESS';
	var ORDER_FETCH_EXTRA_COSTS_FAILURE = exports.ORDER_FETCH_EXTRA_COSTS_FAILURE = 'ORDER_FETCH_EXTRA_COSTS_FAILURE';
	
	var VOUCHER_FORMAT_PERCENTAGE = exports.VOUCHER_FORMAT_PERCENTAGE = 'PERCENTAGE';
	var VOUCHER_FORMAT_ABSOLUTE = exports.VOUCHER_FORMAT_ABSOLUTE = 'ABSOLUTE_VALUE';
	var VOUCHER_FORMAT_FREE_ITEM = exports.VOUCHER_FORMAT_FREE_ITEM = 'FREE_ITEM';
	
	var EXTRA_COST_TYPE_POSITIVE = exports.EXTRA_COST_TYPE_POSITIVE = 'positive';
	var EXTRA_COST_TYPE_NEGATIVE = exports.EXTRA_COST_TYPE_NEGATIVE = 'negative';
	var EXTRA_COST_TYPE_NEUTRAL = exports.EXTRA_COST_TYPE_NEUTRAL = 'neutral';
	
	var SET_USER_LOCATION = exports.SET_USER_LOCATION = 'SET_USER_LOCATION';
	var SET_BOOKING_RESTAURANT = exports.SET_BOOKING_RESTAURANT = 'SET_BOOKING_RESTAURANT';
	var SET_BOOKING_DATE = exports.SET_BOOKING_DATE = 'SET_BOOKING_DATE';
	var SET_BOOKING_TIME = exports.SET_BOOKING_TIME = 'SET_BOOKING_TIME';
	var SET_BOOKING_SEATS = exports.SET_BOOKING_SEATS = 'SET_BOOKING_SEATS';
	var BOOKING_RESET_END = exports.BOOKING_RESET_END = 'BOOKING_RESET_END';
	var BOOKING_SET_FORM = exports.BOOKING_SET_FORM = 'BOOKING_SET_FORM';
	
	var SET_PICKER_VISIBILITY = exports.SET_PICKER_VISIBILITY = 'SET_PICKER_VISIBILITY';
	var BOOKING_PICKER_SEATS = exports.BOOKING_PICKER_SEATS = 'BOOKING_PICKER_SEATS';
	
	var SET_RECOVERY_TOKEN = exports.SET_RECOVERY_TOKEN = 'SET_RECOVERY_TOKEN';
	var UPDATE_RECOVERY_FORM_VALUE = exports.UPDATE_RECOVERY_FORM_VALUE = 'UPDATE_RECOVERY_FORM_VALUE';
	var VERIFY_RECOVERY_TOKEN_START = exports.VERIFY_RECOVERY_TOKEN_START = 'VERIFY_RECOVERY_TOKEN_START';
	var VERIFY_RECOVERY_TOKEN_SUCCESS = exports.VERIFY_RECOVERY_TOKEN_SUCCESS = 'VERIFY_RECOVERY_TOKEN_SUCCESS';
	var VERIFY_RECOVERY_TOKEN_FAILURE = exports.VERIFY_RECOVERY_TOKEN_FAILURE = 'VERIFY_RECOVERY_TOKEN_FAILURE';
	var RESET_PASSWORD_START = exports.RESET_PASSWORD_START = 'RESET_PASSWORD_START';
	var RESET_PASSWORD_SUCCESS = exports.RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
	var RESET_PASSWORD_FAILURE = exports.RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
	var RESET_RECOVERY_PASSWORD_STATUS = exports.RESET_RECOVERY_PASSWORD_STATUS = 'RESET_RECOVERY_PASSWORD_STATUS';
	var RECOVERY_EMAIL_REQUEST = exports.RECOVERY_EMAIL_REQUEST = 'RECOVERY_EMAIL_REQUEST';
	
	var MENU_COLLAPSE_CATEGORIES = exports.MENU_COLLAPSE_CATEGORIES = 'MENU_COLLAPSE_CATEGORIES';
	var MENU_UNCOLLAPSE_CATEGORIES = exports.MENU_UNCOLLAPSE_CATEGORIES = 'MENU_UNCOLLAPSE_CATEGORIES';
	
	var PICKER_VISIBLE = exports.PICKER_VISIBLE = 'PICKER_VISIBLE';
	
	var ORDER_TOGGLE_ASAP = exports.ORDER_TOGGLE_ASAP = 'ORDER_TOGGLE_ASAP';

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.connect = exports.getTheme = exports.serviceSelector = exports.createApiInstance = exports.mapDispatchToProps = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(76);
	
	var _redux = __webpack_require__(153);
	
	var _reselect = __webpack_require__(18);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _apolloLink = __webpack_require__(118);
	
	var _apolloLinkHttp = __webpack_require__(443);
	
	var _apolloCacheInmemory = __webpack_require__(439);
	
	var _apolloClient = __webpack_require__(206);
	
	var _apolloClient2 = _interopRequireDefault(_apolloClient);
	
	var _service = __webpack_require__(433);
	
	var _app = __webpack_require__(199);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _booking = __webpack_require__(202);
	
	var _booking2 = _interopRequireDefault(_booking);
	
	var _order = __webpack_require__(200);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _user = __webpack_require__(203);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _voucher = __webpack_require__(204);
	
	var _voucher2 = _interopRequireDefault(_voucher);
	
	var _app3 = __webpack_require__(408);
	
	var _app4 = _interopRequireDefault(_app3);
	
	var _api = __webpack_require__(428);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _user3 = __webpack_require__(426);
	
	var _user4 = _interopRequireDefault(_user3);
	
	var _order3 = __webpack_require__(410);
	
	var _order4 = _interopRequireDefault(_order3);
	
	var _booking3 = __webpack_require__(409);
	
	var _booking4 = _interopRequireDefault(_booking3);
	
	var _voucher3 = __webpack_require__(427);
	
	var _voucher4 = _interopRequireDefault(_voucher3);
	
	var _ux = __webpack_require__(446);
	
	var uxAction = _interopRequireWildcard(_ux);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapState = function mapState(state) {
	  return state;
	};
	var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    user: (0, _redux.bindActionCreators)(_user4.default, dispatch),
	    app: (0, _redux.bindActionCreators)(_app4.default, dispatch),
	    order: (0, _redux.bindActionCreators)(_order4.default, dispatch),
	    booking: (0, _redux.bindActionCreators)(_booking4.default, dispatch),
	    ux: (0, _redux.bindActionCreators)(uxAction, dispatch),
	    voucher: (0, _redux.bindActionCreators)(_voucher4.default, dispatch)
	  };
	};
	
	var apolloClientSelector = (0, _reselect.createSelector)(function (state) {
	  return state.app.bootstrap.api_endpoint;
	}, function (state) {
	  return state.user.currentUser && state.user.currentUser.accessToken;
	}, function (apiUrl, token) {
	  var httpLink = (0, _apolloLinkHttp.createHttpLink)({
	    uri: apiUrl
	  });
	
	  var link = new _apolloLink.ApolloLink(function (operation, forward) {
	    // const token = getStoredToken();
	    operation.setContext({
	      headers: {
	        authorization: token ? 'Bearer ' + token : null,
	        'Accept-Language': 'it'
	      }
	    });
	    return forward(operation);
	  });
	
	  return new _apolloClient2.default({
	    link: link.concat(httpLink),
	    cache: new _apolloCacheInmemory.InMemoryCache()
	  });
	});
	
	var createApiInstance = exports.createApiInstance = function createApiInstance(endpoint, accessToken) {
	  var api = (0, _api2.default)(endpoint);
	  api.setHeaders({
	    'Authorization': 'Bearer ' + accessToken
	  });
	
	  return api;
	};
	
	var serviceSelector = exports.serviceSelector = (0, _reselect.createSelector)(function (state) {
	  return state.app.bootstrap;
	}, function (state) {
	  return state.user.currentUser && state.user.currentUser.accessToken;
	}, function (bootstrap, accessToken) {
	  var api = createApiInstance(bootstrap.api_endpoint, accessToken);
	
	  return {
	    app: (0, _service.curryApiToService)(api, (0, _app2.default)(bootstrap.bundleId, 'WEB')),
	    order: (0, _service.curryApiToService)(api, _order2.default),
	    booking: (0, _service.curryApiToService)(api, _booking2.default),
	    user: (0, _service.curryApiToService)(api, _user2.default),
	    voucher: (0, _service.curryApiToService)(api, _voucher2.default)
	  };
	});
	
	var getTheme = exports.getTheme = function getTheme(props) {
	  return _lodash2.default.property('app.config.theme')(props) || {};
	};
	
	var connect = exports.connect = function connect(Component) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var extraProps = arguments[2];
	
	  var componentMapState = options.mapStateToProps || mapState;
	
	  var mapStateToProps = function mapStateToProps(state, props) {
	    return _extends({}, componentMapState(state, props), {
	      services: serviceSelector(state, props),
	      apolloClient: apolloClientSelector(state, props)
	    });
	  };
	
	  var createProps = function createProps(dispatch) {
	    return _extends({
	      actions: mapDispatchToProps(dispatch),
	      dispatch: dispatch
	    }, extraProps);
	  };
	
	  return (0, _reactRedux.connect)(mapStateToProps, createProps)(Component);
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(39);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(149);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(60);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(738);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(268);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(734);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(749);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(735);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(736);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(270);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(737);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(150);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(747);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(275);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(740);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(741);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(745);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(272);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var root = 'app';
	
	var getAppIdFromUrl = function getAppIdFromUrl(location) {
	  return location.pathname.split('/')[2];
	};
	
	var getTargetRestaurantIdFromUrl = function getTargetRestaurantIdFromUrl(location) {
	  return location.pathname.split('/')[5];
	};
	
	var order = function order(appId) {
	  return '/' + root + '/' + appId + '/order';
	};
	
	var orderFullPath = function orderFullPath(_ref) {
	  var appId = _ref.appId,
	      restaurantId = _ref.restaurantId,
	      orderType = _ref.orderType,
	      orderDate = _ref.orderDate;
	
	  return order(appId) + '/' + orderType + '/' + restaurantId + '/' + orderDate;
	};
	
	var orderTakeAway = function orderTakeAway(appId) {
	  return order(appId) + '/takeAway';
	};
	
	var orderTakeAwayRestaurant = function orderTakeAwayRestaurant(appId, restaurantId) {
	  return orderTakeAway(appId) + '/' + restaurantId;
	};
	
	var orderMenu = function orderMenu(params) {
	  return orderFullPath(params) + '/menu';
	};
	
	var orderCart = function orderCart(params) {
	  return orderFullPath(params) + '/cart';
	};
	
	var orderUserVoucher = function orderUserVoucher(params) {
	  return orderFullPath(params) + '/voucher';
	};
	
	var orderDelivery = function orderDelivery(appId) {
	  return order(appId) + '/delivery';
	};
	
	var orderDeliveryAddress = function orderDeliveryAddress(appId) {
	  return order(appId) + '/delivery/address';
	};
	
	var orderDeliveryRestaurant = function orderDeliveryRestaurant(appId, restaurantId) {
	  return orderDelivery(appId) + '/' + restaurantId;
	};
	
	var orderDeliveryRestaurantFromRoute = function orderDeliveryRestaurantFromRoute(route, restaurantId) {
	  var last = route.length - 1;
	  var sanitized = route[last] === '/' ? route.substring(0, last) : route;
	  // if the previuos route was /address, we should remove the last
	  // component before redirect to date-select-time container
	  var nextRoute = sanitized.split('/').filter(function (comp) {
	    return comp !== 'address';
	  }).join('/');
	  return nextRoute + '/' + restaurantId;
	};
	
	var orderCheckout = function orderCheckout(params) {
	  return orderFullPath(params) + '/checkout';
	};
	
	var orderPayment = function orderPayment(params) {
	  return orderFullPath(params) + '/payment';
	};
	
	var orderEnd = function orderEnd(params) {
	  return orderFullPath(params) + '/end';
	};
	
	var orderEndFromRoute = function orderEndFromRoute(route) {
	  var last = route.lastIndexOf('/');
	  var next = route.substring(0, last);
	  return next + '/end';
	};
	
	var orderNoDelivery = function orderNoDelivery(appId) {
	  var offline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var base = order(appId) + '/no-delivery';
	  if (offline) return base + '?offline=true';
	  return base;
	};
	
	var booking = function booking(appId) {
	  return '/' + root + '/' + appId + '/booking';
	};
	
	var bookingDate = function bookingDate(appId, restaurant, date) {
	  return '/' + root + '/' + appId + '/booking/' + restaurant + '/' + date;
	};
	
	var bookingCheckout = function bookingCheckout(appId, restaurant, date, slot, seats) {
	  return '/' + root + '/' + appId + '/booking/' + restaurant + '/' + date + '/' + slot + '/' + seats + '/checkout';
	};
	
	var bookingEnd = function bookingEnd(appId, restaurant, date, slot, seats) {
	  return '/' + root + '/' + appId + '/booking/' + restaurant + '/' + date + '/' + slot + '/' + seats + '/end';
	};
	
	var bookingEndFromRoute = function bookingEndFromRoute(route) {
	  var last = route.lastIndexOf('/');
	  var next = route.substring(0, last);
	  return next + '/end';
	};
	
	exports.default = {
	  order: order,
	  orderTakeAway: orderTakeAway,
	  orderTakeAwayRestaurant: orderTakeAwayRestaurant,
	  orderDelivery: orderDelivery,
	  orderDeliveryAddress: orderDeliveryAddress,
	  orderDeliveryRestaurant: orderDeliveryRestaurant,
	  orderDeliveryRestaurantFromRoute: orderDeliveryRestaurantFromRoute,
	  orderMenu: orderMenu,
	  orderCart: orderCart,
	  orderUserVoucher: orderUserVoucher,
	  orderCheckout: orderCheckout,
	  orderPayment: orderPayment,
	  orderEnd: orderEnd,
	  orderEndFromRoute: orderEndFromRoute,
	  orderNoDelivery: orderNoDelivery,
	  getAppIdFromUrl: getAppIdFromUrl,
	  getTargetRestaurantIdFromUrl: getTargetRestaurantIdFromUrl,
	  booking: booking,
	  bookingDate: bookingDate,
	  bookingCheckout: bookingCheckout,
	  bookingEnd: bookingEnd,
	  bookingEndFromRoute: bookingEndFromRoute
	};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _time = __webpack_require__(20);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var currentLanguage = function currentLanguage(arg) {
	  var deviceLang = typeof arg === 'string' ? arg : arg.language;
	  if (deviceLang.length === 2) {
	    return _time2.default.supportLocale(deviceLang) ? deviceLang : 'en';
	  }
	  // ISO-639-2 to ISO-639-1 conversion for Android
	  switch (deviceLang) {
	    case 'ita':
	      return 'it';
	    case 'eng':
	      return 'en';
	    case 'fra':
	      return 'fr';
	    case 'fre':
	      return 'fr';
	    case 'ger':
	      return 'de';
	    case 'deu':
	      return 'de';
	    case 'jpn':
	      return 'ja';
	    case 'spa':
	      return 'es';
	    case 'dut':
	      return 'nl';
	    case 'nld':
	      return 'nl';
	
	    default:
	      return 'en';
	
	  }
	}; // @flow
	
	var formatPrice = function formatPrice(priceInCents) {
	  var currencySymbol = '€';
	  var price = priceInCents / 100;
	  return (currencySymbol + ' ' + price.toFixed(2)).replace('.', ',');
	};
	
	exports.default = { currentLanguage: currentLanguage, formatPrice: formatPrice };

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(13);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BackButton = function BackButton(props) {
	  if (!props.to) {
	    return _react2.default.createElement(
	      'a',
	      { className: 'btn', style: props.style, onClick: _reactRouter.browserHistory.goBack },
	      _react2.default.createElement('i', { className: 'bi_interface-left' }),
	      'Indietro'
	    );
	  }
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { to: props.to, style: props.style },
	    _react2.default.createElement('i', { className: 'bi_interface-left' }),
	    'Indietro'
	  );
	};
	
	BackButton.propTypes = {
	  to: _propTypes2.default.string,
	  style: _propTypes2.default.object
	};
	
	exports.default = BackButton;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.defaultMemoize = defaultMemoize;
	exports.createSelectorCreator = createSelectorCreator;
	exports.createStructuredSelector = createStructuredSelector;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function defaultEqualityCheck(a, b) {
	  return a === b;
	}
	
	function defaultMemoize(func) {
	  var equalityCheck = arguments.length <= 1 || arguments[1] === undefined ? defaultEqualityCheck : arguments[1];
	
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (lastArgs === null || lastArgs.length !== args.length || !args.every(function (value, index) {
	      return equalityCheck(value, lastArgs[index]);
	    })) {
	      lastResult = func.apply(undefined, args);
	    }
	    lastArgs = args;
	    return lastResult;
	  };
	}
	
	function getDependencies(funcs) {
	  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
	
	  if (!dependencies.every(function (dep) {
	    return typeof dep === 'function';
	  })) {
	    var dependencyTypes = dependencies.map(function (dep) {
	      return typeof dep;
	    }).join(', ');
	    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
	  }
	
	  return dependencies;
	}
	
	function createSelectorCreator(memoize) {
	  for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    memoizeOptions[_key2 - 1] = arguments[_key2];
	  }
	
	  return function () {
	    for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      funcs[_key3] = arguments[_key3];
	    }
	
	    var recomputations = 0;
	    var resultFunc = funcs.pop();
	    var dependencies = getDependencies(funcs);
	
	    var memoizedResultFunc = memoize.apply(undefined, [function () {
	      recomputations++;
	      return resultFunc.apply(undefined, arguments);
	    }].concat(memoizeOptions));
	
	    var selector = function selector(state, props) {
	      for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	        args[_key4 - 2] = arguments[_key4];
	      }
	
	      var params = dependencies.map(function (dependency) {
	        return dependency.apply(undefined, [state, props].concat(args));
	      });
	      return memoizedResultFunc.apply(undefined, _toConsumableArray(params));
	    };
	
	    selector.resultFunc = resultFunc;
	    selector.recomputations = function () {
	      return recomputations;
	    };
	    selector.resetRecomputations = function () {
	      return recomputations = 0;
	    };
	    return selector;
	  };
	}
	
	var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);
	
	function createStructuredSelector(selectors) {
	  var selectorCreator = arguments.length <= 1 || arguments[1] === undefined ? createSelector : arguments[1];
	
	  if (typeof selectors !== 'object') {
	    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
	  }
	  var objectKeys = Object.keys(selectors);
	  return selectorCreator(objectKeys.map(function (key) {
	    return selectors[key];
	  }), function () {
	    for (var _len5 = arguments.length, values = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	      values[_key5] = arguments[_key5];
	    }
	
	    return values.reduce(function (composition, value, index) {
	      composition[objectKeys[index]] = value;
	      return composition;
	    }, {});
	  });
	}

/***/ }),
/* 19 */
[782, 385],
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _momentWithLocales = __webpack_require__(425);
	
	var _momentWithLocales2 = _interopRequireDefault(_momentWithLocales);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _datetimeFormatter = __webpack_require__(192);
	
	var _datetimeFormatter2 = _interopRequireDefault(_datetimeFormatter);
	
	var _constants = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var DATE_FORMAT = 'DD/MM';
	var DATE_FORMAT_FULL = 'DD/MM/YYYY';
	var DATE_FORMAT_ISO = 'YYYY-MM-DD';
	var DATE_FORMAT_PRETTY = 'DD MMMM';
	var TIME_FORMAT = 'HH:mm';
	var DATE_TIME_FORMAT = DATE_FORMAT_FULL + ' ' + TIME_FORMAT;
	var DATE_TIME_FORMAT_SHORT = DATE_FORMAT + ' ' + TIME_FORMAT;
	var SLOT_LENGTH = 15;
	
	function extractDay(date) {
	  var dateFormat = date.length === 4 ? DATE_FORMAT : DATE_FORMAT_FULL;
	  var value = _momentWithLocales2.default.utc(date, dateFormat).day();
	  return value === 0 ? 6 : value - 1;
	}
	
	function dateFromSlotTime(date, slotTime) {
	  var forceUTC = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var timeComponents = slotTime.split(':');
	  if (!forceUTC) {
	    return date.hours(timeComponents[0]).minutes(timeComponents[1]);
	  }
	  return _momentWithLocales2.default.utc(date).hours(timeComponents[0]).minutes(timeComponents[1]);
	}
	
	function deliveryDayData(times, date) {
	  var n = extractDay(date);
	  return _lodash2.default.find(times, { day: n });
	}
	
	function deliveryTimesForSlot(slot, current) {
	  var min = SLOT_LENGTH;
	
	  var currentDateTime = current ? _momentWithLocales2.default.utc(current, DATE_TIME_FORMAT) : _momentWithLocales2.default.utc();
	
	  var start = dateFromSlotTime(currentDateTime.clone(), slot.open);
	  var end = dateFromSlotTime(currentDateTime.clone(), slot.close);
	  var times = {};
	  while (end.diff(start, 'minutes') > 0) {
	    if (start.isAfter(currentDateTime) || start.isSame(currentDateTime)) {
	      times[start.format(TIME_FORMAT)] = start.format(TIME_FORMAT);
	    }
	    start.add(min, 'minutes');
	  }
	  return times;
	}
	
	function parseOrCurrentDate(current) {
	  if (!current) {
	    return _momentWithLocales2.default.utc();
	  }
	
	  var dateFormat = current.indexOf('-') > -1 ? DATE_FORMAT_ISO : DATE_TIME_FORMAT;
	  return _momentWithLocales2.default.utc(current, dateFormat);
	}
	
	function deliveryTimesData(offset, data, date) {
	  var today = !date ? _momentWithLocales2.default.utc() : _momentWithLocales2.default.utc(date, DATE_TIME_FORMAT);
	  var tomorrow = !date ? _momentWithLocales2.default.utc() : _momentWithLocales2.default.utc(date, DATE_TIME_FORMAT);
	  var days = {};
	
	  var todayTimes = deliveryDayData(data, today.clone());
	
	  if (!todayTimes) return days;
	
	  tomorrow.add(1, 'day').hour(0).minute(0);
	  today.add(offset, 'minutes');
	
	  var valuesToday = _lodash2.default.map(todayTimes.slots, function (slot) {
	    return deliveryTimesForSlot(slot, today.clone().format(DATE_TIME_FORMAT));
	  });
	  var valuesTodayMerged = Object.assign.apply(Object, [{}].concat(_toConsumableArray(valuesToday)));
	  if (Object.keys(valuesTodayMerged).length > 0) {
	    days[today.format(DATE_FORMAT_FULL)] = Object.assign.apply(Object, [{}].concat(_toConsumableArray(valuesToday)));
	  }
	
	  var tomorrowTimes = deliveryDayData(data, tomorrow);
	  if (tomorrowTimes && tomorrowTimes.open) {
	    var valuesTomorrow = _lodash2.default.map(tomorrowTimes.slots, function (slot) {
	      return deliveryTimesForSlot(slot, _lodash2.default.clone(tomorrow).format(DATE_TIME_FORMAT));
	    });
	    days[tomorrow.format(DATE_FORMAT_FULL)] = Object.assign.apply(Object, [{}].concat(_toConsumableArray(valuesTomorrow)));
	  }
	  return days;
	}
	
	function addAsapToDeliveryTimes(deliveryTimes, ASAP_LABEL) {
	  var today = deliveryTimes[0];
	  return [{
	    label: today.label,
	    value: today.value,
	    values: _extends(_defineProperty({}, ASAP_LABEL, _constants.DELIVERY_TIME_ASAP), today.values)
	  }, deliveryTimes[1]];
	}
	
	function isAfterLastSlot(current, todaySlots) {
	  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  if (todaySlots.length === 0) {
	    return true;
	  }
	
	  // parse or extract current time
	  var theDate = !_momentWithLocales2.default.isMoment(current) ? _momentWithLocales2.default.utc(current, DATE_FORMAT + ' ' + TIME_FORMAT) : current;
	
	  if (!theDate.isValid()) {
	    throw new Error('Invalid current date. Valid format: ' + DATE_FORMAT + ' ' + TIME_FORMAT);
	  }
	
	  var last = dateFromSlotTime(theDate.clone(), todaySlots[todaySlots.length - 1].close, false);
	  theDate.add(offset, 'minutes');
	
	  if (theDate.isAfter(last)) {
	    return true;
	  }
	  return false;
	}
	
	function localToday() {
	  var dateFormat = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DATE_FORMAT;
	
	  return _momentWithLocales2.default.utc().local().format(dateFormat);
	}
	
	function extractUTCTime(date) {
	  return _momentWithLocales2.default.utc(date).format(TIME_FORMAT);
	}
	
	function toLocalTime(date, time) {
	  var isISO = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (time === _constants.DELIVERY_TIME_DEFAULT) {
	    return _momentWithLocales2.default.utc().local().format(TIME_FORMAT);
	  }
	
	  var mDate = isISO ? _momentWithLocales2.default.utc(date) : _momentWithLocales2.default.utc(date, DATE_FORMAT);
	  if (!time) {
	    return mDate.local().format(TIME_FORMAT);
	  }
	
	  var timeComponents = time.split(':');
	  if (timeComponents.length !== 2) {
	    throw new Error('Time ' + time + ' is not a valid time. Format should be ' + TIME_FORMAT);
	  }
	  mDate.hour(timeComponents[0]);
	  mDate.minutes(timeComponents[1]);
	
	  return mDate.local().format(TIME_FORMAT);
	}
	
	function toUTCTime(time) {
	  if (time === _constants.DELIVERY_TIME_DEFAULT) {
	    return _momentWithLocales2.default.utc().format(TIME_FORMAT);
	  }
	  return _momentWithLocales2.default.utc(time, TIME_FORMAT).format(TIME_FORMAT);
	}
	
	function toUTCFullDate(date) {
	  if (date === _constants.DELIVERY_DATE_DEFAULT) {
	    return _momentWithLocales2.default.utc().format(DATE_FORMAT_FULL);
	  }
	  return _momentWithLocales2.default.utc(date, DATE_FORMAT).format(DATE_FORMAT_FULL);
	}
	
	function formatISO(date) {
	  if (_momentWithLocales2.default.isMoment(date)) {
	    return date.format(DATE_FORMAT_ISO);
	  }
	
	  return _momentWithLocales2.default.utc(date, DATE_FORMAT_FULL).format(DATE_FORMAT_ISO);
	}
	
	function splitISO(date) {
	  var parsed = _momentWithLocales2.default.utc(date);
	  return {
	    date: parsed.format(DATE_FORMAT_FULL),
	    time: parsed.format(TIME_FORMAT)
	  };
	}
	
	function toLocalDate(date, locale) {
	  var dateFormat = date.indexOf('-') > -1 ? DATE_FORMAT_ISO : DATE_FORMAT;
	  var outputFormat = locale ? DATE_FORMAT_PRETTY : DATE_FORMAT;
	  return _momentWithLocales2.default.utc(date, dateFormat).locale(locale).format(outputFormat);
	}
	
	function toLocalHumanDate(date, locale) {
	  return _momentWithLocales2.default.utc(date).local().locale(locale).format('LL');
	}
	
	function toHumanDate(date, locale) {
	  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'LL';
	  var timeFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TIME_FORMAT;
	
	  return _momentWithLocales2.default.utc(date).locale(locale).format(format + ' ' + timeFormat);
	}
	
	function toHumanCalendar(date, locale) {
	  return _momentWithLocales2.default.utc(date).locale(locale).calendar();
	}
	
	function isFuture(date, locale) {
	  return !_momentWithLocales2.default.utc(date).locale(locale).isBefore(_momentWithLocales2.default.utc().locale(locale), 'day');
	}
	
	function isDeliveryAvailableToday(slots, offset, current) {
	  var currentDate = !current ? _momentWithLocales2.default.utc() : current;
	  var today = deliveryDayData(slots, currentDate);
	  if (!today.open || isAfterLastSlot(currentDate, today.slots, offset)) {
	    return false;
	  }
	
	  return true;
	}
	
	function isDeliveryAvailableTomorrow(slots, current) {
	  var currentDate = parseOrCurrentDate(current);
	  currentDate.add(1, 'days');
	  var tomorrow = deliveryDayData(slots, currentDate);
	
	  if (!tomorrow.open || tomorrow.slots.length === 0) {
	    return false;
	  }
	
	  return true;
	}
	
	function nextDeliveryTimeToday(offset, days, current) {
	  var currentDate = parseOrCurrentDate(current);
	  var data = deliveryTimesData(offset, days, currentDate);
	  var date = Object.keys(data)[0];
	  if (!date) {
	    return null;
	  }
	  var timeUTC = Object.keys(data[date])[0];
	  var timeLocal = data[date][timeUTC];
	  return {
	    date: date,
	    time: timeLocal
	  };
	}
	
	function isOpenToday(times, current) {
	  var currentDate = parseOrCurrentDate(current);
	  var data = deliveryDayData(times, currentDate);
	  return data && data.open && !isAfterLastSlot(currentDate, data.slots);
	}
	
	function nextXDaysRange(days, start) {
	  var current = parseOrCurrentDate(start);
	  return [current.format(DATE_FORMAT_ISO), current.add(days, 'days').format(DATE_FORMAT_ISO)];
	}
	
	function nextWeekRange(start) {
	  return nextXDaysRange(7, start);
	}
	
	function nextTwoWeeksRange(start) {
	  return nextXDaysRange(14, start);
	}
	
	function weekDayLocale(date, locale) {
	  var dateFormat = date.indexOf('-') > -1 ? DATE_FORMAT_ISO : DATE_FORMAT_FULL;
	  var mDate = _momentWithLocales2.default.utc(date, dateFormat);
	  var val = locale === 'en-US' ? mDate.format('dddd') : mDate.locale(locale).format('dddd');
	  return val[0].toUpperCase() + val.substring(1);
	}
	
	function weekDayLocaleByIndex(index) {
	  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
	
	  return (0, _momentWithLocales2.default)().locale(locale).isoWeekday(index).format('dddd').toString();
	}
	
	function isDateExpired(date, toCheck) {
	  var current = parseOrCurrentDate(toCheck);
	  return current.isAfter(_momentWithLocales2.default.utc(date), 'minute');
	}
	
	function areDatesEqual(dateISO, toCheck) {
	  var date1 = _momentWithLocales2.default.utc(dateISO).startOf('day');
	  var date2 = parseOrCurrentDate(toCheck).startOf('day');
	  return date1.isSame(date2, 'hour');
	}
	
	function now() {
	  var full = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  var date = _momentWithLocales2.default.utc().local();
	  return full ? date.format(DATE_TIME_FORMAT) : date.format(TIME_FORMAT);
	}
	
	function isDatePastNow(dateISO) {
	  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var nowDateLocal = (0, _momentWithLocales2.default)().local().seconds(0);
	  var nowDateFakeUTC = _momentWithLocales2.default.utc().hours(nowDateLocal.hours()).minutes(nowDateLocal.minutes()).seconds(0);
	  return _momentWithLocales2.default.utc(dateISO).add(offset, 'minutes').isAfter(nowDateFakeUTC);
	}
	
	// compare 2 (absolute) times with format hh:mm
	// returns
	//        -1 if t1<t2
	//        0 if t1==t2
	//        1 if t1>t2
	function compareTimes(t1, t2) {
	  var d1 = dateFromSlotTime(_momentWithLocales2.default.utc(), t1);
	  var d2 = dateFromSlotTime(_momentWithLocales2.default.utc(), t2);
	  if (d1.isAfter(d2, 'minute')) {
	    return 1;
	  }
	
	  if (d1.isSame(d2, 'minute')) {
	    return 0;
	  }
	
	  return -1;
	}
	
	/*
	  changing time/date values (ISO) without
	  switch timezone to local withouth
	 */
	function switchTimeZoneToLocal(date, time) {
	  var parsedDate = _momentWithLocales2.default.utc(date + ' ' + time, DATE_TIME_FORMAT);
	  var offset = parsedDate.clone().local().utcOffset();
	  return parsedDate.subtract(offset, 'minutes').format();
	}
	
	function currentTimeInSlot(slots, offset, dateTime) {
	  var current = !dateTime ? (0, _momentWithLocales2.default)().local() : parseOrCurrentDate(dateTime);
	  var data = deliveryDayData(slots, current);
	  if (data.slots.length === 0) {
	    return false;
	  }
	
	  return _lodash2.default.some(data.slots, function (slot) {
	    var openParts = slot.open.split(':');
	    var closeParts = slot.close.split(':');
	    var open = current.clone().hours(openParts[0]).minutes(openParts[1]);
	
	    if (offset) {
	      open.subtract(offset, 'minutes');
	    }
	    var close = current.clone().hours(closeParts[0]).minutes(closeParts[1]);
	    return (current.isAfter(open) || current.isSame(open)) && (current.isBefore(close) || current.isSame(close));
	  });
	}
	
	// fromISO and toISO are REAL utc dates in ISO string format
	function currentDateInRange(_ref) {
	  var fromISO = _ref.fromISO,
	      toISO = _ref.toISO;
	  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var current = !today ? (0, _momentWithLocales2.default)().local() : _momentWithLocales2.default.utc(today);
	  return current.isBetween(fromISO, toISO, 'minute') || current.isSame(fromISO, 'minute') || current.isSame(toISO, 'minute');
	}
	
	// fromISO and toISO are REAL utc dates in ISO string format
	function currentDateIsBefore(toISO) {
	  var today = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var current = !today ? (0, _momentWithLocales2.default)().local() : _momentWithLocales2.default.utc(today);
	  return current.isBefore(toISO, 'minute') || current.isSame(toISO, 'minute');
	}
	
	function mapTimesToHumanTimes(offset, times, localeConstants) {
	  var useISODate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!times) {
	    return [];
	  }
	  var preparedData = deliveryTimesData(offset, times, now(true));
	  var today = localToday(DATE_FORMAT_FULL);
	  return _lodash2.default.map(Object.keys(preparedData), function (key) {
	    return {
	      label: today === key ? localeConstants.TODAY : localeConstants.TOMORROW,
	      value: useISODate ? (0, _momentWithLocales2.default)(key, DATE_FORMAT_FULL).format(DATE_FORMAT_ISO) : key,
	      values: preparedData[key]
	    };
	  });
	}
	
	function supportLocale(lang) {
	  return (_momentWithLocales2.default.locales() || []).indexOf(lang) > -1;
	}
	
	exports.default = {
	  deliveryTimesData: deliveryTimesData,
	  deliveryTimesForSlot: deliveryTimesForSlot,
	  extractDay: extractDay,
	  isAfterLastSlot: isAfterLastSlot,
	  isFuture: isFuture,
	  toLocalTime: toLocalTime,
	  localToday: localToday,
	  toUTCTime: toUTCTime,
	  toUTCFullDate: toUTCFullDate,
	  toHumanDate: toHumanDate,
	  toHumanCalendar: toHumanCalendar,
	  isDatePastNow: isDatePastNow,
	  formatISO: formatISO,
	  isDeliveryAvailableToday: isDeliveryAvailableToday,
	  isDeliveryAvailableTomorrow: isDeliveryAvailableTomorrow,
	  nextDeliveryTimeToday: nextDeliveryTimeToday,
	  isOpenToday: isOpenToday,
	  nextXDaysRange: nextXDaysRange,
	  nextWeekRange: nextWeekRange,
	  nextTwoWeeksRange: nextTwoWeeksRange,
	  weekDayLocale: weekDayLocale,
	  weekDayLocaleByIndex: weekDayLocaleByIndex,
	  toLocalDate: toLocalDate,
	  isDateExpired: isDateExpired,
	  areDatesEqual: areDatesEqual,
	  extractUTCTime: extractUTCTime,
	  now: now,
	  compareTimes: compareTimes,
	  toLocalHumanDate: toLocalHumanDate,
	  switchTimeZoneToLocal: switchTimeZoneToLocal,
	  currentTimeInSlot: currentTimeInSlot,
	  currentDateInRange: currentDateInRange,
	  currentDateIsBefore: currentDateIsBefore,
	  splitISO: splitISO,
	  mapTimesToHumanTimes: mapTimesToHumanTimes,
	  addAsapToDeliveryTimes: addAsapToDeliveryTimes,
	  supportLocale: supportLocale,
	  DATE_FORMAT: DATE_FORMAT,
	  DATE_FORMAT_PRETTY: DATE_FORMAT_PRETTY,
	  TIME_FORMAT: TIME_FORMAT
	};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonsContainer = function ButtonsContainer(props) {
	  var children = _react2.default.Children.toArray(props.children);
	  if (children.length === 1) {
	    return _react2.default.createElement(
	      'div',
	      { className: 'buttonsContainer' },
	      _react2.default.cloneElement(children[0], _extends({}, children[0].props, { style: { alignSelf: 'flex-start' } }))
	    );
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'buttonsContainer' },
	    _react2.default.cloneElement(children[0], _extends({}, children[0].props, { style: { alignSelf: 'flex-start' } })),
	    _react2.default.cloneElement(children[1], _extends({}, children[1].props, { style: { alignSelf: 'flex-end' } }))
	  );
	};
	
	exports.default = ButtonsContainer;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(411);
	
	Object.keys(_helpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _helpers[key];
	    }
	  });
	});
	
	var _selectors = __webpack_require__(417);
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});
	
	var _services = __webpack_require__(419);
	
	Object.keys(_services).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _services[key];
	    }
	  });
	});
	
	var _middlewareHelpers = __webpack_require__(413);
	
	Object.keys(_middlewareHelpers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _middlewareHelpers[key];
	    }
	  });
	});
	
	var _constants = __webpack_require__(9);
	
	Object.keys(_constants).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _constants[key];
	    }
	  });
	});
	
	var _reducers = __webpack_require__(416);
	
	Object.keys(_reducers).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _reducers[key];
	    }
	  });
	});

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var BOOKINGRUSH_CREATEREQUEST_START = exports.BOOKINGRUSH_CREATEREQUEST_START = 'BOOKINGRUSH_CREATEREQUEST_START';
	var BOOKINGRUSH_CREATEREQUEST_SUCCESS = exports.BOOKINGRUSH_CREATEREQUEST_SUCCESS = 'BOOKINGRUSH_CREATEREQUEST_SUCCESS';
	var BOOKINGRUSH_CREATEREQUEST_FAILURE = exports.BOOKINGRUSH_CREATEREQUEST_FAILURE = 'BOOKINGRUSH_CREATEREQUEST_FAILURE';
	
	var BOOKING_REQUEST_CREATE_START = exports.BOOKING_REQUEST_CREATE_START = 'BOOKING_REQUEST_CREATE_START';
	var BOOKING_REQUEST_CREATE_SUCCESS = exports.BOOKING_REQUEST_CREATE_SUCCESS = 'BOOKING_REQUEST_CREATE_SUCCESS';
	var BOOKING_REQUEST_CREATE_FAILURE = exports.BOOKING_REQUEST_CREATE_FAILURE = 'BOOKING_REQUEST_CREATE_FAILURE';
	
	var LOAD_BOOKING_AVAILABILITY_START = exports.LOAD_BOOKING_AVAILABILITY_START = 'LOAD_BOOKING_AVAILABILITY_START';
	var LOAD_BOOKING_AVAILABILITY_SUCCESS = exports.LOAD_BOOKING_AVAILABILITY_SUCCESS = 'LOAD_BOOKING_AVAILABILITY_SUCCESS';
	var LOAD_BOOKING_AVAILABILITY_FAILURE = exports.LOAD_BOOKING_AVAILABILITY_FAILURE = 'LOAD_BOOKING_AVAILABILITY_FAILURE';
	
	var BOOKINGRUSH_CREATE_START = exports.BOOKINGRUSH_CREATE_START = 'BOOKINGRUSH_CREATE_START';
	var BOOKINGRUSH_CREATE_SUCCESS = exports.BOOKINGRUSH_CREATE_SUCCESS = 'BOOKINGRUSH_CREATE_SUCCESS';
	var BOOKINGRUSH_CREATE_FAILURE = exports.BOOKINGRUSH_CREATE_FAILURE = 'BOOKINGRUSH_CREATE_FAILURE';
	
	var BOOKINGRUSH_UPDATE_START = exports.BOOKINGRUSH_UPDATE_START = 'BOOKINGRUSH_UPDATE_START';
	var BOOKINGRUSH_UPDATE_SUCCESS = exports.BOOKINGRUSH_UPDATE_SUCCESS = 'BOOKINGRUSH_UPDATE_SUCCESS';
	var BOOKINGRUSH_UPDATE_FAILURE = exports.BOOKINGRUSH_UPDATE_FAILURE = 'BOOKINGRUSH_UPDATE_FAILURE';
	
	var LOYALTYCARD_ADDSTAMPS_START = exports.LOYALTYCARD_ADDSTAMPS_START = 'LOYALTYCARD_ADDSTAMPS_START';
	var LOYALTYCARD_ADDSTAMPS_SUCCESS = exports.LOYALTYCARD_ADDSTAMPS_SUCCESS = 'LOYALTYCARD_ADDSTAMPS_SUCCESS';
	var LOYALTYCARD_ADDSTAMPS_FAILURE = exports.LOYALTYCARD_ADDSTAMPS_FAILURE = 'LOYALTYCARD_ADDSTAMPS_FAILURE';
	
	var LOYALTYCARD_GET_ACTIVE_CARD_START = exports.LOYALTYCARD_GET_ACTIVE_CARD_START = 'LOYALTYCARD_GET_ACTIVE_CARD_START';
	var LOYALTYCARD_GET_ACTIVE_CARD_SUCCESS = exports.LOYALTYCARD_GET_ACTIVE_CARD_SUCCESS = 'LOYALTYCARD_GET_ACTIVE_CARD_SUCCESS';
	var LOYALTYCARD_GET_ACTIVE_CARD_FAILURE = exports.LOYALTYCARD_GET_ACTIVE_CARD_FAILURE = 'LOYALTYCARD_GET_ACTIVE_CARD_FAILURE';
	
	var LOYALTYCARD_GET_CARD_START = exports.LOYALTYCARD_GET_CARD_START = 'LOYALTYCARD_GET_CARD_START';
	var LOYALTYCARD_GET_CARD_SUCCESS = exports.LOYALTYCARD_GET_CARD_SUCCESS = 'LOYALTYCARD_GET_CARD_SUCCESS';
	var LOYALTYCARD_GET_CARD_FAILURE = exports.LOYALTYCARD_GET_CARD_FAILURE = 'LOYALTYCARD_GET_CARD_FAILURE';
	
	var USER_AUTHENTICATE_START = exports.USER_AUTHENTICATE_START = 'USER_AUTHENTICATE_START';
	var USER_AUTHENTICATE_SUCCESS = exports.USER_AUTHENTICATE_SUCCESS = 'USER_AUTHENTICATE_SUCCESS';
	var USER_AUTHENTICATE_FAILURE = exports.USER_AUTHENTICATE_FAILURE = 'USER_AUTHENTICATE_FAILURE';
	
	var USER_REGISTER_START = exports.USER_REGISTER_START = 'USER_REGISTER_START';
	var USER_REGISTER_SUCCESS = exports.USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
	var USER_REGISTER_FAILURE = exports.USER_REGISTER_FAILURE = 'USER_REGISTER_FAILURE';
	
	var USER_LOGOUT_START = exports.USER_LOGOUT_START = 'USER_LOGOUT_START';
	var USER_LOGOUT_SUCCESS = exports.USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
	var USER_LOGOUT_FAILURE = exports.USER_LOGOUT_FAILURE = 'USER_LOGOUT_FAILURE';
	
	var USER_UPDATE_ACCESSTOKEN = exports.USER_UPDATE_ACCESSTOKEN = 'USER_UPDATE_ACCESSTOKEN';
	
	var USER_LOAD_START = exports.USER_LOAD_START = 'USER_LOAD_START';
	var USER_LOAD_SUCCESS = exports.USER_LOAD_SUCCESS = 'USER_LOAD_SUCCESS';
	var USER_LOAD_FAILURE = exports.USER_LOAD_FAILURE = 'USER_LOAD_FAILURE';
	var USER_LOAD_CREDIT_CARDS_SUCCESS = exports.USER_LOAD_CREDIT_CARDS_SUCCESS = 'USER_LOAD_CREDIT_CARDS_SUCCESS';
	var USER_DELETE_CREDIT_CARD_SUCCESS = exports.USER_DELETE_CREDIT_CARD_SUCCESS = 'USER_DELETE_CREDIT_CARD_SUCCESS';
	var USER_ADD_TMP_NEW_CREDIT_CARD = exports.USER_ADD_TMP_NEW_CREDIT_CARD = 'USER_ADD_TMP_NEW_CREDIT_CARD';
	
	var USER_LOAD_ORDERS_START = exports.USER_LOAD_ORDERS_START = 'USER_LOAD_ORDERS_START';
	var USER_LOAD_ORDERS_SUCCESS = exports.USER_LOAD_ORDERS_SUCCESS = 'USER_LOAD_ORDERS_SUCCESS';
	var USER_LOAD_ORDERS_FAILURE = exports.USER_LOAD_ORDERS_FAILURE = 'USER_LOAD_ORDERS_FAILURE';
	
	var USER_RESET_ORDERS = exports.USER_RESET_ORDERS = 'USER_RESET_ORDERS';
	
	var USER_LOAD_BOOKING_REQUESTS_START = exports.USER_LOAD_BOOKING_REQUESTS_START = 'USER_LOAD_BOOKING_REQUESTS_START';
	var USER_LOAD_BOOKING_REQUESTS_SUCCESS = exports.USER_LOAD_BOOKING_REQUESTS_SUCCESS = 'USER_LOAD_BOOKING_REQUESTS_SUCCESS';
	var USER_LOAD_BOOKING_REQUESTS_FAILURE = exports.USER_LOAD_BOOKING_REQUESTS_FAILURE = 'USER_LOAD_BOOKING_REQUESTS_FAILURE';
	
	var USER_SELECT_ARCHIVED_ORDER = exports.USER_SELECT_ARCHIVED_ORDER = 'USER_SELECT_ARCHIVED_ORDER';
	
	var VOUCHER_REDEEM_START = exports.VOUCHER_REDEEM_START = 'VOUCHER_REDEEM_START';
	var VOUCHER_REDEEM_SUCCESS = exports.VOUCHER_REDEEM_SUCCESS = 'VOUCHER_REDEEM_SUCCESS';
	var VOUCHER_REDEEM_FAILURE = exports.VOUCHER_REDEEM_FAILURE = 'VOUCHER_REDEEM_FAILURE';
	
	var VOUCHER_GET_MINE_START = exports.VOUCHER_GET_MINE_START = 'VOUCHER_GET_MINE_START';
	var VOUCHER_GET_MINE_SUCCESS = exports.VOUCHER_GET_MINE_SUCCESS = 'VOUCHER_GET_MINE_SUCCESS';
	var VOUCHER_GET_MINE_FAILURE = exports.VOUCHER_GET_MINE_FAILURE = 'VOUCHER_GET_MINE_FAILURE';
	
	var VOUCHER_CREATE_START = exports.VOUCHER_CREATE_START = 'VOUCHER_CREATE_START';
	var VOUCHER_CREATE_SUCCESS = exports.VOUCHER_CREATE_SUCCESS = 'VOUCHER_CREATE_SUCCESS';
	var VOUCHER_CREATE_FAILURE = exports.VOUCHER_CREATE_FAILURE = 'VOUCHER_CREATE_FAILURE';
	
	var VOUCHER_FORMAT_PERCENTAGE = exports.VOUCHER_FORMAT_PERCENTAGE = 'PERCENTAGE';
	var VOUCHER_FORMAT_ABSOLUTE = exports.VOUCHER_FORMAT_ABSOLUTE = 'ABSOLUTE_VALUE';
	var VOUCHER_FORMAT_FREE_ITEM = exports.VOUCHER_FORMAT_FREE_ITEM = 'FREE_ITEM';
	
	var VOUCHER_UPDATE_START = exports.VOUCHER_UPDATE_START = 'VOUCHER_UPDATE_START';
	var VOUCHER_UPDATE_SUCCESS = exports.VOUCHER_UPDATE_SUCCESS = 'VOUCHER_UPDATE_SUCCESS';
	var VOUCHER_UPDATE_FAILURE = exports.VOUCHER_UPDATE_FAILURE = 'VOUCHER_UPDATE_FAILURE';
	
	var GLOBAL_APP_INIT = exports.GLOBAL_APP_INIT = 'GLOBAL_APP_INIT';
	
	var GLOBAL_ERRORS_SET = exports.GLOBAL_ERRORS_SET = 'GLOBAL_ERRORS_SET';
	var GLOBAL_ERRORS_CLEAR = exports.GLOBAL_ERRORS_CLEAR = 'GLOBAL_ERRORS_CLEAR';
	
	var GLOBAL_SUCCESS_SET = exports.GLOBAL_SUCCESS_SET = 'GLOBAL_SUCCESS_SET';
	var GLOBAL_SUCCESS_CLEAR = exports.GLOBAL_SUCCESS_CLEAR = 'GLOBAL_SUCCESS_CLEAR';
	
	var GLOBAL_MESSAGE_SHOW = exports.GLOBAL_MESSAGE_SHOW = 'GLOBAL_MESSAGE_SHOW';
	
	var CONNECTIVITY_ERROR = exports.CONNECTIVITY_ERROR = 'CONNECTIVITY_ERROR';
	
	var EXTRA_COST_TYPE_POSITIVE = exports.EXTRA_COST_TYPE_POSITIVE = 'positive';
	var EXTRA_COST_TYPE_NEGATIVE = exports.EXTRA_COST_TYPE_NEGATIVE = 'negative';
	var EXTRA_COST_TYPE_NEUTRAL = exports.EXTRA_COST_TYPE_NEUTRAL = 'neutral';
	
	var RESTAURANTS_REFRESH_START = exports.RESTAURANTS_REFRESH_START = 'RESTAURANTS_REFRESH_START';
	var RESTAURANTS_REFRESH_SUCCESS = exports.RESTAURANTS_REFRESH_SUCCESS = 'RESTAURANTS_REFRESH_SUCCESS';
	var RESTAURANTS_REFRESH_FAILURE = exports.RESTAURANTS_REFRESH_FAILURE = 'RESTAURANTS_REFRESH_FAILURE';
	
	var ORDER_STATUS_CONFIRMED = exports.ORDER_STATUS_CONFIRMED = 'CONFIRMED';
	var ORDER_STATUS_PENDING = exports.ORDER_STATUS_PENDING = 'PENDING';
	var ORDER_STATUS_DECLINED = exports.ORDER_STATUS_DECLINED = 'DECLINED';
	
	var SWITCH_BUNDLE_ID = exports.SWITCH_BUNDLE_ID = 'SWITCH_BUNDLE_ID';

/***/ }),
/* 25 */
[786, 201],
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.urlSelector = undefined;
	
	var _reselect = __webpack_require__(18);
	
	var urlSelector = exports.urlSelector = (0, _reselect.createSelector)(function (state, props) {
	  return props.params.appId;
	}, function (state, props) {
	  return props.params.restaurantId;
	}, function (state, props) {
	  return props.params.orderType;
	}, function (state, props) {
	  return props.params.orderDate;
	}, function (state, props) {
	  return props.params.bookingDate;
	}, function (appId, restaurantId, orderType, orderDate, bookingDate) {
	  return {
	    appId: appId,
	    restaurantId: restaurantId,
	    orderType: orderType,
	    orderDate: orderDate,
	    bookingDate: bookingDate
	  };
	});

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(222);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(251);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(75)
	
	var NON_WORD_REGEXP = __webpack_require__(706)
	var CAMEL_CASE_REGEXP = __webpack_require__(704)
	var CAMEL_CASE_UPPER_REGEXP = __webpack_require__(705)
	
	/**
	 * Sentence case a string.
	 *
	 * @param  {string} str
	 * @param  {string} locale
	 * @param  {string} replacement
	 * @return {string}
	 */
	module.exports = function (str, locale, replacement) {
	  if (str == null) {
	    return ''
	  }
	
	  replacement = typeof replacement !== 'string' ? ' ' : replacement
	
	  function replace (match, index, value) {
	    if (index === 0 || index === (value.length - match.length)) {
	      return ''
	    }
	
	    return replacement
	  }
	
	  str = String(str)
	    // Support camel case ("camelCase" -> "camel Case").
	    .replace(CAMEL_CASE_REGEXP, '$1 $2')
	    // Support odd camel case ("CAMELCase" -> "CAMEL Case").
	    .replace(CAMEL_CASE_UPPER_REGEXP, '$1 $2')
	    // Remove all non-word characters and replace with a single space.
	    .replace(NON_WORD_REGEXP, replace)
	
	  // Lower case the entire string.
	  return lowerCase(str, locale)
	}


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(14);
	
	var genericMessage = "Invariant Violation";
	var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
	    obj.__proto__ = proto;
	    return obj;
	} : _a;
	var InvariantError = /** @class */ (function (_super) {
	    tslib.__extends(InvariantError, _super);
	    function InvariantError(message) {
	        if (message === void 0) { message = genericMessage; }
	        var _this = _super.call(this, typeof message === "number"
	            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
	            : message) || this;
	        _this.framesToPop = 1;
	        _this.name = genericMessage;
	        setPrototypeOf(_this, InvariantError.prototype);
	        return _this;
	    }
	    return InvariantError;
	}(Error));
	function invariant(condition, message) {
	    if (!condition) {
	        throw new InvariantError(message);
	    }
	}
	function wrapConsoleMethod(method) {
	    return function () {
	        return console[method].apply(console, arguments);
	    };
	}
	(function (invariant) {
	    invariant.warn = wrapConsoleMethod("warn");
	    invariant.error = wrapConsoleMethod("error");
	})(invariant || (invariant = {}));
	// Code that uses ts-invariant with rollup-plugin-invariant may want to
	// import this process stub to avoid errors evaluating process.env.NODE_ENV.
	// However, because most ESM-to-CJS compilers will rewrite the process import
	// as tsInvariant.process, which prevents proper replacement by minifiers, we
	// also attempt to define the stub globally when it is not already defined.
	exports.process = { env: {} };
	if (typeof process === "object") {
	    exports.process = process;
	}
	else
	    try {
	        // Using Function to evaluate this assignment in global scope also escapes
	        // the strict mode of the current module, thereby allowing the assignment.
	        // Inspired by https://github.com/facebook/regenerator/pull/369.
	        Function("stub", "process = stub")(exports.process);
	    }
	    catch (atLeastWeTried) {
	        // The assignment can fail if a Content Security Policy heavy-handedly
	        // forbids Function usage. In those environments, developers should take
	        // extra care to replace process.env.NODE_ENV in their production builds,
	        // or define an appropriate global.process polyfill.
	    }
	var invariant$1 = invariant;
	
	exports.default = invariant$1;
	exports.InvariantError = InvariantError;
	exports.invariant = invariant;
	//# sourceMappingURL=invariant.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(374);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(24);
	
	var _cart = __webpack_require__(51);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _constants2 = __webpack_require__(9);
	
	var _time = __webpack_require__(20);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var formatString = function formatString(type, amount) {
	  if (type === _constants.VOUCHER_FORMAT_PERCENTAGE) {
	    return amount + '%';
	  }
	
	  if (type === _constants.VOUCHER_FORMAT_ABSOLUTE) {
	    return _i18n2.default.formatPrice(amount);
	  }
	
	  return '';
	};
	
	var voucherHasMessage = function voucherHasMessage(voucher) {
	  return voucher && voucher.message && voucher.message.length > 0;
	};
	
	var format = function format(voucher, localized) {
	  var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'it';
	
	  if (!voucher) {
	    return null;
	  }
	
	  var title = voucher.discount.format === _constants.VOUCHER_FORMAT_FREE_ITEM ? localized.FREE_ITEM : localized.DISCOUNT;
	  return {
	    title: title,
	    subtitle: formatString(voucher.discount.format, voucher.discount.amount),
	    message: voucher.message,
	    validityPeriod: {
	      from: _time2.default.toLocalHumanDate(voucher.validityPeriod.from, lang),
	      to: _time2.default.toLocalHumanDate(voucher.validityPeriod.to, lang)
	    }
	  };
	};
	
	var isVoucherUsable = function isVoucherUsable(voucherData) {
	  var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (!voucherData) {
	    return false;
	  }
	  var validity = voucherData.validityPeriod;
	  var isValid = _time2.default.currentDateInRange({ fromISO: validity.from, toISO: validity.to }, currentDate);
	  var notRedeemed = voucherData.instance.redeemed !== true;
	  var notInvalidated = voucherData.instance.invalidated !== true;
	  return isValid && notRedeemed && notInvalidated;
	};
	
	var isVoucherAssigned = function isVoucherAssigned(voucherData) {
	  var currentDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (!voucherData) {
	    return false;
	  }
	  var validity = voucherData.validityPeriod;
	  var isValid = _time2.default.currentDateIsBefore(validity.to, currentDate);
	  var notRedeemed = voucherData.instance.redeemed !== true;
	  var notInvalidated = voucherData.instance.invalidated !== true;
	  return isValid && notRedeemed && notInvalidated;
	};
	
	var voucherForService = function voucherForService(voucherArray, moduleName, serviceName) {
	  return _lodash2.default.filter(voucherArray, function (v) {
	    var module = _lodash2.default.find(v.constraints.modules, { module: moduleName });
	    if (!module) {
	      return false;
	    }
	    var service = _lodash2.default.find(module.services, { name: serviceName });
	    if (!service) {
	      return false;
	    }
	    return module && service.active && isVoucherUsable(v);
	  });
	};
	
	var getVoucherWithId = function getVoucherWithId(voucherArray, id) {
	  return _lodash2.default.find(voucherArray, { instance: { id: id } });
	};
	
	var cartTotalWithVoucher = function cartTotalWithVoucher(cart, extraCosts, selectedVoucher, voucherInstances) {
	  if (selectedVoucher === _constants2.ORDER_NO_VOUCHER || !voucherInstances || voucherInstances.length === 0) {
	    return _cart2.default.total(cart, extraCosts);
	  }
	  var voucherData = getVoucherWithId(voucherInstances, selectedVoucher);
	  // extra check, voucherData should always be at this point
	  if (!voucherData) {
	    return _cart2.default.total(cart, extraCosts);
	  }
	  return _cart2.default.total(cart, [].concat(_toConsumableArray(extraCosts), [_cart2.default.extraCostFromVoucher(voucherData, cart)]));
	};
	
	var orderModuleForVoucher = function orderModuleForVoucher(voucherData) {
	  return _lodash2.default.find(voucherData.constraints.modules, { module: 'order' });
	};
	
	var voucherActiveForOrder = function voucherActiveForOrder(voucherData) {
	  var module = orderModuleForVoucher(voucherData);
	  if (!module) {
	    return false;
	  }
	  return _lodash2.default.find(module.services, { name: _constants2.ORDER_TYPE_DELIVERY, active: true }) || _lodash2.default.find(module.services, { name: _constants2.ORDER_TYPE_TAKEAWAY, active: true });
	};
	
	exports.default = {
	  voucherForService: voucherForService,
	  format: format,
	  getVoucherWithId: getVoucherWithId,
	  cartTotalWithVoucher: cartTotalWithVoucher,
	  voucherActiveForOrder: voucherActiveForOrder,
	  orderModuleForVoucher: orderModuleForVoucher,
	  isVoucherUsable: isVoucherUsable,
	  isVoucherAssigned: isVoucherAssigned,
	  voucherHasMessage: voucherHasMessage
	};

/***/ }),
/* 34 */
24,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = function Button(props) {
	  var type = props.type,
	      _onClick = props.onClick,
	      text = props.text,
	      style = props.style,
	      disabled = props.disabled;
	
	  var body = text || {
	    back: 'Indietro',
	    submit: 'Prosegui'
	  }[type];
	
	  var baseClass = type === 'next' ? 'btn-submit' : 'btn-' + type;
	  var classes = (0, _classnames2.default)(baseClass, { 'btn--disabled': disabled });
	
	  if (!_onClick && type !== 'next') {
	    return _react2.default.createElement('input', { type: 'submit', value: body, className: classes });
	  }
	
	  if (type === 'next') {
	    return _react2.default.createElement(
	      'a',
	      { href: '#', onClick: function onClick(e) {
	          return e.preventDefault() & _onClick();
	        }, className: classes, style: style },
	      body,
	      _react2.default.createElement('i', { className: 'bi_interface-right' })
	    );
	  }
	
	  if (type === 'secondary') {
	    return _react2.default.createElement(
	      'button',
	      { href: '#', onClick: _onClick, className: classes, style: style },
	      body
	    );
	  }
	
	  return _react2.default.createElement(
	    'a',
	    { href: '#', onClick: function onClick(e) {
	        return e.preventDefault() & _onClick();
	      }, className: classes, style: style },
	    type === 'back' && _react2.default.createElement('i', { className: 'bi_interface-left' }),
	    body
	  );
	};
	
	Button.propTypes = {
	  type: _propTypes2.default.string,
	  text: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  disabled: _propTypes2.default.bool
	};
	
	exports.default = Button;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var es5 = __webpack_require__(44);
	var Objectfreeze = es5.freeze;
	var util = __webpack_require__(8);
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
	        value: errorTypes,
	        writable: false,
	        enumerable: false,
	        configurable: false
	    });
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  az: {
	    regexp: /[\u0069]/g,
	    map: {
	      '\u0069': '\u0130'
	    }
	  },
	  lt: {
	    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
	    map: {
	      '\u0069\u0307': '\u0049',
	      '\u006A\u0307': '\u004A',
	      '\u012F\u0307': '\u012E',
	      '\u0069\u0307\u0300': '\u00CC',
	      '\u0069\u0307\u0301': '\u00CD',
	      '\u0069\u0307\u0303': '\u0128'
	    }
	  }
	}
	
	/**
	 * Upper case a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toUpperCase()
	}


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(55);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.COMMON_LOCALIZED = undefined;
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var COMMON_LOCALIZED = exports.COMMON_LOCALIZED = {
	  TODAY: 'Oggi' /*i18next.t('common.today')*/
	  , TOMORROW: 'Domani' /*i18next.t('common.tomorrow')*/
	  , ASAP: 'Il prima possibile' /*i18next.t('common.asap')*/
	  , FREE_ITEM: 'Omaggio' /*i18next.t('common.free_item')*/
	  , DISCOUNT: 'Sconto' /*i18next.t('common.discount')*/
	  , UNHANDLED_LABELS: {
	    PAY_WITH: 'Pagherò con' /*i18next.t('order.unhandled_pay_with')*/
	    , PAY_EXACT_AMOUNT: 'Ho i soldi giusti' /*i18next.t('order.unhandled_exact_amount')*/
	    , PAY_WITH_STAMPS: 'Pago con i buoni pasto' /*i18next.t('order.unhandled_food_stamps')*/
	  },
	  // language used in selectors
	  language: _i18n2.default.currentLanguage('it')
	};

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(615),
	    getValue = __webpack_require__(645);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(63);
	
	var ReactCurrentOwner = __webpack_require__(179);
	
	var warning = __webpack_require__(128);
	var canDefineProperty = __webpack_require__(182);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(180);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isAWellFormedAddress = exports.mapDelta = exports.distanceBetweenPoints = exports.formatResult = exports.addressFromCoordinates = exports.coordinatesFromAddress = exports.mergeAddresses = exports.extractAddressComponent = exports.validateStreetNumber = exports.deliveryAddressFactory = exports.addressComponentsToString = exports.formatAddressDescription = exports.S_NUMBER_RGX = exports.GEO_COMPONENTS = exports.setApiKey = exports.getApiKey = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global fetch */
	
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _i18next = __webpack_require__(134);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var API_KEY; // eslint-disable-line
	var getApiKey = exports.getApiKey = function getApiKey() {
	  return API_KEY;
	};
	var setApiKey = exports.setApiKey = function setApiKey(apiKey) {
	  API_KEY = apiKey;
	};
	
	var GEO_COMPONENTS = exports.GEO_COMPONENTS = {
	  STREET: 'route',
	  STREET_NUMBER: 'street_number',
	  ZIP: 'postal_code',
	  CITY_GEO: 'locality',
	  CITY_GEO_ALT: 'administrative_area_level_3',
	  CITY: 'city',
	  COUNTRY: 'country'
	};
	
	var DISTANCE_THRESHOLD = 50;
	
	var S_NUMBER_RGX = exports.S_NUMBER_RGX = /[0-9]{1,6}[,/-]?[a-zA-Z]?/;
	
	var getApiUrl = function getApiUrl(reverse) {
	  if (reverse) {
	    return 'https://maps.googleapis.com/maps/api/geocode/json?latlng=XXX__LAT,XXX__LNG&key=' + getApiKey(); // REVERSE
	  }
	  return 'https://maps.googleapis.com/maps/api/geocode/json?address=[XXX__ADDRESS]&key=' + getApiKey(); // REGULAR
	};
	
	var formatAddressShort = function formatAddressShort(components) {
	  return [components[GEO_COMPONENTS.STREET], components[GEO_COMPONENTS.CITY]].join(', ');
	};
	
	var formatAddressDescription = exports.formatAddressDescription = function formatAddressDescription(components) {
	  var shortForm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (typeof components === 'string') {
	    return components;
	  }
	
	  if (shortForm) {
	    return formatAddressShort(components);
	  }
	
	  var filter = void 0;
	  if (components[GEO_COMPONENTS.STREET_NUMBER]) {
	    filter = [components[GEO_COMPONENTS.STREET], components[GEO_COMPONENTS.STREET_NUMBER], components[GEO_COMPONENTS.CITY]];
	  } else {
	    filter = [components[GEO_COMPONENTS.STREET], components[GEO_COMPONENTS.CITY]];
	  }
	  return filter.join(', ');
	};
	
	var addressComponentsToString = exports.addressComponentsToString = function addressComponentsToString(components) {
	  var streetNumber = components[GEO_COMPONENTS.STREET_NUMBER] || '';
	  var zipCode = components[GEO_COMPONENTS.ZIP] || '';
	  return [components[GEO_COMPONENTS.STREET], streetNumber, zipCode, components[GEO_COMPONENTS.CITY], components[GEO_COMPONENTS.COUNTRY]].join(', ');
	};
	
	var deliveryAddressFactory = exports.deliveryAddressFactory = function deliveryAddressFactory(description, lat, lng, addressComponents) {
	  return {
	    description: description,
	    addressComponents: addressComponents,
	    geometry: {
	      location: { lat: lat, lng: lng }
	    }
	  };
	};
	
	var validateStreetNumber = exports.validateStreetNumber = function validateStreetNumber(number) {
	  return S_NUMBER_RGX.test(number);
	};
	
	var extractAddressComponent = exports.extractAddressComponent = function extractAddressComponent(components) {
	  return _lodash2.default.reduce(components, function (f, c) {
	    var filtered = Object.assign({}, f);
	    if (c.types[0] === GEO_COMPONENTS.STREET || c.types[0] === GEO_COMPONENTS.STREET_NUMBER || c.types[0] === GEO_COMPONENTS.ZIP || c.types[0] === GEO_COMPONENTS.COUNTRY) {
	      filtered[c.types[0]] = c.long_name;
	    }
	    // a cleaner and more human name for city
	    if (c.types[0] === GEO_COMPONENTS.CITY_GEO) {
	      filtered.city = c.long_name;
	    }
	
	    // keep administrative_area_3 as city if locality is not available
	    if (c.types[0] === GEO_COMPONENTS.CITY_GEO_ALT && !filtered.city) {
	      filtered.city = c.long_name;
	    }
	
	    return filtered;
	  }, {});
	};
	
	var mergeAddresses = exports.mergeAddresses = function mergeAddresses(currentAddress, newAddress) {
	  var currentAddrSNum = currentAddress[GEO_COMPONENTS.STREET_NUMBER];
	  if (!currentAddrSNum) {
	    return _extends({}, newAddress);
	  }
	  var newAddrSNum = newAddress[GEO_COMPONENTS.STREET_NUMBER];
	
	  // keep user street number even if google did not
	  // get it
	  if (currentAddrSNum && !newAddrSNum) {
	    return _extends({}, newAddress, _defineProperty({}, GEO_COMPONENTS.STREET_NUMBER, currentAddrSNum));
	  }
	
	  // use currentAddress if is a substring of newAddress or if is "valid",
	  // e.g. 56/A and 56
	  var streetNumber = currentAddrSNum.indexOf(newAddrSNum) >= 0 || validateStreetNumber(currentAddrSNum) ? currentAddrSNum : newAddrSNum;
	
	  return _extends({}, newAddress, _defineProperty({}, GEO_COMPONENTS.STREET_NUMBER, streetNumber));
	};
	
	var coordinatesFromAddress = exports.coordinatesFromAddress = function coordinatesFromAddress(address) {
	  var API_URL = getApiUrl();
	  var reqURL = API_URL.replace('XXX__ADDRESS', encodeURI(address));
	
	  return fetch(reqURL).then(function (res) {
	    return res.json();
	  }).then(function (res) {
	    var data = res.results[0];
	    var components = extractAddressComponent(data.address_components);
	    return {
	      data: {
	        address: {
	          components: components,
	          location: {
	            description: formatAddressDescription(components),
	            geometry: {
	              location: data.geometry.location
	            }
	          }
	        }
	      }
	    };
	  }).catch(function (e) {
	    console.log(e); // eslint-disable-line
	    return { errors: [{ message: _i18next2.default.t('user.address_s_number_error') }] };
	  });
	};
	
	var addressFromCoordinates = exports.addressFromCoordinates = function addressFromCoordinates(lat, lng) {
	  var REVERSE_API_URL = getApiUrl(true);
	  var reqURL = REVERSE_API_URL.replace('XXX__LAT', lat).replace('XXX__LNG', lng);
	
	  return fetch(reqURL).then(function (res) {
	    return res.json();
	  }).then(function (res) {
	    if (!res.results.length) {
	      throw new Error('No results');
	    }
	
	    var data = res.results[0];
	    var components = extractAddressComponent(data.address_components);
	    return {
	      data: {
	        address: {
	          components: components,
	          location: {
	            description: formatAddressDescription(components),
	            geometry: {
	              location: data.geometry.location
	            }
	          }
	        }
	      }
	    };
	  }).catch(function (e) {
	    console.log(e); // eslint-disable-line
	    return { errors: [{ message: _i18next2.default.t('user.address_s_number_error') }] };
	  });
	};
	
	var formatResult = exports.formatResult = function formatResult(details) {
	  var _details$geometry$loc = details.geometry.location,
	      lat = _details$geometry$loc.lat,
	      lng = _details$geometry$loc.lng;
	  // extract needed components
	
	  var addressComponents = extractAddressComponent(details.address_components);
	  var description = formatAddressDescription(addressComponents);
	  return deliveryAddressFactory(description, lat, lng, addressComponents);
	};
	
	var R = 6371000; // earth's radius in meters
	var degreesToRadians = function degreesToRadians(g) {
	  return g * Math.PI / 180;
	};
	/*
	 * distance between 2 points {lat:xxx, lng:yyy}
	*/
	var distanceBetweenPoints = exports.distanceBetweenPoints = function distanceBetweenPoints(p1, p2) {
	  var l1 = degreesToRadians(p1.lat);
	  var l2 = degreesToRadians(p2.lat);
	  var dphi = degreesToRadians(p2.lat - p1.lat);
	  var dalp = degreesToRadians(p2.lng - p1.lng);
	
	  // https://en.wikipedia.org/wiki/Haversine_formula
	  var haversine = Math.sin(dphi / 2) * Math.sin(dphi / 2) + Math.cos(l1) * Math.cos(l2) * Math.sin(dalp / 2) * Math.sin(dalp / 2);
	
	  // anuglar distance in radius
	  var c = 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
	
	  // distance in km and m
	  var d = Math.ceil(R * c);
	  return Number((d / 1000).toFixed(2));
	};
	
	var mapDelta = exports.mapDelta = function mapDelta(p1, p2) {
	  var distance = distanceBetweenPoints(p1, p2);
	  if (distance === 0) {
	    return 0.045;
	  }
	
	  return distance / 90;
	};
	
	var isAWellFormedAddress = exports.isAWellFormedAddress = function isAWellFormedAddress(addressComponents) {
	  return addressComponents.filter(function (comp) {
	    return comp.types.indexOf(GEO_COMPONENTS.STREET) > -1;
	  }).length > 0;
	};
	
	exports.default = {
	  DISTANCE_THRESHOLD: DISTANCE_THRESHOLD,
	  GEO_COMPONENTS: GEO_COMPONENTS,
	  S_NUMBER_RGX: S_NUMBER_RGX,
	  getApiKey: getApiKey,
	  setApiKey: setApiKey,
	  extractAddressComponent: extractAddressComponent,
	  formatAddressDescription: formatAddressDescription,
	  coordinatesFromAddress: coordinatesFromAddress,
	  addressFromCoordinates: addressFromCoordinates,
	  distanceBetweenPoints: distanceBetweenPoints,
	  mapDelta: mapDelta,
	  deliveryAddressFactory: deliveryAddressFactory,
	  formatResult: formatResult,
	  addressComponentsToString: addressComponentsToString,
	  isAWellFormedAddress: isAWellFormedAddress,
	  validateStreetNumber: validateStreetNumber,
	  mergeAddresses: mergeAddresses
	};

/***/ }),
/* 51 */
[784, 24],
/* 52 */
[786, 423],
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Spinner = function Spinner(props) {
	  var size = { large: '40px', normal: '20px', small: '10px' }[props.size];
	  return _react2.default.createElement(
	    'div',
	    { className: 'spinner' },
	    _react2.default.createElement('span', { className: 'primary--border-top', style: { width: size, height: size } }),
	    props.text && _react2.default.createElement(
	      'p',
	      { className: 'primary spinner__text' },
	      props.text
	    )
	  );
	};
	
	Spinner.propTypes = {
	  size: _propTypes2.default.oneOf(['large', 'normal', 'small']),
	  text: _propTypes2.default.string
	};
	Spinner.defaultProps = {
	  size: 'normal'
	};
	
	exports.default = Spinner;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.orderOvercomeThreshold = exports.orderLocationAddressSelector = exports.orderStepSelector = undefined;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reselect = __webpack_require__(18);
	
	var _cart = __webpack_require__(64);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _constants = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ORDER_STEPS = {
	  end: 5,
	  payment: 4,
	  voucher: 3,
	  checkout: 3,
	  cart: 2,
	  menu: 1,
	  order: 0
	};
	
	var orderStepSelector = exports.orderStepSelector = (0, _reselect.createSelector)(function (state, props) {
	  return props.location.pathname;
	}, function (fullLocation) {
	  if (!fullLocation) return 0;
	
	  var lastUrlPart = fullLocation.substring(fullLocation.lastIndexOf('/') + 1);
	  return ORDER_STEPS[lastUrlPart] || 0;
	});
	
	var orderLocationAddressSelector = exports.orderLocationAddressSelector = (0, _reselect.createSelector)(function (state) {
	  return state.app.merchant.restaurants;
	}, function (state, props) {
	  return props.params.orderType;
	}, function (state, props) {
	  return props.params.restaurantId;
	}, function (state) {
	  return state.order.deliveryLocation;
	}, function (restaurants, orderType, restaurantId, deliveryLocation) {
	  if (orderType === _constants.ORDER_TYPE_TAKEAWAY) {
	    var restaurant = _lodash2.default.find(restaurants, { id: restaurantId });
	    return {
	      address: restaurant.address,
	      coords: {
	        lat: restaurant.location.latitude,
	        lng: restaurant.location.longitude
	      }
	    };
	  }
	
	  return {
	    address: deliveryLocation.description,
	    coords: deliveryLocation.geometry.location
	  };
	});
	
	var orderOvercomeThreshold = exports.orderOvercomeThreshold = (0, _reselect.createSelector)(function (state) {
	  return _cart2.default.total(state.order.cart);
	}, function (state, props) {
	  return props.params.orderType === _constants.ORDER_TYPE_DELIVERY;
	}, function (state) {
	  return state.order.deliveryAreaCustomThreshold || 0;
	}, function (cartTotal, isDelivery, threshold) {
	  return cartTotal >= threshold && isDelivery || !isDelivery;
	});

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(37);
	
	var _Actions = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var consoleLogger = {
	  type: 'logger',
	
	  log: function log(args) {
	    this.output('log', args);
	  },
	  warn: function warn(args) {
	    this.output('warn', args);
	  },
	  error: function error(args) {
	    this.output('error', args);
	  },
	  output: function output(type, args) {
	    var _console;
	
	    /* eslint no-console: 0 */
	    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
	  }
	};
	
	var Logger = function () {
	  function Logger(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Logger);
	
	    this.init(concreteLogger, options);
	  }
	
	  Logger.prototype.init = function init(concreteLogger) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    this.prefix = options.prefix || 'i18next:';
	    this.logger = concreteLogger || consoleLogger;
	    this.options = options;
	    this.debug = options.debug;
	  };
	
	  Logger.prototype.setDebug = function setDebug(bool) {
	    this.debug = bool;
	  };
	
	  Logger.prototype.log = function log() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return this.forward(args, 'log', '', true);
	  };
	
	  Logger.prototype.warn = function warn() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return this.forward(args, 'warn', '', true);
	  };
	
	  Logger.prototype.error = function error() {
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return this.forward(args, 'error', '');
	  };
	
	  Logger.prototype.deprecate = function deprecate() {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
	  };
	
	  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
	    if (debugOnly && !this.debug) return null;
	    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
	    return this.logger[lvl](args);
	  };
	
	  Logger.prototype.create = function create(moduleName) {
	    return new Logger(this.logger, _extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
	  };
	
	  return Logger;
	}();
	
	exports.default = new Logger();

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(71),
	    getRawTag = __webpack_require__(642),
	    objectToString = __webpack_require__(671);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.getApolloContext = getApolloContext;
	exports.operationName = operationName;
	exports.parser = parser;
	exports.resetApolloContext = resetApolloContext;
	exports.DocumentType = exports.ApolloProvider = exports.ApolloConsumer = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _tsInvariant = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apolloContext;
	
	function getApolloContext() {
	  if (!apolloContext) {
	    apolloContext = _react.default.createContext({});
	  }
	
	  return apolloContext;
	}
	
	function resetApolloContext() {
	  apolloContext = _react.default.createContext({});
	}
	
	var ApolloProvider = function (_a) {
	  var client = _a.client,
	      children = _a.children;
	  var ApolloContext = getApolloContext();
	  return _react.default.createElement(ApolloContext.Consumer, null, function (context) {
	    if (context === void 0) {
	      context = {};
	    }
	
	    if (client && context.client !== client) {
	      context = Object.assign({}, context, {
	        client: client
	      });
	    }
	
	     true ? (0, _tsInvariant.invariant)(context.client, 5) : (0, _tsInvariant.invariant)(context.client, 'ApolloProvider was not passed a client instance. Make ' + 'sure you pass in your client via the "client" prop.');
	    return _react.default.createElement(ApolloContext.Provider, {
	      value: context
	    }, children);
	  });
	};
	
	exports.ApolloProvider = ApolloProvider;
	
	var ApolloConsumer = function (props) {
	  var ApolloContext = getApolloContext();
	  return _react.default.createElement(ApolloContext.Consumer, null, function (context) {
	     true ? (0, _tsInvariant.invariant)(context && context.client, 6) : (0, _tsInvariant.invariant)(context && context.client, 'Could not find "client" in the context of ApolloConsumer. ' + 'Wrap the root component in an <ApolloProvider>.');
	    return props.children(context.client);
	  });
	};
	
	exports.ApolloConsumer = ApolloConsumer;
	var DocumentType;
	exports.DocumentType = DocumentType;
	
	(function (DocumentType) {
	  DocumentType[DocumentType["Query"] = 0] = "Query";
	  DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
	  DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
	})(DocumentType || (exports.DocumentType = DocumentType = {}));
	
	var cache = new Map();
	
	function operationName(type) {
	  var name;
	
	  switch (type) {
	    case DocumentType.Query:
	      name = 'Query';
	      break;
	
	    case DocumentType.Mutation:
	      name = 'Mutation';
	      break;
	
	    case DocumentType.Subscription:
	      name = 'Subscription';
	      break;
	  }
	
	  return name;
	}
	
	function parser(document) {
	  var cached = cache.get(document);
	  if (cached) return cached;
	  var variables, type, name;
	   true ? (0, _tsInvariant.invariant)(!!document && !!document.kind, 1) : (0, _tsInvariant.invariant)(!!document && !!document.kind, "Argument of " + document + " passed to parser was not a valid GraphQL " + "DocumentNode. You may need to use 'graphql-tag' or another method " + "to convert your operation into a document");
	  var fragments = document.definitions.filter(function (x) {
	    return x.kind === 'FragmentDefinition';
	  });
	  var queries = document.definitions.filter(function (x) {
	    return x.kind === 'OperationDefinition' && x.operation === 'query';
	  });
	  var mutations = document.definitions.filter(function (x) {
	    return x.kind === 'OperationDefinition' && x.operation === 'mutation';
	  });
	  var subscriptions = document.definitions.filter(function (x) {
	    return x.kind === 'OperationDefinition' && x.operation === 'subscription';
	  });
	   true ? (0, _tsInvariant.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2) : (0, _tsInvariant.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, "Passing only a fragment to 'graphql' is not yet supported. " + "You must include a query, subscription or mutation as well");
	   true ? (0, _tsInvariant.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3) : (0, _tsInvariant.invariant)(queries.length + mutations.length + subscriptions.length <= 1, "react-apollo only supports a query, subscription, or a mutation per HOC. " + (document + " had " + queries.length + " queries, " + subscriptions.length + " ") + ("subscriptions and " + mutations.length + " mutations. ") + "You can use 'compose' to join multiple operation types to a component");
	  type = queries.length ? DocumentType.Query : DocumentType.Mutation;
	  if (!queries.length && !mutations.length) type = DocumentType.Subscription;
	  var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
	   true ? (0, _tsInvariant.invariant)(definitions.length === 1, 4) : (0, _tsInvariant.invariant)(definitions.length === 1, "react-apollo only supports one definition per HOC. " + document + " had " + (definitions.length + " definitions. ") + "You can use 'compose' to join multiple operation types to a component");
	  var definition = definitions[0];
	  variables = definition.variableDefinitions || [];
	
	  if (definition.name && definition.name.kind === 'Name') {
	    name = definition.name.value;
	  } else {
	    name = 'data';
	  }
	
	  var payload = {
	    name: name,
	    type: type,
	    variables: variables
	  };
	  cache.set(document, payload);
	  return payload;
	}


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 64 */
[784, 34],
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _spinner = __webpack_require__(53);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BoxedItem = function BoxedItem(props) {
	  var contentClasses = (0, _classnames2.default)('boxedItem', {
	    'boxedItem--active': props.active,
	    'boxedItem--with-icon': props.icon,
	    'boxedItem--with-action': props.onClick
	  }, props.className);
	  var noop = function noop() {};
	  var onClickWrapper = function onClickWrapper(evt) {
	    // prevent propagation if the onclick has been fired
	    // by an inner element and not the box itself
	    var targetType = evt.target.getAttribute('type');
	    var targetTag = evt.target.tagName;
	    var isInputText = targetTag === 'INPUT' && targetType === 'text';
	    var isInputSubmitReset = targetTag === 'BUTTON' && (targetType === 'submit' || targetType === 'reset');
	    if (isInputText || isInputSubmitReset) {
	      return;
	    }
	    // prevent multiple click while in loading state
	    if (props.isLoading || !props.onClick) return;
	    props.onClick();
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: contentClasses, onClick: onClickWrapper || noop },
	    _react2.default.createElement(
	      'div',
	      { className: 'boxedItem__header' },
	      _react2.default.createElement(
	        'h5',
	        null,
	        props.title
	      ),
	      props.subtitle && _react2.default.createElement(
	        'p',
	        null,
	        props.subtitle
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'boxedItem__content' },
	      _react2.default.createElement(
	        'div',
	        null,
	        props.children
	      )
	    ),
	    props.icon && !props.isLoading && _react2.default.createElement('i', { className: props.icon }),
	    props.isLoading && _react2.default.createElement(_spinner2.default, null)
	  );
	};
	
	BoxedItem.propTypes = {
	  title: _propTypes2.default.string,
	  subtitle: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  icon: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  isLoading: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.element)])
	};
	
	BoxedItem.defaultProps = {
	  isLoading: false,
	  active: false
	};
	
	exports.default = BoxedItem;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _arreebaForm = __webpack_require__(164);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// utility for merging form single field errors
	// and extra errors
	var mergeErrors = function mergeErrors(errors, extra) {
	  var mergedErrors = _extends({}, errors);
	  _lodash2.default.forIn(extra, function (val, key) {
	    var err = mergedErrors[key] || [];
	    mergedErrors[key] = err.concat(val);
	  });
	  return mergedErrors;
	};
	
	var FormWrapper = function (_React$Component) {
	  _inherits(FormWrapper, _React$Component);
	
	  function FormWrapper(props) {
	    _classCallCheck(this, FormWrapper);
	
	    var _this = _possibleConstructorReturn(this, (FormWrapper.__proto__ || Object.getPrototypeOf(FormWrapper)).call(this, props));
	
	    _this.state = {
	      config: _this.props.config,
	      errors: {}
	    };
	    _this.save = _this.save.bind(_this);
	    return _this;
	  }
	
	  _createClass(FormWrapper, [{
	    key: 'save',
	    value: function save(data) {
	      var config = this.state.config.map(function (field) {
	        return _extends({}, field, {
	          initialValue: data[field.name] || ''
	        });
	      }, {});
	
	      var extraErrors = this.props.extraCheck ? this.props.extraCheck(data) : {};
	
	      var errors = mergeErrors((0, _arreebaForm.validateForm)(data, config), extraErrors);
	      if (!(0, _arreebaForm.isFormValid)(errors)) {
	        this.setState({ errors: errors, config: config });
	        return;
	      }
	      this.props.onValidSave(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_arreebaForm.Form, {
	        data: this.state.config,
	        errors: this.state.errors,
	        onSubmit: this.save,
	        onSave: this.save,
	        onCancel: this.props.onCancel,
	        submitButtonLabel: this.props.submitButtonLabel,
	        cancelButtonLabel: this.props.cancelButtonLabel,
	        submitClassNames: ['btn-submit']
	      });
	    }
	  }]);
	
	  return FormWrapper;
	}(_react2.default.Component);
	
	FormWrapper.propTypes = {
	  config: _propTypes2.default.array.isRequired,
	  extraCheck: _propTypes2.default.func,
	  onValidSave: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func,
	  submitButtonLabel: _propTypes2.default.string,
	  cancelButtonLabel: _propTypes2.default.string
	};
	
	exports.default = FormWrapper;

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = getWindow;
	
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = offset;
	
	var _contains = _interopRequireDefault(__webpack_require__(125));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(67));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(55));
	
	function offset(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      win = (0, _isWindow.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = {
	    top: 0,
	    left: 0,
	    height: 0,
	    width: 0
	  };
	  if (!doc) return; // Make sure it's not a disconnected DOM node
	
	  if (!(0, _contains.default)(docElem, node)) return box;
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height
	
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	  return box;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defer = defer;
	exports.makeString = makeString;
	exports.copy = copy;
	exports.setPath = setPath;
	exports.pushPath = pushPath;
	exports.getPath = getPath;
	exports.deepExtend = deepExtend;
	exports.regexEscape = regexEscape;
	exports.escape = escape;
	// http://lea.verou.me/2016/12/resolve-promises-externally-with-this-one-weird-trick/
	function defer() {
	  var res = void 0;
	  var rej = void 0;
	
	  var promise = new Promise(function (resolve, reject) {
	    res = resolve;
	    rej = reject;
	  });
	
	  promise.resolve = res;
	  promise.reject = rej;
	
	  return promise;
	}
	
	function makeString(object) {
	  if (object == null) return '';
	  /* eslint prefer-template: 0 */
	  return '' + object;
	}
	
	function copy(a, s, t) {
	  a.forEach(function (m) {
	    if (s[m]) t[m] = s[m];
	  });
	}
	
	function getLastOfPath(object, path, Empty) {
	  function cleanKey(key) {
	    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
	  }
	
	  function canNotTraverseDeeper() {
	    return !object || typeof object === 'string';
	  }
	
	  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
	  while (stack.length > 1) {
	    if (canNotTraverseDeeper()) return {};
	
	    var key = cleanKey(stack.shift());
	    if (!object[key] && Empty) object[key] = new Empty();
	    object = object[key];
	  }
	
	  if (canNotTraverseDeeper()) return {};
	  return {
	    obj: object,
	    k: cleanKey(stack.shift())
	  };
	}
	
	function setPath(object, path, newValue) {
	  var _getLastOfPath = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath.obj,
	      k = _getLastOfPath.k;
	
	  obj[k] = newValue;
	}
	
	function pushPath(object, path, newValue, concat) {
	  var _getLastOfPath2 = getLastOfPath(object, path, Object),
	      obj = _getLastOfPath2.obj,
	      k = _getLastOfPath2.k;
	
	  obj[k] = obj[k] || [];
	  if (concat) obj[k] = obj[k].concat(newValue);
	  if (!concat) obj[k].push(newValue);
	}
	
	function getPath(object, path) {
	  var _getLastOfPath3 = getLastOfPath(object, path),
	      obj = _getLastOfPath3.obj,
	      k = _getLastOfPath3.k;
	
	  if (!obj) return undefined;
	  return obj[k];
	}
	
	function deepExtend(target, source, overwrite) {
	  /* eslint no-restricted-syntax: 0 */
	  for (var prop in source) {
	    if (prop in target) {
	      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
	      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
	        if (overwrite) target[prop] = source[prop];
	      } else {
	        deepExtend(target[prop], source[prop], overwrite);
	      }
	    } else {
	      target[prop] = source[prop];
	    }
	  }
	  return target;
	}
	
	function regexEscape(str) {
	  /* eslint no-useless-escape: 0 */
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	/* eslint-disable */
	var _entityMap = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;',
	  '/': '&#x2F;'
	};
	/* eslint-enable */
	
	function escape(data) {
	  if (typeof data === 'string') {
	    return data.replace(/[&<>"'\/]/g, function (s) {
	      return _entityMap[s];
	    });
	  }
	
	  return data;
	}

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(28);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(257),
	    isLength = __webpack_require__(143);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/**
	 * Special language-specific overrides.
	 *
	 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
	 *
	 * @type {Object}
	 */
	var LANGUAGES = {
	  tr: {
	    regexp: /\u0130|\u0049|\u0049\u0307/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  az: {
	    regexp: /[\u0130]/g,
	    map: {
	      '\u0130': '\u0069',
	      '\u0049': '\u0131',
	      '\u0049\u0307': '\u0069'
	    }
	  },
	  lt: {
	    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
	    map: {
	      '\u0049': '\u0069\u0307',
	      '\u004A': '\u006A\u0307',
	      '\u012E': '\u012F\u0307',
	      '\u00CC': '\u0069\u0307\u0300',
	      '\u00CD': '\u0069\u0307\u0301',
	      '\u0128': '\u0069\u0307\u0303'
	    }
	  }
	}
	
	/**
	 * Lowercase a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  var lang = LANGUAGES[locale]
	
	  str = str == null ? '' : String(str)
	
	  if (lang) {
	    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
	  }
	
	  return str.toLowerCase()
	}


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(727);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(728);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(3);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.log = log;
	exports.warn = warn;
	function log() {
	
	    if (false) {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        console.log(args);
	    }
	}
	
	function warn() {
	
	    if (false) {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        console.warn(args);
	    }
	}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fixCustomClassNames = exports.isFormValid = exports.validateForm = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _validators = __webpack_require__(295);
	
	var _validators2 = _interopRequireDefault(_validators);
	
	var _logging = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validateForm = exports.validateForm = function validateForm(formData, formConfig) {
	
	  var errors = {};
	
	  formConfig.forEach(function (fieldConfig) {
	
	    if (fieldConfig.customComponent) {
	      return;
	    }
	
	    var shouldValidate = fieldConfig.type !== 'button' && (fieldConfig.shouldValidate === undefined || fieldConfig.shouldValidate(formData));
	
	    if (shouldValidate) {
	      if (!errors[fieldConfig.name]) {
	        errors[fieldConfig.name] = [];
	      }
	
	      var value = _lodash2.default.get(formData, fieldConfig.name);
	
	      if (value === undefined) {
	        (0, _logging.warn)('Not found element in form:', fieldConfig.name);
	
	        errors[fieldConfig.name].push('Errore imprevisto');
	        return;
	      }
	
	      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	
	        var atLeastOneValidItem = false;
	
	        fieldConfig.items.forEach(function (itemConfig) {
	
	          var isRequired = typeof itemConfig.isRequired !== 'boolean' || itemConfig.isRequired;
	          var itemValue = _lodash2.default.get(formData, itemConfig.name);
	          var format = itemConfig.format || fieldConfig.format || 'string';
	
	          if (typeof format === 'function') {
	            /* If format is a function, when called it should return a string or a falsy value. */
	            format = format(formData);
	          }
	
	          var isValid = !format || _validators2.default[format](itemValue);
	
	          atLeastOneValidItem = atLeastOneValidItem || !!(isValid && itemValue);
	
	          /* If value is not set, we will give an error only if isRequired. */
	          if (!isValid && (itemValue || isRequired)) {
	
	            var label = itemConfig.leftLabel || itemConfig.rightLabel || itemConfig.label || fieldConfig.label || fieldConfig.bigLabel;
	
	            (0, _logging.warn)('Not valid (1):', { label: label, name: itemConfig.name, format: format, itemValue: itemValue });
	
	            /* Adding the error in parent field's errors list. */
	            errors[fieldConfig.name].push(label + ': ' + _validators2.default[format].errorMessage);
	          }
	        });
	
	        if (fieldConfig.isRequired && !atLeastOneValidItem) {
	
	          (0, _logging.warn)('Not valid (2):', fieldConfig.name);
	
	          errors[fieldConfig.name].push(_validators2.default[fieldConfig.items[0].format].errorMessage);
	        }
	      } else {
	
	        var format = fieldConfig.format || 'string';
	
	        //console.log('Field config', fieldConfig.name, format, value);
	
	        var isRequired = typeof fieldConfig.isRequired !== 'boolean' || fieldConfig.isRequired;
	
	        var isValid = !format || _validators2.default[format](value);
	
	        if (!isValid && (value || isRequired)) {
	
	          (0, _logging.warn)('Not valid (3)', { name: fieldConfig.name, format: format, value: value });
	
	          errors[fieldConfig.name].push(_validators2.default[format].errorMessage);
	        }
	      }
	    }
	  });
	
	  return errors;
	};
	
	var isFormValid = exports.isFormValid = function isFormValid(errorsMap) {
	
	  return _lodash2.default.values(errorsMap).reduce(function (prev, current) {
	    return prev && current.length === 0;
	  }, true);
	};
	
	var fixCustomClassNames = exports.fixCustomClassNames = function fixCustomClassNames(customClassNames) {
	
	  var fixedCustomClassNames = customClassNames || [];
	
	  if (typeof customClassNames === 'string') {
	    fixedCustomClassNames = customClassNames.split(' ');
	  }
	  return fixedCustomClassNames;
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var Framework7App_1 = __webpack_require__(362);
	exports.Framework7App = Framework7App_1.Framework7App;
	var Framework7_1 = __webpack_require__(81);
	exports.Framework7 = Framework7_1.Framework7;
	var AccordionContent_1 = __webpack_require__(297);
	exports.AccordionContent = AccordionContent_1.AccordionContent;
	var AccordionItem_1 = __webpack_require__(298);
	exports.AccordionItem = AccordionItem_1.AccordionItem;
	var AccordionToggle_1 = __webpack_require__(299);
	exports.AccordionToggle = AccordionToggle_1.AccordionToggle;
	var Accordion_1 = __webpack_require__(296);
	exports.Accordion = Accordion_1.Accordion;
	var ActionsButton_1 = __webpack_require__(301);
	exports.ActionsButton = ActionsButton_1.ActionsButton;
	var ActionsGroup_1 = __webpack_require__(302);
	exports.ActionsGroup = ActionsGroup_1.ActionsGroup;
	var ActionsLabel_1 = __webpack_require__(303);
	exports.ActionsLabel = ActionsLabel_1.ActionsLabel;
	var Actions_1 = __webpack_require__(300);
	exports.Actions = Actions_1.Actions;
	var Badge_1 = __webpack_require__(110);
	exports.Badge = Badge_1.Badge;
	var Button_1 = __webpack_require__(304);
	exports.Button = Button_1.Button;
	var ButtonsSegmented_1 = __webpack_require__(305);
	exports.ButtonsSegmented = ButtonsSegmented_1.ButtonsSegmented;
	var Calendar_1 = __webpack_require__(306);
	exports.Calendar = Calendar_1.Calendar;
	var CardContent_1 = __webpack_require__(165);
	exports.CardContent = CardContent_1.CardContent;
	var CardFooter_1 = __webpack_require__(166);
	exports.CardFooter = CardFooter_1.CardFooter;
	var CardHeader_1 = __webpack_require__(167);
	exports.CardHeader = CardHeader_1.CardHeader;
	var Card_1 = __webpack_require__(307);
	exports.Card = Card_1.Card;
	var Chip_1 = __webpack_require__(308);
	exports.Chip = Chip_1.Chip;
	var ContentBlockTitle_1 = __webpack_require__(310);
	exports.ContentBlockTitle = ContentBlockTitle_1.ContentBlockTitle;
	var ContentBlock_1 = __webpack_require__(309);
	exports.ContentBlock = ContentBlock_1.ContentBlock;
	var DataTableActions_1 = __webpack_require__(312);
	exports.DataTableActions = DataTableActions_1.DataTableActions;
	var DataTableCell_1 = __webpack_require__(111);
	exports.DataTableCell = DataTableCell_1.DataTableCell;
	var DataTableHeader_1 = __webpack_require__(168);
	exports.DataTableHeader = DataTableHeader_1.DataTableHeader;
	var DataTableLinks_1 = __webpack_require__(313);
	exports.DataTableLinks = DataTableLinks_1.DataTableLinks;
	var DataTableRow_1 = __webpack_require__(169);
	exports.DataTableRow = DataTableRow_1.DataTableRow;
	var DataTableTitle_1 = __webpack_require__(170);
	exports.DataTableTitle = DataTableTitle_1.DataTableTitle;
	var DataTable_1 = __webpack_require__(311);
	exports.DataTable = DataTable_1.DataTable;
	var Datepicker_1 = __webpack_require__(314);
	exports.Datepicker = Datepicker_1.Datepicker;
	var FabSpeedDialAction_1 = __webpack_require__(317);
	exports.FabSpeedDialAction = FabSpeedDialAction_1.FabSpeedDialAction;
	var FabSpeedDialActions_1 = __webpack_require__(318);
	exports.FabSpeedDialActions = FabSpeedDialActions_1.FabSpeedDialActions;
	var FabSpeedDial_1 = __webpack_require__(316);
	exports.FabSpeedDial = FabSpeedDial_1.FabSpeedDial;
	var Fab_1 = __webpack_require__(315);
	exports.Fab = Fab_1.Fab;
	var FormInput_1 = __webpack_require__(319);
	exports.FormInput = FormInput_1.FormInput;
	var FormLabel_1 = __webpack_require__(320);
	exports.FormLabel = FormLabel_1.FormLabel;
	var FormRange_1 = __webpack_require__(171);
	exports.FormRange = FormRange_1.FormRange;
	var FormSwitch_1 = __webpack_require__(172);
	exports.FormSwitch = FormSwitch_1.FormSwitch;
	var GridCol_1 = __webpack_require__(321);
	exports.GridCol = GridCol_1.GridCol;
	var GridRow_1 = __webpack_require__(322);
	exports.GridRow = GridRow_1.GridRow;
	var Icon_1 = __webpack_require__(112);
	exports.Icon = Icon_1.Icon;
	var Link_1 = __webpack_require__(113);
	exports.Link = Link_1.Link;
	var ListButton_1 = __webpack_require__(324);
	exports.ListButton = ListButton_1.ListButton;
	var ListGroup_1 = __webpack_require__(325);
	exports.ListGroup = ListGroup_1.ListGroup;
	var ListItemContent_1 = __webpack_require__(173);
	exports.ListItemContent = ListItemContent_1.ListItemContent;
	var ListItemSwipeoutActions_1 = __webpack_require__(327);
	exports.ListItemSwipeoutActions = ListItemSwipeoutActions_1.ListItemSwipeoutActions;
	var ListItemSwipeoutButton_1 = __webpack_require__(328);
	exports.ListItemSwipeoutButton = ListItemSwipeoutButton_1.ListItemSwipeoutButton;
	var ListItem_1 = __webpack_require__(326);
	exports.ListItem = ListItem_1.ListItem;
	var ListLabel_1 = __webpack_require__(329);
	exports.ListLabel = ListLabel_1.ListLabel;
	var List_1 = __webpack_require__(323);
	exports.List = List_1.List;
	var LoginScreenTitle_1 = __webpack_require__(331);
	exports.LoginScreenTitle = LoginScreenTitle_1.LoginScreenTitle;
	var LoginScreen_1 = __webpack_require__(330);
	exports.LoginScreen = LoginScreen_1.LoginScreen;
	var Message_1 = __webpack_require__(332);
	exports.Message = Message_1.Message;
	var Messagebar_1 = __webpack_require__(333);
	exports.Messagebar = Messagebar_1.Messagebar;
	var Messages_1 = __webpack_require__(334);
	exports.Messages = Messages_1.Messages;
	var NavCenter_1 = __webpack_require__(174);
	exports.NavCenter = NavCenter_1.NavCenter;
	var NavLeft_1 = __webpack_require__(175);
	exports.NavLeft = NavLeft_1.NavLeft;
	var NavRight_1 = __webpack_require__(335);
	exports.NavRight = NavRight_1.NavRight;
	var Navbar_1 = __webpack_require__(176);
	exports.Navbar = Navbar_1.Navbar;
	var PageContent_1 = __webpack_require__(337);
	exports.PageContent = PageContent_1.PageContent;
	var Page_1 = __webpack_require__(336);
	exports.Page = Page_1.Page;
	var Pages_1 = __webpack_require__(177);
	exports.Pages = Pages_1.Pages;
	var Panel_1 = __webpack_require__(338);
	exports.Panel = Panel_1.Panel;
	var PhotoBrowser_1 = __webpack_require__(339);
	exports.PhotoBrowser = PhotoBrowser_1.PhotoBrowser;
	var PickerModal_1 = __webpack_require__(340);
	exports.PickerModal = PickerModal_1.PickerModal;
	var Popover_1 = __webpack_require__(341);
	exports.Popover = Popover_1.Popover;
	var Popup_1 = __webpack_require__(342);
	exports.Popup = Popup_1.Popup;
	var Preloader_1 = __webpack_require__(343);
	exports.Preloader = Preloader_1.Preloader;
	var Progressbar_1 = __webpack_require__(344);
	exports.Progressbar = Progressbar_1.Progressbar;
	var Searchbar_1 = __webpack_require__(345);
	exports.Searchbar = Searchbar_1.Searchbar;
	var Statusbar_1 = __webpack_require__(346);
	exports.Statusbar = Statusbar_1.Statusbar;
	var Subnavbar_1 = __webpack_require__(347);
	exports.Subnavbar = Subnavbar_1.Subnavbar;
	var SwiperSlide_1 = __webpack_require__(349);
	exports.SwiperSlide = SwiperSlide_1.SwiperSlide;
	var Swiper_1 = __webpack_require__(348);
	exports.Swiper = Swiper_1.Swiper;
	var Tab_1 = __webpack_require__(350);
	exports.Tab = Tab_1.Tab;
	var Tabs_1 = __webpack_require__(351);
	exports.Tabs = Tabs_1.Tabs;
	var Template7Template_1 = __webpack_require__(352);
	exports.Template7Template = Template7Template_1.Template7Template;
	var TimelineItemChild_1 = __webpack_require__(355);
	exports.TimelineItemChild = TimelineItemChild_1.TimelineItemChild;
	var TimelineItem_1 = __webpack_require__(354);
	exports.TimelineItem = TimelineItem_1.TimelineItem;
	var TimelineMonth_1 = __webpack_require__(356);
	exports.TimelineMonth = TimelineMonth_1.TimelineMonth;
	var TimelineYear_1 = __webpack_require__(357);
	exports.TimelineYear = TimelineYear_1.TimelineYear;
	var Timeline_1 = __webpack_require__(353);
	exports.Timeline = Timeline_1.Timeline;
	var Toolbar_1 = __webpack_require__(358);
	exports.Toolbar = Toolbar_1.Toolbar;
	var View_1 = __webpack_require__(359);
	exports.View = View_1.View;
	var Views_1 = __webpack_require__(360);
	exports.Views = Views_1.Views;
	
	//# sourceMappingURL=index.js.map


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Framework7 1.6.4
	 * Full featured mobile HTML framework for building iOS & Android apps
	 *
	 * http://framework7.io/
	 *
	 * Copyright 2017, Vladimir Kharlampidi
	 * The iDangero.us
	 * http://www.idangero.us/
	 *
	 * Licensed under MIT
	 *
	 * Released on: August 28, 2017
	 */
	window.Dom7 = module.exports.Dom7 = (function () {
	    'use strict';
	    var Dom7 = function Dom7(arr) {
	        var self = this;
	        // Create array-like object
	        for (var i = 0; i < arr.length; i += 1) {
	            self[i] = arr[i];
	        }
	        self.length = arr.length;
	        // Return collection with methods
	        return this;
	    };
	    function $(selector, context) {
	        var arr = [];
	        var i = 0;
	        if (selector && !context) {
	            if (selector instanceof Dom7) {
	                return selector;
	            }
	        }
	        if (selector) {
	            // String
	            if (typeof selector === 'string') {
	                var els;
	                var tempParent;
	                var html = selector.trim();
	                if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
	                    var toCreate = 'div';
	                    if (html.indexOf('<li') === 0) {
	                        toCreate = 'ul';
	                    }
	                    if (html.indexOf('<tr') === 0) {
	                        toCreate = 'tbody';
	                    }
	                    if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) {
	                        toCreate = 'tr';
	                    }
	                    if (html.indexOf('<tbody') === 0) {
	                        toCreate = 'table';
	                    }
	                    if (html.indexOf('<option') === 0) {
	                        toCreate = 'select';
	                    }
	                    tempParent = document.createElement(toCreate);
	                    tempParent.innerHTML = html;
	                    for (i = 0; i < tempParent.childNodes.length; i += 1) {
	                        arr.push(tempParent.childNodes[i]);
	                    }
	                }
	                else {
	                    if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
	                        // Pure ID selector
	                        els = [document.getElementById(selector.trim().split('#')[1])];
	                    }
	                    else {
	                        // Other selectors
	                        els = (context || document).querySelectorAll(selector.trim());
	                    }
	                    for (i = 0; i < els.length; i += 1) {
	                        if (els[i]) {
	                            arr.push(els[i]);
	                        }
	                    }
	                }
	            }
	            else if (selector.nodeType || selector === window || selector === document) {
	                // Node/element
	                arr.push(selector);
	            }
	            else if (selector.length > 0 && selector[0].nodeType) {
	                // Array of elements or instance of Dom
	                for (i = 0; i < selector.length; i += 1) {
	                    arr.push(selector[i]);
	                }
	            }
	        }
	        return new Dom7(arr);
	    }
	    // Remove Diacritics
	    var defaultDiacriticsRemovalap = [
	        { base: 'A', letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F' },
	        { base: 'AA', letters: '\uA732' },
	        { base: 'AE', letters: '\u00C6\u01FC\u01E2' },
	        { base: 'AO', letters: '\uA734' },
	        { base: 'AU', letters: '\uA736' },
	        { base: 'AV', letters: '\uA738\uA73A' },
	        { base: 'AY', letters: '\uA73C' },
	        { base: 'B', letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181' },
	        { base: 'C', letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E' },
	        { base: 'D', letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779' },
	        { base: 'DZ', letters: '\u01F1\u01C4' },
	        { base: 'Dz', letters: '\u01F2\u01C5' },
	        { base: 'E', letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E' },
	        { base: 'F', letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B' },
	        { base: 'G', letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E' },
	        { base: 'H', letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D' },
	        { base: 'I', letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197' },
	        { base: 'J', letters: '\u004A\u24BF\uFF2A\u0134\u0248' },
	        { base: 'K', letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2' },
	        { base: 'L', letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780' },
	        { base: 'LJ', letters: '\u01C7' },
	        { base: 'Lj', letters: '\u01C8' },
	        { base: 'M', letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C' },
	        { base: 'N', letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4' },
	        { base: 'NJ', letters: '\u01CA' },
	        { base: 'Nj', letters: '\u01CB' },
	        { base: 'O', letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C' },
	        { base: 'OI', letters: '\u01A2' },
	        { base: 'OO', letters: '\uA74E' },
	        { base: 'OU', letters: '\u0222' },
	        { base: 'OE', letters: '\u008C\u0152' },
	        { base: 'oe', letters: '\u009C\u0153' },
	        { base: 'P', letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754' },
	        { base: 'Q', letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A' },
	        { base: 'R', letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782' },
	        { base: 'S', letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784' },
	        { base: 'T', letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786' },
	        { base: 'TZ', letters: '\uA728' },
	        { base: 'U', letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244' },
	        { base: 'V', letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245' },
	        { base: 'VY', letters: '\uA760' },
	        { base: 'W', letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72' },
	        { base: 'X', letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C' },
	        { base: 'Y', letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE' },
	        { base: 'Z', letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762' },
	        { base: 'a', letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250' },
	        { base: 'aa', letters: '\uA733' },
	        { base: 'ae', letters: '\u00E6\u01FD\u01E3' },
	        { base: 'ao', letters: '\uA735' },
	        { base: 'au', letters: '\uA737' },
	        { base: 'av', letters: '\uA739\uA73B' },
	        { base: 'ay', letters: '\uA73D' },
	        { base: 'b', letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253' },
	        { base: 'c', letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184' },
	        { base: 'd', letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A' },
	        { base: 'dz', letters: '\u01F3\u01C6' },
	        { base: 'e', letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD' },
	        { base: 'f', letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C' },
	        { base: 'g', letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F' },
	        { base: 'h', letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265' },
	        { base: 'hv', letters: '\u0195' },
	        { base: 'i', letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131' },
	        { base: 'j', letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249' },
	        { base: 'k', letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3' },
	        { base: 'l', letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747' },
	        { base: 'lj', letters: '\u01C9' },
	        { base: 'm', letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F' },
	        { base: 'n', letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5' },
	        { base: 'nj', letters: '\u01CC' },
	        { base: 'o', letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275' },
	        { base: 'oi', letters: '\u01A3' },
	        { base: 'ou', letters: '\u0223' },
	        { base: 'oo', letters: '\uA74F' },
	        { base: 'p', letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755' },
	        { base: 'q', letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759' },
	        { base: 'r', letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783' },
	        { base: 's', letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B' },
	        { base: 't', letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787' },
	        { base: 'tz', letters: '\uA729' },
	        { base: 'u', letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289' },
	        { base: 'v', letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C' },
	        { base: 'vy', letters: '\uA761' },
	        { base: 'w', letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73' },
	        { base: 'x', letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D' },
	        { base: 'y', letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF' },
	        { base: 'z', letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763' }
	    ];
	    var diacriticsMap = {};
	    for (var i = 0; i < defaultDiacriticsRemovalap.length; i += 1) {
	        var letters = defaultDiacriticsRemovalap[i].letters;
	        for (var j = 0; j < letters.length; j += 1) {
	            diacriticsMap[letters[j]] = defaultDiacriticsRemovalap[i].base;
	        }
	    }
	    var Utils = {
	        parseUrlQuery: function parseUrlQuery(url) {
	            var query = {};
	            var urlToParse = url || window.location.href;
	            var i;
	            var params;
	            var param;
	            var length;
	            if (typeof urlToParse === 'string' && urlToParse.length) {
	                urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
	                params = urlToParse.split('&').filter(function (paramsPart) { return paramsPart !== ''; });
	                length = params.length;
	                for (i = 0; i < length; i += 1) {
	                    param = params[i].replace(/#\S+/g, '').split('=');
	                    query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
	                }
	            }
	            return query;
	        },
	        isArray: function isArray(arr) {
	            return Array.isArray(arr);
	        },
	        each: function each(obj, callback) {
	            // Check it's iterable
	            // TODO: Should probably raise a value error here
	            if (typeof obj !== 'object') {
	                return;
	            }
	            // Don't bother continuing without a callback
	            if (!callback) {
	                return;
	            }
	            if (Array.isArray(obj) || obj instanceof Dom7) {
	                // Array
	                for (var i = 0; i < obj.length; i++) {
	                    // If callback returns false
	                    if (callback(i, obj[i]) === false) {
	                        // Break out of the loop
	                        return;
	                    }
	                }
	            }
	            else {
	                // Object
	                for (var prop in obj) {
	                    // Check the propertie belongs to the object
	                    // not it's prototype
	                    if (obj.hasOwnProperty(prop)) {
	                        // If the callback returns false
	                        if (callback(prop, obj[prop]) === false) {
	                            // Break out of the loop;
	                            return;
	                        }
	                    }
	                }
	            }
	        },
	        unique: function unique(arr) {
	            var uniqueArray = [];
	            for (var i = 0; i < arr.length; i += 1) {
	                if (uniqueArray.indexOf(arr[i]) === -1) {
	                    uniqueArray.push(arr[i]);
	                }
	            }
	            return uniqueArray;
	        },
	        serializeObject: function serializeObject(obj, parents) {
	            if (parents === void 0)
	                parents = [];
	            if (typeof obj === 'string') {
	                return obj;
	            }
	            var resultArray = [];
	            var separator = '&';
	            var newParents;
	            function varName(name) {
	                if (parents.length > 0) {
	                    var parentParts = '';
	                    for (var j = 0; j < parents.length; j += 1) {
	                        if (j === 0) {
	                            parentParts += parents[j];
	                        }
	                        else {
	                            parentParts += "[" + (encodeURIComponent(parents[j])) + "]";
	                        }
	                    }
	                    return (parentParts + "[" + (encodeURIComponent(name)) + "]");
	                }
	                return encodeURIComponent(name);
	            }
	            function varValue(value) {
	                return encodeURIComponent(value);
	            }
	            for (var prop in obj) {
	                if (obj.hasOwnProperty(prop)) {
	                    var toPush = (void 0);
	                    if (Array.isArray(obj[prop])) {
	                        toPush = [];
	                        for (var i = 0; i < obj[prop].length; i += 1) {
	                            if (!Array.isArray(obj[prop][i]) && typeof obj[prop][i] === 'object') {
	                                newParents = parents.slice();
	                                newParents.push(prop);
	                                newParents.push(String(i));
	                                toPush.push(Utils.serializeObject(obj[prop][i], newParents));
	                            }
	                            else {
	                                toPush.push(((varName(prop)) + "[]=" + (varValue(obj[prop][i]))));
	                            }
	                        }
	                        if (toPush.length > 0) {
	                            resultArray.push(toPush.join(separator));
	                        }
	                    }
	                    else if (obj[prop] === null || obj[prop] === '') {
	                        resultArray.push(((varName(prop)) + "="));
	                    }
	                    else if (typeof obj[prop] === 'object') {
	                        // Object, convert to named array
	                        newParents = parents.slice();
	                        newParents.push(prop);
	                        toPush = Utils.serializeObject(obj[prop], newParents);
	                        if (toPush !== '') {
	                            resultArray.push(toPush);
	                        }
	                    }
	                    else if (typeof obj[prop] !== 'undefined' && obj[prop] !== '') {
	                        // Should be string or plain value
	                        resultArray.push(((varName(prop)) + "=" + (varValue(obj[prop]))));
	                    }
	                    else if (obj[prop] === '') {
	                        resultArray.push(varName(prop));
	                    }
	                }
	            }
	            return resultArray.join(separator);
	        },
	        toCamelCase: function toCamelCase(string) {
	            return string.toLowerCase().replace(/-(.)/g, function (match, group1) { return group1.toUpperCase(); });
	        },
	        dataset: function dataset(el) {
	            return $(el).dataset();
	        },
	        getTranslate: function getTranslate(el, axis) {
	            if (axis === void 0)
	                axis = 'x';
	            var curStyle = window.getComputedStyle(el, null);
	            var matrix;
	            var curTransform;
	            var transformMatrix;
	            if (window.WebKitCSSMatrix) {
	                curTransform = curStyle.transform || curStyle.webkitTransform;
	                if (curTransform.split(',').length > 6) {
	                    curTransform = curTransform.split(', ').map(function map(a) {
	                        return a.replace(',', '.');
	                    }).join(', ');
	                }
	                // Some old versions of Webkit choke when 'none' is passed; pass
	                // empty string instead in this case
	                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	            }
	            else {
	                transformMatrix = curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	                matrix = transformMatrix.toString().split(',');
	            }
	            if (axis === 'x') {
	                // Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix) {
	                    curTransform = transformMatrix.m41;
	                }
	                else if (matrix.length === 16) {
	                    curTransform = parseFloat(matrix[12]);
	                }
	                else {
	                    curTransform = parseFloat(matrix[4]);
	                }
	            }
	            if (axis === 'y') {
	                // Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix) {
	                    curTransform = transformMatrix.m42;
	                }
	                else if (matrix.length === 16) {
	                    curTransform = parseFloat(matrix[13]);
	                }
	                else {
	                    curTransform = parseFloat(matrix[5]);
	                }
	            }
	            return curTransform || 0;
	        },
	        requestAnimationFrame: function requestAnimationFrame(callback) {
	            if (window.requestAnimationFrame) {
	                return window.requestAnimationFrame(callback);
	            }
	            else if (window.webkitRequestAnimationFrame) {
	                return window.webkitRequestAnimationFrame(callback);
	            }
	            return window.setTimeout(callback, 1000 / 60);
	        },
	        cancelAnimationFrame: function cancelAnimationFrame(id) {
	            if (window.cancelAnimationFrame) {
	                return window.cancelAnimationFrame(id);
	            }
	            else if (window.webkitCancelAnimationFrame) {
	                return window.webkitCancelAnimationFrame(id);
	            }
	            return window.clearTimeout(id);
	        },
	        supportTouch: !!(('ontouchstart' in window) || (window.DocumentTouch && document instanceof window.DocumentTouch)),
	        removeDiacritics: function removeDiacritics(str) {
	            return str.replace(/[^\u0000-\u007E]/g, function (a) { return diacriticsMap[a] || a; });
	        },
	        extend: function extend() {
	            var args = [], len$1 = arguments.length;
	            while (len$1--)
	                args[len$1] = arguments[len$1];
	            var to = Object(args[0]);
	            for (var i = 1; i < args.length; i += 1) {
	                var nextSource = args[i];
	                if (nextSource !== undefined && nextSource !== null) {
	                    var keysArray = Object.keys(Object(nextSource));
	                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
	                        var nextKey = keysArray[nextIndex];
	                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	                        if (desc !== undefined && desc.enumerable) {
	                            if (typeof to[nextKey] === 'object' && typeof nextSource[nextKey] === 'object') {
	                                Utils.extend(to[nextKey], nextSource[nextKey]);
	                            }
	                            else {
	                                to[nextKey] = nextSource[nextKey];
	                            }
	                        }
	                    }
	                }
	            }
	            return to;
	        },
	    };
	    // Aliases
	    Utils.parseQuery = Utils.parseUrlQuery;
	    Utils.param = Utils.serializeObject;
	    // Global Ajax Setup
	    var globalAjaxOptions = {};
	    $.ajaxSetup = function ajaxSetup(options) {
	        if (options.type && !options.method) {
	            options.method = options.type;
	        }
	        Utils.each(options, function (optionName, optionValue) {
	            globalAjaxOptions[optionName] = optionValue;
	        });
	    };
	    // JSONP Requests
	    var jsonpRequests = 0;
	    // Ajax
	    function ajax(options) {
	        var defaults = {
	            method: 'GET',
	            data: false,
	            async: true,
	            cache: true,
	            user: '',
	            password: '',
	            headers: {},
	            xhrFields: {},
	            statusCode: {},
	            processData: true,
	            dataType: 'text',
	            contentType: 'application/x-www-form-urlencoded',
	            timeout: 0,
	        };
	        var callbacks = ['beforeSend', 'error', 'complete', 'success', 'statusCode'];
	        // For jQuery guys
	        if (options.type) {
	            options.method = options.type;
	        }
	        // Global options
	        var globals = globalAjaxOptions;
	        // Merge global and defaults
	        Utils.each(globals, function (globalOptionName, globalOptionValue) {
	            if (callbacks.indexOf(globalOptionName) < 0) {
	                defaults[globalOptionName] = globalOptionValue;
	            }
	        });
	        // Function to run XHR callbacks and events
	        function fireAjaxCallback(eventName, eventData, callbackName) {
	            var a = arguments;
	            if (eventName) {
	                $(document).trigger(eventName, eventData);
	            }
	            if (callbackName) {
	                // Global callback
	                if (callbackName in globals) {
	                    globals[callbackName](a[3], a[4], a[5], a[6]);
	                }
	                // Options callback
	                if (options[callbackName]) {
	                    options[callbackName](a[3], a[4], a[5], a[6]);
	                }
	            }
	        }
	        // Merge options and defaults
	        Utils.each(defaults, function (prop, defaultValue) {
	            if (!(prop in options)) {
	                options[prop] = defaultValue;
	            }
	        });
	        // Default URL
	        if (!options.url) {
	            options.url = window.location.toString();
	        }
	        // Parameters Prefix
	        var paramsPrefix = options.url.indexOf('?') >= 0 ? '&' : '?';
	        // UC method
	        var method = options.method.toUpperCase();
	        // Data to modify GET URL
	        if ((method === 'GET' || method === 'HEAD' || method === 'OPTIONS' || method === 'DELETE') && options.data) {
	            var stringData;
	            if (typeof options.data === 'string') {
	                // Should be key=value string
	                if (options.data.indexOf('?') >= 0) {
	                    stringData = options.data.split('?')[1];
	                }
	                else {
	                    stringData = options.data;
	                }
	            }
	            else {
	                // Should be key=value object
	                stringData = Utils.serializeObject(options.data);
	            }
	            if (stringData.length) {
	                options.url += paramsPrefix + stringData;
	                if (paramsPrefix === '?') {
	                    paramsPrefix = '&';
	                }
	            }
	        }
	        // JSONP
	        if (options.dataType === 'json' && options.url.indexOf('callback=') >= 0) {
	            var callbackName = "f7jsonp_" + (Date.now() + ((jsonpRequests += 1)));
	            var abortTimeout;
	            var callbackSplit = options.url.split('callback=');
	            var requestUrl = (callbackSplit[0]) + "callback=" + callbackName;
	            if (callbackSplit[1].indexOf('&') >= 0) {
	                var addVars = callbackSplit[1].split('&').filter(function (el) { return el.indexOf('=') > 0; }).join('&');
	                if (addVars.length > 0) {
	                    requestUrl += "&" + addVars;
	                }
	            }
	            // Create script
	            var script = document.createElement('script');
	            script.type = 'text/javascript';
	            script.onerror = function onerror() {
	                clearTimeout(abortTimeout);
	                fireAjaxCallback(undefined, undefined, 'error', null, 'scripterror');
	                fireAjaxCallback('ajaxComplete ajax:complete', { scripterror: true }, 'complete', null, 'scripterror');
	            };
	            script.src = requestUrl;
	            // Handler
	            window[callbackName] = function jsonpCallback(data) {
	                clearTimeout(abortTimeout);
	                fireAjaxCallback(undefined, undefined, 'success', data);
	                script.parentNode.removeChild(script);
	                script = null;
	                delete window[callbackName];
	            };
	            document.querySelector('head').appendChild(script);
	            if (options.timeout > 0) {
	                abortTimeout = setTimeout(function () {
	                    script.parentNode.removeChild(script);
	                    script = null;
	                    fireAjaxCallback(undefined, undefined, 'error', null, 'timeout');
	                }, options.timeout);
	            }
	            return;
	        }
	        // Cache for GET/HEAD requests
	        if (method === 'GET' || method === 'HEAD' || method === 'OPTIONS' || method === 'DELETE') {
	            if (options.cache === false) {
	                options.url += paramsPrefix + "_nocache" + (Date.now());
	            }
	        }
	        // Create XHR
	        var xhr = new XMLHttpRequest();
	        // Save Request URL
	        xhr.requestUrl = options.url;
	        xhr.requestParameters = options;
	        // Open XHR
	        xhr.open(method, options.url, options.async, options.user, options.password);
	        // Create POST Data
	        var postData = null;
	        if ((method === 'POST' || method === 'PUT' || method === 'PATCH') && options.data) {
	            if (options.processData) {
	                var postDataInstances = [ArrayBuffer, Blob, Document, FormData];
	                // Post Data
	                if (postDataInstances.indexOf(options.data.constructor) >= 0) {
	                    postData = options.data;
	                }
	                else {
	                    // POST Headers
	                    var boundary = "---------------------------" + (Date.now().toString(16));
	                    if (options.contentType === 'multipart/form-data') {
	                        xhr.setRequestHeader('Content-Type', ("multipart/form-data; boundary=" + boundary));
	                    }
	                    else {
	                        xhr.setRequestHeader('Content-Type', options.contentType);
	                    }
	                    postData = '';
	                    var data = Utils.serializeObject(options.data);
	                    if (options.contentType === 'multipart/form-data') {
	                        data = data.split('&');
	                        var newData = [];
	                        for (var i = 0; i < data.length; i += 1) {
	                            newData.push(("Content-Disposition: form-data; name=\"" + (data[i].split('=')[0]) + "\"\r\n\r\n" + (data[i].split('=')[1]) + "\r\n"));
	                        }
	                        postData = "--" + boundary + "\r\n" + (newData.join(("--" + boundary + "\r\n"))) + "--" + boundary + "--\r\n";
	                    }
	                    else {
	                        postData = data;
	                    }
	                }
	            }
	            else {
	                postData = options.data;
	            }
	        }
	        // Additional headers
	        if (options.headers) {
	            Utils.each(options.headers, function (headerName, headerCallback) {
	                xhr.setRequestHeader(headerName, headerCallback);
	            });
	        }
	        // Check for crossDomain
	        if (typeof options.crossDomain === 'undefined') {
	            options.crossDomain = /^([\w-]+:)?\/\/([^\/]+)/.test(options.url) && RegExp.$2 !== window.location.host;
	        }
	        if (!options.crossDomain) {
	            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        }
	        if (options.xhrFields) {
	            Utils.each(options.xhrFields, function (fieldName, fieldValue) {
	                xhr[fieldName] = fieldValue;
	            });
	        }
	        var xhrTimeout;
	        // Handle XHR
	        xhr.onload = function onload(e) {
	            if (xhrTimeout) {
	                clearTimeout(xhrTimeout);
	            }
	            if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 0) {
	                var responseData;
	                if (options.dataType === 'json') {
	                    try {
	                        responseData = JSON.parse(xhr.responseText);
	                        fireAjaxCallback('ajaxSuccess ajax:success', { xhr: xhr }, 'success', responseData, xhr.status, xhr);
	                    }
	                    catch (err) {
	                        fireAjaxCallback('ajaxError ajax:error', { xhr: xhr, parseerror: true }, 'error', xhr, 'parseerror');
	                    }
	                }
	                else {
	                    responseData = xhr.responseType === 'text' || xhr.responseType === '' ? xhr.responseText : xhr.response;
	                    fireAjaxCallback('ajaxSuccess ajax:success', { xhr: xhr }, 'success', responseData, xhr.status, xhr);
	                }
	            }
	            else {
	                fireAjaxCallback('ajaxError ajax:error', { xhr: xhr }, 'error', xhr, xhr.status);
	            }
	            if (options.statusCode) {
	                if (globals.statusCode && globals.statusCode[xhr.status]) {
	                    globals.statusCode[xhr.status](xhr);
	                }
	                if (options.statusCode[xhr.status]) {
	                    options.statusCode[xhr.status](xhr);
	                }
	            }
	            fireAjaxCallback('ajaxComplete ajax:complete', { xhr: xhr }, 'complete', xhr, xhr.status);
	        };
	        xhr.onerror = function onerror(e) {
	            if (xhrTimeout) {
	                clearTimeout(xhrTimeout);
	            }
	            fireAjaxCallback('ajaxError ajax:error', { xhr: xhr }, 'error', xhr, xhr.status);
	            fireAjaxCallback('ajaxComplete ajax:complete', { xhr: xhr, error: true }, 'complete', xhr, 'error');
	        };
	        // Ajax start callback
	        fireAjaxCallback('ajaxStart ajax:start', { xhr: xhr }, 'start', xhr);
	        fireAjaxCallback(undefined, undefined, 'beforeSend', xhr);
	        // Timeout
	        if (options.timeout > 0) {
	            xhr.onabort = function onabort() {
	                if (xhrTimeout) {
	                    clearTimeout(xhrTimeout);
	                }
	            };
	            xhrTimeout = setTimeout(function () {
	                xhr.abort();
	                fireAjaxCallback('ajaxError ajax:error', { xhr: xhr, timeout: true }, 'error', xhr, 'timeout');
	                fireAjaxCallback('ajaxComplete ajax:complete', { xhr: xhr, timeout: true }, 'complete', xhr, 'timeout');
	            }, options.timeout);
	        }
	        // Send XHR
	        xhr.send(postData);
	        // Return XHR object
	        return xhr;
	    }
	    function ajaxShortcut(method) {
	        var args = [], len = arguments.length - 1;
	        while (len-- > 0)
	            args[len] = arguments[len + 1];
	        var url;
	        var data;
	        var success;
	        var error;
	        var dataType;
	        if (typeof args[1] === 'function') {
	            var assign;
	            (assign = args, url = assign[0], success = assign[1], error = assign[2], dataType = assign[3]);
	        }
	        else {
	            var assign$1;
	            (assign$1 = args, url = assign$1[0], data = assign$1[1], success = assign$1[2], error = assign$1[3], dataType = assign$1[4]);
	        }
	        [success, error].forEach(function (callback) {
	            if (typeof callback === 'string') {
	                dataType = callback;
	                if (callback === success) {
	                    success = undefined;
	                }
	                else {
	                    error = undefined;
	                }
	            }
	        });
	        dataType = dataType || (method === 'getJSON' ? 'json' : undefined);
	        return $.ajax({
	            url: url,
	            method: method === 'post' ? 'POST' : 'GET',
	            data: data,
	            success: success,
	            error: error,
	            dataType: dataType,
	        });
	    }
	    function get() {
	        var args = [], len = arguments.length;
	        while (len--)
	            args[len] = arguments[len];
	        args.unshift('get');
	        return ajaxShortcut.apply(this, args);
	    }
	    function post() {
	        var args = [], len = arguments.length;
	        while (len--)
	            args[len] = arguments[len];
	        args.unshift('post');
	        return ajaxShortcut.apply(this, args);
	    }
	    function getJSON() {
	        var args = [], len = arguments.length;
	        while (len--)
	            args[len] = arguments[len];
	        args.unshift('getJSON');
	        return ajaxShortcut.apply(this, args);
	    }
	    var Scroll = {
	        scrollTo: function scrollTo(left, top, duration, easing, callback) {
	            if (easing === void 0)
	                easing = 'swing';
	            if (arguments.length === 4 && typeof easing === 'function') {
	                callback = easing;
	                easing = undefined;
	            }
	            return this.each(function animate() {
	                var el = this;
	                var currentTop;
	                var currentLeft;
	                var maxTop;
	                var maxLeft;
	                var newTop;
	                var newLeft;
	                var scrollTop;
	                var scrollLeft;
	                var animateTop = top > 0 || top === 0;
	                var animateLeft = left > 0 || left === 0;
	                if (typeof easing === 'undefined') {
	                    easing = 'swing';
	                }
	                if (animateTop) {
	                    currentTop = el.scrollTop;
	                    if (!duration) {
	                        el.scrollTop = top;
	                    }
	                }
	                if (animateLeft) {
	                    currentLeft = el.scrollLeft;
	                    if (!duration) {
	                        el.scrollLeft = left;
	                    }
	                }
	                if (!duration) {
	                    return;
	                }
	                if (animateTop) {
	                    maxTop = el.scrollHeight - el.offsetHeight;
	                    newTop = Math.max(Math.min(top, maxTop), 0);
	                }
	                if (animateLeft) {
	                    maxLeft = el.scrollWidth - el.offsetWidth;
	                    newLeft = Math.max(Math.min(left, maxLeft), 0);
	                }
	                var startTime = null;
	                if (animateTop && newTop === currentTop) {
	                    animateTop = false;
	                }
	                if (animateLeft && newLeft === currentLeft) {
	                    animateLeft = false;
	                }
	                function render(time) {
	                    if (time === void 0)
	                        time = new Date().getTime();
	                    if (startTime === null) {
	                        startTime = time;
	                    }
	                    var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
	                    var easeProgress = easing === 'linear' ? progress : (0.5 - (Math.cos(progress * Math.PI) / 2));
	                    var done;
	                    if (animateTop) {
	                        scrollTop = currentTop + (easeProgress * (newTop - currentTop));
	                    }
	                    if (animateLeft) {
	                        scrollLeft = currentLeft + (easeProgress * (newLeft - currentLeft));
	                    }
	                    if (animateTop && newTop > currentTop && scrollTop >= newTop) {
	                        el.scrollTop = newTop;
	                        done = true;
	                    }
	                    if (animateTop && newTop < currentTop && scrollTop <= newTop) {
	                        el.scrollTop = newTop;
	                        done = true;
	                    }
	                    if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
	                        el.scrollLeft = newLeft;
	                        done = true;
	                    }
	                    if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
	                        el.scrollLeft = newLeft;
	                        done = true;
	                    }
	                    if (done) {
	                        if (callback) {
	                            callback();
	                        }
	                        return;
	                    }
	                    if (animateTop) {
	                        el.scrollTop = scrollTop;
	                    }
	                    if (animateLeft) {
	                        el.scrollLeft = scrollLeft;
	                    }
	                    Utils.requestAnimationFrame(render);
	                }
	                Utils.requestAnimationFrame(render);
	            });
	        },
	        scrollTop: function scrollTop(top, duration, easing, callback) {
	            if (arguments.length === 3 && typeof easing === 'function') {
	                callback = easing;
	                easing = undefined;
	            }
	            var dom = this;
	            if (typeof top === 'undefined') {
	                if (dom.length > 0) {
	                    return dom[0].scrollTop;
	                }
	                return null;
	            }
	            return dom.scrollTo(undefined, top, duration, easing, callback);
	        },
	        scrollLeft: function scrollLeft(left, duration, easing, callback) {
	            if (arguments.length === 3 && typeof easing === 'function') {
	                callback = easing;
	                easing = undefined;
	            }
	            var dom = this;
	            if (typeof left === 'undefined') {
	                if (dom.length > 0) {
	                    return dom[0].scrollLeft;
	                }
	                return null;
	            }
	            return dom.scrollTo(left, undefined, duration, easing, callback);
	        },
	    };
	    var Methods = {
	        // Classes and attributes
	        addClass: function addClass(className) {
	            var this$1 = this;
	            if (typeof className === 'undefined') {
	                return this;
	            }
	            var classes = className.split(' ');
	            for (var i = 0; i < classes.length; i += 1) {
	                for (var j = 0; j < this.length; j += 1) {
	                    if (typeof this$1[j].classList !== 'undefined') {
	                        this$1[j].classList.add(classes[i]);
	                    }
	                }
	            }
	            return this;
	        },
	        removeClass: function removeClass(className) {
	            var this$1 = this;
	            var classes = className.split(' ');
	            for (var i = 0; i < classes.length; i += 1) {
	                for (var j = 0; j < this.length; j += 1) {
	                    if (typeof this$1[j].classList !== 'undefined') {
	                        this$1[j].classList.remove(classes[i]);
	                    }
	                }
	            }
	            return this;
	        },
	        hasClass: function hasClass(className) {
	            if (!this[0]) {
	                return false;
	            }
	            return this[0].classList.contains(className);
	        },
	        toggleClass: function toggleClass(className) {
	            var this$1 = this;
	            var classes = className.split(' ');
	            for (var i = 0; i < classes.length; i += 1) {
	                for (var j = 0; j < this.length; j += 1) {
	                    if (typeof this$1[j].classList !== 'undefined') {
	                        this$1[j].classList.toggle(classes[i]);
	                    }
	                }
	            }
	            return this;
	        },
	        attr: function attr(attrs, value) {
	            var arguments$1 = arguments;
	            var this$1 = this;
	            if (arguments.length === 1 && typeof attrs === 'string') {
	                // Get attr
	                if (this[0]) {
	                    return this[0].getAttribute(attrs);
	                }
	                return undefined;
	            }
	            // Set attrs
	            for (var i = 0; i < this.length; i += 1) {
	                if (arguments$1.length === 2) {
	                    // String
	                    this$1[i].setAttribute(attrs, value);
	                }
	                else {
	                    // Object
	                    for (var attrName in attrs) {
	                        this$1[i][attrName] = attrs[attrName];
	                        this$1[i].setAttribute(attrName, attrs[attrName]);
	                    }
	                }
	            }
	            return this;
	        },
	        removeAttr: function removeAttr(attr) {
	            var this$1 = this;
	            for (var i = 0; i < this.length; i += 1) {
	                this$1[i].removeAttribute(attr);
	            }
	            return this;
	        },
	        prop: function prop(props, value) {
	            var arguments$1 = arguments;
	            var this$1 = this;
	            if (arguments.length === 1 && typeof props === 'string') {
	                // Get prop
	                if (this[0]) {
	                    return this[0][props];
	                }
	            }
	            else {
	                // Set props
	                for (var i = 0; i < this.length; i += 1) {
	                    if (arguments$1.length === 2) {
	                        // String
	                        this$1[i][props] = value;
	                    }
	                    else {
	                        // Object
	                        for (var propName in props) {
	                            this$1[i][propName] = props[propName];
	                        }
	                    }
	                }
	                return this;
	            }
	        },
	        data: function data(key, value) {
	            var this$1 = this;
	            var el;
	            if (typeof value === 'undefined') {
	                el = this[0];
	                // Get value
	                if (el) {
	                    if (el.dom7ElementDataStorage && (key in el.dom7ElementDataStorage)) {
	                        return el.dom7ElementDataStorage[key];
	                    }
	                    var dataKey = el.getAttribute(("data-" + key));
	                    if (dataKey) {
	                        return dataKey;
	                    }
	                    return undefined;
	                }
	                return undefined;
	            }
	            // Set value
	            for (var i = 0; i < this.length; i += 1) {
	                el = this$1[i];
	                if (!el.dom7ElementDataStorage) {
	                    el.dom7ElementDataStorage = {};
	                }
	                el.dom7ElementDataStorage[key] = value;
	            }
	            return this;
	        },
	        removeData: function removeData(key) {
	            var this$1 = this;
	            for (var i = 0; i < this.length; i += 1) {
	                var el = this$1[i];
	                if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
	                    el.dom7ElementDataStorage[key] = null;
	                    delete el.dom7ElementDataStorage[key];
	                }
	            }
	        },
	        dataset: function dataset() {
	            var el = this[0];
	            if (!el) {
	                return undefined;
	            }
	            var dataset = {};
	            if (el.dataset) {
	                for (var dataKey in el.dataset) {
	                    dataset[dataKey] = el.dataset[dataKey];
	                }
	            }
	            else {
	                for (var i = 0; i < el.attributes.length; i += 1) {
	                    var attr = el.attributes[i];
	                    if (attr.name.indexOf('data-') >= 0) {
	                        dataset[Utils.toCamelCase(attr.name.split('data-')[1])] = attr.value;
	                    }
	                }
	            }
	            for (var key in dataset) {
	                if (dataset[key] === 'false') {
	                    dataset[key] = false;
	                }
	                else if (dataset[key] === 'true') {
	                    dataset[key] = true;
	                }
	                else if (parseFloat(dataset[key]) === dataset[key] * 1) {
	                    dataset[key] *= 1;
	                }
	            }
	            return dataset;
	        },
	        val: function val(value) {
	            var this$1 = this;
	            if (typeof value === 'undefined') {
	                if (this[0]) {
	                    if (this[0].multiple && this[0].nodeName.toLowerCase() === 'select') {
	                        var values = [];
	                        for (var i = 0; i < this[0].selectedOptions.length; i += 1) {
	                            values.push(this$1[0].selectedOptions[i].value);
	                        }
	                        return values;
	                    }
	                    return this[0].value;
	                }
	                return undefined;
	            }
	            for (var i$1 = 0; i$1 < this.length; i$1 += 1) {
	                this$1[i$1].value = value;
	            }
	            return this;
	        },
	        // Transforms
	        transform: function transform(transform$1) {
	            var this$1 = this;
	            for (var i = 0; i < this.length; i += 1) {
	                var elStyle = this$1[i].style;
	                elStyle.webkitTransform = transform$1;
	                elStyle.transform = transform$1;
	            }
	            return this;
	        },
	        transition: function transition(duration) {
	            var this$1 = this;
	            if (typeof duration !== 'string') {
	                duration = duration + "ms";
	            }
	            for (var i = 0; i < this.length; i += 1) {
	                var elStyle = this$1[i].style;
	                elStyle.webkitTransitionDuration = duration;
	                elStyle.transitionDuration = duration;
	            }
	            return this;
	        },
	        // Events
	        on: function on() {
	            var this$1 = this;
	            var args = [], len = arguments.length;
	            while (len--)
	                args[len] = arguments[len];
	            var eventType = args[0];
	            var targetSelector;
	            var listener;
	            var capture = false;
	            if (typeof args[1] === 'function') {
	                targetSelector = false;
	                listener = args[1];
	                capture = args[2];
	            }
	            else {
	                targetSelector = args[1];
	                listener = args[2];
	                capture = args[3];
	            }
	            function handleLiveEvent(e) {
	                var target = e.target;
	                if (!target) {
	                    return;
	                }
	                var eventData = e.target.dom7EventData || [];
	                eventData.unshift(e);
	                if ($(target).is(targetSelector)) {
	                    listener.apply(target, eventData);
	                }
	                else {
	                    var parents = $(target).parents();
	                    for (var k = 0; k < parents.length; k += 1) {
	                        if ($(parents[k]).is(targetSelector)) {
	                            listener.apply(parents[k], eventData);
	                        }
	                    }
	                }
	            }
	            function handleEvent(e) {
	                var eventData = e && e.target ? e.target.dom7EventData || [] : [];
	                eventData.unshift(e);
	                listener.apply(this, eventData);
	            }
	            var events = eventType.split(' ');
	            var j;
	            for (var i = 0; i < this.length; i += 1) {
	                var el = this$1[i];
	                if (!targetSelector) {
	                    for (j = 0; j < events.length; j += 1) {
	                        if (!el.dom7Listeners) {
	                            el.dom7Listeners = [];
	                        }
	                        el.dom7Listeners.push({
	                            type: eventType,
	                            listener: listener,
	                            proxyListener: handleEvent,
	                        });
	                        el.addEventListener(events[j], handleEvent, capture);
	                    }
	                }
	                else {
	                    // Live events
	                    for (j = 0; j < events.length; j += 1) {
	                        if (!el.dom7LiveListeners) {
	                            el.dom7LiveListeners = [];
	                        }
	                        el.dom7LiveListeners.push({
	                            type: eventType,
	                            listener: listener,
	                            proxyListener: handleLiveEvent,
	                        });
	                        el.addEventListener(events[j], handleLiveEvent, capture);
	                    }
	                }
	            }
	            return this;
	        },
	        off: function off() {
	            var this$1 = this;
	            var args = [], len = arguments.length;
	            while (len--)
	                args[len] = arguments[len];
	            var eventType = args[0];
	            var targetSelector;
	            var listener;
	            var capture = false;
	            if (typeof args[1] === 'function') {
	                targetSelector = false;
	                listener = args[1];
	                capture = args[2];
	            }
	            else {
	                targetSelector = args[1];
	                listener = args[2];
	                capture = args[3];
	            }
	            var events = eventType.split(' ');
	            for (var i = 0; i < events.length; i += 1) {
	                for (var j = 0; j < this.length; j += 1) {
	                    var el = this$1[j];
	                    if (!targetSelector) {
	                        if (el.dom7Listeners) {
	                            for (var k = 0; k < el.dom7Listeners.length; k += 1) {
	                                if (listener) {
	                                    if (el.dom7Listeners[k].listener === listener) {
	                                        el.removeEventListener(events[i], el.dom7Listeners[k].proxyListener, capture);
	                                    }
	                                }
	                                else if (el.dom7Listeners[k].type === events[i]) {
	                                    el.removeEventListener(events[i], el.dom7Listeners[k].proxyListener, capture);
	                                }
	                            }
	                        }
	                    }
	                    else if (el.dom7LiveListeners) {
	                        for (var k$1 = 0; k$1 < el.dom7LiveListeners.length; k$1 += 1) {
	                            if (listener) {
	                                if (el.dom7LiveListeners[k$1].listener === listener) {
	                                    el.removeEventListener(events[i], el.dom7LiveListeners[k$1].proxyListener, capture);
	                                }
	                            }
	                            else if (el.dom7Listeners[k$1].type === events[i]) {
	                                el.removeEventListener(events[i], el.dom7LiveListeners[k$1].proxyListener, capture);
	                            }
	                        }
	                    }
	                }
	            }
	            return this;
	        },
	        once: function once(eventName, targetSelector, listener, capture) {
	            var dom = this;
	            if (typeof targetSelector === 'function') {
	                listener = arguments[1];
	                capture = arguments[2];
	                targetSelector = false;
	            }
	            function proxy(e) {
	                var eventData = e.target.dom7EventData || [];
	                listener.apply(this, eventData);
	                dom.off(eventName, targetSelector, proxy, capture);
	            }
	            return dom.on(eventName, targetSelector, proxy, capture);
	        },
	        trigger: function trigger() {
	            var this$1 = this;
	            var args = [], len = arguments.length;
	            while (len--)
	                args[len] = arguments[len];
	            var events = args[0].split(' ');
	            var eventData = args[1];
	            for (var i = 0; i < events.length; i += 1) {
	                for (var j = 0; j < this.length; j += 1) {
	                    var evt = (void 0);
	                    try {
	                        evt = new CustomEvent(events[i], { detail: eventData, bubbles: true, cancelable: true });
	                    }
	                    catch (e) {
	                        evt = document.createEvent('Event');
	                        evt.initEvent(events[i], true, true);
	                        evt.detail = eventData;
	                    }
	                    this$1[j].dom7EventData = args.filter(function (data, dataIndex) { return dataIndex > 0; });
	                    this$1[j].dispatchEvent(evt);
	                    this$1[j].dom7EventData = [];
	                    delete this$1[j].dom7EventData;
	                }
	            }
	            return this;
	        },
	        transitionEnd: function transitionEnd(callback) {
	            var events = ['webkitTransitionEnd', 'transitionend'];
	            var dom = this;
	            var i;
	            function fireCallBack(e) {
	                /* jshint validthis:true */
	                if (e.target !== this) {
	                    return;
	                }
	                callback.call(this, e);
	                for (i = 0; i < events.length; i += 1) {
	                    dom.off(events[i], fireCallBack);
	                }
	            }
	            if (callback) {
	                for (i = 0; i < events.length; i += 1) {
	                    dom.on(events[i], fireCallBack);
	                }
	            }
	            return this;
	        },
	        animationEnd: function animationEnd(callback) {
	            var events = ['webkitAnimationEnd', 'animationend'];
	            var dom = this;
	            var i;
	            function fireCallBack(e) {
	                callback(e);
	                for (i = 0; i < events.length; i += 1) {
	                    dom.off(events[i], fireCallBack);
	                }
	            }
	            if (callback) {
	                for (i = 0; i < events.length; i += 1) {
	                    dom.on(events[i], fireCallBack);
	                }
	            }
	            return this;
	        },
	        // Sizing/Styles
	        width: function width() {
	            if (this[0] === window) {
	                return window.innerWidth;
	            }
	            if (this.length > 0) {
	                return parseFloat(this.css('width'));
	            }
	            return null;
	        },
	        outerWidth: function outerWidth(includeMargins) {
	            if (this.length > 0) {
	                if (includeMargins) {
	                    var styles = this.styles();
	                    return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
	                }
	                return this[0].offsetWidth;
	            }
	            return null;
	        },
	        height: function height() {
	            if (this[0] === window) {
	                return window.innerHeight;
	            }
	            if (this.length > 0) {
	                return parseFloat(this.css('height'));
	            }
	            return null;
	        },
	        outerHeight: function outerHeight(includeMargins) {
	            if (this.length > 0) {
	                if (includeMargins) {
	                    var styles = this.styles();
	                    return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
	                }
	                return this[0].offsetHeight;
	            }
	            return null;
	        },
	        offset: function offset() {
	            if (this.length > 0) {
	                var el = this[0];
	                var box = el.getBoundingClientRect();
	                var body = document.body;
	                var clientTop = el.clientTop || body.clientTop || 0;
	                var clientLeft = el.clientLeft || body.clientLeft || 0;
	                var scrollTop = el === window ? window.scrollY : el.scrollTop;
	                var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
	                return {
	                    top: (box.top + scrollTop) - clientTop,
	                    left: (box.left + scrollLeft) - clientLeft,
	                };
	            }
	            return null;
	        },
	        hide: function hide() {
	            var this$1 = this;
	            for (var i = 0; i < this.length; i += 1) {
	                this$1[i].style.display = 'none';
	            }
	            return this;
	        },
	        show: function show() {
	            var this$1 = this;
	            for (var i = 0; i < this.length; i += 1) {
	                this$1[i].style.display = 'block';
	            }
	            return this;
	        },
	        styles: function styles() {
	            if (this[0]) {
	                return window.getComputedStyle(this[0], null);
	            }
	        },
	        css: function css(props, value) {
	            var this$1 = this;
	            var i;
	            if (arguments.length === 1) {
	                if (typeof props === 'string') {
	                    if (this[0]) {
	                        return window.getComputedStyle(this[0], null).getPropertyValue(props);
	                    }
	                }
	                else {
	                    for (i = 0; i < this.length; i += 1) {
	                        for (var prop in props) {
	                            this$1[i].style[prop] = props[prop];
	                        }
	                    }
	                    return this;
	                }
	            }
	            if (arguments.length === 2 && typeof props === 'string') {
	                for (i = 0; i < this.length; i += 1) {
	                    this$1[i].style[props] = value;
	                }
	                return this;
	            }
	            return this;
	        },
	        // Dom manipulation
	        // Iterate over the collection passing elements to `callback`
	        each: function each(callback) {
	            var this$1 = this;
	            // Don't bother continuing without a callback
	            if (!callback) {
	                return this;
	            }
	            // Iterate over the current collection
	            for (var i = 0; i < this.length; i += 1) {
	                // If the callback returns false
	                if (callback.call(this$1[i], i, this$1[i]) === false) {
	                    // End the loop early
	                    return this$1;
	                }
	            }
	            // Return `this` to allow chained DOM operations
	            return this;
	        },
	        filter: function filter(callback) {
	            var matchedItems = [];
	            var dom = this;
	            for (var i = 0; i < dom.length; i += 1) {
	                if (callback.call(dom[i], i, dom[i])) {
	                    matchedItems.push(dom[i]);
	                }
	            }
	            return new Dom7(matchedItems);
	        },
	        html: function html(html$1) {
	            var this$1 = this;
	            if (typeof html$1 === 'undefined') {
	                return this[0] ? this[0].innerHTML : undefined;
	            }
	            for (var i = 0; i < this.length; i += 1) {
	                this$1[i].innerHTML = html$1;
	            }
	            return this;
	        },
	        text: function text(text$1) {
	            var this$1 = this;
	            if (typeof text$1 === 'undefined') {
	                if (this[0]) {
	                    return this[0].textContent.trim();
	                }
	                return null;
	            }
	            for (var i = 0; i < this.length; i += 1) {
	                this$1[i].textContent = text$1;
	            }
	            return this;
	        },
	        is: function is(selector) {
	            var el = this[0];
	            var compareWith;
	            var i;
	            if (!el || typeof selector === 'undefined') {
	                return false;
	            }
	            if (typeof selector === 'string') {
	                if (el.matches) {
	                    return el.matches(selector);
	                }
	                else if (el.webkitMatchesSelector) {
	                    return el.webkitMatchesSelector(selector);
	                }
	                else if (el.msMatchesSelector) {
	                    return el.msMatchesSelector(selector);
	                }
	                compareWith = $(selector);
	                for (i = 0; i < compareWith.length; i += 1) {
	                    if (compareWith[i] === el) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	            else if (selector === document) {
	                return el === document;
	            }
	            else if (selector === window) {
	                return el === window;
	            }
	            if (selector.nodeType || selector instanceof Dom7) {
	                compareWith = selector.nodeType ? [selector] : selector;
	                for (i = 0; i < compareWith.length; i += 1) {
	                    if (compareWith[i] === el) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	            return false;
	        },
	        indexOf: function indexOf(el) {
	            var this$1 = this;
	            for (var i = 0; i < this.length; i += 1) {
	                if (this$1[i] === el) {
	                    return i;
	                }
	            }
	        },
	        index: function index() {
	            var child = this[0];
	            var i;
	            if (child) {
	                i = 0;
	                while ((child = child.previousSibling) !== null) {
	                    if (child.nodeType === 1) {
	                        i += 1;
	                    }
	                }
	                return i;
	            }
	        },
	        eq: function eq(index) {
	            if (typeof index === 'undefined') {
	                return this;
	            }
	            var length = this.length;
	            var returnIndex;
	            if (index > length - 1) {
	                return new Dom7([]);
	            }
	            if (index < 0) {
	                returnIndex = length + index;
	                if (returnIndex < 0) {
	                    return new Dom7([]);
	                }
	                return new Dom7([this[returnIndex]]);
	            }
	            return new Dom7([this[index]]);
	        },
	        append: function append() {
	            var this$1 = this;
	            var args = [], len = arguments.length;
	            while (len--)
	                args[len] = arguments[len];
	            var newChild;
	            for (var k = 0; k < args.length; k += 1) {
	                newChild = args[k];
	                for (var i = 0; i < this.length; i += 1) {
	                    if (typeof newChild === 'string') {
	                        var tempDiv = document.createElement('div');
	                        tempDiv.innerHTML = newChild;
	                        while (tempDiv.firstChild) {
	                            this$1[i].appendChild(tempDiv.firstChild);
	                        }
	                    }
	                    else if (newChild instanceof Dom7) {
	                        for (var j = 0; j < newChild.length; j += 1) {
	                            this$1[i].appendChild(newChild[j]);
	                        }
	                    }
	                    else {
	                        this$1[i].appendChild(newChild);
	                    }
	                }
	            }
	            return this;
	        },
	        appendTo: function appendTo(parent) {
	            $(parent).append(this);
	            return this;
	        },
	        prepend: function prepend(newChild) {
	            var this$1 = this;
	            var i;
	            var j;
	            for (i = 0; i < this.length; i += 1) {
	                if (typeof newChild === 'string') {
	                    var tempDiv = document.createElement('div');
	                    tempDiv.innerHTML = newChild;
	                    for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
	                        this$1[i].insertBefore(tempDiv.childNodes[j], this$1[i].childNodes[0]);
	                    }
	                }
	                else if (newChild instanceof Dom7) {
	                    for (j = 0; j < newChild.length; j += 1) {
	                        this$1[i].insertBefore(newChild[j], this$1[i].childNodes[0]);
	                    }
	                }
	                else {
	                    this$1[i].insertBefore(newChild, this$1[i].childNodes[0]);
	                }
	            }
	            return this;
	        },
	        prependTo: function prependTo(parent) {
	            $(parent).prepend(this);
	            return this;
	        },
	        insertBefore: function insertBefore(selector) {
	            var this$1 = this;
	            var before = $(selector);
	            for (var i = 0; i < this.length; i += 1) {
	                if (before.length === 1) {
	                    before[0].parentNode.insertBefore(this$1[i], before[0]);
	                }
	                else if (before.length > 1) {
	                    for (var j = 0; j < before.length; j += 1) {
	                        before[j].parentNode.insertBefore(this$1[i].cloneNode(true), before[j]);
	                    }
	                }
	            }
	        },
	        insertAfter: function insertAfter(selector) {
	            var this$1 = this;
	            var after = $(selector);
	            for (var i = 0; i < this.length; i += 1) {
	                if (after.length === 1) {
	                    after[0].parentNode.insertBefore(this$1[i], after[0].nextSibling);
	                }
	                else if (after.length > 1) {
	                    for (var j = 0; j < after.length; j += 1) {
	                        after[j].parentNode.insertBefore(this$1[i].cloneNode(true), after[j].nextSibling);
	                    }
	                }
	            }
	        },
	        next: function next(selector) {
	            if (this.length > 0) {
	                if (selector) {
	                    if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
	                        return new Dom7([this[0].nextElementSibling]);
	                    }
	                    return new Dom7([]);
	                }
	                if (this[0].nextElementSibling) {
	                    return new Dom7([this[0].nextElementSibling]);
	                }
	                return new Dom7([]);
	            }
	            return new Dom7([]);
	        },
	        nextAll: function nextAll(selector) {
	            var nextEls = [];
	            var el = this[0];
	            if (!el) {
	                return new Dom7([]);
	            }
	            while (el.nextElementSibling) {
	                var next = el.nextElementSibling;
	                if (selector) {
	                    if ($(next).is(selector)) {
	                        nextEls.push(next);
	                    }
	                }
	                else {
	                    nextEls.push(next);
	                }
	                el = next;
	            }
	            return new Dom7(nextEls);
	        },
	        prev: function prev(selector) {
	            if (this.length > 0) {
	                var el = this[0];
	                if (selector) {
	                    if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
	                        return new Dom7([el.previousElementSibling]);
	                    }
	                    return new Dom7([]);
	                }
	                if (el.previousElementSibling) {
	                    return new Dom7([el.previousElementSibling]);
	                }
	                return new Dom7([]);
	            }
	            return new Dom7([]);
	        },
	        prevAll: function prevAll(selector) {
	            var prevEls = [];
	            var el = this[0];
	            if (!el) {
	                return new Dom7([]);
	            }
	            while (el.previousElementSibling) {
	                var prev = el.previousElementSibling;
	                if (selector) {
	                    if ($(prev).is(selector)) {
	                        prevEls.push(prev);
	                    }
	                }
	                else {
	                    prevEls.push(prev);
	                }
	                el = prev;
	            }
	            return new Dom7(prevEls);
	        },
	        siblings: function siblings(selector) {
	            return this.nextAll(selector).add(this.prevAll(selector));
	        },
	        parent: function parent(selector) {
	            var this$1 = this;
	            var parents = [];
	            for (var i = 0; i < this.length; i += 1) {
	                if (this$1[i].parentNode !== null) {
	                    if (selector) {
	                        if ($(this$1[i].parentNode).is(selector)) {
	                            parents.push(this$1[i].parentNode);
	                        }
	                    }
	                    else {
	                        parents.push(this$1[i].parentNode);
	                    }
	                }
	            }
	            return $(Utils.unique(parents));
	        },
	        parents: function parents(selector) {
	            var this$1 = this;
	            var parents = [];
	            for (var i = 0; i < this.length; i += 1) {
	                var parent = this$1[i].parentNode;
	                while (parent) {
	                    if (selector) {
	                        if ($(parent).is(selector)) {
	                            parents.push(parent);
	                        }
	                    }
	                    else {
	                        parents.push(parent);
	                    }
	                    parent = parent.parentNode;
	                }
	            }
	            return $(Utils.unique(parents));
	        },
	        closest: function closest(selector) {
	            var closest = this;
	            if (typeof selector === 'undefined') {
	                return new Dom7([]);
	            }
	            if (!closest.is(selector)) {
	                closest = closest.parents(selector).eq(0);
	            }
	            return closest;
	        },
	        find: function find(selector) {
	            var this$1 = this;
	            var foundElements = [];
	            for (var i = 0; i < this.length; i += 1) {
	                var found = this$1[i].querySelectorAll(selector);
	                for (var j = 0; j < found.length; j += 1) {
	                    foundElements.push(found[j]);
	                }
	            }
	            return new Dom7(foundElements);
	        },
	        children: function children(selector) {
	            var this$1 = this;
	            var children = [];
	            for (var i = 0; i < this.length; i += 1) {
	                var childNodes = this$1[i].childNodes;
	                for (var j = 0; j < childNodes.length; j += 1) {
	                    if (!selector) {
	                        if (childNodes[j].nodeType === 1) {
	                            children.push(childNodes[j]);
	                        }
	                    }
	                    else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
	                        children.push(childNodes[j]);
	                    }
	                }
	            }
	            return new Dom7(Utils.unique(children));
	        },
	        remove: function remove() {
	            var this$1 = this;
	            for (var i = 0; i < this.length; i += 1) {
	                if (this$1[i].parentNode) {
	                    this$1[i].parentNode.removeChild(this$1[i]);
	                }
	            }
	            return this;
	        },
	        detach: function detach() {
	            return this.remove();
	        },
	        add: function add() {
	            var args = [], len = arguments.length;
	            while (len--)
	                args[len] = arguments[len];
	            var dom = this;
	            var i;
	            var j;
	            for (i = 0; i < args.length; i += 1) {
	                var toAdd = $(args[i]);
	                for (j = 0; j < toAdd.length; j += 1) {
	                    dom[dom.length] = toAdd[j];
	                    dom.length += 1;
	                }
	            }
	            return dom;
	        },
	        empty: function empty() {
	            var this$1 = this;
	            for (var i = 0; i < this.length; i += 1) {
	                var el = this$1[i];
	                if (el.nodeType === 1) {
	                    for (var j = 0; j < el.childNodes.length; j += 1) {
	                        if (el.childNodes[j].parentNode) {
	                            el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
	                        }
	                    }
	                    el.textContent = '';
	                }
	            }
	            return this;
	        },
	    };
	    // Shortcuts
	    var shortcuts = ('click blur focus focusin focusout keyup keydown keypress submit change mousedown mousemove mouseup mouseenter mouseleave mouseout mouseover touchstart touchend touchmove resize scroll').split(' ');
	    var notTrigger = ('resize scroll').split(' ');
	    function createMethod(name) {
	        Methods[name] = function eventShortcut(targetSelector, listener, capture) {
	            var this$1 = this;
	            if (typeof targetSelector === 'undefined') {
	                for (var i = 0; i < this.length; i += 1) {
	                    if (notTrigger.indexOf(name) < 0) {
	                        if (name in this$1[i]) {
	                            this$1[i][name]();
	                        }
	                        else {
	                            $(this$1[i]).trigger(name);
	                        }
	                    }
	                }
	                return this;
	            }
	            return this.on(name, targetSelector, listener, capture);
	        };
	    }
	    for (var i$1 = 0; i$1 < shortcuts.length; i$1 += 1) {
	        createMethod(shortcuts[i$1]);
	    }
	    function animate(initialProps, initialParams) {
	        var els = this;
	        var a = {
	            props: $.extend({}, initialProps),
	            params: $.extend({
	                duration: 300,
	                easing: 'swing',
	            }, initialParams),
	            elements: els,
	            animating: false,
	            que: [],
	            easingProgress: function easingProgress(easing, progress) {
	                if (easing === 'swing') {
	                    return 0.5 - (Math.cos(progress * Math.PI) / 2);
	                }
	                if (typeof easing === 'function') {
	                    return easing(progress);
	                }
	                return progress;
	            },
	            stop: function stop() {
	                if (a.frameId) {
	                    Utils.cancelAnimationFrame(a.frameId);
	                }
	                a.animating = false;
	                a.elements.each(function (index, el) {
	                    var element = el;
	                    delete element.dom7AnimateInstance;
	                });
	                a.que = [];
	            },
	            done: function done(complete) {
	                a.animating = false;
	                a.elements.each(function (index, el) {
	                    var element = el;
	                    delete element.dom7AnimateInstance;
	                });
	                if (complete) {
	                    complete(els);
	                }
	                if (a.que.length > 0) {
	                    var que = a.que.shift();
	                    a.animate(que[0], que[1]);
	                }
	            },
	            animate: function animate(props, params) {
	                if (a.animating) {
	                    a.que.push([props, params]);
	                    return a;
	                }
	                var elements = [];
	                // Define & Cache Initials & Units
	                a.elements.each(function (index, el) {
	                    var initialFullValue;
	                    var initialValue;
	                    var unit;
	                    var finalValue;
	                    var finalFullValue;
	                    if (!el.dom7AnimateInstance) {
	                        a.elements[index].dom7AnimateInstance = a;
	                    }
	                    elements[index] = {
	                        container: el,
	                    };
	                    Object.keys(props).forEach(function (prop) {
	                        initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
	                        initialValue = parseFloat(initialFullValue);
	                        unit = initialFullValue.replace(initialValue, '');
	                        finalValue = parseFloat(props[prop]);
	                        finalFullValue = props[prop] + unit;
	                        elements[index][prop] = {
	                            initialFullValue: initialFullValue,
	                            initialValue: initialValue,
	                            unit: unit,
	                            finalValue: finalValue,
	                            finalFullValue: finalFullValue,
	                            currentValue: initialValue,
	                        };
	                    });
	                });
	                var startTime = null;
	                var time;
	                var elementsDone = 0;
	                var propsDone = 0;
	                var done;
	                var began = false;
	                a.animating = true;
	                function render() {
	                    time = new Date().getTime();
	                    var progress;
	                    var easeProgress;
	                    // let el;
	                    if (!began) {
	                        began = true;
	                        if (params.begin) {
	                            params.begin(els);
	                        }
	                    }
	                    if (startTime === null) {
	                        startTime = time;
	                    }
	                    if (params.progress) {
	                        params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), ((startTime + params.duration) - time < 0 ? 0 : (startTime + params.duration) - time), startTime);
	                    }
	                    elements.forEach(function (element) {
	                        var el = element;
	                        if (done || el.done) {
	                            return;
	                        }
	                        Object.keys(props).forEach(function (prop) {
	                            if (done || el.done) {
	                                return;
	                            }
	                            progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
	                            easeProgress = a.easingProgress(params.easing, progress);
	                            var ref = el[prop];
	                            var initialValue = ref.initialValue;
	                            var finalValue = ref.finalValue;
	                            var unit = ref.unit;
	                            el[prop].currentValue = initialValue + (easeProgress * (finalValue - initialValue));
	                            var currentValue = el[prop].currentValue;
	                            if ((finalValue > initialValue && currentValue >= finalValue) ||
	                                (finalValue < initialValue && currentValue <= finalValue)) {
	                                el.container.style[prop] = finalValue + unit;
	                                propsDone += 1;
	                                if (propsDone === Object.keys(props).length) {
	                                    el.done = true;
	                                    elementsDone += 1;
	                                }
	                                if (elementsDone === elements.length) {
	                                    done = true;
	                                }
	                            }
	                            if (done) {
	                                a.done(params.complete);
	                                return;
	                            }
	                            el.container.style[prop] = currentValue + unit;
	                        });
	                    });
	                    if (done) {
	                        return;
	                    }
	                    // Then call
	                    a.frameId = Utils.requestAnimationFrame(render);
	                }
	                a.frameId = Utils.requestAnimationFrame(render);
	                return a;
	            },
	        };
	        if (a.elements.length === 0) {
	            return els;
	        }
	        var animateInstance;
	        for (var i = 0; i < a.elements.length; i += 1) {
	            if (a.elements[i].dom7AnimateInstance) {
	                animateInstance = a.elements[i].dom7AnimateInstance;
	            }
	            else {
	                a.elements[i].dom7AnimateInstance = a;
	            }
	        }
	        if (!animateInstance) {
	            animateInstance = a;
	        }
	        if (initialProps === 'stop') {
	            animateInstance.stop();
	        }
	        else {
	            animateInstance.animate(a.props, a.params);
	        }
	        return els;
	    }
	    function stop() {
	        var els = this;
	        for (var i = 0; i < els.length; i += 1) {
	            if (els[i].dom7AnimateInstance) {
	                els[i].dom7AnimateInstance.stop();
	            }
	        }
	    }
	    function dom7() {
	        // Utils & Helpers
	        Object.keys(Utils).forEach(function (key) {
	            $[key] = Utils[key];
	        });
	        // Methods
	        Object.keys(Methods).forEach(function (key) {
	            Dom7.prototype[key] = Methods[key];
	        });
	        // Scroll
	        Object.keys(Scroll).forEach(function (key) {
	            Dom7.prototype[key] = Scroll[key];
	        });
	        // Animate
	        Dom7.prototype.animate = animate;
	        Dom7.prototype.stop = stop;
	        // Ajax
	        $.ajax = ajax;
	        $.get = get;
	        $.post = post;
	        $.getJSON = getJSON;
	        // Link to prototype
	        $.fn = Dom7.prototype;
	        return $;
	    }
	    var dom7$1 = dom7();
	    return dom7$1;
	}());
	window.Template7 = module.exports.Template7 = (function () {
	    'use strict';
	    var template7Context;
	    if (typeof window !== 'undefined') {
	        template7Context = window;
	    }
	    else if (typeof global !== 'undefined') {
	        template7Context = global;
	    }
	    else {
	        template7Context = undefined;
	    }
	    function isArray(arr) {
	        return Array.isArray ? Array.isArray(arr) : Object.prototype.toString.apply(arr) === '[object Array]';
	    }
	    function isFunction(func) {
	        return typeof func === 'function';
	    }
	    function escape(string) {
	        return (typeof template7Context !== 'undefined' && template7Context.escape ? template7Context.escape(string) : string)
	            .replace(/&/g, '&amp;')
	            .replace(/</g, '&lt;')
	            .replace(/>/g, '&gt;')
	            .replace(/"/g, '&quot;');
	    }
	    var quoteSingleRexExp = new RegExp('\'', 'g');
	    var quoteDoubleRexExp = new RegExp('"', 'g');
	    function helperToSlices(string) {
	        var helperParts = string.replace(/[{}#}]/g, '').split(' ');
	        var slices = [];
	        var shiftIndex;
	        var i;
	        var j;
	        for (i = 0; i < helperParts.length; i += 1) {
	            var part = helperParts[i];
	            var blockQuoteRegExp = (void 0);
	            var openingQuote = (void 0);
	            if (i === 0) {
	                slices.push(part);
	            }
	            else if (part.indexOf('"') === 0 || part.indexOf('\'') === 0) {
	                blockQuoteRegExp = part.indexOf('"') === 0 ? quoteDoubleRexExp : quoteSingleRexExp;
	                openingQuote = part.indexOf('"') === 0 ? '"' : '\'';
	                // Plain String
	                if (part.match(blockQuoteRegExp).length === 2) {
	                    // One word string
	                    slices.push(part);
	                }
	                else {
	                    // Find closed Index
	                    shiftIndex = 0;
	                    for (j = i + 1; j < helperParts.length; j += 1) {
	                        part += " " + (helperParts[j]);
	                        if (helperParts[j].indexOf(openingQuote) >= 0) {
	                            shiftIndex = j;
	                            slices.push(part);
	                            break;
	                        }
	                    }
	                    if (shiftIndex) {
	                        i = shiftIndex;
	                    }
	                }
	            }
	            else if (part.indexOf('=') > 0) {
	                // Hash
	                var hashParts = part.split('=');
	                var hashName = hashParts[0];
	                var hashContent = hashParts[1];
	                if (!blockQuoteRegExp) {
	                    blockQuoteRegExp = hashContent.indexOf('"') === 0 ? quoteDoubleRexExp : quoteSingleRexExp;
	                    openingQuote = hashContent.indexOf('"') === 0 ? '"' : '\'';
	                }
	                if (hashContent.match(blockQuoteRegExp).length !== 2) {
	                    shiftIndex = 0;
	                    for (j = i + 1; j < helperParts.length; j += 1) {
	                        hashContent += " " + (helperParts[j]);
	                        if (helperParts[j].indexOf(openingQuote) >= 0) {
	                            shiftIndex = j;
	                            break;
	                        }
	                    }
	                    if (shiftIndex) {
	                        i = shiftIndex;
	                    }
	                }
	                var hash = [hashName, hashContent.replace(blockQuoteRegExp, '')];
	                slices.push(hash);
	            }
	            else {
	                // Plain variable
	                slices.push(part);
	            }
	        }
	        return slices;
	    }
	    function stringToBlocks(string) {
	        var blocks = [];
	        var i;
	        var j;
	        if (!string) {
	            return [];
	        }
	        var stringBlocks = string.split(/({{[^{^}]*}})/);
	        for (i = 0; i < stringBlocks.length; i += 1) {
	            var block = stringBlocks[i];
	            if (block === '') {
	                continue;
	            }
	            if (block.indexOf('{{') < 0) {
	                blocks.push({
	                    type: 'plain',
	                    content: block,
	                });
	            }
	            else {
	                if (block.indexOf('{/') >= 0) {
	                    continue;
	                }
	                if (block.indexOf('{#') < 0 && block.indexOf(' ') < 0 && block.indexOf('else') < 0) {
	                    // Simple variable
	                    blocks.push({
	                        type: 'variable',
	                        contextName: block.replace(/[{}]/g, ''),
	                    });
	                    continue;
	                }
	                // Helpers
	                var helperSlices = helperToSlices(block);
	                var helperName = helperSlices[0];
	                var isPartial = helperName === '>';
	                var helperContext = [];
	                var helperHash = {};
	                for (j = 1; j < helperSlices.length; j += 1) {
	                    var slice = helperSlices[j];
	                    if (isArray(slice)) {
	                        // Hash
	                        helperHash[slice[0]] = slice[1] === 'false' ? false : slice[1];
	                    }
	                    else {
	                        helperContext.push(slice);
	                    }
	                }
	                if (block.indexOf('{#') >= 0) {
	                    // Condition/Helper
	                    var helperContent = '';
	                    var elseContent = '';
	                    var toSkip = 0;
	                    var shiftIndex = (void 0);
	                    var foundClosed = false;
	                    var foundElse = false;
	                    var depth = 0;
	                    for (j = i + 1; j < stringBlocks.length; j += 1) {
	                        if (stringBlocks[j].indexOf('{{#') >= 0) {
	                            depth += 1;
	                        }
	                        if (stringBlocks[j].indexOf('{{/') >= 0) {
	                            depth -= 1;
	                        }
	                        if (stringBlocks[j].indexOf(("{{#" + helperName)) >= 0) {
	                            helperContent += stringBlocks[j];
	                            if (foundElse) {
	                                elseContent += stringBlocks[j];
	                            }
	                            toSkip += 1;
	                        }
	                        else if (stringBlocks[j].indexOf(("{{/" + helperName)) >= 0) {
	                            if (toSkip > 0) {
	                                toSkip -= 1;
	                                helperContent += stringBlocks[j];
	                                if (foundElse) {
	                                    elseContent += stringBlocks[j];
	                                }
	                            }
	                            else {
	                                shiftIndex = j;
	                                foundClosed = true;
	                                break;
	                            }
	                        }
	                        else if (stringBlocks[j].indexOf('else') >= 0 && depth === 0) {
	                            foundElse = true;
	                        }
	                        else {
	                            if (!foundElse) {
	                                helperContent += stringBlocks[j];
	                            }
	                            if (foundElse) {
	                                elseContent += stringBlocks[j];
	                            }
	                        }
	                    }
	                    if (foundClosed) {
	                        if (shiftIndex) {
	                            i = shiftIndex;
	                        }
	                        blocks.push({
	                            type: 'helper',
	                            helperName: helperName,
	                            contextName: helperContext,
	                            content: helperContent,
	                            inverseContent: elseContent,
	                            hash: helperHash,
	                        });
	                    }
	                }
	                else if (block.indexOf(' ') > 0) {
	                    if (isPartial) {
	                        helperName = '_partial';
	                        if (helperContext[0]) {
	                            helperContext[0] = "\"" + (helperContext[0].replace(/"|'/g, '')) + "\"";
	                        }
	                    }
	                    blocks.push({
	                        type: 'helper',
	                        helperName: helperName,
	                        contextName: helperContext,
	                        hash: helperHash,
	                    });
	                }
	            }
	        }
	        return blocks;
	    }
	    function parseJsVariable(expression, replace, object) {
	        return expression.split(/([+ -*/^])/g).map(function (part) {
	            if (part.indexOf(replace) < 0) {
	                return part;
	            }
	            if (!object) {
	                return JSON.stringify('');
	            }
	            var variable = object;
	            if (part.indexOf((replace + ".")) >= 0) {
	                part.split((replace + "."))[1].split('.').forEach(function (partName) {
	                    if (variable[partName]) {
	                        variable = variable[partName];
	                    }
	                    else {
	                        variable = 'undefined';
	                    }
	                });
	            }
	            return JSON.stringify(variable);
	        }).join('');
	    }
	    function parseJsParents(expression, parents) {
	        return expression.split(/([+ -*^])/g).map(function (part) {
	            if (part.indexOf('../') < 0) {
	                return part;
	            }
	            if (!parents || parents.length === 0) {
	                return JSON.stringify('');
	            }
	            var levelsUp = part.split('../').length - 1;
	            var parentData = levelsUp > parents.length ? parents[parents.length - 1] : parents[levelsUp - 1];
	            var variable = parentData;
	            var parentPart = part.replace(/..\//g, '');
	            parentPart.split('.').forEach(function (partName) {
	                if (variable[partName]) {
	                    variable = variable[partName];
	                }
	                else {
	                    variable = 'undefined';
	                }
	            });
	            return JSON.stringify(variable);
	        }).join('');
	    }
	    var Template7 = function Template7(template) {
	        var t = this;
	        t.template = template;
	        function getCompileVar(name, ctx, data) {
	            if (data === void 0)
	                data = 'data_1';
	            var variable = ctx;
	            var parts;
	            var levelsUp = 0;
	            var newDepth;
	            if (name.indexOf('../') === 0) {
	                levelsUp = name.split('../').length - 1;
	                newDepth = variable.split('_')[1] - levelsUp;
	                variable = "ctx_" + (newDepth >= 1 ? newDepth : 1);
	                parts = name.split('../')[levelsUp].split('.');
	            }
	            else if (name.indexOf('@global') === 0) {
	                variable = 'Template7.global';
	                parts = name.split('@global.')[1].split('.');
	            }
	            else if (name.indexOf('@root') === 0) {
	                variable = 'root';
	                parts = name.split('@root.')[1].split('.');
	            }
	            else {
	                parts = name.split('.');
	            }
	            for (var i = 0; i < parts.length; i += 1) {
	                var part = parts[i];
	                if (part.indexOf('@') === 0) {
	                    var dataLevel = data.split('_')[1];
	                    if (levelsUp > 0) {
	                        dataLevel = newDepth;
	                    }
	                    if (i > 0) {
	                        variable += "[(data_" + dataLevel + " && data_" + dataLevel + "." + (part.replace('@', '')) + ")]";
	                    }
	                    else {
	                        variable = "(data_" + dataLevel + " && data_" + dataLevel + "." + (part.replace('@', '')) + ")";
	                    }
	                }
	                else if (isFinite(part)) {
	                    variable += "[" + part + "]";
	                }
	                else if (part === 'this' || part.indexOf('this.') >= 0 || part.indexOf('this[') >= 0 || part.indexOf('this(') >= 0) {
	                    variable = part.replace('this', ctx);
	                }
	                else {
	                    variable += "." + part;
	                }
	            }
	            return variable;
	        }
	        function getCompiledArguments(contextArray, ctx, data) {
	            var arr = [];
	            for (var i = 0; i < contextArray.length; i += 1) {
	                if (/^['"]/.test(contextArray[i])) {
	                    arr.push(contextArray[i]);
	                }
	                else if (/^(true|false|\d+)$/.test(contextArray[i])) {
	                    arr.push(contextArray[i]);
	                }
	                else {
	                    arr.push(getCompileVar(contextArray[i], ctx, data));
	                }
	            }
	            return arr.join(', ');
	        }
	        function compile(template, depth) {
	            if (template === void 0)
	                template = t.template;
	            if (depth === void 0)
	                depth = 1;
	            if (typeof template !== 'string') {
	                throw new Error('Template7: Template must be a string');
	            }
	            var blocks = stringToBlocks(template);
	            var ctx = "ctx_" + depth;
	            var data = "data_" + depth;
	            if (blocks.length === 0) {
	                return function empty() { return ''; };
	            }
	            function getCompileFn(block, newDepth) {
	                if (block.content) {
	                    return compile(block.content, newDepth);
	                }
	                return function empty() { return ''; };
	            }
	            function getCompileInverse(block, newDepth) {
	                if (block.inverseContent) {
	                    return compile(block.inverseContent, newDepth);
	                }
	                return function empty() { return ''; };
	            }
	            var resultString = '';
	            if (depth === 1) {
	                resultString += "(function (" + ctx + ", " + data + ", root) {\n";
	            }
	            else {
	                resultString += "(function (" + ctx + ", " + data + ") {\n";
	            }
	            if (depth === 1) {
	                resultString += 'function isArray(arr){return Object.prototype.toString.apply(arr) === \'[object Array]\';}\n';
	                resultString += 'function isFunction(func){return (typeof func === \'function\');}\n';
	                resultString += 'function c(val, ctx) {if (typeof val !== "undefined" && val !== null) {if (isFunction(val)) {return val.call(ctx);} else return val;} else return "";}\n';
	                resultString += 'root = root || ctx_1 || {};\n';
	            }
	            resultString += 'var r = \'\';\n';
	            var i;
	            for (i = 0; i < blocks.length; i += 1) {
	                var block = blocks[i];
	                // Plain block
	                if (block.type === 'plain') {
	                    resultString += "r +='" + ((block.content).replace(/\r/g, '\\r').replace(/\n/g, '\\n').replace(/'/g, '\\' + '\'')) + "';";
	                    continue;
	                }
	                var variable = (void 0);
	                var compiledArguments = (void 0);
	                // Variable block
	                if (block.type === 'variable') {
	                    variable = getCompileVar(block.contextName, ctx, data);
	                    resultString += "r += c(" + variable + ", " + ctx + ");";
	                }
	                // Helpers block
	                if (block.type === 'helper') {
	                    var parents = (void 0);
	                    if (ctx !== 'ctx_1') {
	                        var level = ctx.split('_')[1];
	                        var parentsString = "ctx_" + (level - 1);
	                        for (var j = level - 2; j >= 1; j -= 1) {
	                            parentsString += ", ctx_" + j;
	                        }
	                        parents = "[" + parentsString + "]";
	                    }
	                    else {
	                        parents = "[" + ctx + "]";
	                    }
	                    if (block.helperName in t.helpers) {
	                        compiledArguments = getCompiledArguments(block.contextName, ctx, data);
	                        resultString += "r += (Template7.helpers." + (block.helperName) + ").call(" + ctx + ", " + (compiledArguments && ((compiledArguments + ", "))) + "{hash:" + (JSON.stringify(block.hash)) + ", data: " + data + " || {}, fn: " + (getCompileFn(block, depth + 1)) + ", inverse: " + (getCompileInverse(block, depth + 1)) + ", root: root, parents: " + parents + "});";
	                    }
	                    else if (block.contextName.length > 0) {
	                        throw new Error(("Template7: Missing helper: \"" + (block.helperName) + "\""));
	                    }
	                    else {
	                        variable = getCompileVar(block.helperName, ctx, data);
	                        resultString += "if (" + variable + ") {";
	                        resultString += "if (isArray(" + variable + ")) {";
	                        resultString += "r += (Template7.helpers.each).call(" + ctx + ", " + variable + ", {hash:" + (JSON.stringify(block.hash)) + ", data: " + data + " || {}, fn: " + (getCompileFn(block, depth + 1)) + ", inverse: " + (getCompileInverse(block, depth + 1)) + ", root: root, parents: " + parents + "});";
	                        resultString += '}else {';
	                        resultString += "r += (Template7.helpers.with).call(" + ctx + ", " + variable + ", {hash:" + (JSON.stringify(block.hash)) + ", data: " + data + " || {}, fn: " + (getCompileFn(block, depth + 1)) + ", inverse: " + (getCompileInverse(block, depth + 1)) + ", root: root, parents: " + parents + "});";
	                        resultString += '}}';
	                    }
	                }
	            }
	            resultString += '\nreturn r;})';
	            return eval.call(template7Context, resultString);
	        }
	        t.compile = function _compile(template) {
	            if (!t.compiled) {
	                t.compiled = compile(template);
	            }
	            return t.compiled;
	        };
	    };
	    Template7.prototype = {
	        options: {},
	        partials: {},
	        helpers: {
	            _partial: function _partial(partialName, options) {
	                var p = Template7.prototype.partials[partialName];
	                if (!p || (p && !p.template)) {
	                    return '';
	                }
	                if (!p.compiled) {
	                    p.compiled = new Template7(p.template).compile();
	                }
	                var ctx = this;
	                for (var hashName in options.hash) {
	                    ctx[hashName] = options.hash[hashName];
	                }
	                return p.compiled(ctx, options.data, options.root);
	            },
	            escape: function escape$1(context, options) {
	                if (typeof context !== 'string') {
	                    throw new Error('Template7: Passed context to "escape" helper should be a string');
	                }
	                return escape(context);
	            },
	            if: function if$1(context, options) {
	                var ctx = context;
	                if (isFunction(ctx)) {
	                    ctx = ctx.call(this);
	                }
	                if (ctx) {
	                    return options.fn(this, options.data);
	                }
	                return options.inverse(this, options.data);
	            },
	            unless: function unless(context, options) {
	                var ctx = context;
	                if (isFunction(ctx)) {
	                    ctx = ctx.call(this);
	                }
	                if (!ctx) {
	                    return options.fn(this, options.data);
	                }
	                return options.inverse(this, options.data);
	            },
	            each: function each(context, options) {
	                var ctx = context;
	                var ret = '';
	                var i = 0;
	                if (isFunction(ctx)) {
	                    ctx = ctx.call(this);
	                }
	                if (isArray(ctx)) {
	                    if (options.hash.reverse) {
	                        ctx = ctx.reverse();
	                    }
	                    for (i = 0; i < ctx.length; i += 1) {
	                        ret += options.fn(ctx[i], { first: i === 0, last: i === ctx.length - 1, index: i });
	                    }
	                    if (options.hash.reverse) {
	                        ctx = ctx.reverse();
	                    }
	                }
	                else {
	                    for (var key in ctx) {
	                        i += 1;
	                        ret += options.fn(ctx[key], { key: key });
	                    }
	                }
	                if (i > 0) {
	                    return ret;
	                }
	                return options.inverse(this);
	            },
	            with: function with$1(context, options) {
	                var ctx = context;
	                if (isFunction(ctx)) {
	                    ctx = context.call(this);
	                }
	                return options.fn(ctx);
	            },
	            join: function join(context, options) {
	                var ctx = context;
	                if (isFunction(ctx)) {
	                    ctx = ctx.call(this);
	                }
	                return ctx.join(options.hash.delimiter || options.hash.delimeter);
	            },
	            js: function js(expression, options) {
	                var data = options.data;
	                var func;
	                var execute = expression;
	                ('index first last key').split(' ').forEach(function (prop) {
	                    if (typeof data[prop] !== 'undefined') {
	                        var re1 = new RegExp(("this.@" + prop), 'g');
	                        var re2 = new RegExp(("@" + prop), 'g');
	                        execute = execute
	                            .replace(re1, JSON.stringify(data[prop]))
	                            .replace(re2, JSON.stringify(data[prop]));
	                    }
	                });
	                if (options.root && execute.indexOf('@root') >= 0) {
	                    execute = parseJsVariable(execute, '@root', options.root);
	                }
	                if (execute.indexOf('@global') >= 0) {
	                    execute = parseJsVariable(execute, '@global', template7Context.Template7.global);
	                }
	                if (execute.indexOf('../') >= 0) {
	                    execute = parseJsParents(execute, options.parents);
	                }
	                if (execute.indexOf('return') >= 0) {
	                    func = "(function(){" + execute + "})";
	                }
	                else {
	                    func = "(function(){return (" + execute + ")})";
	                }
	                return eval.call(this, func).call(this);
	            },
	            js_if: function js_if(expression, options) {
	                var data = options.data;
	                var func;
	                var execute = expression;
	                ('index first last key').split(' ').forEach(function (prop) {
	                    if (typeof data[prop] !== 'undefined') {
	                        var re1 = new RegExp(("this.@" + prop), 'g');
	                        var re2 = new RegExp(("@" + prop), 'g');
	                        execute = execute
	                            .replace(re1, JSON.stringify(data[prop]))
	                            .replace(re2, JSON.stringify(data[prop]));
	                    }
	                });
	                if (options.root && execute.indexOf('@root') >= 0) {
	                    execute = parseJsVariable(execute, '@root', options.root);
	                }
	                if (execute.indexOf('@global') >= 0) {
	                    execute = parseJsVariable(execute, '@global', Template7.global);
	                }
	                if (execute.indexOf('../') >= 0) {
	                    execute = parseJsParents(execute, options.parents);
	                }
	                if (execute.indexOf('return') >= 0) {
	                    func = "(function(){" + execute + "})";
	                }
	                else {
	                    func = "(function(){return (" + execute + ")})";
	                }
	                var condition = eval.call(this, func).call(this);
	                if (condition) {
	                    return options.fn(this, options.data);
	                }
	                return options.inverse(this, options.data);
	            },
	        },
	    };
	    Template7.prototype.helpers.js_compare = Template7.prototype.helpers.js_if;
	    function t7(template, data) {
	        if (arguments.length === 2) {
	            var instance = new Template7(template);
	            var rendered = instance.compile()(data);
	            instance = null;
	            return (rendered);
	        }
	        return new Template7(template);
	    }
	    t7.registerHelper = function registerHelper(name, fn) {
	        Template7.prototype.helpers[name] = fn;
	    };
	    t7.unregisterHelper = function unregisterHelper(name) {
	        Template7.prototype.helpers[name] = undefined;
	        delete Template7.prototype.helpers[name];
	    };
	    t7.registerPartial = function registerPartial(name, template) {
	        Template7.prototype.partials[name] = { template: template };
	    };
	    t7.unregisterPartial = function unregisterPartial(name) {
	        if (Template7.prototype.partials[name]) {
	            Template7.prototype.partials[name] = undefined;
	            delete Template7.prototype.partials[name];
	        }
	    };
	    t7.compile = function compile(template, options) {
	        var instance = new Template7(template, options);
	        return instance.compile();
	    };
	    t7.options = Template7.prototype.options;
	    t7.helpers = Template7.prototype.helpers;
	    t7.partials = Template7.prototype.partials;
	    return t7;
	}());
	(function () {
	    'use strict';
	    /*===========================
	    Framework 7
	    ===========================*/
	    window.Framework7 = module.exports.Framework7 = function (params) {
	        // App
	        var app = this;
	        // Version
	        app.version = '1.6.0';
	        // Default Parameters
	        app.params = {
	            //
	            root: 'body',
	            //
	            cache: true,
	            cacheIgnore: [],
	            cacheIgnoreGetParameters: false,
	            cacheDuration: 1000 * 60 * 10,
	            preloadPreviousPage: true,
	            uniqueHistory: false,
	            uniqueHistoryIgnoreGetParameters: false,
	            dynamicPageUrl: 'content-{{index}}',
	            allowDuplicateUrls: false,
	            router: true,
	            routerRemoveTimeout: false,
	            routerRemoveWithTimeout: false,
	            // Push State
	            pushState: false,
	            pushStateRoot: undefined,
	            pushStateNoAnimation: false,
	            pushStateSeparator: '#!/',
	            pushStateOnLoad: true,
	            // Fast clicks
	            fastClicks: true,
	            fastClicksDistanceThreshold: 10,
	            fastClicksDelayBetweenClicks: 50,
	            fastClicksExclude: '',
	            // Tap Hold
	            tapHold: false,
	            tapHoldDelay: 750,
	            tapHoldPreventClicks: true,
	            // Active State
	            activeState: true,
	            activeStateElements: 'a, button, label, span',
	            // Animate Nav Back Icon
	            animateNavBackIcon: false,
	            // Swipe Back
	            swipeBackPage: true,
	            swipeBackPageThreshold: 0,
	            swipeBackPageActiveArea: 30,
	            swipeBackPageAnimateShadow: true,
	            swipeBackPageAnimateOpacity: true,
	            // Ajax
	            ajaxLinks: undefined,
	            // External Links
	            externalLinks: '.external',
	            // Sortable
	            sortable: true,
	            // Scroll toolbars
	            hideNavbarOnPageScroll: false,
	            hideToolbarOnPageScroll: false,
	            hideTabbarOnPageScroll: false,
	            showBarsOnPageScrollEnd: true,
	            showBarsOnPageScrollTop: true,
	            // Swipeout
	            swipeout: true,
	            swipeoutActionsNoFold: false,
	            swipeoutNoFollow: false,
	            swipeoutRemoveWithTimeout: false,
	            // Smart Select Back link template
	            smartSelectOpenIn: 'page',
	            smartSelectBackText: 'Back',
	            smartSelectPopupCloseText: 'Close',
	            smartSelectPickerCloseText: 'Done',
	            smartSelectSearchbar: false,
	            smartSelectBackOnSelect: false,
	            // Tap Navbar or Statusbar to scroll to top
	            scrollTopOnNavbarClick: false,
	            scrollTopOnStatusbarClick: false,
	            // Panels
	            panelLeftBreakpoint: null,
	            panelRightBreakpoint: null,
	            swipePanel: false,
	            swipePanelActiveArea: 0,
	            swipePanelCloseOpposite: true,
	            swipePanelOnlyClose: false,
	            swipePanelNoFollow: false,
	            swipePanelThreshold: 0,
	            panelsCloseByOutside: true,
	            // Modals
	            modalButtonOk: 'OK',
	            modalButtonCancel: 'Cancel',
	            modalUsernamePlaceholder: 'Username',
	            modalPasswordPlaceholder: 'Password',
	            modalTitle: 'Framework7',
	            modalCloseByOutside: false,
	            actionsCloseByOutside: true,
	            popupCloseByOutside: true,
	            popoverCloseByOutside: true,
	            modalPreloaderTitle: 'Loading... ',
	            modalStack: true,
	            modalsMoveToRoot: true,
	            // Lazy Load
	            imagesLazyLoadThreshold: 0,
	            imagesLazyLoadSequential: true,
	            // Name space
	            viewClass: 'view',
	            viewMainClass: 'view-main',
	            viewsClass: 'views',
	            // Notifications defaults
	            notificationCloseOnClick: false,
	            notificationCloseIcon: true,
	            notificationCloseButtonText: 'Close',
	            // Animate Pages
	            animatePages: true,
	            // Template7
	            templates: {},
	            template7Data: {},
	            template7Pages: false,
	            precompileTemplates: false,
	            // Material
	            material: false,
	            materialPageLoadDelay: 0,
	            materialPreloaderSvg: '<svg xmlns="http://www.w3.org/2000/svg" height="75" width="75" viewbox="0 0 75 75"><circle cx="37.5" cy="37.5" r="33.5" stroke-width="8"/></svg>',
	            materialPreloaderHtml: '<span class="preloader-inner">' +
	                '<span class="preloader-inner-gap"></span>' +
	                '<span class="preloader-inner-left">' +
	                '<span class="preloader-inner-half-circle"></span>' +
	                '</span>' +
	                '<span class="preloader-inner-right">' +
	                '<span class="preloader-inner-half-circle"></span>' +
	                '</span>' +
	                '</span>',
	            materialRipple: true,
	            materialRippleElements: '.ripple, a.link, a.item-link, .button, .modal-button, .tab-link, .label-radio, .label-checkbox, .actions-modal-button, a.searchbar-clear, a.floating-button, .floating-button > a, .speed-dial-buttons a, .form-checkbox, .form-radio, .data-table .sortable-cell',
	            // Auto init
	            init: true,
	        };
	        // Extend defaults with parameters
	        for (var param in params) {
	            app.params[param] = params[param];
	        }
	        // DOM lib
	        var $ = Dom7;
	        // Template7 lib
	        var t7 = Template7;
	        app._compiledTemplates = {};
	        // App Root
	        app.root = $(app.params.root);
	        app.root.eq(0).addClass('framework7-root');
	        // Touch events
	        app.touchEvents = {
	            start: app.support.touch ? 'touchstart' : 'mousedown',
	            move: app.support.touch ? 'touchmove' : 'mousemove',
	            end: app.support.touch ? 'touchend' : 'mouseup'
	        };
	        // Link to local storage
	        app.ls = window.localStorage;
	        // RTL
	        app.rtl = $('body').css('direction') === 'rtl';
	        if (app.rtl)
	            $('html').attr('dir', 'rtl');
	        // Overwrite statusbar overlay
	        if (typeof app.params.statusbarOverlay !== 'undefined') {
	            if (app.params.statusbarOverlay)
	                $('html').addClass('with-statusbar-overlay');
	            else
	                $('html').removeClass('with-statusbar-overlay');
	        }
	        else if (app.device.ios && (window.cordova || window.phonegap)) {
	            $(document).on('resume', function () {
	                if (app.device.needsStatusBar()) {
	                    $('html').addClass('with-statusbar-overlay');
	                }
	            }, false);
	        }
	        /*======================================================
	        ************   Views   ************
	        ======================================================*/
	        app.views = [];
	        var View = function (selector, params) {
	            var defaults = {
	                dynamicNavbar: false,
	                domCache: false,
	                linksView: undefined,
	                reloadPages: false,
	                uniqueHistory: app.params.uniqueHistory,
	                uniqueHistoryIgnoreGetParameters: app.params.uniqueHistoryIgnoreGetParameters,
	                allowDuplicateUrls: app.params.allowDuplicateUrls,
	                swipeBackPage: app.params.swipeBackPage,
	                swipeBackPageAnimateShadow: app.params.swipeBackPageAnimateShadow,
	                swipeBackPageAnimateOpacity: app.params.swipeBackPageAnimateOpacity,
	                swipeBackPageActiveArea: app.params.swipeBackPageActiveArea,
	                swipeBackPageThreshold: app.params.swipeBackPageThreshold,
	                animatePages: app.params.animatePages,
	                preloadPreviousPage: app.params.preloadPreviousPage
	            };
	            var i;
	            // Params
	            params = params || {};
	            // Disable dynamic navbar for material theme
	            if (params.dynamicNavbar && app.params.material)
	                params.dynamicNavbar = false;
	            // Extend params with defaults
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            // View
	            var view = this;
	            view.params = params;
	            // Selector
	            view.selector = selector;
	            // Container
	            var container = $(selector);
	            view.container = container[0];
	            // Fix Selector
	            if (typeof selector !== 'string') {
	                // Supposed to be HTMLElement or Dom7
	                selector = (container.attr('id') ? '#' + container.attr('id') : '') + (container.attr('class') ? '.' + container.attr('class').replace(/ /g, '.').replace('.active', '') : '');
	                view.selector = selector;
	            }
	            // Is main
	            view.main = container.hasClass(app.params.viewMainClass);
	            // Content cache
	            view.contentCache = {};
	            // Context cache
	            view.contextCache = {};
	            // Pages cache
	            view.pagesCache = {};
	            view.pageElementsCache = {};
	            // Store View in element for easy access
	            container[0].f7View = view;
	            // Pages
	            view.pagesContainer = container.find('.pages')[0];
	            view.initialPages = [];
	            view.initialPagesUrl = [];
	            view.initialNavbars = [];
	            if (view.params.domCache) {
	                var initialPages = container.find('.page');
	                for (i = 0; i < initialPages.length; i++) {
	                    view.initialPages.push(initialPages[i]);
	                    view.initialPagesUrl.push('#' + initialPages.eq(i).attr('data-page'));
	                }
	                if (view.params.dynamicNavbar) {
	                    var initialNavbars = container.find('.navbar-inner');
	                    for (i = 0; i < initialNavbars.length; i++) {
	                        view.initialNavbars.push(initialNavbars[i]);
	                    }
	                }
	            }
	            view.allowPageChange = true;
	            // Location
	            var docLocation = document.location.href;
	            // History
	            view.history = [];
	            var viewURL = docLocation;
	            var pushStateSeparator = app.params.pushStateSeparator;
	            var pushStateRoot = app.params.pushStateRoot;
	            if (app.params.pushState && view.main) {
	                if (pushStateRoot) {
	                    viewURL = pushStateRoot;
	                }
	                else {
	                    if (pushStateSeparator && viewURL.indexOf(pushStateSeparator) >= 0 && viewURL.indexOf(pushStateSeparator + '#') < 0)
	                        viewURL = viewURL.split(pushStateSeparator)[0];
	                }
	            }
	            // Active Page
	            var currentPage, currentPageData;
	            if (!view.activePage) {
	                currentPage = $(view.pagesContainer).find('.page-on-center');
	                if (currentPage.length === 0) {
	                    currentPage = $(view.pagesContainer).find('.page:not(.cached)');
	                    currentPage = currentPage.eq(currentPage.length - 1);
	                }
	                if (currentPage.length > 0) {
	                    currentPageData = currentPage[0].f7PageData;
	                }
	            }
	            // View startup URL
	            if (view.params.domCache && currentPage) {
	                view.url = container.attr('data-url') || view.params.url || '#' + currentPage.attr('data-page');
	                view.pagesCache[view.url] = currentPage.attr('data-page');
	            }
	            else
	                view.url = container.attr('data-url') || view.params.url || viewURL;
	            // Update current page Data
	            if (currentPageData) {
	                currentPageData.view = view;
	                currentPageData.url = view.url;
	                if (view.params.domCache && view.params.dynamicNavbar && !currentPageData.navbarInnerContainer) {
	                    currentPageData.navbarInnerContainer = view.initialNavbars[view.initialPages.indexOf(currentPageData.container)];
	                }
	                view.activePage = currentPageData;
	                currentPage[0].f7PageData = currentPageData;
	            }
	            // Store to history main view's url
	            if (view.url) {
	                view.history.push(view.url);
	            }
	            // Touch events
	            var isTouched = false, isMoved = false, touchesStart = {}, isScrolling, activePage = [], previousPage = [], viewContainerWidth, touchesDiff, allowViewTouchMove = true, touchStartTime, activeNavbar = [], previousNavbar = [], activeNavElements, previousNavElements, activeNavBackIcon, previousNavBackIcon, dynamicNavbar, pageShadow, pageOpacity, el;
	            view.handleTouchStart = function (e) {
	                if (!allowViewTouchMove || !view.params.swipeBackPage || isTouched || app.swipeoutOpenedEl || !view.allowPageChange)
	                    return;
	                isMoved = false;
	                isTouched = true;
	                isScrolling = undefined;
	                touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                touchStartTime = (new Date()).getTime();
	                dynamicNavbar = view.params.dynamicNavbar && container.find('.navbar-inner').length > 1;
	            };
	            view.handleTouchMove = function (e) {
	                if (!isTouched)
	                    return;
	                var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (typeof isScrolling === 'undefined') {
	                    isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	                }
	                if (isScrolling || e.f7PreventSwipeBack || app.preventSwipeBack) {
	                    isTouched = false;
	                    return;
	                }
	                if (!isMoved) {
	                    var cancel = false;
	                    // Calc values during first move fired
	                    viewContainerWidth = container.width();
	                    var target = $(e.target);
	                    var swipeout = target.hasClass('swipeout') ? target : target.parents('.swipeout');
	                    if (swipeout.length > 0) {
	                        if (!app.rtl && swipeout.find('.swipeout-actions-left').length > 0)
	                            cancel = true;
	                        if (app.rtl && swipeout.find('.swipeout-actions-right').length > 0)
	                            cancel = true;
	                    }
	                    activePage = target.is('.page') ? target : target.parents('.page');
	                    if (activePage.hasClass('no-swipeback'))
	                        cancel = true;
	                    previousPage = container.find('.page-on-left:not(.cached)');
	                    var notFromBorder = touchesStart.x - container.offset().left > view.params.swipeBackPageActiveArea;
	                    if (app.rtl) {
	                        notFromBorder = touchesStart.x < container.offset().left - container[0].scrollLeft + viewContainerWidth - view.params.swipeBackPageActiveArea;
	                    }
	                    else {
	                        notFromBorder = touchesStart.x - container.offset().left > view.params.swipeBackPageActiveArea;
	                    }
	                    if (notFromBorder)
	                        cancel = true;
	                    if (previousPage.length === 0 || activePage.length === 0)
	                        cancel = true;
	                    if (cancel) {
	                        isTouched = false;
	                        return;
	                    }
	                    if (view.params.swipeBackPageAnimateShadow && !app.device.android) {
	                        pageShadow = activePage.find('.swipeback-page-shadow');
	                        if (pageShadow.length === 0) {
	                            pageShadow = $('<div class="swipeback-page-shadow"></div>');
	                            activePage.append(pageShadow);
	                        }
	                    }
	                    if (view.params.swipeBackPageAnimateOpacity) {
	                        pageOpacity = previousPage.find('.swipeback-page-opacity');
	                        if (pageOpacity.length === 0) {
	                            pageOpacity = $('<div class="swipeback-page-opacity"></div>');
	                            previousPage.append(pageOpacity);
	                        }
	                    }
	                    if (dynamicNavbar) {
	                        activeNavbar = container.find('.navbar-on-center:not(.cached)');
	                        previousNavbar = container.find('.navbar-on-left:not(.cached)');
	                        activeNavElements = activeNavbar.find('.left, .center, .right, .subnavbar, .fading');
	                        previousNavElements = previousNavbar.find('.left, .center, .right, .subnavbar, .fading');
	                        if (app.params.animateNavBackIcon) {
	                            activeNavBackIcon = activeNavbar.find('.left.sliding .back .icon');
	                            previousNavBackIcon = previousNavbar.find('.left.sliding .back .icon');
	                        }
	                    }
	                    // Close/Hide Any Picker
	                    if ($('.picker-modal.modal-in').length > 0) {
	                        app.closeModal($('.picker-modal.modal-in'));
	                    }
	                }
	                e.f7PreventPanelSwipe = true;
	                isMoved = true;
	                e.preventDefault();
	                // RTL inverter
	                var inverter = app.rtl ? -1 : 1;
	                // Touches diff
	                touchesDiff = (pageX - touchesStart.x - view.params.swipeBackPageThreshold) * inverter;
	                if (touchesDiff < 0)
	                    touchesDiff = 0;
	                var percentage = touchesDiff / viewContainerWidth;
	                // Swipe Back Callback
	                var callbackData = {
	                    percentage: percentage,
	                    activePage: activePage[0],
	                    previousPage: previousPage[0],
	                    activeNavbar: activeNavbar[0],
	                    previousNavbar: previousNavbar[0]
	                };
	                if (view.params.onSwipeBackMove) {
	                    view.params.onSwipeBackMove(callbackData);
	                }
	                container.trigger('swipeBackMove swipeback:move', callbackData);
	                // Transform pages
	                var activePageTranslate = touchesDiff * inverter;
	                var previousPageTranslate = (touchesDiff / 5 - viewContainerWidth / 5) * inverter;
	                if (app.device.pixelRatio === 1) {
	                    activePageTranslate = Math.round(activePageTranslate);
	                    previousPageTranslate = Math.round(previousPageTranslate);
	                }
	                activePage.transform('translate3d(' + activePageTranslate + 'px,0,0)');
	                if (view.params.swipeBackPageAnimateShadow && !app.device.android)
	                    pageShadow[0].style.opacity = 1 - 1 * percentage;
	                previousPage.transform('translate3d(' + previousPageTranslate + 'px,0,0)');
	                if (view.params.swipeBackPageAnimateOpacity)
	                    pageOpacity[0].style.opacity = 1 - 1 * percentage;
	                // Dynamic Navbars Animation
	                if (dynamicNavbar) {
	                    var i;
	                    for (i = 0; i < activeNavElements.length; i++) {
	                        el = $(activeNavElements[i]);
	                        if (!el.is('.subnavbar.sliding'))
	                            el[0].style.opacity = (1 - percentage * 1.3);
	                        if (el[0].className.indexOf('sliding') >= 0) {
	                            var activeNavTranslate = percentage * el[0].f7NavbarRightOffset;
	                            if (app.device.pixelRatio === 1)
	                                activeNavTranslate = Math.round(activeNavTranslate);
	                            el.transform('translate3d(' + activeNavTranslate + 'px,0,0)');
	                            if (app.params.animateNavBackIcon) {
	                                if (el[0].className.indexOf('left') >= 0 && activeNavBackIcon.length > 0) {
	                                    activeNavBackIcon.transform('translate3d(' + -activeNavTranslate + 'px,0,0)');
	                                }
	                            }
	                        }
	                    }
	                    for (i = 0; i < previousNavElements.length; i++) {
	                        el = $(previousNavElements[i]);
	                        if (!el.is('.subnavbar.sliding'))
	                            el[0].style.opacity = percentage * 1.3 - 0.3;
	                        if (el[0].className.indexOf('sliding') >= 0) {
	                            var previousNavTranslate = el[0].f7NavbarLeftOffset * (1 - percentage);
	                            if (app.device.pixelRatio === 1)
	                                previousNavTranslate = Math.round(previousNavTranslate);
	                            el.transform('translate3d(' + previousNavTranslate + 'px,0,0)');
	                            if (app.params.animateNavBackIcon) {
	                                if (el[0].className.indexOf('left') >= 0 && previousNavBackIcon.length > 0) {
	                                    previousNavBackIcon.transform('translate3d(' + -previousNavTranslate + 'px,0,0)');
	                                }
	                            }
	                        }
	                    }
	                }
	            };
	            view.handleTouchEnd = function (e) {
	                if (!isTouched || !isMoved) {
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                isTouched = false;
	                isMoved = false;
	                if (touchesDiff === 0) {
	                    $([activePage[0], previousPage[0]]).transform('');
	                    if (dynamicNavbar) {
	                        activeNavElements.transform('').css({ opacity: '' });
	                        previousNavElements.transform('').css({ opacity: '' });
	                        if (activeNavBackIcon && activeNavBackIcon.length > 0)
	                            activeNavBackIcon.transform('');
	                        if (previousNavBackIcon && activeNavBackIcon.length > 0)
	                            previousNavBackIcon.transform('');
	                    }
	                    return;
	                }
	                var timeDiff = (new Date()).getTime() - touchStartTime;
	                var pageChanged = false;
	                // Swipe back to previous page
	                if (timeDiff < 300 && touchesDiff > 10 ||
	                    timeDiff >= 300 && touchesDiff > viewContainerWidth / 2) {
	                    activePage.removeClass('page-on-center').addClass('page-on-right');
	                    previousPage.removeClass('page-on-left').addClass('page-on-center');
	                    if (dynamicNavbar) {
	                        activeNavbar.removeClass('navbar-on-center').addClass('navbar-on-right');
	                        previousNavbar.removeClass('navbar-on-left').addClass('navbar-on-center');
	                    }
	                    pageChanged = true;
	                }
	                // Reset custom styles
	                // Add transitioning class for transition-duration
	                $([activePage[0], previousPage[0]]).transform('').addClass('page-transitioning');
	                if (dynamicNavbar) {
	                    activeNavElements.css({ opacity: '' })
	                        .each(function () {
	                        var translate = pageChanged ? this.f7NavbarRightOffset : 0;
	                        var sliding = $(this);
	                        sliding.transform('translate3d(' + translate + 'px,0,0)');
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('left') && activeNavBackIcon.length > 0) {
	                                activeNavBackIcon.addClass('page-transitioning').transform('translate3d(' + -translate + 'px,0,0)');
	                            }
	                        }
	                    }).addClass('page-transitioning');
	                    previousNavElements.transform('').css({ opacity: '' }).each(function () {
	                        var translate = pageChanged ? 0 : this.f7NavbarLeftOffset;
	                        var sliding = $(this);
	                        sliding.transform('translate3d(' + translate + 'px,0,0)');
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('left') && previousNavBackIcon.length > 0) {
	                                previousNavBackIcon.addClass('page-transitioning').transform('translate3d(' + -translate + 'px,0,0)');
	                            }
	                        }
	                    }).addClass('page-transitioning');
	                }
	                allowViewTouchMove = false;
	                view.allowPageChange = false;
	                // Swipe Back Callback
	                var callbackData = {
	                    activePage: activePage[0],
	                    previousPage: previousPage[0],
	                    activeNavbar: activeNavbar[0],
	                    previousNavbar: previousNavbar[0]
	                };
	                if (pageChanged) {
	                    // Update View's URL
	                    var url = view.history[view.history.length - 2];
	                    view.url = url;
	                    // Page before animation callback
	                    app.pageBackCallback('before', view, { pageContainer: activePage[0], url: url, position: 'center', newPage: previousPage, oldPage: activePage, swipeBack: true });
	                    app.pageAnimCallback('before', view, { pageContainer: previousPage[0], url: url, position: 'left', newPage: previousPage, oldPage: activePage, swipeBack: true });
	                    if (view.params.onSwipeBackBeforeChange) {
	                        view.params.onSwipeBackBeforeChange(callbackData);
	                    }
	                    container.trigger('swipeBackBeforeChange swipeback:beforechange', callbackData);
	                }
	                else {
	                    if (view.params.onSwipeBackBeforeReset) {
	                        view.params.onSwipeBackBeforeReset(callbackData);
	                    }
	                    container.trigger('swipeBackBeforeReset swipeback:beforereset', callbackData);
	                }
	                activePage.transitionEnd(function () {
	                    $([activePage[0], previousPage[0]]).removeClass('page-transitioning');
	                    if (dynamicNavbar) {
	                        activeNavElements.removeClass('page-transitioning').css({ opacity: '' });
	                        previousNavElements.removeClass('page-transitioning').css({ opacity: '' });
	                        if (activeNavBackIcon && activeNavBackIcon.length > 0)
	                            activeNavBackIcon.removeClass('page-transitioning');
	                        if (previousNavBackIcon && previousNavBackIcon.length > 0)
	                            previousNavBackIcon.removeClass('page-transitioning');
	                    }
	                    allowViewTouchMove = true;
	                    view.allowPageChange = true;
	                    if (pageChanged) {
	                        if (app.params.pushState && view.main)
	                            history.back();
	                        // Page after animation callback
	                        app.pageBackCallback('after', view, { pageContainer: activePage[0], url: url, position: 'center', newPage: previousPage, oldPage: activePage, swipeBack: true });
	                        app.pageAnimCallback('after', view, { pageContainer: previousPage[0], url: url, position: 'left', newPage: previousPage, oldPage: activePage, swipeBack: true });
	                        app.router.afterBack(view, activePage, previousPage);
	                        if (view.params.onSwipeBackAfterChange) {
	                            view.params.onSwipeBackAfterChange(callbackData);
	                        }
	                        container.trigger('swipeBackAfterChange swipeback:afterchange', callbackData);
	                    }
	                    else {
	                        if (view.params.onSwipeBackAfterReset) {
	                            view.params.onSwipeBackAfterReset(callbackData);
	                        }
	                        container.trigger('swipeBackAfterReset swipeback:afterreset', callbackData);
	                    }
	                    if (pageShadow && pageShadow.length > 0)
	                        pageShadow.remove();
	                    if (pageOpacity && pageOpacity.length > 0)
	                        pageOpacity.remove();
	                });
	            };
	            view.attachEvents = function (detach) {
	                var action = detach ? 'off' : 'on';
	                var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? { passive: true, capture: false } : false;
	                var activeListener = app.support.passiveListener ? { passive: false, capture: false } : false;
	                container[action](app.touchEvents.start, view.handleTouchStart, passiveListener);
	                container[action](app.touchEvents.move, view.handleTouchMove, activeListener);
	                container[action](app.touchEvents.end, view.handleTouchEnd, passiveListener);
	            };
	            view.detachEvents = function () {
	                view.attachEvents(true);
	            };
	            // Init
	            if (view.params.swipeBackPage && !app.params.material) {
	                view.attachEvents();
	            }
	            // Check view name to delete unwanted characters
	            if (view.params.name)
	                view.params.name = view.params.name.replace(/[^a-zA-Z]/g, '');
	            // Add view to app
	            app.views.push(view);
	            if (view.main) {
	                app.mainView = view;
	                app.views.main = view;
	            }
	            else if (view.params.name) {
	                app[view.params.name + 'View'] = view;
	                app.views[view.params.name] = view;
	            }
	            // Router
	            view.router = {
	                load: function (options) {
	                    return app.router.load(view, options);
	                },
	                back: function (options) {
	                    return app.router.back(view, options);
	                },
	                // Shortcuts
	                loadPage: function (options) {
	                    options = options || {};
	                    if (typeof options === 'string') {
	                        var url = options;
	                        options = {};
	                        if (url && url.indexOf('#') === 0 && view.params.domCache) {
	                            options.pageName = url.split('#')[1];
	                        }
	                        else
	                            options.url = url;
	                    }
	                    return app.router.load(view, options);
	                },
	                loadContent: function (content) {
	                    return app.router.load(view, { content: content });
	                },
	                reloadPage: function (url) {
	                    return app.router.load(view, { url: url, reload: true });
	                },
	                reloadContent: function (content) {
	                    return app.router.load(view, { content: content, reload: true });
	                },
	                reloadPreviousPage: function (url) {
	                    return app.router.load(view, { url: url, reloadPrevious: true, reload: true });
	                },
	                reloadPreviousContent: function (content) {
	                    return app.router.load(view, { content: content, reloadPrevious: true, reload: true });
	                },
	                refreshPage: function () {
	                    var options = {
	                        url: view.url,
	                        reload: true,
	                        ignoreCache: true
	                    };
	                    if (options.url && options.url.indexOf('#') === 0) {
	                        if (view.params.domCache && view.pagesCache[options.url]) {
	                            options.pageName = view.pagesCache[options.url];
	                            options.url = undefined;
	                            delete options.url;
	                        }
	                        else if (view.contentCache[options.url]) {
	                            options.content = view.contentCache[options.url];
	                            options.url = undefined;
	                            delete options.url;
	                        }
	                    }
	                    return app.router.load(view, options);
	                },
	                refreshPreviousPage: function () {
	                    var options = {
	                        url: view.history[view.history.length - 2],
	                        reload: true,
	                        reloadPrevious: true,
	                        ignoreCache: true
	                    };
	                    if (options.url && options.url.indexOf('#') === 0 && view.params.domCache && view.pagesCache[options.url]) {
	                        options.pageName = view.pagesCache[options.url];
	                        options.url = undefined;
	                        delete options.url;
	                    }
	                    return app.router.load(view, options);
	                }
	            };
	            // Aliases for temporary backward compatibility
	            view.loadPage = view.router.loadPage;
	            view.loadContent = view.router.loadContent;
	            view.reloadPage = view.router.reloadPage;
	            view.reloadContent = view.router.reloadContent;
	            view.reloadPreviousPage = view.router.reloadPreviousPage;
	            view.reloadPreviousContent = view.router.reloadPreviousContent;
	            view.refreshPage = view.router.refreshPage;
	            view.refreshPreviousPage = view.router.refreshPreviousPage;
	            view.back = view.router.back;
	            // Bars methods
	            view.hideNavbar = function (animated) {
	                return app.hideNavbar(container.find('.navbar'), animated);
	            };
	            view.showNavbar = function (animated) {
	                return app.showNavbar(container.find('.navbar'), animated);
	            };
	            view.hideToolbar = function (animated) {
	                return app.hideToolbar(container.find('.toolbar'), animated);
	            };
	            view.showToolbar = function (animated) {
	                return app.showToolbar(container.find('.toolbar'), animated);
	            };
	            // Push State on load
	            if (app.params.pushState && app.params.pushStateOnLoad && view.main) {
	                var pushStateUrl;
	                var pushStateUrlSplit = docLocation.split(pushStateSeparator)[1];
	                if (pushStateRoot) {
	                    pushStateUrl = docLocation.split(app.params.pushStateRoot + pushStateSeparator)[1];
	                }
	                else if (pushStateSeparator && docLocation.indexOf(pushStateSeparator) >= 0 && docLocation.indexOf(pushStateSeparator + '#') < 0) {
	                    pushStateUrl = pushStateUrlSplit;
	                }
	                var pushStateAnimatePages = app.params.pushStateNoAnimation ? false : undefined;
	                var historyState = history.state;
	                if (pushStateUrl) {
	                    if (pushStateUrl.indexOf('#') >= 0 && view.params.domCache && historyState && historyState.pageName && 'viewIndex' in historyState) {
	                        app.router.load(view, { pageName: historyState.pageName, url: historyState.url, animatePages: pushStateAnimatePages, pushState: false });
	                    }
	                    else if (pushStateUrl.indexOf('#') >= 0 && view.params.domCache && view.initialPagesUrl.indexOf(pushStateUrl) >= 0) {
	                        app.router.load(view, { pageName: pushStateUrl.replace('#', ''), animatePages: pushStateAnimatePages, pushState: false });
	                    }
	                    else
	                        app.router.load(view, { url: pushStateUrl, animatePages: pushStateAnimatePages, pushState: false });
	                }
	                else if (view.params.domCache && docLocation.indexOf(pushStateSeparator + '#') >= 0) {
	                    if (historyState && historyState.pageName && 'viewIndex' in historyState) {
	                        app.router.load(view, { pageName: historyState.pageName, url: historyState.url, animatePages: pushStateAnimatePages, pushState: false });
	                    }
	                    else if (pushStateSeparator && pushStateUrlSplit.indexOf('#') === 0) {
	                        if (view.initialPagesUrl.indexOf(pushStateUrlSplit)) {
	                            app.router.load(view, { pageName: pushStateUrlSplit.replace('#', ''), animatePages: pushStateAnimatePages, pushState: false });
	                        }
	                    }
	                }
	            }
	            // Destroy
	            view.destroy = function () {
	                view.detachEvents();
	                if (view.main) {
	                    app.mainView = null;
	                    delete app.mainView;
	                    app.views.main = null;
	                    delete app.views.main;
	                }
	                else if (view.params.name) {
	                    app[view.params.name + 'View'] = null;
	                    delete app[view.params.name + 'View'];
	                    app.views[view.params.name] = null;
	                    delete app.views[view.params.name];
	                }
	                container.removeAttr('data-page');
	                container[0].f7View = null;
	                delete container[0].f7View;
	                app.views.splice(app.views.indexOf(view), 1);
	                // Delete props & methods
	                for (var prop in view) {
	                    if (view.hasOwnProperty(prop)) {
	                        view[prop] = null;
	                        delete view[prop];
	                    }
	                }
	                view = null;
	            };
	            // Plugin hook
	            app.pluginHook('addView', view);
	            // Return view
	            return view;
	        };
	        app.addView = function (selector, params) {
	            return new View(selector, params);
	        };
	        app.getCurrentView = function (index) {
	            var popoverView = $('.popover.modal-in .view');
	            var popupView = $('.popup.modal-in .view');
	            var panelView = $('.panel.active .view');
	            var appViews = $('.views');
	            // Find active view as tab
	            var appView = appViews.children('.view');
	            // Propably in tabs or split view
	            if (appView.length > 1) {
	                if (appView.hasClass('tab')) {
	                    // Tabs
	                    appView = appViews.children('.view.active');
	                }
	                else {
	                    // Split View, leave appView intact
	                }
	            }
	            if (popoverView.length > 0 && popoverView[0].f7View)
	                return popoverView[0].f7View;
	            if (popupView.length > 0 && popupView[0].f7View)
	                return popupView[0].f7View;
	            if (panelView.length > 0 && panelView[0].f7View)
	                return panelView[0].f7View;
	            if (appView.length > 0) {
	                if (appView.length === 1 && appView[0].f7View)
	                    return appView[0].f7View;
	                if (appView.length > 1) {
	                    var currentViews = [];
	                    for (var i = 0; i < appView.length; i++) {
	                        if (appView[i].f7View)
	                            currentViews.push(appView[i].f7View);
	                    }
	                    if (currentViews.length > 0 && typeof index !== 'undefined')
	                        return currentViews[index];
	                    if (currentViews.length > 1)
	                        return currentViews;
	                    if (currentViews.length === 1)
	                        return currentViews[0];
	                    return undefined;
	                }
	            }
	            return undefined;
	        };
	        /*======================================================
	        ************   Navbars && Toolbars   ************
	        ======================================================*/
	        // On Navbar Init Callback
	        app.navbarInitCallback = function (view, pageContainer, navbarContainer, navbarInnerContainer) {
	            if (!navbarContainer && navbarInnerContainer)
	                navbarContainer = $(navbarInnerContainer).parent('.navbar')[0];
	            if (!navbarInnerContainer || navbarInnerContainer.f7NavbarInitialized && view && !view.params.domCache)
	                return;
	            var navbarData = {
	                container: navbarContainer,
	                innerContainer: navbarInnerContainer
	            };
	            var pageData = pageContainer && pageContainer.f7PageData;
	            var eventData = {
	                page: pageData,
	                navbar: navbarData
	            };
	            if (navbarInnerContainer.f7NavbarInitialized && ((view && view.params.domCache) || (!view && $(navbarContainer).parents('.popup, .popover, .login-screen, .modal, .actions-modal, .picker-modal').length > 0))) {
	                // Reinit Navbar
	                app.reinitNavbar(navbarContainer, navbarInnerContainer);
	                // Plugin hook
	                app.pluginHook('navbarReinit', eventData);
	                // Event
	                $(navbarInnerContainer).trigger('navbarReinit navbar:reinit', eventData);
	                return;
	            }
	            navbarInnerContainer.f7NavbarInitialized = true;
	            // Before Init
	            app.pluginHook('navbarBeforeInit', navbarData, pageData);
	            $(navbarInnerContainer).trigger('navbarBeforeInit navbar:beforeinit', eventData);
	            // Initialize Navbar
	            app.initNavbar(navbarContainer, navbarInnerContainer);
	            // On init
	            app.pluginHook('navbarInit', navbarData, pageData);
	            $(navbarInnerContainer).trigger('navbarInit navbar:init', eventData);
	        };
	        // Navbar Remove Callback
	        app.navbarRemoveCallback = function (view, pageContainer, navbarContainer, navbarInnerContainer) {
	            if (!navbarContainer && navbarInnerContainer)
	                navbarContainer = $(navbarInnerContainer).parent('.navbar')[0];
	            var navbarData = {
	                container: navbarContainer,
	                innerContainer: navbarInnerContainer
	            };
	            var pageData;
	            if (pageContainer) {
	                pageData = pageContainer.f7PageData;
	            }
	            var eventData = {
	                page: pageData,
	                navbar: navbarData
	            };
	            app.pluginHook('navbarBeforeRemove', navbarData, pageData);
	            $(navbarInnerContainer).trigger('navbarBeforeRemove navbar:beforeremove', eventData);
	            navbarData = null;
	            pageData = null;
	        };
	        app.initNavbar = function (navbarContainer, navbarInnerContainer) {
	            // Init Subnavbar Searchbar
	            if (app.initSearchbar)
	                app.initSearchbar(navbarInnerContainer);
	        };
	        app.reinitNavbar = function (navbarContainer, navbarInnerContainer) {
	            // Re init navbar methods
	        };
	        app.initNavbarWithCallback = function (navbarContainer) {
	            navbarContainer = $(navbarContainer);
	            var viewContainer = navbarContainer.parents('.' + app.params.viewClass);
	            var view;
	            if (viewContainer.length === 0)
	                return;
	            if (navbarContainer.parents('.navbar-through').length === 0 && viewContainer.find('.navbar-through').length === 0)
	                return;
	            view = viewContainer[0].f7View || undefined;
	            navbarContainer.find('.navbar-inner').each(function () {
	                var navbarInnerContainer = this;
	                var pageContainer;
	                if ($(navbarInnerContainer).attr('data-page')) {
	                    // For dom cache
	                    pageContainer = viewContainer.find('.page[data-page="' + $(navbarInnerContainer).attr('data-page') + '"]')[0];
	                }
	                if (!pageContainer) {
	                    var pages = viewContainer.find('.page');
	                    if (pages.length === 1) {
	                        pageContainer = pages[0];
	                    }
	                    else {
	                        viewContainer.find('.page').each(function () {
	                            if (this.f7PageData && this.f7PageData.navbarInnerContainer === navbarInnerContainer) {
	                                pageContainer = this;
	                            }
	                        });
	                    }
	                }
	                app.navbarInitCallback(view, pageContainer, navbarContainer[0], navbarInnerContainer);
	            });
	        };
	        // Size Navbars
	        app.sizeNavbars = function (viewContainer) {
	            if (app.params.material)
	                return;
	            var navbarInner = viewContainer ? $(viewContainer).find('.navbar .navbar-inner:not(.cached)') : $('.navbar .navbar-inner:not(.cached)');
	            navbarInner.each(function () {
	                var n = $(this);
	                if (n.hasClass('cached'))
	                    return;
	                var left = app.rtl ? n.find('.right') : n.find('.left'), right = app.rtl ? n.find('.left') : n.find('.right'), center = n.find('.center'), subnavbar = n.find('.subnavbar'), noLeft = left.length === 0, noRight = right.length === 0, leftWidth = noLeft ? 0 : left.outerWidth(true), rightWidth = noRight ? 0 : right.outerWidth(true), centerWidth = center.outerWidth(true), navbarStyles = n.styles(), navbarWidth = n[0].offsetWidth - parseInt(navbarStyles.paddingLeft, 10) - parseInt(navbarStyles.paddingRight, 10), onLeft = n.hasClass('navbar-on-left'), currLeft, diff;
	                if (noRight) {
	                    currLeft = navbarWidth - centerWidth;
	                }
	                if (noLeft) {
	                    currLeft = 0;
	                }
	                if (!noLeft && !noRight) {
	                    currLeft = (navbarWidth - rightWidth - centerWidth + leftWidth) / 2;
	                }
	                var requiredLeft = (navbarWidth - centerWidth) / 2;
	                if (navbarWidth - leftWidth - rightWidth > centerWidth) {
	                    if (requiredLeft < leftWidth) {
	                        requiredLeft = leftWidth;
	                    }
	                    if (requiredLeft + centerWidth > navbarWidth - rightWidth) {
	                        requiredLeft = navbarWidth - rightWidth - centerWidth;
	                    }
	                    diff = requiredLeft - currLeft;
	                }
	                else {
	                    diff = 0;
	                }
	                // RTL inverter
	                var inverter = app.rtl ? -1 : 1;
	                if (center.hasClass('sliding')) {
	                    center[0].f7NavbarLeftOffset = -(currLeft + diff) * inverter;
	                    center[0].f7NavbarRightOffset = (navbarWidth - currLeft - diff - centerWidth) * inverter;
	                    if (onLeft) {
	                        if (app.params.animateNavBackIcon) {
	                            var activeNavbarBackLink = n.parent().find('.navbar-on-center').find('.left.sliding .back .icon ~ span');
	                            if (activeNavbarBackLink.length > 0) {
	                                center[0].f7NavbarLeftOffset += activeNavbarBackLink[0].offsetLeft;
	                            }
	                        }
	                        center.transform('translate3d(' + center[0].f7NavbarLeftOffset + 'px, 0, 0)');
	                    }
	                }
	                if (!noLeft && left.hasClass('sliding')) {
	                    if (app.rtl) {
	                        left[0].f7NavbarLeftOffset = -(navbarWidth - left[0].offsetWidth) / 2 * inverter;
	                        left[0].f7NavbarRightOffset = leftWidth * inverter;
	                    }
	                    else {
	                        left[0].f7NavbarLeftOffset = -leftWidth;
	                        left[0].f7NavbarRightOffset = (navbarWidth - left[0].offsetWidth) / 2;
	                        if (app.params.animateNavBackIcon && left.find('.back .icon').length > 0) {
	                            left[0].f7NavbarRightOffset -= left.find('.back .icon')[0].offsetWidth;
	                        }
	                    }
	                    if (onLeft)
	                        left.transform('translate3d(' + left[0].f7NavbarLeftOffset + 'px, 0, 0)');
	                }
	                if (!noRight && right.hasClass('sliding')) {
	                    if (app.rtl) {
	                        right[0].f7NavbarLeftOffset = -rightWidth * inverter;
	                        right[0].f7NavbarRightOffset = (navbarWidth - right[0].offsetWidth) / 2 * inverter;
	                    }
	                    else {
	                        right[0].f7NavbarLeftOffset = -(navbarWidth - right[0].offsetWidth) / 2;
	                        right[0].f7NavbarRightOffset = rightWidth;
	                    }
	                    if (onLeft)
	                        right.transform('translate3d(' + right[0].f7NavbarLeftOffset + 'px, 0, 0)');
	                }
	                if (subnavbar.length && subnavbar.hasClass('sliding')) {
	                    subnavbar[0].f7NavbarLeftOffset = app.rtl ? subnavbar[0].offsetWidth : -subnavbar[0].offsetWidth;
	                    subnavbar[0].f7NavbarRightOffset = -subnavbar[0].f7NavbarLeftOffset;
	                }
	                // Center left
	                var centerLeft = diff;
	                if (app.rtl && noLeft && noRight && center.length > 0)
	                    centerLeft = -centerLeft;
	                center.css({ left: centerLeft + 'px' });
	            });
	        };
	        // Hide/Show Navbars/Toolbars
	        app.hideNavbar = function (navbarContainer, animated) {
	            if (typeof animated === 'undefined')
	                animated = true;
	            $(navbarContainer).addClass('navbar-hidden' + (!animated ? (' not-animated') : ''));
	            return true;
	        };
	        app.showNavbar = function (navbarContainer, animated) {
	            if (typeof animated === 'undefined')
	                animated = true;
	            var navbar = $(navbarContainer);
	            if (animated) {
	                navbar.removeClass('not-animated');
	                navbar.addClass('navbar-hiding').removeClass('navbar-hidden').transitionEnd(function () {
	                    navbar.removeClass('navbar-hiding');
	                });
	            }
	            else {
	                navbar.removeClass('navbar-hidden navbar-hiding not-animated');
	            }
	            return true;
	        };
	        app.hideToolbar = function (toolbarContainer, animated) {
	            if (typeof animated === 'undefined')
	                animated = true;
	            $(toolbarContainer).addClass('toolbar-hidden' + (!animated ? (' not-animated') : ''));
	            return true;
	        };
	        app.showToolbar = function (toolbarContainer, animated) {
	            if (typeof animated === 'undefined')
	                animated = true;
	            var toolbar = $(toolbarContainer);
	            if (animated) {
	                toolbar.removeClass('not-animated');
	                toolbar.addClass('toolbar-hiding').removeClass('toolbar-hidden').transitionEnd(function () {
	                    toolbar.removeClass('toolbar-hiding' + (!animated ? (' not-animated') : ''));
	                });
	            }
	            else {
	                toolbar.removeClass('toolbar-hidden toolbar-hiding not-animated');
	            }
	        };
	        /*======================================================
	        ************   Searchbar   ************
	        ======================================================*/
	        var Searchbar = function (container, params) {
	            var defaults = {
	                input: null,
	                clearButton: null,
	                cancelButton: null,
	                searchList: null,
	                searchIn: '.item-title',
	                searchBy: '',
	                found: null,
	                notFound: null,
	                overlay: null,
	                ignore: '.searchbar-ignore',
	                customSearch: false,
	                removeDiacritics: false,
	                hideDividers: true,
	                hideGroups: true,
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined' || params[def] === null && defaults.hasOwnProperty(def)) {
	                    params[def] = defaults[def];
	                }
	            }
	            // Instance
	            var s = this;
	            // Material
	            s.material = app.params.material;
	            // Params
	            s.params = params;
	            // Container
	            container = $(container);
	            s.container = container;
	            // Active
	            s.active = false;
	            // Input
	            s.input = s.params.input ? $(s.params.input) : s.container.find('input[type="search"]');
	            s.clearButton = s.params.clearButton ? $(s.params.clearButton) : s.container.find('.searchbar-clear');
	            s.cancelButton = s.params.cancelButton ? $(s.params.cancelButton) : s.container.find('.searchbar-cancel');
	            // Search List
	            s.searchList = $(s.params.searchList);
	            // Is Virtual List
	            s.isVirtualList = s.searchList.hasClass('virtual-list');
	            // Is In Page
	            s.pageContainer = s.container.parents('.page').eq(0);
	            // Overlay
	            if (!s.params.overlay) {
	                s.overlay = s.pageContainer.length > 0 ? s.pageContainer.find('.searchbar-overlay') : $('.searchbar-overlay');
	            }
	            else {
	                s.overlay = $(s.params.overlay);
	            }
	            // Found and not found
	            if (!s.params.found) {
	                s.found = s.pageContainer.length > 0 ? s.pageContainer.find('.searchbar-found') : $('.searchbar-found');
	            }
	            else {
	                s.found = $(s.params.found);
	            }
	            if (!s.params.notFound) {
	                s.notFound = s.pageContainer.length > 0 ? s.pageContainer.find('.searchbar-not-found') : $('.searchbar-not-found');
	            }
	            else {
	                s.notFound = $(s.params.notFound);
	            }
	            // Set Cancel button
	            var cancelMarginProp = app.rtl ? 'margin-left' : 'margin-right';
	            var cancelButtonHasMargin = false;
	            s.setCancelButtonMargin = function () {
	                s.cancelButton.transition(0).show();
	                s.cancelButton.css(cancelMarginProp, -s.cancelButton[0].offsetWidth + 'px');
	                var clientLeft = s.cancelButton[0].clientLeft;
	                s.cancelButton.transition('');
	                cancelButtonHasMargin = true;
	            };
	            // Trigger
	            s.triggerEvent = function (eventName, callbackName, eventData) {
	                s.container.trigger(eventName, eventData);
	                if (s.searchList.length > 0)
	                    s.searchList.trigger(eventName, eventData);
	                if (callbackName && s.params[callbackName])
	                    s.params[callbackName](s, eventData);
	            };
	            // Enable/disalbe
	            s.enable = function (e) {
	                function _enable() {
	                    if ((s.searchList.length || s.params.customSearch) && !s.container.hasClass('searchbar-active') && !s.query)
	                        s.overlay.addClass('searchbar-overlay-active');
	                    s.container.addClass('searchbar-active');
	                    if (s.cancelButton.length > 0 && !s.material) {
	                        if (!cancelButtonHasMargin) {
	                            s.setCancelButtonMargin();
	                        }
	                        s.cancelButton.css(cancelMarginProp, '0px');
	                    }
	                    s.triggerEvent('enableSearch searchbar:enable', 'onEnable');
	                    s.active = true;
	                }
	                if (app.device.ios && !app.params.material && e && e.type === 'focus') {
	                    setTimeout(function () {
	                        _enable();
	                    }, 400);
	                }
	                else {
	                    _enable();
	                }
	            };
	            s.disable = function () {
	                s.input.val('').trigger('change');
	                s.container.removeClass('searchbar-active searchbar-not-empty');
	                if (s.cancelButton.length > 0 && !s.material)
	                    s.cancelButton.css(cancelMarginProp, -s.cancelButton[0].offsetWidth + 'px');
	                if (s.searchList.length || s.params.customSearch)
	                    s.overlay.removeClass('searchbar-overlay-active');
	                s.active = false;
	                function _disable() {
	                    s.input.blur();
	                }
	                if (app.device.ios) {
	                    setTimeout(function () {
	                        _disable();
	                    }, 400);
	                }
	                else {
	                    _disable();
	                }
	                s.triggerEvent('disableSearch searchbar:disable', 'onDisable');
	            };
	            // Clear
	            s.clear = function (e) {
	                if (!s.query && e && $(e.target).hasClass('searchbar-clear')) {
	                    s.disable();
	                    return;
	                }
	                var previousQuery = s.value;
	                s.input.val('').trigger('change').focus();
	                s.triggerEvent('clearSearch searchbar:clear', 'onClear', { previousQuery: previousQuery });
	            };
	            // Search
	            s.handleInput = function () {
	                setTimeout(function () {
	                    var value = s.input.val().trim();
	                    if ((s.searchList.length > 0 || s.params.customSearch) && (s.params.searchIn || s.isVirtualList))
	                        s.search(value, true);
	                }, 0);
	            };
	            var previousQuery = '';
	            var virtualList;
	            s.search = function (query, internal) {
	                if (previousQuery && query.trim() === previousQuery)
	                    return;
	                previousQuery = query.trim();
	                if (!internal) {
	                    if (!s.active) {
	                        s.enable();
	                    }
	                    s.input.val(query);
	                }
	                s.query = s.value = query;
	                // Add active/inactive classes on overlay
	                if (query.length === 0) {
	                    s.container.removeClass('searchbar-not-empty');
	                    if (s.searchList.length && s.container.hasClass('searchbar-active'))
	                        s.overlay.addClass('searchbar-overlay-active');
	                }
	                else {
	                    s.container.addClass('searchbar-not-empty');
	                    if (s.searchList.length && s.container.hasClass('searchbar-active'))
	                        s.overlay.removeClass('searchbar-overlay-active');
	                }
	                if (s.params.customSearch) {
	                    s.triggerEvent('search searchbar:search', 'onSearch', { query: query });
	                    return;
	                }
	                var foundItems = [], _vlQuery;
	                if (s.isVirtualList) {
	                    virtualList = s.searchList[0].f7VirtualList;
	                    if (query.trim() === '') {
	                        virtualList.resetFilter();
	                        s.notFound.hide();
	                        s.found.show();
	                        return;
	                    }
	                    _vlQuery = s.params.removeDiacritics ? $.removeDiacritics(query) : query;
	                    if (virtualList.params.searchAll) {
	                        foundItems = virtualList.params.searchAll(_vlQuery, virtualList.items) || [];
	                    }
	                    else if (virtualList.params.searchByItem) {
	                        for (var i = 0; i < virtualList.items.length; i++) {
	                            if (virtualList.params.searchByItem(_vlQuery, i, virtualList.params.items[i])) {
	                                foundItems.push(i);
	                            }
	                        }
	                    }
	                }
	                else {
	                    var values;
	                    if (s.params.removeDiacritics)
	                        values = $.removeDiacritics(query.trim().toLowerCase()).split(' ');
	                    else {
	                        values = query.trim().toLowerCase().split(' ');
	                    }
	                    s.searchList.find('li').removeClass('hidden-by-searchbar').each(function (index, el) {
	                        el = $(el);
	                        var compareWithText = [];
	                        el.find(s.params.searchIn).each(function () {
	                            var itemText = $(this).text().trim().toLowerCase();
	                            if (s.params.removeDiacritics)
	                                itemText = $.removeDiacritics(itemText);
	                            compareWithText.push(itemText);
	                        });
	                        compareWithText = compareWithText.join(' ');
	                        var wordsMatch = 0;
	                        for (var i = 0; i < values.length; i++) {
	                            if (compareWithText.indexOf(values[i]) >= 0)
	                                wordsMatch++;
	                        }
	                        if (wordsMatch !== values.length && !(s.params.ignore && el.is(s.params.ignore))) {
	                            el.addClass('hidden-by-searchbar');
	                        }
	                        else {
	                            foundItems.push(el[0]);
	                        }
	                    });
	                    if (s.params.hideDividers) {
	                        s.searchList.find('.item-divider, .list-group-title').each(function () {
	                            var title = $(this);
	                            var nextElements = title.nextAll('li');
	                            var hide = true;
	                            for (var i = 0; i < nextElements.length; i++) {
	                                var nextEl = $(nextElements[i]);
	                                if (nextEl.hasClass('list-group-title') || nextEl.hasClass('item-divider'))
	                                    break;
	                                if (!nextEl.hasClass('hidden-by-searchbar')) {
	                                    hide = false;
	                                }
	                            }
	                            var ignore = s.params.ignore && title.is(s.params.ignore);
	                            if (hide && !ignore)
	                                title.addClass('hidden-by-searchbar');
	                            else
	                                title.removeClass('hidden-by-searchbar');
	                        });
	                    }
	                    if (s.params.hideGroups) {
	                        s.searchList.find('.list-group').each(function () {
	                            var group = $(this);
	                            var ignore = s.params.ignore && group.is(s.params.ignore);
	                            var notHidden = group.find('li:not(.hidden-by-searchbar)');
	                            if (notHidden.length === 0 && !ignore) {
	                                group.addClass('hidden-by-searchbar');
	                            }
	                            else {
	                                group.removeClass('hidden-by-searchbar');
	                            }
	                        });
	                    }
	                }
	                s.triggerEvent('search searchbar:search', 'onSearch', { query: query, foundItems: foundItems });
	                if (foundItems.length === 0) {
	                    s.notFound.show();
	                    s.found.hide();
	                }
	                else {
	                    s.notFound.hide();
	                    s.found.show();
	                }
	                if (s.isVirtualList) {
	                    virtualList.filterItems(foundItems);
	                }
	            };
	            // Events
	            function preventSubmit(e) {
	                e.preventDefault();
	            }
	            s.attachEvents = function (destroy) {
	                var method = destroy ? 'off' : 'on';
	                s.container[method]('submit', preventSubmit);
	                if (!s.material)
	                    s.cancelButton[method]('click', s.disable);
	                s.overlay[method]('click', s.disable);
	                s.input[method]('focus', s.enable);
	                s.input[method]('change keydown keypress keyup compositionend', s.handleInput);
	                s.clearButton[method]('click', s.clear);
	            };
	            s.detachEvents = function () {
	                s.attachEvents(true);
	            };
	            // Init Destroy
	            s.init = function () {
	                s.attachEvents();
	            };
	            s.destroy = function () {
	                if (!s)
	                    return;
	                s.detachEvents();
	                s = null;
	            };
	            // Init
	            s.init();
	            s.container[0].f7Searchbar = s;
	            return s;
	        };
	        app.searchbar = function (container, params) {
	            return new Searchbar(container, params);
	        };
	        app.initSearchbar = function (container) {
	            container = $(container);
	            var searchbar = container.hasClass('searchbar') ? container : container.find('.searchbar');
	            if (searchbar.length === 0)
	                return;
	            if (!searchbar.hasClass('searchbar-init'))
	                return;
	            var sb = app.searchbar(searchbar, searchbar.dataset());
	            function onBeforeRemove() {
	                if (sb)
	                    sb.destroy();
	            }
	            if (container.hasClass('page')) {
	                container.once('pageBeforeRemove', onBeforeRemove);
	            }
	            else if (container.hasClass('navbar-inner')) {
	                container.once('navbarBeforeRemove', onBeforeRemove);
	            }
	        };
	        /*======================================================
	        ************   Messagebar   ************
	        ======================================================*/
	        var Messagebar = function (container, params) {
	            var defaults = {
	                textarea: null,
	                maxHeight: null,
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined' || params[def] === null) {
	                    params[def] = defaults[def];
	                }
	            }
	            // Instance
	            var m = this;
	            // Params
	            m.params = params;
	            // Container
	            m.container = $(container);
	            if (m.container.length === 0)
	                return;
	            // Textarea
	            m.textarea = m.params.textarea ? $(m.params.textarea) : m.container.find('textarea');
	            // Is In Page
	            m.pageContainer = m.container.parents('.page').eq(0);
	            m.pageContent = m.pageContainer.find('.page-content');
	            // Initial Sizes
	            m.pageContentPadding = parseInt(m.pageContent.css('padding-bottom'));
	            m.initialBarHeight = m.container[0].offsetHeight;
	            m.initialAreaHeight = m.textarea[0].offsetHeight;
	            // Resize textarea
	            m.sizeTextarea = function () {
	                // Reset
	                m.textarea.css({ 'height': '' });
	                var height = m.textarea[0].offsetHeight;
	                var diff = height - m.textarea[0].clientHeight;
	                var scrollHeight = m.textarea[0].scrollHeight;
	                // Update
	                if (scrollHeight + diff > height) {
	                    var newAreaHeight = scrollHeight + diff;
	                    var newBarHeight = m.initialBarHeight + (newAreaHeight - m.initialAreaHeight);
	                    var maxBarHeight = m.params.maxHeight || m.container.parents('.view')[0].offsetHeight - 88;
	                    if (newBarHeight > maxBarHeight) {
	                        newBarHeight = parseInt(maxBarHeight, 10);
	                        newAreaHeight = newBarHeight - m.initialBarHeight + m.initialAreaHeight;
	                    }
	                    m.textarea.css('height', newAreaHeight + 'px');
	                    m.container.css('height', newBarHeight + 'px');
	                    var onBottom = (m.pageContent[0].scrollTop === m.pageContent[0].scrollHeight - m.pageContent[0].offsetHeight);
	                    if (m.pageContent.length > 0) {
	                        m.pageContent.css('padding-bottom', newBarHeight + 'px');
	                        if (m.pageContent.find('.messages-new-first').length === 0 && onBottom) {
	                            m.pageContent.scrollTop(m.pageContent[0].scrollHeight - m.pageContent[0].offsetHeight);
	                        }
	                    }
	                }
	                else {
	                    if (m.pageContent.length > 0) {
	                        m.container.css({ 'height': '', 'bottom': '' });
	                        m.pageContent.css({ 'padding-bottom': '' });
	                    }
	                }
	            };
	            // Clear
	            m.clear = function () {
	                m.textarea.val('').trigger('change');
	            };
	            m.value = function (value) {
	                if (typeof value === 'undefined')
	                    return m.textarea.val();
	                else
	                    m.textarea.val(value).trigger('change');
	            };
	            // Handle textarea
	            m.textareaTimeout = undefined;
	            m.handleTextarea = function (e) {
	                clearTimeout(m.textareaTimeout);
	                m.textareaTimeout = setTimeout(function () {
	                    m.sizeTextarea();
	                }, 0);
	            };
	            //Events
	            function preventSubmit(e) {
	                e.preventDefault();
	            }
	            m.attachEvents = function (destroy) {
	                var method = destroy ? 'off' : 'on';
	                m.container[method]('submit', preventSubmit);
	                m.textarea[method]('change keydown keypress keyup paste cut', m.handleTextarea);
	            };
	            m.detachEvents = function () {
	                m.attachEvents(true);
	            };
	            // Init Destroy
	            m.init = function () {
	                m.attachEvents();
	            };
	            m.destroy = function () {
	                m.detachEvents();
	                m = null;
	            };
	            // Init
	            m.init();
	            m.container[0].f7Messagebar = m;
	            return m;
	        };
	        app.messagebar = function (container, params) {
	            return new Messagebar(container, params);
	        };
	        app.initPageMessagebar = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var messagebar = pageContainer.hasClass('messagebar') ? pageContainer : pageContainer.find('.messagebar');
	            if (messagebar.length === 0)
	                return;
	            if (!messagebar.hasClass('messagebar-init'))
	                return;
	            var mb = app.messagebar(messagebar, messagebar.dataset());
	            // Destroy on page remove
	            function pageBeforeRemove() {
	                mb.destroy();
	                pageContainer.off('page:beforeremove', pageBeforeRemove);
	            }
	            if (pageContainer.hasClass('page')) {
	                pageContainer.on('page:beforeremove', pageBeforeRemove);
	            }
	        };
	        /*======================================================
	        ************   XHR   ************
	        ======================================================*/
	        // XHR Caching
	        app.cache = [];
	        app.removeFromCache = function (url) {
	            var index = false;
	            for (var i = 0; i < app.cache.length; i++) {
	                if (app.cache[i].url === url)
	                    index = i;
	            }
	            if (index !== false)
	                app.cache.splice(index, 1);
	        };
	        // XHR
	        app.xhr = false;
	        app.get = function (url, view, ignoreCache, callback) {
	            // should we ignore get params or not
	            var _url = url;
	            if (app.params.cacheIgnoreGetParameters && url.indexOf('?') >= 0) {
	                _url = url.split('?')[0];
	            }
	            if (app.params.cache && !ignoreCache && url.indexOf('nocache') < 0 && app.params.cacheIgnore.indexOf(_url) < 0) {
	                // Check is the url cached
	                for (var i = 0; i < app.cache.length; i++) {
	                    if (app.cache[i].url === _url) {
	                        // Check expiration
	                        if ((new Date()).getTime() - app.cache[i].time < app.params.cacheDuration) {
	                            // Load from cache
	                            callback(app.cache[i].content);
	                            return false;
	                        }
	                    }
	                }
	            }
	            app.xhr = $.ajax({
	                url: url,
	                method: 'GET',
	                beforeSend: app.params.onAjaxStart,
	                complete: function (xhr, status) {
	                    if (status !== 'error' && status !== 'timeout' && (xhr.status >= 200 && xhr.status < 300) || xhr.status === 0) {
	                        if (app.params.cache && xhr.responseText !== '') {
	                            app.removeFromCache(_url);
	                            app.cache.push({
	                                url: _url,
	                                time: (new Date()).getTime(),
	                                content: xhr.responseText
	                            });
	                        }
	                        callback(xhr.responseText, false);
	                    }
	                    else {
	                        callback(xhr.responseText, true);
	                    }
	                    if (app.params.onAjaxComplete)
	                        app.params.onAjaxComplete(xhr);
	                },
	                error: function (xhr) {
	                    callback(xhr.responseText, true);
	                    if (app.params.onAjaxError)
	                        app.params.onAjaxError(xhr);
	                }
	            });
	            if (view)
	                view.xhr = app.xhr;
	            return app.xhr;
	        };
	        /*======================================================
	        ************   Pages   ************
	        ======================================================*/
	        // Page Callbacks API
	        app.pageCallbacks = {};
	        app.onPage = function (callbackName, pageName, callback) {
	            if (pageName && pageName.split(' ').length > 1) {
	                var pageNames = pageName.split(' ');
	                var returnCallbacks = [];
	                for (var i = 0; i < pageNames.length; i++) {
	                    returnCallbacks.push(app.onPage(callbackName, pageNames[i], callback));
	                }
	                returnCallbacks.remove = function () {
	                    for (var i = 0; i < returnCallbacks.length; i++) {
	                        returnCallbacks[i].remove();
	                    }
	                };
	                returnCallbacks.trigger = function () {
	                    for (var i = 0; i < returnCallbacks.length; i++) {
	                        returnCallbacks[i].trigger();
	                    }
	                };
	                return returnCallbacks;
	            }
	            var callbacks = app.pageCallbacks[callbackName][pageName];
	            if (!callbacks) {
	                callbacks = app.pageCallbacks[callbackName][pageName] = [];
	            }
	            app.pageCallbacks[callbackName][pageName].push(callback);
	            return {
	                remove: function () {
	                    var removeIndex;
	                    for (var i = 0; i < callbacks.length; i++) {
	                        if (callbacks[i].toString() === callback.toString()) {
	                            removeIndex = i;
	                        }
	                    }
	                    if (typeof removeIndex !== 'undefined')
	                        callbacks.splice(removeIndex, 1);
	                },
	                trigger: callback
	            };
	        };
	        //Create callbacks methods dynamically
	        function createPageCallback(callbackName) {
	            var capitalized = callbackName.replace(/^./, function (match) {
	                return match.toUpperCase();
	            });
	            app['onPage' + capitalized] = function (pageName, callback) {
	                return app.onPage(callbackName, pageName, callback);
	            };
	        }
	        var pageCallbacksNames = ('beforeInit init reinit beforeAnimation afterAnimation back afterBack beforeRemove').split(' ');
	        for (var i = 0; i < pageCallbacksNames.length; i++) {
	            app.pageCallbacks[pageCallbacksNames[i]] = {};
	            createPageCallback(pageCallbacksNames[i]);
	        }
	        app.triggerPageCallbacks = function (callbackName, pageName, pageData) {
	            var allPagesCallbacks = app.pageCallbacks[callbackName]['*'];
	            if (allPagesCallbacks) {
	                for (var j = 0; j < allPagesCallbacks.length; j++) {
	                    allPagesCallbacks[j](pageData);
	                }
	            }
	            var callbacks = app.pageCallbacks[callbackName][pageName];
	            if (!callbacks || callbacks.length === 0)
	                return;
	            for (var i = 0; i < callbacks.length; i++) {
	                callbacks[i](pageData);
	            }
	        };
	        // On Page Init Callback
	        app.pageInitCallback = function (view, params) {
	            var pageContainer = params.pageContainer;
	            if (!pageContainer)
	                return;
	            if (pageContainer.f7PageInitialized && view && !view.params.domCache)
	                return;
	            var pageQuery = params.query;
	            if (!pageQuery) {
	                if (params.url && params.url.indexOf('?') > 0) {
	                    pageQuery = $.parseUrlQuery(params.url || '');
	                }
	                else if (pageContainer.f7PageData && pageContainer.f7PageData.query) {
	                    pageQuery = pageContainer.f7PageData.query;
	                }
	                else {
	                    pageQuery = {};
	                }
	            }
	            // Page Data
	            var pageData = {
	                container: pageContainer,
	                url: params.url,
	                query: pageQuery,
	                name: $(pageContainer).attr('data-page'),
	                view: view,
	                from: params.position,
	                context: params.context,
	                navbarInnerContainer: params.navbarInnerContainer,
	                fromPage: params.fromPage
	            };
	            if (params.fromPage && !params.fromPage.navbarInnerContainer && params.oldNavbarInnerContainer) {
	                params.fromPage.navbarInnerContainer = params.oldNavbarInnerContainer;
	            }
	            if (pageContainer.f7PageInitialized && ((view && view.params.domCache) || (!view && $(pageContainer).parents('.popup, .popover, .login-screen, .modal, .actions-modal, .picker-modal').length > 0))) {
	                // Reinit Page
	                app.reinitPage(pageContainer);
	                // Callbacks
	                app.pluginHook('pageReinit', pageData);
	                if (app.params.onPageReinit)
	                    app.params.onPageReinit(app, pageData);
	                app.triggerPageCallbacks('reinit', pageData.name, pageData);
	                $(pageData.container).trigger('pageReinit page:reinit', { page: pageData });
	                return;
	            }
	            pageContainer.f7PageInitialized = true;
	            // Store pagedata in page
	            pageContainer.f7PageData = pageData;
	            // Update View's activePage
	            if (view && !params.preloadOnly && !params.reloadPrevious) {
	                // Add data-page on view
	                $(view.container).attr('data-page', pageData.name);
	                // Update View active page data
	                view.activePage = pageData;
	            }
	            // Before Init Callbacks
	            app.pluginHook('pageBeforeInit', pageData);
	            if (app.params.onPageBeforeInit)
	                app.params.onPageBeforeInit(app, pageData);
	            app.triggerPageCallbacks('beforeInit', pageData.name, pageData);
	            $(pageData.container).trigger('pageBeforeInit page:beforeinit', { page: pageData });
	            // Init page
	            app.initPage(pageContainer);
	            // Init Callback
	            app.pluginHook('pageInit', pageData);
	            if (app.params.onPageInit)
	                app.params.onPageInit(app, pageData);
	            app.triggerPageCallbacks('init', pageData.name, pageData);
	            $(pageData.container).trigger('pageInit page:init', { page: pageData });
	        };
	        app.pageRemoveCallback = function (view, pageContainer, position) {
	            var pageContext;
	            if (!pageContainer)
	                return;
	            if (pageContainer.f7PageData)
	                pageContext = pageContainer.f7PageData.context;
	            // Page Data
	            var pageData = {
	                container: pageContainer,
	                name: $(pageContainer).attr('data-page'),
	                view: view,
	                url: pageContainer.f7PageData && pageContainer.f7PageData.url,
	                query: pageContainer.f7PageData && pageContainer.f7PageData.query,
	                navbarInnerContainer: pageContainer.f7PageData && pageContainer.f7PageData.navbarInnerContainer,
	                from: position,
	                context: pageContext
	            };
	            // Before Init Callback
	            app.pluginHook('pageBeforeRemove', pageData);
	            if (app.params.onPageBeforeRemove)
	                app.params.onPageBeforeRemove(app, pageData);
	            app.triggerPageCallbacks('beforeRemove', pageData.name, pageData);
	            $(pageData.container).trigger('pageBeforeRemove page:beforeremove', { page: pageData });
	            pageData = null;
	        };
	        app.pageBackCallback = function (callback, view, params) {
	            // Page Data
	            var pageContainer = params.pageContainer;
	            var pageContext;
	            if (!pageContainer)
	                return;
	            if (pageContainer.f7PageData)
	                pageContext = pageContainer.f7PageData.context;
	            var pageData = {
	                container: pageContainer,
	                name: $(pageContainer).attr('data-page'),
	                url: pageContainer.f7PageData && pageContainer.f7PageData.url,
	                query: pageContainer.f7PageData && pageContainer.f7PageData.query,
	                view: view,
	                from: params.position,
	                context: pageContext,
	                navbarInnerContainer: pageContainer.f7PageData && pageContainer.f7PageData.navbarInnerContainer,
	                swipeBack: params.swipeBack
	            };
	            if (callback === 'after') {
	                app.pluginHook('pageAfterBack', pageData);
	                if (app.params.onPageAfterBack)
	                    app.params.onPageAfterBack(app, pageData);
	                app.triggerPageCallbacks('afterBack', pageData.name, pageData);
	                $(pageContainer).trigger('pageAfterBack page:afterback', { page: pageData });
	            }
	            if (callback === 'before') {
	                app.pluginHook('pageBack', pageData);
	                if (app.params.onPageBack)
	                    app.params.onPageBack(app, pageData);
	                app.triggerPageCallbacks('back', pageData.name, pageData);
	                $(pageData.container).trigger('pageBack page:back', { page: pageData });
	            }
	        };
	        app.pageAnimCallback = function (callback, view, params) {
	            var pageContainer = params.pageContainer;
	            var pageContext;
	            if (!pageContainer)
	                return;
	            if (pageContainer.f7PageData)
	                pageContext = pageContainer.f7PageData.context;
	            var pageQuery = params.query;
	            if (!pageQuery) {
	                if (params.url && params.url.indexOf('?') > 0) {
	                    pageQuery = $.parseUrlQuery(params.url || '');
	                }
	                else if (pageContainer.f7PageData && pageContainer.f7PageData.query) {
	                    pageQuery = pageContainer.f7PageData.query;
	                }
	                else {
	                    pageQuery = {};
	                }
	            }
	            // Page Data
	            var pageData = {
	                container: pageContainer,
	                url: params.url,
	                query: pageQuery,
	                name: $(pageContainer).attr('data-page'),
	                view: view,
	                from: params.position,
	                context: pageContext,
	                swipeBack: params.swipeBack,
	                navbarInnerContainer: pageContainer.f7PageData && pageContainer.f7PageData.navbarInnerContainer,
	                fromPage: params.fromPage
	            };
	            var oldPage = params.oldPage, newPage = params.newPage;
	            // Update page date
	            pageContainer.f7PageData = pageData;
	            if (callback === 'after') {
	                app.pluginHook('pageAfterAnimation', pageData);
	                if (app.params.onPageAfterAnimation)
	                    app.params.onPageAfterAnimation(app, pageData);
	                app.triggerPageCallbacks('afterAnimation', pageData.name, pageData);
	                $(pageData.container).trigger('pageAfterAnimation page:afteranimation', { page: pageData });
	            }
	            if (callback === 'before') {
	                // Add data-page on view
	                $(view.container).attr('data-page', pageData.name);
	                // Update View's activePage
	                if (view)
	                    view.activePage = pageData;
	                // Hide/show navbar dynamically
	                if (newPage.hasClass('no-navbar') && !oldPage.hasClass('no-navbar')) {
	                    view.hideNavbar();
	                }
	                if (!newPage.hasClass('no-navbar') && (oldPage.hasClass('no-navbar') || oldPage.hasClass('no-navbar-by-scroll'))) {
	                    view.showNavbar();
	                }
	                // Hide/show navbar toolbar
	                if (newPage.hasClass('no-toolbar') && !oldPage.hasClass('no-toolbar')) {
	                    view.hideToolbar();
	                }
	                if (!newPage.hasClass('no-toolbar') && (oldPage.hasClass('no-toolbar') || oldPage.hasClass('no-toolbar-by-scroll'))) {
	                    view.showToolbar();
	                }
	                // Hide/show tabbar
	                var tabBar;
	                if (newPage.hasClass('no-tabbar') && !oldPage.hasClass('no-tabbar')) {
	                    tabBar = $(view.container).find('.tabbar');
	                    if (tabBar.length === 0)
	                        tabBar = $(view.container).parents('.' + app.params.viewsClass).find('.tabbar');
	                    app.hideToolbar(tabBar);
	                }
	                if (!newPage.hasClass('no-tabbar') && (oldPage.hasClass('no-tabbar') || oldPage.hasClass('no-tabbar-by-scroll'))) {
	                    tabBar = $(view.container).find('.tabbar');
	                    if (tabBar.length === 0)
	                        tabBar = $(view.container).parents('.' + app.params.viewsClass).find('.tabbar');
	                    app.showToolbar(tabBar);
	                }
	                oldPage.removeClass('no-navbar-by-scroll no-toolbar-by-scroll');
	                // Callbacks
	                app.pluginHook('pageBeforeAnimation', pageData);
	                if (app.params.onPageBeforeAnimation)
	                    app.params.onPageBeforeAnimation(app, pageData);
	                app.triggerPageCallbacks('beforeAnimation', pageData.name, pageData);
	                $(pageData.container).trigger('pageBeforeAnimation page:beforeanimation', { page: pageData });
	            }
	        };
	        // Init Page Events and Manipulations
	        app.initPage = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            if (pageContainer.length === 0)
	                return;
	            // Size navbars on page load
	            if (app.sizeNavbars)
	                app.sizeNavbars(pageContainer.parents('.' + app.params.viewClass)[0]);
	            // Init messages
	            if (app.initPageMessages)
	                app.initPageMessages(pageContainer);
	            // Init forms storage
	            if (app.initFormsStorage)
	                app.initFormsStorage(pageContainer);
	            // Init smart select
	            if (app.initSmartSelects)
	                app.initSmartSelects(pageContainer);
	            // Init slider
	            if (app.initPageSwiper)
	                app.initPageSwiper(pageContainer);
	            // Init pull to refres
	            if (app.initPullToRefresh)
	                app.initPullToRefresh(pageContainer);
	            // Init infinite scroll
	            if (app.initPageInfiniteScroll)
	                app.initPageInfiniteScroll(pageContainer);
	            // Init searchbar
	            if (app.initSearchbar)
	                app.initSearchbar(pageContainer);
	            // Init message bar
	            if (app.initPageMessagebar)
	                app.initPageMessagebar(pageContainer);
	            // Init scroll toolbars
	            if (app.initPageScrollToolbars)
	                app.initPageScrollToolbars(pageContainer);
	            // Init lazy images
	            if (app.initImagesLazyLoad)
	                app.initImagesLazyLoad(pageContainer);
	            // Init progress bars
	            if (app.initPageProgressbar)
	                app.initPageProgressbar(pageContainer);
	            // Init resizeable textareas
	            if (app.initPageResizableTextarea)
	                app.initPageResizableTextarea(pageContainer);
	            // Init Data Table
	            if (app.initPageDataTables)
	                app.initPageDataTables(pageContainer);
	            // Init Material Preloader
	            if (app.params.material && app.initPageMaterialPreloader)
	                app.initPageMaterialPreloader(pageContainer);
	            // Init Material Inputs
	            if (app.params.material && app.initPageMaterialInputs)
	                app.initPageMaterialInputs(pageContainer);
	            // Init Material Tabbar
	            if (app.params.material && app.initPageMaterialTabbar)
	                app.initPageMaterialTabbar(pageContainer);
	        };
	        app.reinitPage = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            if (pageContainer.length === 0)
	                return;
	            // Size navbars on page reinit
	            if (app.sizeNavbars)
	                app.sizeNavbars(pageContainer.parents('.' + app.params.viewClass)[0]);
	            // Reinit slider
	            if (app.reinitPageSwiper)
	                app.reinitPageSwiper(pageContainer);
	            // Reinit lazy load
	            if (app.reinitLazyLoad)
	                app.reinitLazyLoad(pageContainer);
	        };
	        app.initPageWithCallback = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var viewContainer = pageContainer.parents('.' + app.params.viewClass);
	            if (viewContainer.length === 0)
	                return;
	            var view = viewContainer[0].f7View || undefined;
	            var url = view && view.url ? view.url : undefined;
	            if (viewContainer && pageContainer.attr('data-page')) {
	                viewContainer.attr('data-page', pageContainer.attr('data-page'));
	            }
	            app.pageInitCallback(view, { pageContainer: pageContainer[0], url: url, position: 'center' });
	        };
	        /*======================================================
	        ************   Navigation / Router   ************
	        ======================================================*/
	        app.router = {
	            _remove: function (el) {
	                if (app.params.routerRemoveTimeout || app.params.routerRemoveWithTimeout) {
	                    setTimeout(function () {
	                        $(el).remove();
	                    }, 0);
	                }
	                else
	                    $(el).remove();
	            },
	            _modalsSelector: '.popup, .modal, .popover, .actions-modal, .picker-modal, .login-screen',
	            // Temporary DOM Element
	            temporaryDom: document.createElement('div'),
	            // Find page or navbar in passed container which are related to View
	            findElement: function (selector, container, view, notCached) {
	                container = $(container);
	                if (notCached)
	                    selector = selector + ':not(.cached)';
	                var found = container.find(selector).filter(function (index, el) {
	                    return $(el).parents(app.router._modalsSelector).length === 0;
	                });
	                if (found.length > 1) {
	                    if (typeof view.selector === 'string') {
	                        // Search in related view
	                        found = container.find(view.selector + ' ' + selector);
	                    }
	                    if (found.length > 1) {
	                        // Search in main view
	                        found = container.find('.' + app.params.viewMainClass + ' ' + selector);
	                    }
	                }
	                if (found.length === 1)
	                    return found;
	                else {
	                    // Try to find non cached
	                    if (!notCached)
	                        found = app.router.findElement(selector, container, view, true);
	                    if (found && found.length === 1)
	                        return found;
	                    if (found && found.length > 1)
	                        return $(found[0]);
	                    else
	                        return undefined;
	                }
	            },
	            // Set pages classes for animationEnd
	            animatePages: function (leftPage, rightPage, direction) {
	                // Loading new page
	                var removeClasses = 'page-on-center page-on-right page-on-left';
	                if (direction === 'to-left') {
	                    leftPage.removeClass(removeClasses).addClass('page-from-center-to-left');
	                    rightPage.removeClass(removeClasses).addClass('page-from-right-to-center');
	                }
	                // Go back
	                if (direction === 'to-right') {
	                    leftPage.removeClass(removeClasses).addClass('page-from-left-to-center');
	                    rightPage.removeClass(removeClasses).addClass('page-from-center-to-right');
	                }
	            },
	            // Prepare navbar before animarion
	            prepareNavbar: function (newNavbarInner, oldNavbarInner, newNavbarPosition) {
	                $(newNavbarInner).find('.sliding').each(function () {
	                    var sliding = $(this);
	                    var slidingOffset = newNavbarPosition === 'right' ? this.f7NavbarRightOffset : this.f7NavbarLeftOffset;
	                    if (app.params.animateNavBackIcon) {
	                        if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                            sliding.find('.back .icon').transform('translate3d(' + (-slidingOffset) + 'px,0,0)');
	                        }
	                    }
	                    sliding.transform('translate3d(' + slidingOffset + 'px,0,0)');
	                });
	            },
	            // Set navbars classes for animation
	            animateNavbars: function (leftNavbarInner, rightNavbarInner, direction) {
	                // Loading new page
	                var removeClasses = 'navbar-on-right navbar-on-center navbar-on-left';
	                if (direction === 'to-left') {
	                    rightNavbarInner.removeClass(removeClasses).addClass('navbar-from-right-to-center');
	                    rightNavbarInner.find('.sliding').each(function () {
	                        var sliding = $(this);
	                        sliding.transform('translate3d(0px,0,0)');
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                                sliding.find('.back .icon').transform('translate3d(0px,0,0)');
	                            }
	                        }
	                    });
	                    leftNavbarInner.removeClass(removeClasses).addClass('navbar-from-center-to-left');
	                    leftNavbarInner.find('.sliding').each(function () {
	                        var sliding = $(this);
	                        var rightText;
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('center') && rightNavbarInner.find('.sliding.left .back .icon').length > 0) {
	                                rightText = rightNavbarInner.find('.sliding.left .back span');
	                                if (rightText.length > 0)
	                                    this.f7NavbarLeftOffset += rightText[0].offsetLeft;
	                            }
	                            if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                                sliding.find('.back .icon').transform('translate3d(' + (-this.f7NavbarLeftOffset) + 'px,0,0)');
	                            }
	                        }
	                        sliding.transform('translate3d(' + (this.f7NavbarLeftOffset) + 'px,0,0)');
	                    });
	                }
	                // Go back
	                if (direction === 'to-right') {
	                    leftNavbarInner.removeClass(removeClasses).addClass('navbar-from-left-to-center');
	                    leftNavbarInner.find('.sliding').each(function () {
	                        var sliding = $(this);
	                        sliding.transform('translate3d(0px,0,0)');
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                                sliding.find('.back .icon').transform('translate3d(0px,0,0)');
	                            }
	                        }
	                    });
	                    rightNavbarInner.removeClass(removeClasses).addClass('navbar-from-center-to-right');
	                    rightNavbarInner.find('.sliding').each(function () {
	                        var sliding = $(this);
	                        if (app.params.animateNavBackIcon) {
	                            if (sliding.hasClass('left') && sliding.find('.back .icon').length > 0) {
	                                sliding.find('.back .icon').transform('translate3d(' + (-this.f7NavbarRightOffset) + 'px,0,0)');
	                            }
	                        }
	                        sliding.transform('translate3d(' + (this.f7NavbarRightOffset) + 'px,0,0)');
	                    });
	                }
	            },
	            preprocess: function (view, content, url, next) {
	                // Plugin hook
	                app.pluginHook('routerPreprocess', view, content, url, next);
	                // Preprocess by plugin
	                content = app.pluginProcess('preprocess', content);
	                if (view && view.params && view.params.preprocess) {
	                    content = view.params.preprocess(content, url, next);
	                    if (typeof content !== 'undefined') {
	                        next(content);
	                    }
	                }
	                else if (app.params.preprocess) {
	                    content = app.params.preprocess(content, url, next);
	                    if (typeof content !== 'undefined') {
	                        next(content);
	                    }
	                }
	                else {
	                    next(content);
	                }
	            },
	            preroute: function (view, options, isBack) {
	                if (isBack)
	                    options.isBack = true;
	                app.pluginHook('routerPreroute', view, options);
	                if ((app.params.preroute && app.params.preroute(view, options) === false) || (view && view.params.preroute && view.params.preroute(view, options) === false)) {
	                    return true;
	                }
	                else {
	                    return false;
	                }
	            },
	            template7Render: function (view, options) {
	                var url = options.url, content = options.content, //initial content
	                t7_rendered_content = options.content, // will be rendered using Template7
	                context = options.context, // Context data for Template7
	                contextName = options.contextName, template = options.template; // Template 7 compiled template
	                var t7_ctx, t7_template;
	                if (typeof content === 'string') {
	                    if (url) {
	                        if (app.template7Cache[url] && !options.ignoreCache)
	                            t7_template = t7.cache[url];
	                        else {
	                            t7_template = t7.compile(content);
	                            t7.cache[url] = t7_template;
	                        }
	                    }
	                    else
	                        t7_template = t7.compile(content);
	                }
	                else if (template) {
	                    t7_template = template;
	                }
	                if (context) {
	                    t7_ctx = context;
	                    if (context && url) {
	                        view.contextCache[url] = context;
	                    }
	                }
	                else {
	                    if (contextName) {
	                        if (contextName.indexOf('.') >= 0) {
	                            var _ctx_path = contextName.split('.');
	                            var _ctx = t7.data[_ctx_path[0]];
	                            for (var i = 1; i < _ctx_path.length; i++) {
	                                if (_ctx_path[i])
	                                    _ctx = _ctx[_ctx_path[i]];
	                            }
	                            t7_ctx = _ctx;
	                        }
	                        else
	                            t7_ctx = t7.data[contextName];
	                    }
	                    if (!t7_ctx && url) {
	                        t7_ctx = t7.data['url:' + url];
	                    }
	                    if (!t7_ctx && typeof content === 'string' && !template) {
	                        //try to find by page name in content
	                        var pageNameMatch = content.match(/(data-page=["'][^"^']*["'])/);
	                        if (pageNameMatch) {
	                            var page = pageNameMatch[0].split('data-page=')[1].replace(/['"]/g, '');
	                            if (page)
	                                t7_ctx = t7.data['page:' + page];
	                        }
	                    }
	                    if (!t7_ctx && template && t7.templates) {
	                        // Try to find matched template name in t7.templates
	                        for (var templateName in t7.templates) {
	                            if (t7.templates[templateName] === template)
	                                t7_ctx = t7.data[templateName];
	                        }
	                    }
	                    if (!t7_ctx && url && url in view.contextCache) {
	                        t7_ctx = view.contextCache[url];
	                    }
	                    if (!t7_ctx) {
	                        t7_ctx = {};
	                    }
	                }
	                if (t7_template && t7_ctx) {
	                    if (typeof t7_ctx === 'function')
	                        t7_ctx = t7_ctx();
	                    if (url) {
	                        // Extend data with URL query
	                        var query = $.parseUrlQuery(url);
	                        t7_ctx.url_query = {};
	                        for (var key in query) {
	                            t7_ctx.url_query[key] = query[key];
	                        }
	                    }
	                    try {
	                        t7_rendered_content = t7_template(t7_ctx);
	                    }
	                    catch (e) {
	                        t7_rendered_content = '';
	                        if (window.console && window.console.error) {
	                            console.error(e);
	                        }
	                    }
	                }
	                return { content: t7_rendered_content, context: t7_ctx };
	            }
	        };
	        app.router._load = function (view, options) {
	            // Plugin hook
	            app.pluginHook('routerLoad', view, options);
	            var url = options.url, content = options.content, //initial content
	            t7_rendered = { content: options.content }, template = options.template, // Template 7 compiled template
	            pageName = options.pageName, viewContainer = $(view.container), pagesContainer = $(view.pagesContainer), animatePages = options.animatePages, newPage, oldPage, pagesInView, i, oldNavbarInner, newNavbarInner, navbar, dynamicNavbar, reloadPosition, isDynamicPage = typeof url === 'undefined' && content || template, pushState = options.pushState, pageElement = options.pageElement;
	            if (typeof animatePages === 'undefined')
	                animatePages = view.params.animatePages;
	            // Render with Template7
	            if (app.params.template7Pages && typeof content === 'string' || template) {
	                t7_rendered = app.router.template7Render(view, options);
	                if (t7_rendered.content && !content) {
	                    content = t7_rendered.content;
	                }
	            }
	            app.router.temporaryDom.innerHTML = '';
	            // Parse DOM
	            if (!pageName && !pageElement) {
	                if ((typeof content === 'string') || (url && (typeof content === 'string'))) {
	                    app.router.temporaryDom.innerHTML = t7_rendered.content;
	                }
	                else {
	                    if ('length' in content && content.length > 1) {
	                        for (var ci = 0; ci < content.length; ci++) {
	                            $(app.router.temporaryDom).append(content[ci]);
	                        }
	                    }
	                    else {
	                        $(app.router.temporaryDom).append(content);
	                    }
	                }
	            }
	            // Reload position
	            reloadPosition = options.reload && (options.reloadPrevious ? 'left' : 'center');
	            // Find new page
	            if (pageName)
	                newPage = pagesContainer.find('.page[data-page="' + pageName + '"]');
	            else {
	                if (pageElement)
	                    newPage = $(pageElement);
	                else
	                    newPage = app.router.findElement('.page', app.router.temporaryDom, view);
	            }
	            // If page not found exit
	            if (!newPage || newPage.length === 0 || (pageName && view.activePage && view.activePage.name === pageName)) {
	                view.allowPageChange = true;
	                return;
	            }
	            newPage.addClass(options.reload ? 'page-on-' + reloadPosition : 'page-on-right');
	            // Find old page (should be the last one) and remove older pages
	            pagesInView = pagesContainer.children('.page:not(.cached)');
	            if (pageElement) {
	                pagesInView = pagesInView.filter(function (index, page) {
	                    if (page !== pageElement)
	                        return page;
	                });
	            }
	            if (options.reload && options.reloadPrevious && pagesInView.length === 1) {
	                view.allowPageChange = true;
	                return;
	            }
	            if (options.reload) {
	                oldPage = pagesInView.eq(pagesInView.length - 1);
	            }
	            else {
	                if (pagesInView.length > 1) {
	                    for (i = 0; i < pagesInView.length - 2; i++) {
	                        if (!view.params.domCache) {
	                            app.pageRemoveCallback(view, pagesInView[i], 'left');
	                            app.router._remove(pagesInView[i]);
	                        }
	                        else {
	                            $(pagesInView[i]).addClass('cached');
	                        }
	                    }
	                    if (!view.params.domCache) {
	                        app.pageRemoveCallback(view, pagesInView[i], 'left');
	                        app.router._remove(pagesInView[i]);
	                    }
	                    else {
	                        $(pagesInView[i]).addClass('cached');
	                    }
	                }
	                oldPage = pagesContainer.children('.page:not(.cached)');
	            }
	            if (pageElement && oldPage.length > 1) {
	                oldPage = oldPage.filter(function (index, page) {
	                    if (page !== pageElement)
	                        return page;
	                });
	            }
	            if (view.params.domCache || pageElement)
	                newPage.removeClass('cached');
	            // Dynamic navbar
	            if (view.params.dynamicNavbar) {
	                dynamicNavbar = true;
	                // Find navbar
	                if (pageName) {
	                    newNavbarInner = viewContainer.find('.navbar-inner[data-page="' + pageName + '"]');
	                }
	                else {
	                    newNavbarInner = app.router.findElement('.navbar-inner', app.router.temporaryDom, view);
	                }
	                if (!newNavbarInner || newNavbarInner.length === 0) {
	                    // Look in page
	                    newNavbarInner = newPage.find('.navbar-inner');
	                    if (!newNavbarInner || newNavbarInner.length === 0) {
	                        // Set false
	                        dynamicNavbar = false;
	                    }
	                    else {
	                        if (newNavbarInner.parent('.navbar').length > 0) {
	                            newNavbarInner.prependTo(newPage);
	                        }
	                    }
	                }
	                if (dynamicNavbar && newPage.find('.navbar').length > 0) {
	                    app.router._remove(newPage.find('.navbar').filter(function (index, el) {
	                        return $(el).parents(app.router._modalsSelector).length === 0;
	                    }));
	                }
	                navbar = viewContainer.children('.navbar');
	                if (options.reload) {
	                    oldNavbarInner = navbar.find('.navbar-inner:not(.cached):last-child');
	                }
	                else {
	                    oldNavbarInner = navbar.find('.navbar-inner:not(.cached)');
	                    if (oldNavbarInner.length > 0) {
	                        for (i = 0; i < oldNavbarInner.length - 1; i++) {
	                            if (!view.params.domCache) {
	                                app.navbarRemoveCallback(view, pagesInView[i], navbar[0], oldNavbarInner[i]);
	                                app.router._remove(oldNavbarInner[i]);
	                            }
	                            else
	                                $(oldNavbarInner[i]).addClass('cached');
	                        }
	                        if (!newNavbarInner && oldNavbarInner.length === 1) {
	                            if (!view.params.domCache) {
	                                app.navbarRemoveCallback(view, pagesInView[0], navbar[0], oldNavbarInner[0]);
	                                app.router._remove(oldNavbarInner[0]);
	                            }
	                            else
	                                $(oldNavbarInner[0]).addClass('cached');
	                        }
	                        oldNavbarInner = navbar.find('.navbar-inner:not(.cached)');
	                    }
	                }
	            }
	            if (dynamicNavbar) {
	                newNavbarInner.addClass(options.reload ? 'navbar-on-' + reloadPosition : 'navbar-on-right');
	                if (view.params.domCache || pageElement)
	                    newNavbarInner.removeClass('cached');
	                newPage[0].f7RelatedNavbar = newNavbarInner[0];
	                newNavbarInner[0].f7RelatedPage = newPage[0];
	            }
	            // save content areas into view's cache
	            if (!url) {
	                var newPageName = pageName || newPage.attr('data-page');
	                if (isDynamicPage)
	                    url = '#' + app.params.dynamicPageUrl.replace(/{{name}}/g, newPageName).replace(/{{index}}/g, view.history.length - (options.reload ? 1 : 0));
	                else
	                    url = '#' + newPageName;
	                if (!view.params.domCache) {
	                    view.contentCache[url] = content;
	                }
	                if (view.params.domCache && pageName) {
	                    view.pagesCache[url] = pageName;
	                }
	            }
	            else if (url && pageElement) {
	                view.pageElementsCache[url] = {
	                    page: newPage,
	                    navbarInner: newNavbarInner
	                };
	            }
	            // Push State
	            if (app.params.pushState && !options.reloadPrevious && view.main) {
	                if (typeof pushState === 'undefined')
	                    pushState = true;
	                var pushStateRoot = app.params.pushStateRoot || '';
	                var method = options.reload ? 'replaceState' : 'pushState';
	                if (pushState) {
	                    if (!isDynamicPage && !pageName) {
	                        history[method]({ url: url, viewIndex: app.views.indexOf(view) }, '', pushStateRoot + app.params.pushStateSeparator + url);
	                    }
	                    else if (isDynamicPage && content) {
	                        history[method]({ content: typeof content === 'string' ? content : '', url: url, viewIndex: app.views.indexOf(view) }, '', pushStateRoot + app.params.pushStateSeparator + url);
	                    }
	                    else if (pageName) {
	                        history[method]({ pageName: pageName, url: url, viewIndex: app.views.indexOf(view) }, '', pushStateRoot + app.params.pushStateSeparator + url);
	                    }
	                }
	            }
	            // Update View history
	            view.url = url;
	            if (options.reload) {
	                var lastUrl = view.history[view.history.length - (options.reloadPrevious ? 2 : 1)];
	                if (lastUrl &&
	                    lastUrl.indexOf('#') === 0 &&
	                    lastUrl in view.contentCache &&
	                    lastUrl !== url &&
	                    view.history.indexOf(lastUrl) === -1) {
	                    view.contentCache[lastUrl] = null;
	                    delete view.contentCache[lastUrl];
	                }
	                else if (lastUrl &&
	                    lastUrl in view.pageElementsCache &&
	                    lastUrl !== url &&
	                    (view.history.indexOf(lastUrl) === -1 || view.history.indexOf(lastUrl) === view.history.length - 1)) {
	                    view.pageElementsCache[lastUrl] = null;
	                    delete view.pageElementsCache[lastUrl];
	                }
	                if (lastUrl &&
	                    lastUrl in view.contextCache &&
	                    lastUrl !== url &&
	                    (view.history.indexOf(lastUrl) === -1 || view.history.indexOf(lastUrl) === view.history.length - 1)) {
	                    view.contextCache[lastUrl] = null;
	                    delete view.contextCache[lastUrl];
	                }
	                view.history[view.history.length - (options.reloadPrevious ? 2 : 1)] = url;
	            }
	            else {
	                view.history.push(url);
	            }
	            // Unique history
	            var historyBecameUnique = false;
	            if (view.params.uniqueHistory) {
	                var _history = view.history;
	                var _url = url;
	                if (view.params.uniqueHistoryIgnoreGetParameters) {
	                    _history = [];
	                    _url = url.split('?')[0];
	                    for (i = 0; i < view.history.length; i++) {
	                        _history.push(view.history[i].split('?')[0]);
	                    }
	                }
	                if (_history.indexOf(_url) !== _history.lastIndexOf(_url)) {
	                    view.history = view.history.slice(0, _history.indexOf(_url));
	                    view.history.push(url);
	                    historyBecameUnique = true;
	                }
	            }
	            // Dom manipulations
	            if (options.reloadPrevious) {
	                oldPage = oldPage.prev('.page');
	                newPage.insertBefore(oldPage);
	                if (dynamicNavbar) {
	                    oldNavbarInner = oldNavbarInner.prev('.navbar-inner');
	                    newNavbarInner.insertAfter(oldNavbarInner);
	                }
	            }
	            else {
	                pagesContainer.append(newPage[0]);
	                if (dynamicNavbar)
	                    navbar.append(newNavbarInner[0]);
	            }
	            // Remove Old Page And Navbar
	            if (options.reload) {
	                if (view.params.domCache && view.initialPages.indexOf(oldPage[0]) >= 0) {
	                    oldPage.addClass('cached');
	                    if (dynamicNavbar)
	                        oldNavbarInner.addClass('cached');
	                }
	                else {
	                    app.pageRemoveCallback(view, oldPage[0], reloadPosition);
	                    if (dynamicNavbar)
	                        app.navbarRemoveCallback(view, oldPage[0], navbar[0], oldNavbarInner[0]);
	                    app.router._remove(oldPage);
	                    if (dynamicNavbar)
	                        app.router._remove(oldNavbarInner);
	                }
	            }
	            // Page Init Events
	            app.pageInitCallback(view, {
	                pageContainer: newPage[0],
	                url: url,
	                position: options.reload ? reloadPosition : 'right',
	                navbarInnerContainer: dynamicNavbar ? newNavbarInner && newNavbarInner[0] : undefined,
	                oldNavbarInnerContainer: dynamicNavbar ? oldNavbarInner && oldNavbarInner[0] : undefined,
	                context: t7_rendered.context || options.context,
	                query: options.query,
	                fromPage: oldPage && oldPage.length && oldPage[0].f7PageData,
	                reload: options.reload,
	                reloadPrevious: options.reloadPrevious
	            });
	            // Navbar init event
	            if (dynamicNavbar) {
	                app.navbarInitCallback(view, newPage[0], navbar[0], newNavbarInner[0], url, options.reload ? reloadPosition : 'right');
	            }
	            if (options.reload) {
	                view.allowPageChange = true;
	                if (historyBecameUnique)
	                    view.refreshPreviousPage();
	                return;
	            }
	            if (dynamicNavbar && animatePages) {
	                app.router.prepareNavbar(newNavbarInner, oldNavbarInner, 'right');
	            }
	            // Force reLayout
	            var clientLeft = newPage[0].clientLeft;
	            // Before Anim Callback
	            app.pageAnimCallback('before', view, {
	                pageContainer: newPage[0],
	                url: url,
	                position: 'right',
	                oldPage: oldPage,
	                newPage: newPage,
	                query: options.query,
	                fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	            });
	            function afterAnimation() {
	                view.allowPageChange = true;
	                newPage.removeClass('page-from-right-to-center page-on-right page-on-left').addClass('page-on-center');
	                oldPage.removeClass('page-from-center-to-left page-on-center page-on-right').addClass('page-on-left');
	                if (dynamicNavbar) {
	                    newNavbarInner.removeClass('navbar-from-right-to-center navbar-on-left navbar-on-right').addClass('navbar-on-center');
	                    oldNavbarInner.removeClass('navbar-from-center-to-left navbar-on-center navbar-on-right').addClass('navbar-on-left');
	                }
	                app.pageAnimCallback('after', view, {
	                    pageContainer: newPage[0],
	                    url: url,
	                    position: 'right',
	                    oldPage: oldPage,
	                    newPage: newPage,
	                    query: options.query,
	                    fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	                });
	                if (app.params.pushState && view.main)
	                    app.pushStateClearQueue();
	                if (!(view.params.swipeBackPage || view.params.preloadPreviousPage)) {
	                    if (view.params.domCache) {
	                        oldPage.addClass('cached');
	                        if (dynamicNavbar)
	                            oldNavbarInner.addClass('cached');
	                    }
	                    else {
	                        if (!(url.indexOf('#') === 0 && newPage.attr('data-page').indexOf('smart-select-') === 0)) {
	                            app.pageRemoveCallback(view, oldPage[0], 'left');
	                            if (dynamicNavbar)
	                                app.navbarRemoveCallback(view, oldPage[0], navbar[0], oldNavbarInner[0]);
	                            app.router._remove(oldPage);
	                            if (dynamicNavbar)
	                                app.router._remove(oldNavbarInner);
	                        }
	                    }
	                }
	                if (view.params.uniqueHistory && historyBecameUnique) {
	                    view.refreshPreviousPage();
	                }
	            }
	            if (animatePages) {
	                // Set pages before animation
	                if (app.params.material && app.params.materialPageLoadDelay) {
	                    setTimeout(function () {
	                        app.router.animatePages(oldPage, newPage, 'to-left', view);
	                    }, app.params.materialPageLoadDelay);
	                }
	                else {
	                    app.router.animatePages(oldPage, newPage, 'to-left', view);
	                }
	                // Dynamic navbar animation
	                if (dynamicNavbar) {
	                    setTimeout(function () {
	                        app.router.animateNavbars(oldNavbarInner, newNavbarInner, 'to-left', view);
	                    }, 0);
	                }
	                newPage.animationEnd(function () {
	                    afterAnimation();
	                });
	            }
	            else {
	                if (dynamicNavbar)
	                    newNavbarInner.find('.sliding, .sliding .back .icon').transform('');
	                afterAnimation();
	            }
	        };
	        app.router.load = function (view, options) {
	            options = options || {};
	            if (app.routerPreOptions) {
	                options = app.routerPreOptions(view, options) || {};
	            }
	            if (options.component && app.componentLoader) {
	                try {
	                    app.componentLoader(view, options, function (newOptions) {
	                        app.router.load(view, newOptions);
	                    });
	                }
	                catch (e) { }
	                return;
	            }
	            if (app.router.preroute(view, options)) {
	                return false;
	            }
	            var url = options.url;
	            var content = options.content;
	            var pageName = options.pageName;
	            var pageElement = options.pageElement;
	            if (pageName) {
	                if (pageName.indexOf('?') > 0) {
	                    options.query = $.parseUrlQuery(pageName);
	                    options.pageName = pageName = pageName.split('?')[0];
	                }
	            }
	            var template = options.template;
	            if (view.params.reloadPages === true)
	                options.reload = true;
	            if (!view.allowPageChange)
	                return false;
	            if (url && view.url === url && !options.reload && !view.params.allowDuplicateUrls)
	                return false;
	            view.allowPageChange = false;
	            if (app.xhr && view.xhr && view.xhr === app.xhr) {
	                app.xhr.abort();
	                app.xhr = false;
	            }
	            function proceed(content) {
	                app.router.preprocess(view, content, url, function (content) {
	                    options.content = content;
	                    app.router._load(view, options);
	                });
	            }
	            if (content || pageName || pageElement) {
	                proceed(content);
	                return;
	            }
	            else if (template) {
	                app.router._load(view, options);
	                return;
	            }
	            if (!options.url || options.url === '#') {
	                view.allowPageChange = true;
	                return;
	            }
	            app.get(options.url, view, options.ignoreCache, function (content, error) {
	                if (error) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                proceed(content);
	            });
	        };
	        app.router._back = function (view, options) {
	            options = options || {};
	            app.pluginHook('routerBack', view, options);
	            var url = options.url, content = options.content, t7_rendered = { content: options.content }, // will be rendered using Template7
	            template = options.template, // Template 7 compiled template
	            animatePages = options.animatePages, preloadOnly = options.preloadOnly, pushState = options.pushState, ignoreCache = options.ignoreCache, force = options.force, pageName = options.pageName, pageElement = options.pageElement;
	            var viewContainer = $(view.container), pagesContainer = $(view.pagesContainer), pagesInView = pagesContainer.children('.page:not(.cached)'), oldPage, newPage, oldNavbarInner, newNavbarInner, navbar, navbarInners, dynamicNavbar, manipulateDom = true;
	            if (typeof animatePages === 'undefined')
	                animatePages = view.params.animatePages;
	            // Render with Template7
	            if (app.params.template7Pages && typeof content === 'string' || template) {
	                t7_rendered = app.router.template7Render(view, options);
	                if (t7_rendered.content && !content) {
	                    content = t7_rendered.content;
	                }
	            }
	            // Animation
	            function afterAnimation() {
	                app.pageBackCallback('after', view, {
	                    pageContainer: oldPage[0],
	                    url: url,
	                    position: 'center',
	                    oldPage: oldPage,
	                    newPage: newPage,
	                });
	                app.pageAnimCallback('after', view, {
	                    pageContainer: newPage[0],
	                    url: url,
	                    position: 'left',
	                    oldPage: oldPage,
	                    newPage: newPage,
	                    query: options.query,
	                    fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	                });
	                app.router.afterBack(view, oldPage[0], newPage[0]);
	            }
	            function animateBack() {
	                // Page before animation callback
	                app.pageBackCallback('before', view, {
	                    pageContainer: oldPage[0],
	                    url: url,
	                    position: 'center',
	                    oldPage: oldPage,
	                    newPage: newPage,
	                });
	                app.pageAnimCallback('before', view, {
	                    pageContainer: newPage[0],
	                    url: url,
	                    position: 'left',
	                    oldPage: oldPage,
	                    newPage: newPage,
	                    query: options.query,
	                    fromPage: oldPage && oldPage.length && oldPage[0].f7PageData
	                });
	                if (animatePages) {
	                    // Set pages before animation
	                    app.router.animatePages(newPage, oldPage, 'to-right', view);
	                    // Dynamic navbar animation
	                    if (dynamicNavbar) {
	                        setTimeout(function () {
	                            app.router.animateNavbars(newNavbarInner, oldNavbarInner, 'to-right', view);
	                        }, 0);
	                    }
	                    newPage.animationEnd(function () {
	                        afterAnimation();
	                    });
	                }
	                else {
	                    if (dynamicNavbar)
	                        newNavbarInner.find('.sliding, .sliding .back .icon').transform('');
	                    afterAnimation();
	                }
	            }
	            function parseNewPage() {
	                app.router.temporaryDom.innerHTML = '';
	                // Parse DOM
	                if ((typeof content === 'string') || (url && (typeof content === 'string'))) {
	                    app.router.temporaryDom.innerHTML = t7_rendered.content;
	                }
	                else {
	                    if ('length' in content && content.length > 1) {
	                        for (var ci = 0; ci < content.length; ci++) {
	                            $(app.router.temporaryDom).append(content[ci]);
	                        }
	                    }
	                    else {
	                        $(app.router.temporaryDom).append(content);
	                    }
	                }
	                if (pageElement)
	                    newPage = $(pageElement);
	                else
	                    newPage = app.router.findElement('.page', app.router.temporaryDom, view);
	                if (view.params.dynamicNavbar) {
	                    // Find navbar
	                    newNavbarInner = app.router.findElement('.navbar-inner', app.router.temporaryDom, view);
	                }
	            }
	            function setPages() {
	                // If pages not found or there are still more than one, exit
	                if (!newPage || newPage.length === 0) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                if (view.params.dynamicNavbar && typeof dynamicNavbar === 'undefined') {
	                    if (!newNavbarInner || newNavbarInner.length === 0) {
	                        dynamicNavbar = false;
	                    }
	                    else {
	                        dynamicNavbar = true;
	                    }
	                }
	                newPage.addClass('page-on-left').removeClass('cached');
	                if (dynamicNavbar) {
	                    navbar = viewContainer.children('.navbar');
	                    navbarInners = navbar.find('.navbar-inner:not(.cached)');
	                    newNavbarInner.addClass('navbar-on-left').removeClass('cached');
	                }
	                // Remove/hide previous page in force mode
	                if (force) {
	                    var pageToRemove, navbarToRemove;
	                    pageToRemove = $(pagesInView[pagesInView.length - 2]);
	                    if (dynamicNavbar)
	                        navbarToRemove = $(pageToRemove[0] && pageToRemove[0].f7RelatedNavbar || navbarInners[navbarInners.length - 2]);
	                    if (view.params.domCache && view.initialPages.indexOf(pageToRemove[0]) >= 0) {
	                        if (pageToRemove.length && pageToRemove[0] !== newPage[0])
	                            pageToRemove.addClass('cached');
	                        if (dynamicNavbar && navbarToRemove.length && navbarToRemove[0] !== newNavbarInner[0]) {
	                            navbarToRemove.addClass('cached');
	                        }
	                    }
	                    else {
	                        var removeNavbar = dynamicNavbar && navbarToRemove.length;
	                        if (pageToRemove.length) {
	                            app.pageRemoveCallback(view, pageToRemove[0], 'right');
	                            if (removeNavbar) {
	                                app.navbarRemoveCallback(view, pageToRemove[0], navbar[0], navbarToRemove[0]);
	                            }
	                            app.router._remove(pageToRemove);
	                            if (removeNavbar)
	                                app.router._remove(navbarToRemove);
	                        }
	                        else if (removeNavbar) {
	                            app.navbarRemoveCallback(view, pageToRemove[0], navbar[0], navbarToRemove[0]);
	                            app.router._remove(navbarToRemove);
	                        }
	                    }
	                    pagesInView = pagesContainer.children('.page:not(.cached)');
	                    if (dynamicNavbar) {
	                        navbarInners = viewContainer.children('.navbar').find('.navbar-inner:not(.cached)');
	                    }
	                    if (view.history.indexOf(url) >= 0) {
	                        view.history = view.history.slice(0, view.history.indexOf(url) + 2);
	                    }
	                    else {
	                        if (view.history[[view.history.length - 2]]) {
	                            view.history[view.history.length - 2] = url;
	                        }
	                        else {
	                            view.history.unshift(url);
	                        }
	                    }
	                }
	                oldPage = $(pagesInView[pagesInView.length - 1]);
	                if (view.params.domCache) {
	                    if (oldPage[0] === newPage[0]) {
	                        oldPage = pagesContainer.children('.page.page-on-center');
	                        if (oldPage.length === 0 && view.activePage)
	                            oldPage = $(view.activePage.container);
	                    }
	                }
	                if (dynamicNavbar && !oldNavbarInner) {
	                    oldNavbarInner = $(navbarInners[navbarInners.length - 1]);
	                    if (view.params.domCache) {
	                        if (oldNavbarInner[0] === newNavbarInner[0]) {
	                            oldNavbarInner = navbar.children('.navbar-inner.navbar-on-center:not(.cached)');
	                        }
	                        if (oldNavbarInner.length === 0) {
	                            oldNavbarInner = navbar.children('.navbar-inner[data-page="' + oldPage.attr('data-page') + '"]');
	                        }
	                    }
	                    if (oldNavbarInner.length === 0 || newNavbarInner[0] === oldNavbarInner[0])
	                        dynamicNavbar = false;
	                }
	                if (dynamicNavbar) {
	                    if (manipulateDom)
	                        newNavbarInner.insertBefore(oldNavbarInner);
	                    newNavbarInner[0].f7RelatedPage = newPage[0];
	                    newPage[0].f7RelatedNavbar = newNavbarInner[0];
	                }
	                if (manipulateDom)
	                    newPage.insertBefore(oldPage);
	                // Page Init Events
	                app.pageInitCallback(view, {
	                    pageContainer: newPage[0],
	                    url: url,
	                    position: 'left',
	                    navbarInnerContainer: dynamicNavbar ? newNavbarInner[0] : undefined,
	                    oldNavbarInnerContainer: dynamicNavbar ? oldNavbarInner && oldNavbarInner[0] : undefined,
	                    context: t7_rendered.context,
	                    query: options.query,
	                    fromPage: oldPage && oldPage.length && oldPage[0].f7PageData,
	                    preloadOnly: preloadOnly
	                });
	                if (dynamicNavbar) {
	                    app.navbarInitCallback(view, newPage[0], navbar[0], newNavbarInner[0], url, 'right');
	                }
	                if (dynamicNavbar && newNavbarInner.hasClass('navbar-on-left') && animatePages) {
	                    app.router.prepareNavbar(newNavbarInner, oldNavbarInner, 'left');
	                }
	                if (preloadOnly) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                // Update View's URL
	                view.url = url;
	                // Force reLayout
	                var clientLeft = newPage[0].clientLeft;
	                animateBack();
	                // Push state
	                if (app.params.pushState && view.main) {
	                    if (typeof pushState === 'undefined')
	                        pushState = true;
	                    if (!preloadOnly && history.state && pushState) {
	                        history.back();
	                    }
	                }
	                return;
	            }
	            // Simple go back when we have pages on left
	            if (pagesInView.length > 1 && !force) {
	                // Exit if only preloadOnly
	                if (preloadOnly) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                // Update View's URL
	                view.url = view.history[view.history.length - 2];
	                url = view.url;
	                // Define old and new pages
	                newPage = $(pagesInView[pagesInView.length - 2]);
	                oldPage = $(pagesInView[pagesInView.length - 1]);
	                // Dynamic navbar
	                if (view.params.dynamicNavbar) {
	                    dynamicNavbar = true;
	                    // Find navbar
	                    navbarInners = viewContainer.children('.navbar').find('.navbar-inner:not(.cached)');
	                    newNavbarInner = $(navbarInners[0]);
	                    oldNavbarInner = $(navbarInners[1]);
	                    if (newNavbarInner.length === 0 || oldNavbarInner.length === 0 || oldNavbarInner[0] === newNavbarInner[0]) {
	                        dynamicNavbar = false;
	                    }
	                }
	                manipulateDom = false;
	                setPages();
	                return;
	            }
	            if (!force) {
	                // Go back when there is no pages on left
	                if (!preloadOnly) {
	                    view.url = view.history[view.history.length - 2];
	                    url = view.url;
	                }
	                if (content) {
	                    parseNewPage();
	                    setPages();
	                    return;
	                }
	                else if (pageName) {
	                    // Get dom cached pages
	                    newPage = $(viewContainer).find('.page[data-page="' + pageName + '"]');
	                    if (view.params.dynamicNavbar) {
	                        newNavbarInner = $(viewContainer).children('.navbar').find('.navbar-inner[data-page="' + pageName + '"]');
	                        if (newNavbarInner.length === 0 && newPage[0].f7RelatedNavbar) {
	                            newNavbarInner = $(newPage[0].f7RelatedNavbar);
	                        }
	                        if (newNavbarInner.length === 0 && newPage[0].f7PageData) {
	                            newNavbarInner = $(newPage[0].f7PageData.navbarInnerContainer);
	                        }
	                    }
	                    setPages();
	                    return;
	                }
	                else if (url && url in view.pageElementsCache) {
	                    newPage = view.pageElementsCache[url].page;
	                    newNavbarInner = view.pageElementsCache[url].navbarInner;
	                    setPages();
	                    return;
	                }
	                else {
	                    view.allowPageChange = true;
	                    return;
	                }
	            }
	            else {
	                if (url && url === view.url || pageName && view.activePage && view.activePage.name === pageName) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                // Go back with force url
	                if (content) {
	                    parseNewPage();
	                    setPages();
	                    return;
	                }
	                else if (pageName && view.params.domCache) {
	                    if (pageName)
	                        url = '#' + pageName;
	                    newPage = $(viewContainer).find('.page[data-page="' + pageName + '"]');
	                    if (newPage[0].f7PageData && newPage[0].f7PageData.url) {
	                        url = newPage[0].f7PageData.url;
	                    }
	                    if (view.params.dynamicNavbar) {
	                        newNavbarInner = $(viewContainer).children('.navbar').find('.navbar-inner[data-page="' + pageName + '"]');
	                        if (newNavbarInner.length === 0 && newPage[0].f7RelatedNavbar) {
	                            newNavbarInner = $(newPage[0].f7RelatedNavbar);
	                        }
	                        if (newNavbarInner.length === 0 && newPage[0].f7PageData) {
	                            newNavbarInner = $(newPage[0].f7PageData.navbarInnerContainer);
	                        }
	                    }
	                    setPages();
	                    return;
	                }
	                else if (pageElement && url) {
	                    newPage = $(pageElement);
	                    if (view.params.dynamicNavbar) {
	                        newNavbarInner = newPage.find('.navbar-inner').filter(function (index, el) {
	                            return $(el).parents(app.router._modalsSelector).length === 0;
	                        });
	                        if (newNavbarInner.length > 0) {
	                            newPage.prepend(newNavbarInner);
	                            app.router._remove(newPage.find('.navbar').filter(function (index, el) {
	                                return $(el).parents(app.router._modalsSelector).length === 0;
	                            }));
	                        }
	                    }
	                    setPages();
	                    return;
	                }
	                else {
	                    view.allowPageChange = true;
	                    return;
	                }
	            }
	        };
	        app.router.back = function (view, options) {
	            options = options || {};
	            if (app.routerPreOptions) {
	                options = app.routerPreOptions(view, options) || {};
	            }
	            if (options.component && app.componentLoader) {
	                try {
	                    app.componentLoader(view, options, function (newOptions) {
	                        app.router.load(view, newOptions);
	                    });
	                }
	                catch (e) { }
	                return;
	            }
	            if (app.router.preroute(view, options, true)) {
	                return false;
	            }
	            var url = options.url;
	            var content = options.content;
	            var pageName = options.pageName;
	            var pageElement = options.pageElement;
	            if (pageName) {
	                if (pageName.indexOf('?') > 0) {
	                    options.query = $.parseUrlQuery(pageName);
	                    options.pageName = pageName = pageName.split('?')[0];
	                }
	            }
	            var force = options.force;
	            if (!view.allowPageChange)
	                return false;
	            view.allowPageChange = false;
	            if (app.xhr && view.xhr && view.xhr === app.xhr) {
	                app.xhr.abort();
	                app.xhr = false;
	            }
	            var pagesInView = $(view.pagesContainer).find('.page:not(.cached)');
	            function proceed(content) {
	                app.router.preprocess(view, content, url, function (content) {
	                    options.content = content;
	                    app.router._back(view, options);
	                });
	            }
	            if (pagesInView.length > 1 && !force) {
	                // Simple go back to previos page in view
	                app.router._back(view, options);
	                return;
	            }
	            if (!force) {
	                url = view.history[view.history.length - 2] || options.url;
	                if (!options.url)
	                    options.url = url;
	                if (!url) {
	                    view.allowPageChange = true;
	                    return;
	                }
	                if (url.indexOf('#') === 0 && view.contentCache[url]) {
	                    proceed(view.contentCache[url]);
	                    return;
	                }
	                else if (url.indexOf('#') === 0 && view.params.domCache) {
	                    if (!pageName)
	                        options.pageName = url.split('#')[1];
	                    proceed();
	                    return;
	                }
	                else if (url && url in view.pageElementsCache) {
	                    proceed();
	                }
	                else if (url.indexOf('#') !== 0) {
	                    // Load ajax page
	                    app.get(options.url, view, options.ignoreCache, function (content, error) {
	                        if (error) {
	                            view.allowPageChange = true;
	                            return;
	                        }
	                        proceed(content);
	                    });
	                    return;
	                }
	            }
	            else {
	                // Go back with force url
	                if (!url && content) {
	                    proceed(content);
	                    return;
	                }
	                else if (!url && pageName) {
	                    if (pageName)
	                        url = '#' + pageName;
	                    proceed();
	                    return;
	                }
	                else if (url && pageElement) {
	                    proceed();
	                    return;
	                }
	                else if (url) {
	                    app.get(options.url, view, options.ignoreCache, function (content, error) {
	                        if (error) {
	                            view.allowPageChange = true;
	                            return;
	                        }
	                        proceed(content);
	                    });
	                    return;
	                }
	            }
	            view.allowPageChange = true;
	            return;
	        };
	        app.router.afterBack = function (view, oldPage, newPage) {
	            // Remove old page and set classes on new one
	            oldPage = $(oldPage);
	            newPage = $(newPage);
	            if (view.params.domCache && view.initialPages.indexOf(oldPage[0]) >= 0) {
	                oldPage.removeClass('page-from-center-to-right').addClass('cached');
	            }
	            else {
	                app.pageRemoveCallback(view, oldPage[0], 'right');
	                app.router._remove(oldPage);
	            }
	            newPage.removeClass('page-from-left-to-center page-on-left').addClass('page-on-center');
	            view.allowPageChange = true;
	            // Update View's History
	            var previousURL = view.history.pop();
	            var newNavbar;
	            // Updated dynamic navbar
	            if (view.params.dynamicNavbar) {
	                var inners = $(view.container).children('.navbar').find('.navbar-inner:not(.cached)');
	                var oldNavbar = $(oldPage[0].f7RelatedNavbar || inners[1]);
	                if (view.params.domCache && view.initialNavbars.indexOf(oldNavbar[0]) >= 0) {
	                    oldNavbar.removeClass('navbar-from-center-to-right').addClass('cached');
	                }
	                else {
	                    app.navbarRemoveCallback(view, oldPage[0], undefined, oldNavbar[0]);
	                    app.router._remove(oldNavbar);
	                }
	                newNavbar = $(inners[0]).removeClass('navbar-on-left navbar-from-left-to-center').addClass('navbar-on-center');
	            }
	            // Remove pages in dom cache
	            if (view.params.domCache) {
	                $(view.container).find('.page.cached').each(function () {
	                    var page = $(this);
	                    var pageUrl = page[0].f7PageData && page[0].f7PageData.url;
	                    if (pageUrl && view.history.indexOf(pageUrl) < 0 && view.initialPages.indexOf(this) < 0) {
	                        app.pageRemoveCallback(view, page[0], 'right');
	                        if (page[0].f7RelatedNavbar && view.params.dynamicNavbar)
	                            app.navbarRemoveCallback(view, page[0], undefined, page[0].f7RelatedNavbar);
	                        app.router._remove(page);
	                        if (page[0].f7RelatedNavbar && view.params.dynamicNavbar)
	                            app.router._remove(page[0].f7RelatedNavbar);
	                    }
	                });
	            }
	            // Check previous page is content based only and remove it from content cache
	            if (!view.params.domCache &&
	                previousURL &&
	                previousURL.indexOf('#') > -1 &&
	                (previousURL in view.contentCache) &&
	                // If the same page is in the history multiple times, don't remove it.
	                view.history.indexOf(previousURL) === -1) {
	                view.contentCache[previousURL] = null;
	                delete view.contentCache[previousURL];
	            }
	            if (previousURL &&
	                (previousURL in view.pageElementsCache) &&
	                // If the same page is in the history multiple times, don't remove it.
	                view.history.indexOf(previousURL) === -1) {
	                view.pageElementsCache[previousURL] = null;
	                delete view.pageElementsCache[previousURL];
	            }
	            // Check for context cache
	            if (previousURL &&
	                (previousURL in view.contextCache) &&
	                // If the same page is in the history multiple times, don't remove it.
	                view.history.indexOf(previousURL) === -1) {
	                view.contextCache[previousURL] = null;
	                delete view.contextCache[previousURL];
	            }
	            if (app.params.pushState && view.main)
	                app.pushStateClearQueue();
	            // Preload previous page
	            if (view.params.preloadPreviousPage) {
	                if (view.params.domCache && view.history.length > 1) {
	                    var preloadUrl = view.history[view.history.length - 2];
	                    var previousPage;
	                    var previousNavbar;
	                    if (preloadUrl && view.pagesCache[preloadUrl]) {
	                        // Load by page name
	                        previousPage = $(view.container).find('.page[data-page="' + view.pagesCache[preloadUrl] + '"]');
	                        if (previousPage.next('.page')[0] !== newPage[0])
	                            previousPage.insertBefore(newPage);
	                        if (newNavbar) {
	                            previousNavbar = $(view.container).children('.navbar').find('.navbar-inner[data-page="' + view.pagesCache[preloadUrl] + '"]');
	                            if (!previousNavbar || previousNavbar.length === 0)
	                                previousNavbar = newNavbar.prev('.navbar-inner.cached');
	                            if (previousNavbar.next('.navbar-inner')[0] !== newNavbar[0])
	                                previousNavbar.insertBefore(newNavbar);
	                        }
	                    }
	                    else {
	                        // Just load previous page
	                        previousPage = newPage.prev('.page.cached');
	                        if (newNavbar)
	                            previousNavbar = newNavbar.prev('.navbar-inner.cached');
	                    }
	                    if (previousPage && previousPage.length > 0)
	                        previousPage.removeClass('cached page-on-right page-on-center').addClass('page-on-left');
	                    if (previousNavbar && previousNavbar.length > 0)
	                        previousNavbar.removeClass('cached navbar-on-right navbar-on-center').addClass('navbar-on-left');
	                }
	                else {
	                    app.router.back(view, { preloadOnly: true });
	                }
	            }
	        };
	        /*======================================================
	        ************   Modals   ************
	        ======================================================*/
	        var _modalTemplateTempDiv = document.createElement('div');
	        app.modalStack = [];
	        app.modalStackClearQueue = function () {
	            if (app.modalStack.length) {
	                (app.modalStack.shift())();
	            }
	        };
	        app.modal = function (params) {
	            params = params || {};
	            var modalHTML = '';
	            if (app.params.modalTemplate) {
	                if (!app._compiledTemplates.modal)
	                    app._compiledTemplates.modal = t7.compile(app.params.modalTemplate);
	                modalHTML = app._compiledTemplates.modal(params);
	            }
	            else {
	                var buttonsHTML = '';
	                if (params.buttons && params.buttons.length > 0) {
	                    for (var i = 0; i < params.buttons.length; i++) {
	                        buttonsHTML += '<span class="modal-button' + (params.buttons[i].bold ? ' modal-button-bold' : '') + '">' + params.buttons[i].text + '</span>';
	                    }
	                }
	                var titleHTML = params.title ? '<div class="modal-title">' + params.title + '</div>' : '';
	                var textHTML = params.text ? '<div class="modal-text">' + params.text + '</div>' : '';
	                var afterTextHTML = params.afterText ? params.afterText : '';
	                var noButtons = !params.buttons || params.buttons.length === 0 ? 'modal-no-buttons' : '';
	                var verticalButtons = params.verticalButtons ? 'modal-buttons-vertical' : '';
	                var modalButtonsHTML = params.buttons && params.buttons.length > 0 ? '<div class="modal-buttons modal-buttons-' + params.buttons.length + ' ' + verticalButtons + '">' + buttonsHTML + '</div>' : '';
	                modalHTML = '<div class="modal ' + noButtons + ' ' + (params.cssClass || '') + '"><div class="modal-inner">' + (titleHTML + textHTML + afterTextHTML) + '</div>' + modalButtonsHTML + '</div>';
	            }
	            _modalTemplateTempDiv.innerHTML = modalHTML;
	            var modal = $(_modalTemplateTempDiv).children();
	            app.root.append(modal[0]);
	            // Add events on buttons
	            modal.find('.modal-button').each(function (index, el) {
	                $(el).on('click', function (e) {
	                    if (params.buttons[index].close !== false)
	                        app.closeModal(modal);
	                    if (params.buttons[index].onClick)
	                        params.buttons[index].onClick(modal, e);
	                    if (params.onClick)
	                        params.onClick(modal, index);
	                });
	            });
	            app.openModal(modal);
	            return modal[0];
	        };
	        app.alert = function (text, title, callbackOk) {
	            if (typeof title === 'function') {
	                callbackOk = arguments[1];
	                title = undefined;
	            }
	            return app.modal({
	                text: text || '',
	                title: typeof title === 'undefined' ? app.params.modalTitle : title,
	                buttons: [{ text: app.params.modalButtonOk, bold: true, onClick: callbackOk }]
	            });
	        };
	        app.confirm = function (text, title, callbackOk, callbackCancel) {
	            if (typeof title === 'function') {
	                callbackCancel = arguments[2];
	                callbackOk = arguments[1];
	                title = undefined;
	            }
	            return app.modal({
	                text: text || '',
	                title: typeof title === 'undefined' ? app.params.modalTitle : title,
	                buttons: [
	                    { text: app.params.modalButtonCancel, onClick: callbackCancel },
	                    { text: app.params.modalButtonOk, bold: true, onClick: callbackOk }
	                ]
	            });
	        };
	        app.prompt = function (text, title, callbackOk, callbackCancel) {
	            if (typeof title === 'function') {
	                callbackCancel = arguments[2];
	                callbackOk = arguments[1];
	                title = undefined;
	            }
	            return app.modal({
	                text: text || '',
	                title: typeof title === 'undefined' ? app.params.modalTitle : title,
	                afterText: '<div class="input-field"><input type="text" class="modal-text-input"></div>',
	                buttons: [
	                    {
	                        text: app.params.modalButtonCancel
	                    },
	                    {
	                        text: app.params.modalButtonOk,
	                        bold: true
	                    }
	                ],
	                onClick: function (modal, index) {
	                    if (index === 0 && callbackCancel)
	                        callbackCancel($(modal).find('.modal-text-input').val());
	                    if (index === 1 && callbackOk)
	                        callbackOk($(modal).find('.modal-text-input').val());
	                }
	            });
	        };
	        app.modalLogin = function (text, title, callbackOk, callbackCancel) {
	            if (typeof title === 'function') {
	                callbackCancel = arguments[2];
	                callbackOk = arguments[1];
	                title = undefined;
	            }
	            return app.modal({
	                text: text || '',
	                title: typeof title === 'undefined' ? app.params.modalTitle : title,
	                afterText: '<div class="input-field modal-input-double"><input type="text" name="modal-username" placeholder="' + app.params.modalUsernamePlaceholder + '" class="modal-text-input"></div><div class="input-field modal-input-double"><input type="password" name="modal-password" placeholder="' + app.params.modalPasswordPlaceholder + '" class="modal-text-input"></div>',
	                buttons: [
	                    {
	                        text: app.params.modalButtonCancel
	                    },
	                    {
	                        text: app.params.modalButtonOk,
	                        bold: true
	                    }
	                ],
	                onClick: function (modal, index) {
	                    var username = $(modal).find('.modal-text-input[name="modal-username"]').val();
	                    var password = $(modal).find('.modal-text-input[name="modal-password"]').val();
	                    if (index === 0 && callbackCancel)
	                        callbackCancel(username, password);
	                    if (index === 1 && callbackOk)
	                        callbackOk(username, password);
	                }
	            });
	        };
	        app.modalPassword = function (text, title, callbackOk, callbackCancel) {
	            if (typeof title === 'function') {
	                callbackCancel = arguments[2];
	                callbackOk = arguments[1];
	                title = undefined;
	            }
	            return app.modal({
	                text: text || '',
	                title: typeof title === 'undefined' ? app.params.modalTitle : title,
	                afterText: '<div class="input-field"><input type="password" name="modal-password" placeholder="' + app.params.modalPasswordPlaceholder + '" class="modal-text-input"></div>',
	                buttons: [
	                    {
	                        text: app.params.modalButtonCancel
	                    },
	                    {
	                        text: app.params.modalButtonOk,
	                        bold: true
	                    }
	                ],
	                onClick: function (modal, index) {
	                    var password = $(modal).find('.modal-text-input[name="modal-password"]').val();
	                    if (index === 0 && callbackCancel)
	                        callbackCancel(password);
	                    if (index === 1 && callbackOk)
	                        callbackOk(password);
	                }
	            });
	        };
	        app.showPreloader = function (title) {
	            return app.modal({
	                title: title || app.params.modalPreloaderTitle,
	                text: '<div class="preloader">' + (app.params.material ? app.params.materialPreloaderHtml : '') + '</div>',
	                cssClass: 'modal-preloader'
	            });
	        };
	        app.hidePreloader = function () {
	            app.closeModal('.modal-preloader');
	        };
	        app.showIndicator = function () {
	            if ($('.preloader-indicator-overlay').length > 0)
	                return;
	            app.root.append('<div class="preloader-indicator-overlay"></div><div class="preloader-indicator-modal"><span class="preloader preloader-white">' + (app.params.material ? app.params.materialPreloaderHtml : '') + '</span></div>');
	        };
	        app.hideIndicator = function () {
	            $('.preloader-indicator-overlay, .preloader-indicator-modal').remove();
	        };
	        // Action Sheet
	        app.actions = function (target, params, animated) {
	            var toPopover = false, modal, groupSelector, buttonSelector;
	            if (arguments.length === 1 || arguments.length === 2 && typeof arguments[1] === 'boolean') {
	                // Actions
	                params = arguments[0];
	                animated = arguments[1];
	            }
	            else {
	                // Popover
	                if (app.device.ios) {
	                    if (app.device.ipad)
	                        toPopover = true;
	                }
	                else {
	                    if (app.width >= 768)
	                        toPopover = true;
	                }
	            }
	            if (typeof animated === 'undefined')
	                animated = true;
	            params = params || [];
	            if (params.length > 0 && !Array.isArray(params[0])) {
	                params = [params];
	            }
	            var modalHTML;
	            if (toPopover) {
	                var actionsToPopoverTemplate = app.params.modalActionsToPopoverTemplate ||
	                    '<div class="popover actions-popover">' +
	                        '<div class="popover-inner">' +
	                        '{{#each this}}' +
	                        '<div class="list-block">' +
	                        '<ul>' +
	                        '{{#each this}}' +
	                        '{{#if label}}' +
	                        '<li class="actions-popover-label {{#if color}}color-{{color}}{{/if}} {{#if bold}}actions-popover-bold{{/if}}">{{text}}</li>' +
	                        '{{else}}' +
	                        '<li><a href="#" class="item-link list-button {{#if color}}color-{{color}}{{/if}} {{#if bg}}bg-{{bg}}{{/if}} {{#if bold}}actions-popover-bold{{/if}} {{#if disabled}}disabled{{/if}}">{{text}}</a></li>' +
	                        '{{/if}}' +
	                        '{{/each}}' +
	                        '</ul>' +
	                        '</div>' +
	                        '{{/each}}' +
	                        '</div>' +
	                        '</div>';
	                if (!app._compiledTemplates.actionsToPopover) {
	                    app._compiledTemplates.actionsToPopover = t7.compile(actionsToPopoverTemplate);
	                }
	                var popoverHTML = app._compiledTemplates.actionsToPopover(params);
	                modal = $(app.popover(popoverHTML, target, true, animated));
	                groupSelector = '.list-block ul';
	                buttonSelector = '.list-button';
	            }
	            else {
	                if (app.params.modalActionsTemplate) {
	                    if (!app._compiledTemplates.actions)
	                        app._compiledTemplates.actions = t7.compile(app.params.modalActionsTemplate);
	                    modalHTML = app._compiledTemplates.actions(params);
	                }
	                else {
	                    var buttonsHTML = '';
	                    for (var i = 0; i < params.length; i++) {
	                        for (var j = 0; j < params[i].length; j++) {
	                            if (j === 0)
	                                buttonsHTML += '<div class="actions-modal-group">';
	                            var button = params[i][j];
	                            var buttonClass = button.label ? 'actions-modal-label' : 'actions-modal-button';
	                            if (button.bold)
	                                buttonClass += ' actions-modal-button-bold';
	                            if (button.color)
	                                buttonClass += ' color-' + button.color;
	                            if (button.bg)
	                                buttonClass += ' bg-' + button.bg;
	                            if (button.disabled)
	                                buttonClass += ' disabled';
	                            buttonsHTML += '<div class="' + buttonClass + '">' + button.text + '</div>';
	                            if (j === params[i].length - 1)
	                                buttonsHTML += '</div>';
	                        }
	                    }
	                    modalHTML = '<div class="actions-modal">' + buttonsHTML + '</div>';
	                }
	                _modalTemplateTempDiv.innerHTML = modalHTML;
	                modal = $(_modalTemplateTempDiv).children();
	                app.root.append(modal[0]);
	                groupSelector = '.actions-modal-group';
	                buttonSelector = '.actions-modal-button';
	            }
	            var groups = modal.find(groupSelector);
	            groups.each(function (index, el) {
	                var groupIndex = index;
	                $(el).children().each(function (index, el) {
	                    var buttonIndex = index;
	                    var buttonParams = params[groupIndex][buttonIndex];
	                    var clickTarget;
	                    if (!toPopover && $(el).is(buttonSelector))
	                        clickTarget = $(el);
	                    if (toPopover && $(el).find(buttonSelector).length > 0)
	                        clickTarget = $(el).find(buttonSelector);
	                    if (clickTarget) {
	                        clickTarget.on('click', function (e) {
	                            if (buttonParams.close !== false)
	                                app.closeModal(modal);
	                            if (buttonParams.onClick)
	                                buttonParams.onClick(modal, e);
	                        });
	                    }
	                });
	            });
	            if (!toPopover)
	                app.openModal(modal, animated);
	            return modal[0];
	        };
	        app.popover = function (modal, target, removeOnClose, animated, closeByOutside) {
	            if (typeof removeOnClose === 'undefined')
	                removeOnClose = true;
	            if (typeof closeByOutside === 'undefined')
	                closeByOutside = true;
	            if (typeof animated === 'undefined')
	                animated = true;
	            if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
	                var _modal = document.createElement('div');
	                _modal.innerHTML = modal.trim();
	                if (_modal.childNodes.length > 0) {
	                    modal = _modal.childNodes[0];
	                    if (removeOnClose)
	                        modal.classList.add('remove-on-close');
	                    if (!closeByOutside)
	                        modal.classList.add('ignore-close-by-outside');
	                    app.root.append(modal);
	                }
	                else
	                    return false; //nothing found
	            }
	            modal = $(modal);
	            target = $(target);
	            if (modal.length === 0 || target.length === 0)
	                return false;
	            if (modal.parents('body').length === 0) {
	                if (removeOnClose)
	                    modal.addClass('remove-on-close');
	                if (!closeByOutside)
	                    modal.addClass.add('ignore-close-by-outside');
	                app.root.append(modal[0]);
	            }
	            if (modal.find('.popover-angle').length === 0 && !app.params.material) {
	                modal.append('<div class="popover-angle"></div>');
	            }
	            modal.show();
	            var material = app.params.material;
	            function sizePopover() {
	                modal.css({ left: '', top: '' });
	                var modalWidth = modal.width();
	                var modalHeight = modal.height(); // 13 - height of angle
	                var modalAngle, modalAngleSize = 0, modalAngleLeft, modalAngleTop;
	                if (!material) {
	                    modalAngle = modal.find('.popover-angle');
	                    modalAngleSize = modalAngle.width() / 2;
	                    modalAngle.removeClass('on-left on-right on-top on-bottom').css({ left: '', top: '' });
	                }
	                else {
	                    modal.removeClass('popover-on-left popover-on-right popover-on-top popover-on-bottom').css({ left: '', top: '' });
	                }
	                var targetWidth = target.outerWidth();
	                var targetHeight = target.outerHeight();
	                var targetOffset = target.offset();
	                var targetOffsetLeft = targetOffset.left - app.left;
	                var targetOffsetTop = targetOffset.top - app.top;
	                var targetParentPage = target.parents('.page');
	                if (targetParentPage.length > 0) {
	                    targetOffsetTop = targetOffsetTop - targetParentPage[0].scrollTop;
	                }
	                var modalTop = 0;
	                var modalLeft = 0;
	                var diff = 0;
	                // Top Position
	                var modalPosition = material ? 'bottom' : 'top';
	                if (material) {
	                    if (modalHeight < app.height - targetOffsetTop - targetHeight) {
	                        // On bottom
	                        modalPosition = 'bottom';
	                        modalTop = targetOffsetTop;
	                    }
	                    else if (modalHeight < targetOffsetTop) {
	                        // On top
	                        modalTop = targetOffsetTop - modalHeight + targetHeight;
	                        modalPosition = 'top';
	                    }
	                    else {
	                        // On middle
	                        modalPosition = 'bottom';
	                        modalTop = targetOffsetTop;
	                    }
	                    if (modalTop <= 0) {
	                        modalTop = 8;
	                    }
	                    else if (modalTop + modalHeight >= app.height) {
	                        modalTop = app.height - modalHeight - 8;
	                    }
	                    // Horizontal Position
	                    modalLeft = targetOffsetLeft;
	                    if (modalLeft + modalWidth >= app.width - 8) {
	                        modalLeft = targetOffsetLeft + targetWidth - modalWidth - 8;
	                    }
	                    if (modalLeft < 8) {
	                        modalLeft = 8;
	                    }
	                    if (modalPosition === 'top') {
	                        modal.addClass('popover-on-top');
	                    }
	                    if (modalPosition === 'bottom') {
	                        modal.addClass('popover-on-bottom');
	                    }
	                    if (target.hasClass('floating-button-to-popover') && !modal.hasClass('modal-in')) {
	                        modal.addClass('popover-floating-button');
	                        var diffX = (modalLeft + modalWidth / 2) - (targetOffsetLeft + targetWidth / 2), diffY = (modalTop + modalHeight / 2) - (targetOffsetTop + targetHeight / 2);
	                        target
	                            .addClass('floating-button-to-popover-in')
	                            .transform('translate3d(' + diffX + 'px, ' + diffY + 'px,0)')
	                            .transitionEnd(function (e) {
	                            if (!target.hasClass('floating-button-to-popover-in'))
	                                return;
	                            target
	                                .addClass('floating-button-to-popover-scale')
	                                .transform('translate3d(' + diffX + 'px, ' + diffY + 'px,0) scale(' + (modalWidth / targetWidth) + ', ' + (modalHeight / targetHeight) + ')');
	                        });
	                        modal.once('popover:close', function () {
	                            target
	                                .removeClass('floating-button-to-popover-in floating-button-to-popover-scale')
	                                .addClass('floating-button-to-popover-out')
	                                .transform('')
	                                .transitionEnd(function (e) {
	                                target.removeClass('floating-button-to-popover-out');
	                            });
	                        });
	                        modal.once('popover:closed', function () {
	                            modal.removeClass('popover-floating-button');
	                        });
	                    }
	                    else if (target.hasClass('floating-button-to-popover') && modal.hasClass('modal-in')) {
	                        modalLeft = targetOffsetLeft;
	                        modalTop = targetOffsetTop;
	                    }
	                }
	                else {
	                    if ((modalHeight + modalAngleSize) < targetOffsetTop) {
	                        // On top
	                        modalTop = targetOffsetTop - modalHeight - modalAngleSize;
	                    }
	                    else if ((modalHeight + modalAngleSize) < app.height - targetOffsetTop - targetHeight) {
	                        // On bottom
	                        modalPosition = 'bottom';
	                        modalTop = targetOffsetTop + targetHeight + modalAngleSize;
	                    }
	                    else {
	                        // On middle
	                        modalPosition = 'middle';
	                        modalTop = targetHeight / 2 + targetOffsetTop - modalHeight / 2;
	                        diff = modalTop;
	                        if (modalTop <= 0) {
	                            modalTop = 5;
	                        }
	                        else if (modalTop + modalHeight >= app.height) {
	                            modalTop = app.height - modalHeight - 5;
	                        }
	                        diff = diff - modalTop;
	                    }
	                    // Horizontal Position
	                    if (modalPosition === 'top' || modalPosition === 'bottom') {
	                        modalLeft = targetWidth / 2 + targetOffsetLeft - modalWidth / 2;
	                        diff = modalLeft;
	                        if (modalLeft < 5)
	                            modalLeft = 5;
	                        if (modalLeft + modalWidth > app.width)
	                            modalLeft = app.width - modalWidth - 5;
	                        if (modalPosition === 'top') {
	                            modalAngle.addClass('on-bottom');
	                        }
	                        if (modalPosition === 'bottom') {
	                            modalAngle.addClass('on-top');
	                        }
	                        diff = diff - modalLeft;
	                        modalAngleLeft = (modalWidth / 2 - modalAngleSize + diff);
	                        modalAngleLeft = Math.max(Math.min(modalAngleLeft, modalWidth - modalAngleSize * 2 - 13), 13);
	                        modalAngle.css({ left: modalAngleLeft + 'px' });
	                    }
	                    else if (modalPosition === 'middle') {
	                        modalLeft = targetOffsetLeft - modalWidth - modalAngleSize;
	                        modalAngle.addClass('on-right');
	                        if (modalLeft < 5 || (modalLeft + modalWidth > app.width)) {
	                            if (modalLeft < 5)
	                                modalLeft = targetOffsetLeft + targetWidth + modalAngleSize;
	                            if (modalLeft + modalWidth > app.width)
	                                modalLeft = app.width - modalWidth - 5;
	                            modalAngle.removeClass('on-right').addClass('on-left');
	                        }
	                        modalAngleTop = (modalHeight / 2 - modalAngleSize + diff);
	                        modalAngleTop = Math.max(Math.min(modalAngleTop, modalHeight - modalAngleSize * 2 - 13), 13);
	                        modalAngle.css({ top: modalAngleTop + 'px' });
	                    }
	                }
	                // Apply Styles
	                modal.css({ top: modalTop + 'px', left: modalLeft + 'px' });
	            }
	            sizePopover();
	            app.onResize(sizePopover);
	            modal.on('popover:close', function () {
	                app.offResize(sizePopover);
	            });
	            app.openModal(modal, animated);
	            return modal[0];
	        };
	        app.popup = function (modal, removeOnClose, animated) {
	            if (typeof removeOnClose === 'undefined')
	                removeOnClose = true;
	            if (typeof animated === 'undefined')
	                animated = true;
	            if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
	                var _modal = document.createElement('div');
	                _modal.innerHTML = modal.trim();
	                if (_modal.childNodes.length > 0) {
	                    modal = _modal.childNodes[0];
	                    if (removeOnClose)
	                        modal.classList.add('remove-on-close');
	                    app.root.append(modal);
	                }
	                else
	                    return false; //nothing found
	            }
	            modal = $(modal);
	            if (modal.length === 0)
	                return false;
	            if (modal.parents('body').length === 0) {
	                if (removeOnClose)
	                    modal.addClass('remove-on-close');
	                app.root.append(modal[0]);
	            }
	            modal.show();
	            app.openModal(modal, animated);
	            return modal[0];
	        };
	        app.pickerModal = function (modal, removeOnClose, animated) {
	            if (typeof removeOnClose === 'undefined')
	                removeOnClose = true;
	            if (typeof animated === 'undefined')
	                animated = true;
	            if (typeof modal === 'string' && modal.indexOf('<') >= 0) {
	                modal = $(modal);
	                if (modal.length > 0) {
	                    if (removeOnClose)
	                        modal.addClass('remove-on-close');
	                    app.root.append(modal[0]);
	                }
	                else
	                    return false; //nothing found
	            }
	            modal = $(modal);
	            if (modal.length === 0)
	                return false;
	            if (modal.parents('body').length === 0) {
	                if (removeOnClose)
	                    modal.addClass('remove-on-close');
	                app.root.append(modal[0]);
	            }
	            if ($('.picker-modal.modal-in:not(.modal-out)').length > 0 && !modal.hasClass('modal-in')) {
	                app.closeModal('.picker-modal.modal-in:not(.modal-out)');
	            }
	            modal.show();
	            app.openModal(modal, animated);
	            return modal[0];
	        };
	        app.loginScreen = function (modal, animated) {
	            if (!modal)
	                modal = '.login-screen';
	            if (typeof animated === 'undefined')
	                animated = true;
	            modal = $(modal);
	            if (modal.length === 0)
	                return false;
	            if ($('.login-screen.modal-in:not(.modal-out)').length > 0 && !modal.hasClass('modal-in')) {
	                app.closeModal('.login-screen.modal-in:not(.modal-out)');
	            }
	            modal.show();
	            app.openModal(modal, animated);
	            return modal[0];
	        };
	        app.openModal = function (modal, animated) {
	            if (typeof animated === 'undefined')
	                animated = true;
	            modal = $(modal);
	            modal[animated ? 'removeClass' : 'addClass']('not-animated');
	            var isModal = modal.hasClass('modal');
	            var isPopover = modal.hasClass('popover');
	            var isPopup = modal.hasClass('popup');
	            var isLoginScreen = modal.hasClass('login-screen');
	            var isPickerModal = modal.hasClass('picker-modal');
	            var isActions = modal.hasClass('actions-modal');
	            // Modal Event Prefix
	            var modalType = 'modal';
	            if (isPopover)
	                modalType = 'popover';
	            if (isPopup)
	                modalType = 'popup';
	            if (isLoginScreen)
	                modalType = 'loginscreen';
	            if (isPickerModal)
	                modalType = 'picker';
	            if (isActions)
	                modalType = 'actions';
	            if ($('.modal.modal-in:not(.modal-out)').length && app.params.modalStack && isModal) {
	                app.modalStack.push(function () {
	                    app.openModal(modal);
	                });
	                return;
	            }
	            // do nothing if this modal already shown
	            if (true === modal.data('f7-modal-shown')) {
	                return;
	            }
	            modal.data('f7-modal-shown', true);
	            // Move modal
	            var modalParent = modal.parent();
	            if (app.params.modalsMoveToRoot && !modalParent.is(app.root)) {
	                app.root.append(modal);
	                modal.once(modalType + ':closed', function () {
	                    modalParent.append(modal);
	                });
	            }
	            modal.once(modalType + ':close', function () {
	                modal.removeData('f7-modal-shown');
	            });
	            if (isModal) {
	                modal.show();
	                modal.css({
	                    marginTop: -Math.round(modal.outerHeight() / 2) + 'px'
	                });
	            }
	            var overlay;
	            if (!isLoginScreen && !isPickerModal) {
	                if ($('.modal-overlay').length === 0 && !isPopup) {
	                    app.root.append('<div class="modal-overlay"></div>');
	                }
	                if ($('.popup-overlay').length === 0 && isPopup) {
	                    app.root.append('<div class="popup-overlay"></div>');
	                }
	                overlay = isPopup ? $('.popup-overlay') : $('.modal-overlay');
	            }
	            if (app.params.material && isPickerModal) {
	                if (modal.hasClass('picker-calendar')) {
	                    if ($('.picker-modal-overlay').length === 0 && !isPopup) {
	                        app.root.append('<div class="picker-modal-overlay"></div>');
	                    }
	                    overlay = $('.picker-modal-overlay');
	                }
	            }
	            if (overlay) {
	                overlay[animated ? 'removeClass' : 'addClass']('not-animated');
	            }
	            //Make sure that styles are applied, trigger relayout;
	            var clientLeft = modal[0].clientLeft;
	            // Trugger open event
	            modal.trigger('open ' + modalType + ':open');
	            // Picker modal body class
	            if (isPickerModal) {
	                $('body').addClass('with-picker-modal');
	            }
	            // Init Pages and Navbars in modal
	            if (modal.find('.' + app.params.viewClass).length > 0) {
	                modal.find('.page').each(function () {
	                    app.initPageWithCallback(this);
	                });
	                modal.find('.navbar').each(function () {
	                    app.initNavbarWithCallback(this);
	                });
	            }
	            // Classes for transition in
	            if (!isLoginScreen && !isPickerModal)
	                overlay.addClass('modal-overlay-visible');
	            if (app.params.material && isPickerModal && overlay)
	                overlay.addClass('modal-overlay-visible');
	            if (animated) {
	                modal.removeClass('modal-out').addClass('modal-in').transitionEnd(function (e) {
	                    if (modal.hasClass('modal-out'))
	                        modal.trigger('closed ' + modalType + ':closed');
	                    else
	                        modal.trigger('opened ' + modalType + ':opened');
	                });
	            }
	            else {
	                modal.removeClass('modal-out').addClass('modal-in');
	                modal.trigger('opened ' + modalType + ':opened');
	            }
	            return true;
	        };
	        app.closeModal = function (modal, animated) {
	            if (typeof animated === 'undefined')
	                animated = true;
	            modal = $(modal || '.modal-in');
	            if (typeof modal !== 'undefined' && modal.length === 0) {
	                return;
	            }
	            modal[animated ? 'removeClass' : 'addClass']('not-animated');
	            var isModal = modal.hasClass('modal');
	            var isPopover = modal.hasClass('popover');
	            var isPopup = modal.hasClass('popup');
	            var isLoginScreen = modal.hasClass('login-screen');
	            var isPickerModal = modal.hasClass('picker-modal');
	            var isActions = modal.hasClass('actions-modal');
	            // Modal Event Prefix
	            var modalType = 'modal';
	            if (isPopover)
	                modalType = 'popover';
	            if (isPopup)
	                modalType = 'popup';
	            if (isLoginScreen)
	                modalType = 'loginscreen';
	            if (isPickerModal)
	                modalType = 'picker';
	            if (isActions)
	                modalType = 'actions';
	            var removeOnClose = modal.hasClass('remove-on-close');
	            // ignore close popover
	            if (isPopover && !removeOnClose && modal.hasClass('ignore-close-by-outside')) {
	                return;
	            }
	            // For Actions
	            var keepOnClose = modal.hasClass('keep-on-close');
	            var overlay;
	            if (isPopup)
	                overlay = $('.popup-overlay');
	            else {
	                if (isPickerModal && app.params.material)
	                    overlay = $('.picker-modal-overlay');
	                else if (!isPickerModal)
	                    overlay = $('.modal-overlay');
	            }
	            if (isPopup) {
	                if (modal.length === $('.popup.modal-in').length) {
	                    overlay.removeClass('modal-overlay-visible');
	                }
	            }
	            else if (overlay && overlay.length > 0) {
	                overlay.removeClass('modal-overlay-visible');
	            }
	            if (overlay)
	                overlay[animated ? 'removeClass' : 'addClass']('not-animated');
	            modal.trigger('close ' + modalType + ':close');
	            // Picker modal body class
	            if (isPickerModal) {
	                $('body').removeClass('with-picker-modal');
	                $('body').addClass('picker-modal-closing');
	            }
	            if (!(isPopover && !app.params.material)) {
	                if (animated) {
	                    modal.removeClass('modal-in').addClass('modal-out').transitionEnd(function (e) {
	                        if (modal.hasClass('modal-out'))
	                            modal.trigger('closed ' + modalType + ':closed');
	                        else {
	                            modal.trigger('opened ' + modalType + ':opened');
	                            if (isPopover)
	                                return;
	                        }
	                        if (isPickerModal) {
	                            $('body').removeClass('picker-modal-closing');
	                        }
	                        if (isPopup || isLoginScreen || isPickerModal || isPopover) {
	                            modal.removeClass('modal-out').hide();
	                            if (removeOnClose && modal.length > 0) {
	                                modal.remove();
	                            }
	                        }
	                        else if (!keepOnClose) {
	                            modal.remove();
	                        }
	                    });
	                }
	                else {
	                    modal.trigger('closed ' + modalType + ':closed');
	                    modal.removeClass('modal-in modal-out');
	                    if (isPickerModal) {
	                        $('body').removeClass('picker-modal-closing');
	                    }
	                    if (isPopup || isLoginScreen || isPickerModal || isPopover) {
	                        modal.hide();
	                        if (removeOnClose && modal.length > 0) {
	                            modal.remove();
	                        }
	                    }
	                    else if (!keepOnClose) {
	                        modal.remove();
	                    }
	                }
	                if (isModal && app.params.modalStack) {
	                    app.modalStackClearQueue();
	                }
	            }
	            else {
	                modal.removeClass('modal-in modal-out not-animated').trigger('closed ' + modalType + ':closed').hide();
	                if (removeOnClose) {
	                    modal.remove();
	                }
	            }
	            return true;
	        };
	        /*===============================================================================
	        ************   Progress Bar   ************
	        ===============================================================================*/
	        app.setProgressbar = function (container, progress, speed) {
	            container = $(container || app.root);
	            if (container.length === 0)
	                return;
	            if (progress)
	                progress = Math.min(Math.max(progress, 0), 100);
	            var progressbar;
	            if (container.hasClass('progressbar'))
	                progressbar = container;
	            else {
	                progressbar = container.children('.progressbar');
	            }
	            if (progressbar.length === 0 || progressbar.hasClass('progressbar-infinite'))
	                return;
	            var clientLeft = progressbar[0].clientLeft;
	            progressbar.children('span').transform('translate3d(' + (-100 + progress) + '%,0,0)');
	            if (typeof speed !== 'undefined') {
	                progressbar.children('span').transition(speed);
	            }
	            else {
	                progressbar.children('span').transition('');
	            }
	            return progressbar[0];
	        };
	        app.showProgressbar = function (container, progress, color) {
	            if (typeof container === 'number') {
	                container = app.root;
	                progress = arguments[0];
	                color = arguments[1];
	            }
	            if (progress && typeof progress === 'string' && parseFloat(progress) !== progress * 1) {
	                color = progress;
	                progress = undefined;
	            }
	            container = $(container || app.root);
	            if (container.length === 0)
	                return;
	            var progressbar;
	            if (container.hasClass('progressbar'))
	                progressbar = container;
	            else {
	                progressbar = container.children('.progressbar:not(.progressbar-out), .progressbar-infinite:not(.progressbar-out)');
	                if (progressbar.length === 0) {
	                    // Create one
	                    if (typeof progress !== 'undefined') {
	                        // Determined
	                        progressbar = $('<span class="progressbar progressbar-in' + (color ? ' color-' + color : '') + '"><span></span></span>');
	                    }
	                    else {
	                        // Infinite
	                        progressbar = $('<span class="progressbar-infinite progressbar-in' + (color ? ' color-' + color : '') + '"></span>');
	                    }
	                    container.append(progressbar);
	                }
	            }
	            if (progress)
	                app.setProgressbar(container, progress);
	            return progressbar[0];
	        };
	        app.hideProgressbar = function (container) {
	            container = $(container || app.root);
	            if (container.length === 0)
	                return;
	            var progressbar;
	            if (container.hasClass('progressbar'))
	                progressbar = container;
	            else {
	                progressbar = container.children('.progressbar, .progressbar-infinite');
	            }
	            if (progressbar.length === 0 || !progressbar.hasClass('progressbar-in') || progressbar.hasClass('progressbar-out'))
	                return;
	            progressbar.removeClass('progressbar-in').addClass('progressbar-out').animationEnd(function () {
	                progressbar.remove();
	                progressbar = null;
	            });
	            return;
	        };
	        app.initPageProgressbar = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            pageContainer.find('.progressbar').each(function () {
	                var p = $(this);
	                if (p.children('span').length === 0)
	                    p.append('<span></span>');
	                if (p.attr('data-progress'))
	                    app.setProgressbar(p, p.attr('data-progress'));
	            });
	        };
	        /*======================================================
	        ************   Panels   ************
	        ======================================================*/
	        app.allowPanelOpen = true;
	        app.openPanel = function (panelPosition, animated) {
	            if (typeof animated === 'undefined')
	                animated = true;
	            if (!app.allowPanelOpen)
	                return false;
	            var panel = $('.panel-' + panelPosition);
	            if (panel.length === 0 || panel.hasClass('active') || panel.hasClass('panel-visible-by-breakpoint'))
	                return false;
	            app.closePanel(); // Close if some panel is opened
	            app.allowPanelOpen = false;
	            var effect = panel.hasClass('panel-reveal') ? 'reveal' : 'cover';
	            panel[animated ? 'removeClass' : 'addClass']('not-animated');
	            panel.css({ display: 'block' }).addClass('active');
	            panel.trigger('open panel:open');
	            var panelOverlay = $('.panel-overlay');
	            panelOverlay[animated ? 'removeClass' : 'addClass']('not-animated');
	            panelOverlay.show();
	            if (panel.find('.' + app.params.viewClass).length > 0) {
	                if (app.sizeNavbars)
	                    app.sizeNavbars(panel.find('.' + app.params.viewClass)[0]);
	            }
	            // Trigger reLayout
	            var clientLeft = panel[0].clientLeft;
	            // Transition End;
	            var transitionEndTarget = effect === 'reveal' ? $('.' + app.params.viewsClass) : panel;
	            function panelTransitionEnd() {
	                transitionEndTarget.transitionEnd(function (e) {
	                    if ($(e.target).is(transitionEndTarget)) {
	                        if (panel.hasClass('active')) {
	                            panel.trigger('opened panel:opened');
	                        }
	                        else {
	                            panel.trigger('closed panel:closed');
	                        }
	                        panelOverlay.css({ display: '' });
	                        app.allowPanelOpen = true;
	                    }
	                    else
	                        panelTransitionEnd();
	                });
	            }
	            if (animated) {
	                panelTransitionEnd();
	            }
	            else {
	                panel.trigger('opened panel:opened');
	                panelOverlay.css({ display: '' });
	                app.allowPanelOpen = true;
	            }
	            $('body').addClass('with-panel-' + panelPosition + '-' + effect);
	            return true;
	        };
	        app.closePanel = function (animated) {
	            if (typeof animated === 'undefined')
	                animated = true;
	            var activePanel = $('.panel.active');
	            if (activePanel.length === 0 || activePanel.hasClass('panel-visible-by-breakpoint'))
	                return false;
	            var effect = activePanel.hasClass('panel-reveal') ? 'reveal' : 'cover';
	            var panelPosition = activePanel.hasClass('panel-left') ? 'left' : 'right';
	            activePanel[animated ? 'removeClass' : 'addClass']('not-animated');
	            activePanel.removeClass('active');
	            var panelOverlay = $('.panel-overlay');
	            panelOverlay.removeClass('not-animated');
	            var transitionEndTarget = effect === 'reveal' ? $('.' + app.params.viewsClass) : activePanel;
	            activePanel.trigger('close panel:close');
	            app.allowPanelOpen = false;
	            if (animated) {
	                transitionEndTarget.transitionEnd(function () {
	                    if (activePanel.hasClass('active'))
	                        return;
	                    activePanel.css({ display: '' });
	                    activePanel.trigger('closed panel:closed');
	                    $('body').removeClass('panel-closing');
	                    app.allowPanelOpen = true;
	                });
	                $('body').addClass('panel-closing').removeClass('with-panel-' + panelPosition + '-' + effect);
	            }
	            else {
	                activePanel.css({ display: '' });
	                activePanel.trigger('closed panel:closed');
	                activePanel.removeClass('not-animated');
	                $('body').removeClass('with-panel-' + panelPosition + '-' + effect);
	                app.allowPanelOpen = true;
	            }
	        };
	        /*======================================================
	        ************   Panels breakpoints   ************
	        ======================================================*/
	        app.initPanelsBreakpoints = function () {
	            var panelLeft = $('.panel-left');
	            var panelRight = $('.panel-right');
	            var views = app.root.children('.views');
	            var wasVisible;
	            function setPanels() {
	                // Left Panel
	                if (app.params.panelLeftBreakpoint && panelLeft.length > 0) {
	                    wasVisible = panelLeft.hasClass('panel-visible-by-breakpoint');
	                    if (app.width >= app.params.panelLeftBreakpoint) {
	                        if (!wasVisible) {
	                            $('body').removeClass('with-panel-left-reveal with-panel-left-cover');
	                            panelLeft.css('display', '').addClass('panel-visible-by-breakpoint').removeClass('active');
	                            panelLeft.trigger('open panel:open opened panel:opened');
	                            views.css({
	                                'margin-left': panelLeft.width() + 'px'
	                            });
	                            app.allowPanelOpen = true;
	                        }
	                    }
	                    else {
	                        if (wasVisible) {
	                            panelLeft.css('display', '').removeClass('panel-visible-by-breakpoint active');
	                            panelLeft.trigger('close panel:close closed panel:closed');
	                            views.css({
	                                'margin-left': ''
	                            });
	                            app.allowPanelOpen = true;
	                        }
	                    }
	                }
	                // Right Panel
	                if (app.params.panelRightBreakpoint && panelRight.length > 0) {
	                    wasVisible = panelRight.hasClass('panel-visible-by-breakpoint');
	                    if (app.width >= app.params.panelRightBreakpoint) {
	                        if (!wasVisible) {
	                            $('body').removeClass('with-panel-right-reveal with-panel-right-cover');
	                            panelRight.css('display', '').addClass('panel-visible-by-breakpoint').removeClass('active');
	                            panelRight.trigger('open panel:open opened panel:opened');
	                            views.css({
	                                'margin-right': panelRight.width() + 'px'
	                            });
	                            app.allowPanelOpen = true;
	                        }
	                    }
	                    else {
	                        if (wasVisible) {
	                            panelRight.css('display', '').removeClass('panel-visible-by-breakpoint active');
	                            panelRight.trigger('close panel:close closed panel:closed');
	                            views.css({
	                                'margin-right': ''
	                            });
	                            app.allowPanelOpen = true;
	                        }
	                    }
	                }
	            }
	            app.onResize(setPanels);
	            setPanels();
	        };
	        /*======================================================
	        ************   Swipe panels   ************
	        ======================================================*/
	        app.initSwipePanels = function () {
	            var panel, side;
	            if (app.params.swipePanel) {
	                panel = $('.panel.panel-' + app.params.swipePanel);
	                side = app.params.swipePanel;
	                if (panel.length === 0 && side !== 'both')
	                    return;
	            }
	            else {
	                if (app.params.swipePanelOnlyClose) {
	                    if ($('.panel').length === 0)
	                        return;
	                }
	                else
	                    return;
	            }
	            var panelOverlay = $('.panel-overlay');
	            var isTouched, isMoved, isScrolling, touchesStart = {}, touchStartTime, touchesDiff, translate, overlayOpacity, opened, panelWidth, effect, direction;
	            var views = $('.' + app.params.viewsClass);
	            function handleTouchStart(e) {
	                if (!app.allowPanelOpen || (!app.params.swipePanel && !app.params.swipePanelOnlyClose) || isTouched)
	                    return;
	                if ($('.modal-in, .photo-browser-in').length > 0)
	                    return;
	                if (!(app.params.swipePanelCloseOpposite || app.params.swipePanelOnlyClose)) {
	                    if ($('.panel.active').length > 0 && !panel.hasClass('active'))
	                        return;
	                }
	                if (e.target && e.target.nodeName.toLowerCase() === 'input' && e.target.type === 'range')
	                    return;
	                if ($(e.target).closest('.tabs-swipeable-wrap').length > 0)
	                    return;
	                touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                if (app.params.swipePanelCloseOpposite || app.params.swipePanelOnlyClose) {
	                    if ($('.panel.active').length > 0) {
	                        side = $('.panel.active').hasClass('panel-left') ? 'left' : 'right';
	                    }
	                    else {
	                        if (app.params.swipePanelOnlyClose)
	                            return;
	                        side = app.params.swipePanel;
	                    }
	                    if (!side)
	                        return;
	                }
	                panel = $('.panel.panel-' + side);
	                opened = panel.hasClass('active');
	                if (app.params.swipePanelActiveArea && !opened) {
	                    if (side === 'left') {
	                        if (touchesStart.x > app.params.swipePanelActiveArea)
	                            return;
	                    }
	                    if (side === 'right') {
	                        if (touchesStart.x < app.width - app.params.swipePanelActiveArea)
	                            return;
	                    }
	                }
	                isMoved = false;
	                isTouched = true;
	                isScrolling = undefined;
	                touchStartTime = (new Date()).getTime();
	                direction = undefined;
	            }
	            function handleTouchMove(e) {
	                if (!isTouched)
	                    return;
	                if (e.f7PreventPanelSwipe)
	                    return;
	                var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (typeof isScrolling === 'undefined') {
	                    isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	                }
	                if (isScrolling) {
	                    isTouched = false;
	                    return;
	                }
	                if (!direction) {
	                    if (pageX > touchesStart.x) {
	                        direction = 'to-right';
	                    }
	                    else {
	                        direction = 'to-left';
	                    }
	                    if (side === 'both') {
	                        if ($('.panel.active').length > 0) {
	                            side = $('.panel.active').hasClass('panel-left') ? 'left' : 'right';
	                        }
	                        else {
	                            side = direction === 'to-right' ? 'left' : 'right';
	                        }
	                        if (app.params.swipePanelActiveArea > 0) {
	                            if (side === 'left' && touchesStart.x > app.params.swipePanelActiveArea) {
	                                isTouched = false;
	                                return;
	                            }
	                            if (side === 'right' && touchesStart.x < app.width - app.params.swipePanelActiveArea) {
	                                isTouched = false;
	                                return;
	                            }
	                        }
	                        panel = $('.panel.panel-' + side);
	                    }
	                    if (panel.hasClass('panel-visible-by-breakpoint')) {
	                        isTouched = false;
	                        return;
	                    }
	                    if (side === 'left' &&
	                        (direction === 'to-left' && !panel.hasClass('active')) ||
	                        side === 'right' &&
	                            (direction === 'to-right' && !panel.hasClass('active'))) {
	                        isTouched = false;
	                        return;
	                    }
	                }
	                if (app.params.swipePanelNoFollow) {
	                    var timeDiff = (new Date()).getTime() - touchStartTime;
	                    if (timeDiff < 300) {
	                        if (direction === 'to-left') {
	                            if (side === 'right')
	                                app.openPanel(side);
	                            if (side === 'left' && panel.hasClass('active'))
	                                app.closePanel();
	                        }
	                        if (direction === 'to-right') {
	                            if (side === 'left')
	                                app.openPanel(side);
	                            if (side === 'right' && panel.hasClass('active'))
	                                app.closePanel();
	                        }
	                    }
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                if (!isMoved) {
	                    effect = panel.hasClass('panel-cover') ? 'cover' : 'reveal';
	                    if (!opened) {
	                        panel.show();
	                        panelOverlay.show();
	                    }
	                    panelWidth = panel[0].offsetWidth;
	                    panel.transition(0);
	                    if (panel.find('.' + app.params.viewClass).length > 0) {
	                        if (app.sizeNavbars)
	                            app.sizeNavbars(panel.find('.' + app.params.viewClass)[0]);
	                    }
	                }
	                isMoved = true;
	                e.preventDefault();
	                var threshold = opened ? 0 : -app.params.swipePanelThreshold;
	                if (side === 'right')
	                    threshold = -threshold;
	                touchesDiff = pageX - touchesStart.x + threshold;
	                if (side === 'right') {
	                    if (effect === 'cover') {
	                        translate = touchesDiff + (opened ? 0 : panelWidth);
	                        if (translate < 0)
	                            translate = 0;
	                        if (translate > panelWidth) {
	                            translate = panelWidth;
	                        }
	                    }
	                    else {
	                        translate = touchesDiff - (opened ? panelWidth : 0);
	                        if (translate > 0)
	                            translate = 0;
	                        if (translate < -panelWidth) {
	                            translate = -panelWidth;
	                        }
	                    }
	                }
	                else {
	                    translate = touchesDiff + (opened ? panelWidth : 0);
	                    if (translate < 0)
	                        translate = 0;
	                    if (translate > panelWidth) {
	                        translate = panelWidth;
	                    }
	                }
	                if (effect === 'reveal') {
	                    views.transform('translate3d(' + translate + 'px,0,0)').transition(0);
	                    panelOverlay.transform('translate3d(' + translate + 'px,0,0)').transition(0);
	                    panel.trigger('panel:swipe', { progress: Math.abs(translate / panelWidth) });
	                    app.pluginHook('swipePanelSetTransform', views[0], panel[0], Math.abs(translate / panelWidth));
	                }
	                else {
	                    if (side === 'left')
	                        translate = translate - panelWidth;
	                    panel.transform('translate3d(' + (translate) + 'px,0,0)').transition(0);
	                    panelOverlay.transition(0);
	                    overlayOpacity = 1 - Math.abs(translate / panelWidth);
	                    panelOverlay.css({ opacity: overlayOpacity });
	                    panel.trigger('panel:swipe', { progress: Math.abs(translate / panelWidth) });
	                    app.pluginHook('swipePanelSetTransform', views[0], panel[0], Math.abs(translate / panelWidth));
	                }
	            }
	            function handleTouchEnd(e) {
	                if (!isTouched || !isMoved) {
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                isTouched = false;
	                isMoved = false;
	                var timeDiff = (new Date()).getTime() - touchStartTime;
	                var action;
	                var edge = (translate === 0 || Math.abs(translate) === panelWidth);
	                if (!opened) {
	                    if (effect === 'cover') {
	                        if (translate === 0) {
	                            action = 'swap'; //open
	                        }
	                        else if (timeDiff < 300 && Math.abs(translate) > 0) {
	                            action = 'swap'; //open
	                        }
	                        else if (timeDiff >= 300 && Math.abs(translate) < panelWidth / 2) {
	                            action = 'swap'; //open
	                        }
	                        else {
	                            action = 'reset'; //close
	                        }
	                    }
	                    else {
	                        if (translate === 0) {
	                            action = 'reset';
	                        }
	                        else if (timeDiff < 300 && Math.abs(translate) > 0 ||
	                            timeDiff >= 300 && (Math.abs(translate) >= panelWidth / 2)) {
	                            action = 'swap';
	                        }
	                        else {
	                            action = 'reset';
	                        }
	                    }
	                }
	                else {
	                    if (effect === 'cover') {
	                        if (translate === 0) {
	                            action = 'reset'; //open
	                        }
	                        else if (timeDiff < 300 && Math.abs(translate) > 0) {
	                            action = 'swap'; //open
	                        }
	                        else if (timeDiff >= 300 && Math.abs(translate) < panelWidth / 2) {
	                            action = 'reset'; //open
	                        }
	                        else {
	                            action = 'swap'; //close
	                        }
	                    }
	                    else {
	                        if (translate === -panelWidth) {
	                            action = 'reset';
	                        }
	                        else if (timeDiff < 300 && Math.abs(translate) >= 0 ||
	                            timeDiff >= 300 && (Math.abs(translate) <= panelWidth / 2)) {
	                            if (side === 'left' && translate === panelWidth)
	                                action = 'reset';
	                            else
	                                action = 'swap';
	                        }
	                        else {
	                            action = 'reset';
	                        }
	                    }
	                }
	                if (action === 'swap') {
	                    app.allowPanelOpen = true;
	                    if (opened) {
	                        app.closePanel();
	                        if (edge) {
	                            panel.css({ display: '' });
	                            $('body').removeClass('panel-closing');
	                        }
	                    }
	                    else {
	                        app.openPanel(side);
	                    }
	                    if (edge)
	                        app.allowPanelOpen = true;
	                }
	                if (action === 'reset') {
	                    if (opened) {
	                        app.allowPanelOpen = true;
	                        app.openPanel(side);
	                    }
	                    else {
	                        app.closePanel();
	                        if (edge) {
	                            app.allowPanelOpen = true;
	                            panel.css({ display: '' });
	                        }
	                        else {
	                            var target = effect === 'reveal' ? views : panel;
	                            panel.trigger('close panel:close');
	                            $('body').addClass('panel-closing');
	                            target.transitionEnd(function () {
	                                if (panel.hasClass('active'))
	                                    return;
	                                panel.trigger('close panel:closed');
	                                panel.css({ display: '' });
	                                $('body').removeClass('panel-closing');
	                                app.allowPanelOpen = true;
	                            });
	                        }
	                    }
	                }
	                if (effect === 'reveal') {
	                    views.transition('');
	                    views.transform('');
	                }
	                panel.transition('').transform('');
	                panelOverlay.css({ display: '' }).transform('').transition('').css('opacity', '');
	            }
	            var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? { passive: true, capture: false } : false;
	            var activeListener = app.support.passiveListener ? { passive: false, capture: false } : false;
	            $(document).on(app.touchEvents.start, handleTouchStart, passiveListener);
	            $(document).on(app.touchEvents.move, handleTouchMove, activeListener);
	            $(document).on(app.touchEvents.end, handleTouchEnd, passiveListener);
	        };
	        /*======================================================
	        ************   Image Lazy Loading   ************
	        ************   Based on solution by Marc Godard, https://github.com/MarcGodard   ************
	        ======================================================*/
	        app.initImagesLazyLoad = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            // Lazy images
	            var lazyLoadImages;
	            if (pageContainer.hasClass('lazy')) {
	                lazyLoadImages = pageContainer;
	                pageContainer = lazyLoadImages.parents('.page');
	            }
	            else {
	                lazyLoadImages = pageContainer.find('.lazy');
	            }
	            if (lazyLoadImages.length === 0)
	                return;
	            // Scrollable page content
	            var pageContent;
	            if (pageContainer.hasClass('page-content')) {
	                pageContent = pageContainer;
	                pageContainer = pageContainer.parents('.page');
	            }
	            else {
	                pageContent = pageContainer.find('.page-content');
	            }
	            if (pageContent.length === 0)
	                return;
	            // Placeholder
	            var placeholderSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXCwsK592mkAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg==';
	            if (typeof app.params.imagesLazyLoadPlaceholder === 'string') {
	                placeholderSrc = app.params.imagesLazyLoadPlaceholder;
	            }
	            if (app.params.imagesLazyLoadPlaceholder !== false)
	                lazyLoadImages.each(function () {
	                    if ($(this).attr('data-src') && !$(this).attr('src'))
	                        $(this).attr('src', placeholderSrc);
	                });
	            // load image
	            var imagesSequence = [];
	            var imageIsLoading = false;
	            function loadImage(el) {
	                el = $(el);
	                var bg = el.attr('data-background');
	                var src = bg ? bg : el.attr('data-src');
	                if (!src)
	                    return;
	                function onLoad() {
	                    el.removeClass('lazy').addClass('lazy-loaded');
	                    if (bg) {
	                        el.css('background-image', 'url(' + src + ')');
	                    }
	                    else {
	                        el.attr('src', src);
	                    }
	                    if (app.params.imagesLazyLoadSequential) {
	                        imageIsLoading = false;
	                        if (imagesSequence.length > 0) {
	                            loadImage(imagesSequence.shift());
	                        }
	                    }
	                    el.trigger('lazy-loaded');
	                    if (app.params.onLazyLoaded)
	                        app.params.onLazyLoaded(el);
	                }
	                function onError() {
	                    el.removeClass('lazy').addClass('lazy-loaded');
	                    if (bg) {
	                        el.css('background-image', 'url(' + placeholderSrc + ')');
	                    }
	                    else {
	                        el.attr('src', placeholderSrc);
	                    }
	                    if (app.params.imagesLazyLoadSequential) {
	                        imageIsLoading = false;
	                        if (imagesSequence.length > 0) {
	                            loadImage(imagesSequence.shift());
	                        }
	                    }
	                    el.trigger('lazy-error');
	                    if (app.params.onLazyError)
	                        app.params.onLazyError(el);
	                }
	                if (app.params.imagesLazyLoadSequential) {
	                    if (imageIsLoading) {
	                        if (imagesSequence.indexOf(el[0]) < 0)
	                            imagesSequence.push(el[0]);
	                        return;
	                    }
	                }
	                // Loading flag
	                imageIsLoading = true;
	                var image = new Image();
	                image.onload = onLoad;
	                image.onerror = onError;
	                image.src = src;
	                // Add loaded callback and events
	                el.trigger('lazy-load');
	                if (app.params.onLazyLoad && !el.hasClass('lazy-loaded'))
	                    app.params.onLazyLoad(el);
	            }
	            function lazyHandler() {
	                lazyLoadImages = pageContainer.find('.lazy');
	                lazyLoadImages.each(function (index, el) {
	                    el = $(el);
	                    if (el.parents('.tab:not(.active)').length > 0) {
	                        return;
	                    }
	                    if (isElementInViewport(el[0])) {
	                        loadImage(el);
	                    }
	                });
	            }
	            function isElementInViewport(el) {
	                var rect = el.getBoundingClientRect();
	                var threshold = app.params.imagesLazyLoadThreshold || 0;
	                return (rect.top >= (0 - threshold) &&
	                    rect.left >= (0 - threshold) &&
	                    rect.top <= (app.height + threshold) &&
	                    rect.left <= (app.width + threshold));
	            }
	            function attachEvents(destroy) {
	                var method = destroy ? 'off' : 'on';
	                lazyLoadImages[method]('lazy', lazyHandler);
	                lazyLoadImages.parents('.tab')[method]('show', lazyHandler);
	                pageContainer[method]('lazy', lazyHandler);
	                pageContent[method]('lazy', lazyHandler);
	                pageContent[method]('scroll', lazyHandler);
	                app[method === 'on' ? 'onResize' : 'offResize'](lazyHandler);
	            }
	            function detachEvents() {
	                attachEvents(true);
	            }
	            // Store detach function
	            pageContainer[0].f7DestroyImagesLazyLoad = detachEvents;
	            // Attach events
	            attachEvents();
	            // Destroy on page remove
	            if (pageContainer.hasClass('page')) {
	                pageContainer.once('page:beforeremove', detachEvents);
	            }
	            // Run loader on page load/init
	            lazyHandler();
	            // Run after page animation
	            pageContainer.once('page:afteranimation', lazyHandler);
	        };
	        app.destroyImagesLazyLoad = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            if (pageContainer.length > 0 && pageContainer[0].f7DestroyImagesLazyLoad) {
	                pageContainer[0].f7DestroyImagesLazyLoad();
	            }
	        };
	        app.reinitImagesLazyLoad = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            if (pageContainer.length > 0) {
	                pageContainer.trigger('lazy');
	            }
	        };
	        /*======================================================
	        ************   Material Preloader   ************
	        ======================================================*/
	        app.initPageMaterialPreloader = function (pageContainer) {
	            $(pageContainer).find('.preloader').each(function () {
	                if ($(this).children().length === 0) {
	                    $(this).html(app.params.materialPreloaderHtml);
	                }
	            });
	        };
	        /*======================================================
	        ************   Messages   ************
	        ======================================================*/
	        var Messages = function (container, params) {
	            var defaults = {
	                autoLayout: true,
	                newMessagesFirst: false,
	                scrollMessages: true,
	                scrollMessagesOnlyOnEdge: false,
	                messageTemplate: '{{#if day}}' +
	                    '<div class="messages-date">{{day}} {{#if time}}, <span>{{time}}</span>{{/if}}</div>' +
	                    '{{/if}}' +
	                    '<div class="message message-{{type}} {{#if hasImage}}message-pic{{/if}} {{#if avatar}}message-with-avatar{{/if}} {{#if position}}message-appear-from-{{position}}{{/if}}">' +
	                    '{{#if name}}<div class="message-name">{{name}}</div>{{/if}}' +
	                    '<div class="message-text">{{text}}{{#if date}}<div class="message-date">{{date}}</div>{{/if}}</div>' +
	                    '{{#if avatar}}<div class="message-avatar" style="background-image:url({{avatar}})"></div>{{/if}}' +
	                    '{{#if label}}<div class="message-label">{{label}}</div>{{/if}}' +
	                    '</div>'
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined' || params[def] === null) {
	                    params[def] = defaults[def];
	                }
	            }
	            // Instance
	            var m = this;
	            // Params
	            m.params = params;
	            // Container
	            m.container = $(container);
	            if (m.container.length === 0)
	                return;
	            // Autolayout
	            if (m.params.autoLayout)
	                m.container.addClass('messages-auto-layout');
	            // New messages first
	            if (m.params.newMessagesFirst)
	                m.container.addClass('messages-new-first');
	            // Is In Page
	            m.pageContainer = m.container.parents('.page').eq(0);
	            m.pageContent = m.pageContainer.find('.page-content');
	            // Compiled template
	            m.template = Template7.compile(m.params.messageTemplate);
	            // Auto Layout
	            m.layout = function () {
	                if (!m.container.hasClass('messages-auto-layout'))
	                    m.container.addClass('messages-auto-layout');
	                m.container.find('.message').each(function () {
	                    var message = $(this);
	                    if (message.find('.message-text img').length > 0) {
	                        var childNodes = message.find('.message-text')[0].childNodes;
	                        var onlyPic = true;
	                        for (var i = 0; i < childNodes.length; i++) {
	                            if (childNodes[i].nodeType === 1 && childNodes[i].nodeName.toLowerCase() !== 'img')
	                                onlyPic = false;
	                            if (childNodes[i].nodeType === 3 && childNodes[i].textContent.trim() !== '')
	                                onlyPic = false;
	                        }
	                        if (onlyPic)
	                            message.addClass('message-pic');
	                        else
	                            message.removeClass('message-pic');
	                    }
	                    if (message.find('.message-avatar').length > 0)
	                        message.addClass('message-with-avatar');
	                });
	                m.container.find('.message').each(function () {
	                    var message = $(this);
	                    var isSent = message.hasClass('message-sent');
	                    var next = message.next('.message-' + (isSent ? 'sent' : 'received'));
	                    var prev = message.prev('.message-' + (isSent ? 'sent' : 'received'));
	                    if (next.length === 0) {
	                        message.addClass('message-last message-with-tail');
	                    }
	                    else
	                        message.removeClass('message-last message-with-tail');
	                    if (prev.length === 0) {
	                        message.addClass('message-first');
	                    }
	                    else
	                        message.removeClass('message-first');
	                    if (prev.length > 0 && prev.find('.message-name').length > 0 && message.find('.message-name').length > 0) {
	                        if (prev.find('.message-name').text() !== message.find('.message-name').text()) {
	                            prev.addClass('message-last message-with-tail');
	                            message.addClass('message-first');
	                        }
	                    }
	                });
	            };
	            // Add Message
	            m.appendMessage = function (props, animate) {
	                return m.addMessage(props, 'append', animate);
	            };
	            m.prependMessage = function (props, animate) {
	                return m.addMessage(props, 'prepend', animate);
	            };
	            m.addMessage = function (props, method, animate) {
	                return m.addMessages([props], method, animate);
	            };
	            m.addMessages = function (newMessages, method, animate) {
	                if (typeof animate === 'undefined') {
	                    animate = true;
	                }
	                if (typeof method === 'undefined') {
	                    method = m.params.newMessagesFirst ? 'prepend' : 'append';
	                }
	                var newMessagesHTML = '', i;
	                for (i = 0; i < newMessages.length; i++) {
	                    var props = newMessages[i] || {};
	                    props.type = props.type || 'sent';
	                    if (!props.text)
	                        continue;
	                    props.hasImage = props.text.indexOf('<img') >= 0;
	                    if (props.onlyImage === false)
	                        props.hasImage = false;
	                    if (animate)
	                        props.position = method === 'append' ? 'bottom' : 'top';
	                    newMessagesHTML += m.template(props);
	                }
	                var scrollHeightBefore = m.pageContent[0].scrollHeight, heightBefore = m.pageContent[0].offsetHeight, scrollBefore = m.pageContent[0].scrollTop;
	                m.container[method](newMessagesHTML);
	                if (m.params.autoLayout)
	                    m.layout();
	                if (method === 'prepend') {
	                    m.pageContent[0].scrollTop = scrollBefore + (m.pageContent[0].scrollHeight - scrollHeightBefore);
	                }
	                if (m.params.scrollMessages && (method === 'append' && !m.params.newMessagesFirst) || (method === 'prepend' && m.params.newMessagesFirst)) {
	                    if (m.params.scrollMessagesOnlyOnEdge) {
	                        var onEdge = false;
	                        if (m.params.newMessagesFirst) {
	                            if (scrollBefore === 0)
	                                onEdge = true;
	                        }
	                        else {
	                            if (scrollBefore - (scrollHeightBefore - heightBefore) >= -10)
	                                onEdge = true;
	                        }
	                        if (onEdge)
	                            m.scrollMessages(animate ? undefined : 0);
	                    }
	                    else
	                        m.scrollMessages(animate ? undefined : 0);
	                }
	                var messages = m.container.find('.message');
	                if (newMessages.length === 1) {
	                    return method === 'append' ? messages[messages.length - 1] : messages[0];
	                }
	                else {
	                    var messagesToReturn = [];
	                    if (method === 'append') {
	                        for (i = messages.length - newMessages.length; i < messages.length; i++) {
	                            messagesToReturn.push(messages[i]);
	                        }
	                    }
	                    else {
	                        for (i = 0; i < newMessages.length; i++) {
	                            messagesToReturn.push(messages[i]);
	                        }
	                    }
	                    return messagesToReturn;
	                }
	            };
	            m.removeMessage = function (message) {
	                message = $(message);
	                if (message.length === 0) {
	                    return false;
	                }
	                else {
	                    message.remove();
	                    if (m.params.autoLayout)
	                        m.layout();
	                    return true;
	                }
	            };
	            m.removeMessages = function (messages) {
	                m.removeMessage(messages);
	            };
	            m.clean = function () {
	                m.container.html('');
	            };
	            // Scroll
	            m.scrollMessages = function (duration, scrollTop) {
	                if (typeof duration === 'undefined')
	                    duration = 400;
	                var currentScroll = m.pageContent[0].scrollTop;
	                var newScroll;
	                if (typeof scrollTop !== 'undefined')
	                    newScroll = scrollTop;
	                else {
	                    newScroll = m.params.newMessagesFirst ? 0 : m.pageContent[0].scrollHeight - m.pageContent[0].offsetHeight;
	                    if (newScroll === currentScroll)
	                        return;
	                }
	                m.pageContent.scrollTop(newScroll, duration);
	            };
	            // Init Destroy
	            m.init = function () {
	                if (m.params.messages) {
	                    m.addMessages(m.params.messages, undefined, false);
	                }
	                else {
	                    if (m.params.autoLayout)
	                        m.layout();
	                    m.scrollMessages(0);
	                }
	            };
	            m.destroy = function () {
	                m = null;
	            };
	            // Init
	            m.init();
	            m.container[0].f7Messages = m;
	            return m;
	        };
	        app.messages = function (container, params) {
	            return new Messages(container, params);
	        };
	        app.initPageMessages = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var messages = pageContainer.find('.messages');
	            if (messages.length === 0)
	                return;
	            if (!messages.hasClass('messages-init')) {
	                return;
	            }
	            var m = app.messages(messages, messages.dataset());
	            // Destroy on page remove
	            function pageBeforeRemove() {
	                m.destroy();
	                pageContainer.off('page:beforeremove', pageBeforeRemove);
	            }
	            if (pageContainer.hasClass('page')) {
	                pageContainer.on('page:beforeremove', pageBeforeRemove);
	            }
	        };
	        /*===============================================================================
	        ************   Swipeout Actions (Swipe to delete)   ************
	        ===============================================================================*/
	        app.swipeoutOpenedEl = undefined;
	        app.allowSwipeout = true;
	        app.initSwipeout = function (swipeoutEl) {
	            var isTouched, isMoved, isScrolling, touchesStart = {}, touchStartTime, touchesDiff, swipeOutEl, swipeOutContent, actionsRight, actionsLeft, actionsLeftWidth, actionsRightWidth, translate, opened, openedActions, buttonsLeft, buttonsRight, direction, overswipeLeftButton, overswipeRightButton, overswipeLeft, overswipeRight, noFoldLeft, noFoldRight;
	            var activeListener = app.support.passiveListener ? { passive: false, capture: false } : false;
	            $(document).on(app.touchEvents.start, function (e) {
	                if (app.swipeoutOpenedEl) {
	                    var target = $(e.target);
	                    if (!(app.swipeoutOpenedEl.is(target[0]) ||
	                        target.parents('.swipeout').is(app.swipeoutOpenedEl) ||
	                        target.hasClass('modal-in') ||
	                        target.hasClass('modal-overlay') ||
	                        target.hasClass('actions-modal') ||
	                        target.parents('.actions-modal.modal-in, .modal.modal-in').length > 0)) {
	                        app.swipeoutClose(app.swipeoutOpenedEl);
	                    }
	                }
	            }, activeListener);
	            function handleTouchStart(e) {
	                if (!app.allowSwipeout)
	                    return;
	                isMoved = false;
	                isTouched = true;
	                isScrolling = undefined;
	                touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                touchStartTime = (new Date()).getTime();
	            }
	            function handleTouchMove(e) {
	                if (!isTouched)
	                    return;
	                var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (typeof isScrolling === 'undefined') {
	                    isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	                }
	                if (isScrolling) {
	                    isTouched = false;
	                    return;
	                }
	                if (!isMoved) {
	                    if ($('.list-block.sortable-opened').length > 0)
	                        return;
	                    /*jshint validthis:true */
	                    swipeOutEl = $(this);
	                    swipeOutContent = swipeOutEl.find('.swipeout-content');
	                    actionsRight = swipeOutEl.find('.swipeout-actions-right');
	                    actionsLeft = swipeOutEl.find('.swipeout-actions-left');
	                    actionsLeftWidth = actionsRightWidth = buttonsLeft = buttonsRight = overswipeRightButton = overswipeLeftButton = null;
	                    noFoldLeft = actionsLeft.hasClass('swipeout-actions-no-fold') || app.params.swipeoutActionsNoFold;
	                    noFoldRight = actionsRight.hasClass('swipeout-actions-no-fold') || app.params.swipeoutActionsNoFold;
	                    if (actionsLeft.length > 0) {
	                        actionsLeftWidth = actionsLeft.outerWidth();
	                        buttonsLeft = actionsLeft.children('a');
	                        overswipeLeftButton = actionsLeft.find('.swipeout-overswipe');
	                    }
	                    if (actionsRight.length > 0) {
	                        actionsRightWidth = actionsRight.outerWidth();
	                        buttonsRight = actionsRight.children('a');
	                        overswipeRightButton = actionsRight.find('.swipeout-overswipe');
	                    }
	                    opened = swipeOutEl.hasClass('swipeout-opened');
	                    if (opened) {
	                        openedActions = swipeOutEl.find('.swipeout-actions-left.swipeout-actions-opened').length > 0 ? 'left' : 'right';
	                    }
	                    swipeOutEl.removeClass('transitioning');
	                    if (!app.params.swipeoutNoFollow) {
	                        swipeOutEl.find('.swipeout-actions-opened').removeClass('swipeout-actions-opened');
	                        swipeOutEl.removeClass('swipeout-opened');
	                    }
	                }
	                isMoved = true;
	                e.preventDefault();
	                touchesDiff = pageX - touchesStart.x;
	                translate = touchesDiff;
	                if (opened) {
	                    if (openedActions === 'right')
	                        translate = translate - actionsRightWidth;
	                    else
	                        translate = translate + actionsLeftWidth;
	                }
	                if (translate > 0 && actionsLeft.length === 0 || translate < 0 && actionsRight.length === 0) {
	                    if (!opened) {
	                        isTouched = isMoved = false;
	                        swipeOutContent.transform('');
	                        if (buttonsRight && buttonsRight.length > 0) {
	                            buttonsRight.transform('');
	                        }
	                        if (buttonsLeft && buttonsLeft.length > 0) {
	                            buttonsLeft.transform('');
	                        }
	                        return;
	                    }
	                    translate = 0;
	                }
	                if (translate < 0)
	                    direction = 'to-left';
	                else if (translate > 0)
	                    direction = 'to-right';
	                else {
	                    if (!direction)
	                        direction = 'to-left';
	                }
	                var i, buttonOffset, progress;
	                e.f7PreventPanelSwipe = true;
	                if (app.params.swipeoutNoFollow) {
	                    if (opened) {
	                        if (openedActions === 'right' && touchesDiff > 0) {
	                            app.swipeoutClose(swipeOutEl);
	                        }
	                        if (openedActions === 'left' && touchesDiff < 0) {
	                            app.swipeoutClose(swipeOutEl);
	                        }
	                    }
	                    else {
	                        if (touchesDiff < 0 && actionsRight.length > 0) {
	                            app.swipeoutOpen(swipeOutEl, 'right');
	                        }
	                        if (touchesDiff > 0 && actionsLeft.length > 0) {
	                            app.swipeoutOpen(swipeOutEl, 'left');
	                        }
	                    }
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                overswipeLeft = false;
	                overswipeRight = false;
	                var $button;
	                if (actionsRight.length > 0) {
	                    // Show right actions
	                    progress = translate / actionsRightWidth;
	                    if (translate < -actionsRightWidth) {
	                        translate = -actionsRightWidth - Math.pow(-translate - actionsRightWidth, 0.8);
	                        if (overswipeRightButton.length > 0) {
	                            overswipeRight = true;
	                        }
	                    }
	                    for (i = 0; i < buttonsRight.length; i++) {
	                        if (typeof buttonsRight[i]._buttonOffset === 'undefined') {
	                            buttonsRight[i]._buttonOffset = buttonsRight[i].offsetLeft;
	                        }
	                        buttonOffset = buttonsRight[i]._buttonOffset;
	                        $button = $(buttonsRight[i]);
	                        if (overswipeRightButton.length > 0 && $button.hasClass('swipeout-overswipe')) {
	                            $button.css({ left: (overswipeRight ? -buttonOffset : 0) + 'px' });
	                            if (overswipeRight) {
	                                $button.addClass('swipeout-overswipe-active');
	                            }
	                            else {
	                                $button.removeClass('swipeout-overswipe-active');
	                            }
	                        }
	                        $button.transform('translate3d(' + (translate - buttonOffset * (1 + Math.max(progress, -1))) + 'px,0,0)');
	                    }
	                }
	                if (actionsLeft.length > 0) {
	                    // Show left actions
	                    progress = translate / actionsLeftWidth;
	                    if (translate > actionsLeftWidth) {
	                        translate = actionsLeftWidth + Math.pow(translate - actionsLeftWidth, 0.8);
	                        if (overswipeLeftButton.length > 0) {
	                            overswipeLeft = true;
	                        }
	                    }
	                    for (i = 0; i < buttonsLeft.length; i++) {
	                        if (typeof buttonsLeft[i]._buttonOffset === 'undefined') {
	                            buttonsLeft[i]._buttonOffset = actionsLeftWidth - buttonsLeft[i].offsetLeft - buttonsLeft[i].offsetWidth;
	                        }
	                        buttonOffset = buttonsLeft[i]._buttonOffset;
	                        $button = $(buttonsLeft[i]);
	                        if (overswipeLeftButton.length > 0 && $button.hasClass('swipeout-overswipe')) {
	                            $button.css({ left: (overswipeLeft ? buttonOffset : 0) + 'px' });
	                            if (overswipeLeft) {
	                                $button.addClass('swipeout-overswipe-active');
	                            }
	                            else {
	                                $button.removeClass('swipeout-overswipe-active');
	                            }
	                        }
	                        if (buttonsLeft.length > 1) {
	                            $button.css('z-index', buttonsLeft.length - i);
	                        }
	                        $button.transform('translate3d(' + (translate + buttonOffset * (1 - Math.min(progress, 1))) + 'px,0,0)');
	                    }
	                }
	                swipeOutContent.transform('translate3d(' + translate + 'px,0,0)');
	            }
	            function handleTouchEnd(e) {
	                if (!isTouched || !isMoved) {
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                isTouched = false;
	                isMoved = false;
	                var timeDiff = (new Date()).getTime() - touchStartTime;
	                var action, actionsWidth, actions, buttons, i;
	                actions = direction === 'to-left' ? actionsRight : actionsLeft;
	                actionsWidth = direction === 'to-left' ? actionsRightWidth : actionsLeftWidth;
	                if (timeDiff < 300 && (touchesDiff < -10 && direction === 'to-left' || touchesDiff > 10 && direction === 'to-right') ||
	                    timeDiff >= 300 && Math.abs(translate) > actionsWidth / 2) {
	                    action = 'open';
	                }
	                else {
	                    action = 'close';
	                }
	                if (timeDiff < 300) {
	                    if (Math.abs(translate) === 0)
	                        action = 'close';
	                    if (Math.abs(translate) === actionsWidth)
	                        action = 'open';
	                }
	                if (action === 'open') {
	                    app.swipeoutOpenedEl = swipeOutEl;
	                    swipeOutEl.trigger('open swipeout:open');
	                    swipeOutEl.addClass('swipeout-opened transitioning');
	                    var newTranslate = direction === 'to-left' ? -actionsWidth : actionsWidth;
	                    swipeOutContent.transform('translate3d(' + newTranslate + 'px,0,0)');
	                    actions.addClass('swipeout-actions-opened');
	                    buttons = direction === 'to-left' ? buttonsRight : buttonsLeft;
	                    if (buttons) {
	                        for (i = 0; i < buttons.length; i++) {
	                            $(buttons[i]).transform('translate3d(' + newTranslate + 'px,0,0)');
	                        }
	                    }
	                    if (overswipeRight) {
	                        actionsRight.find('.swipeout-overswipe')[0].click();
	                    }
	                    if (overswipeLeft) {
	                        actionsLeft.find('.swipeout-overswipe')[0].click();
	                    }
	                }
	                else {
	                    swipeOutEl.trigger('close swipeout:close');
	                    app.swipeoutOpenedEl = undefined;
	                    swipeOutEl.addClass('transitioning').removeClass('swipeout-opened');
	                    swipeOutContent.transform('');
	                    actions.removeClass('swipeout-actions-opened');
	                }
	                var buttonOffset;
	                if (buttonsLeft && buttonsLeft.length > 0 && buttonsLeft !== buttons) {
	                    for (i = 0; i < buttonsLeft.length; i++) {
	                        buttonOffset = buttonsLeft[i]._buttonOffset;
	                        if (typeof buttonOffset === 'undefined') {
	                            buttonsLeft[i]._buttonOffset = actionsLeftWidth - buttonsLeft[i].offsetLeft - buttonsLeft[i].offsetWidth;
	                        }
	                        $(buttonsLeft[i]).transform('translate3d(' + (buttonOffset) + 'px,0,0)');
	                    }
	                }
	                if (buttonsRight && buttonsRight.length > 0 && buttonsRight !== buttons) {
	                    for (i = 0; i < buttonsRight.length; i++) {
	                        buttonOffset = buttonsRight[i]._buttonOffset;
	                        if (typeof buttonOffset === 'undefined') {
	                            buttonsRight[i]._buttonOffset = buttonsRight[i].offsetLeft;
	                        }
	                        $(buttonsRight[i]).transform('translate3d(' + (-buttonOffset) + 'px,0,0)');
	                    }
	                }
	                swipeOutContent.transitionEnd(function (e) {
	                    if (opened && action === 'open' || closed && action === 'close')
	                        return;
	                    swipeOutEl.trigger(action === 'open' ? 'opened' : 'closed');
	                    if (opened && action === 'close') {
	                        if (actionsRight.length > 0) {
	                            buttonsRight.transform('');
	                        }
	                        if (actionsLeft.length > 0) {
	                            buttonsLeft.transform('');
	                        }
	                    }
	                });
	            }
	            if (swipeoutEl) {
	                $(swipeoutEl).on(app.touchEvents.start, handleTouchStart, activeListener);
	                $(swipeoutEl).on(app.touchEvents.move, handleTouchMove, activeListener);
	                $(swipeoutEl).on(app.touchEvents.end, handleTouchEnd, activeListener);
	            }
	            else {
	                $(document).on(app.touchEvents.start, '.list-block li.swipeout', handleTouchStart, activeListener);
	                $(document).on(app.touchEvents.move, '.list-block li.swipeout', handleTouchMove, activeListener);
	                $(document).on(app.touchEvents.end, '.list-block li.swipeout', handleTouchEnd, activeListener);
	            }
	        };
	        app.swipeoutOpen = function (el, dir, callback) {
	            el = $(el);
	            if (arguments.length === 2) {
	                if (typeof arguments[1] === 'function') {
	                    callback = dir;
	                }
	            }
	            if (el.length === 0)
	                return;
	            if (el.length > 1)
	                el = $(el[0]);
	            if (!el.hasClass('swipeout') || el.hasClass('swipeout-opened'))
	                return;
	            if (!dir) {
	                if (el.find('.swipeout-actions-right').length > 0)
	                    dir = 'right';
	                else
	                    dir = 'left';
	            }
	            var swipeOutActions = el.find('.swipeout-actions-' + dir);
	            if (swipeOutActions.length === 0)
	                return;
	            el.trigger('open swipeout:open').addClass('swipeout-opened').removeClass('transitioning');
	            swipeOutActions.addClass('swipeout-actions-opened');
	            var buttons = swipeOutActions.children('a');
	            var swipeOutActionsWidth = swipeOutActions.outerWidth();
	            var translate = dir === 'right' ? -swipeOutActionsWidth : swipeOutActionsWidth;
	            var i;
	            if (buttons.length > 1) {
	                for (i = 0; i < buttons.length; i++) {
	                    if (dir === 'right') {
	                        $(buttons[i]).transform('translate3d(' + (-buttons[i].offsetLeft) + 'px,0,0)');
	                    }
	                    else {
	                        $(buttons[i]).css('z-index', buttons.length - i).transform('translate3d(' + (swipeOutActionsWidth - buttons[i].offsetWidth - buttons[i].offsetLeft) + 'px,0,0)');
	                    }
	                }
	                var clientLeft = buttons[1].clientLeft;
	            }
	            el.addClass('transitioning');
	            for (i = 0; i < buttons.length; i++) {
	                $(buttons[i]).transform('translate3d(' + (translate) + 'px,0,0)');
	            }
	            el.find('.swipeout-content').transform('translate3d(' + translate + 'px,0,0)').transitionEnd(function () {
	                el.trigger('opened swipeout:opened');
	                if (callback)
	                    callback.call(el[0]);
	            });
	            app.swipeoutOpenedEl = el;
	        };
	        app.swipeoutClose = function (el, callback) {
	            el = $(el);
	            if (el.length === 0)
	                return;
	            if (!el.hasClass('swipeout-opened'))
	                return;
	            var dir = el.find('.swipeout-actions-opened').hasClass('swipeout-actions-right') ? 'right' : 'left';
	            var swipeOutActions = el.find('.swipeout-actions-opened').removeClass('swipeout-actions-opened');
	            var buttons = swipeOutActions.children('a');
	            var swipeOutActionsWidth = swipeOutActions.outerWidth();
	            app.allowSwipeout = false;
	            el.trigger('close swipeout:close');
	            el.removeClass('swipeout-opened').addClass('transitioning');
	            var closeTO;
	            function onSwipeoutClose() {
	                app.allowSwipeout = true;
	                if (el.hasClass('swipeout-opened'))
	                    return;
	                el.removeClass('transitioning');
	                buttons.transform('');
	                el.trigger('closed swipeout:closed');
	                if (callback)
	                    callback.call(el[0]);
	                if (closeTO)
	                    clearTimeout(closeTO);
	            }
	            el.find('.swipeout-content').transform('').transitionEnd(onSwipeoutClose);
	            closeTO = setTimeout(onSwipeoutClose, 500);
	            for (var i = 0; i < buttons.length; i++) {
	                if (dir === 'right') {
	                    $(buttons[i]).transform('translate3d(' + (-buttons[i].offsetLeft) + 'px,0,0)');
	                }
	                else {
	                    $(buttons[i]).transform('translate3d(' + (swipeOutActionsWidth - buttons[i].offsetWidth - buttons[i].offsetLeft) + 'px,0,0)');
	                }
	                $(buttons[i]).css({ left: 0 + 'px' }).removeClass('swipeout-overswipe-active');
	            }
	            if (app.swipeoutOpenedEl && app.swipeoutOpenedEl[0] === el[0])
	                app.swipeoutOpenedEl = undefined;
	        };
	        app.swipeoutDelete = function (el, callback) {
	            el = $(el);
	            if (el.length === 0)
	                return;
	            if (el.length > 1)
	                el = $(el[0]);
	            app.swipeoutOpenedEl = undefined;
	            el.trigger('delete swipeout:delete');
	            el.css({ height: el.outerHeight() + 'px' });
	            var clientLeft = el[0].clientLeft;
	            el.css({ height: 0 + 'px' }).addClass('deleting transitioning').transitionEnd(function () {
	                el.trigger('deleted swipeout:deleted');
	                if (callback)
	                    callback.call(el[0]);
	                if (el.parents('.virtual-list').length > 0) {
	                    var virtualList = el.parents('.virtual-list')[0].f7VirtualList;
	                    var virtualIndex = el[0].f7VirtualListIndex;
	                    if (virtualList && typeof virtualIndex !== 'undefined')
	                        virtualList.deleteItem(virtualIndex);
	                }
	                else {
	                    if (app.params.swipeoutRemoveWithTimeout) {
	                        setTimeout(function () {
	                            el.remove();
	                        }, 0);
	                    }
	                    else
	                        el.remove();
	                }
	            });
	            var translate = '-100%';
	            el.find('.swipeout-content').transform('translate3d(' + translate + ',0,0)');
	        };
	        /*===============================================================================
	        ************   Sortable   ************
	        ===============================================================================*/
	        app.sortableToggle = function (sortableContainer) {
	            sortableContainer = $(sortableContainer);
	            if (sortableContainer.length === 0)
	                sortableContainer = $('.list-block.sortable');
	            sortableContainer.toggleClass('sortable-opened');
	            if (sortableContainer.hasClass('sortable-opened')) {
	                sortableContainer.trigger('open sortable:open');
	            }
	            else {
	                sortableContainer.trigger('close sortable:close');
	            }
	            return sortableContainer;
	        };
	        app.sortableOpen = function (sortableContainer) {
	            sortableContainer = $(sortableContainer);
	            if (sortableContainer.length === 0)
	                sortableContainer = $('.list-block.sortable');
	            sortableContainer.addClass('sortable-opened');
	            sortableContainer.trigger('open sortable:open');
	            return sortableContainer;
	        };
	        app.sortableClose = function (sortableContainer) {
	            sortableContainer = $(sortableContainer);
	            if (sortableContainer.length === 0)
	                sortableContainer = $('.list-block.sortable');
	            sortableContainer.removeClass('sortable-opened');
	            sortableContainer.trigger('close sortable:close');
	            return sortableContainer;
	        };
	        app.initSortable = function () {
	            var isTouched, isMoved, touchStartY, touchesDiff, sortingEl, sortingElHeight, sortingItems, minTop, maxTop, insertAfter, insertBefore, sortableContainer, startIndex;
	            function handleTouchStart(e) {
	                isMoved = false;
	                isTouched = true;
	                touchStartY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                /*jshint validthis:true */
	                sortingEl = $(this).parent();
	                startIndex = sortingEl.index();
	                sortingItems = sortingEl.parent().children('li');
	                sortableContainer = sortingEl.parents('.sortable');
	                e.preventDefault();
	                app.allowPanelOpen = app.allowSwipeout = false;
	            }
	            function handleTouchMove(e) {
	                if (!isTouched || !sortingEl)
	                    return;
	                var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (!isMoved) {
	                    sortingEl.addClass('sorting');
	                    sortableContainer.addClass('sortable-sorting');
	                    minTop = sortingEl[0].offsetTop;
	                    maxTop = sortingEl.parent().height() - sortingEl[0].offsetTop - sortingEl.height();
	                    sortingElHeight = sortingEl[0].offsetHeight;
	                }
	                isMoved = true;
	                e.preventDefault();
	                e.f7PreventPanelSwipe = true;
	                touchesDiff = pageY - touchStartY;
	                var translate = touchesDiff;
	                if (translate < -minTop)
	                    translate = -minTop;
	                if (translate > maxTop)
	                    translate = maxTop;
	                sortingEl.transform('translate3d(0,' + translate + 'px,0)');
	                insertBefore = insertAfter = undefined;
	                sortingItems.each(function () {
	                    var currentEl = $(this);
	                    if (currentEl[0] === sortingEl[0])
	                        return;
	                    var currentElOffset = currentEl[0].offsetTop;
	                    var currentElHeight = currentEl.height();
	                    var sortingElOffset = sortingEl[0].offsetTop + translate;
	                    if ((sortingElOffset >= currentElOffset - currentElHeight / 2) && sortingEl.index() < currentEl.index()) {
	                        currentEl.transform('translate3d(0, ' + (-sortingElHeight) + 'px,0)');
	                        insertAfter = currentEl;
	                        insertBefore = undefined;
	                    }
	                    else if ((sortingElOffset <= currentElOffset + currentElHeight / 2) && sortingEl.index() > currentEl.index()) {
	                        currentEl.transform('translate3d(0, ' + (sortingElHeight) + 'px,0)');
	                        insertAfter = undefined;
	                        if (!insertBefore)
	                            insertBefore = currentEl;
	                    }
	                    else {
	                        $(this).transform('translate3d(0, 0%,0)');
	                    }
	                });
	            }
	            function handleTouchEnd(e) {
	                app.allowPanelOpen = app.allowSwipeout = true;
	                if (!isTouched || !isMoved) {
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                e.preventDefault();
	                sortingItems.transform('');
	                sortingEl.removeClass('sorting');
	                sortableContainer.removeClass('sortable-sorting');
	                var virtualList, oldIndex, newIndex;
	                if (insertAfter) {
	                    sortingEl.insertAfter(insertAfter);
	                    sortingEl.trigger('sort sortable:sort', { startIndex: startIndex, newIndex: sortingEl.index() });
	                }
	                if (insertBefore) {
	                    sortingEl.insertBefore(insertBefore);
	                    sortingEl.trigger('sort sortable:sort', { startIndex: startIndex, newIndex: sortingEl.index() });
	                }
	                if ((insertAfter || insertBefore) && sortableContainer.hasClass('virtual-list')) {
	                    virtualList = sortableContainer[0].f7VirtualList;
	                    oldIndex = sortingEl[0].f7VirtualListIndex;
	                    newIndex = insertBefore ? insertBefore[0].f7VirtualListIndex : insertAfter[0].f7VirtualListIndex;
	                    if (virtualList)
	                        virtualList.moveItem(oldIndex, newIndex);
	                }
	                insertAfter = insertBefore = undefined;
	                isTouched = false;
	                isMoved = false;
	            }
	            var activeListener = app.support.passiveListener ? { passive: false, capture: false } : false;
	            $(document).on(app.touchEvents.start, '.list-block.sortable .sortable-handler', handleTouchStart, activeListener);
	            if (app.support.touch) {
	                $(document).on(app.touchEvents.move, '.list-block.sortable .sortable-handler', handleTouchMove, activeListener);
	                $(document).on(app.touchEvents.end, '.list-block.sortable .sortable-handler', handleTouchEnd, activeListener);
	            }
	            else {
	                $(document).on(app.touchEvents.move, handleTouchMove, activeListener);
	                $(document).on(app.touchEvents.end, handleTouchEnd, activeListener);
	            }
	        };
	        /*===============================================================================
	        ************   Smart Select   ************
	        ===============================================================================*/
	        app.initSmartSelects = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var selects;
	            if (pageContainer.is('.smart-select')) {
	                selects = pageContainer;
	            }
	            else {
	                selects = pageContainer.find('.smart-select');
	            }
	            if (selects.length === 0)
	                return;
	            selects.each(function () {
	                var smartSelect = $(this);
	                var $select = smartSelect.find('select');
	                if ($select.length === 0)
	                    return;
	                var select = $select[0];
	                if (select.length === 0)
	                    return;
	                var valueText = [];
	                var displayAs;
	                for (var i = 0; i < select.length; i++) {
	                    if (select[i].selected) {
	                        displayAs = select[i].dataset ? select[i].dataset.displayAs : $(select[i]).data('display-as');
	                        if (displayAs && typeof displayAs !== 'undefined') {
	                            valueText.push(displayAs);
	                        }
	                        else {
	                            valueText.push(select[i].textContent.trim());
	                        }
	                    }
	                }
	                var itemAfter = smartSelect.find('.item-after');
	                if (itemAfter.length === 0) {
	                    smartSelect.find('.item-inner').append('<div class="item-after">' + valueText.join(', ') + '</div>');
	                }
	                else {
	                    var selectedText = itemAfter.text();
	                    if (itemAfter.hasClass('smart-select-value')) {
	                        for (i = 0; i < select.length; i++) {
	                            select[i].selected = select[i].textContent.trim() === selectedText.trim();
	                        }
	                    }
	                    else {
	                        itemAfter.text(valueText.join(', '));
	                    }
	                }
	                $select.on('change', function () {
	                    var valueText = [];
	                    for (var i = 0; i < select.length; i++) {
	                        if (select[i].selected) {
	                            var displayAs = select[i].dataset ? select[i].dataset.displayAs : $(select[i]).data('display-as');
	                            if (displayAs && typeof displayAs !== 'undefined') {
	                                valueText.push(displayAs);
	                            }
	                            else {
	                                valueText.push(select[i].textContent.trim());
	                            }
	                        }
	                    }
	                    smartSelect.find('.item-after').text(valueText.join(', '));
	                });
	            });
	        };
	        app.smartSelectAddOption = function (select, option, index) {
	            select = $(select);
	            var smartSelect = select.parents('.smart-select');
	            if (typeof index === 'undefined') {
	                select.append(option);
	            }
	            else {
	                $(option).insertBefore(select.find('option').eq(index));
	            }
	            app.initSmartSelects(smartSelect);
	            var selectName = smartSelect.find('select').attr('name');
	            var opened = $('.page.smart-select-page[data-select-name="' + selectName + '"]').length > 0;
	            if (opened) {
	                app.smartSelectOpen(smartSelect, true);
	            }
	        };
	        app.smartSelectOpen = function (smartSelect, reLayout) {
	            smartSelect = $(smartSelect);
	            if (smartSelect.length === 0)
	                return;
	            // Find related view
	            var view = smartSelect.parents('.' + app.params.viewClass);
	            if (view.length === 0)
	                return;
	            view = view[0].f7View;
	            // Parameters
	            var openIn = smartSelect.attr('data-open-in') || app.params.smartSelectOpenIn;
	            if (openIn === 'popup') {
	                if ($('.popup.smart-select-popup').length > 0)
	                    return;
	            }
	            else if (openIn === 'picker') {
	                if ($('.picker-modal.modal-in').length > 0 && !reLayout) {
	                    if (smartSelect[0].f7SmartSelectPicker !== $('.picker-modal.modal-in:not(.modal-out)')[0])
	                        app.closeModal($('.picker-modal.modal-in:not(.modal-out)'));
	                    else
	                        return;
	                }
	            }
	            else {
	                if (!view)
	                    return;
	            }
	            var smartSelectData = smartSelect.dataset();
	            var pageTitle = smartSelectData.pageTitle || smartSelect.find('.item-title').text();
	            var backText = smartSelectData.backText || app.params.smartSelectBackText;
	            var closeText;
	            if (openIn === 'picker') {
	                closeText = smartSelectData.pickerCloseText || smartSelectData.backText || app.params.smartSelectPickerCloseText;
	            }
	            else {
	                closeText = smartSelectData.popupCloseText || smartSelectData.backText || app.params.smartSelectPopupCloseText;
	            }
	            var backOnSelect = smartSelectData.backOnSelect !== undefined ? smartSelectData.backOnSelect : app.params.smartSelectBackOnSelect;
	            var formTheme = smartSelectData.formTheme || app.params.smartSelectFormTheme;
	            var navbarTheme = smartSelectData.navbarTheme || app.params.smartSelectNavbarTheme;
	            var toolbarTheme = smartSelectData.toolbarTheme || app.params.smartSelectToolbarTheme;
	            var virtualList = smartSelectData.virtualList;
	            var virtualListHeight = smartSelectData.virtualListHeight;
	            var material = app.params.material;
	            var pickerHeight = smartSelectData.pickerHeight || app.params.smartSelectPickerHeight;
	            // Collect all options/values
	            var select = smartSelect.find('select')[0];
	            var $select = $(select);
	            var $selectData = $select.dataset();
	            if (select.disabled || smartSelect.hasClass('disabled') || $select.hasClass('disabled')) {
	                return;
	            }
	            var values = [];
	            var id = (new Date()).getTime();
	            var inputType = select.multiple ? 'checkbox' : 'radio';
	            var inputName = inputType + '-' + id;
	            var maxLength = $select.attr('maxlength');
	            var selectName = select.name;
	            var option, optionHasMedia, optionImage, optionIcon, optionGroup, optionGroupLabel, optionPreviousGroup, optionIsLabel, previousGroup, optionColor, optionClassName, optionData;
	            for (var i = 0; i < select.length; i++) {
	                option = $(select[i]);
	                optionData = option.dataset();
	                optionImage = optionData.optionImage || $selectData.optionImage || smartSelectData.optionImage;
	                optionIcon = optionData.optionIcon || $selectData.optionIcon || smartSelectData.optionIcon;
	                optionHasMedia = optionImage || optionIcon || inputType === 'checkbox';
	                if (material)
	                    optionHasMedia = optionImage || optionIcon;
	                optionColor = optionData.optionColor;
	                optionClassName = optionData.optionClass;
	                if (option[0].disabled)
	                    optionClassName += ' disabled';
	                optionGroup = option.parent('optgroup')[0];
	                optionGroupLabel = optionGroup && optionGroup.label;
	                optionIsLabel = false;
	                if (optionGroup) {
	                    if (optionGroup !== previousGroup) {
	                        optionIsLabel = true;
	                        previousGroup = optionGroup;
	                        values.push({
	                            groupLabel: optionGroupLabel,
	                            isLabel: optionIsLabel
	                        });
	                    }
	                }
	                values.push({
	                    value: option[0].value,
	                    text: option[0].textContent.trim(),
	                    selected: option[0].selected,
	                    group: optionGroup,
	                    groupLabel: optionGroupLabel,
	                    image: optionImage,
	                    icon: optionIcon,
	                    color: optionColor,
	                    className: optionClassName,
	                    disabled: option[0].disabled,
	                    inputType: inputType,
	                    id: id,
	                    hasMedia: optionHasMedia,
	                    checkbox: inputType === 'checkbox',
	                    inputName: inputName,
	                    material: app.params.material
	                });
	            }
	            // Item template/HTML
	            if (!app._compiledTemplates.smartSelectItem) {
	                app._compiledTemplates.smartSelectItem = t7.compile(app.params.smartSelectItemTemplate ||
	                    '{{#if isLabel}}' +
	                        '<li class="item-divider">{{groupLabel}}</li>' +
	                        '{{else}}' +
	                        '<li{{#if className}} class="{{className}}"{{/if}}>' +
	                        '<label class="label-{{inputType}} item-content">' +
	                        '<input type="{{inputType}}" name="{{inputName}}" value="{{value}}" {{#if selected}}checked{{/if}}>' +
	                        '{{#if material}}' +
	                        '{{#if hasMedia}}' +
	                        '<div class="item-media">' +
	                        '{{#if icon}}<i class="icon {{icon}}"></i>{{/if}}' +
	                        '{{#if image}}<img src="{{image}}">{{/if}}' +
	                        '</div>' +
	                        '<div class="item-inner">' +
	                        '<div class="item-title{{#if color}} color-{{color}}{{/if}}">{{text}}</div>' +
	                        '</div>' +
	                        '<div class="item-after">' +
	                        '<i class="icon icon-form-{{inputType}}"></i>' +
	                        '</div>' +
	                        '{{else}}' +
	                        '<div class="item-media">' +
	                        '<i class="icon icon-form-{{inputType}}"></i>' +
	                        '</div>' +
	                        '<div class="item-inner">' +
	                        '<div class="item-title{{#if color}} color-{{color}}{{/if}}">{{text}}</div>' +
	                        '</div>' +
	                        '{{/if}}' +
	                        '{{else}}' +
	                        '{{#if hasMedia}}' +
	                        '<div class="item-media">' +
	                        '{{#if checkbox}}<i class="icon icon-form-checkbox"></i>{{/if}}' +
	                        '{{#if icon}}<i class="icon {{icon}}"></i>{{/if}}' +
	                        '{{#if image}}<img src="{{image}}">{{/if}}' +
	                        '</div>' +
	                        '{{/if}}' +
	                        '<div class="item-inner">' +
	                        '<div class="item-title{{#if color}} color-{{color}}{{/if}}">{{text}}</div>' +
	                        '</div>' +
	                        '{{/if}}' +
	                        '</label>' +
	                        '</li>' +
	                        '{{/if}}');
	            }
	            var smartSelectItemTemplate = app._compiledTemplates.smartSelectItem;
	            var inputsHTML = '';
	            if (!virtualList) {
	                for (var j = 0; j < values.length; j++) {
	                    inputsHTML += smartSelectItemTemplate(values[j]);
	                }
	            }
	            // Toolbar / Navbar
	            var toolbarHTML = '', navbarHTML;
	            var noNavbar = '', noToolbar = '', noTabbar = '', navbarLayout;
	            if (openIn === 'picker') {
	                if (!app._compiledTemplates.smartSelectToolbar) {
	                    app._compiledTemplates.smartSelectToolbar = t7.compile(app.params.smartSelectToolbarTemplate ||
	                        '<div class="toolbar {{#if toolbarTheme}}theme-{{toolbarTheme}}{{/if}}">' +
	                            '<div class="toolbar-inner">' +
	                            '<div class="left"></div>' +
	                            '<div class="right"><a href="#" class="link close-picker"><span>{{closeText}}</span></a></div>' +
	                            '</div>' +
	                            '</div>');
	                }
	                toolbarHTML = app._compiledTemplates.smartSelectToolbar({
	                    pageTitle: pageTitle,
	                    closeText: closeText,
	                    openIn: openIn,
	                    toolbarTheme: toolbarTheme,
	                    inPicker: openIn === 'picker'
	                });
	            }
	            else {
	                // Navbar HTML
	                if (!app._compiledTemplates.smartSelectNavbar) {
	                    app._compiledTemplates.smartSelectNavbar = t7.compile(app.params.smartSelectNavbarTemplate ||
	                        '<div class="navbar {{#if navbarTheme}}theme-{{navbarTheme}}{{/if}}">' +
	                            '<div class="navbar-inner">' +
	                            '{{leftTemplate}}' +
	                            '<div class="center sliding">{{pageTitle}}</div>' +
	                            '</div>' +
	                            '</div>');
	                }
	                navbarHTML = app._compiledTemplates.smartSelectNavbar({
	                    pageTitle: pageTitle,
	                    backText: backText,
	                    closeText: closeText,
	                    openIn: openIn,
	                    navbarTheme: navbarTheme,
	                    inPopup: openIn === 'popup',
	                    inPage: openIn === 'page',
	                    leftTemplate: openIn === 'popup' ?
	                        (app.params.smartSelectPopupCloseTemplate || (material ? '<div class="left"><a href="#" class="link close-popup icon-only"><i class="icon icon-back"></i></a></div>' : '<div class="left"><a href="#" class="link close-popup"><i class="icon icon-back"></i><span>{{closeText}}</span></a></div>')).replace(/{{closeText}}/g, closeText) :
	                        (app.params.smartSelectBackTemplate || (material ? '<div class="left"><a href="#" class="back link icon-only"><i class="icon icon-back"></i></a></div>' : '<div class="left sliding"><a href="#" class="back link"><i class="icon icon-back"></i><span>{{backText}}</span></a></div>')).replace(/{{backText}}/g, backText)
	                });
	                // Determine navbar layout type - static/fixed/through
	                if (openIn === 'page') {
	                    navbarLayout = 'static';
	                    if (smartSelect.parents('.navbar-through').length > 0)
	                        navbarLayout = 'through';
	                    if (smartSelect.parents('.navbar-fixed').length > 0)
	                        navbarLayout = 'fixed';
	                    noToolbar = smartSelect.parents('.page').hasClass('no-toolbar') ? 'no-toolbar' : '';
	                    noNavbar = smartSelect.parents('.page').hasClass('no-navbar') ? 'no-navbar' : 'navbar-' + navbarLayout;
	                    noTabbar = smartSelect.parents('.page').hasClass('no-tabbar') ? 'no-tabbar' : '';
	                }
	                else {
	                    navbarLayout = 'fixed';
	                }
	            }
	            // Page Layout
	            var pageName = 'smart-select-' + inputName;
	            var useSearchbar = typeof smartSelect.data('searchbar') === 'undefined' ? app.params.smartSelectSearchbar : (smartSelect.data('searchbar') === 'true' ? true : false);
	            var searchbarPlaceholder, searchbarCancel;
	            if (useSearchbar) {
	                searchbarPlaceholder = smartSelect.data('searchbar-placeholder') || 'Search';
	                searchbarCancel = smartSelect.data('searchbar-cancel') || 'Cancel';
	            }
	            var searchbarHTML = '<form class="searchbar searchbar-init" data-search-list=".smart-select-list-' + id + '" data-search-in=".item-title">' +
	                '<div class="searchbar-input">' +
	                '<input type="search" placeholder="' + searchbarPlaceholder + '">' +
	                '<a href="#" class="searchbar-clear"></a>' +
	                '</div>' +
	                (material ? '' : '<a href="#" class="searchbar-cancel">' + searchbarCancel + '</a>') +
	                '</form>' +
	                '<div class="searchbar-overlay"></div>';
	            var pageHTML = (openIn !== 'picker' && navbarLayout === 'through' ? navbarHTML : '') +
	                '<div class="pages">' +
	                '  <div data-page="' + pageName + '" data-select-name="' + selectName + '" class="page smart-select-page ' + noNavbar + ' ' + noToolbar + ' ' + noTabbar + '">' +
	                (openIn !== 'picker' && navbarLayout === 'fixed' ? navbarHTML : '') +
	                (useSearchbar ? searchbarHTML : '') +
	                '    <div class="page-content">' +
	                (openIn !== 'picker' && navbarLayout === 'static' ? navbarHTML : '') +
	                '      <div class="list-block ' + (virtualList ? 'virtual-list' : '') + ' smart-select-list-' + id + ' ' + (formTheme ? 'theme-' + formTheme : '') + '">' +
	                '        <ul>' +
	                (virtualList ? '' : inputsHTML) +
	                '        </ul>' +
	                '      </div>' +
	                '    </div>' +
	                '  </div>' +
	                '</div>';
	            // Define popup and picker
	            var popup, picker;
	            // Scroll SS Picker To Input
	            function scrollToInput() {
	                var pageContent = smartSelect.parents('.page-content');
	                if (pageContent.length === 0)
	                    return;
	                var paddingTop = parseInt(pageContent.css('padding-top'), 10), paddingBottom = parseInt(pageContent.css('padding-bottom'), 10), pageHeight = pageContent[0].offsetHeight - paddingTop - picker.height(), pageScrollHeight = pageContent[0].scrollHeight - paddingTop - picker.height(), newPaddingBottom;
	                var inputTop = smartSelect.offset().top - paddingTop + smartSelect[0].offsetHeight;
	                if (inputTop > pageHeight) {
	                    var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
	                    if (scrollTop + pageHeight > pageScrollHeight) {
	                        newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
	                        if (pageHeight === pageScrollHeight) {
	                            newPaddingBottom = picker.height();
	                        }
	                        pageContent.css({ 'padding-bottom': (newPaddingBottom) + 'px' });
	                    }
	                    pageContent.scrollTop(scrollTop, 300);
	                }
	            }
	            // Close SS Picker on HTML Click
	            function closeOnHTMLClick(e) {
	                var close = true;
	                if (e.target === smartSelect[0] || $(e.target).parents(smartSelect[0]).length > 0) {
	                    close = false;
	                }
	                if ($(e.target).parents('.picker-modal').length > 0) {
	                    close = false;
	                }
	                if (close) {
	                    app.closeModal('.smart-select-picker.modal-in');
	                }
	            }
	            // Check max length
	            function checkMaxLength(container) {
	                if (select.selectedOptions.length >= maxLength) {
	                    container.find('input[type="checkbox"]').each(function () {
	                        if (!this.checked) {
	                            $(this).parents('li').addClass('disabled');
	                        }
	                        else {
	                            $(this).parents('li').removeClass('disabled');
	                        }
	                    });
	                }
	                else {
	                    container.find('.disabled').removeClass('disabled');
	                }
	            }
	            // Event Listeners on new page
	            function handleInputs(container) {
	                container = $(container);
	                if (virtualList) {
	                    var virtualListInstance = app.virtualList(container.find('.virtual-list'), {
	                        items: values,
	                        template: smartSelectItemTemplate,
	                        height: virtualListHeight || undefined,
	                        searchByItem: function (query, index, item) {
	                            if (item.text && item.text.toLowerCase().indexOf(query.trim().toLowerCase()) >= 0)
	                                return true;
	                            return false;
	                        }
	                    });
	                    container.once(openIn === 'popup' || openIn === 'picker' ? 'closed' : 'pageBeforeRemove', function () {
	                        if (virtualListInstance && virtualListInstance.destroy)
	                            virtualListInstance.destroy();
	                    });
	                }
	                if (maxLength) {
	                    checkMaxLength(container);
	                }
	                if (backOnSelect) {
	                    container.find('input[type="radio"][name="' + inputName + '"]:checked').parents('label').once('click', function () {
	                        if (openIn === 'popup')
	                            app.closeModal(popup);
	                        else if (openIn === 'picker')
	                            app.closeModal(picker);
	                        else
	                            view.router.back();
	                    });
	                }
	                container.on('change', 'input[name="' + inputName + '"]', function () {
	                    var option, text;
	                    var input = this;
	                    var value = input.value;
	                    var optionText = [];
	                    var displayAs;
	                    if (input.type === 'checkbox') {
	                        var values = [];
	                        for (var i = 0; i < select.options.length; i++) {
	                            option = select.options[i];
	                            if (option.value === value) {
	                                option.selected = input.checked;
	                            }
	                            if (option.selected) {
	                                displayAs = option.dataset ? option.dataset.displayAs : $(option).data('display-as');
	                                text = displayAs && typeof displayAs !== 'undefined' ? displayAs : option.textContent;
	                                optionText.push(text.trim());
	                            }
	                        }
	                        if (maxLength) {
	                            checkMaxLength(container);
	                        }
	                    }
	                    else {
	                        option = smartSelect.find('option[value="' + value + '"]')[0];
	                        displayAs = option.dataset ? option.dataset.displayAs : $(option).data('display-as');
	                        text = displayAs && typeof displayAs !== 'undefined' ? displayAs : option.textContent;
	                        optionText = [text];
	                        select.value = value;
	                    }
	                    $select.trigger('change');
	                    smartSelect.find('.item-after').text(optionText.join(', '));
	                    if (backOnSelect && inputType === 'radio') {
	                        if (openIn === 'popup')
	                            app.closeModal(popup);
	                        else if (openIn === 'picker')
	                            app.closeModal(picker);
	                        else
	                            view.router.back();
	                    }
	                });
	            }
	            function pageInit(e) {
	                var page = e.detail.page;
	                if (page.name === pageName) {
	                    handleInputs(page.container);
	                }
	            }
	            if (openIn === 'popup') {
	                if (reLayout) {
	                    popup = $('.popup.smart-select-popup .view');
	                    popup.html(pageHTML);
	                }
	                else {
	                    popup = app.popup('<div class="popup smart-select-popup smart-select-popup-' + inputName + '">' +
	                        '<div class="view navbar-fixed">' +
	                        pageHTML +
	                        '</div>' +
	                        '</div>');
	                    popup = $(popup);
	                }
	                app.initPage(popup.find('.page'));
	                handleInputs(popup);
	            }
	            else if (openIn === 'picker') {
	                if (reLayout) {
	                    picker = $('.picker-modal.smart-select-picker .view');
	                    picker.html(pageHTML);
	                }
	                else {
	                    picker = app.pickerModal('<div class="picker-modal smart-select-picker smart-select-picker-' + inputName + '"' + (pickerHeight ? ' style="height:' + pickerHeight + '"' : '') + '>' +
	                        toolbarHTML +
	                        '<div class="picker-modal-inner">' +
	                        '<div class="view">' +
	                        pageHTML +
	                        '</div>' +
	                        '</div>' +
	                        '</div>');
	                    picker = $(picker);
	                    // Scroll To Input
	                    scrollToInput();
	                    // Close On Click
	                    $('html').on('click', closeOnHTMLClick);
	                    // On Close
	                    picker.once('picker:close', function () {
	                        // Reset linked picker
	                        smartSelect[0].f7SmartSelectPicker = undefined;
	                        // Detach html click
	                        $('html').off('click', closeOnHTMLClick);
	                        // Restore page padding bottom
	                        smartSelect.parents('.page-content').css({ paddingBottom: '' });
	                    });
	                    // Link Picker
	                    smartSelect[0].f7SmartSelectPicker = picker[0];
	                }
	                // Init Page
	                app.initPage(picker.find('.page'));
	                // Attach events
	                handleInputs(picker);
	            }
	            else {
	                $(document).once('page:init', '.smart-select-page', pageInit);
	                view.router.load({
	                    content: pageHTML,
	                    reload: reLayout ? true : undefined
	                });
	            }
	        };
	        /*===============================================================================
	        ************   Virtual List   ************
	        ===============================================================================*/
	        var VirtualList = function (listBlock, params) {
	            var defaults = {
	                cols: 1,
	                height: app.params.material ? 48 : 44,
	                cache: true,
	                dynamicHeightBufferSize: 1,
	                showFilteredItemsOnly: false,
	                renderExternal: undefined,
	                template: '<li>' +
	                    '<div class="item-content">' +
	                    '<div class="item-inner">' +
	                    '<div class="item-title">{{this}}</div>' +
	                    '</div>' +
	                    '</div>' +
	                    '</li>'
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            // Preparation
	            var vl = this;
	            vl.listBlock = $(listBlock);
	            vl.params = params;
	            vl.items = vl.params.items;
	            if (vl.params.showFilteredItemsOnly) {
	                vl.filteredItems = [];
	            }
	            if (vl.params.template && !vl.params.renderItem) {
	                if (typeof vl.params.template === 'string')
	                    vl.template = t7.compile(vl.params.template);
	                else if (typeof vl.params.template === 'function')
	                    vl.template = vl.params.template;
	            }
	            vl.pageContent = vl.listBlock.parents('.page-content');
	            // Bad scroll
	            var updatableScroll;
	            if (typeof vl.params.updatableScroll !== 'undefined') {
	                updatableScroll = vl.params.updatableScroll;
	            }
	            else {
	                updatableScroll = true;
	                if (app.device.ios && app.device.osVersion.split('.')[0] < 8) {
	                    updatableScroll = false;
	                }
	                vl.params.updatableScroll = updatableScroll;
	            }
	            // Append <ul>
	            vl.ul = vl.params.ul ? $(vl.params.ul) : vl.listBlock.children('ul');
	            if (vl.ul.length === 0) {
	                vl.listBlock.append('<ul></ul>');
	                vl.ul = vl.listBlock.children('ul');
	            }
	            // DOM cached items
	            vl.domCache = {};
	            vl.displayDomCache = {};
	            // Temporary DOM Element
	            vl.tempDomElement = document.createElement('ul');
	            // Last repain position
	            vl.lastRepaintY = null;
	            // Fragment
	            vl.fragment = document.createDocumentFragment();
	            // Filter
	            vl.filterItems = function (indexes, resetScrollTop) {
	                vl.filteredItems = [];
	                var firstIndex = indexes[0];
	                var lastIndex = indexes[indexes.length - 1];
	                for (var i = 0; i < indexes.length; i++) {
	                    vl.filteredItems.push(vl.items[indexes[i]]);
	                }
	                if (typeof resetScrollTop === 'undefined')
	                    resetScrollTop = true;
	                if (resetScrollTop) {
	                    vl.pageContent[0].scrollTop = 0;
	                }
	                vl.update();
	            };
	            vl.resetFilter = function () {
	                if (vl.params.showFilteredItemsOnly) {
	                    vl.filteredItems = [];
	                }
	                else {
	                    vl.filteredItems = null;
	                    delete vl.filteredItems;
	                }
	                vl.update();
	            };
	            var pageHeight, rowsPerScreen, rowsBefore, rowsAfter, rowsToRender, maxBufferHeight = 0, listHeight;
	            var dynamicHeight = typeof vl.params.height === 'function';
	            // Set list size
	            vl.setListSize = function () {
	                var items = vl.filteredItems || vl.items;
	                pageHeight = vl.pageContent[0].offsetHeight;
	                if (dynamicHeight) {
	                    listHeight = 0;
	                    vl.heights = [];
	                    for (var i = 0; i < items.length; i++) {
	                        var itemHeight = vl.params.height(items[i]);
	                        listHeight += itemHeight;
	                        vl.heights.push(itemHeight);
	                    }
	                }
	                else {
	                    listHeight = Math.ceil(items.length / vl.params.cols) * vl.params.height;
	                    rowsPerScreen = Math.ceil(pageHeight / vl.params.height);
	                    rowsBefore = vl.params.rowsBefore || rowsPerScreen * 2;
	                    rowsAfter = vl.params.rowsAfter || rowsPerScreen;
	                    rowsToRender = (rowsPerScreen + rowsBefore + rowsAfter);
	                    maxBufferHeight = rowsBefore / 2 * vl.params.height;
	                }
	                if (updatableScroll) {
	                    vl.ul.css({ height: listHeight + 'px' });
	                }
	            };
	            // Render items
	            vl.render = function (force, forceScrollTop) {
	                if (force)
	                    vl.lastRepaintY = null;
	                var scrollTop = -(vl.listBlock[0].getBoundingClientRect().top - vl.pageContent[0].getBoundingClientRect().top);
	                if (typeof forceScrollTop !== 'undefined')
	                    scrollTop = forceScrollTop;
	                if (vl.lastRepaintY === null || Math.abs(scrollTop - vl.lastRepaintY) > maxBufferHeight || (!updatableScroll && (vl.pageContent[0].scrollTop + pageHeight >= vl.pageContent[0].scrollHeight))) {
	                    vl.lastRepaintY = scrollTop;
	                }
	                else {
	                    return;
	                }
	                var items = vl.filteredItems || vl.items, fromIndex, toIndex, heightBeforeFirstItem = 0, heightBeforeLastItem = 0;
	                if (dynamicHeight) {
	                    var itemTop = 0, j, itemHeight;
	                    maxBufferHeight = pageHeight;
	                    for (j = 0; j < vl.heights.length; j++) {
	                        itemHeight = vl.heights[j];
	                        if (typeof fromIndex === 'undefined') {
	                            if (itemTop + itemHeight >= scrollTop - pageHeight * 2 * vl.params.dynamicHeightBufferSize)
	                                fromIndex = j;
	                            else
	                                heightBeforeFirstItem += itemHeight;
	                        }
	                        if (typeof toIndex === 'undefined') {
	                            if (itemTop + itemHeight >= scrollTop + pageHeight * 2 * vl.params.dynamicHeightBufferSize || j === vl.heights.length - 1)
	                                toIndex = j + 1;
	                            heightBeforeLastItem += itemHeight;
	                        }
	                        itemTop += itemHeight;
	                    }
	                    toIndex = Math.min(toIndex, items.length);
	                }
	                else {
	                    fromIndex = (parseInt(scrollTop / vl.params.height) - rowsBefore) * vl.params.cols;
	                    if (fromIndex < 0) {
	                        fromIndex = 0;
	                    }
	                    toIndex = Math.min(fromIndex + rowsToRender * vl.params.cols, items.length);
	                }
	                var topPosition, renderExternalItems = [];
	                vl.reachEnd = false;
	                for (var i = fromIndex; i < toIndex; i++) {
	                    var item, index;
	                    // Define real item index
	                    index = vl.items.indexOf(items[i]);
	                    if (i === fromIndex)
	                        vl.currentFromIndex = index;
	                    if (i === toIndex - 1)
	                        vl.currentToIndex = index;
	                    if (vl.filteredItems) {
	                        if (vl.items[index] === vl.filteredItems[vl.filteredItems.length - 1])
	                            vl.reachEnd = true;
	                    }
	                    else {
	                        if (index === vl.items.length - 1)
	                            vl.reachEnd = true;
	                    }
	                    // Find items
	                    if (vl.params.renderExternal) {
	                        renderExternalItems.push(items[i]);
	                    }
	                    else {
	                        if (vl.domCache[index]) {
	                            item = vl.domCache[index];
	                            item.f7VirtualListIndex = index;
	                        }
	                        else {
	                            if (vl.template && !vl.params.renderItem) {
	                                vl.tempDomElement.innerHTML = vl.template(items[i], { index: index }).trim();
	                            }
	                            else if (vl.params.renderItem) {
	                                vl.tempDomElement.innerHTML = vl.params.renderItem(index, items[i]).trim();
	                            }
	                            else {
	                                vl.tempDomElement.innerHTML = items[i].toString().trim();
	                            }
	                            item = vl.tempDomElement.childNodes[0];
	                            if (vl.params.cache)
	                                vl.domCache[index] = item;
	                            item.f7VirtualListIndex = index;
	                        }
	                    }
	                    // Set item top position
	                    if (i === fromIndex) {
	                        if (dynamicHeight) {
	                            topPosition = heightBeforeFirstItem;
	                        }
	                        else {
	                            topPosition = (i * vl.params.height / vl.params.cols);
	                        }
	                    }
	                    if (!vl.params.renderExternal) {
	                        item.style.top = topPosition + 'px';
	                        // Before item insert
	                        if (vl.params.onItemBeforeInsert)
	                            vl.params.onItemBeforeInsert(vl, item);
	                        // Append item to fragment
	                        vl.fragment.appendChild(item);
	                    }
	                }
	                // Update list height with not updatable scroll
	                if (!updatableScroll) {
	                    if (dynamicHeight) {
	                        vl.ul[0].style.height = heightBeforeLastItem + 'px';
	                    }
	                    else {
	                        vl.ul[0].style.height = i * vl.params.height / vl.params.cols + 'px';
	                    }
	                }
	                // Update list html
	                if (vl.params.renderExternal) {
	                    if (items && items.length === 0) {
	                        vl.reachEnd = true;
	                    }
	                }
	                else {
	                    if (vl.params.onBeforeClear)
	                        vl.params.onBeforeClear(vl, vl.fragment);
	                    vl.ul[0].innerHTML = '';
	                    if (vl.params.onItemsBeforeInsert)
	                        vl.params.onItemsBeforeInsert(vl, vl.fragment);
	                    if (items && items.length === 0) {
	                        vl.reachEnd = true;
	                        if (vl.params.emptyTemplate)
	                            vl.ul[0].innerHTML = vl.params.emptyTemplate;
	                    }
	                    else {
	                        vl.ul[0].appendChild(vl.fragment);
	                    }
	                    if (vl.params.onItemsAfterInsert)
	                        vl.params.onItemsAfterInsert(vl, vl.fragment);
	                }
	                if (typeof forceScrollTop !== 'undefined' && force) {
	                    vl.pageContent.scrollTop(forceScrollTop, 0);
	                }
	                if (vl.params.renderExternal) {
	                    vl.params.renderExternal(vl, {
	                        fromIndex: fromIndex,
	                        toIndex: toIndex,
	                        listHeight: listHeight,
	                        topPosition: topPosition,
	                        items: renderExternalItems
	                    });
	                }
	            };
	            vl.scrollToItem = function (index) {
	                if (index > vl.items.length)
	                    return false;
	                var itemTop = 0, listTop;
	                if (dynamicHeight) {
	                    for (var i = 0; i < index; i++) {
	                        itemTop += vl.heights[i];
	                    }
	                }
	                else {
	                    itemTop = index * vl.params.height;
	                }
	                listTop = vl.listBlock[0].offsetTop;
	                vl.render(true, listTop + itemTop - parseInt(vl.pageContent.css('padding-top'), 10));
	                return true;
	            };
	            // Handle scroll event
	            vl.handleScroll = function (e) {
	                vl.render();
	            };
	            // Handle resize event
	            vl._isVisible = function (el) {
	                return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
	            };
	            vl.handleResize = function (e) {
	                if (vl._isVisible(vl.listBlock[0])) {
	                    vl.setListSize();
	                    vl.render(true);
	                }
	            };
	            vl.attachEvents = function (detach) {
	                var action = detach ? 'off' : 'on';
	                vl.pageContent[action]('scroll', vl.handleScroll);
	                vl.listBlock.parents('.tab').eq(0)[action]('tab:show', vl.handleResize);
	                vl.listBlock.parents('.panel').eq(0)[action]('panel:open', vl.handleResize);
	                vl.listBlock.parents('.popup').eq(0)[action]('popup:open', vl.handleResize);
	                app[action === 'on' ? 'onResize' : 'offResize'](vl.handleResize);
	            };
	            // Init Virtual List
	            vl.init = function () {
	                vl.attachEvents();
	                vl.setListSize();
	                vl.render();
	            };
	            // Append
	            vl.appendItems = function (items) {
	                for (var i = 0; i < items.length; i++) {
	                    vl.items.push(items[i]);
	                }
	                vl.update();
	            };
	            vl.appendItem = function (item) {
	                vl.appendItems([item]);
	            };
	            // Replace
	            vl.replaceAllItems = function (items) {
	                vl.items = items;
	                delete vl.filteredItems;
	                vl.domCache = {};
	                vl.update();
	            };
	            vl.replaceItem = function (index, item) {
	                vl.items[index] = item;
	                if (vl.params.cache)
	                    delete vl.domCache[index];
	                vl.update();
	            };
	            // Prepend
	            vl.prependItems = function (items) {
	                for (var i = items.length - 1; i >= 0; i--) {
	                    vl.items.unshift(items[i]);
	                }
	                if (vl.params.cache) {
	                    var newCache = {};
	                    for (var cached in vl.domCache) {
	                        newCache[parseInt(cached, 10) + items.length] = vl.domCache[cached];
	                    }
	                    vl.domCache = newCache;
	                }
	                vl.update();
	            };
	            vl.prependItem = function (item) {
	                vl.prependItems([item]);
	            };
	            // Move
	            vl.moveItem = function (oldIndex, newIndex) {
	                if (oldIndex === newIndex)
	                    return;
	                // remove item from array
	                var item = vl.items.splice(oldIndex, 1)[0];
	                if (newIndex >= vl.items.length) {
	                    // Add item to the end
	                    vl.items.push(item);
	                    newIndex = vl.items.length - 1;
	                }
	                else {
	                    // Add item to new index
	                    vl.items.splice(newIndex, 0, item);
	                }
	                // Update cache
	                if (vl.params.cache) {
	                    var newCache = {};
	                    for (var cached in vl.domCache) {
	                        var cachedIndex = parseInt(cached, 10);
	                        var leftIndex = oldIndex < newIndex ? oldIndex : newIndex;
	                        var rightIndex = oldIndex < newIndex ? newIndex : oldIndex;
	                        var indexShift = oldIndex < newIndex ? -1 : 1;
	                        if (cachedIndex < leftIndex || cachedIndex > rightIndex)
	                            newCache[cachedIndex] = vl.domCache[cachedIndex];
	                        if (cachedIndex === leftIndex)
	                            newCache[rightIndex] = vl.domCache[cachedIndex];
	                        if (cachedIndex > leftIndex && cachedIndex <= rightIndex)
	                            newCache[cachedIndex + indexShift] = vl.domCache[cachedIndex];
	                    }
	                    vl.domCache = newCache;
	                }
	                vl.update();
	            };
	            // Insert before
	            vl.insertItemBefore = function (index, item) {
	                if (index === 0) {
	                    vl.prependItem(item);
	                    return;
	                }
	                if (index >= vl.items.length) {
	                    vl.appendItem(item);
	                    return;
	                }
	                vl.items.splice(index, 0, item);
	                // Update cache
	                if (vl.params.cache) {
	                    var newCache = {};
	                    for (var cached in vl.domCache) {
	                        var cachedIndex = parseInt(cached, 10);
	                        if (cachedIndex >= index) {
	                            newCache[cachedIndex + 1] = vl.domCache[cachedIndex];
	                        }
	                    }
	                    vl.domCache = newCache;
	                }
	                vl.update();
	            };
	            // Delete
	            vl.deleteItems = function (indexes) {
	                var prevIndex, indexShift = 0;
	                for (var i = 0; i < indexes.length; i++) {
	                    var index = indexes[i];
	                    if (typeof prevIndex !== 'undefined') {
	                        if (index > prevIndex) {
	                            indexShift = -i;
	                        }
	                    }
	                    index = index + indexShift;
	                    prevIndex = indexes[i];
	                    // Delete item
	                    var deletedItem = vl.items.splice(index, 1)[0];
	                    // Delete from filtered
	                    if (vl.filteredItems && vl.filteredItems.indexOf(deletedItem) >= 0) {
	                        vl.filteredItems.splice(vl.filteredItems.indexOf(deletedItem), 1);
	                    }
	                    // Update cache
	                    if (vl.params.cache) {
	                        var newCache = {};
	                        for (var cached in vl.domCache) {
	                            var cachedIndex = parseInt(cached, 10);
	                            if (cachedIndex === index) {
	                                delete vl.domCache[index];
	                            }
	                            else if (parseInt(cached, 10) > index) {
	                                newCache[cachedIndex - 1] = vl.domCache[cached];
	                            }
	                            else {
	                                newCache[cachedIndex] = vl.domCache[cached];
	                            }
	                        }
	                        vl.domCache = newCache;
	                    }
	                }
	                vl.update();
	            };
	            vl.deleteAllItems = function () {
	                vl.items = [];
	                delete vl.filteredItems;
	                if (vl.params.cache)
	                    vl.domCache = {};
	                vl.update();
	            };
	            vl.deleteItem = function (index) {
	                vl.deleteItems([index]);
	            };
	            // Clear cache
	            vl.clearCache = function () {
	                vl.domCache = {};
	            };
	            // Update Virtual List
	            vl.update = function () {
	                vl.setListSize();
	                vl.render(true);
	            };
	            // Destroy
	            vl.destroy = function () {
	                vl.attachEvents(true);
	                delete vl.items;
	                delete vl.domCache;
	            };
	            // Init Virtual List
	            vl.init();
	            // Store vl in container
	            vl.listBlock[0].f7VirtualList = vl;
	            return vl;
	        };
	        // App Method
	        app.virtualList = function (listBlock, params) {
	            return new VirtualList(listBlock, params);
	        };
	        app.reinitVirtualList = function (pageContainer) {
	            var page = $(pageContainer);
	            var vlists = page.find('.virtual-list');
	            if (vlists.length === 0)
	                return;
	            for (var i = 0; i < vlists.length; i++) {
	                var vlistInstance = vlists[i].f7VirtualList;
	                if (vlistInstance) {
	                    vlistInstance.update();
	                }
	            }
	        };
	        /*======================================================
	        ************   Pull To Refresh   ************
	        ======================================================*/
	        app.initPullToRefresh = function (pageContainer) {
	            var eventsTarget = $(pageContainer);
	            if (!eventsTarget.hasClass('pull-to-refresh-content')) {
	                eventsTarget = eventsTarget.find('.pull-to-refresh-content');
	            }
	            if (!eventsTarget || eventsTarget.length === 0)
	                return;
	            var touchId, isTouched, isMoved, touchesStart = {}, isScrolling, touchesDiff, touchStartTime, container, refresh = false, useTranslate = false, startTranslate = 0, translate, scrollTop, wasScrolled, layer, triggerDistance, dynamicTriggerDistance, pullStarted;
	            var page = eventsTarget.hasClass('page') ? eventsTarget : eventsTarget.parents('.page');
	            var hasNavbar = false;
	            if (page.find('.navbar').length > 0 || page.parents('.navbar-fixed, .navbar-through').length > 0 || page.hasClass('navbar-fixed') || page.hasClass('navbar-through'))
	                hasNavbar = true;
	            if (page.hasClass('no-navbar'))
	                hasNavbar = false;
	            if (!hasNavbar)
	                eventsTarget.addClass('pull-to-refresh-no-navbar');
	            container = eventsTarget;
	            // Define trigger distance
	            if (container.attr('data-ptr-distance')) {
	                dynamicTriggerDistance = true;
	            }
	            else {
	                triggerDistance = 44;
	            }
	            function handleTouchStart(e) {
	                if (isTouched) {
	                    if (app.device.os === 'android') {
	                        if ('targetTouches' in e && e.targetTouches.length > 1)
	                            return;
	                    }
	                    else {
	                        if (isMoved && isTouched && isScrolling) {
	                            return;
	                        }
	                    }
	                }
	                /*jshint validthis:true */
	                container = $(this);
	                if (container.hasClass('refreshing')) {
	                    return;
	                }
	                isMoved = false;
	                pullStarted = false;
	                isTouched = true;
	                isScrolling = undefined;
	                wasScrolled = undefined;
	                if (e.type === 'touchstart')
	                    touchId = e.targetTouches[0].identifier;
	                touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                touchStartTime = (new Date()).getTime();
	            }
	            function handleTouchMove(e) {
	                if (!isTouched)
	                    return;
	                var pageX, pageY, touch;
	                if (e.type === 'touchmove') {
	                    if (touchId && e.touches) {
	                        for (var i = 0; i < e.touches.length; i++) {
	                            if (e.touches[i].identifier === touchId) {
	                                touch = e.touches[i];
	                            }
	                        }
	                    }
	                    if (!touch)
	                        touch = e.targetTouches[0];
	                    pageX = touch.pageX;
	                    pageY = touch.pageY;
	                }
	                else {
	                    pageX = e.pageX;
	                    pageY = e.pageY;
	                }
	                if (!pageX || !pageY)
	                    return;
	                if (typeof isScrolling === 'undefined') {
	                    isScrolling = !!(isScrolling || Math.abs(pageY - touchesStart.y) > Math.abs(pageX - touchesStart.x));
	                }
	                if (!isScrolling) {
	                    isTouched = false;
	                    return;
	                }
	                scrollTop = container[0].scrollTop;
	                if (typeof wasScrolled === 'undefined' && scrollTop !== 0)
	                    wasScrolled = true;
	                if (!isMoved) {
	                    /*jshint validthis:true */
	                    container.removeClass('transitioning');
	                    if (scrollTop > container[0].offsetHeight) {
	                        isTouched = false;
	                        return;
	                    }
	                    if (dynamicTriggerDistance) {
	                        triggerDistance = container.attr('data-ptr-distance');
	                        if (triggerDistance.indexOf('%') >= 0)
	                            triggerDistance = container[0].offsetHeight * parseInt(triggerDistance, 10) / 100;
	                    }
	                    startTranslate = container.hasClass('refreshing') ? triggerDistance : 0;
	                    if (container[0].scrollHeight === container[0].offsetHeight || app.device.os !== 'ios') {
	                        useTranslate = true;
	                    }
	                    else {
	                        useTranslate = false;
	                    }
	                }
	                isMoved = true;
	                touchesDiff = pageY - touchesStart.y;
	                if (touchesDiff > 0 && scrollTop <= 0 || scrollTop < 0) {
	                    // iOS 8 fix
	                    if (app.device.os === 'ios' && parseInt(app.device.osVersion.split('.')[0], 10) > 7 && scrollTop === 0 && !wasScrolled)
	                        useTranslate = true;
	                    if (useTranslate) {
	                        e.preventDefault();
	                        translate = (Math.pow(touchesDiff, 0.85) + startTranslate);
	                        container.transform('translate3d(0,' + translate + 'px,0)');
	                    }
	                    if ((useTranslate && Math.pow(touchesDiff, 0.85) > triggerDistance) || (!useTranslate && touchesDiff >= triggerDistance * 2)) {
	                        refresh = true;
	                        container.addClass('pull-up').removeClass('pull-down');
	                    }
	                    else {
	                        refresh = false;
	                        container.removeClass('pull-up').addClass('pull-down');
	                    }
	                    if (!pullStarted) {
	                        container.trigger('pullstart ptr:pullstart');
	                        pullStarted = true;
	                    }
	                    container.trigger('pullmove ptr:pullmove', {
	                        event: e,
	                        scrollTop: scrollTop,
	                        translate: translate,
	                        touchesDiff: touchesDiff
	                    });
	                }
	                else {
	                    pullStarted = false;
	                    container.removeClass('pull-up pull-down');
	                    refresh = false;
	                    return;
	                }
	            }
	            function handleTouchEnd(e) {
	                if (e.type === 'touchend' && e.changedTouches && e.changedTouches.length > 0 && touchId) {
	                    if (e.changedTouches[0].identifier !== touchId) {
	                        isTouched = false;
	                        isScrolling = false;
	                        isMoved = false;
	                        touchId = null;
	                        return;
	                    }
	                    ;
	                }
	                if (!isTouched || !isMoved) {
	                    isTouched = false;
	                    isMoved = false;
	                    return;
	                }
	                if (translate) {
	                    container.addClass('transitioning');
	                    translate = 0;
	                }
	                container.transform('');
	                if (refresh) {
	                    container.addClass('refreshing');
	                    container.trigger('refresh ptr:refresh', {
	                        done: function () {
	                            app.pullToRefreshDone(container);
	                        }
	                    });
	                }
	                else {
	                    container.removeClass('pull-down');
	                }
	                isTouched = false;
	                isMoved = false;
	                if (pullStarted)
	                    container.trigger('pullend ptr:pullend');
	            }
	            // Attach Events
	            var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? { passive: true, capture: false } : false;
	            var activeListener = app.support.passiveListener ? { passive: false, capture: false } : false;
	            eventsTarget.on(app.touchEvents.start, handleTouchStart, passiveListener);
	            eventsTarget.on(app.touchEvents.move, handleTouchMove, activeListener);
	            eventsTarget.on(app.touchEvents.end, handleTouchEnd, passiveListener);
	            // Detach Events on page remove
	            if (page.length === 0)
	                return;
	            function destroyPullToRefresh(destroyTarget) {
	                destroyTarget.off(app.touchEvents.start, handleTouchStart, passiveListener);
	                destroyTarget.off(app.touchEvents.move, handleTouchMove, activeListener);
	                destroyTarget.off(app.touchEvents.end, handleTouchEnd, passiveListener);
	            }
	            for (var i = 0; i < eventsTarget.length; i++) {
	                eventsTarget[i].f7DestroyPullToRefresh = destroyPullToRefresh;
	            }
	            function detachEvents() {
	                destroyPullToRefresh(eventsTarget);
	                page.off('page:beforeremove', detachEvents);
	            }
	            page.on('page:beforeremove', detachEvents);
	        };
	        app.pullToRefreshDone = function (container) {
	            container = $(container);
	            if (container.length === 0)
	                container = $('.pull-to-refresh-content.refreshing');
	            container.removeClass('refreshing').addClass('transitioning');
	            container.transitionEnd(function () {
	                container.removeClass('transitioning pull-up pull-down');
	                container.trigger('refreshdone ptr:done');
	            });
	        };
	        app.pullToRefreshTrigger = function (container) {
	            container = $(container);
	            if (container.length === 0)
	                container = $('.pull-to-refresh-content');
	            if (container.hasClass('refreshing'))
	                return;
	            container.addClass('transitioning refreshing');
	            container.trigger('refresh ptr:refresh', {
	                done: function () {
	                    app.pullToRefreshDone(container);
	                }
	            });
	        };
	        app.destroyPullToRefresh = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var pullToRefreshContent = pageContainer.hasClass('pull-to-refresh-content') ? pageContainer : pageContainer.find('.pull-to-refresh-content');
	            if (pullToRefreshContent.length === 0)
	                return;
	            if (pullToRefreshContent[0].f7DestroyPullToRefresh)
	                pullToRefreshContent[0].f7DestroyPullToRefresh(pageContainer);
	        };
	        /* ===============================================================================
	        ************   Infinite Scroll   ************
	        =============================================================================== */
	        function handleInfiniteScroll() {
	            /*jshint validthis:true */
	            var inf = $(this);
	            var scrollTop = inf[0].scrollTop;
	            var scrollHeight = inf[0].scrollHeight;
	            var height = inf[0].offsetHeight;
	            var distance = inf[0].getAttribute('data-distance');
	            var virtualListContainer = inf.find('.virtual-list');
	            var virtualList;
	            var onTop = inf.hasClass('infinite-scroll-top');
	            if (!distance)
	                distance = 50;
	            if (typeof distance === 'string' && distance.indexOf('%') >= 0) {
	                distance = parseInt(distance, 10) / 100 * height;
	            }
	            if (distance > height)
	                distance = height;
	            if (onTop) {
	                if (scrollTop < distance) {
	                    inf.trigger('infinite');
	                }
	            }
	            else {
	                if (scrollTop + height >= scrollHeight - distance) {
	                    if (virtualListContainer.length > 0) {
	                        virtualList = virtualListContainer.eq(-1)[0].f7VirtualList;
	                        if (virtualList && !virtualList.reachEnd && !virtualList.params.updatableScroll) {
	                            return;
	                        }
	                    }
	                    inf.trigger('infinite');
	                }
	            }
	        }
	        app.attachInfiniteScroll = function (infiniteContent) {
	            $(infiniteContent).on('scroll', handleInfiniteScroll);
	        };
	        app.detachInfiniteScroll = function (infiniteContent) {
	            $(infiniteContent).off('scroll', handleInfiniteScroll);
	        };
	        app.initPageInfiniteScroll = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var infiniteContent = pageContainer.find('.infinite-scroll');
	            if (infiniteContent.length === 0)
	                return;
	            app.attachInfiniteScroll(infiniteContent);
	            function detachEvents() {
	                app.detachInfiniteScroll(infiniteContent);
	                pageContainer.off('page:beforeremove', detachEvents);
	            }
	            pageContainer.on('page:beforeremove', detachEvents);
	        };
	        /*=============================================================
	        ************   Hide/show Toolbar/Navbar on scroll   ************
	        =============================================================*/
	        app.initPageScrollToolbars = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var scrollContent = pageContainer.find('.page-content');
	            if (scrollContent.length === 0)
	                return;
	            var hideNavbar = (app.params.hideNavbarOnPageScroll || scrollContent.hasClass('hide-navbar-on-scroll') || scrollContent.hasClass('hide-bars-on-scroll')) && !(scrollContent.hasClass('keep-navbar-on-scroll') || scrollContent.hasClass('keep-bars-on-scroll'));
	            var hideToolbar = (app.params.hideToolbarOnPageScroll || scrollContent.hasClass('hide-toolbar-on-scroll') || scrollContent.hasClass('hide-bars-on-scroll')) && !(scrollContent.hasClass('keep-toolbar-on-scroll') || scrollContent.hasClass('keep-bars-on-scroll'));
	            var hideTabbar = (app.params.hideTabbarOnPageScroll || scrollContent.hasClass('hide-tabbar-on-scroll')) && !(scrollContent.hasClass('keep-tabbar-on-scroll'));
	            if (!(hideNavbar || hideToolbar || hideTabbar))
	                return;
	            var viewContainer = scrollContent.parents('.' + app.params.viewClass);
	            if (viewContainer.length === 0)
	                return;
	            var navbar = viewContainer.find('.navbar'), toolbar = viewContainer.find('.toolbar'), tabbar;
	            if (hideTabbar) {
	                tabbar = viewContainer.find('.tabbar');
	                if (tabbar.length === 0)
	                    tabbar = viewContainer.parents('.' + app.params.viewsClass).find('.tabbar');
	            }
	            var hasNavbar = navbar.length > 0, hasToolbar = toolbar.length > 0, hasTabbar = tabbar && tabbar.length > 0;
	            var previousScroll, currentScroll;
	            previousScroll = currentScroll = scrollContent[0].scrollTop;
	            var scrollHeight, offsetHeight, reachEnd, action, navbarHidden, toolbarHidden, tabbarHidden;
	            var toolbarHeight = (hasToolbar && hideToolbar) ? toolbar[0].offsetHeight : 0;
	            var tabbarHeight = (hasTabbar && hideTabbar) ? tabbar[0].offsetHeight : 0;
	            var bottomBarHeight = tabbarHeight || toolbarHeight;
	            function handleScroll(e) {
	                if (pageContainer.hasClass('page-on-left'))
	                    return;
	                currentScroll = scrollContent[0].scrollTop;
	                scrollHeight = scrollContent[0].scrollHeight;
	                offsetHeight = scrollContent[0].offsetHeight;
	                reachEnd = currentScroll + offsetHeight >= scrollHeight - bottomBarHeight;
	                navbarHidden = navbar.hasClass('navbar-hidden');
	                toolbarHidden = toolbar.hasClass('toolbar-hidden');
	                tabbarHidden = tabbar && tabbar.hasClass('toolbar-hidden');
	                if (reachEnd) {
	                    if (app.params.showBarsOnPageScrollEnd) {
	                        action = 'show';
	                    }
	                }
	                else if (previousScroll > currentScroll) {
	                    if (app.params.showBarsOnPageScrollTop || currentScroll <= 44) {
	                        action = 'show';
	                    }
	                    else {
	                        action = 'hide';
	                    }
	                }
	                else {
	                    if (currentScroll > 44) {
	                        action = 'hide';
	                    }
	                    else {
	                        action = 'show';
	                    }
	                }
	                if (action === 'show') {
	                    if (hasNavbar && hideNavbar && navbarHidden) {
	                        app.showNavbar(navbar);
	                        pageContainer.removeClass('no-navbar-by-scroll');
	                        navbarHidden = false;
	                    }
	                    if (hasToolbar && hideToolbar && toolbarHidden) {
	                        app.showToolbar(toolbar);
	                        pageContainer.removeClass('no-toolbar-by-scroll');
	                        toolbarHidden = false;
	                    }
	                    if (hasTabbar && hideTabbar && tabbarHidden) {
	                        app.showToolbar(tabbar);
	                        pageContainer.removeClass('no-tabbar-by-scroll');
	                        tabbarHidden = false;
	                    }
	                }
	                else {
	                    if (hasNavbar && hideNavbar && !navbarHidden) {
	                        app.hideNavbar(navbar);
	                        pageContainer.addClass('no-navbar-by-scroll');
	                        navbarHidden = true;
	                    }
	                    if (hasToolbar && hideToolbar && !toolbarHidden) {
	                        app.hideToolbar(toolbar);
	                        pageContainer.addClass('no-toolbar-by-scroll');
	                        toolbarHidden = true;
	                    }
	                    if (hasTabbar && hideTabbar && !tabbarHidden) {
	                        app.hideToolbar(tabbar);
	                        pageContainer.addClass('no-tabbar-by-scroll');
	                        tabbarHidden = true;
	                    }
	                }
	                previousScroll = currentScroll;
	            }
	            scrollContent.on('scroll', handleScroll);
	            scrollContent[0].f7ScrollToolbarsHandler = handleScroll;
	        };
	        app.destroyScrollToolbars = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var scrollContent = pageContainer.find('.page-content');
	            if (scrollContent.length === 0)
	                return;
	            var handler = scrollContent[0].f7ScrollToolbarsHandler;
	            if (!handler)
	                return;
	            scrollContent.off('scroll', scrollContent[0].f7ScrollToolbarsHandler);
	        };
	        /*======================================================
	        ************   Material Tabbar   ************
	        ======================================================*/
	        app.materialTabbarSetHighlight = function (tabbar, activeLink) {
	            $(tabbar).each(function () {
	                var tabbar = $(this);
	                activeLink = activeLink || tabbar.find('.tab-link.active');
	                if (activeLink && activeLink.length > 0) {
	                    var tabLinkWidth, highlightTranslate;
	                    if (tabbar.hasClass('tabbar-scrollable')) {
	                        tabLinkWidth = activeLink[0].offsetWidth + 'px';
	                        highlightTranslate = activeLink[0].offsetLeft + 'px';
	                    }
	                    else {
	                        tabLinkWidth = 1 / tabbar.find('.tab-link').length * 100 + '%';
	                        highlightTranslate = (app.rtl ? -activeLink.index() : activeLink.index()) * 100 + '%';
	                    }
	                    tabbar.find('.tab-link-highlight')
	                        .css({ width: tabLinkWidth })
	                        .transform('translate3d(' + highlightTranslate + ',0,0)');
	                }
	            });
	        };
	        app.initPageMaterialTabbar = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var tabbar = pageContainer.find('.tabbar');
	            if (tabbar.length === 0 && pageContainer.hasClass('tabbar'))
	                tabbar = pageContainer;
	            function tabbarSetHighlight() {
	                app.materialTabbarSetHighlight(tabbar);
	            }
	            if (tabbar.length > 0) {
	                if (tabbar.find('.tab-link-highlight').length === 0) {
	                    tabbar.find('.toolbar-inner').append('<span class="tab-link-highlight"></span>');
	                }
	                tabbarSetHighlight();
	                app.onResize(tabbarSetHighlight);
	                pageContainer.once('page:beforeremove', function () {
	                    app.offResize(tabbarSetHighlight);
	                });
	            }
	        };
	        app.initMaterialTabbar = function (tabbar) {
	            return app.initPageMaterialTabbar(tabbar);
	        };
	        /* ===============================================================================
	        ************   Tabs   ************
	        =============================================================================== */
	        app.showTab = function (tab, tabLink, animated, force) {
	            var newTab = $(tab);
	            if (arguments.length === 2 && typeof arguments[1] === 'boolean') {
	                tab = arguments[0];
	                animated = arguments[1];
	            }
	            if (arguments.length === 3 && typeof arguments[1] === 'boolean' && typeof arguments[2] === 'boolean') {
	                tab = arguments[0];
	                animated = arguments[1];
	                force = arguments[2];
	            }
	            if (typeof animated === 'undefined')
	                animated = true;
	            if (newTab.length === 0)
	                return false;
	            if (newTab.hasClass('active')) {
	                if (force)
	                    newTab.trigger('show tab:show');
	                return false;
	            }
	            var tabs = newTab.parent('.tabs');
	            if (tabs.length === 0)
	                return false;
	            // Return swipeouts in hidden tabs
	            app.allowSwipeout = true;
	            // Animated tabs
	            var isAnimatedTabs = tabs.parent().hasClass('tabs-animated-wrap');
	            if (isAnimatedTabs) {
	                tabs.parent()[animated ? 'removeClass' : 'addClass']('not-animated');
	                var tabTranslate = (app.rtl ? newTab.index() : -newTab.index()) * 100;
	                tabs.transform('translate3d(' + tabTranslate + '%,0,0)');
	            }
	            // Swipeable tabs
	            var isSwipeableTabs = tabs.parent().hasClass('tabs-swipeable-wrap'), swiper;
	            if (isSwipeableTabs) {
	                swiper = tabs.parent()[0].swiper;
	                if (swiper.activeIndex !== newTab.index())
	                    swiper.slideTo(newTab.index(), animated ? undefined : 0, false);
	            }
	            // Remove active class from old tabs
	            var oldTab = tabs.children('.tab.active').removeClass('active').trigger('hide tab:hide');
	            // Add active class to new tab
	            newTab.addClass('active');
	            // Trigger 'show' event on new tab
	            newTab.trigger('show tab:show');
	            // Update navbars in new tab
	            if (!isAnimatedTabs && !isSwipeableTabs && newTab.find('.navbar').length > 0) {
	                // Find tab's view
	                var viewContainer;
	                if (newTab.hasClass(app.params.viewClass))
	                    viewContainer = newTab[0];
	                else
	                    viewContainer = newTab.parents('.' + app.params.viewClass)[0];
	                app.sizeNavbars(viewContainer);
	            }
	            // Find related link for new tab
	            if (tabLink)
	                tabLink = $(tabLink);
	            else {
	                // Search by id
	                if (typeof tab === 'string')
	                    tabLink = $('.tab-link[href="' + tab + '"]');
	                else
	                    tabLink = $('.tab-link[href="#' + newTab.attr('id') + '"]');
	                // Search by data-tab
	                if (!tabLink || tabLink && tabLink.length === 0) {
	                    $('[data-tab]').each(function () {
	                        if (newTab.is($(this).attr('data-tab')))
	                            tabLink = $(this);
	                    });
	                }
	            }
	            if (tabLink.length === 0)
	                return;
	            // Find related link for old tab
	            var oldTabLink;
	            if (oldTab && oldTab.length > 0) {
	                // Search by id
	                var oldTabId = oldTab.attr('id');
	                if (oldTabId)
	                    oldTabLink = $('.tab-link[href="#' + oldTabId + '"]');
	                // Search by data-tab
	                if (!oldTabLink || oldTabLink && oldTabLink.length === 0) {
	                    $('[data-tab]').each(function () {
	                        if (oldTab.is($(this).attr('data-tab')))
	                            oldTabLink = $(this);
	                    });
	                }
	            }
	            // Update links' classes
	            if (tabLink && tabLink.length > 0) {
	                tabLink.addClass('active');
	                // Material Highlight
	                if (app.params.material) {
	                    var tabbar = tabLink.parents('.tabbar');
	                    if (tabbar.length > 0) {
	                        if (tabbar.find('.tab-link-highlight').length === 0) {
	                            tabbar.find('.toolbar-inner').append('<span class="tab-link-highlight"></span>');
	                        }
	                        app.materialTabbarSetHighlight(tabbar, tabLink);
	                    }
	                }
	            }
	            if (oldTabLink && oldTabLink.length > 0)
	                oldTabLink.removeClass('active');
	            return true;
	        };
	        /*===============================================================================
	        ************   Accordion   ************
	        ===============================================================================*/
	        app.accordionToggle = function (item) {
	            item = $(item);
	            if (item.length === 0)
	                return;
	            if (item.hasClass('accordion-item-expanded'))
	                app.accordionClose(item);
	            else
	                app.accordionOpen(item);
	        };
	        app.accordionOpen = function (item) {
	            item = $(item);
	            var list = item.parents('.accordion-list').eq(0);
	            var content = item.children('.accordion-item-content');
	            if (content.length === 0)
	                content = item.find('.accordion-item-content');
	            var expandedItem = list.length > 0 && item.parent().children('.accordion-item-expanded');
	            if (expandedItem.length > 0) {
	                app.accordionClose(expandedItem);
	            }
	            content.css('height', content[0].scrollHeight + 'px').transitionEnd(function () {
	                if (item.hasClass('accordion-item-expanded')) {
	                    content.transition(0);
	                    content.css('height', 'auto');
	                    var clientLeft = content[0].clientLeft;
	                    content.transition('');
	                    item.trigger('opened accordion:opened');
	                }
	                else {
	                    content.css('height', '');
	                    item.trigger('closed accordion:closed');
	                }
	            });
	            item.trigger('open accordion:open');
	            item.addClass('accordion-item-expanded');
	        };
	        app.accordionClose = function (item) {
	            item = $(item);
	            var content = item.children('.accordion-item-content');
	            if (content.length === 0)
	                content = item.find('.accordion-item-content');
	            item.removeClass('accordion-item-expanded');
	            content.transition(0);
	            content.css('height', content[0].scrollHeight + 'px');
	            // Relayout
	            var clientLeft = content[0].clientLeft;
	            // Close
	            content.transition('');
	            content.css('height', '').transitionEnd(function () {
	                if (item.hasClass('accordion-item-expanded')) {
	                    content.transition(0);
	                    content.css('height', 'auto');
	                    var clientLeft = content[0].clientLeft;
	                    content.transition('');
	                    item.trigger('opened accordion:opened');
	                }
	                else {
	                    content.css('height', '');
	                    item.trigger('closed accordion:closed');
	                }
	            });
	            item.trigger('close accordion:close');
	        };
	        /*===============================================================================
	        ************   Fast Clicks   ************
	        ************   Inspired by https://github.com/ftlabs/fastclick   ************
	        ===============================================================================*/
	        app.initFastClicks = function () {
	            if (app.params.activeState) {
	                $('html').addClass('watch-active-state');
	            }
	            if (app.device.ios && app.device.webView) {
	                // Strange hack required for iOS 8 webview to work on inputs
	                window.addEventListener('touchstart', function () { });
	            }
	            var touchStartX, touchStartY, touchStartTime, targetElement, trackClick, activeSelection, scrollParent, lastClickTime, isMoved, tapHoldFired, tapHoldTimeout;
	            var activableElement, activeTimeout, needsFastClick, needsFastClickTimeOut;
	            var rippleWave, rippleTarget, rippleTransform, rippleTimeout;
	            function findActivableElement(el) {
	                var target = $(el);
	                var parents = target.parents(app.params.activeStateElements);
	                var activable;
	                if (target.is(app.params.activeStateElements)) {
	                    activable = target;
	                }
	                if (parents.length > 0) {
	                    activable = activable ? activable.add(parents) : parents;
	                }
	                return activable ? activable : target;
	            }
	            function isInsideScrollableView(el) {
	                var pageContent = el.parents('.page-content, .panel');
	                if (pageContent.length === 0) {
	                    return false;
	                }
	                // This event handler covers the "tap to stop scrolling".
	                if (pageContent.prop('scrollHandlerSet') !== 'yes') {
	                    pageContent.on('scroll', function () {
	                        clearTimeout(activeTimeout);
	                        clearTimeout(rippleTimeout);
	                    });
	                    pageContent.prop('scrollHandlerSet', 'yes');
	                }
	                return true;
	            }
	            function addActive() {
	                if (!activableElement)
	                    return;
	                activableElement.addClass('active-state');
	            }
	            function removeActive(el) {
	                if (!activableElement)
	                    return;
	                activableElement.removeClass('active-state');
	                activableElement = null;
	            }
	            function isFormElement(el) {
	                var nodes = ('input select textarea label').split(' ');
	                if (el.nodeName && nodes.indexOf(el.nodeName.toLowerCase()) >= 0)
	                    return true;
	                return false;
	            }
	            function androidNeedsBlur(el) {
	                var noBlur = ('button input textarea select').split(' ');
	                if (document.activeElement && el !== document.activeElement && document.activeElement !== document.body) {
	                    if (noBlur.indexOf(el.nodeName.toLowerCase()) >= 0) {
	                        return false;
	                    }
	                    else {
	                        return true;
	                    }
	                }
	                else {
	                    return false;
	                }
	            }
	            function targetNeedsFastClick(el) {
	                var $el = $(el);
	                if (el.nodeName.toLowerCase() === 'input' && (el.type === 'file' || el.type === 'range'))
	                    return false;
	                if (el.nodeName.toLowerCase() === 'select' && app.device.android)
	                    return false;
	                if ($el.hasClass('no-fastclick') || $el.parents('.no-fastclick').length > 0)
	                    return false;
	                if (app.params.fastClicksExclude && $el.is(app.params.fastClicksExclude))
	                    return false;
	                return true;
	            }
	            function targetNeedsFocus(el) {
	                if (document.activeElement === el) {
	                    return false;
	                }
	                var tag = el.nodeName.toLowerCase();
	                var skipInputs = ('button checkbox file image radio submit').split(' ');
	                if (el.disabled || el.readOnly)
	                    return false;
	                if (tag === 'textarea')
	                    return true;
	                if (tag === 'select') {
	                    if (app.device.android)
	                        return false;
	                    else
	                        return true;
	                }
	                if (tag === 'input' && skipInputs.indexOf(el.type) < 0)
	                    return true;
	            }
	            function targetNeedsPrevent(el) {
	                el = $(el);
	                var prevent = true;
	                if (el.is('label') || el.parents('label').length > 0) {
	                    if (app.device.android) {
	                        prevent = false;
	                    }
	                    else if (app.device.ios && el.is('input')) {
	                        prevent = true;
	                    }
	                    else
	                        prevent = false;
	                }
	                return prevent;
	            }
	            // Mouse Handlers
	            function handleMouseDown(e) {
	                findActivableElement(e.target).addClass('active-state');
	                if ('which' in e && e.which === 3) {
	                    setTimeout(function () {
	                        $('.active-state').removeClass('active-state');
	                    }, 0);
	                }
	                if (app.params.material && app.params.materialRipple) {
	                    touchStartX = e.pageX;
	                    touchStartY = e.pageY;
	                    rippleTouchStart(e.target, e.pageX, e.pageY);
	                }
	            }
	            function handleMouseMove(e) {
	                $('.active-state').removeClass('active-state');
	                if (app.params.material && app.params.materialRipple) {
	                    rippleTouchMove();
	                }
	            }
	            function handleMouseUp(e) {
	                $('.active-state').removeClass('active-state');
	                if (app.params.material && app.params.materialRipple) {
	                    rippleTouchEnd();
	                }
	            }
	            // Material Touch Ripple Effect
	            function findRippleElement(el) {
	                var needsRipple = app.params.materialRippleElements;
	                var $el = $(el);
	                if ($el.is(needsRipple)) {
	                    if ($el.hasClass('no-ripple')) {
	                        return false;
	                    }
	                    return $el;
	                }
	                else if ($el.parents(needsRipple).length > 0) {
	                    var rippleParent = $el.parents(needsRipple).eq(0);
	                    if (rippleParent.hasClass('no-ripple')) {
	                        return false;
	                    }
	                    return rippleParent;
	                }
	                else
	                    return false;
	            }
	            function createRipple(x, y, el) {
	                if (!el)
	                    return;
	                var box = el[0].getBoundingClientRect();
	                var center = {
	                    x: x - box.left,
	                    y: y - box.top
	                }, height = box.height, width = box.width;
	                var diameter = Math.max(Math.pow((Math.pow(height, 2) + Math.pow(width, 2)), 0.5), 48);
	                rippleWave = $('<div class="ripple-wave" style="width: ' + diameter + 'px; height: ' + diameter + 'px; margin-top:-' + diameter / 2 + 'px; margin-left:-' + diameter / 2 + 'px; left:' + center.x + 'px; top:' + center.y + 'px;"></div>');
	                el.prepend(rippleWave);
	                var clientLeft = rippleWave[0].clientLeft;
	                rippleTransform = 'translate3d(' + (-center.x + width / 2) + 'px, ' + (-center.y + height / 2) + 'px, 0) scale(1)';
	                rippleWave.transform(rippleTransform);
	            }
	            function removeRipple() {
	                if (!rippleWave)
	                    return;
	                var toRemove = rippleWave;
	                var removeTimeout = setTimeout(function () {
	                    toRemove.remove();
	                }, 400);
	                rippleWave
	                    .addClass('ripple-wave-fill')
	                    .transform(rippleTransform.replace('scale(1)', 'scale(1.01)'))
	                    .transitionEnd(function () {
	                    clearTimeout(removeTimeout);
	                    var rippleWave = $(this)
	                        .addClass('ripple-wave-out')
	                        .transform(rippleTransform.replace('scale(1)', 'scale(1.01)'));
	                    removeTimeout = setTimeout(function () {
	                        rippleWave.remove();
	                    }, 700);
	                    setTimeout(function () {
	                        rippleWave.transitionEnd(function () {
	                            clearTimeout(removeTimeout);
	                            $(this).remove();
	                        });
	                    }, 0);
	                });
	                rippleWave = rippleTarget = undefined;
	            }
	            function rippleTouchStart(el, x, y) {
	                rippleTarget = findRippleElement(el);
	                if (!rippleTarget || rippleTarget.length === 0) {
	                    rippleTarget = undefined;
	                    return;
	                }
	                if (!isInsideScrollableView(rippleTarget)) {
	                    createRipple(touchStartX, touchStartY, rippleTarget);
	                }
	                else {
	                    rippleTimeout = setTimeout(function () {
	                        createRipple(touchStartX, touchStartY, rippleTarget);
	                    }, 80);
	                }
	            }
	            function rippleTouchMove() {
	                clearTimeout(rippleTimeout);
	                removeRipple();
	            }
	            function rippleTouchEnd() {
	                if (rippleWave) {
	                    removeRipple();
	                }
	                else if (rippleTarget && !isMoved) {
	                    clearTimeout(rippleTimeout);
	                    createRipple(touchStartX, touchStartY, rippleTarget);
	                    setTimeout(removeRipple, 0);
	                }
	                else {
	                    removeRipple();
	                }
	            }
	            // Send Click
	            function sendClick(e) {
	                var touch = e.changedTouches[0];
	                var evt = document.createEvent('MouseEvents');
	                var eventType = 'click';
	                if (app.device.android && targetElement.nodeName.toLowerCase() === 'select') {
	                    eventType = 'mousedown';
	                }
	                evt.initMouseEvent(eventType, true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
	                evt.forwardedTouchEvent = true;
	                if (app.device.ios && navigator.standalone) {
	                    //Fix the issue happens in iOS home screen apps where the wrong element is selected during a momentum scroll.
	                    //Upon tapping, we give the scrolling time to stop, then we grab the element based where the user tapped.
	                    setTimeout(function () {
	                        targetElement = document.elementFromPoint(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
	                        targetElement.dispatchEvent(evt);
	                    }, 10);
	                }
	                else {
	                    targetElement.dispatchEvent(evt);
	                }
	            }
	            // Touch Handlers
	            function handleTouchStart(e) {
	                isMoved = false;
	                tapHoldFired = false;
	                if (e.targetTouches.length > 1) {
	                    if (activableElement)
	                        removeActive();
	                    return true;
	                }
	                if (e.touches.length > 1 && activableElement) {
	                    removeActive();
	                }
	                if (app.params.tapHold) {
	                    if (tapHoldTimeout)
	                        clearTimeout(tapHoldTimeout);
	                    tapHoldTimeout = setTimeout(function () {
	                        if (e && e.touches && e.touches.length > 1)
	                            return;
	                        tapHoldFired = true;
	                        e.preventDefault();
	                        $(e.target).trigger('taphold');
	                    }, app.params.tapHoldDelay);
	                }
	                if (needsFastClickTimeOut)
	                    clearTimeout(needsFastClickTimeOut);
	                needsFastClick = targetNeedsFastClick(e.target);
	                if (!needsFastClick) {
	                    trackClick = false;
	                    return true;
	                }
	                if (app.device.ios || (app.device.android && 'getSelection' in window)) {
	                    var selection = window.getSelection();
	                    if (selection.rangeCount && selection.focusNode !== document.body && (!selection.isCollapsed || document.activeElement === selection.focusNode)) {
	                        activeSelection = true;
	                        return true;
	                    }
	                    else {
	                        activeSelection = false;
	                    }
	                }
	                if (app.device.android) {
	                    if (androidNeedsBlur(e.target)) {
	                        document.activeElement.blur();
	                    }
	                }
	                trackClick = true;
	                targetElement = e.target;
	                touchStartTime = (new Date()).getTime();
	                touchStartX = e.targetTouches[0].pageX;
	                touchStartY = e.targetTouches[0].pageY;
	                // Detect scroll parent
	                if (app.device.ios) {
	                    scrollParent = undefined;
	                    $(targetElement).parents().each(function () {
	                        var parent = this;
	                        if (parent.scrollHeight > parent.offsetHeight && !scrollParent) {
	                            scrollParent = parent;
	                            scrollParent.f7ScrollTop = scrollParent.scrollTop;
	                        }
	                    });
	                }
	                if ((e.timeStamp - lastClickTime) < app.params.fastClicksDelayBetweenClicks) {
	                    e.preventDefault();
	                }
	                if (app.params.activeState) {
	                    activableElement = findActivableElement(targetElement);
	                    // If it's inside a scrollable view, we don't trigger active-state yet,
	                    // because it can be a scroll instead. Based on the link:
	                    // http://labnote.beedesk.com/click-scroll-and-pseudo-active-on-mobile-webk
	                    if (!isInsideScrollableView(activableElement)) {
	                        addActive();
	                    }
	                    else {
	                        activeTimeout = setTimeout(addActive, 80);
	                    }
	                }
	                if (app.params.material && app.params.materialRipple) {
	                    rippleTouchStart(targetElement, touchStartX, touchStartY);
	                }
	            }
	            function handleTouchMove(e) {
	                if (!trackClick)
	                    return;
	                var _isMoved = false;
	                var distance = app.params.fastClicksDistanceThreshold;
	                if (distance) {
	                    var pageX = e.targetTouches[0].pageX;
	                    var pageY = e.targetTouches[0].pageY;
	                    if (Math.abs(pageX - touchStartX) > distance || Math.abs(pageY - touchStartY) > distance) {
	                        _isMoved = true;
	                    }
	                }
	                else {
	                    _isMoved = true;
	                }
	                if (_isMoved) {
	                    trackClick = false;
	                    targetElement = null;
	                    isMoved = true;
	                    if (app.params.tapHold) {
	                        clearTimeout(tapHoldTimeout);
	                    }
	                    if (app.params.activeState) {
	                        clearTimeout(activeTimeout);
	                        removeActive();
	                    }
	                    if (app.params.material && app.params.materialRipple) {
	                        rippleTouchMove();
	                    }
	                }
	            }
	            function handleTouchEnd(e) {
	                clearTimeout(activeTimeout);
	                clearTimeout(tapHoldTimeout);
	                if (!trackClick) {
	                    if (!activeSelection && needsFastClick) {
	                        if (!(app.device.android && !e.cancelable)) {
	                            e.preventDefault();
	                        }
	                    }
	                    return true;
	                }
	                if (document.activeElement === e.target) {
	                    if (app.params.activeState)
	                        removeActive();
	                    if (app.params.material && app.params.materialRipple) {
	                        rippleTouchEnd();
	                    }
	                    return true;
	                }
	                if (!activeSelection) {
	                    e.preventDefault();
	                }
	                if ((e.timeStamp - lastClickTime) < app.params.fastClicksDelayBetweenClicks) {
	                    setTimeout(removeActive, 0);
	                    return true;
	                }
	                lastClickTime = e.timeStamp;
	                trackClick = false;
	                if (app.device.ios && scrollParent) {
	                    if (scrollParent.scrollTop !== scrollParent.f7ScrollTop) {
	                        return false;
	                    }
	                }
	                // Add active-state here because, in a very fast tap, the timeout didn't
	                // have the chance to execute. Removing active-state in a timeout gives
	                // the chance to the animation execute.
	                if (app.params.activeState) {
	                    addActive();
	                    setTimeout(removeActive, 0);
	                }
	                // Remove Ripple
	                if (app.params.material && app.params.materialRipple) {
	                    rippleTouchEnd();
	                }
	                // Trigger focus when required
	                if (targetNeedsFocus(targetElement)) {
	                    if (app.device.ios && app.device.webView) {
	                        if ((event.timeStamp - touchStartTime) > 159) {
	                            targetElement = null;
	                            return false;
	                        }
	                        targetElement.focus();
	                        return false;
	                    }
	                    else {
	                        targetElement.focus();
	                    }
	                }
	                // Blur active elements
	                if (document.activeElement && targetElement !== document.activeElement && document.activeElement !== document.body && targetElement.nodeName.toLowerCase() !== 'label') {
	                    document.activeElement.blur();
	                }
	                // Send click
	                e.preventDefault();
	                sendClick(e);
	                return false;
	            }
	            function handleTouchCancel(e) {
	                trackClick = false;
	                targetElement = null;
	                // Remove Active State
	                clearTimeout(activeTimeout);
	                clearTimeout(tapHoldTimeout);
	                if (app.params.activeState) {
	                    removeActive();
	                }
	                // Remove Ripple
	                if (app.params.material && app.params.materialRipple) {
	                    rippleTouchEnd();
	                }
	            }
	            function handleClick(e) {
	                var allowClick = false;
	                if (trackClick) {
	                    targetElement = null;
	                    trackClick = false;
	                    return true;
	                }
	                if (e.target.type === 'submit' && e.detail === 0 || e.target.type === 'file') {
	                    return true;
	                }
	                if (!targetElement) {
	                    if (!isFormElement(e.target)) {
	                        allowClick = true;
	                    }
	                }
	                if (!needsFastClick) {
	                    allowClick = true;
	                }
	                if (document.activeElement === targetElement) {
	                    allowClick = true;
	                }
	                if (e.forwardedTouchEvent) {
	                    allowClick = true;
	                }
	                if (!e.cancelable) {
	                    allowClick = true;
	                }
	                if (app.params.tapHold && app.params.tapHoldPreventClicks && tapHoldFired) {
	                    allowClick = false;
	                }
	                if (!allowClick) {
	                    e.stopImmediatePropagation();
	                    e.stopPropagation();
	                    if (targetElement) {
	                        if (targetNeedsPrevent(targetElement) || isMoved) {
	                            e.preventDefault();
	                        }
	                    }
	                    else {
	                        e.preventDefault();
	                    }
	                    targetElement = null;
	                }
	                needsFastClickTimeOut = setTimeout(function () {
	                    needsFastClick = false;
	                }, (app.device.ios || app.device.androidChrome ? 100 : 400));
	                if (app.params.tapHold) {
	                    tapHoldTimeout = setTimeout(function () {
	                        tapHoldFired = false;
	                    }, (app.device.ios || app.device.androidChrome ? 100 : 400));
	                }
	                return allowClick;
	            }
	            if (app.support.touch) {
	                document.addEventListener('click', handleClick, true);
	                document.addEventListener('touchstart', handleTouchStart);
	                document.addEventListener('touchmove', handleTouchMove);
	                document.addEventListener('touchend', handleTouchEnd);
	                document.addEventListener('touchcancel', handleTouchCancel);
	            }
	            else {
	                if (app.params.activeState) {
	                    document.addEventListener('mousedown', handleMouseDown);
	                    document.addEventListener('mousemove', handleMouseMove);
	                    document.addEventListener('mouseup', handleMouseUp);
	                }
	            }
	            if (app.params.material && app.params.materialRipple) {
	                document.addEventListener('contextmenu', function (e) {
	                    if (activableElement)
	                        removeActive();
	                    rippleTouchEnd();
	                });
	            }
	        };
	        /*===============================================================================
	        ************   Handle clicks and make them fast (on tap);   ************
	        ===============================================================================*/
	        app.initClickEvents = function () {
	            function handleScrollTop(e) {
	                /*jshint validthis:true */
	                var clicked = $(this);
	                var target = $(e.target);
	                var isLink = clicked[0].nodeName.toLowerCase() === 'a' ||
	                    clicked.parents('a').length > 0 ||
	                    target[0].nodeName.toLowerCase() === 'a' ||
	                    target.parents('a').length > 0;
	                if (isLink)
	                    return;
	                var pageContent, page;
	                if (app.params.scrollTopOnNavbarClick && clicked.is('.navbar .center')) {
	                    // Find active page
	                    var navbar = clicked.parents('.navbar');
	                    // Static Layout
	                    pageContent = navbar.parents('.page-content');
	                    if (pageContent.length === 0) {
	                        // Fixed Layout
	                        if (navbar.parents('.page').length > 0) {
	                            pageContent = navbar.parents('.page').find('.page-content');
	                        }
	                        // Through Layout
	                        if (pageContent.length === 0) {
	                            if (navbar.nextAll('.pages').length > 0) {
	                                pageContent = navbar.nextAll('.pages').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                            }
	                        }
	                    }
	                }
	                if (app.params.scrollTopOnStatusbarClick && clicked.is('.statusbar-overlay')) {
	                    if ($('.popup.modal-in').length > 0) {
	                        // Check for opened popup
	                        pageContent = $('.popup.modal-in').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                    }
	                    else if ($('.panel.active').length > 0) {
	                        // Check for opened panel
	                        pageContent = $('.panel.active').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                    }
	                    else if ($('.views > .view.active').length > 0) {
	                        // View in tab bar app layout
	                        pageContent = $('.views > .view.active').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                    }
	                    else {
	                        // Usual case
	                        pageContent = $('.views').find('.page:not(.page-on-left):not(.page-on-right):not(.cached)').find('.page-content');
	                    }
	                }
	                if (pageContent && pageContent.length > 0) {
	                    // Check for tab
	                    if (pageContent.hasClass('tab')) {
	                        pageContent = pageContent.parent('.tabs').children('.page-content.active');
	                    }
	                    if (pageContent.length > 0)
	                        pageContent.scrollTop(0, 300);
	                }
	            }
	            function handleClicks(e) {
	                /*jshint validthis:true */
	                var clicked = $(this);
	                var url = clicked.attr('href');
	                var isLink = clicked[0].nodeName.toLowerCase() === 'a';
	                // Check if link is external
	                if (isLink) {
	                    if (clicked.is(app.params.externalLinks) || (url && url.indexOf('javascript:') >= 0)) {
	                        if (url && clicked.attr('target') === '_system') {
	                            e.preventDefault();
	                            window.open(url, '_system');
	                        }
	                        return;
	                    }
	                }
	                // Collect Clicked data- attributes
	                var clickedData = clicked.dataset();
	                // Smart Select
	                if (clicked.hasClass('smart-select')) {
	                    if (app.smartSelectOpen)
	                        app.smartSelectOpen(clicked);
	                }
	                // Open Panel
	                if (clicked.hasClass('open-panel')) {
	                    if ($('.panel').length === 1) {
	                        if ($('.panel').hasClass('panel-left'))
	                            app.openPanel('left');
	                        else
	                            app.openPanel('right');
	                    }
	                    else {
	                        if (clickedData.panel === 'right')
	                            app.openPanel('right');
	                        else
	                            app.openPanel('left');
	                    }
	                }
	                // Close Panel
	                if (clicked.hasClass('close-panel')) {
	                    app.closePanel();
	                }
	                // Panel Overlay
	                if (clicked.hasClass('panel-overlay')) {
	                    $('.panel.active').trigger('panel:overlay-click');
	                    if (app.params.panelsCloseByOutside)
	                        app.closePanel();
	                }
	                // Popover
	                if (clicked.hasClass('open-popover')) {
	                    var popover;
	                    if (clickedData.popover) {
	                        popover = clickedData.popover;
	                    }
	                    else
	                        popover = '.popover';
	                    app.popover(popover, clicked);
	                }
	                if (clicked.hasClass('close-popover')) {
	                    app.closeModal('.popover.modal-in');
	                }
	                // Popup
	                var popup;
	                if (clicked.hasClass('open-popup')) {
	                    if (clickedData.popup) {
	                        popup = clickedData.popup;
	                    }
	                    else
	                        popup = '.popup';
	                    app.popup(popup);
	                }
	                if (clicked.hasClass('close-popup')) {
	                    if (clickedData.popup) {
	                        popup = clickedData.popup;
	                    }
	                    else
	                        popup = '.popup.modal-in';
	                    app.closeModal(popup);
	                }
	                // Login Screen
	                var loginScreen;
	                if (clicked.hasClass('open-login-screen')) {
	                    if (clickedData.loginScreen) {
	                        loginScreen = clickedData.loginScreen;
	                    }
	                    else
	                        loginScreen = '.login-screen';
	                    app.loginScreen(loginScreen);
	                }
	                if (clicked.hasClass('close-login-screen')) {
	                    app.closeModal('.login-screen.modal-in');
	                }
	                // Close Modal
	                if (clicked.hasClass('modal-overlay')) {
	                    if ($('.modal.modal-in').length > 0 && app.params.modalCloseByOutside)
	                        app.closeModal('.modal.modal-in');
	                    if ($('.actions-modal.modal-in').length > 0 && app.params.actionsCloseByOutside)
	                        app.closeModal('.actions-modal.modal-in');
	                    if ($('.popover.modal-in').length > 0 && app.params.popoverCloseByOutside)
	                        app.closeModal('.popover.modal-in');
	                }
	                if (clicked.hasClass('popup-overlay')) {
	                    if ($('.popup.modal-in').length > 0 && app.params.popupCloseByOutside)
	                        app.closeModal('.popup.modal-in');
	                }
	                if (clicked.hasClass('picker-modal-overlay')) {
	                    if ($('.picker-modal.modal-in').length > 0)
	                        app.closeModal('.picker-modal.modal-in');
	                }
	                // Picker
	                if (clicked.hasClass('close-picker')) {
	                    var pickerToClose = $('.picker-modal.modal-in');
	                    if (pickerToClose.length > 0) {
	                        app.closeModal(pickerToClose);
	                    }
	                    else {
	                        pickerToClose = $('.popover.modal-in .picker-modal');
	                        if (pickerToClose.length > 0) {
	                            app.closeModal(pickerToClose.parents('.popover'));
	                        }
	                    }
	                }
	                if (clicked.hasClass('open-picker')) {
	                    var pickerToOpen;
	                    if (clickedData.picker) {
	                        pickerToOpen = clickedData.picker;
	                    }
	                    else
	                        pickerToOpen = '.picker-modal';
	                    app.pickerModal(pickerToOpen, clicked);
	                }
	                // Tabs
	                var isTabLink;
	                if (clicked.hasClass('tab-link')) {
	                    isTabLink = true;
	                    app.showTab(clickedData.tab || clicked.attr('href'), clicked);
	                }
	                // Swipeout Close
	                if (clicked.hasClass('swipeout-close')) {
	                    app.swipeoutClose(clicked.parents('.swipeout-opened'));
	                }
	                // Swipeout Delete
	                if (clicked.hasClass('swipeout-delete')) {
	                    if (clickedData.confirm) {
	                        var text = clickedData.confirm;
	                        var title = clickedData.confirmTitle;
	                        if (title) {
	                            app.confirm(text, title, function () {
	                                app.swipeoutDelete(clicked.parents('.swipeout'));
	                            }, function () {
	                                if (clickedData.closeOnCancel)
	                                    app.swipeoutClose(clicked.parents('.swipeout'));
	                            });
	                        }
	                        else {
	                            app.confirm(text, function () {
	                                app.swipeoutDelete(clicked.parents('.swipeout'));
	                            }, function () {
	                                if (clickedData.closeOnCancel)
	                                    app.swipeoutClose(clicked.parents('.swipeout'));
	                            });
	                        }
	                    }
	                    else {
	                        app.swipeoutDelete(clicked.parents('.swipeout'));
	                    }
	                }
	                // Sortable
	                if (clicked.hasClass('toggle-sortable')) {
	                    app.sortableToggle(clickedData.sortable);
	                }
	                if (clicked.hasClass('open-sortable')) {
	                    app.sortableOpen(clickedData.sortable);
	                }
	                if (clicked.hasClass('close-sortable')) {
	                    app.sortableClose(clickedData.sortable);
	                }
	                // Accordion
	                if (clicked.hasClass('accordion-item-toggle') || (clicked.hasClass('item-link') && clicked.parent().hasClass('accordion-item'))) {
	                    var accordionItem = clicked.parent('.accordion-item');
	                    if (accordionItem.length === 0)
	                        accordionItem = clicked.parents('.accordion-item');
	                    if (accordionItem.length === 0)
	                        accordionItem = clicked.parents('li');
	                    app.accordionToggle(accordionItem);
	                }
	                // Speed Dial
	                if (clicked.hasClass('floating-button') && clicked.parent().hasClass('speed-dial')) {
	                    clicked.parent().toggleClass('speed-dial-opened');
	                }
	                if (clicked.hasClass('close-speed-dial')) {
	                    $('.speed-dial-opened').removeClass('speed-dial-opened');
	                }
	                // Load Page
	                if (app.params.ajaxLinks && !clicked.is(app.params.ajaxLinks) || !isLink || !app.params.router) {
	                    return;
	                }
	                if (isLink) {
	                    e.preventDefault();
	                }
	                var validUrl = url && url.length > 0 && url !== '#' && !isTabLink;
	                var template = clickedData.template;
	                if (validUrl || clicked.hasClass('back') || template) {
	                    var view;
	                    if (clickedData.view) {
	                        view = $(clickedData.view)[0].f7View;
	                    }
	                    else {
	                        view = clicked.parents('.' + app.params.viewClass)[0] && clicked.parents('.' + app.params.viewClass)[0].f7View;
	                        if (view && view.params.linksView) {
	                            if (typeof view.params.linksView === 'string')
	                                view = $(view.params.linksView)[0].f7View;
	                            else if (view.params.linksView instanceof View)
	                                view = view.params.linksView;
	                        }
	                    }
	                    if (!view) {
	                        if (app.mainView)
	                            view = app.mainView;
	                    }
	                    if (!view)
	                        return;
	                    var pageName;
	                    if (!template) {
	                        if (url && url.indexOf('#') === 0 && url !== '#') {
	                            if (view.params.domCache) {
	                                pageName = url.split('#')[1];
	                            }
	                            else
	                                return;
	                        }
	                        if (url === '#' && !clicked.hasClass('back'))
	                            return;
	                    }
	                    else {
	                        url = undefined;
	                    }
	                    var animatePages;
	                    if (typeof clickedData.animatePages !== 'undefined') {
	                        animatePages = clickedData.animatePages;
	                    }
	                    else {
	                        if (clicked.hasClass('with-animation'))
	                            animatePages = true;
	                        if (clicked.hasClass('no-animation'))
	                            animatePages = false;
	                    }
	                    var options = {
	                        animatePages: animatePages,
	                        ignoreCache: clickedData.ignoreCache,
	                        force: clickedData.force,
	                        reload: clickedData.reload,
	                        reloadPrevious: clickedData.reloadPrevious,
	                        pageName: pageName,
	                        pushState: clickedData.pushState,
	                        url: url
	                    };
	                    if (app.params.template7Pages) {
	                        options.contextName = clickedData.contextName;
	                        var context = clickedData.context;
	                        if (context) {
	                            options.context = JSON.parse(context);
	                        }
	                    }
	                    if (template && template in t7.templates) {
	                        options.template = t7.templates[template];
	                    }
	                    if (clicked.hasClass('back'))
	                        view.router.back(options);
	                    else
	                        view.router.load(options);
	                }
	            }
	            $(document).on('click', 'a, .open-panel, .close-panel, .panel-overlay, .modal-overlay, .popup-overlay, .swipeout-delete, .swipeout-close, .close-popup, .open-popup, .open-popover, .open-login-screen, .close-login-screen .smart-select, .toggle-sortable, .open-sortable, .close-sortable, .accordion-item-toggle, .close-picker, .picker-modal-overlay', handleClicks);
	            if (app.params.scrollTopOnNavbarClick || app.params.scrollTopOnStatusbarClick) {
	                $(document).on('click', '.statusbar-overlay, .navbar .center', handleScrollTop);
	            }
	            // Prevent scrolling on overlays
	            function preventScrolling(e) {
	                e.preventDefault();
	            }
	            if (app.support.touch && !app.device.android) {
	                var activeListener = app.support.passiveListener ? { passive: false, capture: false } : false;
	                $(document).on((app.params.fastClicks ? 'touchstart' : 'touchmove'), '.panel-overlay, .modal-overlay, .preloader-indicator-overlay, .popup-overlay, .searchbar-overlay', preventScrolling, activeListener);
	            }
	        };
	        /*======================================================
	        ************   App Resize Actions   ************
	        ======================================================*/
	        // Prevent iPad horizontal body scrolling when soft keyboard is opened
	        function _fixIpadBodyScrolLeft() {
	            if (app.device.ipad) {
	                document.body.scrollLeft = 0;
	                setTimeout(function () {
	                    document.body.scrollLeft = 0;
	                }, 0);
	            }
	        }
	        var appResizeCallbacks = [];
	        app.getSize = function () {
	            var offset = app.root.offset();
	            app.width = app.root[0].offsetWidth;
	            app.height = app.root[0].offsetHeight;
	            app.left = offset.left;
	            app.top = offset.top;
	        };
	        app.onResize = function (callback) {
	            appResizeCallbacks.push(callback);
	        };
	        app.offResize = function (callback) {
	            for (var i = 0; i < appResizeCallbacks.length; i++) {
	                if (appResizeCallbacks[i] === callback) {
	                    appResizeCallbacks.splice(i, 1);
	                }
	            }
	        };
	        app.resize = function () {
	            _fixIpadBodyScrolLeft();
	            app.getSize();
	            if (app.sizeNavbars)
	                app.sizeNavbars();
	            for (var i = 0; i < appResizeCallbacks.length; i++) {
	                appResizeCallbacks[i]();
	            }
	        };
	        app.orientationchange = function () {
	            if (app.device && app.device.minimalUi) {
	                if (window.orientation === 90 || window.orientation === -90)
	                    document.body.scrollTop = 0;
	            }
	            _fixIpadBodyScrolLeft();
	        };
	        app.initResize = function () {
	            $(window).on('resize', app.resize);
	            $(window).on('orientationchange', app.orientationchange);
	            app.getSize();
	        };
	        /*===============================================================================
	        ************   Store and parse forms data   ************
	        ===============================================================================*/
	        app.formsData = {};
	        app.formStoreData = function (formId, formJSON) {
	            // Store form data in app.formsData
	            app.formsData[formId] = formJSON;
	            // Store form data in local storage also
	            app.ls['f7form-' + formId] = JSON.stringify(formJSON);
	        };
	        app.formDeleteData = function (formId) {
	            // Delete form data from app.formsData
	            if (app.formsData[formId]) {
	                app.formsData[formId] = '';
	                delete app.formsData[formId];
	            }
	            // Delete form data from local storage also
	            if (app.ls['f7form-' + formId]) {
	                app.ls['f7form-' + formId] = '';
	                app.ls.removeItem('f7form-' + formId);
	            }
	        };
	        app.formGetData = function (formId) {
	            // First of all check in local storage
	            if (app.ls['f7form-' + formId]) {
	                return JSON.parse(app.ls['f7form-' + formId]);
	            }
	            else if (app.formsData[formId])
	                return app.formsData[formId];
	        };
	        app.formToData = function (form) {
	            form = $(form);
	            if (form.length !== 1)
	                return false;
	            // Form data
	            var formData = {};
	            // Skip input types
	            var skipTypes = ['submit', 'image', 'button', 'file'];
	            var skipNames = [];
	            form.find('input, select, textarea').each(function () {
	                var input = $(this);
	                var name = input.attr('name');
	                var type = input.attr('type');
	                var tag = this.nodeName.toLowerCase();
	                if (skipTypes.indexOf(type) >= 0)
	                    return;
	                if (skipNames.indexOf(name) >= 0 || !name)
	                    return;
	                if (tag === 'select' && input.prop('multiple')) {
	                    skipNames.push(name);
	                    formData[name] = [];
	                    form.find('select[name="' + name + '"] option').each(function () {
	                        if (this.selected)
	                            formData[name].push(this.value);
	                    });
	                }
	                else {
	                    switch (type) {
	                        case 'checkbox':
	                            skipNames.push(name);
	                            formData[name] = [];
	                            form.find('input[name="' + name + '"]').each(function () {
	                                if (this.checked)
	                                    formData[name].push(this.value);
	                            });
	                            break;
	                        case 'radio':
	                            skipNames.push(name);
	                            form.find('input[name="' + name + '"]').each(function () {
	                                if (this.checked)
	                                    formData[name] = this.value;
	                            });
	                            break;
	                        default:
	                            formData[name] = input.val();
	                            break;
	                    }
	                }
	            });
	            form.trigger('formToJSON formToData form:todata', { formData: formData });
	            return formData;
	        };
	        app.formToJSON = app.formToData;
	        app.formFromData = function (form, formData) {
	            form = $(form);
	            if (form.length !== 1)
	                return false;
	            // Skip input types
	            var skipTypes = ['submit', 'image', 'button', 'file'];
	            var skipNames = [];
	            form.find('input, select, textarea').each(function () {
	                var input = $(this);
	                var name = input.attr('name');
	                var type = input.attr('type');
	                var tag = this.nodeName.toLowerCase();
	                if (typeof formData[name] === 'undefined' || formData[name] === null)
	                    return;
	                if (skipTypes.indexOf(type) >= 0)
	                    return;
	                if (skipNames.indexOf(name) >= 0 || !name)
	                    return;
	                if (tag === 'select' && input.prop('multiple')) {
	                    skipNames.push(name);
	                    form.find('select[name="' + name + '"] option').each(function () {
	                        if (formData[name].indexOf(this.value) >= 0)
	                            this.selected = true;
	                        else
	                            this.selected = false;
	                    });
	                }
	                else {
	                    switch (type) {
	                        case 'checkbox':
	                            skipNames.push(name);
	                            form.find('input[name="' + name + '"]').each(function () {
	                                if (formData[name].indexOf(this.value) >= 0)
	                                    this.checked = true;
	                                else
	                                    this.checked = false;
	                            });
	                            break;
	                        case 'radio':
	                            skipNames.push(name);
	                            form.find('input[name="' + name + '"]').each(function () {
	                                if (formData[name] === this.value)
	                                    this.checked = true;
	                                else
	                                    this.checked = false;
	                            });
	                            break;
	                        default:
	                            input.val(formData[name]);
	                            break;
	                    }
	                }
	                if (tag === 'select' || tag === 'input' || tag === 'textarea') {
	                    input.trigger('change');
	                }
	            });
	            form.trigger('formFromJSON formFromData form:fromdata', { formData: formData });
	        };
	        app.formFromJSON = app.formFromData;
	        app.initFormsStorage = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var forms = pageContainer.find('form.store-data');
	            if (forms.length === 0)
	                return;
	            // Parse forms data and fill form if there is such data
	            forms.each(function () {
	                var id = this.getAttribute('id');
	                if (!id)
	                    return;
	                var formData = app.formGetData(id);
	                if (formData)
	                    app.formFromData(this, formData);
	            });
	            // Update forms data on inputs change
	            function storeForm() {
	                /*jshint validthis:true */
	                var form = $(this);
	                var formId = form[0].id;
	                if (!formId)
	                    return;
	                var formJSON = app.formToData(form);
	                if (!formJSON)
	                    return;
	                app.formStoreData(formId, formJSON);
	                form.trigger('store form:storedata', { data: formJSON });
	            }
	            forms.on('change submit', storeForm);
	            // Detach Listeners
	            function pageBeforeRemove() {
	                forms.off('change submit', storeForm);
	                pageContainer.off('page:beforeremove', pageBeforeRemove);
	            }
	            pageContainer.on('page:beforeremove', pageBeforeRemove);
	        };
	        /*===============================================================================
	        ************   Ajax submit for forms   ************
	        ===============================================================================*/
	        // Ajax submit on forms
	        $(document).on('submit change', 'form.ajax-submit, form.ajax-submit-onchange', function (e) {
	            var form = $(this);
	            if (e.type === 'change' && !form.hasClass('ajax-submit-onchange'))
	                return;
	            if (e.type === 'submit')
	                e.preventDefault();
	            var method = (form.attr('method') || 'GET').toUpperCase();
	            var contentType = form.prop('enctype') || form.attr('enctype');
	            var url = form.attr('action');
	            if (!url)
	                return;
	            var data;
	            if (method === 'POST')
	                data = new FormData(form[0]);
	            else
	                data = $.serializeObject(app.formToJSON(form[0]));
	            var xhr = $.ajax({
	                method: method,
	                url: url,
	                contentType: contentType,
	                data: data,
	                beforeSend: function (xhr) {
	                    form.trigger('beforeSubmit form:beforesend', { data: data, xhr: xhr });
	                },
	                error: function (xhr) {
	                    form.trigger('submitError form:error', { data: data, xhr: xhr });
	                },
	                success: function (data) {
	                    form.trigger('submitted form:success', { data: data, xhr: xhr });
	                }
	            });
	        });
	        /*===============================================================================
	        ************   Resizable textarea   ************
	        ===============================================================================*/
	        app.resizeTextarea = function (textarea) {
	            textarea = $(textarea);
	            if (!textarea.hasClass('resizable')) {
	                return;
	            }
	            textarea.css({ 'height': '' });
	            var height = textarea[0].offsetHeight;
	            var diff = height - textarea[0].clientHeight;
	            var scrollHeight = textarea[0].scrollHeight;
	            if (scrollHeight + diff > height) {
	                var newAreaHeight = scrollHeight + diff;
	                textarea.css('height', newAreaHeight + 'px');
	            }
	        };
	        app.resizableTextarea = function (textarea) {
	            textarea = $(textarea);
	            if (textarea.length === 0)
	                return;
	            var textareaTimeout;
	            function handleTextarea() {
	                clearTimeout(textareaTimeout);
	                textareaTimeout = setTimeout(function () {
	                    app.resizeTextarea(textarea);
	                }, 0);
	            }
	            textarea[0].f7DestroyResizableTextarea = function () {
	                textarea.off('change keydown keypress keyup paste cut', handleTextarea);
	            };
	            return textarea.on('change keydown keypress keyup paste cut', handleTextarea);
	        };
	        app.destroyResizableTextarea = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            if (pageContainer.length > 0 && pageContainer.is('textarea') && pageContainer[0].f7DestroyResizableTextarea) {
	                pageContainer[0].f7DestroyResizableTextarea();
	            }
	            else if (pageContainer.length > 0) {
	                pageContainer.find('textarea.resiable').each(function () {
	                    var textarea = this;
	                    if (textarea.f7DestroyResizableTextarea) {
	                        textarea.f7DestroyResizableTextarea();
	                    }
	                });
	            }
	        };
	        app.initPageResizableTextarea = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var textareas = pageContainer.find('textarea.resizable');
	            textareas.each(function () {
	                app.resizableTextarea(this);
	            });
	        };
	        /*======================================================
	        ************   Material Text Inputs   ************
	        ======================================================*/
	        app.initPageMaterialInputs = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var textareas = pageContainer.find('textarea.resizable');
	            pageContainer.find('.item-input').each(function () {
	                var itemInput = $(this);
	                var notInputs = ['checkbox', 'button', 'submit', 'range', 'radio', 'image'];
	                itemInput.find('input, select, textarea').each(function () {
	                    var input = $(this);
	                    if (notInputs.indexOf(input.attr('type')) < 0) {
	                        itemInput.addClass('item-input-field');
	                        if (input.val().trim() !== '') {
	                            input.parents('.item-input, .input-field').add(input.parents('.item-inner')).addClass('not-empty-state');
	                        }
	                    }
	                });
	                if (itemInput.parents('.input-item, .inputs-list').length > 0)
	                    return;
	                itemInput.parents('.list-block').eq(0).addClass('inputs-list');
	            });
	        };
	        /*======================================================
	        ************   Material Focus Inputs   ************
	        ======================================================*/
	        app.initMaterialWatchInputs = function () {
	            var notInputs = ['checkbox', 'button', 'submit', 'range', 'radio', 'image'];
	            function addFocusState(e) {
	                /*jshint validthis:true*/
	                var i = $(this);
	                var type = i.attr('type');
	                if (notInputs.indexOf(type) >= 0)
	                    return;
	                var els = i.add(i.parents('.item-input, .input-field')).add(i.parents('.item-inner').eq(0));
	                els.removeClass('not-empty-state').addClass('focus-state');
	            }
	            function removeFocusState(e) {
	                /*jshint validthis:true*/
	                var i = $(this), value = i.val();
	                var type = i.attr('type');
	                if (notInputs.indexOf(type) >= 0)
	                    return;
	                var els = i.add(i.parents('.item-input, .input-field')).add(i.parents('.item-inner').eq(0));
	                els.removeClass('focus-state');
	                if (value && value.trim() !== '') {
	                    els.removeClass('focus-state').addClass('not-empty-state');
	                }
	                else {
	                    els.removeClass('not-empty-state');
	                }
	            }
	            function watchChangeState(e) {
	                /*jshint validthis:true*/
	                var input = $(this), value = input.val();
	                var type = input.attr('type');
	                if (notInputs.indexOf(type) >= 0)
	                    return;
	                var els = input.add(input.parents('.item-input, .input-field')).add(input.parents('.item-inner').eq(0));
	                if (els.length === 0)
	                    return;
	                if (value && (typeof value === 'string' && value.trim() !== '') || (Array.isArray(value) && value.length > 0)) {
	                    els.addClass('not-empty-state');
	                }
	                else {
	                    els.removeClass('not-empty-state');
	                }
	            }
	            $(document).on('change', 'input, textarea, select', watchChangeState, true);
	            $(document).on('focus', 'input, textarea, select', addFocusState, true);
	            $(document).on('blur', 'input, textarea, select', removeFocusState, true);
	        };
	        /*======================================================
	        ************   Handle Browser's History   ************
	        ======================================================*/
	        app.pushStateQueue = [];
	        app.pushStateClearQueue = function () {
	            if (app.pushStateQueue.length === 0)
	                return;
	            var queue = app.pushStateQueue.pop();
	            var animatePages;
	            if (app.params.pushStateNoAnimation === true)
	                animatePages = false;
	            if (queue.action === 'back') {
	                app.router.back(queue.view, { animatePages: animatePages });
	            }
	            if (queue.action === 'loadPage') {
	                app.router.load(queue.view, { url: queue.stateUrl, animatePages: animatePages, pushState: false });
	            }
	            if (queue.action === 'loadContent') {
	                app.router.load(queue.view, { content: queue.stateContent, animatePages: animatePages, pushState: false });
	            }
	            if (queue.action === 'loadPageName') {
	                app.router.load(queue.view, { pageName: queue.statePageName, url: queue.stateUrl, animatePages: animatePages, pushState: false });
	            }
	        };
	        app.initPushState = function () {
	            var blockPopstate = true;
	            $(window).on('load', function () {
	                setTimeout(function () {
	                    blockPopstate = false;
	                }, 0);
	            });
	            if (document.readyState && document.readyState === 'complete') {
	                blockPopstate = false;
	            }
	            function handlePopState(e) {
	                if (blockPopstate)
	                    return;
	                var mainView = app.mainView;
	                if (!mainView)
	                    return;
	                var state = e.state;
	                if (!state) {
	                    state = {
	                        viewIndex: app.views.indexOf(mainView),
	                        url: mainView.history[0]
	                    };
	                }
	                if (state.viewIndex < 0)
	                    return;
	                var view = app.views[state.viewIndex];
	                var stateUrl = state && state.url || undefined;
	                var stateContent = state && state.content || undefined;
	                var statePageName = state && state.pageName || undefined;
	                var animatePages;
	                if (app.params.pushStateNoAnimation === true)
	                    animatePages = false;
	                if (stateUrl !== view.url) {
	                    if (view.history.indexOf(stateUrl) >= 0) {
	                        // Go Back
	                        if (view.allowPageChange) {
	                            app.router.back(view, { url: undefined, animatePages: animatePages, pushState: false, preloadOnly: false });
	                        }
	                        else {
	                            app.pushStateQueue.push({
	                                action: 'back',
	                                view: view
	                            });
	                        }
	                    }
	                    else if (stateContent) {
	                        // Load Page
	                        if (view.allowPageChange) {
	                            app.router.load(view, { content: stateContent, animatePages: animatePages, pushState: false });
	                        }
	                        else {
	                            app.pushStateQueue.unshift({
	                                action: 'loadContent',
	                                stateContent: stateContent,
	                                view: view
	                            });
	                        }
	                    }
	                    else if (statePageName) {
	                        // Load Page by page name with Dom Cache
	                        if (view.allowPageChange) {
	                            app.router.load(view, { pageName: statePageName, url: stateUrl, animatePages: animatePages, pushState: false });
	                        }
	                        else {
	                            app.pushStateQueue.unshift({
	                                action: 'loadPageName',
	                                statePageName: statePageName,
	                                view: view
	                            });
	                        }
	                    }
	                    else {
	                        // Load Page
	                        if (view.allowPageChange) {
	                            app.router.load(view, { url: stateUrl, animatePages: animatePages, pushState: false });
	                        }
	                        else {
	                            app.pushStateQueue.unshift({
	                                action: 'loadPage',
	                                stateUrl: stateUrl,
	                                view: view
	                            });
	                        }
	                    }
	                }
	            }
	            $(window).on('popstate', handlePopState);
	        };
	        /*===========================
	        Framework7 Swiper Additions
	        ===========================*/
	        app.swiper = function (container, params) {
	            return new Swiper(container, params);
	        };
	        app.initPageSwiper = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var swipers = pageContainer.find('.swiper-init, .tabs-swipeable-wrap');
	            if (swipers.length === 0)
	                return;
	            function destroySwiperOnRemove(slider) {
	                function destroySwiper() {
	                    slider.destroy();
	                    pageContainer.off('page:beforeremove', destroySwiper);
	                }
	                pageContainer.on('page:beforeremove', destroySwiper);
	            }
	            swipers.each(function () {
	                var swiper = $(this), initialSlide;
	                var params;
	                if (swiper.hasClass('tabs-swipeable-wrap')) {
	                    swiper.addClass('swiper-container').children('.tabs').addClass('swiper-wrapper').children('.tab').addClass('swiper-slide');
	                    initialSlide = swiper.children('.tabs').children('.tab.active').index();
	                }
	                if (swiper.data('swiper')) {
	                    params = JSON.parse(swiper.data('swiper'));
	                }
	                else {
	                    params = swiper.dataset();
	                }
	                if (typeof params.initialSlide === 'undefined' && typeof initialSlide !== 'undefined') {
	                    params.initialSlide = initialSlide;
	                }
	                if (swiper.hasClass('tabs-swipeable-wrap')) {
	                    params.onSlideChangeStart = function (s) {
	                        app.showTab(s.slides.eq(s.activeIndex));
	                    };
	                }
	                var _slider = app.swiper(swiper[0], params);
	                destroySwiperOnRemove(_slider);
	            });
	        };
	        app.reinitPageSwiper = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var sliders = pageContainer.find('.swiper-init, .tabs-swipeable-wrap');
	            if (sliders.length === 0)
	                return;
	            for (var i = 0; i < sliders.length; i++) {
	                var sliderInstance = sliders[0].swiper;
	                if (sliderInstance) {
	                    sliderInstance.update(true);
	                }
	            }
	        };
	        /*======================================================
	        ************   Photo Browser   ************
	        ======================================================*/
	        var PhotoBrowser = function (params) {
	            var pb = this, i;
	            var defaults = {
	                photos: [],
	                initialSlide: 0,
	                spaceBetween: 20,
	                speed: 300,
	                zoom: true,
	                zoomMax: 3,
	                zoomMin: 1,
	                exposition: true,
	                expositionHideCaptions: false,
	                type: 'standalone',
	                navbar: true,
	                toolbar: true,
	                theme: 'light',
	                swipeToClose: true,
	                backLinkText: 'Close',
	                ofText: 'of',
	                loop: false,
	                lazyLoading: false,
	                lazyLoadingInPrevNext: false,
	                lazyLoadingOnTransitionStart: false,
	                material: app.params.material,
	                materialPreloaderSvg: app.params.materialPreloaderSvg,
	                materialPreloaderHtml: app.params.materialPreloaderHtml,
	            };
	            params = params || {};
	            if (!params.backLinkText && app.params.material)
	                defaults.backLinkText = '';
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            if (params.maxZoom) {
	                params.zoomMax = params.maxZoom;
	            }
	            if (params.minZoom) {
	                params.zoomMin = params.minZoom;
	            }
	            pb.params = params;
	            pb.params.iconsColorClass = pb.params.iconsColor ? 'color-' + pb.params.iconsColor : (pb.params.theme === 'dark' ? 'color-white' : '');
	            pb.params.preloaderColorClass = pb.params.theme === 'dark' ? 'preloader-white' : '';
	            // Templates
	            var photoTemplate = pb.params.photoTemplate ||
	                '<div class="photo-browser-slide swiper-slide">' +
	                    '<span class="swiper-zoom-container">' +
	                    '<img src="{{js "this.url || this"}}">' +
	                    '</span>' +
	                    '</div>';
	            var photoLazyTemplate = pb.params.lazyPhotoTemplate ||
	                '<div class="photo-browser-slide photo-browser-slide-lazy swiper-slide">' +
	                    '<div class="preloader {{@root.preloaderColorClass}}">{{#if @root.material}}{{@root.materialPreloaderHtml}}{{/if}}</div>' +
	                    '<span class="swiper-zoom-container">' +
	                    '<img data-src="{{js "this.url || this"}}" class="swiper-lazy">' +
	                    '</span>' +
	                    '</div>';
	            var objectTemplate = pb.params.objectTemplate ||
	                '<div class="photo-browser-slide photo-browser-object-slide swiper-slide">{{js "this.html || this"}}</div>';
	            var captionTemplate = pb.params.captionTemplate ||
	                '<div class="photo-browser-caption" data-caption-index="{{@index}}">' +
	                    '{{caption}}' +
	                    '</div>';
	            var navbarTemplate = pb.params.navbarTemplate ||
	                '<div class="navbar">' +
	                    '<div class="navbar-inner">' +
	                    '<div class="left sliding">' +
	                    '<a href="#" class="link ' + (params.type === 'popup' ? 'close-popup' : 'photo-browser-close-link') + ' {{#unless backLinkText}}icon-only{{/unless}} {{js "this.type === \'page\' ? \'back\' : \'\'"}}">' +
	                    '<i class="icon icon-back {{iconsColorClass}}"></i>' +
	                    '{{#if backLinkText}}<span>{{backLinkText}}</span>{{/if}}' +
	                    '</a>' +
	                    '</div>' +
	                    '<div class="center sliding">' +
	                    '<span class="photo-browser-current"></span> ' +
	                    '<span class="photo-browser-of">{{ofText}}</span> ' +
	                    '<span class="photo-browser-total"></span>' +
	                    '</div>' +
	                    '<div class="right"></div>' +
	                    '</div>' +
	                    '</div>';
	            var toolbarTemplate = pb.params.toolbarTemplate ||
	                '<div class="toolbar tabbar">' +
	                    '<div class="toolbar-inner">' +
	                    '<a href="#" class="link photo-browser-prev">' +
	                    '<i class="icon icon-prev {{iconsColorClass}}"></i>' +
	                    '</a>' +
	                    '<a href="#" class="link photo-browser-next">' +
	                    '<i class="icon icon-next {{iconsColorClass}}"></i>' +
	                    '</a>' +
	                    '</div>' +
	                    '</div>';
	            var htmlTemplate = t7.compile('<div class="photo-browser photo-browser-{{theme}}">' +
	                '<div class="view navbar-fixed toolbar-fixed">' +
	                '{{#unless material}}{{#if navbar}}' +
	                navbarTemplate +
	                '{{/if}}{{/unless}}' +
	                '<div class="page no-toolbar {{#unless navbar}}no-navbar{{/unless}} toolbar-fixed navbar-fixed" data-page="photo-browser-slides">' +
	                '{{#if material}}{{#if navbar}}' +
	                navbarTemplate +
	                '{{/if}}{{/if}}' +
	                '{{#if toolbar}}' +
	                toolbarTemplate +
	                '{{/if}}' +
	                '<div class="photo-browser-captions photo-browser-captions-{{js "this.captionsTheme || this.theme"}}">' +
	                '{{#each photos}}{{#if caption}}' +
	                captionTemplate +
	                '{{/if}}{{/each}}' +
	                '</div>' +
	                '<div class="photo-browser-swiper-container swiper-container">' +
	                '<div class="photo-browser-swiper-wrapper swiper-wrapper">' +
	                '{{#each photos}}' +
	                '{{#js_compare "this.html || ((typeof this === \'string\' || this instanceof String) && (this.indexOf(\'<\') >= 0 || this.indexOf(\'>\') >= 0))"}}' +
	                objectTemplate +
	                '{{else}}' +
	                '{{#if @root.lazyLoading}}' +
	                photoLazyTemplate +
	                '{{else}}' +
	                photoTemplate +
	                '{{/if}}' +
	                '{{/js_compare}}' +
	                '{{/each}}' +
	                '</div>' +
	                '</div>' +
	                '</div>' +
	                '</div>' +
	                '</div>')(pb.params);
	            pb.activeIndex = pb.params.initialSlide;
	            pb.openIndex = pb.activeIndex;
	            pb.opened = false;
	            pb.open = function (index) {
	                if (typeof index === 'undefined')
	                    index = pb.activeIndex;
	                index = parseInt(index, 10);
	                if (pb.opened && pb.swiper) {
	                    pb.swiper.slideTo(index);
	                    return;
	                }
	                pb.opened = true;
	                pb.openIndex = index;
	                if (pb.params.type === 'standalone') {
	                    app.root.append(htmlTemplate);
	                }
	                if (pb.params.type === 'popup') {
	                    pb.popup = app.popup('<div class="popup photo-browser-popup">' + htmlTemplate + '</div>');
	                    $(pb.popup).on('popup:closed', pb.onPopupClose);
	                }
	                if (pb.params.type === 'page') {
	                    $(document).once('page:beforeinit', pb.onPageBeforeInit);
	                    $(document).once('page:beforeremove', pb.onPageBeforeRemove);
	                    if (!pb.params.view)
	                        pb.params.view = app.mainView;
	                    pb.params.view.loadContent(htmlTemplate);
	                    return;
	                }
	                pb.layout(pb.openIndex);
	                if (pb.params.onOpen) {
	                    pb.params.onOpen(pb);
	                }
	            };
	            pb.close = function () {
	                pb.opened = false;
	                if (!pb.swiperContainer || pb.swiperContainer.length === 0) {
	                    return;
	                }
	                if (pb.params.onClose) {
	                    pb.params.onClose(pb);
	                }
	                // Detach events
	                pb.attachEvents(true);
	                // Delete from DOM
	                if (pb.params.type === 'standalone') {
	                    pb.container.removeClass('photo-browser-in').addClass('photo-browser-out').animationEnd(function () {
	                        pb.container.remove();
	                    });
	                }
	                // Destroy slider
	                pb.swiper.destroy();
	                // Delete references
	                pb.swiper = pb.swiperContainer = pb.swiperWrapper = pb.slides = undefined; //gestureSlide = gestureImg = gestureImgWrap = undefined;
	            };
	            pb.onPopupClose = function (e) {
	                pb.close();
	                $(pb.popup).off('page:beforeinit', pb.onPopupClose);
	            };
	            pb.onPageBeforeInit = function (e) {
	                if (e.detail.page.name === 'photo-browser-slides') {
	                    pb.layout(pb.openIndex);
	                    if (pb.params.onOpen) {
	                        pb.params.onOpen(pb);
	                    }
	                }
	            };
	            pb.onPageBeforeRemove = function (e) {
	                if (e.detail.page.name === 'photo-browser-slides') {
	                    pb.close();
	                }
	            };
	            pb.onSliderTransitionStart = function (swiper) {
	                pb.activeIndex = swiper.activeIndex;
	                var current = swiper.activeIndex + 1;
	                var total = swiper.slides.length;
	                if (pb.params.loop) {
	                    total = total - 2;
	                    current = current - swiper.loopedSlides;
	                    if (current < 1)
	                        current = total + current;
	                    if (current > total)
	                        current = current - total;
	                }
	                pb.container.find('.photo-browser-current').text(current);
	                pb.container.find('.photo-browser-total').text(total);
	                $('.photo-browser-prev, .photo-browser-next').removeClass('photo-browser-link-inactive');
	                if (swiper.isBeginning && !pb.params.loop) {
	                    $('.photo-browser-prev').addClass('photo-browser-link-inactive');
	                }
	                if (swiper.isEnd && !pb.params.loop) {
	                    $('.photo-browser-next').addClass('photo-browser-link-inactive');
	                }
	                // Update captions
	                if (pb.captions.length > 0) {
	                    pb.captionsContainer.find('.photo-browser-caption-active').removeClass('photo-browser-caption-active');
	                    var captionIndex = pb.params.loop ? swiper.slides.eq(swiper.activeIndex).attr('data-swiper-slide-index') : pb.activeIndex;
	                    pb.captionsContainer.find('[data-caption-index="' + captionIndex + '"]').addClass('photo-browser-caption-active');
	                }
	                // Stop Video
	                var previousSlideVideo = swiper.slides.eq(swiper.previousIndex).find('video');
	                if (previousSlideVideo.length > 0) {
	                    if ('pause' in previousSlideVideo[0])
	                        previousSlideVideo[0].pause();
	                }
	                // Callback
	                if (pb.params.onTransitionStart)
	                    pb.params.onTransitionStart(swiper);
	            };
	            pb.onSliderTransitionEnd = function (swiper) {
	                if (pb.params.onTransitionEnd)
	                    pb.params.onTransitionEnd(swiper);
	            };
	            pb.layout = function (index) {
	                if (pb.params.type === 'page') {
	                    pb.container = $('.photo-browser-swiper-container').parents('.view');
	                }
	                else {
	                    pb.container = $('.photo-browser');
	                }
	                if (pb.params.type === 'standalone') {
	                    pb.container.addClass('photo-browser-in');
	                    app.sizeNavbars(pb.container);
	                }
	                pb.swiperContainer = pb.container.find('.photo-browser-swiper-container');
	                pb.swiperWrapper = pb.container.find('.photo-browser-swiper-wrapper');
	                pb.slides = pb.container.find('.photo-browser-slide');
	                pb.captionsContainer = pb.container.find('.photo-browser-captions');
	                pb.captions = pb.container.find('.photo-browser-caption');
	                var sliderSettings = {
	                    nextButton: pb.params.nextButton || '.photo-browser-next',
	                    prevButton: pb.params.prevButton || '.photo-browser-prev',
	                    indexButton: pb.params.indexButton,
	                    initialSlide: index,
	                    spaceBetween: pb.params.spaceBetween,
	                    speed: pb.params.speed,
	                    loop: pb.params.loop,
	                    lazyLoading: pb.params.lazyLoading,
	                    lazyLoadingInPrevNext: pb.params.lazyLoadingInPrevNext,
	                    lazyLoadingOnTransitionStart: pb.params.lazyLoadingOnTransitionStart,
	                    preloadImages: pb.params.lazyLoading ? false : true,
	                    zoom: pb.params.zoom,
	                    zoomMax: pb.params.zoomMax,
	                    zoomMin: pb.params.zoomMin,
	                    onTap: function (swiper, e) {
	                        if (pb.params.onTap)
	                            pb.params.onTap(swiper, e);
	                    },
	                    onClick: function (swiper, e) {
	                        if (pb.params.exposition)
	                            pb.toggleExposition();
	                        if (pb.params.onClick)
	                            pb.params.onClick(swiper, e);
	                    },
	                    onDoubleTap: function (swiper, e) {
	                        // pb.toggleZoom(e);
	                        if (pb.params.onDoubleTap)
	                            pb.params.onDoubleTap(swiper, e);
	                    },
	                    onTransitionStart: function (swiper) {
	                        pb.onSliderTransitionStart(swiper);
	                    },
	                    onTransitionEnd: function (swiper) {
	                        pb.onSliderTransitionEnd(swiper);
	                    },
	                    onSlideChangeStart: pb.params.onSlideChangeStart,
	                    onSlideChangeEnd: pb.params.onSlideChangeEnd,
	                    onLazyImageLoad: function (swiper, slide, img) {
	                        if (pb.params.onLazyImageLoad)
	                            pb.params.onLazyImageLoad(pb, slide, img);
	                    },
	                    onLazyImageReady: function (swiper, slide, img) {
	                        $(slide).removeClass('photo-browser-slide-lazy');
	                        if (pb.params.onLazyImageReady)
	                            pb.params.onLazyImageReady(pb, slide, img);
	                    }
	                };
	                if (pb.params.swipeToClose && pb.params.type !== 'page') {
	                    sliderSettings.onTouchStart = pb.swipeCloseTouchStart;
	                    sliderSettings.onTouchMoveOpposite = pb.swipeCloseTouchMove;
	                    sliderSettings.onTouchEnd = pb.swipeCloseTouchEnd;
	                }
	                pb.swiper = app.swiper(pb.swiperContainer, sliderSettings);
	                if (index === 0) {
	                    pb.onSliderTransitionStart(pb.swiper);
	                }
	                pb.attachEvents();
	            };
	            pb.attachEvents = function (detach) {
	                var action = detach ? 'off' : 'on';
	                pb.container.find('.photo-browser-close-link')[action]('click', pb.close);
	            };
	            // Expose
	            pb.exposed = false;
	            pb.toggleExposition = function () {
	                if (pb.container)
	                    pb.container.toggleClass('photo-browser-exposed');
	                if (pb.params.expositionHideCaptions)
	                    pb.captionsContainer.toggleClass('photo-browser-captions-exposed');
	                pb.exposed = !pb.exposed;
	            };
	            pb.enableExposition = function () {
	                if (pb.container)
	                    pb.container.addClass('photo-browser-exposed');
	                if (pb.params.expositionHideCaptions)
	                    pb.captionsContainer.addClass('photo-browser-captions-exposed');
	                pb.exposed = true;
	            };
	            pb.disableExposition = function () {
	                if (pb.container)
	                    pb.container.removeClass('photo-browser-exposed');
	                if (pb.params.expositionHideCaptions)
	                    pb.captionsContainer.removeClass('photo-browser-captions-exposed');
	                pb.exposed = false;
	            };
	            // Swipe Up To Close
	            var swipeToCloseIsTouched = false;
	            var allowSwipeToClose = true;
	            var swipeToCloseDiff, swipeToCloseStart, swipeToCloseCurrent, swipeToCloseStarted = false, swipeToCloseActiveSlide, swipeToCloseTimeStart;
	            pb.swipeCloseTouchStart = function (swiper, e) {
	                if (!allowSwipeToClose)
	                    return;
	                swipeToCloseIsTouched = true;
	            };
	            pb.swipeCloseTouchMove = function (swiper, e) {
	                if (!swipeToCloseIsTouched)
	                    return;
	                if (!swipeToCloseStarted) {
	                    swipeToCloseStarted = true;
	                    swipeToCloseStart = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                    swipeToCloseActiveSlide = pb.swiper.slides.eq(pb.swiper.activeIndex);
	                    swipeToCloseTimeStart = (new Date()).getTime();
	                }
	                e.preventDefault();
	                swipeToCloseCurrent = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                swipeToCloseDiff = swipeToCloseStart - swipeToCloseCurrent;
	                var opacity = 1 - Math.abs(swipeToCloseDiff) / 300;
	                swipeToCloseActiveSlide.transform('translate3d(0,' + (-swipeToCloseDiff) + 'px,0)');
	                pb.swiper.container.css('opacity', opacity).transition(0);
	            };
	            pb.swipeCloseTouchEnd = function (swiper, e) {
	                swipeToCloseIsTouched = false;
	                if (!swipeToCloseStarted) {
	                    swipeToCloseStarted = false;
	                    return;
	                }
	                swipeToCloseStarted = false;
	                allowSwipeToClose = false;
	                var diff = Math.abs(swipeToCloseDiff);
	                var timeDiff = (new Date()).getTime() - swipeToCloseTimeStart;
	                if ((timeDiff < 300 && diff > 20) || (timeDiff >= 300 && diff > 100)) {
	                    setTimeout(function () {
	                        if (pb.params.type === 'standalone') {
	                            pb.close();
	                        }
	                        if (pb.params.type === 'popup') {
	                            app.closeModal(pb.popup);
	                        }
	                        if (pb.params.onSwipeToClose) {
	                            pb.params.onSwipeToClose(pb);
	                        }
	                        allowSwipeToClose = true;
	                    }, 0);
	                    return;
	                }
	                if (diff !== 0) {
	                    swipeToCloseActiveSlide.addClass('transitioning').transitionEnd(function () {
	                        allowSwipeToClose = true;
	                        swipeToCloseActiveSlide.removeClass('transitioning');
	                    });
	                }
	                else {
	                    allowSwipeToClose = true;
	                }
	                pb.swiper.container.css('opacity', '').transition('');
	                swipeToCloseActiveSlide.transform('');
	            };
	            return pb;
	        };
	        app.photoBrowser = function (params) {
	            return new PhotoBrowser(params);
	        };
	        /*===============================================================================
	        ************   Autocomplete   ************
	        ===============================================================================*/
	        var Autocomplete = function (params) {
	            var a = this;
	            // Params
	            var defaults = {
	                // Standalone Options
	                /*
	                opener: undefined,
	                */
	                popupCloseText: 'Close',
	                backText: 'Back',
	                searchbarPlaceholderText: 'Search...',
	                searchbarCancelText: 'Cancel',
	                openWithAnimation: true,
	                // When opened in page should the searchbar be focused by default
	                autoFocus: false,
	                openIn: 'page',
	                backOnSelect: false,
	                notFoundText: 'Nothing found',
	                requestSourceOnOpen: false,
	                /*
	                pageTitle: undefined,
	                */
	                // Handle Data
	                /*
	                source: undefined,
	                limit: undefined,
	                */
	                valueProperty: 'id',
	                textProperty: 'text',
	                // Dropdown Options
	                highlightMatches: true,
	                /*
	                dropdownPlaceholderText: 'Type anything...',
	                */
	                updateInputValueOnSelect: true,
	                expandInput: false,
	                // Preloader
	                preloaderColor: false,
	                preloader: false,
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            a.params = params;
	            // Opener Link & View
	            if (a.params.opener) {
	                a.opener = $(a.params.opener);
	            }
	            var view = a.params.view;
	            if (!a.params.view && a.opener && a.opener.length) {
	                // Find related view
	                view = a.opener.parents('.' + app.params.viewClass);
	                if (view.length === 0)
	                    return;
	                view = view[0].f7View;
	            }
	            // Input
	            if (a.params.input) {
	                a.input = $(a.params.input);
	                if (a.input.length === 0 && a.params.openIn === 'dropdown')
	                    return;
	            }
	            // Array with selected items
	            a.value = a.params.value || [];
	            // ID & Inputs
	            a.id = (new Date()).getTime();
	            a.inputType = a.params.multiple ? 'checkbox' : 'radio';
	            a.inputName = a.inputType + '-' + a.id;
	            // Is Material
	            var material = app.params.material;
	            // Back On Select
	            var backOnSelect = a.params.backOnSelect;
	            if (a.params.openIn !== 'dropdown') {
	                // Item Template
	                a.itemTemplate = t7.compile(a.params.itemTemplate ||
	                    '<li>' +
	                        '<label class="label-{{inputType}} item-content">' +
	                        '<input type="{{inputType}}" name="{{inputName}}" value="{{value}}" {{#if selected}}checked{{/if}}>' +
	                        '{{#if material}}' +
	                        '<div class="item-media">' +
	                        '<i class="icon icon-form-{{inputType}}"></i>' +
	                        '</div>' +
	                        '<div class="item-inner">' +
	                        '<div class="item-title">{{text}}</div>' +
	                        '</div>' +
	                        '{{else}}' +
	                        '{{#if checkbox}}' +
	                        '<div class="item-media">' +
	                        '<i class="icon icon-form-checkbox"></i>' +
	                        '</div>' +
	                        '{{/if}}' +
	                        '<div class="item-inner">' +
	                        '<div class="item-title">{{text}}</div>' +
	                        '</div>' +
	                        '{{/if}}' +
	                        '</label>' +
	                        '</li>');
	                // Page Layout
	                var pageTitle = a.params.pageTitle || '';
	                if (!pageTitle && a.opener && a.opener.length) {
	                    pageTitle = a.opener.find('.item-title').text();
	                }
	                var pageName = 'autocomplete-' + a.inputName;
	                var navbarTheme = a.params.navbarTheme, formTheme = a.params.formTheme;
	                // Navbar HTML
	                var navbarHTML;
	                var noNavbar = '', noToolbar = '', navbarLayout;
	                a.navbarTemplate = t7.compile(a.params.navbarTemplate ||
	                    '<div class="navbar no-shadow {{#if navbarTheme}}theme-{{navbarTheme}}{{/if}}">' +
	                        '<div class="navbar-inner">' +
	                        '<div class="left sliding">' +
	                        '{{#if material}}' +
	                        '<a href="#" class="link {{#if inPopup}}close-popup{{else}}back{{/if}} icon-only" {{#unless animated}}data-animate-pages="false"{{/unless}}><i class="icon icon-back"></i></a>' +
	                        '{{else}}' +
	                        '<a href="#" class="link {{#if inPopup}}close-popup{{else}}back{{/if}}" {{#unless animated}}data-animate-pages="false"{{/unless}}>' +
	                        '<i class="icon icon-back"></i>' +
	                        '{{#if inPopup}}' +
	                        '<span>{{popupCloseText}}</span>' +
	                        '{{else}}' +
	                        '<span>{{backText}}</span>' +
	                        '{{/if}}' +
	                        '</a>' +
	                        '{{/if}}' +
	                        '</div>' +
	                        '<div class="center sliding">{{pageTitle}}</div>' +
	                        '{{#if preloader}}' +
	                        '<div class="right">' +
	                        '<div class="autocomplete-preloader preloader {{#if preloaderColor}}preloader-{{preloaderColor}}{{/if}}"></div>' +
	                        '</div>' +
	                        '{{/if}}' +
	                        '</div>' +
	                        '</div>');
	                navbarHTML = a.navbarTemplate({
	                    pageTitle: pageTitle,
	                    backText: a.params.backText,
	                    popupCloseText: a.params.popupCloseText,
	                    openIn: a.params.openIn,
	                    navbarTheme: navbarTheme,
	                    inPopup: a.params.openIn === 'popup',
	                    inPage: a.params.openIn === 'page',
	                    material: material,
	                    preloader: a.params.preloader,
	                    preloaderColor: a.params.preloaderColor,
	                    animated: a.params.openWithAnimation
	                });
	                // Determine navbar layout type - static/fixed/through
	                if (a.params.openIn === 'page') {
	                    navbarLayout = 'static';
	                    if (a.opener) {
	                        if (a.opener.parents('.navbar-through').length > 0)
	                            navbarLayout = 'through';
	                        if (a.opener.parents('.navbar-fixed').length > 0)
	                            navbarLayout = 'fixed';
	                        noToolbar = a.opener.parents('.page').hasClass('no-toolbar') ? 'no-toolbar' : '';
	                        noNavbar = a.opener.parents('.page').hasClass('no-navbar') ? 'no-navbar' : 'navbar-' + navbarLayout;
	                    }
	                    else if (view.container) {
	                        if ($(view.container).hasClass('navbar-through') || $(view.container).find('.navbar-through').length > 0)
	                            navbarLayout = 'through';
	                        if ($(view.container).hasClass('navbar-fixed') || $(view.container).find('.navbar-fixed').length > 0)
	                            navbarLayout = 'fixed';
	                        noToolbar = $(view.activePage.container).hasClass('no-toolbar') ? 'no-toolbar' : '';
	                        noNavbar = $(view.activePage.container).hasClass('no-navbar') ? 'no-navbar' : 'navbar-' + navbarLayout;
	                    }
	                }
	                else {
	                    navbarLayout = 'fixed';
	                }
	                var searchbarHTML = '<form class="searchbar">' +
	                    '<div class="searchbar-input">' +
	                    '<input type="search" placeholder="' + a.params.searchbarPlaceholderText + '">' +
	                    '<a href="#" class="searchbar-clear"></a>' +
	                    '</div>' +
	                    (material ? '' : '<a href="#" class="searchbar-cancel">' + a.params.searchbarCancelText + '</a>') +
	                    '</form>' +
	                    '<div class="searchbar-overlay"></div>';
	                var pageHTML = (navbarLayout === 'through' ? navbarHTML : '') +
	                    '<div class="pages">' +
	                    '<div data-page="' + pageName + '" class="page autocomplete-page ' + noNavbar + ' ' + noToolbar + '">' +
	                    (navbarLayout === 'fixed' ? navbarHTML : '') +
	                    searchbarHTML +
	                    '<div class="page-content">' +
	                    (navbarLayout === 'static' ? navbarHTML : '') +
	                    '<div class="list-block autocomplete-found autocomplete-list-' + a.id + ' ' + (formTheme ? 'theme-' + formTheme : '') + '">' +
	                    '<ul></ul>' +
	                    '</div>' +
	                    '<div class="list-block autocomplete-not-found">' +
	                    '<ul><li class="item-content"><div class="item-inner"><div class="item-title">' + a.params.notFoundText + '</div></div></li></ul>' +
	                    '</div>' +
	                    '<div class="list-block autocomplete-values">' +
	                    '<ul></ul>' +
	                    '</div>' +
	                    '</div>' +
	                    '</div>' +
	                    '</div>';
	            }
	            else {
	                a.dropdownItemTemplate = t7.compile(a.params.dropdownItemTemplate ||
	                    '<li>' +
	                        '<label class="{{#unless placeholder}}label-radio{{/unless}} item-content" data-value="{{value}}">' +
	                        '<div class="item-inner">' +
	                        '<div class="item-title">{{text}}</div>' +
	                        '</div>' +
	                        '</label>' +
	                        '</li>');
	                a.dropdownPlaceholderTemplate = t7.compile(a.params.dropdownPlaceholderTemplate ||
	                    '<li class="autocomplete-dropdown-placeholder">' +
	                        '<div class="item-content">' +
	                        '<div class="item-inner">' +
	                        '<div class="item-title">{{text}}</div>' +
	                        '</div>' +
	                        '</label>' +
	                        '</li>');
	                a.dropdownTemplate = t7.compile(a.params.dropdownTemplate ||
	                    '<div class="autocomplete-dropdown">' +
	                        '<div class="autocomplete-dropdown-inner">' +
	                        '<div class="list-block">' +
	                        '<ul></ul>' +
	                        '</div>' +
	                        '</div>' +
	                        '{{#if preloader}}' +
	                        '<div class="autocomplete-preloader preloader {{#if preloaderColor}}preloader-{{preloaderColor}}{{/if}}">{{#if material}}{{materialPreloaderHtml}}{{/if}}</div>' +
	                        '{{/if}}' +
	                        '</div>');
	            }
	            // Define popup
	            a.popup = undefined;
	            // Define Dropdown
	            a.dropdown = undefined;
	            // Handle Input Value Change
	            function handleInputValue(e) {
	                var query = a.input.val();
	                if (a.params.source) {
	                    a.params.source(a, query, function (items) {
	                        var itemsHTML = '';
	                        var limit = a.params.limit ? Math.min(a.params.limit, items.length) : items.length;
	                        a.items = items;
	                        var i, j, regExp;
	                        if (a.params.highlightMatches) {
	                            query = query.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	                            regExp = new RegExp('(' + query + ')', 'i');
	                        }
	                        for (i = 0; i < limit; i++) {
	                            var itemValue = typeof items[i] === 'object' ? items[i][a.params.valueProperty] : items[i];
	                            var itemText = typeof items[i] !== 'object' ? items[i] : items[i][a.params.textProperty];
	                            itemsHTML += a.dropdownItemTemplate({
	                                value: itemValue,
	                                text: a.params.highlightMatches ? itemText.replace(regExp, '<b>$1</b>') : itemText
	                            });
	                        }
	                        if (itemsHTML === '' && query === '' && a.params.dropdownPlaceholderText) {
	                            itemsHTML += a.dropdownPlaceholderTemplate({
	                                text: a.params.dropdownPlaceholderText,
	                            });
	                        }
	                        a.dropdown.find('ul').html(itemsHTML);
	                    });
	                }
	            }
	            // Handle Drop Down Click
	            function handleDropdownClick(e) {
	                /*jshint validthis:true */
	                var clicked = $(this);
	                var clickedItem;
	                for (var i = 0; i < a.items.length; i++) {
	                    var itemValue = typeof a.items[i] === 'object' ? a.items[i][a.params.valueProperty] : a.items[i];
	                    var value = clicked.attr('data-value');
	                    if (itemValue === value || itemValue * 1 === value * 1) {
	                        clickedItem = a.items[i];
	                    }
	                }
	                if (a.params.updateInputValueOnSelect) {
	                    a.input.val(typeof clickedItem === 'object' ? clickedItem[a.params.valueProperty] : clickedItem);
	                    a.input.trigger('input change');
	                }
	                if (a.params.onChange) {
	                    a.params.onChange(a, clickedItem);
	                }
	                a.close();
	            }
	            // Handle HTML Click to close Dropdown
	            function closeOnHTMLClick(e) {
	                var target = $(e.target);
	                if (!(target.is(a.input[0]) || a.dropdown && target.parents(a.dropdown[0]).length > 0)) {
	                    a.close();
	                }
	            }
	            a.positionDropDown = function () {
	                var listBlock = a.input.parents('.list-block'), pageContent = a.input.parents('.page-content'), paddingTop = parseInt(pageContent.css('padding-top'), 10), paddingBottom = parseInt(pageContent.css('padding-top'), 10), 
	                // inputOffset = a.input.offset(),
	                listBlockOffsetLeft = listBlock.length > 0 ? listBlock.offset().left - listBlock.parent().offset().left : 0, inputOffsetLeft = a.input.offset().left - (listBlock.length > 0 ? listBlock.offset().left : 0), inputOffsetTop = a.input.offset().top - (pageContent.offset().top - pageContent[0].scrollTop), maxHeight = pageContent[0].scrollHeight - paddingBottom - (inputOffsetTop + pageContent[0].scrollTop) - a.input[0].offsetHeight;
	                a.dropdown.css({
	                    left: (listBlock.length > 0 ? listBlockOffsetLeft : inputOffsetLeft) + 'px',
	                    top: inputOffsetTop + pageContent[0].scrollTop + a.input[0].offsetHeight + 'px',
	                    width: (listBlock.length > 0 ? listBlock[0].offsetWidth : a.input[0].offsetWidth) + 'px'
	                });
	                a.dropdown.children('.autocomplete-dropdown-inner').css({
	                    maxHeight: maxHeight + 'px',
	                    paddingLeft: listBlock.length > 0 && !a.params.expandInput ? inputOffsetLeft - (material ? 16 : 15) + 'px' : ''
	                });
	            };
	            a.pageInit = function (e) {
	                var page = e.detail.page;
	                a.page = $(page.container);
	                a.pageData = page;
	                if (page.name !== pageName) {
	                    return;
	                }
	                var container = $(page.container);
	                // Source
	                function onSource(query) {
	                    if (!a.params.source)
	                        return;
	                    var i, j, k;
	                    a.params.source(a, query, function (items) {
	                        var itemsHTML = '';
	                        var limit = a.params.limit ? Math.min(a.params.limit, items.length) : items.length;
	                        a.items = items;
	                        for (i = 0; i < limit; i++) {
	                            var selected = false;
	                            var itemValue = typeof items[i] === 'object' ? items[i][a.params.valueProperty] : items[i];
	                            for (j = 0; j < a.value.length; j++) {
	                                var aValue = typeof a.value[j] === 'object' ? a.value[j][a.params.valueProperty] : a.value[j];
	                                if (aValue === itemValue || aValue * 1 === itemValue * 1)
	                                    selected = true;
	                            }
	                            itemsHTML += a.itemTemplate({
	                                value: itemValue,
	                                text: typeof items[i] !== 'object' ? items[i] : items[i][a.params.textProperty],
	                                inputType: a.inputType,
	                                id: a.id,
	                                inputName: a.inputName,
	                                selected: selected,
	                                checkbox: a.inputType === 'checkbox',
	                                material: material
	                            });
	                        }
	                        container.find('.autocomplete-found ul').html(itemsHTML);
	                        if (items.length === 0) {
	                            if (query.length !== 0) {
	                                container.find('.autocomplete-not-found').show();
	                                container.find('.autocomplete-found, .autocomplete-values').hide();
	                            }
	                            else {
	                                container.find('.autocomplete-values').show();
	                                container.find('.autocomplete-found, .autocomplete-not-found').hide();
	                            }
	                        }
	                        else {
	                            container.find('.autocomplete-found').show();
	                            container.find('.autocomplete-not-found, .autocomplete-values').hide();
	                        }
	                    });
	                }
	                // Init Search Bar
	                var searchbar = app.searchbar(container.find('.searchbar'), {
	                    customSearch: true,
	                    onSearch: function (searchbar, data) {
	                        if (data.query.length === 0 && searchbar.active) {
	                            searchbar.overlay.addClass('searchbar-overlay-active');
	                        }
	                        else {
	                            searchbar.overlay.removeClass('searchbar-overlay-active');
	                        }
	                        onSource(data.query);
	                    }
	                });
	                // Save searchbar instance
	                a.searchbar = searchbar;
	                // Update values
	                function updateValues() {
	                    var valuesHTML = '';
	                    var i;
	                    for (i = 0; i < a.value.length; i++) {
	                        valuesHTML += a.itemTemplate({
	                            value: typeof a.value[i] === 'object' ? a.value[i][a.params.valueProperty] : a.value[i],
	                            text: typeof a.value[i] === 'object' ? a.value[i][a.params.textProperty] : a.value[i],
	                            inputType: a.inputType,
	                            id: a.id,
	                            inputName: a.inputName + '-checked',
	                            checkbox: a.inputType === 'checkbox',
	                            material: material,
	                            selected: true
	                        });
	                    }
	                    container.find('.autocomplete-values ul').html(valuesHTML);
	                }
	                // Handle Inputs
	                if (!a.params.multiple && a.params.backOnSelect) {
	                    container.once('click', '.list-block label', function () {
	                        if (a.params.openIn === 'popup')
	                            app.closeModal(a.popup);
	                        else
	                            view.router.back({ animatePages: a.params.openWithAnimation });
	                    });
	                }
	                container.on('change', 'input[type="radio"], input[type="checkbox"]', function () {
	                    var i;
	                    var input = this;
	                    var value = input.value;
	                    var text = $(input).parents('li').find('.item-title').text();
	                    var isValues = $(input).parents('.autocomplete-values').length > 0;
	                    var item, itemValue, aValue;
	                    if (isValues) {
	                        if (a.inputType === 'checkbox' && !input.checked) {
	                            for (i = 0; i < a.value.length; i++) {
	                                aValue = typeof a.value[i] === 'string' ? a.value[i] : a.value[i][a.params.valueProperty];
	                                if (aValue === value || aValue * 1 === value * 1) {
	                                    a.value.splice(i, 1);
	                                }
	                            }
	                            updateValues();
	                            if (a.params.onChange)
	                                a.params.onChange(a, a.value);
	                        }
	                        return;
	                    }
	                    // Find Related Item
	                    for (i = 0; i < a.items.length; i++) {
	                        itemValue = typeof a.items[i] === 'string' ? a.items[i] : a.items[i][a.params.valueProperty];
	                        if (itemValue === value || itemValue * 1 === value * 1)
	                            item = a.items[i];
	                    }
	                    // Update Selected Value
	                    if (a.inputType === 'radio') {
	                        a.value = [item];
	                    }
	                    else {
	                        if (input.checked) {
	                            a.value.push(item);
	                        }
	                        else {
	                            for (i = 0; i < a.value.length; i++) {
	                                aValue = typeof a.value[i] === 'string' ? a.value[i] : a.value[i][a.params.valueProperty];
	                                if (aValue === value || aValue * 1 === value * 1) {
	                                    a.value.splice(i, 1);
	                                }
	                            }
	                        }
	                    }
	                    // Update Values Block
	                    updateValues();
	                    // On Select Callback
	                    if ((a.inputType === 'radio' && input.checked || a.inputType === 'checkbox') && a.params.onChange) {
	                        a.params.onChange(a, a.value);
	                    }
	                });
	                // Update Values On Page Init
	                updateValues();
	                // Source on load
	                if (a.params.requestSourceOnOpen)
	                    onSource('');
	                // On Open Callback
	                if (a.params.onOpen)
	                    a.params.onOpen(a);
	            };
	            // Show Hide Preloader
	            a.showPreloader = function () {
	                if (a.params.openIn === 'dropdown') {
	                    if (a.dropdown)
	                        a.dropdown.find('.autocomplete-preloader').addClass('autocomplete-preloader-visible');
	                }
	                else
	                    $('.autocomplete-preloader').addClass('autocomplete-preloader-visible');
	            };
	            a.hidePreloader = function () {
	                if (a.params.openIn === 'dropdown') {
	                    if (a.dropdown)
	                        a.dropdown.find('.autocomplete-preloader').removeClass('autocomplete-preloader-visible');
	                }
	                else
	                    $('.autocomplete-preloader').removeClass('autocomplete-preloader-visible');
	            };
	            // Autofocus
	            a.autoFocus = function (e) {
	                var self = this;
	                setTimeout(function () {
	                    $(self).find('input[type=search]').focus();
	                }, 0);
	            };
	            // Open Autocomplete Page/Popup
	            a.open = function () {
	                if (a.opened)
	                    return;
	                a.opened = true;
	                if (a.params.openIn === 'dropdown') {
	                    if (!a.dropdown) {
	                        a.dropdown = $(a.dropdownTemplate({
	                            preloader: a.params.preloader,
	                            preloaderColor: a.params.preloaderColor,
	                            material: material,
	                            materialPreloaderHtml: app.params.materialPreloaderHtml
	                        }));
	                        a.dropdown.on('click', 'label', handleDropdownClick);
	                    }
	                    var listBlock = a.input.parents('.list-block');
	                    if (listBlock.length && a.input.parents('.item-content').length > 0 && a.params.expandInput) {
	                        a.input.parents('.item-content').addClass('item-content-dropdown-expand');
	                    }
	                    a.positionDropDown();
	                    a.input.parents('.page-content').append(a.dropdown);
	                    a.dropdown.addClass('autocomplete-dropdown-in');
	                    a.input.trigger('input');
	                    app.onResize(a.positionDropDown);
	                    if (a.params.onOpen)
	                        a.params.onOpen(a);
	                }
	                else {
	                    $(document).once('page:init', '.autocomplete-page', a.pageInit);
	                    if (a.params.openIn === 'popup') {
	                        a.popup = app.popup('<div class="popup autocomplete-popup autocomplete-popup-' + a.inputName + '">' +
	                            '<div class="view navbar-fixed">' +
	                            pageHTML +
	                            '</div>' +
	                            '</div>', true, a.params.openWithAnimation);
	                        a.popup = $(a.popup);
	                        if (a.params.autoFocus) {
	                            if (a.params.openWithAnimation)
	                                a.popup.once('popup:opened', a.autoFocus);
	                            else
	                                a.autoFocus.bind(a.popup)();
	                        }
	                        a.popup.once('popup:closed', function () {
	                            a.popup = undefined;
	                            a.opened = false;
	                            if (a.params.onClose)
	                                a.params.onClose(a);
	                        });
	                    }
	                    else {
	                        if (a.params.autoFocus) {
	                            $(document).once(a.params.openWithAnimation ? 'page:afteranimation' : 'page:init', '.autocomplete-page', a.autoFocus);
	                        }
	                        view.router.load({
	                            content: pageHTML,
	                            animatePages: a.params.openWithAnimation
	                        });
	                        $(document).once('page:back', '.autocomplete-page', function () {
	                            a.opened = false;
	                            if (a.params.onClose)
	                                a.params.onClose(a);
	                        });
	                    }
	                }
	            };
	            a.close = function (e) {
	                if (!a.opened)
	                    return;
	                if (a.params.openIn === 'dropdown') {
	                    if (e && e.type === 'blur' && a.dropdown.find('label.active-state').length > 0)
	                        return;
	                    a.dropdown.removeClass('autocomplete-dropdown-in').remove();
	                    a.input.parents('.item-content-dropdown-expand').removeClass('item-content-dropdown-expand');
	                    a.opened = false;
	                    app.offResize(a.positionDropDown);
	                    if (a.params.onClose)
	                        a.params.onClose(a);
	                }
	                if (a.params.openIn === 'popup') {
	                    if (a.popup)
	                        app.closeModal(a.popup);
	                }
	            };
	            // Init Events
	            a.initEvents = function (detach) {
	                var method = detach ? 'off' : 'on';
	                if (a.params.openIn !== 'dropdown' && a.opener) {
	                    a.opener[method]('click', a.open);
	                }
	                if (a.params.openIn === 'dropdown' && a.input) {
	                    a.input[method]('focus', a.open);
	                    a.input[method]('input', handleInputValue);
	                    if (app.device.android) {
	                        $('html')[method]('click', closeOnHTMLClick);
	                    }
	                    else {
	                        a.input[method]('blur', a.close);
	                    }
	                }
	                if (detach && a.dropdown) {
	                    a.dropdown = null;
	                }
	            };
	            // Init/Destroy Methods
	            a.init = function () {
	                a.initEvents();
	            };
	            a.destroy = function () {
	                a.initEvents(true);
	                a = null;
	            };
	            // Init
	            a.init();
	            return a;
	        };
	        app.autocomplete = function (params) {
	            return new Autocomplete(params);
	        };
	        /*======================================================
	        ************   Picker   ************
	        ======================================================*/
	        var Picker = function (params) {
	            var p = this;
	            var defaults = {
	                updateValuesOnMomentum: false,
	                updateValuesOnTouchmove: true,
	                rotateEffect: false,
	                momentumRatio: 7,
	                freeMode: false,
	                // Common settings
	                closeByOutsideClick: true,
	                scrollToInput: true,
	                inputReadOnly: true,
	                convertToPopover: true,
	                onlyInPopover: false,
	                toolbar: true,
	                toolbarCloseText: 'Done',
	                toolbarTemplate: '<div class="toolbar">' +
	                    '<div class="toolbar-inner">' +
	                    '<div class="left"></div>' +
	                    '<div class="right">' +
	                    '<a href="#" class="link close-picker">{{closeText}}</a>' +
	                    '</div>' +
	                    '</div>' +
	                    '</div>'
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            p.params = params;
	            p.cols = [];
	            p.initialized = false;
	            // Inline flag
	            p.inline = p.params.container ? true : false;
	            // 3D Transforms origin bug, only on safari
	            var originBug = app.device.ios || (navigator.userAgent.toLowerCase().indexOf('safari') >= 0 && navigator.userAgent.toLowerCase().indexOf('chrome') < 0) && !app.device.android;
	            // Should be converted to popover
	            function isPopover() {
	                var toPopover = false;
	                if (!p.params.convertToPopover && !p.params.onlyInPopover)
	                    return toPopover;
	                if (!p.inline && p.params.input) {
	                    if (p.params.onlyInPopover)
	                        toPopover = true;
	                    else {
	                        if (app.device.ios) {
	                            toPopover = app.device.ipad ? true : false;
	                        }
	                        else {
	                            if (app.width >= 768)
	                                toPopover = true;
	                        }
	                    }
	                }
	                return toPopover;
	            }
	            function inPopover() {
	                if (p.opened && p.container && p.container.length > 0 && p.container.parents('.popover').length > 0)
	                    return true;
	                else
	                    return false;
	            }
	            // Value
	            p.setValue = function (arrValues, transition) {
	                var valueIndex = 0;
	                if (p.cols.length === 0) {
	                    p.value = arrValues;
	                    p.updateValue(arrValues);
	                    return;
	                }
	                for (var i = 0; i < p.cols.length; i++) {
	                    if (p.cols[i] && !p.cols[i].divider) {
	                        p.cols[i].setValue(arrValues[valueIndex], transition);
	                        valueIndex++;
	                    }
	                }
	            };
	            p.updateValue = function (forceValues) {
	                var newValue = forceValues || [];
	                var newDisplayValue = [], i, column;
	                if (p.cols.length === 0) {
	                    var noDividerColumns = p.params.cols.filter(function (column) {
	                        return !column.divider;
	                    });
	                    for (i = 0; i < noDividerColumns.length; i++) {
	                        column = noDividerColumns[i];
	                        if (column.displayValues !== undefined && column.values !== undefined && column.values.indexOf(newValue[i]) !== -1) {
	                            newDisplayValue.push(column.displayValues[column.values.indexOf(newValue[i])]);
	                        }
	                        else {
	                            newDisplayValue.push(newValue[i]);
	                        }
	                    }
	                }
	                else {
	                    for (i = 0; i < p.cols.length; i++) {
	                        if (!p.cols[i].divider) {
	                            newValue.push(p.cols[i].value);
	                            newDisplayValue.push(p.cols[i].displayValue);
	                        }
	                    }
	                }
	                if (newValue.indexOf(undefined) >= 0) {
	                    return;
	                }
	                p.value = newValue;
	                p.displayValue = newDisplayValue;
	                if (p.params.onChange) {
	                    p.params.onChange(p, p.value, p.displayValue);
	                }
	                if (p.input && p.input.length > 0) {
	                    $(p.input).val(p.params.formatValue ? p.params.formatValue(p, p.value, p.displayValue) : p.value.join(' '));
	                    $(p.input).trigger('change');
	                }
	            };
	            // Columns Handlers
	            p.initPickerCol = function (colElement, updateItems) {
	                var colContainer = $(colElement);
	                var colIndex = colContainer.index();
	                var col = p.cols[colIndex];
	                if (col.divider)
	                    return;
	                col.container = colContainer;
	                col.wrapper = col.container.find('.picker-items-col-wrapper');
	                col.items = col.wrapper.find('.picker-item');
	                var i, j;
	                var wrapperHeight, itemHeight, itemsHeight, minTranslate, maxTranslate;
	                col.replaceValues = function (values, displayValues) {
	                    col.destroyEvents();
	                    col.values = values;
	                    col.displayValues = displayValues;
	                    var newItemsHTML = p.columnHTML(col, true);
	                    col.wrapper.html(newItemsHTML);
	                    col.items = col.wrapper.find('.picker-item');
	                    col.calcSize();
	                    col.setValue(col.values[0], 0, true);
	                    col.initEvents();
	                };
	                var resizeTimeout;
	                col.calcSize = function () {
	                    if (p.params.rotateEffect) {
	                        col.container.removeClass('picker-items-col-absolute');
	                        if (!col.width)
	                            col.container.css({ width: '' });
	                    }
	                    var colWidth, colHeight;
	                    colWidth = 0;
	                    colHeight = col.container[0].offsetHeight;
	                    wrapperHeight = col.wrapper[0].offsetHeight;
	                    itemHeight = col.items[0].offsetHeight;
	                    itemsHeight = itemHeight * col.items.length;
	                    minTranslate = colHeight / 2 - itemsHeight + itemHeight / 2;
	                    maxTranslate = colHeight / 2 - itemHeight / 2;
	                    if (col.width) {
	                        colWidth = col.width;
	                        if (parseInt(colWidth, 10) === colWidth)
	                            colWidth = colWidth + 'px';
	                        col.container.css({ width: colWidth });
	                    }
	                    if (p.params.rotateEffect) {
	                        if (!col.width) {
	                            col.items.each(function () {
	                                var item = $(this).children('span');
	                                colWidth = Math.max(colWidth, item[0].offsetWidth);
	                            });
	                            col.container.css({ width: (colWidth + 2) + 'px' });
	                        }
	                        col.container.addClass('picker-items-col-absolute');
	                    }
	                };
	                col.calcSize();
	                col.wrapper.transform('translate3d(0,' + maxTranslate + 'px,0)').transition(0);
	                var activeIndex = 0;
	                var animationFrameId;
	                // Set Value Function
	                col.setValue = function (newValue, transition, valueCallbacks) {
	                    if (typeof transition === 'undefined')
	                        transition = '';
	                    var newActiveIndex = col.wrapper.find('.picker-item[data-picker-value="' + newValue + '"]').index();
	                    if (typeof newActiveIndex === 'undefined' || newActiveIndex === -1) {
	                        return;
	                    }
	                    var newTranslate = -newActiveIndex * itemHeight + maxTranslate;
	                    // Update wrapper
	                    col.wrapper.transition(transition);
	                    col.wrapper.transform('translate3d(0,' + (newTranslate) + 'px,0)');
	                    // Watch items
	                    if (p.params.updateValuesOnMomentum && col.activeIndex && col.activeIndex !== newActiveIndex) {
	                        $.cancelAnimationFrame(animationFrameId);
	                        col.wrapper.transitionEnd(function () {
	                            $.cancelAnimationFrame(animationFrameId);
	                        });
	                        updateDuringScroll();
	                    }
	                    // Update items
	                    col.updateItems(newActiveIndex, newTranslate, transition, valueCallbacks);
	                };
	                col.updateItems = function (activeIndex, translate, transition, valueCallbacks) {
	                    if (typeof translate === 'undefined') {
	                        translate = $.getTranslate(col.wrapper[0], 'y');
	                    }
	                    if (typeof activeIndex === 'undefined')
	                        activeIndex = -Math.round((translate - maxTranslate) / itemHeight);
	                    if (activeIndex < 0)
	                        activeIndex = 0;
	                    if (activeIndex >= col.items.length)
	                        activeIndex = col.items.length - 1;
	                    var previousActiveIndex = col.activeIndex;
	                    col.activeIndex = activeIndex;
	                    col.wrapper.find('.picker-selected').removeClass('picker-selected');
	                    col.items.transition(transition);
	                    var selectedItem = col.items.eq(activeIndex).addClass('picker-selected').transform('');
	                    // Set 3D rotate effect
	                    if (p.params.rotateEffect) {
	                        var percentage = (translate - (Math.floor((translate - maxTranslate) / itemHeight) * itemHeight + maxTranslate)) / itemHeight;
	                        col.items.each(function () {
	                            var item = $(this);
	                            var itemOffsetTop = item.index() * itemHeight;
	                            var translateOffset = maxTranslate - translate;
	                            var itemOffset = itemOffsetTop - translateOffset;
	                            var percentage = itemOffset / itemHeight;
	                            var itemsFit = Math.ceil(col.height / itemHeight / 2) + 1;
	                            var angle = (-18 * percentage);
	                            if (angle > 180)
	                                angle = 180;
	                            if (angle < -180)
	                                angle = -180;
	                            // Far class
	                            if (Math.abs(percentage) > itemsFit)
	                                item.addClass('picker-item-far');
	                            else
	                                item.removeClass('picker-item-far');
	                            // Set transform
	                            item.transform('translate3d(0, ' + (-translate + maxTranslate) + 'px, ' + (originBug ? -110 : 0) + 'px) rotateX(' + angle + 'deg)');
	                        });
	                    }
	                    if (valueCallbacks || typeof valueCallbacks === 'undefined') {
	                        // Update values
	                        col.value = selectedItem.attr('data-picker-value');
	                        col.displayValue = col.displayValues ? col.displayValues[activeIndex] : col.value;
	                        // On change callback
	                        if (previousActiveIndex !== activeIndex) {
	                            if (col.onChange) {
	                                col.onChange(p, col.value, col.displayValue);
	                            }
	                            p.updateValue();
	                        }
	                    }
	                };
	                function updateDuringScroll() {
	                    animationFrameId = $.requestAnimationFrame(function () {
	                        col.updateItems(undefined, undefined, 0);
	                        updateDuringScroll();
	                    });
	                }
	                // Update items on init
	                if (updateItems)
	                    col.updateItems(0, maxTranslate, 0);
	                var allowItemClick = true;
	                var isTouched, isMoved, touchStartY, touchCurrentY, touchStartTime, touchEndTime, startTranslate, returnTo, currentTranslate, prevTranslate, velocityTranslate, velocityTime;
	                function handleTouchStart(e) {
	                    if (isMoved || isTouched)
	                        return;
	                    e.preventDefault();
	                    isTouched = true;
	                    touchStartY = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                    touchStartTime = (new Date()).getTime();
	                    allowItemClick = true;
	                    startTranslate = currentTranslate = $.getTranslate(col.wrapper[0], 'y');
	                }
	                function handleTouchMove(e) {
	                    if (!isTouched)
	                        return;
	                    e.preventDefault();
	                    allowItemClick = false;
	                    touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                    if (!isMoved) {
	                        // First move
	                        $.cancelAnimationFrame(animationFrameId);
	                        isMoved = true;
	                        startTranslate = currentTranslate = $.getTranslate(col.wrapper[0], 'y');
	                        col.wrapper.transition(0);
	                    }
	                    var diff = touchCurrentY - touchStartY;
	                    currentTranslate = startTranslate + diff;
	                    returnTo = undefined;
	                    // Normalize translate
	                    if (currentTranslate < minTranslate) {
	                        currentTranslate = minTranslate - Math.pow(minTranslate - currentTranslate, 0.8);
	                        returnTo = 'min';
	                    }
	                    if (currentTranslate > maxTranslate) {
	                        currentTranslate = maxTranslate + Math.pow(currentTranslate - maxTranslate, 0.8);
	                        returnTo = 'max';
	                    }
	                    // Transform wrapper
	                    col.wrapper.transform('translate3d(0,' + currentTranslate + 'px,0)');
	                    // Update items
	                    col.updateItems(undefined, currentTranslate, 0, p.params.updateValuesOnTouchmove);
	                    // Calc velocity
	                    velocityTranslate = currentTranslate - prevTranslate || currentTranslate;
	                    velocityTime = (new Date()).getTime();
	                    prevTranslate = currentTranslate;
	                }
	                function handleTouchEnd(e) {
	                    if (!isTouched || !isMoved) {
	                        isTouched = isMoved = false;
	                        return;
	                    }
	                    isTouched = isMoved = false;
	                    col.wrapper.transition('');
	                    if (returnTo) {
	                        if (returnTo === 'min') {
	                            col.wrapper.transform('translate3d(0,' + minTranslate + 'px,0)');
	                        }
	                        else
	                            col.wrapper.transform('translate3d(0,' + maxTranslate + 'px,0)');
	                    }
	                    touchEndTime = new Date().getTime();
	                    var velocity, newTranslate;
	                    if (touchEndTime - touchStartTime > 300) {
	                        newTranslate = currentTranslate;
	                    }
	                    else {
	                        velocity = Math.abs(velocityTranslate / (touchEndTime - velocityTime));
	                        newTranslate = currentTranslate + velocityTranslate * p.params.momentumRatio;
	                    }
	                    newTranslate = Math.max(Math.min(newTranslate, maxTranslate), minTranslate);
	                    // Active Index
	                    var activeIndex = -Math.floor((newTranslate - maxTranslate) / itemHeight);
	                    // Normalize translate
	                    if (!p.params.freeMode)
	                        newTranslate = -activeIndex * itemHeight + maxTranslate;
	                    // Transform wrapper
	                    col.wrapper.transform('translate3d(0,' + (parseInt(newTranslate, 10)) + 'px,0)');
	                    // Update items
	                    col.updateItems(activeIndex, newTranslate, '', true);
	                    // Watch items
	                    if (p.params.updateValuesOnMomentum) {
	                        updateDuringScroll();
	                        col.wrapper.transitionEnd(function () {
	                            $.cancelAnimationFrame(animationFrameId);
	                        });
	                    }
	                    // Allow click
	                    setTimeout(function () {
	                        allowItemClick = true;
	                    }, 100);
	                }
	                function handleClick(e) {
	                    if (!allowItemClick)
	                        return;
	                    $.cancelAnimationFrame(animationFrameId);
	                    /*jshint validthis:true */
	                    var value = $(this).attr('data-picker-value');
	                    col.setValue(value);
	                }
	                col.initEvents = function (detach) {
	                    var method = detach ? 'off' : 'on';
	                    var activeListener = app.support.passiveListener ? { passive: false, capture: false } : false;
	                    col.container[method](app.touchEvents.start, handleTouchStart, activeListener);
	                    col.container[method](app.touchEvents.move, handleTouchMove, activeListener);
	                    col.container[method](app.touchEvents.end, handleTouchEnd, activeListener);
	                    col.items[method]('click', handleClick);
	                };
	                col.destroyEvents = function () {
	                    col.initEvents(true);
	                };
	                col.container[0].f7DestroyPickerCol = function () {
	                    col.destroyEvents();
	                };
	                col.initEvents();
	            };
	            p.destroyPickerCol = function (colContainer) {
	                colContainer = $(colContainer);
	                if ('f7DestroyPickerCol' in colContainer[0])
	                    colContainer[0].f7DestroyPickerCol();
	            };
	            // Resize cols
	            function resizeCols() {
	                if (!p.opened)
	                    return;
	                for (var i = 0; i < p.cols.length; i++) {
	                    if (!p.cols[i].divider) {
	                        p.cols[i].calcSize();
	                        p.cols[i].setValue(p.cols[i].value, 0, false);
	                    }
	                }
	            }
	            app.onResize(resizeCols);
	            // HTML Layout
	            p.columnHTML = function (col, onlyItems) {
	                var columnItemsHTML = '';
	                var columnHTML = '';
	                if (col.divider) {
	                    columnHTML += '<div class="picker-items-col picker-items-col-divider ' + (col.textAlign ? 'picker-items-col-' + col.textAlign : '') + ' ' + (col.cssClass || '') + '">' + col.content + '</div>';
	                }
	                else {
	                    for (var j = 0; j < col.values.length; j++) {
	                        columnItemsHTML += '<div class="picker-item" data-picker-value="' + col.values[j] + '"><span>' + (col.displayValues ? col.displayValues[j] : col.values[j]) + '</span></div>';
	                    }
	                    columnHTML += '<div class="picker-items-col ' + (col.textAlign ? 'picker-items-col-' + col.textAlign : '') + ' ' + (col.cssClass || '') + '"><div class="picker-items-col-wrapper">' + columnItemsHTML + '</div></div>';
	                }
	                return onlyItems ? columnItemsHTML : columnHTML;
	            };
	            p.layout = function () {
	                var pickerHTML = '';
	                var pickerClass = '';
	                var i;
	                p.cols = [];
	                var colsHTML = '';
	                for (i = 0; i < p.params.cols.length; i++) {
	                    var col = p.params.cols[i];
	                    colsHTML += p.columnHTML(p.params.cols[i]);
	                    p.cols.push(col);
	                }
	                pickerClass = 'picker-modal picker-columns ' + (p.params.cssClass || '') + (p.params.rotateEffect ? ' picker-3d' : '');
	                pickerHTML =
	                    '<div class="' + (pickerClass) + '">' +
	                        (p.params.toolbar ? p.params.toolbarTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '') +
	                        '<div class="picker-modal-inner picker-items">' +
	                        colsHTML +
	                        '<div class="picker-center-highlight"></div>' +
	                        '</div>' +
	                        '</div>';
	                p.pickerHTML = pickerHTML;
	            };
	            // Input Events
	            function openOnInput(e) {
	                e.preventDefault();
	                if (p.opened)
	                    return;
	                p.open();
	                if (p.params.scrollToInput && !isPopover()) {
	                    var pageContent = p.input.parents('.page-content');
	                    if (pageContent.length === 0)
	                        return;
	                    var paddingTop = parseInt(pageContent.css('padding-top'), 10), paddingBottom = parseInt(pageContent.css('padding-bottom'), 10), pageHeight = pageContent[0].offsetHeight - paddingTop - p.container.height(), pageScrollHeight = pageContent[0].scrollHeight - paddingTop - p.container.height(), newPaddingBottom;
	                    var inputTop = p.input.offset().top - paddingTop + p.input[0].offsetHeight;
	                    if (inputTop > pageHeight) {
	                        var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
	                        if (scrollTop + pageHeight > pageScrollHeight) {
	                            newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
	                            if (pageHeight === pageScrollHeight) {
	                                newPaddingBottom = p.container.height();
	                            }
	                            pageContent.css({ 'padding-bottom': (newPaddingBottom) + 'px' });
	                        }
	                        pageContent.scrollTop(scrollTop, 300);
	                    }
	                }
	            }
	            function closeOnHTMLClick(e) {
	                if (inPopover())
	                    return;
	                if (p.input && p.input.length > 0) {
	                    if (e.target !== p.input[0] && $(e.target).parents('.picker-modal').length === 0)
	                        p.close();
	                }
	                else {
	                    if ($(e.target).parents('.picker-modal').length === 0)
	                        p.close();
	                }
	            }
	            if (p.params.input) {
	                p.input = $(p.params.input);
	                if (p.input.length > 0) {
	                    if (p.params.inputReadOnly)
	                        p.input.prop('readOnly', true);
	                    if (!p.inline) {
	                        p.input.on('click', openOnInput);
	                    }
	                    if (p.params.inputReadOnly) {
	                        p.input.on('focus mousedown', function (e) {
	                            e.preventDefault();
	                        });
	                    }
	                }
	            }
	            if (!p.inline && p.params.closeByOutsideClick)
	                $('html').on('click', closeOnHTMLClick);
	            // Open
	            function onPickerClose() {
	                p.opened = false;
	                if (p.input && p.input.length > 0) {
	                    p.input.parents('.page-content').css({ 'padding-bottom': '' });
	                    if (app.params.material)
	                        p.input.trigger('blur');
	                }
	                if (p.params.onClose)
	                    p.params.onClose(p);
	                // Destroy events
	                p.container.find('.picker-items-col').each(function () {
	                    p.destroyPickerCol(this);
	                });
	            }
	            p.opened = false;
	            p.open = function () {
	                var toPopover = isPopover();
	                if (!p.opened) {
	                    // Layout
	                    p.layout();
	                    // Append
	                    if (toPopover) {
	                        p.pickerHTML = '<div class="popover popover-picker-columns"><div class="popover-inner">' + p.pickerHTML + '</div></div>';
	                        p.popover = app.popover(p.pickerHTML, p.params.input, true);
	                        p.container = $(p.popover).find('.picker-modal');
	                        $(p.popover).on('popover:close', function () {
	                            onPickerClose();
	                        });
	                    }
	                    else if (p.inline) {
	                        p.container = $(p.pickerHTML);
	                        p.container.addClass('picker-modal-inline');
	                        $(p.params.container).append(p.container);
	                    }
	                    else {
	                        p.container = $(app.pickerModal(p.pickerHTML));
	                        $(p.container)
	                            .on('picker:close', function () {
	                            onPickerClose();
	                        });
	                    }
	                    // Store picker instance
	                    p.container[0].f7Picker = p;
	                    // Init Events
	                    p.container.find('.picker-items-col').each(function () {
	                        var updateItems = true;
	                        if ((!p.initialized && p.params.value) || (p.initialized && p.value))
	                            updateItems = false;
	                        p.initPickerCol(this, updateItems);
	                    });
	                    // Set value
	                    if (!p.initialized) {
	                        if (p.value)
	                            p.setValue(p.value, 0);
	                        else if (p.params.value) {
	                            p.setValue(p.params.value, 0);
	                        }
	                    }
	                    else {
	                        if (p.value)
	                            p.setValue(p.value, 0);
	                    }
	                    // Material Focus
	                    if (p.input && p.input.length > 0 && app.params.material) {
	                        p.input.trigger('focus');
	                    }
	                }
	                // Set flag
	                p.opened = true;
	                p.initialized = true;
	                if (p.params.onOpen)
	                    p.params.onOpen(p);
	            };
	            // Close
	            p.close = function () {
	                if (!p.opened || p.inline)
	                    return;
	                if (inPopover()) {
	                    app.closeModal(p.popover);
	                    return;
	                }
	                else {
	                    app.closeModal(p.container);
	                    return;
	                }
	            };
	            // Destroy
	            p.destroy = function () {
	                p.close();
	                if (p.params.input && p.input.length > 0) {
	                    p.input.off('click focus', openOnInput);
	                }
	                $('html').off('click', closeOnHTMLClick);
	                app.offResize(resizeCols);
	            };
	            if (p.inline) {
	                p.open();
	            }
	            else {
	                if (!p.initialized && p.params.value)
	                    p.setValue(p.params.value);
	            }
	            return p;
	        };
	        app.picker = function (params) {
	            return new Picker(params);
	        };
	        /*======================================================
	        ************   Calendar   ************
	        ======================================================*/
	        var Calendar = function (params) {
	            var p = this;
	            var defaults = {
	                monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	                monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	                dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
	                dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	                firstDay: 1,
	                weekendDays: [0, 6],
	                multiple: false,
	                rangePicker: false,
	                dateFormat: 'yyyy-mm-dd',
	                direction: 'horizontal',
	                minDate: null,
	                maxDate: null,
	                disabled: null,
	                events: null,
	                rangesClasses: null,
	                touchMove: true,
	                animate: true,
	                closeOnSelect: false,
	                monthPicker: true,
	                monthPickerTemplate: '<div class="picker-calendar-month-picker">' +
	                    '<a href="#" class="link icon-only picker-calendar-prev-month"><i class="icon icon-prev"></i></a>' +
	                    '<span class="current-month-value"></span>' +
	                    '<a href="#" class="link icon-only picker-calendar-next-month"><i class="icon icon-next"></i></a>' +
	                    '</div>',
	                yearPicker: true,
	                yearPickerTemplate: '<div class="picker-calendar-year-picker">' +
	                    '<a href="#" class="link icon-only picker-calendar-prev-year"><i class="icon icon-prev"></i></a>' +
	                    '<span class="current-year-value"></span>' +
	                    '<a href="#" class="link icon-only picker-calendar-next-year"><i class="icon icon-next"></i></a>' +
	                    '</div>',
	                weekHeader: true,
	                // Common settings
	                closeByOutsideClick: true,
	                scrollToInput: true,
	                inputReadOnly: true,
	                convertToPopover: true,
	                onlyInPopover: false,
	                toolbar: true,
	                toolbarCloseText: 'Done',
	                headerPlaceholder: 'Select date',
	                header: app.params.material,
	                footer: app.params.material,
	                toolbarTemplate: '<div class="toolbar">' +
	                    '<div class="toolbar-inner">' +
	                    '{{monthPicker}}' +
	                    '{{yearPicker}}' +
	                    '</div>' +
	                    '</div>',
	                headerTemplate: '<div class="picker-header">' +
	                    '<div class="picker-calendar-selected-date">{{placeholder}}</div>' +
	                    '</div>',
	                footerTemplate: '<div class="picker-footer">' +
	                    '<a href="#" class="button close-picker">{{closeText}}</a>' +
	                    '</div>',
	            };
	            params = params || {};
	            for (var def in defaults) {
	                if (typeof params[def] === 'undefined') {
	                    params[def] = defaults[def];
	                }
	            }
	            p.params = params;
	            p.initialized = false;
	            // Inline flag
	            p.inline = p.params.container ? true : false;
	            // Is horizontal
	            p.isH = p.params.direction === 'horizontal';
	            // RTL inverter
	            var inverter = p.isH ? (app.rtl ? -1 : 1) : 1;
	            // Animating flag
	            p.animating = false;
	            // Should be converted to popover
	            function isPopover() {
	                var toPopover = false;
	                if (!p.params.convertToPopover && !p.params.onlyInPopover)
	                    return toPopover;
	                if (!p.inline && p.params.input) {
	                    if (p.params.onlyInPopover)
	                        toPopover = true;
	                    else {
	                        if (app.device.ios) {
	                            toPopover = app.device.ipad ? true : false;
	                        }
	                        else {
	                            if (app.width >= 768)
	                                toPopover = true;
	                        }
	                    }
	                }
	                return toPopover;
	            }
	            function inPopover() {
	                if (p.opened && p.container && p.container.length > 0 && p.container.parents('.popover').length > 0)
	                    return true;
	                else
	                    return false;
	            }
	            // Format date
	            function formatDate(date) {
	                date = new Date(date);
	                var year = date.getFullYear();
	                var month = date.getMonth();
	                var month1 = month + 1;
	                var day = date.getDate();
	                var weekDay = date.getDay();
	                return p.params.dateFormat
	                    .replace(/yyyy/g, year)
	                    .replace(/yy/g, (year + '').substring(2))
	                    .replace(/mm/g, month1 < 10 ? '0' + month1 : month1)
	                    .replace(/m(\W+)/g, month1 + '$1')
	                    .replace(/MM/g, p.params.monthNames[month])
	                    .replace(/M(\W+)/g, p.params.monthNamesShort[month] + '$1')
	                    .replace(/dd/g, day < 10 ? '0' + day : day)
	                    .replace(/d(\W+)/g, day + '$1')
	                    .replace(/DD/g, p.params.dayNames[weekDay])
	                    .replace(/D(\W+)/g, p.params.dayNamesShort[weekDay] + '$1');
	            }
	            // Value
	            p.addValue = function (value) {
	                if (p.params.multiple) {
	                    if (!p.value)
	                        p.value = [];
	                    var inValuesIndex;
	                    for (var i = 0; i < p.value.length; i++) {
	                        if (new Date(value).getTime() === new Date(p.value[i]).getTime()) {
	                            inValuesIndex = i;
	                        }
	                    }
	                    if (typeof inValuesIndex === 'undefined') {
	                        p.value.push(value);
	                    }
	                    else {
	                        p.value.splice(inValuesIndex, 1);
	                    }
	                    p.updateValue();
	                }
	                else if (p.params.rangePicker) {
	                    if (!p.value)
	                        p.value = [];
	                    if (p.value.length === 2 || p.value.length === 0) {
	                        p.value = [];
	                    }
	                    if (p.value[0] !== value)
	                        p.value.push(value);
	                    else
	                        p.value = [];
	                    p.value.sort(function (a, b) {
	                        return a - b;
	                    });
	                    p.updateValue();
	                }
	                else {
	                    p.value = [value];
	                    p.updateValue();
	                }
	            };
	            p.setValue = function (arrValues) {
	                p.value = arrValues;
	                p.updateValue();
	            };
	            p.updateValue = function (onlyHeader) {
	                var i, inputValue;
	                if (p.container && p.container.length > 0) {
	                    p.wrapper.find('.picker-calendar-day-selected').removeClass('picker-calendar-day-selected');
	                    var valueDate;
	                    if (p.params.rangePicker && p.value.length === 2) {
	                        for (i = new Date(p.value[0]).getTime(); i <= new Date(p.value[1]).getTime(); i += 24 * 60 * 60 * 1000) {
	                            valueDate = new Date(i);
	                            p.wrapper.find('.picker-calendar-day[data-date="' + valueDate.getFullYear() + '-' + valueDate.getMonth() + '-' + valueDate.getDate() + '"]').addClass('picker-calendar-day-selected');
	                        }
	                    }
	                    else {
	                        for (i = 0; i < p.value.length; i++) {
	                            valueDate = new Date(p.value[i]);
	                            p.wrapper.find('.picker-calendar-day[data-date="' + valueDate.getFullYear() + '-' + valueDate.getMonth() + '-' + valueDate.getDate() + '"]').addClass('picker-calendar-day-selected');
	                        }
	                    }
	                }
	                if (p.params.onChange) {
	                    p.params.onChange(p, p.value);
	                }
	                if ((p.input && p.input.length > 0) || (app.params.material && p.params.header)) {
	                    if (p.params.formatValue)
	                        inputValue = p.params.formatValue(p, p.value);
	                    else {
	                        inputValue = [];
	                        for (i = 0; i < p.value.length; i++) {
	                            inputValue.push(formatDate(p.value[i]));
	                        }
	                        inputValue = inputValue.join(p.params.rangePicker ? ' - ' : ', ');
	                    }
	                    if (app.params.material && p.params.header && p.container && p.container.length > 0) {
	                        p.container.find('.picker-calendar-selected-date').text(inputValue);
	                    }
	                    if (p.input && p.input.length > 0 && !onlyHeader) {
	                        $(p.input).val(inputValue);
	                        $(p.input).trigger('change');
	                    }
	                }
	            };
	            // Columns Handlers
	            p.initCalendarEvents = function () {
	                var col;
	                var allowItemClick = true;
	                var isTouched, isMoved, touchStartX, touchStartY, touchCurrentX, touchCurrentY, touchStartTime, touchEndTime, startTranslate, currentTranslate, wrapperWidth, wrapperHeight, percentage, touchesDiff, isScrolling;
	                function handleTouchStart(e) {
	                    if (isMoved || isTouched)
	                        return;
	                    // e.preventDefault();
	                    isTouched = true;
	                    touchStartX = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                    touchStartY = touchCurrentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	                    touchStartTime = (new Date()).getTime();
	                    percentage = 0;
	                    allowItemClick = true;
	                    isScrolling = undefined;
	                    startTranslate = currentTranslate = p.monthsTranslate;
	                }
	                function handleTouchMove(e) {
	                    if (!isTouched)
	                        return;
	                    touchCurrentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                    touchCurrentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                    if (typeof isScrolling === 'undefined') {
	                        isScrolling = !!(isScrolling || Math.abs(touchCurrentY - touchStartY) > Math.abs(touchCurrentX - touchStartX));
	                    }
	                    if (p.isH && isScrolling) {
	                        isTouched = false;
	                        return;
	                    }
	                    e.preventDefault();
	                    if (p.animating) {
	                        isTouched = false;
	                        return;
	                    }
	                    allowItemClick = false;
	                    if (!isMoved) {
	                        // First move
	                        isMoved = true;
	                        wrapperWidth = p.wrapper[0].offsetWidth;
	                        wrapperHeight = p.wrapper[0].offsetHeight;
	                        p.wrapper.transition(0);
	                    }
	                    touchesDiff = p.isH ? touchCurrentX - touchStartX : touchCurrentY - touchStartY;
	                    percentage = touchesDiff / (p.isH ? wrapperWidth : wrapperHeight);
	                    currentTranslate = (p.monthsTranslate * inverter + percentage) * 100;
	                    // Transform wrapper
	                    p.wrapper.transform('translate3d(' + (p.isH ? currentTranslate : 0) + '%, ' + (p.isH ? 0 : currentTranslate) + '%, 0)');
	                }
	                function handleTouchEnd(e) {
	                    if (!isTouched || !isMoved) {
	                        isTouched = isMoved = false;
	                        return;
	                    }
	                    isTouched = isMoved = false;
	                    touchEndTime = new Date().getTime();
	                    if (touchEndTime - touchStartTime < 300) {
	                        if (Math.abs(touchesDiff) < 10) {
	                            p.resetMonth();
	                        }
	                        else if (touchesDiff >= 10) {
	                            if (app.rtl)
	                                p.nextMonth();
	                            else
	                                p.prevMonth();
	                        }
	                        else {
	                            if (app.rtl)
	                                p.prevMonth();
	                            else
	                                p.nextMonth();
	                        }
	                    }
	                    else {
	                        if (percentage <= -0.5) {
	                            if (app.rtl)
	                                p.prevMonth();
	                            else
	                                p.nextMonth();
	                        }
	                        else if (percentage >= 0.5) {
	                            if (app.rtl)
	                                p.nextMonth();
	                            else
	                                p.prevMonth();
	                        }
	                        else {
	                            p.resetMonth();
	                        }
	                    }
	                    // Allow click
	                    setTimeout(function () {
	                        allowItemClick = true;
	                    }, 100);
	                }
	                function handleDayClick(e) {
	                    if (!allowItemClick)
	                        return;
	                    var day = $(e.target).parents('.picker-calendar-day');
	                    if (day.length === 0 && $(e.target).hasClass('picker-calendar-day')) {
	                        day = $(e.target);
	                    }
	                    if (day.length === 0)
	                        return;
	                    if (day.hasClass('picker-calendar-day-disabled'))
	                        return;
	                    if (!p.params.rangePicker) {
	                        if (day.hasClass('picker-calendar-day-next'))
	                            p.nextMonth();
	                        if (day.hasClass('picker-calendar-day-prev'))
	                            p.prevMonth();
	                    }
	                    var dateYear = day.attr('data-year');
	                    var dateMonth = day.attr('data-month');
	                    var dateDay = day.attr('data-day');
	                    if (p.params.onDayClick) {
	                        p.params.onDayClick(p, day[0], dateYear, dateMonth, dateDay);
	                    }
	                    if (!day.hasClass('picker-calendar-day-selected') || p.params.multiple || p.params.rangePicker) {
	                        p.addValue(new Date(dateYear, dateMonth, dateDay, 0, 0, 0));
	                    }
	                    if (p.params.closeOnSelect) {
	                        if (p.params.rangePicker && p.value.length === 2 || !p.params.rangePicker)
	                            p.close();
	                    }
	                }
	                p.container.find('.picker-calendar-prev-month').on('click', p.prevMonth);
	                p.container.find('.picker-calendar-next-month').on('click', p.nextMonth);
	                p.container.find('.picker-calendar-prev-year').on('click', p.prevYear);
	                p.container.find('.picker-calendar-next-year').on('click', p.nextYear);
	                p.wrapper.on('click', handleDayClick);
	                var passiveListener = app.touchEvents.start === 'touchstart' && app.support.passiveListener ? { passive: true, capture: false } : false;
	                var activeListener = app.support.passiveListener ? { passive: false, capture: false } : false;
	                if (p.params.touchMove) {
	                    p.wrapper.on(app.touchEvents.start, handleTouchStart, passiveListener);
	                    p.wrapper.on(app.touchEvents.move, handleTouchMove, activeListener);
	                    p.wrapper.on(app.touchEvents.end, handleTouchEnd, passiveListener);
	                }
	                p.container[0].f7DestroyCalendarEvents = function () {
	                    p.container.find('.picker-calendar-prev-month').off('click', p.prevMonth);
	                    p.container.find('.picker-calendar-next-month').off('click', p.nextMonth);
	                    p.container.find('.picker-calendar-prev-year').off('click', p.prevYear);
	                    p.container.find('.picker-calendar-next-year').off('click', p.nextYear);
	                    p.wrapper.off('click', handleDayClick);
	                    if (p.params.touchMove) {
	                        p.wrapper.off(app.touchEvents.start, handleTouchStart, passiveListener);
	                        p.wrapper.off(app.touchEvents.move, handleTouchMove, activeListener);
	                        p.wrapper.off(app.touchEvents.end, handleTouchEnd, passiveListener);
	                    }
	                };
	            };
	            p.destroyCalendarEvents = function (colContainer) {
	                if ('f7DestroyCalendarEvents' in p.container[0])
	                    p.container[0].f7DestroyCalendarEvents();
	            };
	            // Scan Dates Range
	            p.dateInRange = function (dayDate, range) {
	                var match = false;
	                var i;
	                if (!range)
	                    return false;
	                if (Array.isArray(range)) {
	                    for (i = 0; i < range.length; i++) {
	                        if (range[i].from || range[i].to) {
	                            if (range[i].from && range[i].to) {
	                                if ((dayDate <= new Date(range[i].to).getTime()) && (dayDate >= new Date(range[i].from).getTime())) {
	                                    match = true;
	                                }
	                            }
	                            else if (range[i].from) {
	                                if (dayDate >= new Date(range[i].from).getTime()) {
	                                    match = true;
	                                }
	                            }
	                            else if (range[i].to) {
	                                if (dayDate <= new Date(range[i].to).getTime()) {
	                                    match = true;
	                                }
	                            }
	                        }
	                        else if (dayDate === new Date(range[i]).getTime()) {
	                            match = true;
	                        }
	                    }
	                }
	                else if (range.from || range.to) {
	                    if (range.from && range.to) {
	                        if ((dayDate <= new Date(range.to).getTime()) && (dayDate >= new Date(range.from).getTime())) {
	                            match = true;
	                        }
	                    }
	                    else if (range.from) {
	                        if (dayDate >= new Date(range.from).getTime()) {
	                            match = true;
	                        }
	                    }
	                    else if (range.to) {
	                        if (dayDate <= new Date(range.to).getTime()) {
	                            match = true;
	                        }
	                    }
	                }
	                else if (typeof range === 'function') {
	                    match = range(new Date(dayDate));
	                }
	                return match;
	            };
	            // Calendar Methods
	            p.daysInMonth = function (date) {
	                var d = new Date(date);
	                return new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
	            };
	            p.monthHTML = function (date, offset) {
	                date = new Date(date);
	                var year = date.getFullYear(), month = date.getMonth(), day = date.getDate();
	                if (offset === 'next') {
	                    if (month === 11)
	                        date = new Date(year + 1, 0);
	                    else
	                        date = new Date(year, month + 1, 1);
	                }
	                if (offset === 'prev') {
	                    if (month === 0)
	                        date = new Date(year - 1, 11);
	                    else
	                        date = new Date(year, month - 1, 1);
	                }
	                if (offset === 'next' || offset === 'prev') {
	                    month = date.getMonth();
	                    year = date.getFullYear();
	                }
	                var daysInPrevMonth = p.daysInMonth(new Date(date.getFullYear(), date.getMonth()).getTime() - 10 * 24 * 60 * 60 * 1000), daysInMonth = p.daysInMonth(date), firstDayOfMonthIndex = new Date(date.getFullYear(), date.getMonth()).getDay();
	                if (firstDayOfMonthIndex === 0)
	                    firstDayOfMonthIndex = 7;
	                var dayDate, currentValues = [], i, j, k, rows = 6, cols = 7, monthHTML = '', dayIndex = 0 + (p.params.firstDay - 1), today = new Date().setHours(0, 0, 0, 0), minDate = p.params.minDate ? new Date(p.params.minDate).getTime() : null, maxDate = p.params.maxDate ? new Date(p.params.maxDate).getTime() : null, disabled, hasEvent;
	                if (p.value && p.value.length) {
	                    for (i = 0; i < p.value.length; i++) {
	                        currentValues.push(new Date(p.value[i]).setHours(0, 0, 0, 0));
	                    }
	                }
	                for (i = 1; i <= rows; i++) {
	                    var rowHTML = '';
	                    var row = i;
	                    for (j = 1; j <= cols; j++) {
	                        var col = j;
	                        dayIndex++;
	                        var dayNumber = dayIndex - firstDayOfMonthIndex;
	                        var weekDayIndex = (col - 1 + p.params.firstDay > 6) ? (col - 1 - 7 + p.params.firstDay) : (col - 1 + p.params.firstDay);
	                        var addClass = '';
	                        if (dayNumber < 0) {
	                            dayNumber = daysInPrevMonth + dayNumber + 1;
	                            addClass += ' picker-calendar-day-prev';
	                            dayDate = new Date(month - 1 < 0 ? year - 1 : year, month - 1 < 0 ? 11 : month - 1, dayNumber).getTime();
	                        }
	                        else {
	                            dayNumber = dayNumber + 1;
	                            if (dayNumber > daysInMonth) {
	                                dayNumber = dayNumber - daysInMonth;
	                                addClass += ' picker-calendar-day-next';
	                                dayDate = new Date(month + 1 > 11 ? year + 1 : year, month + 1 > 11 ? 0 : month + 1, dayNumber).getTime();
	                            }
	                            else {
	                                dayDate = new Date(year, month, dayNumber).getTime();
	                            }
	                        }
	                        // Today
	                        if (dayDate === today)
	                            addClass += ' picker-calendar-day-today';
	                        // Selected
	                        if (p.params.rangePicker && currentValues.length === 2) {
	                            if (dayDate >= currentValues[0] && dayDate <= currentValues[1])
	                                addClass += ' picker-calendar-day-selected';
	                        }
	                        else {
	                            if (currentValues.indexOf(dayDate) >= 0)
	                                addClass += ' picker-calendar-day-selected';
	                        }
	                        // Weekend
	                        if (p.params.weekendDays.indexOf(weekDayIndex) >= 0) {
	                            addClass += ' picker-calendar-day-weekend';
	                        }
	                        // Has Events
	                        hasEvent = false;
	                        if (p.params.events) {
	                            if (p.dateInRange(dayDate, p.params.events)) {
	                                hasEvent = true;
	                            }
	                        }
	                        if (hasEvent) {
	                            addClass += ' picker-calendar-day-has-events';
	                        }
	                        // Custom Ranges
	                        if (p.params.rangesClasses) {
	                            for (k = 0; k < p.params.rangesClasses.length; k++) {
	                                if (p.dateInRange(dayDate, p.params.rangesClasses[k].range)) {
	                                    addClass += ' ' + p.params.rangesClasses[k].cssClass;
	                                }
	                            }
	                        }
	                        // Disabled
	                        disabled = false;
	                        if ((minDate && dayDate < minDate) || (maxDate && dayDate > maxDate)) {
	                            disabled = true;
	                        }
	                        if (p.params.disabled) {
	                            if (p.dateInRange(dayDate, p.params.disabled)) {
	                                disabled = true;
	                            }
	                        }
	                        if (disabled) {
	                            addClass += ' picker-calendar-day-disabled';
	                        }
	                        dayDate = new Date(dayDate);
	                        var dayYear = dayDate.getFullYear();
	                        var dayMonth = dayDate.getMonth();
	                        rowHTML += '<div data-year="' + dayYear + '" data-month="' + dayMonth + '" data-day="' + dayNumber + '" class="picker-calendar-day' + (addClass) + '" data-date="' + (dayYear + '-' + dayMonth + '-' + dayNumber) + '"><span>' + dayNumber + '</span></div>';
	                    }
	                    monthHTML += '<div class="picker-calendar-row">' + rowHTML + '</div>';
	                }
	                monthHTML = '<div class="picker-calendar-month" data-year="' + year + '" data-month="' + month + '">' + monthHTML + '</div>';
	                return monthHTML;
	            };
	            p.animating = false;
	            p.updateCurrentMonthYear = function (dir) {
	                if (typeof dir === 'undefined') {
	                    p.currentMonth = parseInt(p.months.eq(1).attr('data-month'), 10);
	                    p.currentYear = parseInt(p.months.eq(1).attr('data-year'), 10);
	                }
	                else {
	                    p.currentMonth = parseInt(p.months.eq(dir === 'next' ? (p.months.length - 1) : 0).attr('data-month'), 10);
	                    p.currentYear = parseInt(p.months.eq(dir === 'next' ? (p.months.length - 1) : 0).attr('data-year'), 10);
	                }
	                p.container.find('.current-month-value').text(p.params.monthNames[p.currentMonth]);
	                p.container.find('.current-year-value').text(p.currentYear);
	            };
	            p.onMonthChangeStart = function (dir) {
	                p.updateCurrentMonthYear(dir);
	                p.months.removeClass('picker-calendar-month-current picker-calendar-month-prev picker-calendar-month-next');
	                var currentIndex = dir === 'next' ? p.months.length - 1 : 0;
	                p.months.eq(currentIndex).addClass('picker-calendar-month-current');
	                p.months.eq(dir === 'next' ? currentIndex - 1 : currentIndex + 1).addClass(dir === 'next' ? 'picker-calendar-month-prev' : 'picker-calendar-month-next');
	                if (p.params.onMonthYearChangeStart) {
	                    p.params.onMonthYearChangeStart(p, p.currentYear, p.currentMonth);
	                }
	            };
	            p.onMonthChangeEnd = function (dir, rebuildBoth) {
	                p.animating = false;
	                var nextMonthHTML, prevMonthHTML, newMonthHTML;
	                p.wrapper.find('.picker-calendar-month:not(.picker-calendar-month-prev):not(.picker-calendar-month-current):not(.picker-calendar-month-next)').remove();
	                if (typeof dir === 'undefined') {
	                    dir = 'next';
	                    rebuildBoth = true;
	                }
	                if (!rebuildBoth) {
	                    newMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), dir);
	                }
	                else {
	                    p.wrapper.find('.picker-calendar-month-next, .picker-calendar-month-prev').remove();
	                    prevMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), 'prev');
	                    nextMonthHTML = p.monthHTML(new Date(p.currentYear, p.currentMonth), 'next');
	                }
	                if (dir === 'next' || rebuildBoth) {
	                    p.wrapper.append(newMonthHTML || nextMonthHTML);
	                }
	                if (dir === 'prev' || rebuildBoth) {
	                    p.wrapper.prepend(newMonthHTML || prevMonthHTML);
	                }
	                p.months = p.wrapper.find('.picker-calendar-month');
	                p.setMonthsTranslate(p.monthsTranslate);
	                if (p.params.onMonthAdd) {
	                    p.params.onMonthAdd(p, dir === 'next' ? p.months.eq(p.months.length - 1)[0] : p.months.eq(0)[0]);
	                }
	                if (p.params.onMonthYearChangeEnd) {
	                    p.params.onMonthYearChangeEnd(p, p.currentYear, p.currentMonth);
	                }
	            };
	            p.setMonthsTranslate = function (translate) {
	                translate = translate || p.monthsTranslate || 0;
	                if (typeof p.monthsTranslate === 'undefined')
	                    p.monthsTranslate = translate;
	                p.months.removeClass('picker-calendar-month-current picker-calendar-month-prev picker-calendar-month-next');
	                var prevMonthTranslate = -(translate + 1) * 100 * inverter;
	                var currentMonthTranslate = -translate * 100 * inverter;
	                var nextMonthTranslate = -(translate - 1) * 100 * inverter;
	                p.months.eq(0).transform('translate3d(' + (p.isH ? prevMonthTranslate : 0) + '%, ' + (p.isH ? 0 : prevMonthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
	                p.months.eq(1).transform('translate3d(' + (p.isH ? currentMonthTranslate : 0) + '%, ' + (p.isH ? 0 : currentMonthTranslate) + '%, 0)').addClass('picker-calendar-month-current');
	                p.months.eq(2).transform('translate3d(' + (p.isH ? nextMonthTranslate : 0) + '%, ' + (p.isH ? 0 : nextMonthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
	            };
	            p.nextMonth = function (transition) {
	                if (typeof transition === 'undefined' || typeof transition === 'object') {
	                    transition = '';
	                    if (!p.params.animate)
	                        transition = 0;
	                }
	                var nextMonth = parseInt(p.months.eq(p.months.length - 1).attr('data-month'), 10);
	                var nextYear = parseInt(p.months.eq(p.months.length - 1).attr('data-year'), 10);
	                var nextDate = new Date(nextYear, nextMonth);
	                var nextDateTime = nextDate.getTime();
	                var transitionEndCallback = p.animating ? false : true;
	                if (p.params.maxDate) {
	                    if (nextDateTime > new Date(p.params.maxDate).getTime()) {
	                        return p.resetMonth();
	                    }
	                }
	                p.monthsTranslate--;
	                if (nextMonth === p.currentMonth) {
	                    var nextMonthTranslate = -(p.monthsTranslate) * 100 * inverter;
	                    var nextMonthHTML = $(p.monthHTML(nextDateTime, 'next')).transform('translate3d(' + (p.isH ? nextMonthTranslate : 0) + '%, ' + (p.isH ? 0 : nextMonthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
	                    p.wrapper.append(nextMonthHTML[0]);
	                    p.months = p.wrapper.find('.picker-calendar-month');
	                    if (p.params.onMonthAdd) {
	                        p.params.onMonthAdd(p, p.months.eq(p.months.length - 1)[0]);
	                    }
	                }
	                p.animating = true;
	                p.onMonthChangeStart('next');
	                var translate = (p.monthsTranslate * 100) * inverter;
	                p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
	                if (transitionEndCallback) {
	                    p.wrapper.transitionEnd(function () {
	                        p.onMonthChangeEnd('next');
	                    });
	                }
	                if (!p.params.animate) {
	                    p.onMonthChangeEnd('next');
	                }
	            };
	            p.prevMonth = function (transition) {
	                if (typeof transition === 'undefined' || typeof transition === 'object') {
	                    transition = '';
	                    if (!p.params.animate)
	                        transition = 0;
	                }
	                var prevMonth = parseInt(p.months.eq(0).attr('data-month'), 10);
	                var prevYear = parseInt(p.months.eq(0).attr('data-year'), 10);
	                var prevDate = new Date(prevYear, prevMonth + 1, -1);
	                var prevDateTime = prevDate.getTime();
	                var transitionEndCallback = p.animating ? false : true;
	                if (p.params.minDate) {
	                    if (prevDateTime < new Date(p.params.minDate).getTime()) {
	                        return p.resetMonth();
	                    }
	                }
	                p.monthsTranslate++;
	                if (prevMonth === p.currentMonth) {
	                    var prevMonthTranslate = -(p.monthsTranslate) * 100 * inverter;
	                    var prevMonthHTML = $(p.monthHTML(prevDateTime, 'prev')).transform('translate3d(' + (p.isH ? prevMonthTranslate : 0) + '%, ' + (p.isH ? 0 : prevMonthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
	                    p.wrapper.prepend(prevMonthHTML[0]);
	                    p.months = p.wrapper.find('.picker-calendar-month');
	                    if (p.params.onMonthAdd) {
	                        p.params.onMonthAdd(p, p.months.eq(0)[0]);
	                    }
	                }
	                p.animating = true;
	                p.onMonthChangeStart('prev');
	                var translate = (p.monthsTranslate * 100) * inverter;
	                p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
	                if (transitionEndCallback) {
	                    p.wrapper.transitionEnd(function () {
	                        p.onMonthChangeEnd('prev');
	                    });
	                }
	                if (!p.params.animate) {
	                    p.onMonthChangeEnd('prev');
	                }
	            };
	            p.resetMonth = function (transition) {
	                if (typeof transition === 'undefined')
	                    transition = '';
	                var translate = (p.monthsTranslate * 100) * inverter;
	                p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? translate : 0) + '%, ' + (p.isH ? 0 : translate) + '%, 0)');
	            };
	            p.setYearMonth = function (year, month, transition) {
	                if (typeof year === 'undefined')
	                    year = p.currentYear;
	                if (typeof month === 'undefined')
	                    month = p.currentMonth;
	                if (typeof transition === 'undefined' || typeof transition === 'object') {
	                    transition = '';
	                    if (!p.params.animate)
	                        transition = 0;
	                }
	                var targetDate;
	                if (year < p.currentYear) {
	                    targetDate = new Date(year, month + 1, -1).getTime();
	                }
	                else {
	                    targetDate = new Date(year, month).getTime();
	                }
	                if (p.params.maxDate && targetDate > new Date(p.params.maxDate).getTime()) {
	                    return false;
	                }
	                if (p.params.minDate && targetDate < new Date(p.params.minDate).getTime()) {
	                    return false;
	                }
	                var currentDate = new Date(p.currentYear, p.currentMonth).getTime();
	                var dir = targetDate > currentDate ? 'next' : 'prev';
	                var newMonthHTML = p.monthHTML(new Date(year, month));
	                p.monthsTranslate = p.monthsTranslate || 0;
	                var prevTranslate = p.monthsTranslate;
	                var monthTranslate, wrapperTranslate;
	                var transitionEndCallback = p.animating ? false : true;
	                if (targetDate > currentDate) {
	                    // To next
	                    p.monthsTranslate--;
	                    if (!p.animating)
	                        p.months.eq(p.months.length - 1).remove();
	                    p.wrapper.append(newMonthHTML);
	                    p.months = p.wrapper.find('.picker-calendar-month');
	                    monthTranslate = -(prevTranslate - 1) * 100 * inverter;
	                    p.months.eq(p.months.length - 1).transform('translate3d(' + (p.isH ? monthTranslate : 0) + '%, ' + (p.isH ? 0 : monthTranslate) + '%, 0)').addClass('picker-calendar-month-next');
	                }
	                else {
	                    // To prev
	                    p.monthsTranslate++;
	                    if (!p.animating)
	                        p.months.eq(0).remove();
	                    p.wrapper.prepend(newMonthHTML);
	                    p.months = p.wrapper.find('.picker-calendar-month');
	                    monthTranslate = -(prevTranslate + 1) * 100 * inverter;
	                    p.months.eq(0).transform('translate3d(' + (p.isH ? monthTranslate : 0) + '%, ' + (p.isH ? 0 : monthTranslate) + '%, 0)').addClass('picker-calendar-month-prev');
	                }
	                if (p.params.onMonthAdd) {
	                    p.params.onMonthAdd(p, dir === 'next' ? p.months.eq(p.months.length - 1)[0] : p.months.eq(0)[0]);
	                }
	                p.animating = true;
	                p.onMonthChangeStart(dir);
	                wrapperTranslate = (p.monthsTranslate * 100) * inverter;
	                p.wrapper.transition(transition).transform('translate3d(' + (p.isH ? wrapperTranslate : 0) + '%, ' + (p.isH ? 0 : wrapperTranslate) + '%, 0)');
	                if (transitionEndCallback) {
	                    p.wrapper.transitionEnd(function () {
	                        p.onMonthChangeEnd(dir, true);
	                    });
	                }
	                if (!p.params.animate) {
	                    p.onMonthChangeEnd(dir);
	                }
	            };
	            p.nextYear = function () {
	                p.setYearMonth(p.currentYear + 1);
	            };
	            p.prevYear = function () {
	                p.setYearMonth(p.currentYear - 1);
	            };
	            // HTML Layout
	            p.layout = function () {
	                var pickerHTML = '';
	                var pickerClass = '';
	                var i;
	                var layoutDate = p.value && p.value.length ? p.value[0] : new Date().setHours(0, 0, 0, 0);
	                var prevMonthHTML = p.monthHTML(layoutDate, 'prev');
	                var currentMonthHTML = p.monthHTML(layoutDate);
	                var nextMonthHTML = p.monthHTML(layoutDate, 'next');
	                var monthsHTML = '<div class="picker-calendar-months"><div class="picker-calendar-months-wrapper">' + (prevMonthHTML + currentMonthHTML + nextMonthHTML) + '</div></div>';
	                // Week days header
	                var weekHeaderHTML = '';
	                if (p.params.weekHeader) {
	                    for (i = 0; i < 7; i++) {
	                        var weekDayIndex = (i + p.params.firstDay > 6) ? (i - 7 + p.params.firstDay) : (i + p.params.firstDay);
	                        var dayName = p.params.dayNamesShort[weekDayIndex];
	                        weekHeaderHTML += '<div class="picker-calendar-week-day ' + ((p.params.weekendDays.indexOf(weekDayIndex) >= 0) ? 'picker-calendar-week-day-weekend' : '') + '"> ' + dayName + '</div>';
	                    }
	                    weekHeaderHTML = '<div class="picker-calendar-week-days">' + weekHeaderHTML + '</div>';
	                }
	                pickerClass = 'picker-modal picker-calendar' +
	                    (p.params.rangePicker ? ' picker-calendar-range' : '') +
	                    (p.params.cssClass ? ' ' + p.params.cssClass : '');
	                var toolbarHTML = p.params.toolbar ? p.params.toolbarTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '';
	                if (p.params.toolbar) {
	                    toolbarHTML = p.params.toolbarTemplate
	                        .replace(/{{closeText}}/g, p.params.toolbarCloseText)
	                        .replace(/{{monthPicker}}/g, (p.params.monthPicker ? p.params.monthPickerTemplate : ''))
	                        .replace(/{{yearPicker}}/g, (p.params.yearPicker ? p.params.yearPickerTemplate : ''));
	                }
	                var headerHTML = p.params.header ? p.params.headerTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText).replace(/{{placeholder}}/g, p.params.headerPlaceholder) : '';
	                var footerHTML = p.params.footer ? p.params.footerTemplate.replace(/{{closeText}}/g, p.params.toolbarCloseText) : '';
	                pickerHTML =
	                    '<div class="' + (pickerClass) + '">' +
	                        headerHTML +
	                        footerHTML +
	                        toolbarHTML +
	                        '<div class="picker-modal-inner">' +
	                        weekHeaderHTML +
	                        monthsHTML +
	                        '</div>' +
	                        '</div>';
	                p.pickerHTML = pickerHTML;
	            };
	            // Input Events
	            function openOnInput(e) {
	                e.preventDefault();
	                if (p.opened)
	                    return;
	                p.open();
	                if (p.params.scrollToInput && !isPopover() && !app.params.material) {
	                    var pageContent = p.input.parents('.page-content');
	                    if (pageContent.length === 0)
	                        return;
	                    var paddingTop = parseInt(pageContent.css('padding-top'), 10), paddingBottom = parseInt(pageContent.css('padding-bottom'), 10), pageHeight = pageContent[0].offsetHeight - paddingTop - p.container.height(), pageScrollHeight = pageContent[0].scrollHeight - paddingTop - p.container.height(), newPaddingBottom;
	                    var inputTop = p.input.offset().top - paddingTop + p.input[0].offsetHeight;
	                    if (inputTop > pageHeight) {
	                        var scrollTop = pageContent.scrollTop() + inputTop - pageHeight;
	                        if (scrollTop + pageHeight > pageScrollHeight) {
	                            newPaddingBottom = scrollTop + pageHeight - pageScrollHeight + paddingBottom;
	                            if (pageHeight === pageScrollHeight) {
	                                newPaddingBottom = p.container.height();
	                            }
	                            pageContent.css({ 'padding-bottom': (newPaddingBottom) + 'px' });
	                        }
	                        pageContent.scrollTop(scrollTop, 300);
	                    }
	                }
	            }
	            function closeOnHTMLClick(e) {
	                if (inPopover())
	                    return;
	                if (p.input && p.input.length > 0) {
	                    if (e.target !== p.input[0] && $(e.target).parents('.picker-modal').length === 0)
	                        p.close();
	                }
	                else {
	                    if ($(e.target).parents('.picker-modal').length === 0)
	                        p.close();
	                }
	            }
	            if (p.params.input) {
	                p.input = $(p.params.input);
	                if (p.input.length > 0) {
	                    if (p.params.inputReadOnly)
	                        p.input.prop('readOnly', true);
	                    if (!p.inline) {
	                        p.input.on('click', openOnInput);
	                    }
	                    if (p.params.inputReadOnly) {
	                        p.input.on('focus mousedown', function (e) {
	                            e.preventDefault();
	                        });
	                    }
	                }
	            }
	            if (!p.inline && p.params.closeByOutsideClick)
	                $('html').on('click', closeOnHTMLClick);
	            // Open
	            function onPickerClose() {
	                p.opened = false;
	                if (p.input && p.input.length > 0) {
	                    p.input.parents('.page-content').css({ 'padding-bottom': '' });
	                    if (app.params.material)
	                        p.input.trigger('blur');
	                }
	                if (p.params.onClose)
	                    p.params.onClose(p);
	                // Destroy events
	                p.destroyCalendarEvents();
	            }
	            p.opened = false;
	            p.open = function () {
	                var toPopover = isPopover();
	                var updateValue = false;
	                if (!p.opened) {
	                    // Set date value
	                    if (!p.value) {
	                        if (p.params.value) {
	                            p.value = p.params.value;
	                            updateValue = true;
	                        }
	                    }
	                    // Layout
	                    p.layout();
	                    // Append
	                    if (toPopover) {
	                        p.pickerHTML = '<div class="popover popover-picker-calendar"><div class="popover-inner">' + p.pickerHTML + '</div></div>';
	                        p.popover = app.popover(p.pickerHTML, p.params.input, true);
	                        p.container = $(p.popover).find('.picker-modal');
	                        $(p.popover).on('popover:close', function () {
	                            onPickerClose();
	                        });
	                    }
	                    else if (p.inline) {
	                        p.container = $(p.pickerHTML);
	                        p.container.addClass('picker-modal-inline');
	                        $(p.params.container).append(p.container);
	                    }
	                    else {
	                        p.container = $(app.pickerModal(p.pickerHTML));
	                        $(p.container)
	                            .on('picker:close', function () {
	                            onPickerClose();
	                        });
	                    }
	                    // Store calendar instance
	                    p.container[0].f7Calendar = p;
	                    p.wrapper = p.container.find('.picker-calendar-months-wrapper');
	                    // Months
	                    p.months = p.wrapper.find('.picker-calendar-month');
	                    // Update current month and year
	                    p.updateCurrentMonthYear();
	                    // Set initial translate
	                    p.monthsTranslate = 0;
	                    p.setMonthsTranslate();
	                    // Init events
	                    p.initCalendarEvents();
	                    // Update input value
	                    if (updateValue)
	                        p.updateValue();
	                    else if (app.params.material && p.value)
	                        p.updateValue(true);
	                    // Material Focus
	                    if (p.input && p.input.length > 0 && app.params.material) {
	                        p.input.trigger('focus');
	                    }
	                }
	                // Set flag
	                p.opened = true;
	                p.initialized = true;
	                if (p.params.onMonthAdd) {
	                    p.months.each(function () {
	                        p.params.onMonthAdd(p, this);
	                    });
	                }
	                if (p.params.onOpen)
	                    p.params.onOpen(p);
	            };
	            // Close
	            p.close = function () {
	                if (!p.opened || p.inline)
	                    return;
	                if (inPopover()) {
	                    app.closeModal(p.popover);
	                    return;
	                }
	                else {
	                    app.closeModal(p.container);
	                    return;
	                }
	            };
	            // Destroy
	            p.destroy = function () {
	                p.close();
	                if (p.params.input && p.input.length > 0) {
	                    p.input.off('click focus', openOnInput);
	                }
	                $('html').off('click', closeOnHTMLClick);
	            };
	            if (p.inline) {
	                p.open();
	            }
	            else {
	                if (!p.initialized && p.params.value)
	                    p.setValue(p.params.value);
	            }
	            return p;
	        };
	        app.calendar = function (params) {
	            return new Calendar(params);
	        };
	        /*======================================================
	        ************   Notifications   ************
	        ======================================================*/
	        var _tempNotificationElement;
	        app.addNotification = function (params) {
	            if (!params)
	                return;
	            if (typeof params.media === 'undefined')
	                params.media = app.params.notificationMedia;
	            if (typeof params.title === 'undefined')
	                params.title = app.params.notificationTitle;
	            if (typeof params.subtitle === 'undefined')
	                params.subtitle = app.params.notificationSubtitle;
	            if (typeof params.closeIcon === 'undefined')
	                params.closeIcon = app.params.notificationCloseIcon;
	            if (typeof params.hold === 'undefined')
	                params.hold = app.params.notificationHold;
	            if (typeof params.closeOnClick === 'undefined')
	                params.closeOnClick = app.params.notificationCloseOnClick;
	            if (typeof params.button === 'undefined')
	                params.button = app.params.notificationCloseButtonText && {
	                    text: app.params.notificationCloseButtonText,
	                    close: true
	                };
	            if (!_tempNotificationElement)
	                _tempNotificationElement = document.createElement('div');
	            params.material = app.params.material;
	            var container = $('.notifications');
	            if (container.length === 0) {
	                app.root.append('<div class="notifications list-block' + (params.material ? '' : ' media-list') + '"><ul></ul></div>');
	                container = $('.notifications');
	            }
	            var list = container.children('ul');
	            var notificationTemplate = app.params.notificationTemplate ||
	                '{{#if custom}}' +
	                    '<li>{{custom}}</li>' +
	                    '{{else}}' +
	                    '<li class="notification-item notification-hidden">' +
	                    '<div class="item-content">' +
	                    '{{#if material}}' +
	                    '<div class="item-inner">' +
	                    '<div class="item-title">{{js "this.message || this.title || this.subtitle"}}</div>' +
	                    '{{#if ../button}}{{#button}}' +
	                    '<div class="item-after">' +
	                    '<a href="#" class="button {{#if color}}color-{{color}}{{/if}} {{#js_compare "this.close !== false"}}close-notification{{/js_compare}}">{{text}}</a>' +
	                    '</div>' +
	                    '{{/button}}{{/if}}' +
	                    '</div>' +
	                    '{{else}}' +
	                    '{{#if media}}' +
	                    '<div class="item-media">{{media}}</div>' +
	                    '{{/if}}' +
	                    '<div class="item-inner">' +
	                    '<div class="item-title-row">' +
	                    '{{#if title}}' +
	                    '<div class="item-title">{{title}}</div>' +
	                    '{{/if}}' +
	                    '{{#if closeIcon}}' +
	                    '<div class="item-after"><a href="#" class="close-notification"><span></span></a></div>' +
	                    '{{/if}}' +
	                    '</div>' +
	                    '{{#if subtitle}}' +
	                    '<div class="item-subtitle">{{subtitle}}</div>' +
	                    '{{/if}}' +
	                    '{{#if message}}' +
	                    '<div class="item-text">{{message}}</div>' +
	                    '</div>' +
	                    '{{/if}}' +
	                    '{{/if}}' +
	                    '</div>' +
	                    '</li>' +
	                    '{{/if}}';
	            if (!app._compiledTemplates.notification) {
	                app._compiledTemplates.notification = t7.compile(notificationTemplate);
	            }
	            _tempNotificationElement.innerHTML = app._compiledTemplates.notification(params);
	            var item = $(_tempNotificationElement).children();
	            item.on('click', function (e) {
	                var close = false;
	                var target = $(e.target);
	                if (params.material && target.hasClass('button')) {
	                    if (params.button && params.button.onClick)
	                        params.button.onClick.call(target[0], e, item[0]);
	                }
	                if (target.is('.close-notification') || $(e.target).parents('.close-notification').length > 0) {
	                    close = true;
	                }
	                else {
	                    if (params.onClick)
	                        params.onClick(e, item[0]);
	                    if (params.closeOnClick)
	                        close = true;
	                }
	                if (close)
	                    app.closeNotification(item[0], e);
	            });
	            if (params.onClose) {
	                item.data('f7NotificationOnClose', function (e) {
	                    params.onClose(item[0], e);
	                });
	            }
	            if (params.additionalClass) {
	                item.addClass(params.additionalClass);
	            }
	            if (params.hold) {
	                setTimeout(function () {
	                    if (item.length > 0)
	                        app.closeNotification(item[0]);
	                }, params.hold);
	            }
	            if (!app.params.material) {
	                app.closeNotification(list.children('li.notification-item:last-child'));
	            }
	            list.append(item[0]);
	            container.show();
	            var itemHeight = item.outerHeight(), clientLeft;
	            if (params.material) {
	                container.transform('translate3d(0, ' + itemHeight + 'px, 0)');
	                container.transition(0);
	                clientLeft = item[0].clientLeft;
	                container.transform('translate3d(0, 0, 0)');
	                container.transition('');
	            }
	            else {
	                item.transform('translate3d(0,' + (-itemHeight) + 'px,0)');
	                item.transition(0);
	                clientLeft = item[0].clientLeft;
	                item.transition('');
	                item.transform('translate3d(0,0px,0)');
	            }
	            container.transform('translate3d(0, 0,0)');
	            item.removeClass('notification-hidden');
	            return item[0];
	        };
	        app.closeNotification = function (item, event) {
	            item = $(item);
	            if (item.length === 0)
	                return;
	            if (item.hasClass('notification-item-removing'))
	                return;
	            var container = $('.notifications');
	            var itemHeight = item.outerHeight();
	            item.css('height', itemHeight + 'px').transition(0).addClass('notification-item-removing');
	            var clientLeft = item[0].clientLeft;
	            item.css({
	                height: '0px',
	                marginBottom: '0px'
	            }).transition('');
	            if (item.data('f7NotificationOnClose'))
	                item.data('f7NotificationOnClose')(event);
	            if (container.find('.notification-item:not(.notification-item-removing)').length === 0) {
	                container.transform('');
	            }
	            item.addClass('notification-hidden').transitionEnd(function () {
	                item.remove();
	                if (container.find('.notification-item').length === 0) {
	                    container.hide();
	                }
	            });
	        };
	        /*===============================================================================
	        ************   Data Table   ************
	        ===============================================================================*/
	        app.initDataTable = function (table) {
	            table = $(table);
	            var tableHeader = table.find('.data-table-header');
	            var tableHeaderSelected = table.find('.data-table-header-selected');
	            // Handle selected
	            function checkSelectedHeader() {
	                if (tableHeader.length > 0 && tableHeaderSelected.length > 0) {
	                    var checkedItems = table.find('tbody .checkbox-cell input:checked').length;
	                    table[checkedItems > 0 ? 'addClass' : 'removeClass']('data-table-has-checked');
	                    tableHeaderSelected.find('.data-table-selected-count').text(checkedItems);
	                }
	            }
	            function toggleRowSelected(index, el, checked) {
	                // Select the row if the checkbox is the first column
	                if (index === 0) {
	                    el[checked ? 'addClass' : 'removeClass']('data-table-row-selected');
	                }
	            }
	            table.on('change', '.checkbox-cell input[type="checkbox"]', function (e) {
	                if (e.detail && e.detail._sentByF7DataTable) {
	                    // Scripted event, don't do anything
	                    return;
	                }
	                var input = $(this);
	                var checked = input[0].checked;
	                var headerCell = input.parents('th');
	                var columnIndex = input.parents('td,th').index();
	                // If header checkbox exists
	                if (headerCell.length > 0) {
	                    toggleRowSelected(columnIndex, table.find('tbody tr'), checked);
	                    table.find('tbody tr td:nth-child(' + (columnIndex + 1) + ') input').prop('checked', checked).trigger('change', { _sentByF7DataTable: true });
	                }
	                else {
	                    toggleRowSelected(columnIndex, input.parents('tr'), checked);
	                    if (!checked) {
	                        table.find('thead .checkbox-cell:nth-child(' + (columnIndex + 1) + ') input[type="checkbox"]').prop('checked', false);
	                    }
	                    else {
	                        // Check for all checked
	                        if (table.find('tbody .checkbox-cell:nth-child(' + (columnIndex + 1) + ') input[type="checkbox"]:checked').length === table.find('tbody tr').length) {
	                            table.find('thead .checkbox-cell:nth-child(' + (columnIndex + 1) + ') input[type="checkbox"]').prop('checked', true).trigger('change', { _sentByF7DataTable: true });
	                        }
	                    }
	                }
	                checkSelectedHeader();
	            });
	            checkSelectedHeader();
	            // Sortable
	            table.find('thead .sortable-cell').on('click', function () {
	                var cell = $(this);
	                var isActive = cell.hasClass('sortable-active');
	                var currentSort;
	                if (isActive) {
	                    currentSort = cell.hasClass('sortable-desc') ? 'desc' : 'asc';
	                    cell.removeClass('sortable-desc sortable-asc').addClass('sortable-' + (currentSort === 'desc' ? 'asc' : 'desc'));
	                }
	                else {
	                    table.find('thead .sortable-active').removeClass('sortable-active');
	                    cell.addClass('sortable-active');
	                }
	            });
	            // Collapsible
	            if (table.hasClass('data-table-collapsible')) {
	                table.find('tbody td:not(.checkbox-cell)').each(function () {
	                    var index = $(this).index();
	                    var collpsibleTitle = $(this).attr('data-collapsible-title');
	                    if (!collpsibleTitle && collpsibleTitle !== '') {
	                        $(this).attr('data-collapsible-title', table.find('thead th').eq(index).text());
	                    }
	                });
	            }
	        };
	        app.initPageDataTables = function (pageContainer) {
	            pageContainer = $(pageContainer);
	            var dataTables = pageContainer.find('.data-table-init');
	            if (dataTables.length === 0 && pageContainer.hasClass('data-table-init')) {
	                dataTables = pageContainer;
	            }
	            dataTables.each(function () {
	                app.initDataTable(this);
	            });
	        };
	        /*===========================
	        Compile Template7 Templates On App Init
	        ===========================*/
	        app.initTemplate7Templates = function () {
	            if (!window.Template7)
	                return;
	            Template7.templates = Template7.templates || app.params.templates || {};
	            Template7.data = Template7.data || app.params.template7Data || {};
	            Template7.cache = Template7.cache || {};
	            app.templates = Template7.templates;
	            app.template7Data = Template7.data;
	            app.template7Cache = Template7.cache;
	            // Precompile templates on app init
	            if (!app.params.precompileTemplates)
	                return;
	            $('script[type="text/template7"]').each(function () {
	                var id = $(this).attr('id');
	                if (!id)
	                    return;
	                Template7.templates[id] = Template7.compile($(this).html());
	            });
	        };
	        /*=======================================
	        ************   Plugins API   ************
	        =======================================*/
	        var _plugins = [];
	        app.initPlugins = function () {
	            // Initialize plugins
	            for (var plugin in app.plugins) {
	                var p = app.plugins[plugin](app, app.params[plugin]);
	                if (p)
	                    _plugins.push(p);
	            }
	        };
	        // Plugin Hooks
	        app.pluginHook = function (hook) {
	            for (var i = 0; i < _plugins.length; i++) {
	                if (_plugins[i].hooks && hook in _plugins[i].hooks) {
	                    _plugins[i].hooks[hook](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	                }
	            }
	        };
	        // Prevented by plugin
	        app.pluginPrevent = function (action) {
	            var prevent = false;
	            for (var i = 0; i < _plugins.length; i++) {
	                if (_plugins[i].prevents && action in _plugins[i].prevents) {
	                    if (_plugins[i].prevents[action](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]))
	                        prevent = true;
	                }
	            }
	            return prevent;
	        };
	        // Preprocess content by plugin
	        app.pluginProcess = function (process, data) {
	            var processed = data;
	            for (var i = 0; i < _plugins.length; i++) {
	                if (_plugins[i].preprocess && process in _plugins[i].preprocess) {
	                    processed = _plugins[i].preprocess[process](data, arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
	                }
	            }
	            return processed;
	        };
	        /*======================================================
	        ************   App Init   ************
	        ======================================================*/
	        app.init = function () {
	            // Compile Template7 templates on app load
	            if (app.initTemplate7Templates)
	                app.initTemplate7Templates();
	            // Init Plugins
	            if (app.initPlugins)
	                app.initPlugins();
	            // Init Device
	            if (app.getDeviceInfo)
	                app.getDeviceInfo();
	            // Init resize events and calc app sizes
	            if (app.initResize)
	                app.initResize();
	            // Init Panels Breakpoints
	            if (app.initPanelsBreakpoints && (app.params.panelLeftBreakpoint || app.params.panelRightBreakpoint))
	                app.initPanelsBreakpoints();
	            // Init Click events
	            if (app.initFastClicks && app.params.fastClicks)
	                app.initFastClicks();
	            if (app.initClickEvents)
	                app.initClickEvents();
	            // Init each page callbacks
	            $('.page:not(.cached)').each(function () {
	                app.initPageWithCallback(this);
	            });
	            // Init each navbar callbacks
	            $('.navbar:not(.cached)').each(function () {
	                app.initNavbarWithCallback(this);
	            });
	            // Init push state
	            if (app.initPushState && app.params.pushState)
	                app.initPushState();
	            // Init Live Swipeouts events
	            if (app.initSwipeout && app.params.swipeout)
	                app.initSwipeout();
	            // Init Live Sortable events
	            if (app.initSortable && app.params.sortable)
	                app.initSortable();
	            // Init Live Swipe Panels
	            if (app.initSwipePanels && (app.params.swipePanel || app.params.swipePanelOnlyClose))
	                app.initSwipePanels();
	            // Init Material Inputs
	            if (app.params.material && app.initMaterialWatchInputs)
	                app.initMaterialWatchInputs();
	            // Init Material Tabbar
	            if (app.params.material) {
	                $('.tabbar').each(function (index, el) {
	                    if ($(el).parents('.page').length === 0) {
	                        app.initMaterialTabbar(el);
	                    }
	                });
	            }
	            // App Init callback
	            if (app.params.onAppInit)
	                app.params.onAppInit();
	            // Plugin app init hook
	            app.pluginHook('appInit');
	        };
	        if (app.params.init)
	            app.init();
	        //Return instance
	        return app;
	    };
	    // Save Dom7
	    Framework7.$ = window.Dom7;
	    /*===========================
	    Features Support Detection
	    ===========================*/
	    Framework7.prototype.support = (function () {
	        var support = {
	            touch: !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch),
	            passiveListener: (function () {
	                var supportsPassive = false;
	                try {
	                    var opts = Object.defineProperty({}, 'passive', {
	                        get: function () {
	                            supportsPassive = true;
	                        }
	                    });
	                    window.addEventListener('testPassiveListener', null, opts);
	                }
	                catch (e) { }
	                return supportsPassive;
	            })()
	        };
	        // Export object
	        return support;
	    })();
	    /*===========================
	    Device/OS Detection
	    ===========================*/
	    Framework7.prototype.device = (function () {
	        var device = {};
	        var ua = navigator.userAgent;
	        var $ = Dom7;
	        var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/);
	        var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	        var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	        var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	        var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	        device.ios = device.android = device.windows = device.iphone = device.ipod = device.ipad = device.androidChrome = false;
	        // Windows
	        if (windows) {
	            device.os = 'windows';
	            device.osVersion = windows[2];
	            device.windows = true;
	        }
	        // Android
	        if (android && !windows) {
	            device.os = 'android';
	            device.osVersion = android[2];
	            device.android = true;
	            device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
	        }
	        if (ipad || iphone || ipod) {
	            device.os = 'ios';
	            device.ios = true;
	        }
	        // iOS
	        if (iphone && !ipod) {
	            device.osVersion = iphone[2].replace(/_/g, '.');
	            device.iphone = true;
	        }
	        if (ipad) {
	            device.osVersion = ipad[2].replace(/_/g, '.');
	            device.ipad = true;
	        }
	        if (ipod) {
	            device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	            device.iphone = true;
	        }
	        // iOS 8+ changed UA
	        if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
	            if (device.osVersion.split('.')[0] === '10') {
	                device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
	            }
	        }
	        // Webview
	        device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);
	        // Minimal UI
	        if (device.os && device.os === 'ios') {
	            var osVersionArr = device.osVersion.split('.');
	            device.minimalUi = !device.webView &&
	                (ipod || iphone) &&
	                (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) &&
	                $('meta[name="viewport"]').length > 0 && $('meta[name="viewport"]').attr('content').indexOf('minimal-ui') >= 0;
	        }
	        // Check for status bar and fullscreen app mode
	        var windowWidth = $(window).width();
	        var windowHeight = $(window).height();
	        device.needsStatusBar = function () {
	            if (device.webView && (windowWidth * windowHeight === screen.width * screen.height)) {
	                return true;
	            }
	            return false;
	        };
	        device.statusBar = device.needsStatusBar();
	        // Classes
	        var classNames = [];
	        // Pixel Ratio
	        device.pixelRatio = window.devicePixelRatio || 1;
	        classNames.push('pixel-ratio-' + Math.floor(device.pixelRatio));
	        if (device.pixelRatio >= 2) {
	            classNames.push('retina');
	        }
	        // OS classes
	        if (device.os) {
	            classNames.push(device.os, device.os + '-' + device.osVersion.split('.')[0], device.os + '-' + device.osVersion.replace(/\./g, '-'));
	            if (device.os === 'ios') {
	                var major = parseInt(device.osVersion.split('.')[0], 10);
	                for (var i = major - 1; i >= 6; i--) {
	                    classNames.push('ios-gt-' + i);
	                }
	            }
	        }
	        // Status bar classes
	        if (device.statusBar) {
	            classNames.push('with-statusbar-overlay');
	        }
	        else {
	            $('html').removeClass('with-statusbar-overlay');
	        }
	        // Add html classes
	        if (classNames.length > 0)
	            $('html').addClass(classNames.join(' '));
	        // Export object
	        return device;
	    })();
	    /*===========================
	    Plugins prototype
	    ===========================*/
	    Framework7.prototype.plugins = {};
	    /*===========================
	    Swiper
	    ===========================*/
	    window.Swiper = function (container, params) {
	        if (!(this instanceof Swiper))
	            return new Swiper(container, params);
	        var defaults = {
	            direction: 'horizontal',
	            touchEventsTarget: 'container',
	            initialSlide: 0,
	            speed: 300,
	            // autoplay
	            autoplay: false,
	            autoplayDisableOnInteraction: true,
	            autoplayStopOnLast: false,
	            // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
	            iOSEdgeSwipeDetection: false,
	            iOSEdgeSwipeThreshold: 20,
	            // Free mode
	            freeMode: false,
	            freeModeMomentum: true,
	            freeModeMomentumRatio: 1,
	            freeModeMomentumBounce: true,
	            freeModeMomentumBounceRatio: 1,
	            freeModeMomentumVelocityRatio: 1,
	            freeModeSticky: false,
	            freeModeMinimumVelocity: 0.02,
	            // Autoheight
	            autoHeight: false,
	            // Set wrapper width
	            setWrapperSize: false,
	            // Virtual Translate
	            virtualTranslate: false,
	            // Effects
	            effect: 'slide',
	            coverflow: {
	                rotate: 50,
	                stretch: 0,
	                depth: 100,
	                modifier: 1,
	                slideShadows: true
	            },
	            flip: {
	                slideShadows: true,
	                limitRotation: true
	            },
	            cube: {
	                slideShadows: true,
	                shadow: true,
	                shadowOffset: 20,
	                shadowScale: 0.94
	            },
	            fade: {
	                crossFade: false
	            },
	            // Parallax
	            parallax: false,
	            // Zoom
	            zoom: false,
	            zoomMax: 3,
	            zoomMin: 1,
	            zoomToggle: true,
	            // Scrollbar
	            scrollbar: null,
	            scrollbarHide: true,
	            scrollbarDraggable: false,
	            scrollbarSnapOnRelease: false,
	            // Keyboard Mousewheel
	            keyboardControl: false,
	            mousewheelControl: false,
	            mousewheelReleaseOnEdges: false,
	            mousewheelInvert: false,
	            mousewheelForceToAxis: false,
	            mousewheelSensitivity: 1,
	            mousewheelEventsTarged: 'container',
	            // Hash Navigation
	            hashnav: false,
	            hashnavWatchState: false,
	            // History
	            history: false,
	            // Commong Nav State
	            replaceState: false,
	            // Breakpoints
	            breakpoints: undefined,
	            // Slides grid
	            spaceBetween: 0,
	            slidesPerView: 1,
	            slidesPerColumn: 1,
	            slidesPerColumnFill: 'column',
	            slidesPerGroup: 1,
	            centeredSlides: false,
	            slidesOffsetBefore: 0,
	            slidesOffsetAfter: 0,
	            // Round length
	            roundLengths: false,
	            // Touches
	            touchRatio: 1,
	            touchAngle: 45,
	            simulateTouch: true,
	            shortSwipes: true,
	            longSwipes: true,
	            longSwipesRatio: 0.5,
	            longSwipesMs: 300,
	            followFinger: true,
	            onlyExternal: false,
	            threshold: 0,
	            touchMoveStopPropagation: true,
	            touchReleaseOnEdges: false,
	            // Unique Navigation Elements
	            uniqueNavElements: true,
	            // Pagination
	            pagination: null,
	            paginationElement: 'span',
	            paginationClickable: false,
	            paginationHide: false,
	            paginationBulletRender: null,
	            paginationProgressRender: null,
	            paginationFractionRender: null,
	            paginationCustomRender: null,
	            paginationType: 'bullets',
	            // Resistance
	            resistance: true,
	            resistanceRatio: 0.85,
	            // Next/prev buttons
	            nextButton: null,
	            prevButton: null,
	            // Progress
	            watchSlidesProgress: false,
	            watchSlidesVisibility: false,
	            // Cursor
	            grabCursor: false,
	            // Clicks
	            preventClicks: true,
	            preventClicksPropagation: true,
	            slideToClickedSlide: false,
	            // Lazy Loading
	            lazyLoading: false,
	            lazyLoadingInPrevNext: false,
	            lazyLoadingInPrevNextAmount: 1,
	            lazyLoadingOnTransitionStart: false,
	            // Images
	            preloadImages: true,
	            updateOnImagesReady: true,
	            // loop
	            loop: false,
	            loopAdditionalSlides: 0,
	            loopedSlides: null,
	            // Control
	            control: undefined,
	            controlInverse: false,
	            controlBy: 'slide',
	            normalizeSlideIndex: true,
	            // Swiping/no swiping
	            allowSwipeToPrev: true,
	            allowSwipeToNext: true,
	            swipeHandler: null,
	            noSwiping: true,
	            noSwipingClass: 'swiper-no-swiping',
	            // Passive Listeners
	            passiveListeners: true,
	            // NS
	            containerModifierClass: 'swiper-container-',
	            slideClass: 'swiper-slide',
	            slideActiveClass: 'swiper-slide-active',
	            slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
	            slideVisibleClass: 'swiper-slide-visible',
	            slideDuplicateClass: 'swiper-slide-duplicate',
	            slideNextClass: 'swiper-slide-next',
	            slideDuplicateNextClass: 'swiper-slide-duplicate-next',
	            slidePrevClass: 'swiper-slide-prev',
	            slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
	            wrapperClass: 'swiper-wrapper',
	            bulletClass: 'swiper-pagination-bullet',
	            bulletActiveClass: 'swiper-pagination-bullet-active',
	            buttonDisabledClass: 'swiper-button-disabled',
	            paginationCurrentClass: 'swiper-pagination-current',
	            paginationTotalClass: 'swiper-pagination-total',
	            paginationHiddenClass: 'swiper-pagination-hidden',
	            paginationProgressbarClass: 'swiper-pagination-progressbar',
	            paginationClickableClass: 'swiper-pagination-clickable',
	            paginationModifierClass: 'swiper-pagination-',
	            lazyLoadingClass: 'swiper-lazy',
	            lazyStatusLoadingClass: 'swiper-lazy-loading',
	            lazyStatusLoadedClass: 'swiper-lazy-loaded',
	            lazyPreloaderClass: 'swiper-lazy-preloader',
	            notificationClass: 'swiper-notification',
	            preloaderClass: 'preloader',
	            zoomContainerClass: 'swiper-zoom-container',
	            // Observer
	            observer: false,
	            observeParents: false,
	            // Accessibility
	            a11y: false,
	            prevSlideMessage: 'Previous slide',
	            nextSlideMessage: 'Next slide',
	            firstSlideMessage: 'This is the first slide',
	            lastSlideMessage: 'This is the last slide',
	            paginationBulletMessage: 'Go to slide {{index}}',
	            // Callbacks
	            runCallbacksOnInit: true
	            /*
	            Callbacks:
	            onInit: function (swiper)
	            onDestroy: function (swiper)
	            onBeforeResize: function (swiper)
	            onAfterResize: function (swiper)
	            onClick: function (swiper, e)
	            onTap: function (swiper, e)
	            onDoubleTap: function (swiper, e)
	            onSliderMove: function (swiper, e)
	            onSlideChangeStart: function (swiper)
	            onSlideChangeEnd: function (swiper)
	            onTransitionStart: function (swiper)
	            onTransitionEnd: function (swiper)
	            onImagesReady: function (swiper)
	            onProgress: function (swiper, progress)
	            onTouchStart: function (swiper, e)
	            onTouchMove: function (swiper, e)
	            onTouchMoveOpposite: function (swiper, e)
	            onTouchEnd: function (swiper, e)
	            onReachBeginning: function (swiper)
	            onReachEnd: function (swiper)
	            onSetTransition: function (swiper, duration)
	            onSetTranslate: function (swiper, translate)
	            onAutoplayStart: function (swiper)
	            onAutoplayStop: function (swiper),
	            onLazyImageLoad: function (swiper, slide, image)
	            onLazyImageReady: function (swiper, slide, image)
	            onKeyPress: function (swiper, keyCode)
	            */
	        };
	        var initialVirtualTranslate = params && params.virtualTranslate;
	        params = params || {};
	        var originalParams = {};
	        for (var param in params) {
	            if (typeof params[param] === 'object' && params[param] !== null && !(params[param].nodeType || params[param] === window || params[param] === document || (typeof Dom7 !== 'undefined' && params[param] instanceof Dom7) || (typeof jQuery !== 'undefined' && params[param] instanceof jQuery))) {
	                originalParams[param] = {};
	                for (var deepParam in params[param]) {
	                    originalParams[param][deepParam] = params[param][deepParam];
	                }
	            }
	            else {
	                originalParams[param] = params[param];
	            }
	        }
	        for (var def in defaults) {
	            if (typeof params[def] === 'undefined') {
	                params[def] = defaults[def];
	            }
	            else if (typeof params[def] === 'object') {
	                for (var deepDef in defaults[def]) {
	                    if (typeof params[def][deepDef] === 'undefined') {
	                        params[def][deepDef] = defaults[def][deepDef];
	                    }
	                }
	            }
	        }
	        // Swiper
	        var s = this;
	        // Params
	        s.params = params;
	        s.originalParams = originalParams;
	        // Classname
	        s.classNames = [];
	        /*=========================
	          Dom Library and plugins
	          ===========================*/
	        var $ = $;
	        if (typeof $ !== 'undefined' && typeof Dom7 !== 'undefined') {
	            $ = Dom7;
	        }
	        if (typeof $ === 'undefined') {
	            if (typeof Dom7 === 'undefined') {
	                $ = window.Dom7 || window.Zepto || window.jQuery;
	            }
	            else {
	                $ = Dom7;
	            }
	            if (!$)
	                return;
	        }
	        // Export it to Swiper instance
	        s.$ = $;
	        /*=========================
	          Breakpoints
	          ===========================*/
	        s.currentBreakpoint = undefined;
	        s.getActiveBreakpoint = function () {
	            //Get breakpoint for window width
	            if (!s.params.breakpoints)
	                return false;
	            var breakpoint = false;
	            var points = [], point;
	            for (point in s.params.breakpoints) {
	                if (s.params.breakpoints.hasOwnProperty(point)) {
	                    points.push(point);
	                }
	            }
	            points.sort(function (a, b) {
	                return parseInt(a, 10) > parseInt(b, 10);
	            });
	            for (var i = 0; i < points.length; i++) {
	                point = points[i];
	                if (point >= window.innerWidth && !breakpoint) {
	                    breakpoint = point;
	                }
	            }
	            return breakpoint || 'max';
	        };
	        s.setBreakpoint = function () {
	            //Set breakpoint for window width and update parameters
	            var breakpoint = s.getActiveBreakpoint();
	            if (breakpoint && s.currentBreakpoint !== breakpoint) {
	                var breakPointsParams = breakpoint in s.params.breakpoints ? s.params.breakpoints[breakpoint] : s.originalParams;
	                var needsReLoop = s.params.loop && (breakPointsParams.slidesPerView !== s.params.slidesPerView);
	                for (var param in breakPointsParams) {
	                    s.params[param] = breakPointsParams[param];
	                }
	                s.currentBreakpoint = breakpoint;
	                if (needsReLoop && s.destroyLoop) {
	                    s.reLoop(true);
	                }
	            }
	        };
	        // Set breakpoint on load
	        if (s.params.breakpoints) {
	            s.setBreakpoint();
	        }
	        /*=========================
	          Preparation - Define Container, Wrapper and Pagination
	          ===========================*/
	        s.container = $(container);
	        if (s.container.length === 0)
	            return;
	        if (s.container.length > 1) {
	            var swipers = [];
	            s.container.each(function () {
	                var container = this;
	                swipers.push(new Swiper(this, params));
	            });
	            return swipers;
	        }
	        // Save instance in container HTML Element and in data
	        s.container[0].swiper = s;
	        s.container.data('swiper', s);
	        s.classNames.push(s.params.containerModifierClass + s.params.direction);
	        if (s.params.freeMode) {
	            s.classNames.push(s.params.containerModifierClass + 'free-mode');
	        }
	        if (!s.support.flexbox) {
	            s.classNames.push(s.params.containerModifierClass + 'no-flexbox');
	            s.params.slidesPerColumn = 1;
	        }
	        if (s.params.autoHeight) {
	            s.classNames.push(s.params.containerModifierClass + 'autoheight');
	        }
	        // Enable slides progress when required
	        if (s.params.parallax || s.params.watchSlidesVisibility) {
	            s.params.watchSlidesProgress = true;
	        }
	        // Max resistance when touchReleaseOnEdges
	        if (s.params.touchReleaseOnEdges) {
	            s.params.resistanceRatio = 0;
	        }
	        // Coverflow / 3D
	        if (['cube', 'coverflow', 'flip'].indexOf(s.params.effect) >= 0) {
	            if (s.support.transforms3d) {
	                s.params.watchSlidesProgress = true;
	                s.classNames.push(s.params.containerModifierClass + '3d');
	            }
	            else {
	                s.params.effect = 'slide';
	            }
	        }
	        if (s.params.effect !== 'slide') {
	            s.classNames.push(s.params.containerModifierClass + s.params.effect);
	        }
	        if (s.params.effect === 'cube') {
	            s.params.resistanceRatio = 0;
	            s.params.slidesPerView = 1;
	            s.params.slidesPerColumn = 1;
	            s.params.slidesPerGroup = 1;
	            s.params.centeredSlides = false;
	            s.params.spaceBetween = 0;
	            s.params.virtualTranslate = true;
	        }
	        if (s.params.effect === 'fade' || s.params.effect === 'flip') {
	            s.params.slidesPerView = 1;
	            s.params.slidesPerColumn = 1;
	            s.params.slidesPerGroup = 1;
	            s.params.watchSlidesProgress = true;
	            s.params.spaceBetween = 0;
	            if (typeof initialVirtualTranslate === 'undefined') {
	                s.params.virtualTranslate = true;
	            }
	        }
	        // Grab Cursor
	        if (s.params.grabCursor && s.support.touch) {
	            s.params.grabCursor = false;
	        }
	        // Wrapper
	        s.wrapper = s.container.children('.' + s.params.wrapperClass);
	        // Pagination
	        if (s.params.pagination) {
	            s.paginationContainer = $(s.params.pagination);
	            if (s.params.uniqueNavElements && typeof s.params.pagination === 'string' && s.paginationContainer.length > 1 && s.container.find(s.params.pagination).length === 1) {
	                s.paginationContainer = s.container.find(s.params.pagination);
	            }
	            if (s.params.paginationType === 'bullets' && s.params.paginationClickable) {
	                s.paginationContainer.addClass(s.params.paginationModifierClass + 'clickable');
	            }
	            else {
	                s.params.paginationClickable = false;
	            }
	            s.paginationContainer.addClass(s.params.paginationModifierClass + s.params.paginationType);
	        }
	        // Next/Prev Buttons
	        if (s.params.nextButton || s.params.prevButton) {
	            if (s.params.nextButton) {
	                s.nextButton = $(s.params.nextButton);
	                if (s.params.uniqueNavElements && typeof s.params.nextButton === 'string' && s.nextButton.length > 1 && s.container.find(s.params.nextButton).length === 1) {
	                    s.nextButton = s.container.find(s.params.nextButton);
	                }
	            }
	            if (s.params.prevButton) {
	                s.prevButton = $(s.params.prevButton);
	                if (s.params.uniqueNavElements && typeof s.params.prevButton === 'string' && s.prevButton.length > 1 && s.container.find(s.params.prevButton).length === 1) {
	                    s.prevButton = s.container.find(s.params.prevButton);
	                }
	            }
	        }
	        // Is Horizontal
	        s.isHorizontal = function () {
	            return s.params.direction === 'horizontal';
	        };
	        // s.isH = isH;
	        // RTL
	        s.rtl = s.isHorizontal() && (s.container[0].dir.toLowerCase() === 'rtl' || s.container.css('direction') === 'rtl');
	        if (s.rtl) {
	            s.classNames.push(s.params.containerModifierClass + 'rtl');
	        }
	        // Wrong RTL support
	        if (s.rtl) {
	            s.wrongRTL = s.wrapper.css('display') === '-webkit-box';
	        }
	        // Columns
	        if (s.params.slidesPerColumn > 1) {
	            s.classNames.push(s.params.containerModifierClass + 'multirow');
	        }
	        // Check for Android
	        if (s.device.android) {
	            s.classNames.push(s.params.containerModifierClass + 'android');
	        }
	        // Add classes
	        s.container.addClass(s.classNames.join(' '));
	        // Translate
	        s.translate = 0;
	        // Progress
	        s.progress = 0;
	        // Velocity
	        s.velocity = 0;
	        /*=========================
	          Locks, unlocks
	          ===========================*/
	        s.lockSwipeToNext = function () {
	            s.params.allowSwipeToNext = false;
	            if (s.params.allowSwipeToPrev === false && s.params.grabCursor) {
	                s.unsetGrabCursor();
	            }
	        };
	        s.lockSwipeToPrev = function () {
	            s.params.allowSwipeToPrev = false;
	            if (s.params.allowSwipeToNext === false && s.params.grabCursor) {
	                s.unsetGrabCursor();
	            }
	        };
	        s.lockSwipes = function () {
	            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = false;
	            if (s.params.grabCursor)
	                s.unsetGrabCursor();
	        };
	        s.unlockSwipeToNext = function () {
	            s.params.allowSwipeToNext = true;
	            if (s.params.allowSwipeToPrev === true && s.params.grabCursor) {
	                s.setGrabCursor();
	            }
	        };
	        s.unlockSwipeToPrev = function () {
	            s.params.allowSwipeToPrev = true;
	            if (s.params.allowSwipeToNext === true && s.params.grabCursor) {
	                s.setGrabCursor();
	            }
	        };
	        s.unlockSwipes = function () {
	            s.params.allowSwipeToNext = s.params.allowSwipeToPrev = true;
	            if (s.params.grabCursor)
	                s.setGrabCursor();
	        };
	        /*=========================
	          Round helper
	          ===========================*/
	        function round(a) {
	            return Math.floor(a);
	        }
	        /*=========================
	          Set grab cursor
	          ===========================*/
	        s.setGrabCursor = function (moving) {
	            s.container[0].style.cursor = 'move';
	            s.container[0].style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
	            s.container[0].style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
	            s.container[0].style.cursor = moving ? 'grabbing' : 'grab';
	        };
	        s.unsetGrabCursor = function () {
	            s.container[0].style.cursor = '';
	        };
	        if (s.params.grabCursor) {
	            s.setGrabCursor();
	        }
	        /*=========================
	          Update on Images Ready
	          ===========================*/
	        s.imagesToLoad = [];
	        s.imagesLoaded = 0;
	        s.loadImage = function (imgElement, src, srcset, sizes, checkForComplete, callback) {
	            var image;
	            function onReady() {
	                if (callback)
	                    callback();
	            }
	            if (!imgElement.complete || !checkForComplete) {
	                if (src) {
	                    image = new window.Image();
	                    image.onload = onReady;
	                    image.onerror = onReady;
	                    if (sizes) {
	                        image.sizes = sizes;
	                    }
	                    if (srcset) {
	                        image.srcset = srcset;
	                    }
	                    if (src) {
	                        image.src = src;
	                    }
	                }
	                else {
	                    onReady();
	                }
	            }
	            else {
	                onReady();
	            }
	        };
	        s.preloadImages = function () {
	            s.imagesToLoad = s.container.find('img');
	            function _onReady() {
	                if (typeof s === 'undefined' || s === null || !s)
	                    return;
	                if (s.imagesLoaded !== undefined)
	                    s.imagesLoaded++;
	                if (s.imagesLoaded === s.imagesToLoad.length) {
	                    if (s.params.updateOnImagesReady)
	                        s.update();
	                    s.emit('onImagesReady', s);
	                }
	            }
	            for (var i = 0; i < s.imagesToLoad.length; i++) {
	                s.loadImage(s.imagesToLoad[i], (s.imagesToLoad[i].currentSrc || s.imagesToLoad[i].getAttribute('src')), (s.imagesToLoad[i].srcset || s.imagesToLoad[i].getAttribute('srcset')), s.imagesToLoad[i].sizes || s.imagesToLoad[i].getAttribute('sizes'), true, _onReady);
	            }
	        };
	        /*=========================
	          Autoplay
	          ===========================*/
	        s.autoplayTimeoutId = undefined;
	        s.autoplaying = false;
	        s.autoplayPaused = false;
	        function autoplay() {
	            var autoplayDelay = s.params.autoplay;
	            var activeSlide = s.slides.eq(s.activeIndex);
	            if (activeSlide.attr('data-swiper-autoplay')) {
	                autoplayDelay = activeSlide.attr('data-swiper-autoplay') || s.params.autoplay;
	            }
	            s.autoplayTimeoutId = setTimeout(function () {
	                if (s.params.loop) {
	                    s.fixLoop();
	                    s._slideNext();
	                    s.emit('onAutoplay', s);
	                }
	                else {
	                    if (!s.isEnd) {
	                        s._slideNext();
	                        s.emit('onAutoplay', s);
	                    }
	                    else {
	                        if (!params.autoplayStopOnLast) {
	                            s._slideTo(0);
	                            s.emit('onAutoplay', s);
	                        }
	                        else {
	                            s.stopAutoplay();
	                        }
	                    }
	                }
	            }, autoplayDelay);
	        }
	        s.startAutoplay = function () {
	            if (typeof s.autoplayTimeoutId !== 'undefined')
	                return false;
	            if (!s.params.autoplay)
	                return false;
	            if (s.autoplaying)
	                return false;
	            s.autoplaying = true;
	            s.emit('onAutoplayStart', s);
	            autoplay();
	        };
	        s.stopAutoplay = function (internal) {
	            if (!s.autoplayTimeoutId)
	                return;
	            if (s.autoplayTimeoutId)
	                clearTimeout(s.autoplayTimeoutId);
	            s.autoplaying = false;
	            s.autoplayTimeoutId = undefined;
	            s.emit('onAutoplayStop', s);
	        };
	        s.pauseAutoplay = function (speed) {
	            if (s.autoplayPaused)
	                return;
	            if (s.autoplayTimeoutId)
	                clearTimeout(s.autoplayTimeoutId);
	            s.autoplayPaused = true;
	            if (speed === 0) {
	                s.autoplayPaused = false;
	                autoplay();
	            }
	            else {
	                s.wrapper.transitionEnd(function () {
	                    if (!s)
	                        return;
	                    s.autoplayPaused = false;
	                    if (!s.autoplaying) {
	                        s.stopAutoplay();
	                    }
	                    else {
	                        autoplay();
	                    }
	                });
	            }
	        };
	        /*=========================
	          Min/Max Translate
	          ===========================*/
	        s.minTranslate = function () {
	            return (-s.snapGrid[0]);
	        };
	        s.maxTranslate = function () {
	            return (-s.snapGrid[s.snapGrid.length - 1]);
	        };
	        /*=========================
	          Slider/slides sizes
	          ===========================*/
	        s.updateAutoHeight = function () {
	            var activeSlides = [];
	            var newHeight = 0;
	            var i;
	            // Find slides currently in view
	            if (s.params.slidesPerView !== 'auto' && s.params.slidesPerView > 1) {
	                for (i = 0; i < Math.ceil(s.params.slidesPerView); i++) {
	                    var index = s.activeIndex + i;
	                    if (index > s.slides.length)
	                        break;
	                    activeSlides.push(s.slides.eq(index)[0]);
	                }
	            }
	            else {
	                activeSlides.push(s.slides.eq(s.activeIndex)[0]);
	            }
	            // Find new height from heighest slide in view
	            for (i = 0; i < activeSlides.length; i++) {
	                if (typeof activeSlides[i] !== 'undefined') {
	                    var height = activeSlides[i].offsetHeight;
	                    newHeight = height > newHeight ? height : newHeight;
	                }
	            }
	            // Update Height
	            if (newHeight)
	                s.wrapper.css('height', newHeight + 'px');
	        };
	        s.updateContainerSize = function () {
	            var width, height;
	            if (typeof s.params.width !== 'undefined') {
	                width = s.params.width;
	            }
	            else {
	                width = s.container[0].clientWidth;
	            }
	            if (typeof s.params.height !== 'undefined') {
	                height = s.params.height;
	            }
	            else {
	                height = s.container[0].clientHeight;
	            }
	            if (width === 0 && s.isHorizontal() || height === 0 && !s.isHorizontal()) {
	                return;
	            }
	            //Subtract paddings
	            width = width - parseInt(s.container.css('padding-left'), 10) - parseInt(s.container.css('padding-right'), 10);
	            height = height - parseInt(s.container.css('padding-top'), 10) - parseInt(s.container.css('padding-bottom'), 10);
	            // Store values
	            s.width = width;
	            s.height = height;
	            s.size = s.isHorizontal() ? s.width : s.height;
	        };
	        s.updateSlidesSize = function () {
	            s.slides = s.wrapper.children('.' + s.params.slideClass);
	            s.snapGrid = [];
	            s.slidesGrid = [];
	            s.slidesSizesGrid = [];
	            var spaceBetween = s.params.spaceBetween, slidePosition = -s.params.slidesOffsetBefore, i, prevSlideSize = 0, index = 0;
	            if (typeof s.size === 'undefined')
	                return;
	            if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
	                spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * s.size;
	            }
	            s.virtualSize = -spaceBetween;
	            // reset margins
	            if (s.rtl)
	                s.slides.css({ marginLeft: '', marginTop: '' });
	            else
	                s.slides.css({ marginRight: '', marginBottom: '' });
	            var slidesNumberEvenToRows;
	            if (s.params.slidesPerColumn > 1) {
	                if (Math.floor(s.slides.length / s.params.slidesPerColumn) === s.slides.length / s.params.slidesPerColumn) {
	                    slidesNumberEvenToRows = s.slides.length;
	                }
	                else {
	                    slidesNumberEvenToRows = Math.ceil(s.slides.length / s.params.slidesPerColumn) * s.params.slidesPerColumn;
	                }
	                if (s.params.slidesPerView !== 'auto' && s.params.slidesPerColumnFill === 'row') {
	                    slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, s.params.slidesPerView * s.params.slidesPerColumn);
	                }
	            }
	            // Calc slides
	            var slideSize;
	            var slidesPerColumn = s.params.slidesPerColumn;
	            var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
	            var numFullColumns = slidesPerRow - (s.params.slidesPerColumn * slidesPerRow - s.slides.length);
	            for (i = 0; i < s.slides.length; i++) {
	                slideSize = 0;
	                var slide = s.slides.eq(i);
	                if (s.params.slidesPerColumn > 1) {
	                    // Set slides order
	                    var newSlideOrderIndex;
	                    var column, row;
	                    if (s.params.slidesPerColumnFill === 'column') {
	                        column = Math.floor(i / slidesPerColumn);
	                        row = i - column * slidesPerColumn;
	                        if (column > numFullColumns || (column === numFullColumns && row === slidesPerColumn - 1)) {
	                            if (++row >= slidesPerColumn) {
	                                row = 0;
	                                column++;
	                            }
	                        }
	                        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
	                        slide
	                            .css({
	                            '-webkit-box-ordinal-group': newSlideOrderIndex,
	                            '-moz-box-ordinal-group': newSlideOrderIndex,
	                            '-ms-flex-order': newSlideOrderIndex,
	                            '-webkit-order': newSlideOrderIndex,
	                            'order': newSlideOrderIndex
	                        });
	                    }
	                    else {
	                        row = Math.floor(i / slidesPerRow);
	                        column = i - row * slidesPerRow;
	                    }
	                    slide
	                        .css('margin-' + (s.isHorizontal() ? 'top' : 'left'), (row !== 0 && s.params.spaceBetween) && (s.params.spaceBetween + 'px'))
	                        .attr('data-swiper-column', column)
	                        .attr('data-swiper-row', row);
	                }
	                if (slide.css('display') === 'none')
	                    continue;
	                if (s.params.slidesPerView === 'auto') {
	                    slideSize = s.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
	                    if (s.params.roundLengths)
	                        slideSize = round(slideSize);
	                }
	                else {
	                    slideSize = (s.size - (s.params.slidesPerView - 1) * spaceBetween) / s.params.slidesPerView;
	                    if (s.params.roundLengths)
	                        slideSize = round(slideSize);
	                    if (s.isHorizontal()) {
	                        s.slides[i].style.width = slideSize + 'px';
	                    }
	                    else {
	                        s.slides[i].style.height = slideSize + 'px';
	                    }
	                }
	                s.slides[i].swiperSlideSize = slideSize;
	                s.slidesSizesGrid.push(slideSize);
	                if (s.params.centeredSlides) {
	                    slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
	                    if (prevSlideSize === 0 && i !== 0)
	                        slidePosition = slidePosition - s.size / 2 - spaceBetween;
	                    if (i === 0)
	                        slidePosition = slidePosition - s.size / 2 - spaceBetween;
	                    if (Math.abs(slidePosition) < 1 / 1000)
	                        slidePosition = 0;
	                    if ((index) % s.params.slidesPerGroup === 0)
	                        s.snapGrid.push(slidePosition);
	                    s.slidesGrid.push(slidePosition);
	                }
	                else {
	                    if ((index) % s.params.slidesPerGroup === 0)
	                        s.snapGrid.push(slidePosition);
	                    s.slidesGrid.push(slidePosition);
	                    slidePosition = slidePosition + slideSize + spaceBetween;
	                }
	                s.virtualSize += slideSize + spaceBetween;
	                prevSlideSize = slideSize;
	                index++;
	            }
	            s.virtualSize = Math.max(s.virtualSize, s.size) + s.params.slidesOffsetAfter;
	            var newSlidesGrid;
	            if (s.rtl && s.wrongRTL && (s.params.effect === 'slide' || s.params.effect === 'coverflow')) {
	                s.wrapper.css({ width: s.virtualSize + s.params.spaceBetween + 'px' });
	            }
	            if (!s.support.flexbox || s.params.setWrapperSize) {
	                if (s.isHorizontal())
	                    s.wrapper.css({ width: s.virtualSize + s.params.spaceBetween + 'px' });
	                else
	                    s.wrapper.css({ height: s.virtualSize + s.params.spaceBetween + 'px' });
	            }
	            if (s.params.slidesPerColumn > 1) {
	                s.virtualSize = (slideSize + s.params.spaceBetween) * slidesNumberEvenToRows;
	                s.virtualSize = Math.ceil(s.virtualSize / s.params.slidesPerColumn) - s.params.spaceBetween;
	                if (s.isHorizontal())
	                    s.wrapper.css({ width: s.virtualSize + s.params.spaceBetween + 'px' });
	                else
	                    s.wrapper.css({ height: s.virtualSize + s.params.spaceBetween + 'px' });
	                if (s.params.centeredSlides) {
	                    newSlidesGrid = [];
	                    for (i = 0; i < s.snapGrid.length; i++) {
	                        if (s.snapGrid[i] < s.virtualSize + s.snapGrid[0])
	                            newSlidesGrid.push(s.snapGrid[i]);
	                    }
	                    s.snapGrid = newSlidesGrid;
	                }
	            }
	            // Remove last grid elements depending on width
	            if (!s.params.centeredSlides) {
	                newSlidesGrid = [];
	                for (i = 0; i < s.snapGrid.length; i++) {
	                    if (s.snapGrid[i] <= s.virtualSize - s.size) {
	                        newSlidesGrid.push(s.snapGrid[i]);
	                    }
	                }
	                s.snapGrid = newSlidesGrid;
	                if (Math.floor(s.virtualSize - s.size) - Math.floor(s.snapGrid[s.snapGrid.length - 1]) > 1) {
	                    s.snapGrid.push(s.virtualSize - s.size);
	                }
	            }
	            if (s.snapGrid.length === 0)
	                s.snapGrid = [0];
	            if (s.params.spaceBetween !== 0) {
	                if (s.isHorizontal()) {
	                    if (s.rtl)
	                        s.slides.css({ marginLeft: spaceBetween + 'px' });
	                    else
	                        s.slides.css({ marginRight: spaceBetween + 'px' });
	                }
	                else
	                    s.slides.css({ marginBottom: spaceBetween + 'px' });
	            }
	            if (s.params.watchSlidesProgress) {
	                s.updateSlidesOffset();
	            }
	        };
	        s.updateSlidesOffset = function () {
	            for (var i = 0; i < s.slides.length; i++) {
	                s.slides[i].swiperSlideOffset = s.isHorizontal() ? s.slides[i].offsetLeft : s.slides[i].offsetTop;
	            }
	        };
	        /*=========================
	          Dynamic Slides Per View
	          ===========================*/
	        s.currentSlidesPerView = function () {
	            var spv = 1, i, j;
	            if (s.params.centeredSlides) {
	                var size = s.slides[s.activeIndex].swiperSlideSize;
	                var breakLoop;
	                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
	                    if (s.slides[i] && !breakLoop) {
	                        size += s.slides[i].swiperSlideSize;
	                        spv++;
	                        if (size > s.size)
	                            breakLoop = true;
	                    }
	                }
	                for (j = s.activeIndex - 1; j >= 0; j--) {
	                    if (s.slides[j] && !breakLoop) {
	                        size += s.slides[j].swiperSlideSize;
	                        spv++;
	                        if (size > s.size)
	                            breakLoop = true;
	                    }
	                }
	            }
	            else {
	                for (i = s.activeIndex + 1; i < s.slides.length; i++) {
	                    if (s.slidesGrid[i] - s.slidesGrid[s.activeIndex] < s.size) {
	                        spv++;
	                    }
	                }
	            }
	            return spv;
	        };
	        /*=========================
	          Slider/slides progress
	          ===========================*/
	        s.updateSlidesProgress = function (translate) {
	            if (typeof translate === 'undefined') {
	                translate = s.translate || 0;
	            }
	            if (s.slides.length === 0)
	                return;
	            if (typeof s.slides[0].swiperSlideOffset === 'undefined')
	                s.updateSlidesOffset();
	            var offsetCenter = -translate;
	            if (s.rtl)
	                offsetCenter = translate;
	            // Visible Slides
	            s.slides.removeClass(s.params.slideVisibleClass);
	            for (var i = 0; i < s.slides.length; i++) {
	                var slide = s.slides[i];
	                var slideProgress = (offsetCenter + (s.params.centeredSlides ? s.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + s.params.spaceBetween);
	                if (s.params.watchSlidesVisibility) {
	                    var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
	                    var slideAfter = slideBefore + s.slidesSizesGrid[i];
	                    var isVisible = (slideBefore >= 0 && slideBefore < s.size) ||
	                        (slideAfter > 0 && slideAfter <= s.size) ||
	                        (slideBefore <= 0 && slideAfter >= s.size);
	                    if (isVisible) {
	                        s.slides.eq(i).addClass(s.params.slideVisibleClass);
	                    }
	                }
	                slide.progress = s.rtl ? -slideProgress : slideProgress;
	            }
	        };
	        s.updateProgress = function (translate) {
	            if (typeof translate === 'undefined') {
	                translate = s.translate || 0;
	            }
	            var translatesDiff = s.maxTranslate() - s.minTranslate();
	            var wasBeginning = s.isBeginning;
	            var wasEnd = s.isEnd;
	            if (translatesDiff === 0) {
	                s.progress = 0;
	                s.isBeginning = s.isEnd = true;
	            }
	            else {
	                s.progress = (translate - s.minTranslate()) / (translatesDiff);
	                s.isBeginning = s.progress <= 0;
	                s.isEnd = s.progress >= 1;
	            }
	            if (s.isBeginning && !wasBeginning)
	                s.emit('onReachBeginning', s);
	            if (s.isEnd && !wasEnd)
	                s.emit('onReachEnd', s);
	            if (s.params.watchSlidesProgress)
	                s.updateSlidesProgress(translate);
	            s.emit('onProgress', s, s.progress);
	        };
	        s.updateActiveIndex = function () {
	            var translate = s.rtl ? s.translate : -s.translate;
	            var newActiveIndex, i, snapIndex;
	            for (i = 0; i < s.slidesGrid.length; i++) {
	                if (typeof s.slidesGrid[i + 1] !== 'undefined') {
	                    if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1] - (s.slidesGrid[i + 1] - s.slidesGrid[i]) / 2) {
	                        newActiveIndex = i;
	                    }
	                    else if (translate >= s.slidesGrid[i] && translate < s.slidesGrid[i + 1]) {
	                        newActiveIndex = i + 1;
	                    }
	                }
	                else {
	                    if (translate >= s.slidesGrid[i]) {
	                        newActiveIndex = i;
	                    }
	                }
	            }
	            // Normalize slideIndex
	            if (s.params.normalizeSlideIndex) {
	                if (newActiveIndex < 0 || typeof newActiveIndex === 'undefined')
	                    newActiveIndex = 0;
	            }
	            // for (i = 0; i < s.slidesGrid.length; i++) {
	            // if (- translate >= s.slidesGrid[i]) {
	            // newActiveIndex = i;
	            // }
	            // }
	            snapIndex = Math.floor(newActiveIndex / s.params.slidesPerGroup);
	            if (snapIndex >= s.snapGrid.length)
	                snapIndex = s.snapGrid.length - 1;
	            if (newActiveIndex === s.activeIndex) {
	                return;
	            }
	            s.snapIndex = snapIndex;
	            s.previousIndex = s.activeIndex;
	            s.activeIndex = newActiveIndex;
	            s.updateClasses();
	            s.updateRealIndex();
	        };
	        s.updateRealIndex = function () {
	            s.realIndex = parseInt(s.slides.eq(s.activeIndex).attr('data-swiper-slide-index') || s.activeIndex, 10);
	        };
	        /*=========================
	          Classes
	          ===========================*/
	        s.updateClasses = function () {
	            s.slides.removeClass(s.params.slideActiveClass + ' ' + s.params.slideNextClass + ' ' + s.params.slidePrevClass + ' ' + s.params.slideDuplicateActiveClass + ' ' + s.params.slideDuplicateNextClass + ' ' + s.params.slideDuplicatePrevClass);
	            var activeSlide = s.slides.eq(s.activeIndex);
	            // Active classes
	            activeSlide.addClass(s.params.slideActiveClass);
	            if (params.loop) {
	                // Duplicate to all looped slides
	                if (activeSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + s.realIndex + '"]').addClass(s.params.slideDuplicateActiveClass);
	                }
	            }
	            // Next Slide
	            var nextSlide = activeSlide.next('.' + s.params.slideClass).addClass(s.params.slideNextClass);
	            if (s.params.loop && nextSlide.length === 0) {
	                nextSlide = s.slides.eq(0);
	                nextSlide.addClass(s.params.slideNextClass);
	            }
	            // Prev Slide
	            var prevSlide = activeSlide.prev('.' + s.params.slideClass).addClass(s.params.slidePrevClass);
	            if (s.params.loop && prevSlide.length === 0) {
	                prevSlide = s.slides.eq(-1);
	                prevSlide.addClass(s.params.slidePrevClass);
	            }
	            if (params.loop) {
	                // Duplicate to all looped slides
	                if (nextSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + nextSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicateNextClass);
	                }
	                if (prevSlide.hasClass(s.params.slideDuplicateClass)) {
	                    s.wrapper.children('.' + s.params.slideClass + ':not(.' + s.params.slideDuplicateClass + ')[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
	                }
	                else {
	                    s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + prevSlide.attr('data-swiper-slide-index') + '"]').addClass(s.params.slideDuplicatePrevClass);
	                }
	            }
	            // Pagination
	            if (s.paginationContainer && s.paginationContainer.length > 0) {
	                // Current/Total
	                var current, total = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
	                if (s.params.loop) {
	                    current = Math.ceil((s.activeIndex - s.loopedSlides) / s.params.slidesPerGroup);
	                    if (current > s.slides.length - 1 - s.loopedSlides * 2) {
	                        current = current - (s.slides.length - s.loopedSlides * 2);
	                    }
	                    if (current > total - 1)
	                        current = current - total;
	                    if (current < 0 && s.params.paginationType !== 'bullets')
	                        current = total + current;
	                }
	                else {
	                    if (typeof s.snapIndex !== 'undefined') {
	                        current = s.snapIndex;
	                    }
	                    else {
	                        current = s.activeIndex || 0;
	                    }
	                }
	                // Types
	                if (s.params.paginationType === 'bullets' && s.bullets && s.bullets.length > 0) {
	                    s.bullets.removeClass(s.params.bulletActiveClass);
	                    if (s.paginationContainer.length > 1) {
	                        s.bullets.each(function () {
	                            if ($(this).index() === current)
	                                $(this).addClass(s.params.bulletActiveClass);
	                        });
	                    }
	                    else {
	                        s.bullets.eq(current).addClass(s.params.bulletActiveClass);
	                    }
	                }
	                if (s.params.paginationType === 'fraction') {
	                    s.paginationContainer.find('.' + s.params.paginationCurrentClass).text(current + 1);
	                    s.paginationContainer.find('.' + s.params.paginationTotalClass).text(total);
	                }
	                if (s.params.paginationType === 'progress') {
	                    var scale = (current + 1) / total, scaleX = scale, scaleY = 1;
	                    if (!s.isHorizontal()) {
	                        scaleY = scale;
	                        scaleX = 1;
	                    }
	                    s.paginationContainer.find('.' + s.params.paginationProgressbarClass).transform('translate3d(0,0,0) scaleX(' + scaleX + ') scaleY(' + scaleY + ')').transition(s.params.speed);
	                }
	                if (s.params.paginationType === 'custom' && s.params.paginationCustomRender) {
	                    s.paginationContainer.html(s.params.paginationCustomRender(s, current + 1, total));
	                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
	                }
	            }
	            // Next/active buttons
	            if (!s.params.loop) {
	                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                    if (s.isBeginning) {
	                        s.prevButton.addClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y)
	                            s.a11y.disable(s.prevButton);
	                    }
	                    else {
	                        s.prevButton.removeClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y)
	                            s.a11y.enable(s.prevButton);
	                    }
	                }
	                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                    if (s.isEnd) {
	                        s.nextButton.addClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y)
	                            s.a11y.disable(s.nextButton);
	                    }
	                    else {
	                        s.nextButton.removeClass(s.params.buttonDisabledClass);
	                        if (s.params.a11y && s.a11y)
	                            s.a11y.enable(s.nextButton);
	                    }
	                }
	            }
	        };
	        /*=========================
	          Pagination
	          ===========================*/
	        s.updatePagination = function () {
	            if (!s.params.pagination)
	                return;
	            if (s.paginationContainer && s.paginationContainer.length > 0) {
	                var paginationHTML = '';
	                if (s.params.paginationType === 'bullets') {
	                    var numberOfBullets = s.params.loop ? Math.ceil((s.slides.length - s.loopedSlides * 2) / s.params.slidesPerGroup) : s.snapGrid.length;
	                    for (var i = 0; i < numberOfBullets; i++) {
	                        if (s.params.paginationBulletRender) {
	                            paginationHTML += s.params.paginationBulletRender(s, i, s.params.bulletClass);
	                        }
	                        else {
	                            paginationHTML += '<' + s.params.paginationElement + ' class="' + s.params.bulletClass + '"></' + s.params.paginationElement + '>';
	                        }
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                    s.bullets = s.paginationContainer.find('.' + s.params.bulletClass);
	                    if (s.params.paginationClickable && s.params.a11y && s.a11y) {
	                        s.a11y.initPagination();
	                    }
	                }
	                if (s.params.paginationType === 'fraction') {
	                    if (s.params.paginationFractionRender) {
	                        paginationHTML = s.params.paginationFractionRender(s, s.params.paginationCurrentClass, s.params.paginationTotalClass);
	                    }
	                    else {
	                        paginationHTML =
	                            '<span class="' + s.params.paginationCurrentClass + '"></span>' +
	                                ' / ' +
	                                '<span class="' + s.params.paginationTotalClass + '"></span>';
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                }
	                if (s.params.paginationType === 'progress') {
	                    if (s.params.paginationProgressRender) {
	                        paginationHTML = s.params.paginationProgressRender(s, s.params.paginationProgressbarClass);
	                    }
	                    else {
	                        paginationHTML = '<span class="' + s.params.paginationProgressbarClass + '"></span>';
	                    }
	                    s.paginationContainer.html(paginationHTML);
	                }
	                if (s.params.paginationType !== 'custom') {
	                    s.emit('onPaginationRendered', s, s.paginationContainer[0]);
	                }
	            }
	        };
	        /*=========================
	          Common update method
	          ===========================*/
	        s.update = function (updateTranslate) {
	            if (!s)
	                return;
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            s.updateProgress();
	            s.updatePagination();
	            s.updateClasses();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	            }
	            var newTranslate;
	            function forceSetTranslate() {
	                var translate = s.rtl ? -s.translate : s.translate;
	                newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
	                s.setWrapperTranslate(newTranslate);
	                s.updateActiveIndex();
	                s.updateClasses();
	            }
	            if (updateTranslate) {
	                var translated;
	                if (s.controller && s.controller.spline) {
	                    s.controller.spline = undefined;
	                }
	                if (s.params.freeMode) {
	                    forceSetTranslate();
	                    if (s.params.autoHeight) {
	                        s.updateAutoHeight();
	                    }
	                }
	                else {
	                    if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
	                        translated = s.slideTo(s.slides.length - 1, 0, false, true);
	                    }
	                    else {
	                        translated = s.slideTo(s.activeIndex, 0, false, true);
	                    }
	                    if (!translated) {
	                        forceSetTranslate();
	                    }
	                }
	            }
	            else if (s.params.autoHeight) {
	                s.updateAutoHeight();
	            }
	        };
	        /*=========================
	          Resize Handler
	          ===========================*/
	        s.onResize = function (forceUpdatePagination) {
	            if (s.params.onBeforeResize)
	                s.params.onBeforeResize(s);
	            //Breakpoints
	            if (s.params.breakpoints) {
	                s.setBreakpoint();
	            }
	            // Disable locks on resize
	            var allowSwipeToPrev = s.params.allowSwipeToPrev;
	            var allowSwipeToNext = s.params.allowSwipeToNext;
	            s.params.allowSwipeToPrev = s.params.allowSwipeToNext = true;
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            if (s.params.slidesPerView === 'auto' || s.params.freeMode || forceUpdatePagination)
	                s.updatePagination();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	            }
	            if (s.controller && s.controller.spline) {
	                s.controller.spline = undefined;
	            }
	            var slideChangedBySlideTo = false;
	            if (s.params.freeMode) {
	                var newTranslate = Math.min(Math.max(s.translate, s.maxTranslate()), s.minTranslate());
	                s.setWrapperTranslate(newTranslate);
	                s.updateActiveIndex();
	                s.updateClasses();
	                if (s.params.autoHeight) {
	                    s.updateAutoHeight();
	                }
	            }
	            else {
	                s.updateClasses();
	                if ((s.params.slidesPerView === 'auto' || s.params.slidesPerView > 1) && s.isEnd && !s.params.centeredSlides) {
	                    slideChangedBySlideTo = s.slideTo(s.slides.length - 1, 0, false, true);
	                }
	                else {
	                    slideChangedBySlideTo = s.slideTo(s.activeIndex, 0, false, true);
	                }
	            }
	            if (s.params.lazyLoading && !slideChangedBySlideTo && s.lazy) {
	                s.lazy.load();
	            }
	            // Return locks after resize
	            s.params.allowSwipeToPrev = allowSwipeToPrev;
	            s.params.allowSwipeToNext = allowSwipeToNext;
	            if (s.params.onAfterResize)
	                s.params.onAfterResize(s);
	        };
	        /*=========================
	          Events
	          ===========================*/
	        //Define Touch Events
	        s.touchEventsDesktop = { start: 'mousedown', move: 'mousemove', end: 'mouseup' };
	        if (window.navigator.pointerEnabled)
	            s.touchEventsDesktop = { start: 'pointerdown', move: 'pointermove', end: 'pointerup' };
	        else if (window.navigator.msPointerEnabled)
	            s.touchEventsDesktop = { start: 'MSPointerDown', move: 'MSPointerMove', end: 'MSPointerUp' };
	        s.touchEvents = {
	            start: s.support.touch || !s.params.simulateTouch ? 'touchstart' : s.touchEventsDesktop.start,
	            move: s.support.touch || !s.params.simulateTouch ? 'touchmove' : s.touchEventsDesktop.move,
	            end: s.support.touch || !s.params.simulateTouch ? 'touchend' : s.touchEventsDesktop.end
	        };
	        // WP8 Touch Events Fix
	        if (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) {
	            (s.params.touchEventsTarget === 'container' ? s.container : s.wrapper).addClass('swiper-wp8-' + s.params.direction);
	        }
	        // Attach/detach events
	        s.initEvents = function (detach) {
	            var actionDom = detach ? 'off' : 'on';
	            var action = detach ? 'removeEventListener' : 'addEventListener';
	            var touchEventsTarget = s.params.touchEventsTarget === 'container' ? s.container[0] : s.wrapper[0];
	            var target = s.support.touch ? touchEventsTarget : document;
	            var moveCapture = s.params.nested ? true : false;
	            //Touch Events
	            if (s.browser.ie) {
	                touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, false);
	                target[action](s.touchEvents.move, s.onTouchMove, moveCapture);
	                target[action](s.touchEvents.end, s.onTouchEnd, false);
	            }
	            else {
	                if (s.support.touch) {
	                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? { passive: true, capture: false } : false;
	                    touchEventsTarget[action](s.touchEvents.start, s.onTouchStart, passiveListener);
	                    touchEventsTarget[action](s.touchEvents.move, s.onTouchMove, moveCapture);
	                    touchEventsTarget[action](s.touchEvents.end, s.onTouchEnd, passiveListener);
	                }
	                if ((params.simulateTouch && !s.device.ios && !s.device.android) || (params.simulateTouch && !s.support.touch && s.device.ios)) {
	                    touchEventsTarget[action]('mousedown', s.onTouchStart, false);
	                    document[action]('mousemove', s.onTouchMove, moveCapture);
	                    document[action]('mouseup', s.onTouchEnd, false);
	                }
	            }
	            window[action]('resize', s.onResize);
	            // Next, Prev, Index
	            if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                s.nextButton[actionDom]('click', s.onClickNext);
	                if (s.params.a11y && s.a11y)
	                    s.nextButton[actionDom]('keydown', s.a11y.onEnterKey);
	            }
	            if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                s.prevButton[actionDom]('click', s.onClickPrev);
	                if (s.params.a11y && s.a11y)
	                    s.prevButton[actionDom]('keydown', s.a11y.onEnterKey);
	            }
	            if (s.params.pagination && s.params.paginationClickable) {
	                s.paginationContainer[actionDom]('click', '.' + s.params.bulletClass, s.onClickIndex);
	                if (s.params.a11y && s.a11y)
	                    s.paginationContainer[actionDom]('keydown', '.' + s.params.bulletClass, s.a11y.onEnterKey);
	            }
	            // Prevent Links Clicks
	            if (s.params.preventClicks || s.params.preventClicksPropagation)
	                touchEventsTarget[action]('click', s.preventClicks, true);
	        };
	        s.attachEvents = function () {
	            s.initEvents();
	        };
	        s.detachEvents = function () {
	            s.initEvents(true);
	        };
	        /*=========================
	          Handle Clicks
	          ===========================*/
	        // Prevent Clicks
	        s.allowClick = true;
	        s.preventClicks = function (e) {
	            if (!s.allowClick) {
	                if (s.params.preventClicks)
	                    e.preventDefault();
	                if (s.params.preventClicksPropagation && s.animating) {
	                    e.stopPropagation();
	                    e.stopImmediatePropagation();
	                }
	            }
	        };
	        // Clicks
	        s.onClickNext = function (e) {
	            e.preventDefault();
	            if (s.isEnd && !s.params.loop)
	                return;
	            s.slideNext();
	        };
	        s.onClickPrev = function (e) {
	            e.preventDefault();
	            if (s.isBeginning && !s.params.loop)
	                return;
	            s.slidePrev();
	        };
	        s.onClickIndex = function (e) {
	            e.preventDefault();
	            var index = $(this).index() * s.params.slidesPerGroup;
	            if (s.params.loop)
	                index = index + s.loopedSlides;
	            s.slideTo(index);
	        };
	        /*=========================
	          Handle Touches
	          ===========================*/
	        function findElementInEvent(e, selector) {
	            var el = $(e.target);
	            if (!el.is(selector)) {
	                if (typeof selector === 'string') {
	                    el = el.parents(selector);
	                }
	                else if (selector.nodeType) {
	                    var found;
	                    el.parents().each(function (index, _el) {
	                        if (_el === selector)
	                            found = selector;
	                    });
	                    if (!found)
	                        return undefined;
	                    else
	                        return selector;
	                }
	            }
	            if (el.length === 0) {
	                return undefined;
	            }
	            return el[0];
	        }
	        s.updateClickedSlide = function (e) {
	            var slide = findElementInEvent(e, '.' + s.params.slideClass);
	            var slideFound = false;
	            if (slide) {
	                for (var i = 0; i < s.slides.length; i++) {
	                    if (s.slides[i] === slide)
	                        slideFound = true;
	                }
	            }
	            if (slide && slideFound) {
	                s.clickedSlide = slide;
	                s.clickedIndex = $(slide).index();
	            }
	            else {
	                s.clickedSlide = undefined;
	                s.clickedIndex = undefined;
	                return;
	            }
	            if (s.params.slideToClickedSlide && s.clickedIndex !== undefined && s.clickedIndex !== s.activeIndex) {
	                var slideToIndex = s.clickedIndex, realIndex, duplicatedSlides, slidesPerView = s.params.slidesPerView === 'auto' ? s.currentSlidesPerView() : s.params.slidesPerView;
	                if (s.params.loop) {
	                    if (s.animating)
	                        return;
	                    realIndex = parseInt($(s.clickedSlide).attr('data-swiper-slide-index'), 10);
	                    if (s.params.centeredSlides) {
	                        if ((slideToIndex < s.loopedSlides - slidesPerView / 2) || (slideToIndex > s.slides.length - s.loopedSlides + slidesPerView / 2)) {
	                            s.fixLoop();
	                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
	                            setTimeout(function () {
	                                s.slideTo(slideToIndex);
	                            }, 0);
	                        }
	                        else {
	                            s.slideTo(slideToIndex);
	                        }
	                    }
	                    else {
	                        if (slideToIndex > s.slides.length - slidesPerView) {
	                            s.fixLoop();
	                            slideToIndex = s.wrapper.children('.' + s.params.slideClass + '[data-swiper-slide-index="' + realIndex + '"]:not(.' + s.params.slideDuplicateClass + ')').eq(0).index();
	                            setTimeout(function () {
	                                s.slideTo(slideToIndex);
	                            }, 0);
	                        }
	                        else {
	                            s.slideTo(slideToIndex);
	                        }
	                    }
	                }
	                else {
	                    s.slideTo(slideToIndex);
	                }
	            }
	        };
	        var isTouched, isMoved, allowTouchCallbacks, touchStartTime, isScrolling, currentTranslate, startTranslate, allowThresholdMove, 
	        // Form elements to match
	        formElements = 'input, select, textarea, button, video', 
	        // Last click time
	        lastClickTime = Date.now(), clickTimeout, 
	        //Velocities
	        velocities = [], allowMomentumBounce;
	        // Animating Flag
	        s.animating = false;
	        // Touches information
	        s.touches = {
	            startX: 0,
	            startY: 0,
	            currentX: 0,
	            currentY: 0,
	            diff: 0
	        };
	        // Touch handlers
	        var isTouchEvent, startMoving;
	        s.onTouchStart = function (e) {
	            if (e.originalEvent)
	                e = e.originalEvent;
	            isTouchEvent = e.type === 'touchstart';
	            if (!isTouchEvent && 'which' in e && e.which === 3)
	                return;
	            if (s.params.noSwiping && findElementInEvent(e, '.' + s.params.noSwipingClass)) {
	                s.allowClick = true;
	                return;
	            }
	            if (s.params.swipeHandler) {
	                if (!findElementInEvent(e, s.params.swipeHandler))
	                    return;
	            }
	            var startX = s.touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	            var startY = s.touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	            // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore
	            if (s.device.ios && s.params.iOSEdgeSwipeDetection && startX <= s.params.iOSEdgeSwipeThreshold) {
	                return;
	            }
	            isTouched = true;
	            isMoved = false;
	            allowTouchCallbacks = true;
	            isScrolling = undefined;
	            startMoving = undefined;
	            s.touches.startX = startX;
	            s.touches.startY = startY;
	            touchStartTime = Date.now();
	            s.allowClick = true;
	            s.updateContainerSize();
	            s.swipeDirection = undefined;
	            if (s.params.threshold > 0)
	                allowThresholdMove = false;
	            if (e.type !== 'touchstart') {
	                var preventDefault = true;
	                if ($(e.target).is(formElements))
	                    preventDefault = false;
	                if (document.activeElement && $(document.activeElement).is(formElements)) {
	                    document.activeElement.blur();
	                }
	                if (preventDefault) {
	                    e.preventDefault();
	                }
	            }
	            s.emit('onTouchStart', s, e);
	        };
	        s.onTouchMove = function (e) {
	            if (e.originalEvent)
	                e = e.originalEvent;
	            if (isTouchEvent && e.type === 'mousemove')
	                return;
	            if (e.preventedByNestedSwiper) {
	                s.touches.startX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                s.touches.startY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                return;
	            }
	            if (s.params.onlyExternal) {
	                // isMoved = true;
	                s.allowClick = false;
	                if (isTouched) {
	                    s.touches.startX = s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                    s.touches.startY = s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                    touchStartTime = Date.now();
	                }
	                return;
	            }
	            if (isTouchEvent && s.params.touchReleaseOnEdges && !s.params.loop) {
	                if (!s.isHorizontal()) {
	                    // Vertical
	                    if ((s.touches.currentY < s.touches.startY && s.translate <= s.maxTranslate()) ||
	                        (s.touches.currentY > s.touches.startY && s.translate >= s.minTranslate())) {
	                        return;
	                    }
	                }
	                else {
	                    if ((s.touches.currentX < s.touches.startX && s.translate <= s.maxTranslate()) ||
	                        (s.touches.currentX > s.touches.startX && s.translate >= s.minTranslate())) {
	                        return;
	                    }
	                }
	            }
	            if (isTouchEvent && document.activeElement) {
	                if (e.target === document.activeElement && $(e.target).is(formElements)) {
	                    isMoved = true;
	                    s.allowClick = false;
	                    return;
	                }
	            }
	            if (allowTouchCallbacks) {
	                s.emit('onTouchMove', s, e);
	            }
	            if (e.targetTouches && e.targetTouches.length > 1)
	                return;
	            s.touches.currentX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	            s.touches.currentY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	            if (typeof isScrolling === 'undefined') {
	                var touchAngle;
	                if (s.isHorizontal() && s.touches.currentY === s.touches.startY || !s.isHorizontal() && s.touches.currentX === s.touches.startX) {
	                    isScrolling = false;
	                }
	                else {
	                    touchAngle = Math.atan2(Math.abs(s.touches.currentY - s.touches.startY), Math.abs(s.touches.currentX - s.touches.startX)) * 180 / Math.PI;
	                    isScrolling = s.isHorizontal() ? touchAngle > s.params.touchAngle : (90 - touchAngle > s.params.touchAngle);
	                }
	            }
	            if (isScrolling) {
	                s.emit('onTouchMoveOpposite', s, e);
	            }
	            if (typeof startMoving === 'undefined') {
	                if (s.touches.currentX !== s.touches.startX || s.touches.currentY !== s.touches.startY) {
	                    startMoving = true;
	                }
	            }
	            if (!isTouched)
	                return;
	            if (isScrolling) {
	                isTouched = false;
	                return;
	            }
	            if (!startMoving) {
	                return;
	            }
	            s.allowClick = false;
	            s.emit('onSliderMove', s, e);
	            e.preventDefault();
	            if (s.params.touchMoveStopPropagation && !s.params.nested) {
	                e.stopPropagation();
	            }
	            if (!isMoved) {
	                if (params.loop) {
	                    s.fixLoop();
	                }
	                startTranslate = s.getWrapperTranslate();
	                s.setWrapperTransition(0);
	                if (s.animating) {
	                    s.wrapper.trigger('webkitTransitionEnd transitionend oTransitionEnd MSTransitionEnd msTransitionEnd');
	                }
	                if (s.params.autoplay && s.autoplaying) {
	                    if (s.params.autoplayDisableOnInteraction) {
	                        s.stopAutoplay();
	                    }
	                    else {
	                        s.pauseAutoplay();
	                    }
	                }
	                allowMomentumBounce = false;
	                //Grab Cursor
	                if (s.params.grabCursor && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
	                    s.setGrabCursor(true);
	                }
	            }
	            isMoved = true;
	            var diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
	            diff = diff * s.params.touchRatio;
	            if (s.rtl)
	                diff = -diff;
	            s.swipeDirection = diff > 0 ? 'prev' : 'next';
	            currentTranslate = diff + startTranslate;
	            var disableParentSwiper = true;
	            if ((diff > 0 && currentTranslate > s.minTranslate())) {
	                disableParentSwiper = false;
	                if (s.params.resistance)
	                    currentTranslate = s.minTranslate() - 1 + Math.pow(-s.minTranslate() + startTranslate + diff, s.params.resistanceRatio);
	            }
	            else if (diff < 0 && currentTranslate < s.maxTranslate()) {
	                disableParentSwiper = false;
	                if (s.params.resistance)
	                    currentTranslate = s.maxTranslate() + 1 - Math.pow(s.maxTranslate() - startTranslate - diff, s.params.resistanceRatio);
	            }
	            if (disableParentSwiper) {
	                e.preventedByNestedSwiper = true;
	            }
	            // Directions locks
	            if (!s.params.allowSwipeToNext && s.swipeDirection === 'next' && currentTranslate < startTranslate) {
	                currentTranslate = startTranslate;
	            }
	            if (!s.params.allowSwipeToPrev && s.swipeDirection === 'prev' && currentTranslate > startTranslate) {
	                currentTranslate = startTranslate;
	            }
	            // Threshold
	            if (s.params.threshold > 0) {
	                if (Math.abs(diff) > s.params.threshold || allowThresholdMove) {
	                    if (!allowThresholdMove) {
	                        allowThresholdMove = true;
	                        s.touches.startX = s.touches.currentX;
	                        s.touches.startY = s.touches.currentY;
	                        currentTranslate = startTranslate;
	                        s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY - s.touches.startY;
	                        return;
	                    }
	                }
	                else {
	                    currentTranslate = startTranslate;
	                    return;
	                }
	            }
	            if (!s.params.followFinger)
	                return;
	            // Update active index in free mode
	            if (s.params.freeMode || s.params.watchSlidesProgress) {
	                s.updateActiveIndex();
	            }
	            if (s.params.freeMode) {
	                //Velocity
	                if (velocities.length === 0) {
	                    velocities.push({
	                        position: s.touches[s.isHorizontal() ? 'startX' : 'startY'],
	                        time: touchStartTime
	                    });
	                }
	                velocities.push({
	                    position: s.touches[s.isHorizontal() ? 'currentX' : 'currentY'],
	                    time: (new window.Date()).getTime()
	                });
	            }
	            // Update progress
	            s.updateProgress(currentTranslate);
	            // Update translate
	            s.setWrapperTranslate(currentTranslate);
	        };
	        s.onTouchEnd = function (e) {
	            if (e.originalEvent)
	                e = e.originalEvent;
	            if (allowTouchCallbacks) {
	                s.emit('onTouchEnd', s, e);
	            }
	            allowTouchCallbacks = false;
	            if (!isTouched)
	                return;
	            //Return Grab Cursor
	            if (s.params.grabCursor && isMoved && isTouched && (s.params.allowSwipeToNext === true || s.params.allowSwipeToPrev === true)) {
	                s.setGrabCursor(false);
	            }
	            // Time diff
	            var touchEndTime = Date.now();
	            var timeDiff = touchEndTime - touchStartTime;
	            // Tap, doubleTap, Click
	            if (s.allowClick) {
	                s.updateClickedSlide(e);
	                s.emit('onTap', s, e);
	                if (timeDiff < 300 && (touchEndTime - lastClickTime) > 300) {
	                    if (clickTimeout)
	                        clearTimeout(clickTimeout);
	                    clickTimeout = setTimeout(function () {
	                        if (!s)
	                            return;
	                        if (s.params.paginationHide && s.paginationContainer.length > 0 && !$(e.target).hasClass(s.params.bulletClass)) {
	                            s.paginationContainer.toggleClass(s.params.paginationHiddenClass);
	                        }
	                        s.emit('onClick', s, e);
	                    }, 300);
	                }
	                if (timeDiff < 300 && (touchEndTime - lastClickTime) < 300) {
	                    if (clickTimeout)
	                        clearTimeout(clickTimeout);
	                    s.emit('onDoubleTap', s, e);
	                }
	            }
	            lastClickTime = Date.now();
	            setTimeout(function () {
	                if (s)
	                    s.allowClick = true;
	            }, 0);
	            if (!isTouched || !isMoved || !s.swipeDirection || s.touches.diff === 0 || currentTranslate === startTranslate) {
	                isTouched = isMoved = false;
	                return;
	            }
	            isTouched = isMoved = false;
	            var currentPos;
	            if (s.params.followFinger) {
	                currentPos = s.rtl ? s.translate : -s.translate;
	            }
	            else {
	                currentPos = -currentTranslate;
	            }
	            if (s.params.freeMode) {
	                if (currentPos < -s.minTranslate()) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                else if (currentPos > -s.maxTranslate()) {
	                    if (s.slides.length < s.snapGrid.length) {
	                        s.slideTo(s.snapGrid.length - 1);
	                    }
	                    else {
	                        s.slideTo(s.slides.length - 1);
	                    }
	                    return;
	                }
	                if (s.params.freeModeMomentum) {
	                    if (velocities.length > 1) {
	                        var lastMoveEvent = velocities.pop(), velocityEvent = velocities.pop();
	                        var distance = lastMoveEvent.position - velocityEvent.position;
	                        var time = lastMoveEvent.time - velocityEvent.time;
	                        s.velocity = distance / time;
	                        s.velocity = s.velocity / 2;
	                        if (Math.abs(s.velocity) < s.params.freeModeMinimumVelocity) {
	                            s.velocity = 0;
	                        }
	                        // this implies that the user stopped moving a finger then released.
	                        // There would be no events with distance zero, so the last event is stale.
	                        if (time > 150 || (new window.Date().getTime() - lastMoveEvent.time) > 300) {
	                            s.velocity = 0;
	                        }
	                    }
	                    else {
	                        s.velocity = 0;
	                    }
	                    s.velocity = s.velocity * s.params.freeModeMomentumVelocityRatio;
	                    velocities.length = 0;
	                    var momentumDuration = 1000 * s.params.freeModeMomentumRatio;
	                    var momentumDistance = s.velocity * momentumDuration;
	                    var newPosition = s.translate + momentumDistance;
	                    if (s.rtl)
	                        newPosition = -newPosition;
	                    var doBounce = false;
	                    var afterBouncePosition;
	                    var bounceAmount = Math.abs(s.velocity) * 20 * s.params.freeModeMomentumBounceRatio;
	                    if (newPosition < s.maxTranslate()) {
	                        if (s.params.freeModeMomentumBounce) {
	                            if (newPosition + s.maxTranslate() < -bounceAmount) {
	                                newPosition = s.maxTranslate() - bounceAmount;
	                            }
	                            afterBouncePosition = s.maxTranslate();
	                            doBounce = true;
	                            allowMomentumBounce = true;
	                        }
	                        else {
	                            newPosition = s.maxTranslate();
	                        }
	                    }
	                    else if (newPosition > s.minTranslate()) {
	                        if (s.params.freeModeMomentumBounce) {
	                            if (newPosition - s.minTranslate() > bounceAmount) {
	                                newPosition = s.minTranslate() + bounceAmount;
	                            }
	                            afterBouncePosition = s.minTranslate();
	                            doBounce = true;
	                            allowMomentumBounce = true;
	                        }
	                        else {
	                            newPosition = s.minTranslate();
	                        }
	                    }
	                    else if (s.params.freeModeSticky) {
	                        var j = 0, nextSlide;
	                        for (j = 0; j < s.snapGrid.length; j += 1) {
	                            if (s.snapGrid[j] > -newPosition) {
	                                nextSlide = j;
	                                break;
	                            }
	                        }
	                        if (Math.abs(s.snapGrid[nextSlide] - newPosition) < Math.abs(s.snapGrid[nextSlide - 1] - newPosition) || s.swipeDirection === 'next') {
	                            newPosition = s.snapGrid[nextSlide];
	                        }
	                        else {
	                            newPosition = s.snapGrid[nextSlide - 1];
	                        }
	                        if (!s.rtl)
	                            newPosition = -newPosition;
	                    }
	                    //Fix duration
	                    if (s.velocity !== 0) {
	                        if (s.rtl) {
	                            momentumDuration = Math.abs((-newPosition - s.translate) / s.velocity);
	                        }
	                        else {
	                            momentumDuration = Math.abs((newPosition - s.translate) / s.velocity);
	                        }
	                    }
	                    else if (s.params.freeModeSticky) {
	                        s.slideReset();
	                        return;
	                    }
	                    if (s.params.freeModeMomentumBounce && doBounce) {
	                        s.updateProgress(afterBouncePosition);
	                        s.setWrapperTransition(momentumDuration);
	                        s.setWrapperTranslate(newPosition);
	                        s.onTransitionStart();
	                        s.animating = true;
	                        s.wrapper.transitionEnd(function () {
	                            if (!s || !allowMomentumBounce)
	                                return;
	                            s.emit('onMomentumBounce', s);
	                            s.setWrapperTransition(s.params.speed);
	                            s.setWrapperTranslate(afterBouncePosition);
	                            s.wrapper.transitionEnd(function () {
	                                if (!s)
	                                    return;
	                                s.onTransitionEnd();
	                            });
	                        });
	                    }
	                    else if (s.velocity) {
	                        s.updateProgress(newPosition);
	                        s.setWrapperTransition(momentumDuration);
	                        s.setWrapperTranslate(newPosition);
	                        s.onTransitionStart();
	                        if (!s.animating) {
	                            s.animating = true;
	                            s.wrapper.transitionEnd(function () {
	                                if (!s)
	                                    return;
	                                s.onTransitionEnd();
	                            });
	                        }
	                    }
	                    else {
	                        s.updateProgress(newPosition);
	                    }
	                    s.updateActiveIndex();
	                }
	                if (!s.params.freeModeMomentum || timeDiff >= s.params.longSwipesMs) {
	                    s.updateProgress();
	                    s.updateActiveIndex();
	                }
	                return;
	            }
	            // Find current slide
	            var i, stopIndex = 0, groupSize = s.slidesSizesGrid[0];
	            for (i = 0; i < s.slidesGrid.length; i += s.params.slidesPerGroup) {
	                if (typeof s.slidesGrid[i + s.params.slidesPerGroup] !== 'undefined') {
	                    if (currentPos >= s.slidesGrid[i] && currentPos < s.slidesGrid[i + s.params.slidesPerGroup]) {
	                        stopIndex = i;
	                        groupSize = s.slidesGrid[i + s.params.slidesPerGroup] - s.slidesGrid[i];
	                    }
	                }
	                else {
	                    if (currentPos >= s.slidesGrid[i]) {
	                        stopIndex = i;
	                        groupSize = s.slidesGrid[s.slidesGrid.length - 1] - s.slidesGrid[s.slidesGrid.length - 2];
	                    }
	                }
	            }
	            // Find current slide size
	            var ratio = (currentPos - s.slidesGrid[stopIndex]) / groupSize;
	            if (timeDiff > s.params.longSwipesMs) {
	                // Long touches
	                if (!s.params.longSwipes) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                if (s.swipeDirection === 'next') {
	                    if (ratio >= s.params.longSwipesRatio)
	                        s.slideTo(stopIndex + s.params.slidesPerGroup);
	                    else
	                        s.slideTo(stopIndex);
	                }
	                if (s.swipeDirection === 'prev') {
	                    if (ratio > (1 - s.params.longSwipesRatio))
	                        s.slideTo(stopIndex + s.params.slidesPerGroup);
	                    else
	                        s.slideTo(stopIndex);
	                }
	            }
	            else {
	                // Short swipes
	                if (!s.params.shortSwipes) {
	                    s.slideTo(s.activeIndex);
	                    return;
	                }
	                if (s.swipeDirection === 'next') {
	                    s.slideTo(stopIndex + s.params.slidesPerGroup);
	                }
	                if (s.swipeDirection === 'prev') {
	                    s.slideTo(stopIndex);
	                }
	            }
	        };
	        /*=========================
	          Transitions
	          ===========================*/
	        s._slideTo = function (slideIndex, speed) {
	            return s.slideTo(slideIndex, speed, true, true);
	        };
	        s.slideTo = function (slideIndex, speed, runCallbacks, internal) {
	            if (typeof runCallbacks === 'undefined')
	                runCallbacks = true;
	            if (typeof slideIndex === 'undefined')
	                slideIndex = 0;
	            if (slideIndex < 0)
	                slideIndex = 0;
	            s.snapIndex = Math.floor(slideIndex / s.params.slidesPerGroup);
	            if (s.snapIndex >= s.snapGrid.length)
	                s.snapIndex = s.snapGrid.length - 1;
	            var translate = -s.snapGrid[s.snapIndex];
	            // Stop autoplay
	            if (s.params.autoplay && s.autoplaying) {
	                if (internal || !s.params.autoplayDisableOnInteraction) {
	                    s.pauseAutoplay(speed);
	                }
	                else {
	                    s.stopAutoplay();
	                }
	            }
	            // Update progress
	            s.updateProgress(translate);
	            // Normalize slideIndex
	            if (s.params.normalizeSlideIndex) {
	                for (var i = 0; i < s.slidesGrid.length; i++) {
	                    if (-Math.floor(translate * 100) >= Math.floor(s.slidesGrid[i] * 100)) {
	                        slideIndex = i;
	                    }
	                }
	            }
	            // Directions locks
	            if (!s.params.allowSwipeToNext && translate < s.translate && translate < s.minTranslate()) {
	                return false;
	            }
	            if (!s.params.allowSwipeToPrev && translate > s.translate && translate > s.maxTranslate()) {
	                if ((s.activeIndex || 0) !== slideIndex)
	                    return false;
	            }
	            // Update Index
	            if (typeof speed === 'undefined')
	                speed = s.params.speed;
	            s.previousIndex = s.activeIndex || 0;
	            s.activeIndex = slideIndex;
	            s.updateRealIndex();
	            if ((s.rtl && -translate === s.translate) || (!s.rtl && translate === s.translate)) {
	                // Update Height
	                if (s.params.autoHeight) {
	                    s.updateAutoHeight();
	                }
	                s.updateClasses();
	                if (s.params.effect !== 'slide') {
	                    s.setWrapperTranslate(translate);
	                }
	                return false;
	            }
	            s.updateClasses();
	            s.onTransitionStart(runCallbacks);
	            if (speed === 0 || s.browser.lteIE9) {
	                s.setWrapperTranslate(translate);
	                s.setWrapperTransition(0);
	                s.onTransitionEnd(runCallbacks);
	            }
	            else {
	                s.setWrapperTranslate(translate);
	                s.setWrapperTransition(speed);
	                if (!s.animating) {
	                    s.animating = true;
	                    s.wrapper.transitionEnd(function () {
	                        if (!s)
	                            return;
	                        s.onTransitionEnd(runCallbacks);
	                    });
	                }
	            }
	            return true;
	        };
	        s.onTransitionStart = function (runCallbacks) {
	            if (typeof runCallbacks === 'undefined')
	                runCallbacks = true;
	            if (s.params.autoHeight) {
	                s.updateAutoHeight();
	            }
	            if (s.lazy)
	                s.lazy.onTransitionStart();
	            if (runCallbacks) {
	                s.emit('onTransitionStart', s);
	                if (s.activeIndex !== s.previousIndex) {
	                    s.emit('onSlideChangeStart', s);
	                    if (s.activeIndex > s.previousIndex) {
	                        s.emit('onSlideNextStart', s);
	                    }
	                    else {
	                        s.emit('onSlidePrevStart', s);
	                    }
	                }
	            }
	        };
	        s.onTransitionEnd = function (runCallbacks) {
	            s.animating = false;
	            s.setWrapperTransition(0);
	            if (typeof runCallbacks === 'undefined')
	                runCallbacks = true;
	            if (s.lazy)
	                s.lazy.onTransitionEnd();
	            if (runCallbacks) {
	                s.emit('onTransitionEnd', s);
	                if (s.activeIndex !== s.previousIndex) {
	                    s.emit('onSlideChangeEnd', s);
	                    if (s.activeIndex > s.previousIndex) {
	                        s.emit('onSlideNextEnd', s);
	                    }
	                    else {
	                        s.emit('onSlidePrevEnd', s);
	                    }
	                }
	            }
	            if (s.params.history && s.history) {
	                s.history.setHistory(s.params.history, s.activeIndex);
	            }
	            if (s.params.hashnav && s.hashnav) {
	                s.hashnav.setHash();
	            }
	        };
	        s.slideNext = function (runCallbacks, speed, internal) {
	            if (s.params.loop) {
	                if (s.animating)
	                    return false;
	                s.fixLoop();
	                var clientLeft = s.container[0].clientLeft;
	                return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
	            }
	            else
	                return s.slideTo(s.activeIndex + s.params.slidesPerGroup, speed, runCallbacks, internal);
	        };
	        s._slideNext = function (speed) {
	            return s.slideNext(true, speed, true);
	        };
	        s.slidePrev = function (runCallbacks, speed, internal) {
	            if (s.params.loop) {
	                if (s.animating)
	                    return false;
	                s.fixLoop();
	                var clientLeft = s.container[0].clientLeft;
	                return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
	            }
	            else
	                return s.slideTo(s.activeIndex - 1, speed, runCallbacks, internal);
	        };
	        s._slidePrev = function (speed) {
	            return s.slidePrev(true, speed, true);
	        };
	        s.slideReset = function (runCallbacks, speed, internal) {
	            return s.slideTo(s.activeIndex, speed, runCallbacks);
	        };
	        s.disableTouchControl = function () {
	            s.params.onlyExternal = true;
	            return true;
	        };
	        s.enableTouchControl = function () {
	            s.params.onlyExternal = false;
	            return true;
	        };
	        /*=========================
	          Translate/transition helpers
	          ===========================*/
	        s.setWrapperTransition = function (duration, byController) {
	            s.wrapper.transition(duration);
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                s.effects[s.params.effect].setTransition(duration);
	            }
	            if (s.params.parallax && s.parallax) {
	                s.parallax.setTransition(duration);
	            }
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.setTransition(duration);
	            }
	            if (s.params.control && s.controller) {
	                s.controller.setTransition(duration, byController);
	            }
	            s.emit('onSetTransition', s, duration);
	        };
	        s.setWrapperTranslate = function (translate, updateActiveIndex, byController) {
	            var x = 0, y = 0, z = 0;
	            if (s.isHorizontal()) {
	                x = s.rtl ? -translate : translate;
	            }
	            else {
	                y = translate;
	            }
	            if (s.params.roundLengths) {
	                x = round(x);
	                y = round(y);
	            }
	            if (!s.params.virtualTranslate) {
	                if (s.support.transforms3d)
	                    s.wrapper.transform('translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)');
	                else
	                    s.wrapper.transform('translate(' + x + 'px, ' + y + 'px)');
	            }
	            s.translate = s.isHorizontal() ? x : y;
	            // Check if we need to update progress
	            var progress;
	            var translatesDiff = s.maxTranslate() - s.minTranslate();
	            if (translatesDiff === 0) {
	                progress = 0;
	            }
	            else {
	                progress = (translate - s.minTranslate()) / (translatesDiff);
	            }
	            if (progress !== s.progress) {
	                s.updateProgress(translate);
	            }
	            if (updateActiveIndex)
	                s.updateActiveIndex();
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                s.effects[s.params.effect].setTranslate(s.translate);
	            }
	            if (s.params.parallax && s.parallax) {
	                s.parallax.setTranslate(s.translate);
	            }
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.setTranslate(s.translate);
	            }
	            if (s.params.control && s.controller) {
	                s.controller.setTranslate(s.translate, byController);
	            }
	            s.emit('onSetTranslate', s, s.translate);
	        };
	        s.getTranslate = function (el, axis) {
	            var matrix, curTransform, curStyle, transformMatrix;
	            // automatic axis detection
	            if (typeof axis === 'undefined') {
	                axis = 'x';
	            }
	            if (s.params.virtualTranslate) {
	                return s.rtl ? -s.translate : s.translate;
	            }
	            curStyle = window.getComputedStyle(el, null);
	            if (window.WebKitCSSMatrix) {
	                curTransform = curStyle.transform || curStyle.webkitTransform;
	                if (curTransform.split(',').length > 6) {
	                    curTransform = curTransform.split(', ').map(function (a) {
	                        return a.replace(',', '.');
	                    }).join(', ');
	                }
	                // Some old versions of Webkit choke when 'none' is passed; pass
	                // empty string instead in this case
	                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
	            }
	            else {
	                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
	                matrix = transformMatrix.toString().split(',');
	            }
	            if (axis === 'x') {
	                //Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix)
	                    curTransform = transformMatrix.m41;
	                else if (matrix.length === 16)
	                    curTransform = parseFloat(matrix[12]);
	                else
	                    curTransform = parseFloat(matrix[4]);
	            }
	            if (axis === 'y') {
	                //Latest Chrome and webkits Fix
	                if (window.WebKitCSSMatrix)
	                    curTransform = transformMatrix.m42;
	                else if (matrix.length === 16)
	                    curTransform = parseFloat(matrix[13]);
	                else
	                    curTransform = parseFloat(matrix[5]);
	            }
	            if (s.rtl && curTransform)
	                curTransform = -curTransform;
	            return curTransform || 0;
	        };
	        s.getWrapperTranslate = function (axis) {
	            if (typeof axis === 'undefined') {
	                axis = s.isHorizontal() ? 'x' : 'y';
	            }
	            return s.getTranslate(s.wrapper[0], axis);
	        };
	        /*=========================
	          Observer
	          ===========================*/
	        s.observers = [];
	        function initObserver(target, options) {
	            options = options || {};
	            // create an observer instance
	            var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
	            var observer = new ObserverFunc(function (mutations) {
	                mutations.forEach(function (mutation) {
	                    s.onResize(true);
	                    s.emit('onObserverUpdate', s, mutation);
	                });
	            });
	            observer.observe(target, {
	                attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
	                childList: typeof options.childList === 'undefined' ? true : options.childList,
	                characterData: typeof options.characterData === 'undefined' ? true : options.characterData
	            });
	            s.observers.push(observer);
	        }
	        s.initObservers = function () {
	            if (s.params.observeParents) {
	                var containerParents = s.container.parents();
	                for (var i = 0; i < containerParents.length; i++) {
	                    initObserver(containerParents[i]);
	                }
	            }
	            // Observe container
	            initObserver(s.container[0], { childList: false });
	            // Observe wrapper
	            initObserver(s.wrapper[0], { attributes: false });
	        };
	        s.disconnectObservers = function () {
	            for (var i = 0; i < s.observers.length; i++) {
	                s.observers[i].disconnect();
	            }
	            s.observers = [];
	        };
	        /*=========================
	          Loop
	          ===========================*/
	        // Create looped slides
	        s.createLoop = function () {
	            // Remove duplicated slides
	            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
	            var slides = s.wrapper.children('.' + s.params.slideClass);
	            if (s.params.slidesPerView === 'auto' && !s.params.loopedSlides)
	                s.params.loopedSlides = slides.length;
	            s.loopedSlides = parseInt(s.params.loopedSlides || s.params.slidesPerView, 10);
	            s.loopedSlides = s.loopedSlides + s.params.loopAdditionalSlides;
	            if (s.loopedSlides > slides.length) {
	                s.loopedSlides = slides.length;
	            }
	            var prependSlides = [], appendSlides = [], i;
	            slides.each(function (index, el) {
	                var slide = $(this);
	                if (index < s.loopedSlides)
	                    appendSlides.push(el);
	                if (index < slides.length && index >= slides.length - s.loopedSlides)
	                    prependSlides.push(el);
	                slide.attr('data-swiper-slide-index', index);
	            });
	            for (i = 0; i < appendSlides.length; i++) {
	                s.wrapper.append($(appendSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
	            }
	            for (i = prependSlides.length - 1; i >= 0; i--) {
	                s.wrapper.prepend($(prependSlides[i].cloneNode(true)).addClass(s.params.slideDuplicateClass));
	            }
	        };
	        s.destroyLoop = function () {
	            s.wrapper.children('.' + s.params.slideClass + '.' + s.params.slideDuplicateClass).remove();
	            s.slides.removeAttr('data-swiper-slide-index');
	        };
	        s.reLoop = function (updatePosition) {
	            var oldIndex = s.activeIndex - s.loopedSlides;
	            s.destroyLoop();
	            s.createLoop();
	            s.updateSlidesSize();
	            if (updatePosition) {
	                s.slideTo(oldIndex + s.loopedSlides, 0, false);
	            }
	        };
	        s.fixLoop = function () {
	            var newIndex;
	            //Fix For Negative Oversliding
	            if (s.activeIndex < s.loopedSlides) {
	                newIndex = s.slides.length - s.loopedSlides * 3 + s.activeIndex;
	                newIndex = newIndex + s.loopedSlides;
	                s.slideTo(newIndex, 0, false, true);
	            }
	            else if ((s.params.slidesPerView === 'auto' && s.activeIndex >= s.loopedSlides * 2) || (s.activeIndex > s.slides.length - s.params.slidesPerView * 2)) {
	                newIndex = -s.slides.length + s.activeIndex + s.loopedSlides;
	                newIndex = newIndex + s.loopedSlides;
	                s.slideTo(newIndex, 0, false, true);
	            }
	        };
	        /*=========================
	          Append/Prepend/Remove Slides
	          ===========================*/
	        s.appendSlide = function (slides) {
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            if (typeof slides === 'object' && slides.length) {
	                for (var i = 0; i < slides.length; i++) {
	                    if (slides[i])
	                        s.wrapper.append(slides[i]);
	                }
	            }
	            else {
	                s.wrapper.append(slides);
	            }
	            if (s.params.loop) {
	                s.createLoop();
	            }
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	        };
	        s.prependSlide = function (slides) {
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            var newActiveIndex = s.activeIndex + 1;
	            if (typeof slides === 'object' && slides.length) {
	                for (var i = 0; i < slides.length; i++) {
	                    if (slides[i])
	                        s.wrapper.prepend(slides[i]);
	                }
	                newActiveIndex = s.activeIndex + slides.length;
	            }
	            else {
	                s.wrapper.prepend(slides);
	            }
	            if (s.params.loop) {
	                s.createLoop();
	            }
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	            s.slideTo(newActiveIndex, 0, false);
	        };
	        s.removeSlide = function (slidesIndexes) {
	            if (s.params.loop) {
	                s.destroyLoop();
	                s.slides = s.wrapper.children('.' + s.params.slideClass);
	            }
	            var newActiveIndex = s.activeIndex, indexToRemove;
	            if (typeof slidesIndexes === 'object' && slidesIndexes.length) {
	                for (var i = 0; i < slidesIndexes.length; i++) {
	                    indexToRemove = slidesIndexes[i];
	                    if (s.slides[indexToRemove])
	                        s.slides.eq(indexToRemove).remove();
	                    if (indexToRemove < newActiveIndex)
	                        newActiveIndex--;
	                }
	                newActiveIndex = Math.max(newActiveIndex, 0);
	            }
	            else {
	                indexToRemove = slidesIndexes;
	                if (s.slides[indexToRemove])
	                    s.slides.eq(indexToRemove).remove();
	                if (indexToRemove < newActiveIndex)
	                    newActiveIndex--;
	                newActiveIndex = Math.max(newActiveIndex, 0);
	            }
	            if (s.params.loop) {
	                s.createLoop();
	            }
	            if (!(s.params.observer && s.support.observer)) {
	                s.update(true);
	            }
	            if (s.params.loop) {
	                s.slideTo(newActiveIndex + s.loopedSlides, 0, false);
	            }
	            else {
	                s.slideTo(newActiveIndex, 0, false);
	            }
	        };
	        s.removeAllSlides = function () {
	            var slidesIndexes = [];
	            for (var i = 0; i < s.slides.length; i++) {
	                slidesIndexes.push(i);
	            }
	            s.removeSlide(slidesIndexes);
	        };
	        /*=========================
	          Effects
	          ===========================*/
	        s.effects = {
	            fade: {
	                setTranslate: function () {
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var offset = slide[0].swiperSlideOffset;
	                        var tx = -offset;
	                        if (!s.params.virtualTranslate)
	                            tx = tx - s.translate;
	                        var ty = 0;
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                        }
	                        var slideOpacity = s.params.fade.crossFade ?
	                            Math.max(1 - Math.abs(slide[0].progress), 0) :
	                            1 + Math.min(Math.max(slide[0].progress, -1), 0);
	                        slide
	                            .css({
	                            opacity: slideOpacity
	                        })
	                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px)');
	                    }
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration);
	                    if (s.params.virtualTranslate && duration !== 0) {
	                        var eventTriggered = false;
	                        s.slides.transitionEnd(function () {
	                            if (eventTriggered)
	                                return;
	                            if (!s)
	                                return;
	                            eventTriggered = true;
	                            s.animating = false;
	                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
	                            for (var i = 0; i < triggerEvents.length; i++) {
	                                s.wrapper.trigger(triggerEvents[i]);
	                            }
	                        });
	                    }
	                }
	            },
	            flip: {
	                setTranslate: function () {
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var progress = slide[0].progress;
	                        if (s.params.flip.limitRotation) {
	                            progress = Math.max(Math.min(slide[0].progress, 1), -1);
	                        }
	                        var offset = slide[0].swiperSlideOffset;
	                        var rotate = -180 * progress, rotateY = rotate, rotateX = 0, tx = -offset, ty = 0;
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                            rotateX = -rotateY;
	                            rotateY = 0;
	                        }
	                        else if (s.rtl) {
	                            rotateY = -rotateY;
	                        }
	                        slide[0].style.zIndex = -Math.abs(Math.round(progress)) + s.slides.length;
	                        if (s.params.flip.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length)
	                                shadowBefore[0].style.opacity = Math.max(-progress, 0);
	                            if (shadowAfter.length)
	                                shadowAfter[0].style.opacity = Math.max(progress, 0);
	                        }
	                        slide
	                            .transform('translate3d(' + tx + 'px, ' + ty + 'px, 0px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)');
	                    }
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                    if (s.params.virtualTranslate && duration !== 0) {
	                        var eventTriggered = false;
	                        s.slides.eq(s.activeIndex).transitionEnd(function () {
	                            if (eventTriggered)
	                                return;
	                            if (!s)
	                                return;
	                            if (!$(this).hasClass(s.params.slideActiveClass))
	                                return;
	                            eventTriggered = true;
	                            s.animating = false;
	                            var triggerEvents = ['webkitTransitionEnd', 'transitionend', 'oTransitionEnd', 'MSTransitionEnd', 'msTransitionEnd'];
	                            for (var i = 0; i < triggerEvents.length; i++) {
	                                s.wrapper.trigger(triggerEvents[i]);
	                            }
	                        });
	                    }
	                }
	            },
	            cube: {
	                setTranslate: function () {
	                    var wrapperRotate = 0, cubeShadow;
	                    if (s.params.cube.shadow) {
	                        if (s.isHorizontal()) {
	                            cubeShadow = s.wrapper.find('.swiper-cube-shadow');
	                            if (cubeShadow.length === 0) {
	                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
	                                s.wrapper.append(cubeShadow);
	                            }
	                            cubeShadow.css({ height: s.width + 'px' });
	                        }
	                        else {
	                            cubeShadow = s.container.find('.swiper-cube-shadow');
	                            if (cubeShadow.length === 0) {
	                                cubeShadow = $('<div class="swiper-cube-shadow"></div>');
	                                s.container.append(cubeShadow);
	                            }
	                        }
	                    }
	                    for (var i = 0; i < s.slides.length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideAngle = i * 90;
	                        var round = Math.floor(slideAngle / 360);
	                        if (s.rtl) {
	                            slideAngle = -slideAngle;
	                            round = Math.floor(-slideAngle / 360);
	                        }
	                        var progress = Math.max(Math.min(slide[0].progress, 1), -1);
	                        var tx = 0, ty = 0, tz = 0;
	                        if (i % 4 === 0) {
	                            tx = -round * 4 * s.size;
	                            tz = 0;
	                        }
	                        else if ((i - 1) % 4 === 0) {
	                            tx = 0;
	                            tz = -round * 4 * s.size;
	                        }
	                        else if ((i - 2) % 4 === 0) {
	                            tx = s.size + round * 4 * s.size;
	                            tz = s.size;
	                        }
	                        else if ((i - 3) % 4 === 0) {
	                            tx = -s.size;
	                            tz = 3 * s.size + s.size * 4 * round;
	                        }
	                        if (s.rtl) {
	                            tx = -tx;
	                        }
	                        if (!s.isHorizontal()) {
	                            ty = tx;
	                            tx = 0;
	                        }
	                        var transform = 'rotateX(' + (s.isHorizontal() ? 0 : -slideAngle) + 'deg) rotateY(' + (s.isHorizontal() ? slideAngle : 0) + 'deg) translate3d(' + tx + 'px, ' + ty + 'px, ' + tz + 'px)';
	                        if (progress <= 1 && progress > -1) {
	                            wrapperRotate = i * 90 + progress * 90;
	                            if (s.rtl)
	                                wrapperRotate = -i * 90 - progress * 90;
	                        }
	                        slide.transform(transform);
	                        if (s.params.cube.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length)
	                                shadowBefore[0].style.opacity = Math.max(-progress, 0);
	                            if (shadowAfter.length)
	                                shadowAfter[0].style.opacity = Math.max(progress, 0);
	                        }
	                    }
	                    s.wrapper.css({
	                        '-webkit-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        '-moz-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        '-ms-transform-origin': '50% 50% -' + (s.size / 2) + 'px',
	                        'transform-origin': '50% 50% -' + (s.size / 2) + 'px'
	                    });
	                    if (s.params.cube.shadow) {
	                        if (s.isHorizontal()) {
	                            cubeShadow.transform('translate3d(0px, ' + (s.width / 2 + s.params.cube.shadowOffset) + 'px, ' + (-s.width / 2) + 'px) rotateX(90deg) rotateZ(0deg) scale(' + (s.params.cube.shadowScale) + ')');
	                        }
	                        else {
	                            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
	                            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
	                            var scale1 = s.params.cube.shadowScale, scale2 = s.params.cube.shadowScale / multiplier, offset = s.params.cube.shadowOffset;
	                            cubeShadow.transform('scale3d(' + scale1 + ', 1, ' + scale2 + ') translate3d(0px, ' + (s.height / 2 + offset) + 'px, ' + (-s.height / 2 / scale2) + 'px) rotateX(-90deg)');
	                        }
	                    }
	                    var zFactor = (s.isSafari || s.isUiWebView) ? (-s.size / 2) : 0;
	                    s.wrapper.transform('translate3d(0px,0,' + zFactor + 'px) rotateX(' + (s.isHorizontal() ? 0 : wrapperRotate) + 'deg) rotateY(' + (s.isHorizontal() ? -wrapperRotate : 0) + 'deg)');
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                    if (s.params.cube.shadow && !s.isHorizontal()) {
	                        s.container.find('.swiper-cube-shadow').transition(duration);
	                    }
	                }
	            },
	            coverflow: {
	                setTranslate: function () {
	                    var transform = s.translate;
	                    var center = s.isHorizontal() ? -transform + s.width / 2 : -transform + s.height / 2;
	                    var rotate = s.isHorizontal() ? s.params.coverflow.rotate : -s.params.coverflow.rotate;
	                    var translate = s.params.coverflow.depth;
	                    //Each slide offset from center
	                    for (var i = 0, length = s.slides.length; i < length; i++) {
	                        var slide = s.slides.eq(i);
	                        var slideSize = s.slidesSizesGrid[i];
	                        var slideOffset = slide[0].swiperSlideOffset;
	                        var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * s.params.coverflow.modifier;
	                        var rotateY = s.isHorizontal() ? rotate * offsetMultiplier : 0;
	                        var rotateX = s.isHorizontal() ? 0 : rotate * offsetMultiplier;
	                        // var rotateZ = 0
	                        var translateZ = -translate * Math.abs(offsetMultiplier);
	                        var translateY = s.isHorizontal() ? 0 : s.params.coverflow.stretch * (offsetMultiplier);
	                        var translateX = s.isHorizontal() ? s.params.coverflow.stretch * (offsetMultiplier) : 0;
	                        //Fix for ultra small values
	                        if (Math.abs(translateX) < 0.001)
	                            translateX = 0;
	                        if (Math.abs(translateY) < 0.001)
	                            translateY = 0;
	                        if (Math.abs(translateZ) < 0.001)
	                            translateZ = 0;
	                        if (Math.abs(rotateY) < 0.001)
	                            rotateY = 0;
	                        if (Math.abs(rotateX) < 0.001)
	                            rotateX = 0;
	                        var slideTransform = 'translate3d(' + translateX + 'px,' + translateY + 'px,' + translateZ + 'px)  rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg)';
	                        slide.transform(slideTransform);
	                        slide[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
	                        if (s.params.coverflow.slideShadows) {
	                            //Set shadows
	                            var shadowBefore = s.isHorizontal() ? slide.find('.swiper-slide-shadow-left') : slide.find('.swiper-slide-shadow-top');
	                            var shadowAfter = s.isHorizontal() ? slide.find('.swiper-slide-shadow-right') : slide.find('.swiper-slide-shadow-bottom');
	                            if (shadowBefore.length === 0) {
	                                shadowBefore = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'left' : 'top') + '"></div>');
	                                slide.append(shadowBefore);
	                            }
	                            if (shadowAfter.length === 0) {
	                                shadowAfter = $('<div class="swiper-slide-shadow-' + (s.isHorizontal() ? 'right' : 'bottom') + '"></div>');
	                                slide.append(shadowAfter);
	                            }
	                            if (shadowBefore.length)
	                                shadowBefore[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
	                            if (shadowAfter.length)
	                                shadowAfter[0].style.opacity = (-offsetMultiplier) > 0 ? -offsetMultiplier : 0;
	                        }
	                    }
	                    //Set correct perspective for IE10
	                    if (s.browser.ie) {
	                        var ws = s.wrapper[0].style;
	                        ws.perspectiveOrigin = center + 'px 50%';
	                    }
	                },
	                setTransition: function (duration) {
	                    s.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
	                }
	            }
	        };
	        /*=========================
	          Images Lazy Loading
	          ===========================*/
	        s.lazy = {
	            initialImageLoaded: false,
	            loadImageInSlide: function (index, loadInDuplicate) {
	                if (typeof index === 'undefined')
	                    return;
	                if (typeof loadInDuplicate === 'undefined')
	                    loadInDuplicate = true;
	                if (s.slides.length === 0)
	                    return;
	                var slide = s.slides.eq(index);
	                var img = slide.find('.' + s.params.lazyLoadingClass + ':not(.' + s.params.lazyStatusLoadedClass + '):not(.' + s.params.lazyStatusLoadingClass + ')');
	                if (slide.hasClass(s.params.lazyLoadingClass) && !slide.hasClass(s.params.lazyStatusLoadedClass) && !slide.hasClass(s.params.lazyStatusLoadingClass)) {
	                    img = img.add(slide[0]);
	                }
	                if (img.length === 0)
	                    return;
	                img.each(function () {
	                    var _img = $(this);
	                    _img.addClass(s.params.lazyStatusLoadingClass);
	                    var background = _img.attr('data-background');
	                    var src = _img.attr('data-src'), srcset = _img.attr('data-srcset'), sizes = _img.attr('data-sizes');
	                    s.loadImage(_img[0], (src || background), srcset, sizes, false, function () {
	                        if (typeof s === 'undefined' || s === null || !s)
	                            return;
	                        if (background) {
	                            _img.css('background-image', 'url("' + background + '")');
	                            _img.removeAttr('data-background');
	                        }
	                        else {
	                            if (srcset) {
	                                _img.attr('srcset', srcset);
	                                _img.removeAttr('data-srcset');
	                            }
	                            if (sizes) {
	                                _img.attr('sizes', sizes);
	                                _img.removeAttr('data-sizes');
	                            }
	                            if (src) {
	                                _img.attr('src', src);
	                                _img.removeAttr('data-src');
	                            }
	                        }
	                        _img.addClass(s.params.lazyStatusLoadedClass).removeClass(s.params.lazyStatusLoadingClass);
	                        slide.find('.' + s.params.lazyPreloaderClass + ', .' + s.params.preloaderClass).remove();
	                        if (s.params.loop && loadInDuplicate) {
	                            var slideOriginalIndex = slide.attr('data-swiper-slide-index');
	                            if (slide.hasClass(s.params.slideDuplicateClass)) {
	                                var originalSlide = s.wrapper.children('[data-swiper-slide-index="' + slideOriginalIndex + '"]:not(.' + s.params.slideDuplicateClass + ')');
	                                s.lazy.loadImageInSlide(originalSlide.index(), false);
	                            }
	                            else {
	                                var duplicatedSlide = s.wrapper.children('.' + s.params.slideDuplicateClass + '[data-swiper-slide-index="' + slideOriginalIndex + '"]');
	                                s.lazy.loadImageInSlide(duplicatedSlide.index(), false);
	                            }
	                        }
	                        s.emit('onLazyImageReady', s, slide[0], _img[0]);
	                    });
	                    s.emit('onLazyImageLoad', s, slide[0], _img[0]);
	                });
	            },
	            load: function () {
	                var i;
	                var slidesPerView = s.params.slidesPerView;
	                if (slidesPerView === 'auto') {
	                    slidesPerView = 0;
	                }
	                if (!s.lazy.initialImageLoaded)
	                    s.lazy.initialImageLoaded = true;
	                if (s.params.watchSlidesVisibility) {
	                    s.wrapper.children('.' + s.params.slideVisibleClass).each(function () {
	                        s.lazy.loadImageInSlide($(this).index());
	                    });
	                }
	                else {
	                    if (slidesPerView > 1) {
	                        for (i = s.activeIndex; i < s.activeIndex + slidesPerView; i++) {
	                            if (s.slides[i])
	                                s.lazy.loadImageInSlide(i);
	                        }
	                    }
	                    else {
	                        s.lazy.loadImageInSlide(s.activeIndex);
	                    }
	                }
	                if (s.params.lazyLoadingInPrevNext) {
	                    if (slidesPerView > 1 || (s.params.lazyLoadingInPrevNextAmount && s.params.lazyLoadingInPrevNextAmount > 1)) {
	                        var amount = s.params.lazyLoadingInPrevNextAmount;
	                        var spv = slidesPerView;
	                        var maxIndex = Math.min(s.activeIndex + spv + Math.max(amount, spv), s.slides.length);
	                        var minIndex = Math.max(s.activeIndex - Math.max(spv, amount), 0);
	                        // Next Slides
	                        for (i = s.activeIndex + slidesPerView; i < maxIndex; i++) {
	                            if (s.slides[i])
	                                s.lazy.loadImageInSlide(i);
	                        }
	                        // Prev Slides
	                        for (i = minIndex; i < s.activeIndex; i++) {
	                            if (s.slides[i])
	                                s.lazy.loadImageInSlide(i);
	                        }
	                    }
	                    else {
	                        var nextSlide = s.wrapper.children('.' + s.params.slideNextClass);
	                        if (nextSlide.length > 0)
	                            s.lazy.loadImageInSlide(nextSlide.index());
	                        var prevSlide = s.wrapper.children('.' + s.params.slidePrevClass);
	                        if (prevSlide.length > 0)
	                            s.lazy.loadImageInSlide(prevSlide.index());
	                    }
	                }
	            },
	            onTransitionStart: function () {
	                if (s.params.lazyLoading) {
	                    if (s.params.lazyLoadingOnTransitionStart || (!s.params.lazyLoadingOnTransitionStart && !s.lazy.initialImageLoaded)) {
	                        s.lazy.load();
	                    }
	                }
	            },
	            onTransitionEnd: function () {
	                if (s.params.lazyLoading && !s.params.lazyLoadingOnTransitionStart) {
	                    s.lazy.load();
	                }
	            }
	        };
	        /*=========================
	          Scrollbar
	          ===========================*/
	        s.scrollbar = {
	            isTouched: false,
	            setDragPosition: function (e) {
	                var sb = s.scrollbar;
	                var x = 0, y = 0;
	                var translate;
	                var pointerPosition = s.isHorizontal() ?
	                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageX : e.pageX || e.clientX) :
	                    ((e.type === 'touchstart' || e.type === 'touchmove') ? e.targetTouches[0].pageY : e.pageY || e.clientY);
	                var position = (pointerPosition) - sb.track.offset()[s.isHorizontal() ? 'left' : 'top'] - sb.dragSize / 2;
	                var positionMin = -s.minTranslate() * sb.moveDivider;
	                var positionMax = -s.maxTranslate() * sb.moveDivider;
	                if (position < positionMin) {
	                    position = positionMin;
	                }
	                else if (position > positionMax) {
	                    position = positionMax;
	                }
	                position = -position / sb.moveDivider;
	                s.updateProgress(position);
	                s.setWrapperTranslate(position, true);
	            },
	            dragStart: function (e) {
	                var sb = s.scrollbar;
	                sb.isTouched = true;
	                e.preventDefault();
	                e.stopPropagation();
	                sb.setDragPosition(e);
	                clearTimeout(sb.dragTimeout);
	                sb.track.transition(0);
	                if (s.params.scrollbarHide) {
	                    sb.track.css('opacity', 1);
	                }
	                s.wrapper.transition(100);
	                sb.drag.transition(100);
	                s.emit('onScrollbarDragStart', s);
	            },
	            dragMove: function (e) {
	                var sb = s.scrollbar;
	                if (!sb.isTouched)
	                    return;
	                if (e.preventDefault)
	                    e.preventDefault();
	                else
	                    e.returnValue = false;
	                sb.setDragPosition(e);
	                s.wrapper.transition(0);
	                sb.track.transition(0);
	                sb.drag.transition(0);
	                s.emit('onScrollbarDragMove', s);
	            },
	            dragEnd: function (e) {
	                var sb = s.scrollbar;
	                if (!sb.isTouched)
	                    return;
	                sb.isTouched = false;
	                if (s.params.scrollbarHide) {
	                    clearTimeout(sb.dragTimeout);
	                    sb.dragTimeout = setTimeout(function () {
	                        sb.track.css('opacity', 0);
	                        sb.track.transition(400);
	                    }, 1000);
	                }
	                s.emit('onScrollbarDragEnd', s);
	                if (s.params.scrollbarSnapOnRelease) {
	                    s.slideReset();
	                }
	            },
	            draggableEvents: (function () {
	                if ((s.params.simulateTouch === false && !s.support.touch))
	                    return s.touchEventsDesktop;
	                else
	                    return s.touchEvents;
	            })(),
	            enableDraggable: function () {
	                var sb = s.scrollbar;
	                var target = s.support.touch ? sb.track : document;
	                $(sb.track).on(sb.draggableEvents.start, sb.dragStart);
	                $(target).on(sb.draggableEvents.move, sb.dragMove);
	                $(target).on(sb.draggableEvents.end, sb.dragEnd);
	            },
	            disableDraggable: function () {
	                var sb = s.scrollbar;
	                var target = s.support.touch ? sb.track : document;
	                $(sb.track).off(sb.draggableEvents.start, sb.dragStart);
	                $(target).off(sb.draggableEvents.move, sb.dragMove);
	                $(target).off(sb.draggableEvents.end, sb.dragEnd);
	            },
	            set: function () {
	                if (!s.params.scrollbar)
	                    return;
	                var sb = s.scrollbar;
	                sb.track = $(s.params.scrollbar);
	                if (s.params.uniqueNavElements && typeof s.params.scrollbar === 'string' && sb.track.length > 1 && s.container.find(s.params.scrollbar).length === 1) {
	                    sb.track = s.container.find(s.params.scrollbar);
	                }
	                sb.drag = sb.track.find('.swiper-scrollbar-drag');
	                if (sb.drag.length === 0) {
	                    sb.drag = $('<div class="swiper-scrollbar-drag"></div>');
	                    sb.track.append(sb.drag);
	                }
	                sb.drag[0].style.width = '';
	                sb.drag[0].style.height = '';
	                sb.trackSize = s.isHorizontal() ? sb.track[0].offsetWidth : sb.track[0].offsetHeight;
	                sb.divider = s.size / s.virtualSize;
	                sb.moveDivider = sb.divider * (sb.trackSize / s.size);
	                sb.dragSize = sb.trackSize * sb.divider;
	                if (s.isHorizontal()) {
	                    sb.drag[0].style.width = sb.dragSize + 'px';
	                }
	                else {
	                    sb.drag[0].style.height = sb.dragSize + 'px';
	                }
	                if (sb.divider >= 1) {
	                    sb.track[0].style.display = 'none';
	                }
	                else {
	                    sb.track[0].style.display = '';
	                }
	                if (s.params.scrollbarHide) {
	                    sb.track[0].style.opacity = 0;
	                }
	            },
	            setTranslate: function () {
	                if (!s.params.scrollbar)
	                    return;
	                var diff;
	                var sb = s.scrollbar;
	                var translate = s.translate || 0;
	                var newPos;
	                var newSize = sb.dragSize;
	                newPos = (sb.trackSize - sb.dragSize) * s.progress;
	                if (s.rtl && s.isHorizontal()) {
	                    newPos = -newPos;
	                    if (newPos > 0) {
	                        newSize = sb.dragSize - newPos;
	                        newPos = 0;
	                    }
	                    else if (-newPos + sb.dragSize > sb.trackSize) {
	                        newSize = sb.trackSize + newPos;
	                    }
	                }
	                else {
	                    if (newPos < 0) {
	                        newSize = sb.dragSize + newPos;
	                        newPos = 0;
	                    }
	                    else if (newPos + sb.dragSize > sb.trackSize) {
	                        newSize = sb.trackSize - newPos;
	                    }
	                }
	                if (s.isHorizontal()) {
	                    if (s.support.transforms3d) {
	                        sb.drag.transform('translate3d(' + (newPos) + 'px, 0, 0)');
	                    }
	                    else {
	                        sb.drag.transform('translateX(' + (newPos) + 'px)');
	                    }
	                    sb.drag[0].style.width = newSize + 'px';
	                }
	                else {
	                    if (s.support.transforms3d) {
	                        sb.drag.transform('translate3d(0px, ' + (newPos) + 'px, 0)');
	                    }
	                    else {
	                        sb.drag.transform('translateY(' + (newPos) + 'px)');
	                    }
	                    sb.drag[0].style.height = newSize + 'px';
	                }
	                if (s.params.scrollbarHide) {
	                    clearTimeout(sb.timeout);
	                    sb.track[0].style.opacity = 1;
	                    sb.timeout = setTimeout(function () {
	                        sb.track[0].style.opacity = 0;
	                        sb.track.transition(400);
	                    }, 1000);
	                }
	            },
	            setTransition: function (duration) {
	                if (!s.params.scrollbar)
	                    return;
	                s.scrollbar.drag.transition(duration);
	            }
	        };
	        /*=========================
	          Controller
	          ===========================*/
	        s.controller = {
	            LinearSpline: function (x, y) {
	                var binarySearch = (function () {
	                    var maxIndex, minIndex, guess;
	                    return function (array, val) {
	                        minIndex = -1;
	                        maxIndex = array.length;
	                        while (maxIndex - minIndex > 1)
	                            if (array[guess = maxIndex + minIndex >> 1] <= val) {
	                                minIndex = guess;
	                            }
	                            else {
	                                maxIndex = guess;
	                            }
	                        return maxIndex;
	                    };
	                })();
	                this.x = x;
	                this.y = y;
	                this.lastIndex = x.length - 1;
	                // Given an x value (x2), return the expected y2 value:
	                // (x1,y1) is the known point before given value,
	                // (x3,y3) is the known point after given value.
	                var i1, i3;
	                var l = this.x.length;
	                this.interpolate = function (x2) {
	                    if (!x2)
	                        return 0;
	                    // Get the indexes of x1 and x3 (the array indexes before and after given x2):
	                    i3 = binarySearch(this.x, x2);
	                    i1 = i3 - 1;
	                    // We have our indexes i1 & i3, so we can calculate already:
	                    // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
	                    return ((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1];
	                };
	            },
	            //xxx: for now i will just save one spline function to to
	            getInterpolateFunction: function (c) {
	                if (!s.controller.spline)
	                    s.controller.spline = s.params.loop ?
	                        new s.controller.LinearSpline(s.slidesGrid, c.slidesGrid) :
	                        new s.controller.LinearSpline(s.snapGrid, c.snapGrid);
	            },
	            setTranslate: function (translate, byController) {
	                var controlled = s.params.control;
	                var multiplier, controlledTranslate;
	                function setControlledTranslate(c) {
	                    // this will create an Interpolate function based on the snapGrids
	                    // x is the Grid of the scrolled scroller and y will be the controlled scroller
	                    // it makes sense to create this only once and recall it for the interpolation
	                    // the function does a lot of value caching for performance
	                    translate = c.rtl && c.params.direction === 'horizontal' ? -s.translate : s.translate;
	                    if (s.params.controlBy === 'slide') {
	                        s.controller.getInterpolateFunction(c);
	                        // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
	                        // but it did not work out
	                        controlledTranslate = -s.controller.spline.interpolate(-translate);
	                    }
	                    if (!controlledTranslate || s.params.controlBy === 'container') {
	                        multiplier = (c.maxTranslate() - c.minTranslate()) / (s.maxTranslate() - s.minTranslate());
	                        controlledTranslate = (translate - s.minTranslate()) * multiplier + c.minTranslate();
	                    }
	                    if (s.params.controlInverse) {
	                        controlledTranslate = c.maxTranslate() - controlledTranslate;
	                    }
	                    c.updateProgress(controlledTranslate);
	                    c.setWrapperTranslate(controlledTranslate, false, s);
	                    c.updateActiveIndex();
	                }
	                if (Array.isArray(controlled)) {
	                    for (var i = 0; i < controlled.length; i++) {
	                        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	                            setControlledTranslate(controlled[i]);
	                        }
	                    }
	                }
	                else if (controlled instanceof Swiper && byController !== controlled) {
	                    setControlledTranslate(controlled);
	                }
	            },
	            setTransition: function (duration, byController) {
	                var controlled = s.params.control;
	                var i;
	                function setControlledTransition(c) {
	                    c.setWrapperTransition(duration, s);
	                    if (duration !== 0) {
	                        c.onTransitionStart();
	                        c.wrapper.transitionEnd(function () {
	                            if (!controlled)
	                                return;
	                            if (c.params.loop && s.params.controlBy === 'slide') {
	                                c.fixLoop();
	                            }
	                            c.onTransitionEnd();
	                        });
	                    }
	                }
	                if (Array.isArray(controlled)) {
	                    for (i = 0; i < controlled.length; i++) {
	                        if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
	                            setControlledTransition(controlled[i]);
	                        }
	                    }
	                }
	                else if (controlled instanceof Swiper && byController !== controlled) {
	                    setControlledTransition(controlled);
	                }
	            }
	        };
	        /*=========================
	          Parallax
	          ===========================*/
	        function setParallaxTransform(el, progress) {
	            el = $(el);
	            var p, pX, pY;
	            var rtlFactor = s.rtl ? -1 : 1;
	            p = el.attr('data-swiper-parallax') || '0';
	            pX = el.attr('data-swiper-parallax-x');
	            pY = el.attr('data-swiper-parallax-y');
	            if (pX || pY) {
	                pX = pX || '0';
	                pY = pY || '0';
	            }
	            else {
	                if (s.isHorizontal()) {
	                    pX = p;
	                    pY = '0';
	                }
	                else {
	                    pY = p;
	                    pX = '0';
	                }
	            }
	            if ((pX).indexOf('%') >= 0) {
	                pX = parseInt(pX, 10) * progress * rtlFactor + '%';
	            }
	            else {
	                pX = pX * progress * rtlFactor + 'px';
	            }
	            if ((pY).indexOf('%') >= 0) {
	                pY = parseInt(pY, 10) * progress + '%';
	            }
	            else {
	                pY = pY * progress + 'px';
	            }
	            el.transform('translate3d(' + pX + ', ' + pY + ',0px)');
	        }
	        s.parallax = {
	            setTranslate: function () {
	                s.container.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
	                    setParallaxTransform(this, s.progress);
	                });
	                s.slides.each(function () {
	                    var slide = $(this);
	                    slide.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
	                        var progress = Math.min(Math.max(slide[0].progress, -1), 1);
	                        setParallaxTransform(this, progress);
	                    });
	                });
	            },
	            setTransition: function (duration) {
	                if (typeof duration === 'undefined')
	                    duration = s.params.speed;
	                s.container.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]').each(function () {
	                    var el = $(this);
	                    var parallaxDuration = parseInt(el.attr('data-swiper-parallax-duration'), 10) || duration;
	                    if (duration === 0)
	                        parallaxDuration = 0;
	                    el.transition(parallaxDuration);
	                });
	            }
	        };
	        /*=========================
	          Zoom
	          ===========================*/
	        s.zoom = {
	            // "Global" Props
	            scale: 1,
	            currentScale: 1,
	            isScaling: false,
	            gesture: {
	                slide: undefined,
	                slideWidth: undefined,
	                slideHeight: undefined,
	                image: undefined,
	                imageWrap: undefined,
	                zoomMax: s.params.zoomMax
	            },
	            image: {
	                isTouched: undefined,
	                isMoved: undefined,
	                currentX: undefined,
	                currentY: undefined,
	                minX: undefined,
	                minY: undefined,
	                maxX: undefined,
	                maxY: undefined,
	                width: undefined,
	                height: undefined,
	                startX: undefined,
	                startY: undefined,
	                touchesStart: {},
	                touchesCurrent: {}
	            },
	            velocity: {
	                x: undefined,
	                y: undefined,
	                prevPositionX: undefined,
	                prevPositionY: undefined,
	                prevTime: undefined
	            },
	            // Calc Scale From Multi-touches
	            getDistanceBetweenTouches: function (e) {
	                if (e.targetTouches.length < 2)
	                    return 1;
	                var x1 = e.targetTouches[0].pageX, y1 = e.targetTouches[0].pageY, x2 = e.targetTouches[1].pageX, y2 = e.targetTouches[1].pageY;
	                var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
	                return distance;
	            },
	            // Events
	            onGestureStart: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
	                        return;
	                    }
	                    z.gesture.scaleStart = z.getDistanceBetweenTouches(e);
	                }
	                if (!z.gesture.slide || !z.gesture.slide.length) {
	                    z.gesture.slide = $(this);
	                    if (z.gesture.slide.length === 0)
	                        z.gesture.slide = s.slides.eq(s.activeIndex);
	                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
	                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
	                    z.gesture.zoomMax = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;
	                    if (z.gesture.imageWrap.length === 0) {
	                        z.gesture.image = undefined;
	                        return;
	                    }
	                }
	                z.gesture.image.transition(0);
	                z.isScaling = true;
	            },
	            onGestureChange: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
	                        return;
	                    }
	                    z.gesture.scaleMove = z.getDistanceBetweenTouches(e);
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0)
	                    return;
	                if (s.support.gestures) {
	                    z.scale = e.scale * z.currentScale;
	                }
	                else {
	                    z.scale = (z.gesture.scaleMove / z.gesture.scaleStart) * z.currentScale;
	                }
	                if (z.scale > z.gesture.zoomMax) {
	                    z.scale = z.gesture.zoomMax - 1 + Math.pow((z.scale - z.gesture.zoomMax + 1), 0.5);
	                }
	                if (z.scale < s.params.zoomMin) {
	                    z.scale = s.params.zoomMin + 1 - Math.pow((s.params.zoomMin - z.scale + 1), 0.5);
	                }
	                z.gesture.image.transform('translate3d(0,0,0) scale(' + z.scale + ')');
	            },
	            onGestureEnd: function (e) {
	                var z = s.zoom;
	                if (!s.support.gestures) {
	                    if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2) {
	                        return;
	                    }
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0)
	                    return;
	                z.scale = Math.max(Math.min(z.scale, z.gesture.zoomMax), s.params.zoomMin);
	                z.gesture.image.transition(s.params.speed).transform('translate3d(0,0,0) scale(' + z.scale + ')');
	                z.currentScale = z.scale;
	                z.isScaling = false;
	                if (z.scale === 1)
	                    z.gesture.slide = undefined;
	            },
	            onTouchStart: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0)
	                    return;
	                if (z.image.isTouched)
	                    return;
	                if (s.device.os === 'android')
	                    e.preventDefault();
	                z.image.isTouched = true;
	                z.image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
	                z.image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
	            },
	            onTouchMove: function (e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0)
	                    return;
	                s.allowClick = false;
	                if (!z.image.isTouched || !z.gesture.slide)
	                    return;
	                if (!z.image.isMoved) {
	                    z.image.width = z.gesture.image[0].offsetWidth;
	                    z.image.height = z.gesture.image[0].offsetHeight;
	                    z.image.startX = s.getTranslate(z.gesture.imageWrap[0], 'x') || 0;
	                    z.image.startY = s.getTranslate(z.gesture.imageWrap[0], 'y') || 0;
	                    z.gesture.slideWidth = z.gesture.slide[0].offsetWidth;
	                    z.gesture.slideHeight = z.gesture.slide[0].offsetHeight;
	                    z.gesture.imageWrap.transition(0);
	                    if (s.rtl)
	                        z.image.startX = -z.image.startX;
	                    if (s.rtl)
	                        z.image.startY = -z.image.startY;
	                }
	                // Define if we need image drag
	                var scaledWidth = z.image.width * z.scale;
	                var scaledHeight = z.image.height * z.scale;
	                if (scaledWidth < z.gesture.slideWidth && scaledHeight < z.gesture.slideHeight)
	                    return;
	                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
	                z.image.maxX = -z.image.minX;
	                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
	                z.image.maxY = -z.image.minY;
	                z.image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
	                z.image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
	                if (!z.image.isMoved && !z.isScaling) {
	                    if (s.isHorizontal() &&
	                        (Math.floor(z.image.minX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x < z.image.touchesStart.x) ||
	                        (Math.floor(z.image.maxX) === Math.floor(z.image.startX) && z.image.touchesCurrent.x > z.image.touchesStart.x)) {
	                        z.image.isTouched = false;
	                        return;
	                    }
	                    else if (!s.isHorizontal() &&
	                        (Math.floor(z.image.minY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y < z.image.touchesStart.y) ||
	                        (Math.floor(z.image.maxY) === Math.floor(z.image.startY) && z.image.touchesCurrent.y > z.image.touchesStart.y)) {
	                        z.image.isTouched = false;
	                        return;
	                    }
	                }
	                e.preventDefault();
	                e.stopPropagation();
	                z.image.isMoved = true;
	                z.image.currentX = z.image.touchesCurrent.x - z.image.touchesStart.x + z.image.startX;
	                z.image.currentY = z.image.touchesCurrent.y - z.image.touchesStart.y + z.image.startY;
	                if (z.image.currentX < z.image.minX) {
	                    z.image.currentX = z.image.minX + 1 - Math.pow((z.image.minX - z.image.currentX + 1), 0.8);
	                }
	                if (z.image.currentX > z.image.maxX) {
	                    z.image.currentX = z.image.maxX - 1 + Math.pow((z.image.currentX - z.image.maxX + 1), 0.8);
	                }
	                if (z.image.currentY < z.image.minY) {
	                    z.image.currentY = z.image.minY + 1 - Math.pow((z.image.minY - z.image.currentY + 1), 0.8);
	                }
	                if (z.image.currentY > z.image.maxY) {
	                    z.image.currentY = z.image.maxY - 1 + Math.pow((z.image.currentY - z.image.maxY + 1), 0.8);
	                }
	                //Velocity
	                if (!z.velocity.prevPositionX)
	                    z.velocity.prevPositionX = z.image.touchesCurrent.x;
	                if (!z.velocity.prevPositionY)
	                    z.velocity.prevPositionY = z.image.touchesCurrent.y;
	                if (!z.velocity.prevTime)
	                    z.velocity.prevTime = Date.now();
	                z.velocity.x = (z.image.touchesCurrent.x - z.velocity.prevPositionX) / (Date.now() - z.velocity.prevTime) / 2;
	                z.velocity.y = (z.image.touchesCurrent.y - z.velocity.prevPositionY) / (Date.now() - z.velocity.prevTime) / 2;
	                if (Math.abs(z.image.touchesCurrent.x - z.velocity.prevPositionX) < 2)
	                    z.velocity.x = 0;
	                if (Math.abs(z.image.touchesCurrent.y - z.velocity.prevPositionY) < 2)
	                    z.velocity.y = 0;
	                z.velocity.prevPositionX = z.image.touchesCurrent.x;
	                z.velocity.prevPositionY = z.image.touchesCurrent.y;
	                z.velocity.prevTime = Date.now();
	                z.gesture.imageWrap.transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
	            },
	            onTouchEnd: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.image || z.gesture.image.length === 0)
	                    return;
	                if (!z.image.isTouched || !z.image.isMoved) {
	                    z.image.isTouched = false;
	                    z.image.isMoved = false;
	                    return;
	                }
	                z.image.isTouched = false;
	                z.image.isMoved = false;
	                var momentumDurationX = 300;
	                var momentumDurationY = 300;
	                var momentumDistanceX = z.velocity.x * momentumDurationX;
	                var newPositionX = z.image.currentX + momentumDistanceX;
	                var momentumDistanceY = z.velocity.y * momentumDurationY;
	                var newPositionY = z.image.currentY + momentumDistanceY;
	                //Fix duration
	                if (z.velocity.x !== 0)
	                    momentumDurationX = Math.abs((newPositionX - z.image.currentX) / z.velocity.x);
	                if (z.velocity.y !== 0)
	                    momentumDurationY = Math.abs((newPositionY - z.image.currentY) / z.velocity.y);
	                var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
	                z.image.currentX = newPositionX;
	                z.image.currentY = newPositionY;
	                // Define if we need image drag
	                var scaledWidth = z.image.width * z.scale;
	                var scaledHeight = z.image.height * z.scale;
	                z.image.minX = Math.min((z.gesture.slideWidth / 2 - scaledWidth / 2), 0);
	                z.image.maxX = -z.image.minX;
	                z.image.minY = Math.min((z.gesture.slideHeight / 2 - scaledHeight / 2), 0);
	                z.image.maxY = -z.image.minY;
	                z.image.currentX = Math.max(Math.min(z.image.currentX, z.image.maxX), z.image.minX);
	                z.image.currentY = Math.max(Math.min(z.image.currentY, z.image.maxY), z.image.minY);
	                z.gesture.imageWrap.transition(momentumDuration).transform('translate3d(' + z.image.currentX + 'px, ' + z.image.currentY + 'px,0)');
	            },
	            onTransitionEnd: function (s) {
	                var z = s.zoom;
	                if (z.gesture.slide && s.previousIndex !== s.activeIndex) {
	                    z.gesture.image.transform('translate3d(0,0,0) scale(1)');
	                    z.gesture.imageWrap.transform('translate3d(0,0,0)');
	                    z.gesture.slide = z.gesture.image = z.gesture.imageWrap = undefined;
	                    z.scale = z.currentScale = 1;
	                }
	            },
	            // Toggle Zoom
	            toggleZoom: function (s, e) {
	                var z = s.zoom;
	                if (!z.gesture.slide) {
	                    z.gesture.slide = s.clickedSlide ? $(s.clickedSlide) : s.slides.eq(s.activeIndex);
	                    z.gesture.image = z.gesture.slide.find('img, svg, canvas');
	                    z.gesture.imageWrap = z.gesture.image.parent('.' + s.params.zoomContainerClass);
	                }
	                if (!z.gesture.image || z.gesture.image.length === 0)
	                    return;
	                var touchX, touchY, offsetX, offsetY, diffX, diffY, translateX, translateY, imageWidth, imageHeight, scaledWidth, scaledHeight, translateMinX, translateMinY, translateMaxX, translateMaxY, slideWidth, slideHeight;
	                if (typeof z.image.touchesStart.x === 'undefined' && e) {
	                    touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
	                    touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
	                }
	                else {
	                    touchX = z.image.touchesStart.x;
	                    touchY = z.image.touchesStart.y;
	                }
	                if (z.scale && z.scale !== 1) {
	                    // Zoom Out
	                    z.scale = z.currentScale = 1;
	                    z.gesture.imageWrap.transition(300).transform('translate3d(0,0,0)');
	                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(1)');
	                    z.gesture.slide = undefined;
	                }
	                else {
	                    // Zoom In
	                    z.scale = z.currentScale = z.gesture.imageWrap.attr('data-swiper-zoom') || s.params.zoomMax;
	                    if (e) {
	                        slideWidth = z.gesture.slide[0].offsetWidth;
	                        slideHeight = z.gesture.slide[0].offsetHeight;
	                        offsetX = z.gesture.slide.offset().left;
	                        offsetY = z.gesture.slide.offset().top;
	                        diffX = offsetX + slideWidth / 2 - touchX;
	                        diffY = offsetY + slideHeight / 2 - touchY;
	                        imageWidth = z.gesture.image[0].offsetWidth;
	                        imageHeight = z.gesture.image[0].offsetHeight;
	                        scaledWidth = imageWidth * z.scale;
	                        scaledHeight = imageHeight * z.scale;
	                        translateMinX = Math.min((slideWidth / 2 - scaledWidth / 2), 0);
	                        translateMinY = Math.min((slideHeight / 2 - scaledHeight / 2), 0);
	                        translateMaxX = -translateMinX;
	                        translateMaxY = -translateMinY;
	                        translateX = diffX * z.scale;
	                        translateY = diffY * z.scale;
	                        if (translateX < translateMinX) {
	                            translateX = translateMinX;
	                        }
	                        if (translateX > translateMaxX) {
	                            translateX = translateMaxX;
	                        }
	                        if (translateY < translateMinY) {
	                            translateY = translateMinY;
	                        }
	                        if (translateY > translateMaxY) {
	                            translateY = translateMaxY;
	                        }
	                    }
	                    else {
	                        translateX = 0;
	                        translateY = 0;
	                    }
	                    z.gesture.imageWrap.transition(300).transform('translate3d(' + translateX + 'px, ' + translateY + 'px,0)');
	                    z.gesture.image.transition(300).transform('translate3d(0,0,0) scale(' + z.scale + ')');
	                }
	            },
	            // Attach/Detach Events
	            attachEvents: function (detach) {
	                var action = detach ? 'off' : 'on';
	                if (s.params.zoom) {
	                    var target = s.slides;
	                    var passiveListener = s.touchEvents.start === 'touchstart' && s.support.passiveListener && s.params.passiveListeners ? { passive: true, capture: false } : false;
	                    // Scale image
	                    if (s.support.gestures) {
	                        s.slides[action]('gesturestart', s.zoom.onGestureStart, passiveListener);
	                        s.slides[action]('gesturechange', s.zoom.onGestureChange, passiveListener);
	                        s.slides[action]('gestureend', s.zoom.onGestureEnd, passiveListener);
	                    }
	                    else if (s.touchEvents.start === 'touchstart') {
	                        s.slides[action](s.touchEvents.start, s.zoom.onGestureStart, passiveListener);
	                        s.slides[action](s.touchEvents.move, s.zoom.onGestureChange, passiveListener);
	                        s.slides[action](s.touchEvents.end, s.zoom.onGestureEnd, passiveListener);
	                    }
	                    // Move image
	                    s[action]('touchStart', s.zoom.onTouchStart);
	                    s.slides.each(function (index, slide) {
	                        if ($(slide).find('.' + s.params.zoomContainerClass).length > 0) {
	                            $(slide)[action](s.touchEvents.move, s.zoom.onTouchMove);
	                        }
	                    });
	                    s[action]('touchEnd', s.zoom.onTouchEnd);
	                    // Scale Out
	                    s[action]('transitionEnd', s.zoom.onTransitionEnd);
	                    if (s.params.zoomToggle) {
	                        s.on('doubleTap', s.zoom.toggleZoom);
	                    }
	                }
	            },
	            init: function () {
	                s.zoom.attachEvents();
	            },
	            destroy: function () {
	                s.zoom.attachEvents(true);
	            }
	        };
	        /*=========================
	          Plugins API. Collect all and init all plugins
	          ===========================*/
	        s._plugins = [];
	        for (var plugin in s.plugins) {
	            var p = s.plugins[plugin](s, s.params[plugin]);
	            if (p)
	                s._plugins.push(p);
	        }
	        // Method to call all plugins event/method
	        s.callPlugins = function (eventName) {
	            for (var i = 0; i < s._plugins.length; i++) {
	                if (eventName in s._plugins[i]) {
	                    s._plugins[i][eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	                }
	            }
	        };
	        /*=========================
	          Events/Callbacks/Plugins Emitter
	          ===========================*/
	        function normalizeEventName(eventName) {
	            if (eventName.indexOf('on') !== 0) {
	                if (eventName[0] !== eventName[0].toUpperCase()) {
	                    eventName = 'on' + eventName[0].toUpperCase() + eventName.substring(1);
	                }
	                else {
	                    eventName = 'on' + eventName;
	                }
	            }
	            return eventName;
	        }
	        s.emitterEventListeners = {};
	        s.emit = function (eventName) {
	            // Trigger callbacks
	            if (s.params[eventName]) {
	                s.params[eventName](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	            }
	            var i;
	            // Trigger events
	            if (s.emitterEventListeners[eventName]) {
	                for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
	                    s.emitterEventListeners[eventName][i](arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	                }
	            }
	            // Trigger plugins
	            if (s.callPlugins)
	                s.callPlugins(eventName, arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
	        };
	        s.on = function (eventName, handler) {
	            eventName = normalizeEventName(eventName);
	            if (!s.emitterEventListeners[eventName])
	                s.emitterEventListeners[eventName] = [];
	            s.emitterEventListeners[eventName].push(handler);
	            return s;
	        };
	        s.off = function (eventName, handler) {
	            var i;
	            eventName = normalizeEventName(eventName);
	            if (typeof handler === 'undefined') {
	                // Remove all handlers for such event
	                s.emitterEventListeners[eventName] = [];
	                return s;
	            }
	            if (!s.emitterEventListeners[eventName] || s.emitterEventListeners[eventName].length === 0)
	                return;
	            for (i = 0; i < s.emitterEventListeners[eventName].length; i++) {
	                if (s.emitterEventListeners[eventName][i] === handler)
	                    s.emitterEventListeners[eventName].splice(i, 1);
	            }
	            return s;
	        };
	        s.once = function (eventName, handler) {
	            eventName = normalizeEventName(eventName);
	            var _handler = function () {
	                handler(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
	                s.off(eventName, _handler);
	            };
	            s.on(eventName, _handler);
	            return s;
	        };
	        // Accessibility tools
	        s.a11y = {
	            makeFocusable: function ($el) {
	                $el.attr('tabIndex', '0');
	                return $el;
	            },
	            addRole: function ($el, role) {
	                $el.attr('role', role);
	                return $el;
	            },
	            addLabel: function ($el, label) {
	                $el.attr('aria-label', label);
	                return $el;
	            },
	            disable: function ($el) {
	                $el.attr('aria-disabled', true);
	                return $el;
	            },
	            enable: function ($el) {
	                $el.attr('aria-disabled', false);
	                return $el;
	            },
	            onEnterKey: function (event) {
	                if (event.keyCode !== 13)
	                    return;
	                if ($(event.target).is(s.params.nextButton)) {
	                    s.onClickNext(event);
	                    if (s.isEnd) {
	                        s.a11y.notify(s.params.lastSlideMessage);
	                    }
	                    else {
	                        s.a11y.notify(s.params.nextSlideMessage);
	                    }
	                }
	                else if ($(event.target).is(s.params.prevButton)) {
	                    s.onClickPrev(event);
	                    if (s.isBeginning) {
	                        s.a11y.notify(s.params.firstSlideMessage);
	                    }
	                    else {
	                        s.a11y.notify(s.params.prevSlideMessage);
	                    }
	                }
	                if ($(event.target).is('.' + s.params.bulletClass)) {
	                    $(event.target)[0].click();
	                }
	            },
	            liveRegion: $('<span class="' + s.params.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>'),
	            notify: function (message) {
	                var notification = s.a11y.liveRegion;
	                if (notification.length === 0)
	                    return;
	                notification.html('');
	                notification.html(message);
	            },
	            init: function () {
	                // Setup accessibility
	                if (s.params.nextButton && s.nextButton && s.nextButton.length > 0) {
	                    s.a11y.makeFocusable(s.nextButton);
	                    s.a11y.addRole(s.nextButton, 'button');
	                    s.a11y.addLabel(s.nextButton, s.params.nextSlideMessage);
	                }
	                if (s.params.prevButton && s.prevButton && s.prevButton.length > 0) {
	                    s.a11y.makeFocusable(s.prevButton);
	                    s.a11y.addRole(s.prevButton, 'button');
	                    s.a11y.addLabel(s.prevButton, s.params.prevSlideMessage);
	                }
	                $(s.container).append(s.a11y.liveRegion);
	            },
	            initPagination: function () {
	                if (s.params.pagination && s.params.paginationClickable && s.bullets && s.bullets.length) {
	                    s.bullets.each(function () {
	                        var bullet = $(this);
	                        s.a11y.makeFocusable(bullet);
	                        s.a11y.addRole(bullet, 'button');
	                        s.a11y.addLabel(bullet, s.params.paginationBulletMessage.replace(/{{index}}/, bullet.index() + 1));
	                    });
	                }
	            },
	            destroy: function () {
	                if (s.a11y.liveRegion && s.a11y.liveRegion.length > 0)
	                    s.a11y.liveRegion.remove();
	            }
	        };
	        /*=========================
	          Init/Destroy
	          ===========================*/
	        s.init = function () {
	            if (s.params.loop)
	                s.createLoop();
	            s.updateContainerSize();
	            s.updateSlidesSize();
	            s.updatePagination();
	            if (s.params.scrollbar && s.scrollbar) {
	                s.scrollbar.set();
	                if (s.params.scrollbarDraggable) {
	                    s.scrollbar.enableDraggable();
	                }
	            }
	            if (s.params.effect !== 'slide' && s.effects[s.params.effect]) {
	                if (!s.params.loop)
	                    s.updateProgress();
	                s.effects[s.params.effect].setTranslate();
	            }
	            if (s.params.loop) {
	                s.slideTo(s.params.initialSlide + s.loopedSlides, 0, s.params.runCallbacksOnInit);
	            }
	            else {
	                s.slideTo(s.params.initialSlide, 0, s.params.runCallbacksOnInit);
	                if (s.params.initialSlide === 0) {
	                    if (s.parallax && s.params.parallax)
	                        s.parallax.setTranslate();
	                    if (s.lazy && s.params.lazyLoading) {
	                        s.lazy.load();
	                        s.lazy.initialImageLoaded = true;
	                    }
	                }
	            }
	            s.attachEvents();
	            if (s.params.observer && s.support.observer) {
	                s.initObservers();
	            }
	            if (s.params.preloadImages && !s.params.lazyLoading) {
	                s.preloadImages();
	            }
	            if (s.params.zoom && s.zoom) {
	                s.zoom.init();
	            }
	            if (s.params.autoplay) {
	                s.startAutoplay();
	            }
	            if (s.params.keyboardControl) {
	                if (s.enableKeyboardControl)
	                    s.enableKeyboardControl();
	            }
	            if (s.params.mousewheelControl) {
	                if (s.enableMousewheelControl)
	                    s.enableMousewheelControl();
	            }
	            // Deprecated hashnavReplaceState changed to replaceState for use in hashnav and history
	            if (s.params.hashnavReplaceState) {
	                s.params.replaceState = s.params.hashnavReplaceState;
	            }
	            if (s.params.history) {
	                if (s.history)
	                    s.history.init();
	            }
	            if (s.params.hashnav) {
	                if (s.hashnav)
	                    s.hashnav.init();
	            }
	            if (s.params.a11y && s.a11y)
	                s.a11y.init();
	            s.emit('onInit', s);
	        };
	        // Cleanup dynamic styles
	        s.cleanupStyles = function () {
	            // Container
	            s.container.removeClass(s.classNames.join(' ')).removeAttr('style');
	            // Wrapper
	            s.wrapper.removeAttr('style');
	            // Slides
	            if (s.slides && s.slides.length) {
	                s.slides
	                    .removeClass([
	                    s.params.slideVisibleClass,
	                    s.params.slideActiveClass,
	                    s.params.slideNextClass,
	                    s.params.slidePrevClass
	                ].join(' '))
	                    .removeAttr('style')
	                    .removeAttr('data-swiper-column')
	                    .removeAttr('data-swiper-row');
	            }
	            // Pagination/Bullets
	            if (s.paginationContainer && s.paginationContainer.length) {
	                s.paginationContainer.removeClass(s.params.paginationHiddenClass);
	            }
	            if (s.bullets && s.bullets.length) {
	                s.bullets.removeClass(s.params.bulletActiveClass);
	            }
	            // Buttons
	            if (s.params.prevButton)
	                $(s.params.prevButton).removeClass(s.params.buttonDisabledClass);
	            if (s.params.nextButton)
	                $(s.params.nextButton).removeClass(s.params.buttonDisabledClass);
	            // Scrollbar
	            if (s.params.scrollbar && s.scrollbar) {
	                if (s.scrollbar.track && s.scrollbar.track.length)
	                    s.scrollbar.track.removeAttr('style');
	                if (s.scrollbar.drag && s.scrollbar.drag.length)
	                    s.scrollbar.drag.removeAttr('style');
	            }
	        };
	        // Destroy
	        s.destroy = function (deleteInstance, cleanupStyles) {
	            // Detach evebts
	            s.detachEvents();
	            // Stop autoplay
	            s.stopAutoplay();
	            // Disable draggable
	            if (s.params.scrollbar && s.scrollbar) {
	                if (s.params.scrollbarDraggable) {
	                    s.scrollbar.disableDraggable();
	                }
	            }
	            // Destroy loop
	            if (s.params.loop) {
	                s.destroyLoop();
	            }
	            // Cleanup styles
	            if (cleanupStyles) {
	                s.cleanupStyles();
	            }
	            // Disconnect observer
	            s.disconnectObservers();
	            // Destroy zoom
	            if (s.params.zoom && s.zoom) {
	                s.zoom.destroy();
	            }
	            // Disable keyboard/mousewheel
	            if (s.params.keyboardControl) {
	                if (s.disableKeyboardControl)
	                    s.disableKeyboardControl();
	            }
	            if (s.params.mousewheelControl) {
	                if (s.disableMousewheelControl)
	                    s.disableMousewheelControl();
	            }
	            // Disable a11y
	            if (s.params.a11y && s.a11y)
	                s.a11y.destroy();
	            // Delete history popstate
	            if (s.params.history && !s.params.replaceState) {
	                window.removeEventListener('popstate', s.history.setHistoryPopState);
	            }
	            if (s.params.hashnav && s.hashnav) {
	                s.hashnav.destroy();
	            }
	            // Destroy callback
	            s.emit('onDestroy');
	            // Delete instance
	            if (deleteInstance !== false)
	                s = null;
	        };
	        s.init();
	        // Return swiper instance
	        return s;
	    };
	    /*==================================================
	        Prototype
	    ====================================================*/
	    Swiper.prototype = {
	        isSafari: (function () {
	            var ua = window.navigator.userAgent.toLowerCase();
	            return (ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0);
	        })(),
	        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent),
	        isArray: function (arr) {
	            return Object.prototype.toString.apply(arr) === '[object Array]';
	        },
	        /*==================================================
	        Browser
	        ====================================================*/
	        browser: {
	            ie: window.navigator.pointerEnabled || window.navigator.msPointerEnabled,
	            ieTouch: (window.navigator.msPointerEnabled && window.navigator.msMaxTouchPoints > 1) || (window.navigator.pointerEnabled && window.navigator.maxTouchPoints > 1),
	            lteIE9: (function () {
	                // create temporary DIV
	                var div = document.createElement('div');
	                // add content to tmp DIV which is wrapped into the IE HTML conditional statement
	                div.innerHTML = '<!--[if lte IE 9]><i></i><![endif]-->';
	                // return true / false value based on what will browser render
	                return div.getElementsByTagName('i').length === 1;
	            })()
	        },
	        /*==================================================
	        Devices
	        ====================================================*/
	        device: (function () {
	            var ua = window.navigator.userAgent;
	            var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	            var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	            var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
	            return {
	                ios: ipad || iphone || ipod,
	                android: android
	            };
	        })(),
	        /*==================================================
	        Feature Detection
	        ====================================================*/
	        support: {
	            touch: (window.Modernizr && Modernizr.touch === true) || (function () {
	                return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
	            })(),
	            transforms3d: (window.Modernizr && Modernizr.csstransforms3d === true) || (function () {
	                var div = document.createElement('div').style;
	                return ('webkitPerspective' in div || 'MozPerspective' in div || 'OPerspective' in div || 'MsPerspective' in div || 'perspective' in div);
	            })(),
	            flexbox: (function () {
	                var div = document.createElement('div').style;
	                var styles = ('alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient').split(' ');
	                for (var i = 0; i < styles.length; i++) {
	                    if (styles[i] in div)
	                        return true;
	                }
	            })(),
	            observer: (function () {
	                return ('MutationObserver' in window || 'WebkitMutationObserver' in window);
	            })(),
	            passiveListener: (function () {
	                var supportsPassive = false;
	                try {
	                    var opts = Object.defineProperty({}, 'passive', {
	                        get: function () {
	                            supportsPassive = true;
	                        }
	                    });
	                    window.addEventListener('testPassiveListener', null, opts);
	                }
	                catch (e) { }
	                return supportsPassive;
	            })(),
	            gestures: (function () {
	                return 'ongesturestart' in window;
	            })()
	        },
	        /*==================================================
	        Plugins
	        ====================================================*/
	        plugins: {}
	    };
	})();
	//# sourceMappingURL=framework7.js.map
	
	//# sourceMappingURL=Framework7.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 82 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(184);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(546);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(545);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.arrayMove = arrayMove;
	exports.omit = omit;
	exports.closest = closest;
	exports.limit = limit;
	exports.getElementMargin = getElementMargin;
	exports.provideDisplayName = provideDisplayName;
	function arrayMove(arr, previousIndex, newIndex) {
	  var array = arr.slice(0);
	  if (newIndex >= array.length) {
	    var k = newIndex - array.length;
	    while (k-- + 1) {
	      array.push(undefined);
	    }
	  }
	  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
	  return array;
	}
	
	function omit(obj) {
	  for (var _len = arguments.length, keysToOmit = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    keysToOmit[_key - 1] = arguments[_key];
	  }
	
	  return Object.keys(obj).reduce(function (acc, key) {
	    if (keysToOmit.indexOf(key) === -1) acc[key] = obj[key];
	    return acc;
	  }, {});
	}
	
	var events = exports.events = {
	  start: ['touchstart', 'mousedown'],
	  move: ['touchmove', 'mousemove'],
	  end: ['touchend', 'touchcancel', 'mouseup']
	};
	
	var vendorPrefix = exports.vendorPrefix = function () {
	  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
	  // fix for:
	  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	  //    window.getComputedStyle() returns null inside an iframe with display: none
	  // in this case return an array with a fake mozilla style in it.
	  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
	  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];
	
	  switch (pre) {
	    case 'ms':
	      return 'ms';
	    default:
	      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
	  }
	}();
	
	function closest(el, fn) {
	  while (el) {
	    if (fn(el)) return el;
	    el = el.parentNode;
	  }
	}
	
	function limit(min, max, value) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	function getCSSPixelValue(stringValue) {
	  if (stringValue.substr(-2) === 'px') {
	    return parseFloat(stringValue);
	  }
	  return 0;
	}
	
	function getElementMargin(element) {
	  var style = window.getComputedStyle(element);
	
	  return {
	    top: getCSSPixelValue(style.marginTop),
	    right: getCSSPixelValue(style.marginRight),
	    bottom: getCSSPixelValue(style.marginBottom),
	    left: getCSSPixelValue(style.marginLeft)
	  };
	}
	
	function provideDisplayName(prefix, Component) {
	  var componentName = Component.displayName || Component.name;
	
	  return componentName ? prefix + '(' + componentName + ')' : prefix;
	}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formDataSelector = exports.filteredRestaurantsSelector = exports.bookingAvailabilitySelector = exports.pickerTimeSelector = exports.rushSlotsMapSelector = exports.rushSlotsForRestaurantSelector = exports.slotsAvailableSelector = exports.bookingRushResturantsSelector = exports.pickerSelectedSeatsIsPlus = exports.pickerSeatsSelector = exports.availableSpotsSelector = exports.maxPeopleSelector = exports.currentSlotSelector = exports.restaurantById = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reselect = __webpack_require__(18);
	
	var _location = __webpack_require__(50);
	
	var _location2 = _interopRequireDefault(_location);
	
	var _restaurant = __webpack_require__(194);
	
	var _restaurant2 = _interopRequireDefault(_restaurant);
	
	var _time = __webpack_require__(20);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _voucher = __webpack_require__(33);
	
	var _voucher2 = _interopRequireDefault(_voucher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var BOOKING_PICKER_SEATS_PLUS = '+';
	
	var restaurantById = exports.restaurantById = function restaurantById(restaurants, restaurantId) {
	  return _lodash2.default.find(restaurants, { id: restaurantId });
	};
	
	var currentRestaurantSelector = function currentRestaurantSelector(state) {
	  var restaurant = state.booking.targetRestaurant;
	  if (restaurant) return restaurant.id;
	  return null;
	};
	
	var currentSlotSelector = exports.currentSlotSelector = (0, _reselect.createSelector)(function (state) {
	  return state.booking && state.booking.date;
	}, function (state) {
	  return state.booking.time;
	}, function (date, time) {
	  if (!date || !date.slots || !time) {
	    return null;
	  }
	  return _lodash2.default.find(date.slots, { open: time });
	});
	
	var maxPeopleSelector = exports.maxPeopleSelector = (0, _reselect.createSelector)(function (state) {
	  return state.booking.verifiedBookingRush;
	}, function (state) {
	  var bookingRush = state.app.bookingRush;
	
	  return bookingRush && bookingRush.constraints.maxPeople;
	}, function (state) {
	  return state.app.config.booking.constraints.maxPeople;
	}, function (hasBookingRushes, brMaxPeople, bMaxPeople) {
	  return hasBookingRushes ? brMaxPeople : bMaxPeople;
	});
	
	var availableSpotsSelector = exports.availableSpotsSelector = (0, _reselect.createSelector)([currentSlotSelector, maxPeopleSelector], function (slot, maxPeople) {
	  if (!slot) {
	    return null;
	  }
	  return Math.min(maxPeople, slot.availableSpots);
	});
	
	var pickerSeatsSelector = exports.pickerSeatsSelector = (0, _reselect.createSelector)([availableSpotsSelector], function (availableSpots) {
	  if (availableSpots === null) {
	    return null;
	  }
	  var maxPlus = availableSpots + ' ' + BOOKING_PICKER_SEATS_PLUS;
	  if (availableSpots === 1) {
	    return [{ value: 1, label: 1 }];
	  }
	  var values = _lodash2.default.map(_lodash2.default.range(1, availableSpots + 1), function (n) {
	    return {
	      value: n,
	      label: n
	    };
	  });
	  return [].concat(_toConsumableArray(values), [{ value: maxPlus, label: maxPlus }]);
	});
	
	var pickerSelectedSeatsIsPlus = exports.pickerSelectedSeatsIsPlus = (0, _reselect.createSelector)(function (state) {
	  return state.booking.seats;
	}, function (seats) {
	  if (!seats || typeof seats !== 'string') {
	    return false;
	  }
	  return seats.indexOf(BOOKING_PICKER_SEATS_PLUS) > -1;
	});
	
	var bookingRushResturantsSelector = exports.bookingRushResturantsSelector = (0, _reselect.createSelector)(function (state) {
	  return state.app.bookingRush;
	}, function (bookingRush) {
	  return bookingRush ? bookingRush.restaurants : [];
	});
	
	/* filter slots by seats availability */
	var slotsAvailableSelector = exports.slotsAvailableSelector = (0, _reselect.createSelector)(function (state) {
	  return state.booking && state.booking.date;
	}, function (date) {
	  if (!date || !date.slots) {
	    return [];
	  }
	  return date.slots.filter(function (s) {
	    return s.availableSpots > 0;
	  });
	});
	
	var rushSlotsForRestaurantSelector = exports.rushSlotsForRestaurantSelector = (0, _reselect.createSelector)([bookingRushResturantsSelector, function (state) {
	  if (!state.booking.targetRestaurant) {
	    return null;
	  }
	  return state.booking.targetRestaurant.id;
	}], function (restaurants, targetRestaurantId) {
	  var restaurantData = _lodash2.default.find(restaurants, { restaurant: { id: targetRestaurantId } });
	  if (!restaurantData) {
	    return null;
	  }
	  return restaurantData.slots;
	});
	
	var rushSlotsMapSelector = exports.rushSlotsMapSelector = (0, _reselect.createSelector)([rushSlotsForRestaurantSelector], function (slotsForBookingRush) {
	  return _lodash2.default.reduce(slotsForBookingRush, function (acc, x) {
	    return _extends({}, acc, _defineProperty({}, x.open, true));
	  }, {});
	});
	
	var pickerTimeSelector = exports.pickerTimeSelector = function pickerTimeSelector(localizedLabels) {
	  return (0, _reselect.createSelector)([rushSlotsMapSelector, slotsAvailableSelector, function (state) {
	    return state.booking ? state.booking.hasBookingRushes : false;
	  }, function (state) {
	    var bookingRush = state.app.bookingRush;
	    return bookingRush ? _voucher2.default.format(bookingRush.voucher, localizedLabels).subtitle : '';
	  }], function (rushSlotsMap, slotsAvailableSpots, hasBookingRushes, voucherMessage) {
	    var slots = _lodash2.default.map(slotsAvailableSpots, function (s) {
	      var extraInfo = hasBookingRushes && rushSlotsMap[s.open] ? '(' + voucherMessage + ')' : '';
	      return {
	        label: s.open + ' ' + extraInfo,
	        value: s.open
	      };
	    });
	    return slots;
	  });
	};
	
	var bookingAvailabilitySelector = exports.bookingAvailabilitySelector = function bookingAvailabilitySelector(targetRestaurantSelector) {
	  return (0, _reselect.createSelector)(function (state) {
	    return state.app.merchant.restaurants;
	  }, function (state) {
	    return state.booking.availability;
	  }, targetRestaurantSelector || currentRestaurantSelector, function (restaurants, availability, restaurantId) {
	    if (!restaurantId) {
	      return [];
	    }
	
	    var targetRestaurant = restaurantById(restaurants, restaurantId);
	
	    var mapDays = _lodash2.default.reduce(targetRestaurant.openingTimes, function (acc, x) {
	      return _extends({}, acc, _defineProperty({}, x.day, x.open));
	    }, {});
	
	    var target = _lodash2.default.find(availability, { id: restaurantId });
	
	    if (!target) {
	      return [];
	    }
	
	    var bookingAvailability = target.bookingAvailability;
	
	
	    if (!bookingAvailability) {
	      return [];
	    }
	
	    var filterByAvailableSpots = function filterByAvailableSpots(slot) {
	      return slot.availableSpots > 0;
	    };
	
	    return _lodash2.default.map(bookingAvailability, function (availabilityDay) {
	      return _extends({}, availabilityDay, {
	        open: mapDays[availabilityDay.day],
	        hasAvailableSpots: _lodash2.default.some(availabilityDay.slots, filterByAvailableSpots)
	      });
	    });
	  });
	};
	
	var filteredRestaurantsSelector = exports.filteredRestaurantsSelector = (0, _reselect.createSelector)(function (state) {
	  return state.app.merchant.restaurants;
	}, function (state) {
	  return state.booking.userLocation;
	}, function (state) {
	  return state.app.bookingRush;
	}, function (restaurants, userLocation, bookingRush) {
	  var data = _lodash2.default.map(restaurants, function (r) {
	    var hasBookingRushes = bookingRush && !_time2.default.isDateExpired(bookingRush.expirationDate) && _lodash2.default.filter(bookingRush.restaurants, { restaurant: { id: r.id } }).length > 0;
	    return _extends({}, r, {
	      hasBookingRushes: hasBookingRushes,
	      availableForBooking: _restaurant2.default.hasOnlineService(r, 'booking'),
	      distance: userLocation ? _location2.default.distanceBetweenPoints(userLocation, {
	        lat: r.location.latitude,
	        lng: r.location.longitude }) : null
	    });
	  });
	  var cmpKey = userLocation ? 'distance' : 'address';
	  return data.sort(function (r1, r2) {
	    return r1[cmpKey] > r2[cmpKey];
	  });
	});
	
	var formDataSelector = exports.formDataSelector = (0, _reselect.createSelector)(function (state) {
	  return state.booking.formData;
	}, function (state) {
	  return state.user.currentUser;
	}, function (formData) {
	  var user = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return _extends({}, _lodash2.default.pick(user, ['name', 'lastName', 'email']), formData);
	});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.restaurantsCoordinatesMedian = exports.currentOrderSelector = exports.orderTypeSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__(18);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(24);
	
	var _time = __webpack_require__(20);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var orderTypeSelector = exports.orderTypeSelector = (0, _reselect.createSelector)(function (state, props) {
	  return props.params;
	}, function (state) {
	  return state.order;
	}, function (params, orderState) {
	  if (!params) {
	    // if there are url params, we're in the widget
	    // otherwise we're in native app
	    return orderState.orderType;
	  }
	  return params.orderType;
	});
	
	var currentOrderSelector = exports.currentOrderSelector = (0, _reselect.createSelector)(function (state) {
	  return state.order;
	}, orderTypeSelector, function (state) {
	  return state.user.currentUser ? state.user.currentUser.orders : [];
	}, function (state) {
	  return state.user.archivedOrderId;
	}, function (order, orderType, archivedOrders, archivedOrderId) {
	  if (archivedOrderId) {
	    var archived = _lodash2.default.find(archivedOrders, { id: archivedOrderId });
	    var orderDate = archived.status === _constants.ORDER_STATUS_CONFIRMED ? archived.confirmation.date : archived.date;
	    var timeDate = _time2.default.splitISO(orderDate);
	    return _extends({}, archived, {
	      cart: archived.items,
	      orderType: archived.type,
	      deliveryDate: timeDate.date,
	      deliveryTime: timeDate.time
	    });
	  }
	  return _extends({}, order, { orderType: orderType });
	});
	
	var median = function median(xMin, xMax) {
	  return xMin + (xMax - xMin) / 2;
	};
	
	var restaurantsCoordinatesMedian = exports.restaurantsCoordinatesMedian = (0, _reselect.createSelector)(function (state) {
	  return state.app.merchant.restaurants;
	}, function (restaurants) {
	  if (restaurants.length === 1) {
	    return {
	      lat: restaurants[0].location.latitude,
	      lng: restaurants[0].location.longitude
	    };
	  }
	  var defaultVal = { min: 999999, max: -999999 };
	  var extr = restaurants.reduce(function (prev, res) {
	    return {
	      lat: {
	        min: Math.min(prev.lat.min, res.location.latitude),
	        max: Math.max(prev.lat.max, res.location.latitude)
	      },
	      lng: {
	        min: Math.min(prev.lng.min, res.location.longitude),
	        max: Math.max(prev.lng.max, res.location.longitude)
	      }
	    };
	  }, { lat: defaultVal, lng: defaultVal });
	
	  return {
	    lat: median(extr.lat.max, extr.lat.min),
	    lng: median(extr.lng.max, extr.lng.min)
	  };
	});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports.__esModule = true;
	exports.addTypenameToDocument = addTypenameToDocument;
	exports.argumentsObjectFromField = argumentsObjectFromField;
	exports.assign = assign;
	exports.buildQueryFromSelectionSet = buildQueryFromSelectionSet;
	exports.checkDocument = checkDocument;
	exports.cloneDeep = cloneDeep;
	exports.createFragmentMap = createFragmentMap;
	exports.getDefaultValues = getDefaultValues;
	exports.getDirectiveInfoFromField = getDirectiveInfoFromField;
	exports.getDirectiveNames = getDirectiveNames;
	exports.getDirectivesFromDocument = getDirectivesFromDocument;
	exports.getEnv = getEnv;
	exports.getFragmentDefinition = getFragmentDefinition;
	exports.getFragmentDefinitions = getFragmentDefinitions;
	exports.getFragmentQueryDocument = getFragmentQueryDocument;
	exports.getInclusionDirectives = getInclusionDirectives;
	exports.getMainDefinition = getMainDefinition;
	exports.getMutationDefinition = getMutationDefinition;
	exports.getOperationDefinition = getOperationDefinition;
	exports.getOperationDefinitionOrDie = getOperationDefinitionOrDie;
	exports.getOperationName = getOperationName;
	exports.getQueryDefinition = getQueryDefinition;
	exports.getStoreKeyName = getStoreKeyName;
	exports.graphQLResultHasError = graphQLResultHasError;
	exports.hasClientExports = hasClientExports;
	exports.hasDirectives = hasDirectives;
	exports.isDevelopment = isDevelopment;
	exports.isEnv = isEnv;
	exports.isField = isField;
	exports.isIdValue = isIdValue;
	exports.isInlineFragment = isInlineFragment;
	exports.isJsonValue = isJsonValue;
	exports.isNumberValue = isNumberValue;
	exports.isProduction = isProduction;
	exports.isScalarValue = isScalarValue;
	exports.isTest = isTest;
	exports.maybeDeepFreeze = maybeDeepFreeze;
	exports.mergeDeep = mergeDeep;
	exports.mergeDeepArray = mergeDeepArray;
	exports.removeArgumentsFromDocument = removeArgumentsFromDocument;
	exports.removeClientSetsFromDocument = removeClientSetsFromDocument;
	exports.removeConnectionDirectiveFromDocument = removeConnectionDirectiveFromDocument;
	exports.removeDirectivesFromDocument = removeDirectivesFromDocument;
	exports.removeFragmentSpreadFromDocument = removeFragmentSpreadFromDocument;
	exports.resultKeyNameFromField = resultKeyNameFromField;
	exports.shouldInclude = shouldInclude;
	exports.storeKeyNameFromField = storeKeyNameFromField;
	exports.stripSymbols = stripSymbols;
	exports.toIdValue = toIdValue;
	exports.tryFunctionOrLogError = tryFunctionOrLogError;
	exports.valueFromNode = valueFromNode;
	exports.valueToObjectRepresentation = valueToObjectRepresentation;
	exports.variablesInOperation = variablesInOperation;
	exports.warnOnceInDevelopment = warnOnceInDevelopment;
	exports.canUseWeakMap = exports.isEqual = void 0;
	
	var _visitor = __webpack_require__(129);
	
	var _tsInvariant = __webpack_require__(31);
	
	var _tslib = __webpack_require__(14);
	
	var _fastJsonStableStringify = _interopRequireDefault(__webpack_require__(563));
	
	var _equality = __webpack_require__(205);
	
	exports.isEqual = _equality.equal;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isScalarValue(value) {
	  return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
	}
	
	function isNumberValue(value) {
	  return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
	}
	
	function isStringValue(value) {
	  return value.kind === 'StringValue';
	}
	
	function isBooleanValue(value) {
	  return value.kind === 'BooleanValue';
	}
	
	function isIntValue(value) {
	  return value.kind === 'IntValue';
	}
	
	function isFloatValue(value) {
	  return value.kind === 'FloatValue';
	}
	
	function isVariable(value) {
	  return value.kind === 'Variable';
	}
	
	function isObjectValue(value) {
	  return value.kind === 'ObjectValue';
	}
	
	function isListValue(value) {
	  return value.kind === 'ListValue';
	}
	
	function isEnumValue(value) {
	  return value.kind === 'EnumValue';
	}
	
	function isNullValue(value) {
	  return value.kind === 'NullValue';
	}
	
	function valueToObjectRepresentation(argObj, name, value, variables) {
	  if (isIntValue(value) || isFloatValue(value)) {
	    argObj[name.value] = Number(value.value);
	  } else if (isBooleanValue(value) || isStringValue(value)) {
	    argObj[name.value] = value.value;
	  } else if (isObjectValue(value)) {
	    var nestedArgObj_1 = {};
	    value.fields.map(function (obj) {
	      return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
	    });
	    argObj[name.value] = nestedArgObj_1;
	  } else if (isVariable(value)) {
	    var variableValue = (variables || {})[value.name.value];
	    argObj[name.value] = variableValue;
	  } else if (isListValue(value)) {
	    argObj[name.value] = value.values.map(function (listValue) {
	      var nestedArgArrayObj = {};
	      valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
	      return nestedArgArrayObj[name.value];
	    });
	  } else if (isEnumValue(value)) {
	    argObj[name.value] = value.value;
	  } else if (isNullValue(value)) {
	    argObj[name.value] = null;
	  } else {
	    throw  true ? new _tsInvariant.InvariantError(17) : new _tsInvariant.InvariantError("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\"" + 'is not supported. Use variables instead of inline arguments to ' + 'overcome this limitation.');
	  }
	}
	
	function storeKeyNameFromField(field, variables) {
	  var directivesObj = null;
	
	  if (field.directives) {
	    directivesObj = {};
	    field.directives.forEach(function (directive) {
	      directivesObj[directive.name.value] = {};
	
	      if (directive.arguments) {
	        directive.arguments.forEach(function (_a) {
	          var name = _a.name,
	              value = _a.value;
	          return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
	        });
	      }
	    });
	  }
	
	  var argObj = null;
	
	  if (field.arguments && field.arguments.length) {
	    argObj = {};
	    field.arguments.forEach(function (_a) {
	      var name = _a.name,
	          value = _a.value;
	      return valueToObjectRepresentation(argObj, name, value, variables);
	    });
	  }
	
	  return getStoreKeyName(field.name.value, argObj, directivesObj);
	}
	
	var KNOWN_DIRECTIVES = ['connection', 'include', 'skip', 'client', 'rest', 'export'];
	
	function getStoreKeyName(fieldName, args, directives) {
	  if (directives && directives['connection'] && directives['connection']['key']) {
	    if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
	      var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
	      filterKeys.sort();
	      var queryArgs_1 = args;
	      var filteredArgs_1 = {};
	      filterKeys.forEach(function (key) {
	        filteredArgs_1[key] = queryArgs_1[key];
	      });
	      return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
	    } else {
	      return directives['connection']['key'];
	    }
	  }
	
	  var completeFieldName = fieldName;
	
	  if (args) {
	    var stringifiedArgs = (0, _fastJsonStableStringify.default)(args);
	    completeFieldName += "(" + stringifiedArgs + ")";
	  }
	
	  if (directives) {
	    Object.keys(directives).forEach(function (key) {
	      if (KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
	
	      if (directives[key] && Object.keys(directives[key]).length) {
	        completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
	      } else {
	        completeFieldName += "@" + key;
	      }
	    });
	  }
	
	  return completeFieldName;
	}
	
	function argumentsObjectFromField(field, variables) {
	  if (field.arguments && field.arguments.length) {
	    var argObj_1 = {};
	    field.arguments.forEach(function (_a) {
	      var name = _a.name,
	          value = _a.value;
	      return valueToObjectRepresentation(argObj_1, name, value, variables);
	    });
	    return argObj_1;
	  }
	
	  return null;
	}
	
	function resultKeyNameFromField(field) {
	  return field.alias ? field.alias.value : field.name.value;
	}
	
	function isField(selection) {
	  return selection.kind === 'Field';
	}
	
	function isInlineFragment(selection) {
	  return selection.kind === 'InlineFragment';
	}
	
	function isIdValue(idObject) {
	  return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
	}
	
	function toIdValue(idConfig, generated) {
	  if (generated === void 0) {
	    generated = false;
	  }
	
	  return (0, _tslib.__assign)({
	    type: 'id',
	    generated: generated
	  }, typeof idConfig === 'string' ? {
	    id: idConfig,
	    typename: undefined
	  } : idConfig);
	}
	
	function isJsonValue(jsonObject) {
	  return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
	}
	
	function defaultValueFromVariable(node) {
	  throw  true ? new _tsInvariant.InvariantError(18) : new _tsInvariant.InvariantError("Variable nodes are not supported by valueFromNode");
	}
	
	function valueFromNode(node, onVariable) {
	  if (onVariable === void 0) {
	    onVariable = defaultValueFromVariable;
	  }
	
	  switch (node.kind) {
	    case 'Variable':
	      return onVariable(node);
	
	    case 'NullValue':
	      return null;
	
	    case 'IntValue':
	      return parseInt(node.value, 10);
	
	    case 'FloatValue':
	      return parseFloat(node.value);
	
	    case 'ListValue':
	      return node.values.map(function (v) {
	        return valueFromNode(v, onVariable);
	      });
	
	    case 'ObjectValue':
	      {
	        var value = {};
	
	        for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
	          var field = _a[_i];
	          value[field.name.value] = valueFromNode(field.value, onVariable);
	        }
	
	        return value;
	      }
	
	    default:
	      return node.value;
	  }
	}
	
	function getDirectiveInfoFromField(field, variables) {
	  if (field.directives && field.directives.length) {
	    var directiveObj_1 = {};
	    field.directives.forEach(function (directive) {
	      directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
	    });
	    return directiveObj_1;
	  }
	
	  return null;
	}
	
	function shouldInclude(selection, variables) {
	  if (variables === void 0) {
	    variables = {};
	  }
	
	  return getInclusionDirectives(selection.directives).every(function (_a) {
	    var directive = _a.directive,
	        ifArgument = _a.ifArgument;
	    var evaledValue = false;
	
	    if (ifArgument.value.kind === 'Variable') {
	      evaledValue = variables[ifArgument.value.name.value];
	       true ? (0, _tsInvariant.invariant)(evaledValue !== void 0, 13) : (0, _tsInvariant.invariant)(evaledValue !== void 0, "Invalid variable referenced in @" + directive.name.value + " directive.");
	    } else {
	      evaledValue = ifArgument.value.value;
	    }
	
	    return directive.name.value === 'skip' ? !evaledValue : evaledValue;
	  });
	}
	
	function getDirectiveNames(doc) {
	  var names = [];
	  (0, _visitor.visit)(doc, {
	    Directive: function (node) {
	      names.push(node.name.value);
	    }
	  });
	  return names;
	}
	
	function hasDirectives(names, doc) {
	  return getDirectiveNames(doc).some(function (name) {
	    return names.indexOf(name) > -1;
	  });
	}
	
	function hasClientExports(document) {
	  return document && hasDirectives(['client'], document) && hasDirectives(['export'], document);
	}
	
	function isInclusionDirective(_a) {
	  var value = _a.name.value;
	  return value === 'skip' || value === 'include';
	}
	
	function getInclusionDirectives(directives) {
	  return directives ? directives.filter(isInclusionDirective).map(function (directive) {
	    var directiveArguments = directive.arguments;
	    var directiveName = directive.name.value;
	     true ? (0, _tsInvariant.invariant)(directiveArguments && directiveArguments.length === 1, 14) : (0, _tsInvariant.invariant)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @" + directiveName + " directive.");
	    var ifArgument = directiveArguments[0];
	     true ? (0, _tsInvariant.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15) : (0, _tsInvariant.invariant)(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @" + directiveName + " directive.");
	    var ifValue = ifArgument.value;
	     true ? (0, _tsInvariant.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16) : (0, _tsInvariant.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
	    return {
	      directive: directive,
	      ifArgument: ifArgument
	    };
	  }) : [];
	}
	
	function getFragmentQueryDocument(document, fragmentName) {
	  var actualFragmentName = fragmentName;
	  var fragments = [];
	  document.definitions.forEach(function (definition) {
	    if (definition.kind === 'OperationDefinition') {
	      throw  true ? new _tsInvariant.InvariantError(11) : new _tsInvariant.InvariantError("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " + 'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
	    }
	
	    if (definition.kind === 'FragmentDefinition') {
	      fragments.push(definition);
	    }
	  });
	
	  if (typeof actualFragmentName === 'undefined') {
	     true ? (0, _tsInvariant.invariant)(fragments.length === 1, 12) : (0, _tsInvariant.invariant)(fragments.length === 1, "Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
	    actualFragmentName = fragments[0].name.value;
	  }
	
	  var query = (0, _tslib.__assign)((0, _tslib.__assign)({}, document), {
	    definitions: (0, _tslib.__spreadArrays)([{
	      kind: 'OperationDefinition',
	      operation: 'query',
	      selectionSet: {
	        kind: 'SelectionSet',
	        selections: [{
	          kind: 'FragmentSpread',
	          name: {
	            kind: 'Name',
	            value: actualFragmentName
	          }
	        }]
	      }
	    }], document.definitions)
	  });
	  return query;
	}
	
	function assign(target) {
	  var sources = [];
	
	  for (var _i = 1; _i < arguments.length; _i++) {
	    sources[_i - 1] = arguments[_i];
	  }
	
	  sources.forEach(function (source) {
	    if (typeof source === 'undefined' || source === null) {
	      return;
	    }
	
	    Object.keys(source).forEach(function (key) {
	      target[key] = source[key];
	    });
	  });
	  return target;
	}
	
	function getMutationDefinition(doc) {
	  checkDocument(doc);
	  var mutationDef = doc.definitions.filter(function (definition) {
	    return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
	  })[0];
	   true ? (0, _tsInvariant.invariant)(mutationDef, 1) : (0, _tsInvariant.invariant)(mutationDef, 'Must contain a mutation definition.');
	  return mutationDef;
	}
	
	function checkDocument(doc) {
	   true ? (0, _tsInvariant.invariant)(doc && doc.kind === 'Document', 2) : (0, _tsInvariant.invariant)(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
	  var operations = doc.definitions.filter(function (d) {
	    return d.kind !== 'FragmentDefinition';
	  }).map(function (definition) {
	    if (definition.kind !== 'OperationDefinition') {
	      throw  true ? new _tsInvariant.InvariantError(3) : new _tsInvariant.InvariantError("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
	    }
	
	    return definition;
	  });
	   true ? (0, _tsInvariant.invariant)(operations.length <= 1, 4) : (0, _tsInvariant.invariant)(operations.length <= 1, "Ambiguous GraphQL document: contains " + operations.length + " operations");
	  return doc;
	}
	
	function getOperationDefinition(doc) {
	  checkDocument(doc);
	  return doc.definitions.filter(function (definition) {
	    return definition.kind === 'OperationDefinition';
	  })[0];
	}
	
	function getOperationDefinitionOrDie(document) {
	  var def = getOperationDefinition(document);
	   true ? (0, _tsInvariant.invariant)(def, 5) : (0, _tsInvariant.invariant)(def, "GraphQL document is missing an operation");
	  return def;
	}
	
	function getOperationName(doc) {
	  return doc.definitions.filter(function (definition) {
	    return definition.kind === 'OperationDefinition' && definition.name;
	  }).map(function (x) {
	    return x.name.value;
	  })[0] || null;
	}
	
	function getFragmentDefinitions(doc) {
	  return doc.definitions.filter(function (definition) {
	    return definition.kind === 'FragmentDefinition';
	  });
	}
	
	function getQueryDefinition(doc) {
	  var queryDef = getOperationDefinition(doc);
	   true ? (0, _tsInvariant.invariant)(queryDef && queryDef.operation === 'query', 6) : (0, _tsInvariant.invariant)(queryDef && queryDef.operation === 'query', 'Must contain a query definition.');
	  return queryDef;
	}
	
	function getFragmentDefinition(doc) {
	   true ? (0, _tsInvariant.invariant)(doc.kind === 'Document', 7) : (0, _tsInvariant.invariant)(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
	   true ? (0, _tsInvariant.invariant)(doc.definitions.length <= 1, 8) : (0, _tsInvariant.invariant)(doc.definitions.length <= 1, 'Fragment must have exactly one definition.');
	  var fragmentDef = doc.definitions[0];
	   true ? (0, _tsInvariant.invariant)(fragmentDef.kind === 'FragmentDefinition', 9) : (0, _tsInvariant.invariant)(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.');
	  return fragmentDef;
	}
	
	function getMainDefinition(queryDoc) {
	  checkDocument(queryDoc);
	  var fragmentDefinition;
	
	  for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
	    var definition = _a[_i];
	
	    if (definition.kind === 'OperationDefinition') {
	      var operation = definition.operation;
	
	      if (operation === 'query' || operation === 'mutation' || operation === 'subscription') {
	        return definition;
	      }
	    }
	
	    if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
	      fragmentDefinition = definition;
	    }
	  }
	
	  if (fragmentDefinition) {
	    return fragmentDefinition;
	  }
	
	  throw  true ? new _tsInvariant.InvariantError(10) : new _tsInvariant.InvariantError('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
	}
	
	function createFragmentMap(fragments) {
	  if (fragments === void 0) {
	    fragments = [];
	  }
	
	  var symTable = {};
	  fragments.forEach(function (fragment) {
	    symTable[fragment.name.value] = fragment;
	  });
	  return symTable;
	}
	
	function getDefaultValues(definition) {
	  if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
	    var defaultValues = definition.variableDefinitions.filter(function (_a) {
	      var defaultValue = _a.defaultValue;
	      return defaultValue;
	    }).map(function (_a) {
	      var variable = _a.variable,
	          defaultValue = _a.defaultValue;
	      var defaultValueObj = {};
	      valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
	      return defaultValueObj;
	    });
	    return assign.apply(void 0, (0, _tslib.__spreadArrays)([{}], defaultValues));
	  }
	
	  return {};
	}
	
	function variablesInOperation(operation) {
	  var names = new Set();
	
	  if (operation.variableDefinitions) {
	    for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
	      var definition = _a[_i];
	      names.add(definition.variable.name.value);
	    }
	  }
	
	  return names;
	}
	
	function filterInPlace(array, test, context) {
	  var target = 0;
	  array.forEach(function (elem, i) {
	    if (test.call(this, elem, i, array)) {
	      array[target++] = elem;
	    }
	  }, context);
	  array.length = target;
	  return array;
	}
	
	var TYPENAME_FIELD = {
	  kind: 'Field',
	  name: {
	    kind: 'Name',
	    value: '__typename'
	  }
	};
	
	function isEmpty(op, fragments) {
	  return op.selectionSet.selections.every(function (selection) {
	    return selection.kind === 'FragmentSpread' && isEmpty(fragments[selection.name.value], fragments);
	  });
	}
	
	function nullIfDocIsEmpty(doc) {
	  return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc))) ? null : doc;
	}
	
	function getDirectiveMatcher(directives) {
	  return function directiveMatcher(directive) {
	    return directives.some(function (dir) {
	      return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
	    });
	  };
	}
	
	function removeDirectivesFromDocument(directives, doc) {
	  var variablesInUse = Object.create(null);
	  var variablesToRemove = [];
	  var fragmentSpreadsInUse = Object.create(null);
	  var fragmentSpreadsToRemove = [];
	  var modifiedDoc = nullIfDocIsEmpty((0, _visitor.visit)(doc, {
	    Variable: {
	      enter: function (node, _key, parent) {
	        if (parent.kind !== 'VariableDefinition') {
	          variablesInUse[node.name.value] = true;
	        }
	      }
	    },
	    Field: {
	      enter: function (node) {
	        if (directives && node.directives) {
	          var shouldRemoveField = directives.some(function (directive) {
	            return directive.remove;
	          });
	
	          if (shouldRemoveField && node.directives && node.directives.some(getDirectiveMatcher(directives))) {
	            if (node.arguments) {
	              node.arguments.forEach(function (arg) {
	                if (arg.value.kind === 'Variable') {
	                  variablesToRemove.push({
	                    name: arg.value.name.value
	                  });
	                }
	              });
	            }
	
	            if (node.selectionSet) {
	              getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
	                fragmentSpreadsToRemove.push({
	                  name: frag.name.value
	                });
	              });
	            }
	
	            return null;
	          }
	        }
	      }
	    },
	    FragmentSpread: {
	      enter: function (node) {
	        fragmentSpreadsInUse[node.name.value] = true;
	      }
	    },
	    Directive: {
	      enter: function (node) {
	        if (getDirectiveMatcher(directives)(node)) {
	          return null;
	        }
	      }
	    }
	  }));
	
	  if (modifiedDoc && filterInPlace(variablesToRemove, function (v) {
	    return !variablesInUse[v.name];
	  }).length) {
	    modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
	  }
	
	  if (modifiedDoc && filterInPlace(fragmentSpreadsToRemove, function (fs) {
	    return !fragmentSpreadsInUse[fs.name];
	  }).length) {
	    modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
	  }
	
	  return modifiedDoc;
	}
	
	function addTypenameToDocument(doc) {
	  return (0, _visitor.visit)(checkDocument(doc), {
	    SelectionSet: {
	      enter: function (node, _key, parent) {
	        if (parent && parent.kind === 'OperationDefinition') {
	          return;
	        }
	
	        var selections = node.selections;
	
	        if (!selections) {
	          return;
	        }
	
	        var skip = selections.some(function (selection) {
	          return isField(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
	        });
	
	        if (skip) {
	          return;
	        }
	
	        var field = parent;
	
	        if (isField(field) && field.directives && field.directives.some(function (d) {
	          return d.name.value === 'export';
	        })) {
	          return;
	        }
	
	        return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
	          selections: (0, _tslib.__spreadArrays)(selections, [TYPENAME_FIELD])
	        });
	      }
	    }
	  });
	}
	
	var connectionRemoveConfig = {
	  test: function (directive) {
	    var willRemove = directive.name.value === 'connection';
	
	    if (willRemove) {
	      if (!directive.arguments || !directive.arguments.some(function (arg) {
	        return arg.name.value === 'key';
	      })) {
	        ("production") === "production" || _tsInvariant.invariant.warn('Removing an @connection directive even though it does not have a key. ' + 'You may want to use the key parameter to specify a store key.');
	      }
	    }
	
	    return willRemove;
	  }
	};
	
	function removeConnectionDirectiveFromDocument(doc) {
	  return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
	}
	
	function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
	  if (nestedCheck === void 0) {
	    nestedCheck = true;
	  }
	
	  return selectionSet && selectionSet.selections && selectionSet.selections.some(function (selection) {
	    return hasDirectivesInSelection(directives, selection, nestedCheck);
	  });
	}
	
	function hasDirectivesInSelection(directives, selection, nestedCheck) {
	  if (nestedCheck === void 0) {
	    nestedCheck = true;
	  }
	
	  if (!isField(selection)) {
	    return true;
	  }
	
	  if (!selection.directives) {
	    return false;
	  }
	
	  return selection.directives.some(getDirectiveMatcher(directives)) || nestedCheck && hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
	}
	
	function getDirectivesFromDocument(directives, doc) {
	  checkDocument(doc);
	  var parentPath;
	  return nullIfDocIsEmpty((0, _visitor.visit)(doc, {
	    SelectionSet: {
	      enter: function (node, _key, _parent, path) {
	        var currentPath = path.join('-');
	
	        if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
	          if (node.selections) {
	            var selectionsWithDirectives = node.selections.filter(function (selection) {
	              return hasDirectivesInSelection(directives, selection);
	            });
	
	            if (hasDirectivesInSelectionSet(directives, node, false)) {
	              parentPath = currentPath;
	            }
	
	            return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
	              selections: selectionsWithDirectives
	            });
	          } else {
	            return null;
	          }
	        }
	      }
	    }
	  }));
	}
	
	function getArgumentMatcher(config) {
	  return function argumentMatcher(argument) {
	    return config.some(function (aConfig) {
	      return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
	    });
	  };
	}
	
	function removeArgumentsFromDocument(config, doc) {
	  var argMatcher = getArgumentMatcher(config);
	  return nullIfDocIsEmpty((0, _visitor.visit)(doc, {
	    OperationDefinition: {
	      enter: function (node) {
	        return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
	          variableDefinitions: node.variableDefinitions.filter(function (varDef) {
	            return !config.some(function (arg) {
	              return arg.name === varDef.variable.name.value;
	            });
	          })
	        });
	      }
	    },
	    Field: {
	      enter: function (node) {
	        var shouldRemoveField = config.some(function (argConfig) {
	          return argConfig.remove;
	        });
	
	        if (shouldRemoveField) {
	          var argMatchCount_1 = 0;
	          node.arguments.forEach(function (arg) {
	            if (argMatcher(arg)) {
	              argMatchCount_1 += 1;
	            }
	          });
	
	          if (argMatchCount_1 === 1) {
	            return null;
	          }
	        }
	      }
	    },
	    Argument: {
	      enter: function (node) {
	        if (argMatcher(node)) {
	          return null;
	        }
	      }
	    }
	  }));
	}
	
	function removeFragmentSpreadFromDocument(config, doc) {
	  function enter(node) {
	    if (config.some(function (def) {
	      return def.name === node.name.value;
	    })) {
	      return null;
	    }
	  }
	
	  return nullIfDocIsEmpty((0, _visitor.visit)(doc, {
	    FragmentSpread: {
	      enter: enter
	    },
	    FragmentDefinition: {
	      enter: enter
	    }
	  }));
	}
	
	function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
	  var allFragments = [];
	  selectionSet.selections.forEach(function (selection) {
	    if ((isField(selection) || isInlineFragment(selection)) && selection.selectionSet) {
	      getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) {
	        return allFragments.push(frag);
	      });
	    } else if (selection.kind === 'FragmentSpread') {
	      allFragments.push(selection);
	    }
	  });
	  return allFragments;
	}
	
	function buildQueryFromSelectionSet(document) {
	  var definition = getMainDefinition(document);
	  var definitionOperation = definition.operation;
	
	  if (definitionOperation === 'query') {
	    return document;
	  }
	
	  var modifiedDoc = (0, _visitor.visit)(document, {
	    OperationDefinition: {
	      enter: function (node) {
	        return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
	          operation: 'query'
	        });
	      }
	    }
	  });
	  return modifiedDoc;
	}
	
	function removeClientSetsFromDocument(document) {
	  checkDocument(document);
	  var modifiedDoc = removeDirectivesFromDocument([{
	    test: function (directive) {
	      return directive.name.value === 'client';
	    },
	    remove: true
	  }], document);
	
	  if (modifiedDoc) {
	    modifiedDoc = (0, _visitor.visit)(modifiedDoc, {
	      FragmentDefinition: {
	        enter: function (node) {
	          if (node.selectionSet) {
	            var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
	              return isField(selection) && selection.name.value === '__typename';
	            });
	
	            if (isTypenameOnly) {
	              return null;
	            }
	          }
	        }
	      }
	    });
	  }
	
	  return modifiedDoc;
	}
	
	var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
	exports.canUseWeakMap = canUseWeakMap;
	var toString = Object.prototype.toString;
	
	function cloneDeep(value) {
	  return cloneDeepHelper(value, new Map());
	}
	
	function cloneDeepHelper(val, seen) {
	  switch (toString.call(val)) {
	    case "[object Array]":
	      {
	        if (seen.has(val)) return seen.get(val);
	        var copy_1 = val.slice(0);
	        seen.set(val, copy_1);
	        copy_1.forEach(function (child, i) {
	          copy_1[i] = cloneDeepHelper(child, seen);
	        });
	        return copy_1;
	      }
	
	    case "[object Object]":
	      {
	        if (seen.has(val)) return seen.get(val);
	        var copy_2 = Object.create(Object.getPrototypeOf(val));
	        seen.set(val, copy_2);
	        Object.keys(val).forEach(function (key) {
	          copy_2[key] = cloneDeepHelper(val[key], seen);
	        });
	        return copy_2;
	      }
	
	    default:
	      return val;
	  }
	}
	
	function getEnv() {
	  if (typeof process !== 'undefined' && ("production")) {
	    return ("production");
	  }
	
	  return 'development';
	}
	
	function isEnv(env) {
	  return getEnv() === env;
	}
	
	function isProduction() {
	  return isEnv('production') === true;
	}
	
	function isDevelopment() {
	  return isEnv('development') === true;
	}
	
	function isTest() {
	  return isEnv('test') === true;
	}
	
	function tryFunctionOrLogError(f) {
	  try {
	    return f();
	  } catch (e) {
	    if (console.error) {
	      console.error(e);
	    }
	  }
	}
	
	function graphQLResultHasError(result) {
	  return result.errors && result.errors.length;
	}
	
	function deepFreeze(o) {
	  Object.freeze(o);
	  Object.getOwnPropertyNames(o).forEach(function (prop) {
	    if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) {
	      deepFreeze(o[prop]);
	    }
	  });
	  return o;
	}
	
	function maybeDeepFreeze(obj) {
	  if (isDevelopment() || isTest()) {
	    var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
	
	    if (!symbolIsPolyfilled) {
	      return deepFreeze(obj);
	    }
	  }
	
	  return obj;
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function mergeDeep() {
	  var sources = [];
	
	  for (var _i = 0; _i < arguments.length; _i++) {
	    sources[_i] = arguments[_i];
	  }
	
	  return mergeDeepArray(sources);
	}
	
	function mergeDeepArray(sources) {
	  var target = sources[0] || {};
	  var count = sources.length;
	
	  if (count > 1) {
	    var pastCopies = [];
	    target = shallowCopyForMerge(target, pastCopies);
	
	    for (var i = 1; i < count; ++i) {
	      target = mergeHelper(target, sources[i], pastCopies);
	    }
	  }
	
	  return target;
	}
	
	function isObject(obj) {
	  return obj !== null && typeof obj === 'object';
	}
	
	function mergeHelper(target, source, pastCopies) {
	  if (isObject(source) && isObject(target)) {
	    if (Object.isExtensible && !Object.isExtensible(target)) {
	      target = shallowCopyForMerge(target, pastCopies);
	    }
	
	    Object.keys(source).forEach(function (sourceKey) {
	      var sourceValue = source[sourceKey];
	
	      if (hasOwnProperty.call(target, sourceKey)) {
	        var targetValue = target[sourceKey];
	
	        if (sourceValue !== targetValue) {
	          target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
	        }
	      } else {
	        target[sourceKey] = sourceValue;
	      }
	    });
	    return target;
	  }
	
	  return source;
	}
	
	function shallowCopyForMerge(value, pastCopies) {
	  if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
	    if (Array.isArray(value)) {
	      value = value.slice(0);
	    } else {
	      value = (0, _tslib.__assign)({
	        __proto__: Object.getPrototypeOf(value)
	      }, value);
	    }
	
	    pastCopies.push(value);
	  }
	
	  return value;
	}
	
	var haveWarned = Object.create({});
	
	function warnOnceInDevelopment(msg, type) {
	  if (type === void 0) {
	    type = 'warn';
	  }
	
	  if (!isProduction() && !haveWarned[msg]) {
	    if (!isTest()) {
	      haveWarned[msg] = true;
	    }
	
	    if (type === 'error') {
	      console.error(msg);
	    } else {
	      console.warn(msg);
	    }
	  }
	}
	
	function stripSymbols(data) {
	  return JSON.parse(JSON.stringify(data));
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ristorantiFrontendLib = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderRecap = function OrderRecap(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'orderRecap' },
	    _react2.default.createElement(
	      'div',
	      { className: 'orderRecap__el' },
	      _react2.default.createElement('i', { className: 'bi_location-pin' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        props.location
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'orderRecap__el' },
	      _react2.default.createElement('i', { className: 'bi_time-clock-a' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        _ristorantiFrontendLib.TimeHelpers.toHumanDate(props.date, 'it', 'LL')
	      )
	    )
	  );
	};
	
	OrderRecap.propTypes = {
	  date: _propTypes2.default.string.isRequired,
	  location: _propTypes2.default.string.isRequired
	};
	
	exports.default = OrderRecap;

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GEOLOCATION_GET_USER_LOCATION = exports.GEOLOCATION_GET_USER_LOCATION = 'GEOLOCATION_GET_USER_LOCATION';
	var SET_BOOKING_FORM_VISIBILITY = exports.SET_BOOKING_FORM_VISIBILITY = 'SET_BOOKING_FORM_VISIBILITY';
	var SET_MESSAGE = exports.SET_MESSAGE = 'SET_MESSAGE';
	
	var USER_ACCESS_TOKEN = exports.USER_ACCESS_TOKEN = 'RISTORANTI.IT@@@USER_ACCESS_TOKEN';

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global location */
	/* global VERSION */
	
	var GOOGLE_API_KEY = exports.GOOGLE_API_KEY = 'AIzaSyABxWy3OohyBaFEVy6ElB_cyKeUTrDVSWg';
	var STAGING_HOST_URL = 'demo.ristoranti.it';
	var STAGING_HOST_FB_URL = 'https://ristoranti-widget-staging';
	var development = {
	  name: 'development',
	  api_endpoint: 'http://localhost:3000/graphql',
	  stripe_key: 'pk_test_N4uv7Nju1n4tKshBiDXhJ0ED',
	  fb_app_id: '1907283456216930',
	  version: ("ce23569")
	};
	
	var staging = {
	  name: 'staging',
	  api_endpoint: 'https://api-staging.ristoranti.it/graphql',
	  stripe_key: 'pk_test_N4uv7Nju1n4tKshBiDXhJ0ED',
	  fb_app_id: '1907297652882177',
	  version: ("ce23569")
	};
	
	var production = {
	  name: 'production',
	  api_endpoint: 'https://api.ristoranti.it/graphql',
	  stripe_key: 'pk_live_vLPJilgHuVIIzwIOaAdituAV',
	  fb_app_id: '1694667504145194',
	  version: ("ce23569")
	};
	
	var ENVS = {
	  development: development,
	  production: production
	};
	
	var isDev = function isDev() {
	  return ("production") === 'development';
	};
	
	var getCurrent = function getCurrent() {
	  if (location.href.indexOf(STAGING_HOST_URL) > -1 || location.href.indexOf(STAGING_HOST_FB_URL) > -1) {
	    return staging;
	  }
	  return ENVS[("production")];
	};
	
	exports.default = {
	  getCurrent: getCurrent,
	  isDev: isDev
	};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EventEmitter = function () {
	  function EventEmitter() {
	    _classCallCheck(this, EventEmitter);
	
	    this.observers = {};
	  }
	
	  EventEmitter.prototype.on = function on(events, listener) {
	    var _this = this;
	
	    events.split(' ').forEach(function (event) {
	      _this.observers[event] = _this.observers[event] || [];
	      _this.observers[event].push(listener);
	    });
	    return this;
	  };
	
	  EventEmitter.prototype.off = function off(event, listener) {
	    var _this2 = this;
	
	    if (!this.observers[event]) {
	      return;
	    }
	
	    this.observers[event].forEach(function () {
	      if (!listener) {
	        delete _this2.observers[event];
	      } else {
	        var index = _this2.observers[event].indexOf(listener);
	        if (index > -1) {
	          _this2.observers[event].splice(index, 1);
	        }
	      }
	    });
	  };
	
	  EventEmitter.prototype.emit = function emit(event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (this.observers[event]) {
	      var cloned = [].concat(this.observers[event]);
	      cloned.forEach(function (observer) {
	        observer.apply(undefined, args);
	      });
	    }
	
	    if (this.observers['*']) {
	      var _cloned = [].concat(this.observers['*']);
	      _cloned.forEach(function (observer) {
	        observer.apply(observer, [event].concat(args));
	      });
	    }
	  };
	
	  return EventEmitter;
	}();
	
	exports.default = EventEmitter;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(657),
	    listCacheDelete = __webpack_require__(658),
	    listCacheGet = __webpack_require__(659),
	    listCacheHas = __webpack_require__(660),
	    listCacheSet = __webpack_require__(661);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(140);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(654);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(74);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(603),
	    baseKeys = __webpack_require__(617),
	    isArrayLike = __webpack_require__(72);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.elementContextTypes = exports.injectContextTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Provider = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var injectContextTypes = exports.injectContextTypes = {
	  getRegisteredElements: _propTypes2.default.func.isRequired
	};
	
	var elementContextTypes = exports.elementContextTypes = {
	  addElementsLoadListener: _propTypes2.default.func.isRequired,
	  registerElement: _propTypes2.default.func.isRequired,
	  unregisterElement: _propTypes2.default.func.isRequired
	};
	
	var Elements = function (_React$Component) {
	  _inherits(Elements, _React$Component);
	
	  function Elements(props, context) {
	    _classCallCheck(this, Elements);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRegisterElement = function (element, impliedTokenType, impliedSourceType, impliedPaymentMethodType) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [_extends({
	            element: element
	          }, impliedTokenType ? { impliedTokenType: impliedTokenType } : {}, impliedSourceType ? { impliedSourceType: impliedSourceType } : {}, impliedPaymentMethodType ? { impliedPaymentMethodType: impliedPaymentMethodType } : {})])
	        };
	      });
	    };
	
	    _this.handleUnregisterElement = function (el) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: prevState.registeredElements.filter(function (_ref) {
	            var element = _ref.element;
	            return element !== el;
	          })
	        };
	      });
	    };
	
	    _this.state = {
	      registeredElements: []
	    };
	    return _this;
	  }
	
	  Elements.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    return {
	      addElementsLoadListener: function addElementsLoadListener(fn) {
	        // Return the existing elements instance if we already have one.
	        if (_this2._elements) {
	          fn(_this2._elements);
	          return;
	        }
	
	        var _props = _this2.props,
	            children = _props.children,
	            options = _objectWithoutProperties(_props, ['children']);
	
	        if (_this2.context.tag === 'sync') {
	          _this2._elements = _this2.context.stripe.elements(options);
	          fn(_this2._elements);
	        } else {
	          _this2.context.addStripeLoadListener(function (stripe) {
	            if (_this2._elements) {
	              fn(_this2._elements);
	            } else {
	              _this2._elements = stripe.elements(options);
	              fn(_this2._elements);
	            }
	          });
	        }
	      },
	      registerElement: this.handleRegisterElement,
	      unregisterElement: this.handleUnregisterElement,
	      getRegisteredElements: function getRegisteredElements() {
	        return _this2.state.registeredElements;
	      }
	    };
	  };
	
	  Elements.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Elements;
	}(_react2.default.Component);
	
	Elements.childContextTypes = _extends({}, injectContextTypes, elementContextTypes);
	Elements.contextTypes = _Provider.providerContextTypes;
	Elements.defaultProps = {
	  children: null
	};
	exports.default = Elements;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(536);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(48)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./payments.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./payments.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.useApolloClient = useApolloClient;
	exports.useLazyQuery = useLazyQuery;
	exports.useMutation = useMutation;
	exports.useQuery = useQuery;
	exports.useSubscription = useSubscription;
	exports.RenderPromises = exports.resetApolloContext = exports.ApolloProvider = exports.ApolloConsumer = void 0;
	
	var _reactCommon = __webpack_require__(62);
	
	exports.getApolloContext = _reactCommon.getApolloContext;
	exports.ApolloConsumer = _reactCommon.ApolloConsumer;
	exports.ApolloProvider = _reactCommon.ApolloProvider;
	exports.resetApolloContext = _reactCommon.resetApolloContext;
	
	var _tslib = __webpack_require__(14);
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _apolloClient = __webpack_require__(206);
	
	var _equality = __webpack_require__(205);
	
	var _tsInvariant = __webpack_require__(31);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var OperationData = function () {
	  function OperationData(options, context) {
	    this.isMounted = false;
	    this.previousOptions = {};
	    this.context = {};
	    this.options = {};
	    this.options = options || {};
	    this.context = context || {};
	  }
	
	  OperationData.prototype.getOptions = function () {
	    return this.options;
	  };
	
	  OperationData.prototype.setOptions = function (newOptions, storePrevious) {
	    if (storePrevious === void 0) {
	      storePrevious = false;
	    }
	
	    if (storePrevious && !(0, _equality.equal)(this.options, newOptions)) {
	      this.previousOptions = this.options;
	    }
	
	    this.options = newOptions;
	  };
	
	  OperationData.prototype.unmount = function () {
	    this.isMounted = false;
	  };
	
	  OperationData.prototype.refreshClient = function () {
	    var client = this.options && this.options.client || this.context && this.context.client;
	     true ? (0, _tsInvariant.invariant)(!!client, 2) : (0, _tsInvariant.invariant)(!!client, 'Could not find "client" in the context or passed in as an option. ' + 'Wrap the root component in an <ApolloProvider>, or pass an ' + 'ApolloClient instance in via options.');
	    var isNew = false;
	
	    if (client !== this.client) {
	      isNew = true;
	      this.client = client;
	      this.cleanup();
	    }
	
	    return {
	      client: this.client,
	      isNew: isNew
	    };
	  };
	
	  OperationData.prototype.verifyDocumentType = function (document, type) {
	    var operation = (0, _reactCommon.parser)(document);
	    var requiredOperationName = (0, _reactCommon.operationName)(type);
	    var usedOperationName = (0, _reactCommon.operationName)(operation.type);
	     true ? (0, _tsInvariant.invariant)(operation.type === type, 3) : (0, _tsInvariant.invariant)(operation.type === type, "Running a " + requiredOperationName + " requires a graphql " + (requiredOperationName + ", but a " + usedOperationName + " was used instead."));
	  };
	
	  return OperationData;
	}();
	
	var QueryData = function (_super) {
	  (0, _tslib.__extends)(QueryData, _super);
	
	  function QueryData(_a) {
	    var options = _a.options,
	        context = _a.context,
	        onNewData = _a.onNewData;
	
	    var _this = _super.call(this, options, context) || this;
	
	    _this.previousData = {};
	    _this.currentObservable = {};
	    _this.runLazy = false;
	
	    _this.runLazyQuery = function (options) {
	      _this.cleanup();
	
	      _this.runLazy = true;
	      _this.lazyOptions = options;
	
	      _this.onNewData();
	    };
	
	    _this.getExecuteResult = function () {
	      var result = _this.getQueryResult();
	
	      _this.startQuerySubscription();
	
	      return result;
	    };
	
	    _this.obsRefetch = function (variables) {
	      return _this.currentObservable.query.refetch(variables);
	    };
	
	    _this.obsFetchMore = function (fetchMoreOptions) {
	      return _this.currentObservable.query.fetchMore(fetchMoreOptions);
	    };
	
	    _this.obsUpdateQuery = function (mapFn) {
	      return _this.currentObservable.query.updateQuery(mapFn);
	    };
	
	    _this.obsStartPolling = function (pollInterval) {
	      _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
	    };
	
	    _this.obsStopPolling = function () {
	      _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
	    };
	
	    _this.obsSubscribeToMore = function (options) {
	      return _this.currentObservable.query.subscribeToMore(options);
	    };
	
	    _this.onNewData = onNewData;
	    return _this;
	  }
	
	  QueryData.prototype.execute = function () {
	    this.refreshClient();
	
	    var _a = this.getOptions(),
	        skip = _a.skip,
	        query = _a.query;
	
	    if (skip || query !== this.previousData.query) {
	      this.removeQuerySubscription();
	      this.previousData.query = query;
	    }
	
	    this.updateObservableQuery();
	    if (this.isMounted) this.startQuerySubscription();
	    return this.getExecuteSsrResult() || this.getExecuteResult();
	  };
	
	  QueryData.prototype.executeLazy = function () {
	    return !this.runLazy ? [this.runLazyQuery, {
	      loading: false,
	      networkStatus: _apolloClient.NetworkStatus.ready,
	      called: false,
	      data: undefined
	    }] : [this.runLazyQuery, this.execute()];
	  };
	
	  QueryData.prototype.fetchData = function () {
	    var options = this.getOptions();
	    if (options.skip || options.ssr === false) return false;
	    var obs = this.currentObservable.query;
	    var currentResult = obs.getCurrentResult();
	    return currentResult.loading ? obs.result() : false;
	  };
	
	  QueryData.prototype.afterExecute = function (_a) {
	    var _b = (_a === void 0 ? {} : _a).lazy,
	        lazy = _b === void 0 ? false : _b;
	    this.isMounted = true;
	
	    if (!lazy || this.runLazy) {
	      this.handleErrorOrCompleted();
	    }
	
	    this.previousOptions = this.getOptions();
	    return this.unmount.bind(this);
	  };
	
	  QueryData.prototype.cleanup = function () {
	    this.removeQuerySubscription();
	    delete this.currentObservable.query;
	    delete this.previousData.result;
	  };
	
	  QueryData.prototype.getOptions = function () {
	    var options = _super.prototype.getOptions.call(this);
	
	    if (this.lazyOptions) {
	      options.variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, options.variables), this.lazyOptions.variables);
	      options.context = (0, _tslib.__assign)((0, _tslib.__assign)({}, options.context), this.lazyOptions.context);
	    }
	
	    if (this.runLazy) {
	      delete options.skip;
	    }
	
	    return options;
	  };
	
	  QueryData.prototype.ssrInitiated = function () {
	    return this.context && this.context.renderPromises;
	  };
	
	  QueryData.prototype.getExecuteSsrResult = function () {
	    var ssrDisabled = this.getOptions().ssr === false;
	    var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
	    var ssrLoading = (0, _tslib.__assign)({
	      loading: true,
	      networkStatus: _apolloClient.NetworkStatus.loading,
	      called: true,
	      data: undefined,
	      stale: false,
	      client: this.client
	    }, this.observableQueryFields());
	
	    if (ssrDisabled && (this.ssrInitiated() || fetchDisabled)) {
	      this.previousData.result = ssrLoading;
	      return ssrLoading;
	    }
	
	    var result;
	
	    if (this.ssrInitiated()) {
	      result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
	    }
	
	    return result;
	  };
	
	  QueryData.prototype.prepareObservableQueryOptions = function () {
	    var options = this.getOptions();
	    this.verifyDocumentType(options.query, _reactCommon.DocumentType.Query);
	    var displayName = options.displayName || 'Query';
	
	    if (this.ssrInitiated() && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) {
	      options.fetchPolicy = 'cache-first';
	    }
	
	    return (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
	      displayName: displayName,
	      context: options.context,
	      metadata: {
	        reactComponent: {
	          displayName: displayName
	        }
	      }
	    });
	  };
	
	  QueryData.prototype.initializeObservableQuery = function () {
	    var _a, _b;
	
	    if (this.ssrInitiated()) {
	      this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
	    }
	
	    if (!this.currentObservable.query) {
	      var observableQueryOptions = this.prepareObservableQueryOptions();
	      this.previousData.observableQueryOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, observableQueryOptions), {
	        children: null
	      });
	      this.currentObservable.query = this.refreshClient().client.watchQuery((0, _tslib.__assign)({}, observableQueryOptions));
	
	      if (this.ssrInitiated()) {
	        (_b = (_a = this.context) === null || _a === void 0 ? void 0 : _a.renderPromises) === null || _b === void 0 ? void 0 : _b.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
	      }
	    }
	  };
	
	  QueryData.prototype.updateObservableQuery = function () {
	    if (!this.currentObservable.query) {
	      this.initializeObservableQuery();
	      return;
	    }
	
	    var newObservableQueryOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.prepareObservableQueryOptions()), {
	      children: null
	    });
	
	    if (!(0, _equality.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
	      this.previousData.observableQueryOptions = newObservableQueryOptions;
	      this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function () {});
	    }
	  };
	
	  QueryData.prototype.startQuerySubscription = function () {
	    var _this = this;
	
	    if (this.currentObservable.subscription || this.getOptions().skip) return;
	    var obsQuery = this.currentObservable.query;
	    this.currentObservable.subscription = obsQuery.subscribe({
	      next: function (_a) {
	        var loading = _a.loading,
	            networkStatus = _a.networkStatus,
	            data = _a.data;
	        var previousResult = _this.previousData.result;
	
	        if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, _equality.equal)(previousResult.data, data)) {
	          return;
	        }
	
	        _this.onNewData();
	      },
	      error: function (error) {
	        _this.resubscribeToQuery();
	
	        if (!error.hasOwnProperty('graphQLErrors')) throw error;
	        var previousResult = _this.previousData.result;
	
	        if (previousResult && previousResult.loading || !(0, _equality.equal)(error, _this.previousData.error)) {
	          _this.previousData.error = error;
	
	          _this.onNewData();
	        }
	      }
	    });
	  };
	
	  QueryData.prototype.resubscribeToQuery = function () {
	    this.removeQuerySubscription();
	    var lastError = this.currentObservable.query.getLastError();
	    var lastResult = this.currentObservable.query.getLastResult();
	    this.currentObservable.query.resetLastResults();
	    this.startQuerySubscription();
	    Object.assign(this.currentObservable.query, {
	      lastError: lastError,
	      lastResult: lastResult
	    });
	  };
	
	  QueryData.prototype.getQueryResult = function () {
	    var result = this.observableQueryFields();
	    var options = this.getOptions();
	
	    if (options.skip) {
	      result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
	        data: undefined,
	        error: undefined,
	        loading: false,
	        called: true
	      });
	    } else {
	      var currentResult = this.currentObservable.query.getCurrentResult();
	      var loading = currentResult.loading,
	          partial = currentResult.partial,
	          networkStatus = currentResult.networkStatus,
	          errors = currentResult.errors;
	      var error = currentResult.error,
	          data = currentResult.data;
	
	      if (errors && errors.length > 0) {
	        error = new _apolloClient.ApolloError({
	          graphQLErrors: errors
	        });
	      }
	
	      result = (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
	        loading: loading,
	        networkStatus: networkStatus,
	        error: error,
	        called: true
	      });
	
	      if (loading) {
	        var previousData = this.previousData.result && this.previousData.result.data;
	        result.data = previousData && data ? (0, _tslib.__assign)((0, _tslib.__assign)({}, previousData), data) : previousData || data;
	      } else if (error) {
	        Object.assign(result, {
	          data: (this.currentObservable.query.getLastResult() || {}).data
	        });
	      } else {
	        var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
	        var partialRefetch = options.partialRefetch;
	
	        if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
	          Object.assign(result, {
	            loading: true,
	            networkStatus: _apolloClient.NetworkStatus.loading
	          });
	          result.refetch();
	          return result;
	        }
	
	        result.data = data;
	      }
	    }
	
	    result.client = this.client;
	    this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
	    this.previousData.result = result;
	    this.currentObservable.query && this.currentObservable.query.resetQueryStoreErrors();
	    return result;
	  };
	
	  QueryData.prototype.handleErrorOrCompleted = function () {
	    var obsQuery = this.currentObservable.query;
	    if (!obsQuery || !this.previousData.result) return;
	    var _a = this.previousData.result,
	        data = _a.data,
	        loading = _a.loading,
	        error = _a.error;
	
	    if (!loading) {
	      var _b = this.getOptions(),
	          query = _b.query,
	          variables = _b.variables,
	          onCompleted = _b.onCompleted,
	          onError = _b.onError;
	
	      if (this.previousOptions && !this.previousData.loading && (0, _equality.equal)(this.previousOptions.query, query) && (0, _equality.equal)(this.previousOptions.variables, variables)) {
	        return;
	      }
	
	      if (onCompleted && !error) {
	        onCompleted(data);
	      } else if (onError && error) {
	        onError(error);
	      }
	    }
	  };
	
	  QueryData.prototype.removeQuerySubscription = function () {
	    if (this.currentObservable.subscription) {
	      this.currentObservable.subscription.unsubscribe();
	      delete this.currentObservable.subscription;
	    }
	  };
	
	  QueryData.prototype.observableQueryFields = function () {
	    var observable = this.currentObservable.query;
	    return {
	      variables: observable.variables,
	      refetch: this.obsRefetch,
	      fetchMore: this.obsFetchMore,
	      updateQuery: this.obsUpdateQuery,
	      startPolling: this.obsStartPolling,
	      stopPolling: this.obsStopPolling,
	      subscribeToMore: this.obsSubscribeToMore
	    };
	  };
	
	  return QueryData;
	}(OperationData);
	
	function useDeepMemo(memoFn, key) {
	  var ref = (0, _react.useRef)();
	
	  if (!ref.current || !(0, _equality.equal)(key, ref.current.key)) {
	    ref.current = {
	      key: key,
	      value: memoFn()
	    };
	  }
	
	  return ref.current.value;
	}
	
	function useBaseQuery(query, options, lazy) {
	  if (lazy === void 0) {
	    lazy = false;
	  }
	
	  var context = (0, _react.useContext)((0, _reactCommon.getApolloContext)());
	
	  var _a = (0, _react.useReducer)(function (x) {
	    return x + 1;
	  }, 0),
	      tick = _a[0],
	      forceUpdate = _a[1];
	
	  var updatedOptions = options ? (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
	    query: query
	  }) : {
	    query: query
	  };
	  var queryDataRef = (0, _react.useRef)();
	  var queryData = queryDataRef.current || new QueryData({
	    options: updatedOptions,
	    context: context,
	    onNewData: function () {
	      if (!queryData.ssrInitiated()) {
	        Promise.resolve().then(forceUpdate);
	      } else {
	        forceUpdate();
	      }
	    }
	  });
	  queryData.setOptions(updatedOptions);
	  queryData.context = context;
	
	  if (queryData.ssrInitiated() && !queryDataRef.current) {
	    queryDataRef.current = queryData;
	  }
	
	  var memo = {
	    options: (0, _tslib.__assign)((0, _tslib.__assign)({}, updatedOptions), {
	      onError: undefined,
	      onCompleted: undefined
	    }),
	    context: context,
	    tick: tick
	  };
	  var result = useDeepMemo(function () {
	    return lazy ? queryData.executeLazy() : queryData.execute();
	  }, memo);
	  var queryResult = lazy ? result[1] : result;
	  (0, _react.useEffect)(function () {
	    if (!queryDataRef.current) {
	      queryDataRef.current = queryData;
	    }
	
	    return function () {
	      return queryData.cleanup();
	    };
	  }, []);
	  (0, _react.useEffect)(function () {
	    return queryData.afterExecute({
	      lazy: lazy
	    });
	  }, [queryResult.loading, queryResult.networkStatus, queryResult.error, queryResult.data]);
	  return result;
	}
	
	function useQuery(query, options) {
	  return useBaseQuery(query, options, false);
	}
	
	function useLazyQuery(query, options) {
	  return useBaseQuery(query, options, true);
	}
	
	var MutationData = function (_super) {
	  (0, _tslib.__extends)(MutationData, _super);
	
	  function MutationData(_a) {
	    var options = _a.options,
	        context = _a.context,
	        result = _a.result,
	        setResult = _a.setResult;
	
	    var _this = _super.call(this, options, context) || this;
	
	    _this.runMutation = function (mutationFunctionOptions) {
	      if (mutationFunctionOptions === void 0) {
	        mutationFunctionOptions = {};
	      }
	
	      _this.onMutationStart();
	
	      var mutationId = _this.generateNewMutationId();
	
	      return _this.mutate(mutationFunctionOptions).then(function (response) {
	        _this.onMutationCompleted(response, mutationId);
	
	        return response;
	      }).catch(function (error) {
	        _this.onMutationError(error, mutationId);
	
	        if (!_this.getOptions().onError) throw error;
	      });
	    };
	
	    _this.verifyDocumentType(options.mutation, _reactCommon.DocumentType.Mutation);
	
	    _this.result = result;
	    _this.setResult = setResult;
	    _this.mostRecentMutationId = 0;
	    return _this;
	  }
	
	  MutationData.prototype.execute = function (result) {
	    this.isMounted = true;
	    this.verifyDocumentType(this.getOptions().mutation, _reactCommon.DocumentType.Mutation);
	    result.client = this.refreshClient().client;
	    return [this.runMutation, result];
	  };
	
	  MutationData.prototype.afterExecute = function () {
	    this.isMounted = true;
	    return this.unmount.bind(this);
	  };
	
	  MutationData.prototype.cleanup = function () {};
	
	  MutationData.prototype.mutate = function (mutationFunctionOptions) {
	    var _a = this.getOptions(),
	        mutation = _a.mutation,
	        variables = _a.variables,
	        optimisticResponse = _a.optimisticResponse,
	        update = _a.update,
	        _b = _a.context,
	        mutationContext = _b === void 0 ? {} : _b,
	        _c = _a.awaitRefetchQueries,
	        awaitRefetchQueries = _c === void 0 ? false : _c,
	        fetchPolicy = _a.fetchPolicy;
	
	    var mutateOptions = (0, _tslib.__assign)({}, mutationFunctionOptions);
	    var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
	    delete mutateOptions.variables;
	    return this.refreshClient().client.mutate((0, _tslib.__assign)({
	      mutation: mutation,
	      optimisticResponse: optimisticResponse,
	      refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
	      awaitRefetchQueries: awaitRefetchQueries,
	      update: update,
	      context: mutationContext,
	      fetchPolicy: fetchPolicy,
	      variables: mutateVariables
	    }, mutateOptions));
	  };
	
	  MutationData.prototype.onMutationStart = function () {
	    if (!this.result.loading && !this.getOptions().ignoreResults) {
	      this.updateResult({
	        loading: true,
	        error: undefined,
	        data: undefined,
	        called: true
	      });
	    }
	  };
	
	  MutationData.prototype.onMutationCompleted = function (response, mutationId) {
	    var _a = this.getOptions(),
	        onCompleted = _a.onCompleted,
	        ignoreResults = _a.ignoreResults;
	
	    var data = response.data,
	        errors = response.errors;
	    var error = errors && errors.length > 0 ? new _apolloClient.ApolloError({
	      graphQLErrors: errors
	    }) : undefined;
	
	    var callOncomplete = function () {
	      return onCompleted ? onCompleted(data) : null;
	    };
	
	    if (this.isMostRecentMutation(mutationId) && !ignoreResults) {
	      this.updateResult({
	        called: true,
	        loading: false,
	        data: data,
	        error: error
	      });
	    }
	
	    callOncomplete();
	  };
	
	  MutationData.prototype.onMutationError = function (error, mutationId) {
	    var onError = this.getOptions().onError;
	
	    if (this.isMostRecentMutation(mutationId)) {
	      this.updateResult({
	        loading: false,
	        error: error,
	        data: undefined,
	        called: true
	      });
	    }
	
	    if (onError) {
	      onError(error);
	    }
	  };
	
	  MutationData.prototype.generateNewMutationId = function () {
	    return ++this.mostRecentMutationId;
	  };
	
	  MutationData.prototype.isMostRecentMutation = function (mutationId) {
	    return this.mostRecentMutationId === mutationId;
	  };
	
	  MutationData.prototype.updateResult = function (result) {
	    if (this.isMounted && (!this.previousResult || !(0, _equality.equal)(this.previousResult, result))) {
	      this.setResult(result);
	      this.previousResult = result;
	    }
	  };
	
	  return MutationData;
	}(OperationData);
	
	function useMutation(mutation, options) {
	  var context = (0, _react.useContext)((0, _reactCommon.getApolloContext)());
	
	  var _a = (0, _react.useState)({
	    called: false,
	    loading: false
	  }),
	      result = _a[0],
	      setResult = _a[1];
	
	  var updatedOptions = options ? (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
	    mutation: mutation
	  }) : {
	    mutation: mutation
	  };
	  var mutationDataRef = (0, _react.useRef)();
	
	  function getMutationDataRef() {
	    if (!mutationDataRef.current) {
	      mutationDataRef.current = new MutationData({
	        options: updatedOptions,
	        context: context,
	        result: result,
	        setResult: setResult
	      });
	    }
	
	    return mutationDataRef.current;
	  }
	
	  var mutationData = getMutationDataRef();
	  mutationData.setOptions(updatedOptions);
	  mutationData.context = context;
	  (0, _react.useEffect)(function () {
	    return mutationData.afterExecute();
	  });
	  return mutationData.execute(result);
	}
	
	var SubscriptionData = function (_super) {
	  (0, _tslib.__extends)(SubscriptionData, _super);
	
	  function SubscriptionData(_a) {
	    var options = _a.options,
	        context = _a.context,
	        setResult = _a.setResult;
	
	    var _this = _super.call(this, options, context) || this;
	
	    _this.currentObservable = {};
	    _this.setResult = setResult;
	
	    _this.initialize(options);
	
	    return _this;
	  }
	
	  SubscriptionData.prototype.execute = function (result) {
	    if (this.getOptions().skip === true) {
	      this.cleanup();
	      return {
	        loading: false,
	        error: undefined,
	        data: undefined,
	        variables: this.getOptions().variables
	      };
	    }
	
	    var currentResult = result;
	
	    if (this.refreshClient().isNew) {
	      currentResult = this.getLoadingResult();
	    }
	
	    var shouldResubscribe = this.getOptions().shouldResubscribe;
	
	    if (typeof shouldResubscribe === 'function') {
	      shouldResubscribe = !!shouldResubscribe(this.getOptions());
	    }
	
	    if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, _equality.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
	      this.cleanup();
	      currentResult = this.getLoadingResult();
	    }
	
	    this.initialize(this.getOptions());
	    this.startSubscription();
	    this.previousOptions = this.getOptions();
	    return (0, _tslib.__assign)((0, _tslib.__assign)({}, currentResult), {
	      variables: this.getOptions().variables
	    });
	  };
	
	  SubscriptionData.prototype.afterExecute = function () {
	    this.isMounted = true;
	  };
	
	  SubscriptionData.prototype.cleanup = function () {
	    this.endSubscription();
	    delete this.currentObservable.query;
	  };
	
	  SubscriptionData.prototype.initialize = function (options) {
	    if (this.currentObservable.query || this.getOptions().skip === true) return;
	    this.currentObservable.query = this.refreshClient().client.subscribe({
	      query: options.subscription,
	      variables: options.variables,
	      fetchPolicy: options.fetchPolicy
	    });
	  };
	
	  SubscriptionData.prototype.startSubscription = function () {
	    if (this.currentObservable.subscription) return;
	    this.currentObservable.subscription = this.currentObservable.query.subscribe({
	      next: this.updateCurrentData.bind(this),
	      error: this.updateError.bind(this),
	      complete: this.completeSubscription.bind(this)
	    });
	  };
	
	  SubscriptionData.prototype.getLoadingResult = function () {
	    return {
	      loading: true,
	      error: undefined,
	      data: undefined
	    };
	  };
	
	  SubscriptionData.prototype.updateResult = function (result) {
	    if (this.isMounted) {
	      this.setResult(result);
	    }
	  };
	
	  SubscriptionData.prototype.updateCurrentData = function (result) {
	    var onSubscriptionData = this.getOptions().onSubscriptionData;
	    this.updateResult({
	      data: result.data,
	      loading: false,
	      error: undefined
	    });
	
	    if (onSubscriptionData) {
	      onSubscriptionData({
	        client: this.refreshClient().client,
	        subscriptionData: result
	      });
	    }
	  };
	
	  SubscriptionData.prototype.updateError = function (error) {
	    this.updateResult({
	      error: error,
	      loading: false
	    });
	  };
	
	  SubscriptionData.prototype.completeSubscription = function () {
	    var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
	    if (onSubscriptionComplete) onSubscriptionComplete();
	    this.endSubscription();
	  };
	
	  SubscriptionData.prototype.endSubscription = function () {
	    if (this.currentObservable.subscription) {
	      this.currentObservable.subscription.unsubscribe();
	      delete this.currentObservable.subscription;
	    }
	  };
	
	  return SubscriptionData;
	}(OperationData);
	
	function useSubscription(subscription, options) {
	  var context = (0, _react.useContext)((0, _reactCommon.getApolloContext)());
	  var updatedOptions = options ? (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
	    subscription: subscription
	  }) : {
	    subscription: subscription
	  };
	
	  var _a = (0, _react.useState)({
	    loading: !updatedOptions.skip,
	    error: undefined,
	    data: undefined
	  }),
	      result = _a[0],
	      setResult = _a[1];
	
	  var subscriptionDataRef = (0, _react.useRef)();
	
	  function getSubscriptionDataRef() {
	    if (!subscriptionDataRef.current) {
	      subscriptionDataRef.current = new SubscriptionData({
	        options: updatedOptions,
	        context: context,
	        setResult: setResult
	      });
	    }
	
	    return subscriptionDataRef.current;
	  }
	
	  var subscriptionData = getSubscriptionDataRef();
	  subscriptionData.setOptions(updatedOptions, true);
	  subscriptionData.context = context;
	  (0, _react.useEffect)(function () {
	    return subscriptionData.afterExecute();
	  });
	  (0, _react.useEffect)(function () {
	    return subscriptionData.cleanup.bind(subscriptionData);
	  }, []);
	  return subscriptionData.execute(result);
	}
	
	function useApolloClient() {
	  var client = _react.default.useContext((0, _reactCommon.getApolloContext)()).client;
	
	   true ? (0, _tsInvariant.invariant)(client, 1) : (0, _tsInvariant.invariant)(client, 'No Apollo Client instance can be found. Please ensure that you ' + 'have called `ApolloProvider` higher up in your tree.');
	  return client;
	}
	
	function makeDefaultQueryInfo() {
	  return {
	    seen: false,
	    observable: null
	  };
	}
	
	var RenderPromises = function () {
	  function RenderPromises() {
	    this.queryPromises = new Map();
	    this.queryInfoTrie = new Map();
	  }
	
	  RenderPromises.prototype.registerSSRObservable = function (observable, props) {
	    this.lookupQueryInfo(props).observable = observable;
	  };
	
	  RenderPromises.prototype.getSSRObservable = function (props) {
	    return this.lookupQueryInfo(props).observable;
	  };
	
	  RenderPromises.prototype.addQueryPromise = function (queryInstance, finish) {
	    var info = this.lookupQueryInfo(queryInstance.getOptions());
	
	    if (!info.seen) {
	      this.queryPromises.set(queryInstance.getOptions(), new Promise(function (resolve) {
	        resolve(queryInstance.fetchData());
	      }));
	      return null;
	    }
	
	    return finish();
	  };
	
	  RenderPromises.prototype.hasPromises = function () {
	    return this.queryPromises.size > 0;
	  };
	
	  RenderPromises.prototype.consumeAndAwaitPromises = function () {
	    var _this = this;
	
	    var promises = [];
	    this.queryPromises.forEach(function (promise, queryInstance) {
	      _this.lookupQueryInfo(queryInstance).seen = true;
	      promises.push(promise);
	    });
	    this.queryPromises.clear();
	    return Promise.all(promises);
	  };
	
	  RenderPromises.prototype.lookupQueryInfo = function (props) {
	    var queryInfoTrie = this.queryInfoTrie;
	    var query = props.query,
	        variables = props.variables;
	    var varMap = queryInfoTrie.get(query) || new Map();
	    if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
	    var variablesString = JSON.stringify(variables);
	    var info = varMap.get(variablesString) || makeDefaultQueryInfo();
	    if (!varMap.has(variablesString)) varMap.set(variablesString, info);
	    return info;
	  };
	
	  return RenderPromises;
	}(); 
	
	
	exports.RenderPromises = RenderPromises;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Form = __webpack_require__(286);
	
	Object.keys(_Form).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Form[key];
	    }
	  });
	});
	
	var _Input = __webpack_require__(287);
	
	Object.keys(_Input).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Input[key];
	    }
	  });
	});
	
	var _LocationInput = __webpack_require__(288);
	
	Object.keys(_LocationInput).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _LocationInput[key];
	    }
	  });
	});
	
	var _Button = __webpack_require__(285);
	
	Object.keys(_Button).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Button[key];
	    }
	  });
	});

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UndefinedContent = function UndefinedContent() {
	
	  return _react2.default.createElement(
	    "div",
	    { className: "undefinedContent" },
	    _react2.default.createElement("i", { className: "warning sign icon" }),
	    " ",
	    _react2.default.createElement(
	      "span",
	      null,
	      "non presente"
	    )
	  );
	};
	
	exports.default = UndefinedContent;

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isImage = exports.isImage = function isImage(filename) {
	
	  return (/(png|jpg|jpeg|gif|bmp|tiff)$/i.test(filename)
	  );
	};
	
	var getFilename = exports.getFilename = function getFilename(url) {
	
	  var match1 = /\/([^\/]+)$/.exec(url);
	
	  return match1 && match1[1] || '';
	};
	
	var getExtension = exports.getExtension = function getExtension(filename) {
	
	  var match2 = /\.([a-z]+)$/.exec(filename);
	
	  return match2 && match2[1];
	};
	
	var getBackgroundSize = exports.getBackgroundSize = function getBackgroundSize(file, callback) {
	
	  var img = new Image();
	
	  img.onload = function () {
	
	    var backgroundSize = void 0;
	    var r = img.naturalWidth / img.naturalHeight;
	
	    if (r <= 1) {
	      backgroundSize = '100% auto';
	    } else if (r <= 1.35) {
	      backgroundSize = '100% 100%';
	    } else {
	      backgroundSize = 'auto 100%';
	    }
	
	    callback(null, backgroundSize);
	  };
	
	  if (file) {
	    img.src = file.preview || file;
	  } else {
	    callback();
	  }
	};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	exports.no = exports.noCase = __webpack_require__(30)
	exports.dot = exports.dotCase = __webpack_require__(559)
	exports.swap = exports.swapCase = __webpack_require__(775)
	exports.path = exports.pathCase = __webpack_require__(711)
	exports.upper = exports.upperCase = __webpack_require__(40)
	exports.lower = exports.lowerCase = __webpack_require__(75)
	exports.camel = exports.camelCase = __webpack_require__(221)
	exports.snake = exports.snakeCase = __webpack_require__(279)
	exports.title = exports.titleCase = __webpack_require__(778)
	exports.param = exports.paramCase = __webpack_require__(709)
	exports.kebab = exports.kebabCase = exports.paramCase
	exports.hyphen = exports.hyphenCase = exports.paramCase
	exports.header = exports.headerCase = __webpack_require__(574)
	exports.pascal = exports.pascalCase = __webpack_require__(710)
	exports.constant = exports.constantCase = __webpack_require__(532)
	exports.sentence = exports.sentenceCase = __webpack_require__(407)
	exports.isUpper = exports.isUpperCase = __webpack_require__(591)
	exports.isLower = exports.isLowerCase = __webpack_require__(590)
	exports.ucFirst = exports.upperCaseFirst = __webpack_require__(154)
	exports.lcFirst = exports.lowerCaseFirst = __webpack_require__(702)


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Badge = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueBadge,
	    name: 'Badge',
	    tag: 'f7-badge'
	});
	
	//# sourceMappingURL=Badge.js.map


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.DataTableCell = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueDataTableCell,
	    name: 'DataTableCell',
	    tag: 'f7-table-cell',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=DataTableCell.js.map


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Icon = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueIcon,
	    name: 'Icon',
	    tag: 'f7-icon'
	});
	
	//# sourceMappingURL=Icon.js.map


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var Badge_1 = __webpack_require__(110);
	var Icon_1 = __webpack_require__(112);
	var framework7_vue_2 = __webpack_require__(2);
	exports.Link = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueLink,
	    name: 'Link',
	    tag: 'f7-link',
	    events: [
	        'click'
	    ],
	    instantiatedComponents: [
	        Badge_1.Badge,
	        Icon_1.Icon
	    ],
	    mixin: framework7_vue_2.VueLinkMixin
	});
	
	//# sourceMappingURL=Link.js.map


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(83);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(85);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(42);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget);
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _this.getOverlayDOMNode = function () {
	      if (!_this._isMounted) {
	        throw new Error('getOverlayDOMNode(): A component must be mounted to have a DOM node.');
	      }
	
	      if (_this._overlayInstance) {
	        return _reactDom2.default.findDOMNode(_this._overlayInstance);
	      }
	
	      return null;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func])
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cartSelector = exports.cartGroupedSelector = undefined;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reselect = __webpack_require__(18);
	
	var _cart = __webpack_require__(51);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _constants = __webpack_require__(9);
	
	var _common = __webpack_require__(88);
	
	var _voucher = __webpack_require__(117);
	
	var _voucher2 = __webpack_require__(33);
	
	var _voucher3 = _interopRequireDefault(_voucher2);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var cartGroupedSelector = exports.cartGroupedSelector = (0, _reselect.createSelector)(_common.currentOrderSelector, function (order) {
	  if (!order && !order.id) {
	    return {};
	  }
	
	  return _lodash2.default.values(_lodash2.default.groupBy(order.cart, function (item) {
	    // plain items
	    if (item.modifiers.length === 0) {
	      return item.id;
	    }
	    // item with modifiers
	    return item.cart_id || Math.random().toString(16);
	  })).sort(function (group1, group2) {
	    if (group1[0].name >= group2[0].name) {
	      return 1;
	    }
	    return -1;
	  });
	});
	
	var cartSelector = exports.cartSelector = function cartSelector(localizedLabels) {
	  return (0, _reselect.createSelector)(_common.currentOrderSelector, _voucher.usableVouchersSelector, function (order, voucher) {
	    if (!order || !order.orderType) {
	      return null;
	    }
	
	    // filteredVouchers should be null if there are no usable vouchers (e.g. they were not fetched).
	    var filteredVouchers = !voucher ? null : _voucher3.default.voucherForService(voucher, 'order', order.orderType);
	
	    // if is an archived order the extra costs are already
	    // serialized thus we don't need to filter by order type
	    var extraCosts = Array.isArray(order.extraCosts) ? [].concat(_toConsumableArray(order.extraCosts)) :
	    // use [] to prevent crash (babel toConsumableArray err) if there's
	    // no extraCosts for this orderType
	    [].concat(_toConsumableArray(order.extraCosts[order.orderType] || []));
	
	    var extraCostsVoucher = null;
	    var voucherAmountString = null;
	
	    if (order.selectedVoucher && order.selectedVoucher !== _constants.ORDER_NO_VOUCHER) {
	      var voucherData = _voucher3.default.getVoucherWithId(filteredVouchers, order.selectedVoucher);
	      var language = _i18n2.default.currentLanguage(localizedLabels.language);
	      var voucherFormatted = _voucher3.default.format(voucherData, localizedLabels, language);
	
	      voucherAmountString = voucherData && voucherData.discount && voucherData.discount.format !== _constants.VOUCHER_FORMAT_FREE_ITEM ? voucherFormatted ? '- ' + voucherFormatted.subtitle : '' : "";
	
	      if (voucherData) {
	        extraCostsVoucher = _cart2.default.extraCostFromVoucher(voucherData, order.cart);
	        extraCosts.push(extraCostsVoucher);
	      }
	    }
	
	    var subtotal = _cart2.default.subTotal(order.cart);
	
	    // total all inclusive (delivery costs, voucher and other stuff)
	    // if is an archived order use the fixed total field
	    var total = order.total ? order.total : _voucher3.default.cartTotalWithVoucher(order.cart, order.extraCosts[order.orderType], order.selectedVoucher, filteredVouchers);
	
	    // total without extra costs like delivery but with voucher discount applied
	    var totalNoExtraCosts = _voucher3.default.cartTotalWithVoucher(order.cart, [], order.selectedVoucher, filteredVouchers);
	
	    return {
	      voucherAmountString: voucherAmountString,
	      extraCosts: extraCosts,
	      subtotal: subtotal,
	      total: total,
	      totalNoExtraCosts: totalNoExtraCosts,
	      vouchers: !filteredVouchers ? null : [{
	        id: _constants.ORDER_NO_VOUCHER,
	        message: 'Nessuno sconto'
	      }].concat(filteredVouchers)
	    };
	  });
	};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userCreditCardsSelector = exports.lastOrdersSelector = undefined;
	
	var _reselect = __webpack_require__(18);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastOrdersSelector = exports.lastOrdersSelector = (0, _reselect.createSelector)(function (state) {
	  return state.user.currentUser;
	}, function (currentUser) {
	  var orderCmpFn = function orderCmpFn(order1, order2) {
	    return _lodash2.default.isEqual(order1.address, order2.address);
	  };
	  if (currentUser && currentUser.orders) {
	    return _lodash2.default.uniqWith(currentUser.orders.filter(function (order) {
	      return order.type === 'DELIVERY';
	    }), orderCmpFn) || [];
	  }
	  return [];
	});
	
	var userCreditCardsSelector = exports.userCreditCardsSelector = (0, _reselect.createSelector)(function (state) {
	  return state.user.currentUser;
	}, function (user) {
	  if (!user) {
	    return [];
	  }
	  if (!user.creditCards) {
	    return [];
	  }
	  return user.creditCards;
	});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assignedVouchersSelector = exports.usableVouchersSelector = undefined;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reselect = __webpack_require__(18);
	
	var _cart = __webpack_require__(51);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _voucher = __webpack_require__(33);
	
	var _voucher2 = _interopRequireDefault(_voucher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usableVouchersSelector = exports.usableVouchersSelector = (0, _reselect.createSelector)(function (state) {
	  return state.voucher;
	}, function (state) {
	  return state.order.cart.length;
	}, function (state) {
	  return _cart2.default.total(state.order.cart);
	}, function (voucher, cartItemsLength, cartTotal) {
	  if (!voucher || !voucher.instances) {
	    return null;
	  }
	  return _lodash2.default.filter(voucher.instances, function (x) {
	    var threshold = x.constraints.threshold || 0;
	    // voucher instances filterd by modules and threshold
	    if (cartItemsLength === 0) {
	      return _voucher2.default.isVoucherUsable(x);
	    }
	    return _voucher2.default.isVoucherUsable(x) && cartTotal >= threshold;
	  });
	});
	
	var assignedVouchersSelector = exports.assignedVouchersSelector = (0, _reselect.createSelector)(function (state) {
	  return state.voucher;
	}, function (voucher) {
	  if (!voucher || !voucher.instances) {
	    return null;
	  }
	  return voucher.instances.filter(function (x) {
	    return _voucher2.default.isVoucherAssigned(x);
	  });
	});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(14);
	tslib_1.__exportStar(__webpack_require__(444), exports);
	var linkUtils_1 = __webpack_require__(207);
	exports.createOperation = linkUtils_1.createOperation;
	exports.makePromise = linkUtils_1.makePromise;
	exports.toPromise = linkUtils_1.toPromise;
	exports.fromPromise = linkUtils_1.fromPromise;
	exports.fromError = linkUtils_1.fromError;
	exports.getOperationName = linkUtils_1.getOperationName;
	var zen_observable_ts_1 = tslib_1.__importDefault(__webpack_require__(155));
	exports.Observable = zen_observable_ts_1.default;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatExtraCost = function formatExtraCost(c, property, index) {
	  var negative = c.type.toLowerCase() === 'negative';
	  var plusOrMinus = negative ? '- ' : ' ';
	  var classes = (0, _classnames2.default)('cartTotal__extraCostItem', { 'cartTotal__extraCostItem--discount accent': negative });
	  if (property === 'label') {
	    return _react2.default.createElement(
	      'p',
	      { key: index, className: classes },
	      c.label
	    );
	  }
	  return _react2.default.createElement(
	    'p',
	    { key: index, className: classes },
	    plusOrMinus,
	    _i18n2.default.formatPrice(c.amount)
	  );
	};
	
	var CartTotal = function CartTotal(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'cartTotal' },
	    _react2.default.createElement(
	      'div',
	      { className: 'cartTotal__labels' },
	      _react2.default.createElement(
	        'p',
	        { className: 'cartTotal__Item--subtotal' },
	        'SUBTOTALE'
	      ),
	      props.extraCosts.map(function (c, index) {
	        return formatExtraCost(c, 'label', index);
	      }),
	      _react2.default.createElement(
	        'p',
	        { className: 'cartTotal__Item--total' },
	        'TOTALE'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cartTotal__amounts' },
	      _react2.default.createElement(
	        'p',
	        { className: 'cartTotal__Item--subtotal' },
	        _i18n2.default.formatPrice(props.subtotal)
	      ),
	      props.extraCosts.map(function (c, index) {
	        return formatExtraCost(c, 'cost', index);
	      }),
	      _react2.default.createElement(
	        'p',
	        { className: 'cartTotal__Item--total' },
	        _i18n2.default.formatPrice(props.total)
	      )
	    )
	  );
	};
	
	CartTotal.propTypes = {
	  total: _propTypes2.default.number.isRequired,
	  subtotal: _propTypes2.default.number.isRequired,
	  extraCosts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    amount: _propTypes2.default.number.isRequired,
	    label: _propTypes2.default.string.isRequired
	  }))
	};
	
	exports.default = CartTotal;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */
	/* global google */
	
	var GoogleMap = function (_React$Component) {
	  _inherits(GoogleMap, _React$Component);
	
	  function GoogleMap(props) {
	    _classCallCheck(this, GoogleMap);
	
	    var _this = _possibleConstructorReturn(this, (GoogleMap.__proto__ || Object.getPrototypeOf(GoogleMap)).call(this, props));
	
	    _this.initialized = false;
	    return _this;
	  }
	
	  _createClass(GoogleMap, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!this.initialized && window.isMapReady) {
	        // initialize
	        this.map = new google.maps.Map(this.mapNode, {
	          center: this.props.center,
	          zoom: 16
	        });
	
	        // add markers
	        this.markers = this.props.markers.map(function (m) {
	          return new google.maps.Marker({
	            position: m,
	            map: _this2.map
	          });
	        });
	        this.initialized = true;
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.markers.forEach(function (m) {
	        return m.setMap(null);
	      });
	      this.markers = nextProps.markers.map(function (m) {
	        return new google.maps.Marker({
	          position: m,
	          map: _this3.map
	        });
	      });
	      this.map.setCenter(nextProps.center);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      return _react2.default.createElement('div', {
	        className: 'googleMap',
	        ref: function ref(node) {
	          _this4.mapNode = node;
	        }
	      });
	    }
	  }]);
	
	  return GoogleMap;
	}(_react2.default.Component);
	
	GoogleMap.propTypes = {
	  center: _propTypes2.default.shape({
	    lat: _propTypes2.default.number,
	    lng: _propTypes2.default.number
	  }),
	  markers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    lat: _propTypes2.default.number,
	    lng: _propTypes2.default.number
	  }))
	};
	
	exports.default = GoogleMap;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var header = function header(props) {
	  return _react2.default.createElement(
	    'header',
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      props.children
	    )
	  );
	};
	
	exports.default = header;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function List(props) {
	  return _react2.default.createElement(
	    "ul",
	    { className: "grow mobile-list" },
	    props.children
	  );
	};
	
	exports.default = List;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userRequired = exports.SigninSignupPage = exports.SigninSignup = undefined;
	
	__webpack_require__(773);
	
	var _signinSignup = __webpack_require__(216);
	
	var _signinSignup2 = _interopRequireDefault(_signinSignup);
	
	var _userRequired = __webpack_require__(217);
	
	var _userRequired2 = _interopRequireDefault(_userRequired);
	
	var _signinSignupPage = __webpack_require__(493);
	
	var _signinSignupPage2 = _interopRequireDefault(_signinSignupPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SigninSignup = _signinSignup2.default;
	exports.SigninSignupPage = _signinSignupPage2.default;
	exports.userRequired = _userRequired2.default;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = __webpack_require__(518)();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(46));
	
	var _default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	exports.default = _default;
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	  return false;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(67));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = style;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(225));
	
	var _hyphenateStyle = _interopRequireDefault(__webpack_require__(557));
	
	var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(551));
	
	var _removeStyle = _interopRequireDefault(__webpack_require__(552));
	
	var _properties = __webpack_require__(554);
	
	var _isTransform = _interopRequireDefault(__webpack_require__(553));
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	
	    if (!value && value !== 0) {
	      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
	    } else if ((0, _isTransform.default)(key)) {
	      transforms += key + "(" + value + ") ";
	    } else {
	      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ": " + transforms + ";";
	  }
	
	  node.style.cssText += ';' + css;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(227);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.visit = visit;
	exports.visitInParallel = visitInParallel;
	exports.visitWithTypeInfo = visitWithTypeInfo;
	exports.getVisitFn = getVisitFn;
	exports.BREAK = exports.QueryDocumentKeys = void 0;
	
	var _inspect = _interopRequireDefault(__webpack_require__(233));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QueryDocumentKeys = {
	  Name: [],
	  Document: ['definitions'],
	  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
	  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
	  Variable: ['name'],
	  SelectionSet: ['selections'],
	  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
	  Argument: ['name', 'value'],
	  FragmentSpread: ['name', 'directives'],
	  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
	  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
	  // or removed in the future.
	  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
	  IntValue: [],
	  FloatValue: [],
	  StringValue: [],
	  BooleanValue: [],
	  NullValue: [],
	  EnumValue: [],
	  ListValue: ['values'],
	  ObjectValue: ['fields'],
	  ObjectField: ['name', 'value'],
	  Directive: ['name', 'arguments'],
	  NamedType: ['name'],
	  ListType: ['type'],
	  NonNullType: ['type'],
	  SchemaDefinition: ['directives', 'operationTypes'],
	  OperationTypeDefinition: ['type'],
	  ScalarTypeDefinition: ['description', 'name', 'directives'],
	  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
	  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
	  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
	  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
	  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
	  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
	  EnumValueDefinition: ['description', 'name', 'directives'],
	  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
	  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
	  SchemaExtension: ['directives', 'operationTypes'],
	  ScalarTypeExtension: ['name', 'directives'],
	  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
	  InterfaceTypeExtension: ['name', 'directives', 'fields'],
	  UnionTypeExtension: ['name', 'directives', 'types'],
	  EnumTypeExtension: ['name', 'directives', 'values'],
	  InputObjectTypeExtension: ['name', 'directives', 'fields']
	};
	exports.QueryDocumentKeys = QueryDocumentKeys;
	var BREAK = Object.freeze({});
	/**
	 * visit() will walk through an AST using a depth first traversal, calling
	 * the visitor's enter function at each node in the traversal, and calling the
	 * leave function after visiting that node and all of its child nodes.
	 *
	 * By returning different values from the enter and leave functions, the
	 * behavior of the visitor can be altered, including skipping over a sub-tree of
	 * the AST (by returning false), editing the AST by returning a value or null
	 * to remove the value, or to stop the whole traversal by returning BREAK.
	 *
	 * When using visit() to edit an AST, the original AST will not be modified, and
	 * a new version of the AST with the changes applied will be returned from the
	 * visit function.
	 *
	 *     const editedAST = visit(ast, {
	 *       enter(node, key, parent, path, ancestors) {
	 *         // @return
	 *         //   undefined: no action
	 *         //   false: skip visiting this node
	 *         //   visitor.BREAK: stop visiting altogether
	 *         //   null: delete this node
	 *         //   any value: replace this node with the returned value
	 *       },
	 *       leave(node, key, parent, path, ancestors) {
	 *         // @return
	 *         //   undefined: no action
	 *         //   false: no action
	 *         //   visitor.BREAK: stop visiting altogether
	 *         //   null: delete this node
	 *         //   any value: replace this node with the returned value
	 *       }
	 *     });
	 *
	 * Alternatively to providing enter() and leave() functions, a visitor can
	 * instead provide functions named the same as the kinds of AST nodes, or
	 * enter/leave visitors at a named key, leading to four permutations of
	 * visitor API:
	 *
	 * 1) Named visitors triggered when entering a node a specific kind.
	 *
	 *     visit(ast, {
	 *       Kind(node) {
	 *         // enter the "Kind" node
	 *       }
	 *     })
	 *
	 * 2) Named visitors that trigger upon entering and leaving a node of
	 *    a specific kind.
	 *
	 *     visit(ast, {
	 *       Kind: {
	 *         enter(node) {
	 *           // enter the "Kind" node
	 *         }
	 *         leave(node) {
	 *           // leave the "Kind" node
	 *         }
	 *       }
	 *     })
	 *
	 * 3) Generic visitors that trigger upon entering and leaving any node.
	 *
	 *     visit(ast, {
	 *       enter(node) {
	 *         // enter any node
	 *       },
	 *       leave(node) {
	 *         // leave any node
	 *       }
	 *     })
	 *
	 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
	 *
	 *     visit(ast, {
	 *       enter: {
	 *         Kind(node) {
	 *           // enter the "Kind" node
	 *         }
	 *       },
	 *       leave: {
	 *         Kind(node) {
	 *           // leave the "Kind" node
	 *         }
	 *       }
	 *     })
	 */
	
	exports.BREAK = BREAK;
	
	function visit(root, visitor) {
	  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;
	
	  /* eslint-disable no-undef-init */
	  var stack = undefined;
	  var inArray = Array.isArray(root);
	  var keys = [root];
	  var index = -1;
	  var edits = [];
	  var node = undefined;
	  var key = undefined;
	  var parent = undefined;
	  var path = [];
	  var ancestors = [];
	  var newRoot = root;
	  /* eslint-enable no-undef-init */
	
	  do {
	    index++;
	    var isLeaving = index === keys.length;
	    var isEdited = isLeaving && edits.length !== 0;
	
	    if (isLeaving) {
	      key = ancestors.length === 0 ? undefined : path[path.length - 1];
	      node = parent;
	      parent = ancestors.pop();
	
	      if (isEdited) {
	        if (inArray) {
	          node = node.slice();
	        } else {
	          var clone = {};
	
	          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
	            var k = _Object$keys2[_i2];
	            clone[k] = node[k];
	          }
	
	          node = clone;
	        }
	
	        var editOffset = 0;
	
	        for (var ii = 0; ii < edits.length; ii++) {
	          var editKey = edits[ii][0];
	          var editValue = edits[ii][1];
	
	          if (inArray) {
	            editKey -= editOffset;
	          }
	
	          if (inArray && editValue === null) {
	            node.splice(editKey, 1);
	            editOffset++;
	          } else {
	            node[editKey] = editValue;
	          }
	        }
	      }
	
	      index = stack.index;
	      keys = stack.keys;
	      edits = stack.edits;
	      inArray = stack.inArray;
	      stack = stack.prev;
	    } else {
	      key = parent ? inArray ? index : keys[index] : undefined;
	      node = parent ? parent[key] : newRoot;
	
	      if (node === null || node === undefined) {
	        continue;
	      }
	
	      if (parent) {
	        path.push(key);
	      }
	    }
	
	    var result = void 0;
	
	    if (!Array.isArray(node)) {
	      if (!isNode(node)) {
	        throw new Error('Invalid AST Node: ' + (0, _inspect.default)(node));
	      }
	
	      var visitFn = getVisitFn(visitor, node.kind, isLeaving);
	
	      if (visitFn) {
	        result = visitFn.call(visitor, node, key, parent, path, ancestors);
	
	        if (result === BREAK) {
	          break;
	        }
	
	        if (result === false) {
	          if (!isLeaving) {
	            path.pop();
	            continue;
	          }
	        } else if (result !== undefined) {
	          edits.push([key, result]);
	
	          if (!isLeaving) {
	            if (isNode(result)) {
	              node = result;
	            } else {
	              path.pop();
	              continue;
	            }
	          }
	        }
	      }
	    }
	
	    if (result === undefined && isEdited) {
	      edits.push([key, node]);
	    }
	
	    if (isLeaving) {
	      path.pop();
	    } else {
	      stack = {
	        inArray: inArray,
	        index: index,
	        keys: keys,
	        edits: edits,
	        prev: stack
	      };
	      inArray = Array.isArray(node);
	      keys = inArray ? node : visitorKeys[node.kind] || [];
	      index = -1;
	      edits = [];
	
	      if (parent) {
	        ancestors.push(parent);
	      }
	
	      parent = node;
	    }
	  } while (stack !== undefined);
	
	  if (edits.length !== 0) {
	    newRoot = edits[edits.length - 1][1];
	  }
	
	  return newRoot;
	}
	
	function isNode(maybeNode) {
	  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
	}
	/**
	 * Creates a new visitor instance which delegates to many visitors to run in
	 * parallel. Each visitor will be visited for each node before moving on.
	 *
	 * If a prior visitor edits a node, no following visitors will see that node.
	 */
	
	
	function visitInParallel(visitors) {
	  var skipping = new Array(visitors.length);
	  return {
	    enter: function enter(node) {
	      for (var i = 0; i < visitors.length; i++) {
	        if (!skipping[i]) {
	          var fn = getVisitFn(visitors[i], node.kind,
	          /* isLeaving */
	          false);
	
	          if (fn) {
	            var result = fn.apply(visitors[i], arguments);
	
	            if (result === false) {
	              skipping[i] = node;
	            } else if (result === BREAK) {
	              skipping[i] = BREAK;
	            } else if (result !== undefined) {
	              return result;
	            }
	          }
	        }
	      }
	    },
	    leave: function leave(node) {
	      for (var i = 0; i < visitors.length; i++) {
	        if (!skipping[i]) {
	          var fn = getVisitFn(visitors[i], node.kind,
	          /* isLeaving */
	          true);
	
	          if (fn) {
	            var result = fn.apply(visitors[i], arguments);
	
	            if (result === BREAK) {
	              skipping[i] = BREAK;
	            } else if (result !== undefined && result !== false) {
	              return result;
	            }
	          }
	        } else if (skipping[i] === node) {
	          skipping[i] = null;
	        }
	      }
	    }
	  };
	}
	/**
	 * Creates a new visitor instance which maintains a provided TypeInfo instance
	 * along with visiting visitor.
	 */
	
	
	function visitWithTypeInfo(typeInfo, visitor) {
	  return {
	    enter: function enter(node) {
	      typeInfo.enter(node);
	      var fn = getVisitFn(visitor, node.kind,
	      /* isLeaving */
	      false);
	
	      if (fn) {
	        var result = fn.apply(visitor, arguments);
	
	        if (result !== undefined) {
	          typeInfo.leave(node);
	
	          if (isNode(result)) {
	            typeInfo.enter(result);
	          }
	        }
	
	        return result;
	      }
	    },
	    leave: function leave(node) {
	      var fn = getVisitFn(visitor, node.kind,
	      /* isLeaving */
	      true);
	      var result;
	
	      if (fn) {
	        result = fn.apply(visitor, arguments);
	      }
	
	      typeInfo.leave(node);
	      return result;
	    }
	  };
	}
	/**
	 * Given a visitor instance, if it is leaving or not, and a node kind, return
	 * the function the visitor runtime should call.
	 */
	
	
	function getVisitFn(visitor, kind, isLeaving) {
	  var kindVisitor = visitor[kind];
	
	  if (kindVisitor) {
	    if (!isLeaving && typeof kindVisitor === 'function') {
	      // { Kind() {} }
	      return kindVisitor;
	    }
	
	    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
	
	    if (typeof kindSpecificVisitor === 'function') {
	      // { Kind: { enter() {}, leave() {} } }
	      return kindSpecificVisitor;
	    }
	  } else {
	    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
	
	    if (specificVisitor) {
	      if (typeof specificVisitor === 'function') {
	        // { enter() {}, leave() {} }
	        return specificVisitor;
	      }
	
	      var specificKindVisitor = specificVisitor[kind];
	
	      if (typeof specificKindVisitor === 'function') {
	        // { enter: { Kind() {} }, leave: { Kind() {} } }
	        return specificKindVisitor;
	      }
	    }
	  }
	}


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(56);
	
	var _DOMUtils = __webpack_require__(94);
	
	var _DOMStateStorage = __webpack_require__(238);
	
	var _PathUtils = __webpack_require__(37);
	
	var _ExecutionEnvironment = __webpack_require__(131);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(575);
	
	var _PathUtils = __webpack_require__(37);
	
	var _runTransitionHook = __webpack_require__(133);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(93);
	
	var _LocationUtils = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(589).default;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(28);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(662),
	    mapCacheDelete = __webpack_require__(663),
	    mapCacheGet = __webpack_require__(664),
	    mapCacheHas = __webpack_require__(665),
	    mapCacheSet = __webpack_require__(666);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(619),
	    baseMatchesProperty = __webpack_require__(620),
	    identity = __webpack_require__(101),
	    isArray = __webpack_require__(29),
	    property = __webpack_require__(694);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(29),
	    isSymbol = __webpack_require__(74);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var _ = __webpack_require__(692).runInContext();
	module.exports = __webpack_require__(687)(_, _);


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(612),
	    isObjectLike = __webpack_require__(59);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 143 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    getPrototype = __webpack_require__(641),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(721);
	} else {
	  module.exports = require('./cjs/react-dom-server.browser.development.js');
	}


/***/ }),
/* 146 */
[788, 726],
/* 147 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(3);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(754);
	
	var _createReactClass = __webpack_require__(27);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _getRouteParams = __webpack_require__(744);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(148);
	
	var _RouteUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.providerContextTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO(jez) 'sync' and 'async' are bad tag names.
	// TODO(jez) What if redux also uses this.context.tag?
	var providerContextTypes = exports.providerContextTypes = {
	  tag: _propTypes2.default.string.isRequired,
	  stripe: _propTypes2.default.object,
	  addStripeLoadListener: _propTypes2.default.func
	};
	
	var getOrCreateStripe = function getOrCreateStripe(apiKey, options) {
	  /**
	   * Note that this is not meant to be a generic memoization solution.
	   * This is specifically a solution for `StripeProvider`s being initialized
	   * and destroyed regularly (with the same set of props) when users only
	   * use `StripeProvider` for the subtree that contains their checkout form.
	   */
	  window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
	  var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);
	
	  var stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
	  window.Stripe.__cachedInstances[cacheKey] = stripe;
	
	  return stripe;
	};
	
	var ensureStripeShape = function ensureStripeShape(stripe) {
	  if (stripe && stripe.elements && stripe.createSource && stripe.createToken && stripe.createPaymentMethod && stripe.handleCardPayment) {
	    return stripe;
	  } else {
	    throw new Error("Please pass a valid Stripe object to StripeProvider. You can obtain a Stripe object by calling 'Stripe(...)' with your publishable key.");
	  }
	};
	
	var Provider = function (_React$Component) {
	  _inherits(Provider, _React$Component);
	
	  // on the other hand: childContextTypes is *required* to use context.
	  function Provider(props) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    if (_this.props.apiKey && _this.props.stripe) {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider, not both.");
	    } else if (_this.props.apiKey) {
	      if (!window.Stripe) {
	        throw new Error("Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements. If Stripe.js isn't available yet (it's loading asynchronously, or you're using server-side rendering), see https://github.com/stripe/react-stripe-elements#advanced-integrations");
	      } else {
	        var _this$props = _this.props,
	            _apiKey = _this$props.apiKey,
	            _children = _this$props.children,
	            _stripe = _this$props.stripe,
	            options = _objectWithoutProperties(_this$props, ['apiKey', 'children', 'stripe']);
	
	        _this._meta = {
	          tag: 'sync',
	          stripe: getOrCreateStripe(_apiKey, options)
	        };
	      }
	    } else if (_this.props.stripe) {
	      // If we already have a stripe instance (in the constructor), we can behave synchronously.
	      _this._meta = {
	        tag: 'sync',
	        stripe: ensureStripeShape(_this.props.stripe)
	      };
	    } else if (_this.props.stripe === null) {
	      _this._meta = {
	        tag: 'async',
	        stripe: null
	      };
	    } else {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider. If you're using 'stripe' but don't have a Stripe instance yet, pass 'null' explicitly.");
	    }
	
	    _this._didWarn = false;
	    _this._didWakeUpListeners = false;
	    _this._listeners = [];
	    return _this;
	  }
	  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.
	
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    // getChildContext is run after the constructor, so we WILL have access to
	    // the initial state.
	    //
	    // However, context doesn't update in respnse to state changes like you
	    // might expect: context is pulled by the child, not pushed by the parent.
	    if (this._meta.tag === 'sync') {
	      return {
	        tag: 'sync',
	        stripe: this._meta.stripe
	      };
	    } else {
	      return {
	        tag: 'async',
	        addStripeLoadListener: function addStripeLoadListener(fn) {
	          if (_this2._meta.stripe) {
	            fn(_this2._meta.stripe);
	          } else {
	            _this2._listeners.push(fn);
	          }
	        }
	      };
	    }
	  };
	
	  Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var apiKeyChanged = this.props.apiKey && nextProps.apiKey && this.props.apiKey !== nextProps.apiKey;
	
	    var stripeInstanceChanged = this.props.stripe && nextProps.stripe && this.props.stripe !== nextProps.stripe;
	    if (!this._didWarn && (apiKeyChanged || stripeInstanceChanged) && window.console && window.console.error) {
	      this._didWarn = true;
	      // eslint-disable-next-line no-console
	      console.error('StripeProvider does not support changing the apiKey parameter.');
	      return;
	    }
	
	    if (!this._didWakeUpListeners && nextProps.stripe) {
	      // Wake up the listeners if we've finally been given a StripeShape
	      this._didWakeUpListeners = true;
	      var _stripe2 = ensureStripeShape(nextProps.stripe);
	      this._meta.stripe = _stripe2;
	      this._listeners.forEach(function (fn) {
	        fn(_stripe2);
	      });
	    }
	  };
	
	  Provider.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react2.default.Component);
	
	Provider.propTypes = {
	  apiKey: _propTypes2.default.string,
	  // PropTypes.object is the only way we can accept a Stripe instance
	  // eslint-disable-next-line react/forbid-prop-types
	  stripe: _propTypes2.default.object,
	  children: _propTypes2.default.node
	};
	Provider.childContextTypes = providerContextTypes;
	Provider.defaultProps = {
	  apiKey: undefined,
	  stripe: undefined,
	  children: null
	};
	exports.default = Provider;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.IdealBankElement = exports.IbanElement = exports.PaymentRequestButtonElement = exports.CardCVCElement = exports.CardCvcElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;
	
	var _Provider = __webpack_require__(151);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _inject = __webpack_require__(757);
	
	var _inject2 = _interopRequireDefault(_inject);
	
	var _Elements = __webpack_require__(103);
	
	var _Elements2 = _interopRequireDefault(_Elements);
	
	var _Element = __webpack_require__(755);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _PaymentRequestButtonElement = __webpack_require__(756);
	
	var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Define Elements, and register their implied token / source types for
	// automatic token / source creation.
	
	// Card
	var CardElement = (0, _Element2.default)('card', {
	  impliedTokenType: 'card',
	  impliedSourceType: 'card',
	  impliedPaymentMethodType: 'card'
	});
	
	// Split Fields
	// Note: we only register the CardNumberElement for split fields so that we have
	// a unique Element to infer when calling `wrappedCreateToken` or `wrappedCreateSource`.
	
	var CardNumberElement = (0, _Element2.default)('cardNumber', {
	  impliedTokenType: 'card',
	  impliedSourceType: 'card',
	  impliedPaymentMethodType: 'card'
	});
	var CardExpiryElement = (0, _Element2.default)('cardExpiry');
	var CardCvcElement = (0, _Element2.default)('cardCvc');
	var CardCVCElement = CardCvcElement; // deprecated in favor of CardCvcElement which better matches Elements API
	
	// IBAN
	var IbanElement = (0, _Element2.default)('iban', {
	  impliedTokenType: 'bank_account',
	  impliedSourceType: 'sepa_debit'
	});
	
	// iDEAL Bank
	var IdealBankElement = (0, _Element2.default)('idealBank', { impliedSourceType: 'ideal' });
	
	exports.StripeProvider = _Provider2.default;
	exports.injectStripe = _inject2.default;
	exports.Elements = _Elements2.default;
	exports.CardElement = CardElement;
	exports.CardNumberElement = CardNumberElement;
	exports.CardExpiryElement = CardExpiryElement;
	exports.CardCvcElement = CardCvcElement;
	exports.CardCVCElement = CardCVCElement;
	exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;
	exports.IbanElement = IbanElement;
	exports.IdealBankElement = IdealBankElement;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(277);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(764);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(763);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(762);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(276);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(278);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(40)
	
	/**
	 * Upper case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return upperCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(14);
	var zenObservable_1 = __webpack_require__(281);
	tslib_1.__exportStar(__webpack_require__(281), exports);
	exports.default = zenObservable_1.Observable;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Mutation = Mutation;
	exports.Query = Query;
	exports.Subscription = Subscription;
	exports.resetApolloContext = exports.getApolloContext = exports.ApolloProvider = exports.ApolloConsumer = void 0;
	
	var _reactCommon = __webpack_require__(62);
	
	exports.ApolloConsumer = _reactCommon.ApolloConsumer;
	exports.ApolloProvider = _reactCommon.ApolloProvider;
	exports.getApolloContext = _reactCommon.getApolloContext;
	exports.resetApolloContext = _reactCommon.resetApolloContext;
	
	var _tslib = __webpack_require__(14);
	
	var _reactHooks = __webpack_require__(105);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Query(props) {
	  var children = props.children,
	      query = props.query,
	      options = (0, _tslib.__rest)(props, ["children", "query"]);
	  var result = (0, _reactHooks.useQuery)(query, options);
	  return children && result ? children(result) : null;
	}
	
	(function (Query) {
	  Query.propTypes = {
	    client: _propTypes.default.object,
	    children: _propTypes.default.func.isRequired,
	    fetchPolicy: _propTypes.default.string,
	    notifyOnNetworkStatusChange: _propTypes.default.bool,
	    onCompleted: _propTypes.default.func,
	    onError: _propTypes.default.func,
	    pollInterval: _propTypes.default.number,
	    query: _propTypes.default.object.isRequired,
	    variables: _propTypes.default.object,
	    ssr: _propTypes.default.bool,
	    partialRefetch: _propTypes.default.bool,
	    returnPartialData: _propTypes.default.bool
	  };
	})(Query || (exports.Query = Query = {}));
	
	function Mutation(props) {
	  var _a = (0, _reactHooks.useMutation)(props.mutation, props),
	      runMutation = _a[0],
	      result = _a[1];
	
	  return props.children ? props.children(runMutation, result) : null;
	}
	
	(function (Mutation) {
	  Mutation.propTypes = {
	    mutation: _propTypes.default.object.isRequired,
	    variables: _propTypes.default.object,
	    optimisticResponse: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	    refetchQueries: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object])), _propTypes.default.func]),
	    awaitRefetchQueries: _propTypes.default.bool,
	    update: _propTypes.default.func,
	    children: _propTypes.default.func.isRequired,
	    onCompleted: _propTypes.default.func,
	    onError: _propTypes.default.func,
	    fetchPolicy: _propTypes.default.string
	  };
	})(Mutation || (exports.Mutation = Mutation = {}));
	
	function Subscription(props) {
	  var result = (0, _reactHooks.useSubscription)(props.subscription, props);
	  return props.children && result ? props.children(result) : null;
	}
	
	(function (Subscription) {
	  Subscription.propTypes = {
	    subscription: _propTypes.default.object.isRequired,
	    variables: _propTypes.default.object,
	    children: _propTypes.default.func,
	    onSubscriptionData: _propTypes.default.func,
	    onSubscriptionComplete: _propTypes.default.func,
	    shouldResubscribe: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.bool])
	  };
	})(Subscription || (exports.Subscription = Subscription = {}));


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Button = function Button(props) {
	  var title = props.title,
	      label = props.label,
	      customClassNames = props.customClassNames,
	      onClick = props.onClick,
	      otherFieldsErrorsCount = props.otherFieldsErrorsCount;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: _classnames2.default.apply(undefined, ['field', 'buttonContainerField'].concat(_toConsumableArray((0, _utils.fixCustomClassNames)(customClassNames)))) },
	    _react2.default.createElement(
	      'div',
	      { className: 'ui button', title: title, onClick: onClick },
	      label
	    ),
	    otherFieldsErrorsCount > 0 && _react2.default.createElement(
	      'label',
	      { className: 'ui red basic label', style: { visibility: 'hidden' } },
	      _lodash2.default.range(otherFieldsErrorsCount).map(function (i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i },
	          '...'
	        );
	      })
	    )
	  );
	};
	
	Button.propTypes = {
	  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  customClassNames: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  onClick: _propTypes2.default.func.isRequired,
	  otherFieldsErrorsCount: _propTypes2.default.number,
	  title: _propTypes2.default.string
	};
	
	exports.default = Button;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDropzone = __webpack_require__(386);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PictureModal = __webpack_require__(163);
	
	var _PictureModal2 = _interopRequireDefault(_PictureModal);
	
	var _files = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FileInput = function (_Component) {
	  _inherits(FileInput, _Component);
	
	  function FileInput(props) {
	    _classCallCheck(this, FileInput);
	
	    var _this = _possibleConstructorReturn(this, (FileInput.__proto__ || Object.getPrototypeOf(FileInput)).call(this, props));
	
	    _this.state = {
	      shouldShowModal: false
	    };
	    return _this;
	  }
	
	  _createClass(FileInput, [{
	    key: 'onImageClick',
	    value: function onImageClick() {
	      this.setState({ shouldShowModal: true });
	    }
	  }, {
	    key: 'onModalHide',
	    value: function onModalHide() {
	      this.setState({ shouldShowModal: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          item = _props.item,
	          files = _props.files,
	          filesUrls = _props.filesUrls,
	          extraData = _props.extraData,
	          _onDrop = _props.onDrop,
	          onRemove = _props.onRemove;
	      var backgroundSize = extraData.backgroundSize;
	
	
	      var file = files && files[item.name] || filesUrls && filesUrls[item.name] || {};
	
	      var filename = file.name || (0, _files.getFilename)(file);
	
	      var fileIsImage = (0, _files.isImage)(filename);
	
	      var dropzone = void 0;
	
	      var match2 = /\.([a-z]+)$/.exec(filename);
	
	      var extension = match2 && match2[1];
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('ui', 'input', 'inputItem', 'fileInputItem', {
	            placeholder: !filename
	          })
	        },
	        !(file || {}).preview && _react2.default.createElement(_reactDropzone2.default, {
	          ref: function ref(c) {
	            dropzone = c;
	          },
	          onDrop: function onDrop(droppedFiles) {
	            _onDrop(item.name, droppedFiles[0]);
	          },
	          style: { display: 'none' }
	        }),
	        filename && _react2.default.createElement(
	          'div',
	          { className: 'removeFileButton', onClick: function onClick() {
	              onRemove(item.name, file);
	            } },
	          _react2.default.createElement('i', { className: 'remove icon' })
	        ),
	        filename && fileIsImage && _react2.default.createElement('div', {
	          className: 'filePreview imagePreview',
	          onClick: this.onImageClick.bind(this),
	          style: {
	            backgroundImage: 'url("' + (file.preview || file) + '")',
	            backgroundSize: backgroundSize || 'auto 100%'
	          }
	        }),
	        filename && fileIsImage && backgroundSize && _react2.default.createElement(_PictureModal2.default, {
	          shouldShowModal: this.state.shouldShowModal,
	          onModalHide: this.onModalHide.bind(this),
	          file: file
	        }),
	        filename && !fileIsImage && _react2.default.createElement(
	          'div',
	          { className: 'filePreview' },
	          _react2.default.createElement(
	            'div',
	            null,
	            filename
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement('i', { className: (0, _classnames2.default)('file', extension, 'outline', 'icon') })
	          )
	        ),
	        !filename && _react2.default.createElement(
	          'div',
	          { className: 'filePlaceholderContainer', onClick: function onClick() {
	              dropzone.open();
	            } },
	          _react2.default.createElement(
	            'div',
	            { className: 'filePlaceholder' },
	            'Seleziona un file',
	            _react2.default.createElement('i', { className: 'plus icon' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return FileInput;
	}(_react.Component);
	
	;
	
	FileInput.propTypes = {
	  item: _propTypes2.default.object.isRequired,
	  files: _propTypes2.default.object.isRequired,
	  filesUrls: _propTypes2.default.object.isRequired,
	  onDrop: _propTypes2.default.func.isRequired,
	  onRemove: _propTypes2.default.func.isRequired
	};
	
	exports.default = FileInput;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _FileInput = __webpack_require__(158);
	
	var _FileInput2 = _interopRequireDefault(_FileInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FileInputList = function (_Component) {
	  _inherits(FileInputList, _Component);
	
	  function FileInputList(props) {
	    _classCallCheck(this, FileInputList);
	
	    var _this = _possibleConstructorReturn(this, (FileInputList.__proto__ || Object.getPrototypeOf(FileInputList)).call(this, props));
	
	    var filesUrls = {};
	
	    props.items.forEach(function (item) {
	      filesUrls[item.name] = item.initialValue;
	    });
	
	    _this.state = {
	      filesUrls: filesUrls,
	      files: {}
	    };
	    return _this;
	  }
	
	  _createClass(FileInputList, [{
	    key: 'onDrop',
	    value: function onDrop(name, file) {
	      var _this2 = this;
	
	      var files = _extends({}, this.state.files);
	      files[name] = file;
	
	      this.setState({ files: files }, function () {
	        _this2.props.onDrop(name, file);
	      });
	    }
	  }, {
	    key: 'onRemove',
	    value: function onRemove(name, file) {
	      var _this3 = this;
	
	      var key = this.state.files[name] === file ? 'files' : 'filesUrls';
	
	      var files = _extends({}, this.state[key]);
	      files[name] = undefined;
	
	      this.setState(_defineProperty({}, key, files), function () {
	        _this3.props.onRemove(name, file);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	
	      var files = this.state.files;
	      var filesUrls = this.state.filesUrls;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _classnames2.default.apply(undefined, ['field', { hidden: props.hidden }].concat(_toConsumableArray(props.customClassNames || []))) },
	        props.bigLabel && _react2.default.createElement(
	          'label',
	          { className: 'bigLabel' },
	          props.bigLabel
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          props.label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'fieldItemsContainer' },
	          props.items.map(function (item, key) {
	            return _react2.default.createElement(_FileInput2.default, {
	              key: key,
	              item: item,
	              files: files,
	              filesUrls: filesUrls,
	              extraData: {},
	              onDrop: _this4.onDrop.bind(_this4),
	              onRemove: _this4.onRemove.bind(_this4)
	            });
	          })
	        ),
	        props.errors && props.errors.length > 0 && _react2.default.createElement(
	          'label',
	          { className: 'ui red basic label' },
	          props.errors.map(function (error, key) {
	            return _react2.default.createElement(
	              'div',
	              { key: key },
	              error
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return FileInputList;
	}(_react.Component);
	
	FileInputList.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.string,
	  bigLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  items: _propTypes2.default.array,
	  type: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  initialValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
	  onDrop: _propTypes2.default.func,
	  hidden: _propTypes2.default.bool,
	  errors: _propTypes2.default.array,
	  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	FileInputList.defaultProps = {
	  type: 'text',
	  initialValue: '',
	  placeholder: ''
	};
	
	exports.default = FileInputList;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input(props) {
	    _classCallCheck(this, Input);
	
	    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    var name = props.name,
	        initialValue = props.initialValue;
	
	
	    _this.state = _defineProperty({}, name, initialValue);
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var name = nextProps.name,
	          initialValue = nextProps.initialValue,
	          onChange = nextProps.onChange;
	
	
	      if (initialValue === this.state[name]) {
	        return;
	      }
	
	      var obj = _defineProperty({}, name, initialValue);
	
	      this.setState(obj, function () {
	        onChange(obj);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(target) {
	      var id = target.id,
	          type = target.type;
	
	
	      var value = ['checkbox', 'radio'].indexOf(type) >= 0 ? target.checked : target.value;
	
	      var obj = _defineProperty({}, id, value);
	
	      this.setState(obj);
	
	      this.props.onChange(obj);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          type = _props.type,
	          name = _props.name,
	          hidden = _props.hidden,
	          focus = _props.focus,
	          bigLabel = _props.bigLabel,
	          label = _props.label,
	          leftLabel = _props.leftLabel,
	          rightLabel = _props.rightLabel,
	          uomLabel = _props.uomLabel,
	          placeholder = _props.placeholder,
	          customClassNames = _props.customClassNames,
	          leftIcon = _props.leftIcon,
	          disabled = _props.disabled,
	          readOnly = _props.readOnly,
	          rows = _props.rows,
	          errors = _props.errors,
	          extraAttributes = _props.extraAttributes;
	
	
	      var inputValuePropName = ['checkbox', 'radio'].indexOf(type) >= 0 ? 'checked' : 'value';
	
	      var extraProps = _defineProperty({}, inputValuePropName, this.state[name]);
	
	      var InputTag = type === 'textarea' ? 'textarea' : 'input';
	
	      if (type === 'textarea') {
	        extraProps.rows = typeof rows === 'number' ? rows : 4;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: _classnames2.default.apply(undefined, ['field', { hidden: hidden }].concat(_toConsumableArray((0, _utils.fixCustomClassNames)(customClassNames)))) },
	        bigLabel && _react2.default.createElement(
	          'label',
	          { className: 'bigLabel' },
	          bigLabel
	        ),
	        label && _react2.default.createElement(
	          'label',
	          null,
	          label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('ui', 'input', 'inputItem', type + 'InputItem', {
	              labeled: uomLabel,
	              left: leftIcon,
	              icon: leftIcon
	            })
	          },
	          leftLabel && _react2.default.createElement(
	            'div',
	            { className: 'ui' },
	            leftLabel
	          ),
	          uomLabel && _react2.default.createElement(
	            'div',
	            { className: 'ui label' },
	            uomLabel
	          ),
	          leftIcon,
	          _react2.default.createElement(InputTag, _extends({
	            id: name,
	            name: name,
	            type: type,
	            placeholder: placeholder,
	            onChange: function onChange(evt) {
	              _this2.onChange(evt.target);
	            },
	            autoFocus: !!focus,
	            disabled: !!disabled,
	            readOnly: !!readOnly
	          }, extraProps, extraAttributes)),
	          rightLabel && _react2.default.createElement(
	            'label',
	            { htmlFor: name, className: 'rightLabel' },
	            rightLabel
	          )
	        ),
	        errors && errors.length > 0 && _react2.default.createElement(
	          'label',
	          { className: 'ui red basic label' },
	          errors.map(function (error, key) {
	            return _react2.default.createElement(
	              'div',
	              { key: key },
	              error
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Input;
	}(_react.Component);
	
	;
	
	Input.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  focus: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  readOnly: _propTypes2.default.bool,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  bigLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  uomLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  leftLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  rightLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  type: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  initialValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
	  onChange: _propTypes2.default.func,
	  rows: _propTypes2.default.number, // if type === 'textarea'
	  hidden: _propTypes2.default.bool,
	  errors: _propTypes2.default.array,
	  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  leftIcon: _propTypes2.default.object,
	  extraAttributes: _propTypes2.default.object
	};
	
	Input.defaultProps = {
	  type: 'text',
	  initialValue: '',
	  placeholder: ''
	};
	
	exports.default = Input;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InputList = function (_Component) {
	  _inherits(InputList, _Component);
	
	  function InputList(props) {
	    _classCallCheck(this, InputList);
	
	    var _this = _possibleConstructorReturn(this, (InputList.__proto__ || Object.getPrototypeOf(InputList)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    var items = props.items;
	
	
	    _this.state = items.reduce(function (acc, item) {
	      return _extends({}, acc, _defineProperty({}, item.name, item.initialValue));
	    }, {});
	    return _this;
	  }
	
	  _createClass(InputList, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var items = nextProps.items,
	          onChange = nextProps.onChange;
	
	
	      if (_lodash2.default.isEqual(items, this.props.items)) {
	        return;
	      }
	
	      var obj = items.filter(function (_ref) {
	        var id = _ref.id,
	            initialValue = _ref.initialValue;
	        return initialValue !== _this2.state[id];
	      }).reduce(function (acc, item) {
	        return _extends({}, acc, _defineProperty({}, item.name, item.initialValue));
	      }, {});
	
	      this.setState(obj, function () {
	        onChange(obj);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(target) {
	      var _props = this.props,
	          items = _props.items,
	          onChange = _props.onChange;
	      var id = target.id,
	          type = target.type,
	          value = target.value,
	          checked = target.checked;
	
	
	      var newValues = {};
	
	      if (type === 'radio') {
	
	        newValues = items.reduce(function (acc, item) {
	          return _extends({}, acc, _defineProperty({}, item.name, false));
	        }, {});
	      }
	
	      newValues[id] = ['checkbox', 'radio'].indexOf(type) >= 0 ? checked : value;
	
	      this.setState(newValues);
	
	      onChange(newValues);
	    }
	  }, {
	    key: 'getItemName',
	    value: function getItemName(item) {
	
	      return this.props.type === 'radio' ? this.props.name : item.name;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          type = _props2.type,
	          name = _props2.name,
	          items = _props2.items,
	          hidden = _props2.hidden,
	          bigLabel = _props2.bigLabel,
	          label = _props2.label,
	          customClassNames = _props2.customClassNames,
	          onRemoveItem = _props2.onRemoveItem,
	          errors = _props2.errors,
	          otherFieldsErrorsCount = _props2.otherFieldsErrorsCount;
	
	
	      var inputValuePropName = ['checkbox', 'radio'].indexOf(type) >= 0 ? 'checked' : 'value';
	
	      return _react2.default.createElement(
	        'div',
	        { id: name, className: _classnames2.default.apply(undefined, ['field', { hidden: hidden }].concat(_toConsumableArray(customClassNames || []))) },
	        bigLabel && _react2.default.createElement(
	          'label',
	          { className: 'bigLabel' },
	          bigLabel
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          label
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('fieldItemsContainer', type + 'FieldItemsContainer') },
	          items.map(function (item, key) {
	            return _react2.default.createElement(
	              'div',
	              { className: _classnames2.default.apply(undefined, ['ui', 'input', 'inputItem', 'inputListItem', type + 'InputItem', type + 'InputListItem', { labeled: item.uomLabel }].concat(_toConsumableArray((0, _utils.fixCustomClassNames)(item.customClassNames)))),
	                key: key
	              },
	              item.leftLabel && _react2.default.createElement(
	                'div',
	                { className: 'leftLabel' },
	                item.leftLabel
	              ),
	              item.uomLabel && _react2.default.createElement(
	                'div',
	                { className: 'ui label' },
	                item.uomLabel
	              ),
	              _react2.default.createElement('input', _extends({
	                id: item.name,
	                name: _this3.getItemName(item),
	                type: type,
	                placeholder: item.placeholder,
	                disabled: item.disabled,
	                onChange: function onChange(evt) {
	                  _this3.onChange(evt.target);
	                }
	              }, _defineProperty({}, inputValuePropName, _this3.state[item.name]))),
	              item.rightLabel && _react2.default.createElement(
	                'label',
	                { htmlFor: item.name, className: 'rightLabel' },
	                item.rightLabel
	              )
	            );
	          }),
	          onRemoveItem && _react2.default.createElement(
	            'div',
	            { className: 'removeItemButtonContainer' },
	            _react2.default.createElement(
	              'div',
	              { className: 'removeItemButton', onClick: onRemoveItem },
	              'Elimina'
	            )
	          )
	        ),
	        (errors || []).length > 0 && _react2.default.createElement(
	          'label',
	          { className: 'ui red basic label' },
	          errors.map(function (error, key) {
	            return _react2.default.createElement(
	              'div',
	              { key: key },
	              error
	            );
	          })
	        ),
	        (errors || []).length === 0 && otherFieldsErrorsCount > 0 && _react2.default.createElement(
	          'label',
	          { className: 'ui red basic label', style: { visibility: 'hidden' } },
	          _lodash2.default.range(otherFieldsErrorsCount).map(function (i) {
	            return _react2.default.createElement(
	              'div',
	              { key: i },
	              'Hey'
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return InputList;
	}(_react.Component);
	
	;
	
	InputList.propTypes = {
	  name: _propTypes2.default.string,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  bigLabel: _propTypes2.default.string,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  type: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  onRemoveItem: _propTypes2.default.func,
	  hidden: _propTypes2.default.bool,
	  errors: _propTypes2.default.array,
	  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  otherFieldsErrorsCount: _propTypes2.default.number
	};
	
	exports.default = InputList;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _UndefinedContent = __webpack_require__(107);
	
	var _UndefinedContent2 = _interopRequireDefault(_UndefinedContent);
	
	var _logging = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Geosuggest = void 0;
	
	var LocationInput = function (_Component) {
	  _inherits(LocationInput, _Component);
	
	  function LocationInput(props) {
	    _classCallCheck(this, LocationInput);
	
	    // Import only if instantiated
	    var _this = _possibleConstructorReturn(this, (LocationInput.__proto__ || Object.getPrototypeOf(LocationInput)).call(this, props));
	
	    Geosuggest = __webpack_require__(185).default;
	
	    _this.state = { fields: {} };
	    return _this;
	  }
	
	  _createClass(LocationInput, [{
	    key: 'onSelect',
	    value: function onSelect(address_components, location) {
	      var _this2 = this;
	
	      var fields = address_components.reduce(function (acc, c) {
	        return _extends({}, acc, _defineProperty({}, c.types[0], c.long_name));
	      }, _extends({}, location));
	
	      if (!fields.locality) {
	        fields.locality = fields.administrative_area_level_3;
	      }
	
	      if (!fields.street_number) {
	        // if is required, do not use default value
	        var streetNumberItem = _lodash2.default.find(this.props.items, { locationField: 'street_number' });
	        var isRequired = streetNumberItem && streetNumberItem.isRequired;
	        fields.street_number = !isRequired ? 'n/d' : fields.street_number;
	      }
	
	      //log('Address components', address_components);
	      //log('Fields', fields);
	
	      ['route', 'street_number', 'postal_code', 'locality', 'country', 'lat', 'lng'].forEach(function (locationField) {
	
	        if (!fields[locationField]) {
	          fields[locationField] = '';
	        }
	
	        var item = _lodash2.default.find(_this2.props.items, { locationField: locationField });
	
	        if (item) {
	          _this2.props.onChange(_defineProperty({}, item.name, fields[locationField]));
	        }
	      });
	
	      this.setState({ fields: fields });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var customClassNames = this.props.customClassNames || [];
	
	      //console.log('Fields', this.state.fields);
	
	      var addressFields = this.props.items.filter(function (item) {
	        return ['lat', 'lng'].indexOf(item.locationField) < 0;
	      });
	
	      var fieldsHidden = !this.state.fields.route && !(_lodash2.default.find(addressFields, { locationField: 'route' }) || {}).initialValue;
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('field', { hidden: this.props.hidden }) },
	        _react2.default.createElement(
	          'div',
	          { className: _classnames2.default.apply(undefined, ['field', 'longInputs'].concat(_toConsumableArray(customClassNames))) },
	          _react2.default.createElement(
	            'label',
	            null,
	            this.props.label
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ui input inputItem textInputItem' },
	            _react2.default.createElement(Geosuggest, {
	              placeholder: 'Ricerca...',
	              types: this.props.suggestionTypes,
	              initialValue: this.props.initialValue,
	              onSuggestSelect: function onSuggestSelect(_ref) {
	                var gmaps = _ref.gmaps,
	                    location = _ref.location;
	
	                if (!gmaps) {
	                  (0, _logging.warn)('onSuggestSelect: gmaps is null');
	                  return;
	                }
	
	                var address_components = gmaps.address_components;
	
	
	                _this3.onSelect(address_components, location);
	              }
	            })
	          ),
	          this.props.errors && this.props.errors.length > 0 && _react2.default.createElement(
	            'label',
	            { className: 'ui red basic label' },
	            this.props.errors.map(function (error, key) {
	              return _react2.default.createElement(
	                'div',
	                { key: key },
	                error
	              );
	            })
	          )
	        ),
	        addressFields.map(function (item, key) {
	          return _react2.default.createElement(
	            'div',
	            { className: (0, _classnames2.default)('field', 'longInputs', 'locationInputItem', { hidden: fieldsHidden }), key: key },
	            _react2.default.createElement(
	              'label',
	              null,
	              item.label,
	              ': '
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: (0, _classnames2.default)('ui', 'input', 'inputItem', 'textInputItem', item.locationField) },
	              (typeof _this3.state.fields[item.locationField] === 'string' ? _this3.state.fields[item.locationField] : item.initialValue) || _react2.default.createElement(_UndefinedContent2.default, null)
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return LocationInput;
	}(_react.Component);
	
	LocationInput.propTypes = {
	  label: _propTypes2.default.string,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  initialValue: _propTypes2.default.string,
	  onChange: _propTypes2.default.func.isRequired,
	  errors: _propTypes2.default.array,
	  country: _propTypes2.default.string,
	  suggestionTypes: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  hidden: _propTypes2.default.bool
	};
	
	exports.default = LocationInput;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactOverlays = __webpack_require__(396);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var modalStyle = {
	  position: 'fixed',
	  zIndex: 1040,
	  top: 0, bottom: 0, left: 0, right: 0,
	  width: '100%',
	  height: '100%'
	};
	
	var backdropStyle = _extends({}, modalStyle, {
	  zIndex: 'auto',
	  backgroundColor: '#000',
	  opacity: 0.7
	});
	
	var dialogStyle = {
	  position: 'absolute',
	  top: '50%', left: '50%',
	  transform: 'translate(-50%, -50%)',
	  border: '1px solid #e5e5e5',
	  backgroundColor: '#fff',
	  boxShadow: '0 5px 15px rgba(0, 0, 0, .5)',
	  padding: 20
	};
	
	var PictureModal = function PictureModal(props) {
	  return _react2.default.createElement(
	    _reactOverlays.Modal,
	    {
	      'aria-labelledby': 'modal-label',
	      style: modalStyle,
	      backdropStyle: backdropStyle,
	      show: props.shouldShowModal,
	      onHide: props.onModalHide
	    },
	    _react2.default.createElement(
	      'div',
	      { style: dialogStyle },
	      _react2.default.createElement('img', {
	        style: { width: '100%' },
	        src: props.file.preview || props.file
	      })
	    )
	  );
	};
	
	PictureModal.propTypes = {
	  shouldShowModal: _propTypes2.default.bool.isRequired,
	  file: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired,
	  onModalHide: _propTypes2.default.func.isRequired
	};
	
	exports.default = PictureModal;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(79);
	
	Object.keys(_utils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _utils[key];
	    }
	  });
	});
	
	var _components = __webpack_require__(292);
	
	Object.keys(_components).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _components[key];
	    }
	  });
	});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.CardContent = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueCardContent,
	    name: 'CardContent',
	    tag: 'f7-card-content'
	});
	
	//# sourceMappingURL=CardContent.js.map


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.CardFooter = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueCardFooter,
	    name: 'CardFooter',
	    tag: 'f7-card-footer'
	});
	
	//# sourceMappingURL=CardFooter.js.map


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.CardHeader = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueCardHeader,
	    name: 'CardHeader',
	    tag: 'f7-card-header'
	});
	
	//# sourceMappingURL=CardHeader.js.map


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var DataTableTitle_1 = __webpack_require__(170);
	exports.DataTableHeader = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueDataTableHeader,
	    name: 'DataTableHeader',
	    tag: 'f7-table-header',
	    instantiatedComponents: [
	        DataTableTitle_1.DataTableTitle
	    ]
	});
	
	//# sourceMappingURL=DataTableHeader.js.map


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var DataTableCell_1 = __webpack_require__(111);
	exports.DataTableRow = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueDataTableRow,
	    name: 'DataTableRow',
	    tag: 'f7-table-row',
	    events: [
	        'change'
	    ],
	    instantiatedComponents: [
	        DataTableCell_1.DataTableCell
	    ]
	});
	
	//# sourceMappingURL=DataTableRow.js.map


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.DataTableTitle = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueDataTableTitle,
	    name: 'DataTableTitle',
	    tag: 'f7-table-title'
	});
	
	//# sourceMappingURL=DataTableTitle.js.map


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.FormRange = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFormRange,
	    name: 'FormRange',
	    tag: 'f7-range',
	    events: [
	        'input',
	        'change',
	        'click'
	    ]
	});
	
	//# sourceMappingURL=FormRange.js.map


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.FormSwitch = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFormSwitch,
	    name: 'FormSwitch',
	    tag: 'f7-switch',
	    events: [
	        'input',
	        'change',
	        'click'
	    ]
	});
	
	//# sourceMappingURL=FormSwitch.js.map


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var Badge_1 = __webpack_require__(110);
	exports.ListItemContent = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListItemContent,
	    name: 'ListItemContent',
	    tag: 'f7-list-item-content',
	    events: [
	        'click',
	        'change'
	    ],
	    instantiatedComponents: [
	        Badge_1.Badge
	    ]
	});
	
	//# sourceMappingURL=ListItemContent.js.map


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.NavCenter = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueNavCenter,
	    name: 'NavCenter',
	    tag: 'f7-nav-center'
	});
	
	//# sourceMappingURL=NavCenter.js.map


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var Link_1 = __webpack_require__(113);
	exports.NavLeft = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueNavLeft,
	    name: 'NavLeft',
	    tag: 'f7-nav-left',
	    events: [
	        'back-click',
	        'click:back'
	    ],
	    instantiatedComponents: [
	        Link_1.Link
	    ]
	});
	
	//# sourceMappingURL=NavLeft.js.map


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var NavLeft_1 = __webpack_require__(175);
	var NavCenter_1 = __webpack_require__(174);
	exports.Navbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueNavbar,
	    name: 'Navbar',
	    tag: 'f7-navbar',
	    events: [
	        'navbar:beforeinit',
	        'navbar:init',
	        'navbar:reinit',
	        'navbar:beforeremove',
	        'back-click',
	        'click:back'
	    ],
	    instantiatedComponents: [
	        NavLeft_1.NavLeft,
	        NavCenter_1.NavCenter
	    ],
	    slots: [
	        'before-inner',
	        'after-inner'
	    ]
	});
	
	//# sourceMappingURL=Navbar.js.map


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Pages = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePages,
	    name: 'Pages',
	    tag: 'f7-pages'
	});
	
	//# sourceMappingURL=Pages.js.map


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(82),
	    _assign = __webpack_require__(63);
	
	var ReactNoopUpdateQueue = __webpack_require__(181);
	
	var canDefineProperty = __webpack_require__(182);
	var emptyObject = __webpack_require__(228);
	var invariant = __webpack_require__(69);
	var lowPriorityWarning = __webpack_require__(381);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(128);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(146);
	
	var _createChainableTypeChecker = __webpack_require__(184);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  if (!(0, _reactIs.isValidElementType)(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	module.exports = exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(592);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _defaults = __webpack_require__(387);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	var _propTypes = __webpack_require__(389);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _filterInputAttributes = __webpack_require__(186);
	
	var _filterInputAttributes2 = _interopRequireDefault(_filterInputAttributes);
	
	var _input = __webpack_require__(388);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _suggestList = __webpack_require__(391);
	
	var _suggestList2 = _interopRequireDefault(_suggestList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */
	
	// Escapes special characters in user input for regex
	function escapeRegExp(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
	}
	
	/**
	 * Entry point for the Geosuggest component
	 */
	
	var Geosuggest = function (_React$Component) {
	  _inherits(Geosuggest, _React$Component);
	
	  /**
	   * The constructor. Sets the initial state.
	   * @param  {Object} props The properties object.
	   */
	  function Geosuggest(props) {
	    _classCallCheck(this, Geosuggest);
	
	    var _this = _possibleConstructorReturn(this, (Geosuggest.__proto__ || Object.getPrototypeOf(Geosuggest)).call(this, props));
	
	    _this.onInputChange = function (userInput) {
	      _this.setState({ userInput: userInput }, _this.onAfterInputChange);
	    };
	
	    _this.onAfterInputChange = function () {
	      if (!_this.state.isSuggestsHidden) {
	        _this.showSuggests();
	      }
	      _this.props.onChange(_this.state.userInput);
	    };
	
	    _this.onInputFocus = function () {
	      _this.props.onFocus();
	      _this.showSuggests();
	    };
	
	    _this.onInputBlur = function () {
	      if (!_this.state.ignoreBlur) {
	        _this.hideSuggests();
	      }
	    };
	
	    _this.onNext = function () {
	      return _this.activateSuggest('next');
	    };
	
	    _this.onPrev = function () {
	      return _this.activateSuggest('prev');
	    };
	
	    _this.onSelect = function () {
	      return _this.selectSuggest(_this.state.activeSuggest);
	    };
	
	    _this.onSuggestMouseDown = function () {
	      return _this.setState({ ignoreBlur: true });
	    };
	
	    _this.onSuggestMouseOut = function () {
	      return _this.setState({ ignoreBlur: false });
	    };
	
	    _this.onSuggestNoResults = function () {
	      _this.props.onSuggestNoResults(_this.state.userInput);
	    };
	
	    _this.hideSuggests = function () {
	      _this.props.onBlur(_this.state.userInput);
	      _this.timer = setTimeout(function () {
	        _this.setState({
	          isSuggestsHidden: true,
	          activeSuggest: null
	        });
	      }, 100);
	    };
	
	    _this.selectSuggest = function (suggest) {
	      _this.autocompleteSessionToken = new _this.googleMaps.places.AutocompleteSessionToken();
	
	      if (!suggest) {
	        suggest = {
	          label: _this.state.userInput
	        };
	      }
	
	      _this.setState({
	        isSuggestsHidden: true,
	        userInput: _typeof(suggest.label) !== 'object' ? suggest.label : suggest.description
	      });
	
	      if (suggest.location) {
	        _this.setState({ ignoreBlur: false });
	        _this.props.onSuggestSelect(suggest);
	        return;
	      }
	
	      _this.geocodeSuggest(suggest);
	    };
	
	    _this.state = {
	      isSuggestsHidden: true,
	      isLoading: false,
	      userInput: props.initialValue,
	      activeSuggest: null,
	      suggests: []
	    };
	
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.onAfterInputChange = _this.onAfterInputChange.bind(_this);
	
	    if (props.queryDelay) {
	      _this.onAfterInputChange = (0, _lodash2.default)(_this.onAfterInputChange, props.queryDelay);
	    }
	    return _this;
	  }
	
	  /**
	   * Change inputValue if prop changes
	   * @param {Object} props The new props
	   */
	
	
	  _createClass(Geosuggest, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (this.props.initialValue !== props.initialValue) {
	        this.setState({ userInput: props.initialValue });
	      }
	    }
	
	    /**
	     * Called on the client side after component is mounted.
	     * Google api sdk object will be obtained and cached as a instance property.
	     * Necessary objects of google api will also be determined and saved.
	     */
	
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var googleMaps = this.props.googleMaps || window.google && // eslint-disable-line no-extra-parens
	      window.google.maps || this.googleMaps;
	
	      /* istanbul ignore next */
	      if (!googleMaps) {
	        if (console) {
	          console.error( // eslint-disable-line no-console
	          'Google map api was not found in the page.');
	        }
	        return;
	      }
	      this.googleMaps = googleMaps;
	
	      this.autocompleteService = new googleMaps.places.AutocompleteService();
	      this.geocoder = new googleMaps.Geocoder();
	      this.autocompleteSessionToken = new googleMaps.places.AutocompleteSessionToken();
	    }
	
	    /**
	     * When the component will unmount
	     */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timer);
	    }
	
	    /**
	     * When the input changed
	     * @param {String} userInput The input value of the user
	     */
	
	
	    /**
	     * On After the input got changed
	     */
	
	
	    /**
	     * When the input gets focused
	     */
	
	
	    /**
	     * When the input gets blurred
	     */
	
	  }, {
	    key: 'focus',
	
	
	    /**
	     * Focus the input
	     */
	    value: function focus() {
	      this.input.focus();
	    }
	
	    /**
	     * Blur the input
	     */
	
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.input.blur();
	    }
	
	    /**
	     * Update the value of the user input
	     * @param {String} userInput the new value of the user input
	     */
	
	  }, {
	    key: 'update',
	    value: function update(userInput) {
	      this.setState({ userInput: userInput });
	      this.props.onChange(userInput);
	    }
	
	    /*
	     * Clear the input and close the suggestion pane
	     */
	
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this.setState({ userInput: '' }, this.hideSuggests);
	    }
	
	    /**
	     * Search for new suggests
	     */
	
	  }, {
	    key: 'searchSuggests',
	    value: function searchSuggests() {
	      var _this2 = this;
	
	      if (!this.state.userInput) {
	        this.updateSuggests();
	        return;
	      }
	
	      var options = {
	        input: this.state.userInput
	      },
	          inputLength = this.state.userInput.length,
	          isShorterThanMinLength = inputLength < this.props.minLength;
	
	      if (isShorterThanMinLength) {
	        return;
	      }
	
	      ['location', 'radius', 'bounds', 'types'].forEach(function (option) {
	        if (_this2.props[option]) {
	          options[option] = _this2.props[option];
	        }
	      });
	
	      if (this.props.country) {
	        options.componentRestrictions = {
	          country: this.props.country
	        };
	      }
	
	      options.sessionToken = this.autocompleteSessionToken;
	
	      this.setState({ isLoading: true }, function () {
	        _this2.autocompleteService.getPlacePredictions(options, function (suggestsGoogle) {
	          _this2.setState({ isLoading: false });
	          _this2.updateSuggests(suggestsGoogle || [], // can be null
	          function () {
	            if (_this2.props.autoActivateFirstSuggest && !_this2.state.activeSuggest) {
	              _this2.activateSuggest('next');
	            }
	          });
	        });
	      });
	    }
	
	    /**
	     * Update the suggests
	     * @param {Array} suggestsGoogle The new google suggests
	     * @param {Function} callback Called once the state has been updated
	     */
	
	  }, {
	    key: 'updateSuggests',
	    value: function updateSuggests() {
	      var _this3 = this;
	
	      var suggestsGoogle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	      var callback = arguments[1];
	
	      var suggests = [],
	          userInput = this.state.userInput,
	          regex = new RegExp(escapeRegExp(userInput), 'gim'),
	          skipSuggest = this.props.skipSuggest,
	          maxFixtures = this.props.maxFixtures,
	          fixturesSearched = 0,
	          activeSuggest = null;
	
	      this.props.fixtures.forEach(function (suggest) {
	        if (fixturesSearched >= maxFixtures) {
	          return;
	        }
	
	        if (!skipSuggest(suggest) && suggest.label.match(regex)) {
	          fixturesSearched++;
	
	          suggest.placeId = suggest.label;
	          suggest.isFixture = true;
	          suggest.matchedSubstrings = {
	            offset: suggest.label.indexOf(userInput),
	            length: userInput.length
	          };
	          suggests.push(suggest);
	        }
	      });
	
	      suggestsGoogle.forEach(function (suggest) {
	        if (!skipSuggest(suggest)) {
	          suggests.push({
	            description: suggest.description,
	            label: _this3.props.getSuggestLabel(suggest),
	            placeId: suggest.place_id,
	            isFixture: false,
	            matchedSubstrings: suggest.matched_substrings[0]
	          });
	        }
	      });
	
	      activeSuggest = this.updateActiveSuggest(suggests);
	      this.setState({ suggests: suggests, activeSuggest: activeSuggest }, callback);
	    }
	
	    /**
	     * Return the new activeSuggest object after suggests have been updated
	     * @param {Array} suggests The new list of suggests
	     * @return {Object} The new activeSuggest
	     **/
	
	  }, {
	    key: 'updateActiveSuggest',
	    value: function updateActiveSuggest() {
	      var suggests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      var activeSuggest = this.state.activeSuggest;
	
	      if (activeSuggest) {
	        var newSuggest = suggests.filter(function (listedSuggest) {
	          return activeSuggest.placeId === listedSuggest.placeId && activeSuggest.isFixture === listedSuggest.isFixture;
	        })[0];
	
	        activeSuggest = newSuggest || null;
	      }
	
	      return activeSuggest;
	    }
	
	    /**
	     * Show the suggestions
	     */
	
	  }, {
	    key: 'showSuggests',
	    value: function showSuggests() {
	      this.searchSuggests();
	      this.setState({ isSuggestsHidden: false });
	    }
	
	    /**
	     * Hide the suggestions
	     */
	
	  }, {
	    key: 'activateSuggest',
	
	
	    /**
	     * Activate a new suggest
	     * @param {String} direction The direction in which to activate new suggest
	     */
	    value: function activateSuggest(direction) {
	      // eslint-disable-line complexity
	      if (this.state.isSuggestsHidden) {
	        this.showSuggests();
	        return;
	      }
	
	      var suggestsCount = this.state.suggests.length - 1,
	          next = direction === 'next';
	      var newActiveSuggest = null,
	          newIndex = 0,
	          i = 0;
	
	      for (i; i <= suggestsCount; i++) {
	        if (this.state.suggests[i] === this.state.activeSuggest) {
	          newIndex = next ? i + 1 : i - 1;
	        }
	      }
	
	      if (!this.state.activeSuggest) {
	        newIndex = next ? 0 : suggestsCount;
	      }
	
	      if (newIndex >= 0 && newIndex <= suggestsCount) {
	        newActiveSuggest = this.state.suggests[newIndex];
	      }
	
	      this.props.onActivateSuggest(newActiveSuggest);
	
	      this.setState({ activeSuggest: newActiveSuggest });
	    }
	
	    /**
	     * When an item got selected
	     * @param {GeosuggestItem} suggest The selected suggest item
	     */
	
	  }, {
	    key: 'geocodeSuggest',
	
	
	    /**
	     * Geocode a suggest
	     * @param  {Object} suggest The suggest
	     */
	    value: function geocodeSuggest(suggest) {
	      var _this4 = this;
	
	      var options = null;
	      if (suggest.placeId && !suggest.isFixture) {
	        options = {
	          placeId: suggest.placeId
	        };
	      } else {
	        options = {
	          address: suggest.label,
	          location: this.props.location,
	          bounds: this.props.bounds,
	          componentRestrictions: this.props.country ? { country: this.props.country } : null
	        };
	      }
	      this.geocoder.geocode(options, function (results, status) {
	        if (status === _this4.googleMaps.GeocoderStatus.OK) {
	          var gmaps = results[0],
	              location = gmaps.geometry.location;
	
	          suggest.gmaps = gmaps;
	          suggest.location = {
	            lat: location.lat(),
	            lng: location.lng()
	          };
	        }
	        _this4.props.onSuggestSelect(suggest);
	      });
	    }
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var attributes = (0, _filterInputAttributes2.default)(this.props),
	          classes = (0, _classnames2.default)('geosuggest', this.props.className, { 'geosuggest--loading': this.state.isLoading }),
	          shouldRenderLabel = this.props.label && attributes.id,
	          input = _react2.default.createElement(_input2.default, _extends({ className: this.props.inputClassName,
	        ref: function ref(i) {
	          return _this5.input = i;
	        },
	        value: this.state.userInput,
	        ignoreEnter: !this.state.isSuggestsHidden,
	        ignoreTab: this.props.ignoreTab,
	        style: this.props.style.input,
	        onChange: this.onInputChange,
	        onFocus: this.onInputFocus,
	        onBlur: this.onInputBlur,
	        onKeyDown: this.props.onKeyDown,
	        onKeyPress: this.props.onKeyPress,
	        onNext: this.onNext,
	        onPrev: this.onPrev,
	        onSelect: this.onSelect,
	        onEscape: this.hideSuggests }, attributes)),
	          suggestionsList = _react2.default.createElement(_suggestList2.default, { isHidden: this.state.isSuggestsHidden,
	        style: this.props.style.suggests,
	        suggestItemStyle: this.props.style.suggestItem,
	        userInput: this.state.userInput,
	        isHighlightMatch: this.props.highlightMatch,
	        suggestsClassName: this.props.suggestsClassName,
	        suggestItemClassName: this.props.suggestItemClassName,
	        suggests: this.state.suggests,
	        hiddenClassName: this.props.suggestsHiddenClassName,
	        suggestItemActiveClassName: this.props.suggestItemActiveClassName,
	        activeSuggest: this.state.activeSuggest,
	        onSuggestNoResults: this.onSuggestNoResults,
	        onSuggestMouseDown: this.onSuggestMouseDown,
	        onSuggestMouseOut: this.onSuggestMouseOut,
	        onSuggestSelect: this.selectSuggest,
	        renderSuggestItem: this.props.renderSuggestItem,
	        minLength: this.props.minLength });
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'geosuggest__input-wrapper' },
	          shouldRenderLabel && _react2.default.createElement(
	            'label',
	            { className: 'geosuggest__label',
	              htmlFor: attributes.id },
	            this.props.label
	          ),
	          input
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'geosuggest__suggests-wrapper' },
	          suggestionsList
	        )
	      );
	    }
	  }]);
	
	  return Geosuggest;
	}(_react2.default.Component);
	
	/**
	 * Types for the properties
	 * @type {Object}
	 */
	
	
	Geosuggest.propTypes = _propTypes2.default;
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	Geosuggest.defaultProps = _defaults2.default;
	
	exports.default = Geosuggest;

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (props) {
	  var attributes = {};
	
	  allowedAttributes.forEach(function (allowedAttribute) {
	    if (props[allowedAttribute]) {
	      attributes[allowedAttribute] = props[allowedAttribute];
	    }
	  });
	
	  return attributes;
	};
	
	/**
	 * Attributes allowed on input elements
	 */
	var allowedAttributes = ['autoCapitalize', 'autoComplete', 'autoCorrect', 'autoFocus', 'disabled', 'form', 'formAction', 'formEncType', 'formMethod', 'formNoValidate', 'formTarget', 'height', 'id', 'inputMode', 'maxLength', 'name', 'onClick', 'onContextMenu', 'onCopy', 'onCut', 'onDoubleClick', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', 'onPaste', 'pattern', 'placeholder', 'readOnly', 'required', 'size', 'spellCheck', 'tabIndex', 'aria-atomic', 'aria-busy', 'aria-controls', 'aria-current', 'aria-describedby', 'aria-details', 'aria-disabled', 'aria-dropeffect', 'aria-errormessage', 'aria-flowto', 'aria-grabbed', 'aria-haspopup', 'aria-hidden', 'aria-invalid', 'aria-keyshortcuts', 'aria-label', 'aria-labelledby', 'aria-live', 'aria-owns', 'aria-relevant', 'aria-roledescription', 'aria-activedescendant', 'aria-autocomplete', 'aria-multiline', 'aria-placeholder', 'aria-readonly', 'aria-required'];
	
	/**
	 * Filter the properties for only allowed input properties
	 * @param  {Object} props The properties to filter
	 * @return {Object} The filtered, allowed properties
	 */

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _height = __webpack_require__(548);
	
	var _height2 = _interopRequireDefault(_height);
	
	var _offset = __webpack_require__(68);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _offsetParent = __webpack_require__(224);
	
	var _offsetParent2 = _interopRequireDefault(_offsetParent);
	
	var _scrollTop = __webpack_require__(126);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(226);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(84);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _getDocumentHeight = __webpack_require__(190);
	
	var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);
	
	var _ownerDocument = __webpack_require__(42);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _ownerWindow = __webpack_require__(191);
	
	var _ownerWindow2 = _interopRequireDefault(_ownerWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Affix/>` component toggles `position: fixed;` on and off, emulating
	 * the effect found with `position: sticky;`.
	 */
	var Affix = function (_React$Component) {
	  _inherits(Affix, _React$Component);
	
	  function Affix(props, context) {
	    _classCallCheck(this, Affix);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.onWindowScroll = function () {
	      _this.onUpdate();
	    };
	
	    _this.onDocumentClick = function () {
	      (0, _requestAnimationFrame2.default)(function () {
	        return _this.onUpdate();
	      });
	    };
	
	    _this.onUpdate = function () {
	      if (!_this._isMounted) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          offsetTop = _this$props.offsetTop,
	          viewportOffsetTop = _this$props.viewportOffsetTop;
	
	      var scrollTop = (0, _scrollTop2.default)((0, _ownerWindow2.default)(_this));
	      var positionTopMin = scrollTop + (viewportOffsetTop || 0);
	
	      if (positionTopMin <= offsetTop) {
	        _this.updateState('top', null, null);
	        return;
	      }
	
	      if (positionTopMin > _this.getPositionTopMax()) {
	        if (_this.state.affixed === 'bottom') {
	          _this.updateStateAtBottom();
	        } else {
	          // Setting position away from `fixed` can change the offset parent of
	          // the affix, so we can't calculate the correct position until after
	          // we've updated its position.
	          _this.setState({
	            affixed: 'bottom',
	            position: 'absolute',
	            top: null
	          }, function () {
	            if (!_this._isMounted) {
	              return;
	            }
	
	            _this.updateStateAtBottom();
	          });
	        }
	        return;
	      }
	
	      _this.updateState('affix', 'fixed', viewportOffsetTop);
	    };
	
	    _this.getPositionTopMax = function () {
	      var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));
	      var height = (0, _height2.default)(_reactDom2.default.findDOMNode(_this));
	
	      return documentHeight - height - _this.props.offsetBottom;
	    };
	
	    _this.updateState = function (affixed, position, top) {
	      if (affixed === _this.state.affixed && position === _this.state.position && top === _this.state.top) {
	        return;
	      }
	
	      var upperName = affixed === 'affix' ? '' : affixed.charAt(0).toUpperCase() + affixed.substr(1);
	
	      if (_this.props['onAffix' + upperName]) {
	        _this.props['onAffix' + upperName]();
	      }
	
	      _this.setState({ affixed: affixed, position: position, top: top }, function () {
	        if (_this.props['onAffixed' + upperName]) {
	          _this.props['onAffixed' + upperName]();
	        }
	      });
	    };
	
	    _this.updateStateAtBottom = function () {
	      var positionTopMax = _this.getPositionTopMax();
	      var offsetParent = (0, _offsetParent2.default)(_reactDom2.default.findDOMNode(_this));
	      var parentTop = (0, _offset2.default)(offsetParent).top;
	
	      _this.updateState('bottom', 'absolute', positionTopMax - parentTop);
	    };
	
	    _this.state = {
	      affixed: 'top',
	      position: null,
	      top: null
	    };
	
	    _this._needPositionUpdate = false;
	    return _this;
	  }
	
	  Affix.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this._isMounted = true;
	
	    this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
	      return _this2.onWindowScroll();
	    });
	    this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
	      return _this2.onDocumentClick();
	    });
	
	    this.onUpdate();
	  };
	
	  Affix.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needPositionUpdate = true;
	  };
	
	  Affix.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this._needPositionUpdate) {
	      this._needPositionUpdate = false;
	      this.onUpdate();
	    }
	  };
	
	  Affix.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	
	    if (this._windowScrollListener) {
	      this._windowScrollListener.remove();
	    }
	    if (this._documentClickListener) {
	      this._documentClickListener.remove();
	    }
	  };
	
	  Affix.prototype.render = function render() {
	    var child = _react2.default.Children.only(this.props.children);
	    var _child$props = child.props,
	        className = _child$props.className,
	        style = _child$props.style;
	    var _state = this.state,
	        affixed = _state.affixed,
	        position = _state.position,
	        top = _state.top;
	
	    var positionStyle = { position: position, top: top };
	
	    var affixClassName = void 0;
	    var affixStyle = void 0;
	    if (affixed === 'top') {
	      affixClassName = this.props.topClassName;
	      affixStyle = this.props.topStyle;
	    } else if (affixed === 'bottom') {
	      affixClassName = this.props.bottomClassName;
	      affixStyle = this.props.bottomStyle;
	    } else {
	      affixClassName = this.props.affixClassName;
	      affixStyle = this.props.affixStyle;
	    }
	
	    return _react2.default.cloneElement(child, {
	      className: (0, _classnames2.default)(affixClassName, className),
	      style: _extends({}, positionStyle, affixStyle, style)
	    });
	  };
	
	  return Affix;
	}(_react2.default.Component);
	
	Affix.propTypes = {
	  /**
	   * Pixels to offset from top of screen when calculating position
	   */
	  offsetTop: _propTypes2.default.number,
	
	  /**
	   * When affixed, pixels to offset from top of viewport
	   */
	  viewportOffsetTop: _propTypes2.default.number,
	
	  /**
	   * Pixels to offset from bottom of screen when calculating position
	   */
	  offsetBottom: _propTypes2.default.number,
	
	  /**
	   * CSS class or classes to apply when at top
	   */
	  topClassName: _propTypes2.default.string,
	
	  /**
	   * Style to apply when at top
	   */
	  topStyle: _propTypes2.default.object,
	
	  /**
	   * CSS class or classes to apply when affixed
	   */
	  affixClassName: _propTypes2.default.string,
	  /**
	   * Style to apply when affixed
	   */
	  affixStyle: _propTypes2.default.object,
	
	  /**
	   * CSS class or classes to apply when at bottom
	   */
	  bottomClassName: _propTypes2.default.string,
	
	  /**
	   * Style to apply when at bottom
	   */
	  bottomStyle: _propTypes2.default.object,
	
	  /**
	   * Callback fired when the right before the `affixStyle` and `affixStyle` props are rendered
	   */
	  onAffix: _propTypes2.default.func,
	  /**
	   * Callback fired after the component `affixStyle` and `affixClassName` props have been rendered.
	   */
	  onAffixed: _propTypes2.default.func,
	
	  /**
	   * Callback fired when the right before the `topStyle` and `topClassName` props are rendered
	   */
	  onAffixTop: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the component `topStyle` and `topClassName` props have been rendered.
	   */
	  onAffixedTop: _propTypes2.default.func,
	
	  /**
	   * Callback fired when the right before the `bottomStyle` and `bottomClassName` props are rendered
	   */
	  onAffixBottom: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the component `bottomStyle` and `bottomClassName` props have been rendered.
	   */
	  onAffixedBottom: _propTypes2.default.func
	};
	
	Affix.defaultProps = {
	  offsetTop: 0,
	  viewportOffsetTop: null,
	  offsetBottom: 0
	};
	
	exports.default = Affix;
	module.exports = exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(83);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _calculatePosition = __webpack_require__(398);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(85);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(42);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.getTarget = function () {
	      var target = _this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    };
	
	    _this.maybeUpdatePosition = function (placementChanged) {
	      var target = _this.getTarget();
	
	      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      _this.updatePosition(target);
	    };
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  Position.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition(this.getTarget());
	  };
	
	  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needsFlush = true;
	  };
	
	  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._needsFlush) {
	      this._needsFlush = false;
	      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	    }
	  };
	
	  Position.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var _state = this.state,
	        positionLeft = _state.positionLeft,
	        positionTop = _state.positionTop,
	        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	    // These should not be forwarded to the child.
	
	
	    delete props.target;
	    delete props.container;
	    delete props.containerPadding;
	    delete props.shouldUpdatePosition;
	
	    var child = _react2.default.Children.only(children);
	    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	      // and `props.style`.
	      positionLeft: positionLeft,
	      positionTop: positionTop,
	      className: (0, _classnames2.default)(className, child.props.className),
	      style: _extends({}, child.props.style, {
	        left: positionLeft,
	        top: positionTop
	      })
	    }));
	  };
	
	  Position.prototype.updatePosition = function updatePosition(target) {
	    this._lastTarget = target;
	
	    if (!target) {
	      this.setState({
	        positionLeft: 0,
	        positionTop: 0,
	        arrowOffsetLeft: null,
	        arrowOffsetTop: null
	      });
	
	      return;
	    }
	
	    var overlay = _reactDom2.default.findDOMNode(this);
	    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	  };
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _propTypes2.default.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _propTypes2.default.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contains = __webpack_require__(125);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(84);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(42);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.addEventListeners = function () {
	      var event = _this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(_this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
	
	      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
	
	      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
	    };
	
	    _this.removeEventListeners = function () {
	      if (_this.documentMouseCaptureListener) {
	        _this.documentMouseCaptureListener.remove();
	      }
	
	      if (_this.documentMouseListener) {
	        _this.documentMouseListener.remove();
	      }
	
	      if (_this.documentKeyupListener) {
	        _this.documentKeyupListener.remove();
	      }
	    };
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.disabled) {
	      this.addEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.props.disabled && prevProps.disabled) {
	      this.addEventListeners();
	    } else if (this.props.disabled && !prevProps.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (!this.props.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _propTypes2.default.func,
	  /**
	   * Children to render.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (doc) {
	  return Math.max(doc.documentElement.offsetHeight || 0, doc.height || 0, doc.body.scrollHeight || 0, doc.body.offsetHeight || 0);
	};
	
	module.exports = exports["default"]; /**
	                                      * Get the height of the document
	                                      *
	                                      * @returns {documentHeight: number}
	                                      */

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerWindow2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerWindow = __webpack_require__(547);
	
	var _ownerWindow2 = _interopRequireDefault(_ownerWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(9);
	
	var _time = __webpack_require__(20);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatDateTime = function formatDateTime(date, time, localeConstants) {
	  var timeF = time === _constants.DELIVERY_TIME_DEFAULT ? localeConstants.ASAP : time;
	  var dateF = date === _time2.default.localToday() || date === _constants.DELIVERY_DATE_DEFAULT ? localeConstants.TODAY : date;
	
	  return { date: dateF, time: timeF };
	};
	
	exports.default = {
	  formatDateTime: formatDateTime
	};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var singleStrategy = function singleStrategy(modifier) {
	  var items = modifier.items;
	
	  return {
	    isCompleted: false,
	    minSelection: 1,
	    maxSelection: 1,
	    isValid: _lodash2.default.some(items, ['selected', true]),
	
	    update: function update(tappedItem) {
	      return items.map(function (i) {
	        if (i.id === tappedItem.id) {
	          return _extends({}, tappedItem, {
	            selected: true
	          });
	        }
	
	        return _extends({}, i, {
	          selected: false
	        });
	      });
	    }
	  };
	};
	
	var multiRangeStrategy = function multiRangeStrategy(modifier) {
	  var items = modifier.items;
	  var selected = items.filter(function (i) {
	    return i.selected;
	  }).length;
	  var maxSelection = modifier.max_selection_points || 1;
	  var minSelection = modifier.min_selection_points || 0;
	  var remaining = maxSelection - selected;
	
	  return {
	    selected: selected,
	    remaining: remaining,
	    minSelection: minSelection,
	    maxSelection: maxSelection,
	    isCompleted: remaining === 0,
	    isValid: selected >= minSelection && selected <= maxSelection,
	
	    update: function update(tappedItem) {
	      return items.map(function (i) {
	        if (i.id === tappedItem.id) {
	          return _extends({}, tappedItem, {
	            selected: !tappedItem.selected
	          });
	        }
	
	        return i;
	      });
	    }
	  };
	};
	
	exports.default = {
	  SINGLE: singleStrategy,
	  MULTI_RANGE: multiRangeStrategy
	};

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasOnlineService = function hasOnlineService(restaurant, serviceId) {
	  var res = _lodash2.default.find(restaurant.services, { id: serviceId, online: true, active: true });
	  return res !== undefined;
	};
	
	var getDeliveryThreshold = function getDeliveryThreshold(order, config) {
	  if (!order.deliveryAreaCustomThreshold) {
	    return config.order.delivery.threshold || 0;
	  }
	  return order.deliveryAreaCustomThreshold || 0;
	};
	
	var getTargetRestaurant = function getTargetRestaurant(props, type) {
	  var order = props.order,
	      merchant = props.app.merchant;
	
	  if (!order.targetRestaurant && !order.restaurant) {
	    return null;
	  }
	  var targetRestaurant = order.targetRestaurant || order.restaurant.id;
	
	  if (typeof targetRestaurant !== 'string') {
	    throw new Error('Target restaurant is a not a valid id: ', targetRestaurant);
	  }
	
	  if (type !== _constants.ORDER_TYPE_DELIVERY && type !== _constants.ORDER_TYPE_TAKEAWAY) {
	    throw new Error('Unknow order type: ', type);
	  }
	
	  var found = _lodash2.default.find(merchant.restaurants, { id: targetRestaurant });
	  if (!found) {
	    throw new Error('Restaurant not found: ', targetRestaurant, merchant.restaurants);
	  }
	
	  return found;
	};
	
	exports.default = {
	  hasOnlineService: hasOnlineService,
	  getDeliveryThreshold: getDeliveryThreshold,
	  getTargetRestaurant: getTargetRestaurant
	};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(9);
	
	var _constants2 = __webpack_require__(24);
	
	var bootstrap = {
	  api_endpoint: 'https://api.ristoranti.it/graphql',
	  extra: {}
	};
	
	var initialState = {
	  id: '',
	  bootstrap: bootstrap,
	  config: {},
	  merchant: {},
	  bookingRush: null,
	  bookingRushSelectedRestaurant: '',
	  bookingRushSelectedWindow: '',
	  bookingRushNPosti: 2,
	  bookingRushActiveRequest: null,
	  connectivity: null,
	  internetConnectionAvailable: false,
	  userLocation: null,
	  isFetching: false,
	  passwordRecovery: {
	    formValue: null,
	    recoveryToken: null,
	    processCompleted: false,
	    emailSent: false
	  }
	};
	
	exports.default = function () {
	  var overrideBootstrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (state, action) {
	
	    switch (action.type) {
	      case _constants.LOAD_APP_CONFIGURATION_START:
	        return _extends({}, state, {
	          isFetching: true
	        });
	
	      case _constants.LOAD_APP_CONFIGURATION_SUCCESS:
	        return _extends({}, state, {
	          isFetching: false
	        }, action.data, {
	          config: JSON.parse(action.data.config)
	        });
	
	      case _constants.LOAD_APP_CONFIGURATION_FAILURE:
	        return _extends({}, state, {
	          isFetching: false,
	          errors: action.errors
	        });
	
	      case _constants.SWITCH_BUNDLE_ID:
	        return _extends({}, state, {
	          bootstrap: _extends({}, state.bootstrap, {
	            bundleId: action.newBundleId
	          })
	        });
	
	      case _constants.SWITCH_API_ENDPOINT:
	        return _extends({}, state, {
	          bootstrap: _extends({}, state.bootstrap, {
	            api_endpoint: action.endpoint
	          })
	        });
	
	      case _constants.LOAD_MERCHANT_INFO_START:
	        return _extends({}, state, {
	          isFetching: true
	        });
	
	      case _constants.LOAD_MERCHANT_INFO_SUCCESS:
	        return _extends({}, state, {
	          isFetching: false,
	          merchant: action.data[0].merchant
	        });
	
	      case _constants.LOAD_MERCHANT_INFO_FAILURE:
	        return _extends({}, state, {
	          isFetching: false,
	          errors: action.errors
	        });
	
	      case _constants2.LOAD_BOOKING_AVAILABILITY_SUCCESS:
	        return _extends({}, state, {
	          bookingRush: action.data.bookingRushes[0]
	        });
	
	      case _constants.SELECT_BOOKING_RUSH_RESTAURANT:
	        return _extends({}, state, {
	          bookingRushSelectedRestaurant: action.restaurantId,
	          bookingRushSelectedWindow: action.windowId
	        });
	
	      case _constants.SELECT_BOOKING_RUSH_RESTAURANT_WINDOW:
	        return _extends({}, state, {
	          bookingRushSelectedWindow: action.windowId,
	          bookingRushNPosti: action.nPosti
	        });
	
	      case _constants.SET_ACTIVE_BOOKING_REQUEST:
	        {
	          var restaurant = action.activeBookingRequest.restaurant.id;
	          var window = action.activeBookingRequest.availabilityWindow.id;
	
	          return _extends({}, state, {
	            bookingRush: _extends({}, state.bookingRush, {
	              createdRequest: action.activeBookingRequest
	            }),
	            bookingRushSelectedRestaurant: restaurant,
	            bookingRushSelectedWindow: window
	          });
	        }
	
	      case _constants.UPDATE_CONNECTION_INFO:
	        {
	          var info = action.info;
	          var disconnected = info in { none: 1, unknown: 1 };
	
	          return _extends({}, state, {
	            connectivity: action.info,
	            internetConnectionAvailable: !disconnected
	          });
	        }
	
	      case _constants.USER_LOCATION:
	        return _extends({}, state, {
	          userLocation: action.location
	        });
	
	      case _constants2.RESTAURANTS_REFRESH_SUCCESS:
	        return _extends({}, state, {
	          merchant: {
	            restaurants: action.data
	          }
	        });
	
	      // TODO move to @arreeba/ristoranti-lib
	      case _constants.VERIFY_RECOVERY_TOKEN_START:
	        return _extends({}, state, {
	          isFetching: true
	        });
	
	      case _constants.VERIFY_RECOVERY_TOKEN_SUCCESS:
	        return _extends({}, state, {
	          isFetching: false,
	          passwordRecovery: {
	            formValue: null,
	            recoveryToken: null
	          }
	        });
	
	      case _constants.VERIFY_RECOVERY_TOKEN_FAILURE:
	        return _extends({}, state, {
	          isFetching: false,
	          passwordRecovery: {
	            formValue: null,
	            recoveryToken: null,
	            verified: false
	          }
	        });
	
	      case _constants.UPDATE_RECOVERY_FORM_VALUE:
	        return _extends({}, state, {
	          passwordRecovery: _extends({}, state.passwordRecovery, {
	            formValue: action.value
	          })
	        });
	
	      case _constants.RESET_PASSWORD_START:
	        return _extends({}, state, {
	          isFetching: true,
	          passwordRecovery: _extends({}, state.passwordRecovery)
	        });
	
	      case _constants.RESET_PASSWORD_SUCCESS:
	        return _extends({}, state, {
	          isFetching: false,
	          passwordRecovery: _extends({}, state.passwordRecovery, {
	            processCompleted: true
	          })
	        });
	
	      case _constants.RESET_PASSWORD_FAILURE:
	        return _extends({}, state, {
	          isFetching: false,
	          passwordRecovery: _extends({}, state.passwordRecovery, {
	            processCompleted: false
	          })
	        });
	
	      case _constants.RESET_RECOVERY_PASSWORD_STATUS:
	        return _extends({}, state, {
	          isFetching: false,
	          passwordRecovery: _extends({}, initialState.passwordRecovery)
	        });
	
	      case _constants.RECOVERY_EMAIL_REQUEST:
	        return _extends({}, state, {
	          isFetching: false,
	          passwordRecovery: _extends({}, state.passwordRecovery, {
	            emailSent: true
	          })
	        });
	
	      case _constants.SET_RECOVERY_TOKEN:
	        return _extends({}, state, {
	          passwordRecovery: _extends({}, state.passwordRecovery, {
	            recoveryToken: action.token
	          })
	        });
	    }
	
	    if (!state) {
	      return _extends({}, initialState, {
	        bootstrap: _extends({}, bootstrap, overrideBootstrap)
	      });
	    }
	
	    return state;
	  };
	};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(9);
	
	var _constants2 = __webpack_require__(24);
	
	var initialState = {
	  userLocation: null,
	  isFetching: false,
	  availability: [],
	  date: null,
	  hasBookingRushes: false, // optimistic bookingrush flag
	  verifiedBookingRush: false,
	  time: null,
	  seats: null,
	  pickerVisible: false,
	  pickerType: _constants.BOOKING_PICKER_TIME,
	  formData: null,
	  createdRequest: {
	    id: null,
	    status: null
	  },
	  targetRestaurant: null
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.SET_USER_LOCATION:
	      return _extends({}, state, {
	        userLocation: action.location
	      });
	
	    case _constants2.LOAD_BOOKING_AVAILABILITY_START:
	      return _extends({}, state, {
	        isFetching: true
	      });
	
	    case _constants2.LOAD_BOOKING_AVAILABILITY_SUCCESS:
	      return _extends({}, state, {
	        isFetching: false,
	        availability: action.data.merchant.restaurants
	      });
	
	    case _constants2.LOAD_BOOKING_AVAILABILITY_FAILURE:
	      return _extends({}, state, {
	        isFetching: false,
	        availability: []
	      });
	
	    case _constants.SET_BOOKING_RESTAURANT:
	      return _extends({}, state, {
	        targetRestaurant: action.restaurant
	      });
	
	    case _constants.SET_BOOKING_DATE:
	      return _extends({}, state, {
	        date: action.date,
	        hasBookingRushes: action.hasBookingRushes
	      });
	
	    case _constants.SET_PICKER_VISIBILITY:
	      return _extends({}, state, {
	        pickerVisible: action.value,
	        pickerType: action.pickerType || _constants.BOOKING_PICKER_TIME
	      });
	
	    case _constants.SET_BOOKING_TIME:
	      return _extends({}, state, {
	        time: action.time,
	        verifiedBookingRush: action.verifyBookingRush,
	        seats: null // reset seats when user change booking time
	      });
	
	    case _constants.SET_BOOKING_SEATS:
	      return _extends({}, state, {
	        seats: action.n
	      });
	
	    case _constants.BOOKING_SET_FORM:
	      return _extends({}, state, {
	        formData: action.data
	      });
	
	    case _constants2.BOOKING_REQUEST_CREATE_START:
	      return _extends({}, state, {
	        isFetching: true
	      });
	
	    case _constants2.BOOKING_REQUEST_CREATE_SUCCESS:
	      return _extends({}, initialState, {
	        createdRequest: {
	          hasBookingRushes: state.verifiedBookingRush,
	          id: action.data.id,
	          date: action.data.date,
	          availabilitySlot: action.data.availabilitySlot,
	          status: action.data.status
	        }
	      });
	
	    case _constants2.BOOKING_REQUEST_CREATE_FAILURE:
	      return _extends({}, state, {
	        isFetching: false
	      });
	
	    case _constants.BOOKING_RESET_END:
	      return _extends({}, initialState);
	
	    /* partial reset state to avoid inconsistency */
	    case _constants.UPDATE_ROUTE:
	      {
	        if (action.route === 'booking-select-date') {
	          return _extends({}, state, {
	            date: null,
	            verifiedBookingRush: false,
	            pickerVisible: false,
	            pickerType: initialState.pickerType,
	            time: null,
	            seats: null
	          });
	        }
	
	        return state;
	      }
	
	    case _constants2.SWITCH_BUNDLE_ID:
	      return _extends({}, initialState);
	
	    default:
	      return state;
	  }
	};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(24);
	
	var _constants2 = __webpack_require__(9);
	
	var _location = __webpack_require__(50);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	  configuredItem: null,
	  timePickerVisible: false,
	  targetRestaurant: null,
	  deliveryAddress: null,
	  deliveryAddressExtraInfo: null,
	  deliveryLocation: null,
	  deliveryAddressConfirmed: false,
	  deliveryDate: null,
	  deliveryTime: null,
	  deliveryData: null,
	  deliveryAreaId: null,
	  deliveryAreaCustomThreshold: null, // order threshold based on delivery area
	  deliveryAreaCustomOffset: null, // order time offset based on delivery area
	  orderTypeDefault: null,
	  orderType: null,
	  currentOrder: null,
	  reloadedOrder: null,
	  creditCardToken: null,
	  checkoutFormData: null,
	  cart: [],
	  extraCosts: {
	    isFetching: false,
	    delivery: [],
	    takeAway: []
	  },
	  selectedVoucher: _constants2.ORDER_NO_VOUCHER,
	
	  showErrors: false,
	
	  menu: {
	    categories: []
	  },
	  menuIsFetching: false,
	  menuCategoriesCollapsed: false,
	
	  isFetching: false,
	
	  newCreditCardFormData: null,
	  paymentMethod: null,
	  paymentPickerVisible: false,
	  unhandledExpectedAmount: null,
	
	  sessionStartedAt: null,
	
	  isAsap: false
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants2.LOAD_APP_CONFIGURATION_SUCCESS:
	      {
	        var _JSON$parse = JSON.parse(action.data.config),
	            order = _JSON$parse.order;
	
	        var orderTypes = order.types;
	        var orderTypeDefault = orderTypes && orderTypes[0] || null;
	        // set default order type
	        return _extends({}, state, {
	          orderTypeDefault: orderTypeDefault,
	          orderType: orderTypeDefault,
	          extraCosts: {
	            isFetching: false,
	            delivery: [],
	            takeAway: []
	          },
	          menuCategoriesCollapsed: order.menuCategoriesInitCollapsed || initialState.menuCategoriesCollapsed
	        });
	      }
	
	    case _constants2.LOAD_MENU_START:
	      return _extends({}, state, {
	        menuIsFetching: true
	      });
	
	    case _constants2.LOAD_MENU_SUCCESS:
	      return _extends({}, state, {
	        menuIsFetching: false,
	        menu: action.data[0].menu
	      });
	
	    case _constants2.LOAD_MENU_FAILURE:
	      return _extends({}, state, {
	        menuIsFetching: false,
	        errors: action.errors
	      });
	
	    case _constants2.MENU_CONFIGURE_ITEM:
	      return _extends({}, state, {
	        configuredItem: action.item
	      });
	
	    case _constants2.MENU_CART_ADDITEM:
	      var items = Array.isArray(action.item) ? action.item : [action.item];
	
	      return _extends({}, state, {
	        cart: [].concat(_toConsumableArray(state.cart)).concat(items.map(function (item) {
	          return _extends({
	            cart_id: Math.random().toString(16)
	          }, item);
	        }))
	      });
	
	    case _constants2.MENU_CART_RESTORE_FROM_ORDER:
	      return _extends({}, state, {
	        cart: [].concat(_toConsumableArray(action.cart.map(function (item) {
	          return _extends({
	            cart_id: Math.random().toString(16)
	          }, item);
	        })))
	      });
	
	    case _constants2.MENU_CART_REMOVEITEM:
	      {
	        if (action.item.cart_id) {
	          var _newCart = state.cart.filter(function (item) {
	            return item.cart_id !== action.item.cart_id;
	          });
	          return _extends({}, state, {
	            cart: _newCart
	          });
	        }
	
	        var newCart = state.cart.filter(function (item) {
	          return item.id !== action.item.id;
	        });
	        return _extends({}, state, {
	          cart: newCart
	        });
	      }
	
	    case _constants2.MENU_CART_RESET:
	      {
	        return _extends({}, state, {
	          cart: []
	        });
	      }
	
	    case _constants2.MENU_SHOW_ERRORS:
	      return _extends({}, state, {
	        showErrors: action.bool
	      });
	
	    case _constants2.MENU_COLLAPSE_CATEGORIES:
	      return _extends({}, state, {
	        menuCategoriesCollapsed: true
	      });
	
	    case _constants2.MENU_UNCOLLAPSE_CATEGORIES:
	      return _extends({}, state, {
	        menuCategoriesCollapsed: false
	      });
	
	    case _constants2.DELIVERY_ADDRESS_CHECK_START:
	      return _extends({}, state, {
	        isFetching: true,
	        targetRestaurant: null,
	        deliveryTime: null,
	        deliveryDate: null,
	        deliveryAreaCustomThreshold: null
	      });
	
	    case _constants2.DELIVERY_ADDRESS_CHECK_SUCCESS:
	      if (!action.data) {
	        return _extends({}, state, {
	          isFetching: false,
	          targetRestaurant: null,
	          deliveryAreaCustomThreshold: null,
	          deliveryAreaCustomOffset: null
	        });
	      }
	
	      return _extends({}, state, {
	        isFetching: false,
	        targetRestaurant: action.data.id,
	        deliveryAreaId: action.data.targetDeliveryArea.id,
	        deliveryAreaCustomThreshold: action.data.targetDeliveryArea.threshold || null,
	        deliveryAreaCustomOffset: action.data.targetDeliveryArea.offset || null,
	        extraCosts: _extends({}, state.extraCosts, {
	          isFetching: false,
	          delivery: []
	        })
	      });
	
	    case _constants2.DELIVERY_ADDRESS_CHECK_FAILURE:
	      return _extends({}, state, {
	        isFetching: false,
	        targetRestaurant: null,
	        deliveryAreaCustomThreshold: null,
	        deliveryAreaCustomOffset: null
	      });
	
	    case _constants2.DELIVERY_ADDRESS_UPDATE_START:
	      return _extends({}, state, {
	        isFetching: true
	      });
	
	    case _constants2.DELIVERY_ADDRESS_UPDATE_SUCCESS:
	      return _extends({}, state, {
	        deliveryAddress: (0, _location.mergeAddresses)(state.deliveryAddress, action.data.components),
	        deliveryLocation: action.data.location,
	        isFetching: false
	      });
	
	    case _constants2.DELIVERY_UPDATE_ADDRESS_SNUMBER:
	      return _extends({}, state, {
	        deliveryAddress: _extends({}, state.deliveryAddress, _defineProperty({}, _location.GEO_COMPONENTS.STREET_NUMBER, action.streetNum))
	      });
	
	    case _constants2.DELIVERY_UPDATE_EXTRA_INFO:
	      return _extends({}, state, {
	        deliveryAddressExtraInfo: action.data
	      });
	
	    case _constants2.DELIVERY_SET_ADDRESS:
	      return _extends({}, state, {
	        deliveryAddress: action.addressComponents,
	        deliveryLocation: action.location,
	        targetRestaurant: null,
	        deliveryAreaCustomThreshold: null,
	        deliveryAreaCustomOffset: null
	      });
	    case _constants2.DELIVERY_RESET_ADDRESS:
	      return _extends({}, state, {
	        deliveryAddress: initialState.deliveryAddress,
	        deliveryLocation: initialState.deliveryLocation,
	        targetRestaurant: initialState.targetRestaurant,
	        deliveryAddressConfirmed: initialState.deliveryAddressConfirmed,
	        deliveryAddressExtraInfo: initialState.deliveryAddressExtraInfo,
	        deliveryAreaCustomThreshold: initialState.deliveryAreaCustomThreshold,
	        deliveryAreaCustomOffset: initialState.deliveryAreaCustomOffset
	      });
	
	    case _constants2.DELIVERY_CONFIRM_ADDRESS:
	      return _extends({}, state, {
	        deliveryAddressConfirmed: true
	      });
	
	    case _constants2.ORDER_FETCH_EXTRA_COSTS_START:
	      return _extends({}, state, {
	        extraCosts: _extends({}, state.extraCosts, {
	          isFetching: true
	        })
	      });
	
	    case _constants2.ORDER_FETCH_EXTRA_COSTS_SUCCESS:
	      return _extends({}, state, {
	        extraCosts: _extends({}, state.extraCosts, {
	          isFetching: false,
	          // inconsistency among API and clients
	          // on how extraCosts type are represented
	          delivery: action.data.map(function (c) {
	            return _extends({}, c, { type: c.type.toLowerCase() });
	          })
	        })
	      });
	
	    case _constants2.ORDER_FETCH_EXTRA_COSTS_FAILURE:
	      return _extends({}, state, {
	        extraCosts: _extends({}, state.extraCosts, {
	          isFetching: false
	        })
	      });
	
	    case _constants2.ORDER_RELOAD:
	      return _extends({}, state, {
	        reloadedOrder: action.order
	      });
	
	    case _constants2.PICKER_VISIBLE:
	      return _extends({}, state, {
	        timePickerVisible: action.bool
	      });
	
	    case _constants2.DELIVERY_SET_DATE_TIME:
	      return _extends({}, state, {
	        deliveryDate: action.deliveryDate,
	        deliveryTime: action.deliveryTime,
	        sessionStartedAt: Date.now()
	      });
	
	    case _constants2.DELIVERY_SET_ORDER_TYPE:
	      return _extends({}, state, {
	        selectedVoucher: _constants2.ORDER_NO_VOUCHER,
	        targetRestaurant: null,
	        deliveryAddress: null,
	        deliveryDate: null,
	        deliveryTime: null,
	        deliveryAreaCustomThreshold: null,
	        deliveryAreaCustomOffset: null,
	        orderType: action.orderType,
	        timePickerVisible: false
	      });
	
	    case _constants2.TAKEAWAY_SET_RESTAURANT:
	      {
	        return _extends({}, state, {
	          targetRestaurant: action.id
	        });
	      }
	
	    case _constants2.DELIVERY_SET_ORDER_DATA:
	      {
	        var _action$data = action.data,
	            streetNumber = _action$data.streetNumber,
	            street_number = _action$data.street_number,
	            data = _objectWithoutProperties(_action$data, ['streetNumber', 'street_number']);
	
	        var deliveryAddress = Object.assign({}, state.deliveryAddress, { street_number: streetNumber || street_number });
	        return _extends({}, state, {
	          deliveryAddress: deliveryAddress,
	          deliveryData: data
	        });
	      }
	
	    case _constants2.ORDER_SET_CHECKOUT_FORM:
	      {
	        return _extends({}, state, {
	          checkoutFormData: _extends({}, state.checkoutFormData, action.data)
	        });
	      }
	
	    case _constants2.CREATE_CARD_TOKEN_START:
	      return _extends({}, state, {
	        isFetching: true
	      });
	
	    case _constants2.CREATE_CARD_TOKEN_SUCCESS:
	      return _extends({}, state, {
	        isFetching: false,
	        creditCardToken: action.data
	      });
	
	    case _constants2.CREATE_CARD_TOKEN_FAILURE:
	      return _extends({}, state, {
	        isFetching: false,
	        creditCardToken: null,
	        errors: action.errors
	      });
	
	    case _constants2.ORDER_TOGGLE_UNHANDLED:
	      return _extends({}, state, {
	        paymentPickerVisible: action.flag
	      });
	
	    case _constants2.ORDER_NEW_CC_SETFORM:
	      return _extends({}, state, {
	        newCreditCardFormData: action.data
	      });
	
	    case _constants2.PAYMENT_SET_METHOD:
	      if (action.method === _constants2.PAYMENT_UNHANDLED) {
	        return _extends({}, state, {
	          paymentMethod: action.method,
	          unhandledExpectedAmount: action.amount
	        });
	      }
	
	      return _extends({}, state, {
	        paymentMethod: action.method,
	        unhandledExpectedAmount: null
	      });
	
	    case _constants2.STORE_ORDER_START:
	      return _extends({}, state, {
	        isFetching: true
	      });
	
	    case _constants2.STORE_ORDER_SUCCESS:
	      {
	        var targetRestaurant = state.orderType === _constants2.ORDER_TYPE_DELIVERY ? state.targetRestaurant : state.targetRestaurant;
	
	        return _extends({}, state, {
	          isFetching: false,
	          currentOrder: _extends({}, action.data, {
	            targetRestaurant: targetRestaurant,
	            deliveryAddress: state.deliveryAddress,
	            deliveryLocation: state.deliveryLocation,
	            deliveryDate: state.deliveryDate,
	            deliveryTime: state.deliveryTime,
	            orderType: state.orderType,
	            paymentMethod: state.paymentMethod
	          })
	        });
	      }
	
	    case _constants2.UPDATE_CURRENTORDER:
	      {
	        return _extends({}, state, {
	          currentOrder: _extends({}, state.currentOrder, action.order)
	        });
	      }
	
	    case _constants2.ORDER_RESET:
	      {
	        var keep = action.keep.reduce(function (acc, item) {
	          return _extends({}, acc, _defineProperty({}, item, state[item]));
	        }, {});
	
	        return _extends({}, initialState, {
	          extraCosts: state.extraCosts,
	          orderTypeDefault: state.orderTypeDefault,
	          orderType: state.orderTypeDefault
	        }, keep);
	      }
	
	    case _constants2.STORE_ORDER_FAILURE:
	      return _extends({}, state, {
	        isFetching: false,
	        errors: action.errors
	      });
	
	    // hide errors when item modifier modal
	    // is closed (aka popped out of nav)
	    case _constants2.UPDATE_ROUTE:
	      return _extends({}, state, {
	        showErrors: false,
	        timePickerVisible: false,
	        paymentPickerVisible: false
	      });
	
	    case _constants2.ORDER_ADD_VOUCHER:
	      {
	        return _extends({}, state, {
	          selectedVoucher: action.voucherID
	        });
	      }
	
	    case _constants2.ORDER_TOGGLE_ASAP:
	      {
	        return _extends({}, state, {
	          isAsap: action.status
	        });
	      }
	
	    case _constants.SWITCH_BUNDLE_ID:
	      return _extends({}, initialState);
	  }
	
	  return state;
	};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.orderOffsetSelector = exports.deliveryOffsetSelector = exports.creditCardPaymentSuspended = exports.unhandledSelectedSelector = exports.unhandledDataSelector = exports.orderObjectSelector = exports.availablePaymentsForOrder = undefined;
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reselect = __webpack_require__(18);
	
	var _cart = __webpack_require__(51);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _common = __webpack_require__(88);
	
	var _constants = __webpack_require__(9);
	
	var _cart3 = __webpack_require__(115);
	
	var _voucher = __webpack_require__(117);
	
	var _voucher2 = __webpack_require__(33);
	
	var _voucher3 = _interopRequireDefault(_voucher2);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var availablePaymentsForOrder = exports.availablePaymentsForOrder = (0, _reselect.createSelector)(function (state) {
	  return state.app.config.order.paymentType;
	}, _common.orderTypeSelector, function (available, orderType) {
	  var _result, _result2;
	
	  var result = (_result = {}, _defineProperty(_result, _constants.PAYMENT_UNHANDLED, true), _defineProperty(_result, _constants.PAYMENT_METHOD_CC, true), _result);
	
	  if (!available) {
	    // assume they're all available if config is missing
	    return result;
	  }
	
	  var object = _lodash2.default.find(available, { type: orderType });
	  if (!object || !object.payments) {
	    return result;
	  }
	
	  result = (_result2 = {}, _defineProperty(_result2, _constants.PAYMENT_UNHANDLED, false), _defineProperty(_result2, _constants.PAYMENT_METHOD_CC, false), _result2);
	
	  object.payments.forEach(function (paymentType) {
	    result[paymentType] = true;
	  });
	
	  return result;
	});
	
	var orderObjectSelector = exports.orderObjectSelector = function orderObjectSelector(localizedLabels) {
	  return (0, _reselect.createSelector)((0, _cart3.cartSelector)(localizedLabels), _cart3.cartGroupedSelector, _common.currentOrderSelector, function (cartData, cartGrouped, _ref) {
	    var orderType = _ref.orderType,
	        deliveryTime = _ref.deliveryTime,
	        deliveryDate = _ref.deliveryDate,
	        paymentType = _ref.paymentType;
	
	    return {
	      cart: cartGrouped,
	      orderType: orderType,
	      orderTime: deliveryTime,
	      orderDate: deliveryDate,
	      paymentType: paymentType,
	      subtotal: cartData.subtotal,
	      total: cartData.total,
	      extraCosts: cartData.extraCosts
	    };
	  });
	};
	
	var unhandledDataSelector = exports.unhandledDataSelector = function unhandledDataSelector(_ref2) {
	  var PAY_WITH = _ref2.PAY_WITH,
	      PAY_EXACT_AMOUNT = _ref2.PAY_EXACT_AMOUNT,
	      PAY_WITH_STAMPS = _ref2.PAY_WITH_STAMPS;
	  return (0, _reselect.createSelector)(function (state) {
	    return state.order.cart;
	  }, function (state) {
	    return state.order.extraCosts;
	  }, _common.orderTypeSelector, _voucher.usableVouchersSelector, function (state) {
	    return state.order.selectedVoucher;
	  }, function (state) {
	    return state.app.config.order;
	  }, function (cart, extraCosts, orderType, userVouchers, selectedVoucher, orderConfig) {
	    var availableCash = [1000, 2000, 3000, 5000, 10000];
	    var total = selectedVoucher ? _voucher3.default.cartTotalWithVoucher(cart, extraCosts[orderType], selectedVoucher, userVouchers) : _cart2.default.total(cart, extraCosts[orderType]);
	    var roundedTotal = Math.floor(total / 1000) * 1000;
	    var nextRoundedTotal = total - roundedTotal < 500 ? roundedTotal + 500 : roundedTotal + 1000;
	    var nextAvailableCash = _lodash2.default.map(_lodash2.default.filter(availableCash, function (c) {
	      return c > nextRoundedTotal;
	    }), function (x) {
	      return {
	        label: PAY_WITH + ' ' + _i18n2.default.formatPrice(x),
	        value: x
	      };
	    });
	
	    var data = [{ label: PAY_EXACT_AMOUNT, value: total },
	    // TODO: da modificare (creare un flag apposito per il pagamento con i ticket)
	    orderConfig.ticketRestaurantAccepted ? { label: PAY_WITH_STAMPS, value: 529 } : null, { label: PAY_WITH + ' ' + _i18n2.default.formatPrice(nextRoundedTotal), value: nextRoundedTotal }].concat(_toConsumableArray(nextAvailableCash)).filter(function (item) {
	      return item;
	    });
	
	    return _lodash2.default.sortBy(data, 'value');
	  });
	};
	
	var unhandledSelectedSelector = exports.unhandledSelectedSelector = function unhandledSelectedSelector(unhandledLabels) {
	  return (0, _reselect.createSelector)([unhandledDataSelector(unhandledLabels), function (state) {
	    return state.order.unhandledExpectedAmount;
	  }], function (data, selected) {
	    if (!selected) {
	      return data[0].value;
	    }
	    return selected;
	  });
	};
	
	var creditCardPaymentSuspended = exports.creditCardPaymentSuspended = (0, _reselect.createSelector)(function (state) {
	  return state.app.config.order;
	}, function (orderConfig) {
	  if (orderConfig.creditCardPaymentSuspended) {
	    return true;
	  }
	  return false;
	});
	
	var deliveryOffsetSelector = exports.deliveryOffsetSelector = (0, _reselect.createSelector)(function (state) {
	  return state.order.deliveryAreaCustomOffset;
	}, function (state) {
	  return state.app.config.order.delivery.offset;
	}, function (customOffset, configOffset) {
	  if (!customOffset) return configOffset || 0;
	  return configOffset;
	});
	
	var orderOffsetSelector = exports.orderOffsetSelector = (0, _reselect.createSelector)(function (state) {
	  return state.order.targetRestaurant;
	}, function (state) {
	  return state.app.merchant.restaurants;
	}, function (state) {
	  return state.order.deliveryAreaCustomOffset;
	}, function (state) {
	  return state.order.orderType;
	}, function (targetRestaurantId, restaurants, deliveryOffset, orderType) {
	  if (!targetRestaurantId) return 0;
	
	  if (orderType === _constants.ORDER_TYPE_DELIVERY) return deliveryOffset;
	
	  var restaurant = _lodash2.default.find(restaurants, { id: targetRestaurantId }) || {};
	  var takeAwayService = _lodash2.default.find(restaurant.services, { id: 'takeAway', active: true }) || {};
	
	  return takeAwayService.offset || 0;
	});

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(52);
	
	var _appType = __webpack_require__(422);
	
	exports.default = function (bundleId) {
	  var deviceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'IOS';
	  return {
	    loadConfiguration: function loadConfiguration(api, appAction) {
	      var query = 'query {\n      app(bundleId: "' + bundleId + '" deviceType: ' + (0, _util.serializeEnum)(deviceType) + ') {\n        id\n        config\n        active\n        environment\n        merchant {\n          id\n          name\n          social {\n            facebook {\n              pageUrl\n              appId\n            }\n            twitter {\n              username\n            }\n            instagram {\n              username\n            }\n          }\n          restaurants {\n            id\n            name\n            services {\n              id\n              online\n              active\n              offset\n            }\n            location {\n              latitude\n              longitude\n            }\n            address\n            fullAddress {\n              route\n              street_number\n              postal_code\n              city\n              country\n            }\n            email\n            phone\n            zipCode\n            city\n            country\n            cuisine\n            highlights {\n              name\n              check\n            }\n            openingTimes {\n              day\n              open\n              slots {\n                open\n                close\n              }\n            }\n            takeAwayTimes {\n              day\n              open\n              slots {\n                open\n                close\n              }\n            }\n            deliveryTimes {\n              day\n              open\n              slots {\n                open\n                close\n              }\n            }\n          }\n        }\n      }\n    }';
	
	      var queryName = 'loadConfiguration';
	      return (0, _util.wrapAction)(appAction, 'app[0]', 'loadConfiguration', api.fetch(query, {}, queryName));
	    },
	    registerDevice: function registerDevice(api, data) {
	      // doesn't need appAction, it makes the call behind the scenes
	      var query = '\n      mutation {\n        registerDevice(\n          id: "' + data.id + '"\n          appType: ' + (data.appType || _appType.STANDALONE) + '\n          type: ' + (0, _util.serializeEnum)(deviceType) + '\n          bundleId: "' + bundleId + '"\n          osVersion: "' + data.osVersion + '"\n          appVersion: "' + data.appVersion + '"\n          bundleVersion: "' + data.bundleVersion + '"\n        ) {\n          id\n        }\n      }\n    ';
	
	      var queryName = 'registerDevice';
	      return api.fetch(query, {}, queryName);
	    },
	    updateDeviceToken: function updateDeviceToken(api, data) {
	      var query = '\n      mutation {\n        registerDeviceToken(\n          deviceUUID: "' + data.deviceUUID + '"\n          deviceToken: "' + data.deviceToken + '"\n          bundleId: "' + bundleId + '"\n          type: ' + (0, _util.serializeEnum)(deviceType) + '\n        ) {\n          id\n        }\n      }\n    ';
	
	      var queryName = 'registerDeviceToken';
	      return api.fetch(query, {}, queryName);
	    },
	    unregisterDeviceToken: function unregisterDeviceToken(api, data) {
	
	      // If only data.user is set, every device token associated to that user will be deleted.
	      // If only data.deviceToken is set, only that device token will be deleted.
	      // If both data.user and data.deviceToken are set, only that device token will be deleted (if associated to that user).
	
	      var query = '\n      mutation {\n        unregisterDeviceToken(\n          bundleId: "' + bundleId + '"\n          type: ' + (0, _util.serializeEnum)(deviceType) + '\n          ' + (data.user ? 'user: "' + data.user + '"' : '') + '\n          ' + (data.deviceToken ? 'deviceToken: "' + data.deviceToken + '"' : '') + '\n        )\n      }\n    ';
	
	      var queryName = 'unregisterDeviceToken';
	      return api.fetch(query, {}, queryName);
	    },
	
	
	    // TODO move to @arreeba/ristoranti-lib
	    askResetPasswordEmail: function askResetPasswordEmail(api, data) {
	      var query = '\n      mutation {\n        resetPassword(\n          app:"' + data.app + '"\n          email: "' + data.email + '"\n        )\n      }';
	
	      var queryName = 'resetPassword';
	      return api.fetch(query, {}, queryName);
	    },
	    verifyRecoveryToken: function verifyRecoveryToken(api, data, appAction) {
	      var query = '\n      mutation {\n        verifyRecoveryToken(\n          token: "' + data.token + '"\n          app: "' + data.app + '"\n          device: "' + data.device + '"\n        )\n      }';
	
	      var queryName = 'verifyRecoveryToken';
	      return (0, _util.wrapAction)(appAction, queryName, 'verifyRecoveryToken', api.fetch(query, {}, queryName));
	    },
	    resetPassword: function resetPassword(api, data, appAction) {
	      var query = '\n      mutation {\n        updatePassword(\n          newPassword: "' + data.password + '"\n          confirmPassword: "' + data.passwordConfirm + '"\n        )\n      }\n    ';
	
	      var queryName = 'resetPassword';
	      return (0, _util.wrapAction)(appAction, queryName, 'resetPassword', api.fetch(query, {}, queryName));
	    }
	  };
	};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _util = __webpack_require__(52);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cart = __webpack_require__(51);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _payment = __webpack_require__(424);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _time = __webpack_require__(20);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _voucher = __webpack_require__(33);
	
	var _voucher2 = _interopRequireDefault(_voucher);
	
	var _constants = __webpack_require__(9);
	
	var _location = __webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var formatDate = function formatDate(date, time) {
	  if (time === _constants.DELIVERY_TIME_ASAP) {
	    return new Date().toISOString();
	  }
	  return [_time2.default.formatISO(date), _time2.default.toUTCTime(time)].join('T');
	};
	
	exports.default = {
	  loadMenu: function loadMenu(api, appId, restaurantId, orderAction) {
	    var query = 'query {\n      app(id: "' + appId + '") {\n        menu(restaurant: "' + restaurantId + '") {\n          id\n          categories {\n            name\n            description\n            items {\n              id\n              name\n              description\n              price\n              available\n              modifiers {\n                id\n                name\n                instruction\n                min_selection_points\n                max_selection_points\n                price_strategy\n                items {\n                  id\n                  name\n                  description\n                  price\n                  available\n                }\n              }\n            }\n          }\n        }\n      }\n    }';
	
	    var queryName = 'loadMenu';
	    return (0, _util.wrapAction)(orderAction, 'app', 'loadMenu', api.fetch(query, {}, queryName));
	  },
	  deliveryAddressCheck: function deliveryAddressCheck(api, appId, data, orderAction) {
	    var _data$geometry$locati = data.geometry.location,
	        lat = _data$geometry$locati.lat,
	        lng = _data$geometry$locati.lng;
	
	
	    var query = '\n      query {\n        app(id: "' + appId + '") {\n          merchant {\n            deliversAt(lat: ' + lat + ', lng: ' + lng + ') {\n              id\n              targetDeliveryArea {\n                id\n                offset\n                threshold\n                costs {\n                  cost\n                  threshold\n                }\n              }\n            }\n          }\n        }\n      }\n    ';
	
	    var queryName = 'deliveryAddressCheck';
	    return (0, _util.wrapAction)(orderAction, 'app[0].merchant.deliversAt', 'deliveryAddressCheck', api.fetch(query, {}, queryName));
	  },
	  updateDeliveryAddress: function updateDeliveryAddress(api, data, orderAction) {
	
	    return (0, _util.wrapAction)(orderAction, 'address', 'deliveryAddressUpdate', (0, _location.coordinatesFromAddress)(data));
	  },
	  createOrder: function createOrder(api, appId, data, orderAction) {
	    var _data$order = data.order,
	        cart = _data$order.cart,
	        deliveryAddress = _data$order.deliveryAddress,
	        deliveryAddressExtraInfo = _data$order.deliveryAddressExtraInfo,
	        deliveryData = _data$order.deliveryData,
	        deliveryLocation = _data$order.deliveryLocation,
	        targetRestaurant = _data$order.targetRestaurant,
	        orderType = _data$order.orderType,
	        orderDate = _data$order.orderDate,
	        deliveryDate = _data$order.deliveryDate,
	        deliveryTime = _data$order.deliveryTime,
	        selectedVoucher = _data$order.selectedVoucher,
	        sourceType = _data$order.sourceType,
	        isAsap = _data$order.isAsap;
	
	    // for unhandled payment
	
	    var cashAmount = data.cashAmount;
	
	    var extraCosts = data.order.extraCosts[orderType] || [];
	
	    var order = _extends({
	      app: appId,
	      items: _cart2.default.serialize(cart),
	      extraCosts: extraCosts
	    }, _lodash2.default.pick(deliveryData, ['phoneNumber', 'email', 'extraInfo']), {
	      date: !orderDate ? formatDate(deliveryDate, deliveryTime) : orderDate // TODO use only orderDate
	    });
	
	    var userVouchers = _lodash2.default.filter(data.userVouchers, function (x) {
	      var threshold = x.constraints.threshold || 0;
	      // voucher instances filterd by modules and threshold
	      if (order.items.length === 0) {
	        return _voucher2.default.isVoucherUsable(x);
	      }
	      return _voucher2.default.isVoucherUsable(x) && _cart2.default.total(cart, order.extraCosts) >= threshold;
	    });
	
	    if (isAsap) {
	      order.asap = true;
	    }
	
	    if (deliveryAddressExtraInfo) {
	      order.addressInfo = deliveryAddressExtraInfo;
	    }
	
	    if (orderType === _constants.ORDER_TYPE_DELIVERY) {
	      order.location = deliveryLocation.geometry.location;
	      order.address = _extends({}, deliveryAddress, _lodash2.default.pick(deliveryData, ['street_number', 'citofono']));
	      order.restaurant = targetRestaurant;
	      order.name = data.user.name;
	      if (data.order.deliveryAreaId) {
	        order.targetDeliveryArea = data.order.deliveryAreaId;
	      }
	      order.type = (0, _util.serializeEnum)('DELIVERY');
	    } else {
	      order.name = deliveryData.name;
	      order.restaurant = targetRestaurant;
	      order.type = (0, _util.serializeEnum)('TAKEAWAY');
	    }
	
	    // serialize sourcType enum
	    order.sourceType = (0, _util.serializeEnum)(sourceType);
	
	    order.total = _voucher2.default.cartTotalWithVoucher(cart, extraCosts, selectedVoucher, userVouchers);
	
	    // apply voucher if needed
	    if (selectedVoucher !== _constants.ORDER_NO_VOUCHER) {
	      var voucherData = _voucher2.default.getVoucherWithId(userVouchers, selectedVoucher);
	      if (voucherData) {
	        order.extraCosts = [].concat(_toConsumableArray(extraCosts), [_cart2.default.extraCostFromVoucher(voucherData, cart)]);
	        order.voucher = selectedVoucher;
	      }
	    }
	
	    order.total = _cart2.default.total(cart, order.extraCosts);
	    order.extraCosts = order.extraCosts.map(function (c) {
	      return _extends({}, c, {
	        type: (0, _util.serializeEnum)(c.type)
	      });
	    });
	
	    // stripe payment with saved credit card (before SCA) or nexi payments with saved cardId (id contratto)
	    if (data.cardId) {
	      order.paymentType = (0, _util.serializeEnum)('CREDIT_CARD');
	      var query = '\n        mutation {\n          storeOrder(' + (0, _util.serializeForMutation)(order) + ' creditCardId: "' + data.cardId + '" ) {\n            id\n            total\n            status\n          }\n        }\n      ';
	
	      var queryName = 'storeOrder';
	      return (0, _util.wrapAction)(orderAction, queryName, 'storeOrder', api.fetch(query, {}, queryName));
	    }
	
	    // stripe payments with new credit card (before SCA)
	    if (data.stripeToken) {
	      order.paymentType = (0, _util.serializeEnum)('CREDIT_CARD');
	      var _query = '\n        mutation {\n          storeOrder(' + (0, _util.serializeForMutation)(order) + ' creditCardToken: "' + data.stripeToken + '" ) {\n            id\n            total\n            status\n          }\n        }\n      ';
	
	      var _queryName = 'storeOrder';
	      return (0, _util.wrapAction)(orderAction, _queryName, 'storeOrder', api.fetch(_query, {}, _queryName));
	    }
	
	    // stripe payment with new or saved credit card
	    // both handled with stripe payment intent api that support SCA
	    if (data.stripePaymentIntentId) {
	      order.paymentType = (0, _util.serializeEnum)('CREDIT_CARD');
	
	      var _query2 = '\n        mutation {\n          storeOrder(\n            ' + (0, _util.serializeForMutation)(order) + ' \n            stripePaymentIntentId: "' + data.stripePaymentIntentId + '",\n          ) {\n            id\n            total\n            status\n          }\n        }\n      ';
	
	      var _queryName2 = 'storeOrder';
	      return (0, _util.wrapAction)(orderAction, _queryName2, 'storeOrder', api.fetch(_query2, {}, _queryName2));
	    }
	
	    // nexi payments with new credit card
	    if (data.nexi) {
	      order.paymentType = (0, _util.serializeEnum)('CREDIT_CARD');
	
	      var _query3 = '\n        mutation {\n          storeOrder(\n            ' + (0, _util.serializeForMutation)(order) + ' \n            xpayCodiceTransazione: "' + data.xpayCodiceTransazione + '",\n            xpayEsito: "' + data.xpayEsito + '",\n            xpayIdOperazione: "' + data.xpayIdOperazione + '",\n            xpayMac: "' + data.xpayMac + '",\n            xpayTimeStamp: "' + data.xpayTimeStamp + '",\n            xpayNonce: "' + data.xpayNonce + '",\n            saveCreditCard: ' + data.saveCreditCard + ',\n          ) {\n            id\n            total\n            status\n          }\n        }\n      ';
	
	      var _queryName3 = 'storeOrder';
	      return (0, _util.wrapAction)(orderAction, _queryName3, 'storeOrder', api.fetch(_query3, {}, _queryName3));
	    }
	
	    // unhandled payment
	    if (!data.card && !data.nexi) {
	      order.paymentType = (0, _util.serializeEnum)('UNHANDLED');
	      order.cashAmount = cashAmount;
	      var _query4 = '\n        mutation {\n          storeOrder(' + (0, _util.serializeForMutation)(order) + ') {\n            id\n            total\n            status\n          }\n        }\n      ';
	
	      var _queryName4 = 'storeOrder';
	      return (0, _util.wrapAction)(orderAction, _queryName4, 'storeOrder', api.fetch(_query4, {}, _queryName4));
	    }
	
	    // credit card payment
	    order.paymentType = (0, _util.serializeEnum)('CREDIT_CARD');
	
	    return _payment2.default.stripeCreateCardToken(orderAction, data.card).then(function (token) {
	      if (!token) {
	        return;
	      }
	      var query = '\n          mutation {\n            storeOrder(' + (0, _util.serializeForMutation)(order) + ' creditCardToken: "' + token + '" ) {\n              id\n              total\n              status\n            }\n          }\n        ';
	
	      var queryName = 'storeOrder';
	      (0, _util.wrapAction)(orderAction, queryName, 'storeOrder', api.fetch(query, {}, queryName));
	    });
	  },
	  updateCurrentOrder: function updateCurrentOrder(api, appId, orderId, orderAction) {
	    var query = '\n      {\n        app(id:"' + appId + '") {\n          orders(id:"' + orderId + '") {\n            status\n            confirmation {\n              date\n            }\n          }\n        }\n      }\n    ';
	
	    var queryName = 'updateCurrentOrder';
	    // we don't really give a shit about failure and fetching
	    return api.fetch(query, {}, queryName).then(function (data) {
	      orderAction.updateCurrentOrder(_lodash2.default.property('data.app[0].orders[0]')(data));
	    });
	  },
	  orderFetchExtraCosts: function orderFetchExtraCosts(api, appId, _ref, orderAction) {
	    var total = _ref.total,
	        targetDeliveryArea = _ref.targetDeliveryArea,
	        targetRestaurant = _ref.targetRestaurant;
	
	    var query = '\n      {\n        app(id:"' + appId + '") {\n          merchant{\n            orderExtraCosts(\n              total:' + total + ',\n              targetDeliveryArea:"' + targetDeliveryArea + '"\n              restaurant:"' + targetRestaurant + '"\n            ) {\n              label\n              amount\n              type\n            }\n          }\n        }\n      }\n    ';
	
	    var queryName = 'orderFetchExtraCosts';
	    (0, _util.wrapAction)(orderAction, 'app[0].merchant.orderExtraCosts', 'orderFetchExtraCosts', api.fetch(query, {}, queryName));
	  }
	};

/***/ }),
/* 201 */
[785, 34],
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(25);
	
	exports.default = {
	  createRequest: function createRequest(api, data) {
	    var fragment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	    var bookingAction = arguments[3];
	
	    var fields = {
	      'app': '',
	      'availabilitySlot': '',
	      'date': '',
	      'name': '',
	      'lastName': '',
	      'phoneNumber': '',
	      'email': '',
	      'people': '',
	      'restaurant': '',
	      'type': ''
	    };
	
	    var args = Object.assign({}, fields, data);
	    args['type'] = (0, _util.serializeEnum)(args['type']);
	
	    if (args['sourceType']) {
	      args['sourceType'] = (0, _util.serializeEnum)(args['sourceType']);
	    }
	
	    var query = 'mutation { createBookingRequest(' + (0, _util.serializeForMutation)(args) + ') { ' + fragment + ' } }';
	
	    var queryName = 'createBookingRequest';
	    return (0, _util.wrapAction)(bookingAction, queryName, 'createRequest', api.fetch(query, {}, queryName));
	  },
	  loadBookingAvailability: function loadBookingAvailability(api, appId, _ref, bookingAction) {
	    var from = _ref.from,
	        to = _ref.to;
	
	    var query = '{\n      app(id: "' + appId + '") {\n        bookingRushes(removeExpired:true) {\n          id\n          message\n          targetDate\n          expirationDate\n          restaurants {\n            restaurant {\n              id\n            }\n            slots {\n              open\n              totalSpots\n              availableSpots\n            }\n          }\n          constraints {\n            maxPeople\n          }\n          voucher {\n            id\n            validityPeriod {\n              from\n              to\n            }\n            active\n            discount {\n              amount\n              format\n            }\n            message\n          }\n      \t}\n\n        merchant {\n          restaurants {\n            id\n            bookingAvailability(from: "' + from + '" to: "' + to + '") {\n              day\n              date\n              open\n              slots {\n                open\n                close\n                totalSpots\n                availableSpots\n              }\n            }\n          }\n        }\n      }\n    }';
	
	    var queryName = 'loadBookingAvailability';
	    return (0, _util.wrapAction)(bookingAction, 'app[0]', 'loadBookingAvailability', api.fetch(query, {}, queryName));
	  }
	};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _util = __webpack_require__(25);
	
	exports.default = {
	  authenticate: function authenticate(api, data, fragment, userAction, context) {
	    var args = (0, _util.serializeFields)(['email', 'password', 'app', 'device'], data);
	    var query = 'mutation { signIn(' + args + ') { ' + fragment + ' } }';
	
	    var queryName = 'signIn';
	    return (0, _util.wrapAction)(userAction, queryName, 'authenticate', api.fetch(query, {}, queryName), context);
	  },
	  facebookLogin: function facebookLogin(api, data, fragment, userAction, context) {
	    var args = (0, _util.serializeFields)(['fbAccessToken', 'app', 'device'], data);
	    var query = 'mutation { fbLogin(' + args + ') { ' + fragment + ' } }';
	
	    var queryName = 'fbLogin';
	    return (0, _util.wrapAction)(userAction, queryName, 'authenticate', api.fetch(query, {}, queryName), context);
	  },
	  register: function register(api, data) {
	    var fragment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
	    var userAction = arguments[3];
	    var context = arguments[4];
	
	    var args = (0, _util.serializeFields)(['email', 'password', 'name', 'lastName', 'app', 'device'], data);
	    var query = 'mutation { signUp(' + args + ') { ' + fragment + ' } }';
	
	    var queryName = 'signUp';
	    return (0, _util.wrapAction)(userAction, queryName, 'register', api.fetch(query, {}, queryName), context);
	  },
	  logout: function logout(api, userAction) {
	    var query = 'mutation { signOut }';
	
	    var queryName = 'signOut';
	    return (0, _util.wrapAction)(userAction, queryName, 'logout', api.fetch(query, {}, queryName));
	  },
	  loadCurrentUser: function loadCurrentUser(api, fragment, userAction) {
	    if (!fragment) {
	      fragment = '\n        id\n        name\n        accessToken\n      ';
	    }
	
	    var query = '\n      query {\n        me {\n          ' + fragment + '\n        }\n      }\n    ';
	
	    var queryName = 'me';
	    return (0, _util.wrapAction)(userAction, queryName, 'loadCurrentUser', api.fetch(query, {}, queryName));
	  },
	  loadUserOrders: function loadUserOrders(api, params, userAction) {
	    var paramsDefault = {
	      limit: 3
	    };
	
	    if (params.type) {
	      params.type = (0, _util.serializeEnum)(params.type);
	    }
	
	    params = (0, _util.serializeForMutation)(_extends({}, paramsDefault, params));
	
	    var fragment = '\n      orders(' + params + ') {\n        id\n        status\n        date\n        name\n        confirmation {\n          date\n        }\n        type\n        total\n        restaurant {\n          id\n        }\n        items {\n          id\n          name\n          quantity\n          price\n          modifiers {\n            id\n            name\n            items {\n              id\n              name\n              price\n            }\n          }\n        }\n        extraCosts {\n          label\n          amount\n          type\n        }\n        paymentType\n        email\n        phoneNumber\n        address {\n          route\n          street_number\n          postal_code\n          city\n          country\n          citofono\n        }\n        addressInfo\n        location {\n          lat\n          lng\n        }\n      }\n    ';
	
	    var query = '\n      query {\n        me {\n          ' + fragment + '\n        }\n      }\n    ';
	
	    var queryName = 'me';
	    return (0, _util.wrapAction)(userAction, queryName, 'loadUserOrders', api.fetch(query, {}, queryName));
	  },
	  loadUserBookingRequests: function loadUserBookingRequests(api, params, userAction) {
	    var paramsDefault = {
	      limit: 3
	    };
	
	    if (params.type) {
	      params.type = (0, _util.serializeEnum)(params.type);
	    }
	
	    params = (0, _util.serializeForMutation)(_extends({}, paramsDefault, params));
	
	    var fragment = '\n      bookingRequests(' + params + ') {\n        id\n        app\n        name\n        lastName\n        phoneNumber\n        email\n        date\n        people\n        type\n        status\n        extraInfo\n        insertedAt\n        updatedAt\n        sourceType\n        restaurant {\n          id\n        }\n        availabilitySlot {\n          open\n          close\n        }\n        user {\n          id\n        }\n      }\n    ';
	
	    var query = '\n      query {\n        me {\n          ' + fragment + '\n        }\n      }\n    ';
	
	    var queryName = 'me';
	    return (0, _util.wrapAction)(userAction, queryName, 'loadUserBookingRequests', api.fetch(query, {}, queryName));
	  },
	  loadCreditCards: function loadCreditCards(api, params, userAction) {
	    var fragment = '\n      creditCards {\n        id\n        brand\n        country\n        exp_month\n        exp_year\n        last4\n      }\n    ';
	
	    var query = '\n      query {\n        me {\n          ' + fragment + '\n        }\n      }\n    ';
	
	    var queryName = 'me';
	    return (0, _util.wrapAction)(userAction, queryName, 'loadCreditCards', api.fetch(query, {}, queryName));
	  },
	  deleteCreditCard: function deleteCreditCard(api, params, userAction) {
	    var fragment = '\n      {\n        id\n        brand\n        country\n        exp_month\n        exp_year\n        last4\n      }\n    ';
	
	    var query = 'mutation { deleteCreditCard(cardId: "' + params.cardId + '") ' + fragment + ' }';
	    var queryName = 'deleteCreditCard';
	    return (0, _util.wrapAction)(userAction, queryName, 'deleteCreditCard', api.fetch(query, {}, queryName));
	  },
	  storeCreditCardToken: function storeCreditCardToken(api, data, userAction) {
	    // TODO questa roba probabilmente non va, e la mutation non esiste sulle api ^^'
	    var args = (0, _util.serializeFields)(['lastDigits', 'token', 'app', 'device', 'user'], data);
	    var query = 'mutation { storeCreditCardToken(' + args + ') }';
	    var queryName = 'storeCreditCardToken';
	    return (0, _util.wrapAction)(userAction, queryName, 'storeCreditCardToken', api.fetch(query, {}, queryName));
	  }
	};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(25);
	
	exports.default = {
	  redeem: function redeem(api, data, fragment, voucherAction) {
	    var query = 'mutation { redeeemVoucher(id: "' + data.id + '") { ' + fragment + ' } }';
	
	    var queryName = 'redeeemVoucher';
	    return (0, _util.wrapAction)(voucherAction, queryName, 'redeem', api.fetch(query, {}, queryName));
	  },
	  create: function create(api, data, fragment, voucherAction) {
	    var fields = ['app', 'discount', 'source', 'active', 'validityPeriod', 'message'];
	    var args = (0, _util.serializeFields)(fields, data);
	    var query = 'mutation { createVoucher(' + args + ') { ' + fragment + ' } }';
	
	    var queryName = 'createVoucher';
	    return (0, _util.wrapAction)(voucherAction, queryName, 'create', api.fetch(query, {}, queryName));
	  },
	  update: function update(api, data, fragment, voucherAction) {
	    var fields = ['id', 'app', 'discount', 'active', 'validityPeriod', 'message'];
	    var args = (0, _util.serializeFields)(fields, data);
	    var query = 'mutation { updateVoucher(' + args + ') { ' + fragment + ' } }';
	
	    var queryName = 'updateVoucher';
	    return (0, _util.wrapAction)(voucherAction, queryName, 'update', api.fetch(query, {}, queryName));
	  },
	
	
	  /*
	  NB: il filtro su redeemed è per l'instance, non per il prototipo del voucher. E' riportato in corrispondenza
	  di vouchers perché veniva più comodo e più intuitivo su GraphQL
	  */
	  getMine: function getMine(api, voucherAction) {
	    var query = 'query {\n      me {\n        vouchers(redeemed: false) {\n          id\n          validityPeriod {\n            from\n            to\n          }\n          source\n          active\n          image\n          constraints {\n            inStore\n            modules {\n              module\n              services {\n                name\n                active\n              }\n            }\n            threshold\n          }\n          discount {\n            amount\n            format\n          }\n          message\n          instance {\n            id\n            redeemed\n            redemptionDate\n            invalidated\n          }\n        }\n      }\n    }';
	
	    var queryName = 'me:voucher:getMine';
	    return (0, _util.wrapAction)(voucherAction, 'me', 'getMine', api.fetch(query, {}, queryName));
	  }
	};

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
	var previousComparisons = new Map();
	/**
	 * Performs a deep equality check on two JavaScript values, tolerating cycles.
	 */
	function equal(a, b) {
	    try {
	        return check(a, b);
	    }
	    finally {
	        previousComparisons.clear();
	    }
	}
	function check(a, b) {
	    // If the two values are strictly equal, our job is easy.
	    if (a === b) {
	        return true;
	    }
	    // Object.prototype.toString returns a representation of the runtime type of
	    // the given value that is considerably more precise than typeof.
	    var aTag = toString.call(a);
	    var bTag = toString.call(b);
	    // If the runtime types of a and b are different, they could maybe be equal
	    // under some interpretation of equality, but for simplicity and performance
	    // we just return false instead.
	    if (aTag !== bTag) {
	        return false;
	    }
	    switch (aTag) {
	        case '[object Array]':
	            // Arrays are a lot like other objects, but we can cheaply compare their
	            // lengths as a short-cut before comparing their elements.
	            if (a.length !== b.length)
	                return false;
	        // Fall through to object case...
	        case '[object Object]': {
	            if (previouslyCompared(a, b))
	                return true;
	            var aKeys = Object.keys(a);
	            var bKeys = Object.keys(b);
	            // If `a` and `b` have a different number of enumerable keys, they
	            // must be different.
	            var keyCount = aKeys.length;
	            if (keyCount !== bKeys.length)
	                return false;
	            // Now make sure they have the same keys.
	            for (var k = 0; k < keyCount; ++k) {
	                if (!hasOwnProperty.call(b, aKeys[k])) {
	                    return false;
	                }
	            }
	            // Finally, check deep equality of all child properties.
	            for (var k = 0; k < keyCount; ++k) {
	                var key = aKeys[k];
	                if (!check(a[key], b[key])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        case '[object Error]':
	            return a.name === b.name && a.message === b.message;
	        case '[object Number]':
	            // Handle NaN, which is !== itself.
	            if (a !== a)
	                return b !== b;
	        // Fall through to shared +a === +b case...
	        case '[object Boolean]':
	        case '[object Date]':
	            return +a === +b;
	        case '[object RegExp]':
	        case '[object String]':
	            return a == "" + b;
	        case '[object Map]':
	        case '[object Set]': {
	            if (a.size !== b.size)
	                return false;
	            if (previouslyCompared(a, b))
	                return true;
	            var aIterator = a.entries();
	            var isMap = aTag === '[object Map]';
	            while (true) {
	                var info = aIterator.next();
	                if (info.done)
	                    break;
	                // If a instanceof Set, aValue === aKey.
	                var _a = info.value, aKey = _a[0], aValue = _a[1];
	                // So this works the same way for both Set and Map.
	                if (!b.has(aKey)) {
	                    return false;
	                }
	                // However, we care about deep equality of values only when dealing
	                // with Map structures.
	                if (isMap && !check(aValue, b.get(aKey))) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	    // Otherwise the values are not equal.
	    return false;
	}
	function previouslyCompared(a, b) {
	    // Though cyclic references can make an object graph appear infinite from the
	    // perspective of a depth-first traversal, the graph still contains a finite
	    // number of distinct object references. We use the previousComparisons cache
	    // to avoid comparing the same pair of object references more than once, which
	    // guarantees termination (even if we end up comparing every object in one
	    // graph to every object in the other graph, which is extremely unlikely),
	    // while still allowing weird isomorphic structures (like rings with different
	    // lengths) a chance to pass the equality test.
	    var bSet = previousComparisons.get(a);
	    if (bSet) {
	        // Return true here because we can be sure false will be returned somewhere
	        // else if the objects are not equivalent.
	        if (bSet.has(b))
	            return true;
	    }
	    else {
	        previousComparisons.set(a, bSet = new Set);
	    }
	    bSet.add(b);
	    return false;
	}
	
	exports.default = equal;
	exports.equal = equal;
	//# sourceMappingURL=equality.js.map


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(14), __webpack_require__(89), __webpack_require__(118), __webpack_require__(280), __webpack_require__(31), __webpack_require__(129)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require("tslib"), require("apollo-utilities"), require("apollo-link"), require("symbol-observable"), require("ts-invariant"), require("graphql/language/visitor"));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.tslib, global.apolloUtilities, global.apolloLink, global.symbolObservable, global.tsInvariant, global.visitor);
	    global.unknown = mod.exports;
	  }
	})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _tslib, _apolloUtilities, _apolloLink, _symbolObservable, _tsInvariant, _visitor) {
	
	  _exports.__esModule = true;
	  _exports.isApolloError = isApolloError;
	  _exports.ObservableQuery = _exports.NetworkStatus = _exports.FetchType = _exports.ApolloError = _exports.ApolloClient = _exports.default = void 0;
	  _symbolObservable = _interopRequireDefault(_symbolObservable);
	
	  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	  var NetworkStatus;
	  _exports.NetworkStatus = NetworkStatus;
	
	  (function (NetworkStatus) {
	    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
	    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
	    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
	    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
	    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
	    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
	    NetworkStatus[NetworkStatus["error"] = 8] = "error";
	  })(NetworkStatus || (_exports.NetworkStatus = NetworkStatus = {}));
	
	  function isNetworkRequestInFlight(networkStatus) {
	    return networkStatus < 7;
	  }
	
	  var Observable = function (_super) {
	    (0, _tslib.__extends)(Observable, _super);
	
	    function Observable() {
	      return _super !== null && _super.apply(this, arguments) || this;
	    }
	
	    Observable.prototype[_symbolObservable.default] = function () {
	      return this;
	    };
	
	    Observable.prototype['@@observable'] = function () {
	      return this;
	    };
	
	    return Observable;
	  }(_apolloLink.Observable);
	
	  function isNonEmptyArray(value) {
	    return Array.isArray(value) && value.length > 0;
	  }
	
	  function isApolloError(err) {
	    return err.hasOwnProperty('graphQLErrors');
	  }
	
	  var generateErrorMessage = function (err) {
	    var message = '';
	
	    if (isNonEmptyArray(err.graphQLErrors)) {
	      err.graphQLErrors.forEach(function (graphQLError) {
	        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
	        message += "GraphQL error: " + errorMessage + "\n";
	      });
	    }
	
	    if (err.networkError) {
	      message += 'Network error: ' + err.networkError.message + '\n';
	    }
	
	    message = message.replace(/\n$/, '');
	    return message;
	  };
	
	  var ApolloError = function (_super) {
	    (0, _tslib.__extends)(ApolloError, _super);
	
	    function ApolloError(_a) {
	      var graphQLErrors = _a.graphQLErrors,
	          networkError = _a.networkError,
	          errorMessage = _a.errorMessage,
	          extraInfo = _a.extraInfo;
	
	      var _this = _super.call(this, errorMessage) || this;
	
	      _this.graphQLErrors = graphQLErrors || [];
	      _this.networkError = networkError || null;
	
	      if (!errorMessage) {
	        _this.message = generateErrorMessage(_this);
	      } else {
	        _this.message = errorMessage;
	      }
	
	      _this.extraInfo = extraInfo;
	      _this.__proto__ = ApolloError.prototype;
	      return _this;
	    }
	
	    return ApolloError;
	  }(Error);
	
	  _exports.ApolloError = ApolloError;
	  var FetchType;
	  _exports.FetchType = FetchType;
	
	  (function (FetchType) {
	    FetchType[FetchType["normal"] = 1] = "normal";
	    FetchType[FetchType["refetch"] = 2] = "refetch";
	    FetchType[FetchType["poll"] = 3] = "poll";
	  })(FetchType || (_exports.FetchType = FetchType = {}));
	
	  var hasError = function (storeValue, policy) {
	    if (policy === void 0) {
	      policy = 'none';
	    }
	
	    return storeValue && (storeValue.networkError || policy === 'none' && isNonEmptyArray(storeValue.graphQLErrors));
	  };
	
	  var ObservableQuery = function (_super) {
	    (0, _tslib.__extends)(ObservableQuery, _super);
	
	    function ObservableQuery(_a) {
	      var queryManager = _a.queryManager,
	          options = _a.options,
	          _b = _a.shouldSubscribe,
	          shouldSubscribe = _b === void 0 ? true : _b;
	
	      var _this = _super.call(this, function (observer) {
	        return _this.onSubscribe(observer);
	      }) || this;
	
	      _this.observers = new Set();
	      _this.subscriptions = new Set();
	      _this.isTornDown = false;
	      _this.options = options;
	      _this.variables = options.variables || {};
	      _this.queryId = queryManager.generateQueryId();
	      _this.shouldSubscribe = shouldSubscribe;
	      var opDef = (0, _apolloUtilities.getOperationDefinition)(options.query);
	      _this.queryName = opDef && opDef.name && opDef.name.value;
	      _this.queryManager = queryManager;
	      return _this;
	    }
	
	    ObservableQuery.prototype.result = function () {
	      var _this = this;
	
	      return new Promise(function (resolve, reject) {
	        var observer = {
	          next: function (result) {
	            resolve(result);
	
	            _this.observers.delete(observer);
	
	            if (!_this.observers.size) {
	              _this.queryManager.removeQuery(_this.queryId);
	            }
	
	            setTimeout(function () {
	              subscription.unsubscribe();
	            }, 0);
	          },
	          error: reject
	        };
	
	        var subscription = _this.subscribe(observer);
	      });
	    };
	
	    ObservableQuery.prototype.currentResult = function () {
	      var result = this.getCurrentResult();
	
	      if (result.data === undefined) {
	        result.data = {};
	      }
	
	      return result;
	    };
	
	    ObservableQuery.prototype.getCurrentResult = function () {
	      if (this.isTornDown) {
	        var lastResult = this.lastResult;
	        return {
	          data: !this.lastError && lastResult && lastResult.data || void 0,
	          error: this.lastError,
	          loading: false,
	          networkStatus: NetworkStatus.error
	        };
	      }
	
	      var _a = this.queryManager.getCurrentQueryResult(this),
	          data = _a.data,
	          partial = _a.partial;
	
	      var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
	      var result;
	      var fetchPolicy = this.options.fetchPolicy;
	      var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
	
	      if (queryStoreValue) {
	        var networkStatus = queryStoreValue.networkStatus;
	
	        if (hasError(queryStoreValue, this.options.errorPolicy)) {
	          return {
	            data: void 0,
	            loading: false,
	            networkStatus: networkStatus,
	            error: new ApolloError({
	              graphQLErrors: queryStoreValue.graphQLErrors,
	              networkError: queryStoreValue.networkError
	            })
	          };
	        }
	
	        if (queryStoreValue.variables) {
	          this.options.variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.options.variables), queryStoreValue.variables);
	          this.variables = this.options.variables;
	        }
	
	        result = {
	          data: data,
	          loading: isNetworkRequestInFlight(networkStatus),
	          networkStatus: networkStatus
	        };
	
	        if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') {
	          result.errors = queryStoreValue.graphQLErrors;
	        }
	      } else {
	        var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
	        result = {
	          data: data,
	          loading: loading,
	          networkStatus: loading ? NetworkStatus.loading : NetworkStatus.ready
	        };
	      }
	
	      if (!partial) {
	        this.updateLastResult((0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
	          stale: false
	        }));
	      }
	
	      return (0, _tslib.__assign)((0, _tslib.__assign)({}, result), {
	        partial: partial
	      });
	    };
	
	    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
	      var snapshot = this.lastResultSnapshot;
	      return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, _apolloUtilities.isEqual)(snapshot.data, newResult.data));
	    };
	
	    ObservableQuery.prototype.getLastResult = function () {
	      return this.lastResult;
	    };
	
	    ObservableQuery.prototype.getLastError = function () {
	      return this.lastError;
	    };
	
	    ObservableQuery.prototype.resetLastResults = function () {
	      delete this.lastResult;
	      delete this.lastResultSnapshot;
	      delete this.lastError;
	      this.isTornDown = false;
	    };
	
	    ObservableQuery.prototype.resetQueryStoreErrors = function () {
	      var queryStore = this.queryManager.queryStore.get(this.queryId);
	
	      if (queryStore) {
	        queryStore.networkError = null;
	        queryStore.graphQLErrors = [];
	      }
	    };
	
	    ObservableQuery.prototype.refetch = function (variables) {
	      var fetchPolicy = this.options.fetchPolicy;
	
	      if (fetchPolicy === 'cache-only') {
	        return Promise.reject( true ? new _tsInvariant.InvariantError(1) : new _tsInvariant.InvariantError('cache-only fetchPolicy option should not be used together with query refetch.'));
	      }
	
	      if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') {
	        fetchPolicy = 'network-only';
	      }
	
	      if (!(0, _apolloUtilities.isEqual)(this.variables, variables)) {
	        this.variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.variables), variables);
	      }
	
	      if (!(0, _apolloUtilities.isEqual)(this.options.variables, this.variables)) {
	        this.options.variables = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.options.variables), this.variables);
	      }
	
	      return this.queryManager.fetchQuery(this.queryId, (0, _tslib.__assign)((0, _tslib.__assign)({}, this.options), {
	        fetchPolicy: fetchPolicy
	      }), FetchType.refetch);
	    };
	
	    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
	      var _this = this;
	
	       true ? (0, _tsInvariant.invariant)(fetchMoreOptions.updateQuery, 2) : (0, _tsInvariant.invariant)(fetchMoreOptions.updateQuery, 'updateQuery option is required. This function defines how to update the query data with the new results.');
	      var combinedOptions = (0, _tslib.__assign)((0, _tslib.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, this.options), fetchMoreOptions), {
	        variables: (0, _tslib.__assign)((0, _tslib.__assign)({}, this.variables), fetchMoreOptions.variables)
	      })), {
	        fetchPolicy: 'network-only'
	      });
	      var qid = this.queryManager.generateQueryId();
	      return this.queryManager.fetchQuery(qid, combinedOptions, FetchType.normal, this.queryId).then(function (fetchMoreResult) {
	        _this.updateQuery(function (previousResult) {
	          return fetchMoreOptions.updateQuery(previousResult, {
	            fetchMoreResult: fetchMoreResult.data,
	            variables: combinedOptions.variables
	          });
	        });
	
	        _this.queryManager.stopQuery(qid);
	
	        return fetchMoreResult;
	      }, function (error) {
	        _this.queryManager.stopQuery(qid);
	
	        throw error;
	      });
	    };
	
	    ObservableQuery.prototype.subscribeToMore = function (options) {
	      var _this = this;
	
	      var subscription = this.queryManager.startGraphQLSubscription({
	        query: options.document,
	        variables: options.variables
	      }).subscribe({
	        next: function (subscriptionData) {
	          var updateQuery = options.updateQuery;
	
	          if (updateQuery) {
	            _this.updateQuery(function (previous, _a) {
	              var variables = _a.variables;
	              return updateQuery(previous, {
	                subscriptionData: subscriptionData,
	                variables: variables
	              });
	            });
	          }
	        },
	        error: function (err) {
	          if (options.onError) {
	            options.onError(err);
	            return;
	          }
	
	          ("production") === "production" || _tsInvariant.invariant.error('Unhandled GraphQL subscription error', err);
	        }
	      });
	      this.subscriptions.add(subscription);
	      return function () {
	        if (_this.subscriptions.delete(subscription)) {
	          subscription.unsubscribe();
	        }
	      };
	    };
	
	    ObservableQuery.prototype.setOptions = function (opts) {
	      var oldFetchPolicy = this.options.fetchPolicy;
	      this.options = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.options), opts);
	
	      if (opts.pollInterval) {
	        this.startPolling(opts.pollInterval);
	      } else if (opts.pollInterval === 0) {
	        this.stopPolling();
	      }
	
	      var fetchPolicy = opts.fetchPolicy;
	      return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
	    };
	
	    ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
	      if (tryFetch === void 0) {
	        tryFetch = false;
	      }
	
	      if (fetchResults === void 0) {
	        fetchResults = true;
	      }
	
	      this.isTornDown = false;
	      variables = variables || this.variables;
	
	      if (!tryFetch && (0, _apolloUtilities.isEqual)(variables, this.variables)) {
	        return this.observers.size && fetchResults ? this.result() : Promise.resolve();
	      }
	
	      this.variables = this.options.variables = variables;
	
	      if (!this.observers.size) {
	        return Promise.resolve();
	      }
	
	      return this.queryManager.fetchQuery(this.queryId, this.options);
	    };
	
	    ObservableQuery.prototype.updateQuery = function (mapFn) {
	      var queryManager = this.queryManager;
	
	      var _a = queryManager.getQueryWithPreviousResult(this.queryId),
	          previousResult = _a.previousResult,
	          variables = _a.variables,
	          document = _a.document;
	
	      var newResult = (0, _apolloUtilities.tryFunctionOrLogError)(function () {
	        return mapFn(previousResult, {
	          variables: variables
	        });
	      });
	
	      if (newResult) {
	        queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
	        queryManager.broadcastQueries();
	      }
	    };
	
	    ObservableQuery.prototype.stopPolling = function () {
	      this.queryManager.stopPollingQuery(this.queryId);
	      this.options.pollInterval = undefined;
	    };
	
	    ObservableQuery.prototype.startPolling = function (pollInterval) {
	      assertNotCacheFirstOrOnly(this);
	      this.options.pollInterval = pollInterval;
	      this.queryManager.startPollingQuery(this.options, this.queryId);
	    };
	
	    ObservableQuery.prototype.updateLastResult = function (newResult) {
	      var previousResult = this.lastResult;
	      this.lastResult = newResult;
	      this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, _apolloUtilities.cloneDeep)(newResult);
	      return previousResult;
	    };
	
	    ObservableQuery.prototype.onSubscribe = function (observer) {
	      var _this = this;
	
	      try {
	        var subObserver = observer._subscription._observer;
	
	        if (subObserver && !subObserver.error) {
	          subObserver.error = defaultSubscriptionObserverErrorCallback;
	        }
	      } catch (_a) {}
	
	      var first = !this.observers.size;
	      this.observers.add(observer);
	      if (observer.next && this.lastResult) observer.next(this.lastResult);
	      if (observer.error && this.lastError) observer.error(this.lastError);
	
	      if (first) {
	        this.setUpQuery();
	      }
	
	      return function () {
	        if (_this.observers.delete(observer) && !_this.observers.size) {
	          _this.tearDownQuery();
	        }
	      };
	    };
	
	    ObservableQuery.prototype.setUpQuery = function () {
	      var _this = this;
	
	      var _a = this,
	          queryManager = _a.queryManager,
	          queryId = _a.queryId;
	
	      if (this.shouldSubscribe) {
	        queryManager.addObservableQuery(queryId, this);
	      }
	
	      if (this.options.pollInterval) {
	        assertNotCacheFirstOrOnly(this);
	        queryManager.startPollingQuery(this.options, queryId);
	      }
	
	      var onError = function (error) {
	        _this.updateLastResult((0, _tslib.__assign)((0, _tslib.__assign)({}, _this.lastResult), {
	          errors: error.graphQLErrors,
	          networkStatus: NetworkStatus.error,
	          loading: false
	        }));
	
	        iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
	      };
	
	      queryManager.observeQuery(queryId, this.options, {
	        next: function (result) {
	          if (_this.lastError || _this.isDifferentFromLastResult(result)) {
	            var previousResult_1 = _this.updateLastResult(result);
	
	            var _a = _this.options,
	                query_1 = _a.query,
	                variables = _a.variables,
	                fetchPolicy_1 = _a.fetchPolicy;
	
	            if (queryManager.transform(query_1).hasClientExports) {
	              queryManager.getLocalState().addExportedVariables(query_1, variables).then(function (variables) {
	                var previousVariables = _this.variables;
	                _this.variables = _this.options.variables = variables;
	
	                if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, _apolloUtilities.isEqual)(previousVariables, variables)) {
	                  _this.refetch();
	                } else {
	                  iterateObserversSafely(_this.observers, 'next', result);
	                }
	              });
	            } else {
	              iterateObserversSafely(_this.observers, 'next', result);
	            }
	          }
	        },
	        error: onError
	      }).catch(onError);
	    };
	
	    ObservableQuery.prototype.tearDownQuery = function () {
	      var queryManager = this.queryManager;
	      this.isTornDown = true;
	      queryManager.stopPollingQuery(this.queryId);
	      this.subscriptions.forEach(function (sub) {
	        return sub.unsubscribe();
	      });
	      this.subscriptions.clear();
	      queryManager.removeObservableQuery(this.queryId);
	      queryManager.stopQuery(this.queryId);
	      this.observers.clear();
	    };
	
	    return ObservableQuery;
	  }(Observable);
	
	  _exports.ObservableQuery = ObservableQuery;
	
	  function defaultSubscriptionObserverErrorCallback(error) {
	    ("production") === "production" || _tsInvariant.invariant.error('Unhandled error', error.message, error.stack);
	  }
	
	  function iterateObserversSafely(observers, method, argument) {
	    var observersWithMethod = [];
	    observers.forEach(function (obs) {
	      return obs[method] && observersWithMethod.push(obs);
	    });
	    observersWithMethod.forEach(function (obs) {
	      return obs[method](argument);
	    });
	  }
	
	  function assertNotCacheFirstOrOnly(obsQuery) {
	    var fetchPolicy = obsQuery.options.fetchPolicy;
	     true ? (0, _tsInvariant.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3) : (0, _tsInvariant.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 'Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
	  }
	
	  var MutationStore = function () {
	    function MutationStore() {
	      this.store = {};
	    }
	
	    MutationStore.prototype.getStore = function () {
	      return this.store;
	    };
	
	    MutationStore.prototype.get = function (mutationId) {
	      return this.store[mutationId];
	    };
	
	    MutationStore.prototype.initMutation = function (mutationId, mutation, variables) {
	      this.store[mutationId] = {
	        mutation: mutation,
	        variables: variables || {},
	        loading: true,
	        error: null
	      };
	    };
	
	    MutationStore.prototype.markMutationError = function (mutationId, error) {
	      var mutation = this.store[mutationId];
	
	      if (mutation) {
	        mutation.loading = false;
	        mutation.error = error;
	      }
	    };
	
	    MutationStore.prototype.markMutationResult = function (mutationId) {
	      var mutation = this.store[mutationId];
	
	      if (mutation) {
	        mutation.loading = false;
	        mutation.error = null;
	      }
	    };
	
	    MutationStore.prototype.reset = function () {
	      this.store = {};
	    };
	
	    return MutationStore;
	  }();
	
	  var QueryStore = function () {
	    function QueryStore() {
	      this.store = {};
	    }
	
	    QueryStore.prototype.getStore = function () {
	      return this.store;
	    };
	
	    QueryStore.prototype.get = function (queryId) {
	      return this.store[queryId];
	    };
	
	    QueryStore.prototype.initQuery = function (query) {
	      var previousQuery = this.store[query.queryId];
	       true ? (0, _tsInvariant.invariant)(!previousQuery || previousQuery.document === query.document || (0, _apolloUtilities.isEqual)(previousQuery.document, query.document), 19) : (0, _tsInvariant.invariant)(!previousQuery || previousQuery.document === query.document || (0, _apolloUtilities.isEqual)(previousQuery.document, query.document), 'Internal Error: may not update existing query string in store');
	      var isSetVariables = false;
	      var previousVariables = null;
	
	      if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== NetworkStatus.loading) {
	        if (!(0, _apolloUtilities.isEqual)(previousQuery.variables, query.variables)) {
	          isSetVariables = true;
	          previousVariables = previousQuery.variables;
	        }
	      }
	
	      var networkStatus;
	
	      if (isSetVariables) {
	        networkStatus = NetworkStatus.setVariables;
	      } else if (query.isPoll) {
	        networkStatus = NetworkStatus.poll;
	      } else if (query.isRefetch) {
	        networkStatus = NetworkStatus.refetch;
	      } else {
	        networkStatus = NetworkStatus.loading;
	      }
	
	      var graphQLErrors = [];
	
	      if (previousQuery && previousQuery.graphQLErrors) {
	        graphQLErrors = previousQuery.graphQLErrors;
	      }
	
	      this.store[query.queryId] = {
	        document: query.document,
	        variables: query.variables,
	        previousVariables: previousVariables,
	        networkError: null,
	        graphQLErrors: graphQLErrors,
	        networkStatus: networkStatus,
	        metadata: query.metadata
	      };
	
	      if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) {
	        this.store[query.fetchMoreForQueryId].networkStatus = NetworkStatus.fetchMore;
	      }
	    };
	
	    QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
	      if (!this.store || !this.store[queryId]) return;
	      this.store[queryId].networkError = null;
	      this.store[queryId].graphQLErrors = isNonEmptyArray(result.errors) ? result.errors : [];
	      this.store[queryId].previousVariables = null;
	      this.store[queryId].networkStatus = NetworkStatus.ready;
	
	      if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) {
	        this.store[fetchMoreForQueryId].networkStatus = NetworkStatus.ready;
	      }
	    };
	
	    QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
	      if (!this.store || !this.store[queryId]) return;
	      this.store[queryId].networkError = error;
	      this.store[queryId].networkStatus = NetworkStatus.error;
	
	      if (typeof fetchMoreForQueryId === 'string') {
	        this.markQueryResultClient(fetchMoreForQueryId, true);
	      }
	    };
	
	    QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
	      var storeValue = this.store && this.store[queryId];
	
	      if (storeValue) {
	        storeValue.networkError = null;
	        storeValue.previousVariables = null;
	
	        if (complete) {
	          storeValue.networkStatus = NetworkStatus.ready;
	        }
	      }
	    };
	
	    QueryStore.prototype.stopQuery = function (queryId) {
	      delete this.store[queryId];
	    };
	
	    QueryStore.prototype.reset = function (observableQueryIds) {
	      var _this = this;
	
	      Object.keys(this.store).forEach(function (queryId) {
	        if (observableQueryIds.indexOf(queryId) < 0) {
	          _this.stopQuery(queryId);
	        } else {
	          _this.store[queryId].networkStatus = NetworkStatus.loading;
	        }
	      });
	    };
	
	    return QueryStore;
	  }();
	
	  function capitalizeFirstLetter(str) {
	    return str.charAt(0).toUpperCase() + str.slice(1);
	  }
	
	  var LocalState = function () {
	    function LocalState(_a) {
	      var cache = _a.cache,
	          client = _a.client,
	          resolvers = _a.resolvers,
	          fragmentMatcher = _a.fragmentMatcher;
	      this.cache = cache;
	
	      if (client) {
	        this.client = client;
	      }
	
	      if (resolvers) {
	        this.addResolvers(resolvers);
	      }
	
	      if (fragmentMatcher) {
	        this.setFragmentMatcher(fragmentMatcher);
	      }
	    }
	
	    LocalState.prototype.addResolvers = function (resolvers) {
	      var _this = this;
	
	      this.resolvers = this.resolvers || {};
	
	      if (Array.isArray(resolvers)) {
	        resolvers.forEach(function (resolverGroup) {
	          _this.resolvers = (0, _apolloUtilities.mergeDeep)(_this.resolvers, resolverGroup);
	        });
	      } else {
	        this.resolvers = (0, _apolloUtilities.mergeDeep)(this.resolvers, resolvers);
	      }
	    };
	
	    LocalState.prototype.setResolvers = function (resolvers) {
	      this.resolvers = {};
	      this.addResolvers(resolvers);
	    };
	
	    LocalState.prototype.getResolvers = function () {
	      return this.resolvers || {};
	    };
	
	    LocalState.prototype.runResolvers = function (_a) {
	      var document = _a.document,
	          remoteResult = _a.remoteResult,
	          context = _a.context,
	          variables = _a.variables,
	          _b = _a.onlyRunForcedResolvers,
	          onlyRunForcedResolvers = _b === void 0 ? false : _b;
	      return (0, _tslib.__awaiter)(this, void 0, void 0, function () {
	        return (0, _tslib.__generator)(this, function (_c) {
	          if (document) {
	            return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) {
	              return (0, _tslib.__assign)((0, _tslib.__assign)({}, remoteResult), {
	                data: localResult.result
	              });
	            })];
	          }
	
	          return [2, remoteResult];
	        });
	      });
	    };
	
	    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
	      this.fragmentMatcher = fragmentMatcher;
	    };
	
	    LocalState.prototype.getFragmentMatcher = function () {
	      return this.fragmentMatcher;
	    };
	
	    LocalState.prototype.clientQuery = function (document) {
	      if ((0, _apolloUtilities.hasDirectives)(['client'], document)) {
	        if (this.resolvers) {
	          return document;
	        }
	
	        ("production") === "production" || _tsInvariant.invariant.warn('Found @client directives in a query but no ApolloClient resolvers ' + 'were specified. This means ApolloClient local resolver handling ' + 'has been disabled, and @client directives will be passed through ' + 'to your link chain.');
	      }
	
	      return null;
	    };
	
	    LocalState.prototype.serverQuery = function (document) {
	      return this.resolvers ? (0, _apolloUtilities.removeClientSetsFromDocument)(document) : document;
	    };
	
	    LocalState.prototype.prepareContext = function (context) {
	      if (context === void 0) {
	        context = {};
	      }
	
	      var cache = this.cache;
	      var newContext = (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
	        cache: cache,
	        getCacheKey: function (obj) {
	          if (cache.config) {
	            return cache.config.dataIdFromObject(obj);
	          } else {
	             true ? (0, _tsInvariant.invariant)(false, 6) : (0, _tsInvariant.invariant)(false, 'To use context.getCacheKey, you need to use a cache that has ' + 'a configurable dataIdFromObject, like apollo-cache-inmemory.');
	          }
	        }
	      });
	      return newContext;
	    };
	
	    LocalState.prototype.addExportedVariables = function (document, variables, context) {
	      if (variables === void 0) {
	        variables = {};
	      }
	
	      if (context === void 0) {
	        context = {};
	      }
	
	      return (0, _tslib.__awaiter)(this, void 0, void 0, function () {
	        return (0, _tslib.__generator)(this, function (_a) {
	          if (document) {
	            return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) {
	              return (0, _tslib.__assign)((0, _tslib.__assign)({}, variables), data.exportedVariables);
	            })];
	          }
	
	          return [2, (0, _tslib.__assign)({}, variables)];
	        });
	      });
	    };
	
	    LocalState.prototype.shouldForceResolvers = function (document) {
	      var forceResolvers = false;
	      (0, _visitor.visit)(document, {
	        Directive: {
	          enter: function (node) {
	            if (node.name.value === 'client' && node.arguments) {
	              forceResolvers = node.arguments.some(function (arg) {
	                return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
	              });
	
	              if (forceResolvers) {
	                return _visitor.BREAK;
	              }
	            }
	          }
	        }
	      });
	      return forceResolvers;
	    };
	
	    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
	      return this.cache.diff({
	        query: (0, _apolloUtilities.buildQueryFromSelectionSet)(document),
	        variables: variables,
	        returnPartialData: true,
	        optimistic: false
	      }).result;
	    };
	
	    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
	      if (context === void 0) {
	        context = {};
	      }
	
	      if (variables === void 0) {
	        variables = {};
	      }
	
	      if (fragmentMatcher === void 0) {
	        fragmentMatcher = function () {
	          return true;
	        };
	      }
	
	      if (onlyRunForcedResolvers === void 0) {
	        onlyRunForcedResolvers = false;
	      }
	
	      return (0, _tslib.__awaiter)(this, void 0, void 0, function () {
	        var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
	
	        return (0, _tslib.__generator)(this, function (_b) {
	          mainDefinition = (0, _apolloUtilities.getMainDefinition)(document);
	          fragments = (0, _apolloUtilities.getFragmentDefinitions)(document);
	          fragmentMap = (0, _apolloUtilities.createFragmentMap)(fragments);
	          definitionOperation = mainDefinition.operation;
	          defaultOperationType = definitionOperation ? capitalizeFirstLetter(definitionOperation) : 'Query';
	          _a = this, cache = _a.cache, client = _a.client;
	          execContext = {
	            fragmentMap: fragmentMap,
	            context: (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
	              cache: cache,
	              client: client
	            }),
	            variables: variables,
	            fragmentMatcher: fragmentMatcher,
	            defaultOperationType: defaultOperationType,
	            exportedVariables: {},
	            onlyRunForcedResolvers: onlyRunForcedResolvers
	          };
	          return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) {
	            return {
	              result: result,
	              exportedVariables: execContext.exportedVariables
	            };
	          })];
	        });
	      });
	    };
	
	    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
	      return (0, _tslib.__awaiter)(this, void 0, void 0, function () {
	        var fragmentMap, context, variables, resultsToMerge, execute;
	
	        var _this = this;
	
	        return (0, _tslib.__generator)(this, function (_a) {
	          fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
	          resultsToMerge = [rootValue];
	
	          execute = function (selection) {
	            return (0, _tslib.__awaiter)(_this, void 0, void 0, function () {
	              var fragment, typeCondition;
	              return (0, _tslib.__generator)(this, function (_a) {
	                if (!(0, _apolloUtilities.shouldInclude)(selection, variables)) {
	                  return [2];
	                }
	
	                if ((0, _apolloUtilities.isField)(selection)) {
	                  return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
	                    var _a;
	
	                    if (typeof fieldResult !== 'undefined') {
	                      resultsToMerge.push((_a = {}, _a[(0, _apolloUtilities.resultKeyNameFromField)(selection)] = fieldResult, _a));
	                    }
	                  })];
	                }
	
	                if ((0, _apolloUtilities.isInlineFragment)(selection)) {
	                  fragment = selection;
	                } else {
	                  fragment = fragmentMap[selection.name.value];
	                   true ? (0, _tsInvariant.invariant)(fragment, 7) : (0, _tsInvariant.invariant)(fragment, "No fragment named " + selection.name.value);
	                }
	
	                if (fragment && fragment.typeCondition) {
	                  typeCondition = fragment.typeCondition.name.value;
	
	                  if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
	                    return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
	                      resultsToMerge.push(fragmentResult);
	                    })];
	                  }
	                }
	
	                return [2];
	              });
	            });
	          };
	
	          return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
	            return (0, _apolloUtilities.mergeDeepArray)(resultsToMerge);
	          })];
	        });
	      });
	    };
	
	    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
	      return (0, _tslib.__awaiter)(this, void 0, void 0, function () {
	        var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
	
	        var _this = this;
	
	        return (0, _tslib.__generator)(this, function (_a) {
	          variables = execContext.variables;
	          fieldName = field.name.value;
	          aliasedFieldName = (0, _apolloUtilities.resultKeyNameFromField)(field);
	          aliasUsed = fieldName !== aliasedFieldName;
	          defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
	          resultPromise = Promise.resolve(defaultResult);
	
	          if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
	            resolverType = rootValue.__typename || execContext.defaultOperationType;
	            resolverMap = this.resolvers && this.resolvers[resolverType];
	
	            if (resolverMap) {
	              resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
	
	              if (resolve) {
	                resultPromise = Promise.resolve(resolve(rootValue, (0, _apolloUtilities.argumentsObjectFromField)(field, variables), execContext.context, {
	                  field: field,
	                  fragmentMap: execContext.fragmentMap
	                }));
	              }
	            }
	          }
	
	          return [2, resultPromise.then(function (result) {
	            if (result === void 0) {
	              result = defaultResult;
	            }
	
	            if (field.directives) {
	              field.directives.forEach(function (directive) {
	                if (directive.name.value === 'export' && directive.arguments) {
	                  directive.arguments.forEach(function (arg) {
	                    if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
	                      execContext.exportedVariables[arg.value.value] = result;
	                    }
	                  });
	                }
	              });
	            }
	
	            if (!field.selectionSet) {
	              return result;
	            }
	
	            if (result == null) {
	              return result;
	            }
	
	            if (Array.isArray(result)) {
	              return _this.resolveSubSelectedArray(field, result, execContext);
	            }
	
	            if (field.selectionSet) {
	              return _this.resolveSelectionSet(field.selectionSet, result, execContext);
	            }
	          })];
	        });
	      });
	    };
	
	    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
	      var _this = this;
	
	      return Promise.all(result.map(function (item) {
	        if (item === null) {
	          return null;
	        }
	
	        if (Array.isArray(item)) {
	          return _this.resolveSubSelectedArray(field, item, execContext);
	        }
	
	        if (field.selectionSet) {
	          return _this.resolveSelectionSet(field.selectionSet, item, execContext);
	        }
	      }));
	    };
	
	    return LocalState;
	  }();
	
	  function multiplex(inner) {
	    var observers = new Set();
	    var sub = null;
	    return new Observable(function (observer) {
	      observers.add(observer);
	      sub = sub || inner.subscribe({
	        next: function (value) {
	          observers.forEach(function (obs) {
	            return obs.next && obs.next(value);
	          });
	        },
	        error: function (error) {
	          observers.forEach(function (obs) {
	            return obs.error && obs.error(error);
	          });
	        },
	        complete: function () {
	          observers.forEach(function (obs) {
	            return obs.complete && obs.complete();
	          });
	        }
	      });
	      return function () {
	        if (observers.delete(observer) && !observers.size && sub) {
	          sub.unsubscribe();
	          sub = null;
	        }
	      };
	    });
	  }
	
	  function asyncMap(observable, mapFn) {
	    return new Observable(function (observer) {
	      var next = observer.next,
	          error = observer.error,
	          complete = observer.complete;
	      var activeNextCount = 0;
	      var completed = false;
	      var handler = {
	        next: function (value) {
	          ++activeNextCount;
	          new Promise(function (resolve) {
	            resolve(mapFn(value));
	          }).then(function (result) {
	            --activeNextCount;
	            next && next.call(observer, result);
	            completed && handler.complete();
	          }, function (e) {
	            --activeNextCount;
	            error && error.call(observer, e);
	          });
	        },
	        error: function (e) {
	          error && error.call(observer, e);
	        },
	        complete: function () {
	          completed = true;
	
	          if (!activeNextCount) {
	            complete && complete.call(observer);
	          }
	        }
	      };
	      var sub = observable.subscribe(handler);
	      return function () {
	        return sub.unsubscribe();
	      };
	    });
	  }
	
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  var QueryManager = function () {
	    function QueryManager(_a) {
	      var link = _a.link,
	          _b = _a.queryDeduplication,
	          queryDeduplication = _b === void 0 ? false : _b,
	          store = _a.store,
	          _c = _a.onBroadcast,
	          onBroadcast = _c === void 0 ? function () {
	        return undefined;
	      } : _c,
	          _d = _a.ssrMode,
	          ssrMode = _d === void 0 ? false : _d,
	          _e = _a.clientAwareness,
	          clientAwareness = _e === void 0 ? {} : _e,
	          localState = _a.localState,
	          assumeImmutableResults = _a.assumeImmutableResults;
	      this.mutationStore = new MutationStore();
	      this.queryStore = new QueryStore();
	      this.clientAwareness = {};
	      this.idCounter = 1;
	      this.queries = new Map();
	      this.fetchQueryRejectFns = new Map();
	      this.transformCache = new (_apolloUtilities.canUseWeakMap ? WeakMap : Map)();
	      this.inFlightLinkObservables = new Map();
	      this.pollingInfoByQueryId = new Map();
	      this.link = link;
	      this.queryDeduplication = queryDeduplication;
	      this.dataStore = store;
	      this.onBroadcast = onBroadcast;
	      this.clientAwareness = clientAwareness;
	      this.localState = localState || new LocalState({
	        cache: store.getCache()
	      });
	      this.ssrMode = ssrMode;
	      this.assumeImmutableResults = !!assumeImmutableResults;
	    }
	
	    QueryManager.prototype.stop = function () {
	      var _this = this;
	
	      this.queries.forEach(function (_info, queryId) {
	        _this.stopQueryNoBroadcast(queryId);
	      });
	      this.fetchQueryRejectFns.forEach(function (reject) {
	        reject( true ? new _tsInvariant.InvariantError(8) : new _tsInvariant.InvariantError('QueryManager stopped while query was in flight'));
	      });
	    };
	
	    QueryManager.prototype.mutate = function (_a) {
	      var mutation = _a.mutation,
	          variables = _a.variables,
	          optimisticResponse = _a.optimisticResponse,
	          updateQueriesByName = _a.updateQueries,
	          _b = _a.refetchQueries,
	          refetchQueries = _b === void 0 ? [] : _b,
	          _c = _a.awaitRefetchQueries,
	          awaitRefetchQueries = _c === void 0 ? false : _c,
	          updateWithProxyFn = _a.update,
	          _d = _a.errorPolicy,
	          errorPolicy = _d === void 0 ? 'none' : _d,
	          fetchPolicy = _a.fetchPolicy,
	          _e = _a.context,
	          context = _e === void 0 ? {} : _e;
	      return (0, _tslib.__awaiter)(this, void 0, void 0, function () {
	        var mutationId, generateUpdateQueriesInfo, self;
	
	        var _this = this;
	
	        return (0, _tslib.__generator)(this, function (_f) {
	          switch (_f.label) {
	            case 0:
	               true ? (0, _tsInvariant.invariant)(mutation, 9) : (0, _tsInvariant.invariant)(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.');
	               true ? (0, _tsInvariant.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10) : (0, _tsInvariant.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', "Mutations only support a 'no-cache' fetchPolicy. If you don't want to disable the cache, remove your fetchPolicy setting to proceed with the default mutation behavior.");
	              mutationId = this.generateQueryId();
	              mutation = this.transform(mutation).document;
	              this.setQuery(mutationId, function () {
	                return {
	                  document: mutation
	                };
	              });
	              variables = this.getVariables(mutation, variables);
	              if (!this.transform(mutation).hasClientExports) return [3, 2];
	              return [4, this.localState.addExportedVariables(mutation, variables, context)];
	
	            case 1:
	              variables = _f.sent();
	              _f.label = 2;
	
	            case 2:
	              generateUpdateQueriesInfo = function () {
	                var ret = {};
	
	                if (updateQueriesByName) {
	                  _this.queries.forEach(function (_a, queryId) {
	                    var observableQuery = _a.observableQuery;
	
	                    if (observableQuery) {
	                      var queryName = observableQuery.queryName;
	
	                      if (queryName && hasOwnProperty.call(updateQueriesByName, queryName)) {
	                        ret[queryId] = {
	                          updater: updateQueriesByName[queryName],
	                          query: _this.queryStore.get(queryId)
	                        };
	                      }
	                    }
	                  });
	                }
	
	                return ret;
	              };
	
	              this.mutationStore.initMutation(mutationId, mutation, variables);
	              this.dataStore.markMutationInit({
	                mutationId: mutationId,
	                document: mutation,
	                variables: variables,
	                updateQueries: generateUpdateQueriesInfo(),
	                update: updateWithProxyFn,
	                optimisticResponse: optimisticResponse
	              });
	              this.broadcastQueries();
	              self = this;
	              return [2, new Promise(function (resolve, reject) {
	                var storeResult;
	                var error;
	                self.getObservableFromLink(mutation, (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
	                  optimisticResponse: optimisticResponse
	                }), variables, false).subscribe({
	                  next: function (result) {
	                    if ((0, _apolloUtilities.graphQLResultHasError)(result) && errorPolicy === 'none') {
	                      error = new ApolloError({
	                        graphQLErrors: result.errors
	                      });
	                      return;
	                    }
	
	                    self.mutationStore.markMutationResult(mutationId);
	
	                    if (fetchPolicy !== 'no-cache') {
	                      self.dataStore.markMutationResult({
	                        mutationId: mutationId,
	                        result: result,
	                        document: mutation,
	                        variables: variables,
	                        updateQueries: generateUpdateQueriesInfo(),
	                        update: updateWithProxyFn
	                      });
	                    }
	
	                    storeResult = result;
	                  },
	                  error: function (err) {
	                    self.mutationStore.markMutationError(mutationId, err);
	                    self.dataStore.markMutationComplete({
	                      mutationId: mutationId,
	                      optimisticResponse: optimisticResponse
	                    });
	                    self.broadcastQueries();
	                    self.setQuery(mutationId, function () {
	                      return {
	                        document: null
	                      };
	                    });
	                    reject(new ApolloError({
	                      networkError: err
	                    }));
	                  },
	                  complete: function () {
	                    if (error) {
	                      self.mutationStore.markMutationError(mutationId, error);
	                    }
	
	                    self.dataStore.markMutationComplete({
	                      mutationId: mutationId,
	                      optimisticResponse: optimisticResponse
	                    });
	                    self.broadcastQueries();
	
	                    if (error) {
	                      reject(error);
	                      return;
	                    }
	
	                    if (typeof refetchQueries === 'function') {
	                      refetchQueries = refetchQueries(storeResult);
	                    }
	
	                    var refetchQueryPromises = [];
	
	                    if (isNonEmptyArray(refetchQueries)) {
	                      refetchQueries.forEach(function (refetchQuery) {
	                        if (typeof refetchQuery === 'string') {
	                          self.queries.forEach(function (_a) {
	                            var observableQuery = _a.observableQuery;
	
	                            if (observableQuery && observableQuery.queryName === refetchQuery) {
	                              refetchQueryPromises.push(observableQuery.refetch());
	                            }
	                          });
	                        } else {
	                          var queryOptions = {
	                            query: refetchQuery.query,
	                            variables: refetchQuery.variables,
	                            fetchPolicy: 'network-only'
	                          };
	
	                          if (refetchQuery.context) {
	                            queryOptions.context = refetchQuery.context;
	                          }
	
	                          refetchQueryPromises.push(self.query(queryOptions));
	                        }
	                      });
	                    }
	
	                    Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function () {
	                      self.setQuery(mutationId, function () {
	                        return {
	                          document: null
	                        };
	                      });
	
	                      if (errorPolicy === 'ignore' && storeResult && (0, _apolloUtilities.graphQLResultHasError)(storeResult)) {
	                        delete storeResult.errors;
	                      }
	
	                      resolve(storeResult);
	                    });
	                  }
	                });
	              })];
	          }
	        });
	      });
	    };
	
	    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, fetchMoreForQueryId) {
	      return (0, _tslib.__awaiter)(this, void 0, void 0, function () {
	        var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
	
	        var _this = this;
	
	        return (0, _tslib.__generator)(this, function (_e) {
	          switch (_e.label) {
	            case 0:
	              _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
	              query = this.transform(options.query).document;
	              variables = this.getVariables(query, options.variables);
	              if (!this.transform(query).hasClientExports) return [3, 2];
	              return [4, this.localState.addExportedVariables(query, variables, context)];
	
	            case 1:
	              variables = _e.sent();
	              _e.label = 2;
	
	            case 2:
	              options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
	                variables: variables
	              });
	              isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
	              needToFetch = isNetworkOnly;
	
	              if (!isNetworkOnly) {
	                _d = this.dataStore.getCache().diff({
	                  query: query,
	                  variables: variables,
	                  returnPartialData: true,
	                  optimistic: false
	                }), complete = _d.complete, result = _d.result;
	                needToFetch = !complete || fetchPolicy === 'cache-and-network';
	                storeResult = result;
	              }
	
	              shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
	              if ((0, _apolloUtilities.hasDirectives)(['live'], query)) shouldFetch = true;
	              requestId = this.idCounter++;
	              cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
	              this.setQuery(queryId, function () {
	                return {
	                  document: query,
	                  lastRequestId: requestId,
	                  invalidated: true,
	                  cancel: cancel
	                };
	              });
	              this.invalidate(fetchMoreForQueryId);
	              this.queryStore.initQuery({
	                queryId: queryId,
	                document: query,
	                storePreviousVariables: shouldFetch,
	                variables: variables,
	                isPoll: fetchType === FetchType.poll,
	                isRefetch: fetchType === FetchType.refetch,
	                metadata: metadata,
	                fetchMoreForQueryId: fetchMoreForQueryId
	              });
	              this.broadcastQueries();
	
	              if (shouldFetch) {
	                networkResult = this.fetchRequest({
	                  requestId: requestId,
	                  queryId: queryId,
	                  document: query,
	                  options: options,
	                  fetchMoreForQueryId: fetchMoreForQueryId
	                }).catch(function (error) {
	                  if (isApolloError(error)) {
	                    throw error;
	                  } else {
	                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
	                      _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
	
	                      _this.invalidate(queryId);
	
	                      _this.invalidate(fetchMoreForQueryId);
	
	                      _this.broadcastQueries();
	                    }
	
	                    throw new ApolloError({
	                      networkError: error
	                    });
	                  }
	                });
	
	                if (fetchPolicy !== 'cache-and-network') {
	                  return [2, networkResult];
	                }
	
	                networkResult.catch(function () {});
	              }
	
	              this.queryStore.markQueryResultClient(queryId, !shouldFetch);
	              this.invalidate(queryId);
	              this.invalidate(fetchMoreForQueryId);
	
	              if (this.transform(query).hasForcedResolvers) {
	                return [2, this.localState.runResolvers({
	                  document: query,
	                  remoteResult: {
	                    data: storeResult
	                  },
	                  context: context,
	                  variables: variables,
	                  onlyRunForcedResolvers: true
	                }).then(function (result) {
	                  _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
	
	                  _this.broadcastQueries();
	
	                  return result;
	                })];
	              }
	
	              this.broadcastQueries();
	              return [2, {
	                data: storeResult
	              }];
	          }
	        });
	      });
	    };
	
	    QueryManager.prototype.markQueryResult = function (queryId, result, _a, fetchMoreForQueryId) {
	      var fetchPolicy = _a.fetchPolicy,
	          variables = _a.variables,
	          errorPolicy = _a.errorPolicy;
	
	      if (fetchPolicy === 'no-cache') {
	        this.setQuery(queryId, function () {
	          return {
	            newData: {
	              result: result.data,
	              complete: true
	            }
	          };
	        });
	      } else {
	        this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
	      }
	    };
	
	    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
	      var _this = this;
	
	      function invoke(method, argument) {
	        if (observer[method]) {
	          try {
	            observer[method](argument);
	          } catch (e) {
	            ("production") === "production" || _tsInvariant.invariant.error(e);
	          }
	        } else if (method === 'error') {
	          ("production") === "production" || _tsInvariant.invariant.error(argument);
	        }
	      }
	
	      return function (queryStoreValue, newData) {
	        _this.invalidate(queryId, false);
	
	        if (!queryStoreValue) return;
	
	        var _a = _this.getQuery(queryId),
	            observableQuery = _a.observableQuery,
	            document = _a.document;
	
	        var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
	        if (fetchPolicy === 'standby') return;
	        var loading = isNetworkRequestInFlight(queryStoreValue.networkStatus);
	        var lastResult = observableQuery && observableQuery.getLastResult();
	        var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
	        var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
	
	        if (loading && !shouldNotifyIfLoading) {
	          return;
	        }
	
	        var hasGraphQLErrors = isNonEmptyArray(queryStoreValue.graphQLErrors);
	        var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
	
	        if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) {
	          return invoke('error', new ApolloError({
	            graphQLErrors: queryStoreValue.graphQLErrors,
	            networkError: queryStoreValue.networkError
	          }));
	        }
	
	        try {
	          var data = void 0;
	          var isMissing = void 0;
	
	          if (newData) {
	            if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') {
	              _this.setQuery(queryId, function () {
	                return {
	                  newData: null
	                };
	              });
	            }
	
	            data = newData.result;
	            isMissing = !newData.complete;
	          } else {
	            var lastError = observableQuery && observableQuery.getLastError();
	            var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
	
	            if (lastResult && lastResult.data && !errorStatusChanged) {
	              data = lastResult.data;
	              isMissing = false;
	            } else {
	              var diffResult = _this.dataStore.getCache().diff({
	                query: document,
	                variables: queryStoreValue.previousVariables || queryStoreValue.variables,
	                returnPartialData: true,
	                optimistic: true
	              });
	
	              data = diffResult.result;
	              isMissing = !diffResult.complete;
	            }
	          }
	
	          var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
	          var resultFromStore = {
	            data: stale ? lastResult && lastResult.data : data,
	            loading: loading,
	            networkStatus: queryStoreValue.networkStatus,
	            stale: stale
	          };
	
	          if (errorPolicy === 'all' && hasGraphQLErrors) {
	            resultFromStore.errors = queryStoreValue.graphQLErrors;
	          }
	
	          invoke('next', resultFromStore);
	        } catch (networkError) {
	          invoke('error', new ApolloError({
	            networkError: networkError
	          }));
	        }
	      };
	    };
	
	    QueryManager.prototype.transform = function (document) {
	      var transformCache = this.transformCache;
	
	      if (!transformCache.has(document)) {
	        var cache = this.dataStore.getCache();
	        var transformed = cache.transformDocument(document);
	        var forLink = (0, _apolloUtilities.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
	        var clientQuery = this.localState.clientQuery(transformed);
	        var serverQuery = this.localState.serverQuery(forLink);
	        var cacheEntry_1 = {
	          document: transformed,
	          hasClientExports: (0, _apolloUtilities.hasClientExports)(transformed),
	          hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
	          clientQuery: clientQuery,
	          serverQuery: serverQuery,
	          defaultVars: (0, _apolloUtilities.getDefaultValues)((0, _apolloUtilities.getOperationDefinition)(transformed))
	        };
	
	        var add = function (doc) {
	          if (doc && !transformCache.has(doc)) {
	            transformCache.set(doc, cacheEntry_1);
	          }
	        };
	
	        add(document);
	        add(transformed);
	        add(clientQuery);
	        add(serverQuery);
	      }
	
	      return transformCache.get(document);
	    };
	
	    QueryManager.prototype.getVariables = function (document, variables) {
	      return (0, _tslib.__assign)((0, _tslib.__assign)({}, this.transform(document).defaultVars), variables);
	    };
	
	    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
	      if (shouldSubscribe === void 0) {
	        shouldSubscribe = true;
	      }
	
	       true ? (0, _tsInvariant.invariant)(options.fetchPolicy !== 'standby', 11) : (0, _tsInvariant.invariant)(options.fetchPolicy !== 'standby', 'client.watchQuery cannot be called with fetchPolicy set to "standby"');
	      options.variables = this.getVariables(options.query, options.variables);
	
	      if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
	        options.notifyOnNetworkStatusChange = false;
	      }
	
	      var transformedOptions = (0, _tslib.__assign)({}, options);
	      return new ObservableQuery({
	        queryManager: this,
	        options: transformedOptions,
	        shouldSubscribe: shouldSubscribe
	      });
	    };
	
	    QueryManager.prototype.query = function (options) {
	      var _this = this;
	
	       true ? (0, _tsInvariant.invariant)(options.query, 12) : (0, _tsInvariant.invariant)(options.query, 'query option is required. You must specify your GraphQL document ' + 'in the query option.');
	       true ? (0, _tsInvariant.invariant)(options.query.kind === 'Document', 13) : (0, _tsInvariant.invariant)(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.');
	       true ? (0, _tsInvariant.invariant)(!options.returnPartialData, 14) : (0, _tsInvariant.invariant)(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.');
	       true ? (0, _tsInvariant.invariant)(!options.pollInterval, 15) : (0, _tsInvariant.invariant)(!options.pollInterval, 'pollInterval option only supported on watchQuery.');
	      return new Promise(function (resolve, reject) {
	        var watchedQuery = _this.watchQuery(options, false);
	
	        _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
	
	        watchedQuery.result().then(resolve, reject).then(function () {
	          return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
	        });
	      });
	    };
	
	    QueryManager.prototype.generateQueryId = function () {
	      return String(this.idCounter++);
	    };
	
	    QueryManager.prototype.stopQueryInStore = function (queryId) {
	      this.stopQueryInStoreNoBroadcast(queryId);
	      this.broadcastQueries();
	    };
	
	    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
	      this.stopPollingQuery(queryId);
	      this.queryStore.stopQuery(queryId);
	      this.invalidate(queryId);
	    };
	
	    QueryManager.prototype.addQueryListener = function (queryId, listener) {
	      this.setQuery(queryId, function (_a) {
	        var listeners = _a.listeners;
	        listeners.add(listener);
	        return {
	          invalidated: false
	        };
	      });
	    };
	
	    QueryManager.prototype.updateQueryWatch = function (queryId, document, options) {
	      var _this = this;
	
	      var cancel = this.getQuery(queryId).cancel;
	      if (cancel) cancel();
	
	      var previousResult = function () {
	        var previousResult = null;
	
	        var observableQuery = _this.getQuery(queryId).observableQuery;
	
	        if (observableQuery) {
	          var lastResult = observableQuery.getLastResult();
	
	          if (lastResult) {
	            previousResult = lastResult.data;
	          }
	        }
	
	        return previousResult;
	      };
	
	      return this.dataStore.getCache().watch({
	        query: document,
	        variables: options.variables,
	        optimistic: true,
	        previousResult: previousResult,
	        callback: function (newData) {
	          _this.setQuery(queryId, function () {
	            return {
	              invalidated: true,
	              newData: newData
	            };
	          });
	        }
	      });
	    };
	
	    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
	      this.setQuery(queryId, function () {
	        return {
	          observableQuery: observableQuery
	        };
	      });
	    };
	
	    QueryManager.prototype.removeObservableQuery = function (queryId) {
	      var cancel = this.getQuery(queryId).cancel;
	      this.setQuery(queryId, function () {
	        return {
	          observableQuery: null
	        };
	      });
	      if (cancel) cancel();
	    };
	
	    QueryManager.prototype.clearStore = function () {
	      this.fetchQueryRejectFns.forEach(function (reject) {
	        reject( true ? new _tsInvariant.InvariantError(16) : new _tsInvariant.InvariantError('Store reset while query was in flight (not completed in link chain)'));
	      });
	      var resetIds = [];
	      this.queries.forEach(function (_a, queryId) {
	        var observableQuery = _a.observableQuery;
	        if (observableQuery) resetIds.push(queryId);
	      });
	      this.queryStore.reset(resetIds);
	      this.mutationStore.reset();
	      return this.dataStore.reset();
	    };
	
	    QueryManager.prototype.resetStore = function () {
	      var _this = this;
	
	      return this.clearStore().then(function () {
	        return _this.reFetchObservableQueries();
	      });
	    };
	
	    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
	      var _this = this;
	
	      if (includeStandby === void 0) {
	        includeStandby = false;
	      }
	
	      var observableQueryPromises = [];
	      this.queries.forEach(function (_a, queryId) {
	        var observableQuery = _a.observableQuery;
	
	        if (observableQuery) {
	          var fetchPolicy = observableQuery.options.fetchPolicy;
	          observableQuery.resetLastResults();
	
	          if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) {
	            observableQueryPromises.push(observableQuery.refetch());
	          }
	
	          _this.setQuery(queryId, function () {
	            return {
	              newData: null
	            };
	          });
	
	          _this.invalidate(queryId);
	        }
	      });
	      this.broadcastQueries();
	      return Promise.all(observableQueryPromises);
	    };
	
	    QueryManager.prototype.observeQuery = function (queryId, options, observer) {
	      this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
	      return this.fetchQuery(queryId, options);
	    };
	
	    QueryManager.prototype.startQuery = function (queryId, options, listener) {
	      ("production") === "production" || _tsInvariant.invariant.warn("The QueryManager.startQuery method has been deprecated");
	      this.addQueryListener(queryId, listener);
	      this.fetchQuery(queryId, options).catch(function () {
	        return undefined;
	      });
	      return queryId;
	    };
	
	    QueryManager.prototype.startGraphQLSubscription = function (_a) {
	      var _this = this;
	
	      var query = _a.query,
	          fetchPolicy = _a.fetchPolicy,
	          variables = _a.variables;
	      query = this.transform(query).document;
	      variables = this.getVariables(query, variables);
	
	      var makeObservable = function (variables) {
	        return _this.getObservableFromLink(query, {}, variables, false).map(function (result) {
	          if (!fetchPolicy || fetchPolicy !== 'no-cache') {
	            _this.dataStore.markSubscriptionResult(result, query, variables);
	
	            _this.broadcastQueries();
	          }
	
	          if ((0, _apolloUtilities.graphQLResultHasError)(result)) {
	            throw new ApolloError({
	              graphQLErrors: result.errors
	            });
	          }
	
	          return result;
	        });
	      };
	
	      if (this.transform(query).hasClientExports) {
	        var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
	        return new Observable(function (observer) {
	          var sub = null;
	          observablePromise_1.then(function (observable) {
	            return sub = observable.subscribe(observer);
	          }, observer.error);
	          return function () {
	            return sub && sub.unsubscribe();
	          };
	        });
	      }
	
	      return makeObservable(variables);
	    };
	
	    QueryManager.prototype.stopQuery = function (queryId) {
	      this.stopQueryNoBroadcast(queryId);
	      this.broadcastQueries();
	    };
	
	    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
	      this.stopQueryInStoreNoBroadcast(queryId);
	      this.removeQuery(queryId);
	    };
	
	    QueryManager.prototype.removeQuery = function (queryId) {
	      this.fetchQueryRejectFns.delete("query:" + queryId);
	      this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
	      this.getQuery(queryId).subscriptions.forEach(function (x) {
	        return x.unsubscribe();
	      });
	      this.queries.delete(queryId);
	    };
	
	    QueryManager.prototype.getCurrentQueryResult = function (observableQuery, optimistic) {
	      if (optimistic === void 0) {
	        optimistic = true;
	      }
	
	      var _a = observableQuery.options,
	          variables = _a.variables,
	          query = _a.query,
	          fetchPolicy = _a.fetchPolicy,
	          returnPartialData = _a.returnPartialData;
	      var lastResult = observableQuery.getLastResult();
	      var newData = this.getQuery(observableQuery.queryId).newData;
	
	      if (newData && newData.complete) {
	        return {
	          data: newData.result,
	          partial: false
	        };
	      }
	
	      if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') {
	        return {
	          data: undefined,
	          partial: false
	        };
	      }
	
	      var _b = this.dataStore.getCache().diff({
	        query: query,
	        variables: variables,
	        previousResult: lastResult ? lastResult.data : undefined,
	        returnPartialData: true,
	        optimistic: optimistic
	      }),
	          result = _b.result,
	          complete = _b.complete;
	
	      return {
	        data: complete || returnPartialData ? result : void 0,
	        partial: !complete
	      };
	    };
	
	    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable) {
	      var observableQuery;
	
	      if (typeof queryIdOrObservable === 'string') {
	        var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
	         true ? (0, _tsInvariant.invariant)(foundObserveableQuery, 17) : (0, _tsInvariant.invariant)(foundObserveableQuery, "ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
	        observableQuery = foundObserveableQuery;
	      } else {
	        observableQuery = queryIdOrObservable;
	      }
	
	      var _a = observableQuery.options,
	          variables = _a.variables,
	          query = _a.query;
	      return {
	        previousResult: this.getCurrentQueryResult(observableQuery, false).data,
	        variables: variables,
	        document: query
	      };
	    };
	
	    QueryManager.prototype.broadcastQueries = function () {
	      var _this = this;
	
	      this.onBroadcast();
	      this.queries.forEach(function (info, id) {
	        if (info.invalidated) {
	          info.listeners.forEach(function (listener) {
	            if (listener) {
	              listener(_this.queryStore.get(id), info.newData);
	            }
	          });
	        }
	      });
	    };
	
	    QueryManager.prototype.getLocalState = function () {
	      return this.localState;
	    };
	
	    QueryManager.prototype.getObservableFromLink = function (query, context, variables, deduplication) {
	      var _this = this;
	
	      if (deduplication === void 0) {
	        deduplication = this.queryDeduplication;
	      }
	
	      var observable;
	      var serverQuery = this.transform(query).serverQuery;
	
	      if (serverQuery) {
	        var _a = this,
	            inFlightLinkObservables_1 = _a.inFlightLinkObservables,
	            link = _a.link;
	
	        var operation = {
	          query: serverQuery,
	          variables: variables,
	          operationName: (0, _apolloUtilities.getOperationName)(serverQuery) || void 0,
	          context: this.prepareContext((0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
	            forceFetch: !deduplication
	          }))
	        };
	        context = operation.context;
	
	        if (deduplication) {
	          var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
	          inFlightLinkObservables_1.set(serverQuery, byVariables_1);
	          var varJson_1 = JSON.stringify(variables);
	          observable = byVariables_1.get(varJson_1);
	
	          if (!observable) {
	            byVariables_1.set(varJson_1, observable = multiplex((0, _apolloLink.execute)(link, operation)));
	
	            var cleanup = function () {
	              byVariables_1.delete(varJson_1);
	              if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
	              cleanupSub_1.unsubscribe();
	            };
	
	            var cleanupSub_1 = observable.subscribe({
	              next: cleanup,
	              error: cleanup,
	              complete: cleanup
	            });
	          }
	        } else {
	          observable = multiplex((0, _apolloLink.execute)(link, operation));
	        }
	      } else {
	        observable = Observable.of({
	          data: {}
	        });
	        context = this.prepareContext(context);
	      }
	
	      var clientQuery = this.transform(query).clientQuery;
	
	      if (clientQuery) {
	        observable = asyncMap(observable, function (result) {
	          return _this.localState.runResolvers({
	            document: clientQuery,
	            remoteResult: result,
	            context: context,
	            variables: variables
	          });
	        });
	      }
	
	      return observable;
	    };
	
	    QueryManager.prototype.fetchRequest = function (_a) {
	      var _this = this;
	
	      var requestId = _a.requestId,
	          queryId = _a.queryId,
	          document = _a.document,
	          options = _a.options,
	          fetchMoreForQueryId = _a.fetchMoreForQueryId;
	      var variables = options.variables,
	          _b = options.errorPolicy,
	          errorPolicy = _b === void 0 ? 'none' : _b,
	          fetchPolicy = options.fetchPolicy;
	      var resultFromStore;
	      var errorsFromStore;
	      return new Promise(function (resolve, reject) {
	        var observable = _this.getObservableFromLink(document, options.context, variables);
	
	        var fqrfId = "fetchRequest:" + queryId;
	
	        _this.fetchQueryRejectFns.set(fqrfId, reject);
	
	        var cleanup = function () {
	          _this.fetchQueryRejectFns.delete(fqrfId);
	
	          _this.setQuery(queryId, function (_a) {
	            var subscriptions = _a.subscriptions;
	            subscriptions.delete(subscription);
	          });
	        };
	
	        var subscription = observable.map(function (result) {
	          if (requestId >= _this.getQuery(queryId).lastRequestId) {
	            _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
	
	            _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
	
	            _this.invalidate(queryId);
	
	            _this.invalidate(fetchMoreForQueryId);
	
	            _this.broadcastQueries();
	          }
	
	          if (errorPolicy === 'none' && isNonEmptyArray(result.errors)) {
	            return reject(new ApolloError({
	              graphQLErrors: result.errors
	            }));
	          }
	
	          if (errorPolicy === 'all') {
	            errorsFromStore = result.errors;
	          }
	
	          if (fetchMoreForQueryId || fetchPolicy === 'no-cache') {
	            resultFromStore = result.data;
	          } else {
	            var _a = _this.dataStore.getCache().diff({
	              variables: variables,
	              query: document,
	              optimistic: false,
	              returnPartialData: true
	            }),
	                result_1 = _a.result,
	                complete = _a.complete;
	
	            if (complete || options.returnPartialData) {
	              resultFromStore = result_1;
	            }
	          }
	        }).subscribe({
	          error: function (error) {
	            cleanup();
	            reject(error);
	          },
	          complete: function () {
	            cleanup();
	            resolve({
	              data: resultFromStore,
	              errors: errorsFromStore,
	              loading: false,
	              networkStatus: NetworkStatus.ready,
	              stale: false
	            });
	          }
	        });
	
	        _this.setQuery(queryId, function (_a) {
	          var subscriptions = _a.subscriptions;
	          subscriptions.add(subscription);
	        });
	      });
	    };
	
	    QueryManager.prototype.getQuery = function (queryId) {
	      return this.queries.get(queryId) || {
	        listeners: new Set(),
	        invalidated: false,
	        document: null,
	        newData: null,
	        lastRequestId: 1,
	        observableQuery: null,
	        subscriptions: new Set()
	      };
	    };
	
	    QueryManager.prototype.setQuery = function (queryId, updater) {
	      var prev = this.getQuery(queryId);
	      var newInfo = (0, _tslib.__assign)((0, _tslib.__assign)({}, prev), updater(prev));
	      this.queries.set(queryId, newInfo);
	    };
	
	    QueryManager.prototype.invalidate = function (queryId, invalidated) {
	      if (invalidated === void 0) {
	        invalidated = true;
	      }
	
	      if (queryId) {
	        this.setQuery(queryId, function () {
	          return {
	            invalidated: invalidated
	          };
	        });
	      }
	    };
	
	    QueryManager.prototype.prepareContext = function (context) {
	      if (context === void 0) {
	        context = {};
	      }
	
	      var newContext = this.localState.prepareContext(context);
	      return (0, _tslib.__assign)((0, _tslib.__assign)({}, newContext), {
	        clientAwareness: this.clientAwareness
	      });
	    };
	
	    QueryManager.prototype.checkInFlight = function (queryId) {
	      var query = this.queryStore.get(queryId);
	      return query && query.networkStatus !== NetworkStatus.ready && query.networkStatus !== NetworkStatus.error;
	    };
	
	    QueryManager.prototype.startPollingQuery = function (options, queryId, listener) {
	      var _this = this;
	
	      var pollInterval = options.pollInterval;
	       true ? (0, _tsInvariant.invariant)(pollInterval, 18) : (0, _tsInvariant.invariant)(pollInterval, 'Attempted to start a polling query without a polling interval.');
	
	      if (!this.ssrMode) {
	        var info = this.pollingInfoByQueryId.get(queryId);
	
	        if (!info) {
	          this.pollingInfoByQueryId.set(queryId, info = {});
	        }
	
	        info.interval = pollInterval;
	        info.options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
	          fetchPolicy: 'network-only'
	        });
	
	        var maybeFetch_1 = function () {
	          var info = _this.pollingInfoByQueryId.get(queryId);
	
	          if (info) {
	            if (_this.checkInFlight(queryId)) {
	              poll_1();
	            } else {
	              _this.fetchQuery(queryId, info.options, FetchType.poll).then(poll_1, poll_1);
	            }
	          }
	        };
	
	        var poll_1 = function () {
	          var info = _this.pollingInfoByQueryId.get(queryId);
	
	          if (info) {
	            clearTimeout(info.timeout);
	            info.timeout = setTimeout(maybeFetch_1, info.interval);
	          }
	        };
	
	        if (listener) {
	          this.addQueryListener(queryId, listener);
	        }
	
	        poll_1();
	      }
	
	      return queryId;
	    };
	
	    QueryManager.prototype.stopPollingQuery = function (queryId) {
	      this.pollingInfoByQueryId.delete(queryId);
	    };
	
	    return QueryManager;
	  }();
	
	  var DataStore = function () {
	    function DataStore(initialCache) {
	      this.cache = initialCache;
	    }
	
	    DataStore.prototype.getCache = function () {
	      return this.cache;
	    };
	
	    DataStore.prototype.markQueryResult = function (result, document, variables, fetchMoreForQueryId, ignoreErrors) {
	      if (ignoreErrors === void 0) {
	        ignoreErrors = false;
	      }
	
	      var writeWithErrors = !(0, _apolloUtilities.graphQLResultHasError)(result);
	
	      if (ignoreErrors && (0, _apolloUtilities.graphQLResultHasError)(result) && result.data) {
	        writeWithErrors = true;
	      }
	
	      if (!fetchMoreForQueryId && writeWithErrors) {
	        this.cache.write({
	          result: result.data,
	          dataId: 'ROOT_QUERY',
	          query: document,
	          variables: variables
	        });
	      }
	    };
	
	    DataStore.prototype.markSubscriptionResult = function (result, document, variables) {
	      if (!(0, _apolloUtilities.graphQLResultHasError)(result)) {
	        this.cache.write({
	          result: result.data,
	          dataId: 'ROOT_SUBSCRIPTION',
	          query: document,
	          variables: variables
	        });
	      }
	    };
	
	    DataStore.prototype.markMutationInit = function (mutation) {
	      var _this = this;
	
	      if (mutation.optimisticResponse) {
	        var optimistic_1;
	
	        if (typeof mutation.optimisticResponse === 'function') {
	          optimistic_1 = mutation.optimisticResponse(mutation.variables);
	        } else {
	          optimistic_1 = mutation.optimisticResponse;
	        }
	
	        this.cache.recordOptimisticTransaction(function (c) {
	          var orig = _this.cache;
	          _this.cache = c;
	
	          try {
	            _this.markMutationResult({
	              mutationId: mutation.mutationId,
	              result: {
	                data: optimistic_1
	              },
	              document: mutation.document,
	              variables: mutation.variables,
	              updateQueries: mutation.updateQueries,
	              update: mutation.update
	            });
	          } finally {
	            _this.cache = orig;
	          }
	        }, mutation.mutationId);
	      }
	    };
	
	    DataStore.prototype.markMutationResult = function (mutation) {
	      var _this = this;
	
	      if (!(0, _apolloUtilities.graphQLResultHasError)(mutation.result)) {
	        var cacheWrites_1 = [{
	          result: mutation.result.data,
	          dataId: 'ROOT_MUTATION',
	          query: mutation.document,
	          variables: mutation.variables
	        }];
	        var updateQueries_1 = mutation.updateQueries;
	
	        if (updateQueries_1) {
	          Object.keys(updateQueries_1).forEach(function (id) {
	            var _a = updateQueries_1[id],
	                query = _a.query,
	                updater = _a.updater;
	
	            var _b = _this.cache.diff({
	              query: query.document,
	              variables: query.variables,
	              returnPartialData: true,
	              optimistic: false
	            }),
	                currentQueryResult = _b.result,
	                complete = _b.complete;
	
	            if (complete) {
	              var nextQueryResult = (0, _apolloUtilities.tryFunctionOrLogError)(function () {
	                return updater(currentQueryResult, {
	                  mutationResult: mutation.result,
	                  queryName: (0, _apolloUtilities.getOperationName)(query.document) || undefined,
	                  queryVariables: query.variables
	                });
	              });
	
	              if (nextQueryResult) {
	                cacheWrites_1.push({
	                  result: nextQueryResult,
	                  dataId: 'ROOT_QUERY',
	                  query: query.document,
	                  variables: query.variables
	                });
	              }
	            }
	          });
	        }
	
	        this.cache.performTransaction(function (c) {
	          cacheWrites_1.forEach(function (write) {
	            return c.write(write);
	          });
	          var update = mutation.update;
	
	          if (update) {
	            (0, _apolloUtilities.tryFunctionOrLogError)(function () {
	              return update(c, mutation.result);
	            });
	          }
	        });
	      }
	    };
	
	    DataStore.prototype.markMutationComplete = function (_a) {
	      var mutationId = _a.mutationId,
	          optimisticResponse = _a.optimisticResponse;
	
	      if (optimisticResponse) {
	        this.cache.removeOptimistic(mutationId);
	      }
	    };
	
	    DataStore.prototype.markUpdateQueryResult = function (document, variables, newResult) {
	      this.cache.write({
	        result: newResult,
	        dataId: 'ROOT_QUERY',
	        variables: variables,
	        query: document
	      });
	    };
	
	    DataStore.prototype.reset = function () {
	      return this.cache.reset();
	    };
	
	    return DataStore;
	  }();
	
	  var version = "2.6.10";
	  var hasSuggestedDevtools = false;
	
	  var ApolloClient = function () {
	    function ApolloClient(options) {
	      var _this = this;
	
	      this.defaultOptions = {};
	      this.resetStoreCallbacks = [];
	      this.clearStoreCallbacks = [];
	      var cache = options.cache,
	          _a = options.ssrMode,
	          ssrMode = _a === void 0 ? false : _a,
	          _b = options.ssrForceFetchDelay,
	          ssrForceFetchDelay = _b === void 0 ? 0 : _b,
	          connectToDevTools = options.connectToDevTools,
	          _c = options.queryDeduplication,
	          queryDeduplication = _c === void 0 ? true : _c,
	          defaultOptions = options.defaultOptions,
	          _d = options.assumeImmutableResults,
	          assumeImmutableResults = _d === void 0 ? false : _d,
	          resolvers = options.resolvers,
	          typeDefs = options.typeDefs,
	          fragmentMatcher = options.fragmentMatcher,
	          clientAwarenessName = options.name,
	          clientAwarenessVersion = options.version;
	      var link = options.link;
	
	      if (!link && resolvers) {
	        link = _apolloLink.ApolloLink.empty();
	      }
	
	      if (!link || !cache) {
	        throw  true ? new _tsInvariant.InvariantError(4) : new _tsInvariant.InvariantError("In order to initialize Apollo Client, you must specify 'link' and 'cache' properties in the options object.\n" + "These options are part of the upgrade requirements when migrating from Apollo Client 1.x to Apollo Client 2.x.\n" + "For more information, please visit: https://www.apollographql.com/docs/tutorial/client.html#apollo-client-setup");
	      }
	
	      this.link = link;
	      this.cache = cache;
	      this.store = new DataStore(cache);
	      this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
	      this.queryDeduplication = queryDeduplication;
	      this.defaultOptions = defaultOptions || {};
	      this.typeDefs = typeDefs;
	
	      if (ssrForceFetchDelay) {
	        setTimeout(function () {
	          return _this.disableNetworkFetches = false;
	        }, ssrForceFetchDelay);
	      }
	
	      this.watchQuery = this.watchQuery.bind(this);
	      this.query = this.query.bind(this);
	      this.mutate = this.mutate.bind(this);
	      this.resetStore = this.resetStore.bind(this);
	      this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
	      var defaultConnectToDevTools = ("production") !== 'production' && typeof window !== 'undefined' && !window.__APOLLO_CLIENT__;
	
	      if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') {
	        window.__APOLLO_CLIENT__ = this;
	      }
	
	      if (!hasSuggestedDevtools && ("production") !== 'production') {
	        hasSuggestedDevtools = true;
	
	        if (typeof window !== 'undefined' && window.document && window.top === window.self) {
	          if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	            if (window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('Chrome') > -1) {
	              console.debug('Download the Apollo DevTools ' + 'for a better development experience: ' + 'https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm');
	            }
	          }
	        }
	      }
	
	      this.version = version;
	      this.localState = new LocalState({
	        cache: cache,
	        client: this,
	        resolvers: resolvers,
	        fragmentMatcher: fragmentMatcher
	      });
	      this.queryManager = new QueryManager({
	        link: this.link,
	        store: this.store,
	        queryDeduplication: queryDeduplication,
	        ssrMode: ssrMode,
	        clientAwareness: {
	          name: clientAwarenessName,
	          version: clientAwarenessVersion
	        },
	        localState: this.localState,
	        assumeImmutableResults: assumeImmutableResults,
	        onBroadcast: function () {
	          if (_this.devToolsHookCb) {
	            _this.devToolsHookCb({
	              action: {},
	              state: {
	                queries: _this.queryManager.queryStore.getStore(),
	                mutations: _this.queryManager.mutationStore.getStore()
	              },
	              dataWithOptimisticResults: _this.cache.extract(true)
	            });
	          }
	        }
	      });
	    }
	
	    ApolloClient.prototype.stop = function () {
	      this.queryManager.stop();
	    };
	
	    ApolloClient.prototype.watchQuery = function (options) {
	      if (this.defaultOptions.watchQuery) {
	        options = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.defaultOptions.watchQuery), options);
	      }
	
	      if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) {
	        options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
	          fetchPolicy: 'cache-first'
	        });
	      }
	
	      return this.queryManager.watchQuery(options);
	    };
	
	    ApolloClient.prototype.query = function (options) {
	      if (this.defaultOptions.query) {
	        options = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.defaultOptions.query), options);
	      }
	
	       true ? (0, _tsInvariant.invariant)(options.fetchPolicy !== 'cache-and-network', 5) : (0, _tsInvariant.invariant)(options.fetchPolicy !== 'cache-and-network', 'The cache-and-network fetchPolicy does not work with client.query, because ' + 'client.query can only return a single result. Please use client.watchQuery ' + 'to receive multiple results from the cache and the network, or consider ' + 'using a different fetchPolicy, such as cache-first or network-only.');
	
	      if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
	        options = (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
	          fetchPolicy: 'cache-first'
	        });
	      }
	
	      return this.queryManager.query(options);
	    };
	
	    ApolloClient.prototype.mutate = function (options) {
	      if (this.defaultOptions.mutate) {
	        options = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.defaultOptions.mutate), options);
	      }
	
	      return this.queryManager.mutate(options);
	    };
	
	    ApolloClient.prototype.subscribe = function (options) {
	      return this.queryManager.startGraphQLSubscription(options);
	    };
	
	    ApolloClient.prototype.readQuery = function (options, optimistic) {
	      if (optimistic === void 0) {
	        optimistic = false;
	      }
	
	      return this.cache.readQuery(options, optimistic);
	    };
	
	    ApolloClient.prototype.readFragment = function (options, optimistic) {
	      if (optimistic === void 0) {
	        optimistic = false;
	      }
	
	      return this.cache.readFragment(options, optimistic);
	    };
	
	    ApolloClient.prototype.writeQuery = function (options) {
	      var result = this.cache.writeQuery(options);
	      this.queryManager.broadcastQueries();
	      return result;
	    };
	
	    ApolloClient.prototype.writeFragment = function (options) {
	      var result = this.cache.writeFragment(options);
	      this.queryManager.broadcastQueries();
	      return result;
	    };
	
	    ApolloClient.prototype.writeData = function (options) {
	      var result = this.cache.writeData(options);
	      this.queryManager.broadcastQueries();
	      return result;
	    };
	
	    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
	      this.devToolsHookCb = cb;
	    };
	
	    ApolloClient.prototype.__requestRaw = function (payload) {
	      return (0, _apolloLink.execute)(this.link, payload);
	    };
	
	    ApolloClient.prototype.initQueryManager = function () {
	      ("production") === "production" || _tsInvariant.invariant.warn('Calling the initQueryManager method is no longer necessary, ' + 'and it will be removed from ApolloClient in version 3.0.');
	      return this.queryManager;
	    };
	
	    ApolloClient.prototype.resetStore = function () {
	      var _this = this;
	
	      return Promise.resolve().then(function () {
	        return _this.queryManager.clearStore();
	      }).then(function () {
	        return Promise.all(_this.resetStoreCallbacks.map(function (fn) {
	          return fn();
	        }));
	      }).then(function () {
	        return _this.reFetchObservableQueries();
	      });
	    };
	
	    ApolloClient.prototype.clearStore = function () {
	      var _this = this;
	
	      return Promise.resolve().then(function () {
	        return _this.queryManager.clearStore();
	      }).then(function () {
	        return Promise.all(_this.clearStoreCallbacks.map(function (fn) {
	          return fn();
	        }));
	      });
	    };
	
	    ApolloClient.prototype.onResetStore = function (cb) {
	      var _this = this;
	
	      this.resetStoreCallbacks.push(cb);
	      return function () {
	        _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) {
	          return c !== cb;
	        });
	      };
	    };
	
	    ApolloClient.prototype.onClearStore = function (cb) {
	      var _this = this;
	
	      this.clearStoreCallbacks.push(cb);
	      return function () {
	        _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) {
	          return c !== cb;
	        });
	      };
	    };
	
	    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
	      return this.queryManager.reFetchObservableQueries(includeStandby);
	    };
	
	    ApolloClient.prototype.extract = function (optimistic) {
	      return this.cache.extract(optimistic);
	    };
	
	    ApolloClient.prototype.restore = function (serializedState) {
	      return this.cache.restore(serializedState);
	    };
	
	    ApolloClient.prototype.addResolvers = function (resolvers) {
	      this.localState.addResolvers(resolvers);
	    };
	
	    ApolloClient.prototype.setResolvers = function (resolvers) {
	      this.localState.setResolvers(resolvers);
	    };
	
	    ApolloClient.prototype.getResolvers = function () {
	      return this.localState.getResolvers();
	    };
	
	    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
	      this.localState.setFragmentMatcher(fragmentMatcher);
	    };
	
	    return ApolloClient;
	  }();
	
	  _exports.ApolloClient = ApolloClient;
	  var _default = ApolloClient; 
	
	  _exports.default = _default;
	});


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(14);
	var zen_observable_ts_1 = tslib_1.__importDefault(__webpack_require__(155));
	var apollo_utilities_1 = __webpack_require__(89);
	exports.getOperationName = apollo_utilities_1.getOperationName;
	var ts_invariant_1 = __webpack_require__(31);
	function validateOperation(operation) {
	    var OPERATION_FIELDS = [
	        'query',
	        'operationName',
	        'variables',
	        'extensions',
	        'context',
	    ];
	    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
	        var key = _a[_i];
	        if (OPERATION_FIELDS.indexOf(key) < 0) {
	            throw new ts_invariant_1.InvariantError("illegal argument: " + key);
	        }
	    }
	    return operation;
	}
	exports.validateOperation = validateOperation;
	var LinkError = (function (_super) {
	    tslib_1.__extends(LinkError, _super);
	    function LinkError(message, link) {
	        var _this = _super.call(this, message) || this;
	        _this.link = link;
	        return _this;
	    }
	    return LinkError;
	}(Error));
	exports.LinkError = LinkError;
	function isTerminating(link) {
	    return link.request.length <= 1;
	}
	exports.isTerminating = isTerminating;
	function toPromise(observable) {
	    var completed = false;
	    return new Promise(function (resolve, reject) {
	        observable.subscribe({
	            next: function (data) {
	                if (completed) {
	                    ts_invariant_1.invariant.warn("Promise Wrapper does not support multiple results from Observable");
	                }
	                else {
	                    completed = true;
	                    resolve(data);
	                }
	            },
	            error: reject,
	        });
	    });
	}
	exports.toPromise = toPromise;
	exports.makePromise = toPromise;
	function fromPromise(promise) {
	    return new zen_observable_ts_1.default(function (observer) {
	        promise
	            .then(function (value) {
	            observer.next(value);
	            observer.complete();
	        })
	            .catch(observer.error.bind(observer));
	    });
	}
	exports.fromPromise = fromPromise;
	function fromError(errorValue) {
	    return new zen_observable_ts_1.default(function (observer) {
	        observer.error(errorValue);
	    });
	}
	exports.fromError = fromError;
	function transformOperation(operation) {
	    var transformedOperation = {
	        variables: operation.variables || {},
	        extensions: operation.extensions || {},
	        operationName: operation.operationName,
	        query: operation.query,
	    };
	    if (!transformedOperation.operationName) {
	        transformedOperation.operationName =
	            typeof transformedOperation.query !== 'string'
	                ? apollo_utilities_1.getOperationName(transformedOperation.query)
	                : '';
	    }
	    return transformedOperation;
	}
	exports.transformOperation = transformOperation;
	function createOperation(starting, operation) {
	    var context = tslib_1.__assign({}, starting);
	    var setContext = function (next) {
	        if (typeof next === 'function') {
	            context = tslib_1.__assign({}, context, next(context));
	        }
	        else {
	            context = tslib_1.__assign({}, context, next);
	        }
	    };
	    var getContext = function () { return (tslib_1.__assign({}, context)); };
	    Object.defineProperty(operation, 'setContext', {
	        enumerable: false,
	        value: setContext,
	    });
	    Object.defineProperty(operation, 'getContext', {
	        enumerable: false,
	        value: getContext,
	    });
	    Object.defineProperty(operation, 'toKey', {
	        enumerable: false,
	        value: function () { return getKey(operation); },
	    });
	    return operation;
	}
	exports.createOperation = createOperation;
	function getKey(operation) {
	    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
	    return JSON.stringify([operationName, query, variables]);
	}
	exports.getKey = getKey;
	//# sourceMappingURL=linkUtils.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Reach = __webpack_require__(501);
	var Merge = __webpack_require__(593);
	
	var _defaults = {
	  cardTypes: {
	    VISA: {
	      cardType: 'VISA',
	      cardPattern: /^4[0-9]{12}(?:[0-9]{3})?$/,
	      partialPattern: /^4/,
	      cvvPattern: /^\d{3}$/
	    },
	    MASTERCARD: {
	      cardType: 'MASTERCARD',
	      cardPattern: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[0-1][0-9]|2720)[0-9]{12}$/,
	      partialPattern: /^(?:5[1-5]|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[0-1][0-9]|2720)/,
	      cvvPattern: /^\d{3}$/
	    },
	    AMERICANEXPRESS: {
	      cardType: 'AMERICANEXPRESS',
	      cardPattern: /^3[47][0-9]{13}$/,
	      partialPattern: /^3[47]/,
	      cvvPattern: /^\d{4}$/
	    },
	    DINERSCLUB: {
	      cardType: 'DINERSCLUB',
	      cardPattern: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
	      partialPattern: /^3(0[0-5]|[68])/,
	      cvvPattern: /^\d{3}$/
	    },
	    DISCOVER: {
	      cardType: 'DISCOVER',
	      cardPattern: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
	      partialPattern: /^6(011|5[0-9])/,
	      cvvPattern: /^\d{3}$/
	    },
	    JCB: {
	      cardType: 'JCB',
	      cardPattern: /^(?:2131|1800|35\d{3})\d{11}$/,
	      partialPattern: /^(2131|1800|35)/,
	      cvvPattern: /^\d{3}$/
	    }
	  },
	  expiryMonths: {
	    min: 1,
	    max: 12
	  },
	  expiryYears: {
	    min: 1900,
	    max: 2200
	  },
	  schema: {
	    cardType: 'cardType',
	    number: 'number',
	    expiryMonth: 'expiryMonth',
	    expiryYear: 'expiryYear',
	    cvv: 'cvv'
	  }
	};
	
	// Setup Aliases
	_setupCardTypeAliases('VISA', ['vc', 'VC', 'visa']);
	_setupCardTypeAliases('MASTERCARD', ['mc', 'MC', 'mastercard', 'master card', 'MASTER CARD']);
	_setupCardTypeAliases('AMERICANEXPRESS', ['ae', 'AE', 'ax', 'AX', 'amex', 'AMEX', 'american express', 'AMERICAN EXPRESS']);
	_setupCardTypeAliases('DINERSCLUB', ['dinersclub']);
	_setupCardTypeAliases('DISCOVER', ['dc', 'DC', 'discover']);
	_setupCardTypeAliases('JCB', ['jcb']);
	
	// Store original defaults. This must happen after aliases are setup
	var _originalDefaults = Merge({}, _defaults);
	
	function validate(card, options) {
	  card = card || {};
	
	  var settings = Merge({}, _defaults, options);
	  var schema = settings.schema;
	  var cardType = Reach(card, schema.cardType);
	  var number = sanitizeNumberString(Reach(card, schema.number));
	  var expiryMonth = Reach(card, schema.expiryMonth);
	  var expiryYear = Reach(card, schema.expiryYear);
	  var cvv = sanitizeNumberString(Reach(card, schema.cvv));
	  var customValidationFn = settings.customValidation;
	  var customValidation = void 0;
	
	  // Optional custom validation
	  if (typeof customValidationFn === 'function') {
	    customValidation = customValidationFn(card, settings);
	  }
	
	  return {
	    card: card,
	    validCardNumber: isValidCardNumber(number, cardType, settings.cardTypes),
	    validExpiryMonth: isValidExpiryMonth(expiryMonth, settings.expiryMonths),
	    validExpiryYear: isValidExpiryYear(expiryYear, settings.expiryYears),
	    validCvv: doesCvvMatchType(cvv, cardType, settings.cardTypes),
	    isExpired: isExpired(expiryMonth, expiryYear),
	    customValidation: customValidation
	  };
	}
	
	function determineCardType(number, options) {
	  var settings = Merge({}, _defaults, options);
	  var cardTypes = settings.cardTypes;
	  var keys = Object.keys(cardTypes);
	
	  number = sanitizeNumberString(number);
	
	  for (var i = 0; i < keys.length; ++i) {
	    var key = keys[i];
	    var type = cardTypes[key];
	
	    if (type.cardPattern.test(number) || settings.allowPartial === true && type.partialPattern.test(number)) {
	      return type.cardType;
	    }
	  }
	
	  return null;
	}
	
	function isValidCardNumber(number, type, options) {
	  return doesNumberMatchType(number, type, options) && luhn(number);
	}
	
	function isValidExpiryMonth(month, options) {
	  var settings = Merge({}, _defaults.expiryMonths, options);
	
	  if (typeof month === 'string' && month.length > 2) {
	    return false;
	  }
	
	  month = ~~month;
	  return month >= settings.min && month <= settings.max;
	}
	
	function isValidExpiryYear(year, options) {
	  var settings = Merge({}, _defaults.expiryYears, options);
	
	  if (typeof year === 'string' && year.length !== 4) {
	    return false;
	  }
	
	  year = ~~year;
	  return year >= settings.min && year <= settings.max;
	}
	
	function doesNumberMatchType(number, type, options) {
	  var settings = Merge({}, _defaults.cardTypes, options);
	  var patterns = settings[type];
	
	  if (!patterns) {
	    return false;
	  }
	
	  return patterns.cardPattern.test(number);
	}
	
	function doesCvvMatchType(number, type, options) {
	  var settings = Merge({}, _defaults.cardTypes, options);
	  var patterns = settings[type];
	
	  if (!patterns) {
	    return false;
	  }
	
	  return patterns.cvvPattern.test(number);
	}
	
	function isExpired(month, year) {
	  month = ~~month;
	  year = ~~year;
	
	  // Cards are good until the end of the month
	  // http://stackoverflow.com/questions/54037/credit-card-expiration-dates-inclusive-or-exclusive
	  var expiration = new Date(year, month);
	
	  return Date.now() >= expiration;
	}
	
	function luhn(number) {
	  // Source - https://gist.github.com/DiegoSalazar/4075533
	
	  if (/[^\d]+/.test(number) || typeof number !== 'string' || !number) {
	    return false;
	  }
	
	  var nCheck = 0;
	  var bEven = false;
	  var nDigit = void 0;
	
	  for (var i = number.length - 1; i >= 0; --i) {
	    nDigit = ~~number.charAt(i);
	
	    if (bEven) {
	      if ((nDigit *= 2) > 9) {
	        nDigit -= 9;
	      }
	    }
	
	    nCheck += nDigit;
	    bEven = !bEven;
	  }
	
	  return nCheck % 10 === 0;
	}
	
	function sanitizeNumberString(number) {
	  if (typeof number !== 'string') {
	    return '';
	  }
	
	  return number.replace(/[^\d]/g, '');
	}
	
	function defaults(options, overwrite) {
	  options = options || {};
	
	  if (overwrite === true) {
	    _defaults = Merge({}, options);
	  } else {
	    _defaults = Merge({}, _defaults, options);
	  }
	
	  return _defaults;
	}
	
	function reset() {
	  _defaults = Merge({}, _originalDefaults);
	  return _defaults;
	}
	
	function _setupCardTypeAliases(type, aliases) {
	  for (var i = 0; i < aliases.length; ++i) {
	    _defaults.cardTypes[aliases[i]] = _defaults.cardTypes[type];
	  }
	}
	
	module.exports = {
	  validate: validate,
	  determineCardType: determineCardType,
	  isValidCardNumber: isValidCardNumber,
	  isValidExpiryMonth: isValidExpiryMonth,
	  isValidExpiryYear: isValidExpiryYear,
	  doesNumberMatchType: doesNumberMatchType,
	  doesCvvMatchType: doesCvvMatchType,
	  isExpired: isExpired,
	  luhn: luhn,
	  sanitizeNumberString: sanitizeNumberString,
	  defaults: defaults,
	  reset: reset
	};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CartRowPropTypes = exports.CartRow = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _cart = __webpack_require__(64);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CartRow = function CartRow(props) {
	  var price = props.modifiers.length === 0 ? _cart2.default.itemPrice(props) * props.quantity : _cart2.default.itemPrice(props);
	  return _react2.default.createElement(
	    'div',
	    { className: 'cartRow', 'data-cartId': props.cart_id },
	    _react2.default.createElement(
	      'div',
	      { className: 'cartRow__quantity' },
	      props.quantity + ' \xD7'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cartRow__description' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'cartRow__name' },
	        props.name
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'cartRow__modifiers' },
	        props.modifiers.map(function (mod) {
	          return mod.items.map(function (item) {
	            return _react2.default.createElement(
	              'p',
	              { className: 'cartRow__modifier' },
	              '+ ',
	              item.name
	            );
	          });
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'cartRow__price' },
	      _i18n2.default.formatPrice(price)
	    ),
	    props.onRemove && _react2.default.createElement(
	      'button',
	      {
	        className: 'cartRow__remove',
	        onClick: function onClick() {
	          return props.onRemove(props);
	        }
	      },
	      _react2.default.createElement('i', { className: 'bi_editorial-trash-l' })
	    ),
	    !props.onRemove && _react2.default.createElement('span', { className: 'cartRow__remove' })
	  );
	};
	
	var CartRowPropTypes = {
	  cart_id: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  price: _propTypes2.default.number,
	  modifiers: _propTypes2.default.array,
	  onRemove: _propTypes2.default.func
	};
	
	CartRow.propTypes = CartRowPropTypes;
	
	exports.CartRow = CartRow;
	exports.CartRowPropTypes = CartRowPropTypes;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Cart = exports.CartTotal = exports.CartRowPropTypes = exports.CartRow = undefined;
	
	__webpack_require__(769);
	
	var _cartRow = __webpack_require__(209);
	
	var _cartTotal = __webpack_require__(119);
	
	var _cartTotal2 = _interopRequireDefault(_cartTotal);
	
	var _cart = __webpack_require__(449);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CartRow = _cartRow.CartRow;
	exports.CartRowPropTypes = _cartRow.CartRowPropTypes;
	exports.CartTotal = _cartTotal2.default;
	exports.Cart = _cart2.default;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _spinner = __webpack_require__(53);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoadingContainer = function (_React$Component) {
	  _inherits(LoadingContainer, _React$Component);
	
	  function LoadingContainer() {
	    _classCallCheck(this, LoadingContainer);
	
	    return _possibleConstructorReturn(this, (LoadingContainer.__proto__ || Object.getPrototypeOf(LoadingContainer)).apply(this, arguments));
	  }
	
	  _createClass(LoadingContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch({
	        type: 'route.mounted',
	        route: this.props.route
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.isLoading) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'loadingContainer is-loading' },
	          _react2.default.createElement(_spinner2.default, { size: 'large' })
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'loadingContainer is-loaded' },
	        this.props.children
	      );
	    }
	  }]);
	
	  return LoadingContainer;
	}(_react2.default.Component);
	
	LoadingContainer.propTypes = {
	  isLoading: _propTypes2.default.bool,
	  route: _propTypes2.default.string,
	  dispatch: _propTypes2.default.func
	};
	LoadingContainer.defaultProps = {
	  isLoading: false
	};
	
	exports.default = LoadingContainer;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _listItem = __webpack_require__(452);
	
	var _listItem2 = _interopRequireDefault(_listItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RestaurantRow = function RestaurantRow(_ref) {
	  var restaurant = _ref.restaurant,
	      href = _ref.href,
	      availability = _ref.availability;
	
	  return _react2.default.createElement(
	    _listItem2.default,
	    {
	      disabled: !availability,
	      to: href + '/' + restaurant.id,
	      title: restaurant.name
	    },
	    _react2.default.createElement(
	      'p',
	      null,
	      restaurant.address,
	      ', ',
	      restaurant.city
	    ),
	    !availability && _react2.default.createElement(
	      'div',
	      { className: 'not-available' },
	      'Ora non disponibile'
	    )
	  );
	};
	
	RestaurantRow.propTypes = {
	  restaurant: _propTypes2.default.shape({
	    name: _propTypes2.default.string,
	    address: _propTypes2.default.string,
	    city: _propTypes2.default.string
	  }),
	  availability: _propTypes2.default.bool,
	  href: _propTypes2.default.string
	};
	
	RestaurantRow.defaultProps = {
	  availability: true
	};
	
	exports.default = RestaurantRow;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ristorantiFrontendLib = __webpack_require__(23);
	
	var _time = __webpack_require__(20);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _localized = __webpack_require__(43);
	
	var _util = __webpack_require__(11);
	
	var _spinner = __webpack_require__(53);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _formWrapper = __webpack_require__(66);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	var _buttonsContainer = __webpack_require__(21);
	
	var _buttonsContainer2 = _interopRequireDefault(_buttonsContainer);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global location */
	
	
	var privacyLabel = _react2.default.createElement(
	  'span',
	  null,
	  'Accetto le ',
	  _react2.default.createElement(
	    'a',
	    { href: 'https://ristoranti.it/privacy', target: '_blank' },
	    'condizioni d\'uso e il trattamento dati'
	  )
	);
	
	var BookingForm = function (_React$Component) {
	  _inherits(BookingForm, _React$Component);
	
	  function BookingForm(props) {
	    _classCallCheck(this, BookingForm);
	
	    var _this = _possibleConstructorReturn(this, (BookingForm.__proto__ || Object.getPrototypeOf(BookingForm)).call(this, props));
	
	    var config = [{
	      label: 'Nome',
	      name: 'name',
	      format: 'string',
	      placeholder: 'Nome',
	      initialValue: '',
	      isRequired: true
	    }, {
	      label: 'Cognome',
	      name: 'lastName',
	      format: 'string',
	      placeholder: 'Cognome',
	      initialValue: '',
	      isRequired: true
	    }, {
	      label: 'E-mail',
	      name: 'email',
	      format: 'email',
	      placeholder: 'E-mail',
	      initialValue: '',
	      isRequired: true
	    }, {
	      label: 'Numero di Telefono',
	      name: 'phoneNumber',
	      format: 'phoneNumber',
	      placeholder: 'Telefono',
	      initialValue: '',
	      isRequired: true
	    }, {
	      label: 'Note',
	      name: 'extraInfo',
	      format: 'text',
	      placeholder: 'Richieste aggiuntive',
	      initialValue: '',
	      isRequired: false
	    }, {
	      rightLabel: privacyLabel,
	      name: 'privacy',
	      type: 'checkbox',
	      initialValue: '',
	      format: 'boolean'
	    }];
	    // prefill data from current user
	    if (props.user.currentUser) {
	      _this.formConfig = config.reduce(function (acc, field) {
	        return [].concat(_toConsumableArray(acc), [_extends({}, field, {
	          initialValue: props.user.currentUser[field.name] || ''
	        })]);
	      }, []);
	    } else {
	      _this.formConfig = config;
	    }
	    _this.save = _this.save.bind(_this);
	    return _this;
	  }
	
	  _createClass(BookingForm, [{
	    key: 'save',
	    value: function save(formValue) {
	      var _props = this.props,
	          app = _props.app,
	          booking = _props.booking,
	          actions = _props.actions;
	
	
	      var targetRestaurant = this.props.routeParams.restaurantId;
	      var data = {
	        app: app.id,
	        availabilitySlot: booking.time,
	        date: booking.date.date,
	        name: formValue.name,
	        lastName: formValue.lastName,
	        phoneNumber: formValue.phoneNumber,
	        extraInfo: formValue.extraInfo,
	        email: formValue.email,
	        people: booking.seats,
	        restaurant: targetRestaurant,
	        type: booking.verifiedBookingRush ? 'BOOKING_RUSH' : 'STANDARD',
	        source: location.hostname,
	        sourceType: 'WEB'
	      };
	
	      if (booking.hasBookingRushes) {
	        data.bookingRush = app.bookingRush.id;
	      }
	
	      var fragment = 'id status date people availabilitySlot { open }';
	      this.props.services.booking.createRequest(data, fragment, actions.booking);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          booking = _props2.booking,
	          app = _props2.app;
	
	      var targetRestaurant = this.props.routeParams.restaurantId;
	      var restaurant = (0, _ristorantiFrontendLib.restaurantById)(app.merchant.restaurants, targetRestaurant);
	
	      if (booking.isFetching || booking.createdRequest.id) {
	        return _react2.default.createElement(
	          'main',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'paymentContainer container--loading' },
	            _react2.default.createElement(_spinner2.default, { size: 'large', text: 'Prenotazione in corso...' })
	          )
	        );
	      }
	
	      var locale = 'it';
	      var day = _time2.default.weekDayLocale(booking.date.date, locale);
	      var date = _time2.default.toLocalDate(booking.date.date, locale);
	      return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(
	          'p',
	          { className: 'booking-info' },
	          'Prenotazione per ',
	          _react2.default.createElement(
	            'strong',
	            null,
	            day,
	            ' ',
	            date
	          ),
	          ' alle ',
	          booking.time,
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'strong',
	            null,
	            restaurant.name
	          ),
	          ' \u2013 ',
	          restaurant.address,
	          _react2.default.createElement('br', null),
	          booking.seats,
	          ' persone'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Inserisci i tuoi dati per completare la prenotazione'
	        ),
	        _react2.default.createElement(_formWrapper2.default, {
	          config: this.formConfig,
	          onValidSave: this.save,
	          submitButtonLabel: 'PRENOTA'
	        }),
	        _react2.default.createElement(
	          _buttonsContainer2.default,
	          null,
	          _react2.default.createElement(_backButton2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return BookingForm;
	}(_react2.default.Component);
	
	var connectOptions = {
	  mapStateToProps: function mapStateToProps(state, props) {
	    return _extends({}, state, {
	      currentSlot: (0, _ristorantiFrontendLib.currentSlotSelector)(state, props),
	      maxPeople: (0, _ristorantiFrontendLib.maxPeopleSelector)(state, props),
	      pickerSeats: (0, _ristorantiFrontendLib.pickerSeatsSelector)(state, props),
	      pickerTime: (0, _ristorantiFrontendLib.pickerTimeSelector)(_localized.COMMON_LOCALIZED)(state, props),
	      slotsAvailable: (0, _ristorantiFrontendLib.slotsAvailableSelector)(state),
	      formData: (0, _ristorantiFrontendLib.formDataSelector)(state)
	    });
	  }
	};
	
	exports.default = (0, _util.connect)(BookingForm, connectOptions);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _location = __webpack_require__(50);
	
	var _location2 = _interopRequireDefault(_location);
	
	var _user = __webpack_require__(116);
	
	var _util = __webpack_require__(11);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _boxedItem = __webpack_require__(65);
	
	var _boxedItem2 = _interopRequireDefault(_boxedItem);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _buttonsContainer = __webpack_require__(21);
	
	var _buttonsContainer2 = _interopRequireDefault(_buttonsContainer);
	
	var _env = __webpack_require__(92);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global navigator */
	/* global alert */
	
	
	var OrderDelivery = function (_React$Component) {
	  _inherits(OrderDelivery, _React$Component);
	
	  function OrderDelivery(props) {
	    _classCallCheck(this, OrderDelivery);
	
	    var _this = _possibleConstructorReturn(this, (OrderDelivery.__proto__ || Object.getPrototypeOf(OrderDelivery)).call(this, props));
	
	    _this.checkUserLocation = _this.checkUserLocation.bind(_this);
	    _this.setDeliveryAddress = _this.setDeliveryAddress.bind(_this);
	    _this.onLocationError = _this.onLocationError.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderDelivery, [{
	    key: 'onLocationError',
	    value: function onLocationError(e) {
	      console.warn(e);
	      this.props.actions.ux.setIsGettingUserLocation(false);
	      this.props.actions.ux.setMessage({
	        title: 'Attenzione',
	        text: 'Impossibile ottenere la posizione corrente'
	      });
	    }
	  }, {
	    key: 'setDeliveryAddress',
	    value: function setDeliveryAddress(data) {
	      var _data$location = data.location,
	          lat = _data$location.lat,
	          lng = _data$location.lng;
	
	      var description = _location2.default.formatAddressDescription(data.address);
	      var location = _location2.default.deliveryAddressFactory(description, lat, lng, data.address);
	      this.props.services.order.deliveryAddressCheck(this.props.app.id, location, this.props.actions.order);
	      this.props.actions.order.setDeliveryAddress(location);
	
	      // reload order if we're using an address from previuos order
	      if (data.id) {
	        this.props.actions.order.reloadOrder(data);
	      }
	    }
	  }, {
	    key: 'checkUserLocation',
	    value: function checkUserLocation() {
	      var _this2 = this;
	
	      this.props.actions.ux.setIsGettingUserLocation(true);
	      navigator.geolocation.getCurrentPosition(function (position) {
	        (0, _location.setApiKey)(_env.GOOGLE_API_KEY);
	        _location2.default.addressFromCoordinates(position.coords.latitude, position.coords.longitude).then(function (o) {
	          var data = {
	            location: o.data.address.location.geometry.location,
	            address: o.data.address.components
	          };
	          _this2.props.actions.ux.setIsGettingUserLocation(false);
	          _this2.setDeliveryAddress(data);
	        }).catch(_this2.onLocationError);
	      }, this.onLocationError);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var appId = this.props.url.appId;
	      return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'orderDeliveryContainer' },
	          _react2.default.createElement(
	            'header',
	            null,
	            _react2.default.createElement(
	              'h4',
	              { className: 'viewTitle' },
	              'Consegna a domicilio'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Seleziona l\'indirizzo di consegna'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_boxedItem2.default, {
	              title: 'Posizione corrente',
	              subtitle: 'Consegna qui!',
	              icon: 'bi_location-pin',
	              isLoading: this.props.ux.isGettingCurrenUserPosition,
	              onClick: this.checkUserLocation
	            }),
	            _react2.default.createElement(_boxedItem2.default, {
	              title: 'Inserisci nuovo indirizzo',
	              icon: 'bi_location-pin-plus',
	              onClick: function onClick() {
	                return _reactRouter.browserHistory.push(_url2.default.orderDeliveryAddress(appId));
	              }
	            })
	          ),
	          this.props.lastOrders.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'lastOrders' },
	            this.props.lastOrders.map(function (order) {
	              return _react2.default.createElement(_boxedItem2.default, {
	                key: order.id,
	                title: order.address.route + ', ' + order.address.street_number + ', ' + order.address.city,
	                subtitle: order.address.citofono,
	                icon: 'bi_location-pin',
	                onClick: function onClick() {
	                  return _this3.setDeliveryAddress(order);
	                }
	              });
	            })
	          ),
	          _react2.default.createElement(
	            _buttonsContainer2.default,
	            null,
	            _react2.default.createElement(_backButton2.default, null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrderDelivery;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return _extends({}, state, {
	    lastOrders: (0, _user.lastOrdersSelector)(state, props)
	  });
	};
	exports.default = (0, _util.connect)(OrderDelivery, { mapStateToProps: mapStateToProps });

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ristorantiFrontendLib = __webpack_require__(23);
	
	var _list = __webpack_require__(122);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _restaurantRow = __webpack_require__(212);
	
	var _restaurantRow2 = _interopRequireDefault(_restaurantRow);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _buttonsContainer = __webpack_require__(21);
	
	var _buttonsContainer2 = _interopRequireDefault(_buttonsContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderTakeAway = function OrderTakeAway(props) {
	  var restaurants = props.app.merchant.restaurants;
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'Scegli il ristorante presso il quale vuoi ordinare'
	    ),
	    _react2.default.createElement(
	      _list2.default,
	      null,
	      restaurants.map(function (res) {
	        return _react2.default.createElement(_restaurantRow2.default, {
	          key: res.id,
	          restaurant: res,
	          availability: _ristorantiFrontendLib.RestaurantHelpers.hasOnlineService(res, 'takeAway'),
	          href: _url2.default.orderTakeAway(props.url.appId)
	        });
	      })
	    ),
	    _react2.default.createElement(
	      _buttonsContainer2.default,
	      null,
	      _react2.default.createElement(_backButton2.default, { to: _url2.default.order(props.url.appId) })
	    )
	  );
	};
	
	exports.default = OrderTakeAway;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _util = __webpack_require__(11);
	
	var _device = __webpack_require__(218);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _signinForm = __webpack_require__(492);
	
	var _signinForm2 = _interopRequireDefault(_signinForm);
	
	var _signupForm = __webpack_require__(494);
	
	var _signupForm2 = _interopRequireDefault(_signupForm);
	
	var _spinner = __webpack_require__(53);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _fbLoginButton = __webpack_require__(451);
	
	var _fbLoginButton2 = _interopRequireDefault(_fbLoginButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SigninSignup = function (_React$Component) {
	  _inherits(SigninSignup, _React$Component);
	
	  function SigninSignup(props) {
	    _classCallCheck(this, SigninSignup);
	
	    var _this = _possibleConstructorReturn(this, (SigninSignup.__proto__ || Object.getPrototypeOf(SigninSignup)).call(this, props));
	
	    _this.state = {
	      showSignupForm: true
	    };
	    _this.login = _this.login.bind(_this);
	    _this.signup = _this.signup.bind(_this);
	    _this.switchMode = _this.switchMode.bind(_this);
	    _this.onFacebookLogin = _this.onFacebookLogin.bind(_this);
	    return _this;
	  }
	
	  _createClass(SigninSignup, [{
	    key: 'signup',
	    value: function signup(signupData) {
	      this.props.actions.user.registerStart();
	      this.props.services.user.register(_extends({}, signupData, {
	        app: this.props.app.id,
	        device: _device2.default.UUID()
	      }), 'id name lastName email accessToken', this.props.actions.user, {});
	    }
	  }, {
	    key: 'onFacebookLogin',
	    value: function onFacebookLogin(token) {
	
	      var data = {
	        app: this.props.app.id,
	        fbAccessToken: token,
	        device: _device2.default.UUID()
	      };
	      var fragment = 'id name lastName email accessToken facebookId';
	      this.props.services.user.facebookLogin(data, fragment, this.props.actions.user, {});
	    }
	  }, {
	    key: 'login',
	    value: function login(loginData) {
	      var data = _extends({}, loginData, {
	        app: this.props.app.id,
	        device: _device2.default.UUID()
	      });
	
	      this.props.services.user.authenticate(data, 'id name lastName email accessToken facebookId', this.props.actions.user, {});
	    }
	  }, {
	    key: 'switchMode',
	    value: function switchMode() {
	      this.setState({ showSignupForm: !this.state.showSignupForm });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.user.isFetching || this.props.app.isFetching) {
	        return _react2.default.createElement(
	          'main',
	          { className: 'userContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container--loading' },
	            _react2.default.createElement(_spinner2.default, { size: 'large' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'main',
	        { className: 'userContainer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'signinSignup' },
	          _react2.default.createElement(
	            'header',
	            null,
	            _react2.default.createElement(
	              'h4',
	              { className: 'viewTitle' },
	              'Ci siamo quasi!'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Per completare il tuo ordine, devi prima effettuare l\'accesso.'
	            )
	          ),
	          this.state.showSignupForm && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_signupForm2.default, {
	              onSave: this.signup,
	              onCancel: this.switchMode
	            })
	          ),
	          !this.state.showSignupForm && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_signinForm2.default, {
	              onSave: this.login,
	              onCancel: this.switchMode
	            })
	          ),
	          _react2.default.createElement(_fbLoginButton2.default, { user: {}, onLogin: this.onFacebookLogin }),
	          _react2.default.createElement(
	            'a',
	            {
	              href: 'https://account.ristoranti.it/' + this.props.app.id.replace(/^app-/, '') + '/reset-password',
	              target: '_blank',
	              style: {
	                display: 'block',
	                textAlign: 'center',
	                padding: '0 1em',
	                fontSize: '0.8em'
	              }
	            },
	            'Ho dimenticato la password'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SigninSignup;
	}(_react2.default.Component);
	
	SigninSignup.propTypes = {
	  app: _propTypes2.default.shape({
	    id: _propTypes2.default.string,
	    isFetching: _propTypes2.default.bool
	  }),
	  user: _propTypes2.default.shape({
	    currentUser: _propTypes2.default.shape({}),
	    isFetching: _propTypes2.default.bool
	  })
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    app: state.app,
	    user: state.user
	  };
	};
	
	exports.default = (0, _util.connect)(SigninSignup, { mapStateToProps: mapStateToProps });

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _signinSignup = __webpack_require__(216);
	
	var _signinSignup2 = _interopRequireDefault(_signinSignup);
	
	var _util = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserRequiredComponent = function UserRequiredComponent(props) {
	  var WrappedComponent = props.component;
	  if (!props.user.currentUser) {
	    return _react2.default.createElement(_signinSignup2.default, null);
	  }
	  return _react2.default.createElement(WrappedComponent, props);
	};
	
	UserRequiredComponent.propTypes = {
	  component: _propTypes2.default.func,
	  user: _propTypes2.default.shape({
	    currentUser: _propTypes2.default.object
	  })
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    user: state.user,
	    app: state.app
	  };
	};
	
	var userRequired = function userRequired(WrappedComponent) {
	  return (0, _util.connect)(UserRequiredComponent, { mapStateToProps: mapStateToProps }, { component: WrappedComponent });
	};
	
	exports.default = userRequired;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* global localStorage */
	var DEVICE_KEY = 'RISTORANTI.IT@@@DEVICE_UUID';
	
	var UUID = function UUID() {
	  var current = localStorage.getItem(DEVICE_KEY);
	  if (current) return current;
	
	  // generate new UUID
	  var newUUID = 'widget_' + Math.random().toString(16);
	  localStorage.setItem(DEVICE_KEY, newUUID);
	  return newUUID;
	};
	
	exports.default = {
	  UUID: UUID
	};

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = __webpack_require__(8);
	var getKeys = __webpack_require__(44).keys;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function catchFilter(instances, cb, promise) {
	    return function(e) {
	        var boundTo = promise._boundValue();
	        predicateLoop: for (var i = 0; i < instances.length; ++i) {
	            var item = instances[i];
	
	            if (item === Error ||
	                (item != null && item.prototype instanceof Error)) {
	                if (e instanceof item) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (typeof item === "function") {
	                var matchesPredicate = tryCatch(item).call(boundTo, e);
	                if (matchesPredicate === errorObj) {
	                    return matchesPredicate;
	                } else if (matchesPredicate) {
	                    return tryCatch(cb).call(boundTo, e);
	                }
	            } else if (util.isObject(e)) {
	                var keys = getKeys(item);
	                for (var j = 0; j < keys.length; ++j) {
	                    var key = keys[j];
	                    if (item[key] != e[key]) {
	                        continue predicateLoop;
	                    }
	                }
	                return tryCatch(cb).call(boundTo, e);
	            }
	        }
	        return NEXT_FILTER;
	    };
	}
	
	return catchFilter;
	};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(8);
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = __webpack_require__(36);
	var OperationalError = errors.OperationalError;
	var es5 = __webpack_require__(44);
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise, multiArgs) {
	    return function(err, value) {
	        if (promise === null) return;
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (!multiArgs) {
	            promise._fulfill(value);
	        } else {
	            var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	            promise._fulfill(args);
	        }
	        promise = null;
	    };
	}
	
	module.exports = nodebackForPromise;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(40)
	var noCase = __webpack_require__(30)
	
	/**
	 * Camel case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale, mergeNumbers) {
	  var result = noCase(value, locale)
	
	  // Replace periods between numeric entities with an underscore.
	  if (!mergeNumbers) {
	    result = result.replace(/ (?=\d)/g, '_')
	  }
	
	  // Replace spaces between words with an upper cased character.
	  return result.replace(/ (.)/g, function (m, $1) {
	    return upperCase($1, locale)
	  })
	}


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(533);
	
	var emptyObject = __webpack_require__(228);
	var _invariant = __webpack_require__(69);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 223 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = offsetParent;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(55));
	
	var _style = _interopRequireDefault(__webpack_require__(127));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = camelizeStyleName;
	
	var _camelize = _interopRequireDefault(__webpack_require__(555));
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	 */
	var msPattern = /^-ms-/;
	
	function camelizeStyleName(string) {
	  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(46));
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	/* https://github.com/component/raf */
	
	
	var prev = new Date().getTime();
	
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	
	var _default = compatRaf;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(factory());
	}(this, (function () { 'use strict';
	
	var parser = __webpack_require__(570);
	
	var parse = parser.parse;
	
	// Strip insignificant whitespace
	// Note that this could do a lot more, such as reorder fields etc.
	function normalize(string) {
	  return string.replace(/[\s,]+/g, ' ').trim();
	}
	
	// A map docString -> graphql document
	var docCache = {};
	
	// A map fragmentName -> [normalized source]
	var fragmentSourceMap = {};
	
	function cacheKeyFromLoc(loc) {
	  return normalize(loc.source.body.substring(loc.start, loc.end));
	}
	
	// For testing.
	function resetCaches() {
	  docCache = {};
	  fragmentSourceMap = {};
	}
	
	// Take a unstripped parsed document (query/mutation or even fragment), and
	// check all fragment definitions, checking for name->source uniqueness.
	// We also want to make sure only unique fragments exist in the document.
	var printFragmentWarnings = true;
	function processFragments(ast) {
	  var astFragmentMap = {};
	  var definitions = [];
	
	  for (var i = 0; i < ast.definitions.length; i++) {
	    var fragmentDefinition = ast.definitions[i];
	
	    if (fragmentDefinition.kind === 'FragmentDefinition') {
	      var fragmentName = fragmentDefinition.name.value;
	      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
	
	      // We know something about this fragment
	      if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {
	
	        // this is a problem because the app developer is trying to register another fragment with
	        // the same name as one previously registered. So, we tell them about it.
	        if (printFragmentWarnings) {
	          console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
	            + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
	            + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
	        }
	
	        fragmentSourceMap[fragmentName][sourceKey] = true;
	
	      } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
	        fragmentSourceMap[fragmentName] = {};
	        fragmentSourceMap[fragmentName][sourceKey] = true;
	      }
	
	      if (!astFragmentMap[sourceKey]) {
	        astFragmentMap[sourceKey] = true;
	        definitions.push(fragmentDefinition);
	      }
	    } else {
	      definitions.push(fragmentDefinition);
	    }
	  }
	
	  ast.definitions = definitions;
	  return ast;
	}
	
	function disableFragmentWarnings() {
	  printFragmentWarnings = false;
	}
	
	function stripLoc(doc, removeLocAtThisLevel) {
	  var docType = Object.prototype.toString.call(doc);
	
	  if (docType === '[object Array]') {
	    return doc.map(function (d) {
	      return stripLoc(d, removeLocAtThisLevel);
	    });
	  }
	
	  if (docType !== '[object Object]') {
	    throw new Error('Unexpected input.');
	  }
	
	  // We don't want to remove the root loc field so we can use it
	  // for fragment substitution (see below)
	  if (removeLocAtThisLevel && doc.loc) {
	    delete doc.loc;
	  }
	
	  // https://github.com/apollographql/graphql-tag/issues/40
	  if (doc.loc) {
	    delete doc.loc.startToken;
	    delete doc.loc.endToken;
	  }
	
	  var keys = Object.keys(doc);
	  var key;
	  var value;
	  var valueType;
	
	  for (key in keys) {
	    if (keys.hasOwnProperty(key)) {
	      value = doc[keys[key]];
	      valueType = Object.prototype.toString.call(value);
	
	      if (valueType === '[object Object]' || valueType === '[object Array]') {
	        doc[keys[key]] = stripLoc(value, true);
	      }
	    }
	  }
	
	  return doc;
	}
	
	var experimentalFragmentVariables = false;
	function parseDocument(doc) {
	  var cacheKey = normalize(doc);
	
	  if (docCache[cacheKey]) {
	    return docCache[cacheKey];
	  }
	
	  var parsed = parse(doc, { experimentalFragmentVariables: experimentalFragmentVariables });
	  if (!parsed || parsed.kind !== 'Document') {
	    throw new Error('Not a valid GraphQL document.');
	  }
	
	  // check that all "new" fragments inside the documents are consistent with
	  // existing fragments of the same name
	  parsed = processFragments(parsed);
	  parsed = stripLoc(parsed, false);
	  docCache[cacheKey] = parsed;
	
	  return parsed;
	}
	
	function enableExperimentalFragmentVariables() {
	  experimentalFragmentVariables = true;
	}
	
	function disableExperimentalFragmentVariables() {
	  experimentalFragmentVariables = false;
	}
	
	// XXX This should eventually disallow arbitrary string interpolation, like Relay does
	function gql(/* arguments */) {
	  var args = Array.prototype.slice.call(arguments);
	
	  var literals = args[0];
	
	  // We always get literals[0] and then matching post literals for each arg given
	  var result = (typeof(literals) === "string") ? literals : literals[0];
	
	  for (var i = 1; i < args.length; i++) {
	    if (args[i] && args[i].kind && args[i].kind === 'Document') {
	      result += args[i].loc.source.body;
	    } else {
	      result += args[i];
	    }
	
	    result += literals[i];
	  }
	
	  return parseDocument(result);
	}
	
	// Support typescript, which isn't as nice as Babel about default exports
	gql.default = gql;
	gql.resetCaches = resetCaches;
	gql.disableFragmentWarnings = disableFragmentWarnings;
	gql.enableExperimentalFragmentVariables = enableExperimentalFragmentVariables;
	gql.disableExperimentalFragmentVariables = disableExperimentalFragmentVariables;
	
	module.exports = gql;
	
	})));
	//# sourceMappingURL=graphql-tag.umd.js.map


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.syntaxError = syntaxError;
	
	var _GraphQLError = __webpack_require__(564);
	
	/**
	 * Produces a GraphQLError representing a syntax error, containing useful
	 * descriptive information about the syntax error's position in the source.
	 */
	function syntaxError(source, position, description) {
	  return new _GraphQLError.GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
	}


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defineToJSON;
	
	var _nodejsCustomInspectSymbol = _interopRequireDefault(__webpack_require__(234));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The `defineToJSON()` function defines toJSON() and inspect() prototype
	 * methods, if no function provided they become aliases for toString().
	 */
	function defineToJSON(classObject) {
	  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : classObject.prototype.toString;
	  classObject.prototype.toJSON = fn;
	  classObject.prototype.inspect = fn;
	
	  if (_nodejsCustomInspectSymbol.default) {
	    classObject.prototype[_nodejsCustomInspectSymbol.default] = fn;
	  }
	}


/***/ }),
/* 232 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = devAssert;
	
	function devAssert(condition, message) {
	  var booleanCondition = Boolean(condition);
	
	  if (!booleanCondition) {
	    throw new Error(message);
	  }
	}


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inspect;
	
	var _nodejsCustomInspectSymbol = _interopRequireDefault(__webpack_require__(234));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var MAX_ARRAY_LENGTH = 10;
	var MAX_RECURSIVE_DEPTH = 2;
	/**
	 * Used to print values in error messages.
	 */
	
	function inspect(value) {
	  return formatValue(value, []);
	}
	
	function formatValue(value, seenValues) {
	  switch (_typeof(value)) {
	    case 'string':
	      return JSON.stringify(value);
	
	    case 'function':
	      return value.name ? "[function ".concat(value.name, "]") : '[function]';
	
	    case 'object':
	      if (value === null) {
	        return 'null';
	      }
	
	      return formatObjectValue(value, seenValues);
	
	    default:
	      return String(value);
	  }
	}
	
	function formatObjectValue(value, previouslySeenValues) {
	  if (previouslySeenValues.indexOf(value) !== -1) {
	    return '[Circular]';
	  }
	
	  var seenValues = [].concat(previouslySeenValues, [value]);
	  var customInspectFn = getCustomFn(value);
	
	  if (customInspectFn !== undefined) {
	    // $FlowFixMe(>=0.90.0)
	    var customValue = customInspectFn.call(value); // check for infinite recursion
	
	    if (customValue !== value) {
	      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
	    }
	  } else if (Array.isArray(value)) {
	    return formatArray(value, seenValues);
	  }
	
	  return formatObject(value, seenValues);
	}
	
	function formatObject(object, seenValues) {
	  var keys = Object.keys(object);
	
	  if (keys.length === 0) {
	    return '{}';
	  }
	
	  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
	    return '[' + getObjectTag(object) + ']';
	  }
	
	  var properties = keys.map(function (key) {
	    var value = formatValue(object[key], seenValues);
	    return key + ': ' + value;
	  });
	  return '{ ' + properties.join(', ') + ' }';
	}
	
	function formatArray(array, seenValues) {
	  if (array.length === 0) {
	    return '[]';
	  }
	
	  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
	    return '[Array]';
	  }
	
	  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
	  var remaining = array.length - len;
	  var items = [];
	
	  for (var i = 0; i < len; ++i) {
	    items.push(formatValue(array[i], seenValues));
	  }
	
	  if (remaining === 1) {
	    items.push('... 1 more item');
	  } else if (remaining > 1) {
	    items.push("... ".concat(remaining, " more items"));
	  }
	
	  return '[' + items.join(', ') + ']';
	}
	
	function getCustomFn(object) {
	  var customInspectFn = object[String(_nodejsCustomInspectSymbol.default)];
	
	  if (typeof customInspectFn === 'function') {
	    return customInspectFn;
	  }
	
	  if (typeof object.inspect === 'function') {
	    return object.inspect;
	  }
	}
	
	function getObjectTag(object) {
	  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
	
	  if (tag === 'Object' && typeof object.constructor === 'function') {
	    var name = object.constructor.name;
	
	    if (typeof name === 'string' && name !== '') {
	      return name;
	    }
	  }
	
	  return tag;
	}


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
	var _default = nodejsCustomInspectSymbol;
	exports.default = _default;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dedentBlockStringValue = dedentBlockStringValue;
	exports.getBlockStringIndentation = getBlockStringIndentation;
	exports.printBlockString = printBlockString;
	
	/**
	 * Produces the value of a block string from its parsed raw value, similar to
	 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
	 *
	 * This implements the GraphQL spec's BlockStringValue() static algorithm.
	 */
	function dedentBlockStringValue(rawString) {
	  // Expand a block string's raw value into independent lines.
	  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
	
	  var commonIndent = getBlockStringIndentation(lines);
	
	  if (commonIndent !== 0) {
	    for (var i = 1; i < lines.length; i++) {
	      lines[i] = lines[i].slice(commonIndent);
	    }
	  } // Remove leading and trailing blank lines.
	
	
	  while (lines.length > 0 && isBlank(lines[0])) {
	    lines.shift();
	  }
	
	  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
	    lines.pop();
	  } // Return a string of the lines joined with U+000A.
	
	
	  return lines.join('\n');
	} // @internal
	
	
	function getBlockStringIndentation(lines) {
	  var commonIndent = null;
	
	  for (var i = 1; i < lines.length; i++) {
	    var line = lines[i];
	    var indent = leadingWhitespace(line);
	
	    if (indent === line.length) {
	      continue; // skip empty lines
	    }
	
	    if (commonIndent === null || indent < commonIndent) {
	      commonIndent = indent;
	
	      if (commonIndent === 0) {
	        break;
	      }
	    }
	  }
	
	  return commonIndent === null ? 0 : commonIndent;
	}
	
	function leadingWhitespace(str) {
	  var i = 0;
	
	  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
	    i++;
	  }
	
	  return i;
	}
	
	function isBlank(str) {
	  return leadingWhitespace(str) === str.length;
	}
	/**
	 * Print a block string in the indented block form by adding a leading and
	 * trailing blank line. However, if a block string starts with whitespace and is
	 * a single-line, adding a leading blank line would strip that whitespace.
	 */
	
	
	function printBlockString(value) {
	  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var isSingleLine = value.indexOf('\n') === -1;
	  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
	  var hasTrailingQuote = value[value.length - 1] === '"';
	  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || preferMultipleLines;
	  var result = ''; // Format a multi-line block quote to account for leading space.
	
	  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
	    result += '\n' + indentation;
	  }
	
	  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
	
	  if (printAsMultipleLines) {
	    result += '\n';
	  }
	
	  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
	}


/***/ }),
/* 236 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocation = getLocation;
	
	/**
	 * Represents a location in a Source.
	 */
	
	/**
	 * Takes a Source and a UTF-8 character offset, and returns the corresponding
	 * line and column as a SourceLocation.
	 */
	function getLocation(source, position) {
	  var lineRegexp = /\r\n|[\n\r]/g;
	  var line = 1;
	  var column = position + 1;
	  var match;
	
	  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
	    line += 1;
	    column = position + 1 - (match.index + match[0].length);
	  }
	
	  return {
	    line: line,
	    column: column
	  };
	}


/***/ }),
/* 237 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TokenKind = void 0;
	
	/**
	 * An exported enum describing the different kinds of tokens that the
	 * lexer emits.
	 */
	var TokenKind = Object.freeze({
	  SOF: '<SOF>',
	  EOF: '<EOF>',
	  BANG: '!',
	  DOLLAR: '$',
	  AMP: '&',
	  PAREN_L: '(',
	  PAREN_R: ')',
	  SPREAD: '...',
	  COLON: ':',
	  EQUALS: '=',
	  AT: '@',
	  BRACKET_L: '[',
	  BRACKET_R: ']',
	  BRACE_L: '{',
	  PIPE: '|',
	  BRACE_R: '}',
	  NAME: 'Name',
	  INT: 'Int',
	  FLOAT: 'Float',
	  STRING: 'String',
	  BLOCK_STRING: 'BlockString',
	  COMMENT: 'Comment'
	});
	/**
	 * The enum type representing the token kinds values.
	 */
	
	exports.TokenKind = TokenKind;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(133);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(719);
	
	var _runTransitionHook = __webpack_require__(133);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(56);
	
	var _PathUtils = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var ReactIs = __webpack_require__(146);
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextType: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromError: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var FORWARD_REF_STATICS = {
	    '$$typeof': true,
	    render: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true
	};
	
	var MEMO_STATICS = {
	    '$$typeof': true,
	    compare: true,
	    defaultProps: true,
	    displayName: true,
	    propTypes: true,
	    type: true
	};
	
	var TYPE_STATICS = {};
	TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	    if (ReactIs.isMemo(component)) {
	        return MEMO_STATICS;
	    }
	    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        var targetStatics = getStatics(targetComponent);
	        var sourceStatics = getStatics(sourceComponent);
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try {
	                    // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 242 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  processors: {},
	
	  addPostProcessor: function addPostProcessor(module) {
	    this.processors[module.name] = module;
	  },
	  handle: function handle(processors, value, key, options, translator) {
	    var _this = this;
	
	    processors.forEach(function (processor) {
	      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
	    });
	
	    return value;
	  }
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(96),
	    stackClear = __webpack_require__(678),
	    stackDelete = __webpack_require__(679),
	    stackGet = __webpack_require__(680),
	    stackHas = __webpack_require__(681),
	    stackSet = __webpack_require__(682);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 245 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(249),
	    toKey = __webpack_require__(100);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(613),
	    isObjectLike = __webpack_require__(59);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 248 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(29),
	    isKey = __webpack_require__(139),
	    stringToPath = __webpack_require__(683),
	    toString = __webpack_require__(701);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(598),
	    arraySome = __webpack_require__(604),
	    cacheHas = __webpack_require__(629);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(73);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 254 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(28),
	    stubFalse = __webpack_require__(697);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)(module)))

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    isObject = __webpack_require__(73);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(616),
	    baseUnary = __webpack_require__(248),
	    nodeUtil = __webpack_require__(670);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return isArray(this._weekdays) ? this._weekdays :
	                this._weekdays['standalone'];
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.22.2';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)(module)))

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(445);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ }),
/* 261 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.renderToStringWithData = exports.getMarkupFromTree = exports.getDataFromTree = exports.useSubscription = exports.useQuery = exports.useMutation = exports.useLazyQuery = exports.useApolloClient = exports.withSubscription = exports.withQuery = exports.withMutation = exports.withApollo = exports.graphql = exports.Subscription = exports.Query = exports.Mutation = exports.resetApolloContext = exports.getApolloContext = exports.ApolloProvider = exports.ApolloConsumer = void 0;
	
	var _reactCommon = __webpack_require__(62);
	
	exports.ApolloConsumer = _reactCommon.ApolloConsumer;
	exports.ApolloProvider = _reactCommon.ApolloProvider;
	exports.getApolloContext = _reactCommon.getApolloContext;
	exports.resetApolloContext = _reactCommon.resetApolloContext;
	
	var _reactComponents = __webpack_require__(156);
	
	exports.Mutation = _reactComponents.Mutation;
	exports.Query = _reactComponents.Query;
	exports.Subscription = _reactComponents.Subscription;
	
	var _reactHoc = __webpack_require__(283);
	
	exports.graphql = _reactHoc.graphql;
	exports.withApollo = _reactHoc.withApollo;
	exports.withMutation = _reactHoc.withMutation;
	exports.withQuery = _reactHoc.withQuery;
	exports.withSubscription = _reactHoc.withSubscription;
	
	var _reactHooks = __webpack_require__(105);
	
	exports.useApolloClient = _reactHooks.useApolloClient;
	exports.useLazyQuery = _reactHooks.useLazyQuery;
	exports.useMutation = _reactHooks.useMutation;
	exports.useQuery = _reactHooks.useQuery;
	exports.useSubscription = _reactHooks.useSubscription;
	
	var _reactSsr = __webpack_require__(284);
	
	exports.getDataFromTree = _reactSsr.getDataFromTree;
	exports.getMarkupFromTree = _reactSsr.getMarkupFromTree;
	exports.renderToStringWithData = _reactSsr.renderToStringWithData;


/***/ }),
/* 263 */
63,
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports["default"] = _propTypes2["default"].shape({
	  subscribe: _propTypes2["default"].func.isRequired,
	  dispatch: _propTypes2["default"].func.isRequired,
	  getState: _propTypes2["default"].func.isRequired
	});

/***/ }),
/* 265 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 266 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 267 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(27);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(149);
	
	var _ContextUtils = __webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 269 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(27);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(39);
	
	var _PatternUtils = __webpack_require__(60);
	
	var _InternalPropTypes = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 271 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(240);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(239);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(580);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(275);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(61);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(742);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(739);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(746);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(743);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(748);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(240);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(239);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(144);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(280);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(30)
	
	/**
	 * Snake case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '_')
	}


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(776);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(41)(module)))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(14);
	var zen_observable_1 = tslib_1.__importDefault(__webpack_require__(780));
	exports.Observable = zen_observable_1.default;
	//# sourceMappingURL=zenObservable.js.map

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(713).enable();
	  window.Promise = __webpack_require__(712);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(779);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(707);


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.graphql = graphql;
	exports.withApollo = withApollo;
	exports.withMutation = withMutation;
	exports.withQuery = withQuery;
	exports.withSubscription = withSubscription;
	exports.resetApolloContext = exports.getApolloContext = exports.ApolloProvider = void 0;
	
	var _reactCommon = __webpack_require__(62);
	
	exports.ApolloConsumer = _reactCommon.ApolloConsumer;
	exports.ApolloProvider = _reactCommon.ApolloProvider;
	exports.getApolloContext = _reactCommon.getApolloContext;
	exports.resetApolloContext = _reactCommon.resetApolloContext;
	
	var _tslib = __webpack_require__(14);
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(241));
	
	var _reactComponents = __webpack_require__(156);
	
	var _tsInvariant = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultMapPropsToOptions = function () {
	  return {};
	};
	
	var defaultMapPropsToSkip = function () {
	  return false;
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function calculateVariablesFromProps(operation, props) {
	  var variables = {};
	
	  for (var _i = 0, _a = operation.variables; _i < _a.length; _i++) {
	    var _b = _a[_i],
	        variable = _b.variable,
	        type = _b.type;
	    if (!variable.name || !variable.name.value) continue;
	    var variableName = variable.name.value;
	    var variableProp = props[variableName];
	
	    if (typeof variableProp !== 'undefined') {
	      variables[variableName] = variableProp;
	      continue;
	    }
	
	    if (type.kind !== 'NonNullType') {
	      variables[variableName] = undefined;
	    }
	  }
	
	  return variables;
	}
	
	var GraphQLBase = function (_super) {
	  (0, _tslib.__extends)(GraphQLBase, _super);
	
	  function GraphQLBase(props) {
	    var _this = _super.call(this, props) || this;
	
	    _this.withRef = false;
	    _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	    return _this;
	  }
	
	  GraphQLBase.prototype.getWrappedInstance = function () {
	     true ? (0, _tsInvariant.invariant)(this.withRef, 2) : (0, _tsInvariant.invariant)(this.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
	    return this.wrappedInstance;
	  };
	
	  GraphQLBase.prototype.setWrappedInstance = function (ref) {
	    this.wrappedInstance = ref;
	  };
	
	  return GraphQLBase;
	}(_react.default.Component);
	
	function withQuery(document, operationOptions) {
	  if (operationOptions === void 0) {
	    operationOptions = {};
	  }
	
	  var operation = (0, _reactCommon.parser)(document);
	  var _a = operationOptions.options,
	      options = _a === void 0 ? defaultMapPropsToOptions : _a,
	      _b = operationOptions.skip,
	      skip = _b === void 0 ? defaultMapPropsToSkip : _b,
	      _c = operationOptions.alias,
	      alias = _c === void 0 ? 'Apollo' : _c;
	  var mapPropsToOptions = options;
	
	  if (typeof mapPropsToOptions !== 'function') {
	    mapPropsToOptions = function () {
	      return options;
	    };
	  }
	
	  var mapPropsToSkip = skip;
	
	  if (typeof mapPropsToSkip !== 'function') {
	    mapPropsToSkip = function () {
	      return skip;
	    };
	  }
	
	  var lastResultProps;
	  return function (WrappedComponent) {
	    var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
	
	    var GraphQL = function (_super) {
	      (0, _tslib.__extends)(GraphQL, _super);
	
	      function GraphQL() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      GraphQL.prototype.render = function () {
	        var _this = this;
	
	        var props = this.props;
	        var shouldSkip = mapPropsToSkip(props);
	        var opts = shouldSkip ? Object.create(null) : (0, _tslib.__assign)({}, mapPropsToOptions(props));
	
	        if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
	          opts.variables = calculateVariablesFromProps(operation, props);
	        }
	
	        return _react.default.createElement(_reactComponents.Query, (0, _tslib.__assign)({}, opts, {
	          displayName: graphQLDisplayName,
	          skip: shouldSkip,
	          query: document
	        }), function (_a) {
	          var _b, _c;
	
	          var _ = _a.client,
	              data = _a.data,
	              r = (0, _tslib.__rest)(_a, ["client", "data"]);
	
	          if (operationOptions.withRef) {
	            _this.withRef = true;
	            props = Object.assign({}, props, {
	              ref: _this.setWrappedInstance
	            });
	          }
	
	          if (shouldSkip) {
	            return _react.default.createElement(WrappedComponent, (0, _tslib.__assign)({}, props, {}));
	          }
	
	          var result = Object.assign(r, data || {});
	          var name = operationOptions.name || 'data';
	          var childProps = (_b = {}, _b[name] = result, _b);
	
	          if (operationOptions.props) {
	            var newResult = (_c = {}, _c[name] = result, _c.ownProps = props, _c);
	            lastResultProps = operationOptions.props(newResult, lastResultProps);
	            childProps = lastResultProps;
	          }
	
	          return _react.default.createElement(WrappedComponent, (0, _tslib.__assign)({}, props, childProps));
	        });
	      };
	
	      GraphQL.displayName = graphQLDisplayName;
	      GraphQL.WrappedComponent = WrappedComponent;
	      return GraphQL;
	    }(GraphQLBase);
	
	    return (0, _hoistNonReactStatics.default)(GraphQL, WrappedComponent, {});
	  };
	}
	
	function withMutation(document, operationOptions) {
	  if (operationOptions === void 0) {
	    operationOptions = {};
	  }
	
	  var operation = (0, _reactCommon.parser)(document);
	  var _a = operationOptions.options,
	      options = _a === void 0 ? defaultMapPropsToOptions : _a,
	      _b = operationOptions.alias,
	      alias = _b === void 0 ? 'Apollo' : _b;
	  var mapPropsToOptions = options;
	  if (typeof mapPropsToOptions !== 'function') mapPropsToOptions = function () {
	    return options;
	  };
	  return function (WrappedComponent) {
	    var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
	
	    var GraphQL = function (_super) {
	      (0, _tslib.__extends)(GraphQL, _super);
	
	      function GraphQL() {
	        return _super !== null && _super.apply(this, arguments) || this;
	      }
	
	      GraphQL.prototype.render = function () {
	        var props = this.props;
	        var opts = mapPropsToOptions(props);
	
	        if (operationOptions.withRef) {
	          this.withRef = true;
	          props = Object.assign({}, props, {
	            ref: this.setWrappedInstance
	          });
	        }
	
	        if (!opts.variables && operation.variables.length > 0) {
	          opts.variables = calculateVariablesFromProps(operation, props);
	        }
	
	        return _react.default.createElement(_reactComponents.Mutation, (0, _tslib.__assign)({
	          ignoreResults: true
	        }, opts, {
	          mutation: document
	        }), function (mutate, _a) {
	          var _b, _c;
	
	          var data = _a.data,
	              r = (0, _tslib.__rest)(_a, ["data"]);
	          var result = Object.assign(r, data || {});
	          var name = operationOptions.name || 'mutate';
	          var resultName = operationOptions.name ? name + "Result" : 'result';
	          var childProps = (_b = {}, _b[name] = mutate, _b[resultName] = result, _b);
	
	          if (operationOptions.props) {
	            var newResult = (_c = {}, _c[name] = mutate, _c[resultName] = result, _c.ownProps = props, _c);
	            childProps = operationOptions.props(newResult);
	          }
	
	          return _react.default.createElement(WrappedComponent, (0, _tslib.__assign)({}, props, childProps));
	        });
	      };
	
	      GraphQL.displayName = graphQLDisplayName;
	      GraphQL.WrappedComponent = WrappedComponent;
	      return GraphQL;
	    }(GraphQLBase);
	
	    return (0, _hoistNonReactStatics.default)(GraphQL, WrappedComponent, {});
	  };
	}
	
	function withSubscription(document, operationOptions) {
	  if (operationOptions === void 0) {
	    operationOptions = {};
	  }
	
	  var operation = (0, _reactCommon.parser)(document);
	  var _a = operationOptions.options,
	      options = _a === void 0 ? defaultMapPropsToOptions : _a,
	      _b = operationOptions.skip,
	      skip = _b === void 0 ? defaultMapPropsToSkip : _b,
	      _c = operationOptions.alias,
	      alias = _c === void 0 ? 'Apollo' : _c,
	      shouldResubscribe = operationOptions.shouldResubscribe;
	  var mapPropsToOptions = options;
	  if (typeof mapPropsToOptions !== 'function') mapPropsToOptions = function () {
	    return options;
	  };
	  var mapPropsToSkip = skip;
	  if (typeof mapPropsToSkip !== 'function') mapPropsToSkip = function () {
	    return skip;
	  };
	  var lastResultProps;
	  return function (WrappedComponent) {
	    var graphQLDisplayName = alias + "(" + getDisplayName(WrappedComponent) + ")";
	
	    var GraphQL = function (_super) {
	      (0, _tslib.__extends)(GraphQL, _super);
	
	      function GraphQL(props) {
	        var _this = _super.call(this, props) || this;
	
	        _this.state = {
	          resubscribe: false
	        };
	        return _this;
	      }
	
	      GraphQL.prototype.componentDidUpate = function (prevProps) {
	        if (shouldResubscribe) {
	          this.setState({
	            resubscribe: shouldResubscribe(prevProps, this.props)
	          });
	        }
	      };
	
	      GraphQL.prototype.render = function () {
	        var _this = this;
	
	        var props = this.props;
	        var shouldSkip = mapPropsToSkip(props);
	        var opts = shouldSkip ? Object.create(null) : mapPropsToOptions(props);
	
	        if (!shouldSkip && !opts.variables && operation.variables.length > 0) {
	          opts.variables = calculateVariablesFromProps(operation, props);
	        }
	
	        return _react.default.createElement(_reactComponents.Subscription, (0, _tslib.__assign)({}, opts, {
	          displayName: graphQLDisplayName,
	          skip: shouldSkip,
	          subscription: document,
	          shouldResubscribe: this.state.resubscribe
	        }), function (_a) {
	          var _b, _c;
	
	          var data = _a.data,
	              r = (0, _tslib.__rest)(_a, ["data"]);
	
	          if (operationOptions.withRef) {
	            _this.withRef = true;
	            props = Object.assign({}, props, {
	              ref: _this.setWrappedInstance
	            });
	          }
	
	          if (shouldSkip) {
	            return _react.default.createElement(WrappedComponent, (0, _tslib.__assign)({}, props, {}));
	          }
	
	          var result = Object.assign(r, data || {});
	          var name = operationOptions.name || 'data';
	          var childProps = (_b = {}, _b[name] = result, _b);
	
	          if (operationOptions.props) {
	            var newResult = (_c = {}, _c[name] = result, _c.ownProps = props, _c);
	            lastResultProps = operationOptions.props(newResult, lastResultProps);
	            childProps = lastResultProps;
	          }
	
	          return _react.default.createElement(WrappedComponent, (0, _tslib.__assign)({}, props, childProps));
	        });
	      };
	
	      GraphQL.displayName = graphQLDisplayName;
	      GraphQL.WrappedComponent = WrappedComponent;
	      return GraphQL;
	    }(GraphQLBase);
	
	    return (0, _hoistNonReactStatics.default)(GraphQL, WrappedComponent, {});
	  };
	}
	
	function graphql(document, operationOptions) {
	  if (operationOptions === void 0) {
	    operationOptions = {};
	  }
	
	  switch ((0, _reactCommon.parser)(document).type) {
	    case _reactCommon.DocumentType.Mutation:
	      return withMutation(document, operationOptions);
	
	    case _reactCommon.DocumentType.Subscription:
	      return withSubscription(document, operationOptions);
	
	    case _reactCommon.DocumentType.Query:
	    default:
	      return withQuery(document, operationOptions);
	  }
	}
	
	function getDisplayName$1(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withApollo(WrappedComponent, operationOptions) {
	  if (operationOptions === void 0) {
	    operationOptions = {};
	  }
	
	  var withDisplayName = "withApollo(" + getDisplayName$1(WrappedComponent) + ")";
	
	  var WithApollo = function (_super) {
	    (0, _tslib.__extends)(WithApollo, _super);
	
	    function WithApollo(props) {
	      var _this = _super.call(this, props) || this;
	
	      _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	      return _this;
	    }
	
	    WithApollo.prototype.getWrappedInstance = function () {
	       true ? (0, _tsInvariant.invariant)(operationOptions.withRef, 1) : (0, _tsInvariant.invariant)(operationOptions.withRef, "To access the wrapped instance, you need to specify " + "{ withRef: true } in the options");
	      return this.wrappedInstance;
	    };
	
	    WithApollo.prototype.setWrappedInstance = function (ref) {
	      this.wrappedInstance = ref;
	    };
	
	    WithApollo.prototype.render = function () {
	      var _this = this;
	
	      return _react.default.createElement(_reactCommon.ApolloConsumer, null, function (client) {
	        var props = Object.assign({}, _this.props, {
	          client: client,
	          ref: operationOptions.withRef ? _this.setWrappedInstance : undefined
	        });
	        return _react.default.createElement(WrappedComponent, (0, _tslib.__assign)({}, props));
	      });
	    };
	
	    WithApollo.displayName = withDisplayName;
	    WithApollo.WrappedComponent = WrappedComponent;
	    return WithApollo;
	  }(_react.default.Component);
	
	  return (0, _hoistNonReactStatics.default)(WithApollo, WrappedComponent, {});
	}


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.getDataFromTree = getDataFromTree;
	exports.getMarkupFromTree = getMarkupFromTree;
	exports.renderToStringWithData = renderToStringWithData;
	
	var _tslib = __webpack_require__(14);
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactCommon = __webpack_require__(62);
	
	var _reactHooks = __webpack_require__(105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDataFromTree(tree, context) {
	  if (context === void 0) {
	    context = {};
	  }
	
	  return getMarkupFromTree({
	    tree: tree,
	    context: context,
	    renderFunction: __webpack_require__(145).renderToStaticMarkup
	  });
	}
	
	function getMarkupFromTree(_a) {
	  var tree = _a.tree,
	      _b = _a.context,
	      context = _b === void 0 ? {} : _b,
	      _c = _a.renderFunction,
	      renderFunction = _c === void 0 ? __webpack_require__(145).renderToStaticMarkup : _c;
	  var renderPromises = new _reactHooks.RenderPromises();
	
	  function process() {
	    var ApolloContext = (0, _reactCommon.getApolloContext)();
	    var html = renderFunction(_react.default.createElement(ApolloContext.Provider, {
	      value: (0, _tslib.__assign)((0, _tslib.__assign)({}, context), {
	        renderPromises: renderPromises
	      })
	    }, tree));
	    return renderPromises.hasPromises() ? renderPromises.consumeAndAwaitPromises().then(process) : html;
	  }
	
	  return Promise.resolve().then(process);
	}
	
	function renderToStringWithData(component) {
	  return getMarkupFromTree({
	    tree: component,
	    renderFunction: __webpack_require__(145).renderToString
	  });
	}


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Button = exports.onClick = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _framework7React = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  whiteBackground: {
	    backgroundColor: '#ffffff',
	    margin: 0,
	    paddingTop: '5px',
	    paddingBottom: '5px',
	    display: 'flex',
	    zIndex: 30
	  },
	  whiteBackgroundInternalGap: {
	    backgroundColor: '#ffffff',
	    width: '5px'
	  },
	  whiteBackgroundContent: {
	    flex: 1
	  }
	};
	
	var _onClick = function _onClick(event, props) {
	  event.preventDefault();
	  event.stopPropagation();
	
	  var originalOnClick = props.onClick;
	
	  if (originalOnClick) {
	    // do not follow default href="#"
	    originalOnClick();
	  }
	};
	
	exports.onClick = _onClick;
	var Button = function Button(props) {
	  var content = props.label || props.children || '';
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.whiteBackground },
	    _react2.default.createElement('div', { style: styles.whiteBackgroundInternalGap }),
	    _react2.default.createElement(
	      _framework7React.Button,
	      _extends({}, props, {
	        onClick: function onClick(event) {
	          _onClick(event, props);
	        },
	        style: _extends({}, styles.whiteBackgroundContent)
	      }),
	      content.toUpperCase()
	    ),
	    _react2.default.createElement('div', { style: styles.whiteBackgroundInternalGap })
	  );
	};
	
	Button.propTypes = {
	  color: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  label: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node])
	};
	
	Button.defaultProps = {
	  onClick: function onClick() {},
	  label: null,
	  children: null
	};
	
	exports.Button = Button;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Form = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _framework7React = __webpack_require__(80);
	
	var _ = __webpack_require__(106);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var bottomElementSlideTransition = {
	  'WebkitTransition': 'height 0.5s linear',
	  'MozTransition': 'height 0.5s linear',
	  'msTransition': 'height 0.5s linear',
	  'OTransition': 'height 0.5s linear',
	  'transition': 'height 0.5s linear'
	};
	
	var styles = {
	  bottomPositionedElementParent: {
	    display: 'flex',
	    flexDirection: 'column',
	    height: '100%',
	    position: 'relative',
	    overflow: 'hidden'
	  },
	  content: {
	    height: '100%',
	    overflowY: 'scroll'
	  },
	  bottomElement: _extends({
	    position: 'absolute',
	    bottom: 0,
	    width: '100%'
	  }, bottomElementSlideTransition),
	  bottomElementHidden: _extends({
	    height: 0
	  }, bottomElementSlideTransition)
	};
	
	var resizeEventListenerRegistered = false;
	var formFullHeight = void 0;
	var checkPageSize = function checkPageSize(callback) {
	  var form = document.getElementsByClassName('arreeba-form_content')[0];
	  if (form) {
	    var formCurrentHeight = form.offsetHeight;
	    var shouldHide = formCurrentHeight < formFullHeight;
	    console.log('resize', formCurrentHeight, shouldHide);
	    callback(shouldHide);
	  } else {
	    console.log('form removed from page?');
	  }
	};
	
	var resizeEventListener = checkPageSize;
	
	var setResizeEventListener = function setResizeEventListener(callback) {
	  if (!resizeEventListenerRegistered) {
	    resizeEventListenerRegistered = true;
	    var form = document.getElementsByClassName('arreeba-form_content')[0];
	    formFullHeight = form.offsetHeight;
	    var onResize = function onResize() {
	      return resizeEventListener(callback);
	    };
	    window.removeEventListener('resize', onResize);
	    window.addEventListener('resize', onResize, true);
	  }
	};
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form(props) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	    _this.state = {};
	    _this.toggleTopElementVisibility = _this.toggleTopElementVisibility.bind(_this);
	    _this.toggleBottomElementVisibility = _this.toggleBottomElementVisibility.bind(_this);
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.bottomElement) {
	        // eslint-disable-next-line react/no-did-mount-set-state
	        this.setState({ bottomElementHeight: this.bottomElement.offsetHeight });
	      }
	
	      setResizeEventListener(function (shouldHide) {
	        _this2.toggleTopElementVisibility(shouldHide);
	        _this2.toggleBottomElementVisibility(shouldHide);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', resizeEventListener);
	    }
	  }, {
	    key: 'toggleTopElementVisibility',
	    value: function toggleTopElementVisibility(shouldHideTopElement) {
	      if (typeof shouldHideTopElement === 'boolean') {
	        this.setState({ shouldHideTopElement: shouldHideTopElement });
	        return;
	      }
	      this.setState({ shouldHideTopElement: !this.state.shouldHideTopElement });
	    }
	  }, {
	    key: 'toggleBottomElementVisibility',
	    value: function toggleBottomElementVisibility(shouldHideBottomElement) {
	      if (typeof shouldHideBottomElement === 'boolean') {
	        this.setState({ shouldHideBottomElement: shouldHideBottomElement });
	        return;
	      }
	      this.setState({ shouldHideBottomElement: !this.state.shouldHideBottomElement });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          formTitle = _props.formTitle,
	          topElement = _props.topElement,
	          bottomElement = _props.bottomElement,
	          submitClassNames = _props.submitClassNames,
	          onCancel = _props.onCancel,
	          onSubmit = _props.onSubmit,
	          submitButtonLabel = _props.submitButtonLabel,
	          cancelButtonLabel = _props.cancelButtonLabel,
	          framework7AppContext = _props.framework7AppContext;
	
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(c) {
	              _this3.form = c;
	            },
	            className: 'arreeba-form_content',
	            style: _extends({}, styles.content, {
	              marginBottom: this.state.shouldHideBottomElement ? 0 : this.state.bottomElementHeight + 'px'
	            })
	          },
	          !this.state.shouldHideTopElement && topElement,
	          formTitle && _react2.default.createElement(
	            _framework7React.ContentBlockTitle,
	            null,
	            formTitle
	          ),
	          _react2.default.createElement(
	            _framework7React.List,
	            { inset: this.props.inset, form: true, id: 'this-form' },
	            children
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            ref: function ref(c) {
	              _this3.bottomElement = c;
	            },
	            className: 'arreeba-form_bottomElement',
	            style: _extends({}, this.state.shouldHideBottomElement ? styles.bottomElementHidden : styles.bottomElement)
	          },
	          bottomElement,
	          onCancel && _react2.default.createElement(
	            _.Button,
	            {
	              big: true,
	              raised: true // material
	              , onClick: onCancel,
	              style: styles.cancelButton
	            },
	            cancelButtonLabel
	          ),
	          onSubmit && _react2.default.createElement(
	            _.Button,
	            {
	              big: true,
	              active: true // ios
	              , raised: true // material
	              , fill: true // material
	              , className: submitClassNames,
	              onClick: function onClick() {
	                framework7AppContext.getFramework7(function (f7) {
	                  onSubmit(f7.formToData('#this-form'));
	                });
	              },
	              style: styles.submitButton
	            },
	            submitButtonLabel
	          )
	        )
	      );
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	;
	
	Form.propTypes = {
	  children: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  formTitle: _propTypes2.default.string,
	  cancelButtonLabel: _propTypes2.default.string,
	  submitButtonLabel: _propTypes2.default.string.isRequired,
	  onCancel: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  topElement: _propTypes2.default.object,
	  bottomElement: _propTypes2.default.object,
	  buttonsAtTheBottom: _propTypes2.default.bool,
	  submitClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	Form.defaultProps = {
	  inset: false
	};
	
	exports.Form = Form;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Input = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _framework7React = __webpack_require__(80);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  error: {
	    fontSize: '10px',
	    color: 'white',
	    fontWeight: 'bold',
	    whiteSpace: 'nowrap',
	    textAlign: 'right',
	    paddingLeft: '3px',
	    paddingRight: '3px',
	    backgroundColor: '#ef2d26',
	    borderRadius: '4px'
	  }
	};
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input(props) {
	    _classCallCheck(this, Input);
	
	    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	
	    var name = props.name,
	        initialValue = props.initialValue;
	
	
	    _this.state = _defineProperty({}, name, initialValue);
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var name = nextProps.name,
	          initialValue = nextProps.initialValue,
	          onChange = nextProps.onChange;
	
	
	      if (initialValue === this.state[name]) {
	        return;
	      }
	      var obj = _defineProperty({}, name, initialValue);
	
	      this.setState(obj, function () {
	        onChange(obj);
	      });
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(target) {
	      var id = target.id,
	          type = target.type;
	
	
	      var value = ['checkbox'].indexOf(type) >= 0 ? target.checked : target.value;
	
	      var obj = _defineProperty({}, id, value);
	
	      this.setState(obj);
	
	      this.props.onChange(obj);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          type = _props.type,
	          name = _props.name,
	          focus = _props.focus,
	          label = _props.label,
	          extraText = _props.extraText,
	          placeholder = _props.placeholder,
	          errors = _props.errors;
	
	
	      var inputValuePropName = ['checkbox'].indexOf(type) >= 0 ? 'checked' : 'value';
	
	      var extraProps = _defineProperty({}, inputValuePropName, this.state[name]);
	
	      var labelStyle = {},
	          inputStyle = {};
	      if (type === 'checkbox') {
	        labelStyle = { flex: 1, width: 'auto' };
	        inputStyle = { width: 'auto' };
	      }
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _framework7React.ListItem,
	          null,
	          _react2.default.createElement(
	            _framework7React.FormLabel,
	            { style: labelStyle },
	            label
	          ),
	          _react2.default.createElement(_framework7React.FormInput, _extends({
	            id: name,
	            name: name,
	            type: type === 'checkbox' ? 'switch' : type,
	            placeholder: placeholder,
	            onChange: function onChange(evt) {
	              _this2.onChange(evt.target);
	            },
	            autoFocus: !!focus,
	            style: inputStyle
	          }, extraProps)),
	          errors && errors.length > 0 && errors.map(function (error, key) {
	            return _react2.default.createElement(
	              'span',
	              { style: _extends({}, styles.error), key: key },
	              error
	            );
	          })
	        ),
	        extraText && _react2.default.createElement(
	          _framework7React.ListItem,
	          { inner: true, style: { fontSize: '13px', color: 'grey' } },
	          extraText
	        )
	      );
	    }
	  }]);
	
	  return Input;
	}(_react.Component);
	
	;
	
	Input.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  focus: _propTypes2.default.bool,
	  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  type: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  initialValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
	  onChange: _propTypes2.default.func,
	  rows: _propTypes2.default.number, // if type === 'textarea'
	  errors: _propTypes2.default.array,
	  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	Input.defaultProps = {
	  type: 'text',
	  initialValue: '',
	  placeholder: ''
	};
	
	exports.Input = Input;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocationInput = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _framework7React = __webpack_require__(80);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _logging = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  error: {
	    fontSize: '10px',
	    color: 'white',
	    fontWeight: 'bold',
	    whiteSpace: 'nowrap',
	    textAlign: 'right',
	    paddingLeft: '3px',
	    paddingRight: '3px',
	    backgroundColor: '#ef2d26',
	    borderRadius: '4px'
	  },
	  geosuggest: {
	    input: {},
	    suggests: {
	      listStyleType: 'none',
	      padding: '0px 5px',
	      margin: 0
	    },
	    suggestItem: {
	      height: '45px',
	      lineHeight: '45px',
	      borderBottom: 'solid 1px #eeeeee',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    }
	  }
	};
	
	var Geosuggest = void 0;
	
	var LocationInput = function (_Component) {
	  _inherits(LocationInput, _Component);
	
	  function LocationInput(props) {
	    _classCallCheck(this, LocationInput);
	
	    // Import only if instantiated
	    var _this = _possibleConstructorReturn(this, (LocationInput.__proto__ || Object.getPrototypeOf(LocationInput)).call(this, props));
	
	    _this.onSuggestSelect = function (data) {
	      var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      if (!data.gmaps) {
	        (0, _logging.warn)('onSuggestSelect: gmaps is null');
	        return;
	      }
	
	      var address_components = data.gmaps.address_components;
	
	
	      var fields = address_components.reduce(function (acc, c) {
	        return _extends({}, acc, _defineProperty({}, c.types[0], c.long_name));
	      }, _extends({}, data.location));
	
	      if (!fields.locality) {
	        fields.locality = fields.administrative_area_level_3;
	      }
	
	      if (!fields.street_number) {
	        // if is required, do not use default value
	        var streetNumberItem = _lodash2.default.find(_this.props.items, { locationField: 'street_number' });
	        var isRequired = streetNumberItem && streetNumberItem.isRequired;
	        fields.street_number = !isRequired ? 'n/d' : fields.street_number;
	      }
	
	      ['route', 'street_number', 'postal_code', 'locality', 'country', 'lat', 'lng'].forEach(function (locationField) {
	        if (!fields[locationField]) {
	          fields[locationField] = '';
	        }
	      });
	
	      var address = {
	        city: fields.locality,
	        route: fields.route,
	        street_number: fields.street_number,
	        country: fields.country
	      };
	
	      var location = {
	        latitude: fields.lat,
	        longitude: fields.lng
	      };
	
	      _this.setState({ fields: fields, address: address, location: location });
	      _this.props.onChange({ fields: fields, address: address, location: location });
	    };
	
	    _this.renderSingleFieldSections = function (addressFields) {
	
	      var singleFieldList = addressFields.map(function (item, key) {
	
	        var value = typeof _this.state.fields[item.locationField] === 'string' ? _this.state.fields[item.locationField] : item.initialValue;
	
	        var errorMap = _this.props.errors.reduce(function (acc, next) {
	          var splitted = next.split(':');
	          var key = splitted[0];
	          var value = splitted[1];
	          return _extends({}, acc, _defineProperty({}, key, value));
	        }, {});
	
	        return _react2.default.createElement(
	          _framework7React.ListItem,
	          { key: key, className: (0, _classnames2.default)({ hidden: item.hidden }) },
	          _react2.default.createElement(
	            _framework7React.FormLabel,
	            null,
	            item.label
	          ),
	          _react2.default.createElement(_framework7React.FormInput, {
	            type: 'text',
	            name: item.locationField,
	            placeholder: item.label,
	            value: value,
	            onChange: function onChange(_ref) {
	              var target = _ref.target;
	
	              _this.setState(function () {
	                return {
	                  fields: _extends({}, _this.state.fields, _defineProperty({}, item.locationField, target.value))
	                };
	              }, function () {
	                var fields = _this.state.fields;
	
	                var fullAddress = fields.route + ', ' + fields.locality + ', ' + fields.country;
	                if (fields.street_number) {
	                  fullAddress = fields.route + ', ' + fields.street_number + ', ' + fields.locality + ', ' + fields.country;
	                }
	                _this._geoSuggest.update(fullAddress);
	
	                _this.timeout = setTimeout(function () {
	                  _this.timeout && clearTimeout(_this.timeout);
	                  _this._geoSuggest.selectSuggest();
	                }, 1500);
	              });
	            }
	          }),
	          errorMap[item.label] && _react2.default.createElement(
	            'span',
	            { style: _extends({}, styles.error) },
	            errorMap[item.label]
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(_framework7React.ListItem, { divider: true, style: { height: '1px' } }),
	        singleFieldList
	      );
	    };
	
	    Geosuggest = __webpack_require__(185).default;
	    __webpack_require__(560);
	
	    _this.state = {
	      fields: {}
	    };
	    return _this;
	  }
	
	  _createClass(LocationInput, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var addressFields = this.props.items.filter(function (item) {
	        return ['lat', 'lng'].indexOf(item.locationField) < 0;
	      });
	
	      return _react2.default.createElement(
	        _react.Fragment,
	        null,
	        _react2.default.createElement(
	          _framework7React.ListItem,
	          null,
	          _react2.default.createElement(Geosuggest, {
	            ref: function ref(el) {
	              if (!_this2._geoSuggest) {
	                _this2._geoSuggest = el;el.selectSuggest();
	              }
	            },
	            placeholder: 'Cerca indirizzo di consegna',
	            types: this.props.suggestionTypes,
	            initialValue: this.props.initialValue,
	            onSuggestSelect: this.onSuggestSelect,
	            onUpdateSuggests: this.onUpdateSuggests,
	            style: _extends({}, styles.geosuggest)
	          })
	        ),
	        //this.state.showForm && // hide when suggestions are open
	        this.renderSingleFieldSections(addressFields)
	      );
	    }
	  }]);
	
	  return LocationInput;
	}(_react.Component);
	
	LocationInput.propTypes = {
	  label: _propTypes2.default.string,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  initialValue: _propTypes2.default.string,
	  onChange: _propTypes2.default.func.isRequired,
	  errors: _propTypes2.default.array,
	  country: _propTypes2.default.string,
	  suggestionTypes: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  hidden: _propTypes2.default.bool
	};
	LocationInput.defaultProps = {
	  errors: []
	};
	
	exports.LocationInput = LocationInput;
	
	// {
	//   this.props.errors && this.props.errors.length > 0 &&
	//   <label className="ui red basic label">
	//     {this.props.errors.map((error, key) => <div key={key}>{error}</div>)}
	//   </label>
	// }

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSortableHoc = __webpack_require__(405);
	
	var _bluebird = __webpack_require__(124);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _FileInput = __webpack_require__(158);
	
	var _FileInput2 = _interopRequireDefault(_FileInput);
	
	var _files = __webpack_require__(108);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortableItem = (0, _reactSortableHoc.SortableElement)(function (props) {
	  return _react2.default.createElement(_FileInput2.default, props);
	});
	
	var SortableList = (0, _reactSortableHoc.SortableContainer)(function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'fieldItemsContainer' },
	    props.items.map(function (item, index) {
	      return _react2.default.createElement(SortableItem, {
	        key: 'item-' + index,
	        index: index,
	        item: item,
	        files: props.files,
	        filesUrls: {},
	        extraData: (props.extraData || [])[index] || {},
	        onDrop: props.onDrop,
	        onRemove: props.onRemove
	      });
	    })
	  );
	});
	
	var FileInputSortableList = function (_Component) {
	  _inherits(FileInputSortableList, _Component);
	
	  function FileInputSortableList(props) {
	    _classCallCheck(this, FileInputSortableList);
	
	    var _this = _possibleConstructorReturn(this, (FileInputSortableList.__proto__ || Object.getPrototypeOf(FileInputSortableList)).call(this, props));
	
	    var files = {};
	
	    props.items.forEach(function (item) {
	      files[item.name] = item.initialValue;
	    });
	
	    _this.state = { files: files };
	
	    _this.setBackgroundSizes(files);
	    return _this;
	  }
	
	  _createClass(FileInputSortableList, [{
	    key: 'setBackgroundSizes',
	    value: function setBackgroundSizes(files) {
	      var _this2 = this;
	
	      var pGetBackgroundSize = _bluebird2.default.promisify(_files.getBackgroundSize);
	
	      var filesUrls = _lodash2.default.values(files);
	
	      _bluebird2.default.map(filesUrls, function (fileUrl) {
	        return pGetBackgroundSize(fileUrl).then(function (backgroundSize) {
	          return { backgroundSize: backgroundSize };
	        });
	      }).then(function (backgroundSizes) {
	        // Let's put the generated backgroundSizes in the first element of extradata
	        _this2.setState({ extraData: backgroundSizes });
	      });
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(name, file) {
	      var _this3 = this;
	
	      var files = _extends({}, this.state.files, _defineProperty({}, name, file));
	
	      this.setState({ files: files }, function () {
	        _this3.props.onDrop(name, file);
	
	        _this3.setBackgroundSizes(files);
	      });
	    }
	  }, {
	    key: 'onRemove',
	    value: function onRemove(name, file) {
	      var _this4 = this;
	
	      var files = _extends({}, this.state.files, _defineProperty({}, name, undefined));
	
	      this.setState({ files: files }, function () {
	        _this4.props.onRemove(name, file);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props = this.props,
	          hidden = _props.hidden,
	          customClassNames = _props.customClassNames,
	          bigLabel = _props.bigLabel,
	          label = _props.label,
	          items = _props.items,
	          errors = _props.errors,
	          onChange = _props.onChange;
	
	
	      var files = this.state.files;
	
	      return _react2.default.createElement(
	        'div',
	        { className: _classnames2.default.apply(undefined, ['field', { hidden: hidden }].concat(_toConsumableArray(customClassNames || []))) },
	        bigLabel && _react2.default.createElement(
	          'label',
	          { className: 'bigLabel' },
	          bigLabel
	        ),
	        _react2.default.createElement(
	          'label',
	          null,
	          label
	        ),
	        _react2.default.createElement(SortableList, {
	          items: items,
	          extraData: this.state.extraData,
	          files: files,
	          onDrop: this.onDrop.bind(this),
	          onRemove: this.onRemove.bind(this),
	          axis: 'xy',
	          pressDelay: 100,
	          onSortEnd: function onSortEnd(_ref) {
	            var oldIndex = _ref.oldIndex,
	                newIndex = _ref.newIndex;
	
	            var keys = Object.keys(files).filter(function (k) {
	              return files[k];
	            });
	            var updatedFiles = {};
	
	            updatedFiles[keys[newIndex]] = files[keys[oldIndex]];
	
	            if (oldIndex < newIndex) {
	              for (var i = newIndex; i > oldIndex; i--) {
	                updatedFiles[keys[i - 1]] = files[keys[i]];
	              }
	            } else {
	              for (var _i = newIndex; _i < oldIndex; _i++) {
	                updatedFiles[keys[_i + 1]] = files[keys[_i]];
	              }
	            }
	
	            var sortedFiles = _extends({}, files, updatedFiles);
	
	            _this5.setState({ files: sortedFiles }, function () {
	              onChange(updatedFiles);
	            });
	
	            _this5.setBackgroundSizes(sortedFiles);
	          }
	        }),
	        (errors || []).length > 0 && _react2.default.createElement(
	          'label',
	          { className: 'ui red basic label' },
	          errors.map(function (error, key) {
	            return _react2.default.createElement(
	              'div',
	              { key: key },
	              error
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return FileInputSortableList;
	}(_react.Component);
	
	FileInputSortableList.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.string,
	  bigLabel: _propTypes2.default.string,
	  items: _propTypes2.default.array,
	  type: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  initialValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]),
	  onChange: _propTypes2.default.func.isRequired,
	  onDrop: _propTypes2.default.func,
	  hidden: _propTypes2.default.bool,
	  errors: _propTypes2.default.array,
	  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	FileInputSortableList.defaultProps = {
	  type: 'text',
	  initialValue: '',
	  placeholder: ''
	};
	
	exports.default = FileInputSortableList;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(157);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Input = __webpack_require__(160);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _InputList = __webpack_require__(161);
	
	var _InputList2 = _interopRequireDefault(_InputList);
	
	var _LocationInput = __webpack_require__(162);
	
	var _LocationInput2 = _interopRequireDefault(_LocationInput);
	
	var _FileInputList = __webpack_require__(159);
	
	var _FileInputList2 = _interopRequireDefault(_FileInputList);
	
	var _FileInputSortableList = __webpack_require__(289);
	
	var _FileInputSortableList2 = _interopRequireDefault(_FileInputSortableList);
	
	var _logging = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formElementFactory = function formElementFactory(type, isList, useFramework7) {
	
	  var InputF7 = void 0,
	      LocationInputF7 = void 0;
	  if (useFramework7) {
	    var _require = __webpack_require__(106);
	
	    InputF7 = _require.Input;
	    LocationInputF7 = _require.LocationInput;
	  }
	
	  switch (type) {
	    case 'location':
	      return useFramework7 ? LocationInputF7 : _LocationInput2.default;
	
	    case 'file':
	      return _FileInputList2.default;
	
	    case 'file-sortable':
	      return _FileInputSortableList2.default;
	
	    case 'button':
	      return _Button2.default;
	
	    default:
	      if (isList) {
	        return _InputList2.default;
	      }
	      return useFramework7 ? InputF7 : _Input2.default;
	  }
	};
	
	var getFramework7Form = function getFramework7Form(props, inputElements, onSubmit, framework7AppContext) {
	  var _require2 = __webpack_require__(106),
	      FormF7 = _require2.Form;
	
	  return _react2.default.createElement(
	    FormF7,
	    {
	      inset: false,
	      submitButtonLabel: props.submitButtonLabel,
	      cancelButtonLabel: props.cancelButtonLabel,
	      formTitle: props.formTitle,
	      onSubmit: onSubmit,
	      onCancel: props.onCancel,
	      topElement: props.topElement,
	      bottomElement: props.bottomElement,
	      framework7AppContext: framework7AppContext,
	      submitClassNames: props.submitClassNames
	    },
	    inputElements
	  );
	};
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form(props) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onSubmit = _this.onSubmit.bind(_this);
	
	    _this.formData = {};
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initForm();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.initForm();
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(obj) {
	      var _this2 = this;
	
	      Object.keys(obj).forEach(function (id) {
	        _lodash2.default.set(_this2.formData, id, obj[id]);
	      });
	    }
	  }, {
	    key: 'onSubmit',
	    value: function onSubmit(event) {
	      if (event && event.preventDefault) {
	        event.preventDefault();
	      }
	      this.props.onSubmit(this.formData);
	    }
	  }, {
	    key: 'initForm',
	    value: function initForm() {
	      var _this3 = this;
	
	      /* We are going to overwrite the elements in this.formData only if their value was null or undefined */
	
	      this.props.data.forEach(function (d) {
	
	        if (d.items) {
	          d.items.forEach(function (item) {
	            var value = _lodash2.default.get(_this3.formData, item.name);
	
	            if (value === null || value === false || typeof value === 'undefined') {
	              _lodash2.default.set(_this3.formData, item.name, item.initialValue);
	            }
	          });
	        } else {
	          var value = _lodash2.default.get(_this3.formData, d.name);
	
	          if (value === null || value === false || typeof value === 'undefined') {
	            _lodash2.default.set(_this3.formData, d.name, d.initialValue);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          isSaving = _props.isSaving,
	          submitContainerClassNames = _props.submitContainerClassNames,
	          onCancel = _props.onCancel,
	          framework7AppContext = _props.framework7AppContext;
	
	
	      var customClassNames = this.props.customClassNames || [];
	
	      var baseFormClasses = 'ui form arreebaForm ' + customClassNames.join(' ');
	
	      var formClasses = isSaving ? baseFormClasses + ' loading' : baseFormClasses;
	
	      var submitClassNames = ['positive'];
	      if (this.props.submitClassNames) {
	        submitClassNames = Array.isArray(this.props.submitClassNames) ? this.props.submitClassNames : [this.props.submitClassNames];
	      }
	
	      var cancelButtonLabel = this.props.cancelButtonLabel || 'Annulla';
	      var submitButtonLabel = this.props.submitButtonLabel || 'Salva';
	
	      var inputElements = _lodash2.default.map(this.props.data, function (element) {
	
	        if (!element) {
	          return null;
	        }
	
	        if (element.customComponent) {
	          return _react2.default.createElement(
	            'div',
	            {
	              key: element.name,
	              name: element.name,
	              className: _classnames2.default.apply(undefined, ['field'].concat(_toConsumableArray(element.customClassNames || []), [{ hidden: element.hidden }]))
	            },
	            element.customComponent
	          );
	        }
	
	        var elementConfig = _extends({}, element);
	
	        if (elementConfig.removable && !elementConfig.onRemoveItem) {
	          (0, _logging.warn)('Found an element with "removable: true" but without the callback "onRemoveItem".', elementConfig);
	        }
	
	        if (elementConfig.type === 'file' || elementConfig.type === 'file-sortable') {
	
	          elementConfig.onDrop = function (name, file) {
	            _lodash2.default.set(_this4.formData, name, file);
	          };
	
	          elementConfig.onRemove = function (name, file) {
	            // We want to match 'type' in these example patterns:
	            // files.type[0] or type[0]
	            var m = name.match(/([^\[].*)\[/)[1].split('.');
	            var fileType = m[m.length - 1];
	
	            _lodash2.default.set(_this4.formData, name, undefined);
	
	            if (typeof file === 'string') {
	
	              if (!_this4.formData.removedFilesUrls) {
	                _this4.formData.removedFilesUrls = {};
	              }
	              if (!_this4.formData.removedFilesUrls[fileType]) {
	                _this4.formData.removedFilesUrls[fileType] = [];
	              }
	              if (_this4.formData.removedFilesUrls[fileType].indexOf(file) < 0) {
	                _this4.formData.removedFilesUrls[fileType].push(file);
	              }
	            }
	          };
	        }
	
	        if (elementConfig.type === 'file-sortable') {
	          elementConfig.onSortingChange = function (obj) {
	            _this4.onChange(obj);
	          };
	        }
	
	        var InputComponent = formElementFactory(elementConfig.type, !!elementConfig.items, !!framework7AppContext);
	
	        return _react2.default.createElement(InputComponent, _extends({
	          key: element.name
	        }, elementConfig, {
	          onChange: function onChange(obj) {
	            _this4.onChange(obj);
	            if (element.onChange) {
	              element.onChange(obj);
	            }
	          },
	          errors: _this4.props.errors[element.name]
	        }));
	      }).filter(function (e) {
	        return e;
	      }); // filter out null elements
	
	      if (framework7AppContext) {
	        return getFramework7Form(this.props, inputElements, this.onSubmit, framework7AppContext);
	      }
	
	      return _react2.default.createElement(
	        'form',
	        { className: formClasses, onSubmit: this.onSubmit },
	        inputElements,
	        _react2.default.createElement(
	          'div',
	          { className: 'formButtonsContainer' },
	          _react2.default.createElement(
	            'div',
	            { className: _classnames2.default.apply(undefined, ['ui', 'buttons'].concat(_toConsumableArray(submitContainerClassNames || []))) },
	            onCancel && _react2.default.createElement(
	              'button',
	              { className: 'ui button', type: 'reset', onClick: onCancel },
	              cancelButtonLabel
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: _classnames2.default.apply(undefined, ['ui', 'button'].concat(_toConsumableArray(submitClassNames))),
	                type: 'submit'
	              },
	              submitButtonLabel
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  data: _propTypes2.default.array,
	  defaultValues: _propTypes2.default.object,
	  onChange: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func.isRequired,
	  onSubmitClick: _propTypes2.default.func,
	  onCancel: _propTypes2.default.func,
	  isSaving: _propTypes2.default.bool,
	  errors: _propTypes2.default.object,
	  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  submitClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  submitContainerClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  cancelButtonLabel: _propTypes2.default.string,
	  submitButtonLabel: _propTypes2.default.string,
	  topElement: _propTypes2.default.object,
	  bottomElement: _propTypes2.default.object,
	  framework7AppContext: _propTypes2.default.object
	};
	
	exports.default = Form;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _bluebird = __webpack_require__(124);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _UndefinedContent = __webpack_require__(107);
	
	var _UndefinedContent2 = _interopRequireDefault(_UndefinedContent);
	
	var _files = __webpack_require__(108);
	
	var _browser = __webpack_require__(294);
	
	var _formElementsTypes = __webpack_require__(293);
	
	var _PictureModal = __webpack_require__(163);
	
	var _PictureModal2 = _interopRequireDefault(_PictureModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getSummaryData = function getSummaryData(data, downloadOnClick, extraData, toggleImageModal) {
	  return data.map(function (item, i) {
	    return _react2.default.createElement(
	      'div',
	      { key: i, className: _classnames2.default.apply(undefined, ['item'].concat(_toConsumableArray(item.customClassNames || []), [{ hidden: item.hidden }])) },
	      item.label && _react2.default.createElement(
	        'span',
	        { className: 'ui horizontal label' },
	        item.label
	      ),
	      !item.value && _react2.default.createElement(_UndefinedContent2.default, null),
	      !Array.isArray(item.value) && item.value,
	      Array.isArray(item.value) && item.value.length > 0 && _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('summaryItemsList', (item.type || 'text') + 'SummaryItemsList') },
	        item.value.map(function (valueItem, j) {
	          return _react2.default.createElement(
	            'div',
	            { key: j, className: 'summaryItemsListItem' },
	            item.type === _formElementsTypes.FILES_URLS && (0, _files.isImage)(valueItem) && _react2.default.createElement(
	              'a',
	              {
	                href: valueItem,
	                onClick: function onClick(event) {
	                  if (!downloadOnClick) {
	                    (0, _browser.stopPropagation)(event);
	                    toggleImageModal(valueItem, true);
	                  }
	                }
	              },
	              _react2.default.createElement('div', {
	                className: 'filePreview imagePreview',
	                style: {
	                  backgroundImage: 'url("' + valueItem + '")',
	                  backgroundSize: ((extraData[i] || {})[j] || {}).backgroundSize || 'auto 100%'
	                }
	              })
	            ),
	            item.type === _formElementsTypes.FILES_URLS && (0, _files.isImage)(valueItem) && extraData[i] && (extraData[i][j] || {}).shouldShowModal && _react2.default.createElement(_PictureModal2.default, {
	              shouldShowModal: true,
	              onModalHide: function onModalHide() {
	                return toggleImageModal(valueItem, false);
	              },
	              file: valueItem
	            }),
	            item.type === _formElementsTypes.FILES_URLS && !(0, _files.isImage)(valueItem) && _react2.default.createElement(
	              'a',
	              { className: 'filePreview', href: valueItem },
	              _react2.default.createElement(
	                'div',
	                null,
	                (0, _files.getFilename)(valueItem)
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement('i', { className: (0, _classnames2.default)('file', (0, _files.getExtension)(valueItem), 'outline', 'icon') })
	              )
	            ),
	            item.type !== _formElementsTypes.FILES_URLS && valueItem
	          );
	        })
	      ),
	      Array.isArray(item.value) && item.value.length === 0 && _react2.default.createElement(_UndefinedContent2.default, null)
	    );
	  });
	};
	
	var FormSummary = function (_Component) {
	  _inherits(FormSummary, _Component);
	
	  function FormSummary(props) {
	    _classCallCheck(this, FormSummary);
	
	    var _this = _possibleConstructorReturn(this, (FormSummary.__proto__ || Object.getPrototypeOf(FormSummary)).call(this, props));
	
	    _this.state = {
	      extraData: []
	    };
	    return _this;
	  }
	
	  _createClass(FormSummary, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.tryInit(this.props.data);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.tryInit(nextProps.data);
	    }
	  }, {
	    key: 'toggleImageModal',
	    value: function toggleImageModal(url, shouldShowModal) {
	      var data = this.props.data;
	
	
	      var imageIndex = data[0].value.indexOf(url);
	
	      // Let's put the generated backgroundSizes in the first element of extraData
	      var extraData = [].concat(_toConsumableArray(this.state.extraData))[0] || [];
	
	      extraData = _lodash2.default.range(data[0].value.length).map(function (i) {
	        return _extends({}, extraData[i] || {}, {
	          shouldShowModal: shouldShowModal && i === imageIndex
	        });
	      });
	
	      this.setState({ extraData: [extraData] });
	    }
	  }, {
	    key: 'tryInit',
	    value: function tryInit(data) {
	      var _this2 = this;
	
	      // In this function, since we are looking for file urls, we will assume
	      // that in that case data contains only one element.
	      if (!data || (data[0] || {}).type !== _formElementsTypes.FILES_URLS) {
	        return;
	      }
	
	      var pGetBackgroundSize = _bluebird2.default.promisify(_files.getBackgroundSize);
	
	      _bluebird2.default.map(data[0].value, function (fileUrl) {
	        return pGetBackgroundSize(fileUrl);
	      }).then(function (backgroundSizes) {
	
	        // Let's put the generated backgroundSizes in the first element of extraData
	        var extraData = [].concat(_toConsumableArray(_this2.state.extraData))[0] || [];
	
	        extraData = _lodash2.default.range(data[0].value.length).map(function (i) {
	          return _extends({}, extraData[i] || {}, {
	            backgroundSize: backgroundSizes[i]
	          });
	        });
	
	        _this2.setState({ extraData: [extraData] });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          downloadOnClick = _props.downloadOnClick,
	          action = _props.action,
	          canEditForm = _props.canEditForm,
	          editButtonLabel = _props.editButtonLabel;
	
	
	      if (!data) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('infoList', { editable: canEditForm }) },
	        _react2.default.createElement(
	          'div',
	          { className: 'ui divided list' },
	          getSummaryData(data, downloadOnClick, this.state.extraData, this.toggleImageModal.bind(this))
	        ),
	        canEditForm && _react2.default.createElement(
	          'button',
	          { onClick: action, className: 'ui labeled icon button right floated' },
	          _react2.default.createElement('i', { className: 'edit icon' }),
	          ' ',
	          editButtonLabel
	        )
	      );
	    }
	  }]);
	
	  return FormSummary;
	}(_react.Component);
	
	;
	
	FormSummary.propTypes = {
	  data: _propTypes2.default.array.isRequired,
	  action: _propTypes2.default.func.isRequired,
	  canEditForm: _propTypes2.default.bool,
	  editButtonLabel: _propTypes2.default.string,
	  downloadOnClick: _propTypes2.default.bool
	};
	
	FormSummary.defaultProps = {
	  canEditForm: true
	};
	
	exports.default = FormSummary;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.UndefinedContent = exports.LocationInput = exports.InputList = exports.Input = exports.FormSummary = exports.Form = exports.FileInputList = exports.Button = undefined;
	
	var _Button = __webpack_require__(157);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FileInputList = __webpack_require__(159);
	
	var _FileInputList2 = _interopRequireDefault(_FileInputList);
	
	var _Form = __webpack_require__(290);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _FormSummary = __webpack_require__(291);
	
	var _FormSummary2 = _interopRequireDefault(_FormSummary);
	
	var _Input = __webpack_require__(160);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _InputList = __webpack_require__(161);
	
	var _InputList2 = _interopRequireDefault(_InputList);
	
	var _LocationInput = __webpack_require__(162);
	
	var _LocationInput2 = _interopRequireDefault(_LocationInput);
	
	var _UndefinedContent = __webpack_require__(107);
	
	var _UndefinedContent2 = _interopRequireDefault(_UndefinedContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Button = _Button2.default;
	exports.FileInputList = _FileInputList2.default;
	exports.Form = _Form2.default;
	exports.FormSummary = _FormSummary2.default;
	exports.Input = _Input2.default;
	exports.InputList = _InputList2.default;
	exports.LocationInput = _LocationInput2.default;
	exports.UndefinedContent = _UndefinedContent2.default;

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FILES_URLS = exports.FILES_URLS = 'filesUrls';

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var stopPropagation = exports.stopPropagation = function stopPropagation(event) {
	
	  if (!event) {
	    return;
	  }
	
	  if (typeof event.preventDefault === 'function') {
	    event.preventDefault();
	  }
	
	  if (typeof event.stopPropagation === 'function') {
	    event.stopPropagation();
	  }
	
	  if (event.nativeEvent && typeof event.nativeEvent.stopImmediatePropagation === 'function') {
	    event.nativeEvent.stopImmediatePropagation();
	  }
	};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _creditCard = __webpack_require__(208);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Every validator should be a boolean pure function with an 'errorMessage' property */
	
	var EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	
	var DATE_DDMMYYYY_REGEX = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
	
	var string = function string(value) {
	  return typeof value === 'string' && value.length > 0 && !/^\s*$/.test(value);
	};
	string.errorMessage = 'Campo obbligatorio';
	
	var text = function text(value) {
	  return typeof value === 'string' && value.length > 0 && !/^\s*$/.test(value);
	};
	text.errorMessage = 'Campo inserito non valido';
	
	var email = function email(value) {
	  return EMAIL_REGEX.test(value);
	};
	email.errorMessage = 'Indirizzo email non valido';
	
	var number = function number(value) {
	
	  if (typeof value === 'string') {
	    return (/^[0-9]+\.?([0-9]{1,2})?$/.test(value)
	    );
	  }
	
	  return typeof value === 'number';
	};
	number.errorMessage = 'Consentiti solo caratteri numerici (usa il . in caso di decimali).';
	
	var coordinate = function coordinate(value) {
	
	  if (typeof value === 'string') {
	    return (/^[0-9]+\.[0-9]+$/.test(value)
	    );
	  }
	
	  return typeof value === 'number';
	};
	coordinate.errorMessage = 'Consentiti solo caratteri numerici (usa il . in caso di decimali)';
	
	var integer = function integer(value) {
	
	  if (typeof value === 'number' || typeof value === 'string') {
	    return (/^[0-9]+$/.test(value.toString())
	    );
	  }
	
	  return false;
	};
	integer.errorMessage = 'Consentiti solo caratteri numerici';
	
	var phoneNumber = function phoneNumber(value) {
	
	  /* The value should not be an integer, we need a string containing numbers. */
	  if (typeof value === 'string') {
	    return (/^\+?[0-9]{8,}$/.test(value)
	    );
	  }
	
	  return false;
	};
	phoneNumber.errorMessage = 'Inserire un numero di telefono corretto';
	
	var boolean = function boolean(value) {
	  return typeof value === 'boolean';
	};
	boolean.errorMessage = 'Selezionare un elemento';
	
	var date = function date(value) {
	  if (typeof value !== 'string') {
	    return false;
	  }
	
	  return DATE_DDMMYYYY_REGEX.test(value);
	};
	date.errorMessage = 'Inserire una data valida';
	
	var time = function time(value) {
	  if (typeof value !== 'string') {
	    return false;
	  }
	
	  return (/^([0-1][0-9]|2[0-3]):([0-5][0-9])$/.test(value)
	  );
	};
	time.errorMessage = 'Inserire un orario valido';
	
	var slot = function slot(value) {
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
	    return false;
	  }
	
	  return time(value.open) && time(value.close);
	};
	slot.errorMessage = 'Inserire un orario valido';
	
	var file = function file(value) {
	  return value instanceof File;
	};
	file.errorMessage = 'Caricare un file valido';
	
	var creditCardNumber = function creditCardNumber(value) {
	  return _creditCard2.default.luhn(value);
	};
	creditCardNumber.errorMessage = 'Inserire un numero di carta di credito valido';
	
	var creditCardExpiryMonth = function creditCardExpiryMonth(value) {
	  return _creditCard2.default.isValidExpiryMonth(value);
	};
	creditCardExpiryMonth.errorMessage = 'Inserire un mese valido per la data di scadenza (formato mm)';
	
	var creditCardExpiryYear = function creditCardExpiryYear(value) {
	  return _creditCard2.default.isValidExpiryYear(value);
	};
	creditCardExpiryYear.errorMessage = 'Inserire un anno valido per la data di scadenza (formato aaaa)';
	
	var creditCardCVC = function creditCardCVC(value) {
	  return (/^[0-9]{3,4}$/.test(value)
	  );
	};
	creditCardCVC.errorMessage = 'Inserire un codice di sicurezza valido';
	
	exports.default = {
	  string: string,
	  text: text,
	  email: email,
	  phoneNumber: phoneNumber,
	  number: number,
	  coordinate: coordinate,
	  integer: integer,
	  boolean: boolean,
	  date: date,
	  time: time,
	  slot: slot,
	  file: file,
	  creditCardNumber: creditCardNumber,
	  creditCardExpiryMonth: creditCardExpiryMonth,
	  creditCardExpiryYear: creditCardExpiryYear,
	  creditCardCVC: creditCardCVC
	};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Accordion = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueAccordion,
	    name: 'Accordion',
	    tag: 'f7-accordion'
	});
	
	//# sourceMappingURL=Accordion.js.map


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.AccordionContent = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueAccordionContent,
	    name: 'AccordionContent',
	    tag: 'f7-accordion-content'
	});
	
	//# sourceMappingURL=AccordionContent.js.map


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.AccordionItem = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueAccordionItem,
	    name: 'AccordionItem',
	    tag: 'f7-accordion-item',
	    events: [
	        'accordion:open',
	        'accordion:opened',
	        'accordion:close',
	        'accordion:closed'
	    ]
	});
	
	//# sourceMappingURL=AccordionItem.js.map


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.AccordionToggle = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueAccordionToggle,
	    name: 'AccordionToggle',
	    tag: 'f7-accordion-toggle'
	});
	
	//# sourceMappingURL=AccordionToggle.js.map


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Actions = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueActions,
	    name: 'Actions',
	    tag: 'f7-actions',
	    events: [
	        'actions:open',
	        'actions:opened',
	        'actions:close',
	        'actions:closed'
	    ]
	});
	
	//# sourceMappingURL=Actions.js.map


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ActionsButton = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueActionsButton,
	    name: 'ActionsButton',
	    tag: 'f7-actions-button',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=ActionsButton.js.map


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ActionsGroup = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueActionsGroup,
	    name: 'ActionsGroup',
	    tag: 'f7-actions-group'
	});
	
	//# sourceMappingURL=ActionsGroup.js.map


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ActionsLabel = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueActionsLabel,
	    name: 'ActionsLabel',
	    tag: 'f7-actions-label',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=ActionsLabel.js.map


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var Icon_1 = __webpack_require__(112);
	var framework7_vue_2 = __webpack_require__(2);
	exports.Button = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueButton,
	    name: 'Button',
	    tag: 'f7-button',
	    events: [
	        'click'
	    ],
	    instantiatedComponents: [
	        Icon_1.Icon
	    ],
	    mixin: framework7_vue_2.VueLinkMixin
	});
	
	//# sourceMappingURL=Button.js.map


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ButtonsSegmented = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueButtonsSegmented,
	    name: 'ButtonsSegmented',
	    tag: 'f7-segmented'
	});
	
	//# sourceMappingURL=ButtonsSegmented.js.map


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var framework7_vue_2 = __webpack_require__(2);
	exports.Calendar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueCalendar,
	    name: 'Calendar',
	    tag: 'f7-calendar',
	    events: [
	        'change',
	        'monthAdd',
	        'dayClick',
	        'monthYearChangeStart',
	        'monthYearChangeEnd',
	        'open',
	        'close'
	    ],
	    mixin: framework7_vue_2.VueCalendarDatePickerMixin
	});
	
	//# sourceMappingURL=Calendar.js.map


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var CardHeader_1 = __webpack_require__(167);
	var CardFooter_1 = __webpack_require__(166);
	var CardContent_1 = __webpack_require__(165);
	exports.Card = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueCard,
	    name: 'Card',
	    tag: 'f7-card',
	    instantiatedComponents: [
	        CardHeader_1.CardHeader,
	        CardFooter_1.CardFooter,
	        CardContent_1.CardContent
	    ]
	});
	
	//# sourceMappingURL=Card.js.map


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Chip = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueChip,
	    name: 'Chip',
	    tag: 'f7-chip',
	    events: [
	        'click',
	        'delete'
	    ]
	});
	
	//# sourceMappingURL=Chip.js.map


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ContentBlock = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueContentBlock,
	    name: 'ContentBlock',
	    tag: 'f7-block',
	    events: [
	        'tab:show',
	        'tab:hide'
	    ]
	});
	
	//# sourceMappingURL=ContentBlock.js.map


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ContentBlockTitle = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueContentBlockTitle,
	    name: 'ContentBlockTitle',
	    tag: 'f7-list-block-title'
	});
	
	//# sourceMappingURL=ContentBlockTitle.js.map


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var DataTableHeader_1 = __webpack_require__(168);
	var DataTableCell_1 = __webpack_require__(111);
	var DataTableRow_1 = __webpack_require__(169);
	exports.DataTable = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueDataTable,
	    name: 'DataTable',
	    tag: 'f7-table',
	    instantiatedComponents: [
	        DataTableHeader_1.DataTableHeader,
	        DataTableCell_1.DataTableCell,
	        DataTableRow_1.DataTableRow
	    ],
	    slots: [
	        'before-table',
	        'after-table'
	    ]
	});
	
	//# sourceMappingURL=DataTable.js.map


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.DataTableActions = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueDataTableActions,
	    name: 'DataTableActions',
	    tag: 'f7-table-actions'
	});
	
	//# sourceMappingURL=DataTableActions.js.map


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.DataTableLinks = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueDataTableLinks,
	    name: 'DataTableLinks',
	    tag: 'f7-table-links'
	});
	
	//# sourceMappingURL=DataTableLinks.js.map


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var framework7_vue_2 = __webpack_require__(2);
	exports.Datepicker = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueDatepicker,
	    name: 'Datepicker',
	    tag: 'undefined',
	    events: [
	        'change',
	        'monthAdd',
	        'dayClick',
	        'monthYearChangeStart',
	        'monthYearChangeEnd',
	        'open',
	        'close'
	    ],
	    mixin: framework7_vue_2.VueCalendarDatePickerMixin
	});
	
	//# sourceMappingURL=Datepicker.js.map


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Fab = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFab,
	    name: 'Fab',
	    tag: 'f7-fab',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=Fab.js.map


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.FabSpeedDial = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFabSpeedDial,
	    name: 'FabSpeedDial',
	    tag: 'f7-fab-speed-dial'
	});
	
	//# sourceMappingURL=FabSpeedDial.js.map


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.FabSpeedDialAction = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFabSpeedDialAction,
	    name: 'FabSpeedDialAction',
	    tag: 'undefined',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=FabSpeedDialAction.js.map


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.FabSpeedDialActions = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFabSpeedDialActions,
	    name: 'FabSpeedDialActions',
	    tag: 'undefined'
	});
	
	//# sourceMappingURL=FabSpeedDialActions.js.map


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var FormSwitch_1 = __webpack_require__(172);
	var FormRange_1 = __webpack_require__(171);
	exports.FormInput = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFormInput,
	    name: 'FormInput',
	    tag: 'f7-input',
	    events: [
	        'input',
	        'focus',
	        'blur',
	        'change',
	        'click',
	        'keypress',
	        'keyup',
	        'keydown',
	        'beforeinput',
	        'compositionstart',
	        'compositionupdate',
	        'compositionend',
	        'focusin',
	        'focusout',
	        'dblclick',
	        'mousedown',
	        'mouseenter',
	        'mouseleave',
	        'mousemove',
	        'mouseout',
	        'mouseover',
	        'mouseup',
	        'wheel',
	        'select'
	    ],
	    instantiatedComponents: [
	        FormSwitch_1.FormSwitch,
	        FormRange_1.FormRange
	    ]
	});
	
	//# sourceMappingURL=FormInput.js.map


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.FormLabel = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueFormLabel,
	    name: 'FormLabel',
	    tag: 'f7-label'
	});
	
	//# sourceMappingURL=FormLabel.js.map


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.GridCol = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueGridCol,
	    name: 'GridCol',
	    tag: 'f7-col'
	});
	
	//# sourceMappingURL=GridCol.js.map


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.GridRow = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueGridRow,
	    name: 'GridRow',
	    tag: 'f7-grid'
	});
	
	//# sourceMappingURL=GridRow.js.map


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.List = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueList,
	    name: 'List',
	    tag: 'f7-list',
	    events: [
	        'sortable:open',
	        'sortable:close',
	        'sortable:sort',
	        'tab:show',
	        'tab:hide',
	        'virtual:itembeforeinsert',
	        'virtual:beforeclear',
	        'virtual:itemsbeforeinsert',
	        'virtual:itemsafterinsert'
	    ]
	});
	
	//# sourceMappingURL=List.js.map


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ListButton = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListButton,
	    name: 'ListButton',
	    tag: 'f7-list-button',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=ListButton.js.map


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ListGroup = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListGroup,
	    name: 'ListGroup',
	    tag: 'f7-list-group'
	});
	
	//# sourceMappingURL=ListGroup.js.map


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var ListItemContent_1 = __webpack_require__(173);
	exports.ListItem = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListItem,
	    name: 'ListItem',
	    tag: 'f7-list-item',
	    events: [
	        'click',
	        'swipeout:deleted',
	        'swipeout:delete',
	        'swipeout:close',
	        'swipeout:closed',
	        'swipeout:open',
	        'swipeout:opened',
	        'swipeout',
	        'accordion:close',
	        'accordion:closed',
	        'accordion:open',
	        'accordion:opened',
	        'input',
	        'change'
	    ],
	    instantiatedComponents: [
	        ListItemContent_1.ListItemContent
	    ],
	    slots: [
	        'content-start',
	        'media-start',
	        'inner-start',
	        'after-start',
	        'root-start',
	        'content',
	        'media',
	        'inner',
	        'after',
	        'root'
	    ]
	});
	
	//# sourceMappingURL=ListItem.js.map


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ListItemSwipeoutActions = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListItemSwipeoutActions,
	    name: 'ListItemSwipeoutActions',
	    tag: 'f7-swipeout-actions'
	});
	
	//# sourceMappingURL=ListItemSwipeoutActions.js.map


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ListItemSwipeoutButton = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListItemSwipeoutButton,
	    name: 'ListItemSwipeoutButton',
	    tag: 'f7-swipeout-button',
	    events: [
	        'click'
	    ]
	});
	
	//# sourceMappingURL=ListItemSwipeoutButton.js.map


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.ListLabel = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueListLabel,
	    name: 'ListLabel',
	    tag: 'f7-list-label'
	});
	
	//# sourceMappingURL=ListLabel.js.map


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.LoginScreen = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueLoginScreen,
	    name: 'LoginScreen',
	    tag: 'f7-login-screen',
	    events: [
	        'loginscreen:open',
	        'loginscreen:opened',
	        'loginscreen:close',
	        'loginscreen:closed'
	    ]
	});
	
	//# sourceMappingURL=LoginScreen.js.map


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.LoginScreenTitle = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueLoginScreenTitle,
	    name: 'LoginScreenTitle',
	    tag: 'f7-login-screen-title'
	});
	
	//# sourceMappingURL=LoginScreenTitle.js.map


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Message = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueMessage,
	    name: 'Message',
	    tag: 'f7-message',
	    events: [
	        'click',
	        'click:name',
	        'click:text',
	        'click:avatar'
	    ],
	    slots: [
	        'start',
	        'end'
	    ]
	});
	
	//# sourceMappingURL=Message.js.map


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var Link_1 = __webpack_require__(113);
	exports.Messagebar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueMessagebar,
	    name: 'Messagebar',
	    tag: 'f7-messagebar',
	    events: [
	        'change',
	        'input',
	        'focus',
	        'blur',
	        'submit',
	        'click'
	    ],
	    instantiatedComponents: [
	        Link_1.Link
	    ],
	    slots: [
	        'before-inner',
	        'before-textarea',
	        'after-textarea',
	        'after-inner'
	    ]
	});
	
	//# sourceMappingURL=Messagebar.js.map


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Messages = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueMessages,
	    name: 'Messages',
	    tag: 'f7-messages'
	});
	
	//# sourceMappingURL=Messages.js.map


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.NavRight = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueNavRight,
	    name: 'NavRight',
	    tag: 'f7-nav-right'
	});
	
	//# sourceMappingURL=NavRight.js.map


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Page = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePage,
	    name: 'Page',
	    tag: 'f7-page',
	    events: [
	        'ptr:pullstart',
	        'ptr:pullmove',
	        'ptr:pullend',
	        'ptr:refresh',
	        'ptr:done',
	        'infinite',
	        'page:beforeinit',
	        'page:init',
	        'page:reinit',
	        'page:beforeanimation',
	        'page:afteranimation',
	        'page:beforeremove',
	        'page:back',
	        'page:afterback'
	    ],
	    slots: [
	        'static',
	        'fixed'
	    ]
	});
	
	//# sourceMappingURL=Page.js.map


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.PageContent = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePageContent,
	    name: 'PageContent',
	    tag: 'f7-page-content',
	    events: [
	        'tab:show',
	        'tab:hide'
	    ]
	});
	
	//# sourceMappingURL=PageContent.js.map


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Panel = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePanel,
	    name: 'Panel',
	    tag: 'f7-panel',
	    events: [
	        'panel:open',
	        'panel:opened',
	        'panel:closed',
	        'panel:overlay-click',
	        'panel:swipe'
	    ]
	});
	
	//# sourceMappingURL=Panel.js.map


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.PhotoBrowser = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePhotoBrowser,
	    name: 'PhotoBrowser',
	    tag: 'f7-photo-browser',
	    events: [
	        'open',
	        'close',
	        'swipeToClose',
	        'slideChangeStart',
	        'slideChangeEnd',
	        'transitionStart',
	        'transitionEnd',
	        'click',
	        'tap',
	        'doubleTap',
	        'lazyImageLoad',
	        'lazyImageReady'
	    ]
	});
	
	//# sourceMappingURL=PhotoBrowser.js.map


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.PickerModal = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePickerModal,
	    name: 'PickerModal',
	    tag: 'f7-picker-modal',
	    events: [
	        'picker:open',
	        'picker:opened',
	        'picker:close',
	        'picker:closed'
	    ]
	});
	
	//# sourceMappingURL=PickerModal.js.map


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Popover = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePopover,
	    name: 'Popover',
	    tag: 'f7-popover',
	    events: [
	        'popover:open',
	        'popover:opened',
	        'popover:close',
	        'popover:closed'
	    ]
	});
	
	//# sourceMappingURL=Popover.js.map


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Popup = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePopup,
	    name: 'Popup',
	    tag: 'f7-popup',
	    events: [
	        'popup:open',
	        'popup:opened',
	        'popup:close',
	        'popup:closed'
	    ]
	});
	
	//# sourceMappingURL=Popup.js.map


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Preloader = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VuePreloader,
	    name: 'Preloader',
	    tag: 'f7-preloader'
	});
	
	//# sourceMappingURL=Preloader.js.map


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Progressbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueProgressbar,
	    name: 'Progressbar',
	    tag: 'f7-progressbar'
	});
	
	//# sourceMappingURL=Progressbar.js.map


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Searchbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueSearchbar,
	    name: 'Searchbar',
	    tag: 'f7-searchbar',
	    events: [
	        'change',
	        'input',
	        'focus',
	        'blur',
	        'submit',
	        'searchbar:search',
	        'searchbar:clear',
	        'searchbar:enable',
	        'searchbar:disable',
	        'click:clear',
	        'click:cancel'
	    ],
	    slots: [
	        'before-input',
	        'after-input'
	    ]
	});
	
	//# sourceMappingURL=Searchbar.js.map


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Statusbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueStatusbar,
	    name: 'Statusbar',
	    tag: 'undefined'
	});
	
	//# sourceMappingURL=Statusbar.js.map


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Subnavbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueSubnavbar,
	    name: 'Subnavbar',
	    tag: 'f7-subnavbar'
	});
	
	//# sourceMappingURL=Subnavbar.js.map


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Swiper = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueSwiper,
	    name: 'Swiper',
	    tag: 'f7-swiper'
	});
	
	//# sourceMappingURL=Swiper.js.map


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.SwiperSlide = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueSwiperSlide,
	    name: 'SwiperSlide',
	    tag: 'f7-swiper-slide'
	});
	
	//# sourceMappingURL=SwiperSlide.js.map


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Tab = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTab,
	    name: 'Tab',
	    tag: 'f7-tab',
	    events: [
	        'tab:show',
	        'tab:hide'
	    ]
	});
	
	//# sourceMappingURL=Tab.js.map


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Tabs = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTabs,
	    name: 'Tabs',
	    tag: 'f7-tabs'
	});
	
	//# sourceMappingURL=Tabs.js.map


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Template7Template = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTemplate7Template,
	    name: 'Template7Template',
	    tag: 'undefined'
	});
	
	//# sourceMappingURL=Template7Template.js.map


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Timeline = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTimeline,
	    name: 'Timeline',
	    tag: 'f7-timeline'
	});
	
	//# sourceMappingURL=Timeline.js.map


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.TimelineItem = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTimelineItem,
	    name: 'TimelineItem',
	    tag: 'f7-timeline-item'
	});
	
	//# sourceMappingURL=TimelineItem.js.map


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.TimelineItemChild = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTimelineItemChild,
	    name: 'TimelineItemChild',
	    tag: 'f7-timeline-item-child'
	});
	
	//# sourceMappingURL=TimelineItemChild.js.map


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.TimelineMonth = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTimelineMonth,
	    name: 'TimelineMonth',
	    tag: 'f7-timeline-month'
	});
	
	//# sourceMappingURL=TimelineMonth.js.map


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.TimelineYear = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueTimelineYear,
	    name: 'TimelineYear',
	    tag: 'f7-timeline-year'
	});
	
	//# sourceMappingURL=TimelineYear.js.map


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Toolbar = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueToolbar,
	    name: 'Toolbar',
	    tag: 'f7-toolbar',
	    slots: [
	        'before-inner',
	        'after-inner'
	    ]
	});
	
	//# sourceMappingURL=Toolbar.js.map


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	var Pages_1 = __webpack_require__(177);
	var Navbar_1 = __webpack_require__(176);
	exports.View = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueView,
	    name: 'View',
	    tag: 'f7-view',
	    events: [
	        'swipeback:move',
	        'swipeback:beforechange',
	        'swipeback:afterchange',
	        'swipeback:beforereset',
	        'swipeback:afterreset',
	        'tab:show',
	        'tab:hide'
	    ],
	    instantiatedComponents: [
	        Pages_1.Pages,
	        Navbar_1.Navbar
	    ]
	});
	
	//# sourceMappingURL=View.js.map


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ReactifyF7Vue_1 = __webpack_require__(4);
	var framework7_vue_1 = __webpack_require__(2);
	exports.Views = ReactifyF7Vue_1.reactifyF7Vue({
	    component: framework7_vue_1.VueViews,
	    name: 'Views',
	    tag: 'f7-views'
	});
	
	//# sourceMappingURL=Views.js.map


/***/ }),
/* 361 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var combinePaths = function () {
	    var paths = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        paths[_i] = arguments[_i];
	    }
	    return paths.join('/').replace(/\/+/g, '/');
	};
	var flattenTabNestedRoutes = function (pageRoute, tabRoute, tabNestedRoutes) {
	    return tabNestedRoutes.map(function (tabNestedRoute) {
	        return {
	            path: combinePaths(pageRoute.path, tabRoute.path, tabNestedRoute.path),
	            pagePath: pageRoute.path,
	            component: pageRoute.component,
	            tab: {
	                tabId: tabRoute.tabId,
	                component: tabNestedRoute.component
	            }
	        };
	    });
	};
	var flattenTabRoutes = function (pageRoute, tabRoutes) {
	    return tabRoutes.reduce(function (accumulatedFlattenedRoutes, nextTabRoute) {
	        var flattenedTabRoutes;
	        if (nextTabRoute.routes) {
	            flattenedTabRoutes = flattenTabNestedRoutes(pageRoute, nextTabRoute, nextTabRoute.routes);
	        }
	        else {
	            flattenedTabRoutes = [{
	                    path: combinePaths(pageRoute.path, nextTabRoute.path),
	                    pagePath: pageRoute.path,
	                    component: pageRoute.component,
	                    tab: {
	                        tabId: nextTabRoute.tabId,
	                        component: nextTabRoute.component
	                    }
	                }];
	        }
	        return accumulatedFlattenedRoutes.concat(flattenedTabRoutes);
	    }, []);
	};
	var flattenRoutes = function (routes) {
	    if (routes === void 0) { routes = []; }
	    return routes.reduce(function (accumulatedFlattenedRoutes, nextRoute) {
	        var flattenedNextRoute;
	        if (nextRoute.tabs) {
	            flattenedNextRoute = flattenTabRoutes(nextRoute, nextRoute.tabs);
	        }
	        else {
	            flattenedNextRoute = [Object.assign({}, nextRoute, {
	                    pagePath: nextRoute.path
	                })];
	        }
	        return accumulatedFlattenedRoutes.concat(flattenedNextRoute);
	    }, []);
	};
	var parseRoute = function (str) {
	    var parts = [];
	    str.split('/').forEach(function (part) {
	        if (part !== '') {
	            if (part.indexOf(':') === 0) {
	                parts.push({ name: part.replace(':', '') });
	            }
	            else
	                parts.push(part);
	        }
	    });
	    return parts;
	};
	function handleRouteChangeFromFramework7(view, options, changeRouteCallback) {
	    if (!view.allowPageChange)
	        return false;
	    var url = options.url;
	    var pageElement = options.pageElement;
	    if (url && pageElement || !url || url === '#') {
	        return true;
	    }
	    var inHistory = view.history.indexOf(url) >= 0;
	    var inDomCache = view.pagesCache[url];
	    if (inHistory && inDomCache)
	        return true;
	    return changeRouteCallback(url, view, options);
	}
	var Framework7Router = (function () {
	    function Framework7Router(originalRoutes, framework7, dom7) {
	        var _this = this;
	        this.routeChangeHandler = null;
	        this.routes = flattenRoutes(originalRoutes);
	        this.framework7 = framework7;
	        this.dom7 = dom7;
	        //Hook router into Framework7 routing events
	        var initialPreroute = framework7.params.preroute;
	        framework7.params.routes = originalRoutes;
	        framework7.params.routerRemoveTimeout = true;
	        framework7.params.preroute = function (view, options) {
	            var passToVueRouter = true;
	            if (initialPreroute && !options.pageElement) {
	                passToVueRouter = initialPreroute(view, options);
	            }
	            if (passToVueRouter) {
	                return handleRouteChangeFromFramework7(view, options, _this.changeRoute.bind(_this));
	            }
	            else {
	                return false;
	            }
	        };
	    }
	    Framework7Router.prototype.setRouteChangeHandler = function (routeChangeHandler) {
	        this.routeChangeHandler = routeChangeHandler;
	    };
	    Framework7Router.prototype.changeRoute = function (url, view, options) {
	        var _this = this;
	        if (view === void 0) { view = null; }
	        var getMainView = function () { return _this.framework7.views && _this.framework7.views.reduce(function (mainView, nextView) {
	            if (nextView.main) {
	                return nextView;
	            }
	            else {
	                return mainView;
	            }
	        }, null); };
	        var matchingRoute = this.findMatchingRoute(url);
	        if (!matchingRoute)
	            return true;
	        return this.routeChangeHandler(Object.assign({}, matchingRoute, {
	            view: view || getMainView(),
	            options: options,
	            router: this
	        }));
	    };
	    Framework7Router.prototype.findMatchingRoute = function (url) {
	        var matchingRoute;
	        if (!url)
	            return matchingRoute;
	        url = "" + url; //Insures that the url is of type string so url.split does not crash app in weird situations.
	        var routes = this.routes;
	        var query = this.dom7.parseUrlQuery(url);
	        var hash = url.split('#')[1];
	        var params = {};
	        var path = url.split('#')[0].split('?')[0];
	        var urlParts = path.split('/').filter(function (part) {
	            if (part !== '')
	                return part;
	        });
	        var i, j, k;
	        for (i = 0; i < routes.length; i++) {
	            if (matchingRoute)
	                continue;
	            var route = routes[i];
	            var parsedRoute = parseRoute(route.path);
	            if (parsedRoute.length !== urlParts.length)
	                continue;
	            var matchedParts = 0;
	            for (j = 0; j < parsedRoute.length; j++) {
	                if (typeof parsedRoute[j] === 'string' && urlParts[j] === parsedRoute[j])
	                    matchedParts++;
	                if (typeof parsedRoute[j] === 'object') {
	                    params[parsedRoute[j].name] = urlParts[j];
	                    matchedParts++;
	                }
	            }
	            if (matchedParts === urlParts.length) {
	                matchingRoute = {
	                    query: query,
	                    hash: hash,
	                    params: params,
	                    url: url,
	                    path: path,
	                    route: route
	                };
	            }
	        }
	        return matchingRoute;
	    };
	    return Framework7Router;
	}());
	exports.default = Framework7Router;
	
	//# sourceMappingURL=router.js.map


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(32);
	var prop_types_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(361);
	var Framework7_1 = __webpack_require__(81);
	var OverscrollFix_1 = __webpack_require__(365);
	var Framework7App = (function (_super) {
	    __extends(Framework7App, _super);
	    function Framework7App() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.framework7 = null;
	        _this.framework7InitCallbacks = [];
	        _this.routeChangeCallbacks = {};
	        return _this;
	    }
	    Framework7App.prototype.getChildContext = function () {
	        var _this = this;
	        return {
	            framework7AppContext: {
	                getFramework7: this.getFramework7.bind(this),
	                theme: {
	                    ios: this.props.themeType === 'ios',
	                    material: this.props.themeType === 'material'
	                },
	                onRouteChange: this.onRouteChange.bind(this),
	                unregisterRouteChange: this.unregisterRouteChange.bind(this),
	                getCurrentRoute: function () { return _this.currentRoute; },
	                getRouter: function () { return _this.router; }
	            }
	        };
	    };
	    Framework7App.prototype.render = function () {
	        return React.createElement("span", null, this.props.children);
	    };
	    Framework7App.prototype.componentDidMount = function () {
	        this.handleOverscrollFix();
	        this.initFramework7();
	    };
	    Framework7App.prototype.handleOverscrollFix = function () {
	        if (this.props.applyOverscrollFix) {
	            OverscrollFix_1.applyOverscrollFix();
	        }
	    };
	    Framework7App.prototype.initFramework7 = function () {
	        var _this = this;
	        this.framework7 = new Framework7_1.Framework7(__assign({ material: this.props.themeType === 'material' }, this.props));
	        var router = this.router = new router_1.default(this.props.routes, this.framework7, Framework7_1.Dom7);
	        router.setRouteChangeHandler(function (route) {
	            _this.currentRoute = route;
	            if (_this.props.onRouteChange) {
	                _this.props.onRouteChange(route);
	            }
	            Object.keys(_this.routeChangeCallbacks).forEach(function (componentId) {
	                //Need this if statement in case a component gets unregistered during this forEach                
	                if (_this.routeChangeCallbacks[componentId]) {
	                    _this.routeChangeCallbacks[componentId](route);
	                }
	            });
	            return false;
	        });
	        if (this.props.onFramework7Init) {
	            this.props.onFramework7Init(this.framework7);
	        }
	        this.framework7InitCallbacks.forEach(function (callback) {
	            callback(_this.framework7);
	        });
	        if (this.props.stateKernel) {
	            Framework7_1.Dom7(document).on('click', 'a', function (e) { return e.preventDefault(); });
	            this.props.stateKernel.setFramework7(this.framework7);
	            this.props.stateKernel.setRouter(this.router);
	        }
	    };
	    Framework7App.prototype.getFramework7 = function (callback) {
	        if (this.framework7) {
	            callback(this.framework7);
	        }
	        else {
	            this.framework7InitCallbacks.push(callback);
	        }
	    };
	    Framework7App.prototype.onRouteChange = function (componentId, callback) {
	        this.routeChangeCallbacks[componentId] = callback;
	    };
	    Framework7App.prototype.unregisterRouteChange = function (componentId) {
	        delete this.routeChangeCallbacks[componentId];
	    };
	    Framework7App.childContextTypes = {
	        framework7AppContext: prop_types_1.object
	    };
	    return Framework7App;
	}(React.Component));
	exports.Framework7App = Framework7App;
	;
	
	//# sourceMappingURL=Framework7App.js.map


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(32);
	var SelectableInput_1 = __webpack_require__(364);
	exports.ManagedFormInput = function (props) {
	    var renamedProps = {
	        name: props.name,
	        type: props.type,
	        placeholder: props.placeholder,
	        id: props.id,
	        value: props.value || '',
	        size: props.size,
	        accept: props.accept,
	        autoComplete: props.autocomplete,
	        autoCorrect: props.autocorrect,
	        autoCapitalize: props.autocapitalize,
	        spellCheck: props.spellcheck,
	        autoFocus: props.autofocus,
	        autoSave: props.autosave,
	        checked: props.checked,
	        disabled: props.disabled,
	        max: props.max,
	        maxLength: props.maxlength,
	        min: props.min,
	        minLength: props.minlength,
	        step: props.step,
	        multiple: props.multiple,
	        readOnly: props.readonly,
	        required: props.required,
	        color: props.color,
	        pattern: props.pattern,
	        onFocus: props.onFocus,
	        onBlur: props.onBlur,
	        onInput: props.onInput,
	        onChange: props.onChange,
	        onClick: props.onClick,
	        onKeyPress: props.onKeypress,
	        onKeyUp: props.onKeyUp,
	        onKeyDown: props.onKeyDown,
	        onCompositionStart: props.onCompositionstart,
	        onCompositionUpdate: props.onCompositionupdate,
	        onCompositionEnd: props.onCompositionend,
	        onDoubleClick: props.onDblclick,
	        onMouseDown: props.onMousedown,
	        onMouseEnter: props.onMouseenter,
	        onMouseLeave: props.onMouseleave,
	        onMouseMove: props.onMousemove,
	        onMouseOut: props.onMouseout,
	        onMouseOver: props.onMouseover,
	        onMouseUp: props.onMouseup,
	        onWheel: props.onWheel,
	        onSelect: props.onSelect
	    };
	    switch (props.type.toLowerCase()) {
	        case 'checkbox':
	        case 'radio':
	            return React.createElement(SelectableInput_1.SelectableInput, __assign({}, renamedProps));
	        case 'textarea':
	            return React.createElement("textarea", __assign({}, renamedProps));
	        default:
	            return React.createElement("input", __assign({}, renamedProps));
	    }
	};
	
	//# sourceMappingURL=ManagedFormInput.js.map


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(32);
	var SelectableInput = (function (_super) {
	    __extends(SelectableInput, _super);
	    function SelectableInput() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    SelectableInput.prototype.saveRef = function (element) {
	        this.element = element;
	    };
	    SelectableInput.prototype.componentDidMount = function () {
	        this.element.checked = this.props.checked;
	        this.element.addEventListener('change', this.props.onChange);
	    };
	    SelectableInput.prototype.componentDidUpdate = function () {
	        var _this = this;
	        setTimeout(function () {
	            if (_this.element) {
	                _this.element.checked = _this.props.checked;
	            }
	        });
	    };
	    SelectableInput.prototype.render = function () {
	        return React.createElement("input", __assign({ type: this.props.type, ref: this.saveRef.bind(this) }, this.props, { onChange: null }));
	    };
	    return SelectableInput;
	}(React.Component));
	exports.SelectableInput = SelectableInput;
	
	//# sourceMappingURL=SelectableInput.js.map


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.applyOverscrollFix = function () {
	    var touchTarget, touchScreenX, touchScreenY, conditionParentUntilTrue, disableScroll, scrollMap;
	    conditionParentUntilTrue = function (element, condition) {
	        var outcome = false;
	        if (element === document.body) {
	            return false;
	        }
	        outcome = condition(element);
	        if (outcome) {
	            return true;
	        }
	        else {
	            return conditionParentUntilTrue(element.parentNode, condition);
	        }
	    };
	    window.addEventListener('touchstart', function (e) {
	        touchTarget = e.targetTouches[0].target;
	        // a boolean map indicating if the element (or either of element parents, excluding the document.body) can be scrolled to the X direction.
	        scrollMap = {};
	        scrollMap.left = conditionParentUntilTrue(touchTarget, function (element) {
	            return element.scrollLeft > 0 &&
	                (window.getComputedStyle(element).overflow !== "hidden") &&
	                (window.getComputedStyle(element).overflowX !== "hidden");
	        });
	        scrollMap.top = conditionParentUntilTrue(touchTarget, function (element) {
	            return element.scrollTop > 0 &&
	                (window.getComputedStyle(element).overflow !== "hidden") &&
	                (window.getComputedStyle(element).overflowY !== "hidden");
	        });
	        scrollMap.right = conditionParentUntilTrue(touchTarget, function (element) {
	            return element.scrollWidth > element.clientWidth &&
	                element.scrollWidth - element.clientWidth > element.scrollLeft &&
	                (window.getComputedStyle(element).overflow !== "hidden") &&
	                (window.getComputedStyle(element).overflowX !== "hidden");
	        });
	        scrollMap.bottom = conditionParentUntilTrue(touchTarget, function (element) {
	            return element.scrollHeight > element.clientHeight &&
	                element.scrollHeight - element.clientHeight > element.scrollTop &&
	                (window.getComputedStyle(element).overflow !== "hidden") &&
	                (window.getComputedStyle(element).overflowY !== "hidden");
	        });
	        touchScreenX = e.targetTouches[0].screenX;
	        touchScreenY = e.targetTouches[0].screenY;
	        disableScroll = false;
	    });
	    window.addEventListener('touchmove', function (e) {
	        var moveScreenX, moveScreenY;
	        if (disableScroll) {
	            e.preventDefault();
	            return;
	        }
	        moveScreenX = e.targetTouches[0].screenX;
	        moveScreenY = e.targetTouches[0].screenY;
	        if (moveScreenX > touchScreenX && scrollMap.left ||
	            moveScreenY < touchScreenY && scrollMap.bottom ||
	            moveScreenX < touchScreenX && scrollMap.right ||
	            moveScreenY > touchScreenY && scrollMap.top) {
	            // You are scrolling either the element or its parent.
	            // This will not affect document.body scroll.
	        }
	        else {
	            // This will affect document.body scroll.
	            e.preventDefault();
	            disableScroll = true;
	        }
	    });
	};
	
	//# sourceMappingURL=OverscrollFix.js.map


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var GenerateReactClass_1 = __webpack_require__(367);
	exports.reactifyVue = function (reactifyVueArgs) {
	    return GenerateReactClass_1.generateReactClass(reactifyVueArgs.instantiatedComponents, reactifyVueArgs.component, reactifyVueArgs.slots, reactifyVueArgs.name, reactifyVueArgs.tag, reactifyVueArgs.mixin, reactifyVueArgs.args);
	};
	
	//# sourceMappingURL=ReactifyVue.js.map


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var _this = this;
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(32);
	var VueComponentClass_1 = __webpack_require__(369);
	var ReactClassRuntime_1 = __webpack_require__(368);
	exports.generateReactClass = function (instantiatedComponents, vueComponent, slots, name, tag, mixin, args) {
	    var vueComponentClass = VueComponentClass_1.convertVueComponentToClass(vueComponent);
	    ReactClassRuntime_1.copyMethodsToVueComponent(vueComponent);
	    ReactClassRuntime_1.copyArgsToVueComponent(vueComponent, args);
	    var reactClass = (function (_super) {
	        __extends(reactClass, _super);
	        function reactClass(props, context) {
	            var _this = _super.call(this, props, context) || this;
	            _this.vueComponent = new vueComponentClass(_this.props, _this);
	            _this.createElement = ReactClassRuntime_1.generateCreateElementFunctionForClass(_this.vueComponent, instantiatedComponents, _this.vueComponent);
	            ReactClassRuntime_1.copyPropsToVueComponent(_this.vueComponent, _this.props);
	            ReactClassRuntime_1.copySlotsToVueComponent(_this.vueComponent, slots, _this.props);
	            var state = ReactClassRuntime_1.initData(_this.vueComponent);
	            ReactClassRuntime_1.handleComputedProperties(_this.vueComponent);
	            ReactClassRuntime_1.addCompiledTemplateFunctionsToVueComponent(_this.vueComponent, _this.createElement);
	            if (_this.props.__onInit) {
	                _this.props.__onInit(_this);
	            }
	            _this.state = state;
	            return _this;
	        }
	        reactClass.prototype.componentWillUpdate = function () {
	            if (this.vueComponent.beforeUpdate)
	                this.vueComponent.beforeUpdate();
	        };
	        reactClass.prototype.componentDidUpdate = function () {
	            if (this.vueComponent.updated)
	                this.vueComponent.updated();
	        };
	        reactClass.prototype.componentDidMount = function () {
	            if (this.vueComponent.mounted)
	                this.vueComponent.mounted();
	            if (this.props.__onMount)
	                this.props.__onMount(this);
	            this.didMount = true;
	        };
	        reactClass.prototype.componentWillUnmount = function () {
	            if (vueComponent.beforeDestroy)
	                vueComponent.beforeDestroy();
	        };
	        reactClass.prototype.componentWillReceiveProps = function (nextProps) {
	            ReactClassRuntime_1.handleWatchedProperties(this.vueComponent, this.props, nextProps);
	        };
	        reactClass.prototype.render = function () {
	            if (this.hasRendered) {
	                //Only do this after the first render, since it happens in getInitialState the first time
	                ReactClassRuntime_1.copyPropsToVueComponent(this.vueComponent, this.props);
	                ReactClassRuntime_1.copySlotsToVueComponent(this.vueComponent, slots, this.props);
	                ReactClassRuntime_1.handleComputedProperties(this.vueComponent);
	            }
	            var reactElement = this.vueComponent.render(this.createElement.bind(this));
	            this.hasRendered = true;
	            if (reactElement) {
	                return ReactClassRuntime_1.applyPropOverridesToTopLevelElement(reactElement, tag, this);
	            }
	            else {
	                return null;
	            }
	        };
	        reactClass.prototype.callVueMethod = function (methodName) {
	            var args = [];
	            for (var _i = 1; _i < arguments.length; _i++) {
	                args[_i - 1] = arguments[_i];
	            }
	            return this.vueComponent[methodName](args);
	        };
	        return reactClass;
	    }(React.Component));
	    reactClass.tag = tag;
	    reactClass.vueComponent = vueComponent;
	    reactClass.getVueComponentInstance = function () { return _this.vueComponent; };
	    reactClass.displayName = name;
	    var defaultProps = ReactClassRuntime_1.getDefaultProps(vueComponent);
	    if (defaultProps)
	        reactClass.defaultProps = defaultProps;
	    return reactClass;
	};
	
	//# sourceMappingURL=GenerateReactClass.js.map


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var _this = this;
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(32);
	var change_case_1 = __webpack_require__(109);
	var CreateReactElements_1 = __webpack_require__(370);
	exports.copyMethodsToVueComponent = function (vueComponent) {
	    if (vueComponent.methods) {
	        Object.keys(vueComponent.methods)
	            .forEach(function (methodName) { return vueComponent[methodName] = vueComponent.methods[methodName]; });
	        delete vueComponent.methods;
	    }
	};
	exports.copyPropsToVueComponent = function (vueComponent, props) {
	    if (props) {
	        Object.keys(props)
	            .forEach(function (propName) {
	            if (typeof vueComponent[propName] !== 'function' || typeof vueComponent[propName] === 'function' && !vueComponent[propName]) {
	                vueComponent[propName] = props[propName];
	            }
	        });
	    }
	};
	exports.getComponentTag = function (component) {
	    if (component.type && component.type.tag) {
	        return component.type.tag;
	    }
	    else if (component.type && typeof component.type === 'string') {
	        return component.type;
	    }
	    else {
	        return undefined;
	    }
	};
	exports.copySlotsToVueComponent = function (vueComponent, slotMapping, props) {
	    var reactChildrenArray = props && props.children && React.Children.toArray(props.children);
	    var slots = {
	        default: (reactChildrenArray && reactChildrenArray.length) ? reactChildrenArray : null
	    };
	    if (slotMapping && props) {
	        Object.keys(slotMapping)
	            .forEach(function (slotName) {
	            slots[slotName] = props[slotMapping[slotName]] || [];
	        });
	    }
	    Object.keys(slots)
	        .forEach(function (slotName) {
	        var slot = slots[slotName];
	        if (Array.isArray(slot)) {
	            slot.forEach(function (slotChild, index) {
	                if (typeof slotChild !== 'string') {
	                    slots[slotName][index] = __assign({}, slotChild, { tag: exports.getComponentTag(slotChild) });
	                }
	            });
	        }
	    });
	    vueComponent.$slots = slots;
	};
	exports.copyArgsToVueComponent = function (vueComponent, args) {
	    if (args) {
	        Object.keys(args)
	            .forEach(function (argName) { return vueComponent[argName] = args[argName]; });
	    }
	};
	exports.handleWatchedProperties = function (vueComponent, currentProps, nextProps) {
	    if (vueComponent.watch) {
	        exports.copyPropsToVueComponent(vueComponent, nextProps);
	        exports.handleComputedProperties(vueComponent);
	        Object.keys(vueComponent.watch)
	            .forEach(function (watchedProperty) {
	            if (currentProps[watchedProperty] !== nextProps[watchedProperty]) {
	                vueComponent.watch[watchedProperty].apply(vueComponent, [nextProps[watchedProperty]]);
	            }
	        });
	    }
	};
	exports.handleComputedProperties = function (vueComponent) {
	    if (vueComponent.computed) {
	        Object.keys(vueComponent.computed)
	            .forEach(function (propertyName) {
	            vueComponent[propertyName] = vueComponent.computed[propertyName].apply(vueComponent, []);
	        });
	    }
	};
	exports.getDefaultProps = function (vueComponent) {
	    if (vueComponent.props) {
	        var defaultProps = Object.keys(vueComponent.props).reduce(function (defaultProps, propName) {
	            var propDef = vueComponent.props[propName];
	            if (propDef.default) {
	                return __assign({}, defaultProps, (_a = {}, _a[change_case_1.camelCase(propName)] = propDef.default, _a));
	            }
	            else {
	                return defaultProps;
	            }
	            var _a;
	        }, {});
	        return Object.keys(defaultProps).length ? defaultProps : null;
	    }
	    else {
	        return null;
	    }
	};
	exports.addCompiledTemplateFunctionsToVueComponent = function (vueComponent, createElement) {
	    vueComponent._self = { _c: createElement.bind(vueComponent) };
	    vueComponent._t = function (slotName, fallback) {
	        var slotValue = vueComponent.$slots[slotName];
	        if (fallback && (!slotValue || !slotValue.length)) {
	            return fallback;
	        }
	        else {
	            return slotValue;
	        }
	    };
	    vueComponent._v = function (text) { return text || ''; };
	    vueComponent._s = function (text) { return text || ''; };
	    vueComponent._e = function () { return null; };
	};
	exports.generateCreateElementFunctionForClass = function (classVueComponentInstance, instantiatedComponents, vueComponent) {
	    return function (element, args, children) {
	        if (typeof args !== 'object' || Array.isArray(args)) {
	            //Children passed in as second argument
	            return CreateReactElements_1.createReactElement(element, {}, args, instantiatedComponents, vueComponent);
	        }
	        else {
	            return CreateReactElements_1.createReactElement(element, args, children, instantiatedComponents, vueComponent);
	        }
	    };
	};
	exports.applyPropOverridesToTopLevelElement = function (reactElement, tag, self) {
	    var refFunc = function (e) {
	        reactElement.ref(e);
	        self.element = e;
	        self.nextTickCallbacks.forEach(function (callback) { return callback.apply(_this.vueComponent, []); });
	        self.nextTickCallbacks = [];
	        self.hasUnrenderedStateChanges = false;
	    };
	    var elementWithPropOverrides = __assign({}, reactElement, { props: __assign({}, reactElement.props), tag: tag, ref: refFunc });
	    if (self.vueComponent.className) {
	        var existingClassName = elementWithPropOverrides.props.className || '';
	        elementWithPropOverrides.props.className = [existingClassName, ' ', self.vueComponent.className].join('');
	    }
	    if (self.vueComponent.style) {
	        var existingStyles = elementWithPropOverrides.props.style || {};
	        elementWithPropOverrides.props.style = __assign({}, existingStyles, self.vueComponent.style);
	    }
	    if (self.vueComponent.id) {
	        elementWithPropOverrides.props.id = self.vueComponent.id;
	    }
	    return elementWithPropOverrides;
	};
	exports.initData = function (vueComponent) {
	    var state = null;
	    if (vueComponent.data) {
	        state = vueComponent.data();
	        Object.keys(state).forEach(function (stateKey) {
	            vueComponent[stateKey] = state[stateKey];
	        });
	    }
	    return state;
	};
	
	//# sourceMappingURL=ReactClassRuntime.js.map


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(32);
	var change_case_1 = __webpack_require__(109);
	var handleStateSet = function (stateObject, key, value, vueComponent, self, deleteMode) {
	    var stateKey = Object.keys(self.state).reduce(function (macthingStateKey, nextKey) {
	        if (self.state[nextKey] === stateObject) {
	            return nextKey;
	        }
	        else {
	            return macthingStateKey;
	        }
	    }, null);
	    var newState;
	    if (deleteMode) {
	        newState = __assign({}, self.state);
	        delete newState[stateKey][key];
	    }
	    else {
	        newState = __assign({}, self.state, (_a = {}, _a[stateKey] = __assign({}, self.state[stateKey], (_b = {}, _b[key] = value, _b)), _a));
	    }
	    if (deleteMode) {
	        delete vueComponent[stateKey][key];
	    }
	    else {
	        vueComponent[stateKey] = newState[stateKey];
	    }
	    self.setState(newState);
	    var _a, _b;
	};
	var callPropOnEvent = function (eventName, eventArgs, props) {
	    var eventNameCamelCase = change_case_1.camelCase('on-' + eventName.split(':').join('-'));
	    if (props[eventNameCamelCase]) {
	        props[eventNameCamelCase].apply(props, eventArgs);
	    }
	};
	exports.convertVueComponentToClass = function (vueComponentObject) {
	    var vueComponentClass = function (reactComponentProps, reactComponentInstance) {
	        this.reactComponentProps = reactComponentProps;
	        this.reactComponentInstance = reactComponentInstance;
	        this.reactComponentInstance.nextTickCallbacks = [];
	    };
	    vueComponentClass.prototype = vueComponentObject;
	    if (vueComponentObject.mixins) {
	        vueComponentObject.mixins.forEach(function (mixin) {
	            Object.keys(mixin).forEach(function (prop) {
	                if (vueComponentClass.prototype[prop]) {
	                    var existingPropertyValue_1 = vueComponentClass.prototype[prop];
	                    var mixinPropertyValue_1 = mixin[prop];
	                    Object.keys(mixinPropertyValue_1).forEach(function (mixinProp) {
	                        existingPropertyValue_1[mixinProp] = mixinPropertyValue_1[mixinProp];
	                    });
	                }
	                else {
	                    vueComponentClass.prototype[prop] = mixin[prop];
	                }
	            });
	        });
	    }
	    vueComponentClass.prototype.$emit = function (eventName) {
	        var eventArgs = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            eventArgs[_i - 1] = arguments[_i];
	        }
	        callPropOnEvent(eventName, eventArgs, this.reactComponentProps);
	    };
	    Object.defineProperty(vueComponentClass.prototype, '$el', {
	        get: function () { return this.reactComponentInstance.element; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(vueComponentClass.prototype, '$parent', {
	        get: function () { return this.reactComponentProps.parentVueComponent || {}; },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(vueComponentClass.prototype, '$children', {
	        get: function () {
	            var parentElement = this.$el;
	            return React.Children.toArray(this.children).map(function (element, index) {
	                return __assign({}, element, { $el: parentElement.children[index] });
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(vueComponentClass.prototype, '$options', {
	        get: function () {
	            return {
	                propsData: __assign({}, this.reactComponentProps)
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(vueComponentClass.prototype, '$root', {
	        get: function () {
	            return {
	                $el: document.querySelector('.framework7-root')
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    vueComponentClass.prototype.$nextTick = function (func) {
	        if (this.reactComponentInstance.hasUnrenderedStateChanges) {
	            this.reactComponentInstance.nextTickCallbacks.push(func);
	        }
	        else {
	            func();
	        }
	    };
	    vueComponentClass.prototype.$set = function (stateObject, key, value) {
	        this.reactComponentInstance.hasUnrenderedStateChanges = true;
	        handleStateSet(stateObject, key, value, this, this.reactComponentInstance, false);
	    };
	    vueComponentClass.prototype.$delete = function (stateObject, key) {
	        this.reactComponentInstance.hasUnrenderedStateChanges = true;
	        handleStateSet(stateObject, key, null, this, this.reactComponentInstance, true);
	    };
	    return vueComponentClass;
	};
	
	//# sourceMappingURL=VueComponentClass.js.map


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(32);
	var PropsProcessor_1 = __webpack_require__(371);
	var ManagedFormInput_1 = __webpack_require__(363);
	var propsProcessor = new PropsProcessor_1.PropsProcessor();
	var formElements = ['input', 'textarea'];
	var resolveDependencyComponent = function (instantiatedComponents, componentToResolve) {
	    if (instantiatedComponents && componentToResolve.indexOf('f7-') > -1) {
	        //Is a Vue component that React does not know what to do with, so search for it by tag name so that we can pass the actual React component for rendering.
	        var results = instantiatedComponents
	            .filter(function (instantiatedComponent) {
	            if (instantiatedComponent.tag) {
	                return instantiatedComponent.tag === componentToResolve;
	            }
	            else {
	                return false;
	            }
	        });
	        if (results.length) {
	            return results[0];
	        }
	    }
	    else if (formElements.indexOf(componentToResolve) > -1) {
	        //Is an input that we need to manage to control state 
	        return ManagedFormInput_1.ManagedFormInput;
	    }
	    else {
	        //Is just a plain html element like div, etc. so just return it.
	        return componentToResolve;
	    }
	};
	var flattenNestedArrayOfChildren = function (children, finalArray) {
	    if (finalArray === void 0) { finalArray = []; }
	    if (children && Array.isArray(children)) {
	        for (var i = 0; i < children.length; i++) {
	            if (children[i] && children[i].constructor === Array) {
	                flattenNestedArrayOfChildren(children[i], finalArray);
	            }
	            else {
	                if (finalArray.indexOf(children[i]) === -1) {
	                    finalArray.push(children[i]);
	                }
	            }
	        }
	        return finalArray;
	    }
	    else {
	        return children;
	    }
	};
	exports.createReactElement = function (componentOrComponentName, args, children, instantiatedComponents, vueComponent) {
	    var reactElement;
	    if (!componentOrComponentName)
	        return null;
	    var resolvedComponent;
	    if (args.tag !== 'component') {
	        resolvedComponent = resolveDependencyComponent(instantiatedComponents, componentOrComponentName);
	    }
	    children = flattenNestedArrayOfChildren(children);
	    if (!resolvedComponent)
	        resolvedComponent = componentOrComponentName;
	    var props = propsProcessor.getProps(args, children, componentOrComponentName, resolvedComponent, vueComponent);
	    reactElement = React.createElement(resolvedComponent, props);
	    return reactElement;
	};
	
	//# sourceMappingURL=CreateReactElements.js.map


/***/ }),
/* 371 */
/***/ (function(module, exports) {

	"use strict";
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var camelCase = function (str) {
	    camelCase.replacement = camelCase.replacement || {};
	    if (!camelCase.replacement[str]) {
	        camelCase.replacement[str] = str.replace(/-([a-z])/g, function (m, w) {
	            return w.toUpperCase();
	        });
	    }
	    return camelCase.replacement[str];
	};
	var hasOwn = {}.hasOwnProperty;
	var classNames = function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var classes = [];
	    var length = args.length;
	    while (length--) {
	        var arg = args[length];
	        if (!arg)
	            continue;
	        var argType = typeof arg;
	        if (argType === 'string' || argType === 'number') {
	            classes.push(arg);
	        }
	        else if (Array.isArray(arg)) {
	            classes.push(classNames.apply(null, arg));
	        }
	        else if (argType === 'object') {
	            var keys = Object.keys(arg);
	            var length_1 = keys.length;
	            while (length_1--) {
	                var key = keys[length_1];
	                if (hasOwn.call(arg, key) && arg[key]) {
	                    classes.push(key);
	                }
	            }
	        }
	    }
	    return classes.join(' ');
	};
	var renameEvent = function (eventName) {
	    switch (eventName) {
	        case 'keypress':
	            return 'keyPress';
	        case 'keyup':
	            return 'keyUp';
	        case 'keydown':
	            return 'keyDown';
	        case 'beforeinput':
	            return 'beforeInput';
	        case 'compositionstart':
	            return 'compositionStart';
	        case 'compositionupdate':
	            return 'compositionUpdate';
	        case 'compositionend':
	            return 'compositionEnd';
	        case 'dblclick':
	            return 'doubleClick';
	        case 'mousedown':
	            return 'mouseDown';
	        case 'mouseenter':
	            return 'mouseEnter';
	        case 'mouseleave':
	            return 'mouseLeave';
	        case 'mousemove':
	            return 'mouseMove';
	        case 'mouseout':
	            return 'mouseOut';
	        case 'mouseover':
	            return 'mouseOver';
	        case 'mouseup':
	            return 'mouseUp';
	        case 'focusin':
	            return 'focus';
	        case 'focusout':
	            return 'blur';
	        default:
	            return eventName;
	    }
	};
	var attributeMap = {
	    autocapitalize: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'autoCapitalize'
	    },
	    autocomplete: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'autoComplete'
	    },
	    autocorrect: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'autoCorrect'
	    },
	    autofocus: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'autoFocus'
	    },
	    autosave: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'autoSave'
	    },
	    maxlength: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'maxLength'
	    },
	    minlength: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'minLength'
	    },
	    readonly: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'readOnly'
	    },
	    spellcheck: {
	        componentNames: ['input', 'textarea', 'select'],
	        renameTo: 'spellCheck'
	    }
	};
	var handleRefs = function (element, vueComponent, events, props) {
	    if (events) {
	        var _loop_1 = function (eventName) {
	            if (element && element.addEventListener && !(element.vueListeners && element.vueListeners[eventName])) {
	                element.addEventListener(eventName, function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var eventHandler = events[eventName];
	                    eventHandler.apply(vueComponent, args);
	                }, true);
	                element.vueListeners = element.vueListeners || {};
	                element.vueListeners[eventName] = true;
	            }
	        };
	        for (var eventName in events) {
	            _loop_1(eventName);
	        }
	    }
	    if (props['data-vue-ref']) {
	        var vueRef = props['data-vue-ref'];
	        vueRef.vueComponentInstance.$refs[vueRef.refName] = element;
	    }
	};
	var renameAttribute = function (componentName, attribute) {
	    var attributeMapForAttribute = attributeMap[attribute];
	    if (attributeMapForAttribute && attributeMapForAttribute.componentNames.indexOf(componentName) > -1) {
	        attribute = attributeMapForAttribute.renameTo;
	    }
	    return attribute;
	};
	var renameStyleProperties = function (stylesObject) {
	    for (var property in stylesObject) {
	        if (stylesObject.hasOwnProperty(property) && property.indexOf('-') !== -1) {
	            var newPropertyName = camelCase(property);
	            stylesObject[newPropertyName] = stylesObject[property];
	            delete stylesObject[property];
	        }
	    }
	    return stylesObject;
	};
	var PropsProcessor = (function () {
	    function PropsProcessor() {
	        this.handleEvents = function (resolvedComponent, eventHandlers, parentVueComponentInstance, props) {
	            if (typeof resolvedComponent === 'string') {
	            }
	            else {
	                if (eventHandlers) {
	                    var _loop_2 = function (eventName) {
	                        var camelCasedEventName = "" + camelCase('on-' + renameEvent(eventName));
	                        props[camelCasedEventName] = function () {
	                            var eventArgs = [];
	                            for (var _i = 0; _i < arguments.length; _i++) {
	                                eventArgs[_i] = arguments[_i];
	                            }
	                            eventHandlers[eventName].apply(parentVueComponentInstance, eventArgs);
	                        };
	                    };
	                    for (var eventName in eventHandlers) {
	                        _loop_2(eventName);
	                    }
	                }
	            }
	        };
	    }
	    PropsProcessor.prototype.getProps = function (args, children, componentOrComponentName, resolvedComponent, vueComponentInstance) {
	        this.addCurrentComponentAsParentOfChildren(children, vueComponentInstance);
	        var props = {};
	        this.getClasses(args, vueComponentInstance, props);
	        this.getStyle(args, vueComponentInstance, props);
	        this.getRef(args, vueComponentInstance, resolvedComponent, props);
	        this.getPropsFromArgs(args, props);
	        this.getChildren(children, args, props);
	        this.convertAttrsToProps(args, componentOrComponentName, resolvedComponent, props);
	        this.convertVueDomProps(args, props);
	        this.handleEvents(resolvedComponent, args.on, vueComponentInstance, props);
	        this.handleRef(args.ref, vueComponentInstance, props);
	        return props;
	    };
	    PropsProcessor.prototype.getClasses = function (args, vueComponent, props) {
	        var classObject = {};
	        if (args.class && typeof args.class === 'string') {
	            classObject[args.class] = true;
	        }
	        else if (args.class) {
	            classObject = args.class;
	        }
	        if (args.staticClass) {
	            classObject[args.staticClass] = true;
	        }
	        var classes = [];
	        for (var key in classObject) {
	            if (classObject[key]) {
	                classes.push(key);
	            }
	        }
	        props.className = classes.join(' ');
	    };
	    PropsProcessor.prototype.getStyle = function (args, vueComponent, props) {
	        var style;
	        if (args.style) {
	            if (typeof args.style === 'object') {
	                style = args.style;
	            }
	            else {
	                throw new Error('ReactifyVue only supports style attributes that are of type object');
	            }
	        }
	        if (style) {
	            props.style = renameStyleProperties(style);
	        }
	    };
	    PropsProcessor.prototype.getRef = function (args, vueComponent, resolvedComponent, props) {
	        props.ref = (function (events, vueComponent) {
	            return function (element) {
	                var events = args.on;
	                handleRefs(element, vueComponent, events, props);
	            };
	        })(args.on, vueComponent);
	    };
	    PropsProcessor.prototype.getPropsFromArgs = function (args, props) {
	        if (args.props) {
	            for (var prop in args.props) {
	                props[camelCase(prop)] = args.props[prop];
	            }
	        }
	    };
	    PropsProcessor.prototype.getChildren = function (children, args, props) {
	        if (children && !((args.domProps && args.domProps.innerHTML) || (args.domProps && args.domProps.value))) {
	            props.children = children;
	        }
	    };
	    PropsProcessor.prototype.convertAttrsToProps = function (args, componentOrComponentName, resolvedComponent, props) {
	        if (args.attrs) {
	            for (var attr in args.attrs) {
	                attr = renameAttribute(componentOrComponentName, attr);
	                var resolvedVueComponent = resolvedComponent.vueComponent;
	                var attrValue = args.attrs[attr];
	                if (attrValue !== undefined || attrValue !== false) {
	                    var camelCasedAttrName = camelCase(attr);
	                    var vueComponentProp = resolvedVueComponent && resolvedVueComponent.props && resolvedVueComponent.props[camelCasedAttrName];
	                    if (vueComponentProp) {
	                        if (vueComponentProp === Boolean && attrValue !== false) {
	                            props[camelCasedAttrName] = true;
	                        }
	                        else {
	                            props[camelCasedAttrName] = attrValue;
	                        }
	                    }
	                    else {
	                        props[attr] = attrValue;
	                    }
	                }
	            }
	        }
	    };
	    PropsProcessor.prototype.convertVueDomProps = function (args, props) {
	        var dangerouslySetInnerHTML;
	        if (args.domProps) {
	            if (args.domProps.value) {
	                props.value = args.domProps.value;
	            }
	            if (args.domProps.checked) {
	                props.checked = args.domProps.checked;
	            }
	            if (args.domProps.innerHTML) {
	                props.dangerouslySetInnerHTML = { __html: args.domProps.innerHTML };
	            }
	        }
	    };
	    PropsProcessor.prototype.addCurrentComponentAsParentOfChildren = function (children, vueComponent) {
	        var length = children && children.length;
	        if (children && length && Array.isArray(children)) {
	            for (var i = 0, length_2 = children.length; i < length_2; i++) {
	                var child = children[i];
	                if (child && child.tag && child.tag.indexOf('f7-') !== -1) {
	                    child.props = __assign({}, child.props, { parentVueComponent: vueComponent });
	                }
	            }
	        }
	    };
	    PropsProcessor.prototype.handleRef = function (refName, vueComponentInstance, props) {
	        if (refName) {
	            if (!vueComponentInstance.$refs)
	                vueComponentInstance.$refs = {};
	            props['data-vue-ref'] = {
	                refName: refName,
	                vueComponentInstance: vueComponentInstance
	            };
	        }
	    };
	    return PropsProcessor;
	}());
	exports.PropsProcessor = PropsProcessor;
	
	//# sourceMappingURL=PropsProcessor.js.map


/***/ }),
/* 372 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(82);
	
	var invariant = __webpack_require__(69);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(63);
	
	var ReactBaseClasses = __webpack_require__(178);
	var ReactChildren = __webpack_require__(375);
	var ReactDOMFactories = __webpack_require__(376);
	var ReactElement = __webpack_require__(49);
	var ReactPropTypes = __webpack_require__(377);
	var ReactVersion = __webpack_require__(378);
	
	var createReactClass = __webpack_require__(379);
	var onlyChild = __webpack_require__(382);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(373);
	var ReactElement = __webpack_require__(49);
	
	var emptyFunction = __webpack_require__(227);
	var traverseAllChildren = __webpack_require__(383);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(49);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(49),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(715);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(178),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(49),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(181);
	var factory = __webpack_require__(222);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(82);
	
	var ReactElement = __webpack_require__(49);
	
	var invariant = __webpack_require__(69);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(82);
	
	var ReactCurrentOwner = __webpack_require__(179);
	var REACT_ELEMENT_TYPE = __webpack_require__(180);
	
	var getIteratorFn = __webpack_require__(380);
	var invariant = __webpack_require__(69);
	var KeyEscapeUtils = __webpack_require__(372);
	var warning = __webpack_require__(128);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(6),n=__webpack_require__(63),r=__webpack_require__(766);function ba(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function x(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:x("227");function ca(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
	var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,l){da=!1;ea=null;ca.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,l){ja.apply(this,arguments);if(da){if(da){var k=ea;da=!1;ea=null}else x("198"),k=void 0;fa||(fa=!0,ha=k)}}var la=null,ma={};
	function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:x("96",a);if(!oa[c]){b.extractEvents?void 0:x("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?x("99",h):void 0;pa[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&qa(l[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:x("98",d,a)}}}}
	function qa(a,b,c){ra[a]?x("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={},ta=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ka(d,b,void 0,a);a.currentTarget=null}function xa(a,b){null==b?x("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
	var Ba={injectEventPluginOrder:function(a){la?x("101"):void 0;la=Array.prototype.slice.call(a);na()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?x("102",c):void 0,ma[c]=d,b=!0)}b&&na()}};
	function Ca(a,b){var c=a.stateNode;if(!c)return null;var d=ta(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?x("231",b,typeof c):void 0;
	return c}function Da(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a&&(ya(a,Aa),za?x("95"):void 0,fa))throw a=ha,fa=!1,ha=null,a;}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}
	function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;x("33")}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ma(a,b,c){if(b=Ca(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
	function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ca(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}
	function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||!window.document||!window.document.createElement);function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
	Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
	var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),$a=Wa("transitionend"),ab="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bb=null,cb=null,db=null;
	function eb(){if(db)return db;var a,b=cb,c=b.length,d,e="value"in bb?bb.value:bb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return db=e.slice(a,1<d?1-d:void 0)}function fb(){return!0}function gb(){return!1}
	function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?fb:gb;this.isPropagationStopped=gb;return this}
	n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=fb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=fb)},persist:function(){this.isPersistent=fb},isPersistent:gb,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=gb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;hb(c);return c};hb(y);function ib(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function jb(a){a instanceof this?void 0:x("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
	function hb(a){a.eventPool=[];a.getPooled=ib;a.release=jb}var kb=y.extend({data:null}),lb=y.extend({data:null}),mb=[9,13,27,32],nb=Ra&&"CompositionEvent"in window,ob=null;Ra&&"documentMode"in document&&(ob=document.documentMode);
	var pb=Ra&&"TextEvent"in window&&!ob,qb=Ra&&(!nb||ob&&8<ob&&11>=ob),rb=String.fromCharCode(32),sb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},tb=!1;
	function ub(a,b){switch(a){case "keyup":return-1!==mb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function vb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var wb=!1;function xb(a,b){switch(a){case "compositionend":return vb(b);case "keypress":if(32!==b.which)return null;tb=!0;return rb;case "textInput":return a=b.data,a===rb&&tb?null:a;default:return null}}
	function yb(a,b){if(wb)return"compositionend"===a||!nb&&ub(a,b)?(a=eb(),db=cb=bb=null,wb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return qb&&"ko"!==b.locale?null:b.data;default:return null}}
	var zb={eventTypes:sb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(nb)b:{switch(a){case "compositionstart":e=sb.compositionStart;break b;case "compositionend":e=sb.compositionEnd;break b;case "compositionupdate":e=sb.compositionUpdate;break b}e=void 0}else wb?ub(a,c)&&(e=sb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=sb.compositionStart);e?(qb&&"ko"!==c.locale&&(wb||e!==sb.compositionStart?e===sb.compositionEnd&&wb&&(f=eb()):(bb=d,cb="value"in bb?bb.value:bb.textContent,wb=
	!0)),e=kb.getPooled(e,b,c,d),f?e.data=f:(f=vb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=pb?xb(a,c):yb(a,c))?(b=lb.getPooled(sb.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Ab=null,Bb=null,Cb=null;function Db(a){if(a=ua(a)){"function"!==typeof Ab?x("280"):void 0;var b=ta(a.stateNode);Ab(a.stateNode,a.type,b)}}function Eb(a){Bb?Cb?Cb.push(a):Cb=[a]:Bb=a}function Fb(){if(Bb){var a=Bb,b=Cb;Cb=Bb=null;Db(a);if(b)for(a=0;a<b.length;a++)Db(b[a])}}
	function Gb(a,b){return a(b)}function Hb(a,b,c){return a(b,c)}function Ib(){}var Jb=!1;function Kb(a,b){if(Jb)return a(b);Jb=!0;try{return Gb(a,b)}finally{if(Jb=!1,null!==Bb||null!==Cb)Ib(),Fb()}}var Lb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Mb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Lb[a.type]:"textarea"===b?!0:!1}
	function Nb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Ob(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Pb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Qb(a){var b=Pb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Rb(a){a._valueTracker||(a._valueTracker=Qb(a))}function Sb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Pb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Tb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Tb.hasOwnProperty("ReactCurrentDispatcher")||(Tb.ReactCurrentDispatcher={current:null});
	var Ub=/^(.*)[\\\/]/,z="function"===typeof Symbol&&Symbol.for,Vb=z?Symbol.for("react.element"):60103,Wb=z?Symbol.for("react.portal"):60106,Xb=z?Symbol.for("react.fragment"):60107,Yb=z?Symbol.for("react.strict_mode"):60108,Zb=z?Symbol.for("react.profiler"):60114,$b=z?Symbol.for("react.provider"):60109,ac=z?Symbol.for("react.context"):60110,bc=z?Symbol.for("react.concurrent_mode"):60111,cc=z?Symbol.for("react.forward_ref"):60112,dc=z?Symbol.for("react.suspense"):60113,ec=z?Symbol.for("react.memo"):
	60115,fc=z?Symbol.for("react.lazy"):60116,gc="function"===typeof Symbol&&Symbol.iterator;function hc(a){if(null===a||"object"!==typeof a)return null;a=gc&&a[gc]||a["@@iterator"];return"function"===typeof a?a:null}
	function ic(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case bc:return"ConcurrentMode";case Xb:return"Fragment";case Wb:return"Portal";case Zb:return"Profiler";case Yb:return"StrictMode";case dc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ac:return"Context.Consumer";case $b:return"Context.Provider";case cc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
	")":"ForwardRef");case ec:return ic(a.type);case fc:if(a=1===a._status?a._result:null)return ic(a)}return null}function jc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ic(a.type);c=null;d&&(c=ic(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ub,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var kc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,lc=Object.prototype.hasOwnProperty,mc={},nc={};
	function oc(a){if(lc.call(nc,a))return!0;if(lc.call(mc,a))return!1;if(kc.test(a))return nc[a]=!0;mc[a]=!0;return!1}function pc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function qc(a,b,c,d){if(null===b||"undefined"===typeof b||pc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var D={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new C(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new C(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new C(a,2,!1,a.toLowerCase(),null)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new C(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new C(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){D[a]=new C(a,3,!0,a,null)});
	["capture","download"].forEach(function(a){D[a]=new C(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){D[a]=new C(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){D[a]=new C(a,5,!1,a.toLowerCase(),null)});var rc=/[\-:]([a-z])/g;function sc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(rc,
	sc);D[b]=new C(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(rc,sc);D[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new C(a,1,!1,a.toLowerCase(),null)});
	function tc(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(qc(b,c,e,d)&&(c=null),d||null===e?oc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function uc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function vc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=uc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function xc(a,b){b=b.checked;null!=b&&tc(a,"checked",b,!1)}
	function yc(a,b){xc(a,b);var c=uc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?zc(a,b.type,c):b.hasOwnProperty("defaultValue")&&zc(a,b.type,uc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Ac(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function zc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Bc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Cc(a,b,c){a=y.getPooled(Bc.change,a,b,c);a.type="change";Eb(c);Qa(a);return a}var Dc=null,Ec=null;function Fc(a){Da(a)}
	function Gc(a){var b=Ja(a);if(Sb(b))return a}function Hc(a,b){if("change"===a)return b}var Ic=!1;Ra&&(Ic=Ob("input")&&(!document.documentMode||9<document.documentMode));function Jc(){Dc&&(Dc.detachEvent("onpropertychange",Kc),Ec=Dc=null)}function Kc(a){"value"===a.propertyName&&Gc(Ec)&&(a=Cc(Ec,a,Nb(a)),Kb(Fc,a))}function Lc(a,b,c){"focus"===a?(Jc(),Dc=b,Ec=c,Dc.attachEvent("onpropertychange",Kc)):"blur"===a&&Jc()}function Mc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Gc(Ec)}
	function Nc(a,b){if("click"===a)return Gc(b)}function Oc(a,b){if("input"===a||"change"===a)return Gc(b)}
	var Pc={eventTypes:Bc,_isInputEventSupported:Ic,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Hc:Mb(e)?Ic?f=Oc:(f=Mc,g=Lc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Nc);if(f&&(f=f(a,b)))return Cc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&zc(e,"number",e.value)}},Qc=y.extend({view:null,detail:null}),Rc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Sc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Rc[a])?!!b[a]:!1}function Tc(){return Sc}
	var Uc=0,Vc=0,Wc=!1,Xc=!1,Yc=Qc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Tc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Uc;Uc=a.screenX;return Wc?"mousemove"===a.type?a.screenX-b:0:(Wc=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Vc;Vc=a.screenY;return Xc?"mousemove"===a.type?a.screenY-b:0:(Xc=!0,0)}}),Zc=Yc.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),$c={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},ad={eventTypes:$c,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=Yc,h=$c.mouseLeave,l=$c.mouseEnter,k="mouse";
	else if("pointerout"===a||"pointerover"===a)g=Zc,h=$c.pointerLeave,l=$c.pointerEnter,k="pointer";var m=null==f?e:Ja(f);e=null==b?e:Ja(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=La(g))k++;g=0;for(l=e;l;l=La(l))g++;for(;0<k-g;)b=La(b),k--;for(;0<g-k;)e=La(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
	f.alternate;if(null!==k&&k===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function bd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var cd=Object.prototype.hasOwnProperty;
	function dd(a,b){if(bd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!cd.call(b,c[d])||!bd(a[c[d]],b[c[d]]))return!1;return!0}function ed(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function fd(a){2!==ed(a)?x("188"):void 0}
	function gd(a){var b=a.alternate;if(!b)return b=ed(a),3===b?x("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return fd(e),a;if(g===d)return fd(e),b;g=g.sibling}x("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:x("189")}}c.alternate!==d?x("190"):void 0}3!==c.tag?x("188"):void 0;return c.stateNode.current===c?a:b}function hd(a){a=gd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var id=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),jd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),kd=Qc.extend({relatedTarget:null});function ld(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var md={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},od=Qc.extend({key:function(a){if(a.key){var b=md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ld(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?nd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Tc,charCode:function(a){return"keypress"===
	a.type?ld(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ld(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),pd=Yc.extend({dataTransfer:null}),qd=Qc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Tc}),rd=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),sd=Yc.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["abort","abort"],[Xa,"animationEnd"],[Ya,"animationIteration"],[Za,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[$a,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],ud={},vd={};function wd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};ud[a]=b;vd[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
	["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){wd(a,!0)});td.forEach(function(a){wd(a,!1)});
	var xd={eventTypes:ud,isInteractiveTopLevelEventType:function(a){a=vd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===ld(c))return null;case "keydown":case "keyup":a=od;break;case "blur":case "focus":a=kd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=Yc;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Xa:case Ya:case Za:a=id;break;case $a:a=rd;break;case "scroll":a=Qc;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Zc;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},yd=xd.isInteractiveTopLevelEventType,
	zd=[];function Ad(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Nb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<oa.length;h++){var l=oa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=xa(g,l))}Da(g)}}var Bd=!0;
	function E(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!1)}function Ed(a,b){if(!b)return null;var c=(yd(a)?Cd:Dd).bind(null,a);b.addEventListener(a,c,!0)}function Cd(a,b){Hb(Dd,a,b)}
	function Dd(a,b){if(Bd){var c=Nb(b);c=Ha(c);null===c||"number"!==typeof c.tag||2===ed(c)||(c=null);if(zd.length){var d=zd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Kb(Ad,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>zd.length&&zd.push(a)}}}var Fd={},Gd=0,Hd="_reactListenersID"+(""+Math.random()).slice(2);
	function Id(a){Object.prototype.hasOwnProperty.call(a,Hd)||(a[Hd]=Gd++,Fd[a[Hd]]={});return Fd[a[Hd]]}function Jd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Kd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Ld(a,b){var c=Kd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Kd(c)}}function Md(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Md(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Nd(){for(var a=window,b=Jd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Jd(a.document)}return b}function Od(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	function Pd(){var a=Nd();if(Od(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{b=(b=a.ownerDocument)&&b.defaultView||window;var c=b.getSelection&&b.getSelection();if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(A){b=null;break a}var f=0,g=-1,h=-1,l=0,k=0,m=a,p=null;b:for(;;){for(var t;;){m!==b||0!==d&&3!==m.nodeType||(g=f+d);m!==e||0!==c&&3!==m.nodeType||(h=f+c);3===m.nodeType&&(f+=m.nodeValue.length);
	if(null===(t=m.firstChild))break;p=m;m=t}for(;;){if(m===a)break b;p===b&&++l===d&&(g=f);p===e&&++k===c&&(h=f);if(null!==(t=m.nextSibling))break;m=p;p=m.parentNode}m=t}b=-1===g||-1===h?null:{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;return{focusedElem:a,selectionRange:b}}
	function Qd(a){var b=Nd(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Md(c.ownerDocument.documentElement,c)){if(null!==d&&Od(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ld(c,f);var g=Ld(c,
	d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
	var Rd=Ra&&"documentMode"in document&&11>=document.documentMode,Sd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Td=null,Ud=null,Vd=null,Wd=!1;
	function Xd(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Wd||null==Td||Td!==Jd(c))return null;c=Td;"selectionStart"in c&&Od(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Vd&&dd(Vd,c)?null:(Vd=c,a=y.getPooled(Sd.select,Ud,a,b),a.type="select",a.target=Td,Qa(a),a)}
	var Yd={eventTypes:Sd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Id(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Mb(e)||"true"===e.contentEditable)Td=e,Ud=b,Vd=null;break;case "blur":Vd=Ud=Td=null;break;case "mousedown":Wd=!0;break;case "contextmenu":case "mouseup":case "dragend":return Wd=!1,Xd(c,d);case "selectionchange":if(Rd)break;
	case "keydown":case "keyup":return Xd(c,d)}return null}};Ba.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ta=Ka;ua=Ia;va=Ja;Ba.injectEventPluginsByName({SimpleEventPlugin:xd,EnterLeaveEventPlugin:ad,ChangeEventPlugin:Pc,SelectEventPlugin:Yd,BeforeInputEventPlugin:zb});function Zd(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function $d(a,b){a=n({children:void 0},b);if(b=Zd(b.children))a.children=b;return a}function ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+uc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function be(a,b){null!=b.dangerouslySetInnerHTML?x("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ce(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?x("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:x("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:uc(c)}}
	function de(a,b){var c=uc(b.value),d=uc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ee(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var fe={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function ge(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function he(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ge(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ie=void 0,je=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==fe.svg||"innerHTML"in a)a.innerHTML=b;else{ie=ie||document.createElement("div");ie.innerHTML="<svg>"+b+"</svg>";for(b=ie.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function ke(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var le={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},me=["Webkit","ms","Moz","O"];Object.keys(le).forEach(function(a){me.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);le[b]=le[a]})});function ne(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||le.hasOwnProperty(a)&&le[a]?(""+b).trim():b+"px"}
	function oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ne(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var pe=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function qe(a,b){b&&(pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?x("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?x("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:x("61")),null!=b.style&&"object"!==typeof b.style?x("62",""):void 0)}
	function re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function se(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Id(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Ed("scroll",a);break;case "focus":case "blur":Ed("focus",a);Ed("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Ob(e)&&Ed(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===ab.indexOf(e)&&E(e,a)}c[e]=!0}}}function te(){}var ue=null,ve=null;
	function we(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function xe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
	var ye="function"===typeof setTimeout?setTimeout:void 0,ze="function"===typeof clearTimeout?clearTimeout:void 0,Ae=r.unstable_scheduleCallback,Be=r.unstable_cancelCallback;
	function Ce(a,b,c,d,e){a[Ga]=e;"input"===c&&"radio"===e.type&&null!=e.name&&xc(a,e);re(c,d);d=re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?oe(a,h):"dangerouslySetInnerHTML"===g?je(a,h):"children"===g?ke(a,h):tc(a,g,h,d)}switch(c){case "input":yc(a,e);break;case "textarea":de(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ae(a,!!e.multiple,e.defaultValue,
	!0):ae(a,!!e.multiple,e.multiple?[]:"",!1))}}function De(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ee(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Fe=[],Ge=-1;function F(a){0>Ge||(a.current=Fe[Ge],Fe[Ge]=null,Ge--)}function G(a,b){Ge++;Fe[Ge]=a.current;a.current=b}var He={},H={current:He},I={current:!1},Ie=He;
	function Je(a,b){var c=a.type.contextTypes;if(!c)return He;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function J(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Ke(a){F(I,a);F(H,a)}function Le(a){F(I,a);F(H,a)}
	function Me(a,b,c){H.current!==He?x("168"):void 0;G(H,b,a);G(I,c,a)}function Ne(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:x("108",ic(b)||"Unknown",e);return n({},c,d)}function Oe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||He;Ie=H.current;G(H,b,a);G(I,I.current,a);return!0}
	function Pe(a,b,c){var d=a.stateNode;d?void 0:x("169");c?(b=Ne(a,b,Ie),d.__reactInternalMemoizedMergedChildContext=b,F(I,a),F(H,a),G(H,b,a)):F(I,a);G(I,c,a)}var Qe=null,Re=null;function Se(a){return function(b){try{return a(b)}catch(c){}}}
	function Te(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Qe=Se(function(a){return b.onCommitFiberRoot(c,a)});Re=Se(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
	function Ue(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function K(a,b,c,d){return new Ue(a,b,c,d)}
	function Ve(a){a=a.prototype;return!(!a||!a.isReactComponent)}function We(a){if("function"===typeof a)return Ve(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===cc)return 11;if(a===ec)return 14}return 2}
	function Xe(a,b){var c=a.alternate;null===c?(c=K(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
	c.index=a.index;c.ref=a.ref;return c}
	function Ye(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ve(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Xb:return Ze(c.children,e,f,b);case bc:return $e(c,e|3,f,b);case Yb:return $e(c,e|2,f,b);case Zb:return a=K(12,c,b,e|4),a.elementType=Zb,a.type=Zb,a.expirationTime=f,a;case dc:return a=K(13,c,b,e),a.elementType=dc,a.type=dc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case $b:g=10;break a;case ac:g=9;break a;case cc:g=11;break a;case ec:g=
	14;break a;case fc:g=16;d=null;break a}x("130",null==a?a:typeof a,"")}b=K(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Ze(a,b,c,d){a=K(7,a,d,b);a.expirationTime=c;return a}function $e(a,b,c,d){a=K(8,a,d,b);b=0===(b&1)?Yb:bc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function af(a,b,c){a=K(6,a,null,b);a.expirationTime=c;return a}
	function bf(a,b,c){b=K(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function cf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);df(b,a)}
	function ef(a,b){a.didError=!1;if(0===b)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0;else{b<a.latestPingedTime&&(a.latestPingedTime=0);var c=a.latestPendingTime;0!==c&&(c>b?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>b&&(a.earliestPendingTime=a.latestPendingTime));c=a.earliestSuspendedTime;0===c?cf(a,b):b<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,cf(a,b)):
	b>c&&cf(a,b)}df(0,a)}function ff(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);df(b,a)}
	function gf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}function df(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function L(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function hf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var jf=(new aa.Component).refs;
	function kf(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var tf={isMounted:function(a){return(a=a._reactInternalFiber)?2===ed(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=lf();d=mf(d,a);var e=nf(d);e.tag=rf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);of();pf(a,e);qf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=lf();c=mf(c,a);var d=nf(c);d.tag=
	sf;void 0!==b&&null!==b&&(d.callback=b);of();pf(a,d);qf(a,c)}};function uf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!dd(c,d)||!dd(e,f):!0}
	function vf(a,b,c){var d=!1,e=He;var f=b.contextType;"object"===typeof f&&null!==f?f=M(f):(e=J(b)?Ie:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Je(a,e):He);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=tf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function wf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&tf.enqueueReplaceState(b,b.state,null)}
	function xf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=jf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=M(f):(f=J(b)?Ie:H.current,e.context=Je(a,f));f=a.updateQueue;null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(kf(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&tf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(yf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var zf=Array.isArray;
	function Af(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?x("309"):void 0,d=c.stateNode);d?void 0:x("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===jf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?x("284"):void 0;c._owner?void 0:x("290",a)}return a}
	function Bf(a,b){"textarea"!==a.type&&x("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function Cf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Xe(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=af(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Af(a,b,c),d.return=a,d;d=Ye(c.type,c.key,c.props,null,a.mode,d);d.ref=Af(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=bf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Ze(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=af(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Vb:return c=Ye(b.type,b.key,b.props,null,a.mode,c),c.ref=Af(a,null,b),c.return=a,c;case Wb:return b=bf(b,a.mode,c),b.return=a,b}if(zf(b)||
	hc(b))return b=Ze(b,a.mode,c,null),b.return=a,b;Bf(a,b)}return null}function t(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Vb:return c.key===e?c.type===Xb?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case Wb:return c.key===e?k(a,b,c,d):null}if(zf(c)||hc(c))return null!==e?null:m(a,b,c,d,null);Bf(a,c)}return null}function A(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Vb:return a=a.get(null===d.key?c:d.key)||null,d.type===Xb?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case Wb:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(zf(d)||hc(d))return a=a.get(c)||null,m(b,a,d,e,null);Bf(b,d)}return null}function v(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,B=null;null!==q&&u<h.length;u++){q.index>u?(B=q,q=null):B=q.sibling;var w=t(e,q,h[u],k);if(null===w){null===q&&(q=B);break}a&&
	q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=B}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(B=A(q,e,u,h[u],k))a&&null!==B.alternate&&q.delete(null===B.key?u:B.key),g=f(B,g,u),null===m?l=B:m.sibling=B,m=B;a&&q.forEach(function(a){return b(e,a)});return l}function R(e,g,h,k){var l=hc(h);"function"!==typeof l?x("150"):void 0;h=l.call(h);null==h?x("151"):void 0;
	for(var m=l=null,q=g,u=g=0,B=null,w=h.next();null!==q&&!w.done;u++,w=h.next()){q.index>u?(B=q,q=null):B=q.sibling;var v=t(e,q,w.value,k);if(null===v){q||(q=B);break}a&&q&&null===v.alternate&&b(e,q);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;q=B}if(w.done)return c(e,q),l;if(null===q){for(;!w.done;u++,w=h.next())w=p(e,w.value,k),null!==w&&(g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);return l}for(q=d(e,q);!w.done;u++,w=h.next())w=A(q,e,u,w.value,k),null!==w&&(a&&null!==w.alternate&&q.delete(null===w.key?u:
	w.key),g=f(w,g,u),null===m?l=w:m.sibling=w,m=w);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Xb&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Vb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Xb:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Xb?f.props.children:f.props,h);d.ref=Af(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
	k.sibling}f.type===Xb?(d=Ze(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ye(f.type,f.key,f.props,null,a.mode,h),h.ref=Af(a,d,f),h.return=a,a=h)}return g(a);case Wb:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=bf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
	""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=af(f,a.mode,h),d.return=a,a=d),g(a);if(zf(f))return v(a,d,f,h);if(hc(f))return R(a,d,f,h);l&&Bf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,x("152",h.displayName||h.name||"Component")}return c(a,d)}}var Df=Cf(!0),Ef=Cf(!1),Ff={},N={current:Ff},Gf={current:Ff},Hf={current:Ff};function If(a){a===Ff?x("174"):void 0;return a}
	function Jf(a,b){G(Hf,b,a);G(Gf,a,a);G(N,Ff,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:he(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=he(b,c)}F(N,a);G(N,b,a)}function Kf(a){F(N,a);F(Gf,a);F(Hf,a)}function Lf(a){If(Hf.current);var b=If(N.current);var c=he(b,a.type);b!==c&&(G(Gf,a,a),G(N,c,a))}function Mf(a){Gf.current===a&&(F(N,a),F(Gf,a))}
	var Nf=0,Of=2,Pf=4,Qf=8,Rf=16,Sf=32,Tf=64,Uf=128,Vf=Tb.ReactCurrentDispatcher,Wf=0,Xf=null,O=null,P=null,Yf=null,Q=null,Zf=null,$f=0,ag=null,bg=0,cg=!1,dg=null,eg=0;function fg(){x("321")}function gg(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!bd(a[c],b[c]))return!1;return!0}
	function hg(a,b,c,d,e,f){Wf=f;Xf=b;P=null!==a?a.memoizedState:null;Vf.current=null===P?ig:jg;b=c(d,e);if(cg){do cg=!1,eg+=1,P=null!==a?a.memoizedState:null,Zf=Yf,ag=Q=O=null,Vf.current=jg,b=c(d,e);while(cg);dg=null;eg=0}Vf.current=kg;a=Xf;a.memoizedState=Yf;a.expirationTime=$f;a.updateQueue=ag;a.effectTag|=bg;a=null!==O&&null!==O.next;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;a?x("300"):void 0;return b}function lg(){Vf.current=kg;Wf=0;Zf=Q=Yf=P=O=Xf=null;$f=0;ag=null;bg=0;cg=!1;dg=null;eg=0}
	function mg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===Q?Yf=Q=a:Q=Q.next=a;return Q}function ng(){if(null!==Zf)Q=Zf,Zf=Q.next,O=P,P=null!==O?O.next:null;else{null===P?x("310"):void 0;O=P;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};Q=null===Q?Yf=a:Q.next=a;P=O.next}return Q}function og(a,b){return"function"===typeof b?b(a):b}
	function pg(a){var b=ng(),c=b.queue;null===c?x("311"):void 0;c.lastRenderedReducer=a;if(0<eg){var d=c.dispatch;if(null!==dg){var e=dg.get(c);if(void 0!==e){dg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
	d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;m<Wf?(k||(k=!0,h=g,e=f),m>$f&&($f=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);bd(f,b.memoizedState)||(qg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function rg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===ag?(ag={lastEffect:null},ag.lastEffect=a.next=a):(b=ag.lastEffect,null===b?ag.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,ag.lastEffect=a));return a}function sg(a,b,c,d){var e=mg();bg|=a;e.memoizedState=rg(b,c,void 0,void 0===d?null:d)}
	function tg(a,b,c,d){var e=ng();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&gg(d,g.deps)){rg(Nf,c,f,d);return}}bg|=a;e.memoizedState=rg(b,c,f,d)}function ug(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function vg(){}
	function wg(a,b,c){25>eg?void 0:x("301");var d=a.alternate;if(a===Xf||null!==d&&d===Xf)if(cg=!0,a={expirationTime:Wf,action:c,eagerReducer:null,eagerState:null,next:null},null===dg&&(dg=new Map),c=dg.get(b),void 0===c)dg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{of();var e=lf();e=mf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
	d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var l=b.lastRenderedState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(bd(k,l))return}catch(m){}finally{}qf(a,e)}}
	var kg={readContext:M,useCallback:fg,useContext:fg,useEffect:fg,useImperativeHandle:fg,useLayoutEffect:fg,useMemo:fg,useReducer:fg,useRef:fg,useState:fg,useDebugValue:fg},ig={readContext:M,useCallback:function(a,b){mg().memoizedState=[a,void 0===b?null:b];return a},useContext:M,useEffect:function(a,b){return sg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return sg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,b){return sg(4,Pf|Sf,a,b)},
	useMemo:function(a,b){var c=mg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=mg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=wg.bind(null,Xf,a);return[d.memoizedState,a]},useRef:function(a){var b=mg();a={current:a};return b.memoizedState=a},useState:function(a){var b=mg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,
	lastRenderedReducer:og,lastRenderedState:a};a=a.dispatch=wg.bind(null,Xf,a);return[b.memoizedState,a]},useDebugValue:vg},jg={readContext:M,useCallback:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:M,useEffect:function(a,b){return tg(516,Uf|Tf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return tg(4,Pf|Sf,ug.bind(null,b,a),c)},useLayoutEffect:function(a,
	b){return tg(4,Pf|Sf,a,b)},useMemo:function(a,b){var c=ng();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&gg(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:pg,useRef:function(){return ng().memoizedState},useState:function(a){return pg(og,a)},useDebugValue:vg},xg=null,yg=null,zg=!1;
	function Ag(a,b){var c=K(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Bg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Cg(a){if(zg){var b=yg;if(b){var c=b;if(!Bg(a,b)){b=De(c);if(!b||!Bg(a,b)){a.effectTag|=2;zg=!1;xg=a;return}Ag(xg,c)}xg=a;yg=Ee(b)}else a.effectTag|=2,zg=!1,xg=a}}function Dg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;xg=a}function Eg(a){if(a!==xg)return!1;if(!zg)return Dg(a),zg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!xe(b,a.memoizedProps))for(b=yg;b;)Ag(a,b),b=De(b);Dg(a);yg=xg?De(a.stateNode):null;return!0}function Fg(){yg=xg=null;zg=!1}
	var Gg=Tb.ReactCurrentOwner,qg=!1;function S(a,b,c,d){b.child=null===a?Ef(b,null,c,d):Df(b,a.child,c,d)}function Hg(a,b,c,d,e){c=c.render;var f=b.ref;Ig(b,e);d=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
	function Kg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ve(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Lg(a,b,g,d,e,f);a=Ye(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:dd,c(e,d)&&a.ref===b.ref))return Jg(a,b,f);b.effectTag|=1;a=Xe(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Lg(a,b,c,d,e,f){return null!==a&&dd(a.memoizedProps,d)&&a.ref===b.ref&&(qg=!1,e<f)?Jg(a,b,f):Mg(a,b,c,d,f)}function Ng(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Mg(a,b,c,d,e){var f=J(c)?Ie:H.current;f=Je(b,f);Ig(b,e);c=hg(a,b,c,d,f,e);if(null!==a&&!qg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Jg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
	function Og(a,b,c,d,e){if(J(c)){var f=!0;Oe(b)}else f=!1;Ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),vf(b,c,d,e),xf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k);Pg=!1;var t=b.memoizedState;l=g.state=t;var A=b.updateQueue;null!==A&&(yf(b,A,d,g,e),l=b.memoizedState);h!==d||t!==l||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),l=b.memoizedState),(h=Pg||uf(b,c,h,d,t,l,k))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:L(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=M(k):(k=J(c)?Ie:H.current,k=Je(b,k)),m=c.getDerivedStateFromProps,(p="function"===
	typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&wf(b,g,d,k),Pg=!1,l=b.memoizedState,t=g.state=l,A=b.updateQueue,null!==A&&(yf(b,A,d,g,e),t=b.memoizedState),h!==d||l!==t||I.current||Pg?("function"===typeof m&&(kf(b,c,m,d),t=b.memoizedState),(m=Pg||uf(b,c,h,d,l,t,k))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
	typeof g.componentWillUpdate&&g.componentWillUpdate(d,t,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,t,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
	t),g.props=d,g.state=t,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Qg(a,b,c,d,f,e)}
	function Qg(a,b,c,d,e,f){Ng(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Pe(b,c,!1),Jg(a,b,f);d=b.stateNode;Gg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Df(b,a.child,null,f),b.child=Df(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Pe(b,c,!0);return b.child}function Rg(a){var b=a.stateNode;b.pendingContext?Me(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Me(a,b.context,!1);Jf(a,b.containerInfo)}
	function Sg(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=Ze(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=Ze(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Ef(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=Xe(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
	b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=Xe(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=Df(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=Ze(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=Ze(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Df(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
	function Jg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?x("153"):void 0;if(null!==b.child){a=b.child;c=Xe(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xe(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function Tg(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||I.current)qg=!0;else{if(d<c){qg=!1;switch(b.tag){case 3:Rg(b);Fg();break;case 5:Lf(b);break;case 1:J(b.type)&&Oe(b);break;case 4:Jf(b,b.stateNode.containerInfo);break;case 10:Ug(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Sg(a,b,c);b=Jg(a,b,c);return null!==b?b.sibling:null}}return Jg(a,b,c)}}else qg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
	b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Je(b,H.current);Ig(b,c);e=hg(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;lg();if(J(d)){var f=!0;Oe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&kf(b,d,g,a);e.updater=tf;b.stateNode=e;e._reactInternalFiber=b;xf(b,d,a,c);b=Qg(null,b,d,!0,f,
	c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=hf(e);b.type=a;e=b.tag=We(a);f=L(a,f);g=void 0;switch(e){case 0:g=Mg(null,b,a,f,c);break;case 1:g=Og(null,b,a,f,c);break;case 11:g=Hg(null,b,a,f,c);break;case 14:g=Kg(null,b,a,L(a.type,f),d,c);break;default:x("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Mg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
	e=b.elementType===d?e:L(d,e),Og(a,b,d,e,c);case 3:Rg(b);d=b.updateQueue;null===d?x("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;yf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Fg(),b=Jg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)yg=Ee(b.stateNode.containerInfo),xg=b,e=zg=!0;e?(b.effectTag|=2,b.child=Ef(b,null,d,c)):(S(a,b,d,c),Fg());b=b.child}return b;case 5:return Lf(b),null===a&&Cg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
	g=e.children,xe(d,e)?g=null:null!==f&&xe(d,f)&&(b.effectTag|=16),Ng(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Cg(b),null;case 13:return Sg(a,b,c);case 4:return Jf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Df(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:L(d,e),Hg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
	c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;Ug(b,f);if(null!==g){var h=g.value;f=bd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!I.current){b=Jg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
	(k.observedBits&f)){1===h.tag&&(k=nf(c),k.tag=sf,pf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);k=c;for(var m=h.return;null!==m;){var p=m.alternate;if(m.childExpirationTime<k)m.childExpirationTime=k,null!==p&&p.childExpirationTime<k&&(p.childExpirationTime=k);else if(null!==p&&p.childExpirationTime<k)p.childExpirationTime=k;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?
	null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Ig(b,c),e=M(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=L(e,b.pendingProps),f=L(e.type,f),Kg(a,b,e,f,d,c);case 15:return Lg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
	d?e:L(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,J(d)?(a=!0,Oe(b)):a=!1,Ig(b,c),vf(b,d,e,c),xf(b,d,e,c),Qg(null,b,d,!0,a,c)}x("156")}var Vg={current:null},Wg=null,Xg=null,Yg=null;function Ug(a,b){var c=a.type._context;G(Vg,c._currentValue,a);c._currentValue=b}function Zg(a){var b=Vg.current;F(Vg,a);a.type._context._currentValue=b}function Ig(a,b){Wg=a;Yg=Xg=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(qg=!0);a.contextDependencies=null}
	function M(a,b){if(Yg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Yg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===Xg?(null===Wg?x("308"):void 0,Xg=b,Wg.contextDependencies={first:b,expirationTime:0}):Xg=Xg.next=b}return a._currentValue}var $g=0,rf=1,sf=2,ah=3,Pg=!1;function bh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function ch(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function nf(a){return{expirationTime:a,tag:$g,payload:null,callback:null,next:null,nextEffect:null}}function dh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function pf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=bh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=bh(a.memoizedState),e=c.updateQueue=bh(c.memoizedState)):d=a.updateQueue=ch(e):null===e&&(e=c.updateQueue=ch(d));null===e||d===e?dh(d,b):null===d.lastUpdate||null===e.lastUpdate?(dh(d,b),dh(e,b)):(dh(d,b),e.lastUpdate=b)}
	function eh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=bh(a.memoizedState):fh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function fh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=ch(b));return b}
	function gh(a,b,c,d,e,f){switch(c.tag){case rf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ah:a.effectTag=a.effectTag&-2049|64;case $g:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case sf:Pg=!0}return d}
	function yf(a,b,c,d,e){Pg=!1;b=fh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var p=l.expirationTime;p<e?(null===m&&(m=l,null===g&&(f=k)),h<p&&(h=p)):(k=gh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
	32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
	function hh(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ih(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ih(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ih(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?x("191",c):void 0;c.call(d)}a=a.nextEffect}}
	function jh(a,b){return{value:a,source:b,stack:jc(b)}}function kh(a){a.effectTag|=4}var lh=void 0,mh=void 0,nh=void 0,oh=void 0;lh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};mh=function(){};
	nh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;If(N.current);a=null;switch(c){case "input":f=vc(g,f);d=vc(g,d);a=[];break;case "option":f=$d(g,f);d=$d(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=be(g,f);d=be(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=te)}qe(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ra.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
	(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ra.hasOwnProperty(c)?(null!=k&&se(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&kh(b)}};oh=function(a,b,c,d){c!==d&&kh(b)};
	var ph="function"===typeof WeakSet?WeakSet:Set;function qh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=jc(c));null!==c&&ic(c.type);b=b.value;null!==a&&1===a.tag&&ic(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function rh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){sh(a,c)}else b.current=null}
	function th(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Nf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Nf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function uh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=ne("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
	c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
	function vh(a){"function"===typeof Re&&Re(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){sh(e,f)}}c=c.next}while(c!==b)}break;case 1:rh(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){sh(a,f)}break;case 5:rh(a);break;case 4:wh(a)}}
	function xh(a){return 5===a.tag||3===a.tag||4===a.tag}
	function yh(a){a:{for(var b=a.return;null!==b;){if(xh(b)){var c=b;break a}b=b.return}x("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:x("161")}c.effectTag&16&&(ke(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||xh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&
	2)continue b;if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=te)):b.appendChild(e.stateNode);
	else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function wh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?x("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(vh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag){if(null!==b.child){d=b.stateNode.containerInfo;e=!0;b.child.return=b;b=b.child;continue}}else if(vh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function zh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:th(Pf,Qf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ce(c,f,e,a,d,b)}break;case 6:null===b.stateNode?x("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=lf()));null!==a&&uh(a,d);c=
	b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new ph);c.forEach(function(a){var c=Ah.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:x("163")}}var Bh="function"===typeof WeakMap?WeakMap:Map;function Ch(a,b,c){c=nf(c);c.tag=ah;c.payload={element:null};var d=b.value;c.callback=function(){Dh(d);qh(a,b)};return c}
	function Eh(a,b,c){c=nf(c);c.tag=ah;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Fh?Fh=new Set([this]):Fh.add(this));var c=b.value,e=b.stack;qh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
	function Gh(a){switch(a.tag){case 1:J(a.type)&&Ke(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Kf(a),Le(a),b=a.effectTag,0!==(b&64)?x("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Mf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 4:return Kf(a),null;case 10:return Zg(a),null;default:return null}}
	var Hh=Tb.ReactCurrentDispatcher,Ih=Tb.ReactCurrentOwner,Jh=1073741822,Kh=!1,T=null,Lh=null,U=0,Mh=-1,Nh=!1,V=null,Oh=!1,Ph=null,Qh=null,Rh=null,Fh=null;function Sh(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Ke(b);break;case 3:Kf(b);Le(b);break;case 5:Mf(b);break;case 4:Kf(b);break;case 10:Zg(b)}a=a.return}Lh=null;U=0;Mh=-1;Nh=!1;T=null}
	function Th(){for(;null!==V;){var a=V.effectTag;a&16&&ke(V.stateNode,"");if(a&128){var b=V.alternate;null!==b&&(b=b.ref,null!==b&&("function"===typeof b?b(null):b.current=null))}switch(a&14){case 2:yh(V);V.effectTag&=-3;break;case 6:yh(V);V.effectTag&=-3;zh(V.alternate,V);break;case 4:zh(V.alternate,V);break;case 8:a=V,wh(a),a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null,a=a.alternate,null!==a&&(a.return=null,a.child=null,a.memoizedState=null,a.updateQueue=null)}V=V.nextEffect}}
	function Uh(){for(;null!==V;){if(V.effectTag&256)a:{var a=V.alternate,b=V;switch(b.tag){case 0:case 11:case 15:th(Of,Nf,b);break a;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:L(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break a;case 3:case 5:case 6:case 4:case 17:break a;default:x("163")}}V=V.nextEffect}}
	function Vh(a,b){for(;null!==V;){var c=V.effectTag;if(c&36){var d=V.alternate,e=V,f=b;switch(e.tag){case 0:case 11:case 15:th(Rf,Sf,e);break;case 1:var g=e.stateNode;if(e.effectTag&4)if(null===d)g.componentDidMount();else{var h=e.elementType===e.type?d.memoizedProps:L(e.type,d.memoizedProps);g.componentDidUpdate(h,d.memoizedState,g.__reactInternalSnapshotBeforeUpdate)}d=e.updateQueue;null!==d&&hh(e,d,g,f);break;case 3:d=e.updateQueue;if(null!==d){g=null;if(null!==e.child)switch(e.child.tag){case 5:g=
	e.child.stateNode;break;case 1:g=e.child.stateNode}hh(e,d,g,f)}break;case 5:f=e.stateNode;null===d&&e.effectTag&4&&we(e.type,e.memoizedProps)&&f.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:x("163")}}c&128&&(e=V.ref,null!==e&&(f=V.stateNode,"function"===typeof e?e(f):e.current=f));c&512&&(Ph=a);V=V.nextEffect}}
	function Wh(a,b){Rh=Qh=Ph=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;th(Uf,Nf,f);th(Nf,Tf,f)}catch(g){d=!0,e=g}d&&sh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&Xh(a,c);X||W||Yh(1073741823,!1)}function of(){null!==Qh&&Be(Qh);null!==Rh&&Rh()}
	function Zh(a,b){Oh=Kh=!0;a.current===b?x("177"):void 0;var c=a.pendingCommitExpirationTime;0===c?x("261"):void 0;a.pendingCommitExpirationTime=0;var d=b.expirationTime,e=b.childExpirationTime;ef(a,e>d?e:d);Ih.current=null;d=void 0;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ue=Bd;ve=Pd();Bd=!1;for(V=d;null!==V;){e=!1;var f=void 0;try{Uh()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){e=!1;
	f=void 0;try{Th()}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}Qd(ve);ve=null;Bd=!!ue;ue=null;a.current=b;for(V=d;null!==V;){e=!1;f=void 0;try{Vh(a,c)}catch(h){e=!0,f=h}e&&(null===V?x("178"):void 0,sh(V,f),null!==V&&(V=V.nextEffect))}if(null!==d&&null!==Ph){var g=Wh.bind(null,a,d);Qh=r.unstable_runWithPriority(r.unstable_NormalPriority,function(){return Ae(g)});Rh=g}Kh=Oh=!1;"function"===typeof Qe&&Qe(b.stateNode);c=b.expirationTime;b=b.childExpirationTime;b=
	b>c?b:c;0===b&&(Fh=null);$h(a,b)}
	function ai(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:J(b.type)&&Ke(b);break;case 3:Kf(b);Le(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Eg(b),b.effectTag&=-3;mh(b);break;case 5:Mf(b);var h=If(Hf.current);f=b.type;if(null!==e&&null!=b.stateNode)nh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
	128);else if(g){var l=If(N.current);if(Eg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,p=h;e[Fa]=g;e[Ga]=m;f=void 0;h=k;switch(h){case "iframe":case "object":E("load",e);break;case "video":case "audio":for(k=0;k<ab.length;k++)E(ab[k],e);break;case "source":E("error",e);break;case "img":case "image":case "link":E("error",e);E("load",e);break;case "form":E("reset",e);E("submit",e);break;case "details":E("toggle",e);break;case "input":wc(e,m);E("invalid",e);se(p,"onChange");break;case "select":e._wrapperState=
	{wasMultiple:!!m.multiple};E("invalid",e);se(p,"onChange");break;case "textarea":ce(e,m),E("invalid",e),se(p,"onChange")}qe(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ra.hasOwnProperty(f)&&null!=l&&se(p,f));switch(h){case "input":Rb(e);Ac(e,m,!0);break;case "textarea":Rb(e);ee(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
	(e.onclick=te)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&kh(b)}else{m=b;p=f;e=g;k=9===h.nodeType?h:h.ownerDocument;l===fe.html&&(l=ge(p));l===fe.html?"script"===p?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof e.is?k=k.createElement(p,{is:e.is}):(k=k.createElement(p),"select"===p&&(p=k,e.multiple?p.multiple=!0:e.size&&(p.size=e.size))):k=k.createElementNS(l,p);e=k;e[Fa]=m;e[Ga]=g;lh(e,b,!1,!1);p=e;k=f;m=g;var t=h,A=re(k,m);switch(k){case "iframe":case "object":E("load",
	p);h=m;break;case "video":case "audio":for(h=0;h<ab.length;h++)E(ab[h],p);h=m;break;case "source":E("error",p);h=m;break;case "img":case "image":case "link":E("error",p);E("load",p);h=m;break;case "form":E("reset",p);E("submit",p);h=m;break;case "details":E("toggle",p);h=m;break;case "input":wc(p,m);h=vc(p,m);E("invalid",p);se(t,"onChange");break;case "option":h=$d(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};h=n({},m,{value:void 0});E("invalid",p);se(t,"onChange");break;case "textarea":ce(p,
	m);h=be(p,m);E("invalid",p);se(t,"onChange");break;default:h=m}qe(k,h);l=void 0;var v=k,R=p,u=h;for(l in u)if(u.hasOwnProperty(l)){var q=u[l];"style"===l?oe(R,q):"dangerouslySetInnerHTML"===l?(q=q?q.__html:void 0,null!=q&&je(R,q)):"children"===l?"string"===typeof q?("textarea"!==v||""!==q)&&ke(R,q):"number"===typeof q&&ke(R,""+q):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ra.hasOwnProperty(l)?null!=q&&se(t,l):null!=q&&tc(R,l,q,A))}switch(k){case "input":Rb(p);
	Ac(p,m,!1);break;case "textarea":Rb(p);ee(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+uc(m.value));break;case "select":h=p;h.multiple=!!m.multiple;p=m.value;null!=p?ae(h,!!m.multiple,p,!1):null!=m.defaultValue&&ae(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(p.onclick=te)}(g=we(f,g))&&kh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?x("166"):void 0;break;case 6:e&&null!=b.stateNode?oh(e,b,e.memoizedProps,g):("string"!==
	typeof g&&(null===b.stateNode?x("166"):void 0),e=If(Hf.current),If(N.current),Eg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Fa]=g,(g=f.nodeValue!==e)&&kh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Fa]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
	b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Kf(b);mh(b);break;case 10:Zg(b);break;case 9:break;case 14:break;case 17:J(b.type)&&Ke(b);break;case 18:break;default:x("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&
	(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Gh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
	function bi(a){var b=Tg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=ai(a));Ih.current=null;return b}
	function ci(a,b){Kh?x("243"):void 0;of();Kh=!0;var c=Hh.current;Hh.current=kg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Lh||null===T)Sh(),Lh=a,U=d,T=Xe(Lh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!di();)T=bi(T);else for(;null!==T;)T=bi(T)}catch(u){if(Yg=Xg=Wg=null,lg(),null===T)e=!0,Dh(u);else{null===T?x("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Dh(u);else{a:{var h=a,l=g,k=f,m=u;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
	m&&"object"===typeof m&&"function"===typeof m.then){var p=m;m=l;var t=-1,A=-1;do{if(13===m.tag){var v=m.alternate;if(null!==v&&(v=v.memoizedState,null!==v)){A=10*(1073741822-v.timedOutAt);break}v=m.pendingProps.maxDuration;if("number"===typeof v)if(0>=v)t=0;else if(-1===t||v<t)t=v}m=m.return}while(null!==m);m=l;do{if(v=13===m.tag)v=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(v){l=m.updateQueue;null===l?(l=new Set,l.add(p),m.updateQueue=l):l.add(p);if(0===(m.mode&1)){m.effectTag|=
	64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=nf(1073741823),g.tag=sf,pf(k,g)));k.expirationTime=1073741823;break a}k=h;l=g;var R=k.pingCache;null===R?(R=k.pingCache=new Bh,v=new Set,R.set(p,v)):(v=R.get(p),void 0===v&&(v=new Set,R.set(p,v)));v.has(l)||(v.add(l),k=ei.bind(null,k,p,l),p.then(k,k));-1===t?h=1073741823:(-1===A&&(A=10*(1073741822-gf(h,g))-5E3),h=A+t);0<=h&&Mh<h&&(Mh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((ic(k.type)||"A React component")+
	" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+jc(k))}Nh=!0;m=jh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Ch(h,m,g);eh(h,g);break a;case 1:if(t=m,A=h.type,k=h.stateNode,0===(h.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==k&&"function"===typeof k.componentDidCatch&&(null===Fh||!Fh.has(k)))){h.effectTag|=2048;
	h.expirationTime=g;g=Eh(h,t,g);eh(h,g);break a}}h=h.return}while(null!==h)}T=ai(f);continue}}}break}while(1);Kh=!1;Hh.current=c;Yg=Xg=Wg=null;lg();if(e)Lh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?x("281"):void 0;Lh=null;if(Nh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){ff(a,d);fi(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
	b=a.expirationTime=1073741823;fi(a,c,d,b,-1);return}}b&&-1!==Mh?(ff(a,d),b=10*(1073741822-gf(a,d)),b<Mh&&(Mh=b),b=10*(1073741822-lf()),b=Mh-b,fi(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
	function sh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Fh||!Fh.has(d))){a=jh(b,a);a=Eh(c,a,1073741823);pf(c,a);qf(c,1073741823);return}break;case 3:a=jh(b,a);a=Ch(c,a,1073741823);pf(c,a);qf(c,1073741823);return}c=c.return}3===a.tag&&(c=jh(b,a),c=Ch(a,c,1073741823),pf(a,c),qf(a,1073741823))}
	function mf(a,b){var c=r.unstable_getCurrentPriorityLevel(),d=void 0;if(0===(b.mode&1))d=1073741823;else if(Kh&&!Oh)d=U;else{switch(c){case r.unstable_ImmediatePriority:d=1073741823;break;case r.unstable_UserBlockingPriority:d=1073741822-10*(((1073741822-a+15)/10|0)+1);break;case r.unstable_NormalPriority:d=1073741822-25*(((1073741822-a+500)/25|0)+1);break;case r.unstable_LowPriority:case r.unstable_IdlePriority:d=1;break;default:x("313")}null!==Lh&&d===U&&--d}c===r.unstable_UserBlockingPriority&&
	(0===gi||d<gi)&&(gi=d);return d}function ei(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Lh&&U===c)Lh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;df(c,a);c=a.expirationTime;0!==c&&Xh(a,c)}}function Ah(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=lf();b=mf(b,a);a=hi(a,b);null!==a&&(cf(a,b),b=a.expirationTime,0!==b&&Xh(a,b))}
	function hi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
	function qf(a,b){a=hi(a,b);null!==a&&(!Kh&&0!==U&&b>U&&Sh(),cf(a,b),Kh&&!Oh&&Lh===a||Xh(a,a.expirationTime),ii>ji&&(ii=0,x("185")))}function ki(a,b,c,d,e){return r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){return a(b,c,d,e)})}var li=null,Y=null,mi=0,ni=void 0,W=!1,oi=null,Z=0,gi=0,pi=!1,qi=null,X=!1,ri=!1,si=null,ti=r.unstable_now(),ui=1073741822-(ti/10|0),vi=ui,ji=50,ii=0,wi=null;function xi(){ui=1073741822-((r.unstable_now()-ti)/10|0)}
	function yi(a,b){if(0!==mi){if(b<mi)return;null!==ni&&r.unstable_cancelCallback(ni)}mi=b;a=r.unstable_now()-ti;ni=r.unstable_scheduleCallback(zi,{timeout:10*(1073741822-b)-a})}function fi(a,b,c,d,e){a.expirationTime=d;0!==e||di()?0<e&&(a.timeoutHandle=ye(Ai.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ai(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;xi();vi=ui;Bi(a,c)}function $h(a,b){a.expirationTime=b;a.finishedWork=null}
	function lf(){if(W)return vi;Ci();if(0===Z||1===Z)xi(),vi=ui;return vi}function Xh(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===Y?(li=Y=a,a.nextScheduledRoot=a):(Y=Y.nextScheduledRoot=a,Y.nextScheduledRoot=li)):b>a.expirationTime&&(a.expirationTime=b);W||(X?ri&&(oi=a,Z=1073741823,Di(a,1073741823,!1)):1073741823===b?Yh(1073741823,!1):yi(a,b))}
	function Ci(){var a=0,b=null;if(null!==Y)for(var c=Y,d=li;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===Y?x("244"):void 0;if(d===d.nextScheduledRoot){li=Y=d.nextScheduledRoot=null;break}else if(d===li)li=e=d.nextScheduledRoot,Y.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===Y){Y=c;Y.nextScheduledRoot=li;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===Y)break;if(1073741823===
	a)break;c=d;d=d.nextScheduledRoot}}oi=b;Z=a}var Ei=!1;function di(){return Ei?!0:r.unstable_shouldYield()?Ei=!0:!1}function zi(){try{if(!di()&&null!==li){xi();var a=li;do{var b=a.expirationTime;0!==b&&ui<=b&&(a.nextExpirationTimeToWorkOn=ui);a=a.nextScheduledRoot}while(a!==li)}Yh(0,!0)}finally{Ei=!1}}
	function Yh(a,b){Ci();if(b)for(xi(),vi=ui;null!==oi&&0!==Z&&a<=Z&&!(Ei&&ui>Z);)Di(oi,Z,ui>Z),Ci(),xi(),vi=ui;else for(;null!==oi&&0!==Z&&a<=Z;)Di(oi,Z,!1),Ci();b&&(mi=0,ni=null);0!==Z&&yi(oi,Z);ii=0;wi=null;if(null!==si)for(a=si,si=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Bi(a,b){W?x("253"):void 0;oi=a;Z=b;Di(a,b,!1);Yh(1073741823,!1)}
	function Di(a,b,c){W?x("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&(di()?a.finishedWork=d:Fi(a,d,b)))}else d=a.finishedWork,null!==d?Fi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,ze(d)),ci(a,c),d=a.finishedWork,null!==d&&Fi(a,d,b));W=!1}
	function Fi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===si?si=[d]:si.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===wi?ii++:(wi=a,ii=0);r.unstable_runWithPriority(r.unstable_ImmediatePriority,function(){Zh(a,b)})}function Dh(a){null===oi?x("246"):void 0;oi.expirationTime=0;pi||(pi=!0,qi=a)}function Gi(a,b){var c=X;X=!0;try{return a(b)}finally{(X=c)||W||Yh(1073741823,!1)}}
	function Hi(a,b){if(X&&!ri){ri=!0;try{return a(b)}finally{ri=!1}}return a(b)}function Ii(a,b,c){X||W||0===gi||(Yh(gi,!1),gi=0);var d=X;X=!0;try{return r.unstable_runWithPriority(r.unstable_UserBlockingPriority,function(){return a(b,c)})}finally{(X=d)||W||Yh(1073741823,!1)}}
	function Ji(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===ed(c)&&1===c.tag?void 0:x("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(J(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);x("171");g=void 0}if(1===c.tag){var h=c.type;if(J(h)){c=Ne(c,h,g);break a}}c=g}else c=He;null===b.context?b.context=c:b.pendingContext=c;b=e;e=nf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
	of();pf(f,e);qf(f,d);return d}function Ki(a,b,c,d){var e=b.current,f=lf();e=mf(f,e);return Ji(a,b,c,e,d)}function Li(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Mi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Wb,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Ab=function(a,b,c){switch(b){case "input":yc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);e?void 0:x("90");Sb(d);yc(d,e)}}}break;case "textarea":de(a,c);break;case "select":b=c.value,null!=b&&ae(a,!!c.multiple,b,!1)}};
	function Ni(a){var b=1073741822-25*(((1073741822-lf()+500)/25|0)+1);b>=Jh&&(b=Jh-1);this._expirationTime=Jh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ni.prototype.render=function(a){this._defer?void 0:x("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Oi;Ji(a,b,null,c,d._onCommit);return d};
	Ni.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Ni.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:x("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?x("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Bi(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};Ni.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Oi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Oi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Oi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?x("191",c):void 0;c()}}};
	function Pi(a,b,c){b=K(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
	Pi.prototype.render=function(a,b){var c=this._internalRoot,d=new Oi;b=void 0===b?null:b;null!==b&&d.then(b);Ki(a,c,null,d._onCommit);return d};Pi.prototype.unmount=function(a){var b=this._internalRoot,c=new Oi;a=void 0===a?null:a;null!==a&&c.then(a);Ki(null,b,null,c._onCommit);return c};Pi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Oi;c=void 0===c?null:c;null!==c&&e.then(c);Ki(b,d,a,e._onCommit);return e};
	Pi.prototype.createBatch=function(){var a=new Ni(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Qi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Gb=Gi;Hb=Ii;Ib=function(){W||0===gi||(Yh(gi,!1),gi=0)};
	function Ri(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Pi(a,!1,b)}
	function Si(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Li(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Ri(c,d);if("function"===typeof e){var h=e;e=function(){var a=Li(f._internalRoot);h.call(a)}}Hi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Li(f._internalRoot)}
	function Ti(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Qi(b)?void 0:x("200");return Mi(a,b,null,c)}
	var Vi={createPortal:Ti,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?x("188"):x("268",Object.keys(a)));a=hd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!0,c)},render:function(a,b,c){Qi(b)?void 0:x("200");return Si(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Qi(c)?void 0:x("200");null==a||void 0===a._reactInternalFiber?
	x("38"):void 0;return Si(a,b,c,!1,d)},unmountComponentAtNode:function(a){Qi(a)?void 0:x("40");return a._reactRootContainer?(Hi(function(){Si(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Ti.apply(void 0,arguments)},unstable_batchedUpdates:Gi,unstable_interactiveUpdates:Ii,flushSync:function(a,b){W?x("187"):void 0;var c=X;X=!0;try{return ki(a,b)}finally{X=c,Yh(1073741823,!1)}},unstable_createRoot:Ui,unstable_flushControlled:function(a){var b=
	X;X=!0;try{ki(a)}finally{(X=b)||W||Yh(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ba.injectEventPluginsByName,pa,Qa,function(a){ya(a,Pa)},Eb,Fb,Dd,Da]}};function Ui(a,b){Qi(a)?void 0:x("299","unstable_createRoot");return new Pi(a,!0,null!=b&&!0===b.hydrate)}
	(function(a){var b=a.findFiberByHostInstance;return Te(n({},a,{overrideProps:null,currentDispatcherRef:Tb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.8.6",rendererPackageName:"react-dom"});var Wi={default:Vi},Xi=Wi&&Vi||Wi;module.exports=Xi.default||Xi;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(6),__webpack_require__(3)):"function"==typeof define&&define.amd?define(["react","prop-types"],t):"object"==typeof exports?exports.Dropzone=t(require("react"),require("prop-types")):e.Dropzone=t(e.React,e.PropTypes)}(this,function(e,t){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function c(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(1),p=r(f),d=n(2),v=r(d),h=n(3),g=n(5),y=r(g),m=function(e){function t(e,n){a(this,t);var r=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,n));return r.renderChildren=function(e,t,n,o){return"function"==typeof e?e(s({},r.state,{isDragActive:t,isDragAccept:n,isDragReject:o})):e},r.composeHandlers=r.composeHandlers.bind(r),r.onClick=r.onClick.bind(r),r.onDocumentDrop=r.onDocumentDrop.bind(r),r.onDragEnter=r.onDragEnter.bind(r),r.onDragLeave=r.onDragLeave.bind(r),r.onDragOver=r.onDragOver.bind(r),r.onDragStart=r.onDragStart.bind(r),r.onDrop=r.onDrop.bind(r),r.onFileDialogCancel=r.onFileDialogCancel.bind(r),r.onInputElementClick=r.onInputElementClick.bind(r),r.setRef=r.setRef.bind(r),r.setRefs=r.setRefs.bind(r),r.isFileDialogActive=!1,r.state={draggedFiles:[],acceptedFiles:[],rejectedFiles:[]},r}return c(t,e),l(t,[{key:"componentDidMount",value:function(){var e=this.props.preventDropOnDocument;this.dragTargets=[],e&&(document.addEventListener("dragover",h.onDocumentDragOver,!1),document.addEventListener("drop",this.onDocumentDrop,!1)),this.fileInputEl.addEventListener("click",this.onInputElementClick,!1),window.addEventListener("focus",this.onFileDialogCancel,!1)}},{key:"componentWillUnmount",value:function(){this.props.preventDropOnDocument&&(document.removeEventListener("dragover",h.onDocumentDragOver),document.removeEventListener("drop",this.onDocumentDrop)),null!=this.fileInputEl&&this.fileInputEl.removeEventListener("click",this.onInputElementClick,!1),window.removeEventListener("focus",this.onFileDialogCancel,!1)}},{key:"composeHandlers",value:function(e){return this.props.disabled?null:e}},{key:"onDocumentDrop",value:function(e){this.node&&this.node.contains(e.target)||(e.preventDefault(),this.dragTargets=[])}},{key:"onDragStart",value:function(e){this.props.onDragStart&&this.props.onDragStart.call(this,e)}},{key:"onDragEnter",value:function(e){var t=this;e.preventDefault(),-1===this.dragTargets.indexOf(e.target)&&this.dragTargets.push(e.target),Promise.resolve(this.props.getDataTransferItems(e)).then(function(e){t.setState({isDragActive:!0,draggedFiles:e})}),this.props.onDragEnter&&this.props.onDragEnter.call(this,e)}},{key:"onDragOver",value:function(e){e.preventDefault(),e.stopPropagation();try{e.dataTransfer.dropEffect=this.isFileDialogActive?"none":"copy"}catch(e){}return this.props.onDragOver&&this.props.onDragOver.call(this,e),!1}},{key:"onDragLeave",value:function(e){var t=this;e.preventDefault(),this.dragTargets=this.dragTargets.filter(function(n){return n!==e.target&&t.node.contains(n)}),this.dragTargets.length>0||(this.setState({isDragActive:!1,draggedFiles:[]}),this.props.onDragLeave&&this.props.onDragLeave.call(this,e))}},{key:"onDrop",value:function(e){var t=this,n=this.props,r=n.onDrop,o=n.onDropAccepted,a=n.onDropRejected,u=n.multiple,c=n.disablePreview,s=n.accept,l=n.getDataTransferItems;e.preventDefault(),this.dragTargets=[],this.isFileDialogActive=!1,this.draggedFiles=null,this.setState({isDragActive:!1,draggedFiles:[]}),Promise.resolve(l(e)).then(function(n){var l=[],f=[];n.forEach(function(e){if(!c)try{e.preview=window.URL.createObjectURL(e)}catch(e){}(0,h.fileAccepted)(e,s)&&(0,h.fileMatchSize)(e,t.props.maxSize,t.props.minSize)?l.push(e):f.push(e)}),u||f.push.apply(f,i(l.splice(1))),r&&r.call(t,l,f,e),f.length>0&&a&&a.call(t,f,e),l.length>0&&o&&o.call(t,l,e)})}},{key:"onClick",value:function(e){var t=this.props,n=t.onClick;t.disableClick||(e.stopPropagation(),n&&n.call(this,e),(0,h.isIeOrEdge)()?setTimeout(this.open.bind(this),0):this.open())}},{key:"onInputElementClick",value:function(e){e.stopPropagation(),this.props.inputProps&&this.props.inputProps.onClick&&this.props.inputProps.onClick()}},{key:"onFileDialogCancel",value:function(){var e=this,t=this.props.onFileDialogCancel;this.isFileDialogActive&&setTimeout(function(){if(null!=e.fileInputEl){e.fileInputEl.files.length||(e.isFileDialogActive=!1)}"function"==typeof t&&t()},300)}},{key:"setRef",value:function(e){this.node=e}},{key:"setRefs",value:function(e){this.fileInputEl=e}},{key:"open",value:function(){this.isFileDialogActive=!0,this.fileInputEl.value=null,this.fileInputEl.click()}},{key:"render",value:function(){var e=this.props,t=e.accept,n=e.acceptClassName,r=e.activeClassName,i=e.children,a=e.disabled,u=e.disabledClassName,c=e.inputProps,l=e.multiple,f=e.name,d=e.rejectClassName,v=o(e,["accept","acceptClassName","activeClassName","children","disabled","disabledClassName","inputProps","multiple","name","rejectClassName"]),g=v.acceptStyle,m=v.activeStyle,b=v.className,D=void 0===b?"":b,x=v.disabledStyle,O=v.rejectStyle,S=v.style,C=o(v,["acceptStyle","activeStyle","className","disabledStyle","rejectStyle","style"]),j=this.state,E=j.isDragActive,w=j.draggedFiles,_=w.length,k=l||_<=1,P=_>0&&(0,h.allFilesAccepted)(w,this.props.accept),A=_>0&&(!P||!k),F=!(D||S||m||g||O||x);E&&r&&(D+=" "+r),P&&n&&(D+=" "+n),A&&d&&(D+=" "+d),a&&u&&(D+=" "+u),F&&(S=y.default.default,m=y.default.active,g=y.default.active,O=y.default.rejected,x=y.default.disabled);var T=s({position:"relative"},S);m&&E&&(T=s({},T,m)),g&&P&&(T=s({},T,g)),O&&A&&(T=s({},T,O)),x&&a&&(T=s({},T,x));var I={accept:t,disabled:a,type:"file",style:s({position:"absolute",top:0,right:0,bottom:0,left:0,opacity:1e-5,pointerEvents:"none"},c.style),multiple:h.supportMultiple&&l,ref:this.setRefs,onChange:this.onDrop,autoComplete:"off"};f&&f.length&&(I.name=f);var M=(C.acceptedFiles,C.preventDropOnDocument,C.disablePreview,C.disableClick,C.onDropAccepted,C.onDropRejected,C.onFileDialogCancel,C.maxSize,C.minSize,C.getDataTransferItems,o(C,["acceptedFiles","preventDropOnDocument","disablePreview","disableClick","onDropAccepted","onDropRejected","onFileDialogCancel","maxSize","minSize","getDataTransferItems"]));return p.default.createElement("div",s({className:D,style:T},M,{onClick:this.composeHandlers(this.onClick),onDragStart:this.composeHandlers(this.onDragStart),onDragEnter:this.composeHandlers(this.onDragEnter),onDragOver:this.composeHandlers(this.onDragOver),onDragLeave:this.composeHandlers(this.onDragLeave),onDrop:this.composeHandlers(this.onDrop),ref:this.setRef,"aria-disabled":a}),this.renderChildren(i,E,P,A),p.default.createElement("input",s({},c,I)))}}]),t}(p.default.Component);t.default=m,m.propTypes={accept:v.default.oneOfType([v.default.string,v.default.arrayOf(v.default.string)]),children:v.default.oneOfType([v.default.node,v.default.func]),disableClick:v.default.bool,disabled:v.default.bool,disablePreview:v.default.bool,preventDropOnDocument:v.default.bool,inputProps:v.default.object,multiple:v.default.bool,name:v.default.string,maxSize:v.default.number,minSize:v.default.number,className:v.default.string,activeClassName:v.default.string,acceptClassName:v.default.string,rejectClassName:v.default.string,disabledClassName:v.default.string,style:v.default.object,activeStyle:v.default.object,acceptStyle:v.default.object,rejectStyle:v.default.object,disabledStyle:v.default.object,getDataTransferItems:v.default.func,onClick:v.default.func,onDrop:v.default.func,onDropAccepted:v.default.func,onDropRejected:v.default.func,onDragStart:v.default.func,onDragEnter:v.default.func,onDragOver:v.default.func,onDragLeave:v.default.func,onFileDialogCancel:v.default.func},m.defaultProps={preventDropOnDocument:!0,disabled:!1,disablePreview:!1,disableClick:!1,inputProps:{},multiple:!0,maxSize:1/0,minSize:0,getDataTransferItems:h.getDataTransferItems},e.exports=t.default},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t,n){"use strict";function r(e){var t=[];if(e.dataTransfer){var n=e.dataTransfer;n.files&&n.files.length?t=n.files:n.items&&n.items.length&&(t=n.items)}else e.target&&e.target.files&&(t=e.target.files);return Array.prototype.slice.call(t)}function o(e,t){return"application/x-moz-file"===e.type||(0,p.default)(e,t)}function i(e,t,n){return e.size<=t&&e.size>=n}function a(e,t){return e.every(function(e){return o(e,t)})}function u(e){e.preventDefault()}function c(e){return-1!==e.indexOf("MSIE")||-1!==e.indexOf("Trident/")}function s(e){return-1!==e.indexOf("Edge/")}function l(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.navigator.userAgent;return c(e)||s(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.supportMultiple=void 0,t.getDataTransferItems=r,t.fileAccepted=o,t.fileMatchSize=i,t.allFilesAccepted=a,t.onDocumentDragOver=u,t.isIeOrEdge=l;var f=n(4),p=function(e){return e&&e.__esModule?e:{default:e}}(f);t.supportMultiple="undefined"==typeof document||!document||!document.createElement||"multiple"in document.createElement("input")},function(e,t){e.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=13)}([function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t){var n=e.exports={version:"2.5.0"};"number"==typeof __e&&(__e=n)},function(e,t,n){e.exports=!n(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(32)("wks"),o=n(9),i=n(0).Symbol,a="function"==typeof i;(e.exports=function(e){return r[e]||(r[e]=a&&i[e]||(a?i:o)("Symbol."+e))}).store=r},function(e,t,n){var r=n(0),o=n(2),i=n(8),a=n(22),u=n(10),c=function(e,t,n){var s,l,f,p,d=e&c.F,v=e&c.G,h=e&c.S,g=e&c.P,y=e&c.B,m=v?r:h?r[t]||(r[t]={}):(r[t]||{}).prototype,b=v?o:o[t]||(o[t]={}),D=b.prototype||(b.prototype={});v&&(n=t);for(s in n)l=!d&&m&&void 0!==m[s],f=(l?m:n)[s],p=y&&l?u(f,r):g&&"function"==typeof f?u(Function.call,f):f,m&&a(m,s,f,e&c.U),b[s]!=f&&i(b,s,p),g&&D[s]!=f&&(D[s]=f)};r.core=o,c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,e.exports=c},function(e,t,n){var r=n(16),o=n(21);e.exports=n(3)?function(e,t,n){return r.f(e,t,o(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t,n){var r=n(24);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,o){return e.call(t,n,r,o)}}return function(){return e.apply(t,arguments)}}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t,n){var r=n(28),o=Math.min;e.exports=function(e){return e>0?o(r(e),9007199254740991):0}},function(e,t,n){"use strict";t.__esModule=!0,t.default=function(e,t){if(e&&t){var n=Array.isArray(t)?t:t.split(","),r=e.name||"",o=e.type||"",i=o.replace(/\/.*$/,"");return n.some(function(e){var t=e.trim();return"."===t.charAt(0)?r.toLowerCase().endsWith(t.toLowerCase()):t.endsWith("/*")?i===t.replace(/\/.*$/,""):o===t})}return!0},n(14),n(34)},function(e,t,n){n(15),e.exports=n(2).Array.some},function(e,t,n){"use strict";var r=n(7),o=n(25)(3);r(r.P+r.F*!n(33)([].some,!0),"Array",{some:function(e){return o(this,e,arguments[1])}})},function(e,t,n){var r=n(17),o=n(18),i=n(20),a=Object.defineProperty;t.f=n(3)?Object.defineProperty:function(e,t,n){if(r(e),t=i(t,!0),r(n),o)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){var r=n(1);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t,n){e.exports=!n(3)&&!n(4)(function(){return 7!=Object.defineProperty(n(19)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(1),o=n(0).document,i=r(o)&&r(o.createElement);e.exports=function(e){return i?o.createElement(e):{}}},function(e,t,n){var r=n(1);e.exports=function(e,t){if(!r(e))return e;var n,o;if(t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;if("function"==typeof(n=e.valueOf)&&!r(o=n.call(e)))return o;if(!t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;throw TypeError("Can't convert object to primitive value")}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,n){var r=n(0),o=n(8),i=n(23),a=n(9)("src"),u=Function.toString,c=(""+u).split("toString");n(2).inspectSource=function(e){return u.call(e)},(e.exports=function(e,t,n,u){var s="function"==typeof n;s&&(i(n,"name")||o(n,"name",t)),e[t]!==n&&(s&&(i(n,a)||o(n,a,e[t]?""+e[t]:c.join(String(t)))),e===r?e[t]=n:u?e[t]?e[t]=n:o(e,t,n):(delete e[t],o(e,t,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[a]||u.call(this)})},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){var r=n(10),o=n(26),i=n(27),a=n(12),u=n(29);e.exports=function(e,t){var n=1==e,c=2==e,s=3==e,l=4==e,f=6==e,p=5==e||f,d=t||u;return function(t,u,v){for(var h,g,y=i(t),m=o(y),b=r(u,v,3),D=a(m.length),x=0,O=n?d(t,D):c?d(t,0):void 0;D>x;x++)if((p||x in m)&&(h=m[x],g=b(h,x,y),e))if(n)O[x]=g;else if(g)switch(e){case 3:return!0;case 5:return h;case 6:return x;case 2:O.push(h)}else if(l)return!1;return f?-1:s||l?l:O}}},function(e,t,n){var r=n(5);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(11);e.exports=function(e){return Object(r(e))}},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t,n){var r=n(30);e.exports=function(e,t){return new(r(e))(t)}},function(e,t,n){var r=n(1),o=n(31),i=n(6)("species");e.exports=function(e){var t;return o(e)&&(t=e.constructor,"function"!=typeof t||t!==Array&&!o(t.prototype)||(t=void 0),r(t)&&null===(t=t[i])&&(t=void 0)),void 0===t?Array:t}},function(e,t,n){var r=n(5);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});e.exports=function(e){return o[e]||(o[e]={})}},function(e,t,n){"use strict";var r=n(4);e.exports=function(e,t){return!!e&&r(function(){t?e.call(null,function(){},1):e.call(null)})}},function(e,t,n){n(35),e.exports=n(2).String.endsWith},function(e,t,n){"use strict";var r=n(7),o=n(12),i=n(36),a="".endsWith;r(r.P+r.F*n(38)("endsWith"),"String",{endsWith:function(e){var t=i(this,e,"endsWith"),n=arguments.length>1?arguments[1]:void 0,r=o(t.length),u=void 0===n?r:Math.min(o(n),r),c=String(e);return a?a.call(t,c,u):t.slice(u-c.length,u)===c}})},function(e,t,n){var r=n(37),o=n(11);e.exports=function(e,t,n){if(r(t))throw TypeError("String#"+n+" doesn't accept regex!");return String(o(e))}},function(e,t,n){var r=n(1),o=n(5),i=n(6)("match");e.exports=function(e){var t;return r(e)&&(void 0!==(t=e[i])?!!t:"RegExp"==o(e))}},function(e,t,n){var r=n(6)("match");e.exports=function(e){var t=/./;try{"/./"[e](t)}catch(n){try{return t[r]=!1,!"/./"[e](t)}catch(e){}}return!0}}])},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={rejected:{borderStyle:"solid",borderColor:"#c66",backgroundColor:"#eee"},disabled:{opacity:.5},active:{borderStyle:"solid",borderColor:"#6c6",backgroundColor:"#eee"},default:{width:200,height:200,borderWidth:2,borderColor:"#666",borderStyle:"dashed",borderRadius:5}},e.exports=t.default}])});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* istanbul ignore next */
	/**
	 * Default values
	 */
	exports.default = {
	  fixtures: [],
	  maxFixtures: 10,
	  initialValue: '',
	  placeholder: 'Search places',
	  disabled: false,
	  className: '',
	  inputClassName: '',
	  location: null,
	  radius: null,
	  bounds: null,
	  country: null,
	  types: null,
	  queryDelay: 250,
	  googleMaps: null,
	  highlightMatch: true,
	  onActivateSuggest: function onActivateSuggest() {},
	  onSuggestSelect: function onSuggestSelect() {},
	  onSuggestNoResults: function onSuggestNoResults() {},
	  onFocus: function onFocus() {},
	  onBlur: function onBlur() {},
	  onChange: function onChange() {},
	  skipSuggest: function skipSuggest() {},
	  getSuggestLabel: function getSuggestLabel(suggest) {
	    return suggest.description;
	  },
	  renderSuggestItem: null,
	  autoActivateFirstSuggest: false,
	  style: {
	    'input': {},
	    'suggests': {},
	    'suggestItem': {}
	  },
	  ignoreTab: false,
	  minLength: 1
	};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _filterInputAttributes = __webpack_require__(186);
	
	var _filterInputAttributes2 = _interopRequireDefault(_filterInputAttributes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars
	
	
	/**
	 * The input field
	 * @param {Object} props The component's props
	 * @return {JSX} The icon component.
	 */
	var Input = function (_React$PureComponent) {
	  _inherits(Input, _React$PureComponent);
	
	  function Input() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Input);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function () {
	      _this.props.onChange(_this.input.value);
	    }, _this.onFocus = function () {
	      _this.props.onFocus();
	    }, _this.onBlur = function () {
	      _this.props.onBlur();
	    }, _this.onKeyPress = function (event) {
	      _this.props.onKeyPress(event);
	    }, _this.onInputKeyDown = function (event) {
	      // eslint-disable-line complexity
	      // Call props.onKeyDown if defined
	      // Gives the developer a little bit more control if needed
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(event);
	      }
	
	      switch (event.which) {
	        case 40:
	          // DOWN
	          if (!event.shiftKey) {
	            event.preventDefault();
	            _this.props.onNext();
	          }
	          break;
	        case 38:
	          // UP
	          if (!event.shiftKey) {
	            event.preventDefault();
	            _this.props.onPrev();
	          }
	          break;
	        case 13:
	          // ENTER
	          if (_this.props.ignoreEnter) {
	            event.preventDefault();
	          }
	
	          _this.props.onSelect();
	          break;
	        case 9:
	          // TAB
	          if (!_this.props.ignoreTab) {
	            _this.props.onSelect();
	          }
	          break;
	        case 27:
	          // ESC
	          _this.props.onEscape();
	          break;
	        /* istanbul ignore next */
	        default:
	          break;
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  /**
	   * When the input got changed
	   */
	
	
	  /**
	   * When the input got focused
	   */
	
	
	  /**
	   * When the input loses focus
	   */
	
	
	  /**
	   * When a key gets pressed in the input
	   * @param  {Event} event The keypress event
	   */
	
	
	  /**
	   * When a key gets pressed in the input
	   * @param  {Event} event The keydown event
	   */
	
	
	  _createClass(Input, [{
	    key: 'focus',
	
	
	    /**
	     * Focus the input
	     */
	    value: function focus() {
	      this.input.focus();
	    }
	
	    /**
	     * Blur the input
	     */
	
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.input.blur();
	    }
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var attributes = (0, _filterInputAttributes2.default)(this.props),
	          classes = (0, _classnames2.default)('geosuggest__input', this.props.className);
	
	      return _react2.default.createElement('input', _extends({ className: classes,
	        ref: function ref(i) {
	          return _this2.input = i;
	        },
	        type: 'text'
	      }, attributes, {
	        value: this.props.value,
	        style: this.props.style,
	        onKeyDown: this.onInputKeyDown,
	        onChange: this.onChange,
	        onKeyPress: this.onKeyPress,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur }));
	    }
	  }]);
	
	  return Input;
	}(_react2.default.PureComponent);
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	
	
	Input.defaultProps = {
	  className: '',
	  value: '',
	  ignoreTab: false,
	  onKeyDown: function onKeyDown() {},
	  onKeyPress: function onKeyPress() {},
	  autoComplete: 'off'
	};
	
	exports.default = Input;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Default values
	 */
	exports.default = {
	  fixtures: _propTypes2.default.array,
	  maxFixtures: _propTypes2.default.number,
	  initialValue: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  inputClassName: _propTypes2.default.string,
	  suggestsClassName: _propTypes2.default.string,
	  suggestsHiddenClassName: _propTypes2.default.string,
	  suggestItemClassName: _propTypes2.default.string,
	  suggestItemActiveClassName: _propTypes2.default.string,
	  location: _propTypes2.default.object,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  bounds: _propTypes2.default.object,
	  country: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
	  types: _propTypes2.default.array,
	  queryDelay: _propTypes2.default.number,
	  googleMaps: _propTypes2.default.object,
	  highlightMatch: _propTypes2.default.bool,
	  onSuggestSelect: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  onKeyPress: _propTypes2.default.func,
	  skipSuggest: _propTypes2.default.func,
	  getSuggestLabel: _propTypes2.default.func,
	  renderSuggestItem: _propTypes2.default.func,
	  autoActivateFirstSuggest: _propTypes2.default.bool,
	  style: _propTypes2.default.shape({
	    input: _propTypes2.default.object,
	    suggests: _propTypes2.default.object,
	    suggestItem: _propTypes2.default.object
	  }),
	  ignoreTab: _propTypes2.default.bool,
	  label: _propTypes2.default.string,
	  autoComplete: _propTypes2.default.string,
	  minLength: _propTypes2.default.number
	};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A single Geosuggest item in the list
	 * @param {Object} props The component's props
	 * @return {JSX} The icon component.
	 */
	var SuggestItem = function (_React$Component) {
	  _inherits(SuggestItem, _React$Component);
	
	  function SuggestItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SuggestItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SuggestItem.__proto__ || Object.getPrototypeOf(SuggestItem)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (event) {
	      event.preventDefault();
	      _this.props.onSelect(_this.props.suggest);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SuggestItem, [{
	    key: 'makeBold',
	
	    /**
	     * Makes a text bold
	     * @param {String} element The element to wrap
	     * @param {String} key The key to set on the element
	     * @return {JSX} Bolder text
	     */
	    value: function makeBold(element, key) {
	      return _react2.default.createElement(
	        'b',
	        { className: 'geosuggest__item__matched-text', key: key },
	        element
	      );
	    }
	
	    /**
	     * Replace matched text with the same bold
	     * @param {Object} userInput Value from input
	     * @param {Object} suggest Data from google
	     * @return {String} Formatted string with highlighted matched text
	     */
	
	  }, {
	    key: 'formatMatchedText',
	    value: function formatMatchedText(userInput, suggest) {
	      if (!userInput || !suggest.matchedSubstrings) {
	        return suggest.label;
	      }
	
	      var start = suggest.matchedSubstrings.offset,
	          length = suggest.matchedSubstrings.length,
	          end = start + length,
	          boldPart = this.makeBold(suggest.label.substring(start, end), suggest.label);
	
	      var pre = '',
	          post = '';
	
	      if (start > 0) {
	        pre = suggest.label.slice(0, start);
	      }
	      if (end < suggest.label.length) {
	        post = suggest.label.slice(end);
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        pre,
	        boldPart,
	        post
	      );
	    }
	
	    /**
	     * Checking if item just became active and scrolling if needed.
	     * @param {Object} nextProps The new properties
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.isActive && !this.props.isActive) {
	        this.scrollIfNeeded();
	      }
	    }
	
	    /**
	     * Scrolling current item to the center of the list if item needs scrolling.
	     * Item is scrolled to the center of the list.
	     */
	
	  }, {
	    key: 'scrollIfNeeded',
	    value: function scrollIfNeeded() {
	      var el = this.ref,
	          parent = el.parentElement,
	          overTop = el.offsetTop - parent.offsetTop < parent.scrollTop,
	          overBottom = el.offsetTop - parent.offsetTop + el.clientHeight > parent.scrollTop + parent.clientHeight;
	
	      if (overTop || overBottom) {
	        parent.scrollTop = el.offsetTop - parent.offsetTop - parent.clientHeight / 2 + el.clientHeight / 2;
	      }
	    }
	
	    /**
	     * When the suggest item got clicked
	     * @param {Event} event The click event
	     */
	
	  }, {
	    key: 'render',
	
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	    value: function render() {
	      var _this2 = this;
	
	      var suggest = this.props.suggest,
	          classes = (0, _classnames3.default)('geosuggest__item', this.props.className, this.props.suggestItemClassName, { 'geosuggest__item--active': this.props.isActive }, _defineProperty({}, this.props.activeClassname, this.props.activeClassname ? this.props.isActive : null));
	
	      var content = suggest.label;
	
	      if (this.props.renderSuggestItem) {
	        content = this.props.renderSuggestItem(suggest);
	      } else if (this.props.isHighlightMatch) {
	        content = this.formatMatchedText(this.props.userInput, suggest);
	      }
	
	      return _react2.default.createElement(
	        'li',
	        { className: classes,
	          ref: function ref(li) {
	            return _this2.ref = li;
	          },
	          style: this.props.style,
	          onMouseDown: this.props.onMouseDown,
	          onMouseOut: this.props.onMouseOut,
	          onClick: this.onClick },
	        content
	      );
	    }
	  }]);
	
	  return SuggestItem;
	}(_react2.default.Component);
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	
	
	exports.default = SuggestItem;
	SuggestItem.defaultProps = {
	  isActive: false,
	  className: '',
	  suggest: {}
	};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _suggestItem = __webpack_require__(390);
	
	var _suggestItem2 = _interopRequireDefault(_suggestItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // eslint-disable-line no-unused-vars
	
	
	/**
	 * The list with suggestions. Either from an API or provided as fixture
	 * @param {Object} props The component's props
	 * @return {JSX} The icon component.
	 */
	var SuggestList = function (_React$PureComponent) {
	  _inherits(SuggestList, _React$PureComponent);
	
	  function SuggestList() {
	    _classCallCheck(this, SuggestList);
	
	    return _possibleConstructorReturn(this, (SuggestList.__proto__ || Object.getPrototypeOf(SuggestList)).apply(this, arguments));
	  }
	
	  _createClass(SuggestList, [{
	    key: 'isHidden',
	
	    /**
	     * Whether or not it is hidden
	     * @return {Boolean} Hidden or not?
	     */
	    value: function isHidden() {
	      return this.props.isHidden || this.props.suggests.length === 0;
	    }
	
	    /**
	     * There are new properties available for the list
	     * @param {Object} nextProps The new properties
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.suggests !== this.props.suggests) {
	        if (nextProps.suggests.length === 0) {
	          this.props.onSuggestNoResults();
	        }
	      }
	    }
	
	    /**
	     * Render the view
	     * @return {Function} The React element to render
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var classes = (0, _classnames3.default)('geosuggest__suggests', this.props.suggestsClassName, { 'geosuggest__suggests--hidden': this.isHidden() }, _defineProperty({}, this.props.hiddenClassName, this.props.hiddenClassName ? this.isHidden() : null));
	
	      return _react2.default.createElement(
	        'ul',
	        { className: classes, style: this.props.style },
	        this.props.suggests.map(function (suggest) {
	          var isActive = _this2.props.activeSuggest && suggest.placeId === _this2.props.activeSuggest.placeId,
	              key = suggest.key || suggest.placeId;
	
	          return _react2.default.createElement(_suggestItem2.default, { key: key,
	            className: suggest.className,
	            userInput: _this2.props.userInput,
	            isHighlightMatch: _this2.props.isHighlightMatch,
	            suggest: suggest,
	            style: _this2.props.suggestItemStyle,
	            suggestItemClassName: _this2.props.suggestItemClassName,
	            isActive: isActive,
	            activeClassname: _this2.props.suggestItemActiveClassName,
	            onMouseDown: _this2.props.onSuggestMouseDown,
	            onMouseOut: _this2.props.onSuggestMouseOut,
	            onSelect: _this2.props.onSuggestSelect,
	            renderSuggestItem: _this2.props.renderSuggestItem });
	        })
	      );
	    }
	  }]);
	
	  return SuggestList;
	}(_react2.default.PureComponent);
	
	/**
	 * Default values for the properties
	 * @type {Object}
	 */
	
	
	exports.default = SuggestList;
	SuggestList.defaultProps = {
	  isHidden: true,
	  suggests: []
	};

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _offset = __webpack_require__(68);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _requestAnimationFrame = __webpack_require__(226);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(83);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Affix = __webpack_require__(187);
	
	var _Affix2 = _interopRequireDefault(_Affix);
	
	var _addEventListener = __webpack_require__(84);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _getContainer = __webpack_require__(85);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _getDocumentHeight = __webpack_require__(190);
	
	var _getDocumentHeight2 = _interopRequireDefault(_getDocumentHeight);
	
	var _ownerDocument = __webpack_require__(42);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _ownerWindow = __webpack_require__(191);
	
	var _ownerWindow2 = _interopRequireDefault(_ownerWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var displayName = 'AutoAffix';
	
	var propTypes = _extends({}, _Affix2.default.propTypes, {
	  /**
	   * The logical container node or component for determining offset from bottom
	   * of viewport, or a function that returns it
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Automatically set width when affixed
	   */
	  autoWidth: _propTypes2.default.bool
	});
	
	// This intentionally doesn't inherit default props from `<Affix>`, so that the
	// auto-calculated offsets can apply.
	var defaultProps = {
	  viewportOffsetTop: 0,
	  autoWidth: true
	};
	
	/**
	 * The `<AutoAffix/>` component wraps `<Affix/>` to automatically calculate
	 * offsets in many common cases.
	 */
	
	var AutoAffix = function (_React$Component) {
	  _inherits(AutoAffix, _React$Component);
	
	  function AutoAffix(props, context) {
	    _classCallCheck(this, AutoAffix);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.onWindowScroll = function () {
	      _this.onUpdate();
	    };
	
	    _this.onWindowResize = function () {
	      if (_this.props.autoWidth) {
	        (0, _requestAnimationFrame2.default)(function () {
	          return _this.onUpdate();
	        });
	      }
	    };
	
	    _this.onDocumentClick = function () {
	      (0, _requestAnimationFrame2.default)(function () {
	        return _this.onUpdate();
	      });
	    };
	
	    _this.onUpdate = function () {
	      if (!_this._isMounted) {
	        return;
	      }
	
	      var _getOffset = (0, _offset2.default)(_this.positioner),
	          offsetTop = _getOffset.top,
	          width = _getOffset.width;
	
	      var container = (0, _getContainer2.default)(_this.props.container);
	      var offsetBottom = void 0;
	      if (container) {
	        var documentHeight = (0, _getDocumentHeight2.default)((0, _ownerDocument2.default)(_this));
	
	        var _getOffset2 = (0, _offset2.default)(container),
	            top = _getOffset2.top,
	            height = _getOffset2.height;
	
	        offsetBottom = documentHeight - top - height;
	      } else {
	        offsetBottom = null;
	      }
	
	      _this.updateState(offsetTop, offsetBottom, width);
	    };
	
	    _this.updateState = function (offsetTop, offsetBottom, width) {
	      if (offsetTop === _this.state.offsetTop && offsetBottom === _this.state.offsetBottom && width === _this.state.width) {
	        return;
	      }
	
	      _this.setState({ offsetTop: offsetTop, offsetBottom: offsetBottom, width: width });
	    };
	
	    _this.state = {
	      offsetTop: null,
	      offsetBottom: null,
	      width: null
	    };
	    return _this;
	  }
	
	  AutoAffix.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this._isMounted = true;
	
	    this._windowScrollListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'scroll', function () {
	      return _this2.onWindowScroll();
	    });
	
	    this._windowResizeListener = (0, _addEventListener2.default)((0, _ownerWindow2.default)(this), 'resize', function () {
	      return _this2.onWindowResize();
	    });
	
	    this._documentClickListener = (0, _addEventListener2.default)((0, _ownerDocument2.default)(this), 'click', function () {
	      return _this2.onDocumentClick();
	    });
	
	    this.onUpdate();
	  };
	
	  AutoAffix.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needPositionUpdate = true;
	  };
	
	  AutoAffix.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this._needPositionUpdate) {
	      this._needPositionUpdate = false;
	      this.onUpdate();
	    }
	  };
	
	  AutoAffix.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	
	    if (this._windowScrollListener) {
	      this._windowScrollListener.remove();
	    }
	    if (this._documentClickListener) {
	      this._documentClickListener.remove();
	    }
	    if (this._windowResizeListener) {
	      this._windowResizeListener.remove();
	    }
	  };
	
	  AutoAffix.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        autoWidth = _props.autoWidth,
	        viewportOffsetTop = _props.viewportOffsetTop,
	        children = _props.children,
	        props = _objectWithoutProperties(_props, ['autoWidth', 'viewportOffsetTop', 'children']);
	
	    var _state = this.state,
	        offsetTop = _state.offsetTop,
	        offsetBottom = _state.offsetBottom,
	        width = _state.width;
	
	
	    delete props.container;
	
	    var effectiveOffsetTop = Math.max(offsetTop, viewportOffsetTop || 0);
	
	    var _props2 = this.props,
	        affixStyle = _props2.affixStyle,
	        bottomStyle = _props2.bottomStyle;
	
	    if (autoWidth) {
	      affixStyle = _extends({ width: width }, affixStyle);
	      bottomStyle = _extends({ width: width }, bottomStyle);
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement('div', { ref: function ref(c) {
	          _this3.positioner = c;
	        } }),
	      _react2.default.createElement(
	        _Affix2.default,
	        _extends({}, props, {
	          offsetTop: effectiveOffsetTop,
	          viewportOffsetTop: viewportOffsetTop,
	          offsetBottom: offsetBottom,
	          affixStyle: affixStyle,
	          bottomStyle: bottomStyle
	        }),
	        children
	      )
	    );
	  };
	
	  return AutoAffix;
	}(_react2.default.Component);
	
	AutoAffix.displayName = displayName;
	AutoAffix.propTypes = propTypes;
	AutoAffix.defaultProps = defaultProps;
	
	exports.default = AutoAffix;
	module.exports = exports['default'];

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(541);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(125);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(46);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(83);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(384);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(183);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Portal = __webpack_require__(114);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _ModalManager = __webpack_require__(394);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _addEventListener = __webpack_require__(84);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(397);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(85);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(42);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          appear: true,
	          unmountOnExit: true,
	          'in': show,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNode,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        dialog
	      )
	    );
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  //instead of a ref, which might conflict with one the parent applied.
	
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the dialog component.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component used
	   * to control animations for the backdrop components.
	   */
	  backdropTransition: _elementType2.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.backdropTransition;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        {
	          appear: true,
	          'in': _this2.props.show
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	
	    _this2.focus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNode = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.key === 'Escape' && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.key === 'Escape' && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.focus = function () {
	    var autoFocus = _this2.props.autoFocus;
	    var modalContent = _this2.getDialogElement();
	    var current = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	    var focusInModal = modalContent && current && (0, _contains2.default)(modalContent, current);
	
	    if (modalContent && autoFocus && !focusInModal) {
	      _this2.lastFocus = current;
	
	      if (!modalContent.hasAttribute('tabIndex')) {
	        modalContent.setAttribute('tabIndex', -1);
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. ' + 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".');
	      }
	
	      modalContent.focus();
	    }
	  };
	
	  this.restoreLastFocus = function () {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (_this2.lastFocus && _this2.lastFocus.focus) {
	      _this2.lastFocus.focus();
	      _this2.lastFocus = null;
	    }
	  };
	
	  this.enforceFocus = function () {
	    var enforceFocus = _this2.props.enforceFocus;
	
	
	    if (!enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var active = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	    var modal = _this2.getDialogElement();
	
	    if (modal && modal !== active && !(0, _contains2.default)(modal, active)) {
	      modal.focus();
	    }
	  };
	
	  this.getDialogElement = function () {
	    var node = _this2.modalNode;
	    return node && node.lastChild;
	  };
	
	  this.isTopModal = function () {
	    return _this2.props.manager.isTopModal(_this2);
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(543);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(127);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(558);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(399);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(183);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(114);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(188);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(189);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleHidden = function () {
	      _this.setState({ exited: true });
	
	      if (_this.props.onExited) {
	        var _this$props;
	
	        (_this$props = _this.props).onExited.apply(_this$props, arguments);
	      }
	    };
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        container = _props.container,
	        containerPadding = _props.containerPadding,
	        target = _props.target,
	        placement = _props.placement,
	        shouldUpdatePosition = _props.shouldUpdatePosition,
	        rootClose = _props.rootClose,
	        children = _props.children,
	        Transition = _props.transition,
	        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	    // Don't un-render the overlay while it's transitioning out.
	
	
	    var mountOverlay = props.show || Transition && !this.state.exited;
	    if (!mountOverlay) {
	      // Don't bother showing anything if we don't have to.
	      return null;
	    }
	
	    var child = children;
	
	    // Position is be inner-most because it adds inline styles into the child,
	    // which the other wrappers don't forward correctly.
	    child = _react2.default.createElement(
	      _Position2.default,
	      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	      child
	    );
	
	    if (Transition) {
	      var onExit = props.onExit,
	          onExiting = props.onExiting,
	          onEnter = props.onEnter,
	          onEntering = props.onEntering,
	          onEntered = props.onEntered;
	
	      // This animates the child node by injecting props, so it must precede
	      // anything that adds a wrapping div.
	
	      child = _react2.default.createElement(
	        Transition,
	        {
	          'in': props.show,
	          appear: true,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.onHiddenListener,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        child
	      );
	    }
	
	    // This goes after everything else because it adds a wrapping div.
	    if (rootClose) {
	      child = _react2.default.createElement(
	        _RootCloseWrapper2.default,
	        { onRootClose: props.onHide },
	        child
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { container: container },
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _propTypes2.default.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `react-transition-group@2.0.0` `<Transition/>` component
	   * used to animate the overlay as it changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RootCloseWrapper = exports.Position = exports.Portal = exports.Overlay = exports.Modal = exports.AutoAffix = exports.Affix = undefined;
	
	var _Affix2 = __webpack_require__(187);
	
	var _Affix3 = _interopRequireDefault(_Affix2);
	
	var _AutoAffix2 = __webpack_require__(392);
	
	var _AutoAffix3 = _interopRequireDefault(_AutoAffix2);
	
	var _Modal2 = __webpack_require__(393);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _Overlay2 = __webpack_require__(395);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _Portal2 = __webpack_require__(114);
	
	var _Portal3 = _interopRequireDefault(_Portal2);
	
	var _Position2 = __webpack_require__(188);
	
	var _Position3 = _interopRequireDefault(_Position2);
	
	var _RootCloseWrapper2 = __webpack_require__(189);
	
	var _RootCloseWrapper3 = _interopRequireDefault(_RootCloseWrapper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Affix = _Affix3.default;
	exports.AutoAffix = _AutoAffix3.default;
	exports.Modal = _Modal3.default;
	exports.Overlay = _Overlay3.default;
	exports.Portal = _Portal3.default;
	exports.Position = _Position3.default;
	exports.RootCloseWrapper = _RootCloseWrapper3.default;

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(68);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(549);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(126);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(42);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(67);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(55);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _find = __webpack_require__(685);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _sortBy = __webpack_require__(695);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Manager = function () {
	  function Manager() {
	    _classCallCheck(this, Manager);
	
	    this.refs = {};
	  }
	
	  _createClass(Manager, [{
	    key: 'add',
	    value: function add(collection, ref) {
	      if (!this.refs[collection]) {
	        this.refs[collection] = [];
	      }
	
	      this.refs[collection].push(ref);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(collection, ref) {
	      var index = this.getIndex(collection, ref);
	
	      if (index !== -1) {
	        this.refs[collection].splice(index, 1);
	      }
	    }
	  }, {
	    key: 'isActive',
	    value: function isActive() {
	      return this.active;
	    }
	  }, {
	    key: 'getActive',
	    value: function getActive() {
	      var _this = this;
	
	      return (0, _find2.default)(this.refs[this.active.collection],
	      // eslint-disable-next-line eqeqeq
	      function (_ref) {
	        var node = _ref.node;
	        return node.sortableInfo.index == _this.active.index;
	      });
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(collection, ref) {
	      return this.refs[collection].indexOf(ref);
	    }
	  }, {
	    key: 'getOrderedRefs',
	    value: function getOrderedRefs() {
	      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
	
	      return (0, _sortBy2.default)(this.refs[collection], function (_ref2) {
	        var node = _ref2.node;
	        return node.sortableInfo.index;
	      });
	    }
	  }]);
	
	  return Manager;
	}();
	
	exports.default = Manager;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableContainer;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Manager = __webpack_require__(401);
	
	var _Manager2 = _interopRequireDefault(_Manager);
	
	var _utils = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Container Component
	function sortableContainer(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class(props) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));
	
	      _this.handleStart = function (e) {
	        var _this$props = _this.props,
	            distance = _this$props.distance,
	            shouldCancelStart = _this$props.shouldCancelStart;
	
	
	        if (e.button === 2 || shouldCancelStart(e)) {
	          return false;
	        }
	
	        _this._touched = true;
	        _this._pos = {
	          x: e.pageX,
	          y: e.pageY
	        };
	
	        var node = (0, _utils.closest)(e.target, function (el) {
	          return el.sortableInfo != null;
	        });
	
	        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
	          var useDragHandle = _this.props.useDragHandle;
	          var _node$sortableInfo = node.sortableInfo,
	              index = _node$sortableInfo.index,
	              collection = _node$sortableInfo.collection;
	
	
	          if (useDragHandle && !(0, _utils.closest)(e.target, function (el) {
	            return el.sortableHandle != null;
	          })) return;
	
	          _this.manager.active = { index: index, collection: collection };
	
	          /*
	          * Fixes a bug in Firefox where the :active state of anchor tags
	          * prevent subsequent 'mousemove' events from being fired
	          * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
	          */
	          if (e.target.tagName.toLowerCase() === 'a') {
	            e.preventDefault();
	          }
	
	          if (!distance) {
	            if (_this.props.pressDelay === 0) {
	              _this.handlePress(e);
	            } else {
	              _this.pressTimer = setTimeout(function () {
	                return _this.handlePress(e);
	              }, _this.props.pressDelay);
	            }
	          }
	        }
	      };
	
	      _this.nodeIsChild = function (node) {
	        return node.sortableInfo.manager === _this.manager;
	      };
	
	      _this.handleMove = function (e) {
	        var _this$props2 = _this.props,
	            distance = _this$props2.distance,
	            pressThreshold = _this$props2.pressThreshold;
	
	
	        if (!_this.state.sorting && _this._touched) {
	          _this._delta = {
	            x: _this._pos.x - e.pageX,
	            y: _this._pos.y - e.pageY
	          };
	          var delta = Math.abs(_this._delta.x) + Math.abs(_this._delta.y);
	
	          if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
	            clearTimeout(_this.cancelTimer);
	            _this.cancelTimer = setTimeout(_this.cancel, 0);
	          } else if (distance && delta >= distance && _this.manager.isActive()) {
	            _this.handlePress(e);
	          }
	        }
	      };
	
	      _this.handleEnd = function () {
	        var distance = _this.props.distance;
	
	
	        _this._touched = false;
	
	        if (!distance) {
	          _this.cancel();
	        }
	      };
	
	      _this.cancel = function () {
	        if (!_this.state.sorting) {
	          clearTimeout(_this.pressTimer);
	          _this.manager.active = null;
	        }
	      };
	
	      _this.handlePress = function (e) {
	        var active = _this.manager.getActive();
	
	        if (active) {
	          var _this$props3 = _this.props,
	              axis = _this$props3.axis,
	              getHelperDimensions = _this$props3.getHelperDimensions,
	              helperClass = _this$props3.helperClass,
	              hideSortableGhost = _this$props3.hideSortableGhost,
	              onSortStart = _this$props3.onSortStart,
	              useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
	          var node = active.node,
	              collection = active.collection;
	          var index = node.sortableInfo.index;
	
	          var margin = (0, _utils.getElementMargin)(node);
	
	          var containerBoundingRect = _this.container.getBoundingClientRect();
	          var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });
	
	          _this.node = node;
	          _this.margin = margin;
	          _this.width = dimensions.width;
	          _this.height = dimensions.height;
	          _this.marginOffset = {
	            x: _this.margin.left + _this.margin.right,
	            y: Math.max(_this.margin.top, _this.margin.bottom)
	          };
	          _this.boundingClientRect = node.getBoundingClientRect();
	          _this.containerBoundingRect = containerBoundingRect;
	          _this.index = index;
	          _this.newIndex = index;
	
	          _this.axis = {
	            x: axis.indexOf('x') >= 0,
	            y: axis.indexOf('y') >= 0
	          };
	          _this.offsetEdge = _this.getEdgeOffset(node);
	          _this.initialOffset = _this.getOffset(e);
	          _this.initialScroll = {
	            top: _this.scrollContainer.scrollTop,
	            left: _this.scrollContainer.scrollLeft
	          };
	
	          _this.initialWindowScroll = {
	            top: window.pageYOffset,
	            left: window.pageXOffset
	          };
	
	          var fields = node.querySelectorAll('input, textarea, select');
	          var clonedNode = node.cloneNode(true);
	          var clonedFields = [].concat(_toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array
	
	          clonedFields.forEach(function (field, index) {
	            if (field.type !== 'file' && fields[index]) {
	              field.value = fields[index].value;
	            }
	          });
	
	          _this.helper = _this.document.body.appendChild(clonedNode);
	
	          _this.helper.style.position = 'fixed';
	          _this.helper.style.top = _this.boundingClientRect.top - margin.top + 'px';
	          _this.helper.style.left = _this.boundingClientRect.left - margin.left + 'px';
	          _this.helper.style.width = _this.width + 'px';
	          _this.helper.style.height = _this.height + 'px';
	          _this.helper.style.boxSizing = 'border-box';
	          _this.helper.style.pointerEvents = 'none';
	
	          if (hideSortableGhost) {
	            _this.sortableGhost = node;
	            node.style.visibility = 'hidden';
	            node.style.opacity = 0;
	          }
	
	          _this.minTranslate = {};
	          _this.maxTranslate = {};
	          if (_this.axis.x) {
	            _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
	            _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
	          }
	          if (_this.axis.y) {
	            _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
	            _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
	          }
	
	          if (helperClass) {
	            var _this$helper$classLis;
	
	            (_this$helper$classLis = _this.helper.classList).add.apply(_this$helper$classLis, _toConsumableArray(helperClass.split(' ')));
	          }
	
	          _this.listenerNode = e.touches ? node : _this.contentWindow;
	          _utils.events.move.forEach(function (eventName) {
	            return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
	          });
	          _utils.events.end.forEach(function (eventName) {
	            return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
	          });
	
	          _this.setState({
	            sorting: true,
	            sortingIndex: index
	          });
	
	          if (onSortStart) onSortStart({ node: node, index: index, collection: collection }, e);
	        }
	      };
	
	      _this.handleSortMove = function (e) {
	        var onSortMove = _this.props.onSortMove;
	
	        e.preventDefault(); // Prevent scrolling on mobile
	
	        _this.updatePosition(e);
	        _this.animateNodes();
	        _this.autoscroll();
	
	        if (onSortMove) onSortMove(e);
	      };
	
	      _this.handleSortEnd = function (e) {
	        var _this$props4 = _this.props,
	            hideSortableGhost = _this$props4.hideSortableGhost,
	            onSortEnd = _this$props4.onSortEnd;
	        var collection = _this.manager.active.collection;
	
	        // Remove the event listeners if the node is still in the DOM
	
	        if (_this.listenerNode) {
	          _utils.events.move.forEach(function (eventName) {
	            return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
	          });
	          _utils.events.end.forEach(function (eventName) {
	            return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
	          });
	        }
	
	        // Remove the helper from the DOM
	        _this.helper.parentNode.removeChild(_this.helper);
	
	        if (hideSortableGhost && _this.sortableGhost) {
	          _this.sortableGhost.style.visibility = '';
	          _this.sortableGhost.style.opacity = '';
	        }
	
	        var nodes = _this.manager.refs[collection];
	        for (var i = 0, len = nodes.length; i < len; i++) {
	          var node = nodes[i];
	          var el = node.node;
	
	          // Clear the cached offsetTop / offsetLeft value
	          node.edgeOffset = null;
	
	          // Remove the transforms / transitions
	          el.style[_utils.vendorPrefix + 'Transform'] = '';
	          el.style[_utils.vendorPrefix + 'TransitionDuration'] = '';
	        }
	
	        // Stop autoscroll
	        clearInterval(_this.autoscrollInterval);
	        _this.autoscrollInterval = null;
	
	        // Update state
	        _this.manager.active = null;
	
	        _this.setState({
	          sorting: false,
	          sortingIndex: null
	        });
	
	        if (typeof onSortEnd === 'function') {
	          onSortEnd({
	            oldIndex: _this.index,
	            newIndex: _this.newIndex,
	            collection: collection
	          }, e);
	        }
	
	        _this._touched = false;
	      };
	
	      _this.autoscroll = function () {
	        var translate = _this.translate;
	        var direction = {
	          x: 0,
	          y: 0
	        };
	        var speed = {
	          x: 1,
	          y: 1
	        };
	        var acceleration = {
	          x: 10,
	          y: 10
	        };
	
	        if (translate.y >= _this.maxTranslate.y - _this.height / 2) {
	          direction.y = 1; // Scroll Down
	          speed.y = acceleration.y * Math.abs((_this.maxTranslate.y - _this.height / 2 - translate.y) / _this.height);
	        } else if (translate.x >= _this.maxTranslate.x - _this.width / 2) {
	          direction.x = 1; // Scroll Right
	          speed.x = acceleration.x * Math.abs((_this.maxTranslate.x - _this.width / 2 - translate.x) / _this.width);
	        } else if (translate.y <= _this.minTranslate.y + _this.height / 2) {
	          direction.y = -1; // Scroll Up
	          speed.y = acceleration.y * Math.abs((translate.y - _this.height / 2 - _this.minTranslate.y) / _this.height);
	        } else if (translate.x <= _this.minTranslate.x + _this.width / 2) {
	          direction.x = -1; // Scroll Left
	          speed.x = acceleration.x * Math.abs((translate.x - _this.width / 2 - _this.minTranslate.x) / _this.width);
	        }
	
	        if (_this.autoscrollInterval) {
	          clearInterval(_this.autoscrollInterval);
	          _this.autoscrollInterval = null;
	          _this.isAutoScrolling = false;
	        }
	
	        if (direction.x !== 0 || direction.y !== 0) {
	          _this.autoscrollInterval = setInterval(function () {
	            _this.isAutoScrolling = true;
	            var offset = {
	              left: 1 * speed.x * direction.x,
	              top: 1 * speed.y * direction.y
	            };
	            _this.scrollContainer.scrollTop += offset.top;
	            _this.scrollContainer.scrollLeft += offset.left;
	            _this.translate.x += offset.left;
	            _this.translate.y += offset.top;
	            _this.animateNodes();
	          }, 5);
	        }
	      };
	
	      _this.manager = new _Manager2.default();
	      _this.events = {
	        start: _this.handleStart,
	        move: _this.handleMove,
	        end: _this.handleEnd
	      };
	
	      (0, _invariant2.default)(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
	
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(_class, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return {
	          manager: this.manager
	        };
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        var _props = this.props,
	            getContainer = _props.getContainer,
	            useWindowAsScrollContainer = _props.useWindowAsScrollContainer;
	
	        /*
	         *  Set our own default rather than using defaultProps because Jest
	         *  snapshots will serialize window, causing a RangeError
	         *  https://github.com/clauderic/react-sortable-hoc/issues/249
	         */
	
	        var contentWindow = this.props.contentWindow || window;
	
	        this.container = typeof getContainer === 'function' ? getContainer(this.getWrappedInstance()) : (0, _reactDom.findDOMNode)(this);
	        this.document = this.container.ownerDocument || document;
	        this.scrollContainer = useWindowAsScrollContainer ? this.document.body : this.container;
	        this.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
	
	        var _loop = function _loop(key) {
	          if (_this2.events.hasOwnProperty(key)) {
	            _utils.events[key].forEach(function (eventName) {
	              return _this2.container.addEventListener(eventName, _this2.events[key], false);
	            });
	          }
	        };
	
	        for (var key in this.events) {
	          _loop(key);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _this3 = this;
	
	        var _loop2 = function _loop2(key) {
	          if (_this3.events.hasOwnProperty(key)) {
	            _utils.events[key].forEach(function (eventName) {
	              return _this3.container.removeEventListener(eventName, _this3.events[key]);
	            });
	          }
	        };
	
	        for (var key in this.events) {
	          _loop2(key);
	        }
	      }
	    }, {
	      key: 'getEdgeOffset',
	      value: function getEdgeOffset(node) {
	        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };
	
	        // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
	        if (node) {
	          var nodeOffset = {
	            top: offset.top + node.offsetTop,
	            left: offset.left + node.offsetLeft
	          };
	          if (node.parentNode !== this.container) {
	            return this.getEdgeOffset(node.parentNode, nodeOffset);
	          } else {
	            return nodeOffset;
	          }
	        }
	      }
	    }, {
	      key: 'getOffset',
	      value: function getOffset(e) {
	        return {
	          x: e.touches ? e.touches[0].pageX : e.pageX,
	          y: e.touches ? e.touches[0].pageY : e.pageY
	        };
	      }
	    }, {
	      key: 'getLockPixelOffsets',
	      value: function getLockPixelOffsets() {
	        var lockOffset = this.props.lockOffset;
	
	
	        if (!Array.isArray(lockOffset)) {
	          lockOffset = [lockOffset, lockOffset];
	        }
	
	        (0, _invariant2.default)(lockOffset.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);
	
	        var _lockOffset = lockOffset,
	            _lockOffset2 = _slicedToArray(_lockOffset, 2),
	            minLockOffset = _lockOffset2[0],
	            maxLockOffset = _lockOffset2[1];
	
	        return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
	      }
	    }, {
	      key: 'getLockPixelOffset',
	      value: function getLockPixelOffset(lockOffset) {
	        var offsetX = lockOffset;
	        var offsetY = lockOffset;
	        var unit = 'px';
	
	        if (typeof lockOffset === 'string') {
	          var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
	
	          (0, _invariant2.default)(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);
	
	          offsetX = offsetY = parseFloat(lockOffset);
	          unit = match[1];
	        }
	
	        (0, _invariant2.default)(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);
	
	        if (unit === '%') {
	          offsetX = offsetX * this.width / 100;
	          offsetY = offsetY * this.height / 100;
	        }
	
	        return {
	          x: offsetX,
	          y: offsetY
	        };
	      }
	    }, {
	      key: 'updatePosition',
	      value: function updatePosition(e) {
	        var _props2 = this.props,
	            lockAxis = _props2.lockAxis,
	            lockToContainerEdges = _props2.lockToContainerEdges;
	
	
	        var offset = this.getOffset(e);
	        var translate = {
	          x: offset.x - this.initialOffset.x,
	          y: offset.y - this.initialOffset.y
	        };
	        // Adjust for window scroll
	        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
	        translate.x -= window.pageXOffset - this.initialWindowScroll.left;
	
	        this.translate = translate;
	
	        if (lockToContainerEdges) {
	          var _getLockPixelOffsets = this.getLockPixelOffsets(),
	              _getLockPixelOffsets2 = _slicedToArray(_getLockPixelOffsets, 2),
	              minLockOffset = _getLockPixelOffsets2[0],
	              maxLockOffset = _getLockPixelOffsets2[1];
	
	          var minOffset = {
	            x: this.width / 2 - minLockOffset.x,
	            y: this.height / 2 - minLockOffset.y
	          };
	          var maxOffset = {
	            x: this.width / 2 - maxLockOffset.x,
	            y: this.height / 2 - maxLockOffset.y
	          };
	
	          translate.x = (0, _utils.limit)(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
	          translate.y = (0, _utils.limit)(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
	        }
	
	        if (lockAxis === 'x') {
	          translate.y = 0;
	        } else if (lockAxis === 'y') {
	          translate.x = 0;
	        }
	
	        this.helper.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
	      }
	    }, {
	      key: 'animateNodes',
	      value: function animateNodes() {
	        var _props3 = this.props,
	            transitionDuration = _props3.transitionDuration,
	            hideSortableGhost = _props3.hideSortableGhost;
	
	        var nodes = this.manager.getOrderedRefs();
	        var deltaScroll = {
	          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
	          top: this.scrollContainer.scrollTop - this.initialScroll.top
	        };
	        var sortingOffset = {
	          left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
	          top: this.offsetEdge.top + this.translate.y + deltaScroll.top
	        };
	        var scrollDifference = {
	          top: window.pageYOffset - this.initialWindowScroll.top,
	          left: window.pageXOffset - this.initialWindowScroll.left
	        };
	        this.newIndex = null;
	
	        for (var i = 0, len = nodes.length; i < len; i++) {
	          var node = nodes[i].node;
	
	          var index = node.sortableInfo.index;
	          var width = node.offsetWidth;
	          var height = node.offsetHeight;
	          var offset = {
	            width: this.width > width ? width / 2 : this.width / 2,
	            height: this.height > height ? height / 2 : this.height / 2
	          };
	
	          var translate = {
	            x: 0,
	            y: 0
	          };
	          var edgeOffset = nodes[i].edgeOffset;
	
	          // If we haven't cached the node's offsetTop / offsetLeft value
	
	          if (!edgeOffset) {
	            nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
	          }
	
	          // Get a reference to the next and previous node
	          var nextNode = i < nodes.length - 1 && nodes[i + 1];
	          var prevNode = i > 0 && nodes[i - 1];
	
	          // Also cache the next node's edge offset if needed.
	          // We need this for calculating the animation in a grid setup
	          if (nextNode && !nextNode.edgeOffset) {
	            nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
	          }
	
	          // If the node is the one we're currently animating, skip it
	          if (index === this.index) {
	            if (hideSortableGhost) {
	              /*
	              * With windowing libraries such as `react-virtualized`, the sortableGhost
	              * node may change while scrolling down and then back up (or vice-versa),
	              * so we need to update the reference to the new node just to be safe.
	              */
	              this.sortableGhost = node;
	              node.style.visibility = 'hidden';
	              node.style.opacity = 0;
	            }
	            continue;
	          }
	
	          if (transitionDuration) {
	            node.style[_utils.vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
	          }
	
	          if (this.axis.x) {
	            if (this.axis.y) {
	              // Calculations for a grid setup
	              if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
	                // If the current node is to the left on the same row, or above the node that's being dragged
	                // then move it to the right
	                translate.x = this.width + this.marginOffset.x;
	                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
	                  // If it moves passed the right bounds, then animate it to the first position of the next row.
	                  // We just use the offset of the next node to calculate where to move, because that node's original position
	                  // is exactly where we want to go
	                  translate.x = nextNode.edgeOffset.left - edgeOffset.left;
	                  translate.y = nextNode.edgeOffset.top - edgeOffset.top;
	                }
	                if (this.newIndex === null) {
	                  this.newIndex = index;
	                }
	              } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
	                // If the current node is to the right on the same row, or below the node that's being dragged
	                // then move it to the left
	                translate.x = -(this.width + this.marginOffset.x);
	                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
	                  // If it moves passed the left bounds, then animate it to the last position of the previous row.
	                  // We just use the offset of the previous node to calculate where to move, because that node's original position
	                  // is exactly where we want to go
	                  translate.x = prevNode.edgeOffset.left - edgeOffset.left;
	                  translate.y = prevNode.edgeOffset.top - edgeOffset.top;
	                }
	                this.newIndex = index;
	              }
	            } else {
	              if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
	                translate.x = -(this.width + this.marginOffset.x);
	                this.newIndex = index;
	              } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
	                translate.x = this.width + this.marginOffset.x;
	                if (this.newIndex == null) {
	                  this.newIndex = index;
	                }
	              }
	            }
	          } else if (this.axis.y) {
	            if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
	              translate.y = -(this.height + this.marginOffset.y);
	              this.newIndex = index;
	            } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
	              translate.y = this.height + this.marginOffset.y;
	              if (this.newIndex == null) {
	                this.newIndex = index;
	              }
	            }
	          }
	          node.style[_utils.vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
	        }
	
	        if (this.newIndex == null) {
	          this.newIndex = this.index;
	        }
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({
	          ref: ref
	        }, (0, _utils.omit)(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableList', WrappedComponent), _class.defaultProps = {
	    axis: 'y',
	    transitionDuration: 300,
	    pressDelay: 0,
	    pressThreshold: 5,
	    distance: 0,
	    useWindowAsScrollContainer: false,
	    hideSortableGhost: true,
	    shouldCancelStart: function shouldCancelStart(e) {
	      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
	      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];
	
	      if (disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1) {
	        return true; // Return true to cancel sorting
	      }
	    },
	    lockToContainerEdges: false,
	    lockOffset: '50%',
	    getHelperDimensions: function getHelperDimensions(_ref) {
	      var node = _ref.node;
	      return {
	        width: node.offsetWidth,
	        height: node.offsetHeight
	      };
	    }
	  }, _class.propTypes = {
	    axis: _propTypes2.default.oneOf(['x', 'y', 'xy']),
	    distance: _propTypes2.default.number,
	    lockAxis: _propTypes2.default.string,
	    helperClass: _propTypes2.default.string,
	    transitionDuration: _propTypes2.default.number,
	    contentWindow: _propTypes2.default.any,
	    onSortStart: _propTypes2.default.func,
	    onSortMove: _propTypes2.default.func,
	    onSortEnd: _propTypes2.default.func,
	    shouldCancelStart: _propTypes2.default.func,
	    pressDelay: _propTypes2.default.number,
	    useDragHandle: _propTypes2.default.bool,
	    useWindowAsScrollContainer: _propTypes2.default.bool,
	    hideSortableGhost: _propTypes2.default.bool,
	    lockToContainerEdges: _propTypes2.default.bool,
	    lockOffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]))]),
	    getContainer: _propTypes2.default.func,
	    getHelperDimensions: _propTypes2.default.func
	  }, _class.childContextTypes = {
	    manager: _propTypes2.default.object.isRequired
	  }, _temp;
	}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableElement;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Element Component
	function sortableElement(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _props = this.props,
	            collection = _props.collection,
	            disabled = _props.disabled,
	            index = _props.index;
	
	
	        if (!disabled) {
	          this.setDraggable(collection, index);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (this.props.index !== nextProps.index && this.node) {
	          this.node.sortableInfo.index = nextProps.index;
	        }
	        if (this.props.disabled !== nextProps.disabled) {
	          var collection = nextProps.collection,
	              disabled = nextProps.disabled,
	              index = nextProps.index;
	
	          if (disabled) {
	            this.removeDraggable(collection);
	          } else {
	            this.setDraggable(collection, index);
	          }
	        } else if (this.props.collection !== nextProps.collection) {
	          this.removeDraggable(this.props.collection);
	          this.setDraggable(nextProps.collection, nextProps.index);
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _props2 = this.props,
	            collection = _props2.collection,
	            disabled = _props2.disabled;
	
	
	        if (!disabled) this.removeDraggable(collection);
	      }
	    }, {
	      key: 'setDraggable',
	      value: function setDraggable(collection, index) {
	        var node = this.node = (0, _reactDom.findDOMNode)(this);
	
	        node.sortableInfo = {
	          index: index,
	          collection: collection,
	          manager: this.context.manager
	        };
	
	        this.ref = { node: node };
	        this.context.manager.add(collection, this.ref);
	      }
	    }, {
	      key: 'removeDraggable',
	      value: function removeDraggable(collection) {
	        this.context.manager.remove(collection, this.ref);
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({
	          ref: ref
	        }, (0, _utils.omit)(this.props, 'collection', 'disabled', 'index')));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableElement', WrappedComponent), _class.contextTypes = {
	    manager: _propTypes2.default.object.isRequired
	  }, _class.propTypes = {
	    index: _propTypes2.default.number.isRequired,
	    collection: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    disabled: _propTypes2.default.bool
	  }, _class.defaultProps = {
	    collection: 0
	  }, _temp;
	}

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = sortableHandle;
	
	var _react = __webpack_require__(6);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(86);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Export Higher Order Sortable Element Component
	function sortableHandle(WrappedComponent) {
	  var _class, _temp;
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { withRef: false };
	
	  return _temp = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var node = (0, _reactDom.findDOMNode)(this);
	        node.sortableHandle = true;
	      }
	    }, {
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        (0, _invariant2.default)(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var ref = config.withRef ? 'wrappedInstance' : null;
	
	        return _react2.default.createElement(WrappedComponent, _extends({ ref: ref }, this.props));
	      }
	    }]);
	
	    return _class;
	  }(_react.Component), _class.displayName = (0, _utils.provideDisplayName)('sortableHandle', WrappedComponent), _temp;
	}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.arrayMove = exports.sortableHandle = exports.sortableElement = exports.sortableContainer = exports.SortableHandle = exports.SortableElement = exports.SortableContainer = undefined;
	
	var _utils = __webpack_require__(86);
	
	Object.defineProperty(exports, 'arrayMove', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayMove;
	  }
	});
	
	var _SortableContainer2 = __webpack_require__(402);
	
	var _SortableContainer3 = _interopRequireDefault(_SortableContainer2);
	
	var _SortableElement2 = __webpack_require__(403);
	
	var _SortableElement3 = _interopRequireDefault(_SortableElement2);
	
	var _SortableHandle2 = __webpack_require__(404);
	
	var _SortableHandle3 = _interopRequireDefault(_SortableHandle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SortableContainer = _SortableContainer3.default;
	exports.SortableElement = _SortableElement3.default;
	exports.SortableHandle = _SortableHandle3.default;
	exports.sortableContainer = _SortableContainer3.default;
	exports.sortableElement = _SortableElement3.default;
	exports.sortableHandle = _SortableHandle3.default;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.8.6
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(63),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
	60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
	H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("321"):void 0;return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
	b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.6",
	unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(30)
	var upperCaseFirst = __webpack_require__(154)
	
	/**
	 * Sentence case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return upperCaseFirst(noCase(value, locale), locale)
	}


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _util = __webpack_require__(52);
	
	var _merchant = __webpack_require__(421);
	
	var _merchant2 = _interopRequireDefault(_merchant);
	
	var _constants = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({}, _merchant2.default, (0, _util.createActionObject)('loadConfiguration', _constants.LOAD_APP_CONFIGURATION_START, _constants.LOAD_APP_CONFIGURATION_SUCCESS, _constants.LOAD_APP_CONFIGURATION_FAILURE), (0, _util.createActionObject)('loadMerchantInfo', _constants.LOAD_MERCHANT_INFO_START, _constants.LOAD_MERCHANT_INFO_SUCCESS, _constants.LOAD_MERCHANT_INFO_FAILURE), (0, _util.createActionObject)('loadBookingRushes', _constants.LOAD_BOOKING_RUSHES_START, _constants.LOAD_BOOKING_RUSHES_SUCCESS, _constants.LOAD_BOOKING_RUSHES_FAILURE), (0, _util.createActionObject)('verifyRecoveryToken', _constants.VERIFY_RECOVERY_TOKEN_START, _constants.VERIFY_RECOVERY_TOKEN_SUCCESS, _constants.VERIFY_RECOVERY_TOKEN_FAILURE), (0, _util.createActionObject)('resetPassword', _constants.RESET_PASSWORD_START, _constants.RESET_PASSWORD_SUCCESS, _constants.RESET_PASSWORD_FAILURE), {
	  updateConnectionInfo: function updateConnectionInfo(info) {
	    return {
	      type: _constants.UPDATE_CONNECTION_INFO,
	      info: info
	    };
	  },
	  updateUserLocation: function updateUserLocation(location) {
	    return {
	      type: _constants.USER_LOCATION,
	      location: location
	    };
	  },
	  resetRecoveryPasswordState: function resetRecoveryPasswordState() {
	    return {
	      type: _constants.RESET_RECOVERY_PASSWORD_STATUS
	    };
	  },
	  updateRecoveryFormValue: function updateRecoveryFormValue(value) {
	    return {
	      type: _constants.UPDATE_RECOVERY_FORM_VALUE,
	      value: value
	    };
	  },
	  setRecoveryToken: function setRecoveryToken(token) {
	    return {
	      type: _constants.SET_RECOVERY_TOKEN,
	      token: token
	    };
	  },
	  setRecoveryEmailSent: function setRecoveryEmailSent() {
	    return {
	      type: _constants.RECOVERY_EMAIL_REQUEST
	    };
	  },
	
	
	  // just for staging
	  switchBundleId: function switchBundleId(bundleId) {
	    return {
	      type: _constants.SWITCH_BUNDLE_ID,
	      newBundleId: bundleId
	    };
	  },
	  switchApiEndpoint: function switchApiEndpoint(endpoint) {
	    return {
	      type: _constants.SWITCH_API_ENDPOINT,
	      endpoint: endpoint
	    };
	  }
	});

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(9);
	
	var _booking = __webpack_require__(420);
	
	var _booking2 = _interopRequireDefault(_booking);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _extends({}, _booking2.default, {
	  setUserLocation: function setUserLocation(location) {
	    return {
	      type: _constants.SET_USER_LOCATION,
	      location: {
	        lat: location.lat,
	        lng: location.lng
	      }
	    };
	  },
	  setBookingRestaurant: function setBookingRestaurant(restaurant) {
	    return {
	      type: _constants.SET_BOOKING_RESTAURANT,
	      restaurant: restaurant
	    };
	  },
	  setBookingDate: function setBookingDate(date, hasBookingRushes, bookingRushId) {
	    return {
	      type: _constants.SET_BOOKING_DATE,
	      hasBookingRushes: hasBookingRushes,
	      bookingRushId: bookingRushId,
	      date: date
	    };
	  },
	  setBookingSeats: function setBookingSeats(n) {
	    return {
	      type: _constants.SET_BOOKING_SEATS,
	      n: n
	    };
	  },
	  setBookingTime: function setBookingTime(time, verifyBookingRush) {
	    return {
	      type: _constants.SET_BOOKING_TIME,
	      time: time,
	      verifyBookingRush: verifyBookingRush
	    };
	  },
	  setFormData: function setFormData(data) {
	    return {
	      type: _constants.BOOKING_SET_FORM,
	      data: data
	    };
	  },
	  endBooking: function endBooking() {
	    return {
	      type: _constants.BOOKING_RESET_END
	    };
	  }
	});

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _util = __webpack_require__(52);
	
	var _constants = __webpack_require__(9);
	
	exports.default = _extends({}, (0, _util.createActionObject)('loadMenu', _constants.LOAD_MENU_START, _constants.LOAD_MENU_SUCCESS, _constants.LOAD_MENU_FAILURE), (0, _util.createActionObject)('createCardToken', _constants.CREATE_CARD_TOKEN_START, _constants.CREATE_CARD_TOKEN_SUCCESS, _constants.CREATE_CARD_TOKEN_FAILURE), (0, _util.createActionObject)('orderFetchExtraCosts', _constants.ORDER_FETCH_EXTRA_COSTS_START, _constants.ORDER_FETCH_EXTRA_COSTS_SUCCESS, _constants.ORDER_FETCH_EXTRA_COSTS_FAILURE), {
	  configureItem: function configureItem(item) {
	    return {
	      type: _constants.MENU_CONFIGURE_ITEM,
	      item: item
	    };
	  },
	  addToCart: function addToCart(item) {
	    return {
	      type: _constants.MENU_CART_ADDITEM,
	      item: item
	    };
	  },
	  removeFromCart: function removeFromCart(item) {
	    return {
	      type: _constants.MENU_CART_REMOVEITEM,
	      item: item
	    };
	  },
	  resetCart: function resetCart() {
	    return {
	      type: _constants.MENU_CART_RESET
	    };
	  },
	  showErrors: function showErrors(bool) {
	    return {
	      type: _constants.MENU_SHOW_ERRORS,
	      bool: bool
	    };
	  }
	}, (0, _util.createActionObject)('deliveryAddressCheck', _constants.DELIVERY_ADDRESS_CHECK_START, _constants.DELIVERY_ADDRESS_CHECK_SUCCESS, _constants.DELIVERY_ADDRESS_CHECK_FAILURE), (0, _util.createActionObject)('deliveryAddressUpdate', _constants.DELIVERY_ADDRESS_UPDATE_START, _constants.DELIVERY_ADDRESS_UPDATE_SUCCESS, _constants.DELIVERY_ADDRESS_UPDATE_FAILURE), {
	  setDeliveryAddress: function setDeliveryAddress(_ref) {
	    var description = _ref.description,
	        geometry = _ref.geometry,
	        addressComponents = _ref.addressComponents;
	
	    return {
	      type: _constants.DELIVERY_SET_ADDRESS,
	      addressComponents: addressComponents,
	      location: {
	        geometry: geometry,
	        description: description
	      }
	    };
	  },
	  updateDeliveryAddressExtraInfo: function updateDeliveryAddressExtraInfo(data) {
	    return {
	      type: _constants.DELIVERY_UPDATE_EXTRA_INFO,
	      data: data
	    };
	  },
	  reloadOrder: function reloadOrder(order) {
	    return {
	      type: _constants.ORDER_RELOAD,
	      order: order
	    };
	  },
	  setDateTimeDelivery: function setDateTimeDelivery(_ref2) {
	    var date = _ref2.date,
	        time = _ref2.time;
	
	    return {
	      type: _constants.DELIVERY_SET_DATE_TIME,
	      deliveryDate: date,
	      deliveryTime: time
	    };
	  },
	  setOrderType: function setOrderType(orderType) {
	    return {
	      type: _constants.DELIVERY_SET_ORDER_TYPE,
	      orderType: orderType
	    };
	  },
	  setOrderTypeDelivery: function setOrderTypeDelivery() {
	    return {
	      type: _constants.DELIVERY_SET_ORDER_TYPE,
	      orderType: _constants.ORDER_TYPE_DELIVERY
	    };
	  },
	  setOrderTypeTakeAway: function setOrderTypeTakeAway() {
	    return {
	      type: _constants.DELIVERY_SET_ORDER_TYPE,
	      orderType: _constants.ORDER_TYPE_TAKEAWAY
	    };
	  },
	  setDeliveryData: function setDeliveryData(data) {
	    return {
	      type: _constants.DELIVERY_SET_ORDER_DATA,
	      data: data
	    };
	  },
	  setTakeAwayRestaurant: function setTakeAwayRestaurant(restaurantId) {
	    return {
	      type: _constants.TAKEAWAY_SET_RESTAURANT,
	      id: restaurantId
	    };
	  },
	  setPaymentMethod: function setPaymentMethod(method) {
	    return {
	      type: _constants.PAYMENT_SET_METHOD,
	      method: method
	    };
	  },
	  setPaymentCreditCard: function setPaymentCreditCard() {
	    return {
	      type: _constants.PAYMENT_SET_METHOD,
	      method: _constants.PAYMENT_METHOD_CC
	    };
	  },
	  setPaymentUnhandled: function setPaymentUnhandled(amount) {
	    return {
	      type: _constants.PAYMENT_SET_METHOD,
	      method: _constants.PAYMENT_UNHANDLED,
	      amount: amount
	    };
	  },
	  setCheckoutFormData: function setCheckoutFormData(data) {
	    return {
	      type: _constants.ORDER_SET_CHECKOUT_FORM,
	      data: data
	    };
	  },
	  setNewCreditCardFormData: function setNewCreditCardFormData(data) {
	    return {
	      type: _constants.ORDER_NEW_CC_SETFORM,
	      data: data
	    };
	  },
	  resetOrderState: function resetOrderState() {
	    var keep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return {
	      type: _constants.ORDER_RESET,
	      keep: keep
	    };
	  }
	}, (0, _util.createActionObject)('storeOrder', _constants.STORE_ORDER_START, _constants.STORE_ORDER_SUCCESS, _constants.STORE_ORDER_FAILURE), {
	  updateCurrentOrder: function updateCurrentOrder(order) {
	    return {
	      type: _constants.UPDATE_CURRENTORDER,
	      order: order
	    };
	  },
	  addVoucher: function addVoucher(voucherID) {
	    return {
	      type: _constants.ORDER_ADD_VOUCHER,
	      voucherID: voucherID
	    };
	  },
	  toggleAsap: function toggleAsap(status) {
	    return {
	      type: _constants.ORDER_TOGGLE_ASAP,
	      status: status
	    };
	  }
	});

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.VoucherHelpers = exports.TimeHelpers = exports.RestaurantHelpers = exports.PriceStrategy = exports.PaymentHelpers = exports.LocationHelpers = exports.I18N = exports.DateTimeFormatter = undefined;
	
	var _datetimeFormatter = __webpack_require__(192);
	
	var _datetimeFormatter2 = _interopRequireDefault(_datetimeFormatter);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _location = __webpack_require__(50);
	
	var _location2 = _interopRequireDefault(_location);
	
	var _payment = __webpack_require__(412);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _priceStrategy = __webpack_require__(193);
	
	var _priceStrategy2 = _interopRequireDefault(_priceStrategy);
	
	var _restaurant = __webpack_require__(194);
	
	var _restaurant2 = _interopRequireDefault(_restaurant);
	
	var _time = __webpack_require__(20);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _voucher = __webpack_require__(33);
	
	var _voucher2 = _interopRequireDefault(_voucher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DateTimeFormatter = _datetimeFormatter2.default;
	exports.I18N = _i18n2.default;
	exports.LocationHelpers = _location2.default;
	exports.PaymentHelpers = _payment2.default;
	exports.PriceStrategy = _priceStrategy2.default;
	exports.RestaurantHelpers = _restaurant2.default;
	exports.TimeHelpers = _time2.default;
	exports.VoucherHelpers = _voucher2.default;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _bluebird = __webpack_require__(124);
	
	var _bluebird2 = _interopRequireDefault(_bluebird);
	
	var _creditCard = __webpack_require__(208);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creditCardErrors = function creditCardErrors(errors) {
	  var remap = {
	    validCardNumber: 'number',
	    validExpiryMonth: 'expiryMonth',
	    validExpiryYear: 'expiryYear',
	    validCvv: 'cvv',
	    isExpired: 'expired'
	  };
	
	  return _lodash2.default.mapKeys(errors, function (v, k) {
	    return remap[k];
	  });
	};
	
	var getCreditCardType = function getCreditCardType(number, opts) {
	  return _creditCard2.default.determineCardType(number, opts);
	};
	
	var tryValidateCreditCard = function tryValidateCreditCard(value) {
	  var card = _extends({
	    cardType: _creditCard2.default.determineCardType(value.number)
	  }, value);
	
	  var result = _creditCard2.default.validate(card);
	  var valid = _lodash2.default.pick(result, ['validCardNumber', 'validExpiryMonth', 'validExpiryYear', 'validCvv', 'isExpired']);
	
	  valid.isExpired = !valid.isExpired;
	
	  if (_lodash2.default.every(valid)) {
	    return true;
	  }
	
	  var err = new Error('no valid credit card data');
	  err.errors = creditCardErrors(valid);
	  throw err;
	};
	
	var validateCreditCard = function validateCreditCard(value) {
	  try {
	    tryValidateCreditCard(value);
	  } catch (e) {
	    return _bluebird2.default.reject(e);
	  }
	  return _bluebird2.default.resolve(true);
	};
	
	exports.default = {
	  validateCreditCard: validateCreditCard,
	  getCreditCardType: getCreditCardType
	};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _order = __webpack_require__(414);
	
	Object.keys(_order).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _order[key];
	    }
	  });
	});
	
	var _user = __webpack_require__(415);
	
	Object.keys(_user).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _user[key];
	    }
	  });
	});

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateExtraCosts = undefined;
	
	var _cart = __webpack_require__(51);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _constants = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var updateExtraCosts = exports.updateExtraCosts = function updateExtraCosts(state, services, actions) {
	  var resolvedActions = actions.order ? actions.order : actions.orderAction;
	  if (state.order.orderType === _constants.ORDER_TYPE_DELIVERY) {
	    var order = state.order;
	    var total = _cart2.default.total(order.cart);
	    services.order.orderFetchExtraCosts(state.app.id, {
	      total: total,
	      targetDeliveryArea: order.deliveryAreaId,
	      targetRestaurant: order.targetRestaurant
	    }, resolvedActions);
	  }
	};

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var updateCurrentUser = exports.updateCurrentUser = function updateCurrentUser(state, services, actions, action) {
	  var fragment = "\n    id\n    name\n    lastName\n    email\n    accessToken\n  ";
	  var resolvedActions = actions.user ? actions.user : actions.userAction;
	  services.user.loadCurrentUser(fragment, resolvedActions);
	};
	
	var updateAccessToken = exports.updateAccessToken = function updateAccessToken(state, services, actions, action) {
	  var resolvedActions = actions.user ? actions.user : actions.userAction;
	  resolvedActions.updateAccessToken(action.data);
	};
	
	var fetchLoyalty = exports.fetchLoyalty = function fetchLoyalty(state, services, actions) {
	  if (!state.user.currentUser) {
	    return;
	  }
	  var resolvedActions = actions.loyaltyCard ? actions.loyaltyCard : actions.loyaltyCardAction;
	  services.loyaltyCard.getActiveCard({ user: state.user.currentUser.id }, resolvedActions);
	};
	
	var fetchUserOrders = exports.fetchUserOrders = function fetchUserOrders(state, services, actions) {
	  if (!state.user.currentUser) {
	    return;
	  }
	  var resolvedActions = actions.user ? actions.user : actions.userAction;
	
	  var filters = { limit: 50 };
	  if (state.app.id) {
	    filters.app = state.app.id;
	  }
	  services.user.loadUserOrders(filters, resolvedActions);
	};
	
	var reloadCreditCards = exports.reloadCreditCards = function reloadCreditCards(state, services, actions, action) {
	  var resolvedActions = actions.user ? actions.user : actions.userAction;
	  services.user.loadCreditCards(state.app.id, resolvedActions);
	};
	
	var fetchVouchers = exports.fetchVouchers = function fetchVouchers(state, services, actions) {
	  var resolvedActions = actions.voucher ? actions.voucher : actions.voucherAction;
	  services.voucher.getMine(resolvedActions);
	};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrderReducer = exports.BookingReducer = exports.AppReducer = undefined;
	
	var _app = __webpack_require__(195);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _booking = __webpack_require__(196);
	
	var _booking2 = _interopRequireDefault(_booking);
	
	var _order = __webpack_require__(197);
	
	var _order2 = _interopRequireDefault(_order);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppReducer = _app2.default;
	exports.BookingReducer = _booking2.default;
	exports.OrderReducer = _order2.default;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _booking = __webpack_require__(87);
	
	Object.keys(_booking).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _booking[key];
	    }
	  });
	});
	
	var _cart = __webpack_require__(115);
	
	Object.keys(_cart).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _cart[key];
	    }
	  });
	});
	
	var _common = __webpack_require__(88);
	
	Object.keys(_common).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _common[key];
	    }
	  });
	});
	
	var _menu = __webpack_require__(418);
	
	Object.keys(_menu).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _menu[key];
	    }
	  });
	});
	
	var _order = __webpack_require__(198);
	
	Object.keys(_order).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _order[key];
	    }
	  });
	});
	
	var _user = __webpack_require__(116);
	
	Object.keys(_user).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _user[key];
	    }
	  });
	});
	
	var _voucher = __webpack_require__(117);
	
	Object.keys(_voucher).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _voucher[key];
	    }
	  });
	});

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.menuSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reselect = __webpack_require__(18);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var menuSelector = exports.menuSelector = (0, _reselect.createSelector)(function (state) {
	  return state.order.menu;
	}, function (menuData) {
	  if (!menuData) {
	    return {};
	  }
	
	  var data = menuData.categories.reduce(function (acc, cat, index) {
	    var items = cat.items.length;
	    if (items === 0) {
	      return acc;
	    }
	    return {
	      // count items in the category and the section itself
	      itemsCount: acc.itemsCount + cat.items.length + 1,
	      categoriesCollapsed: [].concat(_toConsumableArray(acc.categoriesCollapsed), [{ name: cat.name, description: cat.description, index: index, items: items }]),
	      itemsGrouped: _extends({}, acc.itemsGrouped, _defineProperty({}, cat.name, cat.items)),
	      lookup: _extends({}, acc.lookup, _defineProperty({}, cat.name, acc.categoriesCount)),
	      categoriesCount: acc.categoriesCount + 1
	    };
	  }, {
	    categoriesCount: 0,
	    itemsCount: 0,
	    categoriesCollapsed: [],
	    itemsGrouped: {},
	    lookup: {}
	  });
	  return data;
	});

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrderService = exports.AppService = undefined;
	
	var _app = __webpack_require__(199);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _order = __webpack_require__(200);
	
	var _order2 = _interopRequireDefault(_order);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppService = _app2.default;
	exports.OrderService = _order2.default;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(24);
	
	var _util = __webpack_require__(52);
	
	exports.default = _extends({}, (0, _util.createActionObject)('createRequest', _constants.BOOKING_REQUEST_CREATE_START, _constants.BOOKING_REQUEST_CREATE_SUCCESS, _constants.BOOKING_REQUEST_CREATE_FAILURE), (0, _util.createActionObject)('loadBookingAvailability', _constants.LOAD_BOOKING_AVAILABILITY_START, _constants.LOAD_BOOKING_AVAILABILITY_SUCCESS, _constants.LOAD_BOOKING_AVAILABILITY_FAILURE));

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(24);
	
	var _util = __webpack_require__(52);
	
	exports.default = _extends({}, (0, _util.createActionObject)('restaurantsRefresh', _constants.RESTAURANTS_REFRESH_START, _constants.RESTAURANTS_REFRESH_SUCCESS, _constants.RESTAURANTS_REFRESH_FAILURE));

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STANDALONE = exports.STANDALONE = 'STANDALONE';
	
	var CONTAINER = exports.CONTAINER = 'CONTAINER';

/***/ }),
/* 423 */
[785, 24],
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setStripeKey = undefined;
	
	var _i18next = __webpack_require__(134);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stripe_key = null;
	
	var stripeUrl = function stripeUrl(path) {
	  return 'https://api.stripe.com/v3/' + path;
	};
	
	var stripeBody = function stripeBody(body) {
	  return Object.keys(body).map(function (key) {
	    var property = encodeURIComponent(key);
	    return 'card[' + property + ']=' + encodeURIComponent(body[key]);
	  }).join('&');
	};
	
	var stripeError = function stripeError(error) {
	  var errors = {
	    'invalid_number': _i18next2.default.t('lib.stripe_invalid_number'),
	    'invalid_expiry_month': _i18next2.default.t('lib.stripe_invalid_expiry_month'),
	    'invalid_expiry_year': _i18next2.default.t('lib.stripe_invalid_expiry_year'),
	    'invalid_cvc': _i18next2.default.t('lib.stripe_invalid_cvc'),
	    'incorrect_number': _i18next2.default.t('lib.stripe_invalid_number'),
	    'expired_card': _i18next2.default.t('lib.stripe_expired_card'),
	    'incorrect_cvc': _i18next2.default.t('lib.stripe_invalid_cvc'),
	    'incorrect_zip': _i18next2.default.t('lib.stripe_incorrect_zip'),
	    'card_declined': _i18next2.default.t('lib.stripe_card_declined'),
	    'missing': _i18next2.default.t('lib.stripe_missing'),
	    'processing_error': _i18next2.default.t('lib.stripe_processing_error')
	  };
	
	  var message = errors[error.code] || errors['processing_error'];
	  return [{ message: message }];
	};
	
	var setStripeKey = exports.setStripeKey = function setStripeKey(key) {
	  return stripe_key = key;
	};
	
	exports.default = {
	  stripeCreateCardToken: function stripeCreateCardToken(deliveryAction, card) {
	    var url = stripeUrl('tokens');
	    var encodedBody = stripeBody({
	      number: card.number,
	      exp_month: card.expiryMonth,
	      exp_year: card.expiryYear,
	      cvc: card.cvv
	    });
	
	    var options = {
	      method: 'POST',
	      headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/x-www-form-urlencoded',
	        'Authorization': 'Bearer ' + stripe_key
	      },
	      body: encodedBody
	    };
	
	    return fetch(url, options).then(function (res) {
	      return res.json();
	    }).then(function (result) {
	      if (result.error) {
	        return deliveryAction.createCardTokenFailure(stripeError(result.error), { error: result.error });
	      }
	
	      deliveryAction.createCardTokenSuccess(result.id);
	
	      return result.id;
	    }).catch(function (error) {
	      deliveryAction.createCardTokenFailure(stripeError({ type: 'processing_error' }), { error: error });
	    });
	  }
	};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	    //! moment.js
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months$1 = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    hooks.defineLocale('ar-ly', {
	        months : months$1,
	        monthsShort : months$1,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$1 = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    hooks.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$1[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$2 = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap$1 = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm$1 = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals$1 = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize$1 = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm$1(number),
	                str = plurals$1[u][pluralForm$1(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months$2 = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    hooks.defineLocale('ar', {
	        months : months$2,
	        monthsShort : months$2,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize$1('s'),
	            ss : pluralize$1('s'),
	            m : pluralize$1('m'),
	            mm : pluralize$1('m'),
	            h : pluralize$1('h'),
	            hh : pluralize$1('h'),
	            d : pluralize$1('d'),
	            dd : pluralize$1('d'),
	            M : pluralize$1('M'),
	            MM : pluralize$1('M'),
	            y : pluralize$1('y'),
	            yy : pluralize$1('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap$1[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$2[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    hooks.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    hooks.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$3 = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap$2 = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    hooks.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap$2[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$3[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$4 = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap$3 = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    hooks.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap$3[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$4[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    hooks.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    hooks.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var months$3 = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex$1 = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural$1(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate$1(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$1(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$1(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$1(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$1(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$1(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$1(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    hooks.defineLocale('cs', {
	        months : months$3,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex$1,
	        monthsShortRegex : monthsRegex$1,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate$1,
	            ss : translate$1,
	            m : translate$1,
	            mm : translate$1,
	            h : translate$1,
	            hh : translate$1,
	            d : translate$1,
	            dd : translate$1,
	            M : translate$1,
	            MM : translate$1,
	            y : translate$1,
	            yy : translate$1
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    hooks.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function processRelativeTime$1(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    hooks.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime$1,
	            mm : '%d Minuten',
	            h : processRelativeTime$1,
	            hh : '%d Stunden',
	            d : processRelativeTime$1,
	            dd : processRelativeTime$1,
	            M : processRelativeTime$1,
	            MM : processRelativeTime$1,
	            y : processRelativeTime$1,
	            yy : processRelativeTime$1
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function processRelativeTime$2(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    hooks.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime$2,
	            mm : '%d Minuten',
	            h : processRelativeTime$2,
	            hh : '%d Stunden',
	            d : processRelativeTime$2,
	            dd : processRelativeTime$2,
	            M : processRelativeTime$2,
	            MM : processRelativeTime$2,
	            y : processRelativeTime$2,
	            yy : processRelativeTime$2
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var months$4 = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    hooks.defineLocale('dv', {
	        months : months$4,
	        monthsShort : months$4,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort$1 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse$1 = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex$2 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    hooks.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort$1[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex$2,
	        monthsShortRegex: monthsRegex$2,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse$1,
	        longMonthsParse: monthsParse$1,
	        shortMonthsParse: monthsParse$1,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var monthsShortDot$1 = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort$2 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse$2 = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex$3 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    hooks.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot$1;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort$2[m.month()];
	            } else {
	                return monthsShortDot$1[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex$3,
	        monthsShortRegex: monthsRegex$3,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse$2,
	        longMonthsParse: monthsParse$2,
	        shortMonthsParse: monthsParse$2,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var monthsShortDot$2 = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort$3 = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse$3 = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex$4 = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    hooks.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot$2;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort$3[m.month()];
	            } else {
	                return monthsShortDot$2[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex$4,
	        monthsShortRegex : monthsRegex$4,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse$3,
	        longMonthsParse : monthsParse$3,
	        shortMonthsParse : monthsParse$3,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function processRelativeTime$3(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    hooks.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime$3,
	            ss     : processRelativeTime$3,
	            m      : processRelativeTime$3,
	            mm     : processRelativeTime$3,
	            h      : processRelativeTime$3,
	            hh     : processRelativeTime$3,
	            d      : processRelativeTime$3,
	            dd     : '%d päeva',
	            M      : processRelativeTime$3,
	            MM     : processRelativeTime$3,
	            y      : processRelativeTime$3,
	            yy     : processRelativeTime$3
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$5 = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap$4 = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    hooks.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap$4[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$5[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate$2(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    hooks.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate$2,
	            ss : translate$2,
	            m : translate$2,
	            mm : translate$2,
	            h : translate$2,
	            hh : translate$2,
	            d : translate$2,
	            dd : translate$2,
	            M : translate$2,
	            MM : translate$2,
	            y : translate$2,
	            yy : translate$2
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    hooks.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	
	    var months$5 = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort$4 = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays$1 = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    hooks.defineLocale('ga', {
	        months: months$5,
	        monthsShort: monthsShort$4,
	        monthsParseExact: true,
	        weekdays: weekdays$1,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var months$6 = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort$5 = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays$2 = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort$1 = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin$1 = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    hooks.defineLocale('gd', {
	        months : months$6,
	        monthsShort : monthsShort$5,
	        monthsParseExact : true,
	        weekdays : weekdays$2,
	        weekdaysShort : weekdaysShort$1,
	        weekdaysMin : weekdaysMin$1,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function processRelativeTime$4(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    hooks.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime$4,
	            ss : processRelativeTime$4,
	            m : processRelativeTime$4,
	            mm : processRelativeTime$4,
	            h : processRelativeTime$4,
	            hh : processRelativeTime$4,
	            d : processRelativeTime$4,
	            dd : processRelativeTime$4,
	            M : processRelativeTime$4,
	            MM : processRelativeTime$4,
	            y : processRelativeTime$4,
	            yy : processRelativeTime$4
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$6 = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap$5 = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    hooks.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap$5[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$6[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$7 = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap$6 = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    hooks.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap$6[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$7[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function translate$3(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    hooks.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate$3,
	            m      : translate$3,
	            mm     : translate$3,
	            h      : translate$3,
	            hh     : translate$3,
	            d      : 'dan',
	            dd     : translate$3,
	            M      : 'mjesec',
	            MM     : translate$3,
	            y      : 'godinu',
	            yy     : translate$3
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate$4(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    hooks.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate$4,
	            ss : translate$4,
	            m : translate$4,
	            mm : translate$4,
	            h : translate$4,
	            hh : translate$4,
	            d : translate$4,
	            dd : translate$4,
	            M : translate$4,
	            MM : translate$4,
	            y : translate$4,
	            yy : translate$4
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function plural$2(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate$5(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural$2(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural$2(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural$2(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural$2(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural$2(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural$2(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    hooks.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate$5,
	            ss : translate$5,
	            m : translate$5,
	            mm : translate$5,
	            h : 'klukkustund',
	            hh : translate$5,
	            d : translate$5,
	            dd : translate$5,
	            M : translate$5,
	            MM : translate$5,
	            y : translate$5,
	            yy : translate$5
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var suffixes$1 = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    hooks.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes$1[number] || suffixes$1[a] || suffixes$1[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$8 = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap$7 = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    hooks.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap$7[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$8[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$9 = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap$8 = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    hooks.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap$8[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$9[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$a = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap$9 = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months$7 = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    hooks.defineLocale('ku', {
	        months : months$7,
	        monthsShort : months$7,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap$9[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$a[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var suffixes$2 = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    hooks.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes$2[number] || suffixes$2[a] || suffixes$2[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function processRelativeTime$5(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    hooks.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime$5,
	            mm : '%d Minutten',
	            h : processRelativeTime$5,
	            hh : '%d Stonnen',
	            d : processRelativeTime$5,
	            dd : '%d Deeg',
	            M : processRelativeTime$5,
	            MM : '%d Méint',
	            y : processRelativeTime$5,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate$6(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    hooks.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate$6,
	            m : translateSingular,
	            mm : translate$6,
	            h : translateSingular,
	            hh : translate$6,
	            d : translateSingular,
	            dd : translate$6,
	            M : translateSingular,
	            MM : translate$6,
	            y : translateSingular,
	            yy : translate$6
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var units$1 = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format$1(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural$1(number, withoutSuffix, key) {
	        return number + ' ' + format$1(units$1[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format$1(units$1[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    hooks.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural$1,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural$1,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural$1,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural$1,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural$1,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural$1
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    hooks.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function translate$7(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    hooks.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate$7,
	            ss : translate$7,
	            m : translate$7,
	            mm : translate$7,
	            h : translate$7,
	            hh : translate$7,
	            d : translate$7,
	            dd : translate$7,
	            M : translate$7,
	            MM : translate$7,
	            y : translate$7,
	            yy : translate$7
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$b = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap$a = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    hooks.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap$a[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$b[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$c = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap$b = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    hooks.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap$b[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$c[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$d = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap$c = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    hooks.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap$c[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$d[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots$1 = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots$1 = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse$4 = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex$5 = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    hooks.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots$1;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots$1[m.month()];
	            } else {
	                return monthsShortWithDots$1[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex$5,
	        monthsShortRegex: monthsRegex$5,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse$4,
	        longMonthsParse : monthsParse$4,
	        shortMonthsParse : monthsParse$4,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots$2 = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots$2 = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse$5 = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex$6 = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    hooks.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots$2;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots$2[m.month()];
	            } else {
	                return monthsShortWithDots$2[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex$6,
	        monthsShortRegex: monthsRegex$6,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse$5,
	        longMonthsParse : monthsParse$5,
	        shortMonthsParse : monthsParse$5,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$e = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap$d = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    hooks.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap$d[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$e[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural$3(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate$8(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural$3(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural$3(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural$3(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural$3(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural$3(number) ? 'lata' : 'lat');
	        }
	    }
	
	    hooks.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate$8,
	            m : translate$8,
	            mm : translate$8,
	            h : translate$8,
	            hh : translate$8,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate$8,
	            y : 'rok',
	            yy : translate$8
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural$2(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    hooks.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural$2,
	            m : 'un minut',
	            mm : relativeTimeWithPlural$2,
	            h : 'o oră',
	            hh : relativeTimeWithPlural$2,
	            d : 'o zi',
	            dd : relativeTimeWithPlural$2,
	            M : 'o lună',
	            MM : relativeTimeWithPlural$2,
	            y : 'un an',
	            yy : relativeTimeWithPlural$2
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function plural$4(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural$3(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural$4(format[key], +number);
	        }
	    }
	    var monthsParse$6 = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    hooks.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse$6,
	        longMonthsParse : monthsParse$6,
	        shortMonthsParse : monthsParse$6,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural$3,
	            m : relativeTimeWithPlural$3,
	            mm : relativeTimeWithPlural$3,
	            h : 'час',
	            hh : relativeTimeWithPlural$3,
	            d : 'день',
	            dd : relativeTimeWithPlural$3,
	            M : 'месяц',
	            MM : relativeTimeWithPlural$3,
	            y : 'год',
	            yy : relativeTimeWithPlural$3
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var months$8 = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days$1 = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    hooks.defineLocale('sd', {
	        months : months$8,
	        monthsShort : months$8,
	        weekdays : days$1,
	        weekdaysShort : days$1,
	        weekdaysMin : days$1,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    hooks.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var months$9 = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort$6 = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural$5(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate$9(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$5(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$5(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$5(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$5(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$5(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural$5(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    hooks.defineLocale('sk', {
	        months : months$9,
	        monthsShort : monthsShort$6,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate$9,
	            ss : translate$9,
	            m : translate$9,
	            mm : translate$9,
	            h : translate$9,
	            hh : translate$9,
	            d : translate$9,
	            dd : translate$9,
	            M : translate$9,
	            MM : translate$9,
	            y : translate$9,
	            yy : translate$9
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function processRelativeTime$6(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    hooks.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime$6,
	            ss     : processRelativeTime$6,
	            m      : processRelativeTime$6,
	            mm     : processRelativeTime$6,
	            h      : processRelativeTime$6,
	            hh     : processRelativeTime$6,
	            d      : processRelativeTime$6,
	            dd     : processRelativeTime$6,
	            M      : processRelativeTime$6,
	            MM     : processRelativeTime$6,
	            y      : processRelativeTime$6,
	            yy     : processRelativeTime$6
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var translator$1 = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator$1.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator$1.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    hooks.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator$1.translate,
	            m      : translator$1.translate,
	            mm     : translator$1.translate,
	            h      : translator$1.translate,
	            hh     : translator$1.translate,
	            d      : 'дан',
	            dd     : translator$1.translate,
	            M      : 'месец',
	            MM     : translator$1.translate,
	            y      : 'годину',
	            yy     : translator$1.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var translator$2 = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator$2.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator$2.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    hooks.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator$2.translate,
	            m      : translator$2.translate,
	            mm     : translator$2.translate,
	            h      : translator$2.translate,
	            hh     : translator$2.translate,
	            d      : 'dan',
	            dd     : translator$2.translate,
	            M      : 'mesec',
	            MM     : translator$2.translate,
	            y      : 'godinu',
	            yy     : translator$2.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var symbolMap$f = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap$e = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    hooks.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap$e[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap$f[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var suffixes$3 = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    hooks.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes$3[number] || suffixes$3[a] || suffixes$3[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate$a(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    hooks.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate$a,
	            m : 'wa’ tup',
	            mm : translate$a,
	            h : 'wa’ rep',
	            hh : translate$a,
	            d : 'wa’ jaj',
	            dd : translate$a,
	            M : 'wa’ jar',
	            MM : translate$a,
	            y : 'wa’ DIS',
	            yy : translate$a
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    var suffixes$4 = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    hooks.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes$4[a] || suffixes$4[b] || suffixes$4[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    hooks.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime$7,
	            ss : processRelativeTime$7,
	            m : processRelativeTime$7,
	            mm : processRelativeTime$7,
	            h : processRelativeTime$7,
	            hh : processRelativeTime$7,
	            d : processRelativeTime$7,
	            dd : processRelativeTime$7,
	            M : processRelativeTime$7,
	            MM : processRelativeTime$7,
	            y : processRelativeTime$7,
	            yy : processRelativeTime$7
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime$7(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    //! moment.js language configuration
	
	    hooks.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    function plural$6(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural$4(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural$6(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    hooks.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural$4,
	            m : relativeTimeWithPlural$4,
	            mm : relativeTimeWithPlural$4,
	            h : 'годину',
	            hh : relativeTimeWithPlural$4,
	            d : 'день',
	            dd : relativeTimeWithPlural$4,
	            M : 'місяць',
	            MM : relativeTimeWithPlural$4,
	            y : 'рік',
	            yy : relativeTimeWithPlural$4
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    var months$a = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days$2 = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    hooks.defineLocale('ur', {
	        months : months$a,
	        monthsShort : months$a,
	        weekdays : days$2,
	        weekdaysShort : days$2,
	        weekdaysMin : days$2,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    //! moment.js locale configuration
	
	    hooks.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    hooks.locale('en');
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)(module)))

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(34);
	
	var _util = __webpack_require__(25);
	
	exports.default = _extends({}, (0, _util.createActionObject)('authenticate', _constants.USER_AUTHENTICATE_START, _constants.USER_AUTHENTICATE_SUCCESS, _constants.USER_AUTHENTICATE_FAILURE), (0, _util.createActionObject)('register', _constants.USER_REGISTER_START, _constants.USER_REGISTER_SUCCESS, _constants.USER_REGISTER_FAILURE), (0, _util.createActionObject)('logout', _constants.USER_LOGOUT_START, _constants.USER_LOGOUT_SUCCESS, _constants.USER_LOGOUT_FAILURE), (0, _util.createActionObject)('loadCurrentUser', _constants.USER_LOAD_START, _constants.USER_LOAD_SUCCESS, _constants.USER_LOAD_FAILURE), (0, _util.createActionObject)('loadUserOrders', _constants.USER_LOAD_ORDERS_START, _constants.USER_LOAD_ORDERS_SUCCESS, _constants.USER_LOAD_ORDERS_FAILURE), (0, _util.createActionObject)('loadUserBookingRequests', _constants.USER_LOAD_BOOKING_REQUESTS_START, _constants.USER_LOAD_BOOKING_REQUESTS_SUCCESS, _constants.USER_LOAD_BOOKING_REQUESTS_FAILURE), (0, _util.createActionObject)('loadCreditCards', _constants.USER_LOAD_START, _constants.USER_LOAD_CREDIT_CARDS_SUCCESS, _constants.USER_LOAD_FAILURE), (0, _util.createActionObject)('deleteCreditCard', _constants.USER_LOAD_START, _constants.USER_DELETE_CREDIT_CARD_SUCCESS, _constants.USER_LOAD_FAILURE), {
	  addNewTmpCreditCard: function addNewTmpCreditCard(data) {
	    return {
	      type: _constants.USER_ADD_TMP_NEW_CREDIT_CARD,
	      data: data
	    };
	  },
	  updateAccessToken: function updateAccessToken(accessToken) {
	    return {
	      type: _constants.USER_UPDATE_ACCESSTOKEN,
	      accessToken: accessToken
	    };
	  },
	  selectArchivedOrder: function selectArchivedOrder(orderId) {
	    return {
	      type: _constants.USER_SELECT_ARCHIVED_ORDER,
	      orderId: orderId
	    };
	  },
	  resetUserOrders: function resetUserOrders() {
	    return {
	      type: _constants.USER_RESET_ORDERS
	    };
	  }
	});

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(34);
	
	var _util = __webpack_require__(25);
	
	exports.default = _extends({}, (0, _util.createActionObject)('redeem', _constants.VOUCHER_REDEEM_START, _constants.VOUCHER_REDEEM_SUCCESS, _constants.VOUCHER_REDEEM_FAILURE), (0, _util.createActionObject)('getMine', _constants.VOUCHER_GET_MINE_START, _constants.VOUCHER_GET_MINE_SUCCESS, _constants.VOUCHER_GET_MINE_FAILURE), (0, _util.createActionObject)('create', _constants.VOUCHER_CREATE_START, _constants.VOUCHER_CREATE_SUCCESS, _constants.VOUCHER_CREATE_FAILURE), (0, _util.createActionObject)('update', _constants.VOUCHER_UPDATE_START, _constants.VOUCHER_UPDATE_SUCCESS, _constants.VOUCHER_UPDATE_FAILURE));

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _i18next = __webpack_require__(134);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	var _string = __webpack_require__(436);
	
	var _client = __webpack_require__(429);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (endpoint) {
	  var clientId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _client.UNKNOWN_CLIENT;
	  var deviceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	
	  var headers = {};
	  var sessionCid = (0, _string.randomUniqueHash)();
	  var deviceCid = deviceId ? deviceId.substr(0, 6) : '';
	
	  return {
	    setHeaders: function setHeaders(new_headers) {
	      headers = new_headers;
	    },
	    fetch: function (_fetch) {
	      function fetch(_x3) {
	        return _fetch.apply(this, arguments);
	      }
	
	      fetch.toString = function () {
	        return _fetch.toString();
	      };
	
	      return fetch;
	    }(function (query) {
	      var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var queryName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	      var additionalHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	
	      var requestCid = (0, _string.randomUniqueHash)();
	      var cid = '' + (deviceCid ? 'd:' + deviceCid + '-' : '') + ('s:' + sessionCid + '-') + ('r:' + requestCid);
	
	      var options = {
	        method: 'POST',
	        headers: _extends({
	          'Accept': 'application/json',
	          'Content-Type': 'application/json'
	        }, _i18next2.default.languages && _i18next2.default.languages[0] ? { 'Accept-Language': _i18next2.default.languages[0] } : {}, {
	          cid: cid
	        }, headers, additionalHeaders),
	        body: JSON.stringify({
	          query: query,
	          variables: variables
	        })
	      };
	
	      var graphqlEndpoint = endpoint + '/' + clientId + '/' + cid;
	      if (queryName) {
	        graphqlEndpoint += '/' + queryName;
	      }
	
	      var responseCid = void 0;
	      return fetch(graphqlEndpoint, options).then(function (res) {
	        responseCid = res.headers.get('cid');
	        return res.json();
	      })
	      // We are not going to send back to the caller the cid that was generated
	      // before making the request, but the one returned with the api response,
	      // just to ensure that it was correctly considered by the api.
	      .then(function (json) {
	        return _extends({}, json, { cid: responseCid });
	      });
	    })
	  };
	};

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UNKNOWN_CLIENT = exports.UNKNOWN_CLIENT = 'unknown_client';
	
	var DASHBOARD_WEB = exports.DASHBOARD_WEB = 'dashboard_web';
	
	var MOBILE_STORE = exports.MOBILE_STORE = 'mobile_store';
	
	var NATIVE_APP = exports.NATIVE_APP = 'native_app';
	
	var WIDGET = exports.WIDGET = 'widget';
	
	var PWA = exports.PWA = 'pwa';

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(34);
	
	var _messages = __webpack_require__(201);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var configureApi = _ref.configureApi,
	      loginSuccess = _ref.loginSuccess,
	      logoutSuccess = _ref.logoutSuccess,
	      tokenExpired = _ref.tokenExpired;
	
	
	  return function (_ref2) {
	    var dispatch = _ref2.dispatch,
	        getState = _ref2.getState;
	    return function (next) {
	      return function (action) {
	
	        var hasLoggedIn = action.type == _constants.USER_AUTHENTICATE_SUCCESS || action.type == _constants.USER_REGISTER_SUCCESS;
	
	        if (hasLoggedIn) {
	          var user = action.data;
	          configureApi(user.accessToken);
	          loginSuccess(user, dispatch);
	        }
	
	        if (action.type == _constants.USER_LOGOUT_SUCCESS) {
	          next(action);
	          configureApi(null);
	          logoutSuccess(dispatch);
	          return;
	        }
	
	        if (action.type == _constants.USER_UPDATE_ACCESSTOKEN) {
	          configureApi(action.accessToken);
	        }
	
	        var userLoad = action.type === _constants.USER_LOAD_SUCCESS || action.type === _constants.USER_LOAD_FAILURE;
	
	        if (userLoad && !action.data) {
	
	          var message = Array.isArray(action.errors) && action.errors[0] && action.errors[0].message;
	
	          var isNetworkError = message === _messages2.default.CONNECTIVITY_ERROR;
	
	          if (!isNetworkError) {
	            configureApi(null);
	            logoutSuccess(dispatch);
	
	            if (tokenExpired) tokenExpired(dispatch);
	          }
	        }
	
	        next(action);
	      };
	    };
	  };
	};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _util = __webpack_require__(25);
	
	var _constants = __webpack_require__(34);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initialState = {
	  isFetching: false,
	  currentUser: null,
	  errors: [],
	  isFetchingOrders: false,
	  archivedOrderId: null
	};
	
	var authenticateMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.USER_AUTHENTICATE_START, _constants.USER_AUTHENTICATE_FAILURE);
	
	var registerMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.USER_REGISTER_START, _constants.USER_REGISTER_FAILURE);
	
	var logoutMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.USER_LOGOUT_START, _constants.USER_LOGOUT_FAILURE);
	
	var loadMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.USER_LOAD_START, _constants.USER_LOAD_FAILURE);
	
	exports.default = (0, _util.createReducer)(initialState, _extends({}, authenticateMethods, registerMethods, logoutMethods, loadMethods, (_extends2 = {}, _defineProperty(_extends2, _constants.USER_AUTHENTICATE_SUCCESS, function (state, _ref) {
	  var data = _ref.data;
	
	  return _extends({}, state, {
	    currentUser: data,
	    isFetching: false
	  });
	}), _defineProperty(_extends2, _constants.USER_REGISTER_SUCCESS, function (state, _ref2) {
	  var data = _ref2.data;
	
	  return _extends({}, state, {
	    currentUser: data,
	    isFetching: false
	  });
	}), _defineProperty(_extends2, _constants.USER_LOGOUT_SUCCESS, function (state, action) {
	  return _extends({}, state, {
	    currentUser: null,
	    isFetching: false
	  });
	}), _defineProperty(_extends2, _constants.USER_UPDATE_ACCESSTOKEN, function (state, _ref3) {
	  var accessToken = _ref3.accessToken;
	
	  return _extends({}, state, {
	    currentUser: _extends({}, state.currentUser, {
	      accessToken: accessToken
	    })
	  });
	}), _defineProperty(_extends2, _constants.USER_LOAD_SUCCESS, function (state, _ref4) {
	  var data = _ref4.data;
	
	  return _extends({}, state, {
	    currentUser: data,
	    isFetching: false
	  });
	}), _defineProperty(_extends2, _constants.USER_LOAD_ORDERS_START, function (state) {
	  return _extends({}, state, {
	    isFetchingOrders: true
	  });
	}), _defineProperty(_extends2, _constants.USER_LOAD_ORDERS_SUCCESS, function (state, _ref5) {
	  var data = _ref5.data;
	
	  var currentUser = state.currentUser;
	  var newState = _extends({}, state, {
	    isFetching: false,
	    isFetchingOrders: false
	  });
	
	  if (data && data.orders) {
	    newState.currentUser = _extends({}, currentUser, {
	      orders: data.orders
	    });
	  }
	
	  return newState;
	}), _defineProperty(_extends2, _constants.USER_LOAD_ORDERS_FAILURE, function (state) {
	  return _extends({}, state, {
	    isFetchingOrders: false
	  });
	}), _defineProperty(_extends2, _constants.USER_RESET_ORDERS, function (state) {
	  return _extends({}, state, {
	    currentUser: _extends({}, state.currentUser, {
	      orders: []
	    }),
	    isFetchingOrders: false
	  });
	}), _defineProperty(_extends2, _constants.USER_LOAD_BOOKING_REQUESTS_START, function (state) {
	  return _extends({}, state, {
	    isFetchingBookingRequests: true
	  });
	}), _defineProperty(_extends2, _constants.USER_LOAD_BOOKING_REQUESTS_SUCCESS, function (state, _ref6) {
	  var data = _ref6.data;
	
	  var currentUser = state.currentUser;
	  var newState = _extends({}, state, {
	    isFetching: false,
	    isFetchingBookingRequests: false
	  });
	
	  if (data && data.bookingRequests) {
	    newState.currentUser = _extends({}, currentUser, {
	      bookingRequests: data.bookingRequests
	    });
	  }
	
	  return newState;
	}), _defineProperty(_extends2, _constants.USER_LOAD_BOOKING_REQUESTS_FAILURE, function (state) {
	  return _extends({}, state, {
	    isFetchingBookingRequests: false
	  });
	}), _defineProperty(_extends2, _constants.USER_SELECT_ARCHIVED_ORDER, function (state, action) {
	  return _extends({}, state, {
	    archivedOrderId: action.orderId
	  });
	}), _defineProperty(_extends2, _constants.USER_LOAD_CREDIT_CARDS_SUCCESS, function (state, _ref7) {
	  var data = _ref7.data;
	
	  var currentUser = state.currentUser;
	  var newState = _extends({}, state, {
	    isFetching: false
	  });
	
	  if (data && data.creditCards) {
	    newState.currentUser = _extends({}, currentUser, {
	      creditCards: data.creditCards
	    });
	  }
	
	  return newState;
	}), _defineProperty(_extends2, _constants.USER_DELETE_CREDIT_CARD_SUCCESS, function (state, _ref8) {
	  var data = _ref8.data;
	
	  var currentUser = state.currentUser;
	  var newState = _extends({}, state, {
	    isFetching: false,
	    currentUser: _extends({}, currentUser, {
	      creditCards: data
	    })
	  });
	  return newState;
	}), _defineProperty(_extends2, _constants.USER_ADD_TMP_NEW_CREDIT_CARD, function (state, _ref9) {
	  var data = _ref9.data;
	
	  var currentUser = state.currentUser;
	  var savedCreditCards = currentUser.creditCards;
	  var newState = _extends({}, state, {
	    isFetching: false,
	    currentUser: _extends({}, currentUser, {
	      creditCards: [].concat(_toConsumableArray(savedCreditCards), [data])
	    })
	  });
	  return newState;
	}), _extends2)));

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _util = __webpack_require__(25);
	
	var _constants = __webpack_require__(34);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  isFetching: false,
	  errors: [],
	  instances: null
	};
	
	var redeemMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.VOUCHER_REDEEM_START, _constants.VOUCHER_REDEEM_FAILURE);
	
	var getMineMethods = (0, _util.reducerMethodsFor)('isFetching', _constants.VOUCHER_GET_MINE_START, _constants.VOUCHER_GET_MINE_FAILURE);
	
	exports.default = (0, _util.createReducer)(initialState, _extends({}, redeemMethods, getMineMethods, (_extends2 = {}, _defineProperty(_extends2, _constants.VOUCHER_REDEEM_SUCCESS, function (state, action) {
	  return _extends({}, state, {
	    instances: _lodash2.default.filter(state.instances, { id: action.data }),
	    isFetching: false
	  });
	}), _defineProperty(_extends2, _constants.VOUCHER_GET_MINE_SUCCESS, function (state, _ref) {
	  var data = _ref.data;
	
	  return _extends({}, state, {
	    isFetching: false,
	    instances: data && data.vouchers || []
	  });
	}), _defineProperty(_extends2, _constants.USER_LOGOUT_SUCCESS, function (state, action) {
	  return initialState;
	}), _defineProperty(_extends2, _constants.SWITCH_BUNDLE_ID, function (state, action) {
	  return initialState;
	}), _extends2)));

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.curryApiToService = exports.setApiHeaders = exports.api = exports.setApi = exports.addService = exports.services = undefined;
	
	var _fp = __webpack_require__(141);
	
	var _fp2 = _interopRequireDefault(_fp);
	
	var _booking = __webpack_require__(202);
	
	var _booking2 = _interopRequireDefault(_booking);
	
	var _loyaltyCard = __webpack_require__(434);
	
	var _loyaltyCard2 = _interopRequireDefault(_loyaltyCard);
	
	var _user = __webpack_require__(203);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _voucher = __webpack_require__(204);
	
	var _voucher2 = _interopRequireDefault(_voucher);
	
	var _merchant = __webpack_require__(435);
	
	var _merchant2 = _interopRequireDefault(_merchant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var services = exports.services = {
	  Booking: _booking2.default,
	  LoyaltyCard: _loyaltyCard2.default,
	  User: _user2.default,
	  Voucher: _voucher2.default,
	  Merchant: _merchant2.default
	
	  // this updates whenever the user's access_token changes
	};var apiInstance;
	
	var requireService = function requireService(name) {
	  return curryApiToService(apiInstance, services[name]);
	};
	
	var addService = exports.addService = function addService(name, service) {
	  services[name] = service;
	};
	
	var setApi = exports.setApi = function setApi(instance) {
	  apiInstance = instance;
	};
	
	var api = exports.api = function api() {
	  return apiInstance;
	};
	
	var setApiHeaders = exports.setApiHeaders = function setApiHeaders(headers) {
	  apiInstance.setHeaders(headers);
	};
	
	var curryApiToService = exports.curryApiToService = function curryApiToService(api, service) {
	  return _fp2.default.mapValues(function (method) {
	    return _fp2.default.curry(method)(api);
	  }, service);
	};
	
	exports.default = requireService;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(25);
	
	exports.default = {
	  getCard: function getCard(api, cardId, loyaltyCardAction) {
	    var query = '\n      query {\n        me {\n          loyaltyCards(id:"' + cardId + '") {\n            id\n            voucher {\n              id\n              message\n              validityPeriod {\n                from\n                to\n              }\n              discount {\n                amount\n                format\n              }\n\n            }\n          }\n        }\n      }';
	
	    var queryName = 'me:getCard';
	    return (0, _util.wrapAction)(loyaltyCardAction, 'me', 'getCard', api.fetch(query, {}, queryName));
	  },
	  getActiveCard: function getActiveCard(api, data, loyaltyCardAction) {
	    var query = 'query {\n      me {\n        id\n        activeLoyaltyCard {\n          id\n          stampThreshold\n          totalStamps\n          instance {\n            id\n            stamps {\n              timestamp\n            }\n          }\n          voucher {\n            id\n            message\n            validityPeriod {\n              from\n              to\n            }\n            discount {\n              amount\n              format\n            }\n            instance {\n              id\n              redeemed\n              redemptionDate\n              invalidated\n            }\n          }\n        }\n      }\n    }';
	
	    var queryName = 'me:getActiveCard';
	    return (0, _util.wrapAction)(loyaltyCardAction, 'me', 'getActiveCard', api.fetch(query, {}, queryName));
	  }
	};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(25);
	
	exports.default = {
	  restaurantsRefresh: function restaurantsRefresh(api, appId, merchantAction) {
	    var query = 'query {\n      app(id: "' + appId + '") {\n        merchant{\n          restaurants{\n              id\n              name\n              services {\n                id\n                online\n                active\n                offset\n              }\n              location {\n                latitude\n                longitude\n              }\n              tagline\n              address\n              fullAddress {\n                route\n                street_number\n                postal_code\n                city\n                country\n              }\n              email\n              phone\n              zipCode\n              city\n              country\n              cuisine\n              highlights {\n                name\n                check\n              }\n              openingTimes {\n                day\n                open\n                slots {\n                  open\n                  close\n                }\n              }\n              openingTimesHumanReadable {\n                day\n                open\n                slots {\n                  open\n                  close\n                }\n              }\n              deliveryTimes {\n                day\n                open\n                slots {\n                  open\n                  close\n                }\n              }\n              takeAwayTimes {\n                day\n                open\n                slots {\n                  open\n                  close\n                }\n              }\n          }\n        }\n      }\n    }';
	
	    var queryName = 'loadBookingAvailability';
	    return (0, _util.wrapAction)(merchantAction, 'app[0].merchant.restaurants', 'restaurantsRefresh', api.fetch(query, {}, queryName));
	  }
	};

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var randomUniqueHash = exports.randomUniqueHash = function randomUniqueHash() {
	  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
	  return Math.random().toString(36).split('').filter(function (value, index, self) {
	    return self.indexOf(value) === index;
	  }).join('').substr(2, length);
	};

/***/ }),
/* 437 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	// This currentContext variable will only be used if the makeSlotClass
	// function is called, which happens only if this is the first copy of the
	// @wry/context package to be imported.
	var currentContext = null;
	// This unique internal object is used to denote the absence of a value
	// for a given Slot, and is never exposed to outside code.
	var MISSING_VALUE = {};
	var idCounter = 1;
	// Although we can't do anything about the cost of duplicated code from
	// accidentally bundling multiple copies of the @wry/context package, we can
	// avoid creating the Slot class more than once using makeSlotClass.
	var makeSlotClass = function () { return /** @class */ (function () {
	    function Slot() {
	        // If you have a Slot object, you can find out its slot.id, but you cannot
	        // guess the slot.id of a Slot you don't have access to, thanks to the
	        // randomized suffix.
	        this.id = [
	            "slot",
	            idCounter++,
	            Date.now(),
	            Math.random().toString(36).slice(2),
	        ].join(":");
	    }
	    Slot.prototype.hasValue = function () {
	        for (var context_1 = currentContext; context_1; context_1 = context_1.parent) {
	            // We use the Slot object iself as a key to its value, which means the
	            // value cannot be obtained without a reference to the Slot object.
	            if (this.id in context_1.slots) {
	                var value = context_1.slots[this.id];
	                if (value === MISSING_VALUE)
	                    break;
	                if (context_1 !== currentContext) {
	                    // Cache the value in currentContext.slots so the next lookup will
	                    // be faster. This caching is safe because the tree of contexts and
	                    // the values of the slots are logically immutable.
	                    currentContext.slots[this.id] = value;
	                }
	                return true;
	            }
	        }
	        if (currentContext) {
	            // If a value was not found for this Slot, it's never going to be found
	            // no matter how many times we look it up, so we might as well cache
	            // the absence of the value, too.
	            currentContext.slots[this.id] = MISSING_VALUE;
	        }
	        return false;
	    };
	    Slot.prototype.getValue = function () {
	        if (this.hasValue()) {
	            return currentContext.slots[this.id];
	        }
	    };
	    Slot.prototype.withValue = function (value, callback, 
	    // Given the prevalence of arrow functions, specifying arguments is likely
	    // to be much more common than specifying `this`, hence this ordering:
	    args, thisArg) {
	        var _a;
	        var slots = (_a = {
	                __proto__: null
	            },
	            _a[this.id] = value,
	            _a);
	        var parent = currentContext;
	        currentContext = { parent: parent, slots: slots };
	        try {
	            // Function.prototype.apply allows the arguments array argument to be
	            // omitted or undefined, so args! is fine here.
	            return callback.apply(thisArg, args);
	        }
	        finally {
	            currentContext = parent;
	        }
	    };
	    // Capture the current context and wrap a callback function so that it
	    // reestablishes the captured context when called.
	    Slot.bind = function (callback) {
	        var context = currentContext;
	        return function () {
	            var saved = currentContext;
	            try {
	                currentContext = context;
	                return callback.apply(this, arguments);
	            }
	            finally {
	                currentContext = saved;
	            }
	        };
	    };
	    // Immediately run a callback function without any captured context.
	    Slot.noContext = function (callback, 
	    // Given the prevalence of arrow functions, specifying arguments is likely
	    // to be much more common than specifying `this`, hence this ordering:
	    args, thisArg) {
	        if (currentContext) {
	            var saved = currentContext;
	            try {
	                currentContext = null;
	                // Function.prototype.apply allows the arguments array argument to be
	                // omitted or undefined, so args! is fine here.
	                return callback.apply(thisArg, args);
	            }
	            finally {
	                currentContext = saved;
	            }
	        }
	        else {
	            return callback.apply(thisArg, args);
	        }
	    };
	    return Slot;
	}()); };
	// We store a single global implementation of the Slot class as a permanent
	// non-enumerable symbol property of the Array constructor. This obfuscation
	// does nothing to prevent access to the Slot class, but at least it ensures
	// the implementation (i.e. currentContext) cannot be tampered with, and all
	// copies of the @wry/context package (hopefully just one) will share the
	// same Slot implementation. Since the first copy of the @wry/context package
	// to be imported wins, this technique imposes a very high cost for any
	// future breaking changes to the Slot class.
	var globalKey = "@wry/context:Slot";
	var host = Array;
	var Slot = host[globalKey] || function () {
	    var Slot = makeSlotClass();
	    try {
	        Object.defineProperty(host, globalKey, {
	            value: host[globalKey] = Slot,
	            enumerable: false,
	            writable: false,
	            configurable: false,
	        });
	    }
	    finally {
	        return Slot;
	    }
	}();
	
	var bind = Slot.bind, noContext = Slot.noContext;
	function setTimeoutWithContext(callback, delay) {
	    return setTimeout(bind(callback), delay);
	}
	// Turn any generator function into an async function (using yield instead
	// of await), with context automatically preserved across yields.
	function asyncFromGen(genFn) {
	    return function () {
	        var gen = genFn.apply(this, arguments);
	        var boundNext = bind(gen.next);
	        var boundThrow = bind(gen.throw);
	        return new Promise(function (resolve, reject) {
	            function invoke(method, argument) {
	                try {
	                    var result = method.call(gen, argument);
	                }
	                catch (error) {
	                    return reject(error);
	                }
	                var next = result.done ? resolve : invokeNext;
	                if (isPromiseLike(result.value)) {
	                    result.value.then(next, result.done ? reject : invokeThrow);
	                }
	                else {
	                    next(result.value);
	                }
	            }
	            var invokeNext = function (value) { return invoke(boundNext, value); };
	            var invokeThrow = function (error) { return invoke(boundThrow, error); };
	            invokeNext();
	        });
	    };
	}
	function isPromiseLike(value) {
	    return value && typeof value.then === "function";
	}
	// If you use the fibers npm package to implement coroutines in Node.js,
	// you should call this function at least once to ensure context management
	// remains coherent across any yields.
	var wrappedFibers = [];
	function wrapYieldingFiberMethods(Fiber) {
	    // There can be only one implementation of Fiber per process, so this array
	    // should never grow longer than one element.
	    if (wrappedFibers.indexOf(Fiber) < 0) {
	        var wrap = function (obj, method) {
	            var fn = obj[method];
	            obj[method] = function () {
	                return noContext(fn, arguments, this);
	            };
	        };
	        // These methods can yield, according to
	        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
	        wrap(Fiber, "yield");
	        wrap(Fiber.prototype, "run");
	        wrap(Fiber.prototype, "throwInto");
	        wrappedFibers.push(Fiber);
	    }
	    return Fiber;
	}
	
	exports.Slot = Slot;
	exports.asyncFromGen = asyncFromGen;
	exports.bind = bind;
	exports.noContext = noContext;
	exports.setTimeout = setTimeoutWithContext;
	exports.wrapYieldingFiberMethods = wrapYieldingFiberMethods;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.assertIdValue = assertIdValue;
	exports.defaultDataIdFromObject = defaultDataIdFromObject;
	exports.defaultNormalizedCacheFactory = defaultNormalizedCacheFactory$1;
	exports.enhanceErrorWithDocument = enhanceErrorWithDocument;
	exports.WriteError = exports.StoreWriter = exports.StoreReader = exports.ObjectCache = exports.IntrospectionFragmentMatcher = exports.InMemoryCache = exports.HeuristicFragmentMatcher = void 0;
	
	var _tslib = __webpack_require__(14);
	
	var _apolloCache = __webpack_require__(440);
	
	var _apolloUtilities = __webpack_require__(89);
	
	var _optimism = __webpack_require__(708);
	
	var _tsInvariant = __webpack_require__(31);
	
	var haveWarned = false;
	
	function shouldWarn() {
	  var answer = !haveWarned;
	
	  if (!(0, _apolloUtilities.isTest)()) {
	    haveWarned = true;
	  }
	
	  return answer;
	}
	
	var HeuristicFragmentMatcher = function () {
	  function HeuristicFragmentMatcher() {}
	
	  HeuristicFragmentMatcher.prototype.ensureReady = function () {
	    return Promise.resolve();
	  };
	
	  HeuristicFragmentMatcher.prototype.canBypassInit = function () {
	    return true;
	  };
	
	  HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
	    var obj = context.store.get(idValue.id);
	    var isRootQuery = idValue.id === 'ROOT_QUERY';
	
	    if (!obj) {
	      return isRootQuery;
	    }
	
	    var _a = obj.__typename,
	        __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
	
	    if (!__typename) {
	      if (shouldWarn()) {
	        ("production") === "production" || _tsInvariant.invariant.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
	        ("production") === "production" || _tsInvariant.invariant.warn('Could not find __typename on Fragment ', typeCondition, obj);
	        ("production") === "production" || _tsInvariant.invariant.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior " + "and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
	      }
	
	      return 'heuristic';
	    }
	
	    if (__typename === typeCondition) {
	      return true;
	    }
	
	    if (shouldWarn()) {
	      ("production") === "production" || _tsInvariant.invariant.error('You are using the simple (heuristic) fragment matcher, but your ' + 'queries contain union or interface types. Apollo Client will not be ' + 'able to accurately map fragments. To make this error go away, use ' + 'the `IntrospectionFragmentMatcher` as described in the docs: ' + 'https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher');
	    }
	
	    return 'heuristic';
	  };
	
	  return HeuristicFragmentMatcher;
	}();
	
	exports.HeuristicFragmentMatcher = HeuristicFragmentMatcher;
	
	var IntrospectionFragmentMatcher = function () {
	  function IntrospectionFragmentMatcher(options) {
	    if (options && options.introspectionQueryResultData) {
	      this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
	      this.isReady = true;
	    } else {
	      this.isReady = false;
	    }
	
	    this.match = this.match.bind(this);
	  }
	
	  IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
	     true ? (0, _tsInvariant.invariant)(this.isReady, 1) : (0, _tsInvariant.invariant)(this.isReady, 'FragmentMatcher.match() was called before FragmentMatcher.init()');
	    var obj = context.store.get(idValue.id);
	    var isRootQuery = idValue.id === 'ROOT_QUERY';
	
	    if (!obj) {
	      return isRootQuery;
	    }
	
	    var _a = obj.__typename,
	        __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
	
	     true ? (0, _tsInvariant.invariant)(__typename, 2) : (0, _tsInvariant.invariant)(__typename, "Cannot match fragment because __typename property is missing: " + JSON.stringify(obj));
	
	    if (__typename === typeCondition) {
	      return true;
	    }
	
	    var implementingTypes = this.possibleTypesMap[typeCondition];
	
	    if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) {
	      return true;
	    }
	
	    return false;
	  };
	
	  IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
	    var typeMap = {};
	
	    introspectionResultData.__schema.types.forEach(function (type) {
	      if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
	        typeMap[type.name] = type.possibleTypes.map(function (implementingType) {
	          return implementingType.name;
	        });
	      }
	    });
	
	    return typeMap;
	  };
	
	  return IntrospectionFragmentMatcher;
	}();
	
	exports.IntrospectionFragmentMatcher = IntrospectionFragmentMatcher;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	var DepTrackingCache = function () {
	  function DepTrackingCache(data) {
	    var _this = this;
	
	    if (data === void 0) {
	      data = Object.create(null);
	    }
	
	    this.data = data;
	    this.depend = (0, _optimism.wrap)(function (dataId) {
	      return _this.data[dataId];
	    }, {
	      disposable: true,
	      makeCacheKey: function (dataId) {
	        return dataId;
	      }
	    });
	  }
	
	  DepTrackingCache.prototype.toObject = function () {
	    return this.data;
	  };
	
	  DepTrackingCache.prototype.get = function (dataId) {
	    this.depend(dataId);
	    return this.data[dataId];
	  };
	
	  DepTrackingCache.prototype.set = function (dataId, value) {
	    var oldValue = this.data[dataId];
	
	    if (value !== oldValue) {
	      this.data[dataId] = value;
	      this.depend.dirty(dataId);
	    }
	  };
	
	  DepTrackingCache.prototype.delete = function (dataId) {
	    if (hasOwn.call(this.data, dataId)) {
	      delete this.data[dataId];
	      this.depend.dirty(dataId);
	    }
	  };
	
	  DepTrackingCache.prototype.clear = function () {
	    this.replace(null);
	  };
	
	  DepTrackingCache.prototype.replace = function (newData) {
	    var _this = this;
	
	    if (newData) {
	      Object.keys(newData).forEach(function (dataId) {
	        _this.set(dataId, newData[dataId]);
	      });
	      Object.keys(this.data).forEach(function (dataId) {
	        if (!hasOwn.call(newData, dataId)) {
	          _this.delete(dataId);
	        }
	      });
	    } else {
	      Object.keys(this.data).forEach(function (dataId) {
	        _this.delete(dataId);
	      });
	    }
	  };
	
	  return DepTrackingCache;
	}();
	
	function defaultNormalizedCacheFactory(seed) {
	  return new DepTrackingCache(seed);
	}
	
	var StoreReader = function () {
	  function StoreReader(_a) {
	    var _this = this;
	
	    var _b = _a === void 0 ? {} : _a,
	        _c = _b.cacheKeyRoot,
	        cacheKeyRoot = _c === void 0 ? new _optimism.KeyTrie(_apolloUtilities.canUseWeakMap) : _c,
	        _d = _b.freezeResults,
	        freezeResults = _d === void 0 ? false : _d;
	
	    var _e = this,
	        executeStoreQuery = _e.executeStoreQuery,
	        executeSelectionSet = _e.executeSelectionSet,
	        executeSubSelectedArray = _e.executeSubSelectedArray;
	
	    this.freezeResults = freezeResults;
	    this.executeStoreQuery = (0, _optimism.wrap)(function (options) {
	      return executeStoreQuery.call(_this, options);
	    }, {
	      makeCacheKey: function (_a) {
	        var query = _a.query,
	            rootValue = _a.rootValue,
	            contextValue = _a.contextValue,
	            variableValues = _a.variableValues,
	            fragmentMatcher = _a.fragmentMatcher;
	
	        if (contextValue.store instanceof DepTrackingCache) {
	          return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
	        }
	      }
	    });
	    this.executeSelectionSet = (0, _optimism.wrap)(function (options) {
	      return executeSelectionSet.call(_this, options);
	    }, {
	      makeCacheKey: function (_a) {
	        var selectionSet = _a.selectionSet,
	            rootValue = _a.rootValue,
	            execContext = _a.execContext;
	
	        if (execContext.contextValue.store instanceof DepTrackingCache) {
	          return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
	        }
	      }
	    });
	    this.executeSubSelectedArray = (0, _optimism.wrap)(function (options) {
	      return executeSubSelectedArray.call(_this, options);
	    }, {
	      makeCacheKey: function (_a) {
	        var field = _a.field,
	            array = _a.array,
	            execContext = _a.execContext;
	
	        if (execContext.contextValue.store instanceof DepTrackingCache) {
	          return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
	        }
	      }
	    });
	  }
	
	  StoreReader.prototype.readQueryFromStore = function (options) {
	    return this.diffQueryAgainstStore((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
	      returnPartialData: false
	    })).result;
	  };
	
	  StoreReader.prototype.diffQueryAgainstStore = function (_a) {
	    var store = _a.store,
	        query = _a.query,
	        variables = _a.variables,
	        previousResult = _a.previousResult,
	        _b = _a.returnPartialData,
	        returnPartialData = _b === void 0 ? true : _b,
	        _c = _a.rootId,
	        rootId = _c === void 0 ? 'ROOT_QUERY' : _c,
	        fragmentMatcherFunction = _a.fragmentMatcherFunction,
	        config = _a.config;
	    var queryDefinition = (0, _apolloUtilities.getQueryDefinition)(query);
	    variables = (0, _apolloUtilities.assign)({}, (0, _apolloUtilities.getDefaultValues)(queryDefinition), variables);
	    var context = {
	      store: store,
	      dataIdFromObject: config && config.dataIdFromObject,
	      cacheRedirects: config && config.cacheRedirects || {}
	    };
	    var execResult = this.executeStoreQuery({
	      query: query,
	      rootValue: {
	        type: 'id',
	        id: rootId,
	        generated: true,
	        typename: 'Query'
	      },
	      contextValue: context,
	      variableValues: variables,
	      fragmentMatcher: fragmentMatcherFunction
	    });
	    var hasMissingFields = execResult.missing && execResult.missing.length > 0;
	
	    if (hasMissingFields && !returnPartialData) {
	      execResult.missing.forEach(function (info) {
	        if (info.tolerable) return;
	        throw  true ? new _tsInvariant.InvariantError(8) : new _tsInvariant.InvariantError("Can't find field " + info.fieldName + " on object " + JSON.stringify(info.object, null, 2) + ".");
	      });
	    }
	
	    if (previousResult) {
	      if ((0, _apolloUtilities.isEqual)(previousResult, execResult.result)) {
	        execResult.result = previousResult;
	      }
	    }
	
	    return {
	      result: execResult.result,
	      complete: !hasMissingFields
	    };
	  };
	
	  StoreReader.prototype.executeStoreQuery = function (_a) {
	    var query = _a.query,
	        rootValue = _a.rootValue,
	        contextValue = _a.contextValue,
	        variableValues = _a.variableValues,
	        _b = _a.fragmentMatcher,
	        fragmentMatcher = _b === void 0 ? defaultFragmentMatcher : _b;
	    var mainDefinition = (0, _apolloUtilities.getMainDefinition)(query);
	    var fragments = (0, _apolloUtilities.getFragmentDefinitions)(query);
	    var fragmentMap = (0, _apolloUtilities.createFragmentMap)(fragments);
	    var execContext = {
	      query: query,
	      fragmentMap: fragmentMap,
	      contextValue: contextValue,
	      variableValues: variableValues,
	      fragmentMatcher: fragmentMatcher
	    };
	    return this.executeSelectionSet({
	      selectionSet: mainDefinition.selectionSet,
	      rootValue: rootValue,
	      execContext: execContext
	    });
	  };
	
	  StoreReader.prototype.executeSelectionSet = function (_a) {
	    var _this = this;
	
	    var selectionSet = _a.selectionSet,
	        rootValue = _a.rootValue,
	        execContext = _a.execContext;
	    var fragmentMap = execContext.fragmentMap,
	        contextValue = execContext.contextValue,
	        variables = execContext.variableValues;
	    var finalResult = {
	      result: null
	    };
	    var objectsToMerge = [];
	    var object = contextValue.store.get(rootValue.id);
	    var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
	
	    function handleMissing(result) {
	      var _a;
	
	      if (result.missing) {
	        finalResult.missing = finalResult.missing || [];
	
	        (_a = finalResult.missing).push.apply(_a, result.missing);
	      }
	
	      return result.result;
	    }
	
	    selectionSet.selections.forEach(function (selection) {
	      var _a;
	
	      if (!(0, _apolloUtilities.shouldInclude)(selection, variables)) {
	        return;
	      }
	
	      if ((0, _apolloUtilities.isField)(selection)) {
	        var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
	
	        if (typeof fieldResult !== 'undefined') {
	          objectsToMerge.push((_a = {}, _a[(0, _apolloUtilities.resultKeyNameFromField)(selection)] = fieldResult, _a));
	        }
	      } else {
	        var fragment = void 0;
	
	        if ((0, _apolloUtilities.isInlineFragment)(selection)) {
	          fragment = selection;
	        } else {
	          fragment = fragmentMap[selection.name.value];
	
	          if (!fragment) {
	            throw  true ? new _tsInvariant.InvariantError(9) : new _tsInvariant.InvariantError("No fragment named " + selection.name.value);
	          }
	        }
	
	        var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
	        var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
	
	        if (match) {
	          var fragmentExecResult = _this.executeSelectionSet({
	            selectionSet: fragment.selectionSet,
	            rootValue: rootValue,
	            execContext: execContext
	          });
	
	          if (match === 'heuristic' && fragmentExecResult.missing) {
	            fragmentExecResult = (0, _tslib.__assign)((0, _tslib.__assign)({}, fragmentExecResult), {
	              missing: fragmentExecResult.missing.map(function (info) {
	                return (0, _tslib.__assign)((0, _tslib.__assign)({}, info), {
	                  tolerable: true
	                });
	              })
	            });
	          }
	
	          objectsToMerge.push(handleMissing(fragmentExecResult));
	        }
	      }
	    });
	    finalResult.result = (0, _apolloUtilities.mergeDeepArray)(objectsToMerge);
	
	    if (this.freezeResults && ("production") !== 'production') {
	      Object.freeze(finalResult.result);
	    }
	
	    return finalResult;
	  };
	
	  StoreReader.prototype.executeField = function (object, typename, field, execContext) {
	    var variables = execContext.variableValues,
	        contextValue = execContext.contextValue;
	    var fieldName = field.name.value;
	    var args = (0, _apolloUtilities.argumentsObjectFromField)(field, variables);
	    var info = {
	      resultKey: (0, _apolloUtilities.resultKeyNameFromField)(field),
	      directives: (0, _apolloUtilities.getDirectiveInfoFromField)(field, variables)
	    };
	    var readStoreResult = readStoreResolver(object, typename, fieldName, args, contextValue, info);
	
	    if (Array.isArray(readStoreResult.result)) {
	      return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
	        field: field,
	        array: readStoreResult.result,
	        execContext: execContext
	      }));
	    }
	
	    if (!field.selectionSet) {
	      assertSelectionSetForIdValue(field, readStoreResult.result);
	
	      if (this.freezeResults && ("production") !== 'production') {
	        (0, _apolloUtilities.maybeDeepFreeze)(readStoreResult);
	      }
	
	      return readStoreResult;
	    }
	
	    if (readStoreResult.result == null) {
	      return readStoreResult;
	    }
	
	    return this.combineExecResults(readStoreResult, this.executeSelectionSet({
	      selectionSet: field.selectionSet,
	      rootValue: readStoreResult.result,
	      execContext: execContext
	    }));
	  };
	
	  StoreReader.prototype.combineExecResults = function () {
	    var execResults = [];
	
	    for (var _i = 0; _i < arguments.length; _i++) {
	      execResults[_i] = arguments[_i];
	    }
	
	    var missing;
	    execResults.forEach(function (execResult) {
	      if (execResult.missing) {
	        missing = missing || [];
	        missing.push.apply(missing, execResult.missing);
	      }
	    });
	    return {
	      result: execResults.pop().result,
	      missing: missing
	    };
	  };
	
	  StoreReader.prototype.executeSubSelectedArray = function (_a) {
	    var _this = this;
	
	    var field = _a.field,
	        array = _a.array,
	        execContext = _a.execContext;
	    var missing;
	
	    function handleMissing(childResult) {
	      if (childResult.missing) {
	        missing = missing || [];
	        missing.push.apply(missing, childResult.missing);
	      }
	
	      return childResult.result;
	    }
	
	    array = array.map(function (item) {
	      if (item === null) {
	        return null;
	      }
	
	      if (Array.isArray(item)) {
	        return handleMissing(_this.executeSubSelectedArray({
	          field: field,
	          array: item,
	          execContext: execContext
	        }));
	      }
	
	      if (field.selectionSet) {
	        return handleMissing(_this.executeSelectionSet({
	          selectionSet: field.selectionSet,
	          rootValue: item,
	          execContext: execContext
	        }));
	      }
	
	      assertSelectionSetForIdValue(field, item);
	      return item;
	    });
	
	    if (this.freezeResults && ("production") !== 'production') {
	      Object.freeze(array);
	    }
	
	    return {
	      result: array,
	      missing: missing
	    };
	  };
	
	  return StoreReader;
	}();
	
	exports.StoreReader = StoreReader;
	
	function assertSelectionSetForIdValue(field, value) {
	  if (!field.selectionSet && (0, _apolloUtilities.isIdValue)(value)) {
	    throw  true ? new _tsInvariant.InvariantError(10) : new _tsInvariant.InvariantError("Missing selection set for object of type " + value.typename + " returned for query field " + field.name.value);
	  }
	}
	
	function defaultFragmentMatcher() {
	  return true;
	}
	
	function assertIdValue(idValue) {
	   true ? (0, _tsInvariant.invariant)((0, _apolloUtilities.isIdValue)(idValue), 11) : (0, _tsInvariant.invariant)((0, _apolloUtilities.isIdValue)(idValue), "Encountered a sub-selection on the query, but the store doesn't have an object reference. This should never happen during normal use unless you have custom code that is directly manipulating the store; please file an issue.");
	}
	
	function readStoreResolver(object, typename, fieldName, args, context, _a) {
	  var resultKey = _a.resultKey,
	      directives = _a.directives;
	  var storeKeyName = fieldName;
	
	  if (args || directives) {
	    storeKeyName = (0, _apolloUtilities.getStoreKeyName)(storeKeyName, args, directives);
	  }
	
	  var fieldValue = void 0;
	
	  if (object) {
	    fieldValue = object[storeKeyName];
	
	    if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
	      var type = context.cacheRedirects[typename];
	
	      if (type) {
	        var resolver = type[fieldName];
	
	        if (resolver) {
	          fieldValue = resolver(object, args, {
	            getCacheKey: function (storeObj) {
	              var id = context.dataIdFromObject(storeObj);
	              return id && (0, _apolloUtilities.toIdValue)({
	                id: id,
	                typename: storeObj.__typename
	              });
	            }
	          });
	        }
	      }
	    }
	  }
	
	  if (typeof fieldValue === 'undefined') {
	    return {
	      result: fieldValue,
	      missing: [{
	        object: object,
	        fieldName: storeKeyName,
	        tolerable: false
	      }]
	    };
	  }
	
	  if ((0, _apolloUtilities.isJsonValue)(fieldValue)) {
	    fieldValue = fieldValue.json;
	  }
	
	  return {
	    result: fieldValue
	  };
	}
	
	var ObjectCache = function () {
	  function ObjectCache(data) {
	    if (data === void 0) {
	      data = Object.create(null);
	    }
	
	    this.data = data;
	  }
	
	  ObjectCache.prototype.toObject = function () {
	    return this.data;
	  };
	
	  ObjectCache.prototype.get = function (dataId) {
	    return this.data[dataId];
	  };
	
	  ObjectCache.prototype.set = function (dataId, value) {
	    this.data[dataId] = value;
	  };
	
	  ObjectCache.prototype.delete = function (dataId) {
	    this.data[dataId] = void 0;
	  };
	
	  ObjectCache.prototype.clear = function () {
	    this.data = Object.create(null);
	  };
	
	  ObjectCache.prototype.replace = function (newData) {
	    this.data = newData || Object.create(null);
	  };
	
	  return ObjectCache;
	}();
	
	exports.ObjectCache = ObjectCache;
	
	function defaultNormalizedCacheFactory$1(seed) {
	  return new ObjectCache(seed);
	}
	
	var WriteError = function (_super) {
	  (0, _tslib.__extends)(WriteError, _super);
	
	  function WriteError() {
	    var _this = _super !== null && _super.apply(this, arguments) || this;
	
	    _this.type = 'WriteError';
	    return _this;
	  }
	
	  return WriteError;
	}(Error);
	
	exports.WriteError = WriteError;
	
	function enhanceErrorWithDocument(error, document) {
	  var enhancedError = new WriteError("Error writing result to store for query:\n " + JSON.stringify(document));
	  enhancedError.message += '\n' + error.message;
	  enhancedError.stack = error.stack;
	  return enhancedError;
	}
	
	var StoreWriter = function () {
	  function StoreWriter() {}
	
	  StoreWriter.prototype.writeQueryToStore = function (_a) {
	    var query = _a.query,
	        result = _a.result,
	        _b = _a.store,
	        store = _b === void 0 ? defaultNormalizedCacheFactory() : _b,
	        variables = _a.variables,
	        dataIdFromObject = _a.dataIdFromObject,
	        fragmentMatcherFunction = _a.fragmentMatcherFunction;
	    return this.writeResultToStore({
	      dataId: 'ROOT_QUERY',
	      result: result,
	      document: query,
	      store: store,
	      variables: variables,
	      dataIdFromObject: dataIdFromObject,
	      fragmentMatcherFunction: fragmentMatcherFunction
	    });
	  };
	
	  StoreWriter.prototype.writeResultToStore = function (_a) {
	    var dataId = _a.dataId,
	        result = _a.result,
	        document = _a.document,
	        _b = _a.store,
	        store = _b === void 0 ? defaultNormalizedCacheFactory() : _b,
	        variables = _a.variables,
	        dataIdFromObject = _a.dataIdFromObject,
	        fragmentMatcherFunction = _a.fragmentMatcherFunction;
	    var operationDefinition = (0, _apolloUtilities.getOperationDefinition)(document);
	
	    try {
	      return this.writeSelectionSetToStore({
	        result: result,
	        dataId: dataId,
	        selectionSet: operationDefinition.selectionSet,
	        context: {
	          store: store,
	          processedData: {},
	          variables: (0, _apolloUtilities.assign)({}, (0, _apolloUtilities.getDefaultValues)(operationDefinition), variables),
	          dataIdFromObject: dataIdFromObject,
	          fragmentMap: (0, _apolloUtilities.createFragmentMap)((0, _apolloUtilities.getFragmentDefinitions)(document)),
	          fragmentMatcherFunction: fragmentMatcherFunction
	        }
	      });
	    } catch (e) {
	      throw enhanceErrorWithDocument(e, document);
	    }
	  };
	
	  StoreWriter.prototype.writeSelectionSetToStore = function (_a) {
	    var _this = this;
	
	    var result = _a.result,
	        dataId = _a.dataId,
	        selectionSet = _a.selectionSet,
	        context = _a.context;
	    var variables = context.variables,
	        store = context.store,
	        fragmentMap = context.fragmentMap;
	    selectionSet.selections.forEach(function (selection) {
	      var _a;
	
	      if (!(0, _apolloUtilities.shouldInclude)(selection, variables)) {
	        return;
	      }
	
	      if ((0, _apolloUtilities.isField)(selection)) {
	        var resultFieldKey = (0, _apolloUtilities.resultKeyNameFromField)(selection);
	        var value = result[resultFieldKey];
	
	        if (typeof value !== 'undefined') {
	          _this.writeFieldToStore({
	            dataId: dataId,
	            value: value,
	            field: selection,
	            context: context
	          });
	        } else {
	          var isDefered = false;
	          var isClient = false;
	
	          if (selection.directives && selection.directives.length) {
	            isDefered = selection.directives.some(function (directive) {
	              return directive.name && directive.name.value === 'defer';
	            });
	            isClient = selection.directives.some(function (directive) {
	              return directive.name && directive.name.value === 'client';
	            });
	          }
	
	          if (!isDefered && !isClient && context.fragmentMatcherFunction) {
	            ("production") === "production" || _tsInvariant.invariant.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
	          }
	        }
	      } else {
	        var fragment = void 0;
	
	        if ((0, _apolloUtilities.isInlineFragment)(selection)) {
	          fragment = selection;
	        } else {
	          fragment = (fragmentMap || {})[selection.name.value];
	           true ? (0, _tsInvariant.invariant)(fragment, 3) : (0, _tsInvariant.invariant)(fragment, "No fragment named " + selection.name.value + ".");
	        }
	
	        var matches = true;
	
	        if (context.fragmentMatcherFunction && fragment.typeCondition) {
	          var id = dataId || 'self';
	          var idValue = (0, _apolloUtilities.toIdValue)({
	            id: id,
	            typename: undefined
	          });
	          var fakeContext = {
	            store: new ObjectCache((_a = {}, _a[id] = result, _a)),
	            cacheRedirects: {}
	          };
	          var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
	
	          if (!(0, _apolloUtilities.isProduction)() && match === 'heuristic') {
	            ("production") === "production" || _tsInvariant.invariant.error('WARNING: heuristic fragment matching going on!');
	          }
	
	          matches = !!match;
	        }
	
	        if (matches) {
	          _this.writeSelectionSetToStore({
	            result: result,
	            selectionSet: fragment.selectionSet,
	            dataId: dataId,
	            context: context
	          });
	        }
	      }
	    });
	    return store;
	  };
	
	  StoreWriter.prototype.writeFieldToStore = function (_a) {
	    var _b;
	
	    var field = _a.field,
	        value = _a.value,
	        dataId = _a.dataId,
	        context = _a.context;
	    var variables = context.variables,
	        dataIdFromObject = context.dataIdFromObject,
	        store = context.store;
	    var storeValue;
	    var storeObject;
	    var storeFieldName = (0, _apolloUtilities.storeKeyNameFromField)(field, variables);
	
	    if (!field.selectionSet || value === null) {
	      storeValue = value != null && typeof value === 'object' ? {
	        type: 'json',
	        json: value
	      } : value;
	    } else if (Array.isArray(value)) {
	      var generatedId = dataId + "." + storeFieldName;
	      storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
	    } else {
	      var valueDataId = dataId + "." + storeFieldName;
	      var generated = true;
	
	      if (!isGeneratedId(valueDataId)) {
	        valueDataId = '$' + valueDataId;
	      }
	
	      if (dataIdFromObject) {
	        var semanticId = dataIdFromObject(value);
	         true ? (0, _tsInvariant.invariant)(!semanticId || !isGeneratedId(semanticId), 4) : (0, _tsInvariant.invariant)(!semanticId || !isGeneratedId(semanticId), 'IDs returned by dataIdFromObject cannot begin with the "$" character.');
	
	        if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
	          valueDataId = semanticId;
	          generated = false;
	        }
	      }
	
	      if (!isDataProcessed(valueDataId, field, context.processedData)) {
	        this.writeSelectionSetToStore({
	          dataId: valueDataId,
	          result: value,
	          selectionSet: field.selectionSet,
	          context: context
	        });
	      }
	
	      var typename = value.__typename;
	      storeValue = (0, _apolloUtilities.toIdValue)({
	        id: valueDataId,
	        typename: typename
	      }, generated);
	      storeObject = store.get(dataId);
	      var escapedId = storeObject && storeObject[storeFieldName];
	
	      if (escapedId !== storeValue && (0, _apolloUtilities.isIdValue)(escapedId)) {
	        var hadTypename = escapedId.typename !== undefined;
	        var hasTypename = typename !== undefined;
	        var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
	         true ? (0, _tsInvariant.invariant)(!generated || escapedId.generated || typenameChanged, 5) : (0, _tsInvariant.invariant)(!generated || escapedId.generated || typenameChanged, "Store error: the application attempted to write an object with no provided id but the store already contains an id of " + escapedId.id + " for this object. The selectionSet that was trying to be written is:\n" + JSON.stringify(field));
	         true ? (0, _tsInvariant.invariant)(!hadTypename || hasTypename, 6) : (0, _tsInvariant.invariant)(!hadTypename || hasTypename, "Store error: the application attempted to write an object with no provided typename but the store already contains an object with typename of " + escapedId.typename + " for the object of id " + escapedId.id + ". The selectionSet that was trying to be written is:\n" + JSON.stringify(field));
	
	        if (escapedId.generated) {
	          if (typenameChanged) {
	            if (!generated) {
	              store.delete(escapedId.id);
	            }
	          } else {
	            mergeWithGenerated(escapedId.id, storeValue.id, store);
	          }
	        }
	      }
	    }
	
	    storeObject = store.get(dataId);
	
	    if (!storeObject || !(0, _apolloUtilities.isEqual)(storeValue, storeObject[storeFieldName])) {
	      store.set(dataId, (0, _tslib.__assign)((0, _tslib.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
	    }
	  };
	
	  StoreWriter.prototype.processArrayValue = function (value, generatedId, selectionSet, context) {
	    var _this = this;
	
	    return value.map(function (item, index) {
	      if (item === null) {
	        return null;
	      }
	
	      var itemDataId = generatedId + "." + index;
	
	      if (Array.isArray(item)) {
	        return _this.processArrayValue(item, itemDataId, selectionSet, context);
	      }
	
	      var generated = true;
	
	      if (context.dataIdFromObject) {
	        var semanticId = context.dataIdFromObject(item);
	
	        if (semanticId) {
	          itemDataId = semanticId;
	          generated = false;
	        }
	      }
	
	      if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
	        _this.writeSelectionSetToStore({
	          dataId: itemDataId,
	          result: item,
	          selectionSet: selectionSet,
	          context: context
	        });
	      }
	
	      return (0, _apolloUtilities.toIdValue)({
	        id: itemDataId,
	        typename: item.__typename
	      }, generated);
	    });
	  };
	
	  return StoreWriter;
	}();
	
	exports.StoreWriter = StoreWriter;
	
	function isGeneratedId(id) {
	  return id[0] === '$';
	}
	
	function mergeWithGenerated(generatedKey, realKey, cache) {
	  if (generatedKey === realKey) {
	    return false;
	  }
	
	  var generated = cache.get(generatedKey);
	  var real = cache.get(realKey);
	  var madeChanges = false;
	  Object.keys(generated).forEach(function (key) {
	    var value = generated[key];
	    var realValue = real[key];
	
	    if ((0, _apolloUtilities.isIdValue)(value) && isGeneratedId(value.id) && (0, _apolloUtilities.isIdValue)(realValue) && !(0, _apolloUtilities.isEqual)(value, realValue) && mergeWithGenerated(value.id, realValue.id, cache)) {
	      madeChanges = true;
	    }
	  });
	  cache.delete(generatedKey);
	  var newRealValue = (0, _tslib.__assign)((0, _tslib.__assign)({}, generated), real);
	
	  if ((0, _apolloUtilities.isEqual)(newRealValue, real)) {
	    return madeChanges;
	  }
	
	  cache.set(realKey, newRealValue);
	  return true;
	}
	
	function isDataProcessed(dataId, field, processedData) {
	  if (!processedData) {
	    return false;
	  }
	
	  if (processedData[dataId]) {
	    if (processedData[dataId].indexOf(field) >= 0) {
	      return true;
	    } else {
	      processedData[dataId].push(field);
	    }
	  } else {
	    processedData[dataId] = [field];
	  }
	
	  return false;
	}
	
	var defaultConfig = {
	  fragmentMatcher: new HeuristicFragmentMatcher(),
	  dataIdFromObject: defaultDataIdFromObject,
	  addTypename: true,
	  resultCaching: true,
	  freezeResults: false
	};
	
	function defaultDataIdFromObject(result) {
	  if (result.__typename) {
	    if (result.id !== undefined) {
	      return result.__typename + ":" + result.id;
	    }
	
	    if (result._id !== undefined) {
	      return result.__typename + ":" + result._id;
	    }
	  }
	
	  return null;
	}
	
	var hasOwn$1 = Object.prototype.hasOwnProperty;
	
	var OptimisticCacheLayer = function (_super) {
	  (0, _tslib.__extends)(OptimisticCacheLayer, _super);
	
	  function OptimisticCacheLayer(optimisticId, parent, transaction) {
	    var _this = _super.call(this, Object.create(null)) || this;
	
	    _this.optimisticId = optimisticId;
	    _this.parent = parent;
	    _this.transaction = transaction;
	    return _this;
	  }
	
	  OptimisticCacheLayer.prototype.toObject = function () {
	    return (0, _tslib.__assign)((0, _tslib.__assign)({}, this.parent.toObject()), this.data);
	  };
	
	  OptimisticCacheLayer.prototype.get = function (dataId) {
	    return hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
	  };
	
	  return OptimisticCacheLayer;
	}(ObjectCache);
	
	var InMemoryCache = function (_super) {
	  (0, _tslib.__extends)(InMemoryCache, _super);
	
	  function InMemoryCache(config) {
	    if (config === void 0) {
	      config = {};
	    }
	
	    var _this = _super.call(this) || this;
	
	    _this.watches = new Set();
	    _this.typenameDocumentCache = new Map();
	    _this.cacheKeyRoot = new _optimism.KeyTrie(_apolloUtilities.canUseWeakMap);
	    _this.silenceBroadcast = false;
	    _this.config = (0, _tslib.__assign)((0, _tslib.__assign)({}, defaultConfig), config);
	
	    if (_this.config.customResolvers) {
	      ("production") === "production" || _tsInvariant.invariant.warn('customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.');
	      _this.config.cacheRedirects = _this.config.customResolvers;
	    }
	
	    if (_this.config.cacheResolvers) {
	      ("production") === "production" || _tsInvariant.invariant.warn('cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.');
	      _this.config.cacheRedirects = _this.config.cacheResolvers;
	    }
	
	    _this.addTypename = !!_this.config.addTypename;
	    _this.data = _this.config.resultCaching ? new DepTrackingCache() : new ObjectCache();
	    _this.optimisticData = _this.data;
	    _this.storeWriter = new StoreWriter();
	    _this.storeReader = new StoreReader({
	      cacheKeyRoot: _this.cacheKeyRoot,
	      freezeResults: config.freezeResults
	    });
	    var cache = _this;
	    var maybeBroadcastWatch = cache.maybeBroadcastWatch;
	    _this.maybeBroadcastWatch = (0, _optimism.wrap)(function (c) {
	      return maybeBroadcastWatch.call(_this, c);
	    }, {
	      makeCacheKey: function (c) {
	        if (c.optimistic) {
	          return;
	        }
	
	        if (c.previousResult) {
	          return;
	        }
	
	        if (cache.data instanceof DepTrackingCache) {
	          return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
	        }
	      }
	    });
	    return _this;
	  }
	
	  InMemoryCache.prototype.restore = function (data) {
	    if (data) this.data.replace(data);
	    return this;
	  };
	
	  InMemoryCache.prototype.extract = function (optimistic) {
	    if (optimistic === void 0) {
	      optimistic = false;
	    }
	
	    return (optimistic ? this.optimisticData : this.data).toObject();
	  };
	
	  InMemoryCache.prototype.read = function (options) {
	    if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') {
	      return null;
	    }
	
	    var fragmentMatcher = this.config.fragmentMatcher;
	    var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
	    return this.storeReader.readQueryFromStore({
	      store: options.optimistic ? this.optimisticData : this.data,
	      query: this.transformDocument(options.query),
	      variables: options.variables,
	      rootId: options.rootId,
	      fragmentMatcherFunction: fragmentMatcherFunction,
	      previousResult: options.previousResult,
	      config: this.config
	    }) || null;
	  };
	
	  InMemoryCache.prototype.write = function (write) {
	    var fragmentMatcher = this.config.fragmentMatcher;
	    var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
	    this.storeWriter.writeResultToStore({
	      dataId: write.dataId,
	      result: write.result,
	      variables: write.variables,
	      document: this.transformDocument(write.query),
	      store: this.data,
	      dataIdFromObject: this.config.dataIdFromObject,
	      fragmentMatcherFunction: fragmentMatcherFunction
	    });
	    this.broadcastWatches();
	  };
	
	  InMemoryCache.prototype.diff = function (query) {
	    var fragmentMatcher = this.config.fragmentMatcher;
	    var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
	    return this.storeReader.diffQueryAgainstStore({
	      store: query.optimistic ? this.optimisticData : this.data,
	      query: this.transformDocument(query.query),
	      variables: query.variables,
	      returnPartialData: query.returnPartialData,
	      previousResult: query.previousResult,
	      fragmentMatcherFunction: fragmentMatcherFunction,
	      config: this.config
	    });
	  };
	
	  InMemoryCache.prototype.watch = function (watch) {
	    var _this = this;
	
	    this.watches.add(watch);
	    return function () {
	      _this.watches.delete(watch);
	    };
	  };
	
	  InMemoryCache.prototype.evict = function (query) {
	    throw  true ? new _tsInvariant.InvariantError(7) : new _tsInvariant.InvariantError("eviction is not implemented on InMemory Cache");
	  };
	
	  InMemoryCache.prototype.reset = function () {
	    this.data.clear();
	    this.broadcastWatches();
	    return Promise.resolve();
	  };
	
	  InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
	    var toReapply = [];
	    var removedCount = 0;
	    var layer = this.optimisticData;
	
	    while (layer instanceof OptimisticCacheLayer) {
	      if (layer.optimisticId === idToRemove) {
	        ++removedCount;
	      } else {
	        toReapply.push(layer);
	      }
	
	      layer = layer.parent;
	    }
	
	    if (removedCount > 0) {
	      this.optimisticData = layer;
	
	      while (toReapply.length > 0) {
	        var layer_1 = toReapply.pop();
	        this.performTransaction(layer_1.transaction, layer_1.optimisticId);
	      }
	
	      this.broadcastWatches();
	    }
	  };
	
	  InMemoryCache.prototype.performTransaction = function (transaction, optimisticId) {
	    var _a = this,
	        data = _a.data,
	        silenceBroadcast = _a.silenceBroadcast;
	
	    this.silenceBroadcast = true;
	
	    if (typeof optimisticId === 'string') {
	      this.data = this.optimisticData = new OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
	    }
	
	    try {
	      transaction(this);
	    } finally {
	      this.silenceBroadcast = silenceBroadcast;
	      this.data = data;
	    }
	
	    this.broadcastWatches();
	  };
	
	  InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
	    return this.performTransaction(transaction, id);
	  };
	
	  InMemoryCache.prototype.transformDocument = function (document) {
	    if (this.addTypename) {
	      var result = this.typenameDocumentCache.get(document);
	
	      if (!result) {
	        result = (0, _apolloUtilities.addTypenameToDocument)(document);
	        this.typenameDocumentCache.set(document, result);
	        this.typenameDocumentCache.set(result, result);
	      }
	
	      return result;
	    }
	
	    return document;
	  };
	
	  InMemoryCache.prototype.broadcastWatches = function () {
	    var _this = this;
	
	    if (!this.silenceBroadcast) {
	      this.watches.forEach(function (c) {
	        return _this.maybeBroadcastWatch(c);
	      });
	    }
	  };
	
	  InMemoryCache.prototype.maybeBroadcastWatch = function (c) {
	    c.callback(this.diff({
	      query: c.query,
	      variables: c.variables,
	      previousResult: c.previousResult && c.previousResult(),
	      optimistic: c.optimistic
	    }));
	  };
	
	  return InMemoryCache;
	}(_apolloCache.ApolloCache); 
	
	
	exports.InMemoryCache = InMemoryCache;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Cache = exports.ApolloCache = void 0;
	
	var _apolloUtilities = __webpack_require__(89);
	
	function queryFromPojo(obj) {
	  var op = {
	    kind: 'OperationDefinition',
	    operation: 'query',
	    name: {
	      kind: 'Name',
	      value: 'GeneratedClientQuery'
	    },
	    selectionSet: selectionSetFromObj(obj)
	  };
	  var out = {
	    kind: 'Document',
	    definitions: [op]
	  };
	  return out;
	}
	
	function fragmentFromPojo(obj, typename) {
	  var frag = {
	    kind: 'FragmentDefinition',
	    typeCondition: {
	      kind: 'NamedType',
	      name: {
	        kind: 'Name',
	        value: typename || '__FakeType'
	      }
	    },
	    name: {
	      kind: 'Name',
	      value: 'GeneratedClientQuery'
	    },
	    selectionSet: selectionSetFromObj(obj)
	  };
	  var out = {
	    kind: 'Document',
	    definitions: [frag]
	  };
	  return out;
	}
	
	function selectionSetFromObj(obj) {
	  if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) {
	    return null;
	  }
	
	  if (Array.isArray(obj)) {
	    return selectionSetFromObj(obj[0]);
	  }
	
	  var selections = [];
	  Object.keys(obj).forEach(function (key) {
	    var nestedSelSet = selectionSetFromObj(obj[key]);
	    var field = {
	      kind: 'Field',
	      name: {
	        kind: 'Name',
	        value: key
	      },
	      selectionSet: nestedSelSet || undefined
	    };
	    selections.push(field);
	  });
	  var selectionSet = {
	    kind: 'SelectionSet',
	    selections: selections
	  };
	  return selectionSet;
	}
	
	var justTypenameQuery = {
	  kind: 'Document',
	  definitions: [{
	    kind: 'OperationDefinition',
	    operation: 'query',
	    name: null,
	    variableDefinitions: null,
	    directives: [],
	    selectionSet: {
	      kind: 'SelectionSet',
	      selections: [{
	        kind: 'Field',
	        alias: null,
	        name: {
	          kind: 'Name',
	          value: '__typename'
	        },
	        arguments: [],
	        directives: [],
	        selectionSet: null
	      }]
	    }
	  }]
	};
	
	var ApolloCache = function () {
	  function ApolloCache() {}
	
	  ApolloCache.prototype.transformDocument = function (document) {
	    return document;
	  };
	
	  ApolloCache.prototype.transformForLink = function (document) {
	    return document;
	  };
	
	  ApolloCache.prototype.readQuery = function (options, optimistic) {
	    if (optimistic === void 0) {
	      optimistic = false;
	    }
	
	    return this.read({
	      query: options.query,
	      variables: options.variables,
	      optimistic: optimistic
	    });
	  };
	
	  ApolloCache.prototype.readFragment = function (options, optimistic) {
	    if (optimistic === void 0) {
	      optimistic = false;
	    }
	
	    return this.read({
	      query: (0, _apolloUtilities.getFragmentQueryDocument)(options.fragment, options.fragmentName),
	      variables: options.variables,
	      rootId: options.id,
	      optimistic: optimistic
	    });
	  };
	
	  ApolloCache.prototype.writeQuery = function (options) {
	    this.write({
	      dataId: 'ROOT_QUERY',
	      result: options.data,
	      query: options.query,
	      variables: options.variables
	    });
	  };
	
	  ApolloCache.prototype.writeFragment = function (options) {
	    this.write({
	      dataId: options.id,
	      result: options.data,
	      variables: options.variables,
	      query: (0, _apolloUtilities.getFragmentQueryDocument)(options.fragment, options.fragmentName)
	    });
	  };
	
	  ApolloCache.prototype.writeData = function (_a) {
	    var id = _a.id,
	        data = _a.data;
	
	    if (typeof id !== 'undefined') {
	      var typenameResult = null;
	
	      try {
	        typenameResult = this.read({
	          rootId: id,
	          optimistic: false,
	          query: justTypenameQuery
	        });
	      } catch (e) {}
	
	      var __typename = typenameResult && typenameResult.__typename || '__ClientData';
	
	      var dataToWrite = Object.assign({
	        __typename: __typename
	      }, data);
	      this.writeFragment({
	        id: id,
	        fragment: fragmentFromPojo(dataToWrite, __typename),
	        data: dataToWrite
	      });
	    } else {
	      this.writeQuery({
	        query: queryFromPojo(data),
	        data: data
	      });
	    }
	  };
	
	  return ApolloCache;
	}();
	
	exports.ApolloCache = ApolloCache;
	var Cache;
	exports.Cache = Cache;
	
	(function (Cache) {})(Cache || (exports.Cache = Cache = {}));


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(14);
	var printer_1 = __webpack_require__(572);
	var ts_invariant_1 = __webpack_require__(31);
	var defaultHttpOptions = {
	    includeQuery: true,
	    includeExtensions: false,
	};
	var defaultHeaders = {
	    accept: '*/*',
	    'content-type': 'application/json',
	};
	var defaultOptions = {
	    method: 'POST',
	};
	exports.fallbackHttpConfig = {
	    http: defaultHttpOptions,
	    headers: defaultHeaders,
	    options: defaultOptions,
	};
	exports.throwServerError = function (response, result, message) {
	    var error = new Error(message);
	    error.name = 'ServerError';
	    error.response = response;
	    error.statusCode = response.status;
	    error.result = result;
	    throw error;
	};
	exports.parseAndCheckHttpResponse = function (operations) { return function (response) {
	    return (response
	        .text()
	        .then(function (bodyText) {
	        try {
	            return JSON.parse(bodyText);
	        }
	        catch (err) {
	            var parseError = err;
	            parseError.name = 'ServerParseError';
	            parseError.response = response;
	            parseError.statusCode = response.status;
	            parseError.bodyText = bodyText;
	            return Promise.reject(parseError);
	        }
	    })
	        .then(function (result) {
	        if (response.status >= 300) {
	            exports.throwServerError(response, result, "Response not successful: Received status code " + response.status);
	        }
	        if (!Array.isArray(result) &&
	            !result.hasOwnProperty('data') &&
	            !result.hasOwnProperty('errors')) {
	            exports.throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
	                ? operations.map(function (op) { return op.operationName; })
	                : operations.operationName) + "'.");
	        }
	        return result;
	    }));
	}; };
	exports.checkFetcher = function (fetcher) {
	    if (!fetcher && typeof fetch === 'undefined') {
	        var library = 'unfetch';
	        if (typeof window === 'undefined')
	            library = 'node-fetch';
	        throw new ts_invariant_1.InvariantError("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
	    }
	};
	exports.createSignalIfSupported = function () {
	    if (typeof AbortController === 'undefined')
	        return { controller: false, signal: false };
	    var controller = new AbortController();
	    var signal = controller.signal;
	    return { controller: controller, signal: signal };
	};
	exports.selectHttpOptionsAndBody = function (operation, fallbackConfig) {
	    var configs = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        configs[_i - 2] = arguments[_i];
	    }
	    var options = tslib_1.__assign({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
	    var http = fallbackConfig.http;
	    configs.forEach(function (config) {
	        options = tslib_1.__assign({}, options, config.options, { headers: tslib_1.__assign({}, options.headers, config.headers) });
	        if (config.credentials)
	            options.credentials = config.credentials;
	        http = tslib_1.__assign({}, http, config.http);
	    });
	    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
	    var body = { operationName: operationName, variables: variables };
	    if (http.includeExtensions)
	        body.extensions = extensions;
	    if (http.includeQuery)
	        body.query = printer_1.print(query);
	    return {
	        options: options,
	        body: body,
	    };
	};
	exports.serializeFetchParameter = function (p, label) {
	    var serialized;
	    try {
	        serialized = JSON.stringify(p);
	    }
	    catch (e) {
	        var parseError = new ts_invariant_1.InvariantError("Network request failed. " + label + " is not serializable: " + e.message);
	        parseError.parseError = e;
	        throw parseError;
	    }
	    return serialized;
	};
	exports.selectURI = function (operation, fallbackURI) {
	    var context = operation.getContext();
	    var contextURI = context.uri;
	    if (contextURI) {
	        return contextURI;
	    }
	    else if (typeof fallbackURI === 'function') {
	        return fallbackURI(operation);
	    }
	    else {
	        return fallbackURI || '/graphql';
	    }
	};
	//# sourceMappingURL=index.js.map

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(14);
	var apollo_link_1 = __webpack_require__(118);
	var apollo_link_http_common_1 = __webpack_require__(441);
	exports.createHttpLink = function (linkOptions) {
	    if (linkOptions === void 0) { linkOptions = {}; }
	    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = tslib_1.__rest(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
	    apollo_link_http_common_1.checkFetcher(fetcher);
	    if (!fetcher) {
	        fetcher = fetch;
	    }
	    var linkConfig = {
	        http: { includeExtensions: includeExtensions },
	        options: requestOptions.fetchOptions,
	        credentials: requestOptions.credentials,
	        headers: requestOptions.headers,
	    };
	    return new apollo_link_1.ApolloLink(function (operation) {
	        var chosenURI = apollo_link_http_common_1.selectURI(operation, uri);
	        var context = operation.getContext();
	        var clientAwarenessHeaders = {};
	        if (context.clientAwareness) {
	            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
	            if (name_1) {
	                clientAwarenessHeaders['apollographql-client-name'] = name_1;
	            }
	            if (version) {
	                clientAwarenessHeaders['apollographql-client-version'] = version;
	            }
	        }
	        var contextHeaders = tslib_1.__assign({}, clientAwarenessHeaders, context.headers);
	        var contextConfig = {
	            http: context.http,
	            options: context.fetchOptions,
	            credentials: context.credentials,
	            headers: contextHeaders,
	        };
	        var _b = apollo_link_http_common_1.selectHttpOptionsAndBody(operation, apollo_link_http_common_1.fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
	        var controller;
	        if (!options.signal) {
	            var _c = apollo_link_http_common_1.createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
	            controller = _controller;
	            if (controller)
	                options.signal = signal;
	        }
	        var definitionIsMutation = function (d) {
	            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
	        };
	        if (useGETForQueries &&
	            !operation.query.definitions.some(definitionIsMutation)) {
	            options.method = 'GET';
	        }
	        if (options.method === 'GET') {
	            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
	            if (parseError) {
	                return apollo_link_1.fromError(parseError);
	            }
	            chosenURI = newURI;
	        }
	        else {
	            try {
	                options.body = apollo_link_http_common_1.serializeFetchParameter(body, 'Payload');
	            }
	            catch (parseError) {
	                return apollo_link_1.fromError(parseError);
	            }
	        }
	        return new apollo_link_1.Observable(function (observer) {
	            fetcher(chosenURI, options)
	                .then(function (response) {
	                operation.setContext({ response: response });
	                return response;
	            })
	                .then(apollo_link_http_common_1.parseAndCheckHttpResponse(operation))
	                .then(function (result) {
	                observer.next(result);
	                observer.complete();
	                return result;
	            })
	                .catch(function (err) {
	                if (err.name === 'AbortError')
	                    return;
	                if (err.result && err.result.errors && err.result.data) {
	                    observer.next(err.result);
	                }
	                observer.error(err);
	            });
	            return function () {
	                if (controller)
	                    controller.abort();
	            };
	        });
	    });
	};
	function rewriteURIForGET(chosenURI, body) {
	    var queryParams = [];
	    var addQueryParam = function (key, value) {
	        queryParams.push(key + "=" + encodeURIComponent(value));
	    };
	    if ('query' in body) {
	        addQueryParam('query', body.query);
	    }
	    if (body.operationName) {
	        addQueryParam('operationName', body.operationName);
	    }
	    if (body.variables) {
	        var serializedVariables = void 0;
	        try {
	            serializedVariables = apollo_link_http_common_1.serializeFetchParameter(body.variables, 'Variables map');
	        }
	        catch (parseError) {
	            return { parseError: parseError };
	        }
	        addQueryParam('variables', serializedVariables);
	    }
	    if (body.extensions) {
	        var serializedExtensions = void 0;
	        try {
	            serializedExtensions = apollo_link_http_common_1.serializeFetchParameter(body.extensions, 'Extensions map');
	        }
	        catch (parseError) {
	            return { parseError: parseError };
	        }
	        addQueryParam('extensions', serializedExtensions);
	    }
	    var fragment = '', preFragment = chosenURI;
	    var fragmentStart = chosenURI.indexOf('#');
	    if (fragmentStart !== -1) {
	        fragment = chosenURI.substr(fragmentStart);
	        preFragment = chosenURI.substr(0, fragmentStart);
	    }
	    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
	    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
	    return { newURI: newURI };
	}
	var HttpLink = (function (_super) {
	    tslib_1.__extends(HttpLink, _super);
	    function HttpLink(opts) {
	        return _super.call(this, exports.createHttpLink(opts).request) || this;
	    }
	    return HttpLink;
	}(apollo_link_1.ApolloLink));
	exports.HttpLink = HttpLink;
	//# sourceMappingURL=httpLink.js.map

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(14);
	tslib_1.__exportStar(__webpack_require__(442), exports);
	//# sourceMappingURL=index.js.map

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(14);
	var zen_observable_ts_1 = tslib_1.__importDefault(__webpack_require__(155));
	var ts_invariant_1 = __webpack_require__(31);
	var linkUtils_1 = __webpack_require__(207);
	function passthrough(op, forward) {
	    return forward ? forward(op) : zen_observable_ts_1.default.of();
	}
	function toLink(handler) {
	    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
	}
	function empty() {
	    return new ApolloLink(function () { return zen_observable_ts_1.default.of(); });
	}
	exports.empty = empty;
	function from(links) {
	    if (links.length === 0)
	        return empty();
	    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
	}
	exports.from = from;
	function split(test, left, right) {
	    var leftLink = toLink(left);
	    var rightLink = toLink(right || new ApolloLink(passthrough));
	    if (linkUtils_1.isTerminating(leftLink) && linkUtils_1.isTerminating(rightLink)) {
	        return new ApolloLink(function (operation) {
	            return test(operation)
	                ? leftLink.request(operation) || zen_observable_ts_1.default.of()
	                : rightLink.request(operation) || zen_observable_ts_1.default.of();
	        });
	    }
	    else {
	        return new ApolloLink(function (operation, forward) {
	            return test(operation)
	                ? leftLink.request(operation, forward) || zen_observable_ts_1.default.of()
	                : rightLink.request(operation, forward) || zen_observable_ts_1.default.of();
	        });
	    }
	}
	exports.split = split;
	exports.concat = function (first, second) {
	    var firstLink = toLink(first);
	    if (linkUtils_1.isTerminating(firstLink)) {
	        ts_invariant_1.invariant.warn(new linkUtils_1.LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
	        return firstLink;
	    }
	    var nextLink = toLink(second);
	    if (linkUtils_1.isTerminating(nextLink)) {
	        return new ApolloLink(function (operation) {
	            return firstLink.request(operation, function (op) { return nextLink.request(op) || zen_observable_ts_1.default.of(); }) || zen_observable_ts_1.default.of();
	        });
	    }
	    else {
	        return new ApolloLink(function (operation, forward) {
	            return (firstLink.request(operation, function (op) {
	                return nextLink.request(op, forward) || zen_observable_ts_1.default.of();
	            }) || zen_observable_ts_1.default.of());
	        });
	    }
	};
	var ApolloLink = (function () {
	    function ApolloLink(request) {
	        if (request)
	            this.request = request;
	    }
	    ApolloLink.prototype.split = function (test, left, right) {
	        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
	    };
	    ApolloLink.prototype.concat = function (next) {
	        return exports.concat(this, next);
	    };
	    ApolloLink.prototype.request = function (operation, forward) {
	        throw new ts_invariant_1.InvariantError('request is not implemented');
	    };
	    ApolloLink.empty = empty;
	    ApolloLink.from = from;
	    ApolloLink.split = split;
	    ApolloLink.execute = execute;
	    return ApolloLink;
	}());
	exports.ApolloLink = ApolloLink;
	function execute(link, operation) {
	    return (link.request(linkUtils_1.createOperation(operation.context, linkUtils_1.transformOperation(linkUtils_1.validateOperation(operation)))) || zen_observable_ts_1.default.of());
	}
	exports.execute = execute;
	//# sourceMappingURL=link.js.map

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setIsGettingUserLocation = exports.setMessage = exports.setBookingFormVisible = undefined;
	
	var _constants = __webpack_require__(91);
	
	var setBookingFormVisible = exports.setBookingFormVisible = function setBookingFormVisible(visible) {
	  return {
	    type: _constants.SET_BOOKING_FORM_VISIBILITY,
	    visible: visible
	  };
	};
	
	var setMessage = exports.setMessage = function setMessage(message) {
	  return {
	    type: _constants.SET_MESSAGE,
	    message: message
	  };
	};
	
	var setIsGettingUserLocation = exports.setIsGettingUserLocation = function setIsGettingUserLocation(status) {
	  return {
	    type: _constants.GEOLOCATION_GET_USER_LOCATION,
	    status: status
	  };
	};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppFlashMessage = function AppFlashMessage(props) {
	  var message = props.message || {};
	  var classes = (0, _classnames2.default)('appFlashMessage', {
	    'appFlashMessage--visibile': message.title && message.text,
	    'appFlashMessage--warning': message.type === 'warning',
	    'appFlashMessage--error': message.type === 'error'
	  });
	  return _react2.default.createElement(
	    'section',
	    { className: classes, onClick: props.onDismiss },
	    _react2.default.createElement(
	      'div',
	      { className: 'appFlashMessage__icon' },
	      _react2.default.createElement('i', { className: 'bi_web-warning' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'appFlashMessage__content' },
	      _react2.default.createElement(
	        'h6',
	        null,
	        message.title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        message.text
	      )
	    )
	  );
	};
	
	AppFlashMessage.propTypes = {
	  message: _propTypes2.default.shape({
	    title: _propTypes2.default.string,
	    text: _propTypes2.default.string,
	    type: _propTypes2.default.oneOf(['warning', 'error'])
	  }),
	  onDismiss: _propTypes2.default.func
	};
	
	exports.default = AppFlashMessage;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _time = __webpack_require__(20);
	
	var _time2 = _interopRequireDefault(_time);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookingDateRow = function BookingDateRow(_ref) {
	  var date = _ref.date,
	      open = _ref.open,
	      slots = _ref.slots,
	      hasAvailableSpots = _ref.hasAvailableSpots,
	      _onClick = _ref.onClick,
	      hasBookingRushes = _ref.hasBookingRushes;
	
	  var locale = 'it';
	  var isBookable = slots !== null && slots.length > 0 && hasAvailableSpots;
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'bookingDateRow' },
	    _react2.default.createElement(
	      'button',
	      { onClick: function onClick(e) {
	          return e.preventDefault() & _onClick({ date: date, hasBookingRushes: hasBookingRushes, slots: slots });
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: 'title' },
	        _time2.default.toLocalDate(date, locale)
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _time2.default.weekDayLocale(date, locale)
	      ),
	      !open && _react2.default.createElement(
	        'div',
	        { className: 'not-available' },
	        'Chiuso'
	      ),
	      !isBookable && open && _react2.default.createElement(
	        'div',
	        { className: 'not-available' },
	        'Non ci sono posti disponibili'
	      ),
	      _react2.default.createElement('i', { className: 'bi_interface-right' })
	    )
	  );
	};
	
	BookingDateRow.propTypes = {
	  date: _propTypes2.default.string.isRequired,
	  open: _propTypes2.default.bool,
	  slots: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    open: _propTypes2.default.string,
	    close: _propTypes2.default.string,
	    availableSpots: _propTypes2.default.number,
	    totalSpots: _propTypes2.default.number
	  })),
	  hasAvailableSpots: _propTypes2.default.bool,
	  hasBookingRushes: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func.isRequired
	};
	
	exports.default = BookingDateRow;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cartRow = __webpack_require__(209);
	
	var _cartTotal = __webpack_require__(119);
	
	var _cartTotal2 = _interopRequireDefault(_cartTotal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cart = function Cart(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'cart' },
	    props.items.map(function (item) {
	      return _react2.default.createElement(_cartRow.CartRow, _extends({
	        key: item[0].cart_id
	      }, item[0], {
	        quantity: item.length,
	        onRemove: props.onRemove
	      }));
	    }),
	    _react2.default.createElement(_cartTotal2.default, {
	      total: props.total,
	      subtotal: props.subtotal,
	      extraCosts: props.extraCosts
	    })
	  );
	};
	
	Cart.propTypes = {
	  items: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.shape(_cartRow.CartRowPropTypes))),
	  total: _cartTotal2.default.propTypes.total,
	  subtotal: _cartTotal2.default.propTypes.subtotal,
	  extraCosts: _cartTotal2.default.propTypes.extraCosts,
	  onRemove: _propTypes2.default.func
	};
	
	exports.default = Cart;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurrentUser = function CurrentUser(props) {
	  if (!props.user) {
	    return null;
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'currentUser' },
	    _react2.default.createElement(
	      'p',
	      null,
	      props.user.name
	    ),
	    _react2.default.createElement('i', { className: 'bi_user-male' }),
	    _react2.default.createElement(
	      'button',
	      { className: 'currentUser_logout', onClick: props.onLogout, title: 'ESCI' },
	      _react2.default.createElement('i', { className: 'bi_interface-power' })
	    )
	  );
	};
	
	CurrentUser.propTypes = {
	  user: _propTypes2.default.shape({
	    email: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    accessToken: _propTypes2.default.string,
	    lastName: _propTypes2.default.string,
	    name: _propTypes2.default.string
	  }),
	  onLogout: _propTypes2.default.func
	};
	
	exports.default = CurrentUser;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _env = __webpack_require__(92);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global FB */
	
	
	var finishedRendering = function finishedRendering() {
	  var spinner = global.document.getElementById('spinner');
	  if (spinner) {
	    spinner.removeAttribute('style');
	    spinner.removeChild(spinner.childNodes[0]);
	  }
	};
	
	var eventsSubscribed = false;
	
	var FbLoginButton = function (_Component) {
	  _inherits(FbLoginButton, _Component);
	
	  function FbLoginButton() {
	    _classCallCheck(this, FbLoginButton);
	
	    return _possibleConstructorReturn(this, (FbLoginButton.__proto__ || Object.getPrototypeOf(FbLoginButton)).apply(this, arguments));
	  }
	
	  _createClass(FbLoginButton, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.onStatusChange = this.onStatusChange.bind(this);
	
	      var interval = void 0;
	      var tryInit = function tryInit() {
	        if (typeof FB === 'undefined') {
	          return;
	        }
	        if (_this2.props.user.currentUser) {
	          clearInterval(interval);
	          return;
	        }
	        if (!eventsSubscribed) {
	          eventsSubscribed = true;
	          FB.Event.subscribe('xfbml.render', finishedRendering);
	          FB.Event.subscribe('auth.statusChange', _this2.onStatusChange);
	        }
	
	        FB.init({
	          appId: _env2.default.getCurrent().fb_app_id,
	          status: true,
	          xfbml: true,
	          oauth: false,
	          version: 'v2.12'
	        });
	
	        clearInterval(interval);
	      };
	
	      interval = setInterval(tryInit, 200);
	      tryInit();
	    }
	  }, {
	    key: 'onStatusChange',
	    value: function onStatusChange() {
	      this.checkResponse('StatusChange');
	    }
	  }, {
	    key: 'checkResponse',
	    value: function checkResponse(eventType) {
	      var _this3 = this;
	
	      console.log('FB event ' + eventType);
	
	      if (typeof FB !== 'undefined') {
	        FB.getLoginStatus(function (response) {
	          if (response.status === 'connected') {
	            _this3.props.onLogin(response.authResponse.accessToken);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            marginBottom: '20px',
	            display: 'flex',
	            justifyContent: 'flex-end'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            id: 'spinner',
	            style: {
	              background: '#4267b2',
	              borderRadius: '5px',
	              color: 'white',
	              height: '40px',
	              width: '250px',
	              marginTop: '20px'
	            }
	          },
	          '\xA0',
	          _react2.default.createElement('div', {
	            className: 'fb-login-button',
	            'data-max-rows': '1',
	            'data-size': 'large',
	            'data-button-type': 'continue_with',
	            'data-show-faces': 'false',
	            'data-auto-logout-link': 'false',
	            'data-use-continue-as': 'false',
	            'data-scope': 'public_profile, email'
	          })
	        )
	      );
	    }
	  }]);
	
	  return FbLoginButton;
	}(_react.Component);
	
	FbLoginButton.propTypes = {
	  user: _propTypes2.default.object.isRequired,
	  onLogin: _propTypes2.default.func,
	  shouldShowlargeButton: _propTypes2.default.bool
	};
	
	exports.default = FbLoginButton;
	
	/* global FB */
	// import React from 'react';
	
	// import Env from '../lib/env';
	
	// class FbLoginButton extends React.Component {
	//   componentDidMount() {
	//     this.onStatusChange = this.onStatusChange.bind(this);
	//     FB.Event.subscribe('auth.statusChange', this.onStatusChange);
	//     FB.init({
	//       appId: Env.getCurrent().fb_app_id,
	//       xfbml: true,
	//       version: 'v2.8',
	//     });
	//     this.onStatusChange();
	//   }
	//   onStatusChange() {
	//     FB.getLoginStatus((response) => {
	//       if (response.status === 'connected') {
	//         const token = response.authResponse.accessToken;
	//         this.props.onLogin(token);
	//       }
	//     });
	//   }
	//   render() {
	//     return (
	//       <div
	//         className="fb-login-button"
	//         data-max-rows="1"
	//         data-size="large"
	//         data-show-faces="false"
	//         data-auto-logout-link="true"
	//       />
	//     );
	//   }
	// }
	
	// FbLoginButton.propTypes = {
	//   onLogin: PropTypes.func,
	// };
	
	// export default FbLoginButton;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(13);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ListItem = function ListItem(props) {
	  return _react2.default.createElement(
	    'li',
	    { className: (0, _classnames2.default)({ disabled: props.disabled }) },
	    props.disabled && _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        props.title
	      ),
	      props.children
	    ),
	    !props.disabled && _react2.default.createElement(
	      _reactRouter.Link,
	      { to: props.to },
	      _react2.default.createElement(
	        'div',
	        { className: 'title' },
	        props.title
	      ),
	      props.children,
	      _react2.default.createElement('i', { className: 'bi_interface-right' })
	    )
	  );
	};
	
	ListItem.propTypes = {
	  disabled: _propTypes2.default.bool,
	  to: _propTypes2.default.string.isRequired,
	  title: _propTypes2.default.string.isRequired
	};
	ListItem.defaultProps = {
	  disabled: false
	};
	
	exports.default = ListItem;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var load = function load(store, container, component, route) {
	  return function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class() {
	      _classCallCheck(this, _class);
	
	      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	    }
	
	    _createClass(_class, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        store.dispatch({
	          type: 'route.mounted',
	          route: route
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        if (component) {
	          var children = _react2.default.createElement(component, this.props);
	          return _react2.default.createElement(container, this.props, children);
	        }
	        return _react2.default.createElement(container, this.props);
	      }
	    }]);
	
	    return _class;
	  }(_react2.default.Component);
	};
	
	exports.default = load;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CartButton = function CartButton(props) {
	  var classes = (0, _classnames2.default)('cartButton', 'primary--background', {
	    'cartButton--disabled': props.disabled
	  });
	  return _react2.default.createElement(
	    'button',
	    {
	      disabled: props.disabled,
	      className: classes,
	      onClick: props.onClick
	    },
	    _react2.default.createElement('i', { className: 'bi_ecommerce-shopcart' }),
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement(
	        'span',
	        null,
	        props.total
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        props.text
	      )
	    )
	  );
	};
	
	CartButton.propTypes = {
	  total: _propTypes2.default.string,
	  text: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func
	};
	
	exports.default = CartButton;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CartButton = exports.MenuItemCategory = exports.MenuItem = undefined;
	
	__webpack_require__(770);
	
	var _menuItem = __webpack_require__(458);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _menuItemCategory = __webpack_require__(456);
	
	var _menuItemCategory2 = _interopRequireDefault(_menuItemCategory);
	
	var _cartButton = __webpack_require__(454);
	
	var _cartButton2 = _interopRequireDefault(_cartButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MenuItem = _menuItem2.default;
	exports.MenuItemCategory = _menuItemCategory2.default;
	exports.CartButton = _cartButton2.default;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MenuItemCategory = function (_React$Component) {
	  _inherits(MenuItemCategory, _React$Component);
	
	  function MenuItemCategory(props) {
	    _classCallCheck(this, MenuItemCategory);
	
	    var _this = _possibleConstructorReturn(this, (MenuItemCategory.__proto__ || Object.getPrototypeOf(MenuItemCategory)).call(this, props));
	
	    _this.state = { isOpen: false };
	    _this.toggle = _this.toggle.bind(_this);
	    return _this;
	  }
	
	  _createClass(MenuItemCategory, [{
	    key: 'toggle',
	    value: function toggle() {
	      this.setState({ isOpen: !this.state.isOpen });
	      if (this.props.onDisclose) {
	        this.props.onDisclose(this.state);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'menuCategory' },
	        _react2.default.createElement(
	          'button',
	          { className: 'menuCategory__titleWrapper', onClick: this.toggle },
	          _react2.default.createElement(
	            'h4',
	            { className: 'menuCategory__title' },
	            this.props.name
	          ),
	          this.state.isOpen ? _react2.default.createElement('i', { className: 'bi_interface-top menuCategory__icn' }) : _react2.default.createElement('i', { className: 'bi_interface-bottom menuCategory__icn' })
	        ),
	        this.state.isOpen && _react2.default.createElement(
	          'div',
	          { className: 'menuCategory__content' },
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return MenuItemCategory;
	}(_react2.default.Component);
	
	MenuItemCategory.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  onDisclose: _propTypes2.default.func
	};
	
	exports.default = MenuItemCategory;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MenuItemQuantity = function MenuItemQuantity(props) {
	  var classes = (0, _classnames2.default)('menuItem__quantity', { 'primary--background': props.n > 0 });
	  var text = props.n > 0 ? props.n + ' \xD7' : '';
	  return _react2.default.createElement(
	    'div',
	    { className: classes },
	    _react2.default.createElement(
	      'span',
	      null,
	      text
	    )
	  );
	};
	MenuItemQuantity.propTypes = {
	  n: _propTypes2.default.number
	};
	
	exports.default = MenuItemQuantity;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _cart = __webpack_require__(64);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _priceStrategy = __webpack_require__(193);
	
	var _priceStrategy2 = _interopRequireDefault(_priceStrategy);
	
	var _button = __webpack_require__(35);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _modifier = __webpack_require__(459);
	
	var _modifier2 = _interopRequireDefault(_modifier);
	
	var _menuItemQuantity = __webpack_require__(457);
	
	var _menuItemQuantity2 = _interopRequireDefault(_menuItemQuantity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window */
	
	var scrollToTop = function scrollToTop(handler) {
	  var scrollDuration = 500;
	  var scrollHeight = handler.scrollY;
	  var scrollStep = Math.PI / (scrollDuration / 15);
	  var cosParameter = scrollHeight / 2;
	  var scrollCount = 0;
	  var scrollMargin = void 0;
	  var scrollInterval = setInterval(function () {
	    if (handler.scrollY !== 0) {
	      scrollCount += 1;
	      scrollMargin = cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);
	      handler.scrollTo(0, scrollHeight - scrollMargin);
	    } else {
	      clearInterval(scrollInterval);
	    }
	  }, 15);
	};
	
	var MenuItemBasic = function MenuItemBasic(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'menuItem__content' },
	    _react2.default.createElement(
	      'div',
	      { className: 'menuItem__name' },
	      _react2.default.createElement(
	        'h5',
	        null,
	        props.name
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        props.description
	      )
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'menuItem__price' },
	      _i18n2.default.formatPrice(props.price)
	    )
	  );
	};
	
	MenuItemBasic.propTypes = {
	  available: _propTypes2.default.bool,
	  description: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  price: _propTypes2.default.number
	};
	
	var MenuItem = function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem(props) {
	    _classCallCheck(this, MenuItem);
	
	    var _this = _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call(this, props));
	
	    _this.state = {
	      showErrors: false,
	      modifiersPanelVisibile: false,
	      modifiersStatus: _this.getDefaultModifiersStatus(_this.props.modifiers)
	    };
	    _this.toggleModifiersPanel = _this.toggleModifiersPanel.bind(_this);
	    _this.addToCartFn = _this.addToCartFn.bind(_this);
	    _this.updateModifier = _this.updateModifier.bind(_this);
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: 'getDefaultModifiersStatus',
	    value: function getDefaultModifiersStatus(modifiers) {
	      return modifiers.reduce(function (acc, m) {
	        return _extends({}, acc, _defineProperty({}, m.id, _extends({}, _priceStrategy2.default[m.price_strategy](m), {
	          items: m.items
	        })));
	      }, {});
	    }
	  }, {
	    key: 'toggleModifiersPanel',
	    value: function toggleModifiersPanel(event) {
	      event.preventDefault();
	      event.stopPropagation();
	      if (this.props.modifiers.length < 1) {
	        console.error('Try to open modifiers panel for item w/o modifiers');
	        return;
	      }
	      this.setState({ modifiersPanelVisibile: !this.state.modifiersPanelVisibile });
	    }
	  }, {
	    key: 'addToCartFn',
	    value: function addToCartFn(item) {
	      var hasErrors = _lodash2.default.some(this.state.modifiersStatus, { isValid: false });
	      if (!this.props.available || hasErrors) {
	        this.setState({ showErrors: true });
	        this.modifiersWrapper.scrollTop = 0;
	        return;
	      }
	      this.setState({ modifiersPanelVisibile: false });
	      this.props.onSelect(item);
	      this.setState({
	        modifiersStatus: this.getDefaultModifiersStatus(this.props.modifiers)
	      });
	      // scrollToTop(window);
	    }
	  }, {
	    key: 'updateModifier',
	    value: function updateModifier(modifier, item) {
	      var items = this.state.modifiersStatus[modifier.id].update(item);
	      var newStatus = _extends({}, modifier, {
	        items: items
	      });
	      this.setState({
	        showErrors: _lodash2.default.some(this.state.modifiersStatus, { isValid: false }),
	        modifiersStatus: _extends({}, this.state.modifiersStatus, _defineProperty({}, modifier.id, _extends({}, _priceStrategy2.default[modifier.price_strategy](newStatus), {
	          items: items
	        })))
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var classes = (0, _classnames2.default)('menuItem', { 'menuItem--unavailable': !this.props.available }, { 'menuItem--withModifiers': this.props.modifiers.length > 0 });
	      if (this.props.modifiers.length < 1) {
	        var _item = {
	          id: this.props.id,
	          name: this.props.name,
	          price: this.props.price,
	          modifiers: []
	        };
	        return _react2.default.createElement(
	          'button',
	          { className: classes, onClick: function onClick() {
	              return _this2.addToCartFn(_item);
	            } },
	          _react2.default.createElement(_menuItemQuantity2.default, { n: this.props.quantity || 0 }),
	          _react2.default.createElement(MenuItemBasic, this.props)
	        );
	      }
	
	      var item = {
	        id: this.props.id,
	        name: this.props.name,
	        price: this.props.price,
	        modifiers: this.props.modifiers.map(function (m) {
	          return _extends({}, m, {
	            items: _this2.state.modifiersStatus[m.id].items.filter(function (mi) {
	              return mi.selected;
	            })
	          });
	        })
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        _react2.default.createElement(
	          'div',
	          { className: 'menuItem__header', onClick: this.toggleModifiersPanel },
	          _react2.default.createElement(_menuItemQuantity2.default, { n: this.props.quantity || 0 }),
	          _react2.default.createElement(MenuItemBasic, this.props)
	        ),
	        this.state.modifiersPanelVisibile && _react2.default.createElement(
	          'div',
	          {
	            className: 'menuItem__modifiersWrapper',
	            ref: function ref(node) {
	              _this2.modifiersWrapper = node;
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'itemModifiers' },
	            this.props.modifiers.map(function (m) {
	              var modifier = _extends({}, m, {
	                items: _this2.state.modifiersStatus[m.id].items
	              });
	              return _react2.default.createElement(_modifier2.default, {
	                key: m.id,
	                onUpdate: _this2.updateModifier,
	                status: _this2.state.modifiersStatus[m.id],
	                data: modifier,
	                showErrors: _this2.state.showErrors
	              });
	            })
	          ),
	          _react2.default.createElement(
	            'footer',
	            { className: 'cf menuItem__controls' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'div',
	                { className: 'menuItem__subtot' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Tot parziale'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'menuItem__subtotPrice' },
	                  _i18n2.default.formatPrice(_cart2.default.itemPrice(item))
	                )
	              ),
	              _react2.default.createElement(_button2.default, {
	                type: 'submit',
	                text: 'AGGIUNGI ALL\'ORDINE',
	                onClick: function onClick() {
	                  _this2.addToCartFn(item);
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react2.default.Component);
	
	MenuItem.propTypes = _extends({}, MenuItemBasic.propTypes, {
	  modifiers: _propTypes2.default.array,
	  onSelect: _propTypes2.default.func,
	  quantity: _propTypes2.default.number
	});
	MenuItem.defultProps = {
	  quantity: 0
	};
	
	exports.default = MenuItem;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STRATEGY_SINGLE = 'SINGLE';
	var STRATEGY_MULTI_RANGE = 'MULTI_RANGE';
	
	var formatError = function formatError(status) {
	  if (status.minSelection === 1) {
	    return 'Seleziona almeno ' + status.minSelection + ' elemento';
	  }
	  return 'Seleziona almeno ' + status.minSelection + ' elementi';
	};
	
	var formatInfo = function formatInfo(strategy, status) {
	  if (status.isCompleted) return '';
	  if (strategy === STRATEGY_SINGLE) {
	    return 'Seleziona ' + status.minSelection + ' elementi';
	  }
	  return 'Puoi selezionare ancora ' + status.remaining + ' elementi';
	};
	
	var Modifier = function Modifier(props) {
	  var data = props.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'itemModifier' },
	    _react2.default.createElement(
	      'p',
	      { className: 'itemModifier__name primary' },
	      data.name
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'itemModifier__info' },
	      formatInfo(data.price_strategy, props.status)
	    ),
	    !props.status.isValid && props.showErrors && _react2.default.createElement(
	      'p',
	      { className: 'itemModifier__error' },
	      formatError(props.status)
	    ),
	    _react2.default.createElement(
	      'form',
	      { name: 'modifier_' + data.id, className: 'itemModifier__content' },
	      data.items.map(function (item) {
	        return _react2.default.createElement(
	          'p',
	          {
	            className: 'itemModifier__item',
	            htmlFor: 'modifier_' + item.id,
	            key: item.id,
	            onClick: function onClick() {
	              if (props.status.isCompleted && !item.selected) return;
	              props.onUpdate(data, item);
	            }
	          },
	          _react2.default.createElement(
	            'span',
	            {
	              className: (0, _classnames2.default)('itemModifier__icon', { 'primary--background': item.selected })
	            },
	            _react2.default.createElement('i', { className: 'bi_interface-tick' })
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'itemModifier__nameWrapper' },
	            _react2.default.createElement(
	              'span',
	              { className: 'itemModifier__name' },
	              item.name
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'itemModifier__description' },
	              item.description
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'itemModifier__extraprice' },
	            item.price > 0 ? ' + ' + _i18n2.default.formatPrice(item.price) : ''
	          )
	        );
	      })
	    )
	  );
	};
	
	var ModifierShape = _propTypes2.default.shape({
	  id: _propTypes2.default.string,
	  name: _propTypes2.default.string,
	  price_strategy: _propTypes2.default.oneOf([STRATEGY_SINGLE, STRATEGY_MULTI_RANGE]),
	  min_selection_points: _propTypes2.default.number,
	  max_selection_points: _propTypes2.default.number,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    available: _propTypes2.default.bool,
	    description: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    name: _propTypes2.default.string,
	    price: _propTypes2.default.number
	  }))
	});
	
	Modifier.propTypes = {
	  data: ModifierShape,
	  showErrors: _propTypes2.default.bool,
	  onUpdate: _propTypes2.default.func,
	  status: _propTypes2.default.shape({
	    selected: _propTypes2.default.number,
	    remaining: _propTypes2.default.number,
	    minSelection: _propTypes2.default.number,
	    maxSelection: _propTypes2.default.number,
	    isCompleted: _propTypes2.default.bool,
	    isValid: _propTypes2.default.bool
	  })
	};
	
	exports.default = Modifier;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NumberPicker = function NumberPicker(_ref) {
	  var current = _ref.current,
	      max = _ref.max,
	      update = _ref.update;
	
	  var decrease = function decrease() {
	    return update(Math.max(1, current - 1));
	  };
	  var increase = function increase() {
	    return update(Math.min(max, current + 1));
	  };
	  return _react2.default.createElement(
	    'div',
	    { className: 'number-picker' },
	    _react2.default.createElement('input', {
	      type: 'submit',
	      value: '\u2013',
	      onClick: decrease,
	      disabled: current <= 1
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'value' },
	      current
	    ),
	    _react2.default.createElement('input', {
	      type: 'submit',
	      value: '+',
	      onClick: increase,
	      disabled: current === max
	    })
	  );
	};
	NumberPicker.propTypes = {
	  current: _propTypes2.default.number,
	  max: _propTypes2.default.number,
	  update: _propTypes2.default.func
	};
	
	exports.default = NumberPicker;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formWrapper = __webpack_require__(66);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderDeliveryForm = function (_React$Component) {
	  _inherits(OrderDeliveryForm, _React$Component);
	
	  function OrderDeliveryForm(props) {
	    _classCallCheck(this, OrderDeliveryForm);
	
	    var _this = _possibleConstructorReturn(this, (OrderDeliveryForm.__proto__ || Object.getPrototypeOf(OrderDeliveryForm)).call(this, props));
	
	    var config = [{
	      label: 'Citofono',
	      name: 'citofono',
	      format: 'string',
	      placeholder: 'Citofono',
	      initialValue: '',
	      isRequired: true
	    }].concat(_toConsumableArray(props.baseConfig));
	    _this.formConfig = config.reduce(function (acc, field) {
	      return [].concat(_toConsumableArray(acc), [_extends({}, field, {
	        initialValue: props.initialData[field.name] || ''
	      })]);
	    }, []);
	    return _this;
	  }
	
	  _createClass(OrderDeliveryForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_formWrapper2.default, {
	        config: this.formConfig,
	        onValidSave: this.props.onSave,
	        submitButtonLabel: 'SALVA E CONTINUA'
	      });
	    }
	  }]);
	
	  return OrderDeliveryForm;
	}(_react2.default.Component);
	
	OrderDeliveryForm.propTypes = {
	  initialData: _propTypes2.default.shape({
	    email: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    accessToken: _propTypes2.default.string,
	    lastName: _propTypes2.default.string,
	    name: _propTypes2.default.string
	  }),
	  onSave: _propTypes2.default.func.isRequired
	};
	
	exports.default = OrderDeliveryForm;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StepItem = function StepItem(props) {
	  var index = props.index,
	      current = props.current;
	
	  var stepClasses = (0, _classnames2.default)({
	    ordersteps__item: true,
	    'ordersteps__item--current primary': index === current,
	    'ordersteps__item--past': index < current,
	    'ordersteps__item--next': index > current
	  });
	  return _react2.default.createElement(
	    'li',
	    { className: stepClasses },
	    _react2.default.createElement('i', { className: props.icon }),
	    _react2.default.createElement(
	      'span',
	      null,
	      props.name
	    )
	  );
	};
	
	StepItem.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  icon: _propTypes2.default.string.isRequired,
	  current: _propTypes2.default.number.isRequired,
	  index: _propTypes2.default.number.isRequired
	};
	
	var OrderSteps = function OrderSteps(props) {
	  var steps = [{ name: 'ORDINA', icon: 'bi_location-pin' }, { name: 'MENU', icon: 'bi_kitchen-spoon-fork' }, { name: 'CARRELLO', icon: 'bi_ecommerce-shopcart' }, { name: 'DATI', icon: 'bi_editorial-pencil-a' }, { name: 'PAGA', icon: 'bi_ecommerce-cash-a' }, { name: '', icon: 'bi_com-paperplane' }];
	  return _react2.default.createElement(
	    'div',
	    { className: 'ordersteps' },
	    _react2.default.createElement(
	      'ul',
	      null,
	      steps.map(function (step, i) {
	        return _react2.default.createElement(StepItem, {
	          key: i,
	          index: i,
	          current: props.current,
	          name: step.name,
	          icon: step.icon
	        });
	      })
	    )
	  );
	};
	
	OrderSteps.propTypes = {
	  current: _propTypes2.default.number
	};
	
	exports.default = OrderSteps;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formWrapper = __webpack_require__(66);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderTakeAwayForm = function (_React$Component) {
	  _inherits(OrderTakeAwayForm, _React$Component);
	
	  function OrderTakeAwayForm(props) {
	    _classCallCheck(this, OrderTakeAwayForm);
	
	    var _this = _possibleConstructorReturn(this, (OrderTakeAwayForm.__proto__ || Object.getPrototypeOf(OrderTakeAwayForm)).call(this, props));
	
	    var config = [{
	      label: 'Nome',
	      name: 'name',
	      type: 'string',
	      placeholder: 'Nome',
	      initialValue: ''
	    }].concat(_toConsumableArray(props.baseConfig));
	    _this.formConfig = config.reduce(function (acc, field) {
	      return [].concat(_toConsumableArray(acc), [_extends({}, field, {
	        initialValue: props.initialData[field.name] || ''
	      })]);
	    }, []);
	    return _this;
	  }
	
	  _createClass(OrderTakeAwayForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_formWrapper2.default, {
	        config: this.formConfig,
	        onValidSave: this.props.onSave,
	        submitButtonLabel: 'SALVA E CONTINUA'
	      });
	    }
	  }]);
	
	  return OrderTakeAwayForm;
	}(_react2.default.Component);
	
	OrderTakeAwayForm.propTypes = {
	  initialData: _propTypes2.default.shape({
	    email: _propTypes2.default.string,
	    id: _propTypes2.default.string,
	    accessToken: _propTypes2.default.string,
	    lastName: _propTypes2.default.string,
	    name: _propTypes2.default.string
	  }),
	  onSave: _propTypes2.default.func.isRequired
	};
	
	exports.default = OrderTakeAwayForm;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(13);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderTypeButton = function OrderTypeButton(props) {
	  var data = props.type === 'delivery' ? { to: _url2.default.orderDelivery, icon: 'bi_building-house' } : { to: _url2.default.orderTakeAway, icon: 'bi_kitchen-hood-a' };
	  return _react2.default.createElement(
	    _reactRouter.Link,
	    { className: 'orderType__button', to: data.to(props.appId) },
	    _react2.default.createElement(
	      'span',
	      null,
	      _react2.default.createElement('i', { className: data.icon }),
	      _react2.default.createElement(
	        'span',
	        { className: 'orderType__buttonLabel' },
	        props.children
	      )
	    )
	  );
	};
	
	OrderTypeButton.propTypes = {
	  appId: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(['delivery', 'takeAway']),
	  children: _propTypes2.default.string
	};
	
	exports.default = OrderTypeButton;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactStripeElements = __webpack_require__(152);
	
	var _boxedItem = __webpack_require__(65);
	
	var _boxedItem2 = _interopRequireDefault(_boxedItem);
	
	__webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CC_BRANDS = ['mastercard', 'visa'];
	
	var AddCreditCard = function (_React$Component) {
	  _inherits(AddCreditCard, _React$Component);
	
	  function AddCreditCard(props) {
	    _classCallCheck(this, AddCreditCard);
	
	    var _this = _possibleConstructorReturn(this, (AddCreditCard.__proto__ || Object.getPrototypeOf(AddCreditCard)).call(this, props));
	
	    _this.select = _this.select.bind(_this);
	    return _this;
	  }
	
	  _createClass(AddCreditCard, [{
	    key: 'select',
	    value: function select() {
	      if (!this.props.active) {
	        this.props.onSelect();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _boxedItem2.default,
	        {
	          title: 'Aggiungi nuova carta',
	          icon: 'bi_interface-plus',
	          className: 'paymentTypeBox',
	          active: this.props.active,
	          onClick: this.select
	        },
	        this.props.active && _react2.default.createElement(_reactStripeElements.CardElement, null)
	      );
	    }
	  }]);
	
	  return AddCreditCard;
	}(_react2.default.Component);
	
	AddCreditCard.propTypes = {
	  active: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func.isRequired
	};
	
	exports.default = AddCreditCard;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentHeader = function PaymentHeader(props) {
	  return _react2.default.createElement(
	    'header',
	    { className: 'paymentHeader' },
	    _react2.default.createElement('i', { className: 'bi_user-lock' }),
	    _react2.default.createElement(
	      'h4',
	      null,
	      'La sicurezza delle transazioni \xE8 garantita dal nostro gateway di pagamenti'
	    )
	  );
	};
	
	exports.default = PaymentHeader;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _boxedItem = __webpack_require__(65);
	
	var _boxedItem2 = _interopRequireDefault(_boxedItem);
	
	__webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SavedCreditCard = function SavedCreditCard(props) {
	  return _react2.default.createElement(
	    _boxedItem2.default,
	    {
	      className: 'savedCreditCard',
	      onClick: function onClick() {
	        return props.onSelect(props.id);
	      },
	      active: props.active
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'savedCreditCard__main' },
	      _react2.default.createElement(
	        'div',
	        { className: 'savedCreditCard__image' },
	        props.brand && _react2.default.createElement('img', { src: 'https://static.arreeba.com/cc/' + props.brand.toLowerCase() + '.png', alt: props.brand })
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'savedCreditCard__number' },
	        'XXXX-XXXX-XXXX-',
	        props.last4
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'savedCreditCard__expDate' },
	      props.exp_month,
	      '/',
	      props.exp_year
	    )
	  );
	};
	
	SavedCreditCard.propTypes = {
	  brand: _propTypes2.default.string,
	  exp_month: _propTypes2.default.string,
	  exp_year: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  last4: _propTypes2.default.string,
	  onSelect: _propTypes2.default.func,
	  active: _propTypes2.default.bool
	};
	
	exports.default = SavedCreditCard;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _boxedItem = __webpack_require__(65);
	
	var _boxedItem2 = _interopRequireDefault(_boxedItem);
	
	__webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Unhandled = function Unhandled(props) {
	  var subtitle = props.active ? 'Indica con che importo pagherai' : '';
	  return _react2.default.createElement(
	    'div',
	    { className: 'unhandled' },
	    _react2.default.createElement(
	      _boxedItem2.default,
	      {
	        title: 'Paga in contanti',
	        subtitle: subtitle,
	        icon: 'bi_ecommerce-cash-a',
	        className: 'paymentTypeBox',
	        active: props.active,
	        onClick: props.onSelect
	      },
	      props.active && _react2.default.createElement(
	        'div',
	        { className: 'unhandled__content' },
	        _react2.default.createElement(
	          'select',
	          { value: props.currentValue, onChange: function onChange(evt) {
	              return props.onSelect(evt.target.value);
	            } },
	          props.values.map(function (val) {
	            return _react2.default.createElement(
	              'option',
	              { key: val.value, value: val.value },
	              val.label
	            );
	          })
	        )
	      )
	    )
	  );
	};
	Unhandled.propTypes = {
	  active: _propTypes2.default.bool,
	  values: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    label: _propTypes2.default.string,
	    value: _propTypes2.default.number
	  })).isRequired,
	  onSelect: _propTypes2.default.func.isRequired,
	  currentValue: _propTypes2.default.number
	};
	
	exports.default = Unhandled;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScrollView = function ScrollView(props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "scrollView" },
	    _react2.default.createElement(
	      "div",
	      { className: "scrollView__scroller" },
	      props.children
	    )
	  );
	};
	
	exports.default = ScrollView;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	__webpack_require__(771);
	
	var _header = __webpack_require__(121);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var App = function App(props) {
	  var appId = props.params.appId;
	  return _react2.default.createElement(
	    'main',
	    { className: 'appWrapper' },
	    _react2.default.createElement(
	      _header2.default,
	      null,
	      'Ciao'
	    ),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '' + _url2.default.order(appId) },
	      'Ordina online'
	    ),
	    _react2.default.createElement(
	      _reactRouter.Link,
	      { to: '' + _url2.default.booking(appId) },
	      'Prenota online'
	    )
	  );
	};
	
	exports.default = App;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(76);
	
	var _loadingContainer = __webpack_require__(211);
	
	var _loadingContainer2 = _interopRequireDefault(_loadingContainer);
	
	var _header = __webpack_require__(121);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookingContainer = function BookingContainer(props) {
	  var app = props.app,
	      booking = props.booking,
	      children = props.children;
	
	  var isFetching = app.isFetching || booking.isFetching;
	
	  return _react2.default.createElement(
	    _loadingContainer2.default,
	    { isLoading: isFetching, dispatch: props.dispatch },
	    _react2.default.createElement(
	      _header2.default,
	      null,
	      'Prenota online ',
	      _react2.default.createElement(
	        'span',
	        null,
	        'un tavolo'
	      )
	    ),
	    children
	  );
	};
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var app = _ref.app,
	      booking = _ref.booking;
	  return { app: app, booking: booking };
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(BookingContainer);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _time = __webpack_require__(20);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _booking = __webpack_require__(87);
	
	var _util = __webpack_require__(11);
	
	var _urlSelectors = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var data = {
	  pending: {
	    icon: 'bi_com-paperplane',
	    title: 'La tua prenotazione è in attesa di conferma!',
	    body: 'A breve riceverai una email di conferma all\'indirizzo che ci hai indicato.'
	  },
	  confirmed: {
	    icon: 'bi_interface-tick',
	    title: 'La tua prenotazione è stata confermata!',
	    body: 'Ti abbiamo inviato una email di conferma all\'indirizzo che ci hai indicato.'
	  }
	};
	
	var BookingEnd = function BookingEnd(props) {
	  var actions = props.actions,
	      booking = props.booking,
	      app = props.app;
	  var createdRequest = booking.createdRequest;
	  // const { bookingRush } = app;
	
	  var status = createdRequest.status.toLowerCase();
	  var theme = (0, _util.getTheme)(props);
	
	  var targetRestaurant = props.url.restaurantId;
	  var restaurant = (0, _booking.restaurantById)(app.merchant.restaurants, targetRestaurant);
	
	  var locale = 'it';
	  var day = _time2.default.weekDayLocale(createdRequest.date, locale);
	  var date = _time2.default.toLocalDate(createdRequest.date, locale);
	  var time = createdRequest.availabilitySlot.open;
	
	  var icon = theme.confirmIcon ? _react2.default.createElement('img', { src: theme.confirmIcon, role: 'presentation' }) : _react2.default.createElement('i', { className: data[status].icon });
	  var iconStatusClasses = (0, _classnames2.default)('bookingStatusIcon', { 'bookingStatusIcon--pending': status === 'pending' }, { 'bookingStatusIcon--confirmed': status === 'confirmed' }, { 'bookingStatusIcon--denied': status === 'denied' });
	
	  var resetBookingState = function resetBookingState() {
	    actions.booking.endBooking();
	  };
	
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: iconStatusClasses },
	      icon
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'grow', style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          data[status].title
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        data[status].body
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'restaurant-info-panel' },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement('i', { className: 'bi_location-pin' }),
	          restaurant.name,
	          ', ',
	          restaurant.city
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement('i', { className: 'bi_interface-clock' }),
	          day,
	          ' ',
	          date,
	          ' alle ',
	          time,
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement('i', { className: 'bi_kitchen-fork-knife' }),
	          'x ',
	          createdRequest.people,
	          ' persone'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: '/app/' + props.url.appId, style: { display: 'none' }, onClick: resetBookingState },
	      'Torna alla Home'
	    )
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    app: state.app,
	    booking: state.booking,
	    url: (0, _urlSelectors.urlSelector)(state, props)
	  };
	};
	exports.default = (0, _util.connect)(BookingEnd, { mapStateToProps: mapStateToProps });

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(35);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var message = props.ux.message,
	      actions = props.actions;
	
	
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement('div', { className: 'status-icon' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'grow', style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Non \xE8 stato possibile effettuare la prenotazione.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        message.text
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'actions' },
	      _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(_button2.default, { type: 'back', onClick: function onClick() {
	            actions.ux.setMessage(null);
	            actions.ux.setBookingFormVisible(false);
	            actions.booking.setBookingTime(null, false);
	            actions.booking.setBookingDate(null, false);
	          }
	        })
	      )
	    )
	  );
	};

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _booking = __webpack_require__(87);
	
	var _urlSelectors = __webpack_require__(26);
	
	var _util = __webpack_require__(11);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _bookingDateRow = __webpack_require__(448);
	
	var _bookingDateRow2 = _interopRequireDefault(_bookingDateRow);
	
	var _bookingError = __webpack_require__(473);
	
	var _bookingError2 = _interopRequireDefault(_bookingError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookingSelectDate = function BookingSelectDate(props) {
	  var ux = props.ux,
	      actions = props.actions,
	      bookingAvailability = props.bookingAvailability;
	
	  var targetRestaurant = props.routeParams.restaurantId;
	  var restaurant = (0, _booking.restaurantById)(props.app.merchant.restaurants, targetRestaurant);
	
	  if (ux.message.title) {
	    return _react2.default.createElement(_bookingError2.default, props);
	  }
	
	  var selectRestaurantHref = _url2.default.booking(props.url.appId);
	  var setBookingDate = function setBookingDate(data) {
	    actions.booking.setBookingDate(data);
	    _reactRouter.browserHistory.push(_url2.default.bookingDate(props.url.appId, props.url.restaurantId, data.date));
	  };
	
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 'booking-info' },
	      _react2.default.createElement(
	        'strong',
	        null,
	        restaurant.name
	      ),
	      ' \u2013 ',
	      restaurant.address,
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Scegli la data in cui vuoi prenotare.'
	    ),
	    _react2.default.createElement(
	      'ul',
	      { className: 'grow mobile-list' },
	      bookingAvailability.map(function (day) {
	        return _react2.default.createElement(_bookingDateRow2.default, _extends({}, day, {
	          date: day.date.split('T')[0],
	          key: day.date,
	          onClick: setBookingDate
	        }));
	      })
	    ),
	    _react2.default.createElement(_backButton2.default, { to: selectRestaurantHref })
	  );
	};
	
	var targetRestaurant = function targetRestaurant(state, props) {
	  return props.routeParams.restaurantId;
	};
	var connectOptions = {
	  mapStateToProps: function mapStateToProps(state, props) {
	    return _extends({}, state, {
	      url: (0, _urlSelectors.urlSelector)(state, props),
	      bookingAvailability: (0, _booking.bookingAvailabilitySelector)(targetRestaurant)(state, props)
	    });
	  }
	};
	
	exports.default = (0, _util.connect)(BookingSelectDate, connectOptions);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _booking = __webpack_require__(87);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _util = __webpack_require__(11);
	
	var _restaurantRow = __webpack_require__(212);
	
	var _restaurantRow2 = _interopRequireDefault(_restaurantRow);
	
	var _list = __webpack_require__(122);
	
	var _list2 = _interopRequireDefault(_list);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BookingStart = function BookingStart(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'p',
	      null,
	      'Scegli il ristorante presso il quale vuoi prenotare il tuo tavolo.'
	    ),
	    _react2.default.createElement(
	      _list2.default,
	      null,
	      props.filteredRestaurants.map(function (r) {
	        return _react2.default.createElement(_restaurantRow2.default, {
	          restaurant: r,
	          href: _url2.default.booking(props.params.appId),
	          key: r.id,
	          availability: r.availableForBooking
	        });
	      })
	    )
	  );
	};
	
	var connectOptions = {
	  mapStateToProps: function mapStateToProps(state, props) {
	    return _extends({}, state, {
	      filteredRestaurants: (0, _booking.filteredRestaurantsSelector)(state, props)
	    });
	  }
	};
	
	exports.default = (0, _util.connect)(BookingStart, connectOptions);

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(13);
	
	var _ristorantiFrontendLib = __webpack_require__(23);
	
	var _urlSelectors = __webpack_require__(26);
	
	var _bookingForm = __webpack_require__(213);
	
	var _bookingForm2 = _interopRequireDefault(_bookingForm);
	
	var _button = __webpack_require__(35);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _buttonsContainer = __webpack_require__(21);
	
	var _buttonsContainer2 = _interopRequireDefault(_buttonsContainer);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _numberPicker = __webpack_require__(460);
	
	var _numberPicker2 = _interopRequireDefault(_numberPicker);
	
	var _util = __webpack_require__(11);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _localized = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeRow = function TimeRow(_ref) {
	  var data = _ref.data,
	      selected = _ref.selected,
	      _onClick = _ref.onClick;
	
	  var isSelected = selected === data.value;
	  return _react2.default.createElement(
	    'li',
	    {
	      onClick: function onClick() {
	        return !isSelected && _onClick(data);
	      },
	      className: (0, _classnames2.default)({ selected: isSelected })
	    },
	    data.label
	  );
	};
	TimeRow.propTypes = {
	  selected: _propTypes2.default.string,
	  data: _propTypes2.default.shape({
	    label: _propTypes2.default.string
	  }),
	  onClick: _propTypes2.default.func
	};
	
	var BookingTimeSeats = function BookingTimeSeats(props) {
	  var booking = props.booking,
	      actions = props.actions,
	      ux = props.ux,
	      url = props.url;
	
	
	  if (ux.bookingFormVisible) {
	    return _react2.default.createElement(_bookingForm2.default, props);
	  }
	
	  var targetRestaurant = props.routeParams.restaurantId;
	  var restaurant = (0, _ristorantiFrontendLib.restaurantById)(props.app.merchant.restaurants, targetRestaurant);
	
	  var onTimeSelected = function onTimeSelected(data) {
	    return actions.booking.setBookingTime(data.value, false);
	  };
	  var updateSeats = function updateSeats(n) {
	    return actions.booking.setBookingSeats(n);
	  };
	
	  var onConfirm = function onConfirm() {
	    var checkoutUrl = _url2.default.bookingCheckout(url.appId, url.restaurantId, url.bookingDate, booking.time, booking.seats);
	    _reactRouter.browserHistory.push(checkoutUrl);
	  };
	
	  var locale = 'it';
	  var day = _ristorantiFrontendLib.TimeHelpers.weekDayLocale(booking.date.date, locale);
	  var date = _ristorantiFrontendLib.TimeHelpers.toLocalDate(booking.date.date, locale);
	
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'p',
	      { className: 'booking-info' },
	      'Prenotazione per ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        day,
	        ' ',
	        date
	      ),
	      '.',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'strong',
	        null,
	        restaurant.name
	      ),
	      ' \u2013 ',
	      restaurant.address,
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Seleziona orario e numero di posti'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'grow split-pane full' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pane' },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Orario'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Seleziona un orario'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: 'box-list' },
	          props.pickerTime.map(function (o) {
	            return _react2.default.createElement(TimeRow, { data: o, onClick: onTimeSelected, selected: booking.time, key: o.value });
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('pane', { disabled: !booking.time }) },
	        _react2.default.createElement(
	          'h4',
	          null,
	          'Numero posti ',
	          props.availableSpots && booking.seats === props.availableSpots && _react2.default.createElement(
	            'span',
	            { className: 'error' },
	            '(max posti raggiunti)'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Seleziona numero di posti'
	        ),
	        _react2.default.createElement(_numberPicker2.default, {
	          max: props.availableSpots,
	          current: booking.seats || 0,
	          update: updateSeats
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _buttonsContainer2.default,
	      null,
	      _react2.default.createElement(_backButton2.default, null),
	      _react2.default.createElement(
	        'span',
	        { className: (0, _classnames2.default)({ disabled: !booking.seats }) },
	        _react2.default.createElement(_button2.default, { type: 'submit', onClick: onConfirm })
	      )
	    )
	  );
	};
	
	var connectOptions = {
	  mapStateToProps: function mapStateToProps(state, props) {
	    return _extends({}, state, {
	      url: (0, _urlSelectors.urlSelector)(state, props),
	      availableSpots: (0, _ristorantiFrontendLib.availableSpotsSelector)(state, props),
	      pickerTime: (0, _ristorantiFrontendLib.pickerTimeSelector)(_localized.COMMON_LOCALIZED)(state, props),
	      formData: (0, _ristorantiFrontendLib.formDataSelector)(state)
	    });
	  }
	};
	
	exports.default = (0, _util.connect)(BookingTimeSeats, connectOptions);

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BookingEnd = exports.BookingTimeSeats = exports.BookingForm = exports.BookingSelectDate = exports.BookingStart = exports.BookingContainer = undefined;
	
	var _bookingContainer = __webpack_require__(471);
	
	var _bookingContainer2 = _interopRequireDefault(_bookingContainer);
	
	var _bookingStart = __webpack_require__(475);
	
	var _bookingStart2 = _interopRequireDefault(_bookingStart);
	
	var _bookingSelectDate = __webpack_require__(474);
	
	var _bookingSelectDate2 = _interopRequireDefault(_bookingSelectDate);
	
	var _bookingForm = __webpack_require__(213);
	
	var _bookingForm2 = _interopRequireDefault(_bookingForm);
	
	var _bookingTimeSeats = __webpack_require__(476);
	
	var _bookingTimeSeats2 = _interopRequireDefault(_bookingTimeSeats);
	
	var _bookingEnd = __webpack_require__(472);
	
	var _bookingEnd2 = _interopRequireDefault(_bookingEnd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BookingContainer = _bookingContainer2.default;
	exports.BookingStart = _bookingStart2.default;
	exports.BookingSelectDate = _bookingSelectDate2.default;
	exports.BookingForm = _bookingForm2.default;
	exports.BookingTimeSeats = _bookingTimeSeats2.default;
	exports.BookingEnd = _bookingEnd2.default;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OrderNoDelivery = exports.OrderEnd = exports.OrderPayment = exports.OrderCheckout = exports.OrderVoucher = exports.OrderCart = exports.Menu = exports.OrderSelectDateTime = exports.OrderDeliveryAddress = exports.OrderTakeAway = exports.OrderDelivery = exports.OrderStartWrapper = exports.OrderStart = exports.OrderContainer = undefined;
	
	__webpack_require__(772);
	
	var _orderContainer = __webpack_require__(482);
	
	var _orderContainer2 = _interopRequireDefault(_orderContainer);
	
	var _orderStart = __webpack_require__(489);
	
	var _orderStart2 = _interopRequireDefault(_orderStart);
	
	var _orderStartWrapper = __webpack_require__(488);
	
	var _orderStartWrapper2 = _interopRequireDefault(_orderStartWrapper);
	
	var _orderDelivery = __webpack_require__(214);
	
	var _orderDelivery2 = _interopRequireDefault(_orderDelivery);
	
	var _orderTakeaway = __webpack_require__(215);
	
	var _orderTakeaway2 = _interopRequireDefault(_orderTakeaway);
	
	var _orderDeliveryAddress = __webpack_require__(483);
	
	var _orderDeliveryAddress2 = _interopRequireDefault(_orderDeliveryAddress);
	
	var _orderSelectDatetime = __webpack_require__(487);
	
	var _orderSelectDatetime2 = _interopRequireDefault(_orderSelectDatetime);
	
	var _menu = __webpack_require__(479);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _orderCart = __webpack_require__(480);
	
	var _orderCart2 = _interopRequireDefault(_orderCart);
	
	var _orderCheckout = __webpack_require__(481);
	
	var _orderCheckout2 = _interopRequireDefault(_orderCheckout);
	
	var _orderVoucher = __webpack_require__(490);
	
	var _orderVoucher2 = _interopRequireDefault(_orderVoucher);
	
	var _orderPayment = __webpack_require__(486);
	
	var _orderPayment2 = _interopRequireDefault(_orderPayment);
	
	var _orderEnd = __webpack_require__(484);
	
	var _orderEnd2 = _interopRequireDefault(_orderEnd);
	
	var _orderNoDelivery = __webpack_require__(485);
	
	var _orderNoDelivery2 = _interopRequireDefault(_orderNoDelivery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.OrderContainer = _orderContainer2.default;
	exports.OrderStart = _orderStart2.default;
	exports.OrderStartWrapper = _orderStartWrapper2.default;
	exports.OrderDelivery = _orderDelivery2.default;
	exports.OrderTakeAway = _orderTakeaway2.default;
	exports.OrderDeliveryAddress = _orderDeliveryAddress2.default;
	exports.OrderSelectDateTime = _orderSelectDatetime2.default;
	exports.Menu = _menu2.default;
	exports.OrderCart = _orderCart2.default;
	exports.OrderVoucher = _orderVoucher2.default;
	exports.OrderCheckout = _orderCheckout2.default;
	exports.OrderPayment = _orderPayment2.default;
	exports.OrderEnd = _orderEnd2.default;
	exports.OrderNoDelivery = _orderNoDelivery2.default;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _ristorantiFrontendLib = __webpack_require__(23);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _cart = __webpack_require__(64);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _constants = __webpack_require__(9);
	
	var _util = __webpack_require__(11);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _urlSelectors = __webpack_require__(26);
	
	var _orderSelectors = __webpack_require__(54);
	
	var _spinner = __webpack_require__(53);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _scrollview = __webpack_require__(469);
	
	var _scrollview2 = _interopRequireDefault(_scrollview);
	
	var _menu = __webpack_require__(455);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _buttonsContainer = __webpack_require__(21);
	
	var _buttonsContainer2 = _interopRequireDefault(_buttonsContainer);
	
	var _orderRecap = __webpack_require__(90);
	
	var _orderRecap2 = _interopRequireDefault(_orderRecap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menu = function (_React$Component) {
	  _inherits(Menu, _React$Component);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
	  }
	
	  _createClass(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var restaurantId = this.props.url.restaurantId;
	      var _props = this.props,
	          app = _props.app,
	          actions = _props.actions,
	          services = _props.services;
	
	      services.order.loadMenu(app.id, restaurantId, actions.order);
	
	      this.renderCategory = this.renderCategory.bind(this);
	      this.addToCart = this.addToCart.bind(this);
	      this.goToCart = this.goToCart.bind(this);
	    }
	  }, {
	    key: 'addToCart',
	    value: function addToCart(item) {
	      this.props.actions.order.addToCart(item);
	    }
	  }, {
	    key: 'goToCart',
	    value: function goToCart() {
	      _reactRouter.browserHistory.push(_url2.default.orderCart(_extends({}, this.props.url)));
	    }
	  }, {
	    key: 'renderCategory',
	    value: function renderCategory(name) {
	      var _this2 = this;
	
	      var items = this.props.menu.itemsGrouped[name];
	      return _react2.default.createElement(
	        _menu.MenuItemCategory,
	        { name: name, key: name },
	        items.map(function (item) {
	          return _react2.default.createElement(_menu.MenuItem, _extends({
	            key: item.id
	          }, item, {
	            quantity: _cart2.default.itemQuantity(_this2.props.order.cart, item),
	            onSelect: _this2.addToCart
	          }));
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          url = _props2.url,
	          order = _props2.order,
	          menu = _props2.menu;
	
	      var categories = menu.categoriesCollapsed;
	      var isDelivery = url.orderType === _constants.ORDER_TYPE_DELIVERY;
	      var threshold = order.deliveryAreaCustomThreshold || 0;
	      var cartTotal = _cart2.default.total(order.cart);
	      var buttonDisabled = !this.props.orderOvercomeThreshold;
	      if (this.props.isFetching) {
	        return _react2.default.createElement(
	          'main',
	          { className: 'centerChildren' },
	          _react2.default.createElement(_spinner2.default, { size: 'large' })
	        );
	      }
	      return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(
	          'header',
	          { className: 'menuHeader' },
	          _react2.default.createElement(_orderRecap2.default, {
	            date: url.orderDate,
	            location: this.props.orderAddress
	          }),
	          _react2.default.createElement(_menu.CartButton, {
	            disabled: buttonDisabled,
	            total: _i18n2.default.formatPrice(cartTotal),
	            text: 'INVIA ORDINE',
	            onClick: this.goToCart
	          })
	        ),
	        _react2.default.createElement(
	          _scrollview2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'menuContainer' },
	            categories.map(function (cat) {
	              return _this3.renderCategory(cat.name);
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _buttonsContainer2.default,
	          null,
	          _react2.default.createElement(_backButton2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return _extends({}, state, {
	    isFetching: state.order.menuIsFetching,
	    menu: (0, _ristorantiFrontendLib.menuSelector)(state, props),
	    url: (0, _urlSelectors.urlSelector)(state, props),
	    orderAddress: (0, _orderSelectors.orderLocationAddressSelector)(state, props).address,
	    orderOvercomeThreshold: (0, _orderSelectors.orderOvercomeThreshold)(state, props)
	  });
	};
	
	exports.default = (0, _util.connect)(Menu, { mapStateToProps: mapStateToProps });

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(13);
	
	var _order = __webpack_require__(198);
	
	var _localized = __webpack_require__(43);
	
	var _util = __webpack_require__(11);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _buttonsContainer = __webpack_require__(21);
	
	var _buttonsContainer2 = _interopRequireDefault(_buttonsContainer);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _button = __webpack_require__(35);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _orderRecap = __webpack_require__(90);
	
	var _orderRecap2 = _interopRequireDefault(_orderRecap);
	
	var _urlSelectors = __webpack_require__(26);
	
	var _orderSelectors = __webpack_require__(54);
	
	var _cart = __webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderCart = function (_React$Component) {
	  _inherits(OrderCart, _React$Component);
	
	  function OrderCart(props) {
	    _classCallCheck(this, OrderCart);
	
	    var _this = _possibleConstructorReturn(this, (OrderCart.__proto__ || Object.getPrototypeOf(OrderCart)).call(this, props));
	
	    _this.onRemoveFromCart = _this.onRemoveFromCart.bind(_this);
	    _this.goToCheckout = _this.goToCheckout.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderCart, [{
	    key: 'onRemoveFromCart',
	    value: function onRemoveFromCart(item) {
	      this.props.actions.order.removeFromCart(item);
	    }
	  }, {
	    key: 'goToCheckout',
	    value: function goToCheckout() {
	      if (!this.props.orderOvercomeThreshold) return;
	      _reactRouter.browserHistory.push(_url2.default.orderUserVoucher(_extends({}, this.props.url)));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cartObject = this.props.cartObject;
	      return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(
	          'h4',
	          { className: 'viewTitle' },
	          'IL TUO ORDINE'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cartContainer' },
	          _react2.default.createElement(_cart.Cart, {
	            items: cartObject.cart,
	            extraCosts: cartObject.extraCosts,
	            onRemove: this.onRemoveFromCart,
	            subtotal: cartObject.subtotal,
	            total: cartObject.total
	          })
	        ),
	        _react2.default.createElement(
	          'footer',
	          { className: 'cartFooter' },
	          _react2.default.createElement(_orderRecap2.default, {
	            date: this.props.url.orderDate,
	            location: this.props.orderAddress
	          })
	        ),
	        _react2.default.createElement(
	          _buttonsContainer2.default,
	          null,
	          _react2.default.createElement(_backButton2.default, null),
	          _react2.default.createElement(_button2.default, {
	            type: 'next',
	            text: 'CONTINUA',
	            disabled: !this.props.orderOvercomeThreshold,
	            onClick: this.goToCheckout
	          })
	        )
	      );
	    }
	  }]);
	
	  return OrderCart;
	}(_react2.default.Component);
	
	OrderCart.propTypes = {
	  orderOvercomeThreshold: _propTypes2.default.bool.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return _extends({}, state, {
	    url: (0, _urlSelectors.urlSelector)(state, props),
	    orderAddress: (0, _orderSelectors.orderLocationAddressSelector)(state, props).address,
	    cartObject: (0, _order.orderObjectSelector)(_localized.COMMON_LOCALIZED)(state, props),
	    orderOvercomeThreshold: (0, _orderSelectors.orderOvercomeThreshold)(state, props)
	  });
	};
	
	exports.default = (0, _util.connect)(OrderCart, { mapStateToProps: mapStateToProps });

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(9);
	
	var _util = __webpack_require__(11);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _user = __webpack_require__(123);
	
	var _orderSelectors = __webpack_require__(54);
	
	var _googleMap = __webpack_require__(120);
	
	var _googleMap2 = _interopRequireDefault(_googleMap);
	
	var _orderRecap = __webpack_require__(90);
	
	var _orderRecap2 = _interopRequireDefault(_orderRecap);
	
	var _buttonsContainer = __webpack_require__(21);
	
	var _buttonsContainer2 = _interopRequireDefault(_buttonsContainer);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _orderTakeawayForm = __webpack_require__(463);
	
	var _orderTakeawayForm2 = _interopRequireDefault(_orderTakeawayForm);
	
	var _orderDeliveryForm = __webpack_require__(461);
	
	var _orderDeliveryForm2 = _interopRequireDefault(_orderDeliveryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var formBaseConfig = [{
	  label: 'Telefono',
	  name: 'phoneNumber',
	  format: 'phoneNumber',
	  placeholder: '1234567',
	  initialValue: '',
	  isRequired: true
	}, {
	  label: 'E-mail',
	  name: 'email',
	  format: 'email',
	  placeholder: 'nome@provider.ext',
	  initialValue: '',
	  isRequired: true
	}, {
	  label: 'Note',
	  name: 'extraInfo',
	  format: 'text',
	  placeholder: 'Richieste aggiuntive',
	  initialValue: '',
	  isRequired: false
	}];
	
	var OrderCheckout = function (_React$Component) {
	  _inherits(OrderCheckout, _React$Component);
	
	  function OrderCheckout(props) {
	    _classCallCheck(this, OrderCheckout);
	
	    var _this = _possibleConstructorReturn(this, (OrderCheckout.__proto__ || Object.getPrototypeOf(OrderCheckout)).call(this, props));
	
	    _this.goToPayment = _this.goToPayment.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderCheckout, [{
	    key: 'goToPayment',
	    value: function goToPayment(formData) {
	      var data = _lodash2.default.omit(formData, ['extraInfo']);
	      if (formData.extraInfo.length > 0) {
	        data.extraInfo = formData.extraInfo;
	      }
	      this.props.actions.order.setDeliveryData(_extends({}, data, this.props.order.deliveryAddress));
	      _reactRouter.browserHistory.push(_url2.default.orderPayment(this.props.url));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var user = this.props.user.currentUser || {};
	      var orderLocation = this.props.orderLocation;
	      var orderType = this.props.url.orderType;
	      var orderDate = this.props.url.orderDate;
	      return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Ci servono alcune informazioni aggiuntive per concludere l\'ordine'
	          ),
	          _react2.default.createElement(_orderRecap2.default, {
	            date: orderDate,
	            location: orderLocation.address
	          }),
	          _react2.default.createElement(_googleMap2.default, {
	            markers: [orderLocation.coords],
	            center: orderLocation.coords
	          })
	        ),
	        orderType === _constants.ORDER_TYPE_TAKEAWAY && _react2.default.createElement(_orderTakeawayForm2.default, {
	          baseConfig: formBaseConfig,
	          initialData: user,
	          onSave: this.goToPayment
	        }),
	        orderType === _constants.ORDER_TYPE_DELIVERY && _react2.default.createElement(_orderDeliveryForm2.default, {
	          baseConfig: formBaseConfig,
	          initialData: user,
	          onSave: this.goToPayment
	        }),
	        _react2.default.createElement(
	          _buttonsContainer2.default,
	          null,
	          _react2.default.createElement(_backButton2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return OrderCheckout;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    url: props.url,
	    user: state.user,
	    order: state.order,
	    orderLocation: (0, _orderSelectors.orderLocationAddressSelector)(state, props)
	  };
	};
	
	exports.default = (0, _user.userRequired)((0, _util.connect)(OrderCheckout, { mapStateToProps: mapStateToProps }));

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(76);
	
	var _loadingContainer = __webpack_require__(211);
	
	var _loadingContainer2 = _interopRequireDefault(_loadingContainer);
	
	var _header = __webpack_require__(121);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _orderSteps = __webpack_require__(462);
	
	var _orderSteps2 = _interopRequireDefault(_orderSteps);
	
	var _urlSelectors = __webpack_require__(26);
	
	var _orderSelectors = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderContainer = function OrderContainer(props) {
	  var app = props.app,
	      currentStep = props.currentStep;
	
	  var isFetching = app.isFetching;
	  return _react2.default.createElement(
	    _loadingContainer2.default,
	    { isLoading: isFetching, dispatch: props.dispatch },
	    _react2.default.createElement(
	      _header2.default,
	      null,
	      'Ordina ',
	      _react2.default.createElement(
	        'span',
	        null,
	        'online'
	      )
	    ),
	    _react2.default.createElement(_orderSteps2.default, { current: currentStep }),
	    _react2.default.Children.map(props.children, function (child) {
	      return _react2.default.cloneElement(child, { app: app, url: props.url });
	    })
	  );
	};
	
	OrderContainer.propTypes = {
	  currentStep: _propTypes2.default.number,
	  dispatch: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)])
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return _extends({}, state, {
	    url: (0, _urlSelectors.urlSelector)(state, props),
	    currentStep: (0, _orderSelectors.orderStepSelector)(state, props)
	  });
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(OrderContainer);

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _arreebaForm = __webpack_require__(164);
	
	var _common = __webpack_require__(88);
	
	var _location = __webpack_require__(50);
	
	var _location2 = _interopRequireDefault(_location);
	
	var _util = __webpack_require__(11);
	
	var _googleMap = __webpack_require__(120);
	
	var _googleMap2 = _interopRequireDefault(_googleMap);
	
	var _addressFormHelpers = __webpack_require__(496);
	
	var _addressFormHelpers2 = _interopRequireDefault(_addressFormHelpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderDeliveryAddress = function (_React$Component) {
	  _inherits(OrderDeliveryAddress, _React$Component);
	
	  function OrderDeliveryAddress(props) {
	    _classCallCheck(this, OrderDeliveryAddress);
	
	    var _this = _possibleConstructorReturn(this, (OrderDeliveryAddress.__proto__ || Object.getPrototypeOf(OrderDeliveryAddress)).call(this, props));
	
	    _this.tmpLocation = {};
	    var prevLocation = _this.props.order.deliveryLocation;
	    var prevAddress = _this.props.order.deliveryAddress;
	    _this.formConfig = _addressFormHelpers2.default.getConfig(prevLocation, prevAddress);
	
	    // if a deliveryLocation has been set up, the user is updating
	    // an address (e.g. after geolocation)
	    var location = prevLocation ? _extends({}, prevLocation.geometry.location) : null;
	    _this.state = {
	      location: location,
	      errors: {}
	    };
	
	    _this.onLocationChange = _this.onLocationChange.bind(_this);
	    _this.checkDeliveryAddress = _this.checkDeliveryAddress.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderDeliveryAddress, [{
	    key: 'onLocationChange',
	    value: function onLocationChange(arg) {
	      if (arg.name === 'location.latitude') {
	        this.tmpLocation.latitude = arg.value;
	      }
	      if (arg.name === 'location.longitude') {
	        this.tmpLocation.longitude = arg.value;
	      }
	
	      if (this.tmpLocation.latitude && this.tmpLocation.longitude) {
	        this.setState({
	          location: {
	            lat: this.tmpLocation.latitude,
	            lng: this.tmpLocation.longitude
	          }
	        });
	        this.tmpLocation = {};
	      }
	    }
	  }, {
	    key: 'checkDeliveryAddress',
	    value: function checkDeliveryAddress(data) {
	      var errors = (0, _arreebaForm.validateForm)(data, this.formConfig);
	      if (!(0, _arreebaForm.isFormValid)(errors)) {
	        this.setState({ errors: errors });
	        return;
	      }
	      var _data$location = data.location,
	          latitude = _data$location.latitude,
	          longitude = _data$location.longitude;
	
	      var description = _location2.default.formatAddressDescription(data.address);
	      var location = _location2.default.deliveryAddressFactory(description, latitude, longitude, data.address);
	      this.props.services.order.deliveryAddressCheck(this.props.app.id, location, this.props.actions.order);
	      this.props.actions.order.setDeliveryAddress(location);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var coord = this.state.location ? this.state.location : this.props.defaultCoord;
	      var markers = this.state.location ? [this.state.location] : [];
	
	      return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'deliveryAddress__map' },
	          _react2.default.createElement(_googleMap2.default, {
	            markers: markers,
	            center: coord
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'deliveryAddress__autocomplete' },
	          _react2.default.createElement(_arreebaForm.Form, {
	            data: this.formConfig,
	            errors: this.state.errors,
	            onSave: this.checkDeliveryAddress,
	            onSubmit: this.checkDeliveryAddress,
	            submitButtonLabel: 'CONTINUA',
	            submitClassNames: ['btn-submit']
	          })
	        )
	      );
	    }
	  }]);
	
	  return OrderDeliveryAddress;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    url: props.url,
	    app: state.app,
	    user: state.user,
	    order: state.order,
	    defaultCoord: (0, _common.restaurantsCoordinatesMedian)(state, props)
	  };
	};
	
	exports.default = (0, _util.connect)(OrderDeliveryAddress, { mapStateToProps: mapStateToProps });

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ristorantiFrontendLib = __webpack_require__(23);
	
	var _localized = __webpack_require__(43);
	
	var _util = __webpack_require__(11);
	
	var _orderSelectors = __webpack_require__(54);
	
	var _urlSelectors = __webpack_require__(26);
	
	var _cart = __webpack_require__(210);
	
	var _orderRecap = __webpack_require__(90);
	
	var _orderRecap2 = _interopRequireDefault(_orderRecap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global alert */
	
	
	var OrderStatus = function OrderStatus(props) {
	  var classes = (0, _classnames2.default)('orderEndStatus', 'orderEndStatus--' + props.status);
	  return _react2.default.createElement(
	    'div',
	    { className: classes },
	    _react2.default.createElement('i', { className: props.icon }),
	    _react2.default.createElement(
	      'h4',
	      null,
	      props.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'orderEndStatus__content' },
	      props.children
	    )
	  );
	};
	OrderStatus.propTypes = {
	  title: _propTypes2.default.string,
	  status: _propTypes2.default.oneOf(['pending', 'confirmed', 'denied']),
	  icon: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	var OrderEndPending = function OrderEndPending(props) {
	  var deliveryOrTakeaway = props.orderType === 'delivery' ? 'consegna' : 'ritiro';
	  var total = props.total;
	  var subtotal = props.subtotal;
	  var extraCosts = props.extraCosts;
	  var items = props.cart;
	  return _react2.default.createElement(
	    OrderStatus,
	    {
	      title: 'il tuo ordine \xE8 stato inviato al ristorante',
	      status: 'pending',
	      icon: 'bi_com-paperplane'
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'A breve ti verr\xE0 confermato l\'orario di ',
	        deliveryOrTakeaway,
	        ', segui qui lo stato del tuo ordine'
	      ),
	      _react2.default.createElement(_cart.Cart, {
	        items: items,
	        subtotal: subtotal,
	        total: total,
	        extraCosts: extraCosts
	      }),
	      _react2.default.createElement(_orderRecap2.default, {
	        date: props.orderDate,
	        location: props.orderAddress
	      })
	    )
	  );
	};
	
	var OrderEndConfirmed = function OrderEndConfirmed(props) {
	  var total = props.total;
	  var subtotal = props.subtotal;
	  var extraCosts = props.extraCosts;
	  var items = props.cart;
	  return _react2.default.createElement(
	    OrderStatus,
	    {
	      title: 'il tuo ordine \xE8 stato confermato',
	      status: 'confirmed',
	      icon: 'bi_interface-circle-tick'
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_cart.Cart, {
	        items: items,
	        subtotal: subtotal,
	        total: total,
	        extraCosts: extraCosts
	      }),
	      _react2.default.createElement(_orderRecap2.default, {
	        date: props.confirmationDate,
	        location: props.orderAddress
	      })
	    )
	  );
	};
	
	var OrderEndDenied = function OrderEndDenied(props) {
	  return _react2.default.createElement(
	    OrderStatus,
	    {
	      title: 'il tuo ordine \xE8 stato annullato',
	      status: 'denied',
	      icon: 'bi_misc-mood-sad'
	    },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Il ristorante non pu\xF2 prendere in carico il tuo ordine in questo momento.'
	    )
	  );
	};
	
	var statusMap = {
	  PENDING: OrderEndPending,
	  DECLINED: OrderEndDenied,
	  CONFIRMED: OrderEndConfirmed
	};
	
	var OrderEnd = function (_React$Component) {
	  _inherits(OrderEnd, _React$Component);
	
	  function OrderEnd(props) {
	    _classCallCheck(this, OrderEnd);
	
	    var _this = _possibleConstructorReturn(this, (OrderEnd.__proto__ || Object.getPrototypeOf(OrderEnd)).call(this, props));
	
	    _this.updateOrderStatus = _this.updateOrderStatus.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderEnd, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateOrderStatus();
	    }
	  }, {
	    key: 'updateOrderStatus',
	    value: function updateOrderStatus() {
	      var _this2 = this;
	
	      this.props.services.order.updateCurrentOrder(this.props.app.id, this.props.order.currentOrder.id, this.props.actions.order);
	      setTimeout(function () {
	        if (_this2.props.order.currentOrder.status === 'PENDING') {
	          _this2.updateOrderStatus();
	        }
	      }, 10000);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var orderObject = this.props.orderObject;
	      var currentOrder = this.props.order.currentOrder;
	      var extraCosts = orderObject.extraCosts;
	      var orderAddress = this.props.orderLocation.address;
	      var orderType = this.props.url.orderType;
	      var orderDate = this.props.url.orderDate;
	      var confirmationDate = currentOrder.confirmation ? currentOrder.confirmation.date : '';
	      var data = {
	        orderType: orderType,
	        orderDate: orderDate,
	        orderAddress: orderAddress,
	        confirmationDate: confirmationDate,
	        cart: orderObject.cart,
	        extraCosts: extraCosts,
	        subtotal: orderObject.subtotal,
	        total: orderObject.total
	      };
	      var status = currentOrder.status;
	      var StatusView = statusMap[status];
	
	      if (!StatusView) {
	        this.props.actions.ux.setMessage({
	          title: 'Errore',
	          text: 'Si è verificato un errore imprevisto',
	          type: 'error'
	        });
	        return _react2.default.createElement(
	          'div',
	          null,
	          'error'
	        );
	      }
	
	      return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(StatusView, data)
	      );
	    }
	  }]);
	
	  return OrderEnd;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    app: state.app,
	    order: state.order,
	    url: (0, _urlSelectors.urlSelector)(state, props),
	    orderLocation: (0, _orderSelectors.orderLocationAddressSelector)(state, props),
	    orderObject: (0, _ristorantiFrontendLib.orderObjectSelector)(_localized.COMMON_LOCALIZED)(state, props)
	  };
	};
	exports.default = (0, _util.connect)(OrderEnd, { mapStateToProps: mapStateToProps });

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(9);
	
	var _util = __webpack_require__(11);
	
	var _button = __webpack_require__(35);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderNoDelivery = function OrderNoDelivery(props) {
	  if (props.serviceOffline) {
	    return _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'noDelivery' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'noDelivery__title' },
	          'Gli ordini di ',
	          props.appName,
	          ' sono momentaneamente sospesi!'
	        )
	      )
	    );
	  }
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'noDelivery' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'noDelivery__title' },
	        props.appName,
	        ' non consegna nella tua zona!'
	      ),
	      props.isTakeAwayAvailable && _react2.default.createElement(
	        'div',
	        { className: 'noDelivery__block' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Puoi comunque procedere con un ordine da asporto.'
	        ),
	        _react2.default.createElement(_button2.default, {
	          type: 'next',
	          onClick: function onClick() {
	            return _reactRouter.browserHistory.push(_url2.default.orderTakeAway(props.url.appId));
	          },
	          text: 'ASPORTO'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'noDelivery__block' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'oppure scegli un\'altro indirizzo'
	        ),
	        _react2.default.createElement(_button2.default, {
	          type: 'next',
	          onClick: function onClick() {
	            return _reactRouter.browserHistory.push(_url2.default.orderDelivery(props.url.appId));
	          },
	          text: 'ALTRO INDIRIZZO'
	        })
	      )
	    )
	  );
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    appName: state.app.config.name,
	    url: props.url,
	    config: state.app.config,
	    serviceOffline: props.location.query.offline,
	    isTakeAwayAvailable: _lodash2.default.indexOf(state.app.config.order.types, _constants.ORDER_TYPE_TAKEAWAY) > -1
	  };
	};
	exports.default = (0, _util.connect)(OrderNoDelivery, { mapStateToProps: mapStateToProps });

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PropTypes$shape;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  query stripePaymentIntent(\n      $appId: ID!,\n      $restaurant: ID!,\n      $cartTotal: Int!,\n    ){\n    app(id: $appId) {\n      id\n      stripePaymentIntent(\n        cartTotal: $cartTotal,\n        restaurant: $restaurant,\n      )\n    }\n  }'], ['\n  query stripePaymentIntent(\n      $appId: ID!,\n      $restaurant: ID!,\n      $cartTotal: Int!,\n    ){\n    app(id: $appId) {\n      id\n      stripePaymentIntent(\n        cartTotal: $cartTotal,\n        restaurant: $restaurant,\n      )\n    }\n  }']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactStripeElements = __webpack_require__(152);
	
	var _reactApollo = __webpack_require__(262);
	
	var _graphqlTag = __webpack_require__(229);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _ristorantiFrontendLib = __webpack_require__(23);
	
	var _voucher = __webpack_require__(33);
	
	var _voucher2 = _interopRequireDefault(_voucher);
	
	var _cart = __webpack_require__(64);
	
	var _cart2 = _interopRequireDefault(_cart);
	
	var _constants = __webpack_require__(9);
	
	var _user = __webpack_require__(116);
	
	var _localized = __webpack_require__(43);
	
	var _util = __webpack_require__(11);
	
	var _spinner = __webpack_require__(53);
	
	var _spinner2 = _interopRequireDefault(_spinner);
	
	var _buttonsContainer = __webpack_require__(21);
	
	var _buttonsContainer2 = _interopRequireDefault(_buttonsContainer);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _button = __webpack_require__(35);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _paymentHeader = __webpack_require__(466);
	
	var _paymentHeader2 = _interopRequireDefault(_paymentHeader);
	
	var _unhandled = __webpack_require__(468);
	
	var _unhandled2 = _interopRequireDefault(_unhandled);
	
	var _savedCreditCard = __webpack_require__(467);
	
	var _savedCreditCard2 = _interopRequireDefault(_savedCreditCard);
	
	var _addStripeCreditCard = __webpack_require__(465);
	
	var _addStripeCreditCard2 = _interopRequireDefault(_addStripeCreditCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* global location */
	
	
	var STRIPE_PAYMENT_INTENT_QUERY = (0, _graphqlTag2.default)(_templateObject);
	
	var OrderPayment = function (_React$Component) {
	  _inherits(OrderPayment, _React$Component);
	
	  function OrderPayment(props) {
	    _classCallCheck(this, OrderPayment);
	
	    var _this = _possibleConstructorReturn(this, (OrderPayment.__proto__ || Object.getPrototypeOf(OrderPayment)).call(this, props));
	
	    _this.selectUnhandled = _this.selectUnhandled.bind(_this);
	    _this.selectSavedCard = _this.selectSavedCard.bind(_this);
	    _this.selectNewCard = _this.selectNewCard.bind(_this);
	    _this.createOrder = _this.createOrder.bind(_this);
	    _this.storeOrder = _this.storeOrder.bind(_this);
	    _this.resetState = _this.resetState.bind(_this);
	
	    _this.state = {
	      selectedCardId: null,
	      showNewCardForm: false
	    };
	    return _this;
	  }
	
	  _createClass(OrderPayment, [{
	    key: 'getTotal',
	    value: function getTotal() {
	      var _props = this.props,
	          order = _props.order,
	          orderType = _props.orderType,
	          voucher = _props.voucher,
	          url = _props.url;
	
	
	      return order.selectedVoucher ? _voucher2.default.cartTotalWithVoucher(order.cart, order.extraCosts[url.orderType], order.selectedVoucher, voucher.instances || []) : _cart2.default.total(order.cart, order.extraCosts[url.orderType]);
	    }
	  }, {
	    key: 'resetState',
	    value: function resetState() {
	      this.setState({
	        selectedCardId: null,
	        showNewCardForm: false
	      });
	    }
	  }, {
	    key: 'selectUnhandled',
	    value: function selectUnhandled(value) {
	      var amount = !value ? this.props.unhandledData[0].value : value;
	      this.setState({
	        selectedCardId: null,
	        showNewCardForm: false
	      });
	      this.props.actions.order.setPaymentUnhandled(parseInt(amount, 10));
	    }
	  }, {
	    key: 'selectSavedCard',
	    value: function selectSavedCard(cardId) {
	      this.props.actions.order.setPaymentCreditCard();
	      this.setState({
	        selectedCardId: cardId,
	        showNewCardForm: false
	      });
	    }
	  }, {
	    key: 'selectNewCard',
	    value: function selectNewCard() {
	      this.props.actions.order.setPaymentCreditCard();
	      this.setState({
	        selectedCardId: null,
	        showNewCardForm: true
	      });
	    }
	  }, {
	    key: 'createOrder',
	    value: function createOrder() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          stripe = _props2.stripe,
	          order = _props2.order;
	
	      var noCard = !this.state.selectedCardId;
	      var noCash = !order.unhandledExpectedAmount;
	      var noNewCard = !this.state.showNewCardForm;
	
	      var orderActions = this.props.actions.order;
	
	      if (noCard && noCash && noNewCard) {
	        alert('Seleziona un metodo di pagamento per proseguire');
	        return;
	      }
	
	      // unhandled
	      if (order.unhandledExpectedAmount) {
	        this.storeOrder({ cashAmount: order.unhandledExpectedAmount });
	        return;
	      }
	
	      if (this.props.availablePayments[_constants.PAYMENT_METHOD_CC] && this.props.app.config.payments.nexi) {
	        // nexi
	        // TODO this.storeOrder({ cardId: this.state.selectedCardId });
	      } else {
	        this.setState({ stripeLoading: true });
	        this.props.apolloClient.query({
	          query: STRIPE_PAYMENT_INTENT_QUERY,
	          variables: {
	            appId: this.props.app.id,
	            cartTotal: this.getTotal(),
	            restaurant: this.props.url.restaurantId
	          },
	          fetchPolicy: 'no-cache'
	        }).then(function (_ref) {
	          var data = _ref.data;
	
	          var paymentIntentId = data && data.app && data.app[0] && data.app[0].stripePaymentIntent;
	          // console.log('intent from api ' + paymentIntent);
	          var paymentMethodId = _this2.state.selectedCardId;
	
	
	          stripe.handleCardPayment(paymentIntentId, _extends({}, paymentMethodId ? { payment_method: paymentMethodId } : { save_payment_method: true })).then(function (response) {
	            _this2.setState({ stripeLoading: false });
	            if (response.error) {
	              var message = 'Si è verificato un problema con il pagamento.';
	              orderActions.storeOrderFailure([{ message: message }]);
	            } else if (response.paymentIntent && response.paymentIntent.status === 'requires_capture') {
	              _this2.storeOrder({ stripePaymentIntentId: response.paymentIntent.id });
	            }
	          }).catch(function (error) {
	            _this2.setState({ stripeLoading: false });
	            var message = 'Si è verificato un problema con il pagamento.';
	            orderActions.storeOrderFailure([{ message: message }]);
	          });
	        }).catch(function (error) {
	          _this2.setState({ stripeLoading: false });
	          var message = 'Si è verificato un problema con il pagamento.';
	          orderActions.storeOrderFailure([{ message: message }]);
	        });
	      }
	
	      // const selectedCardId = this.state.selectedCardId;
	      // const data = selectedCardId && selectedCardId !== TMP_NEW_CARD ?
	      //   { cardId: this.state.selectedCardId } :
	      //   { card: this.state.newCardData };
	
	      // this.storeOrder(data);
	    }
	  }, {
	    key: 'storeOrder',
	    value: function storeOrder(data) {
	      var _props3 = this.props,
	          services = _props3.services,
	          app = _props3.app,
	          order = _props3.order,
	          user = _props3.user,
	          voucher = _props3.voucher,
	          url = _props3.url;
	
	      var orderActions = this.props.actions.order;
	      var orderData = {
	        app: app,
	        order: _extends({}, order, {
	          orderType: url.orderType,
	          orderDate: url.orderDate,
	          targetRestaurant: url.restaurantId,
	          sourceType: 'web',
	          source: location.hostname
	        }),
	        user: user.currentUser,
	        userVouchers: voucher.instances
	      };
	      services.order.createOrder(app.id, _extends({}, orderData, data), orderActions).catch(function (errors) {
	        console.log(errors);
	        var message = 'Si è verificato un problema con il pagamento.';
	        orderActions.storeOrderFailure([{ message: message }]);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var stripeLoading = this.state.stripeLoading;
	
	
	      return _react2.default.createElement(
	        _reactApollo.ApolloProvider,
	        { client: this.props.apolloClient },
	        _react2.default.createElement(
	          'main',
	          null,
	          _react2.default.createElement(_paymentHeader2.default, null),
	          this.props.user.isFetching || this.props.order.isFetching ? _react2.default.createElement(
	            'div',
	            { className: 'paymentContainer container--loading' },
	            _react2.default.createElement(_spinner2.default, { size: 'large', text: 'Pagamento in corso...' })
	          ) : _react2.default.createElement(
	            'div',
	            { className: 'paymentContainer' },
	            this.props.availablePayments[_constants.PAYMENT_METHOD_CC] && this.props.userCreditCards.map(function (card) {
	              return _react2.default.createElement(_savedCreditCard2.default, _extends({}, card, {
	                key: card.id,
	                active: _this3.state.selectedCardId === card.id,
	                onSelect: function onSelect() {
	                  return _this3.selectSavedCard(card.id);
	                }
	              }));
	            }),
	            this.props.availablePayments[_constants.PAYMENT_METHOD_CC] && !(this.props.app.config.payments && this.props.app.config.payments.nexi) && // stripe
	            _react2.default.createElement(_addStripeCreditCard2.default, {
	              active: this.state.showNewCardForm,
	              onSelect: this.selectNewCard
	            }),
	            this.props.availablePayments[_constants.PAYMENT_UNHANDLED] && _react2.default.createElement(_unhandled2.default, {
	              values: this.props.unhandledData,
	              active: this.props.order.unhandledExpectedAmount !== null,
	              onSelect: this.selectUnhandled
	            })
	          ),
	          _react2.default.createElement(
	            _buttonsContainer2.default,
	            null,
	            _react2.default.createElement(_backButton2.default, null),
	            _react2.default.createElement(_button2.default, {
	              type: 'next',
	              text: 'CONTINUA',
	              disabled: stripeLoading,
	              onClick: this.createOrder
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrderPayment;
	}(_react2.default.Component);
	
	OrderPayment.propTypes = {
	  availablePayments: _propTypes2.default.shape((_PropTypes$shape = {}, _defineProperty(_PropTypes$shape, _constants.PAYMENT_UNHANDLED, _propTypes2.default.bool), _defineProperty(_PropTypes$shape, _constants.PAYMENT_UNHANDLED, _propTypes2.default.bool), _PropTypes$shape))
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    order: state.order,
	    user: state.user,
	    voucher: state.voucher,
	    userCreditCards: (0, _user.userCreditCardsSelector)(state, props),
	    unhandledData: (0, _ristorantiFrontendLib.unhandledDataSelector)(_localized.COMMON_LOCALIZED.UNHANDLED_LABELS)(state, props),
	    unhandledSelected: (0, _ristorantiFrontendLib.unhandledSelectedSelector)(_localized.COMMON_LOCALIZED.UNHANDLED_LABELS)(state, props),
	    availablePayments: (0, _ristorantiFrontendLib.availablePaymentsForOrder)(state, props)
	  };
	};
	exports.default = (0, _util.connect)((0, _reactStripeElements.injectStripe)(OrderPayment), { mapStateToProps: mapStateToProps });

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(76);
	
	var _reactRouter = __webpack_require__(13);
	
	var _constants = __webpack_require__(9);
	
	var _restaurantSelectors = __webpack_require__(500);
	
	var _orderSelectors = __webpack_require__(54);
	
	var _urlSelectors = __webpack_require__(26);
	
	var _googleMap = __webpack_require__(120);
	
	var _googleMap2 = _interopRequireDefault(_googleMap);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _button = __webpack_require__(35);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _buttonsContainer = __webpack_require__(21);
	
	var _buttonsContainer2 = _interopRequireDefault(_buttonsContainer);
	
	var _boxedItem = __webpack_require__(65);
	
	var _boxedItem2 = _interopRequireDefault(_boxedItem);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderSelectDateTime = function (_React$Component) {
	  _inherits(OrderSelectDateTime, _React$Component);
	
	  function OrderSelectDateTime(props) {
	    _classCallCheck(this, OrderSelectDateTime);
	
	    var _this = _possibleConstructorReturn(this, (OrderSelectDateTime.__proto__ || Object.getPrototypeOf(OrderSelectDateTime)).call(this, props));
	
	    var orderDate = _this.props.url.orderDate;
	    _this.state = {
	      selectedDate: null,
	      selectedTime: null
	    };
	    if (orderDate) {
	      _this.state = _this.setOrderDateTime(orderDate);
	    } else {
	      _this.state = _this.defaultDateTime();
	    }
	    _this.updateOrderDate = _this.updateOrderDate.bind(_this);
	    _this.updateOrderTime = _this.updateOrderTime.bind(_this);
	    _this.goToMenu = _this.goToMenu.bind(_this);
	    return _this;
	  }
	
	  _createClass(OrderSelectDateTime, [{
	    key: 'setOrderDateTime',
	    value: function setOrderDateTime(dateTime) {
	      var components = dateTime.split('T');
	      if (components.length === 1) {
	        return { selectedDate: components[0], selectedTime: null };
	      }
	      return {
	        selectedDate: components[0],
	        selectedTime: components[1]
	      };
	    }
	  }, {
	    key: 'defaultDateTime',
	    value: function defaultDateTime() {
	      var days = this.props.orderTimes;
	      var nextDate = Object.keys(days)[0];
	      return {
	        selectedDate: nextDate,
	        selectedTime: Object.keys(days[nextDate].values)[0]
	      };
	    }
	  }, {
	    key: 'updateOrderDate',
	    value: function updateOrderDate(event) {
	      var days = this.props.orderTimes;
	      this.setState({
	        selectedDate: event.target.value,
	        selectedTime: Object.keys(days[event.target.value].values)[0]
	      });
	    }
	  }, {
	    key: 'updateOrderTime',
	    value: function updateOrderTime(event) {
	      this.setState({ selectedTime: event.target.value });
	    }
	  }, {
	    key: 'goToMenu',
	    value: function goToMenu() {
	      var orderDate = [this.state.selectedDate, this.state.selectedTime].join('T');
	      _reactRouter.browserHistory.push(_url2.default.orderMenu(_extends({}, this.props.url, { orderDate: orderDate })));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var days = this.props.orderTimes;
	      var orderAddress = this.props.orderLocation.address;
	      var orderLocation = this.props.orderLocation.coords;
	      return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_googleMap2.default, {
	            center: orderLocation,
	            markers: [orderLocation]
	          })
	        ),
	        this.props.url.orderType === _constants.ORDER_TYPE_DELIVERY && _react2.default.createElement(
	          _boxedItem2.default,
	          { title: 'Indirizzo di consegna' },
	          orderAddress,
	          _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              className: 'orderEditAddress',
	              to: _url2.default.orderDeliveryAddress(this.props.url.appId)
	            },
	            'Modifica',
	            _react2.default.createElement('i', { className: 'bi_editorial-write' })
	          )
	        ),
	        this.props.url.orderType === _constants.ORDER_TYPE_TAKEAWAY && _react2.default.createElement(
	          _boxedItem2.default,
	          { title: 'Indirizzo di ritiro' },
	          orderAddress
	        ),
	        _react2.default.createElement(
	          _boxedItem2.default,
	          { title: 'Data e ora' },
	          _react2.default.createElement(
	            'form',
	            { className: 'orderDateTime' },
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'select',
	                { onChange: this.updateOrderDate, value: this.state.selectedDate || '' },
	                Object.keys(days).map(function (dayKey) {
	                  return _react2.default.createElement(
	                    'option',
	                    {
	                      key: days[dayKey].value,
	                      value: days[dayKey].value
	                    },
	                    days[dayKey].label
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'select',
	                { onChange: this.updateOrderTime, value: this.state.selectedTime || '' },
	                Object.keys(days[this.state.selectedDate].values).map(function (time) {
	                  return _react2.default.createElement(
	                    'option',
	                    { key: time, value: time },
	                    time
	                  );
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _buttonsContainer2.default,
	          null,
	          _react2.default.createElement(_backButton2.default, null),
	          _react2.default.createElement(_button2.default, {
	            type: 'next',
	            text: 'VAI AL MENU',
	            onClick: this.goToMenu
	          })
	        )
	      );
	    }
	  }]);
	
	  return OrderSelectDateTime;
	}(_react2.default.Component);
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  // merge url props in current state in order to
	  // cope differences between app and widget
	  var mergedState = _extends({}, state, {
	    order: _extends({}, state.order, {
	      orderType: props.url.orderType
	    })
	  });
	  return {
	    url: (0, _urlSelectors.urlSelector)(state, props),
	    restaurant: (0, _restaurantSelectors.currentRestaurantSelector)(state, props),
	    orderTimes: (0, _restaurantSelectors.currentRestaurantTimesSelector)(mergedState, props),
	    orderLocation: (0, _orderSelectors.orderLocationAddressSelector)(state, props)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(OrderSelectDateTime);

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _orderDelivery = __webpack_require__(214);
	
	var _orderDelivery2 = _interopRequireDefault(_orderDelivery);
	
	var _orderTakeaway = __webpack_require__(215);
	
	var _orderTakeaway2 = _interopRequireDefault(_orderTakeaway);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OrderStartWrapper = function OrderStartWrapper(props) {
	  if (props.url.orderType === 'delivery') {
	    return _react2.default.createElement(_orderDelivery2.default, props);
	  }
	  return _react2.default.createElement(_orderTakeaway2.default, props);
	};
	
	exports.default = OrderStartWrapper;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(13);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _orderTypeButton = __webpack_require__(464);
	
	var _orderTypeButton2 = _interopRequireDefault(_orderTypeButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderStart = function (_React$Component) {
	  _inherits(OrderStart, _React$Component);
	
	  function OrderStart() {
	    _classCallCheck(this, OrderStart);
	
	    return _possibleConstructorReturn(this, (OrderStart.__proto__ || Object.getPrototypeOf(OrderStart)).apply(this, arguments));
	  }
	
	  _createClass(OrderStart, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var orderConfig = this.props.app.config.order;
	      if (orderConfig.types.length === 1) {
	        var urlToFn = orderConfig.types[0] === 'delivery' ? _url2.default.orderDelivery : _url2.default.orderTakeAway;
	        _reactRouter.browserHistory.push(urlToFn(this.props.url.appId));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var appId = this.props.url.appId;
	      return _react2.default.createElement(
	        'div',
	        { className: 'grow orderStart' },
	        _react2.default.createElement(
	          'div',
	          { className: 'orderType' },
	          _react2.default.createElement(
	            _orderTypeButton2.default,
	            { appId: appId, type: 'delivery' },
	            'Consegna a domicilio'
	          ),
	          _react2.default.createElement(
	            _orderTypeButton2.default,
	            { appId: appId, type: 'takeAway' },
	            'Asporto'
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrderStart;
	}(_react2.default.Component);
	
	exports.default = OrderStart;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  mutation CreateVoucherInstance(\n    $promoCode: String!,\n    $app: ID!,\n    $amount: Int!,\n    $orderType: OrderType!\n  ) {\n    createVoucherInstance (promoCode: $promoCode, app: $app, amount: $amount, orderType: $orderType) {\n      id\n      instance {\n        id\n      }\n    }\n  }\n'], ['\n  mutation CreateVoucherInstance(\n    $promoCode: String!,\n    $app: ID!,\n    $amount: Int!,\n    $orderType: OrderType!\n  ) {\n    createVoucherInstance (promoCode: $promoCode, app: $app, amount: $amount, orderType: $orderType) {\n      id\n      instance {\n        id\n      }\n    }\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(13);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactApollo = __webpack_require__(262);
	
	var _graphqlTag = __webpack_require__(229);
	
	var _graphqlTag2 = _interopRequireDefault(_graphqlTag);
	
	var _constants = __webpack_require__(9);
	
	var _cart = __webpack_require__(115);
	
	var _voucher = __webpack_require__(33);
	
	var _voucher2 = _interopRequireDefault(_voucher);
	
	var _i18n = __webpack_require__(16);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _buttonsContainer = __webpack_require__(21);
	
	var _buttonsContainer2 = _interopRequireDefault(_buttonsContainer);
	
	var _backButton = __webpack_require__(17);
	
	var _backButton2 = _interopRequireDefault(_backButton);
	
	var _button = __webpack_require__(35);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _list = __webpack_require__(122);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _cartTotal = __webpack_require__(119);
	
	var _cartTotal2 = _interopRequireDefault(_cartTotal);
	
	var _util = __webpack_require__(11);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	var _user = __webpack_require__(123);
	
	var _localized = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var VALIDATE_PROMO_CODE = (0, _graphqlTag2.default)(_templateObject);
	
	var getPromoCodeTreshold = function getPromoCodeTreshold(error) {
	  return parseInt(error.toString().split('€')[0].slice('-2'), 10);
	};
	
	var getPromoCodeErrorMessage = function getPromoCodeErrorMessage(error) {
	  var errorMessage = error.toString();
	  var result = 'Il codice sconto non è valido';
	  if (errorMessage.includes('This promo code requires a higher order amount')) {
	    result = 'Per applicare questo codice sconto devi raggiungere un importo minimo di ' + getPromoCodeTreshold(error) + '\u20AC';
	  }
	  if (errorMessage.includes('Invalid promo code for this kind of order')) {
	    result = 'Il codice sconto inserito non è valido per questo tipo di ordine';
	  }
	  return result;
	};
	
	var OrderVoucher = function (_React$Component) {
	  _inherits(OrderVoucher, _React$Component);
	
	  function OrderVoucher(props) {
	    _classCallCheck(this, OrderVoucher);
	
	    var _this = _possibleConstructorReturn(this, (OrderVoucher.__proto__ || Object.getPrototypeOf(OrderVoucher)).call(this, props));
	
	    _this.goToCheckout = _this.goToCheckout.bind(_this);
	    _this.selectVoucher = _this.selectVoucher.bind(_this);
	    _this.state = { promoCode: '' };
	    return _this;
	  }
	
	  _createClass(OrderVoucher, [{
	    key: 'goToCheckout',
	    value: function goToCheckout() {
	      _reactRouter.browserHistory.push(_url2.default.orderCheckout(_extends({}, this.props.url)));
	    }
	  }, {
	    key: 'selectVoucher',
	    value: function selectVoucher(data) {
	      var voucherId = data.id !== _constants.ORDER_NO_VOUCHER ? data.instance.id : _constants.ORDER_NO_VOUCHER;
	      this.props.actions.order.addVoucher(voucherId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.props.cartData;
	      var app = this.props.app;
	
	      if (data && data.vouchers) {
	        var noVouchers = data.vouchers.length === 1 && data.vouchers[0].id === _constants.ORDER_NO_VOUCHER;
	
	        if (noVouchers && !app.config.modules.promoCode.active) {
	          this.goToCheckout();
	          return null;
	        }
	      }
	      var language = _i18n2.default.currentLanguage('it'); // TODO replace with current language
	      return _react2.default.createElement(
	        _reactApollo.ApolloProvider,
	        { client: this.props.apolloClient },
	        _react2.default.createElement(
	          'main',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Hai accumulato dei buoni sconto di cui puoi usufruire ora, se vuoi.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Scegli quello che vuoi usare, o seleziona "Nessuno sconto" per usufruirne al prossimo ordine!'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'voucherList' },
	            _react2.default.createElement(
	              _list2.default,
	              null,
	              data && data.vouchers && data.vouchers.map(function (voucher, i) {
	                var selectedId = _this2.props.selectedVoucher;
	                var isNoVoucher = !voucher.instance && selectedId === _constants.ORDER_NO_VOUCHER;
	                var isRealVoucher = voucher.instance && voucher.instance.id === selectedId;
	                var isSelected = isNoVoucher || isRealVoucher;
	                var classes = (0, _classnames2.default)({
	                  'voucherList__element--selected': isSelected
	                });
	                return _react2.default.createElement(
	                  'li',
	                  { key: voucher.id + i, className: classes },
	                  _react2.default.createElement(
	                    'button',
	                    {
	                      className: 'voucherList__element',
	                      onClick: function onClick() {
	                        return _this2.selectVoucher(voucher);
	                      }
	                    },
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        voucher.message
	                      ),
	                      voucher.discount && _react2.default.createElement(
	                        'span',
	                        { className: 'voucherList__elementDiscount accent' },
	                        'Sconto ',
	                        _voucher2.default.format(voucher, _localized.COMMON_LOCALIZED, language).subtitle
	                      )
	                    ),
	                    isSelected && _react2.default.createElement(
	                      'span',
	                      { className: 'voucherList__selected' },
	                      '\u2713'
	                    )
	                  )
	                );
	              })
	            ),
	            this.props.app.config.modules.promoCode && this.props.app.config.modules.promoCode.active && _react2.default.createElement(
	              _reactApollo.Mutation,
	              {
	                mutation: VALIDATE_PROMO_CODE,
	                onCompleted: function onCompleted(data) {
	                  _this2.props.services.voucher.getMine(_this2.props.actions.voucher).then(function () {
	                    return _this2.props.actions.order.addVoucher(data.createVoucherInstance.instance.id);
	                  });
	                }
	              },
	              function (validatePromoCode, _ref) {
	                var error = _ref.error;
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'promoCodeForm' },
	                  _react2.default.createElement(
	                    'p',
	                    { className: 'promoCodeForm__title' },
	                    'Se possiedi un codice sconto inseriscilo qui:'
	                  ),
	                  error && _react2.default.createElement(
	                    'p',
	                    { className: 'promoCodeForm__title promoCodeForm__error' },
	                    getPromoCodeErrorMessage(error)
	                  ),
	                  _react2.default.createElement(
	                    'form',
	                    {
	                      className: 'promoCodeForm__form',
	                      onSubmit: function onSubmit(e) {
	                        e.preventDefault();
	                        if (_this2.state.promoCode) {
	                          validatePromoCode({ variables: {
	                              promoCode: _this2.state.promoCode,
	                              app: _this2.props.app.id,
	                              amount: data.total,
	                              orderType: _this2.props.url.orderType.toUpperCase()
	                            } });
	                          _this2.setState({ promoCode: '' });
	                        }
	                      }
	                    },
	                    _react2.default.createElement('input', {
	                      type: 'text',
	                      className: 'promoCodeForm__input',
	                      value: _this2.state.promoCode,
	                      onChange: function onChange(e) {
	                        _this2.setState({ promoCode: e.target.value });
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'button',
	                      {
	                        type: 'submit',
	                        className: 'btn-submit promoCodeForm__submit'
	                      },
	                      'applica'
	                    )
	                  )
	                );
	              }
	            ),
	            _react2.default.createElement(_cartTotal2.default, {
	              total: data.total,
	              subtotal: data.subtotal,
	              extraCosts: data.extraCosts
	            })
	          ),
	          _react2.default.createElement(
	            _buttonsContainer2.default,
	            null,
	            _react2.default.createElement(_backButton2.default, null),
	            _react2.default.createElement(_button2.default, {
	              type: 'next',
	              text: 'CONTINUA',
	              onClick: this.goToCheckout
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrderVoucher;
	}(_react2.default.Component);
	
	OrderVoucher.propTypes = {
	  selectedVoucher: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  return {
	    selectedVoucher: state.order.selectedVoucher,
	    cartData: (0, _cart.cartSelector)(_localized.COMMON_LOCALIZED)(state, props)
	  };
	};
	
	exports.default = (0, _user.userRequired)((0, _util.connect)(OrderVoucher, { mapStateToProps: mapStateToProps }));

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _util = __webpack_require__(11);
	
	var _env = __webpack_require__(92);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _device = __webpack_require__(218);
	
	var _device2 = _interopRequireDefault(_device);
	
	var _constants = __webpack_require__(91);
	
	var _currentUser = __webpack_require__(450);
	
	var _currentUser2 = _interopRequireDefault(_currentUser);
	
	var _appFlashMessage = __webpack_require__(447);
	
	var _appFlashMessage2 = _interopRequireDefault(_appFlashMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global localStorage */
	/* global window */
	/* global FB */
	
	var Root = function (_React$Component) {
	  _inherits(Root, _React$Component);
	
	  function Root() {
	    _classCallCheck(this, Root);
	
	    return _possibleConstructorReturn(this, (Root.__proto__ || Object.getPrototypeOf(Root)).apply(this, arguments));
	  }
	
	  _createClass(Root, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // register device with type WEB
	      var environment = _env2.default.getCurrent();
	      if (!this.props.app.bootstrap) {
	        Raven.captureMessage('RegisterDevice error: bunbleId is undefined', {
	          level: 'error' // one of 'info', 'warning', or 'error'
	        });
	      } else {
	        this.props.services.app.registerDevice({
	          id: _device2.default.UUID(),
	          osVersion: window.navigator.userAgent,
	          appVersion: environment.version,
	          bundleVersion: environment.version
	        });
	      }
	
	      var token = localStorage.getItem(_constants.USER_ACCESS_TOKEN);
	      if (token) {
	        this.props.actions.user.updateAccessToken(token);
	      }
	
	      this.logout = this.logout.bind(this);
	      this.dismissFlashMessage = this.dismissFlashMessage.bind(this);
	    }
	  }, {
	    key: 'dismissFlashMessage',
	    value: function dismissFlashMessage() {
	      this.props.actions.ux.setMessage(null);
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      var _this2 = this;
	
	      if (this.props.user.currentUser.facebookId) {
	        FB.logout(function () {
	          _this2.props.services.user.logout(_this2.props.actions.user);
	        }, function (e) {
	          _this2.props.services.user.logout(_this2.props.actions.user);
	        });
	        return;
	      }
	      this.props.services.user.logout(this.props.actions.user);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var message = this.props.ux.message;
	      var flashMessageVisible = message.title && message.text;
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)({ appFlashMessageBackdrop: flashMessageVisible }) },
	        _react2.default.createElement(_appFlashMessage2.default, {
	          message: message,
	          onDismiss: this.dismissFlashMessage
	        }),
	        _react2.default.createElement(
	          'header',
	          { className: 'userHeader' },
	          _react2.default.createElement(_currentUser2.default, {
	            user: this.props.user.currentUser,
	            onLogout: this.logout
	          })
	        ),
	        this.props.children
	      );
	    }
	  }]);
	
	  return Root;
	}(_react2.default.Component);
	
	Root.propTypes = {
	  children: _propTypes2.default.node
	};
	
	exports.default = (0, _util.connect)(Root);

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formWrapper = __webpack_require__(66);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SigninForm = function (_React$Component) {
	  _inherits(SigninForm, _React$Component);
	
	  function SigninForm(props) {
	    _classCallCheck(this, SigninForm);
	
	    var _this = _possibleConstructorReturn(this, (SigninForm.__proto__ || Object.getPrototypeOf(SigninForm)).call(this, props));
	
	    _this.formConfig = [{
	      label: 'E-mail',
	      name: 'email',
	      type: 'email',
	      placeholder: 'E-mail',
	      initialValue: ''
	    }, {
	      label: 'Password',
	      name: 'password',
	      type: 'password',
	      placeholder: 'Password',
	      initialValue: ''
	    }];
	    return _this;
	  }
	
	  _createClass(SigninForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_formWrapper2.default, {
	        config: this.formConfig,
	        onValidSave: this.props.onSave,
	        onCancel: this.props.onCancel,
	        submitButtonLabel: 'Login',
	        cancelButtonLabel: 'Voglio iscrivermi'
	      });
	    }
	  }]);
	
	  return SigninForm;
	}(_react2.default.Component);
	
	SigninForm.propTypes = {
	  onSave: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired
	};
	
	exports.default = SigninForm;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _userRequired = __webpack_require__(217);
	
	var _userRequired2 = _interopRequireDefault(_userRequired);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SigninSignupPage = function SigninSignupPage(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'h4',
	      null,
	      'Ciao ',
	      props.user.name,
	      ', benvenuto in ',
	      props.app.config.name,
	      '.'
	    )
	  );
	};
	
	exports.default = (0, _userRequired2.default)(SigninSignupPage);

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formWrapper = __webpack_require__(66);
	
	var _formWrapper2 = _interopRequireDefault(_formWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignupForm = function (_React$Component) {
	  _inherits(SignupForm, _React$Component);
	
	  function SignupForm(props) {
	    _classCallCheck(this, SignupForm);
	
	    var _this = _possibleConstructorReturn(this, (SignupForm.__proto__ || Object.getPrototypeOf(SignupForm)).call(this, props));
	
	    _this.formConfig = [{
	      label: 'E-mail',
	      name: 'email',
	      type: 'email',
	      placeholder: 'E-mail',
	      initialValue: ''
	    }, {
	      label: 'Password',
	      name: 'password',
	      type: 'password',
	      placeholder: 'Password',
	      initialValue: ''
	    }, {
	      label: 'Conferma Password',
	      name: 'passwordConfirm',
	      type: 'password',
	      placeholder: 'Password',
	      initialValue: ''
	    }, {
	      label: 'Nome',
	      name: 'name',
	      type: 'text',
	      placeholder: 'Nome',
	      initialValue: ''
	    }, {
	      label: 'Cognome',
	      name: 'lastName',
	      type: 'text',
	      placeholder: 'Cognome',
	      initialValue: ''
	    }];
	    _this.extraCheck = _this.extraCheck.bind(_this);
	    return _this;
	  }
	
	  _createClass(SignupForm, [{
	    key: 'extraCheck',
	    value: function extraCheck(data) {
	      if (data.password !== data.passwordConfirm) {
	        return {
	          password: ['Le password non coincidono'],
	          passwordConfirm: ['Le password non coincidono']
	        };
	      }
	      return {};
	    }
	  }, {
	    key: 'save',
	    value: function save(data) {
	      this.props.onSave(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_formWrapper2.default, {
	        config: this.formConfig,
	        onValidSave: this.props.onSave,
	        onCancel: this.props.onCancel,
	        extraCheck: this.extraCheck,
	        submitButtonLabel: 'Registrati',
	        cancelButtonLabel: 'Sono gi\xE0 iscritto'
	      });
	    }
	  }]);
	
	  return SignupForm;
	}(_react2.default.Component);
	
	SignupForm.propTypes = {
	  onSave: _propTypes2.default.func.isRequired,
	  onCancel: _propTypes2.default.func.isRequired
	};
	
	exports.default = SignupForm;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(723);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactStripeElements = __webpack_require__(152);
	
	__webpack_require__(561);
	
	var _redux = __webpack_require__(153);
	
	var _reactRedux = __webpack_require__(76);
	
	var _reactRouter = __webpack_require__(13);
	
	var _reactRouterRedux = __webpack_require__(731);
	
	var _moment = __webpack_require__(259);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(703);
	
	var _app = __webpack_require__(195);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _booking = __webpack_require__(196);
	
	var _booking2 = _interopRequireDefault(_booking);
	
	var _order = __webpack_require__(197);
	
	var _order2 = _interopRequireDefault(_order);
	
	var _user = __webpack_require__(431);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _voucher = __webpack_require__(432);
	
	var _voucher2 = _interopRequireDefault(_voucher);
	
	var _user3 = __webpack_require__(430);
	
	var _user4 = _interopRequireDefault(_user3);
	
	__webpack_require__(562);
	
	__webpack_require__(774);
	
	var _env = __webpack_require__(92);
	
	var _env2 = _interopRequireDefault(_env);
	
	var _ux = __webpack_require__(499);
	
	var _ux2 = _interopRequireDefault(_ux);
	
	var _sideEffects = __webpack_require__(497);
	
	var _sideEffects2 = _interopRequireDefault(_sideEffects);
	
	var _userWidget = __webpack_require__(498);
	
	var _userWidget2 = _interopRequireDefault(_userWidget);
	
	var _util = __webpack_require__(11);
	
	var _load = __webpack_require__(453);
	
	var _load2 = _interopRequireDefault(_load);
	
	var _root = __webpack_require__(491);
	
	var _root2 = _interopRequireDefault(_root);
	
	var _app3 = __webpack_require__(470);
	
	var _app4 = _interopRequireDefault(_app3);
	
	var _booking3 = __webpack_require__(477);
	
	var _order3 = __webpack_require__(478);
	
	var _user5 = __webpack_require__(123);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_moment2.default.locale('IT_it'); /* global document */
	/* global window */
	/* global Raven */
	
	var environment = _env2.default.getCurrent();
	
	document.body.setAttribute('data-app-version', environment.version);
	
	if (true) {
	  Raven.config('https://1a3b6def2f6c4a2cb0d4bd402d5901e1@sentry.io/137729', {
	    environment: environment.name,
	    release: environment.version
	  }).install();
	}
	
	var reducers = (0, _redux.combineReducers)({
	  app: (0, _app2.default)(environment),
	  user: _user2.default,
	  booking: _booking2.default,
	  routing: _reactRouterRedux.routerReducer,
	  ux: _ux2.default,
	  order: _order2.default,
	  voucher: _voucher2.default
	});
	
	var store = (0, _redux.createStore)(reducers, (0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory), _sideEffects2.default, (0, _user4.default)(_userWidget2.default)));
	
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	var loadConfiguration = function loadConfiguration(nextState, replace, callback) {
	  var actions = (0, _util.mapDispatchToProps)(store.dispatch);
	  var bundle = nextState.params.appId;
	
	  if (bundle) {
	    actions.app.switchBundleId(bundle);
	  }
	
	  var state = store.getState();
	  var services = (0, _util.serviceSelector)(state);
	  services.app.loadConfiguration(actions.app).then(callback);
	};
	
	var widgetLoad = function widgetLoad() {
	  var data = { eventName: 'it.ristoranti.widget.onload' };
	  parent.postMessage(JSON.stringify(data), '*');
	};
	
	window.addEventListener('message', widgetLoad, false);
	
	var isInIframe = window.self !== window.top;
	
	window.addEventListener('load', function () {
	  var stripe = Stripe(environment.stripe_key, { apiVersion: '2019-09-09' });
	
	  _reactDom2.default.render(_react2.default.createElement(
	    _reactStripeElements.StripeProvider,
	    { stripe: stripe },
	    _react2.default.createElement(
	      _reactStripeElements.Elements,
	      { locale: 'it' },
	      _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2.default.createElement(
	          _reactRouter.Router,
	          { history: history },
	          _react2.default.createElement(
	            _reactRouter.Route,
	            { path: '/', component: _root2.default, onEnter: loadConfiguration },
	            _react2.default.createElement(_reactRouter.Route, {
	              path: '/app/:appId',
	              component: (0, _load2.default)(store, _app4.default, null, 'app')
	            }),
	            _react2.default.createElement(
	              _reactRouter.Route,
	              { path: '/app/:appId/order', component: _order3.OrderContainer },
	              _react2.default.createElement(_reactRouter.IndexRoute, { component: _order3.OrderStart }),
	              _react2.default.createElement(_reactRouter.Route, { path: 'no-delivery', component: _order3.OrderNoDelivery }),
	              _react2.default.createElement(_reactRouter.Route, { path: ':orderType', component: _order3.OrderStartWrapper }),
	              _react2.default.createElement(_reactRouter.Route, { path: ':orderType/address', component: _order3.OrderDeliveryAddress }),
	              _react2.default.createElement(_reactRouter.Route, { path: ':orderType/:restaurantId', component: _order3.OrderSelectDateTime }),
	              _react2.default.createElement(_reactRouter.Route, { path: ':orderType/:restaurantId/:orderDate', component: _order3.OrderSelectDateTime }),
	              _react2.default.createElement(_reactRouter.Route, {
	                path: ':orderType/:restaurantId/:orderDate/menu',
	                component: _order3.Menu
	              }),
	              _react2.default.createElement(_reactRouter.Route, { path: ':orderType/:restaurantId/:orderDate/cart', component: _order3.OrderCart }),
	              _react2.default.createElement(_reactRouter.Route, { path: ':orderType/:restaurantId/:orderDate/voucher', component: _order3.OrderVoucher }),
	              _react2.default.createElement(_reactRouter.Route, { path: ':orderType/:restaurantId/:orderDate/checkout', component: _order3.OrderCheckout }),
	              _react2.default.createElement(_reactRouter.Route, { path: ':orderType/:restaurantId/:orderDate/payment', component: _order3.OrderPayment }),
	              _react2.default.createElement(_reactRouter.Route, { path: ':orderType/:restaurantId/:orderDate/end', component: _order3.OrderEnd })
	            ),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: '/app/:appId/booking',
	              component: (0, _load2.default)(store, _booking3.BookingContainer, _booking3.BookingStart, 'booking-start')
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: '/app/:appId/booking/:restaurantId',
	              component: (0, _load2.default)(store, _booking3.BookingContainer, _booking3.BookingSelectDate, 'booking-select-date')
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: '/app/:appId/booking/:restaurantId/:bookingDate',
	              component: (0, _load2.default)(store, _booking3.BookingContainer, _booking3.BookingTimeSeats, 'booking-time-seats')
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: '/app/:appId/booking/:restaurantId/:bookingDate/:bookingSlot/:seats/checkout',
	              component: (0, _load2.default)(store, _booking3.BookingContainer, _booking3.BookingForm, 'booking-form')
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: '/app/:appId/booking/:restaurantId/:bookingDate/:bookingSlot/:seats/end',
	              component: (0, _load2.default)(store, _booking3.BookingContainer, _booking3.BookingEnd, 'booking-end')
	            }),
	            _react2.default.createElement(_reactRouter.Route, {
	              path: '/app/:appId/user/signin-signup',
	              component: _user5.SigninSignupPage
	            })
	          )
	        )
	      )
	    )
	  ), document.getElementById('root'));
	
	  document.getElementById('ristoranti-spinner').style.display = 'none';
	  if (isInIframe) widgetLoad();
	});

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formField = {
	  label: 'Indirizzo',
	  name: 'address',
	  type: 'location',
	  placeholder: 'via, civico, città',
	  initialValue: '',
	  country: 'it'
	};
	
	var formFieldsItems = {};
	
	formFieldsItems.route = {
	  label: 'Via',
	  name: 'address.route',
	  initialValue: '',
	  type: 'text',
	  locationField: 'route'
	};
	
	formFieldsItems.street_number = {
	  label: 'Civico',
	  name: 'address.street_number',
	  initialValue: '',
	  type: 'text',
	  locationField: 'street_number',
	  isRequired: true
	};
	
	formFieldsItems.city = {
	  label: 'Città',
	  name: 'address.city',
	  initialValue: '',
	  type: 'text',
	  locationField: 'locality'
	};
	
	formFieldsItems.country = {
	  label: 'Paese',
	  name: 'address.country',
	  initialValue: '',
	  type: 'text',
	  locationField: 'country'
	};
	
	formFieldsItems.latitude = {
	  label: 'Latitudine', // non visualizzato come label, serve solo per la visualizzazione del messaggio d'errore
	  name: 'location.latitude',
	  initialValue: '',
	  format: 'number',
	  type: 'text',
	  locationField: 'lat'
	};
	
	formFieldsItems.longitude = {
	  label: 'Longitudine', // non visualizzato come label, serve solo per la visualizzazione del messaggio d'errore
	  name: 'location.longitude',
	  initialValue: '',
	  format: 'number',
	  type: 'text',
	  locationField: 'lng'
	};
	
	var getConfig = function getConfig(initialLocation, initialAddress) {
	  var field = _extends({}, formField);
	  var items = _extends({}, formFieldsItems);
	
	  if (initialLocation && initialAddress) {
	    items = _lodash2.default.mergeWith(items, initialAddress, function (src, dst) {
	      return _extends({}, src, {
	        initialValue: dst
	      });
	    });
	
	    field.initialValue = initialLocation.description;
	
	    // coordinates
	    items.latitude.initialValue = initialLocation.geometry.location.lat;
	    items.longitude.initialValue = initialLocation.geometry.location.lng;
	  }
	  field.items = _lodash2.default.values(items);
	  return [field];
	};
	
	exports.default = {
	  getConfig: getConfig
	};

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createCallback;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global document */
	/* global location */
	
	var _reactRouter = __webpack_require__(13);
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ristorantiFrontendLib = __webpack_require__(23);
	
	var _constants = __webpack_require__(9);
	
	var _constants2 = __webpack_require__(34);
	
	var _util = __webpack_require__(11);
	
	var _url = __webpack_require__(15);
	
	var _url2 = _interopRequireDefault(_url);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var createCallback = function createCallback(obj) {
	  return Object.keys(obj).reduce(function (acc, key) {
	    var callback = obj[key];
	    var listener = callback instanceof Array ? callback : [callback];
	
	    return _extends({}, acc, _defineProperty({}, key, function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return listener.map(function (fn) {
	        return fn.apply(undefined, args);
	      });
	    }));
	  }, {});
	};
	
	var loadBookingAvailability = function loadBookingAvailability(state, services, actions) {
	  var appId = state.app.id;
	  // load booking availability for restaurants and booking rushes
	  var rangeAmp = state.app.config.booking.availabilityRange || 7;
	  var range = _ristorantiFrontendLib.TimeHelpers.nextXDaysRange(rangeAmp);
	  services.booking.loadBookingAvailability(appId, { from: range[0], to: range[1] }, actions.booking);
	};
	
	var deliveryAddressCheckSuccess = function deliveryAddressCheckSuccess(state, services, actions, action) {
	  if (action.data && action.data.id) {
	    var hasOnline = _ristorantiFrontendLib.RestaurantHelpers.hasOnlineService(_lodash2.default.find(state.app.merchant.restaurants, { id: action.data.id }), 'delivery');
	    if (!hasOnline) {
	      // address in a delivery area, but restaurant has the service offline
	      _reactRouter.browserHistory.push(_url2.default.orderNoDelivery(_url2.default.getAppIdFromUrl(location), false));
	      return;
	    }
	
	    _reactRouter.browserHistory.push(_url2.default.orderDeliveryRestaurantFromRoute(location.pathname, action.data.id));
	    return;
	  }
	
	  // redirect to no-delivery route
	  _reactRouter.browserHistory.push(_url2.default.orderNoDelivery(_url2.default.getAppIdFromUrl(location)));
	};
	
	var updateWidgetExtraCosts = function updateWidgetExtraCosts(state, services, actions, action) {
	  // the target restaurant id is in the url not in the state
	  // as for the mobile app
	  var augmentedState = _extends({}, state);
	  augmentedState.order.targetRestaurant = _url2.default.getTargetRestaurantIdFromUrl(location);
	  (0, _ristorantiFrontendLib.updateExtraCosts)(augmentedState, services, actions, action);
	};
	
	var storeOrderError = function storeOrderError(state, services, actions, action) {
	  actions.ux.setMessage({
	    title: 'Errore',
	    text: 'Si è verificato un problema con il pagamento',
	    type: 'error'
	  });
	};
	
	var redirectToOrderEnd = function redirectToOrderEnd(state, services, actions, action) {
	  _reactRouter.browserHistory.push(_url2.default.orderEndFromRoute(location.pathname));
	};
	
	var redirectToBookingEnd = function redirectToBookingEnd(state, services, actions, action) {
	  _reactRouter.browserHistory.push(_url2.default.bookingEndFromRoute(location.pathname));
	};
	
	var showErrors = function showErrors(state, service, actions, action) {
	  var errors = state.user.errors;
	  if (errors && errors.length > 0) {
	    if (errors[0].responseLevel === 'USER_FAILURE') {
	      actions.ux.setMessage({
	        title: 'Errore',
	        text: errors[0].message,
	        type: 'error'
	      });
	    }
	  }
	};
	
	var createCustomStyles = function createCustomStyles(state, services, actions, action) {
	  var theme = (0, _util.getTheme)(state);
	  var primary = theme.widget ? theme.widget.primary : theme.primary;
	  var accent = theme.widget ? theme.widget.accent : theme.accent;
	  var secondary = theme.widget ? theme.widget.secondary : theme.secondary;
	
	  if (!primary) return;
	
	  var styleEl = document.createElement('style');
	  document.head.appendChild(styleEl);
	
	  var styleSheet = styleEl.sheet;
	  styleSheet.insertRule('a, h1 { color: ' + primary + '; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('.primary { color: ' + primary + ' !important; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('.primary--background { background-color: ' + primary + ' !important; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('.primary--border { border-color: ' + primary + ' !important; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('.primary--border-top { border-top-color: ' + primary + ' !important; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('.secondary { color: ' + secondary + ' !important; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('.btn-submit { background-color: ' + primary + '; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('.btn-secondary { background-color: ' + secondary + '; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('.box-list li.selected { background-color: ' + primary + '; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('.number-picker input:hover { color: ' + primary + '; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('form.form-stacked input:not([type="submit"]):focus { border-color: ' + primary + '; }', styleSheet.cssRules.length);
	
	  styleSheet.insertRule('.accent { color: ' + accent + ' !important; }', styleSheet.cssRules.length);
	  styleSheet.insertRule('.accent--background { background-color: ' + accent + ' !important; }', styleSheet.cssRules.length);
	};
	
	var loaders = createCallback({
	  'booking-start': function bookingStart(state, services, actions) {
	    return actions.booking.endBooking();
	  },
	  'booking-select-date': loadBookingAvailability
	});
	
	var eventListeners = createCallback((_createCallback = {}, _defineProperty(_createCallback, _constants.LOAD_APP_CONFIGURATION_SUCCESS, createCustomStyles), _defineProperty(_createCallback, _constants.DELIVERY_ADDRESS_CHECK_SUCCESS, deliveryAddressCheckSuccess), _defineProperty(_createCallback, _constants2.USER_REGISTER_FAILURE, showErrors), _defineProperty(_createCallback, _constants2.USER_AUTHENTICATE_FAILURE, showErrors), _defineProperty(_createCallback, _constants2.USER_AUTHENTICATE_SUCCESS, [_ristorantiFrontendLib.reloadCreditCards, _ristorantiFrontendLib.fetchUserOrders, _ristorantiFrontendLib.fetchVouchers]), _defineProperty(_createCallback, _constants2.USER_REGISTER_SUCCESS, [_ristorantiFrontendLib.reloadCreditCards, _ristorantiFrontendLib.fetchVouchers]), _defineProperty(_createCallback, _constants2.USER_UPDATE_ACCESSTOKEN, [_ristorantiFrontendLib.updateCurrentUser, _ristorantiFrontendLib.reloadCreditCards, _ristorantiFrontendLib.fetchVouchers]), _defineProperty(_createCallback, _constants.STORE_ORDER_SUCCESS, [redirectToOrderEnd]), _defineProperty(_createCallback, _constants.STORE_ORDER_FAILURE, [storeOrderError]), _defineProperty(_createCallback, _constants.MENU_CART_ADDITEM, [updateWidgetExtraCosts]), _defineProperty(_createCallback, _constants.MENU_CART_REMOVEITEM, [updateWidgetExtraCosts]), _defineProperty(_createCallback, _constants2.BOOKING_REQUEST_CREATE_SUCCESS, [redirectToBookingEnd]), _createCallback));
	
	var defaultFn = function defaultFn() {
	  return null;
	};
	
	exports.default = function (_ref) {
	  var dispatch = _ref.dispatch,
	      getState = _ref.getState;
	
	  var actions = (0, _util.mapDispatchToProps)(dispatch);
	
	  return function (next) {
	    return function (action) {
	      next(action);
	
	      var state = getState();
	      var services = (0, _util.serviceSelector)(state);
	
	      if (action.type === 'route.mounted') {
	        var fn = loaders[action.route] || defaultFn;
	        fn(state, services, actions);
	      }
	
	      if (action.type === _constants2.BOOKING_REQUEST_CREATE_FAILURE && action.errors[0].responseLevel === 'USER_FAILURE') {
	        actions.ux.setMessage({
	          title: 'Errore',
	          text: action.errors[0].message,
	          type: 'error'
	        });
	      }
	
	      var listener = eventListeners[action.type] || defaultFn;
	      listener(state, services, actions, action);
	    };
	  };
	};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(91);
	
	var userWidgetMiddleware = {
	  configureApi: function configureApi() {
	    return null;
	  },
	  loginSuccess: function loginSuccess(user, dispatch) {
	    localStorage.setItem(_constants.USER_ACCESS_TOKEN, user.accessToken);
	  },
	  logoutSuccess: function logoutSuccess(dispatch) {
	    localStorage.removeItem(_constants.USER_ACCESS_TOKEN);
	  }
	}; /* global localStorage */
	exports.default = userWidgetMiddleware;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _constants = __webpack_require__(91);
	
	var initialState = {
	  isGettingCurrenUserPosition: false,
	  bookingFormVisible: false,
	  message: {
	    title: null,
	    text: null
	  }
	};
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _constants.GEOLOCATION_GET_USER_LOCATION:
	      return _extends({}, state, {
	        isGettingCurrenUserPosition: action.status
	      });
	
	    case _constants.SET_BOOKING_FORM_VISIBILITY:
	      return _extends({}, state, {
	        bookingFormVisible: action.visible
	      });
	
	    case _constants.SET_MESSAGE:
	      return _extends({}, state, {
	        message: !action.message ? initialState.message : action.message
	      });
	
	    default:
	      return state;
	  }
	};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.currentRestaurantTimesSelector = exports.currentRestaurantSelector = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reselect = __webpack_require__(18);
	
	var _ristorantiFrontendLib = __webpack_require__(23);
	
	var _localized = __webpack_require__(43);
	
	var _urlSelectors = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var currentRestaurantSelector = exports.currentRestaurantSelector = (0, _reselect.createSelector)(function (state) {
	  return state.app.merchant.restaurants;
	}, _urlSelectors.urlSelector, function (restaurants, url) {
	  if (!url.restaurantId) {
	    return null;
	  }
	  return _lodash2.default.find(restaurants, { id: url.restaurantId });
	});
	
	var currentRestaurantTimesSelector = exports.currentRestaurantTimesSelector = (0, _reselect.createSelector)(currentRestaurantSelector, function (state, props) {
	  return props.url.orderType;
	}, _ristorantiFrontendLib.orderOffsetSelector, function (restaurant, orderType, offset) {
	  if (!restaurant || !orderType) {
	    return null;
	  }
	  var times = orderType === 'delivery' ? restaurant.deliveryTimes : restaurant.takeAwayTimes;
	
	  return _ristorantiFrontendLib.TimeHelpers.mapTimesToHumanTimes(offset, times, _localized.COMMON_LOCALIZED, true).reduce(function (acc, d) {
	    return _extends({}, acc, _defineProperty({}, d.value, d));
	  }, {});
	});

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	module.exports = reach;
	
	var defaults = {
	  separator: '.',
	  strict: false,
	  default: undefined
	};
	
	function reach(obj, chain, options) {
	  if (typeof chain !== 'string') {
	    throw new TypeError('Reach path must a string. Found ' + chain + '.');
	  }
	
	  var settings = Object.assign({}, defaults, options);
	  var path = chain.split(settings.separator);
	  var ref = obj;
	
	  for (var i = 0; i < path.length; ++i) {
	    var key = path[i];
	
	    if (key[0] === '-' && Array.isArray(ref)) {
	      key = key.slice(1, key.length);
	      key = ref.length - key;
	    }
	
	    // ref must be an object or function and contain key
	    if (ref === null || (typeof ref === 'undefined' ? 'undefined' : _typeof(ref)) !== 'object' && typeof ref !== 'function' || !(key in ref)) {
	      if (settings.strict) {
	        throw new Error('Invalid segment, ' + key + ', in reach path ' + chain + '.');
	      }
	
	      return settings.default;
	    }
	
	    ref = ref[key];
	  }
	
	  return ref;
	}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = __webpack_require__(525);
	var Queue = __webpack_require__(522);
	var util = __webpack_require__(8);
	
	function Async() {
	    this._customScheduler = false;
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._haveDrainedQueues = false;
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule = schedule;
	}
	
	Async.prototype.setScheduler = function(fn) {
	    var prev = this._schedule;
	    this._schedule = fn;
	    this._customScheduler = true;
	    return prev;
	};
	
	Async.prototype.hasCustomScheduler = function() {
	    return this._customScheduler;
	};
	
	Async.prototype.enableTrampoline = function() {
	    this._trampolineEnabled = true;
	};
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._isTickUsed || this._haveDrainedQueues;
	};
	
	
	Async.prototype.fatalError = function(e, isNode) {
	    if (isNode) {
	        process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) +
	            "\n");
	        process.exit(2);
	    } else {
	        this.throwLater(e);
	    }
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	function _drainQueue(queue) {
	    while (queue.length() > 0) {
	        _drainQueueStep(queue);
	    }
	}
	
	function _drainQueueStep(queue) {
	    var fn = queue.shift();
	    if (typeof fn !== "function") {
	        fn._settlePromises();
	    } else {
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	}
	
	Async.prototype._drainQueues = function () {
	    _drainQueue(this._normalQueue);
	    this._reset();
	    this._haveDrainedQueues = true;
	    _drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = Async;
	module.exports.firstLineError = firstLineError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 504 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise, debug) {
	var calledBind = false;
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (((this._bitField & 50397184) === 0)) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    if (!calledBind) {
	        calledBind = true;
	        Promise.prototype._propagateFrom = debug.propagateFromFunction();
	        Promise.prototype._boundValue = debug.boundValueFunction();
	    }
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, undefined, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, undefined, ret, context);
	        ret._setOnCancel(maybePromise);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 2097152;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~2097152);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 2097152) === 2097152;
	};
	
	Promise.bind = function (thisArg, value) {
	    return Promise.resolve(value).bind(thisArg);
	};
	};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = __webpack_require__(8);
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (true) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array(Math.max($_len - 1, 0)); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];};
	    if (true) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, PromiseArray, apiRejection, debug) {
	var util = __webpack_require__(8);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	Promise.prototype["break"] = Promise.prototype.cancel = function() {
	    if (!debug.cancellation()) return this._warn("cancellation is disabled");
	
	    var promise = this;
	    var child = promise;
	    while (promise._isCancellable()) {
	        if (!promise._cancelBy(child)) {
	            if (child._isFollowing()) {
	                child._followee().cancel();
	            } else {
	                child._cancelBranched();
	            }
	            break;
	        }
	
	        var parent = promise._cancellationParent;
	        if (parent == null || !parent._isCancellable()) {
	            if (promise._isFollowing()) {
	                promise._followee().cancel();
	            } else {
	                promise._cancelBranched();
	            }
	            break;
	        } else {
	            if (promise._isFollowing()) promise._followee().cancel();
	            promise._setWillBeCancelled();
	            child = promise;
	            promise = parent;
	        }
	    }
	};
	
	Promise.prototype._branchHasCancelled = function() {
	    this._branchesRemainingToCancel--;
	};
	
	Promise.prototype._enoughBranchesHaveCancelled = function() {
	    return this._branchesRemainingToCancel === undefined ||
	           this._branchesRemainingToCancel <= 0;
	};
	
	Promise.prototype._cancelBy = function(canceller) {
	    if (canceller === this) {
	        this._branchesRemainingToCancel = 0;
	        this._invokeOnCancel();
	        return true;
	    } else {
	        this._branchHasCancelled();
	        if (this._enoughBranchesHaveCancelled()) {
	            this._invokeOnCancel();
	            return true;
	        }
	    }
	    return false;
	};
	
	Promise.prototype._cancelBranched = function() {
	    if (this._enoughBranchesHaveCancelled()) {
	        this._cancel();
	    }
	};
	
	Promise.prototype._cancel = function() {
	    if (!this._isCancellable()) return;
	    this._setCancelled();
	    async.invoke(this._cancelPromises, this, undefined);
	};
	
	Promise.prototype._cancelPromises = function() {
	    if (this._length() > 0) this._settlePromises();
	};
	
	Promise.prototype._unsetOnCancel = function() {
	    this._onCancelField = undefined;
	};
	
	Promise.prototype._isCancellable = function() {
	    return this.isPending() && !this._isCancelled();
	};
	
	Promise.prototype.isCancellable = function() {
	    return this.isPending() && !this.isCancelled();
	};
	
	Promise.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
	    if (util.isArray(onCancelCallback)) {
	        for (var i = 0; i < onCancelCallback.length; ++i) {
	            this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
	        }
	    } else if (onCancelCallback !== undefined) {
	        if (typeof onCancelCallback === "function") {
	            if (!internalOnly) {
	                var e = tryCatch(onCancelCallback).call(this._boundValue());
	                if (e === errorObj) {
	                    this._attachExtraTrace(e.e);
	                    async.throwLater(e.e);
	                }
	            }
	        } else {
	            onCancelCallback._resultCancelled(this);
	        }
	    }
	};
	
	Promise.prototype._invokeOnCancel = function() {
	    var onCancelCallback = this._onCancel();
	    this._unsetOnCancel();
	    async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
	};
	
	Promise.prototype._invokeInternalOnCancel = function() {
	    if (this._isCancellable()) {
	        this._doInvokeOnCancel(this._onCancel(), true);
	        this._unsetOnCancel();
	    }
	};
	
	Promise.prototype._resultCancelled = function() {
	    this.cancel();
	};
	
	};


/***/ }),
/* 507 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	var longStackTraces = false;
	var contextStack = [];
	
	Promise.prototype._promiseCreated = function() {};
	Promise.prototype._pushContext = function() {};
	Promise.prototype._popContext = function() {return null;};
	Promise._peekContext = Promise.prototype._peekContext = function() {};
	
	function Context() {
	    this._trace = new Context.CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (this._trace !== undefined) {
	        this._trace._promiseCreated = null;
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (this._trace !== undefined) {
	        var trace = contextStack.pop();
	        var ret = trace._promiseCreated;
	        trace._promiseCreated = null;
	        return ret;
	    }
	    return null;
	};
	
	function createContext() {
	    if (longStackTraces) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	Context.CapturedTrace = null;
	Context.create = createContext;
	Context.deactivateLongStackTraces = function() {};
	Context.activateLongStackTraces = function() {
	    var Promise_pushContext = Promise.prototype._pushContext;
	    var Promise_popContext = Promise.prototype._popContext;
	    var Promise_PeekContext = Promise._peekContext;
	    var Promise_peekContext = Promise.prototype._peekContext;
	    var Promise_promiseCreated = Promise.prototype._promiseCreated;
	    Context.deactivateLongStackTraces = function() {
	        Promise.prototype._pushContext = Promise_pushContext;
	        Promise.prototype._popContext = Promise_popContext;
	        Promise._peekContext = Promise_PeekContext;
	        Promise.prototype._peekContext = Promise_peekContext;
	        Promise.prototype._promiseCreated = Promise_promiseCreated;
	        longStackTraces = false;
	    };
	    longStackTraces = true;
	    Promise.prototype._pushContext = Context.prototype._pushContext;
	    Promise.prototype._popContext = Context.prototype._popContext;
	    Promise._peekContext = Promise.prototype._peekContext = peekContext;
	    Promise.prototype._promiseCreated = function() {
	        var ctx = this._peekContext();
	        if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
	    };
	};
	return Context;
	};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function(Promise, Context) {
	var getDomain = Promise._getDomain;
	var async = Promise._async;
	var Warning = __webpack_require__(36).Warning;
	var util = __webpack_require__(8);
	var es5 = __webpack_require__(44);
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
	var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
	var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var printWarning;
	var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 &&
	                        (false ||
	                         util.env("BLUEBIRD_DEBUG") ||
	                         util.env("NODE_ENV") === "development"));
	
	var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 &&
	    (debugging || util.env("BLUEBIRD_WARNINGS")));
	
	var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 &&
	    (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
	
	var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 &&
	    (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
	
	Promise.prototype.suppressUnhandledRejections = function() {
	    var target = this._target();
	    target._bitField = ((target._bitField & (~1048576)) |
	                      524288);
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 524288) !== 0) return;
	    this._setRejectionIsUnhandled();
	    var self = this;
	    setTimeout(function() {
	        self._notifyUnhandledRejection();
	    }, 1);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._setReturnedNonUndefined = function() {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._returnedNonUndefined = function() {
	    return (this._bitField & 268435456) !== 0;
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._settledValue();
	        this._setUnhandledRejectionIsNotified();
	        fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 262144;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~262144);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 262144) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 1048576;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~1048576);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._warn = function(message, shouldUseOwnTrace, promise) {
	    return warn(message, shouldUseOwnTrace, promise || this);
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ?
	                                            fn : util.domainBind(domain, fn))
	                                 : undefined;
	};
	
	var disableLongStackTraces = function() {};
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() && !config.longStackTraces) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (!config.longStackTraces && longStackTracesIsSupported()) {
	        var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
	        var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
	        var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
	        config.longStackTraces = true;
	        disableLongStackTraces = function() {
	            if (async.haveItemsQueued() && !config.longStackTraces) {
	                throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	            }
	            Promise.prototype._captureStackTrace = Promise_captureStackTrace;
	            Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
	            Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
	            Context.deactivateLongStackTraces();
	            async.enableTrampoline();
	            config.longStackTraces = false;
	        };
	        Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
	        Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
	        Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
	        Context.activateLongStackTraces();
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return config.longStackTraces && longStackTracesIsSupported();
	};
	
	var fireDomEvent = (function() {
	    try {
	        if (typeof CustomEvent === "function") {
	            var event = new CustomEvent("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var eventData = {
	                    detail: event,
	                    cancelable: true
	                };
	                es5.defineProperty(
	                    eventData, "promise", {value: event.promise});
	                es5.defineProperty(eventData, "reason", {value: event.reason});
	                var domEvent = new CustomEvent(name.toLowerCase(), eventData);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else if (typeof Event === "function") {
	            var event = new Event("CustomEvent");
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = new Event(name.toLowerCase(), {
	                    cancelable: true
	                });
	                domEvent.detail = event;
	                es5.defineProperty(domEvent, "promise", {value: event.promise});
	                es5.defineProperty(domEvent, "reason", {value: event.reason});
	                return !util.global.dispatchEvent(domEvent);
	            };
	        } else {
	            var event = document.createEvent("CustomEvent");
	            event.initCustomEvent("testingtheevent", false, true, {});
	            util.global.dispatchEvent(event);
	            return function(name, event) {
	                var domEvent = document.createEvent("CustomEvent");
	                domEvent.initCustomEvent(name.toLowerCase(), false, true,
	                    event);
	                return !util.global.dispatchEvent(domEvent);
	            };
	        }
	    } catch (e) {}
	    return function() {
	        return false;
	    };
	})();
	
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function() {
	            return process.emit.apply(process, arguments);
	        };
	    } else {
	        if (!util.global) {
	            return function() {
	                return false;
	            };
	        }
	        return function(name) {
	            var methodName = "on" + name.toLowerCase();
	            var method = util.global[methodName];
	            if (!method) return false;
	            method.apply(util.global, [].slice.call(arguments, 1));
	            return true;
	        };
	    }
	})();
	
	function generatePromiseLifecycleEventObject(name, promise) {
	    return {promise: promise};
	}
	
	var eventToObjectGenerator = {
	    promiseCreated: generatePromiseLifecycleEventObject,
	    promiseFulfilled: generatePromiseLifecycleEventObject,
	    promiseRejected: generatePromiseLifecycleEventObject,
	    promiseResolved: generatePromiseLifecycleEventObject,
	    promiseCancelled: generatePromiseLifecycleEventObject,
	    promiseChained: function(name, promise, child) {
	        return {promise: promise, child: child};
	    },
	    warning: function(name, warning) {
	        return {warning: warning};
	    },
	    unhandledRejection: function (name, reason, promise) {
	        return {reason: reason, promise: promise};
	    },
	    rejectionHandled: generatePromiseLifecycleEventObject
	};
	
	var activeFireEvent = function (name) {
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent.apply(null, arguments);
	    } catch (e) {
	        async.throwLater(e);
	        globalEventFired = true;
	    }
	
	    var domEventFired = false;
	    try {
	        domEventFired = fireDomEvent(name,
	                    eventToObjectGenerator[name].apply(null, arguments));
	    } catch (e) {
	        async.throwLater(e);
	        domEventFired = true;
	    }
	
	    return domEventFired || globalEventFired;
	};
	
	Promise.config = function(opts) {
	    opts = Object(opts);
	    if ("longStackTraces" in opts) {
	        if (opts.longStackTraces) {
	            Promise.longStackTraces();
	        } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
	            disableLongStackTraces();
	        }
	    }
	    if ("warnings" in opts) {
	        var warningsOption = opts.warnings;
	        config.warnings = !!warningsOption;
	        wForgottenReturn = config.warnings;
	
	        if (util.isObject(warningsOption)) {
	            if ("wForgottenReturn" in warningsOption) {
	                wForgottenReturn = !!warningsOption.wForgottenReturn;
	            }
	        }
	    }
	    if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
	        if (async.haveItemsQueued()) {
	            throw new Error(
	                "cannot enable cancellation after promises are in use");
	        }
	        Promise.prototype._clearCancellationData =
	            cancellationClearCancellationData;
	        Promise.prototype._propagateFrom = cancellationPropagateFrom;
	        Promise.prototype._onCancel = cancellationOnCancel;
	        Promise.prototype._setOnCancel = cancellationSetOnCancel;
	        Promise.prototype._attachCancellationCallback =
	            cancellationAttachCancellationCallback;
	        Promise.prototype._execute = cancellationExecute;
	        propagateFromFunction = cancellationPropagateFrom;
	        config.cancellation = true;
	    }
	    if ("monitoring" in opts) {
	        if (opts.monitoring && !config.monitoring) {
	            config.monitoring = true;
	            Promise.prototype._fireEvent = activeFireEvent;
	        } else if (!opts.monitoring && config.monitoring) {
	            config.monitoring = false;
	            Promise.prototype._fireEvent = defaultFireEvent;
	        }
	    }
	    return Promise;
	};
	
	function defaultFireEvent() { return false; }
	
	Promise.prototype._fireEvent = defaultFireEvent;
	Promise.prototype._execute = function(executor, resolve, reject) {
	    try {
	        executor(resolve, reject);
	    } catch (e) {
	        return e;
	    }
	};
	Promise.prototype._onCancel = function () {};
	Promise.prototype._setOnCancel = function (handler) { ; };
	Promise.prototype._attachCancellationCallback = function(onCancel) {
	    ;
	};
	Promise.prototype._captureStackTrace = function () {};
	Promise.prototype._attachExtraTrace = function () {};
	Promise.prototype._dereferenceTrace = function () {};
	Promise.prototype._clearCancellationData = function() {};
	Promise.prototype._propagateFrom = function (parent, flags) {
	    ;
	    ;
	};
	
	function cancellationExecute(executor, resolve, reject) {
	    var promise = this;
	    try {
	        executor(resolve, reject, function(onCancel) {
	            if (typeof onCancel !== "function") {
	                throw new TypeError("onCancel must be a function, got: " +
	                                    util.toString(onCancel));
	            }
	            promise._attachCancellationCallback(onCancel);
	        });
	    } catch (e) {
	        return e;
	    }
	}
	
	function cancellationAttachCancellationCallback(onCancel) {
	    if (!this._isCancellable()) return this;
	
	    var previousOnCancel = this._onCancel();
	    if (previousOnCancel !== undefined) {
	        if (util.isArray(previousOnCancel)) {
	            previousOnCancel.push(onCancel);
	        } else {
	            this._setOnCancel([previousOnCancel, onCancel]);
	        }
	    } else {
	        this._setOnCancel(onCancel);
	    }
	}
	
	function cancellationOnCancel() {
	    return this._onCancelField;
	}
	
	function cancellationSetOnCancel(onCancel) {
	    this._onCancelField = onCancel;
	}
	
	function cancellationClearCancellationData() {
	    this._cancellationParent = undefined;
	    this._onCancelField = undefined;
	}
	
	function cancellationPropagateFrom(parent, flags) {
	    if ((flags & 1) !== 0) {
	        this._cancellationParent = parent;
	        var branchesRemainingToCancel = parent._branchesRemainingToCancel;
	        if (branchesRemainingToCancel === undefined) {
	            branchesRemainingToCancel = 0;
	        }
	        parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
	    }
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	
	function bindingPropagateFrom(parent, flags) {
	    if ((flags & 2) !== 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	}
	var propagateFromFunction = bindingPropagateFrom;
	
	function boundValueFunction() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	}
	
	function longStackTracesCaptureStackTrace() {
	    this._trace = new CapturedTrace(this._peekContext());
	}
	
	function longStackTracesAttachExtraTrace(error, ignoreSelf) {
	    if (canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	}
	
	function longStackTracesDereferenceTrace() {
	    this._trace = undefined;
	}
	
	function checkForgottenReturns(returnValue, promiseCreated, name, promise,
	                               parent) {
	    if (returnValue === undefined && promiseCreated !== null &&
	        wForgottenReturn) {
	        if (parent !== undefined && parent._returnedNonUndefined()) return;
	        if ((promise._bitField & 65535) === 0) return;
	
	        if (name) name = name + " ";
	        var handlerLine = "";
	        var creatorLine = "";
	        if (promiseCreated._trace) {
	            var traceLines = promiseCreated._trace.stack.split("\n");
	            var stack = cleanStack(traceLines);
	            for (var i = stack.length - 1; i >= 0; --i) {
	                var line = stack[i];
	                if (!nodeFramePattern.test(line)) {
	                    var lineMatches = line.match(parseLinePattern);
	                    if (lineMatches) {
	                        handlerLine  = "at " + lineMatches[1] +
	                            ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
	                    }
	                    break;
	                }
	            }
	
	            if (stack.length > 0) {
	                var firstUserLine = stack[0];
	                for (var i = 0; i < traceLines.length; ++i) {
	
	                    if (traceLines[i] === firstUserLine) {
	                        if (i > 0) {
	                            creatorLine = "\n" + traceLines[i - 1];
	                        }
	                        break;
	                    }
	                }
	
	            }
	        }
	        var msg = "a promise was created in a " + name +
	            "handler " + handlerLine + "but was not returned from it, " +
	            "see http://goo.gl/rRqMUw" +
	            creatorLine;
	        promise._warn(msg, true, promiseCreated);
	    }
	}
	
	function deprecated(name, replacement) {
	    var message = name +
	        " is deprecated and will be removed in a future version.";
	    if (replacement) message += " Use " + replacement + " instead.";
	    return warn(message);
	}
	
	function warn(message, shouldUseOwnTrace, promise) {
	    if (!config.warnings) return;
	    var warning = new Warning(message);
	    var ctx;
	    if (shouldUseOwnTrace) {
	        promise._attachExtraTrace(warning);
	    } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	
	    if (!activeFireEvent("warning", warning)) {
	        formatAndLogError(warning, "", true);
	    }
	}
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = "    (No stack trace)" === line ||
	            stackFramePattern.test(line);
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0 && error.name != "SyntaxError") {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	function parseStackAndMessage(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
	    };
	}
	
	function formatAndLogError(error, title, isSoft) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (util.isObject(error)) {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof printWarning === "function") {
	            printWarning(message, isSoft);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	}
	
	function fireRejectionEvent(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    if (name === "unhandledRejection") {
	        if (!activeFireEvent(name, reason, promise) && !localEventFired) {
	            formatAndLogError(reason, "Unhandled rejection ");
	        }
	    } else {
	        activeFireEvent(name, promise);
	    }
	}
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj && typeof obj.toString === "function"
	            ? obj.toString() : util.toString(obj);
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	function longStackTracesIsSupported() {
	    return typeof captureStackTrace === "function";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	
	function setBounds(firstLineError, lastLineError) {
	    if (!longStackTracesIsSupported()) return;
	    var firstStackLines = (firstLineError.stack || "").split("\n");
	    var lastStackLines = (lastLineError.stack || "").split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	}
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    this._promisesCreated = 0;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	Context.CapturedTrace = CapturedTrace;
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit += 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit += 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit -= 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit += 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit -= 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    printWarning = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        printWarning = function(message, isSoft) {
	            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
	            console.warn(color + message + "\u001b[0m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        printWarning = function(message, isSoft) {
	            console.warn("%c" + message,
	                        isSoft ? "color: darkorange" : "color: red");
	        };
	    }
	}
	
	var config = {
	    warnings: warnings,
	    longStackTraces: false,
	    cancellation: false,
	    monitoring: false
	};
	
	if (longStackTraces) Promise.longStackTraces();
	
	return {
	    longStackTraces: function() {
	        return config.longStackTraces;
	    },
	    warnings: function() {
	        return config.warnings;
	    },
	    cancellation: function() {
	        return config.cancellation;
	    },
	    monitoring: function() {
	        return config.monitoring;
	    },
	    propagateFromFunction: function() {
	        return propagateFromFunction;
	    },
	    boundValueFunction: function() {
	        return boundValueFunction;
	    },
	    checkForgottenReturns: checkForgottenReturns,
	    setBounds: setBounds,
	    warn: warn,
	    deprecated: deprecated,
	    CapturedTrace: CapturedTrace,
	    fireDomEvent: fireDomEvent,
	    fireGlobalEvent: fireGlobalEvent
	};
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 509 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function returner() {
	    return this.value;
	}
	function thrower() {
	    throw this.reason;
	}
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value instanceof Promise) value.suppressUnhandledRejections();
	    return this._then(
	        returner, undefined, undefined, {value: value}, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    return this._then(
	        thrower, undefined, undefined, {reason: reason}, undefined);
	};
	
	Promise.prototype.catchThrow = function (reason) {
	    if (arguments.length <= 1) {
	        return this._then(
	            undefined, thrower, undefined, {reason: reason}, undefined);
	    } else {
	        var _reason = arguments[1];
	        var handler = function() {throw _reason;};
	        return this.caught(reason, handler);
	    }
	};
	
	Promise.prototype.catchReturn = function (value) {
	    if (arguments.length <= 1) {
	        if (value instanceof Promise) value.suppressUnhandledRejections();
	        return this._then(
	            undefined, returner, undefined, {value: value}, undefined);
	    } else {
	        var _value = arguments[1];
	        if (_value instanceof Promise) _value.suppressUnhandledRejections();
	        var handler = function() {return _value;};
	        return this.caught(value, handler);
	    }
	};
	};


/***/ }),
/* 510 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	var PromiseAll = Promise.all;
	
	function promiseAllThis() {
	    return PromiseAll(this);
	}
	
	function PromiseMapSeries(promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
	}
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, this, undefined);
	};
	
	Promise.prototype.mapSeries = function (fn) {
	    return PromiseReduce(this, fn, INTERNAL, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, INTERNAL, 0)
	              ._then(promiseAllThis, undefined, undefined, promises, undefined);
	};
	
	Promise.mapSeries = PromiseMapSeries;
	};
	


/***/ }),
/* 511 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, tryConvertToPromise, NEXT_FILTER) {
	var util = __webpack_require__(8);
	var CancellationError = Promise.CancellationError;
	var errorObj = util.errorObj;
	var catchFilter = __webpack_require__(219)(NEXT_FILTER);
	
	function PassThroughHandlerContext(promise, type, handler) {
	    this.promise = promise;
	    this.type = type;
	    this.handler = handler;
	    this.called = false;
	    this.cancelPromise = null;
	}
	
	PassThroughHandlerContext.prototype.isFinallyHandler = function() {
	    return this.type === 0;
	};
	
	function FinallyHandlerCancelReaction(finallyHandler) {
	    this.finallyHandler = finallyHandler;
	}
	
	FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
	    checkCancel(this.finallyHandler);
	};
	
	function checkCancel(ctx, reason) {
	    if (ctx.cancelPromise != null) {
	        if (arguments.length > 1) {
	            ctx.cancelPromise._reject(reason);
	        } else {
	            ctx.cancelPromise._cancel();
	        }
	        ctx.cancelPromise = null;
	        return true;
	    }
	    return false;
	}
	
	function succeed() {
	    return finallyHandler.call(this, this.promise._target()._settledValue());
	}
	function fail(reason) {
	    if (checkCancel(this, reason)) return;
	    errorObj.e = reason;
	    return errorObj;
	}
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    if (!this.called) {
	        this.called = true;
	        var ret = this.isFinallyHandler()
	            ? handler.call(promise._boundValue())
	            : handler.call(promise._boundValue(), reasonOrValue);
	        if (ret === NEXT_FILTER) {
	            return ret;
	        } else if (ret !== undefined) {
	            promise._setReturnedNonUndefined();
	            var maybePromise = tryConvertToPromise(ret, promise);
	            if (maybePromise instanceof Promise) {
	                if (this.cancelPromise != null) {
	                    if (maybePromise._isCancelled()) {
	                        var reason =
	                            new CancellationError("late cancellation observer");
	                        promise._attachExtraTrace(reason);
	                        errorObj.e = reason;
	                        return errorObj;
	                    } else if (maybePromise.isPending()) {
	                        maybePromise._attachCancellationCallback(
	                            new FinallyHandlerCancelReaction(this));
	                    }
	                }
	                return maybePromise._then(
	                    succeed, fail, undefined, this, undefined);
	            }
	        }
	    }
	
	    if (promise.isRejected()) {
	        checkCancel(this);
	        errorObj.e = reasonOrValue;
	        return errorObj;
	    } else {
	        checkCancel(this);
	        return reasonOrValue;
	    }
	}
	
	Promise.prototype._passThrough = function(handler, type, success, fail) {
	    if (typeof handler !== "function") return this.then();
	    return this._then(success,
	                      fail,
	                      undefined,
	                      new PassThroughHandlerContext(this, type, handler),
	                      undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThrough(handler,
	                             0,
	                             finallyHandler,
	                             finallyHandler);
	};
	
	
	Promise.prototype.tap = function (handler) {
	    return this._passThrough(handler, 1, finallyHandler);
	};
	
	Promise.prototype.tapCatch = function (handlerOrPredicate) {
	    var len = arguments.length;
	    if(len === 1) {
	        return this._passThrough(handlerOrPredicate,
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    } else {
	         var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(new TypeError(
	                    "tapCatch statement predicate: "
	                    + "expecting an object but got " + util.classString(item)
	                ));
	            }
	        }
	        catchInstances.length = j;
	        var handler = arguments[i];
	        return this._passThrough(catchFilter(catchInstances, handler, this),
	                                 1,
	                                 undefined,
	                                 finallyHandler);
	    }
	
	};
	
	return PassThroughHandlerContext;
	};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise,
	                          Proxyable,
	                          debug) {
	var errors = __webpack_require__(36);
	var TypeError = errors.TypeError;
	var util = __webpack_require__(8);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    if (debug.cancellation()) {
	        var internal = new Promise(INTERNAL);
	        var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);
	        this._promise = internal.lastly(function() {
	            return _finallyPromise;
	        });
	        internal._captureStackTrace();
	        internal._setOnCancel(this);
	    } else {
	        var promise = this._promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	    }
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	    this._yieldedPromise = null;
	    this._cancellationPhase = false;
	}
	util.inherits(PromiseSpawn, Proxyable);
	
	PromiseSpawn.prototype._isResolved = function() {
	    return this._promise === null;
	};
	
	PromiseSpawn.prototype._cleanup = function() {
	    this._promise = this._generator = null;
	    if (debug.cancellation() && this._finallyPromise !== null) {
	        this._finallyPromise._fulfill();
	        this._finallyPromise = null;
	    }
	};
	
	PromiseSpawn.prototype._promiseCancelled = function() {
	    if (this._isResolved()) return;
	    var implementsReturn = typeof this._generator["return"] !== "undefined";
	
	    var result;
	    if (!implementsReturn) {
	        var reason = new Promise.CancellationError(
	            "generator .return() sentinel");
	        Promise.coroutine.returnSentinel = reason;
	        this._promise._attachExtraTrace(reason);
	        this._promise._pushContext();
	        result = tryCatch(this._generator["throw"]).call(this._generator,
	                                                         reason);
	        this._promise._popContext();
	    } else {
	        this._promise._pushContext();
	        result = tryCatch(this._generator["return"]).call(this._generator,
	                                                          undefined);
	        this._promise._popContext();
	    }
	    this._cancellationPhase = true;
	    this._yieldedPromise = null;
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseFulfilled = function(value) {
	    this._yieldedPromise = null;
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._promiseRejected = function(reason) {
	    this._yieldedPromise = null;
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._resultCancelled = function() {
	    if (this._yieldedPromise instanceof Promise) {
	        var promise = this._yieldedPromise;
	        this._yieldedPromise = null;
	        promise.cancel();
	    }
	};
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._promiseFulfilled(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    var promise = this._promise;
	    if (result === errorObj) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._rejectCallback(result.e, false);
	        }
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._cleanup();
	        if (this._cancellationPhase) {
	            return promise.cancel();
	        } else {
	            return promise._resolveCallback(value);
	        }
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._promiseRejected(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise = maybePromise._target();
	        var bitField = maybePromise._bitField;
	        ;
	        if (((bitField & 50397184) === 0)) {
	            this._yieldedPromise = maybePromise;
	            maybePromise._proxy(this, null);
	        } else if (((bitField & 33554432) !== 0)) {
	            Promise._async.invoke(
	                this._promiseFulfilled, this, maybePromise._value()
	            );
	        } else if (((bitField & 16777216) !== 0)) {
	            Promise._async.invoke(
	                this._promiseRejected, this, maybePromise._reason()
	            );
	        } else {
	            this._promiseCancelled();
	        }
	    }
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        var ret = spawn.promise();
	        spawn._generator = generator;
	        spawn._promiseFulfilled(undefined);
	        return ret;
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    debug.deprecated("Promise.spawn()", "Promise.coroutine()");
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async,
	         getDomain) {
	var util = __webpack_require__(8);
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (true) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var promiseSetter = function(i) {
	        return new Function("promise", "holder", "                           \n\
	            'use strict';                                                    \n\
	            holder.pIndex = promise;                                         \n\
	            ".replace(/Index/g, i));
	    };
	
	    var generateHolderClass = function(total) {
	        var props = new Array(total);
	        for (var i = 0; i < props.length; ++i) {
	            props[i] = "this.p" + (i+1);
	        }
	        var assignment = props.join(" = ") + " = null;";
	        var cancellationCode= "var promise;\n" + props.map(function(prop) {
	            return "                                                         \n\
	                promise = " + prop + ";                                      \n\
	                if (promise instanceof Promise) {                            \n\
	                    promise.cancel();                                        \n\
	                }                                                            \n\
	            ";
	        }).join("\n");
	        var passedArguments = props.join(", ");
	        var name = "Holder$" + total;
	
	
	        var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
	            'use strict';                                                    \n\
	            function [TheName](fn) {                                         \n\
	                [TheProperties]                                              \n\
	                this.fn = fn;                                                \n\
	                this.asyncNeeded = true;                                     \n\
	                this.now = 0;                                                \n\
	            }                                                                \n\
	                                                                             \n\
	            [TheName].prototype._callFunction = function(promise) {          \n\
	                promise._pushContext();                                      \n\
	                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
	                promise._popContext();                                       \n\
	                if (ret === errorObj) {                                      \n\
	                    promise._rejectCallback(ret.e, false);                   \n\
	                } else {                                                     \n\
	                    promise._resolveCallback(ret);                           \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype.checkFulfillment = function(promise) {       \n\
	                var now = ++this.now;                                        \n\
	                if (now === [TheTotal]) {                                    \n\
	                    if (this.asyncNeeded) {                                  \n\
	                        async.invoke(this._callFunction, this, promise);     \n\
	                    } else {                                                 \n\
	                        this._callFunction(promise);                         \n\
	                    }                                                        \n\
	                                                                             \n\
	                }                                                            \n\
	            };                                                               \n\
	                                                                             \n\
	            [TheName].prototype._resultCancelled = function() {              \n\
	                [CancellationCode]                                           \n\
	            };                                                               \n\
	                                                                             \n\
	            return [TheName];                                                \n\
	        }(tryCatch, errorObj, Promise, async);                               \n\
	        ";
	
	        code = code.replace(/\[TheName\]/g, name)
	            .replace(/\[TheTotal\]/g, total)
	            .replace(/\[ThePassedArguments\]/g, passedArguments)
	            .replace(/\[TheProperties\]/g, assignment)
	            .replace(/\[CancellationCode\]/g, cancellationCode);
	
	        return new Function("tryCatch", "errorObj", "Promise", "async", code)
	                           (tryCatch, errorObj, Promise, async);
	    };
	
	    var holderClasses = [];
	    var thenCallbacks = [];
	    var promiseSetters = [];
	
	    for (var i = 0; i < 8; ++i) {
	        holderClasses.push(generateHolderClass(i + 1));
	        thenCallbacks.push(thenCallback(i + 1));
	        promiseSetters.push(promiseSetter(i + 1));
	    }
	
	    reject = function (reason) {
	        this._reject(reason);
	    };
	}}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (true) {
	            if (last <= 8 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var HolderClass = holderClasses[last - 1];
	                var holder = new HolderClass(fn);
	                var callbacks = thenCallbacks;
	
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        var bitField = maybePromise._bitField;
	                        ;
	                        if (((bitField & 50397184) === 0)) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                            promiseSetters[i](maybePromise, holder);
	                            holder.asyncNeeded = false;
	                        } else if (((bitField & 33554432) !== 0)) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else if (((bitField & 16777216) !== 0)) {
	                            ret._reject(maybePromise._reason());
	                        } else {
	                            ret._cancel();
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	
	                if (!ret._isFateSealed()) {
	                    if (holder.asyncNeeded) {
	                        var domain = getDomain();
	                        if (domain !== null) {
	                            holder.fn = util.domainBind(domain, holder.fn);
	                        }
	                    }
	                    ret._setAsyncGuaranteed();
	                    ret._setOnCancel(holder);
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];};
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(8);
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var async = Promise._async;
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : util.domainBind(domain, fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = [];
	    async.invoke(this._asyncInit, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	
	MappingPromiseArray.prototype._asyncInit = function() {
	    this._init$(undefined, -2);
	};
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	
	    if (index < 0) {
	        index = (index * -1) - 1;
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return true;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return false;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var promise = this._promise;
	        var callback = this._callback;
	        var receiver = promise._boundValue();
	        promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        var promiseCreated = promise._popContext();
	        debug.checkForgottenReturns(
	            ret,
	            promiseCreated,
	            preservedValues !== null ? "Promise.filter" : "Promise.map",
	            promise
	        );
	        if (ret === errorObj) {
	            this._reject(ret.e);
	            return true;
	        }
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            var bitField = maybePromise._bitField;
	            ;
	            if (((bitField & 50397184) === 0)) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = maybePromise;
	                maybePromise._proxy(this, (index + 1) * -1);
	                return false;
	            } else if (((bitField & 33554432) !== 0)) {
	                ret = maybePromise._value();
	            } else if (((bitField & 16777216) !== 0)) {
	                this._reject(maybePromise._reason());
	                return true;
	            } else {
	                this._cancel();
	                return true;
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	        return true;
	    }
	    return false;
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	
	    var limit = 0;
	    if (options !== undefined) {
	        if (typeof options === "object" && options !== null) {
	            if (typeof options.concurrency !== "number") {
	                return Promise.reject(
	                    new TypeError("'concurrency' must be a number but it is " +
	                                    util.classString(options.concurrency)));
	            }
	            limit = options.concurrency;
	        } else {
	            return Promise.reject(new TypeError(
	                            "options argument must be an object but it is " +
	                             util.classString(options)));
	        }
	    }
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter).promise();
	}
	
	Promise.prototype.map = function (fn, options) {
	    return map(this, fn, options, null);
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    return map(promises, fn, options, _filter);
	};
	
	
	};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
	var util = __webpack_require__(8);
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        var promiseCreated = ret._popContext();
	        debug.checkForgottenReturns(
	            value, promiseCreated, "Promise.method", ret);
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value;
	    if (arguments.length > 1) {
	        debug.deprecated("calling Promise.try with more than 1 argument");
	        var arg = arguments[1];
	        var ctx = arguments[2];
	        value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg)
	                                  : tryCatch(fn).call(ctx, arg);
	    } else {
	        value = tryCatch(fn)();
	    }
	    var promiseCreated = ret._popContext();
	    debug.checkForgottenReturns(
	        value, promiseCreated, "Promise.try", ret);
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise) {
	var util = __webpack_require__(8);
	var async = Promise._async;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var newReason = new Error(reason + "");
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback,
	                                                                     options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var reflectHandler = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	function Proxyable() {}
	var UNDEFINED_BINDING = {};
	var util = __webpack_require__(8);
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var es5 = __webpack_require__(44);
	var Async = __webpack_require__(503);
	var async = new Async();
	es5.defineProperty(Promise, "_async", {value: async});
	var errors = __webpack_require__(36);
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	var CancellationError = Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {};
	var tryConvertToPromise = __webpack_require__(529)(Promise, INTERNAL);
	var PromiseArray =
	    __webpack_require__(519)(Promise, INTERNAL,
	                               tryConvertToPromise, apiRejection, Proxyable);
	var Context = __webpack_require__(507)(Promise);
	 /*jshint unused:false*/
	var createContext = Context.create;
	var debug = __webpack_require__(508)(Promise, Context);
	var CapturedTrace = debug.CapturedTrace;
	var PassThroughHandlerContext =
	    __webpack_require__(512)(Promise, tryConvertToPromise, NEXT_FILTER);
	var catchFilter = __webpack_require__(219)(NEXT_FILTER);
	var nodebackForPromise = __webpack_require__(220);
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	function check(self, executor) {
	    if (self == null || self.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    if (typeof executor !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(executor));
	    }
	
	}
	
	function Promise(executor) {
	    if (executor !== INTERNAL) {
	        check(this, executor);
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._resolveFromExecutor(executor);
	    this._promiseCreated();
	    this._fireEvent("promiseCreated", this);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (util.isObject(item)) {
	                catchInstances[j++] = item;
	            } else {
	                return apiRejection("Catch statement predicate: " +
	                    "expecting an object but got " + util.classString(item));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	
	        if (typeof fn !== "function") {
	            throw new TypeError("The last argument to .catch() " +
	                "must be a function, got " + util.toString(fn));
	        }
	        return this.then(undefined, catchFilter(catchInstances, fn, this));
	    }
	    return this.then(undefined, fn);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflectHandler,
	        reflectHandler, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject) {
	    if (debug.warnings() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, undefined, undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject) {
	    var promise =
	        this._then(didFulfill, didReject, undefined, undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (fn) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    return this.all()._then(fn, undefined, undefined, APPLY, undefined);
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    if (arguments.length > 0) {
	        this._warn(".all() was passed arguments but it does not take any");
	    }
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = Promise.fromCallback = function(fn) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs
	                                         : false;
	    var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true);
	    }
	    if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._setFulfilled();
	        ret._rejectionHandler0 = obj;
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    return async.setScheduler(fn);
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    _,    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var promise = haveInternalData ? internalData : new Promise(INTERNAL);
	    var target = this._target();
	    var bitField = target._bitField;
	
	    if (!haveInternalData) {
	        promise._propagateFrom(this, 3);
	        promise._captureStackTrace();
	        if (receiver === undefined &&
	            ((this._bitField & 2097152) !== 0)) {
	            if (!((bitField & 50397184) === 0)) {
	                receiver = this._boundValue();
	            } else {
	                receiver = target === this ? undefined : this._boundTo;
	            }
	        }
	        this._fireEvent("promiseChained", this, promise);
	    }
	
	    var domain = getDomain();
	    if (!((bitField & 50397184) === 0)) {
	        var handler, value, settler = target._settlePromiseCtx;
	        if (((bitField & 33554432) !== 0)) {
	            value = target._rejectionHandler0;
	            handler = didFulfill;
	        } else if (((bitField & 16777216) !== 0)) {
	            value = target._fulfillmentHandler0;
	            handler = didReject;
	            target._unsetRejectionIsUnhandled();
	        } else {
	            settler = target._settlePromiseLateCancellationObserver;
	            value = new CancellationError("late cancellation observer");
	            target._attachExtraTrace(value);
	            handler = didReject;
	        }
	
	        async.invoke(settler, target, {
	            handler: domain === null ? handler
	                : (typeof handler === "function" &&
	                    util.domainBind(domain, handler)),
	            promise: promise,
	            receiver: receiver,
	            value: value
	        });
	    } else {
	        target._addCallbacks(didFulfill, didReject, promise, receiver, domain);
	    }
	
	    return promise;
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 65535;
	};
	
	Promise.prototype._isFateSealed = function () {
	    return (this._bitField & 117506048) !== 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 67108864) === 67108864;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -65536) |
	        (len & 65535);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 33554432;
	    this._fireEvent("promiseFulfilled", this);
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 16777216;
	    this._fireEvent("promiseRejected", this);
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 67108864;
	    this._fireEvent("promiseResolved", this);
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._unsetCancelled = function() {
	    this._bitField = this._bitField & (~65536);
	};
	
	Promise.prototype._setCancelled = function() {
	    this._bitField = this._bitField | 65536;
	    this._fireEvent("promiseCancelled", this);
	};
	
	Promise.prototype._setWillBeCancelled = function() {
	    this._bitField = this._bitField | 8388608;
	};
	
	Promise.prototype._setAsyncGuaranteed = function() {
	    if (async.hasCustomScheduler()) return;
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0 ? this._receiver0 : this[
	            index * 4 - 4 + 3];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return this[
	            index * 4 - 4 + 2];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return this[
	            index * 4 - 4 + 1];
	};
	
	Promise.prototype._boundValue = function() {};
	
	Promise.prototype._migrateCallback0 = function (follower) {
	    var bitField = follower._bitField;
	    var fulfill = follower._fulfillmentHandler0;
	    var reject = follower._rejectionHandler0;
	    var promise = follower._promise0;
	    var receiver = follower._receiverAt(0);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._migrateCallbackAt = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 65535 - 4) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        this._receiver0 = receiver;
	        if (typeof fulfill === "function") {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    } else {
	        var base = index * 4 - 4;
	        this[base + 2] = promise;
	        this[base + 3] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : util.domainBind(domain, fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : util.domainBind(domain, reject);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._proxy = function (proxyable, arg) {
	    this._addCallbacks(undefined, undefined, arg, proxyable, null);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (((this._bitField & 117506048) !== 0)) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    if (shouldBind) this._propagateFrom(maybePromise, 2);
	
	    var promise = maybePromise._target();
	
	    if (promise === this) {
	        this._reject(makeSelfResolutionError());
	        return;
	    }
	
	    var bitField = promise._bitField;
	    if (((bitField & 50397184) === 0)) {
	        var len = this._length();
	        if (len > 0) promise._migrateCallback0(this);
	        for (var i = 1; i < len; ++i) {
	            promise._migrateCallbackAt(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (((bitField & 33554432) !== 0)) {
	        this._fulfill(promise._value());
	    } else if (((bitField & 16777216) !== 0)) {
	        this._reject(promise._reason());
	    } else {
	        var reason = new CancellationError("late cancellation observer");
	        promise._attachExtraTrace(reason);
	        this._reject(reason);
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, ignoreNonErrorWarnings) {
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
	        var message = "a promise was rejected with a non-error: " +
	            util.classString(reason);
	        this._warn(message, true);
	    }
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason);
	};
	
	Promise.prototype._resolveFromExecutor = function (executor) {
	    if (executor === INTERNAL) return;
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = this._execute(executor, function(value) {
	        promise._resolveCallback(value);
	    }, function (reason) {
	        promise._rejectCallback(reason, synchronous);
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined) {
	        promise._rejectCallback(r, true);
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    var bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY) {
	        if (!value || typeof value.length !== "number") {
	            x = errorObj;
	            x.e = new TypeError("cannot .spread() a non-array: " +
	                                    util.classString(value));
	        } else {
	            x = tryCatch(handler).apply(this._boundValue(), value);
	        }
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    var promiseCreated = promise._popContext();
	    bitField = promise._bitField;
	    if (((bitField & 65536) !== 0)) return;
	
	    if (x === NEXT_FILTER) {
	        promise._reject(value);
	    } else if (x === errorObj) {
	        promise._rejectCallback(x.e, false);
	    } else {
	        debug.checkForgottenReturns(x, promiseCreated, "",  promise, this);
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._settlePromise = function(promise, handler, receiver, value) {
	    var isPromise = promise instanceof Promise;
	    var bitField = this._bitField;
	    var asyncGuaranteed = ((bitField & 134217728) !== 0);
	    if (((bitField & 65536) !== 0)) {
	        if (isPromise) promise._invokeInternalOnCancel();
	
	        if (receiver instanceof PassThroughHandlerContext &&
	            receiver.isFinallyHandler()) {
	            receiver.cancelPromise = promise;
	            if (tryCatch(handler).call(receiver, value) === errorObj) {
	                promise._reject(errorObj.e);
	            }
	        } else if (handler === reflectHandler) {
	            promise._fulfill(reflectHandler.call(receiver));
	        } else if (receiver instanceof Proxyable) {
	            receiver._promiseCancelled(promise);
	        } else if (isPromise || promise instanceof PromiseArray) {
	            promise._cancel();
	        } else {
	            receiver.cancel();
	        }
	    } else if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            if (asyncGuaranteed) promise._setAsyncGuaranteed();
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof Proxyable) {
	        if (!receiver._isResolved()) {
	            if (((bitField & 33554432) !== 0)) {
	                receiver._promiseFulfilled(value, promise);
	            } else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (asyncGuaranteed) promise._setAsyncGuaranteed();
	        if (((bitField & 33554432) !== 0)) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value);
	        }
	    }
	};
	
	Promise.prototype._settlePromiseLateCancellationObserver = function(ctx) {
	    var handler = ctx.handler;
	    var promise = ctx.promise;
	    var receiver = ctx.receiver;
	    var value = ctx.value;
	    if (typeof handler === "function") {
	        if (!(promise instanceof Promise)) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (promise instanceof Promise) {
	        promise._reject(value);
	    }
	};
	
	Promise.prototype._settlePromiseCtx = function(ctx) {
	    this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
	};
	
	Promise.prototype._settlePromise0 = function(handler, value, bitField) {
	    var promise = this._promise0;
	    var receiver = this._receiverAt(0);
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settlePromise(promise, handler, receiver, value);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    var base = index * 4 - 4;
	    this[base + 2] =
	    this[base + 3] =
	    this[base + 0] =
	    this[base + 1] = undefined;
	};
	
	Promise.prototype._fulfill = function (value) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._reject(err);
	    }
	    this._setFulfilled();
	    this._rejectionHandler0 = value;
	
	    if ((bitField & 65535) > 0) {
	        if (((bitField & 134217728) !== 0)) {
	            this._settlePromises();
	        } else {
	            async.settlePromises(this);
	        }
	        this._dereferenceTrace();
	    }
	};
	
	Promise.prototype._reject = function (reason) {
	    var bitField = this._bitField;
	    if (((bitField & 117506048) >>> 16)) return;
	    this._setRejected();
	    this._fulfillmentHandler0 = reason;
	
	    if (this._isFinal()) {
	        return async.fatalError(reason, util.isNode);
	    }
	
	    if ((bitField & 65535) > 0) {
	        async.settlePromises(this);
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._fulfillPromises = function (len, value) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._fulfillmentHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, value);
	    }
	};
	
	Promise.prototype._rejectPromises = function (len, reason) {
	    for (var i = 1; i < len; i++) {
	        var handler = this._rejectionHandlerAt(i);
	        var promise = this._promiseAt(i);
	        var receiver = this._receiverAt(i);
	        this._clearCallbackDataAtIndex(i);
	        this._settlePromise(promise, handler, receiver, reason);
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    var bitField = this._bitField;
	    var len = (bitField & 65535);
	
	    if (len > 0) {
	        if (((bitField & 16842752) !== 0)) {
	            var reason = this._fulfillmentHandler0;
	            this._settlePromise0(this._rejectionHandler0, reason, bitField);
	            this._rejectPromises(len, reason);
	        } else {
	            var value = this._rejectionHandler0;
	            this._settlePromise0(this._fulfillmentHandler0, value, bitField);
	            this._fulfillPromises(len, value);
	        }
	        this._setLength(0);
	    }
	    this._clearCancellationData();
	};
	
	Promise.prototype._settledValue = function() {
	    var bitField = this._bitField;
	    if (((bitField & 33554432) !== 0)) {
	        return this._rejectionHandler0;
	    } else if (((bitField & 16777216) !== 0)) {
	        return this._fulfillmentHandler0;
	    }
	};
	
	if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
	    es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
	        get: function () {
	            return "Object";
	        }
	    });
	}
	
	function deferResolve(v) {this.promise._resolveCallback(v);}
	function deferReject(v) {this.promise._rejectCallback(v, false);}
	
	Promise.defer = Promise.pending = function() {
	    debug.deprecated("Promise.defer", "new Promise");
	    var promise = new Promise(INTERNAL);
	    return {
	        promise: promise,
	        resolve: deferResolve,
	        reject: deferReject
	    };
	};
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	__webpack_require__(516)(Promise, INTERNAL, tryConvertToPromise, apiRejection,
	    debug);
	__webpack_require__(504)(Promise, INTERNAL, tryConvertToPromise, debug);
	__webpack_require__(506)(Promise, PromiseArray, apiRejection, debug);
	__webpack_require__(509)(Promise);
	__webpack_require__(528)(Promise);
	__webpack_require__(514)(
	    Promise, PromiseArray, tryConvertToPromise, INTERNAL, async, getDomain);
	Promise.Promise = Promise;
	Promise.version = "3.5.5";
	__webpack_require__(505)(Promise);
	__webpack_require__(513)(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
	__webpack_require__(515)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(517)(Promise);
	__webpack_require__(520)(Promise, INTERNAL);
	__webpack_require__(521)(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	__webpack_require__(523)(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	__webpack_require__(524)(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
	__webpack_require__(526)(Promise, PromiseArray, debug);
	__webpack_require__(527)(Promise, PromiseArray, apiRejection);
	__webpack_require__(530)(Promise, INTERNAL, debug);
	__webpack_require__(531)(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
	__webpack_require__(502)(Promise);
	__webpack_require__(510)(Promise, INTERNAL);
	__webpack_require__(511)(Promise, INTERNAL);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    debug.setBounds(Async.firstLineError, util.lastLineError);               
	    return Promise;                                                          
	
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection, Proxyable) {
	var util = __webpack_require__(8);
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    case -6: return new Map();
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    if (values instanceof Promise) {
	        promise._propagateFrom(values, 3);
	    }
	    promise._setOnCancel(this);
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	util.inherits(PromiseArray, Proxyable);
	
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        var bitField = values._bitField;
	        ;
	        this._values = values;
	
	        if (((bitField & 50397184) === 0)) {
	            this._promise._setAsyncGuaranteed();
	            return values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	        } else if (((bitField & 33554432) !== 0)) {
	            values = values._value();
	        } else if (((bitField & 16777216) !== 0)) {
	            return this._reject(values._reason());
	        } else {
	            return this._cancel();
	        }
	    }
	    values = util.asArray(values);
	    if (values === null) {
	        var err = apiRejection(
	            "expecting an array or an iterable object but got " + util.classString(values)).reason();
	        this._promise._rejectCallback(err, false);
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    this._iterate(values);
	};
	
	PromiseArray.prototype._iterate = function(values) {
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var result = this._promise;
	    var isResolved = false;
	    var bitField = null;
	    for (var i = 0; i < len; ++i) {
	        var maybePromise = tryConvertToPromise(values[i], result);
	
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            bitField = maybePromise._bitField;
	        } else {
	            bitField = null;
	        }
	
	        if (isResolved) {
	            if (bitField !== null) {
	                maybePromise.suppressUnhandledRejections();
	            }
	        } else if (bitField !== null) {
	            if (((bitField & 50397184) === 0)) {
	                maybePromise._proxy(this, i);
	                this._values[i] = maybePromise;
	            } else if (((bitField & 33554432) !== 0)) {
	                isResolved = this._promiseFulfilled(maybePromise._value(), i);
	            } else if (((bitField & 16777216) !== 0)) {
	                isResolved = this._promiseRejected(maybePromise._reason(), i);
	            } else {
	                isResolved = this._promiseCancelled(i);
	            }
	        } else {
	            isResolved = this._promiseFulfilled(maybePromise, i);
	        }
	    }
	    if (!isResolved) result._setAsyncGuaranteed();
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype._cancel = function() {
	    if (this._isResolved() || !this._promise._isCancellable()) return;
	    this._values = null;
	    this._promise._cancel();
	};
	
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false);
	};
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	PromiseArray.prototype._promiseCancelled = function() {
	    this._cancel();
	    return true;
	};
	
	PromiseArray.prototype._promiseRejected = function (reason) {
	    this._totalResolved++;
	    this._reject(reason);
	    return true;
	};
	
	PromiseArray.prototype._resultCancelled = function() {
	    if (this._isResolved()) return;
	    var values = this._values;
	    this._cancel();
	    if (values instanceof Promise) {
	        values.cancel();
	    } else {
	        for (var i = 0; i < values.length; ++i) {
	            if (values[i] instanceof Promise) {
	                values[i].cancel();
	            }
	        }
	    }
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = __webpack_require__(8);
	var nodebackForPromise = __webpack_require__(220);
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = __webpack_require__(36).TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (true) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn, _, multiArgs) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	    var body = "'use strict';                                                \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode);
	    body = body.replace("Parameters", parameterDeclaration(newParameterCount));
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL",
	                        body)(
	                    Promise,
	                    fn,
	                    receiver,
	                    withAppended,
	                    maybeWrapAsError,
	                    nodebackForPromise,
	                    util.tryCatch,
	                    util.errorObj,
	                    util.notEnumerableProp,
	                    INTERNAL);
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise, multiArgs);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key,
	                                           fn, suffix, multiArgs);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver, multiArgs) {
	    return makeNodePromisified(callback, receiver, undefined,
	                                callback, null, multiArgs);
	}
	
	Promise.promisify = function (fn, options) {
	    if (typeof fn !== "function") {
	        throw new TypeError("expecting a function but got " + util.classString(fn));
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    options = Object(options);
	    var receiver = options.context === undefined ? THIS : options.context;
	    var multiArgs = !!options.multiArgs;
	    var ret = promisify(fn, receiver, multiArgs);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    options = Object(options);
	    var multiArgs = !!options.multiArgs;
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier,
	                multiArgs);
	            promisifyAll(value, suffix, filter, promisifier, multiArgs);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier, multiArgs);
	};
	};
	


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(8);
	var isObject = util.isObject;
	var es5 = __webpack_require__(44);
	var Es6Map;
	if (typeof Map === "function") Es6Map = Map;
	
	var mapToEntries = (function() {
	    var index = 0;
	    var size = 0;
	
	    function extractEntry(value, key) {
	        this[index] = value;
	        this[index + size] = key;
	        index++;
	    }
	
	    return function mapToEntries(map) {
	        size = map.size;
	        index = 0;
	        var ret = new Array(map.size * 2);
	        map.forEach(extractEntry, ret);
	        return ret;
	    };
	})();
	
	var entriesToMap = function(entries) {
	    var ret = new Es6Map();
	    var length = entries.length / 2 | 0;
	    for (var i = 0; i < length; ++i) {
	        var key = entries[length + i];
	        var value = entries[i];
	        ret.set(key, value);
	    }
	    return ret;
	};
	
	function PropertiesPromiseArray(obj) {
	    var isMap = false;
	    var entries;
	    if (Es6Map !== undefined && obj instanceof Es6Map) {
	        entries = mapToEntries(obj);
	        isMap = true;
	    } else {
	        var keys = es5.keys(obj);
	        var len = keys.length;
	        entries = new Array(len * 2);
	        for (var i = 0; i < len; ++i) {
	            var key = keys[i];
	            entries[i] = obj[key];
	            entries[i + len] = key;
	        }
	    }
	    this.constructor$(entries);
	    this._isMap = isMap;
	    this._init$(undefined, isMap ? -6 : -3);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val;
	        if (this._isMap) {
	            val = entriesToMap(this._values);
	        } else {
	            val = {};
	            var keyOffset = this.length();
	            for (var i = 0, len = this.length(); i < len; ++i) {
	                val[this._values[i + keyOffset]] = this._values[i];
	            }
	        }
	        this._resolve(val);
	        return true;
	    }
	    return false;
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 2);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};


/***/ }),
/* 522 */
/***/ (function(module, exports) {

	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = __webpack_require__(8);
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else {
	        promises = util.asArray(promises);
	        if (promises === null)
	            return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 3);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL,
	                          debug) {
	var getDomain = Promise._getDomain;
	var util = __webpack_require__(8);
	var tryCatch = util.tryCatch;
	
	function ReductionPromiseArray(promises, fn, initialValue, _each) {
	    this.constructor$(promises);
	    var domain = getDomain();
	    this._fn = domain === null ? fn : util.domainBind(domain, fn);
	    if (initialValue !== undefined) {
	        initialValue = Promise.resolve(initialValue);
	        initialValue._attachCancellationCallback(this);
	    }
	    this._initialValue = initialValue;
	    this._currentCancellable = null;
	    if(_each === INTERNAL) {
	        this._eachValues = Array(this._length);
	    } else if (_each === 0) {
	        this._eachValues = null;
	    } else {
	        this._eachValues = undefined;
	    }
	    this._promise._captureStackTrace();
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._gotAccum = function(accum) {
	    if (this._eachValues !== undefined && 
	        this._eachValues !== null && 
	        accum !== INTERNAL) {
	        this._eachValues.push(accum);
	    }
	};
	
	ReductionPromiseArray.prototype._eachComplete = function(value) {
	    if (this._eachValues !== null) {
	        this._eachValues.push(value);
	    }
	    return this._eachValues;
	};
	
	ReductionPromiseArray.prototype._init = function() {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function() {
	    this._resolve(this._eachValues !== undefined ? this._eachValues
	                                                 : this._initialValue);
	};
	
	ReductionPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	ReductionPromiseArray.prototype._resolve = function(value) {
	    this._promise._resolveCallback(value);
	    this._values = null;
	};
	
	ReductionPromiseArray.prototype._resultCancelled = function(sender) {
	    if (sender === this._initialValue) return this._cancel();
	    if (this._isResolved()) return;
	    this._resultCancelled$();
	    if (this._currentCancellable instanceof Promise) {
	        this._currentCancellable.cancel();
	    }
	    if (this._initialValue instanceof Promise) {
	        this._initialValue.cancel();
	    }
	};
	
	ReductionPromiseArray.prototype._iterate = function (values) {
	    this._values = values;
	    var value;
	    var i;
	    var length = values.length;
	    if (this._initialValue !== undefined) {
	        value = this._initialValue;
	        i = 0;
	    } else {
	        value = Promise.resolve(values[0]);
	        i = 1;
	    }
	
	    this._currentCancellable = value;
	
	    if (!value.isRejected()) {
	        for (; i < length; ++i) {
	            var ctx = {
	                accum: null,
	                value: values[i],
	                index: i,
	                length: length,
	                array: this
	            };
	            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
	        }
	    }
	
	    if (this._eachValues !== undefined) {
	        value = value
	            ._then(this._eachComplete, undefined, undefined, this, undefined);
	    }
	    value._then(completed, completed, undefined, value, this);
	};
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	
	function completed(valueOrReason, array) {
	    if (this.isFulfilled()) {
	        array._resolve(valueOrReason);
	    } else {
	        array._reject(valueOrReason);
	    }
	}
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") {
	        return apiRejection("expecting a function but got " + util.classString(fn));
	    }
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	function gotAccum(accum) {
	    this.accum = accum;
	    this.array._gotAccum(accum);
	    var value = tryConvertToPromise(this.value, this.array._promise);
	    if (value instanceof Promise) {
	        this.array._currentCancellable = value;
	        return value._then(gotValue, undefined, undefined, this, undefined);
	    } else {
	        return gotValue.call(this, value);
	    }
	}
	
	function gotValue(value) {
	    var array = this.array;
	    var promise = array._promise;
	    var fn = tryCatch(array._fn);
	    promise._pushContext();
	    var ret;
	    if (array._eachValues !== undefined) {
	        ret = fn.call(promise._boundValue(), value, this.index, this.length);
	    } else {
	        ret = fn.call(promise._boundValue(),
	                              this.accum, value, this.index, this.length);
	    }
	    if (ret instanceof Promise) {
	        array._currentCancellable = ret;
	    }
	    var promiseCreated = promise._popContext();
	    debug.checkForgottenReturns(
	        ret,
	        promiseCreated,
	        array._eachValues !== undefined ? "Promise.each" : "Promise.reduce",
	        promise
	    );
	    return ret;
	}
	};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process, setImmediate) {"use strict";
	var util = __webpack_require__(8);
	var schedule;
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	};
	var NativePromise = util.getNativePromise();
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if (typeof NativePromise === "function" &&
	           typeof NativePromise.resolve === "function") {
	    var nativePromise = NativePromise.resolve();
	    schedule = function(fn) {
	        nativePromise.then(fn);
	    };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            (window.navigator.standalone || window.cordova)) &&
	          ("classList" in document.documentElement)) {
	    schedule = (function() {
	        var div = document.createElement("div");
	        var opts = {attributes: true};
	        var toggleScheduled = false;
	        var div2 = document.createElement("div");
	        var o2 = new MutationObserver(function() {
	            div.classList.toggle("foo");
	            toggleScheduled = false;
	        });
	        o2.observe(div2, opts);
	
	        var scheduleToggle = function() {
	            if (toggleScheduled) return;
	            toggleScheduled = true;
	            div2.classList.toggle("foo");
	        };
	
	        return function schedule(fn) {
	            var o = new MutationObserver(function() {
	                o.disconnect();
	                fn();
	            });
	            o.observe(div, opts);
	            scheduleToggle();
	        };
	    })();
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(38), __webpack_require__(777).setImmediate))

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	    function(Promise, PromiseArray, debug) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = __webpack_require__(8);
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	        return true;
	    }
	    return false;
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 33554432;
	    ret._settledValueField = value;
	    return this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 16777216;
	    ret._settledValueField = reason;
	    return this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    debug.deprecated(".settle()", ".reflect()");
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return Promise.settle(this);
	};
	};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = __webpack_require__(8);
	var RangeError = __webpack_require__(36).RangeError;
	var AggregateError = __webpack_require__(36).AggregateError;
	var isArray = util.isArray;
	var CANCELLATION = {};
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	        return true;
	    }
	    return false;
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._promiseCancelled = function () {
	    if (this._values instanceof Promise || this._values == null) {
	        return this._cancel();
	    }
	    this._addRejected(CANCELLATION);
	    return this._checkOutcome();
	};
	
	SomePromiseArray.prototype._checkOutcome = function() {
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            if (this._values[i] !== CANCELLATION) {
	                e.push(this._values[i]);
	            }
	        }
	        if (e.length > 0) {
	            this._reject(e);
	        } else {
	            this._cancel();
	        }
	        return true;
	    }
	    return false;
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};


/***/ }),
/* 528 */
/***/ (function(module, exports) {

	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValueField = promise._isFateSealed()
	            ? promise._settledValue() : undefined;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValueField = undefined;
	    }
	}
	
	PromiseInspection.prototype._settledValue = function() {
	    return this._settledValueField;
	};
	
	var value = PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var reason = PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
	    }
	    return this._settledValue();
	};
	
	var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
	    return (this._bitField & 33554432) !== 0;
	};
	
	var isRejected = PromiseInspection.prototype.isRejected = function () {
	    return (this._bitField & 16777216) !== 0;
	};
	
	var isPending = PromiseInspection.prototype.isPending = function () {
	    return (this._bitField & 50397184) === 0;
	};
	
	var isResolved = PromiseInspection.prototype.isResolved = function () {
	    return (this._bitField & 50331648) !== 0;
	};
	
	PromiseInspection.prototype.isCancelled = function() {
	    return (this._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.__isCancelled = function() {
	    return (this._bitField & 65536) === 65536;
	};
	
	Promise.prototype._isCancelled = function() {
	    return this._target().__isCancelled();
	};
	
	Promise.prototype.isCancelled = function() {
	    return (this._target()._bitField & 8454144) !== 0;
	};
	
	Promise.prototype.isPending = function() {
	    return isPending.call(this._target());
	};
	
	Promise.prototype.isRejected = function() {
	    return isRejected.call(this._target());
	};
	
	Promise.prototype.isFulfilled = function() {
	    return isFulfilled.call(this._target());
	};
	
	Promise.prototype.isResolved = function() {
	    return isResolved.call(this._target());
	};
	
	Promise.prototype.value = function() {
	    return value.call(this._target());
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    target._unsetRejectionIsUnhandled();
	    return reason.call(target);
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue();
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue();
	};
	
	Promise.PromiseInspection = PromiseInspection;
	};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = __webpack_require__(8);
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) return obj;
	        var then = getThen(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            if (isAnyBluebirdPromise(obj)) {
	                var ret = new Promise(INTERNAL);
	                obj._then(
	                    ret._fulfill,
	                    ret._reject,
	                    undefined,
	                    ret,
	                    null
	                );
	                return ret;
	            }
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function doGetThen(obj) {
	    return obj.then;
	}
	
	function getThen(obj) {
	    try {
	        return doGetThen(obj);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    try {
	        return hasProp.call(obj, "_promise0");
	    } catch (e) {
	        return false;
	    }
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x, resolve, reject);
	    synchronous = false;
	
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolve(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function reject(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function(Promise, INTERNAL, debug) {
	var util = __webpack_require__(8);
	var TimeoutError = Promise.TimeoutError;
	
	function HandleWrapper(handle)  {
	    this.handle = handle;
	}
	
	HandleWrapper.prototype._resultCancelled = function() {
	    clearTimeout(this.handle);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (ms, value) {
	    var ret;
	    var handle;
	    if (value !== undefined) {
	        ret = Promise.resolve(value)
	                ._then(afterValue, null, null, ms, undefined);
	        if (debug.cancellation() && value instanceof Promise) {
	            ret._setOnCancel(value);
	        }
	    } else {
	        ret = new Promise(INTERNAL);
	        handle = setTimeout(function() { ret._fulfill(); }, +ms);
	        if (debug.cancellation()) {
	            ret._setOnCancel(new HandleWrapper(handle));
	        }
	        ret._captureStackTrace();
	    }
	    ret._setAsyncGuaranteed();
	    return ret;
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(ms, this);
	};
	
	var afterTimeout = function (promise, message, parent) {
	    var err;
	    if (typeof message !== "string") {
	        if (message instanceof Error) {
	            err = message;
	        } else {
	            err = new TimeoutError("operation timed out");
	        }
	    } else {
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._reject(err);
	
	    if (parent != null) {
	        parent.cancel();
	    }
	};
	
	function successClear(value) {
	    clearTimeout(this.handle);
	    return value;
	}
	
	function failureClear(reason) {
	    clearTimeout(this.handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret, parent;
	
	    var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
	        if (ret.isPending()) {
	            afterTimeout(ret, message, parent);
	        }
	    }, ms));
	
	    if (debug.cancellation()) {
	        parent = this.then();
	        ret = parent._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	        ret._setOnCancel(handleWrapper);
	    } else {
	        ret = this._then(successClear, failureClear,
	                            undefined, handleWrapper, undefined);
	    }
	
	    return ret;
	};
	
	};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext, INTERNAL, debug) {
	    var util = __webpack_require__(8);
	    var TypeError = __webpack_require__(36).TypeError;
	    var inherits = __webpack_require__(8).inherits;
	    var errorObj = util.errorObj;
	    var tryCatch = util.tryCatch;
	    var NULL = {};
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = new Promise(INTERNAL);
	        function iterator() {
	            if (i >= len) return ret._fulfill();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret;
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return NULL;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== NULL
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    function ResourceList(length) {
	        this.length = length;
	        this.promise = null;
	        this[length-1] = null;
	    }
	
	    ResourceList.prototype._resultCancelled = function() {
	        var len = this.length;
	        for (var i = 0; i < len; ++i) {
	            var item = this[i];
	            if (item instanceof Promise) {
	                item.cancel();
	            }
	        }
	    };
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") {
	            return apiRejection("expecting a function but got " + util.classString(fn));
	        }
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new ResourceList(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var reflectedResources = new Array(resources.length);
	        for (var i = 0; i < reflectedResources.length; ++i) {
	            reflectedResources[i] = Promise.resolve(resources[i]).reflect();
	        }
	
	        var resultPromise = Promise.all(reflectedResources)
	            .then(function(inspections) {
	                for (var i = 0; i < inspections.length; ++i) {
	                    var inspection = inspections[i];
	                    if (inspection.isRejected()) {
	                        errorObj.e = inspection.error();
	                        return errorObj;
	                    } else if (!inspection.isFulfilled()) {
	                        resultPromise.cancel();
	                        return;
	                    }
	                    inspections[i] = inspection.value();
	                }
	                promise._pushContext();
	
	                fn = tryCatch(fn);
	                var ret = spreadArgs
	                    ? fn.apply(undefined, inspections) : fn(inspections);
	                var promiseCreated = promise._popContext();
	                debug.checkForgottenReturns(
	                    ret, promiseCreated, "Promise.using", promise);
	                return ret;
	            });
	
	        var promise = resultPromise.lastly(function() {
	            var inspection = new Promise.PromiseInspection(resultPromise);
	            return dispose(resources, inspection);
	        });
	        resources.promise = promise;
	        promise._setOnCancel(resources);
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 131072;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 131072) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~131072);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(40)
	var snakeCase = __webpack_require__(279)
	
	/**
	 * Constant case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return upperCase(snakeCase(value, locale), locale)
	}


/***/ }),
/* 533 */
63,
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(45)();
	// imports
	
	
	// module
	exports.push([module.id, ".cartContainer{padding-bottom:20px}.cartRow{display:flex;padding:15px 0;border:1px solid #ccc;margin:5px 0}.cartRow__quantity{font-weight:400;text-align:right;flex-grow:1;padding-right:10px;align-self:flex-start}.cartRow__description{flex:8}.cartRow__name{padding:0;margin:0}.cartRow__modifiers{padding:5px}.cartRow__modifier{font-size:12px;padding:2px 0;margin:0}.cartRow__price{flex:3;text-align:right;font-weight:400;padding:0;margin:0;align-self:flex-start}.cartRow__remove{padding-left:20px;color:#ccc;background:none;border:none;cursor:pointer;align-self:flex-start}.cartTotal{padding:20px 10px 10px;display:flex;border-bottom:1px solid #ccc}.cartTotal__labels{flex-grow:3;text-align:right}.cartTotal__labels p{margin-bottom:10px}.cartTotal__amounts{flex-grow:1;text-align:right}.cartTotal__amounts p{margin-bottom:10px}.cartTotal__Item--total{font-weight:400}.cartFooter{padding-bottom:20px}", ""]);
	
	// exports


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(45)();
	// imports
	
	
	// module
	exports.push([module.id, ".menuContainer{padding-bottom:20px}.menuHeader{display:flex;justify-content:space-between;padding:15px 0;border-bottom:1px solid #ccc;margin-bottom:0;position:sticky;top:0;background-color:#fff;z-index:100}.menuHeader .orderRecap{align-self:flex-end}.menuCategory{display:flex;flex-direction:column}.menuCategory__titleWrapper{border:none;background:transparent;display:flex;cursor:pointer;padding:10px;justify-content:space-between;border-bottom:1px solid #ddd;background-color:hsla(0,0%,94%,.3)}.menuCategory__titleWrapper:hover{background-color:hsla(0,0%,94%,.5)}.menuCategory__titleWrapper:focus{outline:none}.menuCategory__title{margin:0;text-transform:uppercase;font-weight:700;font-size:13px}.menuCategory__icn{align-self:flex-end}.menuCategory__content{display:block}.menuItem{display:flex;width:100%;background:none;border:none;margin:0;padding:0;cursor:pointer;align-items:stretch;border-bottom:1px solid #eee}.menuItem:focus{outline:none}.menuItem__content{display:flex;align-items:center;justify-content:space-between;padding:10px 0;flex-grow:1}.menuItem--unavailable{opacity:.5;text-decoration:line-through;cursor:not-allowed}.menuItem--withModifiers{display:block;cursor:auto}.menuItem--withModifiers .menuItem__name{cursor:pointer}.menuItem__modifiersWrapper{max-height:400px;overflow-y:scroll}.menuItem__header{display:flex;width:100%}.menuItem__name h5{text-align:left;margin:0;padding:0}.menuItem__name p{text-align:left;font-size:12px;padding:0;margin-top:5px}.menuItem__price{white-space:nowrap;margin-left:10px;font-size:14px;align-self:flex-start;font-weight:400}.menuItem__quantity{display:flex;min-width:30px;align-items:center;text-align:center;font-size:12px;color:#fff;justify-content:center;margin-right:5px;transition:background-color .2s ease-in-out}.menuItem__controls{padding-bottom:20px}.menuItem__controls>div{float:right}.menuItem__controls .menuItem__subtot{display:flex;justify-content:space-between;margin-bottom:15px;font-size:14px;font-weight:400}.menuItem__controls .btn-submit{font-size:14px}.menuItem__subtot{align-self:flex-end}.cartButton{font-weight:400;border:none;cursor:pointer;color:#fff;padding:8px 14px;font-size:10px;border-radius:2px;box-shadow:0 2px 2px 0 rgba(0,0,0,.5);display:flex;align-items:center;backface-visibility:hidden;transition:transform .1s ease-in}.cartButton:active{transform:scale(.95)}.cartButton i{font-size:24px;padding-right:10px;margin-left:-4px;transition:transform .3s ease-out;backface-visibility:hidden}.cartButton>span{padding-left:12px;border-left:1px solid hsla(0,0%,100%,.5)}.cartButton>span>span{display:block}.cartButton>span>span:first-child{font-size:17px;margin-bottom:5px;white-space:nowrap}.cartButton--disabled{opacity:.5;cursor:not-allowed}.itemModifiers{text-align:left;padding-left:50px}.itemModifier{padding-bottom:20px}.itemModifier__name{font-weight:400;margin-bottom:5px}.itemModifier__error{font-size:12px;color:red;text-transform:uppercase}.itemModifier__info{font-size:12px;color:#aaa}.itemModifier__item{display:flex;font-size:13px;font-weight:400;margin-bottom:1.3em;cursor:pointer}.itemModifier__nameWrapper{display:flex;flex-direction:column;flex:1}.itemModifier__description{font-size:12px;font-weight:200}.itemModifier__name{padding-right:15px}.itemModifier__extraprice{opacity:.9}.itemModifier__icon{display:flex;justify-content:center;align-items:center;color:#fff;width:15px;height:15px;border-radius:8px;border:1px solid #ccc;margin-right:8px}.itemModifier__icon i{font-size:7px}", ""]);
	
	// exports


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(45)();
	// imports
	
	
	// module
	exports.push([module.id, ".paymentHeader{display:flex;align-items:center}.paymentHeader i{font-size:30px;color:#ccc;margin-right:10px}.paymentContainer{flex:1 0 auto}.paymentTypeBox{flex-direction:column}.paymentTypeBox>i{order:0;margin-bottom:10px}.paymentTypeBox h5,.paymentTypeBox p{text-align:center!important}.paymentTypeBox p{margin:10px 0}.paymentTypeBox .boxedItem__header{order:1}.paymentTypeBox .boxedItem__content{order:2;width:100%;padding:1em}.paymentTypeBox .boxedItem__content>div{width:100%}.paymentTypeBox input{background:transparent}.savedCreditCard__main{display:flex;align-items:center}.savedCreditCard__number{margin:auto 0;font-weight:400}.savedCreditCard__image{width:30px;margin-right:15px}.savedCreditCard__image img{width:100%}.savedCreditCard__expDate{font-size:14px;margin-top:15px;margin-bottom:0}.newCreditCardBrand{display:inline-block;margin-right:5px;width:30px}.newCreditCardBrand img{width:100%}.newCreditCardForm{margin-top:15px}.newCreditCardForm__error{color:red;font-size:12px;text-transform:uppercase;font-weight:400;margin-bottom:10px}.unhandled__content{display:flex;align-items:center;justify-content:space-around}", ""]);
	
	// exports


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(45)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(45)();
	// imports
	
	
	// module
	exports.push([module.id, ".orderStart,.orderType{display:flex}.orderType{flex-direction:column;width:100%}.orderType__button{display:flex;flex:1;text-align:center;border:1px solid #ccc;align-items:center;justify-content:center;margin-bottom:20px}.orderType__button>span{display:inline-block;font-weight:400;transition:transform .3s ease-out}.orderType__button:hover>span{transform:scale(1.1)}.orderType__button i{font-size:2em}.orderType__buttonLabel{display:block;margin-top:1em}.orderDeliveryContainer{display:flex;flex:1;flex-direction:column}.orderRecap__el{display:flex;padding:5px 0}.orderRecap__el i{color:#ccc;margin-right:5px}.orderRecap__el p{padding:0;margin:0;font-weight:400;font-size:13px;line-height:1.5}.ordersteps ul{list-style-type:none;display:flex;margin:0;padding:0}.ordersteps li:last-child i{margin-bottom:0}.ordersteps__item{display:flex;flex-grow:1;flex-direction:column;border:1px solid #eee;align-items:center;padding:10px 0;margin:0 4px 20px 0}.ordersteps__item span{font-size:10px}.ordersteps__item i{margin-bottom:5px}.ordersteps__item--next{opacity:.5}.locationInputItem{display:none}.orderEditAddress{text-transform:uppercase;font-size:12px;font-weight:800;display:block;float:right;margin:2em 0 0}.orderDateTime{display:flex}.orderDateTime select{margin-right:1em}.voucherList__element{width:100%;background:none;border:none;font-weight:400;display:flex;justify-content:space-between;cursor:pointer;text-align:left}.voucherList__element p{width:100%;font-weight:300!important;font-size:18px!important;margin-bottom:5px!important;text-align:left}.voucherList__elementDiscount{text-transform:uppercase;font-size:12px}.orderEndStatus{text-align:center}.orderEndStatus>i{font-size:100px}.orderEndStatus h4{text-transform:uppercase;margin-bottom:10px}@keyframes pulse{0%{transform:scale(1)}50%{transform:scale(.8)}to{transform:scale(1)}}.orderEndStatus--pending>i:before{animation:pulse 2s ease-in-out infinite}.orderEndStatus__content,.orderEndStatus__content .orderRecap{margin-top:20px}.deliveryAddress__autocomplete{flex:1;margin-top:2em}.geosuggest__suggests{list-style-type:none;padding:0;margin:0}.geosuggest__item{padding:1em .5em;font-size:14px;border-bottom:1px solid #eee;cursor:pointer}.geosuggest__item:hover{background:#eee}.geosuggest__suggests--hidden{display:none}.noDelivery__title{text-align:center}.noDelivery__block{text-align:center;margin-bottom:3em}.promoCodeForm__title{margin-bottom:10px}.promoCodeForm__error{color:#be2a0c}.promoCodeForm__form{display:flex}.promoCodeForm__input{flex-grow:1}.promoCodeForm__submit{margin-left:10px;text-transform:uppercase;box-shadow:none}", ""]);
	
	// exports


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(45)();
	// imports
	
	
	// module
	exports.push([module.id, ".userContainer{position:absolute;top:0;bottom:0;left:0;right:0;background:#fff;padding:20px}.signinSignup{display:flex;flex-direction:column}.userHeader{margin-bottom:0}.userHeader>div{display:flex;float:right}.userHeader>div i{font-size:10px}.userHeader>div p{font-size:12px;text-transform:uppercase;margin-bottom:0}.currentUser_logout{display:block;border:none;background:none;color:#333;padding:0;margin:0 0 0 1em;font-size:12px;cursor:pointer}.currentUser_logout:hover{color:red}.fb-login-button{margin:1em 0 0 auto}", ""]);
	
	// exports


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(45)();
	// imports
	
	
	// module
	exports.push([module.id, "html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}a{text-decoration:none;color:#31777a}p{font-weight:300;color:#4a4a4a;font-size:16px;margin:0 0 1.5em}fieldset{border:0;padding:0;margin:0}.cf:after,.cf:before{content:\" \";display:table}.cf:after{clear:both}.hidden{display:none}h1{font-weight:400;color:#333;font-size:18px;color:#31777a;text-align:center}h1 span{font-weight:100;color:#333;font-size:14px;font-size:18px}.viewTitle,h2,h3,h4,h5,h6,label{font-weight:400}.viewTitle{text-align:center;color:#333;font-size:18px}header{margin-bottom:1.5em;flex-grow:0}main{flex:1;display:flex;flex-direction:column;justify-content:space-between}button:focus{outline:none}.spinner{display:none}.is-loading{flex:1;align-items:center;justify-content:center}.is-loading .spinner{display:block}.is-loading main{display:none}.grow,.is-loaded{flex:1}.centerChildren{align-items:center}.btn{cursor:pointer}.btn-submit{background:#31777a;padding:.5em 3em;box-shadow:0 2px 2px 0 rgba(0,0,0,.5)}.btn-secondary,.btn-submit{font-weight:400;color:#333;font-size:18px;cursor:pointer;color:#fff;border:0;border-radius:2px}.btn-secondary{font-size:12px;text-transform:uppercase;padding:10px 15px}.btn--disabled{opacity:.5;cursor:not-allowed}.buttonsContainer{display:flex;justify-content:space-between;align-items:center;padding-top:30px;margin-top:auto}.buttonsContainer>a,.buttonsContainer button{margin-top:auto;margin-bottom:auto}#root,#root>div{display:flex;flex-direction:column}#root>div{position:relative;max-width:500px;padding:1em 1em 3em;font-family:Lato,sans-serif;font-weight:300;color:#4a4a4a;font-size:16px;min-height:100vh;justify-content:space-between;background:#fff}.mobile-list{width:100%;padding:0;margin-bottom:3em}.mobile-list li{list-style:none;display:block;border-top:1px solid #d1d1d1;padding:.5em;position:relative}.mobile-list li:last-child{border-bottom:1px solid #d1d1d1}.mobile-list li.disabled{pointer-events:none}.mobile-list li.disabled>a :not(.not-available){opacity:.5}.mobile-list li a{display:block;width:100%;line-height:22px}.mobile-list li .title{font-weight:400;color:#333;font-size:18px}.mobile-list li p{font-weight:100;color:#333;font-size:14px;margin:0}.mobile-list i[class^=bi_]{position:absolute;right:5px;top:50%;transform:translateY(-50%);color:#333;font-size:24px}.box-list{display:flex;flex-wrap:wrap;justify-content:space-between;padding:0;margin:0}.box-list li{background:#f5f5f5;list-style:none;display:block;padding:.25em;width:45%;cursor:pointer;margin-bottom:.5em;text-align:center;font-weight:400;color:#333;font-size:18px}.box-list li.selected{background:#31777a;color:#fff}.split-pane{display:flex;justify-content:space-between}.split-pane .pane{width:45%}.split-pane.full{flex-direction:column;justify-content:flex-start}.split-pane.full .pane{width:100%}.split-pane.full .number-picker{justify-content:flex-start}.split-pane .disabled{opacity:.25;pointer-events:none}.split-pane h4{margin-bottom:5px}.split-pane h4+p{font-weight:100;color:#333;font-size:14px}.disabled{opacity:.25;pointer-events:none}.number-picker{display:flex;justify-content:space-between}.number-picker .value{background:#f5f5f5;padding:.5em 1em;font-weight:400;color:#333;font-size:18px}.number-picker input{font-size:30px;padding:0 .5em;cursor:pointer;border:0;background:0;outline:0 none}.number-picker input:hover{color:#31777a}.number-picker input:first-child{padding-left:0}.number-picker input:last-child{padding-right:0}.number-picker input.hidden{visibility:hidden}form.form-stacked{display:flex;flex-direction:column;justify-content:space-between}form.form-stacked fieldset input:not([type=submit]){width:100%;display:block;padding:.25em 1em;margin:1em 0;border:1px solid #979797;border-width:0 0 1px}form.form-stacked fieldset input:not([type=submit]):focus{outline:0 none;border-color:#31777a}select{cursor:pointer;padding:5px 10px;border:1px solid #ccc;background:transparent;-webkit-appearance:none;border-radius:0}select:focus{outline:none;border:1px solid #aaa}.actions{margin-top:3em}.actions .wrapper{display:flex;justify-content:space-between;align-items:center}.actions.disabled .btn-submit{opacity:.25;pointer-events:none}.actions input[type=checkbox]{margin-right:1em}.checkboxInputItem{display:flex}.checkboxInputItem input{width:15px!important;margin-left:0;margin-right:5px}.formError{color:red;text-transform:uppercase;font-size:13px}.bookingStatusIcon{text-align:center;margin-bottom:3em}.bookingStatusIcon i{font-size:200px}.bookingStatusIcon img{max-width:300px}.bookingStatusIcon--pending>i:before{animation:pulse 2s ease-in-out infinite}.restaurant-info-panel{border:1px solid #d1d1d1;padding:1.5em;background:#f5f5f5}.restaurant-info-panel i{color:rgba(0,0,0,.3);margin-right:.5em}.restaurant-info-panel p{font-weight:400;color:#333;font-size:18px;font-size:14px}.restaurant-info-panel p:last-child{margin:0}.not-available{background:red;color:#333;font-size:18px;color:#fff;font-size:10px;margin-top:1em;text-align:center}.error,.not-available{font-weight:400;text-transform:uppercase}.error{color:#333;font-size:18px;color:red;font-size:11px}.bookingDateRow button{border:none;background:none;cursor:pointer;text-align:left;width:100%}.booking-info{border-bottom:1px solid #ccc;padding-bottom:1.5em;margin-bottom:1.5em;text-align:center;text-transform:uppercase;font-size:12px}.googleMap{width:100%;height:30%;min-height:200px;margin:1em 0}.boxedItem{text-align:left;width:100%;background:#fbfbfb;border:1px solid #eee;padding:15px 10px;margin-bottom:10px}.boxedItem h5{margin:0 0 5px}.boxedItem--active{background:#f9f9f9;border:1px solid #aaa}.boxedItem--with-action{cursor:pointer}.boxedItem--with-icon{display:flex;align-items:center}.boxedItem--with-icon h5{font-size:16px;margin:0 0 5px;text-align:left}.boxedItem--with-icon p{margin:0;text-align:left;font-size:14px}.boxedItem--with-icon .boxedItem__content{display:flex;align-items:center}.boxedItem--with-icon .boxedItem__header{flex:5 0 auto}.boxedItem--with-icon i{flex:1 0 auto;text-align:center;color:#ccc;font-size:36px}.boxedItem--with-icon .spinner{width:36px}.spinner{position:relative;display:inline-block}.spinner>span{display:block;border:3px solid hsla(0,0%,59%,.25);border-top:3px solid #31777a;border-radius:100%;animation:Spinner 1s infinite linear;width:20px;height:20px;margin:0 auto 5px}.spinner__text{font-size:12px;text-transform:uppercase}.container--loading{display:flex;align-items:center;justify-content:space-around}.loadingContainer{flex-direction:column;display:flex}.form .field{margin:0 0 20px;width:100%}.form .field input{width:100%;display:block;border:none;border-bottom:1px solid #ccc;padding:10px 0}.form .field input:focus{outline:none;border-bottom:1px solid #333;transition:border .5s ease-in-out}.form .field label{width:100%;display:block;text-transform:uppercase;font-weight:400;font-size:10px}.form .field label.red{color:red;margin-top:5px;text-align:right}.form .formButtonsContainer{display:flex;align-items:flex-end;margin-top:20px}.form .formButtonsContainer .buttons{margin:0 0 0 auto}.form .formButtonsContainer .buttons button{text-transform:uppercase;font-size:12px;padding:10px 15px;font-weight:400;cursor:pointer}.form .formButtonsContainer .buttons button[type=reset]{background-color:#999;font-size:12px;text-transform:uppercase;cursor:pointer;color:#fff;border:0;padding:10px 15px;border-radius:2px;margin-right:1em;box-shadow:0 2px 2px 0 rgba(0,0,0,.5)}.form .textareaInputItem{padding-top:10px}.form .textareaInputItem textarea{width:100%;border:none;border-bottom:1px solid #ccc;text-align:right}.form .textareaInputItem textarea:focus{outline:none;border-bottom:1px solid #333;transition:border .5s ease-in-out}.appFlashMessage{position:absolute;display:none;border:1px solid #f4cb42;background:#fff;z-index:9901;cursor:pointer}.appFlashMessage__icon{font-size:20px;color:#fff;background:#f4df42;padding:5px;display:flex;align-items:center}.appFlashMessage__content h6{color:#f4cb42;margin-top:0;margin-bottom:.3em;font-size:14px;padding:10px 0 5px 10px}.appFlashMessage__content p{margin-bottom:10px;padding:0 10px 10px;font-size:14px}.appFlashMessage--visibile{top:30%;left:50%;transform:translate(-50%);display:flex}.appFlashMessage--warning{border:1px solid #f4cb42}.appFlashMessage--warning .appFlashMessage__icon{background:#f4df42}.appFlashMessage--warning h6{color:#f4cb42}.appFlashMessage--error{border:1px solid #990f00}.appFlashMessage--error .appFlashMessage__icon{background:#ce1400}.appFlashMessage--error h6{color:#990f00}.appFlashMessageBackdrop:before{content:\" \";position:absolute;top:0;left:0;right:0;bottom:0;background:hsla(0,0%,100%,.7);z-index:9900}", ""]);
	
	// exports


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = activeElement;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(55));
	
	function activeElement(doc) {
	  if (doc === void 0) {
	    doc = (0, _ownerDocument.default)();
	  }
	
	  try {
	    return doc.activeElement;
	  } catch (e) {
	    /* ie throws if no active element */
	  }
	}
	
	module.exports = exports["default"];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(223));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _addClass = _interopRequireDefault(__webpack_require__(542));
	
	exports.addClass = _addClass.default;
	
	var _removeClass = _interopRequireDefault(__webpack_require__(544));
	
	exports.removeClass = _removeClass.default;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(223));
	
	exports.hasClass = _hasClass.default;
	var _default = {
	  addClass: _addClass.default,
	  removeClass: _removeClass.default,
	  hasClass: _hasClass.default
	};
	exports.default = _default;

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(46));
	
	var off = function off() {};
	
	if (_inDOM.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	var _default = off;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(46));
	
	var on = function on() {};
	
	if (_inDOM.default) {
	  on = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	var _default = on;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = ownerWindow;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(55));
	
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc && doc.defaultView || doc.parentWindow;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = height;
	
	var _offset = _interopRequireDefault(__webpack_require__(68));
	
	var _isWindow = _interopRequireDefault(__webpack_require__(67));
	
	function height(node, client) {
	  var win = (0, _isWindow.default)(node);
	  return win ? win.innerHeight : client ? node.clientHeight : (0, _offset.default)(node).height;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = position;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(437));
	
	var _offset = _interopRequireDefault(__webpack_require__(68));
	
	var _offsetParent = _interopRequireDefault(__webpack_require__(224));
	
	var _scrollTop = _interopRequireDefault(__webpack_require__(126));
	
	var _scrollLeft = _interopRequireDefault(__webpack_require__(550));
	
	var _style = _interopRequireDefault(__webpack_require__(127));
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = {
	    top: 0,
	    left: 0
	  },
	      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	
	  if ((0, _style.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent.default)(node);
	    offset = (0, _offset.default)(node);
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
	    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
	  } // Subtract parent offsets and node margins
	
	
	  return (0, _extends2.default)({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = scrollTop;
	
	var _isWindow = _interopRequireDefault(__webpack_require__(67));
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow.default)(node);
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = _interopRequireDefault(__webpack_require__(225));
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	      prop = (0, _camelizeStyle.default)(prop);
	      if (prop == 'float') prop = 'styleFloat';
	      var current = node.currentStyle[prop] || null;
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out
	
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px'; // Revert the changed values
	
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeStyle;
	
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 553 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	
	module.exports = exports["default"];

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(46));
	
	var transform = 'transform';
	exports.transform = transform;
	var prefix, transitionEnd, animationEnd;
	exports.animationEnd = animationEnd;
	exports.transitionEnd = transitionEnd;
	var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
	exports.transitionDelay = transitionDelay;
	exports.transitionTiming = transitionTiming;
	exports.transitionDuration = transitionDuration;
	exports.transitionProperty = transitionProperty;
	var animationName, animationDuration, animationTiming, animationDelay;
	exports.animationDelay = animationDelay;
	exports.animationTiming = animationTiming;
	exports.animationDuration = animationDuration;
	exports.animationName = animationName;
	
	if (_inDOM.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	  exports.transform = transform = prefix + "-" + transform;
	  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
	  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
	  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
	  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
	  exports.animationName = animationName = prefix + "-animation-name";
	  exports.animationDuration = animationDuration = prefix + "-animation-duration";
	  exports.animationTiming = animationTiming = prefix + "-animation-delay";
	  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
	}
	
	var _default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	exports.default = _default;
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	  var vendorMap = {
	    O: function O(e) {
	      return "o" + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return "webkit" + e;
	    },
	    ms: function ms(e) {
	      return "MS" + e;
	    }
	  };
	  var vendors = Object.keys(vendorMap);
	  var transitionEnd, animationEnd;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + "TransitionProperty" in style) {
	      prefix = "-" + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	  style = null;
	  return {
	    animationEnd: animationEnd,
	    transitionEnd: transitionEnd,
	    prefix: prefix
	  };
	}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	
	module.exports = exports["default"];

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hyphenate;
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	
	module.exports = exports["default"];

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = hyphenateStyleName;
	
	var _hyphenate = _interopRequireDefault(__webpack_require__(556));
	
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	 */
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
	}
	
	module.exports = exports["default"];

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(10);
	
	exports.__esModule = true;
	exports.default = scrollbarSize;
	
	var _inDOM = _interopRequireDefault(__webpack_require__(46));
	
	var size;
	
	function scrollbarSize(recalc) {
	  if (!size && size !== 0 || recalc) {
	    if (_inDOM.default) {
	      var scrollDiv = document.createElement('div');
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(30)
	
	/**
	 * Dot case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '.')
	}


/***/ }),
/* 560 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 561 */
560,
/* 562 */
560,
/* 563 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (data, opts) {
	    if (!opts) opts = {};
	    if (typeof opts === 'function') opts = { cmp: opts };
	    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;
	
	    var cmp = opts.cmp && (function (f) {
	        return function (node) {
	            return function (a, b) {
	                var aobj = { key: a, value: node[a] };
	                var bobj = { key: b, value: node[b] };
	                return f(aobj, bobj);
	            };
	        };
	    })(opts.cmp);
	
	    var seen = [];
	    return (function stringify (node) {
	        if (node && node.toJSON && typeof node.toJSON === 'function') {
	            node = node.toJSON();
	        }
	
	        if (node === undefined) return;
	        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
	        if (typeof node !== 'object') return JSON.stringify(node);
	
	        var i, out;
	        if (Array.isArray(node)) {
	            out = '[';
	            for (i = 0; i < node.length; i++) {
	                if (i) out += ',';
	                out += stringify(node[i]) || 'null';
	            }
	            return out + ']';
	        }
	
	        if (node === null) return 'null';
	
	        if (seen.indexOf(node) !== -1) {
	            if (cycles) return JSON.stringify('__cycle__');
	            throw new TypeError('Converting circular structure to JSON');
	        }
	
	        var seenIndex = seen.push(node) - 1;
	        var keys = Object.keys(node).sort(cmp && cmp(node));
	        out = '';
	        for (i = 0; i < keys.length; i++) {
	            var key = keys[i];
	            var value = stringify(node[key]);
	
	            if (!value) continue;
	            if (out) out += ',';
	            out += JSON.stringify(key) + ':' + value;
	        }
	        seen.splice(seenIndex, 1);
	        return '{' + out + '}';
	    })(data);
	};


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GraphQLError = GraphQLError;
	exports.printError = printError;
	
	var _isObjectLike = _interopRequireDefault(__webpack_require__(566));
	
	var _location = __webpack_require__(236);
	
	var _printLocation = __webpack_require__(571);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function GraphQLError( // eslint-disable-line no-redeclare
	message, nodes, source, positions, path, originalError, extensions) {
	  // Compute list of blame nodes.
	  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.
	
	
	  var _source = source;
	
	  if (!_source && _nodes) {
	    var node = _nodes[0];
	    _source = node && node.loc && node.loc.source;
	  }
	
	  var _positions = positions;
	
	  if (!_positions && _nodes) {
	    _positions = _nodes.reduce(function (list, node) {
	      if (node.loc) {
	        list.push(node.loc.start);
	      }
	
	      return list;
	    }, []);
	  }
	
	  if (_positions && _positions.length === 0) {
	    _positions = undefined;
	  }
	
	  var _locations;
	
	  if (positions && source) {
	    _locations = positions.map(function (pos) {
	      return (0, _location.getLocation)(source, pos);
	    });
	  } else if (_nodes) {
	    _locations = _nodes.reduce(function (list, node) {
	      if (node.loc) {
	        list.push((0, _location.getLocation)(node.loc.source, node.loc.start));
	      }
	
	      return list;
	    }, []);
	  }
	
	  var _extensions = extensions;
	
	  if (_extensions == null && originalError != null) {
	    var originalExtensions = originalError.extensions;
	
	    if ((0, _isObjectLike.default)(originalExtensions)) {
	      _extensions = originalExtensions;
	    }
	  }
	
	  Object.defineProperties(this, {
	    message: {
	      value: message,
	      // By being enumerable, JSON.stringify will include `message` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: true,
	      writable: true
	    },
	    locations: {
	      // Coercing falsey values to undefined ensures they will not be included
	      // in JSON.stringify() when not provided.
	      value: _locations || undefined,
	      // By being enumerable, JSON.stringify will include `locations` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: Boolean(_locations)
	    },
	    path: {
	      // Coercing falsey values to undefined ensures they will not be included
	      // in JSON.stringify() when not provided.
	      value: path || undefined,
	      // By being enumerable, JSON.stringify will include `path` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: Boolean(path)
	    },
	    nodes: {
	      value: _nodes || undefined
	    },
	    source: {
	      value: _source || undefined
	    },
	    positions: {
	      value: _positions || undefined
	    },
	    originalError: {
	      value: originalError
	    },
	    extensions: {
	      // Coercing falsey values to undefined ensures they will not be included
	      // in JSON.stringify() when not provided.
	      value: _extensions || undefined,
	      // By being enumerable, JSON.stringify will include `path` in the
	      // resulting output. This ensures that the simplest possible GraphQL
	      // service adheres to the spec.
	      enumerable: Boolean(_extensions)
	    }
	  }); // Include (non-enumerable) stack trace.
	
	  if (originalError && originalError.stack) {
	    Object.defineProperty(this, 'stack', {
	      value: originalError.stack,
	      writable: true,
	      configurable: true
	    });
	  } else if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, GraphQLError);
	  } else {
	    Object.defineProperty(this, 'stack', {
	      value: Error().stack,
	      writable: true,
	      configurable: true
	    });
	  }
	}
	
	GraphQLError.prototype = Object.create(Error.prototype, {
	  constructor: {
	    value: GraphQLError
	  },
	  name: {
	    value: 'GraphQLError'
	  },
	  toString: {
	    value: function toString() {
	      return printError(this);
	    }
	  }
	});
	/**
	 * Prints a GraphQLError to a string, representing useful location information
	 * about the error's position in the source.
	 */
	
	function printError(error) {
	  var output = error.message;
	
	  if (error.nodes) {
	    for (var _i2 = 0, _error$nodes2 = error.nodes; _i2 < _error$nodes2.length; _i2++) {
	      var node = _error$nodes2[_i2];
	
	      if (node.loc) {
	        output += '\n\n' + (0, _printLocation.printLocation)(node.loc);
	      }
	    }
	  } else if (error.source && error.locations) {
	    for (var _i4 = 0, _error$locations2 = error.locations; _i4 < _error$locations2.length; _i4++) {
	      var location = _error$locations2[_i4];
	      output += '\n\n' + (0, _printLocation.printSourceLocation)(error.source, location);
	    }
	  }
	
	  return output;
	}


/***/ }),
/* 565 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = defineToStringTag;
	
	/**
	 * The `defineToStringTag()` function checks first to see if the runtime
	 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
	 * is defined as a `Symbol` instance. If both conditions are met, the
	 * Symbol.toStringTag property is defined as a getter that returns the
	 * supplied class constructor's name.
	 *
	 * @method defineToStringTag
	 *
	 * @param {Class<any>} classObject a class such as Object, String, Number but
	 * typically one of your own creation through the class keyword; `class A {}`,
	 * for example.
	 */
	function defineToStringTag(classObject) {
	  if (typeof Symbol === 'function' && Symbol.toStringTag) {
	    Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
	      get: function get() {
	        return this.constructor.name;
	      }
	    });
	  }
	}


/***/ }),
/* 566 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObjectLike;
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	/**
	 * Return true if `value` is object-like. A value is object-like if it's not
	 * `null` and has a `typeof` result of "object".
	 */
	function isObjectLike(value) {
	  return _typeof(value) == 'object' && value !== null;
	}


/***/ }),
/* 567 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DirectiveLocation = void 0;
	
	/**
	 * The set of allowed directive location values.
	 */
	var DirectiveLocation = Object.freeze({
	  // Request Definitions
	  QUERY: 'QUERY',
	  MUTATION: 'MUTATION',
	  SUBSCRIPTION: 'SUBSCRIPTION',
	  FIELD: 'FIELD',
	  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
	  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
	  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
	  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
	  // Type System Definitions
	  SCHEMA: 'SCHEMA',
	  SCALAR: 'SCALAR',
	  OBJECT: 'OBJECT',
	  FIELD_DEFINITION: 'FIELD_DEFINITION',
	  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
	  INTERFACE: 'INTERFACE',
	  UNION: 'UNION',
	  ENUM: 'ENUM',
	  ENUM_VALUE: 'ENUM_VALUE',
	  INPUT_OBJECT: 'INPUT_OBJECT',
	  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
	});
	/**
	 * The enum type representing the directive location values.
	 */
	
	exports.DirectiveLocation = DirectiveLocation;


/***/ }),
/* 568 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Kind = void 0;
	
	/**
	 * The set of allowed kind values for AST nodes.
	 */
	var Kind = Object.freeze({
	  // Name
	  NAME: 'Name',
	  // Document
	  DOCUMENT: 'Document',
	  OPERATION_DEFINITION: 'OperationDefinition',
	  VARIABLE_DEFINITION: 'VariableDefinition',
	  SELECTION_SET: 'SelectionSet',
	  FIELD: 'Field',
	  ARGUMENT: 'Argument',
	  // Fragments
	  FRAGMENT_SPREAD: 'FragmentSpread',
	  INLINE_FRAGMENT: 'InlineFragment',
	  FRAGMENT_DEFINITION: 'FragmentDefinition',
	  // Values
	  VARIABLE: 'Variable',
	  INT: 'IntValue',
	  FLOAT: 'FloatValue',
	  STRING: 'StringValue',
	  BOOLEAN: 'BooleanValue',
	  NULL: 'NullValue',
	  ENUM: 'EnumValue',
	  LIST: 'ListValue',
	  OBJECT: 'ObjectValue',
	  OBJECT_FIELD: 'ObjectField',
	  // Directives
	  DIRECTIVE: 'Directive',
	  // Types
	  NAMED_TYPE: 'NamedType',
	  LIST_TYPE: 'ListType',
	  NON_NULL_TYPE: 'NonNullType',
	  // Type System Definitions
	  SCHEMA_DEFINITION: 'SchemaDefinition',
	  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
	  // Type Definitions
	  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
	  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
	  FIELD_DEFINITION: 'FieldDefinition',
	  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
	  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
	  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
	  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
	  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
	  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
	  // Directive Definitions
	  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
	  // Type System Extensions
	  SCHEMA_EXTENSION: 'SchemaExtension',
	  // Type Extensions
	  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
	  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
	  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
	  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
	  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
	  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
	});
	/**
	 * The enum type representing the possible kind values of AST nodes.
	 */
	
	exports.Kind = Kind;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createLexer = createLexer;
	exports.isPunctuatorToken = isPunctuatorToken;
	
	var _defineToJSON = _interopRequireDefault(__webpack_require__(231));
	
	var _syntaxError = __webpack_require__(230);
	
	var _blockString = __webpack_require__(235);
	
	var _tokenKind = __webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Given a Source object, this returns a Lexer for that source.
	 * A Lexer is a stateful stream generator in that every time
	 * it is advanced, it returns the next token in the Source. Assuming the
	 * source lexes, the final Token emitted by the lexer will be of kind
	 * EOF, after which the lexer will repeatedly return the same EOF token
	 * whenever called.
	 */
	function createLexer(source, options) {
	  var startOfFileToken = new Tok(_tokenKind.TokenKind.SOF, 0, 0, 0, 0, null);
	  var lexer = {
	    source: source,
	    options: options,
	    lastToken: startOfFileToken,
	    token: startOfFileToken,
	    line: 1,
	    lineStart: 0,
	    advance: advanceLexer,
	    lookahead: lookahead
	  };
	  return lexer;
	}
	
	function advanceLexer() {
	  this.lastToken = this.token;
	  var token = this.token = this.lookahead();
	  return token;
	}
	
	function lookahead() {
	  var token = this.token;
	
	  if (token.kind !== _tokenKind.TokenKind.EOF) {
	    do {
	      // Note: next is only mutable during parsing, so we cast to allow this.
	      token = token.next || (token.next = readToken(this, token));
	    } while (token.kind === _tokenKind.TokenKind.COMMENT);
	  }
	
	  return token;
	}
	/**
	 * The return type of createLexer.
	 */
	
	
	// @internal
	function isPunctuatorToken(token) {
	  var kind = token.kind;
	  return kind === _tokenKind.TokenKind.BANG || kind === _tokenKind.TokenKind.DOLLAR || kind === _tokenKind.TokenKind.AMP || kind === _tokenKind.TokenKind.PAREN_L || kind === _tokenKind.TokenKind.PAREN_R || kind === _tokenKind.TokenKind.SPREAD || kind === _tokenKind.TokenKind.COLON || kind === _tokenKind.TokenKind.EQUALS || kind === _tokenKind.TokenKind.AT || kind === _tokenKind.TokenKind.BRACKET_L || kind === _tokenKind.TokenKind.BRACKET_R || kind === _tokenKind.TokenKind.BRACE_L || kind === _tokenKind.TokenKind.PIPE || kind === _tokenKind.TokenKind.BRACE_R;
	}
	/**
	 * Helper function for constructing the Token object.
	 */
	
	
	function Tok(kind, start, end, line, column, prev, value) {
	  this.kind = kind;
	  this.start = start;
	  this.end = end;
	  this.line = line;
	  this.column = column;
	  this.value = value;
	  this.prev = prev;
	  this.next = null;
	} // Print a simplified form when appearing in JSON/util.inspect.
	
	
	(0, _defineToJSON.default)(Tok, function () {
	  return {
	    kind: this.kind,
	    value: this.value,
	    line: this.line,
	    column: this.column
	  };
	});
	
	function printCharCode(code) {
	  return (// NaN/undefined represents access beyond the end of the file.
	    isNaN(code) ? _tokenKind.TokenKind.EOF : // Trust JSON for ASCII.
	    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
	    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
	  );
	}
	/**
	 * Gets the next token from the source starting at the given position.
	 *
	 * This skips over whitespace until it finds the next lexable token, then lexes
	 * punctuators immediately or calls the appropriate helper function for more
	 * complicated tokens.
	 */
	
	
	function readToken(lexer, prev) {
	  var source = lexer.source;
	  var body = source.body;
	  var bodyLength = body.length;
	  var pos = positionAfterWhitespace(body, prev.end, lexer);
	  var line = lexer.line;
	  var col = 1 + pos - lexer.lineStart;
	
	  if (pos >= bodyLength) {
	    return new Tok(_tokenKind.TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
	  }
	
	  var code = body.charCodeAt(pos); // SourceCharacter
	
	  switch (code) {
	    // !
	    case 33:
	      return new Tok(_tokenKind.TokenKind.BANG, pos, pos + 1, line, col, prev);
	    // #
	
	    case 35:
	      return readComment(source, pos, line, col, prev);
	    // $
	
	    case 36:
	      return new Tok(_tokenKind.TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
	    // &
	
	    case 38:
	      return new Tok(_tokenKind.TokenKind.AMP, pos, pos + 1, line, col, prev);
	    // (
	
	    case 40:
	      return new Tok(_tokenKind.TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
	    // )
	
	    case 41:
	      return new Tok(_tokenKind.TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
	    // .
	
	    case 46:
	      if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
	        return new Tok(_tokenKind.TokenKind.SPREAD, pos, pos + 3, line, col, prev);
	      }
	
	      break;
	    // :
	
	    case 58:
	      return new Tok(_tokenKind.TokenKind.COLON, pos, pos + 1, line, col, prev);
	    // =
	
	    case 61:
	      return new Tok(_tokenKind.TokenKind.EQUALS, pos, pos + 1, line, col, prev);
	    // @
	
	    case 64:
	      return new Tok(_tokenKind.TokenKind.AT, pos, pos + 1, line, col, prev);
	    // [
	
	    case 91:
	      return new Tok(_tokenKind.TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
	    // ]
	
	    case 93:
	      return new Tok(_tokenKind.TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
	    // {
	
	    case 123:
	      return new Tok(_tokenKind.TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
	    // |
	
	    case 124:
	      return new Tok(_tokenKind.TokenKind.PIPE, pos, pos + 1, line, col, prev);
	    // }
	
	    case 125:
	      return new Tok(_tokenKind.TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
	    // A-Z _ a-z
	
	    case 65:
	    case 66:
	    case 67:
	    case 68:
	    case 69:
	    case 70:
	    case 71:
	    case 72:
	    case 73:
	    case 74:
	    case 75:
	    case 76:
	    case 77:
	    case 78:
	    case 79:
	    case 80:
	    case 81:
	    case 82:
	    case 83:
	    case 84:
	    case 85:
	    case 86:
	    case 87:
	    case 88:
	    case 89:
	    case 90:
	    case 95:
	    case 97:
	    case 98:
	    case 99:
	    case 100:
	    case 101:
	    case 102:
	    case 103:
	    case 104:
	    case 105:
	    case 106:
	    case 107:
	    case 108:
	    case 109:
	    case 110:
	    case 111:
	    case 112:
	    case 113:
	    case 114:
	    case 115:
	    case 116:
	    case 117:
	    case 118:
	    case 119:
	    case 120:
	    case 121:
	    case 122:
	      return readName(source, pos, line, col, prev);
	    // - 0-9
	
	    case 45:
	    case 48:
	    case 49:
	    case 50:
	    case 51:
	    case 52:
	    case 53:
	    case 54:
	    case 55:
	    case 56:
	    case 57:
	      return readNumber(source, pos, code, line, col, prev);
	    // "
	
	    case 34:
	      if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
	        return readBlockString(source, pos, line, col, prev, lexer);
	      }
	
	      return readString(source, pos, line, col, prev);
	  }
	
	  throw (0, _syntaxError.syntaxError)(source, pos, unexpectedCharacterMessage(code));
	}
	/**
	 * Report a message that an unexpected character was encountered.
	 */
	
	
	function unexpectedCharacterMessage(code) {
	  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
	    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
	  }
	
	  if (code === 39) {
	    // '
	    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
	  }
	
	  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
	}
	/**
	 * Reads from body starting at startPosition until it finds a non-whitespace
	 * character, then returns the position of that character for lexing.
	 */
	
	
	function positionAfterWhitespace(body, startPosition, lexer) {
	  var bodyLength = body.length;
	  var position = startPosition;
	
	  while (position < bodyLength) {
	    var code = body.charCodeAt(position); // tab | space | comma | BOM
	
	    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
	      ++position;
	    } else if (code === 10) {
	      // new line
	      ++position;
	      ++lexer.line;
	      lexer.lineStart = position;
	    } else if (code === 13) {
	      // carriage return
	      if (body.charCodeAt(position + 1) === 10) {
	        position += 2;
	      } else {
	        ++position;
	      }
	
	      ++lexer.line;
	      lexer.lineStart = position;
	    } else {
	      break;
	    }
	  }
	
	  return position;
	}
	/**
	 * Reads a comment token from the source file.
	 *
	 * #[\u0009\u0020-\uFFFF]*
	 */
	
	
	function readComment(source, start, line, col, prev) {
	  var body = source.body;
	  var code;
	  var position = start;
	
	  do {
	    code = body.charCodeAt(++position);
	  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
	  code > 0x001f || code === 0x0009));
	
	  return new Tok(_tokenKind.TokenKind.COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
	}
	/**
	 * Reads a number token from the source file, either a float
	 * or an int depending on whether a decimal point appears.
	 *
	 * Int:   -?(0|[1-9][0-9]*)
	 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
	 */
	
	
	function readNumber(source, start, firstCode, line, col, prev) {
	  var body = source.body;
	  var code = firstCode;
	  var position = start;
	  var isFloat = false;
	
	  if (code === 45) {
	    // -
	    code = body.charCodeAt(++position);
	  }
	
	  if (code === 48) {
	    // 0
	    code = body.charCodeAt(++position);
	
	    if (code >= 48 && code <= 57) {
	      throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
	    }
	  } else {
	    position = readDigits(source, position, code);
	    code = body.charCodeAt(position);
	  }
	
	  if (code === 46) {
	    // .
	    isFloat = true;
	    code = body.charCodeAt(++position);
	    position = readDigits(source, position, code);
	    code = body.charCodeAt(position);
	  }
	
	  if (code === 69 || code === 101) {
	    // E e
	    isFloat = true;
	    code = body.charCodeAt(++position);
	
	    if (code === 43 || code === 45) {
	      // + -
	      code = body.charCodeAt(++position);
	    }
	
	    position = readDigits(source, position, code);
	    code = body.charCodeAt(position);
	  } // Numbers cannot be followed by . or e
	
	
	  if (code === 46 || code === 69 || code === 101) {
	    throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
	  }
	
	  return new Tok(isFloat ? _tokenKind.TokenKind.FLOAT : _tokenKind.TokenKind.INT, start, position, line, col, prev, body.slice(start, position));
	}
	/**
	 * Returns the new position in the source after reading digits.
	 */
	
	
	function readDigits(source, start, firstCode) {
	  var body = source.body;
	  var position = start;
	  var code = firstCode;
	
	  if (code >= 48 && code <= 57) {
	    // 0 - 9
	    do {
	      code = body.charCodeAt(++position);
	    } while (code >= 48 && code <= 57); // 0 - 9
	
	
	    return position;
	  }
	
	  throw (0, _syntaxError.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
	}
	/**
	 * Reads a string token from the source file.
	 *
	 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
	 */
	
	
	function readString(source, start, line, col, prev) {
	  var body = source.body;
	  var position = start + 1;
	  var chunkStart = position;
	  var code = 0;
	  var value = '';
	
	  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
	  code !== 0x000a && code !== 0x000d) {
	    // Closing Quote (")
	    if (code === 34) {
	      value += body.slice(chunkStart, position);
	      return new Tok(_tokenKind.TokenKind.STRING, start, position + 1, line, col, prev, value);
	    } // SourceCharacter
	
	
	    if (code < 0x0020 && code !== 0x0009) {
	      throw (0, _syntaxError.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
	    }
	
	    ++position;
	
	    if (code === 92) {
	      // \
	      value += body.slice(chunkStart, position - 1);
	      code = body.charCodeAt(position);
	
	      switch (code) {
	        case 34:
	          value += '"';
	          break;
	
	        case 47:
	          value += '/';
	          break;
	
	        case 92:
	          value += '\\';
	          break;
	
	        case 98:
	          value += '\b';
	          break;
	
	        case 102:
	          value += '\f';
	          break;
	
	        case 110:
	          value += '\n';
	          break;
	
	        case 114:
	          value += '\r';
	          break;
	
	        case 116:
	          value += '\t';
	          break;
	
	        case 117:
	          {
	            // uXXXX
	            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
	
	            if (charCode < 0) {
	              var invalidSequence = body.slice(position + 1, position + 5);
	              throw (0, _syntaxError.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
	            }
	
	            value += String.fromCharCode(charCode);
	            position += 4;
	            break;
	          }
	
	        default:
	          throw (0, _syntaxError.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
	      }
	
	      ++position;
	      chunkStart = position;
	    }
	  }
	
	  throw (0, _syntaxError.syntaxError)(source, position, 'Unterminated string.');
	}
	/**
	 * Reads a block string token from the source file.
	 *
	 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
	 */
	
	
	function readBlockString(source, start, line, col, prev, lexer) {
	  var body = source.body;
	  var position = start + 3;
	  var chunkStart = position;
	  var code = 0;
	  var rawValue = '';
	
	  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
	    // Closing Triple-Quote (""")
	    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
	      rawValue += body.slice(chunkStart, position);
	      return new Tok(_tokenKind.TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockString.dedentBlockStringValue)(rawValue));
	    } // SourceCharacter
	
	
	    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
	      throw (0, _syntaxError.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
	    }
	
	    if (code === 10) {
	      // new line
	      ++position;
	      ++lexer.line;
	      lexer.lineStart = position;
	    } else if (code === 13) {
	      // carriage return
	      if (body.charCodeAt(position + 1) === 10) {
	        position += 2;
	      } else {
	        ++position;
	      }
	
	      ++lexer.line;
	      lexer.lineStart = position;
	    } else if ( // Escape Triple-Quote (\""")
	    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
	      rawValue += body.slice(chunkStart, position) + '"""';
	      position += 4;
	      chunkStart = position;
	    } else {
	      ++position;
	    }
	  }
	
	  throw (0, _syntaxError.syntaxError)(source, position, 'Unterminated string.');
	}
	/**
	 * Converts four hexadecimal chars to the integer that the
	 * string represents. For example, uniCharCode('0','0','0','f')
	 * will return 15, and uniCharCode('0','0','f','f') returns 255.
	 *
	 * Returns a negative number on error, if a char was invalid.
	 *
	 * This is implemented by noting that char2hex() returns -1 on error,
	 * which means the result of ORing the char2hex() will also be negative.
	 */
	
	
	function uniCharCode(a, b, c, d) {
	  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
	}
	/**
	 * Converts a hex character to its integer value.
	 * '0' becomes 0, '9' becomes 9
	 * 'A' becomes 10, 'F' becomes 15
	 * 'a' becomes 10, 'f' becomes 15
	 *
	 * Returns -1 on error.
	 */
	
	
	function char2hex(a) {
	  return a >= 48 && a <= 57 ? a - 48 // 0-9
	  : a >= 65 && a <= 70 ? a - 55 // A-F
	  : a >= 97 && a <= 102 ? a - 87 // a-f
	  : -1;
	}
	/**
	 * Reads an alphanumeric + underscore name from the source.
	 *
	 * [_A-Za-z][_0-9A-Za-z]*
	 */
	
	
	function readName(source, start, line, col, prev) {
	  var body = source.body;
	  var bodyLength = body.length;
	  var position = start + 1;
	  var code = 0;
	
	  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
	  code >= 48 && code <= 57 || // 0-9
	  code >= 65 && code <= 90 || // A-Z
	  code >= 97 && code <= 122) // a-z
	  ) {
	    ++position;
	  }
	
	  return new Tok(_tokenKind.TokenKind.NAME, start, position, line, col, prev, body.slice(start, position));
	}


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parse = parse;
	exports.parseValue = parseValue;
	exports.parseType = parseType;
	
	var _inspect = _interopRequireDefault(__webpack_require__(233));
	
	var _devAssert = _interopRequireDefault(__webpack_require__(232));
	
	var _defineToJSON = _interopRequireDefault(__webpack_require__(231));
	
	var _syntaxError = __webpack_require__(230);
	
	var _kinds = __webpack_require__(568);
	
	var _source = __webpack_require__(573);
	
	var _lexer = __webpack_require__(569);
	
	var _directiveLocation = __webpack_require__(567);
	
	var _tokenKind = __webpack_require__(237);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Given a GraphQL source, parses it into a Document.
	 * Throws GraphQLError if a syntax error is encountered.
	 */
	function parse(source, options) {
	  var parser = new Parser(source, options);
	  return parser.parseDocument();
	}
	/**
	 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
	 * that value.
	 * Throws GraphQLError if a syntax error is encountered.
	 *
	 * This is useful within tools that operate upon GraphQL Values directly and
	 * in isolation of complete GraphQL documents.
	 *
	 * Consider providing the results to the utility function: valueFromAST().
	 */
	
	
	function parseValue(source, options) {
	  var parser = new Parser(source, options);
	  parser.expectToken(_tokenKind.TokenKind.SOF);
	  var value = parser.parseValueLiteral(false);
	  parser.expectToken(_tokenKind.TokenKind.EOF);
	  return value;
	}
	/**
	 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
	 * that type.
	 * Throws GraphQLError if a syntax error is encountered.
	 *
	 * This is useful within tools that operate upon GraphQL Types directly and
	 * in isolation of complete GraphQL documents.
	 *
	 * Consider providing the results to the utility function: typeFromAST().
	 */
	
	
	function parseType(source, options) {
	  var parser = new Parser(source, options);
	  parser.expectToken(_tokenKind.TokenKind.SOF);
	  var type = parser.parseTypeReference();
	  parser.expectToken(_tokenKind.TokenKind.EOF);
	  return type;
	}
	
	var Parser =
	/*#__PURE__*/
	function () {
	  function Parser(source, options) {
	    var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
	    sourceObj instanceof _source.Source || (0, _devAssert.default)(0, "Must provide Source. Received: ".concat((0, _inspect.default)(sourceObj)));
	    this._lexer = (0, _lexer.createLexer)(sourceObj);
	    this._options = options || {};
	  }
	  /**
	   * Converts a name lex token into a name parse node.
	   */
	
	
	  var _proto = Parser.prototype;
	
	  _proto.parseName = function parseName() {
	    var token = this.expectToken(_tokenKind.TokenKind.NAME);
	    return {
	      kind: _kinds.Kind.NAME,
	      value: token.value,
	      loc: this.loc(token)
	    };
	  } // Implements the parsing rules in the Document section.
	
	  /**
	   * Document : Definition+
	   */
	  ;
	
	  _proto.parseDocument = function parseDocument() {
	    var start = this._lexer.token;
	    return {
	      kind: _kinds.Kind.DOCUMENT,
	      definitions: this.many(_tokenKind.TokenKind.SOF, this.parseDefinition, _tokenKind.TokenKind.EOF),
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * Definition :
	   *   - ExecutableDefinition
	   *   - TypeSystemDefinition
	   *   - TypeSystemExtension
	   *
	   * ExecutableDefinition :
	   *   - OperationDefinition
	   *   - FragmentDefinition
	   */
	  ;
	
	  _proto.parseDefinition = function parseDefinition() {
	    if (this.peek(_tokenKind.TokenKind.NAME)) {
	      switch (this._lexer.token.value) {
	        case 'query':
	        case 'mutation':
	        case 'subscription':
	          return this.parseOperationDefinition();
	
	        case 'fragment':
	          return this.parseFragmentDefinition();
	
	        case 'schema':
	        case 'scalar':
	        case 'type':
	        case 'interface':
	        case 'union':
	        case 'enum':
	        case 'input':
	        case 'directive':
	          return this.parseTypeSystemDefinition();
	
	        case 'extend':
	          return this.parseTypeSystemExtension();
	      }
	    } else if (this.peek(_tokenKind.TokenKind.BRACE_L)) {
	      return this.parseOperationDefinition();
	    } else if (this.peekDescription()) {
	      return this.parseTypeSystemDefinition();
	    }
	
	    throw this.unexpected();
	  } // Implements the parsing rules in the Operations section.
	
	  /**
	   * OperationDefinition :
	   *  - SelectionSet
	   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
	   */
	  ;
	
	  _proto.parseOperationDefinition = function parseOperationDefinition() {
	    var start = this._lexer.token;
	
	    if (this.peek(_tokenKind.TokenKind.BRACE_L)) {
	      return {
	        kind: _kinds.Kind.OPERATION_DEFINITION,
	        operation: 'query',
	        name: undefined,
	        variableDefinitions: [],
	        directives: [],
	        selectionSet: this.parseSelectionSet(),
	        loc: this.loc(start)
	      };
	    }
	
	    var operation = this.parseOperationType();
	    var name;
	
	    if (this.peek(_tokenKind.TokenKind.NAME)) {
	      name = this.parseName();
	    }
	
	    return {
	      kind: _kinds.Kind.OPERATION_DEFINITION,
	      operation: operation,
	      name: name,
	      variableDefinitions: this.parseVariableDefinitions(),
	      directives: this.parseDirectives(false),
	      selectionSet: this.parseSelectionSet(),
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * OperationType : one of query mutation subscription
	   */
	  ;
	
	  _proto.parseOperationType = function parseOperationType() {
	    var operationToken = this.expectToken(_tokenKind.TokenKind.NAME);
	
	    switch (operationToken.value) {
	      case 'query':
	        return 'query';
	
	      case 'mutation':
	        return 'mutation';
	
	      case 'subscription':
	        return 'subscription';
	    }
	
	    throw this.unexpected(operationToken);
	  }
	  /**
	   * VariableDefinitions : ( VariableDefinition+ )
	   */
	  ;
	
	  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
	    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, this.parseVariableDefinition, _tokenKind.TokenKind.PAREN_R);
	  }
	  /**
	   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
	   */
	  ;
	
	  _proto.parseVariableDefinition = function parseVariableDefinition() {
	    var start = this._lexer.token;
	    return {
	      kind: _kinds.Kind.VARIABLE_DEFINITION,
	      variable: this.parseVariable(),
	      type: (this.expectToken(_tokenKind.TokenKind.COLON), this.parseTypeReference()),
	      defaultValue: this.expectOptionalToken(_tokenKind.TokenKind.EQUALS) ? this.parseValueLiteral(true) : undefined,
	      directives: this.parseDirectives(true),
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * Variable : $ Name
	   */
	  ;
	
	  _proto.parseVariable = function parseVariable() {
	    var start = this._lexer.token;
	    this.expectToken(_tokenKind.TokenKind.DOLLAR);
	    return {
	      kind: _kinds.Kind.VARIABLE,
	      name: this.parseName(),
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * SelectionSet : { Selection+ }
	   */
	  ;
	
	  _proto.parseSelectionSet = function parseSelectionSet() {
	    var start = this._lexer.token;
	    return {
	      kind: _kinds.Kind.SELECTION_SET,
	      selections: this.many(_tokenKind.TokenKind.BRACE_L, this.parseSelection, _tokenKind.TokenKind.BRACE_R),
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * Selection :
	   *   - Field
	   *   - FragmentSpread
	   *   - InlineFragment
	   */
	  ;
	
	  _proto.parseSelection = function parseSelection() {
	    return this.peek(_tokenKind.TokenKind.SPREAD) ? this.parseFragment() : this.parseField();
	  }
	  /**
	   * Field : Alias? Name Arguments? Directives? SelectionSet?
	   *
	   * Alias : Name :
	   */
	  ;
	
	  _proto.parseField = function parseField() {
	    var start = this._lexer.token;
	    var nameOrAlias = this.parseName();
	    var alias;
	    var name;
	
	    if (this.expectOptionalToken(_tokenKind.TokenKind.COLON)) {
	      alias = nameOrAlias;
	      name = this.parseName();
	    } else {
	      name = nameOrAlias;
	    }
	
	    return {
	      kind: _kinds.Kind.FIELD,
	      alias: alias,
	      name: name,
	      arguments: this.parseArguments(false),
	      directives: this.parseDirectives(false),
	      selectionSet: this.peek(_tokenKind.TokenKind.BRACE_L) ? this.parseSelectionSet() : undefined,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * Arguments[Const] : ( Argument[?Const]+ )
	   */
	  ;
	
	  _proto.parseArguments = function parseArguments(isConst) {
	    var item = isConst ? this.parseConstArgument : this.parseArgument;
	    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, item, _tokenKind.TokenKind.PAREN_R);
	  }
	  /**
	   * Argument[Const] : Name : Value[?Const]
	   */
	  ;
	
	  _proto.parseArgument = function parseArgument() {
	    var start = this._lexer.token;
	    var name = this.parseName();
	    this.expectToken(_tokenKind.TokenKind.COLON);
	    return {
	      kind: _kinds.Kind.ARGUMENT,
	      name: name,
	      value: this.parseValueLiteral(false),
	      loc: this.loc(start)
	    };
	  };
	
	  _proto.parseConstArgument = function parseConstArgument() {
	    var start = this._lexer.token;
	    return {
	      kind: _kinds.Kind.ARGUMENT,
	      name: this.parseName(),
	      value: (this.expectToken(_tokenKind.TokenKind.COLON), this.parseValueLiteral(true)),
	      loc: this.loc(start)
	    };
	  } // Implements the parsing rules in the Fragments section.
	
	  /**
	   * Corresponds to both FragmentSpread and InlineFragment in the spec.
	   *
	   * FragmentSpread : ... FragmentName Directives?
	   *
	   * InlineFragment : ... TypeCondition? Directives? SelectionSet
	   */
	  ;
	
	  _proto.parseFragment = function parseFragment() {
	    var start = this._lexer.token;
	    this.expectToken(_tokenKind.TokenKind.SPREAD);
	    var hasTypeCondition = this.expectOptionalKeyword('on');
	
	    if (!hasTypeCondition && this.peek(_tokenKind.TokenKind.NAME)) {
	      return {
	        kind: _kinds.Kind.FRAGMENT_SPREAD,
	        name: this.parseFragmentName(),
	        directives: this.parseDirectives(false),
	        loc: this.loc(start)
	      };
	    }
	
	    return {
	      kind: _kinds.Kind.INLINE_FRAGMENT,
	      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
	      directives: this.parseDirectives(false),
	      selectionSet: this.parseSelectionSet(),
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * FragmentDefinition :
	   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
	   *
	   * TypeCondition : NamedType
	   */
	  ;
	
	  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
	    var start = this._lexer.token;
	    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
	    // the grammar of FragmentDefinition:
	    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
	
	    if (this._options.experimentalFragmentVariables) {
	      return {
	        kind: _kinds.Kind.FRAGMENT_DEFINITION,
	        name: this.parseFragmentName(),
	        variableDefinitions: this.parseVariableDefinitions(),
	        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
	        directives: this.parseDirectives(false),
	        selectionSet: this.parseSelectionSet(),
	        loc: this.loc(start)
	      };
	    }
	
	    return {
	      kind: _kinds.Kind.FRAGMENT_DEFINITION,
	      name: this.parseFragmentName(),
	      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
	      directives: this.parseDirectives(false),
	      selectionSet: this.parseSelectionSet(),
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * FragmentName : Name but not `on`
	   */
	  ;
	
	  _proto.parseFragmentName = function parseFragmentName() {
	    if (this._lexer.token.value === 'on') {
	      throw this.unexpected();
	    }
	
	    return this.parseName();
	  } // Implements the parsing rules in the Values section.
	
	  /**
	   * Value[Const] :
	   *   - [~Const] Variable
	   *   - IntValue
	   *   - FloatValue
	   *   - StringValue
	   *   - BooleanValue
	   *   - NullValue
	   *   - EnumValue
	   *   - ListValue[?Const]
	   *   - ObjectValue[?Const]
	   *
	   * BooleanValue : one of `true` `false`
	   *
	   * NullValue : `null`
	   *
	   * EnumValue : Name but not `true`, `false` or `null`
	   */
	  ;
	
	  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
	    var token = this._lexer.token;
	
	    switch (token.kind) {
	      case _tokenKind.TokenKind.BRACKET_L:
	        return this.parseList(isConst);
	
	      case _tokenKind.TokenKind.BRACE_L:
	        return this.parseObject(isConst);
	
	      case _tokenKind.TokenKind.INT:
	        this._lexer.advance();
	
	        return {
	          kind: _kinds.Kind.INT,
	          value: token.value,
	          loc: this.loc(token)
	        };
	
	      case _tokenKind.TokenKind.FLOAT:
	        this._lexer.advance();
	
	        return {
	          kind: _kinds.Kind.FLOAT,
	          value: token.value,
	          loc: this.loc(token)
	        };
	
	      case _tokenKind.TokenKind.STRING:
	      case _tokenKind.TokenKind.BLOCK_STRING:
	        return this.parseStringLiteral();
	
	      case _tokenKind.TokenKind.NAME:
	        if (token.value === 'true' || token.value === 'false') {
	          this._lexer.advance();
	
	          return {
	            kind: _kinds.Kind.BOOLEAN,
	            value: token.value === 'true',
	            loc: this.loc(token)
	          };
	        } else if (token.value === 'null') {
	          this._lexer.advance();
	
	          return {
	            kind: _kinds.Kind.NULL,
	            loc: this.loc(token)
	          };
	        }
	
	        this._lexer.advance();
	
	        return {
	          kind: _kinds.Kind.ENUM,
	          value: token.value,
	          loc: this.loc(token)
	        };
	
	      case _tokenKind.TokenKind.DOLLAR:
	        if (!isConst) {
	          return this.parseVariable();
	        }
	
	        break;
	    }
	
	    throw this.unexpected();
	  };
	
	  _proto.parseStringLiteral = function parseStringLiteral() {
	    var token = this._lexer.token;
	
	    this._lexer.advance();
	
	    return {
	      kind: _kinds.Kind.STRING,
	      value: token.value,
	      block: token.kind === _tokenKind.TokenKind.BLOCK_STRING,
	      loc: this.loc(token)
	    };
	  }
	  /**
	   * ListValue[Const] :
	   *   - [ ]
	   *   - [ Value[?Const]+ ]
	   */
	  ;
	
	  _proto.parseList = function parseList(isConst) {
	    var _this = this;
	
	    var start = this._lexer.token;
	
	    var item = function item() {
	      return _this.parseValueLiteral(isConst);
	    };
	
	    return {
	      kind: _kinds.Kind.LIST,
	      values: this.any(_tokenKind.TokenKind.BRACKET_L, item, _tokenKind.TokenKind.BRACKET_R),
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * ObjectValue[Const] :
	   *   - { }
	   *   - { ObjectField[?Const]+ }
	   */
	  ;
	
	  _proto.parseObject = function parseObject(isConst) {
	    var _this2 = this;
	
	    var start = this._lexer.token;
	
	    var item = function item() {
	      return _this2.parseObjectField(isConst);
	    };
	
	    return {
	      kind: _kinds.Kind.OBJECT,
	      fields: this.any(_tokenKind.TokenKind.BRACE_L, item, _tokenKind.TokenKind.BRACE_R),
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * ObjectField[Const] : Name : Value[?Const]
	   */
	  ;
	
	  _proto.parseObjectField = function parseObjectField(isConst) {
	    var start = this._lexer.token;
	    var name = this.parseName();
	    this.expectToken(_tokenKind.TokenKind.COLON);
	    return {
	      kind: _kinds.Kind.OBJECT_FIELD,
	      name: name,
	      value: this.parseValueLiteral(isConst),
	      loc: this.loc(start)
	    };
	  } // Implements the parsing rules in the Directives section.
	
	  /**
	   * Directives[Const] : Directive[?Const]+
	   */
	  ;
	
	  _proto.parseDirectives = function parseDirectives(isConst) {
	    var directives = [];
	
	    while (this.peek(_tokenKind.TokenKind.AT)) {
	      directives.push(this.parseDirective(isConst));
	    }
	
	    return directives;
	  }
	  /**
	   * Directive[Const] : @ Name Arguments[?Const]?
	   */
	  ;
	
	  _proto.parseDirective = function parseDirective(isConst) {
	    var start = this._lexer.token;
	    this.expectToken(_tokenKind.TokenKind.AT);
	    return {
	      kind: _kinds.Kind.DIRECTIVE,
	      name: this.parseName(),
	      arguments: this.parseArguments(isConst),
	      loc: this.loc(start)
	    };
	  } // Implements the parsing rules in the Types section.
	
	  /**
	   * Type :
	   *   - NamedType
	   *   - ListType
	   *   - NonNullType
	   */
	  ;
	
	  _proto.parseTypeReference = function parseTypeReference() {
	    var start = this._lexer.token;
	    var type;
	
	    if (this.expectOptionalToken(_tokenKind.TokenKind.BRACKET_L)) {
	      type = this.parseTypeReference();
	      this.expectToken(_tokenKind.TokenKind.BRACKET_R);
	      type = {
	        kind: _kinds.Kind.LIST_TYPE,
	        type: type,
	        loc: this.loc(start)
	      };
	    } else {
	      type = this.parseNamedType();
	    }
	
	    if (this.expectOptionalToken(_tokenKind.TokenKind.BANG)) {
	      return {
	        kind: _kinds.Kind.NON_NULL_TYPE,
	        type: type,
	        loc: this.loc(start)
	      };
	    }
	
	    return type;
	  }
	  /**
	   * NamedType : Name
	   */
	  ;
	
	  _proto.parseNamedType = function parseNamedType() {
	    var start = this._lexer.token;
	    return {
	      kind: _kinds.Kind.NAMED_TYPE,
	      name: this.parseName(),
	      loc: this.loc(start)
	    };
	  } // Implements the parsing rules in the Type Definition section.
	
	  /**
	   * TypeSystemDefinition :
	   *   - SchemaDefinition
	   *   - TypeDefinition
	   *   - DirectiveDefinition
	   *
	   * TypeDefinition :
	   *   - ScalarTypeDefinition
	   *   - ObjectTypeDefinition
	   *   - InterfaceTypeDefinition
	   *   - UnionTypeDefinition
	   *   - EnumTypeDefinition
	   *   - InputObjectTypeDefinition
	   */
	  ;
	
	  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
	    // Many definitions begin with a description and require a lookahead.
	    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
	
	    if (keywordToken.kind === _tokenKind.TokenKind.NAME) {
	      switch (keywordToken.value) {
	        case 'schema':
	          return this.parseSchemaDefinition();
	
	        case 'scalar':
	          return this.parseScalarTypeDefinition();
	
	        case 'type':
	          return this.parseObjectTypeDefinition();
	
	        case 'interface':
	          return this.parseInterfaceTypeDefinition();
	
	        case 'union':
	          return this.parseUnionTypeDefinition();
	
	        case 'enum':
	          return this.parseEnumTypeDefinition();
	
	        case 'input':
	          return this.parseInputObjectTypeDefinition();
	
	        case 'directive':
	          return this.parseDirectiveDefinition();
	      }
	    }
	
	    throw this.unexpected(keywordToken);
	  };
	
	  _proto.peekDescription = function peekDescription() {
	    return this.peek(_tokenKind.TokenKind.STRING) || this.peek(_tokenKind.TokenKind.BLOCK_STRING);
	  }
	  /**
	   * Description : StringValue
	   */
	  ;
	
	  _proto.parseDescription = function parseDescription() {
	    if (this.peekDescription()) {
	      return this.parseStringLiteral();
	    }
	  }
	  /**
	   * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
	   */
	  ;
	
	  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
	    var start = this._lexer.token;
	    this.expectKeyword('schema');
	    var directives = this.parseDirectives(true);
	    var operationTypes = this.many(_tokenKind.TokenKind.BRACE_L, this.parseOperationTypeDefinition, _tokenKind.TokenKind.BRACE_R);
	    return {
	      kind: _kinds.Kind.SCHEMA_DEFINITION,
	      directives: directives,
	      operationTypes: operationTypes,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * OperationTypeDefinition : OperationType : NamedType
	   */
	  ;
	
	  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
	    var start = this._lexer.token;
	    var operation = this.parseOperationType();
	    this.expectToken(_tokenKind.TokenKind.COLON);
	    var type = this.parseNamedType();
	    return {
	      kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
	      operation: operation,
	      type: type,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
	   */
	  ;
	
	  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
	    var start = this._lexer.token;
	    var description = this.parseDescription();
	    this.expectKeyword('scalar');
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	    return {
	      kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
	      description: description,
	      name: name,
	      directives: directives,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * ObjectTypeDefinition :
	   *   Description?
	   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
	   */
	  ;
	
	  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
	    var start = this._lexer.token;
	    var description = this.parseDescription();
	    this.expectKeyword('type');
	    var name = this.parseName();
	    var interfaces = this.parseImplementsInterfaces();
	    var directives = this.parseDirectives(true);
	    var fields = this.parseFieldsDefinition();
	    return {
	      kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
	      description: description,
	      name: name,
	      interfaces: interfaces,
	      directives: directives,
	      fields: fields,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * ImplementsInterfaces :
	   *   - implements `&`? NamedType
	   *   - ImplementsInterfaces & NamedType
	   */
	  ;
	
	  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
	    var types = [];
	
	    if (this.expectOptionalKeyword('implements')) {
	      // Optional leading ampersand
	      this.expectOptionalToken(_tokenKind.TokenKind.AMP);
	
	      do {
	        types.push(this.parseNamedType());
	      } while (this.expectOptionalToken(_tokenKind.TokenKind.AMP) || // Legacy support for the SDL?
	      this._options.allowLegacySDLImplementsInterfaces && this.peek(_tokenKind.TokenKind.NAME));
	    }
	
	    return types;
	  }
	  /**
	   * FieldsDefinition : { FieldDefinition+ }
	   */
	  ;
	
	  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
	    // Legacy support for the SDL?
	    if (this._options.allowLegacySDLEmptyFields && this.peek(_tokenKind.TokenKind.BRACE_L) && this._lexer.lookahead().kind === _tokenKind.TokenKind.BRACE_R) {
	      this._lexer.advance();
	
	      this._lexer.advance();
	
	      return [];
	    }
	
	    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseFieldDefinition, _tokenKind.TokenKind.BRACE_R);
	  }
	  /**
	   * FieldDefinition :
	   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
	   */
	  ;
	
	  _proto.parseFieldDefinition = function parseFieldDefinition() {
	    var start = this._lexer.token;
	    var description = this.parseDescription();
	    var name = this.parseName();
	    var args = this.parseArgumentDefs();
	    this.expectToken(_tokenKind.TokenKind.COLON);
	    var type = this.parseTypeReference();
	    var directives = this.parseDirectives(true);
	    return {
	      kind: _kinds.Kind.FIELD_DEFINITION,
	      description: description,
	      name: name,
	      arguments: args,
	      type: type,
	      directives: directives,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * ArgumentsDefinition : ( InputValueDefinition+ )
	   */
	  ;
	
	  _proto.parseArgumentDefs = function parseArgumentDefs() {
	    return this.optionalMany(_tokenKind.TokenKind.PAREN_L, this.parseInputValueDef, _tokenKind.TokenKind.PAREN_R);
	  }
	  /**
	   * InputValueDefinition :
	   *   - Description? Name : Type DefaultValue? Directives[Const]?
	   */
	  ;
	
	  _proto.parseInputValueDef = function parseInputValueDef() {
	    var start = this._lexer.token;
	    var description = this.parseDescription();
	    var name = this.parseName();
	    this.expectToken(_tokenKind.TokenKind.COLON);
	    var type = this.parseTypeReference();
	    var defaultValue;
	
	    if (this.expectOptionalToken(_tokenKind.TokenKind.EQUALS)) {
	      defaultValue = this.parseValueLiteral(true);
	    }
	
	    var directives = this.parseDirectives(true);
	    return {
	      kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
	      description: description,
	      name: name,
	      type: type,
	      defaultValue: defaultValue,
	      directives: directives,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * InterfaceTypeDefinition :
	   *   - Description? interface Name Directives[Const]? FieldsDefinition?
	   */
	  ;
	
	  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
	    var start = this._lexer.token;
	    var description = this.parseDescription();
	    this.expectKeyword('interface');
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	    var fields = this.parseFieldsDefinition();
	    return {
	      kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
	      description: description,
	      name: name,
	      directives: directives,
	      fields: fields,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * UnionTypeDefinition :
	   *   - Description? union Name Directives[Const]? UnionMemberTypes?
	   */
	  ;
	
	  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
	    var start = this._lexer.token;
	    var description = this.parseDescription();
	    this.expectKeyword('union');
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	    var types = this.parseUnionMemberTypes();
	    return {
	      kind: _kinds.Kind.UNION_TYPE_DEFINITION,
	      description: description,
	      name: name,
	      directives: directives,
	      types: types,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * UnionMemberTypes :
	   *   - = `|`? NamedType
	   *   - UnionMemberTypes | NamedType
	   */
	  ;
	
	  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
	    var types = [];
	
	    if (this.expectOptionalToken(_tokenKind.TokenKind.EQUALS)) {
	      // Optional leading pipe
	      this.expectOptionalToken(_tokenKind.TokenKind.PIPE);
	
	      do {
	        types.push(this.parseNamedType());
	      } while (this.expectOptionalToken(_tokenKind.TokenKind.PIPE));
	    }
	
	    return types;
	  }
	  /**
	   * EnumTypeDefinition :
	   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
	   */
	  ;
	
	  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
	    var start = this._lexer.token;
	    var description = this.parseDescription();
	    this.expectKeyword('enum');
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	    var values = this.parseEnumValuesDefinition();
	    return {
	      kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
	      description: description,
	      name: name,
	      directives: directives,
	      values: values,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * EnumValuesDefinition : { EnumValueDefinition+ }
	   */
	  ;
	
	  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
	    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseEnumValueDefinition, _tokenKind.TokenKind.BRACE_R);
	  }
	  /**
	   * EnumValueDefinition : Description? EnumValue Directives[Const]?
	   *
	   * EnumValue : Name
	   */
	  ;
	
	  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
	    var start = this._lexer.token;
	    var description = this.parseDescription();
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	    return {
	      kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
	      description: description,
	      name: name,
	      directives: directives,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * InputObjectTypeDefinition :
	   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
	   */
	  ;
	
	  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
	    var start = this._lexer.token;
	    var description = this.parseDescription();
	    this.expectKeyword('input');
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	    var fields = this.parseInputFieldsDefinition();
	    return {
	      kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
	      description: description,
	      name: name,
	      directives: directives,
	      fields: fields,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * InputFieldsDefinition : { InputValueDefinition+ }
	   */
	  ;
	
	  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
	    return this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseInputValueDef, _tokenKind.TokenKind.BRACE_R);
	  }
	  /**
	   * TypeSystemExtension :
	   *   - SchemaExtension
	   *   - TypeExtension
	   *
	   * TypeExtension :
	   *   - ScalarTypeExtension
	   *   - ObjectTypeExtension
	   *   - InterfaceTypeExtension
	   *   - UnionTypeExtension
	   *   - EnumTypeExtension
	   *   - InputObjectTypeDefinition
	   */
	  ;
	
	  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
	    var keywordToken = this._lexer.lookahead();
	
	    if (keywordToken.kind === _tokenKind.TokenKind.NAME) {
	      switch (keywordToken.value) {
	        case 'schema':
	          return this.parseSchemaExtension();
	
	        case 'scalar':
	          return this.parseScalarTypeExtension();
	
	        case 'type':
	          return this.parseObjectTypeExtension();
	
	        case 'interface':
	          return this.parseInterfaceTypeExtension();
	
	        case 'union':
	          return this.parseUnionTypeExtension();
	
	        case 'enum':
	          return this.parseEnumTypeExtension();
	
	        case 'input':
	          return this.parseInputObjectTypeExtension();
	      }
	    }
	
	    throw this.unexpected(keywordToken);
	  }
	  /**
	   * SchemaExtension :
	   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
	   *  - extend schema Directives[Const]
	   */
	  ;
	
	  _proto.parseSchemaExtension = function parseSchemaExtension() {
	    var start = this._lexer.token;
	    this.expectKeyword('extend');
	    this.expectKeyword('schema');
	    var directives = this.parseDirectives(true);
	    var operationTypes = this.optionalMany(_tokenKind.TokenKind.BRACE_L, this.parseOperationTypeDefinition, _tokenKind.TokenKind.BRACE_R);
	
	    if (directives.length === 0 && operationTypes.length === 0) {
	      throw this.unexpected();
	    }
	
	    return {
	      kind: _kinds.Kind.SCHEMA_EXTENSION,
	      directives: directives,
	      operationTypes: operationTypes,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * ScalarTypeExtension :
	   *   - extend scalar Name Directives[Const]
	   */
	  ;
	
	  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
	    var start = this._lexer.token;
	    this.expectKeyword('extend');
	    this.expectKeyword('scalar');
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	
	    if (directives.length === 0) {
	      throw this.unexpected();
	    }
	
	    return {
	      kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
	      name: name,
	      directives: directives,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * ObjectTypeExtension :
	   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
	   *  - extend type Name ImplementsInterfaces? Directives[Const]
	   *  - extend type Name ImplementsInterfaces
	   */
	  ;
	
	  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
	    var start = this._lexer.token;
	    this.expectKeyword('extend');
	    this.expectKeyword('type');
	    var name = this.parseName();
	    var interfaces = this.parseImplementsInterfaces();
	    var directives = this.parseDirectives(true);
	    var fields = this.parseFieldsDefinition();
	
	    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
	      throw this.unexpected();
	    }
	
	    return {
	      kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
	      name: name,
	      interfaces: interfaces,
	      directives: directives,
	      fields: fields,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * InterfaceTypeExtension :
	   *   - extend interface Name Directives[Const]? FieldsDefinition
	   *   - extend interface Name Directives[Const]
	   */
	  ;
	
	  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
	    var start = this._lexer.token;
	    this.expectKeyword('extend');
	    this.expectKeyword('interface');
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	    var fields = this.parseFieldsDefinition();
	
	    if (directives.length === 0 && fields.length === 0) {
	      throw this.unexpected();
	    }
	
	    return {
	      kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
	      name: name,
	      directives: directives,
	      fields: fields,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * UnionTypeExtension :
	   *   - extend union Name Directives[Const]? UnionMemberTypes
	   *   - extend union Name Directives[Const]
	   */
	  ;
	
	  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
	    var start = this._lexer.token;
	    this.expectKeyword('extend');
	    this.expectKeyword('union');
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	    var types = this.parseUnionMemberTypes();
	
	    if (directives.length === 0 && types.length === 0) {
	      throw this.unexpected();
	    }
	
	    return {
	      kind: _kinds.Kind.UNION_TYPE_EXTENSION,
	      name: name,
	      directives: directives,
	      types: types,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * EnumTypeExtension :
	   *   - extend enum Name Directives[Const]? EnumValuesDefinition
	   *   - extend enum Name Directives[Const]
	   */
	  ;
	
	  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
	    var start = this._lexer.token;
	    this.expectKeyword('extend');
	    this.expectKeyword('enum');
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	    var values = this.parseEnumValuesDefinition();
	
	    if (directives.length === 0 && values.length === 0) {
	      throw this.unexpected();
	    }
	
	    return {
	      kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
	      name: name,
	      directives: directives,
	      values: values,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * InputObjectTypeExtension :
	   *   - extend input Name Directives[Const]? InputFieldsDefinition
	   *   - extend input Name Directives[Const]
	   */
	  ;
	
	  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
	    var start = this._lexer.token;
	    this.expectKeyword('extend');
	    this.expectKeyword('input');
	    var name = this.parseName();
	    var directives = this.parseDirectives(true);
	    var fields = this.parseInputFieldsDefinition();
	
	    if (directives.length === 0 && fields.length === 0) {
	      throw this.unexpected();
	    }
	
	    return {
	      kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
	      name: name,
	      directives: directives,
	      fields: fields,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * DirectiveDefinition :
	   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
	   */
	  ;
	
	  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
	    var start = this._lexer.token;
	    var description = this.parseDescription();
	    this.expectKeyword('directive');
	    this.expectToken(_tokenKind.TokenKind.AT);
	    var name = this.parseName();
	    var args = this.parseArgumentDefs();
	    var repeatable = this.expectOptionalKeyword('repeatable');
	    this.expectKeyword('on');
	    var locations = this.parseDirectiveLocations();
	    return {
	      kind: _kinds.Kind.DIRECTIVE_DEFINITION,
	      description: description,
	      name: name,
	      arguments: args,
	      repeatable: repeatable,
	      locations: locations,
	      loc: this.loc(start)
	    };
	  }
	  /**
	   * DirectiveLocations :
	   *   - `|`? DirectiveLocation
	   *   - DirectiveLocations | DirectiveLocation
	   */
	  ;
	
	  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
	    // Optional leading pipe
	    this.expectOptionalToken(_tokenKind.TokenKind.PIPE);
	    var locations = [];
	
	    do {
	      locations.push(this.parseDirectiveLocation());
	    } while (this.expectOptionalToken(_tokenKind.TokenKind.PIPE));
	
	    return locations;
	  }
	  /*
	   * DirectiveLocation :
	   *   - ExecutableDirectiveLocation
	   *   - TypeSystemDirectiveLocation
	   *
	   * ExecutableDirectiveLocation : one of
	   *   `QUERY`
	   *   `MUTATION`
	   *   `SUBSCRIPTION`
	   *   `FIELD`
	   *   `FRAGMENT_DEFINITION`
	   *   `FRAGMENT_SPREAD`
	   *   `INLINE_FRAGMENT`
	   *
	   * TypeSystemDirectiveLocation : one of
	   *   `SCHEMA`
	   *   `SCALAR`
	   *   `OBJECT`
	   *   `FIELD_DEFINITION`
	   *   `ARGUMENT_DEFINITION`
	   *   `INTERFACE`
	   *   `UNION`
	   *   `ENUM`
	   *   `ENUM_VALUE`
	   *   `INPUT_OBJECT`
	   *   `INPUT_FIELD_DEFINITION`
	   */
	  ;
	
	  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
	    var start = this._lexer.token;
	    var name = this.parseName();
	
	    if (_directiveLocation.DirectiveLocation[name.value] !== undefined) {
	      return name;
	    }
	
	    throw this.unexpected(start);
	  } // Core parsing utility functions
	
	  /**
	   * Returns a location object, used to identify the place in
	   * the source that created a given parsed object.
	   */
	  ;
	
	  _proto.loc = function loc(startToken) {
	    if (!this._options.noLocation) {
	      return new Loc(startToken, this._lexer.lastToken, this._lexer.source);
	    }
	  }
	  /**
	   * Determines if the next token is of a given kind
	   */
	  ;
	
	  _proto.peek = function peek(kind) {
	    return this._lexer.token.kind === kind;
	  }
	  /**
	   * If the next token is of the given kind, return that token after advancing
	   * the lexer. Otherwise, do not change the parser state and throw an error.
	   */
	  ;
	
	  _proto.expectToken = function expectToken(kind) {
	    var token = this._lexer.token;
	
	    if (token.kind === kind) {
	      this._lexer.advance();
	
	      return token;
	    }
	
	    throw (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Expected ".concat(kind, ", found ").concat(getTokenDesc(token)));
	  }
	  /**
	   * If the next token is of the given kind, return that token after advancing
	   * the lexer. Otherwise, do not change the parser state and return undefined.
	   */
	  ;
	
	  _proto.expectOptionalToken = function expectOptionalToken(kind) {
	    var token = this._lexer.token;
	
	    if (token.kind === kind) {
	      this._lexer.advance();
	
	      return token;
	    }
	
	    return undefined;
	  }
	  /**
	   * If the next token is a given keyword, advance the lexer.
	   * Otherwise, do not change the parser state and throw an error.
	   */
	  ;
	
	  _proto.expectKeyword = function expectKeyword(value) {
	    var token = this._lexer.token;
	
	    if (token.kind === _tokenKind.TokenKind.NAME && token.value === value) {
	      this._lexer.advance();
	    } else {
	      throw (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token)));
	    }
	  }
	  /**
	   * If the next token is a given keyword, return "true" after advancing
	   * the lexer. Otherwise, do not change the parser state and return "false".
	   */
	  ;
	
	  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
	    var token = this._lexer.token;
	
	    if (token.kind === _tokenKind.TokenKind.NAME && token.value === value) {
	      this._lexer.advance();
	
	      return true;
	    }
	
	    return false;
	  }
	  /**
	   * Helper function for creating an error when an unexpected lexed token
	   * is encountered.
	   */
	  ;
	
	  _proto.unexpected = function unexpected(atToken) {
	    var token = atToken || this._lexer.token;
	    return (0, _syntaxError.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token)));
	  }
	  /**
	   * Returns a possibly empty list of parse nodes, determined by
	   * the parseFn. This list begins with a lex token of openKind
	   * and ends with a lex token of closeKind. Advances the parser
	   * to the next lex token after the closing token.
	   */
	  ;
	
	  _proto.any = function any(openKind, parseFn, closeKind) {
	    this.expectToken(openKind);
	    var nodes = [];
	
	    while (!this.expectOptionalToken(closeKind)) {
	      nodes.push(parseFn.call(this));
	    }
	
	    return nodes;
	  }
	  /**
	   * Returns a list of parse nodes, determined by the parseFn.
	   * It can be empty only if open token is missing otherwise it will always
	   * return non-empty list that begins with a lex token of openKind and ends
	   * with a lex token of closeKind. Advances the parser to the next lex token
	   * after the closing token.
	   */
	  ;
	
	  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
	    if (this.expectOptionalToken(openKind)) {
	      var nodes = [];
	
	      do {
	        nodes.push(parseFn.call(this));
	      } while (!this.expectOptionalToken(closeKind));
	
	      return nodes;
	    }
	
	    return [];
	  }
	  /**
	   * Returns a non-empty list of parse nodes, determined by
	   * the parseFn. This list begins with a lex token of openKind
	   * and ends with a lex token of closeKind. Advances the parser
	   * to the next lex token after the closing token.
	   */
	  ;
	
	  _proto.many = function many(openKind, parseFn, closeKind) {
	    this.expectToken(openKind);
	    var nodes = [];
	
	    do {
	      nodes.push(parseFn.call(this));
	    } while (!this.expectOptionalToken(closeKind));
	
	    return nodes;
	  };
	
	  return Parser;
	}();
	
	function Loc(startToken, endToken, source) {
	  this.start = startToken.start;
	  this.end = endToken.end;
	  this.startToken = startToken;
	  this.endToken = endToken;
	  this.source = source;
	} // Print a simplified form when appearing in JSON/util.inspect.
	
	
	(0, _defineToJSON.default)(Loc, function () {
	  return {
	    start: this.start,
	    end: this.end
	  };
	});
	/**
	 * A helper function to describe a token as a string for debugging
	 */
	
	function getTokenDesc(token) {
	  var value = token.value;
	  return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
	}


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.printLocation = printLocation;
	exports.printSourceLocation = printSourceLocation;
	
	var _location = __webpack_require__(236);
	
	/**
	 * Render a helpful description of the location in the GraphQL Source document.
	 */
	function printLocation(location) {
	  return printSourceLocation(location.source, (0, _location.getLocation)(location.source, location.start));
	}
	/**
	 * Render a helpful description of the location in the GraphQL Source document.
	 */
	
	
	function printSourceLocation(source, sourceLocation) {
	  var firstLineColumnOffset = source.locationOffset.column - 1;
	  var body = whitespace(firstLineColumnOffset) + source.body;
	  var lineIndex = sourceLocation.line - 1;
	  var lineOffset = source.locationOffset.line - 1;
	  var lineNum = sourceLocation.line + lineOffset;
	  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
	  var columnNum = sourceLocation.column + columnOffset;
	  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
	  var lines = body.split(/\r\n|[\n\r]/g);
	  var locationLine = lines[lineIndex]; // Special case for minified documents
	
	  if (locationLine.length > 120) {
	    var sublineIndex = Math.floor(columnNum / 80);
	    var sublineColumnNum = columnNum % 80;
	    var sublines = [];
	
	    for (var i = 0; i < locationLine.length; i += 80) {
	      sublines.push(locationLine.slice(i, i + 80));
	    }
	
	    return locationStr + printPrefixedLines([["".concat(lineNum), sublines[0]]].concat(sublines.slice(1, sublineIndex + 1).map(function (subline) {
	      return ['', subline];
	    }), [[' ', whitespace(sublineColumnNum - 1) + '^'], ['', sublines[sublineIndex + 1]]]));
	  }
	
	  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
	  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
	}
	
	function printPrefixedLines(lines) {
	  var existingLines = lines.filter(function (_ref) {
	    var _ = _ref[0],
	        line = _ref[1];
	    return line !== undefined;
	  });
	  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
	    var prefix = _ref2[0];
	    return prefix.length;
	  }));
	  return existingLines.map(function (_ref3) {
	    var prefix = _ref3[0],
	        line = _ref3[1];
	    return lpad(padLen, prefix) + (line ? ' | ' + line : ' |');
	  }).join('\n');
	}
	
	function whitespace(len) {
	  return Array(len + 1).join(' ');
	}
	
	function lpad(len, str) {
	  return whitespace(len - str.length) + str;
	}


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.print = print;
	
	var _visitor = __webpack_require__(129);
	
	var _blockString = __webpack_require__(235);
	
	/**
	 * Converts an AST into a string, using one set of reasonable
	 * formatting rules.
	 */
	function print(ast) {
	  return (0, _visitor.visit)(ast, {
	    leave: printDocASTReducer
	  });
	} // TODO: provide better type coverage in future
	
	
	var printDocASTReducer = {
	  Name: function Name(node) {
	    return node.value;
	  },
	  Variable: function Variable(node) {
	    return '$' + node.name;
	  },
	  // Document
	  Document: function Document(node) {
	    return join(node.definitions, '\n\n') + '\n';
	  },
	  OperationDefinition: function OperationDefinition(node) {
	    var op = node.operation;
	    var name = node.name;
	    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
	    var directives = join(node.directives, ' ');
	    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
	    // the query short form.
	
	    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
	  },
	  VariableDefinition: function VariableDefinition(_ref) {
	    var variable = _ref.variable,
	        type = _ref.type,
	        defaultValue = _ref.defaultValue,
	        directives = _ref.directives;
	    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
	  },
	  SelectionSet: function SelectionSet(_ref2) {
	    var selections = _ref2.selections;
	    return block(selections);
	  },
	  Field: function Field(_ref3) {
	    var alias = _ref3.alias,
	        name = _ref3.name,
	        args = _ref3.arguments,
	        directives = _ref3.directives,
	        selectionSet = _ref3.selectionSet;
	    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
	  },
	  Argument: function Argument(_ref4) {
	    var name = _ref4.name,
	        value = _ref4.value;
	    return name + ': ' + value;
	  },
	  // Fragments
	  FragmentSpread: function FragmentSpread(_ref5) {
	    var name = _ref5.name,
	        directives = _ref5.directives;
	    return '...' + name + wrap(' ', join(directives, ' '));
	  },
	  InlineFragment: function InlineFragment(_ref6) {
	    var typeCondition = _ref6.typeCondition,
	        directives = _ref6.directives,
	        selectionSet = _ref6.selectionSet;
	    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
	  },
	  FragmentDefinition: function FragmentDefinition(_ref7) {
	    var name = _ref7.name,
	        typeCondition = _ref7.typeCondition,
	        variableDefinitions = _ref7.variableDefinitions,
	        directives = _ref7.directives,
	        selectionSet = _ref7.selectionSet;
	    return (// Note: fragment variable definitions are experimental and may be changed
	      // or removed in the future.
	      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
	    );
	  },
	  // Value
	  IntValue: function IntValue(_ref8) {
	    var value = _ref8.value;
	    return value;
	  },
	  FloatValue: function FloatValue(_ref9) {
	    var value = _ref9.value;
	    return value;
	  },
	  StringValue: function StringValue(_ref10, key) {
	    var value = _ref10.value,
	        isBlockString = _ref10.block;
	    return isBlockString ? (0, _blockString.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
	  },
	  BooleanValue: function BooleanValue(_ref11) {
	    var value = _ref11.value;
	    return value ? 'true' : 'false';
	  },
	  NullValue: function NullValue() {
	    return 'null';
	  },
	  EnumValue: function EnumValue(_ref12) {
	    var value = _ref12.value;
	    return value;
	  },
	  ListValue: function ListValue(_ref13) {
	    var values = _ref13.values;
	    return '[' + join(values, ', ') + ']';
	  },
	  ObjectValue: function ObjectValue(_ref14) {
	    var fields = _ref14.fields;
	    return '{' + join(fields, ', ') + '}';
	  },
	  ObjectField: function ObjectField(_ref15) {
	    var name = _ref15.name,
	        value = _ref15.value;
	    return name + ': ' + value;
	  },
	  // Directive
	  Directive: function Directive(_ref16) {
	    var name = _ref16.name,
	        args = _ref16.arguments;
	    return '@' + name + wrap('(', join(args, ', '), ')');
	  },
	  // Type
	  NamedType: function NamedType(_ref17) {
	    var name = _ref17.name;
	    return name;
	  },
	  ListType: function ListType(_ref18) {
	    var type = _ref18.type;
	    return '[' + type + ']';
	  },
	  NonNullType: function NonNullType(_ref19) {
	    var type = _ref19.type;
	    return type + '!';
	  },
	  // Type System Definitions
	  SchemaDefinition: function SchemaDefinition(_ref20) {
	    var directives = _ref20.directives,
	        operationTypes = _ref20.operationTypes;
	    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
	  },
	  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
	    var operation = _ref21.operation,
	        type = _ref21.type;
	    return operation + ': ' + type;
	  },
	  ScalarTypeDefinition: addDescription(function (_ref22) {
	    var name = _ref22.name,
	        directives = _ref22.directives;
	    return join(['scalar', name, join(directives, ' ')], ' ');
	  }),
	  ObjectTypeDefinition: addDescription(function (_ref23) {
	    var name = _ref23.name,
	        interfaces = _ref23.interfaces,
	        directives = _ref23.directives,
	        fields = _ref23.fields;
	    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
	  }),
	  FieldDefinition: addDescription(function (_ref24) {
	    var name = _ref24.name,
	        args = _ref24.arguments,
	        type = _ref24.type,
	        directives = _ref24.directives;
	    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
	  }),
	  InputValueDefinition: addDescription(function (_ref25) {
	    var name = _ref25.name,
	        type = _ref25.type,
	        defaultValue = _ref25.defaultValue,
	        directives = _ref25.directives;
	    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
	  }),
	  InterfaceTypeDefinition: addDescription(function (_ref26) {
	    var name = _ref26.name,
	        directives = _ref26.directives,
	        fields = _ref26.fields;
	    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
	  }),
	  UnionTypeDefinition: addDescription(function (_ref27) {
	    var name = _ref27.name,
	        directives = _ref27.directives,
	        types = _ref27.types;
	    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
	  }),
	  EnumTypeDefinition: addDescription(function (_ref28) {
	    var name = _ref28.name,
	        directives = _ref28.directives,
	        values = _ref28.values;
	    return join(['enum', name, join(directives, ' '), block(values)], ' ');
	  }),
	  EnumValueDefinition: addDescription(function (_ref29) {
	    var name = _ref29.name,
	        directives = _ref29.directives;
	    return join([name, join(directives, ' ')], ' ');
	  }),
	  InputObjectTypeDefinition: addDescription(function (_ref30) {
	    var name = _ref30.name,
	        directives = _ref30.directives,
	        fields = _ref30.fields;
	    return join(['input', name, join(directives, ' '), block(fields)], ' ');
	  }),
	  DirectiveDefinition: addDescription(function (_ref31) {
	    var name = _ref31.name,
	        args = _ref31.arguments,
	        repeatable = _ref31.repeatable,
	        locations = _ref31.locations;
	    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
	  }),
	  SchemaExtension: function SchemaExtension(_ref32) {
	    var directives = _ref32.directives,
	        operationTypes = _ref32.operationTypes;
	    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
	  },
	  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
	    var name = _ref33.name,
	        directives = _ref33.directives;
	    return join(['extend scalar', name, join(directives, ' ')], ' ');
	  },
	  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
	    var name = _ref34.name,
	        interfaces = _ref34.interfaces,
	        directives = _ref34.directives,
	        fields = _ref34.fields;
	    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
	  },
	  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
	    var name = _ref35.name,
	        directives = _ref35.directives,
	        fields = _ref35.fields;
	    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
	  },
	  UnionTypeExtension: function UnionTypeExtension(_ref36) {
	    var name = _ref36.name,
	        directives = _ref36.directives,
	        types = _ref36.types;
	    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
	  },
	  EnumTypeExtension: function EnumTypeExtension(_ref37) {
	    var name = _ref37.name,
	        directives = _ref37.directives,
	        values = _ref37.values;
	    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
	  },
	  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
	    var name = _ref38.name,
	        directives = _ref38.directives,
	        fields = _ref38.fields;
	    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
	  }
	};
	
	function addDescription(cb) {
	  return function (node) {
	    return join([node.description, cb(node)], '\n');
	  };
	}
	/**
	 * Given maybeArray, print an empty string if it is null or empty, otherwise
	 * print all items together separated by separator if provided
	 */
	
	
	function join(maybeArray, separator) {
	  return maybeArray ? maybeArray.filter(function (x) {
	    return x;
	  }).join(separator || '') : '';
	}
	/**
	 * Given array, print each item on its own line, wrapped in an
	 * indented "{ }" block.
	 */
	
	
	function block(array) {
	  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
	}
	/**
	 * If maybeString is not null or empty, then wrap with start and end, otherwise
	 * print an empty string.
	 */
	
	
	function wrap(start, maybeString, end) {
	  return maybeString ? start + maybeString + (end || '') : '';
	}
	
	function indent(maybeString) {
	  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
	}
	
	function isMultiline(string) {
	  return string.indexOf('\n') !== -1;
	}
	
	function hasMultilineItems(maybeArray) {
	  return maybeArray && maybeArray.some(isMultiline);
	}


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Source = void 0;
	
	var _devAssert = _interopRequireDefault(__webpack_require__(232));
	
	var _defineToStringTag = _interopRequireDefault(__webpack_require__(565));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A representation of source input to GraphQL.
	 * `name` and `locationOffset` are optional. They are useful for clients who
	 * store GraphQL documents in source files; for example, if the GraphQL input
	 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
	 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
	 * line and column in locationOffset are 1-indexed
	 */
	var Source = function Source(body, name, locationOffset) {
	  this.body = body;
	  this.name = name || 'GraphQL request';
	  this.locationOffset = locationOffset || {
	    line: 1,
	    column: 1
	  };
	  this.locationOffset.line > 0 || (0, _devAssert.default)(0, 'line in locationOffset is 1-indexed and must be positive');
	  this.locationOffset.column > 0 || (0, _devAssert.default)(0, 'column in locationOffset is 1-indexed and must be positive');
	}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported
	
	
	exports.Source = Source;
	(0, _defineToStringTag.default)(Source);


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(30)
	var upperCase = __webpack_require__(40)
	
	/**
	 * Header case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '-').replace(/^.|-./g, function (m) {
	    return upperCase(m, locale)
	  })
	}


/***/ }),
/* 575 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(130);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(56);
	
	var _DOMUtils = __webpack_require__(94);
	
	var _DOMStateStorage = __webpack_require__(238);
	
	var _PathUtils = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(130);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(56);
	
	var _PathUtils = __webpack_require__(37);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(131);
	
	var _BrowserProtocol = __webpack_require__(130);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(577);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(94);
	
	var _createHistory = __webpack_require__(132);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(131);
	
	var _DOMUtils = __webpack_require__(94);
	
	var _HashProtocol = __webpack_require__(576);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(132);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(22);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(56);
	
	var _PathUtils = __webpack_require__(37);
	
	var _createHistory = __webpack_require__(132);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(93);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _utils = __webpack_require__(70);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(57);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(95);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	function remove(arr, what) {
	  var found = arr.indexOf(what);
	
	  while (found !== -1) {
	    arr.splice(found, 1);
	    found = arr.indexOf(what);
	  }
	}
	
	var Connector = function (_EventEmitter) {
	  _inherits(Connector, _EventEmitter);
	
	  function Connector(backend, store, services) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    _classCallCheck(this, Connector);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.backend = backend;
	    _this.store = store;
	    _this.languageUtils = services.languageUtils;
	    _this.options = options;
	    _this.logger = _logger2.default.create('backendConnector');
	
	    _this.state = {};
	    _this.queue = [];
	
	    if (_this.backend && _this.backend.init) {
	      _this.backend.init(services, options.backend, options);
	    }
	    return _this;
	  }
	
	  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, options, callback) {
	    var _this2 = this;
	
	    // find what needs to be loaded
	    var toLoad = [];
	    var pending = [];
	    var toLoadLanguages = [];
	    var toLoadNamespaces = [];
	
	    languages.forEach(function (lng) {
	      var hasAllNamespaces = true;
	
	      namespaces.forEach(function (ns) {
	        var name = lng + '|' + ns;
	
	        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
	          _this2.state[name] = 2; // loaded
	        } else if (_this2.state[name] < 0) {
	          // nothing to do for err
	        } else if (_this2.state[name] === 1) {
	          if (pending.indexOf(name) < 0) pending.push(name);
	        } else {
	          _this2.state[name] = 1; // pending
	
	          hasAllNamespaces = false;
	
	          if (pending.indexOf(name) < 0) pending.push(name);
	          if (toLoad.indexOf(name) < 0) toLoad.push(name);
	          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
	        }
	      });
	
	      if (!hasAllNamespaces) toLoadLanguages.push(lng);
	    });
	
	    if (toLoad.length || pending.length) {
	      this.queue.push({
	        pending: pending,
	        loaded: {},
	        errors: [],
	        callback: callback
	      });
	    }
	
	    return {
	      toLoad: toLoad,
	      pending: pending,
	      toLoadLanguages: toLoadLanguages,
	      toLoadNamespaces: toLoadNamespaces
	    };
	  };
	
	  Connector.prototype.loaded = function loaded(name, err, data) {
	    var _name$split = name.split('|'),
	        _name$split2 = _slicedToArray(_name$split, 2),
	        lng = _name$split2[0],
	        ns = _name$split2[1];
	
	    if (err) this.emit('failedLoading', lng, ns, err);
	
	    if (data) {
	      this.store.addResourceBundle(lng, ns, data);
	    }
	
	    // set loaded
	    this.state[name] = err ? -1 : 2;
	
	    // consolidated loading done in this run - only emit once for a loaded namespace
	    var loaded = {};
	
	    // callback if ready
	    this.queue.forEach(function (q) {
	      utils.pushPath(q.loaded, [lng], ns);
	      remove(q.pending, name);
	
	      if (err) q.errors.push(err);
	
	      if (q.pending.length === 0 && !q.done) {
	        // only do once per loaded -> this.emit('loaded', q.loaded);
	        Object.keys(q.loaded).forEach(function (l) {
	          if (!loaded[l]) loaded[l] = [];
	          if (q.loaded[l].length) {
	            q.loaded[l].forEach(function (ns) {
	              if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
	            });
	          }
	        });
	
	        /* eslint no-param-reassign: 0 */
	        q.done = true;
	        if (q.errors.length) {
	          q.callback(q.errors);
	        } else {
	          q.callback();
	        }
	      }
	    });
	
	    // emit consolidated loaded event
	    this.emit('loaded', loaded);
	
	    // remove done load requests
	    this.queue = this.queue.filter(function (q) {
	      return !q.done;
	    });
	  };
	
	  Connector.prototype.read = function read(lng, ns, fcName) {
	    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	
	    var _this3 = this;
	
	    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
	    var callback = arguments[5];
	
	    if (!lng.length) return callback(null, {}); // noting to load
	
	    return this.backend[fcName](lng, ns, function (err, data) {
	      if (err && data /* = retryFlag */ && tried < 5) {
	        setTimeout(function () {
	          _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
	        }, wait);
	        return;
	      }
	      callback(err, data);
	    });
	  };
	
	  /* eslint consistent-return: 0 */
	
	
	  Connector.prototype.prepareLoading = function prepareLoading(languages, namespaces) {
	    var _this4 = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var callback = arguments[3];
	
	    if (!this.backend) {
	      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
	      return callback && callback();
	    }
	
	    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    var toLoad = this.queueLoad(languages, namespaces, options, callback);
	    if (!toLoad.toLoad.length) {
	      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
	      return null; // pendings will trigger callback
	    }
	
	    toLoad.toLoad.forEach(function (name) {
	      _this4.loadOne(name);
	    });
	  };
	
	  Connector.prototype.load = function load(languages, namespaces, callback) {
	    this.prepareLoading(languages, namespaces, {}, callback);
	  };
	
	  Connector.prototype.reload = function reload(languages, namespaces, callback) {
	    this.prepareLoading(languages, namespaces, { reload: true }, callback);
	  };
	
	  Connector.prototype.loadOne = function loadOne(name) {
	    var _this5 = this;
	
	    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    var _name$split3 = name.split('|'),
	        _name$split4 = _slicedToArray(_name$split3, 2),
	        lng = _name$split4[0],
	        ns = _name$split4[1];
	
	    this.read(lng, ns, 'read', null, null, function (err, data) {
	      if (err) _this5.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
	      if (!err && data) _this5.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);
	
	      _this5.loaded(name, err, data);
	    });
	  };
	
	  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
	    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	
	    if (this.backend && this.backend.create) {
	      this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, _extends({}, options, {
	        isUpdate: isUpdate
	      }));
	    }
	
	    // write to store to avoid resending
	    if (!languages || !languages[0]) return;
	    this.store.addResource(languages[0], namespace, key, fallbackValue);
	  };
	
	  return Connector;
	}(_EventEmitter3.default);
	
	exports.default = Connector;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _utils = __webpack_require__(70);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _logger = __webpack_require__(57);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Interpolator = function () {
	  function Interpolator() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Interpolator);
	
	    this.logger = _logger2.default.create('interpolator');
	
	    this.init(options, true);
	  }
	
	  /* eslint no-param-reassign: 0 */
	
	
	  Interpolator.prototype.init = function init() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var reset = arguments[1];
	
	    if (reset) {
	      this.options = options;
	      this.format = options.interpolation && options.interpolation.format || function (value) {
	        return value;
	      };
	    }
	    if (!options.interpolation) options.interpolation = { escapeValue: true };
	
	    var iOpts = options.interpolation;
	
	    this.escape = iOpts.escape !== undefined ? iOpts.escape : utils.escape;
	    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
	    this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
	
	    this.prefix = iOpts.prefix ? utils.regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
	    this.suffix = iOpts.suffix ? utils.regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
	
	    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
	
	    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
	    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
	
	    this.nestingPrefix = iOpts.nestingPrefix ? utils.regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || utils.regexEscape('$t(');
	    this.nestingSuffix = iOpts.nestingSuffix ? utils.regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || utils.regexEscape(')');
	
	    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
	
	    // the regexp
	    this.resetRegExp();
	  };
	
	  Interpolator.prototype.reset = function reset() {
	    if (this.options) this.init(this.options);
	  };
	
	  Interpolator.prototype.resetRegExp = function resetRegExp() {
	    // the regexp
	    var regexpStr = this.prefix + '(.+?)' + this.suffix;
	    this.regexp = new RegExp(regexpStr, 'g');
	
	    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
	    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
	
	    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
	    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
	  };
	
	  Interpolator.prototype.interpolate = function interpolate(str, data, lng, options) {
	    var _this = this;
	
	    var match = void 0;
	    var value = void 0;
	    var replaces = void 0;
	
	    function regexSafe(val) {
	      return val.replace(/\$/g, '$$$$');
	    }
	
	    var handleFormat = function handleFormat(key) {
	      if (key.indexOf(_this.formatSeparator) < 0) return utils.getPath(data, key);
	
	      var p = key.split(_this.formatSeparator);
	      var k = p.shift().trim();
	      var f = p.join(_this.formatSeparator).trim();
	
	      return _this.format(utils.getPath(data, k), f, lng);
	    };
	
	    this.resetRegExp();
	
	    var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
	
	    replaces = 0;
	    // unescape if has unescapePrefix/Suffix
	    /* eslint no-cond-assign: 0 */
	    while (match = this.regexpUnescape.exec(str)) {
	      value = handleFormat(match[1].trim());
	      str = str.replace(match[0], value);
	      this.regexpUnescape.lastIndex = 0;
	      replaces++;
	      if (replaces >= this.maxReplaces) {
	        break;
	      }
	    }
	
	    replaces = 0;
	    // regular escape on demand
	    while (match = this.regexp.exec(str)) {
	      value = handleFormat(match[1].trim());
	      if (value === undefined) {
	        if (typeof missingInterpolationHandler === 'function') {
	          var temp = missingInterpolationHandler(str, match, options);
	          value = typeof temp === 'string' ? temp : '';
	        } else {
	          this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
	          value = '';
	        }
	      } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
	        value = utils.makeString(value);
	      }
	      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
	      str = str.replace(match[0], value);
	      this.regexp.lastIndex = 0;
	      replaces++;
	      if (replaces >= this.maxReplaces) {
	        break;
	      }
	    }
	    return str;
	  };
	
	  Interpolator.prototype.nest = function nest(str, fc) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var match = void 0;
	    var value = void 0;
	
	    var clonedOptions = _extends({}, options);
	    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup
	
	    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
	    function handleHasOptions(key, inheritedOptions) {
	      if (key.indexOf(',') < 0) return key;
	
	      var p = key.split(',');
	      key = p.shift();
	      var optionsString = p.join(',');
	      optionsString = this.interpolate(optionsString, clonedOptions);
	      optionsString = optionsString.replace(/'/g, '"');
	
	      try {
	        clonedOptions = JSON.parse(optionsString);
	
	        if (inheritedOptions) clonedOptions = _extends({}, inheritedOptions, clonedOptions);
	      } catch (e) {
	        this.logger.error('failed parsing options string in nesting for key ' + key, e);
	      }
	
	      return key;
	    }
	
	    // regular escape on demand
	    while (match = this.nestingRegexp.exec(str)) {
	      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
	
	      // is only the nesting key (key1 = '$(key2)') return the value without stringify
	      if (value && match[0] === str && typeof value !== 'string') return value;
	
	      // no string to include or empty
	      if (typeof value !== 'string') value = utils.makeString(value);
	      if (!value) {
	        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
	        value = '';
	      }
	      // Nested keys should not be escaped by default #854
	      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
	      str = str.replace(match[0], value);
	      this.regexp.lastIndex = 0;
	    }
	    return str;
	  };
	
	  return Interpolator;
	}();
	
	exports.default = Interpolator;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _logger = __webpack_require__(57);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function capitalize(string) {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	var LanguageUtil = function () {
	  function LanguageUtil(options) {
	    _classCallCheck(this, LanguageUtil);
	
	    this.options = options;
	
	    this.whitelist = this.options.whitelist || false;
	    this.logger = _logger2.default.create('languageUtils');
	  }
	
	  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
	    if (!code || code.indexOf('-') < 0) return null;
	
	    var p = code.split('-');
	    if (p.length === 2) return null;
	    p.pop();
	    return this.formatLanguageCode(p.join('-'));
	  };
	
	  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
	    if (!code || code.indexOf('-') < 0) return code;
	
	    var p = code.split('-');
	    return this.formatLanguageCode(p[0]);
	  };
	
	  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
	    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
	    if (typeof code === 'string' && code.indexOf('-') > -1) {
	      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
	      var p = code.split('-');
	
	      if (this.options.lowerCaseLng) {
	        p = p.map(function (part) {
	          return part.toLowerCase();
	        });
	      } else if (p.length === 2) {
	        p[0] = p[0].toLowerCase();
	        p[1] = p[1].toUpperCase();
	
	        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	      } else if (p.length === 3) {
	        p[0] = p[0].toLowerCase();
	
	        // if lenght 2 guess it's a country
	        if (p[1].length === 2) p[1] = p[1].toUpperCase();
	        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
	
	        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
	        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
	      }
	
	      return p.join('-');
	    }
	
	    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
	  };
	
	  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
	    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
	      code = this.getLanguagePartFromCode(code);
	    }
	    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
	  };
	
	  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
	    if (!fallbacks) return [];
	    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
	    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
	
	    if (!code) return fallbacks.default || [];
	
	    // asume we have an object defining fallbacks
	    var found = fallbacks[code];
	    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
	    if (!found) found = fallbacks[this.formatLanguageCode(code)];
	    if (!found) found = fallbacks.default;
	
	    return found || [];
	  };
	
	  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
	    var _this = this;
	
	    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
	
	    var codes = [];
	    var addCode = function addCode(c) {
	      if (!c) return;
	      if (_this.isWhitelisted(c)) {
	        codes.push(c);
	      } else {
	        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
	      }
	    };
	
	    if (typeof code === 'string' && code.indexOf('-') > -1) {
	      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
	      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
	      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
	    } else if (typeof code === 'string') {
	      addCode(this.formatLanguageCode(code));
	    }
	
	    fallbackCodes.forEach(function (fc) {
	      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
	    });
	
	    return codes;
	  };
	
	  return LanguageUtil;
	}();
	
	exports.default = LanguageUtil;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _logger = __webpack_require__(57);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
	/* eslint-disable */
	var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }, { lngs: ['he'], nr: [1, 2, 20, 21], fc: 22 }];
	
	var _rulesPluralsTypes = {
	  1: function _(n) {
	    return Number(n > 1);
	  },
	  2: function _(n) {
	    return Number(n != 1);
	  },
	  3: function _(n) {
	    return 0;
	  },
	  4: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  5: function _(n) {
	    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
	  },
	  6: function _(n) {
	    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
	  },
	  7: function _(n) {
	    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  8: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
	  },
	  9: function _(n) {
	    return Number(n >= 2);
	  },
	  10: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
	  },
	  11: function _(n) {
	    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
	  },
	  12: function _(n) {
	    return Number(n % 10 != 1 || n % 100 == 11);
	  },
	  13: function _(n) {
	    return Number(n !== 0);
	  },
	  14: function _(n) {
	    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
	  },
	  15: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
	  },
	  16: function _(n) {
	    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
	  },
	  17: function _(n) {
	    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
	  },
	  18: function _(n) {
	    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
	  },
	  19: function _(n) {
	    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
	  },
	  20: function _(n) {
	    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
	  },
	  21: function _(n) {
	    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
	  },
	  22: function _(n) {
	    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
	  }
	};
	/* eslint-enable */
	
	function createRules() {
	  var rules = {};
	  sets.forEach(function (set) {
	    set.lngs.forEach(function (l) {
	      rules[l] = {
	        numbers: set.nr,
	        plurals: _rulesPluralsTypes[set.fc]
	      };
	    });
	  });
	  return rules;
	}
	
	var PluralResolver = function () {
	  function PluralResolver(languageUtils) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, PluralResolver);
	
	    this.languageUtils = languageUtils;
	    this.options = options;
	
	    this.logger = _logger2.default.create('pluralResolver');
	
	    this.rules = createRules();
	  }
	
	  PluralResolver.prototype.addRule = function addRule(lng, obj) {
	    this.rules[lng] = obj;
	  };
	
	  PluralResolver.prototype.getRule = function getRule(code) {
	    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
	  };
	
	  PluralResolver.prototype.needsPlural = function needsPlural(code) {
	    var rule = this.getRule(code);
	
	    return rule && rule.numbers.length > 1;
	  };
	
	  PluralResolver.prototype.getPluralFormsOfKey = function getPluralFormsOfKey(code, key) {
	    var _this = this;
	
	    var ret = [];
	
	    var rule = this.getRule(code);
	
	    if (!rule) return ret;
	
	    rule.numbers.forEach(function (n) {
	      var suffix = _this.getSuffix(code, n);
	      ret.push('' + key + suffix);
	    });
	
	    return ret;
	  };
	
	  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
	    var _this2 = this;
	
	    var rule = this.getRule(code);
	
	    if (rule) {
	      // if (rule.numbers.length === 1) return ''; // only singular
	
	      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
	      var suffix = rule.numbers[idx];
	
	      // special treatment for lngs only having singular and plural
	      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
	        if (suffix === 2) {
	          suffix = 'plural';
	        } else if (suffix === 1) {
	          suffix = '';
	        }
	      }
	
	      var returnSuffix = function returnSuffix() {
	        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
	      };
	
	      // COMPATIBILITY JSON
	      // v1
	      if (this.options.compatibilityJSON === 'v1') {
	        if (suffix === 1) return '';
	        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
	        return returnSuffix();
	      } else if ( /* v2 */this.options.compatibilityJSON === 'v2') {
	        return returnSuffix();
	      } else if ( /* v3 - gettext index */this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
	        return returnSuffix();
	      }
	      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
	    }
	
	    this.logger.warn('no plural rule found for: ' + code);
	    return '';
	  };
	
	  return PluralResolver;
	}();
	
	exports.default = PluralResolver;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _EventEmitter2 = __webpack_require__(95);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _utils = __webpack_require__(70);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var ResourceStore = function (_EventEmitter) {
	  _inherits(ResourceStore, _EventEmitter);
	
	  function ResourceStore(data) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };
	
	    _classCallCheck(this, ResourceStore);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.data = data || {};
	    _this.options = options;
	    if (_this.options.keySeparator === undefined) {
	      _this.options.keySeparator = '.';
	    }
	    return _this;
	  }
	
	  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
	    if (this.options.ns.indexOf(ns) < 0) {
	      this.options.ns.push(ns);
	    }
	  };
	
	  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
	    var index = this.options.ns.indexOf(ns);
	    if (index > -1) {
	      this.options.ns.splice(index, 1);
	    }
	  };
	
	  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	
	    var path = [lng, ns];
	    if (key && typeof key !== 'string') path = path.concat(key);
	    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	    }
	
	    return utils.getPath(this.data, path);
	  };
	
	  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
	    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };
	
	    var keySeparator = this.options.keySeparator;
	    if (keySeparator === undefined) keySeparator = '.';
	
	    var path = [lng, ns];
	    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
	
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	      value = ns;
	      ns = path[1];
	    }
	
	    this.addNamespaces(ns);
	
	    utils.setPath(this.data, path, value);
	
	    if (!options.silent) this.emit('added', lng, ns, key, value);
	  };
	
	  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { silent: false };
	
	    /* eslint no-restricted-syntax: 0 */
	    for (var m in resources) {
	      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
	    }
	    if (!options.silent) this.emit('added', lng, ns, resources);
	  };
	
	  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
	    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : { silent: false };
	
	    var path = [lng, ns];
	    if (lng.indexOf('.') > -1) {
	      path = lng.split('.');
	      deep = resources;
	      resources = ns;
	      ns = path[1];
	    }
	
	    this.addNamespaces(ns);
	
	    var pack = utils.getPath(this.data, path) || {};
	
	    if (deep) {
	      utils.deepExtend(pack, resources, overwrite);
	    } else {
	      pack = _extends({}, pack, resources);
	    }
	
	    utils.setPath(this.data, path, pack);
	
	    if (!options.silent) this.emit('added', lng, ns, resources);
	  };
	
	  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
	    if (this.hasResourceBundle(lng, ns)) {
	      delete this.data[lng][ns];
	    }
	    this.removeNamespaces(ns);
	
	    this.emit('removed', lng, ns);
	  };
	
	  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
	    return this.getResource(lng, ns) !== undefined;
	  };
	
	  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
	    if (!ns) ns = this.options.defaultNS;
	
	    // COMPATIBILITY: remove extend in v2.1.0
	    if (this.options.compatibilityAPI === 'v1') return _extends({}, this.getResource(lng, ns));
	
	    return this.getResource(lng, ns);
	  };
	
	  ResourceStore.prototype.getDataByLanguage = function getDataByLanguage(lng) {
	    return this.data[lng];
	  };
	
	  ResourceStore.prototype.toJSON = function toJSON() {
	    return this.data;
	  };
	
	  return ResourceStore;
	}(_EventEmitter3.default);
	
	exports.default = ResourceStore;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _logger = __webpack_require__(57);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(95);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _postProcessor = __webpack_require__(242);
	
	var _postProcessor2 = _interopRequireDefault(_postProcessor);
	
	var _utils = __webpack_require__(70);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var Translator = function (_EventEmitter) {
	  _inherits(Translator, _EventEmitter);
	
	  function Translator(services) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, Translator);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    utils.copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, _this);
	
	    _this.options = options;
	    if (_this.options.keySeparator === undefined) {
	      _this.options.keySeparator = '.';
	    }
	
	    _this.logger = _logger2.default.create('translator');
	    return _this;
	  }
	
	  Translator.prototype.changeLanguage = function changeLanguage(lng) {
	    if (lng) this.language = lng;
	  };
	
	  Translator.prototype.exists = function exists(key) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };
	
	    var resolved = this.resolve(key, options);
	    return resolved && resolved.res !== undefined;
	  };
	
	  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
	    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
	    if (nsSeparator === undefined) nsSeparator = ':';
	
	    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	
	    var namespaces = options.ns || this.options.defaultNS;
	    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
	      var parts = key.split(nsSeparator);
	      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
	      key = parts.join(keySeparator);
	    }
	    if (typeof namespaces === 'string') namespaces = [namespaces];
	
	    return {
	      key: key,
	      namespaces: namespaces
	    };
	  };
	
	  Translator.prototype.translate = function translate(keys, options) {
	    var _this2 = this;
	
	    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' && this.options.overloadTranslationOptionHandler) {
	      /* eslint prefer-rest-params: 0 */
	      options = this.options.overloadTranslationOptionHandler(arguments);
	    }
	    if (!options) options = {};
	
	    // non valid keys handling
	    if (keys === undefined || keys === null) return '';
	    if (!Array.isArray(keys)) keys = [String(keys)];
	
	    // separators
	    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
	
	    // get namespace(s)
	
	    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
	        key = _extractFromKey.key,
	        namespaces = _extractFromKey.namespaces;
	
	    var namespace = namespaces[namespaces.length - 1];
	
	    // return key on CIMode
	    var lng = options.lng || this.language;
	    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
	    if (lng && lng.toLowerCase() === 'cimode') {
	      if (appendNamespaceToCIMode) {
	        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
	        return namespace + nsSeparator + key;
	      }
	
	      return key;
	    }
	
	    // resolve from store
	    var resolved = this.resolve(keys, options);
	    var res = resolved && resolved.res;
	    var resUsedKey = resolved && resolved.usedKey || key;
	    var resExactUsedKey = resolved && resolved.exactUsedKey || key;
	
	    var resType = Object.prototype.toString.apply(res);
	    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
	    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
	
	    // object
	    var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
	    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
	    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
	      if (!options.returnObjects && !this.options.returnObjects) {
	        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
	        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
	      }
	
	      // if we got a separator we loop over children - else we just return object as is
	      // as having it set to false means no hierarchy so no lookup for nested values
	      if (keySeparator) {
	        var resTypeIsArray = resType === '[object Array]';
	        var copy = resTypeIsArray ? [] : {}; // apply child translation on a copy
	
	        /* eslint no-restricted-syntax: 0 */
	        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
	        for (var m in res) {
	          if (Object.prototype.hasOwnProperty.call(res, m)) {
	            var deepKey = '' + newKeyToUse + keySeparator + m;
	            copy[m] = this.translate(deepKey, _extends({}, options, { joinArrays: false, ns: namespaces }));
	            if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
	          }
	        }
	        res = copy;
	      }
	    } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
	      // array special treatment
	      res = res.join(joinArrays);
	      if (res) res = this.extendTranslation(res, keys, options);
	    } else {
	      // string, empty or null
	      var usedDefault = false;
	      var usedKey = false;
	
	      // fallback value
	      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
	        usedDefault = true;
	
	        if (options.count !== undefined) {
	          var suffix = this.pluralResolver.getSuffix(lng, options.count);
	          res = options['defaultValue' + suffix];
	        }
	        if (!res) res = options.defaultValue;
	      }
	      if (!this.isValidLookup(res)) {
	        usedKey = true;
	        res = key;
	      }
	
	      // save missing
	      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
	      if (usedKey || usedDefault || updateMissing) {
	        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);
	
	        var lngs = [];
	        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
	        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
	          for (var i = 0; i < fallbackLngs.length; i++) {
	            lngs.push(fallbackLngs[i]);
	          }
	        } else if (this.options.saveMissingTo === 'all') {
	          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
	        } else {
	          lngs.push(options.lng || this.language);
	        }
	
	        var send = function send(l, k) {
	          if (_this2.options.missingKeyHandler) {
	            _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
	          } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
	            _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
	          }
	          _this2.emit('missingKey', l, namespace, k, res);
	        };
	
	        if (this.options.saveMissing) {
	          var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	          if (this.options.saveMissingPlurals && needsPluralHandling) {
	            lngs.forEach(function (l) {
	              var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);
	
	              plurals.forEach(function (p) {
	                return send([l], p);
	              });
	            });
	          } else {
	            send(lngs, key);
	          }
	        }
	      }
	
	      // extend
	      res = this.extendTranslation(res, keys, options, resolved);
	
	      // append namespace if still key
	      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;
	
	      // parseMissingKeyHandler
	      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
	    }
	
	    // return
	    return res;
	  };
	
	  Translator.prototype.extendTranslation = function extendTranslation(res, key, options, resolved) {
	    var _this3 = this;
	
	    if (this.i18nFormat && this.i18nFormat.parse) {
	      res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, { resolved: resolved });
	    } else if (!options.skipInterpolation) {
	      // i18next.parsing
	      if (options.interpolation) this.interpolator.init(_extends({}, options, { interpolation: _extends({}, this.options.interpolation, options.interpolation) }));
	
	      // interpolate
	      var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
	      if (this.options.interpolation.defaultVariables) data = _extends({}, this.options.interpolation.defaultVariables, data);
	      res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
	
	      // nesting
	      if (options.nest !== false) res = this.interpolator.nest(res, function () {
	        return _this3.translate.apply(_this3, arguments);
	      }, options);
	
	      if (options.interpolation) this.interpolator.reset();
	    }
	
	    // post process
	    var postProcess = options.postProcess || this.options.postProcess;
	    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
	
	    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
	      res = _postProcessor2.default.handle(postProcessorNames, res, key, options, this);
	    }
	
	    return res;
	  };
	
	  Translator.prototype.resolve = function resolve(keys) {
	    var _this4 = this;
	
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var found = void 0;
	    var usedKey = void 0; // plain key
	    var exactUsedKey = void 0; // key with context / plural
	    var usedLng = void 0;
	    var usedNS = void 0;
	
	    if (typeof keys === 'string') keys = [keys];
	
	    // forEach possible key
	    keys.forEach(function (k) {
	      if (_this4.isValidLookup(found)) return;
	      var extracted = _this4.extractFromKey(k, options);
	      var key = extracted.key;
	      usedKey = key;
	      var namespaces = extracted.namespaces;
	      if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
	
	      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
	      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
	
	      var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
	
	      namespaces.forEach(function (ns) {
	        if (_this4.isValidLookup(found)) return;
	        usedNS = ns;
	
	        codes.forEach(function (code) {
	          if (_this4.isValidLookup(found)) return;
	          usedLng = code;
	
	          var finalKey = key;
	          var finalKeys = [finalKey];
	
	          if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
	            _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
	          } else {
	            var pluralSuffix = void 0;
	            if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
	
	            // fallback for plural if context not found
	            if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
	
	            // get key for context if needed
	            if (needsContextHandling) finalKeys.push(finalKey += '' + _this4.options.contextSeparator + options.context);
	
	            // get key for plural if needed
	            if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
	          }
	
	          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
	          var possibleKey = void 0;
	          /* eslint no-cond-assign: 0 */
	          while (possibleKey = finalKeys.pop()) {
	            if (!_this4.isValidLookup(found)) {
	              exactUsedKey = possibleKey;
	              found = _this4.getResource(code, ns, possibleKey, options);
	            }
	          }
	        });
	      });
	    });
	
	    return { res: found, usedKey: usedKey, exactUsedKey: exactUsedKey, usedLng: usedLng, usedNS: usedNS };
	  };
	
	  Translator.prototype.isValidLookup = function isValidLookup(res) {
	    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
	  };
	
	  Translator.prototype.getResource = function getResource(code, ns, key) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
	    return this.resourceStore.getResource(code, ns, key, options);
	  };
	
	  return Translator;
	}(_EventEmitter3.default);
	
	exports.default = Translator;

/***/ }),
/* 587 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.transformOptions = transformOptions;
	function get() {
	  return {
	    debug: false,
	    initImmediate: true,
	
	    ns: ['translation'],
	    defaultNS: ['translation'],
	    fallbackLng: ['dev'],
	    fallbackNS: false, // string or array of namespaces
	
	    whitelist: false, // array with whitelisted languages
	    nonExplicitWhitelist: false,
	    load: 'all', // | currentOnly | languageOnly
	    preload: false, // array with preload languages
	
	    simplifyPluralSuffix: true,
	    keySeparator: '.',
	    nsSeparator: ':',
	    pluralSeparator: '_',
	    contextSeparator: '_',
	
	    partialBundledLanguages: false, // allow bundling certain languages that are not remotely fetched
	    saveMissing: false, // enable to send missing values
	    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
	    saveMissingTo: 'fallback', // 'current' || 'all'
	    saveMissingPlurals: true, // will save all forms not only singular key
	    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
	    missingInterpolationHandler: false, // function(str, match)
	
	    postProcess: false, // string or array of postProcessor names
	    returnNull: true, // allows null value as valid translation
	    returnEmptyString: true, // allows empty string value as valid translation
	    returnObjects: false,
	    joinArrays: false, // or string to join array
	    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
	    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
	    appendNamespaceToMissingKey: false,
	    appendNamespaceToCIMode: false,
	    overloadTranslationOptionHandler: function handle(args) {
	      var ret = {};
	      if (_typeof(args[1]) === 'object') ret = args[1];
	      if (typeof args[1] === 'string') ret.defaultValue = args[1];
	      if (typeof args[2] === 'string') ret.tDescription = args[2];
	      if (_typeof(args[2]) === 'object' || _typeof(args[3]) === 'object') {
	        var options = args[3] || args[2];
	        Object.keys(options).forEach(function (key) {
	          ret[key] = options[key];
	        });
	      }
	      return ret;
	    },
	    interpolation: {
	      escapeValue: true,
	      format: function format(value, _format, lng) {
	        return value;
	      },
	      prefix: '{{',
	      suffix: '}}',
	      formatSeparator: ',',
	      // prefixEscaped: '{{',
	      // suffixEscaped: '}}',
	      // unescapeSuffix: '',
	      unescapePrefix: '-',
	
	      nestingPrefix: '$t(',
	      nestingSuffix: ')',
	      // nestingPrefixEscaped: '$t(',
	      // nestingSuffixEscaped: ')',
	      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
	      maxReplaces: 1000 // max replaces to prevent endless loop
	    }
	  };
	}
	
	/* eslint no-param-reassign: 0 */
	exports.get = get;
	function transformOptions(options) {
	  // create namespace object if namespace is passed in as string
	  if (typeof options.ns === 'string') options.ns = [options.ns];
	  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
	  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
	
	  // extend whitelist with cimode
	  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
	    options.whitelist = options.whitelist.concat(['cimode']);
	  }
	
	  return options;
	}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _logger = __webpack_require__(57);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _EventEmitter2 = __webpack_require__(95);
	
	var _EventEmitter3 = _interopRequireDefault(_EventEmitter2);
	
	var _ResourceStore = __webpack_require__(585);
	
	var _ResourceStore2 = _interopRequireDefault(_ResourceStore);
	
	var _Translator = __webpack_require__(586);
	
	var _Translator2 = _interopRequireDefault(_Translator);
	
	var _LanguageUtils = __webpack_require__(583);
	
	var _LanguageUtils2 = _interopRequireDefault(_LanguageUtils);
	
	var _PluralResolver = __webpack_require__(584);
	
	var _PluralResolver2 = _interopRequireDefault(_PluralResolver);
	
	var _Interpolator = __webpack_require__(582);
	
	var _Interpolator2 = _interopRequireDefault(_Interpolator);
	
	var _BackendConnector = __webpack_require__(581);
	
	var _BackendConnector2 = _interopRequireDefault(_BackendConnector);
	
	var _defaults2 = __webpack_require__(587);
	
	var _postProcessor = __webpack_require__(242);
	
	var _postProcessor2 = _interopRequireDefault(_postProcessor);
	
	var _utils = __webpack_require__(70);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	function noop() {}
	
	var I18n = function (_EventEmitter) {
	  _inherits(I18n, _EventEmitter);
	
	  function I18n() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    _classCallCheck(this, I18n);
	
	    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
	    _this.options = (0, _defaults2.transformOptions)(options);
	    _this.services = {};
	    _this.logger = _logger2.default;
	    _this.modules = { external: [] };
	
	    if (callback && !_this.isInitialized && !options.isClone) {
	      // https://github.com/i18next/i18next/issues/879
	      if (!_this.options.initImmediate) {
	        var _ret;
	
	        _this.init(options, callback);
	        return _ret = _this, _possibleConstructorReturn(_this, _ret);
	      }
	      setTimeout(function () {
	        _this.init(options, callback);
	      }, 0);
	    }
	    return _this;
	  }
	
	  I18n.prototype.init = function init() {
	    var _this2 = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    this.options = _extends({}, (0, _defaults2.get)(), this.options, (0, _defaults2.transformOptions)(options));
	
	    this.format = this.options.interpolation.format;
	    if (!callback) callback = noop;
	
	    function createClassOnDemand(ClassOrObject) {
	      if (!ClassOrObject) return null;
	      if (typeof ClassOrObject === 'function') return new ClassOrObject();
	      return ClassOrObject;
	    }
	
	    // init services
	    if (!this.options.isClone) {
	      if (this.modules.logger) {
	        _logger2.default.init(createClassOnDemand(this.modules.logger), this.options);
	      } else {
	        _logger2.default.init(null, this.options);
	      }
	
	      var lu = new _LanguageUtils2.default(this.options);
	      this.store = new _ResourceStore2.default(this.options.resources, this.options);
	
	      var s = this.services;
	      s.logger = _logger2.default;
	      s.resourceStore = this.store;
	      s.languageUtils = lu;
	      s.pluralResolver = new _PluralResolver2.default(lu, {
	        prepend: this.options.pluralSeparator,
	        compatibilityJSON: this.options.compatibilityJSON,
	        simplifyPluralSuffix: this.options.simplifyPluralSuffix
	      });
	      s.interpolator = new _Interpolator2.default(this.options);
	
	      s.backendConnector = new _BackendConnector2.default(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
	      // pipe events from backendConnector
	      s.backendConnector.on('*', function (event) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      if (this.modules.languageDetector) {
	        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
	        s.languageDetector.init(s, this.options.detection, this.options);
	      }
	
	      if (this.modules.i18nFormat) {
	        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
	        if (s.i18nFormat.init) s.i18nFormat.init(this);
	      }
	
	      this.translator = new _Translator2.default(this.services, this.options);
	      // pipe events from translator
	      this.translator.on('*', function (event) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	          args[_key2 - 1] = arguments[_key2];
	        }
	
	        _this2.emit.apply(_this2, [event].concat(args));
	      });
	
	      this.modules.external.forEach(function (m) {
	        if (m.init) m.init(_this2);
	      });
	    }
	
	    // append api
	    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
	    storeApi.forEach(function (fcName) {
	      _this2[fcName] = function () {
	        var _store;
	
	        return (_store = _this2.store)[fcName].apply(_store, arguments);
	      };
	    });
	
	    var deferred = (0, _utils.defer)();
	
	    var load = function load() {
	      _this2.changeLanguage(_this2.options.lng, function (err, t) {
	        _this2.isInitialized = true;
	        _this2.logger.log('initialized', _this2.options);
	        _this2.emit('initialized', _this2.options);
	
	        deferred.resolve(t); // not rejecting on err (as err is only a loading translation failed warning)
	        callback(err, t);
	      });
	    };
	
	    if (this.options.resources || !this.options.initImmediate) {
	      load();
	    } else {
	      setTimeout(load, 0);
	    }
	
	    return deferred;
	  };
	
	  /* eslint consistent-return: 0 */
	
	
	  I18n.prototype.loadResources = function loadResources() {
	    var _this3 = this;
	
	    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	
	    if (!this.options.resources || this.options.partialBundledLanguages) {
	      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode
	
	      var toLoad = [];
	
	      var append = function append(lng) {
	        if (!lng) return;
	        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
	        lngs.forEach(function (l) {
	          if (toLoad.indexOf(l) < 0) toLoad.push(l);
	        });
	      };
	
	      if (!this.language) {
	        // at least load fallbacks in this case
	        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
	        fallbacks.forEach(function (l) {
	          return append(l);
	        });
	      } else {
	        append(this.language);
	      }
	
	      if (this.options.preload) {
	        this.options.preload.forEach(function (l) {
	          return append(l);
	        });
	      }
	
	      this.services.backendConnector.load(toLoad, this.options.ns, callback);
	    } else {
	      callback(null);
	    }
	  };
	
	  I18n.prototype.reloadResources = function reloadResources(lngs, ns, callback) {
	    var deferred = (0, _utils.defer)();
	    if (!lngs) lngs = this.languages;
	    if (!ns) ns = this.options.ns;
	    if (!callback) callback = noop;
	    this.services.backendConnector.reload(lngs, ns, function () {
	      deferred.resolve();
	      callback(null);
	    });
	    return deferred;
	  };
	
	  I18n.prototype.use = function use(module) {
	    if (module.type === 'backend') {
	      this.modules.backend = module;
	    }
	
	    if (module.type === 'logger' || module.log && module.warn && module.error) {
	      this.modules.logger = module;
	    }
	
	    if (module.type === 'languageDetector') {
	      this.modules.languageDetector = module;
	    }
	
	    if (module.type === 'i18nFormat') {
	      this.modules.i18nFormat = module;
	    }
	
	    if (module.type === 'postProcessor') {
	      _postProcessor2.default.addPostProcessor(module);
	    }
	
	    if (module.type === '3rdParty') {
	      this.modules.external.push(module);
	    }
	
	    return this;
	  };
	
	  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
	    var _this4 = this;
	
	    var deferred = (0, _utils.defer)();
	
	    var done = function done(err, l) {
	      _this4.translator.changeLanguage(l);
	
	      if (l) {
	        _this4.emit('languageChanged', l);
	        _this4.logger.log('languageChanged', l);
	      }
	
	      deferred.resolve(function () {
	        return _this4.t.apply(_this4, arguments);
	      });
	      if (callback) callback(err, function () {
	        return _this4.t.apply(_this4, arguments);
	      });
	    };
	
	    var setLng = function setLng(l) {
	      if (l) {
	        _this4.language = l;
	        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
	        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
	
	        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
	      }
	
	      _this4.loadResources(function (err) {
	        done(err, l);
	      });
	    };
	
	    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
	      setLng(this.services.languageDetector.detect());
	    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
	      this.services.languageDetector.detect(setLng);
	    } else {
	      setLng(lng);
	    }
	
	    return deferred;
	  };
	
	  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
	    var _this5 = this;
	
	    var fixedT = function fixedT(key, opts) {
	      for (var _len3 = arguments.length, rest = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	        rest[_key3 - 2] = arguments[_key3];
	      }
	
	      var options = _extends({}, opts);
	      if ((typeof opts === 'undefined' ? 'undefined' : _typeof(opts)) !== 'object') {
	        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
	      }
	
	      options.lng = options.lng || fixedT.lng;
	      options.lngs = options.lngs || fixedT.lngs;
	      options.ns = options.ns || fixedT.ns;
	      return _this5.t(key, options);
	    };
	    if (typeof lng === 'string') {
	      fixedT.lng = lng;
	    } else {
	      fixedT.lngs = lng;
	    }
	    fixedT.ns = ns;
	    return fixedT;
	  };
	
	  I18n.prototype.t = function t() {
	    var _translator;
	
	    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
	  };
	
	  I18n.prototype.exists = function exists() {
	    var _translator2;
	
	    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
	  };
	
	  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
	    this.options.defaultNS = ns;
	  };
	
	  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
	    var _this6 = this;
	
	    var deferred = (0, _utils.defer)();
	
	    if (!this.options.ns) {
	      callback && callback();
	      return Promise.resolve();
	    }
	    if (typeof ns === 'string') ns = [ns];
	
	    ns.forEach(function (n) {
	      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
	    });
	
	    this.loadResources(function (err) {
	      deferred.resolve();
	      if (callback) callback(err);
	    });
	
	    return deferred;
	  };
	
	  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
	    var deferred = (0, _utils.defer)();
	
	    if (typeof lngs === 'string') lngs = [lngs];
	    var preloaded = this.options.preload || [];
	
	    var newLngs = lngs.filter(function (lng) {
	      return preloaded.indexOf(lng) < 0;
	    });
	    // Exit early if all given languages are already preloaded
	    if (!newLngs.length) {
	      if (callback) callback();
	      return Promise.resolve();
	    }
	
	    this.options.preload = preloaded.concat(newLngs);
	    this.loadResources(function (err) {
	      deferred.resolve();
	      if (callback) callback(err);
	    });
	
	    return deferred;
	  };
	
	  I18n.prototype.dir = function dir(lng) {
	    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
	    if (!lng) return 'rtl';
	
	    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
	
	    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
	  };
	
	  /* eslint class-methods-use-this: 0 */
	
	
	  I18n.prototype.createInstance = function createInstance() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments[1];
	
	    return new I18n(options, callback);
	  };
	
	  I18n.prototype.cloneInstance = function cloneInstance() {
	    var _this7 = this;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
	
	    var mergedOptions = _extends({}, this.options, options, { isClone: true });
	    var clone = new I18n(mergedOptions);
	    var membersToCopy = ['store', 'services', 'language'];
	    membersToCopy.forEach(function (m) {
	      clone[m] = _this7[m];
	    });
	    clone.translator = new _Translator2.default(clone.services, clone.options);
	    clone.translator.on('*', function (event) {
	      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	        args[_key4 - 1] = arguments[_key4];
	      }
	
	      clone.emit.apply(clone, [event].concat(args));
	    });
	    clone.init(mergedOptions, callback);
	    clone.translator.options = clone.options; // sync options
	
	    return clone;
	  };
	
	  return I18n;
	}(_EventEmitter3.default);
	
	exports.default = new I18n();

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.use = exports.t = exports.setDefaultNamespace = exports.on = exports.off = exports.loadResources = exports.loadNamespaces = exports.loadLanguages = exports.init = exports.getFixedT = exports.exists = exports.dir = exports.createInstance = exports.cloneInstance = exports.changeLanguage = undefined;
	
	var _i18next = __webpack_require__(588);
	
	var _i18next2 = _interopRequireDefault(_i18next);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _i18next2.default;
	var changeLanguage = exports.changeLanguage = _i18next2.default.changeLanguage.bind(_i18next2.default);
	var cloneInstance = exports.cloneInstance = _i18next2.default.cloneInstance.bind(_i18next2.default);
	var createInstance = exports.createInstance = _i18next2.default.createInstance.bind(_i18next2.default);
	var dir = exports.dir = _i18next2.default.dir.bind(_i18next2.default);
	var exists = exports.exists = _i18next2.default.exists.bind(_i18next2.default);
	var getFixedT = exports.getFixedT = _i18next2.default.getFixedT.bind(_i18next2.default);
	var init = exports.init = _i18next2.default.init.bind(_i18next2.default);
	var loadLanguages = exports.loadLanguages = _i18next2.default.loadLanguages.bind(_i18next2.default);
	var loadNamespaces = exports.loadNamespaces = _i18next2.default.loadNamespaces.bind(_i18next2.default);
	var loadResources = exports.loadResources = _i18next2.default.loadResources.bind(_i18next2.default);
	var off = exports.off = _i18next2.default.off.bind(_i18next2.default);
	var on = exports.on = _i18next2.default.on.bind(_i18next2.default);
	var setDefaultNamespace = exports.setDefaultNamespace = _i18next2.default.setDefaultNamespace.bind(_i18next2.default);
	var t = exports.t = _i18next2.default.t.bind(_i18next2.default);
	var use = exports.use = _i18next2.default.use.bind(_i18next2.default);

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(75)
	
	/**
	 * Check if a string is lower case.
	 *
	 * @param  {String}  string
	 * @param  {String}  [locale]
	 * @return {Boolean}
	 */
	module.exports = function (string, locale) {
	  return lowerCase(string, locale) === string
	}


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(40)
	
	/**
	 * Check if a string is upper case.
	 *
	 * @param  {String}  string
	 * @param  {String}  [locale]
	 * @return {Boolean}
	 */
	module.exports = function (string, locale) {
	  return upperCase(string, locale) === string
	}


/***/ }),
/* 592 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  return key == '__proto__'
	    ? undefined
	    : object[key];
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(41)(module)))

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(28);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(647),
	    hashDelete = __webpack_require__(648),
	    hashGet = __webpack_require__(649),
	    hashHas = __webpack_require__(650),
	    hashSet = __webpack_require__(651);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(28);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(28);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(136),
	    setCacheAdd = __webpack_require__(673),
	    setCacheHas = __webpack_require__(674);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(28);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47),
	    root = __webpack_require__(28);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 601 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 602 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(627),
	    isArguments = __webpack_require__(142),
	    isArray = __webpack_require__(29),
	    isBuffer = __webpack_require__(256),
	    isIndex = __webpack_require__(138),
	    isTypedArray = __webpack_require__(258);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 604 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(609),
	    createBaseEach = __webpack_require__(633);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 606 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(245),
	    isFlattenable = __webpack_require__(652);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(634);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(608),
	    keys = __webpack_require__(102);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(245),
	    isArray = __webpack_require__(29);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 611 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(243),
	    equalArrays = __webpack_require__(250),
	    equalByTag = __webpack_require__(637),
	    equalObjects = __webpack_require__(638),
	    getTag = __webpack_require__(644),
	    isArray = __webpack_require__(29),
	    isBuffer = __webpack_require__(256),
	    isTypedArray = __webpack_require__(258);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(243),
	    baseIsEqual = __webpack_require__(247);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(257),
	    isMasked = __webpack_require__(655),
	    isObject = __webpack_require__(73),
	    toSource = __webpack_require__(255);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(58),
	    isLength = __webpack_require__(143),
	    isObjectLike = __webpack_require__(59);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(656),
	    nativeKeys = __webpack_require__(669);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(605),
	    isArrayLike = __webpack_require__(72);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(614),
	    getMatchData = __webpack_require__(640),
	    matchesStrictComparable = __webpack_require__(253);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(247),
	    get = __webpack_require__(690),
	    hasIn = __webpack_require__(691),
	    isKey = __webpack_require__(139),
	    isStrictComparable = __webpack_require__(252),
	    matchesStrictComparable = __webpack_require__(253),
	    toKey = __webpack_require__(100);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(244),
	    baseIteratee = __webpack_require__(137),
	    baseMap = __webpack_require__(618),
	    baseSortBy = __webpack_require__(626),
	    baseUnary = __webpack_require__(248),
	    compareMultiple = __webpack_require__(631),
	    identity = __webpack_require__(101);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 622 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(246);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(101),
	    overRest = __webpack_require__(672),
	    setToString = __webpack_require__(676);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(684),
	    defineProperty = __webpack_require__(636),
	    identity = __webpack_require__(101);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 626 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 627 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(71),
	    arrayMap = __webpack_require__(244),
	    isArray = __webpack_require__(29),
	    isSymbol = __webpack_require__(74);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 629 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(74);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(630);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(28);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(72);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 634 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(137),
	    isArrayLike = __webpack_require__(72),
	    keys = __webpack_require__(102);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(47);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(71),
	    Uint8Array = __webpack_require__(599),
	    eq = __webpack_require__(140),
	    equalArrays = __webpack_require__(250),
	    mapToArray = __webpack_require__(667),
	    setToArray = __webpack_require__(675);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(639);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(610),
	    getSymbols = __webpack_require__(643),
	    keys = __webpack_require__(102);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(252),
	    keys = __webpack_require__(102);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(254);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(71);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(602),
	    stubArray = __webpack_require__(696);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(594),
	    Map = __webpack_require__(135),
	    Promise = __webpack_require__(596),
	    Set = __webpack_require__(597),
	    WeakMap = __webpack_require__(600),
	    baseGetTag = __webpack_require__(58),
	    toSource = __webpack_require__(255);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 645 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(249),
	    isArguments = __webpack_require__(142),
	    isArray = __webpack_require__(29),
	    isIndex = __webpack_require__(138),
	    isLength = __webpack_require__(143),
	    toKey = __webpack_require__(100);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(99);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 648 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(99);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(99);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(99);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(71),
	    isArguments = __webpack_require__(142),
	    isArray = __webpack_require__(29);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(140),
	    isArrayLike = __webpack_require__(72),
	    isIndex = __webpack_require__(138),
	    isObject = __webpack_require__(73);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 654 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(632);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 656 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 657 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(97);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(97);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(97);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(97);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(595),
	    ListCache = __webpack_require__(96),
	    Map = __webpack_require__(135);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(98);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(98);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(98);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(98);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 667 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(693);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(254);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(251);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(41)(module)))

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(601);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 673 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 674 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 675 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(625),
	    shortOut = __webpack_require__(677);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 677 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(96);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 679 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 681 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(96),
	    Map = __webpack_require__(135),
	    MapCache = __webpack_require__(136);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(668);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 684 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(635),
	    findIndex = __webpack_require__(686);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(606),
	    baseIteratee = __webpack_require__(137),
	    toInteger = __webpack_require__(699);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	var mapping = __webpack_require__(688),
	    fallbackHolder = __webpack_require__(689);
	
	/** Built-in value reference. */
	var push = Array.prototype.push;
	
	/**
	 * Creates a function, with an arity of `n`, that invokes `func` with the
	 * arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} n The arity of the new function.
	 * @returns {Function} Returns the new function.
	 */
	function baseArity(func, n) {
	  return n == 2
	    ? function(a, b) { return func.apply(undefined, arguments); }
	    : function(a) { return func.apply(undefined, arguments); };
	}
	
	/**
	 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
	 * any additional arguments.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @param {number} n The arity cap.
	 * @returns {Function} Returns the new function.
	 */
	function baseAry(func, n) {
	  return n == 2
	    ? function(a, b) { return func(a, b); }
	    : function(a) { return func(a); };
	}
	
	/**
	 * Creates a clone of `array`.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the cloned array.
	 */
	function cloneArray(array) {
	  var length = array ? array.length : 0,
	      result = Array(length);
	
	  while (length--) {
	    result[length] = array[length];
	  }
	  return result;
	}
	
	/**
	 * Creates a function that clones a given object using the assignment `func`.
	 *
	 * @private
	 * @param {Function} func The assignment function.
	 * @returns {Function} Returns the new cloner function.
	 */
	function createCloner(func) {
	  return function(object) {
	    return func({}, object);
	  };
	}
	
	/**
	 * A specialized version of `_.spread` which flattens the spread array into
	 * the arguments of the invoked `func`.
	 *
	 * @private
	 * @param {Function} func The function to spread arguments over.
	 * @param {number} start The start position of the spread.
	 * @returns {Function} Returns the new function.
	 */
	function flatSpread(func, start) {
	  return function() {
	    var length = arguments.length,
	        lastIndex = length - 1,
	        args = Array(length);
	
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var array = args[start],
	        otherArgs = args.slice(0, start);
	
	    if (array) {
	      push.apply(otherArgs, array);
	    }
	    if (start != lastIndex) {
	      push.apply(otherArgs, args.slice(start + 1));
	    }
	    return func.apply(this, otherArgs);
	  };
	}
	
	/**
	 * Creates a function that wraps `func` and uses `cloner` to clone the first
	 * argument it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} cloner The function to clone arguments.
	 * @returns {Function} Returns the new immutable function.
	 */
	function wrapImmutable(func, cloner) {
	  return function() {
	    var length = arguments.length;
	    if (!length) {
	      return;
	    }
	    var args = Array(length);
	    while (length--) {
	      args[length] = arguments[length];
	    }
	    var result = args[0] = cloner.apply(undefined, args);
	    func.apply(undefined, args);
	    return result;
	  };
	}
	
	/**
	 * The base implementation of `convert` which accepts a `util` object of methods
	 * required to perform conversions.
	 *
	 * @param {Object} util The util object.
	 * @param {string} name The name of the function to convert.
	 * @param {Function} func The function to convert.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
	 * @param {boolean} [options.curry=true] Specify currying.
	 * @param {boolean} [options.fixed=true] Specify fixed arity.
	 * @param {boolean} [options.immutable=true] Specify immutable operations.
	 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
	 * @returns {Function|Object} Returns the converted function or object.
	 */
	function baseConvert(util, name, func, options) {
	  var isLib = typeof name == 'function',
	      isObj = name === Object(name);
	
	  if (isObj) {
	    options = func;
	    func = name;
	    name = undefined;
	  }
	  if (func == null) {
	    throw new TypeError;
	  }
	  options || (options = {});
	
	  var config = {
	    'cap': 'cap' in options ? options.cap : true,
	    'curry': 'curry' in options ? options.curry : true,
	    'fixed': 'fixed' in options ? options.fixed : true,
	    'immutable': 'immutable' in options ? options.immutable : true,
	    'rearg': 'rearg' in options ? options.rearg : true
	  };
	
	  var defaultHolder = isLib ? func : fallbackHolder,
	      forceCurry = ('curry' in options) && options.curry,
	      forceFixed = ('fixed' in options) && options.fixed,
	      forceRearg = ('rearg' in options) && options.rearg,
	      pristine = isLib ? func.runInContext() : undefined;
	
	  var helpers = isLib ? func : {
	    'ary': util.ary,
	    'assign': util.assign,
	    'clone': util.clone,
	    'curry': util.curry,
	    'forEach': util.forEach,
	    'isArray': util.isArray,
	    'isError': util.isError,
	    'isFunction': util.isFunction,
	    'isWeakMap': util.isWeakMap,
	    'iteratee': util.iteratee,
	    'keys': util.keys,
	    'rearg': util.rearg,
	    'toInteger': util.toInteger,
	    'toPath': util.toPath
	  };
	
	  var ary = helpers.ary,
	      assign = helpers.assign,
	      clone = helpers.clone,
	      curry = helpers.curry,
	      each = helpers.forEach,
	      isArray = helpers.isArray,
	      isError = helpers.isError,
	      isFunction = helpers.isFunction,
	      isWeakMap = helpers.isWeakMap,
	      keys = helpers.keys,
	      rearg = helpers.rearg,
	      toInteger = helpers.toInteger,
	      toPath = helpers.toPath;
	
	  var aryMethodKeys = keys(mapping.aryMethod);
	
	  var wrappers = {
	    'castArray': function(castArray) {
	      return function() {
	        var value = arguments[0];
	        return isArray(value)
	          ? castArray(cloneArray(value))
	          : castArray.apply(undefined, arguments);
	      };
	    },
	    'iteratee': function(iteratee) {
	      return function() {
	        var func = arguments[0],
	            arity = arguments[1],
	            result = iteratee(func, arity),
	            length = result.length;
	
	        if (config.cap && typeof arity == 'number') {
	          arity = arity > 2 ? (arity - 2) : 1;
	          return (length && length <= arity) ? result : baseAry(result, arity);
	        }
	        return result;
	      };
	    },
	    'mixin': function(mixin) {
	      return function(source) {
	        var func = this;
	        if (!isFunction(func)) {
	          return mixin(func, Object(source));
	        }
	        var pairs = [];
	        each(keys(source), function(key) {
	          if (isFunction(source[key])) {
	            pairs.push([key, func.prototype[key]]);
	          }
	        });
	
	        mixin(func, Object(source));
	
	        each(pairs, function(pair) {
	          var value = pair[1];
	          if (isFunction(value)) {
	            func.prototype[pair[0]] = value;
	          } else {
	            delete func.prototype[pair[0]];
	          }
	        });
	        return func;
	      };
	    },
	    'nthArg': function(nthArg) {
	      return function(n) {
	        var arity = n < 0 ? 1 : (toInteger(n) + 1);
	        return curry(nthArg(n), arity);
	      };
	    },
	    'rearg': function(rearg) {
	      return function(func, indexes) {
	        var arity = indexes ? indexes.length : 0;
	        return curry(rearg(func, indexes), arity);
	      };
	    },
	    'runInContext': function(runInContext) {
	      return function(context) {
	        return baseConvert(util, runInContext(context), options);
	      };
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Casts `func` to a function with an arity capped iteratee if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCap(name, func) {
	    if (config.cap) {
	      var indexes = mapping.iterateeRearg[name];
	      if (indexes) {
	        return iterateeRearg(func, indexes);
	      }
	      var n = !isLib && mapping.iterateeAry[name];
	      if (n) {
	        return iterateeAry(func, n);
	      }
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to a curried function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castCurry(name, func, n) {
	    return (forceCurry || (config.curry && n > 1))
	      ? curry(func, n)
	      : func;
	  }
	
	  /**
	   * Casts `func` to a fixed arity function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the cast function.
	   */
	  function castFixed(name, func, n) {
	    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
	      var data = mapping.methodSpread[name],
	          start = data && data.start;
	
	      return start  === undefined ? ary(func, n) : flatSpread(func, start);
	    }
	    return func;
	  }
	
	  /**
	   * Casts `func` to an rearged function if needed.
	   *
	   * @private
	   * @param {string} name The name of the function to inspect.
	   * @param {Function} func The function to inspect.
	   * @param {number} n The arity of `func`.
	   * @returns {Function} Returns the cast function.
	   */
	  function castRearg(name, func, n) {
	    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
	      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
	      : func;
	  }
	
	  /**
	   * Creates a clone of `object` by `path`.
	   *
	   * @private
	   * @param {Object} object The object to clone.
	   * @param {Array|string} path The path to clone by.
	   * @returns {Object} Returns the cloned object.
	   */
	  function cloneByPath(object, path) {
	    path = toPath(path);
	
	    var index = -1,
	        length = path.length,
	        lastIndex = length - 1,
	        result = clone(Object(object)),
	        nested = result;
	
	    while (nested != null && ++index < length) {
	      var key = path[index],
	          value = nested[key];
	
	      if (value != null &&
	          !(isFunction(value) || isError(value) || isWeakMap(value))) {
	        nested[key] = clone(index == lastIndex ? value : Object(value));
	      }
	      nested = nested[key];
	    }
	    return result;
	  }
	
	  /**
	   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
	   * version with conversion `options` applied.
	   *
	   * @param {Object} [options] The options object. See `baseConvert` for more details.
	   * @returns {Function} Returns the converted `lodash`.
	   */
	  function convertLib(options) {
	    return _.runInContext.convert(options)(undefined);
	  }
	
	  /**
	   * Create a converter function for `func` of `name`.
	   *
	   * @param {string} name The name of the function to convert.
	   * @param {Function} func The function to convert.
	   * @returns {Function} Returns the new converter function.
	   */
	  function createConverter(name, func) {
	    var realName = mapping.aliasToReal[name] || name,
	        methodName = mapping.remap[realName] || realName,
	        oldOptions = options;
	
	    return function(options) {
	      var newUtil = isLib ? pristine : helpers,
	          newFunc = isLib ? pristine[methodName] : func,
	          newOptions = assign(assign({}, oldOptions), options);
	
	      return baseConvert(newUtil, realName, newFunc, newOptions);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
	   * arguments, ignoring any additional arguments.
	   *
	   * @private
	   * @param {Function} func The function to cap iteratee arguments for.
	   * @param {number} n The arity cap.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeAry(func, n) {
	    return overArg(func, function(func) {
	      return typeof func == 'function' ? baseAry(func, n) : func;
	    });
	  }
	
	  /**
	   * Creates a function that wraps `func` to invoke its iteratee with arguments
	   * arranged according to the specified `indexes` where the argument value at
	   * the first index is provided as the first argument, the argument value at
	   * the second index is provided as the second argument, and so on.
	   *
	   * @private
	   * @param {Function} func The function to rearrange iteratee arguments for.
	   * @param {number[]} indexes The arranged argument indexes.
	   * @returns {Function} Returns the new function.
	   */
	  function iterateeRearg(func, indexes) {
	    return overArg(func, function(func) {
	      var n = indexes.length;
	      return baseArity(rearg(baseAry(func, n), indexes), n);
	    });
	  }
	
	  /**
	   * Creates a function that invokes `func` with its first argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function() {
	      var length = arguments.length;
	      if (!length) {
	        return func();
	      }
	      var args = Array(length);
	      while (length--) {
	        args[length] = arguments[length];
	      }
	      var index = config.rearg ? 0 : (length - 1);
	      args[index] = transform(args[index]);
	      return func.apply(undefined, args);
	    };
	  }
	
	  /**
	   * Creates a function that wraps `func` and applys the conversions
	   * rules by `name`.
	   *
	   * @private
	   * @param {string} name The name of the function to wrap.
	   * @param {Function} func The function to wrap.
	   * @returns {Function} Returns the converted function.
	   */
	  function wrap(name, func, placeholder) {
	    var result,
	        realName = mapping.aliasToReal[name] || name,
	        wrapped = func,
	        wrapper = wrappers[realName];
	
	    if (wrapper) {
	      wrapped = wrapper(func);
	    }
	    else if (config.immutable) {
	      if (mapping.mutate.array[realName]) {
	        wrapped = wrapImmutable(func, cloneArray);
	      }
	      else if (mapping.mutate.object[realName]) {
	        wrapped = wrapImmutable(func, createCloner(func));
	      }
	      else if (mapping.mutate.set[realName]) {
	        wrapped = wrapImmutable(func, cloneByPath);
	      }
	    }
	    each(aryMethodKeys, function(aryKey) {
	      each(mapping.aryMethod[aryKey], function(otherName) {
	        if (realName == otherName) {
	          var data = mapping.methodSpread[realName],
	              afterRearg = data && data.afterRearg;
	
	          result = afterRearg
	            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
	            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
	
	          result = castCap(realName, result);
	          result = castCurry(realName, result, aryKey);
	          return false;
	        }
	      });
	      return !result;
	    });
	
	    result || (result = wrapped);
	    if (result == func) {
	      result = forceCurry ? curry(result, 1) : function() {
	        return func.apply(this, arguments);
	      };
	    }
	    result.convert = createConverter(realName, func);
	    result.placeholder = func.placeholder = placeholder;
	
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  if (!isObj) {
	    return wrap(name, func, defaultHolder);
	  }
	  var _ = func;
	
	  // Convert methods by ary cap.
	  var pairs = [];
	  each(aryMethodKeys, function(aryKey) {
	    each(mapping.aryMethod[aryKey], function(key) {
	      var func = _[mapping.remap[key] || key];
	      if (func) {
	        pairs.push([key, wrap(key, func, _)]);
	      }
	    });
	  });
	
	  // Convert remaining methods.
	  each(keys(_), function(key) {
	    var func = _[key];
	    if (typeof func == 'function') {
	      var length = pairs.length;
	      while (length--) {
	        if (pairs[length][0] == key) {
	          return;
	        }
	      }
	      func.convert = createConverter(key, func);
	      pairs.push([key, func]);
	    }
	  });
	
	  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
	  each(pairs, function(pair) {
	    _[pair[0]] = pair[1];
	  });
	
	  _.convert = convertLib;
	  _.placeholder = _;
	
	  // Assign aliases.
	  each(keys(_), function(key) {
	    each(mapping.realToAlias[key] || [], function(alias) {
	      _[alias] = _[key];
	    });
	  });
	
	  return _;
	}
	
	module.exports = baseConvert;


/***/ }),
/* 688 */
/***/ (function(module, exports) {

	/** Used to map aliases to their real names. */
	exports.aliasToReal = {
	
	  // Lodash aliases.
	  'each': 'forEach',
	  'eachRight': 'forEachRight',
	  'entries': 'toPairs',
	  'entriesIn': 'toPairsIn',
	  'extend': 'assignIn',
	  'extendAll': 'assignInAll',
	  'extendAllWith': 'assignInAllWith',
	  'extendWith': 'assignInWith',
	  'first': 'head',
	
	  // Methods that are curried variants of others.
	  'conforms': 'conformsTo',
	  'matches': 'isMatch',
	  'property': 'get',
	
	  // Ramda aliases.
	  '__': 'placeholder',
	  'F': 'stubFalse',
	  'T': 'stubTrue',
	  'all': 'every',
	  'allPass': 'overEvery',
	  'always': 'constant',
	  'any': 'some',
	  'anyPass': 'overSome',
	  'apply': 'spread',
	  'assoc': 'set',
	  'assocPath': 'set',
	  'complement': 'negate',
	  'compose': 'flowRight',
	  'contains': 'includes',
	  'dissoc': 'unset',
	  'dissocPath': 'unset',
	  'dropLast': 'dropRight',
	  'dropLastWhile': 'dropRightWhile',
	  'equals': 'isEqual',
	  'identical': 'eq',
	  'indexBy': 'keyBy',
	  'init': 'initial',
	  'invertObj': 'invert',
	  'juxt': 'over',
	  'omitAll': 'omit',
	  'nAry': 'ary',
	  'path': 'get',
	  'pathEq': 'matchesProperty',
	  'pathOr': 'getOr',
	  'paths': 'at',
	  'pickAll': 'pick',
	  'pipe': 'flow',
	  'pluck': 'map',
	  'prop': 'get',
	  'propEq': 'matchesProperty',
	  'propOr': 'getOr',
	  'props': 'at',
	  'symmetricDifference': 'xor',
	  'symmetricDifferenceBy': 'xorBy',
	  'symmetricDifferenceWith': 'xorWith',
	  'takeLast': 'takeRight',
	  'takeLastWhile': 'takeRightWhile',
	  'unapply': 'rest',
	  'unnest': 'flatten',
	  'useWith': 'overArgs',
	  'where': 'conformsTo',
	  'whereEq': 'isMatch',
	  'zipObj': 'zipObject'
	};
	
	/** Used to map ary to method names. */
	exports.aryMethod = {
	  '1': [
	    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
	    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
	    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
	    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
	    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
	    'uniqueId', 'words', 'zipAll'
	  ],
	  '2': [
	    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
	    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
	    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
	    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
	    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
	    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
	    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
	    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
	    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
	    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
	    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
	    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
	    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
	    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
	    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
	    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
	    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
	    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
	    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
	    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
	    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
	    'zipObjectDeep'
	  ],
	  '3': [
	    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
	    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
	    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
	    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
	    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
	    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
	    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
	    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
	    'xorWith', 'zipWith'
	  ],
	  '4': [
	    'fill', 'setWith', 'updateWith'
	  ]
	};
	
	/** Used to map ary to rearg configs. */
	exports.aryRearg = {
	  '2': [1, 0],
	  '3': [2, 0, 1],
	  '4': [3, 2, 0, 1]
	};
	
	/** Used to map method names to their iteratee ary. */
	exports.iterateeAry = {
	  'dropRightWhile': 1,
	  'dropWhile': 1,
	  'every': 1,
	  'filter': 1,
	  'find': 1,
	  'findFrom': 1,
	  'findIndex': 1,
	  'findIndexFrom': 1,
	  'findKey': 1,
	  'findLast': 1,
	  'findLastFrom': 1,
	  'findLastIndex': 1,
	  'findLastIndexFrom': 1,
	  'findLastKey': 1,
	  'flatMap': 1,
	  'flatMapDeep': 1,
	  'flatMapDepth': 1,
	  'forEach': 1,
	  'forEachRight': 1,
	  'forIn': 1,
	  'forInRight': 1,
	  'forOwn': 1,
	  'forOwnRight': 1,
	  'map': 1,
	  'mapKeys': 1,
	  'mapValues': 1,
	  'partition': 1,
	  'reduce': 2,
	  'reduceRight': 2,
	  'reject': 1,
	  'remove': 1,
	  'some': 1,
	  'takeRightWhile': 1,
	  'takeWhile': 1,
	  'times': 1,
	  'transform': 2
	};
	
	/** Used to map method names to iteratee rearg configs. */
	exports.iterateeRearg = {
	  'mapKeys': [1],
	  'reduceRight': [1, 0]
	};
	
	/** Used to map method names to rearg configs. */
	exports.methodRearg = {
	  'assignInAllWith': [1, 0],
	  'assignInWith': [1, 2, 0],
	  'assignAllWith': [1, 0],
	  'assignWith': [1, 2, 0],
	  'differenceBy': [1, 2, 0],
	  'differenceWith': [1, 2, 0],
	  'getOr': [2, 1, 0],
	  'intersectionBy': [1, 2, 0],
	  'intersectionWith': [1, 2, 0],
	  'isEqualWith': [1, 2, 0],
	  'isMatchWith': [2, 1, 0],
	  'mergeAllWith': [1, 0],
	  'mergeWith': [1, 2, 0],
	  'padChars': [2, 1, 0],
	  'padCharsEnd': [2, 1, 0],
	  'padCharsStart': [2, 1, 0],
	  'pullAllBy': [2, 1, 0],
	  'pullAllWith': [2, 1, 0],
	  'rangeStep': [1, 2, 0],
	  'rangeStepRight': [1, 2, 0],
	  'setWith': [3, 1, 2, 0],
	  'sortedIndexBy': [2, 1, 0],
	  'sortedLastIndexBy': [2, 1, 0],
	  'unionBy': [1, 2, 0],
	  'unionWith': [1, 2, 0],
	  'updateWith': [3, 1, 2, 0],
	  'xorBy': [1, 2, 0],
	  'xorWith': [1, 2, 0],
	  'zipWith': [1, 2, 0]
	};
	
	/** Used to map method names to spread configs. */
	exports.methodSpread = {
	  'assignAll': { 'start': 0 },
	  'assignAllWith': { 'start': 0 },
	  'assignInAll': { 'start': 0 },
	  'assignInAllWith': { 'start': 0 },
	  'defaultsAll': { 'start': 0 },
	  'defaultsDeepAll': { 'start': 0 },
	  'invokeArgs': { 'start': 2 },
	  'invokeArgsMap': { 'start': 2 },
	  'mergeAll': { 'start': 0 },
	  'mergeAllWith': { 'start': 0 },
	  'partial': { 'start': 1 },
	  'partialRight': { 'start': 1 },
	  'without': { 'start': 1 },
	  'zipAll': { 'start': 0 }
	};
	
	/** Used to identify methods which mutate arrays or objects. */
	exports.mutate = {
	  'array': {
	    'fill': true,
	    'pull': true,
	    'pullAll': true,
	    'pullAllBy': true,
	    'pullAllWith': true,
	    'pullAt': true,
	    'remove': true,
	    'reverse': true
	  },
	  'object': {
	    'assign': true,
	    'assignAll': true,
	    'assignAllWith': true,
	    'assignIn': true,
	    'assignInAll': true,
	    'assignInAllWith': true,
	    'assignInWith': true,
	    'assignWith': true,
	    'defaults': true,
	    'defaultsAll': true,
	    'defaultsDeep': true,
	    'defaultsDeepAll': true,
	    'merge': true,
	    'mergeAll': true,
	    'mergeAllWith': true,
	    'mergeWith': true,
	  },
	  'set': {
	    'set': true,
	    'setWith': true,
	    'unset': true,
	    'update': true,
	    'updateWith': true
	  }
	};
	
	/** Used to map real names to their aliases. */
	exports.realToAlias = (function() {
	  var hasOwnProperty = Object.prototype.hasOwnProperty,
	      object = exports.aliasToReal,
	      result = {};
	
	  for (var key in object) {
	    var value = object[key];
	    if (hasOwnProperty.call(result, value)) {
	      result[value].push(key);
	    } else {
	      result[value] = [key];
	    }
	  }
	  return result;
	}());
	
	/** Used to map method names to other names. */
	exports.remap = {
	  'assignAll': 'assign',
	  'assignAllWith': 'assignWith',
	  'assignInAll': 'assignIn',
	  'assignInAllWith': 'assignInWith',
	  'curryN': 'curry',
	  'curryRightN': 'curryRight',
	  'defaultsAll': 'defaults',
	  'defaultsDeepAll': 'defaultsDeep',
	  'findFrom': 'find',
	  'findIndexFrom': 'findIndex',
	  'findLastFrom': 'findLast',
	  'findLastIndexFrom': 'findLastIndex',
	  'getOr': 'get',
	  'includesFrom': 'includes',
	  'indexOfFrom': 'indexOf',
	  'invokeArgs': 'invoke',
	  'invokeArgsMap': 'invokeMap',
	  'lastIndexOfFrom': 'lastIndexOf',
	  'mergeAll': 'merge',
	  'mergeAllWith': 'mergeWith',
	  'padChars': 'pad',
	  'padCharsEnd': 'padEnd',
	  'padCharsStart': 'padStart',
	  'propertyOf': 'get',
	  'rangeStep': 'range',
	  'rangeStepRight': 'rangeRight',
	  'restFrom': 'rest',
	  'spreadFrom': 'spread',
	  'trimChars': 'trim',
	  'trimCharsEnd': 'trimEnd',
	  'trimCharsStart': 'trimStart',
	  'zipAll': 'zip'
	};
	
	/** Used to track methods that skip fixing their arity. */
	exports.skipFixed = {
	  'castArray': true,
	  'flow': true,
	  'flowRight': true,
	  'iteratee': true,
	  'mixin': true,
	  'rearg': true,
	  'runInContext': true
	};
	
	/** Used to track methods that skip rearranging arguments. */
	exports.skipRearg = {
	  'add': true,
	  'assign': true,
	  'assignIn': true,
	  'bind': true,
	  'bindKey': true,
	  'concat': true,
	  'difference': true,
	  'divide': true,
	  'eq': true,
	  'gt': true,
	  'gte': true,
	  'isEqual': true,
	  'lt': true,
	  'lte': true,
	  'matchesProperty': true,
	  'merge': true,
	  'multiply': true,
	  'overArgs': true,
	  'partial': true,
	  'partialRight': true,
	  'propertyOf': true,
	  'random': true,
	  'range': true,
	  'rangeRight': true,
	  'subtract': true,
	  'zip': true,
	  'zipObject': true,
	  'zipObjectDeep': true
	};


/***/ }),
/* 689 */
/***/ (function(module, exports) {

	/**
	 * The default argument placeholder value for methods.
	 *
	 * @type {Object}
	 */
	module.exports = {};


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(246);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(611),
	    hasPath = __webpack_require__(646);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
	 */
	;(function(){function n(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function t(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function r(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&false!==t(n[r],r,n););return n}function e(n,t){for(var r=null==n?0:n.length;r--&&false!==t(n[r],r,n););return n}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return false;
	return true}function i(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function o(n,t){return!(null==n||!n.length)&&-1<v(n,t,0)}function f(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return true;return false}function c(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function a(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function l(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);
	return r}function s(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function h(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return true;return false}function p(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,false}),e}function _(n,t,r,e){var u=n.length;for(r+=e?1:-1;e?r--:++r<u;)if(t(n[r],r,n))return r;return-1}function v(n,t,r){if(t===t)n:{--r;for(var e=n.length;++r<e;)if(n[r]===t){n=r;break n}n=-1}else n=_(n,d,r);return n}function g(n,t,r,e){
	--r;for(var u=n.length;++r<u;)if(e(n[r],t))return r;return-1}function d(n){return n!==n}function y(n,t){var r=null==n?0:n.length;return r?m(n,t)/r:F}function b(n){return function(t){return null==t?T:t[n]}}function x(n){return function(t){return null==n?T:n[t]}}function j(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=false,n):t(r,n,u,i)}),r}function w(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;return n}function m(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==T&&(r=r===T?i:r+i)}return r;
	}function A(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function k(n,t){return c(t,function(t){return[t,n[t]]})}function E(n){return function(t){return n(t)}}function S(n,t){return c(t,function(t){return n[t]})}function O(n,t){return n.has(t)}function I(n,t){for(var r=-1,e=n.length;++r<e&&-1<v(t,n[r],0););return r}function R(n,t){for(var r=n.length;r--&&-1<v(t,n[r],0););return r}function z(n){return"\\"+Ln[n]}function W(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n];
	}),r}function U(n,t){return function(r){return n(t(r))}}function B(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&"__lodash_placeholder__"!==o||(n[r]="__lodash_placeholder__",i[u++]=r)}return i}function L(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=n}),r}function C(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function D(n){if(Rn.test(n)){for(var t=On.lastIndex=0;On.test(n);)++t;n=t}else n=Qn(n);return n}function M(n){return Rn.test(n)?n.match(On)||[]:n.split("");
	}var T,$=1/0,F=NaN,N=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],P=/\b__p\+='';/g,Z=/\b(__p\+=)''\+/g,q=/(__e\(.*?\)|\b__t\))\+'';/g,V=/&(?:amp|lt|gt|quot|#39);/g,K=/[&<>"']/g,G=RegExp(V.source),H=RegExp(K.source),J=/<%-([\s\S]+?)%>/g,Y=/<%([\s\S]+?)%>/g,Q=/<%=([\s\S]+?)%>/g,X=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,nn=/^\w*$/,tn=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,rn=/[\\^$.*+?()[\]{}|]/g,en=RegExp(rn.source),un=/^\s+|\s+$/g,on=/^\s+/,fn=/\s+$/,cn=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,an=/\{\n\/\* \[wrapped with (.+)\] \*/,ln=/,? & /,sn=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,hn=/\\(\\)?/g,pn=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,_n=/\w*$/,vn=/^[-+]0x[0-9a-f]+$/i,gn=/^0b[01]+$/i,dn=/^\[object .+?Constructor\]$/,yn=/^0o[0-7]+$/i,bn=/^(?:0|[1-9]\d*)$/,xn=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,jn=/($^)/,wn=/['\n\r\u2028\u2029\\]/g,mn="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",An="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+mn,kn="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",En=RegExp("['\u2019]","g"),Sn=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),On=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+kn+mn,"g"),In=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])|\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])|\\d+",An].join("|"),"g"),Rn=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),zn=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Wn="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Un={};
	Un["[object Float32Array]"]=Un["[object Float64Array]"]=Un["[object Int8Array]"]=Un["[object Int16Array]"]=Un["[object Int32Array]"]=Un["[object Uint8Array]"]=Un["[object Uint8ClampedArray]"]=Un["[object Uint16Array]"]=Un["[object Uint32Array]"]=true,Un["[object Arguments]"]=Un["[object Array]"]=Un["[object ArrayBuffer]"]=Un["[object Boolean]"]=Un["[object DataView]"]=Un["[object Date]"]=Un["[object Error]"]=Un["[object Function]"]=Un["[object Map]"]=Un["[object Number]"]=Un["[object Object]"]=Un["[object RegExp]"]=Un["[object Set]"]=Un["[object String]"]=Un["[object WeakMap]"]=false;
	var Bn={};Bn["[object Arguments]"]=Bn["[object Array]"]=Bn["[object ArrayBuffer]"]=Bn["[object DataView]"]=Bn["[object Boolean]"]=Bn["[object Date]"]=Bn["[object Float32Array]"]=Bn["[object Float64Array]"]=Bn["[object Int8Array]"]=Bn["[object Int16Array]"]=Bn["[object Int32Array]"]=Bn["[object Map]"]=Bn["[object Number]"]=Bn["[object Object]"]=Bn["[object RegExp]"]=Bn["[object Set]"]=Bn["[object String]"]=Bn["[object Symbol]"]=Bn["[object Uint8Array]"]=Bn["[object Uint8ClampedArray]"]=Bn["[object Uint16Array]"]=Bn["[object Uint32Array]"]=true,
	Bn["[object Error]"]=Bn["[object Function]"]=Bn["[object WeakMap]"]=false;var Ln={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Cn=parseFloat,Dn=parseInt,Mn=typeof global=="object"&&global&&global.Object===Object&&global,Tn=typeof self=="object"&&self&&self.Object===Object&&self,$n=Mn||Tn||Function("return this")(),Fn=typeof exports=="object"&&exports&&!exports.nodeType&&exports,Nn=Fn&&typeof module=="object"&&module&&!module.nodeType&&module,Pn=Nn&&Nn.exports===Fn,Zn=Pn&&Mn.process,qn=function(){
	try{var n=Nn&&Nn.require&&Nn.require("util").types;return n?n:Zn&&Zn.binding&&Zn.binding("util")}catch(n){}}(),Vn=qn&&qn.isArrayBuffer,Kn=qn&&qn.isDate,Gn=qn&&qn.isMap,Hn=qn&&qn.isRegExp,Jn=qn&&qn.isSet,Yn=qn&&qn.isTypedArray,Qn=b("length"),Xn=x({"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e",
	"\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a",
	"\u0106":"C","\u0108":"C","\u010a":"C","\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g","\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I",
	"\u0129":"i","\u012b":"i","\u012d":"i","\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O","\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r",
	"\u0159":"r","\u015a":"S","\u015c":"S","\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ",
	"\u0133":"ij","\u0152":"Oe","\u0153":"oe","\u0149":"'n","\u017f":"s"}),nt=x({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),tt=x({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),rt=function x(mn){function An(n){if(yu(n)&&!ff(n)&&!(n instanceof Ln)){if(n instanceof On)return n;if(oi.call(n,"__wrapped__"))return Fe(n)}return new On(n)}function kn(){}function On(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=T}function Ln(n){
	this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Mn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Tn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Fn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Nn(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new Fn;++t<r;)this.add(n[t]);
	}function Zn(n){this.size=(this.__data__=new Tn(n)).size}function qn(n,t){var r,e=ff(n),u=!e&&of(n),i=!e&&!u&&af(n),o=!e&&!u&&!i&&_f(n),u=(e=e||u||i||o)?A(n.length,ni):[],f=u.length;for(r in n)!t&&!oi.call(n,r)||e&&("length"==r||i&&("offset"==r||"parent"==r)||o&&("buffer"==r||"byteLength"==r||"byteOffset"==r)||Se(r,f))||u.push(r);return u}function Qn(n){var t=n.length;return t?n[ir(0,t-1)]:T}function et(n,t){return De(Lr(n),pt(t,0,n.length))}function ut(n){return De(Lr(n))}function it(n,t,r){(r===T||lu(n[t],r))&&(r!==T||t in n)||st(n,t,r);
	}function ot(n,t,r){var e=n[t];oi.call(n,t)&&lu(e,r)&&(r!==T||t in n)||st(n,t,r)}function ft(n,t){for(var r=n.length;r--;)if(lu(n[r][0],t))return r;return-1}function ct(n,t,r,e){return uo(n,function(n,u,i){t(e,n,r(n),i)}),e}function at(n,t){return n&&Cr(t,Wu(t),n)}function lt(n,t){return n&&Cr(t,Uu(t),n)}function st(n,t,r){"__proto__"==t&&Ai?Ai(n,t,{configurable:true,enumerable:true,value:r,writable:true}):n[t]=r}function ht(n,t){for(var r=-1,e=t.length,u=Ku(e),i=null==n;++r<e;)u[r]=i?T:Ru(n,t[r]);return u;
	}function pt(n,t,r){return n===n&&(r!==T&&(n=n<=r?n:r),t!==T&&(n=n>=t?n:t)),n}function _t(n,t,e,u,i,o){var f,c=1&t,a=2&t,l=4&t;if(e&&(f=i?e(n,u,i,o):e(n)),f!==T)return f;if(!du(n))return n;if(u=ff(n)){if(f=me(n),!c)return Lr(n,f)}else{var s=vo(n),h="[object Function]"==s||"[object GeneratorFunction]"==s;if(af(n))return Ir(n,c);if("[object Object]"==s||"[object Arguments]"==s||h&&!i){if(f=a||h?{}:Ae(n),!c)return a?Mr(n,lt(f,n)):Dr(n,at(f,n))}else{if(!Bn[s])return i?n:{};f=ke(n,s,c)}}if(o||(o=new Zn),
	i=o.get(n))return i;if(o.set(n,f),pf(n))return n.forEach(function(r){f.add(_t(r,t,e,r,n,o))}),f;if(sf(n))return n.forEach(function(r,u){f.set(u,_t(r,t,e,u,n,o))}),f;var a=l?a?ve:_e:a?Uu:Wu,p=u?T:a(n);return r(p||n,function(r,u){p&&(u=r,r=n[u]),ot(f,u,_t(r,t,e,u,n,o))}),f}function vt(n){var t=Wu(n);return function(r){return gt(r,n,t)}}function gt(n,t,r){var e=r.length;if(null==n)return!e;for(n=Qu(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===T&&!(u in n)||!i(o))return false}return true}function dt(n,t,r){if(typeof n!="function")throw new ti("Expected a function");
	return bo(function(){n.apply(T,r)},t)}function yt(n,t,r,e){var u=-1,i=o,a=true,l=n.length,s=[],h=t.length;if(!l)return s;r&&(t=c(t,E(r))),e?(i=f,a=false):200<=t.length&&(i=O,a=false,t=new Nn(t));n:for(;++u<l;){var p=n[u],_=null==r?p:r(p),p=e||0!==p?p:0;if(a&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function bt(n,t){var r=true;return uo(n,function(n,e,u){return r=!!t(n,e,u)}),r}function xt(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===T?o===o&&!wu(o):r(o,f)))var f=o,c=i;
	}return c}function jt(n,t){var r=[];return uo(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function wt(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=Ee),u||(u=[]);++i<o;){var f=n[i];0<t&&r(f)?1<t?wt(f,t-1,r,e,u):a(u,f):e||(u[u.length]=f)}return u}function mt(n,t){return n&&oo(n,t,Wu)}function At(n,t){return n&&fo(n,t,Wu)}function kt(n,t){return i(t,function(t){return _u(n[t])})}function Et(n,t){t=Sr(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[Me(t[r++])];return r&&r==e?n:T}function St(n,t,r){return t=t(n),
	ff(n)?t:a(t,r(n))}function Ot(n){if(null==n)return n===T?"[object Undefined]":"[object Null]";if(mi&&mi in Qu(n)){var t=oi.call(n,mi),r=n[mi];try{n[mi]=T;var e=true}catch(n){}var u=ai.call(n);e&&(t?n[mi]=r:delete n[mi]),n=u}else n=ai.call(n);return n}function It(n,t){return n>t}function Rt(n,t){return null!=n&&oi.call(n,t)}function zt(n,t){return null!=n&&t in Qu(n)}function Wt(n,t,r){for(var e=r?f:o,u=n[0].length,i=n.length,a=i,l=Ku(i),s=1/0,h=[];a--;){var p=n[a];a&&t&&(p=c(p,E(t))),s=Ci(p.length,s),
	l[a]=!r&&(t||120<=u&&120<=p.length)?new Nn(a&&p):T}var p=n[0],_=-1,v=l[0];n:for(;++_<u&&h.length<s;){var g=p[_],d=t?t(g):g,g=r||0!==g?g:0;if(v?!O(v,d):!e(h,d,r)){for(a=i;--a;){var y=l[a];if(y?!O(y,d):!e(n[a],d,r))continue n}v&&v.push(d),h.push(g)}}return h}function Ut(n,t,r,e){return mt(n,function(n,u,i){t(e,r(n),u,i)}),e}function Bt(t,r,e){return r=Sr(r,t),t=2>r.length?t:Et(t,hr(r,0,-1)),r=null==t?t:t[Me(Ve(r))],null==r?T:n(r,t,e)}function Lt(n){return yu(n)&&"[object Arguments]"==Ot(n)}function Ct(n){
	return yu(n)&&"[object ArrayBuffer]"==Ot(n)}function Dt(n){return yu(n)&&"[object Date]"==Ot(n)}function Mt(n,t,r,e,u){if(n===t)return true;if(null==n||null==t||!yu(n)&&!yu(t))return n!==n&&t!==t;n:{var i=ff(n),o=ff(t),f=i?"[object Array]":vo(n),c=o?"[object Array]":vo(t),f="[object Arguments]"==f?"[object Object]":f,c="[object Arguments]"==c?"[object Object]":c,a="[object Object]"==f,o="[object Object]"==c;if((c=f==c)&&af(n)){if(!af(t)){t=false;break n}i=true,a=false}if(c&&!a)u||(u=new Zn),t=i||_f(n)?se(n,t,r,e,Mt,u):he(n,t,f,r,e,Mt,u);else{
	if(!(1&r)&&(i=a&&oi.call(n,"__wrapped__"),f=o&&oi.call(t,"__wrapped__"),i||f)){n=i?n.value():n,t=f?t.value():t,u||(u=new Zn),t=Mt(n,t,r,e,u);break n}if(c)t:if(u||(u=new Zn),i=1&r,f=_e(n),o=f.length,c=_e(t).length,o==c||i){for(a=o;a--;){var l=f[a];if(!(i?l in t:oi.call(t,l))){t=false;break t}}if((c=u.get(n))&&u.get(t))t=c==t;else{c=true,u.set(n,t),u.set(t,n);for(var s=i;++a<o;){var l=f[a],h=n[l],p=t[l];if(e)var _=i?e(p,h,l,t,n,u):e(h,p,l,n,t,u);if(_===T?h!==p&&!Mt(h,p,r,e,u):!_){c=false;break}s||(s="constructor"==l);
	}c&&!s&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(c=false)),u.delete(n),u.delete(t),t=c}}else t=false;else t=false}}return t}function Tt(n){return yu(n)&&"[object Map]"==vo(n)}function $t(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=Qu(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return false}for(;++u<i;){var f=r[u],c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===T&&!(c in n))return false;
	}else{if(f=new Zn,e)var s=e(a,l,c,n,t,f);if(s===T?!Mt(l,a,3,e,f):!s)return false}}return true}function Ft(n){return!(!du(n)||ci&&ci in n)&&(_u(n)?hi:dn).test(Te(n))}function Nt(n){return yu(n)&&"[object RegExp]"==Ot(n)}function Pt(n){return yu(n)&&"[object Set]"==vo(n)}function Zt(n){return yu(n)&&gu(n.length)&&!!Un[Ot(n)]}function qt(n){return typeof n=="function"?n:null==n?$u:typeof n=="object"?ff(n)?Jt(n[0],n[1]):Ht(n):Zu(n)}function Vt(n){if(!ze(n))return Bi(n);var t,r=[];for(t in Qu(n))oi.call(n,t)&&"constructor"!=t&&r.push(t);
	return r}function Kt(n,t){return n<t}function Gt(n,t){var r=-1,e=su(n)?Ku(n.length):[];return uo(n,function(n,u,i){e[++r]=t(n,u,i)}),e}function Ht(n){var t=xe(n);return 1==t.length&&t[0][2]?We(t[0][0],t[0][1]):function(r){return r===n||$t(r,n,t)}}function Jt(n,t){return Ie(n)&&t===t&&!du(t)?We(Me(n),t):function(r){var e=Ru(r,n);return e===T&&e===t?zu(r,n):Mt(t,e,3)}}function Yt(n,t,r,e,u){n!==t&&oo(t,function(i,o){if(du(i)){u||(u=new Zn);var f=u,c=Be(n,o),a=Be(t,o),l=f.get(a);if(!l){var l=e?e(c,a,o+"",n,t,f):T,s=l===T;
	if(s){var h=ff(a),p=!h&&af(a),_=!h&&!p&&_f(a),l=a;h||p||_?ff(c)?l=c:hu(c)?l=Lr(c):p?(s=false,l=Ir(a,true)):_?(s=false,l=zr(a,true)):l=[]:xu(a)||of(a)?(l=c,of(c)?l=Ou(c):du(c)&&!_u(c)||(l=Ae(a))):s=false}s&&(f.set(a,l),Yt(l,a,r,e,f),f.delete(a))}it(n,o,l)}else f=e?e(Be(n,o),i,o+"",n,t,u):T,f===T&&(f=i),it(n,o,f)},Uu)}function Qt(n,t){var r=n.length;if(r)return t+=0>t?r:0,Se(t,r)?n[t]:T}function Xt(n,t,r){var e=-1;return t=c(t.length?t:[$u],E(ye())),n=Gt(n,function(n,r,u){return{a:c(t,function(t){return t(n)}),
	b:++e,c:n}}),w(n,function(n,t){var e;n:{e=-1;for(var u=n.a,i=t.a,o=u.length,f=r.length;++e<o;){var c=Wr(u[e],i[e]);if(c){if(e>=f){e=c;break n}e=c*("desc"==r[e]?-1:1);break n}}e=n.b-t.b}return e})}function nr(n,t){return tr(n,t,function(t,r){return zu(n,r)})}function tr(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=Et(n,o);r(f,o)&&lr(i,Sr(o,n),f)}return i}function rr(n){return function(t){return Et(t,n)}}function er(n,t,r,e){var u=e?g:v,i=-1,o=t.length,f=n;for(n===t&&(t=Lr(t)),r&&(f=c(n,E(r)));++i<o;)for(var a=0,l=t[i],l=r?r(l):l;-1<(a=u(f,l,a,e));)f!==n&&xi.call(f,a,1),
	xi.call(n,a,1);return n}function ur(n,t){for(var r=n?t.length:0,e=r-1;r--;){var u=t[r];if(r==e||u!==i){var i=u;Se(u)?xi.call(n,u,1):xr(n,u)}}return n}function ir(n,t){return n+Ii(Ti()*(t-n+1))}function or(n,t){var r="";if(!n||1>t||9007199254740991<t)return r;do t%2&&(r+=n),(t=Ii(t/2))&&(n+=n);while(t);return r}function fr(n,t){return xo(Ue(n,t,$u),n+"")}function cr(n){return Qn(Lu(n))}function ar(n,t){var r=Lu(n);return De(r,pt(t,0,r.length))}function lr(n,t,r,e){if(!du(n))return n;t=Sr(t,n);for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){
	var c=Me(t[u]),a=r;if(u!=o){var l=f[c],a=e?e(l,c,f):T;a===T&&(a=du(l)?l:Se(t[u+1])?[]:{})}ot(f,c,a),f=f[c]}return n}function sr(n){return De(Lu(n))}function hr(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Ku(u);++e<u;)r[e]=n[e+t];return r}function pr(n,t){var r;return uo(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function _r(n,t,r){var e=0,u=null==n?e:n.length;if(typeof t=="number"&&t===t&&2147483647>=u){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!wu(o)&&(r?o<=t:o<t)?e=i+1:u=i;
	}return u}return vr(n,t,$u,r)}function vr(n,t,r,e){t=r(t);for(var u=0,i=null==n?0:n.length,o=t!==t,f=null===t,c=wu(t),a=t===T;u<i;){var l=Ii((u+i)/2),s=r(n[l]),h=s!==T,p=null===s,_=s===s,v=wu(s);(o?e||_:a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):p||v?0:e?s<=t:s<t)?u=l+1:i=l}return Ci(i,4294967294)}function gr(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r],f=t?t(o):o;if(!r||!lu(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function dr(n){return typeof n=="number"?n:wu(n)?F:+n}function yr(n){
	if(typeof n=="string")return n;if(ff(n))return c(n,yr)+"";if(wu(n))return ro?ro.call(n):"";var t=n+"";return"0"==t&&1/n==-$?"-0":t}function br(n,t,r){var e=-1,u=o,i=n.length,c=true,a=[],l=a;if(r)c=false,u=f;else if(200<=i){if(u=t?null:so(n))return L(u);c=false,u=O,l=new Nn}else l=t?[]:a;n:for(;++e<i;){var s=n[e],h=t?t(s):s,s=r||0!==s?s:0;if(c&&h===h){for(var p=l.length;p--;)if(l[p]===h)continue n;t&&l.push(h),a.push(s)}else u(l,h,r)||(l!==a&&l.push(h),a.push(s))}return a}function xr(n,t){return t=Sr(t,n),
	n=2>t.length?n:Et(n,hr(t,0,-1)),null==n||delete n[Me(Ve(t))]}function jr(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?hr(n,e?0:i,e?i+1:u):hr(n,e?i+1:0,e?u:i)}function wr(n,t){var r=n;return r instanceof Ln&&(r=r.value()),l(t,function(n,t){return t.func.apply(t.thisArg,a([n],t.args))},r)}function mr(n,t,r){var e=n.length;if(2>e)return e?br(n[0]):[];for(var u=-1,i=Ku(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=yt(i[u]||o,n[f],t,r));return br(wt(i,1),t,r)}function Ar(n,t,r){
	for(var e=-1,u=n.length,i=t.length,o={};++e<u;)r(o,n[e],e<i?t[e]:T);return o}function kr(n){return hu(n)?n:[]}function Er(n){return typeof n=="function"?n:$u}function Sr(n,t){return ff(n)?n:Ie(n,t)?[n]:jo(Iu(n))}function Or(n,t,r){var e=n.length;return r=r===T?e:r,!t&&r>=e?n:hr(n,t,r)}function Ir(n,t){if(t)return n.slice();var r=n.length,r=gi?gi(r):new n.constructor(r);return n.copy(r),r}function Rr(n){var t=new n.constructor(n.byteLength);return new vi(t).set(new vi(n)),t}function zr(n,t){return new n.constructor(t?Rr(n.buffer):n.buffer,n.byteOffset,n.length);
	}function Wr(n,t){if(n!==t){var r=n!==T,e=null===n,u=n===n,i=wu(n),o=t!==T,f=null===t,c=t===t,a=wu(t);if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Ur(n,t,r,e){var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Li(i-o,0),l=Ku(c+a);for(e=!e;++f<c;)l[f]=t[f];for(;++u<o;)(e||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];return l}function Br(n,t,r,e){var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Li(i-f,0),s=Ku(l+a);
	for(e=!e;++u<l;)s[u]=n[u];for(l=u;++c<a;)s[l+c]=t[c];for(;++o<f;)(e||u<i)&&(s[l+r[o]]=n[u++]);return s}function Lr(n,t){var r=-1,e=n.length;for(t||(t=Ku(e));++r<e;)t[r]=n[r];return t}function Cr(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):T;c===T&&(c=n[f]),u?st(r,f,c):ot(r,f,c)}return r}function Dr(n,t){return Cr(n,po(n),t)}function Mr(n,t){return Cr(n,_o(n),t)}function Tr(n,r){return function(e,u){var i=ff(e)?t:ct,o=r?r():{};return i(e,n,ye(u,2),o);
	}}function $r(n){return fr(function(t,r){var e=-1,u=r.length,i=1<u?r[u-1]:T,o=2<u?r[2]:T,i=3<n.length&&typeof i=="function"?(u--,i):T;for(o&&Oe(r[0],r[1],o)&&(i=3>u?T:i,u=1),t=Qu(t);++e<u;)(o=r[e])&&n(t,o,e,i);return t})}function Fr(n,t){return function(r,e){if(null==r)return r;if(!su(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=Qu(r);(t?i--:++i<u)&&false!==e(o[i],i,o););return r}}function Nr(n){return function(t,r,e){var u=-1,i=Qu(t);e=e(t);for(var o=e.length;o--;){var f=e[n?o:++u];if(false===r(i[f],f,i))break;
	}return t}}function Pr(n,t,r){function e(){return(this&&this!==$n&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=1&t,i=Vr(n);return e}function Zr(n){return function(t){t=Iu(t);var r=Rn.test(t)?M(t):T,e=r?r[0]:t.charAt(0);return t=r?Or(r,1).join(""):t.slice(1),e[n]()+t}}function qr(n){return function(t){return l(Mu(Du(t).replace(En,"")),n,"")}}function Vr(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:
	return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=eo(n.prototype),t=n.apply(r,t);return du(t)?t:r}}function Kr(t,r,e){function u(){for(var o=arguments.length,f=Ku(o),c=o,a=de(u);c--;)f[c]=arguments[c];return c=3>o&&f[0]!==a&&f[o-1]!==a?[]:B(f,a),o-=c.length,o<e?ue(t,r,Jr,u.placeholder,T,f,c,T,T,e-o):n(this&&this!==$n&&this instanceof u?i:t,this,f);
	}var i=Vr(t);return u}function Gr(n){return function(t,r,e){var u=Qu(t);if(!su(t)){var i=ye(r,3);t=Wu(t),r=function(n){return i(u[n],n,u)}}return r=n(t,r,e),-1<r?u[i?t[r]:r]:T}}function Hr(n){return pe(function(t){var r=t.length,e=r,u=On.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if(typeof i!="function")throw new ti("Expected a function");if(u&&!o&&"wrapper"==ge(i))var o=new On([],true)}for(e=o?e:r;++e<r;)var i=t[e],u=ge(i),f="wrapper"==u?ho(i):T,o=f&&Re(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?o[ge(f[0])].apply(o,f[3]):1==i.length&&Re(i)?o[u]():o.thru(i);
	return function(){var n=arguments,e=n[0];if(o&&1==n.length&&ff(e))return o.plant(e).value();for(var u=0,n=r?t[u].apply(this,n):e;++u<r;)n=t[u].call(this,n);return n}})}function Jr(n,t,r,e,u,i,o,f,c,a){function l(){for(var d=arguments.length,y=Ku(d),b=d;b--;)y[b]=arguments[b];if(_){var x,j=de(l),b=y.length;for(x=0;b--;)y[b]===j&&++x}if(e&&(y=Ur(y,e,u,_)),i&&(y=Br(y,i,o,_)),d-=x,_&&d<a)return j=B(y,j),ue(n,t,Jr,l.placeholder,r,y,j,f,c,a-d);if(j=h?r:this,b=p?j[n]:n,d=y.length,f){x=y.length;for(var w=Ci(f.length,x),m=Lr(y);w--;){
	var A=f[w];y[w]=Se(A,x)?m[A]:T}}else v&&1<d&&y.reverse();return s&&c<d&&(y.length=c),this&&this!==$n&&this instanceof l&&(b=g||Vr(b)),b.apply(j,y)}var s=128&t,h=1&t,p=2&t,_=24&t,v=512&t,g=p?T:Vr(n);return l}function Yr(n,t){return function(r,e){return Ut(r,n,t(e),{})}}function Qr(n,t){return function(r,e){var u;if(r===T&&e===T)return t;if(r!==T&&(u=r),e!==T){if(u===T)return e;typeof r=="string"||typeof e=="string"?(r=yr(r),e=yr(e)):(r=dr(r),e=dr(e)),u=n(r,e)}return u}}function Xr(t){return pe(function(r){
	return r=c(r,E(ye())),fr(function(e){var u=this;return t(r,function(t){return n(t,u,e)})})})}function ne(n,t){t=t===T?" ":yr(t);var r=t.length;return 2>r?r?or(t,n):t:(r=or(t,Oi(n/D(t))),Rn.test(t)?Or(M(r),0,n).join(""):r.slice(0,n))}function te(t,r,e,u){function i(){for(var r=-1,c=arguments.length,a=-1,l=u.length,s=Ku(l+c),h=this&&this!==$n&&this instanceof i?f:t;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++r];return n(h,o?e:this,s)}var o=1&r,f=Vr(t);return i}function re(n){return function(t,r,e){
	e&&typeof e!="number"&&Oe(t,r,e)&&(r=e=T),t=Au(t),r===T?(r=t,t=0):r=Au(r),e=e===T?t<r?1:-1:Au(e);var u=-1;r=Li(Oi((r-t)/(e||1)),0);for(var i=Ku(r);r--;)i[n?r:++u]=t,t+=e;return i}}function ee(n){return function(t,r){return typeof t=="string"&&typeof r=="string"||(t=Su(t),r=Su(r)),n(t,r)}}function ue(n,t,r,e,u,i,o,f,c,a){var l=8&t,s=l?o:T;o=l?T:o;var h=l?i:T;return i=l?T:i,t=(t|(l?32:64))&~(l?64:32),4&t||(t&=-4),u=[n,t,u,h,s,i,o,f,c,a],r=r.apply(T,u),Re(n)&&yo(r,u),r.placeholder=e,Le(r,n,t)}function ie(n){
	var t=Yu[n];return function(n,r){if(n=Su(n),r=null==r?0:Ci(ku(r),292)){var e=(Iu(n)+"e").split("e"),e=t(e[0]+"e"+(+e[1]+r)),e=(Iu(e)+"e").split("e");return+(e[0]+"e"+(+e[1]-r))}return t(n)}}function oe(n){return function(t){var r=vo(t);return"[object Map]"==r?W(t):"[object Set]"==r?C(t):k(t,n(t))}}function fe(n,t,r,e,u,i,o,f){var c=2&t;if(!c&&typeof n!="function")throw new ti("Expected a function");var a=e?e.length:0;if(a||(t&=-97,e=u=T),o=o===T?o:Li(ku(o),0),f=f===T?f:ku(f),a-=u?u.length:0,64&t){
	var l=e,s=u;e=u=T}var h=c?T:ho(n);return i=[n,t,r,e,u,l,s,i,o,f],h&&(r=i[1],n=h[1],t=r|n,e=128==n&&8==r||128==n&&256==r&&i[7].length<=h[8]||384==n&&h[7].length<=h[8]&&8==r,131>t||e)&&(1&n&&(i[2]=h[2],t|=1&r?0:4),(r=h[3])&&(e=i[3],i[3]=e?Ur(e,r,h[4]):r,i[4]=e?B(i[3],"__lodash_placeholder__"):h[4]),(r=h[5])&&(e=i[5],i[5]=e?Br(e,r,h[6]):r,i[6]=e?B(i[5],"__lodash_placeholder__"):h[6]),(r=h[7])&&(i[7]=r),128&n&&(i[8]=null==i[8]?h[8]:Ci(i[8],h[8])),null==i[9]&&(i[9]=h[9]),i[0]=h[0],i[1]=t),n=i[0],t=i[1],
	r=i[2],e=i[3],u=i[4],f=i[9]=i[9]===T?c?0:n.length:Li(i[9]-a,0),!f&&24&t&&(t&=-25),c=t&&1!=t?8==t||16==t?Kr(n,t,f):32!=t&&33!=t||u.length?Jr.apply(T,i):te(n,t,r,e):Pr(n,t,r),Le((h?co:yo)(c,i),n,t)}function ce(n,t,r,e){return n===T||lu(n,ei[r])&&!oi.call(e,r)?t:n}function ae(n,t,r,e,u,i){return du(n)&&du(t)&&(i.set(t,n),Yt(n,t,T,ae,i),i.delete(t)),n}function le(n){return xu(n)?T:n}function se(n,t,r,e,u,i){var o=1&r,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return false;if((c=i.get(n))&&i.get(t))return c==t;
	var c=-1,a=true,l=2&r?new Nn:T;for(i.set(n,t),i.set(t,n);++c<f;){var s=n[c],p=t[c];if(e)var _=o?e(p,s,c,t,n,i):e(s,p,c,n,t,i);if(_!==T){if(_)continue;a=false;break}if(l){if(!h(t,function(n,t){if(!O(l,t)&&(s===n||u(s,n,r,e,i)))return l.push(t)})){a=false;break}}else if(s!==p&&!u(s,p,r,e,i)){a=false;break}}return i.delete(n),i.delete(t),a}function he(n,t,r,e,u,i,o){switch(r){case"[object DataView]":if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)break;n=n.buffer,t=t.buffer;case"[object ArrayBuffer]":
	if(n.byteLength!=t.byteLength||!i(new vi(n),new vi(t)))break;return true;case"[object Boolean]":case"[object Date]":case"[object Number]":return lu(+n,+t);case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object RegExp]":case"[object String]":return n==t+"";case"[object Map]":var f=W;case"[object Set]":if(f||(f=L),n.size!=t.size&&!(1&e))break;return(r=o.get(n))?r==t:(e|=2,o.set(n,t),t=se(f(n),f(t),e,u,i,o),o.delete(n),t);case"[object Symbol]":if(to)return to.call(n)==to.call(t)}
	return false}function pe(n){return xo(Ue(n,T,Ze),n+"")}function _e(n){return St(n,Wu,po)}function ve(n){return St(n,Uu,_o)}function ge(n){for(var t=n.name+"",r=Gi[t],e=oi.call(Gi,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function de(n){return(oi.call(An,"placeholder")?An:n).placeholder}function ye(){var n=An.iteratee||Fu,n=n===Fu?qt:n;return arguments.length?n(arguments[0],arguments[1]):n}function be(n,t){var r=n.__data__,e=typeof t;return("string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t)?r[typeof t=="string"?"string":"hash"]:r.map;
	}function xe(n){for(var t=Wu(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,u===u&&!du(u)]}return t}function je(n,t){var r=null==n?T:n[t];return Ft(r)?r:T}function we(n,t,r){t=Sr(t,n);for(var e=-1,u=t.length,i=false;++e<u;){var o=Me(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&gu(u)&&Se(o,u)&&(ff(n)||of(n)))}function me(n){var t=n.length,r=new n.constructor(t);return t&&"string"==typeof n[0]&&oi.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Ae(n){
	return typeof n.constructor!="function"||ze(n)?{}:eo(di(n))}function ke(n,t,r){var e=n.constructor;switch(t){case"[object ArrayBuffer]":return Rr(n);case"[object Boolean]":case"[object Date]":return new e(+n);case"[object DataView]":return t=r?Rr(n.buffer):n.buffer,new n.constructor(t,n.byteOffset,n.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":
	case"[object Uint16Array]":case"[object Uint32Array]":return zr(n,r);case"[object Map]":return new e;case"[object Number]":case"[object String]":return new e(n);case"[object RegExp]":return t=new n.constructor(n.source,_n.exec(n)),t.lastIndex=n.lastIndex,t;case"[object Set]":return new e;case"[object Symbol]":return to?Qu(to.call(n)):{}}}function Ee(n){return ff(n)||of(n)||!!(ji&&n&&n[ji])}function Se(n,t){var r=typeof n;return t=null==t?9007199254740991:t,!!t&&("number"==r||"symbol"!=r&&bn.test(n))&&-1<n&&0==n%1&&n<t;
	}function Oe(n,t,r){if(!du(r))return false;var e=typeof t;return!!("number"==e?su(r)&&Se(t,r.length):"string"==e&&t in r)&&lu(r[t],n)}function Ie(n,t){if(ff(n))return false;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!wu(n))||(nn.test(n)||!X.test(n)||null!=t&&n in Qu(t))}function Re(n){var t=ge(n),r=An[t];return typeof r=="function"&&t in Ln.prototype&&(n===r||(t=ho(r),!!t&&n===t[0]))}function ze(n){var t=n&&n.constructor;return n===(typeof t=="function"&&t.prototype||ei)}function We(n,t){
	return function(r){return null!=r&&(r[n]===t&&(t!==T||n in Qu(r)))}}function Ue(t,r,e){return r=Li(r===T?t.length-1:r,0),function(){for(var u=arguments,i=-1,o=Li(u.length-r,0),f=Ku(o);++i<o;)f[i]=u[r+i];for(i=-1,o=Ku(r+1);++i<r;)o[i]=u[i];return o[r]=e(f),n(t,this,o)}}function Be(n,t){if("__proto__"!=t)return n[t]}function Le(n,t,r){var e=t+"";t=xo;var u,i=$e;return u=(u=e.match(an))?u[1].split(ln):[],r=i(u,r),(i=r.length)&&(u=i-1,r[u]=(1<i?"& ":"")+r[u],r=r.join(2<i?", ":" "),e=e.replace(cn,"{\n/* [wrapped with "+r+"] */\n")),
	t(n,e)}function Ce(n){var t=0,r=0;return function(){var e=Di(),u=16-(e-r);if(r=e,0<u){if(800<=++t)return arguments[0]}else t=0;return n.apply(T,arguments)}}function De(n,t){var r=-1,e=n.length,u=e-1;for(t=t===T?e:t;++r<t;){var e=ir(r,u),i=n[e];n[e]=n[r],n[r]=i}return n.length=t,n}function Me(n){if(typeof n=="string"||wu(n))return n;var t=n+"";return"0"==t&&1/n==-$?"-0":t}function Te(n){if(null!=n){try{return ii.call(n)}catch(n){}return n+""}return""}function $e(n,t){return r(N,function(r){var e="_."+r[0];
	t&r[1]&&!o(n,e)&&n.push(e)}),n.sort()}function Fe(n){if(n instanceof Ln)return n.clone();var t=new On(n.__wrapped__,n.__chain__);return t.__actions__=Lr(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Ne(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:ku(r),0>r&&(r=Li(e+r,0)),_(n,ye(t,3),r)):-1}function Pe(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==T&&(u=ku(r),u=0>r?Li(e+u,0):Ci(u,e-1)),_(n,ye(t,3),u,true)}function Ze(n){return(null==n?0:n.length)?wt(n,1):[];
	}function qe(n){return n&&n.length?n[0]:T}function Ve(n){var t=null==n?0:n.length;return t?n[t-1]:T}function Ke(n,t){return n&&n.length&&t&&t.length?er(n,t):n}function Ge(n){return null==n?n:$i.call(n)}function He(n){if(!n||!n.length)return[];var t=0;return n=i(n,function(n){if(hu(n))return t=Li(n.length,t),true}),A(t,function(t){return c(n,b(t))})}function Je(t,r){if(!t||!t.length)return[];var e=He(t);return null==r?e:c(e,function(t){return n(r,T,t)})}function Ye(n){return n=An(n),n.__chain__=true,n;
	}function Qe(n,t){return t(n)}function Xe(){return this}function nu(n,t){return(ff(n)?r:uo)(n,ye(t,3))}function tu(n,t){return(ff(n)?e:io)(n,ye(t,3))}function ru(n,t){return(ff(n)?c:Gt)(n,ye(t,3))}function eu(n,t,r){return t=r?T:t,t=n&&null==t?n.length:t,fe(n,128,T,T,T,T,t)}function uu(n,t){var r;if(typeof t!="function")throw new ti("Expected a function");return n=ku(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=T),r}}function iu(n,t,r){return t=r?T:t,n=fe(n,8,T,T,T,T,T,t),n.placeholder=iu.placeholder,
	n}function ou(n,t,r){return t=r?T:t,n=fe(n,16,T,T,T,T,T,t),n.placeholder=ou.placeholder,n}function fu(n,t,r){function e(t){var r=c,e=a;return c=a=T,_=t,s=n.apply(e,r)}function u(n){var r=n-p;return n-=_,p===T||r>=t||0>r||g&&n>=l}function i(){var n=Go();if(u(n))return o(n);var r,e=bo;r=n-_,n=t-(n-p),r=g?Ci(n,l-r):n,h=e(i,r)}function o(n){return h=T,d&&c?e(n):(c=a=T,s)}function f(){var n=Go(),r=u(n);if(c=arguments,a=this,p=n,r){if(h===T)return _=n=p,h=bo(i,t),v?e(n):s;if(g)return h=bo(i,t),e(p)}return h===T&&(h=bo(i,t)),
	s}var c,a,l,s,h,p,_=0,v=false,g=false,d=true;if(typeof n!="function")throw new ti("Expected a function");return t=Su(t)||0,du(r)&&(v=!!r.leading,l=(g="maxWait"in r)?Li(Su(r.maxWait)||0,t):l,d="trailing"in r?!!r.trailing:d),f.cancel=function(){h!==T&&lo(h),_=0,c=p=a=h=T},f.flush=function(){return h===T?s:o(Go())},f}function cu(n,t){if(typeof n!="function"||null!=t&&typeof t!="function")throw new ti("Expected a function");var r=function(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;return i.has(u)?i.get(u):(e=n.apply(this,e),
	r.cache=i.set(u,e)||i,e)};return r.cache=new(cu.Cache||Fn),r}function au(n){if(typeof n!="function")throw new ti("Expected a function");return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function lu(n,t){return n===t||n!==n&&t!==t}function su(n){return null!=n&&gu(n.length)&&!_u(n)}function hu(n){return yu(n)&&su(n)}function pu(n){if(!yu(n))return false;
	var t=Ot(n);return"[object Error]"==t||"[object DOMException]"==t||typeof n.message=="string"&&typeof n.name=="string"&&!xu(n)}function _u(n){return!!du(n)&&(n=Ot(n),"[object Function]"==n||"[object GeneratorFunction]"==n||"[object AsyncFunction]"==n||"[object Proxy]"==n)}function vu(n){return typeof n=="number"&&n==ku(n)}function gu(n){return typeof n=="number"&&-1<n&&0==n%1&&9007199254740991>=n}function du(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)}function yu(n){return null!=n&&typeof n=="object";
	}function bu(n){return typeof n=="number"||yu(n)&&"[object Number]"==Ot(n)}function xu(n){return!(!yu(n)||"[object Object]"!=Ot(n))&&(n=di(n),null===n||(n=oi.call(n,"constructor")&&n.constructor,typeof n=="function"&&n instanceof n&&ii.call(n)==li))}function ju(n){return typeof n=="string"||!ff(n)&&yu(n)&&"[object String]"==Ot(n)}function wu(n){return typeof n=="symbol"||yu(n)&&"[object Symbol]"==Ot(n)}function mu(n){if(!n)return[];if(su(n))return ju(n)?M(n):Lr(n);if(wi&&n[wi]){n=n[wi]();for(var t,r=[];!(t=n.next()).done;)r.push(t.value);
	return r}return t=vo(n),("[object Map]"==t?W:"[object Set]"==t?L:Lu)(n)}function Au(n){return n?(n=Su(n),n===$||n===-$?1.7976931348623157e308*(0>n?-1:1):n===n?n:0):0===n?n:0}function ku(n){n=Au(n);var t=n%1;return n===n?t?n-t:n:0}function Eu(n){return n?pt(ku(n),0,4294967295):0}function Su(n){if(typeof n=="number")return n;if(wu(n))return F;if(du(n)&&(n=typeof n.valueOf=="function"?n.valueOf():n,n=du(n)?n+"":n),typeof n!="string")return 0===n?n:+n;n=n.replace(un,"");var t=gn.test(n);return t||yn.test(n)?Dn(n.slice(2),t?2:8):vn.test(n)?F:+n;
	}function Ou(n){return Cr(n,Uu(n))}function Iu(n){return null==n?"":yr(n)}function Ru(n,t,r){return n=null==n?T:Et(n,t),n===T?r:n}function zu(n,t){return null!=n&&we(n,t,zt)}function Wu(n){return su(n)?qn(n):Vt(n)}function Uu(n){if(su(n))n=qn(n,true);else if(du(n)){var t,r=ze(n),e=[];for(t in n)("constructor"!=t||!r&&oi.call(n,t))&&e.push(t);n=e}else{if(t=[],null!=n)for(r in Qu(n))t.push(r);n=t}return n}function Bu(n,t){if(null==n)return{};var r=c(ve(n),function(n){return[n]});return t=ye(t),tr(n,r,function(n,r){
	return t(n,r[0])})}function Lu(n){return null==n?[]:S(n,Wu(n))}function Cu(n){return $f(Iu(n).toLowerCase())}function Du(n){return(n=Iu(n))&&n.replace(xn,Xn).replace(Sn,"")}function Mu(n,t,r){return n=Iu(n),t=r?T:t,t===T?zn.test(n)?n.match(In)||[]:n.match(sn)||[]:n.match(t)||[]}function Tu(n){return function(){return n}}function $u(n){return n}function Fu(n){return qt(typeof n=="function"?n:_t(n,1))}function Nu(n,t,e){var u=Wu(t),i=kt(t,u);null!=e||du(t)&&(i.length||!u.length)||(e=t,t=n,n=this,i=kt(t,Wu(t)));
	var o=!(du(e)&&"chain"in e&&!e.chain),f=_u(n);return r(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Lr(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,a([this.value()],arguments))})}),n}function Pu(){}function Zu(n){return Ie(n)?b(Me(n)):rr(n)}function qu(){return[]}function Vu(){return false}mn=null==mn?$n:rt.defaults($n.Object(),mn,rt.pick($n,Wn));var Ku=mn.Array,Gu=mn.Date,Hu=mn.Error,Ju=mn.Function,Yu=mn.Math,Qu=mn.Object,Xu=mn.RegExp,ni=mn.String,ti=mn.TypeError,ri=Ku.prototype,ei=Qu.prototype,ui=mn["__core-js_shared__"],ii=Ju.prototype.toString,oi=ei.hasOwnProperty,fi=0,ci=function(){
	var n=/[^.]+$/.exec(ui&&ui.keys&&ui.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),ai=ei.toString,li=ii.call(Qu),si=$n._,hi=Xu("^"+ii.call(oi).replace(rn,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),pi=Pn?mn.Buffer:T,_i=mn.Symbol,vi=mn.Uint8Array,gi=pi?pi.allocUnsafe:T,di=U(Qu.getPrototypeOf,Qu),yi=Qu.create,bi=ei.propertyIsEnumerable,xi=ri.splice,ji=_i?_i.isConcatSpreadable:T,wi=_i?_i.iterator:T,mi=_i?_i.toStringTag:T,Ai=function(){try{var n=je(Qu,"defineProperty");
	return n({},"",{}),n}catch(n){}}(),ki=mn.clearTimeout!==$n.clearTimeout&&mn.clearTimeout,Ei=Gu&&Gu.now!==$n.Date.now&&Gu.now,Si=mn.setTimeout!==$n.setTimeout&&mn.setTimeout,Oi=Yu.ceil,Ii=Yu.floor,Ri=Qu.getOwnPropertySymbols,zi=pi?pi.isBuffer:T,Wi=mn.isFinite,Ui=ri.join,Bi=U(Qu.keys,Qu),Li=Yu.max,Ci=Yu.min,Di=Gu.now,Mi=mn.parseInt,Ti=Yu.random,$i=ri.reverse,Fi=je(mn,"DataView"),Ni=je(mn,"Map"),Pi=je(mn,"Promise"),Zi=je(mn,"Set"),qi=je(mn,"WeakMap"),Vi=je(Qu,"create"),Ki=qi&&new qi,Gi={},Hi=Te(Fi),Ji=Te(Ni),Yi=Te(Pi),Qi=Te(Zi),Xi=Te(qi),no=_i?_i.prototype:T,to=no?no.valueOf:T,ro=no?no.toString:T,eo=function(){
	function n(){}return function(t){return du(t)?yi?yi(t):(n.prototype=t,t=new n,n.prototype=T,t):{}}}();An.templateSettings={escape:J,evaluate:Y,interpolate:Q,variable:"",imports:{_:An}},An.prototype=kn.prototype,An.prototype.constructor=An,On.prototype=eo(kn.prototype),On.prototype.constructor=On,Ln.prototype=eo(kn.prototype),Ln.prototype.constructor=Ln,Mn.prototype.clear=function(){this.__data__=Vi?Vi(null):{},this.size=0},Mn.prototype.delete=function(n){return n=this.has(n)&&delete this.__data__[n],
	this.size-=n?1:0,n},Mn.prototype.get=function(n){var t=this.__data__;return Vi?(n=t[n],"__lodash_hash_undefined__"===n?T:n):oi.call(t,n)?t[n]:T},Mn.prototype.has=function(n){var t=this.__data__;return Vi?t[n]!==T:oi.call(t,n)},Mn.prototype.set=function(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=Vi&&t===T?"__lodash_hash_undefined__":t,this},Tn.prototype.clear=function(){this.__data__=[],this.size=0},Tn.prototype.delete=function(n){var t=this.__data__;return n=ft(t,n),!(0>n)&&(n==t.length-1?t.pop():xi.call(t,n,1),
	--this.size,true)},Tn.prototype.get=function(n){var t=this.__data__;return n=ft(t,n),0>n?T:t[n][1]},Tn.prototype.has=function(n){return-1<ft(this.__data__,n)},Tn.prototype.set=function(n,t){var r=this.__data__,e=ft(r,n);return 0>e?(++this.size,r.push([n,t])):r[e][1]=t,this},Fn.prototype.clear=function(){this.size=0,this.__data__={hash:new Mn,map:new(Ni||Tn),string:new Mn}},Fn.prototype.delete=function(n){return n=be(this,n).delete(n),this.size-=n?1:0,n},Fn.prototype.get=function(n){return be(this,n).get(n);
	},Fn.prototype.has=function(n){return be(this,n).has(n)},Fn.prototype.set=function(n,t){var r=be(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this},Nn.prototype.add=Nn.prototype.push=function(n){return this.__data__.set(n,"__lodash_hash_undefined__"),this},Nn.prototype.has=function(n){return this.__data__.has(n)},Zn.prototype.clear=function(){this.__data__=new Tn,this.size=0},Zn.prototype.delete=function(n){var t=this.__data__;return n=t.delete(n),this.size=t.size,n},Zn.prototype.get=function(n){
	return this.__data__.get(n)},Zn.prototype.has=function(n){return this.__data__.has(n)},Zn.prototype.set=function(n,t){var r=this.__data__;if(r instanceof Tn){var e=r.__data__;if(!Ni||199>e.length)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new Fn(e)}return r.set(n,t),this.size=r.size,this};var uo=Fr(mt),io=Fr(At,true),oo=Nr(),fo=Nr(true),co=Ki?function(n,t){return Ki.set(n,t),n}:$u,ao=Ai?function(n,t){return Ai(n,"toString",{configurable:true,enumerable:false,value:Tu(t),writable:true})}:$u,lo=ki||function(n){
	return $n.clearTimeout(n)},so=Zi&&1/L(new Zi([,-0]))[1]==$?function(n){return new Zi(n)}:Pu,ho=Ki?function(n){return Ki.get(n)}:Pu,po=Ri?function(n){return null==n?[]:(n=Qu(n),i(Ri(n),function(t){return bi.call(n,t)}))}:qu,_o=Ri?function(n){for(var t=[];n;)a(t,po(n)),n=di(n);return t}:qu,vo=Ot;(Fi&&"[object DataView]"!=vo(new Fi(new ArrayBuffer(1)))||Ni&&"[object Map]"!=vo(new Ni)||Pi&&"[object Promise]"!=vo(Pi.resolve())||Zi&&"[object Set]"!=vo(new Zi)||qi&&"[object WeakMap]"!=vo(new qi))&&(vo=function(n){
	var t=Ot(n);if(n=(n="[object Object]"==t?n.constructor:T)?Te(n):"")switch(n){case Hi:return"[object DataView]";case Ji:return"[object Map]";case Yi:return"[object Promise]";case Qi:return"[object Set]";case Xi:return"[object WeakMap]"}return t});var go=ui?_u:Vu,yo=Ce(co),bo=Si||function(n,t){return $n.setTimeout(n,t)},xo=Ce(ao),jo=function(n){n=cu(n,function(n){return 500===t.size&&t.clear(),n});var t=n.cache;return n}(function(n){var t=[];return 46===n.charCodeAt(0)&&t.push(""),n.replace(tn,function(n,r,e,u){
	t.push(e?u.replace(hn,"$1"):r||n)}),t}),wo=fr(function(n,t){return hu(n)?yt(n,wt(t,1,hu,true)):[]}),mo=fr(function(n,t){var r=Ve(t);return hu(r)&&(r=T),hu(n)?yt(n,wt(t,1,hu,true),ye(r,2)):[]}),Ao=fr(function(n,t){var r=Ve(t);return hu(r)&&(r=T),hu(n)?yt(n,wt(t,1,hu,true),T,r):[]}),ko=fr(function(n){var t=c(n,kr);return t.length&&t[0]===n[0]?Wt(t):[]}),Eo=fr(function(n){var t=Ve(n),r=c(n,kr);return t===Ve(r)?t=T:r.pop(),r.length&&r[0]===n[0]?Wt(r,ye(t,2)):[]}),So=fr(function(n){var t=Ve(n),r=c(n,kr);return(t=typeof t=="function"?t:T)&&r.pop(),
	r.length&&r[0]===n[0]?Wt(r,T,t):[]}),Oo=fr(Ke),Io=pe(function(n,t){var r=null==n?0:n.length,e=ht(n,t);return ur(n,c(t,function(n){return Se(n,r)?+n:n}).sort(Wr)),e}),Ro=fr(function(n){return br(wt(n,1,hu,true))}),zo=fr(function(n){var t=Ve(n);return hu(t)&&(t=T),br(wt(n,1,hu,true),ye(t,2))}),Wo=fr(function(n){var t=Ve(n),t=typeof t=="function"?t:T;return br(wt(n,1,hu,true),T,t)}),Uo=fr(function(n,t){return hu(n)?yt(n,t):[]}),Bo=fr(function(n){return mr(i(n,hu))}),Lo=fr(function(n){var t=Ve(n);return hu(t)&&(t=T),
	mr(i(n,hu),ye(t,2))}),Co=fr(function(n){var t=Ve(n),t=typeof t=="function"?t:T;return mr(i(n,hu),T,t)}),Do=fr(He),Mo=fr(function(n){var t=n.length,t=1<t?n[t-1]:T,t=typeof t=="function"?(n.pop(),t):T;return Je(n,t)}),To=pe(function(n){var t=n.length,r=t?n[0]:0,e=this.__wrapped__,u=function(t){return ht(t,n)};return!(1<t||this.__actions__.length)&&e instanceof Ln&&Se(r)?(e=e.slice(r,+r+(t?1:0)),e.__actions__.push({func:Qe,args:[u],thisArg:T}),new On(e,this.__chain__).thru(function(n){return t&&!n.length&&n.push(T),
	n})):this.thru(u)}),$o=Tr(function(n,t,r){oi.call(n,r)?++n[r]:st(n,r,1)}),Fo=Gr(Ne),No=Gr(Pe),Po=Tr(function(n,t,r){oi.call(n,r)?n[r].push(t):st(n,r,[t])}),Zo=fr(function(t,r,e){var u=-1,i=typeof r=="function",o=su(t)?Ku(t.length):[];return uo(t,function(t){o[++u]=i?n(r,t,e):Bt(t,r,e)}),o}),qo=Tr(function(n,t,r){st(n,r,t)}),Vo=Tr(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),Ko=fr(function(n,t){if(null==n)return[];var r=t.length;return 1<r&&Oe(n,t[0],t[1])?t=[]:2<r&&Oe(t[0],t[1],t[2])&&(t=[t[0]]),
	Xt(n,wt(t,1),[])}),Go=Ei||function(){return $n.Date.now()},Ho=fr(function(n,t,r){var e=1;if(r.length)var u=B(r,de(Ho)),e=32|e;return fe(n,e,t,r,u)}),Jo=fr(function(n,t,r){var e=3;if(r.length)var u=B(r,de(Jo)),e=32|e;return fe(t,e,n,r,u)}),Yo=fr(function(n,t){return dt(n,1,t)}),Qo=fr(function(n,t,r){return dt(n,Su(t)||0,r)});cu.Cache=Fn;var Xo=fr(function(t,r){r=1==r.length&&ff(r[0])?c(r[0],E(ye())):c(wt(r,1),E(ye()));var e=r.length;return fr(function(u){for(var i=-1,o=Ci(u.length,e);++i<o;)u[i]=r[i].call(this,u[i]);
	return n(t,this,u)})}),nf=fr(function(n,t){return fe(n,32,T,t,B(t,de(nf)))}),tf=fr(function(n,t){return fe(n,64,T,t,B(t,de(tf)))}),rf=pe(function(n,t){return fe(n,256,T,T,T,t)}),ef=ee(It),uf=ee(function(n,t){return n>=t}),of=Lt(function(){return arguments}())?Lt:function(n){return yu(n)&&oi.call(n,"callee")&&!bi.call(n,"callee")},ff=Ku.isArray,cf=Vn?E(Vn):Ct,af=zi||Vu,lf=Kn?E(Kn):Dt,sf=Gn?E(Gn):Tt,hf=Hn?E(Hn):Nt,pf=Jn?E(Jn):Pt,_f=Yn?E(Yn):Zt,vf=ee(Kt),gf=ee(function(n,t){return n<=t}),df=$r(function(n,t){
	if(ze(t)||su(t))Cr(t,Wu(t),n);else for(var r in t)oi.call(t,r)&&ot(n,r,t[r])}),yf=$r(function(n,t){Cr(t,Uu(t),n)}),bf=$r(function(n,t,r,e){Cr(t,Uu(t),n,e)}),xf=$r(function(n,t,r,e){Cr(t,Wu(t),n,e)}),jf=pe(ht),wf=fr(function(n,t){n=Qu(n);var r=-1,e=t.length,u=2<e?t[2]:T;for(u&&Oe(t[0],t[1],u)&&(e=1);++r<e;)for(var u=t[r],i=Uu(u),o=-1,f=i.length;++o<f;){var c=i[o],a=n[c];(a===T||lu(a,ei[c])&&!oi.call(n,c))&&(n[c]=u[c])}return n}),mf=fr(function(t){return t.push(T,ae),n(Of,T,t)}),Af=Yr(function(n,t,r){
	null!=t&&typeof t.toString!="function"&&(t=ai.call(t)),n[t]=r},Tu($u)),kf=Yr(function(n,t,r){null!=t&&typeof t.toString!="function"&&(t=ai.call(t)),oi.call(n,t)?n[t].push(r):n[t]=[r]},ye),Ef=fr(Bt),Sf=$r(function(n,t,r){Yt(n,t,r)}),Of=$r(function(n,t,r,e){Yt(n,t,r,e)}),If=pe(function(n,t){var r={};if(null==n)return r;var e=false;t=c(t,function(t){return t=Sr(t,n),e||(e=1<t.length),t}),Cr(n,ve(n),r),e&&(r=_t(r,7,le));for(var u=t.length;u--;)xr(r,t[u]);return r}),Rf=pe(function(n,t){return null==n?{}:nr(n,t);
	}),zf=oe(Wu),Wf=oe(Uu),Uf=qr(function(n,t,r){return t=t.toLowerCase(),n+(r?Cu(t):t)}),Bf=qr(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Lf=qr(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Cf=Zr("toLowerCase"),Df=qr(function(n,t,r){return n+(r?"_":"")+t.toLowerCase()}),Mf=qr(function(n,t,r){return n+(r?" ":"")+$f(t)}),Tf=qr(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),$f=Zr("toUpperCase"),Ff=fr(function(t,r){try{return n(t,T,r)}catch(n){return pu(n)?n:new Hu(n)}}),Nf=pe(function(n,t){
	return r(t,function(t){t=Me(t),st(n,t,Ho(n[t],n))}),n}),Pf=Hr(),Zf=Hr(true),qf=fr(function(n,t){return function(r){return Bt(r,n,t)}}),Vf=fr(function(n,t){return function(r){return Bt(n,r,t)}}),Kf=Xr(c),Gf=Xr(u),Hf=Xr(h),Jf=re(),Yf=re(true),Qf=Qr(function(n,t){return n+t},0),Xf=ie("ceil"),nc=Qr(function(n,t){return n/t},1),tc=ie("floor"),rc=Qr(function(n,t){return n*t},1),ec=ie("round"),uc=Qr(function(n,t){return n-t},0);return An.after=function(n,t){if(typeof t!="function")throw new ti("Expected a function");
	return n=ku(n),function(){if(1>--n)return t.apply(this,arguments)}},An.ary=eu,An.assign=df,An.assignIn=yf,An.assignInWith=bf,An.assignWith=xf,An.at=jf,An.before=uu,An.bind=Ho,An.bindAll=Nf,An.bindKey=Jo,An.castArray=function(){if(!arguments.length)return[];var n=arguments[0];return ff(n)?n:[n]},An.chain=Ye,An.chunk=function(n,t,r){if(t=(r?Oe(n,t,r):t===T)?1:Li(ku(t),0),r=null==n?0:n.length,!r||1>t)return[];for(var e=0,u=0,i=Ku(Oi(r/t));e<r;)i[u++]=hr(n,e,e+=t);return i},An.compact=function(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){
	var i=n[t];i&&(u[e++]=i)}return u},An.concat=function(){var n=arguments.length;if(!n)return[];for(var t=Ku(n-1),r=arguments[0];n--;)t[n-1]=arguments[n];return a(ff(r)?Lr(r):[r],wt(t,1))},An.cond=function(t){var r=null==t?0:t.length,e=ye();return t=r?c(t,function(n){if("function"!=typeof n[1])throw new ti("Expected a function");return[e(n[0]),n[1]]}):[],fr(function(e){for(var u=-1;++u<r;){var i=t[u];if(n(i[0],this,e))return n(i[1],this,e)}})},An.conforms=function(n){return vt(_t(n,1))},An.constant=Tu,
	An.countBy=$o,An.create=function(n,t){var r=eo(n);return null==t?r:at(r,t)},An.curry=iu,An.curryRight=ou,An.debounce=fu,An.defaults=wf,An.defaultsDeep=mf,An.defer=Yo,An.delay=Qo,An.difference=wo,An.differenceBy=mo,An.differenceWith=Ao,An.drop=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:ku(t),hr(n,0>t?0:t,e)):[]},An.dropRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:ku(t),t=e-t,hr(n,0,0>t?0:t)):[]},An.dropRightWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),true,true):[];
	},An.dropWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),true):[]},An.fill=function(n,t,r,e){var u=null==n?0:n.length;if(!u)return[];for(r&&typeof r!="number"&&Oe(n,t,r)&&(r=0,e=u),u=n.length,r=ku(r),0>r&&(r=-r>u?0:u+r),e=e===T||e>u?u:ku(e),0>e&&(e+=u),e=r>e?0:Eu(e);r<e;)n[r++]=t;return n},An.filter=function(n,t){return(ff(n)?i:jt)(n,ye(t,3))},An.flatMap=function(n,t){return wt(ru(n,t),1)},An.flatMapDeep=function(n,t){return wt(ru(n,t),$)},An.flatMapDepth=function(n,t,r){return r=r===T?1:ku(r),
	wt(ru(n,t),r)},An.flatten=Ze,An.flattenDeep=function(n){return(null==n?0:n.length)?wt(n,$):[]},An.flattenDepth=function(n,t){return null!=n&&n.length?(t=t===T?1:ku(t),wt(n,t)):[]},An.flip=function(n){return fe(n,512)},An.flow=Pf,An.flowRight=Zf,An.fromPairs=function(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){var u=n[t];e[u[0]]=u[1]}return e},An.functions=function(n){return null==n?[]:kt(n,Wu(n))},An.functionsIn=function(n){return null==n?[]:kt(n,Uu(n))},An.groupBy=Po,An.initial=function(n){
	return(null==n?0:n.length)?hr(n,0,-1):[]},An.intersection=ko,An.intersectionBy=Eo,An.intersectionWith=So,An.invert=Af,An.invertBy=kf,An.invokeMap=Zo,An.iteratee=Fu,An.keyBy=qo,An.keys=Wu,An.keysIn=Uu,An.map=ru,An.mapKeys=function(n,t){var r={};return t=ye(t,3),mt(n,function(n,e,u){st(r,t(n,e,u),n)}),r},An.mapValues=function(n,t){var r={};return t=ye(t,3),mt(n,function(n,e,u){st(r,e,t(n,e,u))}),r},An.matches=function(n){return Ht(_t(n,1))},An.matchesProperty=function(n,t){return Jt(n,_t(t,1))},An.memoize=cu,
	An.merge=Sf,An.mergeWith=Of,An.method=qf,An.methodOf=Vf,An.mixin=Nu,An.negate=au,An.nthArg=function(n){return n=ku(n),fr(function(t){return Qt(t,n)})},An.omit=If,An.omitBy=function(n,t){return Bu(n,au(ye(t)))},An.once=function(n){return uu(2,n)},An.orderBy=function(n,t,r,e){return null==n?[]:(ff(t)||(t=null==t?[]:[t]),r=e?T:r,ff(r)||(r=null==r?[]:[r]),Xt(n,t,r))},An.over=Kf,An.overArgs=Xo,An.overEvery=Gf,An.overSome=Hf,An.partial=nf,An.partialRight=tf,An.partition=Vo,An.pick=Rf,An.pickBy=Bu,An.property=Zu,
	An.propertyOf=function(n){return function(t){return null==n?T:Et(n,t)}},An.pull=Oo,An.pullAll=Ke,An.pullAllBy=function(n,t,r){return n&&n.length&&t&&t.length?er(n,t,ye(r,2)):n},An.pullAllWith=function(n,t,r){return n&&n.length&&t&&t.length?er(n,t,T,r):n},An.pullAt=Io,An.range=Jf,An.rangeRight=Yf,An.rearg=rf,An.reject=function(n,t){return(ff(n)?i:jt)(n,au(ye(t,3)))},An.remove=function(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=ye(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),
	u.push(e))}return ur(n,u),r},An.rest=function(n,t){if(typeof n!="function")throw new ti("Expected a function");return t=t===T?t:ku(t),fr(n,t)},An.reverse=Ge,An.sampleSize=function(n,t,r){return t=(r?Oe(n,t,r):t===T)?1:ku(t),(ff(n)?et:ar)(n,t)},An.set=function(n,t,r){return null==n?n:lr(n,t,r)},An.setWith=function(n,t,r,e){return e=typeof e=="function"?e:T,null==n?n:lr(n,t,r,e)},An.shuffle=function(n){return(ff(n)?ut:sr)(n)},An.slice=function(n,t,r){var e=null==n?0:n.length;return e?(r&&typeof r!="number"&&Oe(n,t,r)?(t=0,
	r=e):(t=null==t?0:ku(t),r=r===T?e:ku(r)),hr(n,t,r)):[]},An.sortBy=Ko,An.sortedUniq=function(n){return n&&n.length?gr(n):[]},An.sortedUniqBy=function(n,t){return n&&n.length?gr(n,ye(t,2)):[]},An.split=function(n,t,r){return r&&typeof r!="number"&&Oe(n,t,r)&&(t=r=T),r=r===T?4294967295:r>>>0,r?(n=Iu(n))&&(typeof t=="string"||null!=t&&!hf(t))&&(t=yr(t),!t&&Rn.test(n))?Or(M(n),0,r):n.split(t,r):[]},An.spread=function(t,r){if(typeof t!="function")throw new ti("Expected a function");return r=null==r?0:Li(ku(r),0),
	fr(function(e){var u=e[r];return e=Or(e,0,r),u&&a(e,u),n(t,this,e)})},An.tail=function(n){var t=null==n?0:n.length;return t?hr(n,1,t):[]},An.take=function(n,t,r){return n&&n.length?(t=r||t===T?1:ku(t),hr(n,0,0>t?0:t)):[]},An.takeRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:ku(t),t=e-t,hr(n,0>t?0:t,e)):[]},An.takeRightWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),false,true):[]},An.takeWhile=function(n,t){return n&&n.length?jr(n,ye(t,3)):[]},An.tap=function(n,t){return t(n),
	n},An.throttle=function(n,t,r){var e=true,u=true;if(typeof n!="function")throw new ti("Expected a function");return du(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),fu(n,t,{leading:e,maxWait:t,trailing:u})},An.thru=Qe,An.toArray=mu,An.toPairs=zf,An.toPairsIn=Wf,An.toPath=function(n){return ff(n)?c(n,Me):wu(n)?[n]:Lr(jo(Iu(n)))},An.toPlainObject=Ou,An.transform=function(n,t,e){var u=ff(n),i=u||af(n)||_f(n);if(t=ye(t,4),null==e){var o=n&&n.constructor;e=i?u?new o:[]:du(n)&&_u(o)?eo(di(n)):{};
	}return(i?r:mt)(n,function(n,r,u){return t(e,n,r,u)}),e},An.unary=function(n){return eu(n,1)},An.union=Ro,An.unionBy=zo,An.unionWith=Wo,An.uniq=function(n){return n&&n.length?br(n):[]},An.uniqBy=function(n,t){return n&&n.length?br(n,ye(t,2)):[]},An.uniqWith=function(n,t){return t=typeof t=="function"?t:T,n&&n.length?br(n,T,t):[]},An.unset=function(n,t){return null==n||xr(n,t)},An.unzip=He,An.unzipWith=Je,An.update=function(n,t,r){return null!=n&&(r=Er(r),n=lr(n,t,r(Et(n,t)),void 0)),n},An.updateWith=function(n,t,r,e){
	return e=typeof e=="function"?e:T,null!=n&&(r=Er(r),n=lr(n,t,r(Et(n,t)),e)),n},An.values=Lu,An.valuesIn=function(n){return null==n?[]:S(n,Uu(n))},An.without=Uo,An.words=Mu,An.wrap=function(n,t){return nf(Er(t),n)},An.xor=Bo,An.xorBy=Lo,An.xorWith=Co,An.zip=Do,An.zipObject=function(n,t){return Ar(n||[],t||[],ot)},An.zipObjectDeep=function(n,t){return Ar(n||[],t||[],lr)},An.zipWith=Mo,An.entries=zf,An.entriesIn=Wf,An.extend=yf,An.extendWith=bf,Nu(An,An),An.add=Qf,An.attempt=Ff,An.camelCase=Uf,An.capitalize=Cu,
	An.ceil=Xf,An.clamp=function(n,t,r){return r===T&&(r=t,t=T),r!==T&&(r=Su(r),r=r===r?r:0),t!==T&&(t=Su(t),t=t===t?t:0),pt(Su(n),t,r)},An.clone=function(n){return _t(n,4)},An.cloneDeep=function(n){return _t(n,5)},An.cloneDeepWith=function(n,t){return t=typeof t=="function"?t:T,_t(n,5,t)},An.cloneWith=function(n,t){return t=typeof t=="function"?t:T,_t(n,4,t)},An.conformsTo=function(n,t){return null==t||gt(n,t,Wu(t))},An.deburr=Du,An.defaultTo=function(n,t){return null==n||n!==n?t:n},An.divide=nc,An.endsWith=function(n,t,r){
	n=Iu(n),t=yr(t);var e=n.length,e=r=r===T?e:pt(ku(r),0,e);return r-=t.length,0<=r&&n.slice(r,e)==t},An.eq=lu,An.escape=function(n){return(n=Iu(n))&&H.test(n)?n.replace(K,nt):n},An.escapeRegExp=function(n){return(n=Iu(n))&&en.test(n)?n.replace(rn,"\\$&"):n},An.every=function(n,t,r){var e=ff(n)?u:bt;return r&&Oe(n,t,r)&&(t=T),e(n,ye(t,3))},An.find=Fo,An.findIndex=Ne,An.findKey=function(n,t){return p(n,ye(t,3),mt)},An.findLast=No,An.findLastIndex=Pe,An.findLastKey=function(n,t){return p(n,ye(t,3),At);
	},An.floor=tc,An.forEach=nu,An.forEachRight=tu,An.forIn=function(n,t){return null==n?n:oo(n,ye(t,3),Uu)},An.forInRight=function(n,t){return null==n?n:fo(n,ye(t,3),Uu)},An.forOwn=function(n,t){return n&&mt(n,ye(t,3))},An.forOwnRight=function(n,t){return n&&At(n,ye(t,3))},An.get=Ru,An.gt=ef,An.gte=uf,An.has=function(n,t){return null!=n&&we(n,t,Rt)},An.hasIn=zu,An.head=qe,An.identity=$u,An.includes=function(n,t,r,e){return n=su(n)?n:Lu(n),r=r&&!e?ku(r):0,e=n.length,0>r&&(r=Li(e+r,0)),ju(n)?r<=e&&-1<n.indexOf(t,r):!!e&&-1<v(n,t,r);
	},An.indexOf=function(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:ku(r),0>r&&(r=Li(e+r,0)),v(n,t,r)):-1},An.inRange=function(n,t,r){return t=Au(t),r===T?(r=t,t=0):r=Au(r),n=Su(n),n>=Ci(t,r)&&n<Li(t,r)},An.invoke=Ef,An.isArguments=of,An.isArray=ff,An.isArrayBuffer=cf,An.isArrayLike=su,An.isArrayLikeObject=hu,An.isBoolean=function(n){return true===n||false===n||yu(n)&&"[object Boolean]"==Ot(n)},An.isBuffer=af,An.isDate=lf,An.isElement=function(n){return yu(n)&&1===n.nodeType&&!xu(n)},An.isEmpty=function(n){
	if(null==n)return true;if(su(n)&&(ff(n)||typeof n=="string"||typeof n.splice=="function"||af(n)||_f(n)||of(n)))return!n.length;var t=vo(n);if("[object Map]"==t||"[object Set]"==t)return!n.size;if(ze(n))return!Vt(n).length;for(var r in n)if(oi.call(n,r))return false;return true},An.isEqual=function(n,t){return Mt(n,t)},An.isEqualWith=function(n,t,r){var e=(r=typeof r=="function"?r:T)?r(n,t):T;return e===T?Mt(n,t,T,r):!!e},An.isError=pu,An.isFinite=function(n){return typeof n=="number"&&Wi(n)},An.isFunction=_u,
	An.isInteger=vu,An.isLength=gu,An.isMap=sf,An.isMatch=function(n,t){return n===t||$t(n,t,xe(t))},An.isMatchWith=function(n,t,r){return r=typeof r=="function"?r:T,$t(n,t,xe(t),r)},An.isNaN=function(n){return bu(n)&&n!=+n},An.isNative=function(n){if(go(n))throw new Hu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");return Ft(n)},An.isNil=function(n){return null==n},An.isNull=function(n){return null===n},An.isNumber=bu,An.isObject=du,An.isObjectLike=yu,An.isPlainObject=xu,An.isRegExp=hf,
	An.isSafeInteger=function(n){return vu(n)&&-9007199254740991<=n&&9007199254740991>=n},An.isSet=pf,An.isString=ju,An.isSymbol=wu,An.isTypedArray=_f,An.isUndefined=function(n){return n===T},An.isWeakMap=function(n){return yu(n)&&"[object WeakMap]"==vo(n)},An.isWeakSet=function(n){return yu(n)&&"[object WeakSet]"==Ot(n)},An.join=function(n,t){return null==n?"":Ui.call(n,t)},An.kebabCase=Bf,An.last=Ve,An.lastIndexOf=function(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;if(r!==T&&(u=ku(r),u=0>u?Li(e+u,0):Ci(u,e-1)),
	t===t)n:{for(r=u+1;r--;)if(n[r]===t){n=r;break n}n=r}else n=_(n,d,u,true);return n},An.lowerCase=Lf,An.lowerFirst=Cf,An.lt=vf,An.lte=gf,An.max=function(n){return n&&n.length?xt(n,$u,It):T},An.maxBy=function(n,t){return n&&n.length?xt(n,ye(t,2),It):T},An.mean=function(n){return y(n,$u)},An.meanBy=function(n,t){return y(n,ye(t,2))},An.min=function(n){return n&&n.length?xt(n,$u,Kt):T},An.minBy=function(n,t){return n&&n.length?xt(n,ye(t,2),Kt):T},An.stubArray=qu,An.stubFalse=Vu,An.stubObject=function(){
	return{}},An.stubString=function(){return""},An.stubTrue=function(){return true},An.multiply=rc,An.nth=function(n,t){return n&&n.length?Qt(n,ku(t)):T},An.noConflict=function(){return $n._===this&&($n._=si),this},An.noop=Pu,An.now=Go,An.pad=function(n,t,r){n=Iu(n);var e=(t=ku(t))?D(n):0;return!t||e>=t?n:(t=(t-e)/2,ne(Ii(t),r)+n+ne(Oi(t),r))},An.padEnd=function(n,t,r){n=Iu(n);var e=(t=ku(t))?D(n):0;return t&&e<t?n+ne(t-e,r):n},An.padStart=function(n,t,r){n=Iu(n);var e=(t=ku(t))?D(n):0;return t&&e<t?ne(t-e,r)+n:n;
	},An.parseInt=function(n,t,r){return r||null==t?t=0:t&&(t=+t),Mi(Iu(n).replace(on,""),t||0)},An.random=function(n,t,r){if(r&&typeof r!="boolean"&&Oe(n,t,r)&&(t=r=T),r===T&&(typeof t=="boolean"?(r=t,t=T):typeof n=="boolean"&&(r=n,n=T)),n===T&&t===T?(n=0,t=1):(n=Au(n),t===T?(t=n,n=0):t=Au(t)),n>t){var e=n;n=t,t=e}return r||n%1||t%1?(r=Ti(),Ci(n+r*(t-n+Cn("1e-"+((r+"").length-1))),t)):ir(n,t)},An.reduce=function(n,t,r){var e=ff(n)?l:j,u=3>arguments.length;return e(n,ye(t,4),r,u,uo)},An.reduceRight=function(n,t,r){
	var e=ff(n)?s:j,u=3>arguments.length;return e(n,ye(t,4),r,u,io)},An.repeat=function(n,t,r){return t=(r?Oe(n,t,r):t===T)?1:ku(t),or(Iu(n),t)},An.replace=function(){var n=arguments,t=Iu(n[0]);return 3>n.length?t:t.replace(n[1],n[2])},An.result=function(n,t,r){t=Sr(t,n);var e=-1,u=t.length;for(u||(u=1,n=T);++e<u;){var i=null==n?T:n[Me(t[e])];i===T&&(e=u,i=r),n=_u(i)?i.call(n):i}return n},An.round=ec,An.runInContext=x,An.sample=function(n){return(ff(n)?Qn:cr)(n)},An.size=function(n){if(null==n)return 0;
	if(su(n))return ju(n)?D(n):n.length;var t=vo(n);return"[object Map]"==t||"[object Set]"==t?n.size:Vt(n).length},An.snakeCase=Df,An.some=function(n,t,r){var e=ff(n)?h:pr;return r&&Oe(n,t,r)&&(t=T),e(n,ye(t,3))},An.sortedIndex=function(n,t){return _r(n,t)},An.sortedIndexBy=function(n,t,r){return vr(n,t,ye(r,2))},An.sortedIndexOf=function(n,t){var r=null==n?0:n.length;if(r){var e=_r(n,t);if(e<r&&lu(n[e],t))return e}return-1},An.sortedLastIndex=function(n,t){return _r(n,t,true)},An.sortedLastIndexBy=function(n,t,r){
	return vr(n,t,ye(r,2),true)},An.sortedLastIndexOf=function(n,t){if(null==n?0:n.length){var r=_r(n,t,true)-1;if(lu(n[r],t))return r}return-1},An.startCase=Mf,An.startsWith=function(n,t,r){return n=Iu(n),r=null==r?0:pt(ku(r),0,n.length),t=yr(t),n.slice(r,r+t.length)==t},An.subtract=uc,An.sum=function(n){return n&&n.length?m(n,$u):0},An.sumBy=function(n,t){return n&&n.length?m(n,ye(t,2)):0},An.template=function(n,t,r){var e=An.templateSettings;r&&Oe(n,t,r)&&(t=T),n=Iu(n),t=bf({},t,e,ce),r=bf({},t.imports,e.imports,ce);
	var u,i,o=Wu(r),f=S(r,o),c=0;r=t.interpolate||jn;var a="__p+='";r=Xu((t.escape||jn).source+"|"+r.source+"|"+(r===Q?pn:jn).source+"|"+(t.evaluate||jn).source+"|$","g");var l="sourceURL"in t?"//# sourceURL="+t.sourceURL+"\n":"";if(n.replace(r,function(t,r,e,o,f,l){return e||(e=o),a+=n.slice(c,l).replace(wn,z),r&&(u=true,a+="'+__e("+r+")+'"),f&&(i=true,a+="';"+f+";\n__p+='"),e&&(a+="'+((__t=("+e+"))==null?'':__t)+'"),c=l+t.length,t}),a+="';",(t=t.variable)||(a="with(obj){"+a+"}"),a=(i?a.replace(P,""):a).replace(Z,"$1").replace(q,"$1;"),
	a="function("+(t||"obj")+"){"+(t?"":"obj||(obj={});")+"var __t,__p=''"+(u?",__e=_.escape":"")+(i?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+a+"return __p}",t=Ff(function(){return Ju(o,l+"return "+a).apply(T,f)}),t.source=a,pu(t))throw t;return t},An.times=function(n,t){if(n=ku(n),1>n||9007199254740991<n)return[];var r=4294967295,e=Ci(n,4294967295);for(t=ye(t),n-=4294967295,e=A(e,t);++r<n;)t(r);return e},An.toFinite=Au,An.toInteger=ku,An.toLength=Eu,An.toLower=function(n){
	return Iu(n).toLowerCase()},An.toNumber=Su,An.toSafeInteger=function(n){return n?pt(ku(n),-9007199254740991,9007199254740991):0===n?n:0},An.toString=Iu,An.toUpper=function(n){return Iu(n).toUpperCase()},An.trim=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(un,""):n&&(t=yr(t))?(n=M(n),r=M(t),t=I(n,r),r=R(n,r)+1,Or(n,t,r).join("")):n},An.trimEnd=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(fn,""):n&&(t=yr(t))?(n=M(n),t=R(n,M(t))+1,Or(n,0,t).join("")):n},An.trimStart=function(n,t,r){
	return(n=Iu(n))&&(r||t===T)?n.replace(on,""):n&&(t=yr(t))?(n=M(n),t=I(n,M(t)),Or(n,t).join("")):n},An.truncate=function(n,t){var r=30,e="...";if(du(t))var u="separator"in t?t.separator:u,r="length"in t?ku(t.length):r,e="omission"in t?yr(t.omission):e;n=Iu(n);var i=n.length;if(Rn.test(n))var o=M(n),i=o.length;if(r>=i)return n;if(i=r-D(e),1>i)return e;if(r=o?Or(o,0,i).join(""):n.slice(0,i),u===T)return r+e;if(o&&(i+=r.length-i),hf(u)){if(n.slice(i).search(u)){var f=r;for(u.global||(u=Xu(u.source,Iu(_n.exec(u))+"g")),
	u.lastIndex=0;o=u.exec(f);)var c=o.index;r=r.slice(0,c===T?i:c)}}else n.indexOf(yr(u),i)!=i&&(u=r.lastIndexOf(u),-1<u&&(r=r.slice(0,u)));return r+e},An.unescape=function(n){return(n=Iu(n))&&G.test(n)?n.replace(V,tt):n},An.uniqueId=function(n){var t=++fi;return Iu(n)+t},An.upperCase=Tf,An.upperFirst=$f,An.each=nu,An.eachRight=tu,An.first=qe,Nu(An,function(){var n={};return mt(An,function(t,r){oi.call(An.prototype,r)||(n[r]=t)}),n}(),{chain:false}),An.VERSION="4.17.11",r("bind bindKey curry curryRight partial partialRight".split(" "),function(n){
	An[n].placeholder=An}),r(["drop","take"],function(n,t){Ln.prototype[n]=function(r){r=r===T?1:Li(ku(r),0);var e=this.__filtered__&&!t?new Ln(this):this.clone();return e.__filtered__?e.__takeCount__=Ci(r,e.__takeCount__):e.__views__.push({size:Ci(r,4294967295),type:n+(0>e.__dir__?"Right":"")}),e},Ln.prototype[n+"Right"]=function(t){return this.reverse()[n](t).reverse()}}),r(["filter","map","takeWhile"],function(n,t){var r=t+1,e=1==r||3==r;Ln.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({
	iteratee:ye(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),r(["head","last"],function(n,t){var r="take"+(t?"Right":"");Ln.prototype[n]=function(){return this[r](1).value()[0]}}),r(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Ln.prototype[n]=function(){return this.__filtered__?new Ln(this):this[r](1)}}),Ln.prototype.compact=function(){return this.filter($u)},Ln.prototype.find=function(n){return this.filter(n).head()},Ln.prototype.findLast=function(n){return this.reverse().find(n);
	},Ln.prototype.invokeMap=fr(function(n,t){return typeof n=="function"?new Ln(this):this.map(function(r){return Bt(r,n,t)})}),Ln.prototype.reject=function(n){return this.filter(au(ye(n)))},Ln.prototype.slice=function(n,t){n=ku(n);var r=this;return r.__filtered__&&(0<n||0>t)?new Ln(r):(0>n?r=r.takeRight(-n):n&&(r=r.drop(n)),t!==T&&(t=ku(t),r=0>t?r.dropRight(-t):r.take(t-n)),r)},Ln.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},Ln.prototype.toArray=function(){return this.take(4294967295);
	},mt(Ln.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=An[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);u&&(An.prototype[t]=function(){var t=this.__wrapped__,o=e?[1]:arguments,f=t instanceof Ln,c=o[0],l=f||ff(t),s=function(n){return n=u.apply(An,a([n],o)),e&&h?n[0]:n};l&&r&&typeof c=="function"&&1!=c.length&&(f=l=false);var h=this.__chain__,p=!!this.__actions__.length,c=i&&!h,f=f&&!p;return!i&&l?(t=f?t:new Ln(this),t=n.apply(t,o),t.__actions__.push({
	func:Qe,args:[s],thisArg:T}),new On(t,h)):c&&f?n.apply(this,o):(t=this.thru(s),c?e?t.value()[0]:t.value():t)})}),r("pop push shift sort splice unshift".split(" "),function(n){var t=ri[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);An.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){var u=this.value();return t.apply(ff(u)?u:[],n)}return this[r](function(r){return t.apply(ff(r)?r:[],n)})}}),mt(Ln.prototype,function(n,t){var r=An[t];if(r){var e=r.name+"";
	(Gi[e]||(Gi[e]=[])).push({name:t,func:r})}}),Gi[Jr(T,2).name]=[{name:"wrapper",func:T}],Ln.prototype.clone=function(){var n=new Ln(this.__wrapped__);return n.__actions__=Lr(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Lr(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Lr(this.__views__),n},Ln.prototype.reverse=function(){if(this.__filtered__){var n=new Ln(this);n.__dir__=-1,n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n;
	},Ln.prototype.value=function(){var n,t=this.__wrapped__.value(),r=this.__dir__,e=ff(t),u=0>r,i=e?t.length:0;n=0;for(var o=i,f=this.__views__,c=-1,a=f.length;++c<a;){var l=f[c],s=l.size;switch(l.type){case"drop":n+=s;break;case"dropRight":o-=s;break;case"take":o=Ci(o,n+s);break;case"takeRight":n=Li(n,o-s)}}if(n={start:n,end:o},o=n.start,f=n.end,n=f-o,o=u?f:o-1,f=this.__iteratees__,c=f.length,a=0,l=Ci(n,this.__takeCount__),!e||!u&&i==n&&l==n)return wr(t,this.__actions__);e=[];n:for(;n--&&a<l;){for(o+=r,
	u=-1,i=t[o];++u<c;){var h=f[u],s=h.type,h=(0,h.iteratee)(i);if(2==s)i=h;else if(!h){if(1==s)continue n;break n}}e[a++]=i}return e},An.prototype.at=To,An.prototype.chain=function(){return Ye(this)},An.prototype.commit=function(){return new On(this.value(),this.__chain__)},An.prototype.next=function(){this.__values__===T&&(this.__values__=mu(this.value()));var n=this.__index__>=this.__values__.length;return{done:n,value:n?T:this.__values__[this.__index__++]}},An.prototype.plant=function(n){for(var t,r=this;r instanceof kn;){
	var e=Fe(r);e.__index__=0,e.__values__=T,t?u.__wrapped__=e:t=e;var u=e,r=r.__wrapped__}return u.__wrapped__=n,t},An.prototype.reverse=function(){var n=this.__wrapped__;return n instanceof Ln?(this.__actions__.length&&(n=new Ln(this)),n=n.reverse(),n.__actions__.push({func:Qe,args:[Ge],thisArg:T}),new On(n,this.__chain__)):this.thru(Ge)},An.prototype.toJSON=An.prototype.valueOf=An.prototype.value=function(){return wr(this.__wrapped__,this.__actions__)},An.prototype.first=An.prototype.head,wi&&(An.prototype[wi]=Xe),
	An}(); true?($n._=rt, !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return rt}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))):Nn?((Nn.exports=rt)._=rt,Fn._=rt):$n._=rt}).call(this);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(41)(module)))

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(136);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(622),
	    basePropertyDeep = __webpack_require__(623),
	    isKey = __webpack_require__(139),
	    toKey = __webpack_require__(100);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(607),
	    baseOrderBy = __webpack_require__(621),
	    baseRest = __webpack_require__(624),
	    isIterateeCall = __webpack_require__(653);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 696 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 697 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(700);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(698);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(73),
	    isSymbol = __webpack_require__(74);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(628);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	var lowerCase = __webpack_require__(75)
	
	/**
	 * Lower case the first character of a string.
	 *
	 * @param  {String} str
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  str = String(str)
	
	  return lowerCase(str.charAt(0), locale) + str.substr(1)
	}


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(259)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 704 */
/***/ (function(module, exports) {

	module.exports = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g


/***/ }),
/* 705 */
/***/ (function(module, exports) {

	module.exports = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g


/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g


/***/ }),
/* 707 */
/***/ (function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var context = __webpack_require__(438);
	
	function defaultDispose() { }
	var Cache = /** @class */ (function () {
	    function Cache(max, dispose) {
	        if (max === void 0) { max = Infinity; }
	        if (dispose === void 0) { dispose = defaultDispose; }
	        this.max = max;
	        this.dispose = dispose;
	        this.map = new Map();
	        this.newest = null;
	        this.oldest = null;
	    }
	    Cache.prototype.has = function (key) {
	        return this.map.has(key);
	    };
	    Cache.prototype.get = function (key) {
	        var entry = this.getEntry(key);
	        return entry && entry.value;
	    };
	    Cache.prototype.getEntry = function (key) {
	        var entry = this.map.get(key);
	        if (entry && entry !== this.newest) {
	            var older = entry.older, newer = entry.newer;
	            if (newer) {
	                newer.older = older;
	            }
	            if (older) {
	                older.newer = newer;
	            }
	            entry.older = this.newest;
	            entry.older.newer = entry;
	            entry.newer = null;
	            this.newest = entry;
	            if (entry === this.oldest) {
	                this.oldest = newer;
	            }
	        }
	        return entry;
	    };
	    Cache.prototype.set = function (key, value) {
	        var entry = this.getEntry(key);
	        if (entry) {
	            return entry.value = value;
	        }
	        entry = {
	            key: key,
	            value: value,
	            newer: null,
	            older: this.newest
	        };
	        if (this.newest) {
	            this.newest.newer = entry;
	        }
	        this.newest = entry;
	        this.oldest = this.oldest || entry;
	        this.map.set(key, entry);
	        return entry.value;
	    };
	    Cache.prototype.clean = function () {
	        while (this.oldest && this.map.size > this.max) {
	            this.delete(this.oldest.key);
	        }
	    };
	    Cache.prototype.delete = function (key) {
	        var entry = this.map.get(key);
	        if (entry) {
	            if (entry === this.newest) {
	                this.newest = entry.older;
	            }
	            if (entry === this.oldest) {
	                this.oldest = entry.newer;
	            }
	            if (entry.newer) {
	                entry.newer.older = entry.older;
	            }
	            if (entry.older) {
	                entry.older.newer = entry.newer;
	            }
	            this.map.delete(key);
	            this.dispose(entry.value, key);
	            return true;
	        }
	        return false;
	    };
	    return Cache;
	}());
	
	var parentEntrySlot = new context.Slot();
	
	var reusableEmptyArray = [];
	var emptySetPool = [];
	var POOL_TARGET_SIZE = 100;
	// Since this package might be used browsers, we should avoid using the
	// Node built-in assert module.
	function assert(condition, optionalMessage) {
	    if (!condition) {
	        throw new Error(optionalMessage || "assertion failure");
	    }
	}
	function valueIs(a, b) {
	    var len = a.length;
	    return (
	    // Unknown values are not equal to each other.
	    len > 0 &&
	        // Both values must be ordinary (or both exceptional) to be equal.
	        len === b.length &&
	        // The underlying value or exception must be the same.
	        a[len - 1] === b[len - 1]);
	}
	function valueGet(value) {
	    switch (value.length) {
	        case 0: throw new Error("unknown value");
	        case 1: return value[0];
	        case 2: throw value[1];
	    }
	}
	function valueCopy(value) {
	    return value.slice(0);
	}
	var Entry = /** @class */ (function () {
	    function Entry(fn, args) {
	        this.fn = fn;
	        this.args = args;
	        this.parents = new Set();
	        this.childValues = new Map();
	        // When this Entry has children that are dirty, this property becomes
	        // a Set containing other Entry objects, borrowed from emptySetPool.
	        // When the set becomes empty, it gets recycled back to emptySetPool.
	        this.dirtyChildren = null;
	        this.dirty = true;
	        this.recomputing = false;
	        this.value = [];
	        ++Entry.count;
	    }
	    // This is the most important method of the Entry API, because it
	    // determines whether the cached this.value can be returned immediately,
	    // or must be recomputed. The overall performance of the caching system
	    // depends on the truth of the following observations: (1) this.dirty is
	    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
	    // (3) valueGet(this.value) is usually returned without recomputation.
	    Entry.prototype.recompute = function () {
	        assert(!this.recomputing, "already recomputing");
	        if (!rememberParent(this) && maybeReportOrphan(this)) {
	            // The recipient of the entry.reportOrphan callback decided to dispose
	            // of this orphan entry by calling entry.dispose(), so we don't need to
	            // (and should not) proceed with the recomputation.
	            return void 0;
	        }
	        return mightBeDirty(this)
	            ? reallyRecompute(this)
	            : valueGet(this.value);
	    };
	    Entry.prototype.setDirty = function () {
	        if (this.dirty)
	            return;
	        this.dirty = true;
	        this.value.length = 0;
	        reportDirty(this);
	        // We can go ahead and unsubscribe here, since any further dirty
	        // notifications we receive will be redundant, and unsubscribing may
	        // free up some resources, e.g. file watchers.
	        maybeUnsubscribe(this);
	    };
	    Entry.prototype.dispose = function () {
	        var _this = this;
	        forgetChildren(this).forEach(maybeReportOrphan);
	        maybeUnsubscribe(this);
	        // Because this entry has been kicked out of the cache (in index.js),
	        // we've lost the ability to find out if/when this entry becomes dirty,
	        // whether that happens through a subscription, because of a direct call
	        // to entry.setDirty(), or because one of its children becomes dirty.
	        // Because of this loss of future information, we have to assume the
	        // worst (that this entry might have become dirty very soon), so we must
	        // immediately mark this entry's parents as dirty. Normally we could
	        // just call entry.setDirty() rather than calling parent.setDirty() for
	        // each parent, but that would leave this entry in parent.childValues
	        // and parent.dirtyChildren, which would prevent the child from being
	        // truly forgotten.
	        this.parents.forEach(function (parent) {
	            parent.setDirty();
	            forgetChild(parent, _this);
	        });
	    };
	    Entry.count = 0;
	    return Entry;
	}());
	function rememberParent(child) {
	    var parent = parentEntrySlot.getValue();
	    if (parent) {
	        child.parents.add(parent);
	        if (!parent.childValues.has(child)) {
	            parent.childValues.set(child, []);
	        }
	        if (mightBeDirty(child)) {
	            reportDirtyChild(parent, child);
	        }
	        else {
	            reportCleanChild(parent, child);
	        }
	        return parent;
	    }
	}
	function reallyRecompute(entry) {
	    // Since this recomputation is likely to re-remember some of this
	    // entry's children, we forget our children here but do not call
	    // maybeReportOrphan until after the recomputation finishes.
	    var originalChildren = forgetChildren(entry);
	    // Set entry as the parent entry while calling recomputeNewValue(entry).
	    parentEntrySlot.withValue(entry, recomputeNewValue, [entry]);
	    if (maybeSubscribe(entry)) {
	        // If we successfully recomputed entry.value and did not fail to
	        // (re)subscribe, then this Entry is no longer explicitly dirty.
	        setClean(entry);
	    }
	    // Now that we've had a chance to re-remember any children that were
	    // involved in the recomputation, we can safely report any orphan
	    // children that remain.
	    originalChildren.forEach(maybeReportOrphan);
	    return valueGet(entry.value);
	}
	function recomputeNewValue(entry) {
	    entry.recomputing = true;
	    // Set entry.value as unknown.
	    entry.value.length = 0;
	    try {
	        // If entry.fn succeeds, entry.value will become a normal Value.
	        entry.value[0] = entry.fn.apply(null, entry.args);
	    }
	    catch (e) {
	        // If entry.fn throws, entry.value will become exceptional.
	        entry.value[1] = e;
	    }
	    // Either way, this line is always reached.
	    entry.recomputing = false;
	}
	function mightBeDirty(entry) {
	    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
	}
	function setClean(entry) {
	    entry.dirty = false;
	    if (mightBeDirty(entry)) {
	        // This Entry may still have dirty children, in which case we can't
	        // let our parents know we're clean just yet.
	        return;
	    }
	    reportClean(entry);
	}
	function reportDirty(child) {
	    child.parents.forEach(function (parent) { return reportDirtyChild(parent, child); });
	}
	function reportClean(child) {
	    child.parents.forEach(function (parent) { return reportCleanChild(parent, child); });
	}
	// Let a parent Entry know that one of its children may be dirty.
	function reportDirtyChild(parent, child) {
	    // Must have called rememberParent(child) before calling
	    // reportDirtyChild(parent, child).
	    assert(parent.childValues.has(child));
	    assert(mightBeDirty(child));
	    if (!parent.dirtyChildren) {
	        parent.dirtyChildren = emptySetPool.pop() || new Set;
	    }
	    else if (parent.dirtyChildren.has(child)) {
	        // If we already know this child is dirty, then we must have already
	        // informed our own parents that we are dirty, so we can terminate
	        // the recursion early.
	        return;
	    }
	    parent.dirtyChildren.add(child);
	    reportDirty(parent);
	}
	// Let a parent Entry know that one of its children is no longer dirty.
	function reportCleanChild(parent, child) {
	    // Must have called rememberChild(child) before calling
	    // reportCleanChild(parent, child).
	    assert(parent.childValues.has(child));
	    assert(!mightBeDirty(child));
	    var childValue = parent.childValues.get(child);
	    if (childValue.length === 0) {
	        parent.childValues.set(child, valueCopy(child.value));
	    }
	    else if (!valueIs(childValue, child.value)) {
	        parent.setDirty();
	    }
	    removeDirtyChild(parent, child);
	    if (mightBeDirty(parent)) {
	        return;
	    }
	    reportClean(parent);
	}
	function removeDirtyChild(parent, child) {
	    var dc = parent.dirtyChildren;
	    if (dc) {
	        dc.delete(child);
	        if (dc.size === 0) {
	            if (emptySetPool.length < POOL_TARGET_SIZE) {
	                emptySetPool.push(dc);
	            }
	            parent.dirtyChildren = null;
	        }
	    }
	}
	// If the given entry has a reportOrphan method, and no remaining parents,
	// call entry.reportOrphan and return true iff it returns true. The
	// reportOrphan function should return true to indicate entry.dispose()
	// has been called, and the entry has been removed from any other caches
	// (see index.js for the only current example).
	function maybeReportOrphan(entry) {
	    return entry.parents.size === 0 &&
	        typeof entry.reportOrphan === "function" &&
	        entry.reportOrphan() === true;
	}
	// Removes all children from this entry and returns an array of the
	// removed children.
	function forgetChildren(parent) {
	    var children = reusableEmptyArray;
	    if (parent.childValues.size > 0) {
	        children = [];
	        parent.childValues.forEach(function (_value, child) {
	            forgetChild(parent, child);
	            children.push(child);
	        });
	    }
	    // After we forget all our children, this.dirtyChildren must be empty
	    // and therefore must have been reset to null.
	    assert(parent.dirtyChildren === null);
	    return children;
	}
	function forgetChild(parent, child) {
	    child.parents.delete(parent);
	    parent.childValues.delete(child);
	    removeDirtyChild(parent, child);
	}
	function maybeSubscribe(entry) {
	    if (typeof entry.subscribe === "function") {
	        try {
	            maybeUnsubscribe(entry); // Prevent double subscriptions.
	            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
	        }
	        catch (e) {
	            // If this Entry has a subscribe function and it threw an exception
	            // (or an unsubscribe function it previously returned now throws),
	            // return false to indicate that we were not able to subscribe (or
	            // unsubscribe), and this Entry should remain dirty.
	            entry.setDirty();
	            return false;
	        }
	    }
	    // Returning true indicates either that there was no entry.subscribe
	    // function or that it succeeded.
	    return true;
	}
	function maybeUnsubscribe(entry) {
	    var unsubscribe = entry.unsubscribe;
	    if (typeof unsubscribe === "function") {
	        entry.unsubscribe = void 0;
	        unsubscribe();
	    }
	}
	
	// A trie data structure that holds object keys weakly, yet can also hold
	// non-object keys, unlike the native `WeakMap`.
	var KeyTrie = /** @class */ (function () {
	    function KeyTrie(weakness) {
	        this.weakness = weakness;
	    }
	    KeyTrie.prototype.lookup = function () {
	        var array = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            array[_i] = arguments[_i];
	        }
	        return this.lookupArray(array);
	    };
	    KeyTrie.prototype.lookupArray = function (array) {
	        var node = this;
	        array.forEach(function (key) { return node = node.getChildTrie(key); });
	        return node.data || (node.data = Object.create(null));
	    };
	    KeyTrie.prototype.getChildTrie = function (key) {
	        var map = this.weakness && isObjRef(key)
	            ? this.weak || (this.weak = new WeakMap())
	            : this.strong || (this.strong = new Map());
	        var child = map.get(key);
	        if (!child)
	            map.set(key, child = new KeyTrie(this.weakness));
	        return child;
	    };
	    return KeyTrie;
	}());
	function isObjRef(value) {
	    switch (typeof value) {
	        case "object":
	            if (value === null)
	                break;
	        // Fall through to return true...
	        case "function":
	            return true;
	    }
	    return false;
	}
	
	// The defaultMakeCacheKey function is remarkably powerful, because it gives
	// a unique object for any shallow-identical list of arguments. If you need
	// to implement a custom makeCacheKey function, you may find it helpful to
	// delegate the final work to defaultMakeCacheKey, which is why we export it
	// here. However, you may want to avoid defaultMakeCacheKey if your runtime
	// does not support WeakMap, or you have the ability to return a string key.
	// In those cases, just write your own custom makeCacheKey functions.
	var keyTrie = new KeyTrie(typeof WeakMap === "function");
	function defaultMakeCacheKey() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    return keyTrie.lookupArray(args);
	}
	var caches = new Set();
	function wrap(originalFunction, options) {
	    if (options === void 0) { options = Object.create(null); }
	    var cache = new Cache(options.max || Math.pow(2, 16), function (entry) { return entry.dispose(); });
	    var disposable = !!options.disposable;
	    var makeCacheKey = options.makeCacheKey || defaultMakeCacheKey;
	    function optimistic() {
	        if (disposable && !parentEntrySlot.hasValue()) {
	            // If there's no current parent computation, and this wrapped
	            // function is disposable (meaning we don't care about entry.value,
	            // just dependency tracking), then we can short-cut everything else
	            // in this function, because entry.recompute() is going to recycle
	            // the entry object without recomputing anything, anyway.
	            return void 0;
	        }
	        var key = makeCacheKey.apply(null, arguments);
	        if (key === void 0) {
	            return originalFunction.apply(null, arguments);
	        }
	        var args = Array.prototype.slice.call(arguments);
	        var entry = cache.get(key);
	        if (entry) {
	            entry.args = args;
	        }
	        else {
	            entry = new Entry(originalFunction, args);
	            cache.set(key, entry);
	            entry.subscribe = options.subscribe;
	            if (disposable) {
	                entry.reportOrphan = function () { return cache.delete(key); };
	            }
	        }
	        var value = entry.recompute();
	        // Move this entry to the front of the least-recently used queue,
	        // since we just finished computing its value.
	        cache.set(key, entry);
	        caches.add(cache);
	        // Clean up any excess entries in the cache, but only if there is no
	        // active parent entry, meaning we're not in the middle of a larger
	        // computation that might be flummoxed by the cleaning.
	        if (!parentEntrySlot.hasValue()) {
	            caches.forEach(function (cache) { return cache.clean(); });
	            caches.clear();
	        }
	        // If options.disposable is truthy, the caller of wrap is telling us
	        // they don't care about the result of entry.recompute(), so we should
	        // avoid returning the value, so it won't be accidentally used.
	        return disposable ? void 0 : value;
	    }
	    optimistic.dirty = function () {
	        var key = makeCacheKey.apply(null, arguments);
	        var child = key !== void 0 && cache.get(key);
	        if (child) {
	            child.setDirty();
	        }
	    };
	    return optimistic;
	}
	
	Object.defineProperty(exports, 'asyncFromGen', {
	  enumerable: true,
	  get: function () {
	    return context.asyncFromGen;
	  }
	});
	Object.defineProperty(exports, 'bindContext', {
	  enumerable: true,
	  get: function () {
	    return context.bind;
	  }
	});
	Object.defineProperty(exports, 'noContext', {
	  enumerable: true,
	  get: function () {
	    return context.noContext;
	  }
	});
	Object.defineProperty(exports, 'setTimeout', {
	  enumerable: true,
	  get: function () {
	    return context.setTimeout;
	  }
	});
	exports.KeyTrie = KeyTrie;
	exports.defaultMakeCacheKey = defaultMakeCacheKey;
	exports.wrap = wrap;
	//# sourceMappingURL=bundle.cjs.js.map


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(30)
	
	/**
	 * Param case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '-')
	}


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	var camelCase = __webpack_require__(221)
	var upperCaseFirst = __webpack_require__(154)
	
	/**
	 * Pascal case a string.
	 *
	 * @param  {string}  value
	 * @param  {string}  [locale]
	 * @param  {boolean} [mergeNumbers]
	 * @return {string}
	 */
	module.exports = function (value, locale, mergeNumbers) {
	  return upperCaseFirst(camelCase(value, locale, mergeNumbers), locale)
	}


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(30)
	
	/**
	 * Path case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale, '/')
	}


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(260);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(260);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(717);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(261);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(146);
	var assign = __webpack_require__(718);
	
	var ReactPropTypesSecret = __webpack_require__(261);
	var checkPropTypes = __webpack_require__(714);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 718 */
63,
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(768);
	var objectAssign = __webpack_require__(720);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 720 */
63,
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react-dom-server.browser.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(263),l=__webpack_require__(1);function q(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,u=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,v=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,B=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
	60116,ka=t?Symbol.for("react.block"):60121,la=t?Symbol.for("react.fundamental"):60117,ma=t?Symbol.for("react.scope"):60119;function na(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c)},function(c){0===a._status&&(a._status=2,a._result=c)})}}
	function C(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case u:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case B:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case v:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
	case ia:return C(a.type);case ka:return C(a.render);case ja:if(a=1===a._status?a._result:null)return C(a)}return null}var D=l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;D.hasOwnProperty("ReactCurrentDispatcher")||(D.ReactCurrentDispatcher={current:null});D.hasOwnProperty("ReactCurrentBatchConfig")||(D.ReactCurrentBatchConfig={suspense:null});var oa={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}
	function pa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=oa;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
	var qa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ra=Object.prototype.hasOwnProperty,sa={},ta={};
	function ua(a){if(ra.call(ta,a))return!0;if(ra.call(sa,a))return!1;if(qa.test(a))return ta[a]=!0;sa[a]=!0;return!1}function va(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function wa(a,b,c,d){if(null===b||"undefined"===typeof b||va(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=g}var K={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1)});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
	M);K[b]=new J(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1)});
	K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0)});var xa=/["'&<>]/;
	function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=xa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
	function ya(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||wa(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+'="'+(N(b)+'"')}return ua(a)?a+'="'+(N(b)+'"'):""}function za(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
	var Aa="function"===typeof Object.is?Object.is:za,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(q(321));return O}function Ba(){if(0<V)throw Error(q(312));return{memoizedState:null,queue:null,next:null}}function Ca(){null===Q?null===P?(R=!1,P=Q=Ba()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Ba()):(R=!0,Q=Q.next);return Q}function Da(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Ea(a,b){return"function"===typeof b?b(a):b}
	function Fa(a,b,c){O=W();Q=Ca();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Ea?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Ga.bind(null,O,a);return[Q.memoizedState,a]}
	function Ga(a,b,c){if(!(25>V))throw Error(q(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ha(){}
	var X=0,Ia={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Ca();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!Aa(b[f],d[f])){d=!1;break a}d=!0}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Fa,useRef:function(a){O=W();Q=Ca();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
	a):b},useState:function(a){return Fa(Ea,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ha,useEffect:Ha,useDebugValue:Ha,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a()},!1]}},Ja={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Ka(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
	var La={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},Ma=k({menuitem:!0},La),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
	gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Na=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Na.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
	var Oa=/([A-Z])/g,Pa=/^ms-/,Z=l.Children.toArray,Qa=D.ReactCurrentDispatcher,Ra={listing:!0,pre:!0,textarea:!0},Sa=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Ta={},Ua={};function Va(a){if(void 0===a||null===a)return a;var b="";l.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Wa=Object.prototype.hasOwnProperty,Xa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Ya(a,b){if(void 0===a)throw Error(q(152,C(b)||"Component"));}
	function Za(a,b,c){function d(d,g){var e=g.prototype&&g.prototype.isReactComponent,f=pa(g,b,c,e),x=[],h=!1,m={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===x)return null},enqueueReplaceState:function(a,c){h=!0;x=[c]},enqueueSetState:function(a,c){if(null===x)return null;x.push(c)}};if(e){if(e=new g(d.props,f,m),"function"===typeof g.getDerivedStateFromProps){var w=g.getDerivedStateFromProps.call(null,d.props,e.state);null!=w&&(e.state=k({},e.state,w))}}else if(O={},e=g(d.props,
	f,m),e=Da(g,d.props,e,f),null==e||null==e.render){a=e;Ya(a,g);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),x.length){m=x;var r=
	h;x=null;h=!1;if(r&&1===m.length)e.state=m[0];else{w=r?m[0]:e.state;var y=!0;for(r=r?1:0;r<m.length;r++){var p=m[r];p="function"===typeof p?p.call(e,w,d.props,f):p;null!=p&&(y?(y=!1,w=k({},w,p)):k(w,p))}e.state=w}}else x=null;a=e.render();Ya(a,g);if("function"===typeof e.getChildContext&&(d=g.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(q(108,C(g)||"Unknown",T));}A&&(b=k({},b,A))}for(;l.isValidElement(a);){var f=a,g=f.type;if("function"!==
	typeof g)break;d(f,g)}return{child:a,context:b}}
	var $a=function(){function a(a,b){l.isValidElement(a)?a.type!==u?a=[a]:(a=a.props.children,a=l.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ja.html,children:a,childIndex:0,context:oa,footer:""};var c=F[0];if(0===c){var g=F;c=g.length;var d=2*c;if(!(65536>=d))throw Error(q(304));var h=new Uint16Array(d);h.set(g);F=h;F[0]=c+1;for(g=c;g<d-1;g++)F[g]=g+1;F[d-1]=0}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
	b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a}};b.pushProvider=function(a){var c=++this.contextIndex,b=a.type._context,g=this.threadID;E(b,g);var x=b[g];this.contextStack[c]=b;this.contextValueStack[c]=x;b[g]=a.props.value};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
	this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Qa.current;Qa.current=Ia;try{for(var g=[""],x=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;F[h]=F[0];F[0]=h;break}var e=this.stack[this.stack.length-1];if(x||e.childIndex>=
	e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===v)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=g.pop();if(x){x=!1;var n=e.fallbackFrame;if(!n)throw Error(q(303));this.stack.push(n);g[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else g[this.suspenseDepth]+=G}g[this.suspenseDepth]+=I}else{var m=e.children[e.childIndex++],
	w="";try{w+=this.render(m,e.context,e.domNamespace)}catch(r){if(null!=r&&"function"===typeof r.then)throw Error(q(294));throw r;}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=w}}return g[0]}finally{Qa.current=c,X=b}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=Za(a,b,this.threadID);a=b.child;
	b=b.context;if(null===a||!1===a)return"";if(!l.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===aa)throw Error(q(257));throw Error(q(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ba:case ea:case ca:case ha:case u:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
	"";case B:throw Error(q(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case fa:O={};var d=c.render(a.props,a.ref);d=Da(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ia:return a=[l.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case v:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
	context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case da:c=a.type;d=a.props;var h=this.threadID;E(c,h);c=Z(d.children(c[h]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case la:throw Error(q(338));case ja:switch(c=a.type,na(c),c._status){case 1:return a=[l.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(q(295));
	}case ma:throw Error(q(343));}throw Error(q(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===Ja.html&&Ka(c);if(!Ta.hasOwnProperty(c)){if(!Sa.test(c))throw Error(q(65,c));Ta[c]=!0}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var h=d.value;if(null==h){h=d.defaultValue;var e=d.children;if(null!=e){if(null!=
	h)throw Error(q(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(q(93));e=e[0]}h=""+e}null==h&&(h="")}d=k({},d,{value:void 0,children:""+h})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Va(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;h=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){h=!0;break}}else h=""+e===G;d=k({selected:void 0,children:void 0},
	d,{selected:h,children:I})}}if(h=d){if(Ma[c]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw Error(q(137,c,""));if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw Error(q(60));if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw Error(q(61));}if(null!=h.style&&"object"!==typeof h.style)throw Error(q(62,""));}h=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in h)if(Wa.call(h,z)){var m=h[z];if(null!=m){if("style"===
	z){n=void 0;var w="",r="";for(n in m)if(m.hasOwnProperty(n)){var y=0===n.indexOf("--"),p=m[n];if(null!=p){if(y)var A=n;else if(A=n,Ua.hasOwnProperty(A))A=Ua[A];else{var T=A.replace(Oa,"-$1").toLowerCase().replace(Pa,"-ms-");A=Ua[A]=T}w+=r+A+":";r=n;y=null==p||"boolean"===typeof p||""===p?"":y||"number"!==typeof p||0===p||Y.hasOwnProperty(r)&&Y[r]?(""+p).trim():p+"px";w+=y;r=";"}}m=w||null}n=null;b:if(y=c,p=h,-1===y.indexOf("-"))y="string"===typeof p.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
	!1;break b;default:y=!0}y?Xa.hasOwnProperty(z)||(n=z,n=ua(n)&&null!=m?n+'="'+(N(m)+'"'):""):n=ya(z,m);n&&(G+=" "+n)}}e||I&&(G+=' data-reactroot=""');var z=G;h="";La.hasOwnProperty(c)?z+="/>":(z+=">",h="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null}null!=e?(d=[],Ra.hasOwnProperty(c)&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
	f?Ka(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:h});this.previousWasTextNode=!1;return z};return a}(),ab={renderToString:function(a){a=new $a(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new $a(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw Error(q(207));},renderToStaticNodeStream:function(){throw Error(q(208));
	},version:"16.13.1"};module.exports=ab.default||ab;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(263),r=__webpack_require__(725);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.1",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.1";


/***/ }),
/* 723 */
[782, 722],
/* 724 */
/***/ (function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 725 */
[787, 724],
/* 726 */
/***/ (function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _storeShape = __webpack_require__(264);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(265);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _propTypes2["default"].element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(264);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(729);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(730);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(265);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(144);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(241);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(153);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(267);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(266);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(733);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(732);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(266);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(267);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(27);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(268);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(27);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _routerWarning = __webpack_require__(61);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(270);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(27);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _routerWarning = __webpack_require__(61);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(39);
	
	var _InternalPropTypes = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(27);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(39);
	
	var _InternalPropTypes = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(27);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(3);
	
	var _createTransitionManager2 = __webpack_require__(274);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(77);
	
	var _RouterContext = __webpack_require__(150);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(39);
	
	var _RouterUtils = __webpack_require__(271);
	
	var _routerWarning = __webpack_require__(61);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(147);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(150);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(61);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(578);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(273);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(60);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(147);
	
	var _PromiseUtils = __webpack_require__(269);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(60);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(579);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(273);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(60);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(93);
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(272);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(274);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(39);
	
	var _RouterUtils = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(147);
	
	var _PromiseUtils = __webpack_require__(269);
	
	var _PatternUtils = __webpack_require__(60);
	
	var _routerWarning = __webpack_require__(61);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(12);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(27);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(750);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(148);
	
	var _PropTypes = __webpack_require__(149);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(752);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 751 */
726,
/* 752 */
[788, 751],
/* 753 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 754 */
[788, 753],
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isEqual = __webpack_require__(758);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _Elements = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      onBlur = props.onBlur,
	      onReady = props.onReady,
	      options = _objectWithoutProperties(props, ['id', 'className', 'onChange', 'onFocus', 'onBlur', 'onReady']);
	
	  return options;
	};
	
	var capitalized = function capitalized(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	var Element = function Element(type) {
	  var _class, _temp;
	
	  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.handleRef = function (ref) {
	        _this._ref = ref;
	      };
	
	      _this._element = null;
	
	      var options = _extractOptions(_this.props);
	      // We keep track of the extracted options on this._options to avoid re-rendering.
	      // (We would unnecessarily re-render if we were tracking them with state.)
	      _this._options = options;
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.context.addElementsLoadListener(function (elements) {
	        var element = elements.create(type, _this2._options);
	        _this2._element = element;
	
	        _this2._setupEventListeners(element);
	
	        element.mount(_this2._ref);
	
	        // Register Element for automatic token / source / paymentMethod creation
	        if (hocOptions.impliedTokenType || hocOptions.impliedSourceType || hocOptions.impliedPaymentMethodType) {
	          _this2.context.registerElement(element, hocOptions.impliedTokenType, hocOptions.impliedSourceType, hocOptions.impliedPaymentMethodType);
	        }
	      });
	    };
	
	    _class.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var options = _extractOptions(nextProps);
	      if (Object.keys(options).length !== 0 && !(0, _isEqual2.default)(options, this._options)) {
	        this._options = options;
	        if (this._element) {
	          this._element.update(options);
	        }
	      }
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this._element) {
	        var element = this._element;
	        element.destroy();
	        this.context.unregisterElement(element);
	      }
	    };
	
	    _class.prototype._setupEventListeners = function _setupEventListeners(element) {
	      var _this3 = this;
	
	      element.on('ready', function () {
	        _this3.props.onReady(_this3._element);
	      });
	
	      element.on('change', function (change) {
	        _this3.props.onChange(change);
	      });
	
	      element.on('blur', function () {
	        var _props;
	
	        return (_props = _this3.props).onBlur.apply(_props, arguments);
	      });
	      element.on('focus', function () {
	        var _props2;
	
	        return (_props2 = _this3.props).onFocus.apply(_props2, arguments);
	      });
	    };
	
	    _class.prototype.render = function render() {
	      return _react2.default.createElement('div', {
	        id: this.props.id,
	        className: this.props.className,
	        ref: this.handleRef
	      });
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.propTypes = {
	    id: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    onChange: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onReady: _propTypes2.default.func
	  }, _class.defaultProps = {
	    id: undefined,
	    className: undefined,
	    onChange: noop,
	    onBlur: noop,
	    onFocus: noop,
	    onReady: noop
	  }, _class.contextTypes = _Elements.elementContextTypes, _class.displayName = capitalized(type) + 'Element', _temp;
	};
	
	exports.default = Element;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(759);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Elements = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onReady = props.onReady,
	      paymentRequest = props.paymentRequest,
	      options = _objectWithoutProperties(props, ['id', 'className', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);
	
	  return options;
	};
	
	var PaymentRequestButtonElement = function (_React$Component) {
	  _inherits(PaymentRequestButtonElement, _React$Component);
	
	  function PaymentRequestButtonElement(props, context) {
	    _classCallCheck(this, PaymentRequestButtonElement);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRef = function (ref) {
	      _this._ref = ref;
	    };
	
	    var options = _extractOptions(props);
	    // We keep track of the extracted options on this._options to avoid re-rendering.
	    // (We would unnecessarily re-render if we were tracking them with state.)
	    _this._options = options;
	    return _this;
	  }
	
	  PaymentRequestButtonElement.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.context.addElementsLoadListener(function (elements) {
	      _this2._element = elements.create('paymentRequestButton', _extends({
	        paymentRequest: _this2.props.paymentRequest
	      }, _this2._options));
	      _this2._element.on('ready', function () {
	        _this2.props.onReady(_this2._element);
	      });
	      _this2._element.on('focus', function () {
	        var _props;
	
	        return (_props = _this2.props).onFocus.apply(_props, arguments);
	      });
	      _this2._element.on('click', function () {
	        var _props2;
	
	        return (_props2 = _this2.props).onClick.apply(_props2, arguments);
	      });
	      _this2._element.on('blur', function () {
	        var _props3;
	
	        return (_props3 = _this2.props).onBlur.apply(_props3, arguments);
	      });
	      _this2._element.mount(_this2._ref);
	    });
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.paymentRequest !== nextProps.paymentRequest) {
	      console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
	    }
	    var options = _extractOptions(nextProps);
	    if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	      this._options = options;
	      this._element.update(options);
	    }
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._element.destroy();
	  };
	
	  PaymentRequestButtonElement.prototype.render = function render() {
	    return _react2.default.createElement('div', {
	      id: this.props.id,
	      className: this.props.className,
	      ref: this.handleRef
	    });
	  };
	
	  return PaymentRequestButtonElement;
	}(_react2.default.Component);
	
	PaymentRequestButtonElement.propTypes = {
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onReady: _propTypes2.default.func,
	  paymentRequest: _propTypes2.default.shape({
	    canMakePayment: _propTypes2.default.func.isRequired,
	    on: _propTypes2.default.func.isRequired,
	    show: _propTypes2.default.func.isRequired
	  }).isRequired
	};
	PaymentRequestButtonElement.defaultProps = {
	  id: undefined,
	  className: undefined,
	  onBlur: noop,
	  onClick: noop,
	  onFocus: noop,
	  onReady: noop
	};
	PaymentRequestButtonElement.contextTypes = _Elements.elementContextTypes;
	exports.default = PaymentRequestButtonElement;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Elements = __webpack_require__(103);
	
	var _Provider = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
	// not sure if we need to do the same.
	var inject = function inject(WrappedComponent) {
	  var _class, _temp;
	
	  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _componentOptions$wit = componentOptions.withRef,
	      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;
	
	
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      if (!context || !context.getRegisteredElements) {
	        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
	      }
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.parseElementOrData = function (elementOrOptions) {
	        return elementOrOptions && (typeof elementOrOptions === 'undefined' ? 'undefined' : _typeof(elementOrOptions)) === 'object' && elementOrOptions._frame && _typeof(elementOrOptions._frame) === 'object' && elementOrOptions._frame.id && typeof elementOrOptions._frame.id === 'string' && typeof elementOrOptions._componentName === 'string' ? { type: 'element', element: elementOrOptions } : { type: 'data', data: elementOrOptions };
	      };
	
	      _this.findElement = function (filterBy, specifiedType) {
	        var allElements = _this.context.getRegisteredElements();
	        var filteredElements = allElements.filter(function (e) {
	          return e[filterBy];
	        });
	        var matchingElements = specifiedType === 'auto' ? filteredElements : filteredElements.filter(function (e) {
	          return e[filterBy] === specifiedType;
	        });
	
	        if (matchingElements.length === 1) {
	          return matchingElements[0].element;
	        } else if (matchingElements.length > 1) {
	          throw new Error('You did not specify the type of Source, Token, or PaymentMethod to create.\n        We could not infer which Element you want to use for this operation.');
	        } else {
	          return null;
	        }
	      };
	
	      _this.requireElement = function (filterBy, specifiedType) {
	        var element = _this.findElement(filterBy, specifiedType);
	        if (element) {
	          return element;
	        } else {
	          throw new Error('You did not specify the type of Source, Token, or PaymentMethod to create.\n        We could not infer which Element you want to use for this operation.');
	        }
	      };
	
	      _this.wrappedCreateToken = function (stripe) {
	        return function () {
	          var tokenTypeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	          if (tokenTypeOrOptions && (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) === 'object') {
	            // First argument is options; infer the Element and tokenize
	            var opts = tokenTypeOrOptions;
	
	            var tokenType = opts.type,
	                rest = _objectWithoutProperties(opts, ['type']);
	
	            var specifiedType = typeof tokenType === 'string' ? tokenType : 'auto';
	            // Since only options were passed in, a corresponding Element must exist
	            // for the tokenization to succeed -- thus we call requireElement.
	            var element = _this.requireElement('impliedTokenType', specifiedType);
	            return stripe.createToken(element, rest);
	          } else if (typeof tokenTypeOrOptions === 'string') {
	            // First argument is token type; tokenize with token type and options
	            var _tokenType = tokenTypeOrOptions;
	            return stripe.createToken(_tokenType, options);
	          } else {
	            // If a bad value was passed in for options, throw an error.
	            throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedCreateSource = function (stripe) {
	        return function () {
	          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            if (typeof options.type !== 'string') {
	              throw new Error('Invalid Source type passed to createSource. Expected string, got ' + _typeof(options.type) + '.');
	            }
	
	            var element = _this.findElement('impliedSourceType', options.type);
	            if (element) {
	              // If an Element exists for the source type, use that to create the
	              // corresponding source.
	              //
	              // NOTE: this prevents users from independently creating sources of
	              // type `foo` if an Element that can create `foo` sources exists in
	              // the current <Elements /> context.
	              return stripe.createSource(element, options);
	            } else {
	              // If no Element exists for the source type, directly create a source.
	              return stripe.createSource(options);
	            }
	          } else {
	            // If a bad value was passed in for options, throw an error.
	            throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedCreatePaymentMethod = function (stripe) {
	        return function (paymentMethodType, elementOrData, maybeData) {
	          if (!paymentMethodType || typeof paymentMethodType !== 'string') {
	            throw new Error('Invalid PaymentMethod type passed to createPaymentMethod. Expected a string, got ' + (typeof paymentMethodType === 'undefined' ? 'undefined' : _typeof(paymentMethodType)) + '.');
	          }
	
	          if (['card'].indexOf(paymentMethodType) === -1) {
	            throw new Error('Invalid PaymentMethod type passed to createPaymentMethod. ' + paymentMethodType + ' is not yet supported.');
	          }
	
	          var elementOrDataResult = _this.parseElementOrData(elementOrData);
	
	          // Second argument is Element; use passed in Element
	          if (elementOrDataResult.type === 'element') {
	            var _element = elementOrDataResult.element;
	
	            if (maybeData) {
	              return stripe.createPaymentMethod(paymentMethodType, _element, maybeData);
	            } else {
	              return stripe.createPaymentMethod(paymentMethodType, _element);
	            }
	          }
	
	          // Second argument is data or undefined; infer the Element
	          var data = elementOrDataResult.data;
	
	          var element = _this.findElement('impliedPaymentMethodType', paymentMethodType);
	
	          if (element) {
	            return data ? stripe.createPaymentMethod(paymentMethodType, element, data) : stripe.createPaymentMethod(paymentMethodType, element);
	          }
	
	          if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
	            return stripe.createPaymentMethod(paymentMethodType, data);
	          } else if (!data) {
	            throw new Error('Could not find an Element that can be used to create a PaymentMethod of type: ' + paymentMethodType + '.');
	          } else {
	            // If a bad value was passed in for data, throw an error.
	            throw new Error('Invalid data passed to createPaymentMethod. Expected an object, got ' + (typeof data === 'undefined' ? 'undefined' : _typeof(data)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedHandleCardX = function (stripe, method) {
	        return function (clientSecret, elementOrData, maybeData) {
	          if (!clientSecret || typeof clientSecret !== 'string') {
	            // If a bad value was passed in for clientSecret, throw an error.
	            throw new Error('Invalid PaymentIntent client secret passed to handleCardPayment. Expected string, got ' + (typeof clientSecret === 'undefined' ? 'undefined' : _typeof(clientSecret)) + '.');
	          }
	
	          var elementOrDataResult = _this.parseElementOrData(elementOrData);
	
	          // Second argument is Element; handle with element
	          if (elementOrDataResult.type === 'element') {
	            var _element2 = elementOrDataResult.element;
	
	            if (maybeData) {
	              return stripe[method](clientSecret, _element2, maybeData);
	            } else {
	              return stripe[method](clientSecret, _element2);
	            }
	          }
	
	          // Second argument is data or undefined; see if we can find a mounted Element
	          // that can create card PaymentMethods
	          var data = elementOrDataResult.data;
	
	          var element = _this.findElement('impliedPaymentMethodType', 'card');
	
	          if (element) {
	            // If an Element exists that can create card PaymentMethods use it. Otherwise
	            // assume that we must be calling with data only.
	            //
	            // NOTE: this prevents users from using handleCard* with an existing
	            // Source or PaymentMethod if an Element that can create card PaymentMethods
	            // exists in the current <Elements /> context.
	            if (data) {
	              return stripe[method](clientSecret, element, data);
	            } else {
	              return stripe[method](clientSecret, element);
	            }
	          } else if (data) {
	            // if no element exists call handleCard* directly (with data)
	            return stripe[method](clientSecret, data);
	          } else {
	            // if no element exists call handleCard* directly (with only the clientSecret)
	            return stripe[method](clientSecret);
	          }
	        };
	      };
	
	      if (_this.context.tag === 'sync') {
	        _this.state = {
	          stripe: _this.stripeProps(_this.context.stripe)
	        };
	      } else {
	        _this.state = {
	          stripe: null
	        };
	      }
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (this.context.tag === 'async') {
	        this.context.addStripeLoadListener(function (stripe) {
	          _this2.setState({
	            stripe: _this2.stripeProps(stripe)
	          });
	        });
	      } else {
	        // when 'sync', it's already set in the constructor.
	      }
	    };
	
	    _class.prototype.getWrappedInstance = function getWrappedInstance() {
	      if (!withRef) {
	        throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
	      }
	      return this.wrappedInstance;
	    };
	
	    _class.prototype.stripeProps = function stripeProps(stripe) {
	      return _extends({}, stripe, {
	        // These are the only functions that take elements.
	        createToken: this.wrappedCreateToken(stripe),
	        createSource: this.wrappedCreateSource(stripe),
	        createPaymentMethod: this.wrappedCreatePaymentMethod(stripe),
	        handleCardPayment: this.wrappedHandleCardX(stripe, 'handleCardPayment'),
	        handleCardSetup: this.wrappedHandleCardX(stripe, 'handleCardSetup')
	      });
	    };
	
	    // Finds an Element by the specified type, if one exists.
	    // Throws if multiple Elements match.
	
	
	    // Require that exactly one Element is found for the specified type.
	    // Throws if no Element is found.
	
	
	    // Wraps createToken in order to infer the Element that is being tokenized.
	
	
	    // Wraps createSource in order to infer the Element that is being used for
	    // source creation.
	
	
	    // Wraps createPaymentMethod in order to infer the Element that is being
	    // used for PaymentMethod creation.
	
	
	    _class.prototype.render = function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	        stripe: this.state.stripe,
	        ref: withRef ? function (c) {
	          _this3.wrappedInstance = c;
	        } : null
	      }));
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.contextTypes = _extends({}, _Provider.providerContextTypes, _Elements.injectContextTypes), _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
	};
	
	exports.default = inject;

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var PLAIN_OBJECT_STR = '[object Object]';
	
	var isEqual = function isEqual(left, right) {
	  if ((typeof left === 'undefined' ? 'undefined' : _typeof(left)) !== 'object' || (typeof right === 'undefined' ? 'undefined' : _typeof(right)) !== 'object') {
	    return left === right;
	  }
	
	  if (left === null || right === null) return left === right;
	
	  var leftArray = Array.isArray(left);
	  var rightArray = Array.isArray(right);
	
	  if (leftArray !== rightArray) return false;
	
	  var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
	  var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
	
	  if (leftPlainObject !== rightPlainObject) return false;
	
	  if (!leftPlainObject && !leftArray) return false;
	
	  var leftKeys = Object.keys(left);
	  var rightKeys = Object.keys(right);
	
	  if (leftKeys.length !== rightKeys.length) return false;
	
	  var keySet = {};
	  for (var i = 0; i < leftKeys.length; i += 1) {
	    keySet[leftKeys[i]] = true;
	  }
	  for (var _i = 0; _i < rightKeys.length; _i += 1) {
	    keySet[rightKeys[_i]] = true;
	  }
	  var allKeys = Object.keys(keySet);
	  if (allKeys.length !== leftKeys.length) {
	    return false;
	  }
	
	  var l = left;
	  var r = right;
	  var pred = function pred(key) {
	    return isEqual(l[key], r[key]);
	  };
	
	  return allKeys.every(pred);
	};
	
	exports.default = isEqual;

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shallowEqual = function shallowEqual(a, b) {
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  return keysA.length === keysB.length && keysA.every(function (key) {
	    return b.hasOwnProperty(key) && b[key] === a[key];
	  });
	};
	
	exports.default = shallowEqual;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.13.1
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(761),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ }),
/* 761 */
63,
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(276);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(277);
	
	var _isPlainObject = __webpack_require__(144);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(278);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
	function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
	b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
	var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
	if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
	if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
	"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
	var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
	exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
	b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
	exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 766 */
[787, 765],
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(38)))

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(534);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(48)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./cart.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./cart.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(535);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(48)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./menu.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./menu.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(537);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(48)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./style.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(538);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(48)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./order.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./order.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(539);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(48)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./user.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./user.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(540);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(48)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./style.scss", function() {
				var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/index.js!./style.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var upperCase = __webpack_require__(40)
	var lowerCase = __webpack_require__(75)
	
	/**
	 * Swap the case of a string. Manually iterate over every character and check
	 * instead of replacing certain characters for better unicode support.
	 *
	 * @param  {String} str
	 * @param  {String} [locale]
	 * @return {String}
	 */
	module.exports = function (str, locale) {
	  if (str == null) {
	    return ''
	  }
	
	  var result = ''
	
	  for (var i = 0; i < str.length; i++) {
	    var c = str[i]
	    var u = upperCase(c, locale)
	
	    result += u === c ? lowerCase(c, locale) : u
	  }
	
	  return result
	}


/***/ }),
/* 776 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(767);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var noCase = __webpack_require__(30)
	var upperCase = __webpack_require__(40)
	
	/**
	 * Title case a string.
	 *
	 * @param  {string} value
	 * @param  {string} [locale]
	 * @return {string}
	 */
	module.exports = function (value, locale) {
	  return noCase(value, locale).replace(/^.| ./g, function (m) {
	    return upperCase(m, locale)
	  })
	}


/***/ }),
/* 779 */
/***/ (function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(781).Observable;


/***/ }),
/* 781 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Observable = void 0;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	// === Symbol Support ===
	var hasSymbols = function () {
	  return typeof Symbol === 'function';
	};
	
	var hasSymbol = function (name) {
	  return hasSymbols() && Boolean(Symbol[name]);
	};
	
	var getSymbol = function (name) {
	  return hasSymbol(name) ? Symbol[name] : '@@' + name;
	};
	
	if (hasSymbols() && !hasSymbol('observable')) {
	  Symbol.observable = Symbol('observable');
	}
	
	var SymbolIterator = getSymbol('iterator');
	var SymbolObservable = getSymbol('observable');
	var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===
	
	function getMethod(obj, key) {
	  var value = obj[key];
	  if (value == null) return undefined;
	  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
	  return value;
	}
	
	function getSpecies(obj) {
	  var ctor = obj.constructor;
	
	  if (ctor !== undefined) {
	    ctor = ctor[SymbolSpecies];
	
	    if (ctor === null) {
	      ctor = undefined;
	    }
	  }
	
	  return ctor !== undefined ? ctor : Observable;
	}
	
	function isObservable(x) {
	  return x instanceof Observable; // SPEC: Brand check
	}
	
	function hostReportError(e) {
	  if (hostReportError.log) {
	    hostReportError.log(e);
	  } else {
	    setTimeout(function () {
	      throw e;
	    });
	  }
	}
	
	function enqueue(fn) {
	  Promise.resolve().then(function () {
	    try {
	      fn();
	    } catch (e) {
	      hostReportError(e);
	    }
	  });
	}
	
	function cleanupSubscription(subscription) {
	  var cleanup = subscription._cleanup;
	  if (cleanup === undefined) return;
	  subscription._cleanup = undefined;
	
	  if (!cleanup) {
	    return;
	  }
	
	  try {
	    if (typeof cleanup === 'function') {
	      cleanup();
	    } else {
	      var unsubscribe = getMethod(cleanup, 'unsubscribe');
	
	      if (unsubscribe) {
	        unsubscribe.call(cleanup);
	      }
	    }
	  } catch (e) {
	    hostReportError(e);
	  }
	}
	
	function closeSubscription(subscription) {
	  subscription._observer = undefined;
	  subscription._queue = undefined;
	  subscription._state = 'closed';
	}
	
	function flushSubscription(subscription) {
	  var queue = subscription._queue;
	
	  if (!queue) {
	    return;
	  }
	
	  subscription._queue = undefined;
	  subscription._state = 'ready';
	
	  for (var i = 0; i < queue.length; ++i) {
	    notifySubscription(subscription, queue[i].type, queue[i].value);
	    if (subscription._state === 'closed') break;
	  }
	}
	
	function notifySubscription(subscription, type, value) {
	  subscription._state = 'running';
	  var observer = subscription._observer;
	
	  try {
	    var m = getMethod(observer, type);
	
	    switch (type) {
	      case 'next':
	        if (m) m.call(observer, value);
	        break;
	
	      case 'error':
	        closeSubscription(subscription);
	        if (m) m.call(observer, value);else throw value;
	        break;
	
	      case 'complete':
	        closeSubscription(subscription);
	        if (m) m.call(observer);
	        break;
	    }
	  } catch (e) {
	    hostReportError(e);
	  }
	
	  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
	}
	
	function onNotify(subscription, type, value) {
	  if (subscription._state === 'closed') return;
	
	  if (subscription._state === 'buffering') {
	    subscription._queue.push({
	      type: type,
	      value: value
	    });
	
	    return;
	  }
	
	  if (subscription._state !== 'ready') {
	    subscription._state = 'buffering';
	    subscription._queue = [{
	      type: type,
	      value: value
	    }];
	    enqueue(function () {
	      return flushSubscription(subscription);
	    });
	    return;
	  }
	
	  notifySubscription(subscription, type, value);
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(observer, subscriber) {
	    _classCallCheck(this, Subscription);
	
	    // ASSERT: observer is an object
	    // ASSERT: subscriber is callable
	    this._cleanup = undefined;
	    this._observer = observer;
	    this._queue = undefined;
	    this._state = 'initializing';
	    var subscriptionObserver = new SubscriptionObserver(this);
	
	    try {
	      this._cleanup = subscriber.call(undefined, subscriptionObserver);
	    } catch (e) {
	      subscriptionObserver.error(e);
	    }
	
	    if (this._state === 'initializing') this._state = 'ready';
	  }
	
	  _createClass(Subscription, [{
	    key: "unsubscribe",
	    value: function unsubscribe() {
	      if (this._state !== 'closed') {
	        closeSubscription(this);
	        cleanupSubscription(this);
	      }
	    }
	  }, {
	    key: "closed",
	    get: function () {
	      return this._state === 'closed';
	    }
	  }]);
	
	  return Subscription;
	}();
	
	var SubscriptionObserver =
	/*#__PURE__*/
	function () {
	  function SubscriptionObserver(subscription) {
	    _classCallCheck(this, SubscriptionObserver);
	
	    this._subscription = subscription;
	  }
	
	  _createClass(SubscriptionObserver, [{
	    key: "next",
	    value: function next(value) {
	      onNotify(this._subscription, 'next', value);
	    }
	  }, {
	    key: "error",
	    value: function error(value) {
	      onNotify(this._subscription, 'error', value);
	    }
	  }, {
	    key: "complete",
	    value: function complete() {
	      onNotify(this._subscription, 'complete');
	    }
	  }, {
	    key: "closed",
	    get: function () {
	      return this._subscription._state === 'closed';
	    }
	  }]);
	
	  return SubscriptionObserver;
	}();
	
	var Observable =
	/*#__PURE__*/
	function () {
	  function Observable(subscriber) {
	    _classCallCheck(this, Observable);
	
	    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
	    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
	    this._subscriber = subscriber;
	  }
	
	  _createClass(Observable, [{
	    key: "subscribe",
	    value: function subscribe(observer) {
	      if (typeof observer !== 'object' || observer === null) {
	        observer = {
	          next: observer,
	          error: arguments[1],
	          complete: arguments[2]
	        };
	      }
	
	      return new Subscription(observer, this._subscriber);
	    }
	  }, {
	    key: "forEach",
	    value: function forEach(fn) {
	      var _this = this;
	
	      return new Promise(function (resolve, reject) {
	        if (typeof fn !== 'function') {
	          reject(new TypeError(fn + ' is not a function'));
	          return;
	        }
	
	        function done() {
	          subscription.unsubscribe();
	          resolve();
	        }
	
	        var subscription = _this.subscribe({
	          next: function (value) {
	            try {
	              fn(value, done);
	            } catch (e) {
	              reject(e);
	              subscription.unsubscribe();
	            }
	          },
	          error: reject,
	          complete: resolve
	        });
	      });
	    }
	  }, {
	    key: "map",
	    value: function map(fn) {
	      var _this2 = this;
	
	      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
	      var C = getSpecies(this);
	      return new C(function (observer) {
	        return _this2.subscribe({
	          next: function (value) {
	            try {
	              value = fn(value);
	            } catch (e) {
	              return observer.error(e);
	            }
	
	            observer.next(value);
	          },
	          error: function (e) {
	            observer.error(e);
	          },
	          complete: function () {
	            observer.complete();
	          }
	        });
	      });
	    }
	  }, {
	    key: "filter",
	    value: function filter(fn) {
	      var _this3 = this;
	
	      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
	      var C = getSpecies(this);
	      return new C(function (observer) {
	        return _this3.subscribe({
	          next: function (value) {
	            try {
	              if (!fn(value)) return;
	            } catch (e) {
	              return observer.error(e);
	            }
	
	            observer.next(value);
	          },
	          error: function (e) {
	            observer.error(e);
	          },
	          complete: function () {
	            observer.complete();
	          }
	        });
	      });
	    }
	  }, {
	    key: "reduce",
	    value: function reduce(fn) {
	      var _this4 = this;
	
	      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
	      var C = getSpecies(this);
	      var hasSeed = arguments.length > 1;
	      var hasValue = false;
	      var seed = arguments[1];
	      var acc = seed;
	      return new C(function (observer) {
	        return _this4.subscribe({
	          next: function (value) {
	            var first = !hasValue;
	            hasValue = true;
	
	            if (!first || hasSeed) {
	              try {
	                acc = fn(acc, value);
	              } catch (e) {
	                return observer.error(e);
	              }
	            } else {
	              acc = value;
	            }
	          },
	          error: function (e) {
	            observer.error(e);
	          },
	          complete: function () {
	            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
	            observer.next(acc);
	            observer.complete();
	          }
	        });
	      });
	    }
	  }, {
	    key: "concat",
	    value: function concat() {
	      var _this5 = this;
	
	      for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
	        sources[_key] = arguments[_key];
	      }
	
	      var C = getSpecies(this);
	      return new C(function (observer) {
	        var subscription;
	        var index = 0;
	
	        function startNext(next) {
	          subscription = next.subscribe({
	            next: function (v) {
	              observer.next(v);
	            },
	            error: function (e) {
	              observer.error(e);
	            },
	            complete: function () {
	              if (index === sources.length) {
	                subscription = undefined;
	                observer.complete();
	              } else {
	                startNext(C.from(sources[index++]));
	              }
	            }
	          });
	        }
	
	        startNext(_this5);
	        return function () {
	          if (subscription) {
	            subscription.unsubscribe();
	            subscription = undefined;
	          }
	        };
	      });
	    }
	  }, {
	    key: "flatMap",
	    value: function flatMap(fn) {
	      var _this6 = this;
	
	      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
	      var C = getSpecies(this);
	      return new C(function (observer) {
	        var subscriptions = [];
	
	        var outer = _this6.subscribe({
	          next: function (value) {
	            if (fn) {
	              try {
	                value = fn(value);
	              } catch (e) {
	                return observer.error(e);
	              }
	            }
	
	            var inner = C.from(value).subscribe({
	              next: function (value) {
	                observer.next(value);
	              },
	              error: function (e) {
	                observer.error(e);
	              },
	              complete: function () {
	                var i = subscriptions.indexOf(inner);
	                if (i >= 0) subscriptions.splice(i, 1);
	                completeIfDone();
	              }
	            });
	            subscriptions.push(inner);
	          },
	          error: function (e) {
	            observer.error(e);
	          },
	          complete: function () {
	            completeIfDone();
	          }
	        });
	
	        function completeIfDone() {
	          if (outer.closed && subscriptions.length === 0) observer.complete();
	        }
	
	        return function () {
	          subscriptions.forEach(function (s) {
	            return s.unsubscribe();
	          });
	          outer.unsubscribe();
	        };
	      });
	    }
	  }, {
	    key: SymbolObservable,
	    value: function () {
	      return this;
	    }
	  }], [{
	    key: "from",
	    value: function from(x) {
	      var C = typeof this === 'function' ? this : Observable;
	      if (x == null) throw new TypeError(x + ' is not an object');
	      var method = getMethod(x, SymbolObservable);
	
	      if (method) {
	        var observable = method.call(x);
	        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
	        if (isObservable(observable) && observable.constructor === C) return observable;
	        return new C(function (observer) {
	          return observable.subscribe(observer);
	        });
	      }
	
	      if (hasSymbol('iterator')) {
	        method = getMethod(x, SymbolIterator);
	
	        if (method) {
	          return new C(function (observer) {
	            enqueue(function () {
	              if (observer.closed) return;
	              var _iteratorNormalCompletion = true;
	              var _didIteratorError = false;
	              var _iteratorError = undefined;
	
	              try {
	                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                  var _item = _step.value;
	                  observer.next(_item);
	                  if (observer.closed) return;
	                }
	              } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion && _iterator.return != null) {
	                    _iterator.return();
	                  }
	                } finally {
	                  if (_didIteratorError) {
	                    throw _iteratorError;
	                  }
	                }
	              }
	
	              observer.complete();
	            });
	          });
	        }
	      }
	
	      if (Array.isArray(x)) {
	        return new C(function (observer) {
	          enqueue(function () {
	            if (observer.closed) return;
	
	            for (var i = 0; i < x.length; ++i) {
	              observer.next(x[i]);
	              if (observer.closed) return;
	            }
	
	            observer.complete();
	          });
	        });
	      }
	
	      throw new TypeError(x + ' is not observable');
	    }
	  }, {
	    key: "of",
	    value: function of() {
	      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        items[_key2] = arguments[_key2];
	      }
	
	      var C = typeof this === 'function' ? this : Observable;
	      return new C(function (observer) {
	        enqueue(function () {
	          if (observer.closed) return;
	
	          for (var i = 0; i < items.length; ++i) {
	            observer.next(items[i]);
	            if (observer.closed) return;
	          }
	
	          observer.complete();
	        });
	      });
	    }
	  }, {
	    key: SymbolSpecies,
	    get: function () {
	      return this;
	    }
	  }]);
	
	  return Observable;
	}();
	
	exports.Observable = Observable;
	
	if (hasSymbols()) {
	  Object.defineProperty(Observable, Symbol('extensions'), {
	    value: {
	      symbol: SymbolObservable,
	      hostReportError: hostReportError
	    },
	    configurable: true
	  });
	}

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(5);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var modifierTotal = function modifierTotal(modifier) {
	  return _lodash2.default.sum(modifier.items.map(function (item) {
	    return item.price || 0;
	  }));
	};
	
	var itemPrice = function itemPrice(item) {
	  if (!item.modifiers) return item.price;
	
	  var modifiersSum = _lodash2.default.sum(item.modifiers.map(modifierTotal));
	  return item.price + modifiersSum;
	};
	
	var extraCostCreate = function extraCostCreate(label, amount, type) {
	  return {
	    label: label,
	    amount: amount,
	    type: type
	  };
	};
	
	var extraCostFromVoucher = function extraCostFromVoucher(voucher, cartItems) {
	  var amount = void 0,
	      type = void 0;
	  switch (voucher.discount.format) {
	    case _constants.VOUCHER_FORMAT_FREE_ITEM:
	      amount = 0;
	      type = _constants.EXTRA_COST_TYPE_NEUTRAL;
	      break;
	    case _constants.VOUCHER_FORMAT_PERCENTAGE:
	      amount = voucher.discount.amount / 100 * subTotal(cartItems);
	      type = _constants.EXTRA_COST_TYPE_NEGATIVE;
	      break;
	    case _constants.VOUCHER_FORMAT_ABSOLUTE:
	      amount = voucher.discount.amount;
	      type = _constants.EXTRA_COST_TYPE_NEGATIVE;
	      break;
	  }
	  return extraCostCreate(voucher.message, Math.floor(amount), type);
	};
	
	var extraCostItem = function extraCostItem(item) {
	  return (item.type === _constants.EXTRA_COST_TYPE_POSITIVE ? 1 : -1) * item.amount;
	};
	
	var subTotal = function subTotal(items) {
	  return _lodash2.default.sum(items.map(itemPrice));
	};
	
	var extraCosts = function extraCosts(costs) {
	  return _lodash2.default.sum(costs.map(extraCostItem));
	};
	
	var total = function total(items, costs) {
	  return _lodash2.default.sum([subTotal(items || []), extraCosts(costs || [])]);
	};
	
	var hasItem = function hasItem(cart, item) {
	  return _lodash2.default.some(cart, ['id', item.id]);
	};
	
	var serialize = function serialize(cart) {
	  return _lodash2.default.map(cart, function (item) {
	    return {
	      id: item.id,
	      price: item.price,
	      modifiers: _lodash2.default.map(item.modifiers, function (m) {
	        return {
	          id: m.id,
	          items: _lodash2.default.map(m.items, function (x) {
	            return {
	              id: x.id,
	              price: x.price
	            };
	          })
	        };
	      })
	    };
	  });
	};
	
	var itemQuantity = function itemQuantity(cart, item) {
	  return _lodash2.default.filter(cart, ['id', item.id]).length;
	};
	
	var isEmpty = function isEmpty(cart) {
	  return cart.length === 0;
	};
	
	// spostato qua da merchant-lib/modules/orders/lib - valutare se rimuovere da la
	var serializeItemKey = function serializeItemKey(item) {
	  var key = item.id;
	
	  (item.modifiers || []).forEach(function (modifier) {
	    key = key + '_' + modifier.id;
	
	    (modifier.items || []).forEach(function (modifierItem) {
	      key = key + '_' + modifierItem.id;
	    });
	  });
	
	  return key;
	};
	
	// spostato qua da merchant-lib/modules/orders/lib - rimuovere da la
	var groupOrderItems = function groupOrderItems(items) {
	  var map = {};
	
	  var kv = items.reduce(function (acc, item) {
	    var key = serializeItemKey(item);
	
	    var quantity = 0;
	
	    if (map[key] === undefined) {
	      map[key] = Object.keys(acc).length;
	    } else {
	      quantity = acc[map[key]].quantity;
	    }
	
	    return _extends({}, acc, _defineProperty({}, map[key], _extends({}, item, {
	      quantity: quantity + 1
	    })));
	  }, {});
	
	  return _lodash2.default.values(kv);
	};
	
	exports.default = {
	  modifierTotal: modifierTotal,
	  itemPrice: itemPrice,
	  subTotal: subTotal,
	  total: total,
	  hasItem: hasItem,
	  itemQuantity: itemQuantity,
	  isEmpty: isEmpty,
	  serialize: serialize,
	  extraCosts: extraCosts,
	  extraCostCreate: extraCostCreate,
	  extraCostFromVoucher: extraCostFromVoucher,
	  groupOrderItems: groupOrderItems
	};

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BOOKINGRUSH_CREATERE;
	
	var _constants = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	exports.default = (_BOOKINGRUSH_CREATERE = {}, _defineProperty(_BOOKINGRUSH_CREATERE, _constants.BOOKINGRUSH_CREATEREQUEST_SUCCESS, 'Richiesta inviata con successo.'), _defineProperty(_BOOKINGRUSH_CREATERE, _constants.BOOKINGRUSH_CREATE_SUCCESS, 'Booking Rush creato con successo.'), _defineProperty(_BOOKINGRUSH_CREATERE, _constants.BOOKINGRUSH_UPDATE_SUCCESS, 'Booking Rush aggiornato con successo.'), _defineProperty(_BOOKINGRUSH_CREATERE, _constants.LOYALTYCARD_ADDSTAMPS_SUCCESS, 'Loyalty Card aggiornata con successo.'), _defineProperty(_BOOKINGRUSH_CREATERE, _constants.USER_AUTHENTICATE_SUCCESS, 'Login effettuato con successo.'), _defineProperty(_BOOKINGRUSH_CREATERE, _constants.USER_REGISTER_SUCCESS, 'Registrazione effettuata con successo.'), _defineProperty(_BOOKINGRUSH_CREATERE, _constants.USER_LOGOUT_SUCCESS, 'Logout effettuato con successo.'), _defineProperty(_BOOKINGRUSH_CREATERE, _constants.VOUCHER_REDEEM_SUCCESS, 'Il voucher è stato utilizzato.'), _defineProperty(_BOOKINGRUSH_CREATERE, _constants.VOUCHER_CREATE_SUCCESS, 'Voucher creato con successo.'), _defineProperty(_BOOKINGRUSH_CREATERE, _constants.VOUCHER_UPDATE_SUCCESS, 'Voucher aggiornato con successo.'), _defineProperty(_BOOKINGRUSH_CREATERE, 'DATA_FETCHING_FAILURE', 'Errore nella connessione con il server.'), _defineProperty(_BOOKINGRUSH_CREATERE, _constants.CONNECTIVITY_ERROR, 'Si è verificato un errore di rete, controlla la tua connessione.'), _BOOKINGRUSH_CREATERE);

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configureApi = exports.reducerMethodsFor = exports.createReducer = exports.createActionObject = exports.serializeFields = exports.serializeForMutation = exports.serializeEnum = exports.wrapAction = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fp = __webpack_require__(141);
	
	var _fp2 = _interopRequireDefault(_fp);
	
	var _messages = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DATA_FETCHING_FAILURE = _messages2.default.DATA_FETCHING_FAILURE;
	var CONNECTIVITY_ERROR = _messages2.default.CONNECTIVITY_ERROR;
	
	var jsStringEscape = function jsStringEscape(string) {
	  return ('' + string).replace(/["\\\n\r\u2028\u2029]/g, function (character) {
	    switch (character) {
	      case '"':
	      case '\\':
	        return '\\' + character;
	      // Four possible LineTerminator characters need to be escaped:
	      case '\n':
	        return '\\n';
	      case '\r':
	        return '\\r';
	      case '\u2028':
	        return '\\u2028';
	      case '\u2029':
	        return '\\u2029';
	    }
	  });
	};
	
	var wrapAction = exports.wrapAction = function wrapAction(actions, query_name, action_name, promise) {
	  var context = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	  var start = actions[action_name + 'Start'];
	  var success = actions[action_name + 'Success'];
	  var failure = actions[action_name + 'Failure'];
	
	  start(context);
	
	  return promise.then(function (res) {
	    var _ref = res || {},
	        data = _ref.data,
	        errors = _ref.errors,
	        cid = _ref.cid;
	
	    context.cid = cid;
	
	    if (data && !errors) {
	      var result = _fp2.default.property(query_name)(data);
	
	      // success should fire even if result is null
	      return success(result, context);
	    }
	
	    if (errors && errors.length) {
	      return failure(errors, context);
	    }
	
	    return failure([{ message: DATA_FETCHING_FAILURE }], context);
	  }).catch(function (errors) {
	    if (errors.toString().indexOf('Network request') !== -1) {
	      failure([{ message: CONNECTIVITY_ERROR }], context);
	      return;
	    }
	    if (errors) return failure(errors);
	    failure([{ message: DATA_FETCHING_FAILURE }], context);
	  });
	};
	
	var serializeEnum = exports.serializeEnum = function serializeEnum(string) {
	  var s = new String(string.toUpperCase());
	  s.__isGraphQLEnumValue = true;
	  return s;
	};
	
	var formatGraphQLString = function formatGraphQLString(string) {
	  if (_fp2.default.isObject(string) && string.__isGraphQLEnumValue) {
	    return string.toString(); // no quotes
	  }
	
	  if (!string) return '""';
	
	  var escaped = jsStringEscape(string);
	  return '"' + escaped + '"';
	};
	
	var serializeObject = function serializeObject(value) {
	  if (_fp2.default.isDate(value)) {
	    // In order to not alter the original passed date,
	    // we need to subtract the timezone offset.
	    var diff = new Date().getTimezoneOffset() * 60000;
	    return '"' + new Date(value.getTime() - diff).toISOString() + '"';
	  }
	  if (_fp2.default.isString(value)) return formatGraphQLString(value);
	  if (_fp2.default.isArray(value)) return '[ ' + serializeForMutation(value) + ' ]';
	  if (_fp2.default.isObject(value)) return '{ ' + serializeForMutation(value) + ' }';
	  if (_fp2.default.isUndefined(value) || _fp2.default.isNull(value)) return "null";
	
	  return value;
	};
	
	var serializeForMutation = exports.serializeForMutation = function serializeForMutation(data) {
	  var isArray = _fp2.default.isArray(data);
	  var map = isArray ? _fp2.default.map : _fp2.default.mapValues;
	
	  var serialized = map(serializeObject, data);
	
	  return Object.keys(serialized).reduce(function (acc, key) {
	    var item = serialized[key];
	    var obj = isArray ? item : [key, item].join(': ');
	    return acc.concat(obj);
	  }, []).join(' ');
	};
	
	var serializeFields = exports.serializeFields = function serializeFields(fields, data) {
	  return serializeForMutation(_fp2.default.pick(fields, data));
	};
	
	var createActionObject = exports.createActionObject = function createActionObject(action_name, start, success, failure) {
	  var _ref2;
	
	  return _ref2 = {}, _defineProperty(_ref2, action_name + 'Start', function undefined(context) {
	    return {
	      type: start,
	      context: context
	    };
	  }), _defineProperty(_ref2, action_name + 'Success', function undefined(data, context) {
	    return {
	      type: success,
	      data: data,
	      context: context
	    };
	  }), _defineProperty(_ref2, action_name + 'Failure', function undefined(errors, context) {
	    return {
	      type: failure,
	      errors: errors,
	      context: context
	    };
	  }), _ref2;
	};
	
	var createReducer = exports.createReducer = function createReducer(initialState, reducer) {
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var method = action.type;
	    if (reducer[method]) {
	      return reducer[method](state, action);
	    }
	
	    return state;
	  };
	};
	
	var reducerMethodsFor = exports.reducerMethodsFor = function reducerMethodsFor(property, start, failure) {
	  var _ref3;
	
	  return _ref3 = {}, _defineProperty(_ref3, start, function (state, action) {
	    var _extends2;
	
	    return _extends({}, state, (_extends2 = {}, _defineProperty(_extends2, property, true), _defineProperty(_extends2, 'errors', []), _extends2));
	  }), _defineProperty(_ref3, failure, function (state, action) {
	    var _extends3;
	
	    return _extends({}, state, (_extends3 = {}, _defineProperty(_extends3, property, false), _defineProperty(_extends3, 'errors', action.errors), _extends3));
	  }), _ref3;
	};
	
	var configureApi = exports.configureApi = _fp2.default.curry(function (setApiHeaders, accessToken) {
	  var headers = {};
	  if (accessToken) {
	    headers.Authorization = 'Bearer ' + accessToken;
	  };
	  setApiHeaders(headers);
	});

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.0e3efd3d.js